
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3dpDS", function(module, exports) {
$parcel$export(module.exports, "FastshiftDashboardPage", function () { return $1e672df8a000c224$export$357a360ea405de82; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("5PGSJ");
var $7n74L = parcelRequire("7n74L");
const $1e672df8a000c224$export$357a360ea405de82 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7n74L.FastshiftDashboardPageTemplate), {});

});
parcelRegister("5PGSJ", function(module, exports) {
$parcel$export(module.exports, "FastshiftDashboardPageTemplate", function () { return (parcelRequire("7n74L")).FastshiftDashboardPageTemplate; });

var $7n74L = parcelRequire("7n74L");

});
parcelRegister("7n74L", function(module, exports) {
$parcel$export(module.exports, "FastshiftDashboardPageTemplate", function () { return $02d3eed6d4a54315$export$51b95d9ab7d14de8; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");



var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $7WM7y = parcelRequire("7WM7y");

var $6Urh6 = parcelRequire("6Urh6");
const $02d3eed6d4a54315$export$51b95d9ab7d14de8 = ()=>{
    const isFastshiftPortalEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).sxpEnableFastshiftPortal);
    if (!isFastshiftPortalEnabled) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Urh6.FastshiftPortalPageRouter), {});
};

});
parcelRegister("6Urh6", function(module, exports) {
$parcel$export(module.exports, "FastshiftPortalPageRouter", function () { return $30460f107614d17d$export$6e50b31916fa8824; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $ipuAN = parcelRequire("ipuAN");

var $evmye = parcelRequire("evmye");

var $j2t2h = parcelRequire("j2t2h");
var $jwXhl = parcelRequire("jwXhl");

var $4zAuc = parcelRequire("4zAuc");
parcelRequire("ejp9a");
var $jSEBz = parcelRequire("jSEBz");
var $drJeJ = parcelRequire("drJeJ");
var $8aiYh = parcelRequire("8aiYh");
var $iPVQq = parcelRequire("iPVQq");
var $5QUU6 = parcelRequire("5QUU6");
var $8POFg = parcelRequire("8POFg");
parcelRequire("z8fwG");
var $7WhrI = parcelRequire("7WhrI");
var $1NoJu = parcelRequire("1NoJu");

var $fq4go = parcelRequire("fq4go");

var $7J0yo = parcelRequire("7J0yo");

var $kbaUT = parcelRequire("kbaUT");
parcelRequire("l4mrf");
var $gXpxP = parcelRequire("gXpxP");

var $e3yIv = parcelRequire("e3yIv");

var $j2b52 = parcelRequire("j2b52");

var $2uw17 = parcelRequire("2uw17");
const $30460f107614d17d$var$CustomRouterLink = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, ref)=>{
    var { href: href, children: children } = _param, rest = (0, $aPnCa._)(_param, [
        "href",
        "children"
    ]);
    // A basic link by passing a string as the component's `href` prop.
    if (typeof href === "string") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2t2h.Link), (0, $dPABA._)((0, $6ogO3._)({
        ref: ref,
        to: href
    }, rest), {
        children: children
    }));
    // Advanced link configuration by passing an object as the
    // component's `href` prop
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2t2h.Link), (0, $dPABA._)((0, $6ogO3._)({
        ref: ref,
        // href={href.href}
        to: href.to,
        replace: href.replace
    }, rest), {
        children: children
    }));
});
const $30460f107614d17d$export$6e50b31916fa8824 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2b52.ClientOnly), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($ipuAN.ErrorBoundary, {
            beforeCapture: (0, $7J0yo.beforeCaptureWithScope)("catch-all"),
            fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NoJu.GenericErrorDisplay), {}),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4zAuc.default), {
                routerLinkComponent: $30460f107614d17d$var$CustomRouterLink,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2t2h.BrowserRouter), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbaUT.default).Provider, {
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $evmye.Provider), {
                            store: (0, $e3yIv.store),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("style", {
                                    dangerouslySetInnerHTML: {
                                        __html: `.grecaptcha-badge { visibility: hidden !important; }`
                                    }
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jwXhl.Routes), {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jwXhl.Route), {
                                        path: "/:locale?",
                                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jwXhl.Route), {
                                            element: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8POFg.PageLayout), {}),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jwXhl.Route), {
                                                    path: (0, $fq4go.FASTSHIFT_PATHS)[(0, $fq4go.FASTSHIFT_PATH_KEYS).SELECTION],
                                                    element: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gXpxP.FastshiftCustomerSelectionPage), {})
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jwXhl.Route), {
                                                    path: (0, $fq4go.FASTSHIFT_PATHS)[(0, $fq4go.FASTSHIFT_PATH_KEYS).OVERVIEW],
                                                    element: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jSEBz.FastshiftDashboard), {})
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jwXhl.Route), {
                                                    path: (0, $fq4go.FASTSHIFT_PATHS)[(0, $fq4go.FASTSHIFT_PATH_KEYS).TICKETS],
                                                    element: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8aiYh.FastshiftMigrationTicketsPage), {})
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jwXhl.Route), {
                                                    path: (0, $fq4go.FASTSHIFT_PATHS)[(0, $fq4go.FASTSHIFT_PATH_KEYS).PLANNING],
                                                    element: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $drJeJ.FastshiftMigrationsManagementPage), {})
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jwXhl.Route), {
                                                    path: (0, $fq4go.FASTSHIFT_PATHS)[(0, $fq4go.FASTSHIFT_PATH_KEYS).RESOURCES_DOMAIN_SCOPED],
                                                    element: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5QUU6.FastshiftResourcesPage), {})
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jwXhl.Route), {
                                                    path: (0, $fq4go.FASTSHIFT_PATHS)[(0, $fq4go.FASTSHIFT_PATH_KEYS).RESOURCES_PARTNER_SCOPED],
                                                    element: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5QUU6.FastshiftResourcesPage), {})
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jwXhl.Route), {
                                                    path: (0, $fq4go.FASTSHIFT_PATHS)[(0, $fq4go.FASTSHIFT_PATH_KEYS).FASTSHIFT],
                                                    element: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPVQq.FastshiftPage), {})
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jwXhl.Route), {
                                                    path: "fastshift/dashboard",
                                                    element: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2uw17.RedirectToSelectionPage), {})
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jwXhl.Route), {
                                                    path: "fastshift/*",
                                                    element: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WhrI.FourOhFourDisplay), {})
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("4zAuc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3546bbacc0712afb$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $bJ5Wj = parcelRequire("bJ5Wj");

var $hr0LI = parcelRequire("hr0LI");
var $3546bbacc0712afb$var$InsideAppProviderContext = /*#__PURE__*/ (0, $1oC0p.createContext)(false);
/**
 * __App provider__
 *
 * An app provider provides app level configuration such as global theming.
 *
 * Place it at the root of your application.
 */ function $3546bbacc0712afb$var$AppProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'light' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme, routerLinkComponent = _ref.routerLinkComponent, UNSAFE_isThemingDisabled = _ref.UNSAFE_isThemingDisabled;
    var isInsideAppProvider = (0, $1oC0p.useContext)($3546bbacc0712afb$var$InsideAppProviderContext);
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    var routerLinkProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bJ5Wj.default), {
        routerLinkComponent: routerLinkComponent
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($3546bbacc0712afb$var$InsideAppProviderContext.Provider, {
        value: true
    }, UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $hr0LI.default), {
        defaultColorMode: defaultColorMode,
        defaultTheme: defaultTheme
    }, routerLinkProvider));
}
var $3546bbacc0712afb$export$2e2bcd8739ae039 = $3546bbacc0712afb$var$AppProvider;

});

parcelRegister("ejp9a", function(module, exports) {
$parcel$export(module.exports, "FastshiftDashboard", function () { return (parcelRequire("jSEBz")).FastshiftDashboard; });
$parcel$export(module.exports, "FastshiftResourcesPage", function () { return (parcelRequire("5QUU6")).FastshiftResourcesPage; });
$parcel$export(module.exports, "FastshiftMigrationsManagementPage", function () { return (parcelRequire("drJeJ")).FastshiftMigrationsManagementPage; });
$parcel$export(module.exports, "FastshiftMigrationTicketsPage", function () { return (parcelRequire("8aiYh")).FastshiftMigrationTicketsPage; });
$parcel$export(module.exports, "PageLayout", function () { return (parcelRequire("8POFg")).PageLayout; });
$parcel$export(module.exports, "FastshiftPage", function () { return (parcelRequire("iPVQq")).FastshiftPage; });
parcelRequire("4BK9Q");
var $jSEBz = parcelRequire("jSEBz");
parcelRequire("l4mrf");
var $gXpxP = parcelRequire("gXpxP");
parcelRequire("6QUAv");
var $5QUU6 = parcelRequire("5QUU6");
parcelRequire("3LMg6");
var $drJeJ = parcelRequire("drJeJ");
parcelRequire("xxovY");
var $8aiYh = parcelRequire("8aiYh");

var $8POFg = parcelRequire("8POFg");
parcelRequire("ifxD0");
var $iPVQq = parcelRequire("iPVQq");

});
parcelRegister("4BK9Q", function(module, exports) {
$parcel$export(module.exports, "FastshiftDashboard", function () { return (parcelRequire("jSEBz")).FastshiftDashboard; });

var $jSEBz = parcelRequire("jSEBz");

});
parcelRegister("jSEBz", function(module, exports) {
$parcel$export(module.exports, "FastshiftDashboard", function () { return $30d361658a8b3e4d$export$12d84f115c5f031b; });

var $7VQPk = parcelRequire("7VQPk");

var $2YtGy = parcelRequire("2YtGy");
parcelRequire("lOhVA");
var $6FDTa = parcelRequire("6FDTa");

var $bh3Fv = parcelRequire("bh3Fv");

var $hv38C = parcelRequire("hv38C");
parcelRequire("cHEgA");
var $jN2ro = parcelRequire("jN2ro");
parcelRequire("jtpMK");
var $iS5nW = parcelRequire("iS5nW");
parcelRequire("LvLsc");
var $1e3AM = parcelRequire("1e3AM");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");

var $3riD8 = parcelRequire("3riD8");
parcelRequire("6ezXX");
var $6aLna = parcelRequire("6aLna");
parcelRequire("8LnDm");
var $j9oYS = parcelRequire("j9oYS");
parcelRequire("dNM9R");
var $aohNG = parcelRequire("aohNG");
const $30d361658a8b3e4d$export$12d84f115c5f031b = ()=>{
    const { data: userDetails } = (0, $f7YG8.useFastshiftSelector)((state)=>state.userDetails);
    const { paths: paths } = (0, $bh3Fv.useRoutes)();
    const userInfo = (0, $3riD8.useLoggedInUser)();
    const currentTime = (0, $iS5nW.getCurrentTime)();
    (0, $6aLna.useDashboardPageAnalytics)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
        space: "space.400",
        children: [
            (userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) === "CUSTOMER" && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                space: "space.300",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1e3AM.CustomerWelcomeBanner), {
                        currentTime: currentTime,
                        userName: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hv38C.LegalBanner), {})
                ]
            }),
            (userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) !== "CUSTOMER" && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6FDTa.CustomerNameAndLogoHeader), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aohNG.SummarySection), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j9oYS.MigrationTicketsList), {
                migrationTicketsUrl: paths.domainScopedTickets
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jN2ro.RelationshipSection), {})
        ]
    });
};

});
parcelRegister("2YtGy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $22a83643485fa531$export$2e2bcd8739ae039; });

var $3Hvqv = parcelRequire("3Hvqv");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $f6YGh = parcelRequire("f6YGh");

var $fmW7P = parcelRequire("fmW7P");
var $22a83643485fa531$var$flexGrowMap = {
    hug: (0, $f6YGh.xcss)({
        flexGrow: 0
    }),
    fill: (0, $f6YGh.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $22a83643485fa531$var$Stack = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $22a83643485fa531$var$flexGrowMap[grow]
    ].concat((0, $3Hvqv.default)(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $3dJ4i.jsx)((0, $fmW7P.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$22a83643485fa531$var$Stack.displayName = 'Stack';
var $22a83643485fa531$export$2e2bcd8739ae039 = $22a83643485fa531$var$Stack;

});
parcelRegister("3Hvqv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2b1dc3eb54c1f448$export$2e2bcd8739ae039; });

var $5emhA = parcelRequire("5emhA");

var $aSkMh = parcelRequire("aSkMh");

var $dpL3I = parcelRequire("dpL3I");

var $lJdrN = parcelRequire("lJdrN");
function $2b1dc3eb54c1f448$export$2e2bcd8739ae039(r) {
    return (0, $5emhA.default)(r) || (0, $aSkMh.default)(r) || (0, $dpL3I.default)(r) || (0, $lJdrN.default)();
}

});
parcelRegister("5emhA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3cef8b716b26d4db$export$2e2bcd8739ae039; });

var $1XyJ4 = parcelRequire("1XyJ4");
function $3cef8b716b26d4db$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $1XyJ4.default)(r);
}

});
parcelRegister("1XyJ4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $16d63cf5bfb4728c$export$2e2bcd8739ae039; });
function $16d63cf5bfb4728c$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("aSkMh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7eaf10911f0a64a3$export$2e2bcd8739ae039; });
function $7eaf10911f0a64a3$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("dpL3I", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9c421d15f7161001$export$2e2bcd8739ae039; });

var $1XyJ4 = parcelRequire("1XyJ4");
function $9c421d15f7161001$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $1XyJ4.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $1XyJ4.default)(r, a) : void 0;
    }
}

});

parcelRegister("lJdrN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fd183b498b54d8fe$export$2e2bcd8739ae039; });
function $fd183b498b54d8fe$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("f6YGh", function(module, exports) {
$parcel$export(module.exports, "parseXcss", function () { return $b0067c870dff3374$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $b0067c870dff3374$export$f6c783d06584602c; });

var $3Hvqv = parcelRequire("3Hvqv");

var $4hcKa = parcelRequire("4hcKa");

var $bh4U8 = parcelRequire("bh4U8");

var $83oQa = parcelRequire("83oQa");

var $3dJ4i = parcelRequire("3dJ4i");

var $ahhSJ = parcelRequire("ahhSJ");

var $7t0tI = parcelRequire("7t0tI");
function $b0067c870dff3374$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b0067c870dff3374$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b0067c870dff3374$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b0067c870dff3374$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b0067c870dff3374$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b0067c870dff3374$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $b0067c870dff3374$export$9a199fbafee0014e = {
    backgroundColor: (0, $ahhSJ.backgroundColorMap),
    blockSize: (0, $ahhSJ.dimensionMap),
    borderBlockColor: (0, $ahhSJ.borderColorMap),
    borderBlockEndColor: (0, $ahhSJ.borderColorMap),
    borderBlockEndWidth: (0, $ahhSJ.borderWidthMap),
    borderBlockStartColor: (0, $ahhSJ.borderColorMap),
    borderBlockStartWidth: (0, $ahhSJ.borderWidthMap),
    borderBlockWidth: (0, $ahhSJ.borderWidthMap),
    borderBottomColor: (0, $ahhSJ.borderColorMap),
    borderBottomLeftRadius: (0, $ahhSJ.borderRadiusMap),
    borderBottomRightRadius: (0, $ahhSJ.borderRadiusMap),
    borderBottomWidth: (0, $ahhSJ.borderWidthMap),
    borderColor: (0, $ahhSJ.borderColorMap),
    borderEndEndRadius: (0, $ahhSJ.borderRadiusMap),
    borderEndStartRadius: (0, $ahhSJ.borderRadiusMap),
    borderInlineColor: (0, $ahhSJ.borderColorMap),
    borderInlineEndColor: (0, $ahhSJ.borderColorMap),
    borderInlineEndWidth: (0, $ahhSJ.borderWidthMap),
    borderInlineStartColor: (0, $ahhSJ.borderColorMap),
    borderInlineStartWidth: (0, $ahhSJ.borderWidthMap),
    borderInlineWidth: (0, $ahhSJ.borderWidthMap),
    borderLeftColor: (0, $ahhSJ.borderColorMap),
    borderLeftWidth: (0, $ahhSJ.borderWidthMap),
    borderRadius: (0, $ahhSJ.borderRadiusMap),
    borderRightColor: (0, $ahhSJ.borderColorMap),
    borderRightWidth: (0, $ahhSJ.borderWidthMap),
    borderStartEndRadius: (0, $ahhSJ.borderRadiusMap),
    borderStartStartRadius: (0, $ahhSJ.borderRadiusMap),
    borderTopColor: (0, $ahhSJ.borderColorMap),
    borderTopLeftRadius: (0, $ahhSJ.borderRadiusMap),
    borderTopRightRadius: (0, $ahhSJ.borderRadiusMap),
    borderTopWidth: (0, $ahhSJ.borderWidthMap),
    borderWidth: (0, $ahhSJ.borderWidthMap),
    bottom: (0, $ahhSJ.allSpaceMap),
    boxShadow: (0, $ahhSJ.shadowMap),
    color: (0, $ahhSJ.textColorMap),
    columnGap: (0, $ahhSJ.positiveSpaceMap),
    font: (0, $ahhSJ.fontMap),
    fontFamily: (0, $ahhSJ.fontFamilyMap),
    fontWeight: (0, $ahhSJ.fontWeightMap),
    gap: (0, $ahhSJ.positiveSpaceMap),
    height: (0, $ahhSJ.dimensionMap),
    inlineSize: (0, $ahhSJ.dimensionMap),
    inset: (0, $ahhSJ.allSpaceMap),
    insetBlock: (0, $ahhSJ.allSpaceMap),
    insetBlockEnd: (0, $ahhSJ.allSpaceMap),
    insetBlockStart: (0, $ahhSJ.allSpaceMap),
    insetInline: (0, $ahhSJ.allSpaceMap),
    insetInlineEnd: (0, $ahhSJ.allSpaceMap),
    insetInlineStart: (0, $ahhSJ.allSpaceMap),
    left: (0, $ahhSJ.allSpaceMap),
    margin: (0, $ahhSJ.allSpaceMap),
    marginBlock: (0, $ahhSJ.allSpaceMap),
    marginBlockEnd: (0, $ahhSJ.allSpaceMap),
    marginBlockStart: (0, $ahhSJ.allSpaceMap),
    marginBottom: (0, $ahhSJ.allSpaceMap),
    marginInline: (0, $ahhSJ.allSpaceMap),
    marginInlineEnd: (0, $ahhSJ.allSpaceMap),
    marginInlineStart: (0, $ahhSJ.allSpaceMap),
    marginLeft: (0, $ahhSJ.allSpaceMap),
    marginRight: (0, $ahhSJ.allSpaceMap),
    marginTop: (0, $ahhSJ.allSpaceMap),
    maxBlockSize: (0, $ahhSJ.dimensionMap),
    maxHeight: (0, $ahhSJ.dimensionMap),
    maxInlineSize: (0, $ahhSJ.dimensionMap),
    maxWidth: (0, $ahhSJ.dimensionMap),
    minBlockSize: (0, $ahhSJ.dimensionMap),
    minHeight: (0, $ahhSJ.dimensionMap),
    minInlineSize: (0, $ahhSJ.dimensionMap),
    minWidth: (0, $ahhSJ.dimensionMap),
    opacity: (0, $ahhSJ.opacityMap),
    outlineColor: (0, $ahhSJ.borderColorMap),
    outlineOffset: (0, $ahhSJ.allSpaceMap),
    outlineWidth: (0, $ahhSJ.borderWidthMap),
    padding: (0, $ahhSJ.positiveSpaceMap),
    paddingBlock: (0, $ahhSJ.positiveSpaceMap),
    paddingBlockEnd: (0, $ahhSJ.positiveSpaceMap),
    paddingBlockStart: (0, $ahhSJ.positiveSpaceMap),
    paddingBottom: (0, $ahhSJ.positiveSpaceMap),
    paddingInline: (0, $ahhSJ.positiveSpaceMap),
    paddingInlineEnd: (0, $ahhSJ.positiveSpaceMap),
    paddingInlineStart: (0, $ahhSJ.positiveSpaceMap),
    paddingLeft: (0, $ahhSJ.positiveSpaceMap),
    paddingRight: (0, $ahhSJ.positiveSpaceMap),
    paddingTop: (0, $ahhSJ.positiveSpaceMap),
    right: (0, $ahhSJ.allSpaceMap),
    rowGap: (0, $ahhSJ.positiveSpaceMap),
    top: (0, $ahhSJ.allSpaceMap),
    width: (0, $ahhSJ.dimensionMap),
    zIndex: (0, $ahhSJ.layerMap)
};
var $b0067c870dff3374$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $b0067c870dff3374$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $7t0tI === "undefined" ? "undefined" : (0, $83oQa.default)($7t0tI)) === 'object' && (0, $83oQa.default)($7t0tI.env) === 'object' && false;
};
var $b0067c870dff3374$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $b0067c870dff3374$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $b0067c870dff3374$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $83oQa.default)(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($b0067c870dff3374$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $bh4U8.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $83oQa.default)(value) === 'object' && $b0067c870dff3374$var$safeSelectors.test(key)) {
            styleObj[key] = $b0067c870dff3374$var$_transformStyles(value);
            return;
        }
        if ($b0067c870dff3374$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($b0067c870dff3374$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $b0067c870dff3374$export$9a199fbafee0014e)) return;
        var tokenValue = $b0067c870dff3374$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $b0067c870dff3374$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $b0067c870dff3374$var$_transformStyles(style);
    return (0, $4hcKa.default)({}, $b0067c870dff3374$var$uniqueSymbol, (0, $3dJ4i.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $b0067c870dff3374$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $b0067c870dff3374$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $b0067c870dff3374$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $3Hvqv.default)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$b0067c870dff3374$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $b0067c870dff3374$export$f6c783d06584602c(style) {
    return $b0067c870dff3374$var$baseXcss(style);
}

});
parcelRegister("bh4U8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8355162bd98e7555$export$2e2bcd8739ae039; });

var $iiuYD = parcelRequire("iiuYD");

var $7TiQ6 = parcelRequire("7TiQ6");

var $dpL3I = parcelRequire("dpL3I");

var $kCPKY = parcelRequire("kCPKY");
function $8355162bd98e7555$export$2e2bcd8739ae039(r, e) {
    return (0, $iiuYD.default)(r) || (0, $7TiQ6.default)(r, e) || (0, $dpL3I.default)(r, e) || (0, $kCPKY.default)();
}

});
parcelRegister("iiuYD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d521efd3d2e2722a$export$2e2bcd8739ae039; });
function $d521efd3d2e2722a$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("7TiQ6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5bec4890f3b6a202$export$2e2bcd8739ae039; });
function $5bec4890f3b6a202$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("kCPKY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f03f810d2c626835$export$2e2bcd8739ae039; });
function $f03f810d2c626835$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("fmW7P", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b305ff917f319317$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $ahhSJ = parcelRequire("ahhSJ");

var $f6YGh = parcelRequire("f6YGh");
var $b305ff917f319317$var$justifyContentMap = {
    start: (0, $3dJ4i.css)({
        justifyContent: 'start'
    }),
    center: (0, $3dJ4i.css)({
        justifyContent: 'center'
    }),
    end: (0, $3dJ4i.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3dJ4i.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3dJ4i.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3dJ4i.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3dJ4i.css)({
        justifyContent: 'stretch'
    })
};
var $b305ff917f319317$var$flexDirectionMap = {
    column: (0, $3dJ4i.css)({
        flexDirection: 'column'
    }),
    row: (0, $3dJ4i.css)({
        flexDirection: 'row'
    })
};
var $b305ff917f319317$var$flexWrapMap = {
    wrap: (0, $3dJ4i.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $3dJ4i.css)({
        flexWrap: 'nowrap'
    })
};
var $b305ff917f319317$var$alignItemsMap = {
    start: (0, $3dJ4i.css)({
        alignItems: 'start'
    }),
    center: (0, $3dJ4i.css)({
        alignItems: 'center'
    }),
    baseline: (0, $3dJ4i.css)({
        alignItems: 'baseline'
    }),
    end: (0, $3dJ4i.css)({
        alignItems: 'end'
    }),
    stretch: (0, $3dJ4i.css)({
        alignItems: 'stretch'
    })
};
var $b305ff917f319317$var$baseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $b305ff917f319317$var$Flex = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $f6YGh.parseXcss)(xcss);
    return (0, $3dJ4i.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $b305ff917f319317$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $ahhSJ.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $ahhSJ.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $ahhSJ.spaceStylesMap).rowGap[rowGap],
            alignItems && $b305ff917f319317$var$alignItemsMap[alignItems],
            direction && $b305ff917f319317$var$flexDirectionMap[direction],
            justifyContent && $b305ff917f319317$var$justifyContentMap[justifyContent],
            wrap && $b305ff917f319317$var$flexWrapMap[wrap],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$b305ff917f319317$var$Flex.displayName = 'Flex';
var $b305ff917f319317$export$2e2bcd8739ae039 = $b305ff917f319317$var$Flex;

});


parcelRegister("lOhVA", function(module, exports) {
$parcel$export(module.exports, "CustomerNameAndLogoHeader", function () { return (parcelRequire("6FDTa")).CustomerNameAndLogoHeader; });
parcelRequire("iIP2k");
var $6FDTa = parcelRequire("6FDTa");

});
parcelRegister("iIP2k", function(module, exports) {
$parcel$export(module.exports, "CustomerNameAndLogoHeader", function () { return (parcelRequire("6FDTa")).CustomerNameAndLogoHeader; });

var $6FDTa = parcelRequire("6FDTa");

});
parcelRegister("6FDTa", function(module, exports) {
$parcel$export(module.exports, "CustomerNameAndLogoHeader", function () { return $31c96e15b6b5b596$export$300e39a32dd2a6cf; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $dTJrO = parcelRequire("dTJrO");

var $79ZK0 = parcelRequire("79ZK0");

var $4jcRW = parcelRequire("4jcRW");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");

var $imIsw = parcelRequire("imIsw");

var $44mZN = parcelRequire("44mZN");
const $31c96e15b6b5b596$var$CustomerLogo = ()=>{
    const intl = (0, $8e22h.default)();
    const { data: customerDomain } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomain);
    // placeholder if no logo is available
    if (!(customerDomain === null || customerDomain === void 0 ? void 0 : customerDomain.customerLogoUrl)) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
        height: "20px",
        width: "20px",
        borderRadius: "4px"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: (customerDomain === null || customerDomain === void 0 ? void 0 : customerDomain.customerLogoUrl) || "",
            alt: intl.formatMessage((0, $44mZN.messages).logoAltText, {
                name: customerDomain === null || customerDomain === void 0 ? void 0 : customerDomain.customerName
            })
        },
        style: {
            width: "20px",
            height: "20px",
            borderRadius: "4px"
        }
    });
};
const $31c96e15b6b5b596$export$300e39a32dd2a6cf = ()=>{
    const { data: customerDomain, pending: customerDomainPending } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomain);
    if (customerDomainPending) return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                height: "20px",
                width: "20px",
                borderRadius: "4px"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                width: "300px",
                height: "28px"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($31c96e15b6b5b596$var$CustomerLogo, {}),
            (customerDomain === null || customerDomain === void 0 ? void 0 : customerDomain.customerName) && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                size: "large",
                children: customerDomain.customerName
            })
        ]
    });
};

});
parcelRegister("79ZK0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5369442489eea5d3$export$2e2bcd8739ae039; });

var $3Hvqv = parcelRequire("3Hvqv");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $f6YGh = parcelRequire("f6YGh");

var $fmW7P = parcelRequire("fmW7P");
var $5369442489eea5d3$var$flexGrowMap = {
    hug: (0, $f6YGh.xcss)({
        flexGrow: 0
    }),
    fill: (0, $f6YGh.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $5369442489eea5d3$var$separatorStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $5369442489eea5d3$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $3dJ4i.jsx)("span", {
        css: $5369442489eea5d3$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $5369442489eea5d3$var$Inline = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $3dJ4i.jsx)($5369442489eea5d3$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $1oC0p.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $5369442489eea5d3$var$flexGrowMap[grow]
    ].concat((0, $3Hvqv.default)(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $3dJ4i.jsx)((0, $fmW7P.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$5369442489eea5d3$var$Inline.displayName = 'Inline';
var $5369442489eea5d3$export$2e2bcd8739ae039 = $5369442489eea5d3$var$Inline;

});

parcelRegister("hVHtn", function(module, exports) {
$parcel$export(module.exports, "getCustomerDomains", function () { return (parcelRequire("8Bmsc")).getCustomerDomains; });
$parcel$export(module.exports, "getFastshiftTopSupportRequests", function () { return (parcelRequire("8Bmsc")).getFastshiftTopSupportRequests; });
$parcel$export(module.exports, "setSelectedDomainOrg", function () { return (parcelRequire("8Bmsc")).setSelectedDomainOrg; });
$parcel$export(module.exports, "setTableControls", function () { return (parcelRequire("8Bmsc")).setTableControls; });
$parcel$export(module.exports, "RESERVED_ORG_IDS", function () { return (parcelRequire("af3Tw")).RESERVED_ORG_IDS; });
$parcel$export(module.exports, "TABLE_IDS", function () { return (parcelRequire("af3Tw")).TABLE_IDS; });
$parcel$export(module.exports, "useFastshiftDispatch", function () { return (parcelRequire("f7YG8")).useFastshiftDispatch; });
$parcel$export(module.exports, "useFastshiftSelector", function () { return (parcelRequire("f7YG8")).useFastshiftSelector; });
parcelRequire("8Bmsc");
parcelRequire("2taMl");
parcelRequire("af3Tw");
parcelRequire("f7YG8");
parcelRequire("e3yIv");

});
parcelRegister("8Bmsc", function(module, exports) {
$parcel$export(module.exports, "setSelectedOrg", function () { return $2677a05a49707444$export$cd3edf940e33def3; });
$parcel$export(module.exports, "setSelectedDomainOrg", function () { return $2677a05a49707444$export$3d74855dfc7f881a; });
$parcel$export(module.exports, "getAccountOrgs", function () { return $2677a05a49707444$export$2644c4f3d6e7a492; });
$parcel$export(module.exports, "getMigrationPlanTotals", function () { return $2677a05a49707444$export$ce2694aa86fc4617; });
$parcel$export(module.exports, "getL1Assessments", function () { return $2677a05a49707444$export$6a6875ffc42cb856; });
$parcel$export(module.exports, "getInstances", function () { return $2677a05a49707444$export$506de6e030509e20; });
$parcel$export(module.exports, "getCustomerDomains", function () { return $2677a05a49707444$export$d64b3effe75ee91f; });
$parcel$export(module.exports, "getCustomerDomain", function () { return $2677a05a49707444$export$b5a74c1474416dd5; });
$parcel$export(module.exports, "getCustomerDomainEngagementDetails", function () { return $2677a05a49707444$export$e4e0db0484cb8896; });
$parcel$export(module.exports, "clearAllCustomerDomainScopedState", function () { return $2677a05a49707444$export$2dc587c028191d7c; });
$parcel$export(module.exports, "clearCustomerDomain", function () { return $2677a05a49707444$export$ef74ea2676036a4e; });
$parcel$export(module.exports, "getUserDetails", function () { return $2677a05a49707444$export$714d3544202969b; });
$parcel$export(module.exports, "getFastshiftTopSupportRequests", function () { return $2677a05a49707444$export$b71610f7925e2a3b; });
$parcel$export(module.exports, "getFastshiftSupportRequests", function () { return $2677a05a49707444$export$621cdc89556e1418; });
$parcel$export(module.exports, "getPortalUserConsent", function () { return $2677a05a49707444$export$be269b99bb17d655; });
$parcel$export(module.exports, "submitPortalUserConsent", function () { return $2677a05a49707444$export$f1ed3d30abd5a9c; });
$parcel$export(module.exports, "setPortalUserConsent", function () { return $2677a05a49707444$export$f56fa5afb895afc0; });
$parcel$export(module.exports, "setTableControls", function () { return $2677a05a49707444$export$798e4cd4112361e2; });
$parcel$export(module.exports, "clearTableControls", function () { return $2677a05a49707444$export$158c1a1ad7df311c; });

var $3GhuR = parcelRequire("3GhuR");

var $9n7Lo = parcelRequire("9n7Lo");
var $2677a05a49707444$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["GET_USER_DETAILS"] = "[FASTSHIFT] GET_USER_DETAILS";
    Actions["GET_CUSTOMER_DOMAINS"] = "[FASTSHIFT] GET_CUSTOMER_DOMAINS";
    Actions["SET_SELECTED_ORG"] = "[FASTSHIFT] SET_SELECTED_ORG";
    Actions["SET_SELECTED_DOMAIN_ORG"] = "[FASTSHIFT] SET_SELECTED_DOMAIN_ORG";
    Actions["GET_ACCOUNT_ORGS"] = "[FASTSHIFT] GET_ACCOUNT_ORGS";
    Actions["GET_MIGRATION_PLANS"] = "[FASTSHIFT] GET_MIGRATION_PLANS";
    Actions["GET_MIGRATION_PLAN_TOTALS"] = "[FASTSHIFT] GET_MIGRATION_PLAN_TOTALS";
    Actions["GET_L1_ASSESSMENTS"] = "[FASTSHIFT] GET_L1_ASSESSMENTS";
    Actions["GET_INSTANCES"] = "[FASTSHIFT] GET_INSTANCES";
    Actions["GET_CUSTOMER_DOMAIN"] = "[FASTSHIFT] GET_CUSTOMER_DOMAIN";
    Actions["GET_CUSTOMER_DOMAIN_ENGAGEMENT_DETAILS"] = "[FASTSHIFT] GET_CUSTOMER_DOMAIN_ENGAGEMENT_DETAILS";
    Actions["CLEAR_ALL_CUSTOMER_DOMAIN_SCOPED_STATE"] = "[FASTSHIFT] CLEAR_ALL_CUSTOMER_DOMAIN_SCOPED_STATE";
    Actions["CLEAR_CUSTOMER_DOMAIN"] = "[FASTSHIFT] CLEAR_CUSTOMER_DOMAIN";
    Actions["GET_USER_TYPE"] = "[FASTSHIFT] GET_USER_TYPE";
    Actions["GET_FASTSHIFT_SUPPORT_REQUESTS"] = "[FASTSHIFT] GET_FASTSHIFT_SUPPORT_REQUESTS";
    Actions["SET_TABLE_CONTROLS"] = "[FASTSHIFT] SET_TABLE_CONTROLS";
    Actions["CLEAR_TABLE_CONTROLS"] = "[FASTSHIFT] CLEAR_TABLE_CONTROLS";
    Actions["GET_FASTSHIFT_TOP_SUPPORT_REQUESTS"] = "[FASTSHIFT] GET_FASTSHIFT_TOP_SUPPORT_REQUESTS";
    Actions["SET_PORTAL_USER_CONSENT"] = "[FASTSHIFT] SET_PORTAL_USER_CONSENT";
    Actions["SUBMIT_PORTAL_USER_CONSENT"] = "[FASTSHIFT] SUBMIT_PORTAL_USER_CONSENT";
    Actions["GET_PORTAL_USER_CONSENT"] = "[FASTSHIFT] GET_PORTAL_USER_CONSENT";
    return Actions;
}({});
const $2677a05a49707444$export$cd3edf940e33def3 = (0, $3GhuR.createAction)("[FASTSHIFT] SET_SELECTED_ORG");
const $2677a05a49707444$export$3d74855dfc7f881a = (0, $3GhuR.createAction)("[FASTSHIFT] SET_SELECTED_DOMAIN_ORG");
const $2677a05a49707444$export$2644c4f3d6e7a492 = (0, $3GhuR.createAsyncThunk)("[FASTSHIFT] GET_ACCOUNT_ORGS", async (stargateClient)=>{
    const response = await stargateClient.getAccountOrgs({});
    const responseAdminhub = await stargateClient.getAdminhubAccountOrgs({});
    return (0, $9n7Lo.filterForActiveOrgs)(response === null || response === void 0 ? void 0 : response.accountOrgs, responseAdminhub === null || responseAdminhub === void 0 ? void 0 : responseAdminhub.accountOrgs);
});
const $2677a05a49707444$export$ce2694aa86fc4617 = (0, $3GhuR.createAsyncThunk)("[FASTSHIFT] GET_MIGRATION_PLAN_TOTALS", async ({ stargateClient: stargateClient, orgId: orgId })=>{
    const response = await stargateClient.getMigrationPlanTotals({
        orgId: orgId
    });
    return response;
});
const $2677a05a49707444$export$6a6875ffc42cb856 = (0, $3GhuR.createAsyncThunk)("[FASTSHIFT] GET_L1_ASSESSMENTS", async ({ stargateClient: stargateClient, orgId: orgId })=>{
    const response = await stargateClient.getL1Assessments({
        orgId: orgId
    });
    return response;
});
const $2677a05a49707444$export$506de6e030509e20 = (0, $3GhuR.createAsyncThunk)("[FASTSHIFT] GET_INSTANCES", async ({ stargateClient: stargateClient, orgId: orgId })=>{
    const response = await stargateClient.getInstances({
        orgId: orgId
    });
    return response;
});
const $2677a05a49707444$export$d64b3effe75ee91f = (0, $3GhuR.createAsyncThunk)("[FASTSHIFT] GET_CUSTOMER_DOMAINS", async ({ stargateClient: stargateClient, controls: controls })=>{
    const response = await stargateClient.getFastshiftCustomerDomains({
        page: controls.page,
        size: controls.size,
        sortBy: controls.sortBy,
        sortDirection: controls.sortDirection,
        searchTerm: controls.searchTerm,
        filters: controls.filters
    });
    return response;
});
const $2677a05a49707444$export$b5a74c1474416dd5 = (0, $3GhuR.createAsyncThunk)("[FASTSHIFT] GET_CUSTOMER_DOMAIN", async ({ stargateClient: stargateClient, customerDomainId: customerDomainId })=>{
    const response = await stargateClient.getFastshiftCustomerDomain({
        customerDomainId: customerDomainId
    });
    return response.data;
});
const $2677a05a49707444$export$e4e0db0484cb8896 = (0, $3GhuR.createAsyncThunk)("[FASTSHIFT] GET_CUSTOMER_DOMAIN_ENGAGEMENT_DETAILS", async ({ stargateClient: stargateClient, customerDomainId: customerDomainId })=>{
    const response = await stargateClient.getFastshiftCustomerDomainEngagement({
        customerDomainId: customerDomainId
    });
    return response.data;
});
const $2677a05a49707444$export$2dc587c028191d7c = (0, $3GhuR.createAction)("[FASTSHIFT] CLEAR_ALL_CUSTOMER_DOMAIN_SCOPED_STATE");
const $2677a05a49707444$export$ef74ea2676036a4e = (0, $3GhuR.createAction)("[FASTSHIFT] CLEAR_CUSTOMER_DOMAIN");
const $2677a05a49707444$export$714d3544202969b = (0, $3GhuR.createAsyncThunk)("[FASTSHIFT] GET_USER_DETAILS", async (stargateClient)=>{
    const response = await stargateClient.getFastshiftUser({});
    return response.data;
});
const $2677a05a49707444$export$b71610f7925e2a3b = (0, $3GhuR.createAsyncThunk)("[FASTSHIFT] GET_FASTSHIFT_TOP_SUPPORT_REQUESTS", async ({ stargateClient: stargateClient, domainId: domainId, count: count, queryParams: queryParams })=>{
    const response = await stargateClient.getFastshiftTopSupportRequests({
        domainId: domainId,
        count: count,
        queryParams: queryParams
    });
    return response.data;
});
const $2677a05a49707444$export$621cdc89556e1418 = (0, $3GhuR.createAsyncThunk)("[FASTSHIFT] GET_FASTSHIFT_SUPPORT_REQUESTS", async ({ stargateClient: stargateClient, customerDomainId: customerDomainId, queryParams: queryParams })=>{
    const response = await stargateClient.getFastshiftSupportRequests({
        customerDomainId: customerDomainId,
        queryParams: queryParams
    });
    return response;
});
const $2677a05a49707444$export$be269b99bb17d655 = (0, $3GhuR.createAsyncThunk)("[FASTSHIFT] GET_PORTAL_USER_CONSENT", async ({ stargateClient: stargateClient, displayedText: displayedText })=>{
    const response = await stargateClient.fetchFastshiftPortalConsentRequest({
        requestBody: {
            displayedText: displayedText
        }
    });
    return response.data.consent;
});
const $2677a05a49707444$export$f1ed3d30abd5a9c = (0, $3GhuR.createAsyncThunk)("[FASTSHIFT] SUBMIT_PORTAL_USER_CONSENT", async ({ stargateClient: stargateClient, displayedText: displayedText, locale: locale })=>{
    const response = await stargateClient.sendFastshiftPortalConsent({
        requestBody: {
            displayedText: displayedText,
            locale: locale
        }
    });
    return response.data.consent;
});
const $2677a05a49707444$export$f56fa5afb895afc0 = (0, $3GhuR.createAction)("[FASTSHIFT] SET_PORTAL_USER_CONSENT");
const $2677a05a49707444$export$798e4cd4112361e2 = (0, $3GhuR.createAction)("[FASTSHIFT] SET_TABLE_CONTROLS");
const $2677a05a49707444$export$158c1a1ad7df311c = (0, $3GhuR.createAction)("[FASTSHIFT] CLEAR_TABLE_CONTROLS");

});
parcelRegister("9n7Lo", function(module, exports) {
$parcel$export(module.exports, "filterForActiveOrgs", function () { return $6b327f9d2a28c3c8$export$cf62ac3648a13fac; });
$parcel$export(module.exports, "getUserDomain", function () { return $6b327f9d2a28c3c8$export$e9ebe20ff7f8ff23; });
$parcel$export(module.exports, "captureErrorWithContext", function () { return $6b327f9d2a28c3c8$export$33d62652bf76a4d1; });

var $1jDl2 = parcelRequire("1jDl2");

var $k3sv9 = parcelRequire("k3sv9");
const $6b327f9d2a28c3c8$export$cf62ac3648a13fac = (accountOrgs, adminhubAccountOrgs)=>{
    if (!accountOrgs || !adminhubAccountOrgs) return [];
    const mergedAccountOrgs = accountOrgs.filter((org)=>{
        return adminhubAccountOrgs === null || adminhubAccountOrgs === void 0 ? void 0 : adminhubAccountOrgs.find((adminhubOrg)=>adminhubOrg.id === org.id);
    });
    return mergedAccountOrgs;
};
const $6b327f9d2a28c3c8$export$e9ebe20ff7f8ff23 = (state)=>{
    var _state_userDetails_data_userDomain, _state_userDetails_data;
    return (_state_userDetails_data = state.userDetails.data) === null || _state_userDetails_data === void 0 ? void 0 : (_state_userDetails_data_userDomain = _state_userDetails_data.userDomain) === null || _state_userDetails_data_userDomain === void 0 ? void 0 : _state_userDetails_data_userDomain.domain;
};
const $6b327f9d2a28c3c8$export$33d62652bf76a4d1 = ({ error: error, message: message, userDomain: userDomain })=>{
    $1jDl2.captureException(new Error(error), {
        tags: {
            projectName: (0, $k3sv9.SENTRY_PROJECT_NAME)
        },
        extra: {
            errorMessage: message,
            userDomain: userDomain || ""
        }
    });
};

});
parcelRegister("k3sv9", function(module, exports) {
$parcel$export(module.exports, "SENTRY_PROJECT_NAME", function () { return $e96d3c3f171db855$export$4180ed4389ea0efb; });
const $e96d3c3f171db855$export$4180ed4389ea0efb = "FASTSHIFT_PORTAL";

});



parcelRegister("2taMl", function(module, exports) {
$parcel$export(module.exports, "initialState", function () { return $70c58e228f149688$export$d4c72bab9d6cc13a; });
$parcel$export(module.exports, "reducer", function () { return $70c58e228f149688$export$1650419e431d3ba3; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $3GhuR = parcelRequire("3GhuR");

var $eh9Uj = parcelRequire("eh9Uj");

var $8Bmsc = parcelRequire("8Bmsc");

var $af3Tw = parcelRequire("af3Tw");
parcelRequire("hOMFg");
var $PE2DD = parcelRequire("PE2DD");
var $hOMFg = parcelRequire("hOMFg");

var $9n7Lo = parcelRequire("9n7Lo");
const $70c58e228f149688$export$d4c72bab9d6cc13a = {
    userDetails: {
        pending: false,
        data: null,
        error: null
    },
    portalUserConsent: {
        pending: false,
        data: null,
        error: null
    },
    selectedOrg: null,
    selectedDomainOrg: null,
    orgs: {
        pending: false,
        data: [],
        error: null
    },
    migrationPlanTotals: {
        pending: false,
        data: {
            totalPlansCompleted: 0,
            totalPlansUnsuccessful: 0,
            totalPlansRunning: 0
        },
        error: null
    },
    l1Assessments: {
        pending: false,
        data: [],
        error: null
    },
    instances: {
        pending: false,
        data: {
            instances: [],
            totalCount: 0
        },
        error: null
    },
    customerDomain: {
        pending: false,
        error: null,
        data: null
    },
    customerDomainEngagement: {
        pending: false,
        error: null,
        data: null
    },
    // states for partner and fastshift team roles only:
    customerDomains: {
        pending: false,
        error: null,
        data: {
            data: [],
            pagination: {
                page: 0,
                size: 20,
                totalElements: 0,
                totalPages: 0,
                hasNext: false,
                hasPrevious: false,
                sorted: false
            }
        }
    },
    topSupportRequests: {
        pending: false,
        error: null,
        data: null
    },
    supportRequests: {
        pending: false,
        error: null,
        data: null
    },
    pageStateCache: {
        [(0, $af3Tw.TABLE_IDS).SELECTION]: (0, $dPABA._)((0, $6ogO3._)({}, (0, $eh9Uj.DEFAULT_CONTROLS_PAYLOAD)), {
            filters: (0, $dPABA._)((0, $6ogO3._)({}, (0, $eh9Uj.DEFAULT_CONTROLS_PAYLOAD).filters), {
                status: null
            })
        }),
        [(0, $af3Tw.TABLE_IDS).MIGRATION_TICKETS]: (0, $eh9Uj.DEFAULT_CONTROLS_PAYLOAD)
    }
};
const $70c58e228f149688$export$cbf0ecd8bd2735d8 = {
    id: (0, $af3Tw.RESERVED_ORG_IDS).NO_ORG,
    isAdmin: true,
    name: "No Org" // do not display this name to customers
};
const $70c58e228f149688$export$1650419e431d3ba3 = (state = $70c58e228f149688$export$d4c72bab9d6cc13a)=>(0, $3GhuR.createReducer)(state, (builder)=>{
        builder.addCase($8Bmsc.setSelectedOrg, (state, { payload: payload })=>{
            state.selectedOrg = payload;
            // save selected org to localstorage
            localStorage.setItem((0, $af3Tw.FASTSHIFT_LOCALSTORAGE_KEYS).SELECTED_ORG_ID, JSON.stringify(payload.id));
        }).addCase($8Bmsc.setSelectedDomainOrg, (state, { payload: payload })=>{
            state.selectedDomainOrg = payload;
            // Clear support requests when org changes to prevent stale data
            state.supportRequests.pending = false;
            state.supportRequests.error = null;
            state.supportRequests.data = null;
            state.supportRequests.lastFetchParams = undefined;
            // Clear top support requests when org changes to prevent stale data
            state.topSupportRequests.pending = false;
            state.topSupportRequests.error = null;
            state.topSupportRequests.data = null;
            state.topSupportRequests.lastFetchParams = undefined;
        }).addCase($8Bmsc.getAccountOrgs.fulfilled, (state, { payload: payload })=>{
            state.orgs.pending = false;
            var _payload_reduce;
            // filter out orgs where user is not an admin
            const orgsList = (_payload_reduce = payload === null || payload === void 0 ? void 0 : payload.reduce((acc, { id: id, isAdmin: isAdmin, name: name })=>{
                if (isAdmin) acc.push({
                    id: id,
                    isAdmin: isAdmin,
                    name: name
                });
                return acc;
            }, [])) !== null && _payload_reduce !== void 0 ? _payload_reduce : [];
            state.orgs.data = [
                ...orgsList,
                $70c58e228f149688$export$cbf0ecd8bd2735d8
            ];
            state.orgs.error = null;
        }).addCase($8Bmsc.getAccountOrgs.pending, (state)=>{
            state.orgs.pending = true;
            state.orgs.error = null;
        }).addCase($8Bmsc.getAccountOrgs.rejected, (state, action)=>{
            state.orgs.pending = false;
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.orgs.error = message;
            (0, $9n7Lo.captureErrorWithContext)({
                error: "Error on fetching account orgs",
                message: message,
                userDomain: (0, $9n7Lo.getUserDomain)(state)
            });
        }).addCase($8Bmsc.getMigrationPlanTotals.fulfilled, (state, { payload: payload })=>{
            state.migrationPlanTotals.pending = false;
            state.migrationPlanTotals.data = payload;
            state.migrationPlanTotals.error = null;
        }).addCase($8Bmsc.getMigrationPlanTotals.pending, (state)=>{
            state.migrationPlanTotals.pending = true;
            state.migrationPlanTotals.error = null;
        }).addCase($8Bmsc.getMigrationPlanTotals.rejected, (state)=>{
            state.migrationPlanTotals.pending = false;
            state.migrationPlanTotals.data = {
                totalPlansCompleted: 0,
                totalPlansUnsuccessful: 0,
                totalPlansRunning: 0
            };
            const message = "error fetching migration plan totals";
            state.migrationPlanTotals.error = message;
            (0, $9n7Lo.captureErrorWithContext)({
                error: "Error on fetching migration plan totals",
                message: message,
                userDomain: (0, $9n7Lo.getUserDomain)(state)
            });
        }).addCase($8Bmsc.getL1Assessments.fulfilled, (state, { payload: payload })=>{
            state.l1Assessments.pending = false;
            state.l1Assessments.data = payload;
            state.l1Assessments.error = null;
        }).addCase($8Bmsc.getL1Assessments.pending, (state)=>{
            state.l1Assessments.pending = true;
            state.l1Assessments.error = null;
        }).addCase($8Bmsc.getL1Assessments.rejected, (state, action)=>{
            state.l1Assessments.pending = false;
            state.l1Assessments.data = [];
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.l1Assessments.error = message;
            (0, $9n7Lo.captureErrorWithContext)({
                error: "Error on fetching l1 assessments",
                message: message,
                userDomain: (0, $9n7Lo.getUserDomain)(state)
            });
        }).addCase($8Bmsc.getInstances.fulfilled, (state, { payload: payload })=>{
            state.instances.pending = false;
            state.instances.data.instances = payload.instances;
            state.instances.data.totalCount = payload.totalCount;
            state.instances.error = null;
        }).addCase($8Bmsc.getInstances.pending, (state)=>{
            state.instances.pending = true;
            state.instances.error = null;
        }).addCase($8Bmsc.getInstances.rejected, (state, action)=>{
            state.instances.pending = false;
            state.instances.data = {
                instances: [],
                totalCount: 0
            };
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.instances.error = message;
            (0, $9n7Lo.captureErrorWithContext)({
                error: "Error on fetching MMA instances",
                message: message,
                userDomain: (0, $9n7Lo.getUserDomain)(state)
            });
        }).addCase($8Bmsc.getCustomerDomains.fulfilled, (state, { payload: payload })=>{
            state.customerDomains.pending = false;
            state.customerDomains.data = payload;
            state.customerDomains.error = null;
        }).addCase($8Bmsc.getCustomerDomains.pending, (state)=>{
            state.customerDomains.pending = true;
            state.customerDomains.error = null;
        }).addCase($8Bmsc.getCustomerDomains.rejected, (state, action)=>{
            state.customerDomains.pending = false;
            state.customerDomains.data = {
                data: [],
                pagination: {
                    page: 0,
                    size: 20,
                    totalElements: 0,
                    totalPages: 0,
                    hasNext: false,
                    hasPrevious: false,
                    sorted: false
                }
            };
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.customerDomains.error = message;
            (0, $9n7Lo.captureErrorWithContext)({
                error: "Error on fetching customer domains list",
                message: message,
                userDomain: (0, $9n7Lo.getUserDomain)(state)
            });
        }).addCase($8Bmsc.getCustomerDomain.fulfilled, (state, { payload: payload })=>{
            state.customerDomain.pending = false;
            state.customerDomain.data = payload;
            state.customerDomain.error = null;
        }).addCase($8Bmsc.getCustomerDomain.pending, (state)=>{
            state.customerDomain.pending = true;
            state.customerDomain.error = null;
        }).addCase($8Bmsc.getCustomerDomain.rejected, (state, action)=>{
            state.customerDomain.pending = false;
            state.customerDomain.data = null;
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.customerDomain.error = message;
            (0, $9n7Lo.captureErrorWithContext)({
                error: "Error on fetching customer domain details",
                message: message,
                userDomain: (0, $9n7Lo.getUserDomain)(state)
            });
        }).addCase($8Bmsc.getCustomerDomainEngagementDetails.fulfilled, (state, { payload: payload })=>{
            state.customerDomainEngagement.pending = false;
            state.customerDomainEngagement.data = payload;
            state.customerDomainEngagement.error = null;
        }).addCase($8Bmsc.getCustomerDomainEngagementDetails.pending, (state)=>{
            state.customerDomainEngagement.pending = true;
            state.customerDomainEngagement.error = null;
        }).addCase($8Bmsc.getCustomerDomainEngagementDetails.rejected, (state, action)=>{
            state.customerDomainEngagement.pending = false;
            state.customerDomainEngagement.data = null;
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.customerDomainEngagement.error = message;
            // check if error is expected
            const isExpectedError = Object.values($PE2DD.CustomerDomainEngagementExpectedError).includes(message);
            // if unexpected, capture on Sentry
            if (!isExpectedError) (0, $9n7Lo.captureErrorWithContext)({
                error: "Error on fetching customer domain engagement details",
                message: message,
                userDomain: (0, $9n7Lo.getUserDomain)(state)
            });
        })// Legal Consent (Only required for Customer role)
        .addCase($8Bmsc.getPortalUserConsent.pending, (state)=>{
            state.portalUserConsent.pending = true;
            state.portalUserConsent.error = null;
            state.portalUserConsent.data = null;
        }).addCase($8Bmsc.getPortalUserConsent.fulfilled, (state, { payload: payload })=>{
            state.portalUserConsent.pending = false;
            state.portalUserConsent.data = payload;
            state.portalUserConsent.error = null;
        }).addCase($8Bmsc.getPortalUserConsent.rejected, (state, action)=>{
            state.portalUserConsent.pending = false;
            state.portalUserConsent.data = null;
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.portalUserConsent.error = message;
            // capture on Sentry
            (0, $9n7Lo.captureErrorWithContext)({
                error: "Error on fetching user consent state",
                message: message,
                userDomain: (0, $9n7Lo.getUserDomain)(state)
            });
        }).addCase($8Bmsc.submitPortalUserConsent.pending, (state)=>{
            state.portalUserConsent.pending = true;
            state.portalUserConsent.error = null;
        }).addCase($8Bmsc.submitPortalUserConsent.fulfilled, (state, { payload: payload })=>{
            state.portalUserConsent.pending = false;
            state.portalUserConsent.data = payload;
            state.portalUserConsent.error = null;
        }).addCase($8Bmsc.submitPortalUserConsent.rejected, (state, action)=>{
            state.portalUserConsent.pending = false;
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.portalUserConsent.error = message;
            // capture on Sentry
            (0, $9n7Lo.captureErrorWithContext)({
                error: "Error on submitting user consent state",
                message: message,
                userDomain: (0, $9n7Lo.getUserDomain)(state)
            });
        }).addCase($8Bmsc.setPortalUserConsent, (state, { payload: payload })=>{
            state.portalUserConsent.data = payload;
        })// Fastshift support requests (M2-specific)
        .addCase($8Bmsc.getFastshiftSupportRequests.pending, (state)=>{
            state.supportRequests.pending = true;
            state.supportRequests.error = null;
            state.supportRequests.data = null;
        }).addCase($8Bmsc.getFastshiftSupportRequests.fulfilled, (state, { payload: payload, meta: meta })=>{
            state.supportRequests.pending = false;
            state.supportRequests.data = payload.data;
            state.supportRequests.error = null;
            state.supportRequests.lastFetchParams = {
                customerDomainId: meta.arg.customerDomainId,
                queryParams: meta.arg.queryParams
            };
        }).addCase($8Bmsc.getFastshiftSupportRequests.rejected, (state, action)=>{
            if (action.error.name === $hOMFg.FastshiftApiAbortError) return;
            state.supportRequests.pending = false;
            state.supportRequests.data = null;
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.supportRequests.error = message;
            (0, $9n7Lo.captureErrorWithContext)({
                error: "Error on fetching support requests",
                message: message,
                userDomain: (0, $9n7Lo.getUserDomain)(state)
            });
        }).addCase($8Bmsc.getFastshiftTopSupportRequests.pending, (state)=>{
            state.topSupportRequests.pending = true;
            state.topSupportRequests.error = null;
            state.topSupportRequests.data = null;
        }).addCase($8Bmsc.getFastshiftTopSupportRequests.fulfilled, (state, { payload: payload, meta: meta })=>{
            state.topSupportRequests.pending = false;
            state.topSupportRequests.data = payload;
            state.topSupportRequests.error = null;
            state.topSupportRequests.lastFetchParams = {
                customerDomainId: meta.arg.domainId,
                queryParams: meta.arg.queryParams
            };
        }).addCase($8Bmsc.getFastshiftTopSupportRequests.rejected, (state, action)=>{
            if (action.error.name === $hOMFg.FastshiftApiAbortError) return;
            state.topSupportRequests.pending = false;
            state.topSupportRequests.data = null;
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.topSupportRequests.error = message;
            (0, $9n7Lo.captureErrorWithContext)({
                error: "Error on fetching top support requests",
                message: message,
                userDomain: (0, $9n7Lo.getUserDomain)(state)
            });
        }).addCase($8Bmsc.clearAllCustomerDomainScopedState, (state)=>{
            state.customerDomain.pending = false;
            state.customerDomain.error = null;
            state.customerDomain.data = null;
            state.customerDomainEngagement.pending = false;
            state.customerDomainEngagement.error = null;
            state.customerDomainEngagement.data = null;
            state.selectedDomainOrg = null;
            state.pageStateCache[(0, $af3Tw.TABLE_IDS).MIGRATION_TICKETS] = $70c58e228f149688$export$d4c72bab9d6cc13a.pageStateCache[(0, $af3Tw.TABLE_IDS).MIGRATION_TICKETS];
            state.supportRequests.pending = false;
            state.supportRequests.error = null;
            state.supportRequests.data = null;
            state.supportRequests.lastFetchParams = undefined;
            state.topSupportRequests.pending = false;
            state.topSupportRequests.error = null;
            state.topSupportRequests.data = null;
            state.topSupportRequests.lastFetchParams = undefined;
        }).addCase($8Bmsc.clearCustomerDomain, (state)=>{
            state.customerDomain.pending = false;
            state.customerDomain.data = null;
            state.customerDomain.error = null;
        }).addCase($8Bmsc.setTableControls, (state, { payload: payload })=>{
            state.pageStateCache[payload.tableId] = payload.controls;
        }).addCase($8Bmsc.clearTableControls, (state, { payload: payload })=>{
            state.pageStateCache[payload.tableId] = $70c58e228f149688$export$d4c72bab9d6cc13a.pageStateCache[payload.tableId];
        }).addCase($8Bmsc.getUserDetails.fulfilled, (state, { payload: payload })=>{
            state.userDetails.pending = false;
            state.userDetails.data = payload;
            state.userDetails.error = null;
        }).addCase($8Bmsc.getUserDetails.pending, (state)=>{
            state.userDetails.pending = true;
            state.userDetails.data = null;
            state.userDetails.error = null;
        }).addCase($8Bmsc.getUserDetails.rejected, (state, action)=>{
            state.userDetails.pending = false;
            state.userDetails.data = null;
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.userDetails.error = message;
            // check if error is expected
            const isExpectedError = Object.values($PE2DD.FastshiftUserDetailsExpectedError).includes(message);
            // if unexpected, capture on Sentry
            if (!isExpectedError) (0, $9n7Lo.captureErrorWithContext)({
                error: "Error on fetching user details",
                message: message
            });
        });
    });

});
parcelRegister("eh9Uj", function(module, exports) {
$parcel$export(module.exports, "PAGE_SIZE_OPTIONS", function () { return $aa75101efd41b70d$export$a6e06e7d29ab728f; });
$parcel$export(module.exports, "SORT_DIRECTION", function () { return $aa75101efd41b70d$export$2e66878530bcbbc7; });
$parcel$export(module.exports, "PAGINATION_DIRECTION", function () { return $aa75101efd41b70d$export$fd5e87f1af24bb82; });
$parcel$export(module.exports, "DEFAULT_CONTROLS_PAYLOAD", function () { return $aa75101efd41b70d$export$29263a91418b8a52; });
const $aa75101efd41b70d$export$a6e06e7d29ab728f = [
    {
        label: "20",
        value: 20
    },
    {
        label: "50",
        value: 50
    },
    {
        label: "100",
        value: 100
    }
];
const $aa75101efd41b70d$export$2e66878530bcbbc7 = {
    ASC: "ASC",
    DESC: "DESC"
};
const $aa75101efd41b70d$export$fd5e87f1af24bb82 = {
    NEXT: "NEXT",
    PREVIOUS: "PREVIOUS"
};
const $aa75101efd41b70d$export$29263a91418b8a52 = {
    page: 0,
    size: $aa75101efd41b70d$export$a6e06e7d29ab728f[0].value,
    sortBy: undefined,
    sortDirection: undefined,
    searchTerm: undefined,
    filters: {}
};

});

parcelRegister("af3Tw", function(module, exports) {
$parcel$export(module.exports, "FASTSHIFT_LOCALSTORAGE_KEYS", function () { return $0500f05417e5faff$export$c800bcb193959663; });
$parcel$export(module.exports, "RESERVED_ORG_IDS", function () { return $0500f05417e5faff$export$e4c154fc57bef850; });
$parcel$export(module.exports, "TABLE_IDS", function () { return $0500f05417e5faff$export$e2b2f27b574d8e44; });
const $0500f05417e5faff$export$c800bcb193959663 = {
    SELECTED_ORG_ID: "fastshift-selected-org"
};
const $0500f05417e5faff$export$e4c154fc57bef850 = {
    NO_ORG: "no-org",
    OTHER_ORGS: "other-orgs"
};
const $0500f05417e5faff$export$e2b2f27b574d8e44 = {
    SELECTION: "selection",
    MIGRATION_TICKETS: "migrationTickets"
};

});

parcelRegister("hOMFg", function(module, exports) {
$parcel$export(module.exports, "FastshiftApiAbortError", function () { return $9c713ba3af6eb3cd$export$4f590d2762a2c291; });
$parcel$export(module.exports, "CustomerDomainEngagementExpectedError", function () { return (parcelRequire("PE2DD")).CustomerDomainEngagementExpectedError; });
$parcel$export(module.exports, "FastshiftUserDetailsExpectedError", function () { return (parcelRequire("PE2DD")).FastshiftUserDetailsExpectedError; });

var $PE2DD = parcelRequire("PE2DD");
const $9c713ba3af6eb3cd$export$4f590d2762a2c291 = "AbortError";

});


parcelRegister("f7YG8", function(module, exports) {
$parcel$export(module.exports, "useFastshiftDispatch", function () { return $1875adb4e251bc3f$export$671a5d40d73a6cc5; });
$parcel$export(module.exports, "useFastshiftSelector", function () { return $1875adb4e251bc3f$export$5f2b59a93069b0dc; });

var $evmye = parcelRequire("evmye");
const $1875adb4e251bc3f$export$671a5d40d73a6cc5 = ()=>(0, $evmye.useDispatch)();
const $1875adb4e251bc3f$export$5f2b59a93069b0dc = (0, $evmye.useSelector);

});

parcelRegister("e3yIv", function(module, exports) {
$parcel$export(module.exports, "store", function () { return $fa449bd835dea33f$export$6f57813fe9f31bf9; });

var $3GhuR = parcelRequire("3GhuR");

var $2taMl = parcelRequire("2taMl");
const $fa449bd835dea33f$export$6f57813fe9f31bf9 = (0, $3GhuR.configureStore)({
    reducer: (0, $2taMl.reducer)((0, $2taMl.initialState)),
    devTools: {
        name: "fastshift/global"
    }
});

});


parcelRegister("44mZN", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $e1fa6859eb8ed282$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $e1fa6859eb8ed282$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    logoAltText: {
        id: "fastshift-portal.domain-scoped-page.customer-name-and-logo.logo-alt-text",
        defaultMessage: "{name} logo",
        dsecription: "Alt Text for company logo icon for the selected customer"
    }
});

});




parcelRegister("bh3Fv", function(module, exports) {
$parcel$export(module.exports, "useRoutes", function () { return $ad293be5a5f33fc0$export$5d3fca4a98652595; });

var $aPnCa = parcelRequire("aPnCa");

var $1oC0p = parcelRequire("1oC0p");

var $j2t2h = parcelRequire("j2t2h");
var $jwXhl = parcelRequire("jwXhl");

var $fq4go = parcelRequire("fq4go");
const $ad293be5a5f33fc0$var$PATHS_KEYS = {
    HOME: "home",
    SELECTION: "selection",
    PARTNER_RESOURCES: "partnerResources",
    DOMAIN_SCOPED_OVERVIEW: "domainScopedOverview",
    DOMAIN_SCOPED_PLANNING: "domainScopedPlanning",
    DOMAIN_SCOPED_TICKETS: "domainScopedTickets",
    DOMAIN_SCOPED_RESOURCES: "domainScopedResources",
    EAP_HOME: "eapHome"
};
const $ad293be5a5f33fc0$export$5d3fca4a98652595 = ()=>{
    const { pathname: pathname } = (0, $j2t2h.useLocation)();
    const { locale: locale, domainId: domainId } = (0, $jwXhl.useParams)();
    const injectParams = (0, $1oC0p.useCallback)((path, targetDomainId)=>{
        var _ref;
        return `${locale ? `/${locale}/` : "/"}${path.replace(":domainId", (_ref = targetDomainId !== null && targetDomainId !== void 0 ? targetDomainId : domainId) !== null && _ref !== void 0 ? _ref : "")}`;
    }, [
        locale,
        domainId
    ]);
    const paths = {
        [$ad293be5a5f33fc0$var$PATHS_KEYS.HOME]: injectParams((0, $fq4go.FASTSHIFT_PATHS)[(0, $fq4go.FASTSHIFT_PATH_KEYS).FASTSHIFT]),
        [$ad293be5a5f33fc0$var$PATHS_KEYS.SELECTION]: injectParams((0, $fq4go.FASTSHIFT_PATHS)[(0, $fq4go.FASTSHIFT_PATH_KEYS).SELECTION]),
        [$ad293be5a5f33fc0$var$PATHS_KEYS.PARTNER_RESOURCES]: injectParams((0, $fq4go.FASTSHIFT_PATHS)[(0, $fq4go.FASTSHIFT_PATH_KEYS).RESOURCES_PARTNER_SCOPED]),
        [$ad293be5a5f33fc0$var$PATHS_KEYS.DOMAIN_SCOPED_OVERVIEW]: domainId ? injectParams((0, $fq4go.FASTSHIFT_PATHS)[(0, $fq4go.FASTSHIFT_PATH_KEYS).OVERVIEW]) : null,
        [$ad293be5a5f33fc0$var$PATHS_KEYS.DOMAIN_SCOPED_PLANNING]: domainId ? injectParams((0, $fq4go.FASTSHIFT_PATHS)[(0, $fq4go.FASTSHIFT_PATH_KEYS).PLANNING]) : null,
        [$ad293be5a5f33fc0$var$PATHS_KEYS.DOMAIN_SCOPED_TICKETS]: domainId ? injectParams((0, $fq4go.FASTSHIFT_PATHS)[(0, $fq4go.FASTSHIFT_PATH_KEYS).TICKETS]) : null,
        [$ad293be5a5f33fc0$var$PATHS_KEYS.DOMAIN_SCOPED_RESOURCES]: domainId ? injectParams((0, $fq4go.FASTSHIFT_PATHS)[(0, $fq4go.FASTSHIFT_PATH_KEYS).RESOURCES_DOMAIN_SCOPED]) : null,
        [$ad293be5a5f33fc0$var$PATHS_KEYS.EAP_HOME]: injectParams((0, $fq4go.FASTSHIFT_EAP_HOME_PATH))
    };
    const getPathByDomainId = (path, targetDomainId)=>{
        return injectParams(path, targetDomainId);
    };
    const isValidFastshiftRoute = (pathname)=>{
        const { eapHome: _ } = paths, rest = (0, $aPnCa._)(paths, [
            "eapHome"
        ]);
        return Object.values(rest).includes(pathname);
    };
    const isValidFastshiftPartnerRoute = (pathname)=>{
        return [
            paths.selection,
            paths.partnerResources
        ].includes(pathname);
    };
    return {
        domainId: domainId,
        fullPathname: pathname,
        paths: paths,
        getPathByDomainId: getPathByDomainId,
        isValidFastshiftRoute: isValidFastshiftRoute,
        isValidFastshiftPartnerRoute: isValidFastshiftPartnerRoute
    };
};

});

parcelRegister("hv38C", function(module, exports) {
$parcel$export(module.exports, "LegalBanner", function () { return $5a9283d601789a24$export$543e27ba781fe46f; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $7ZMp9 = parcelRequire("7ZMp9");

var $lPRxe = parcelRequire("lPRxe");

var $8S1MN = parcelRequire("8S1MN");

var $kWwru = parcelRequire("kWwru");
const $5a9283d601789a24$var$RESOURCE_LINKS = {
    AtlassianCustomerAgreementLink: "https://www.atlassian.com/legal/atlassian-customer-agreement#intro",
    AtlassianPrivacyPolicyLink: "https://www.atlassian.com/legal/privacy-policy"
};
const $5a9283d601789a24$export$543e27ba781fe46f = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8S1MN.default), {
        title: intl.formatMessage((0, $kWwru.messages).legalTitle),
        appearance: "discovery",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $kWwru.messages).legalDescription), {
                values: {
                    CustomerAgreementLink: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7ZMp9.default), {
                        href: $5a9283d601789a24$var$RESOURCE_LINKS.AtlassianCustomerAgreementLink,
                        target: "_blank",
                        children: intl.formatMessage((0, $kWwru.messages).atlassianCustomerAgreementLinkText)
                    }),
                    PrivacyPolicyLink: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7ZMp9.default), {
                        href: $5a9283d601789a24$var$RESOURCE_LINKS.AtlassianPrivacyPolicyLink,
                        target: "_blank",
                        children: intl.formatMessage((0, $kWwru.messages).atlassianPrivacyPolicyLinkText)
                    })
                }
            }))
        })
    });
};

});
parcelRegister("kWwru", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $cabbc79b0896afbe$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $cabbc79b0896afbe$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    legalTitle: {
        id: "fastshift.legal-banner.title",
        defaultMessage: "FastShift Portal use agreement",
        description: "Title for Legal banner about usage agreement"
    },
    legalDescription: {
        id: "fastshift.legal-banner.description",
        defaultMessage: "By using this FastShift Portal, you agree that its use is governed by the {CustomerAgreementLink} and the {PrivacyPolicyLink}. This FastShift Portal is considered to be a \u201CFree or Beta product\u201D under Section 17 of the Atlassian Customer Agreement.",
        description: "Description for Legal banner about usage agreement"
    },
    atlassianCustomerAgreementLinkText: {
        id: "fastshift.legal-banner.customer-agreement-link-text",
        defaultMessage: "Atlassian Customer Agreement",
        description: "link text for link to Atlassian Customer Agreement"
    },
    atlassianPrivacyPolicyLinkText: {
        id: "fastshift.legal-banner.privacy-policy-link-text",
        defaultMessage: "Atlassian Privacy Policy",
        description: "link text for link to Atlassian Privacy Policy"
    }
});

});


parcelRegister("cHEgA", function(module, exports) {
$parcel$export(module.exports, "RelationshipSection", function () { return (parcelRequire("jN2ro")).RelationshipSection; });
parcelRequire("lDFc7");
var $5PYTZ = parcelRequire("5PYTZ");

var $jN2ro = parcelRequire("jN2ro");

});
parcelRegister("lDFc7", function(module, exports) {
parcelRequire("bC7A8");
var $5PYTZ = parcelRequire("5PYTZ");
parcelRequire("1xCf5");
var $2FpC7 = parcelRequire("2FpC7");
parcelRequire("X2FaZ");
var $7XNgi = parcelRequire("7XNgi");
parcelRequire("7E0l1");
var $4VK5m = parcelRequire("4VK5m");

});
parcelRegister("bC7A8", function(module, exports) {
$parcel$export(module.exports, "CustomerRelationshipsSection", function () { return (parcelRequire("5PYTZ")).CustomerRelationshipsSection; });

var $5PYTZ = parcelRequire("5PYTZ");

});
parcelRegister("5PYTZ", function(module, exports) {
$parcel$export(module.exports, "CustomerRelationshipsSection", function () { return $2c545cb87b6c171d$export$7befb07f457c87ff; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("aQGUe");
var $jCZb0 = parcelRequire("jCZb0");
parcelRequire("hr1PU");
var $dxIOQ = parcelRequire("dxIOQ");
parcelRequire("8lWkh");
var $Pftwr = parcelRequire("Pftwr");

var $560h0 = parcelRequire("560h0");
parcelRequire("4OJkD");
var $4jbZK = parcelRequire("4jbZK");
const $2c545cb87b6c171d$export$7befb07f457c87ff = ({ relationships: relationships })=>{
    const relationshipMapping = (0, $560h0.mapRelationships)(relationships);
    const engineers = (0, $560h0.filterEngineers)(relationships);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $4jbZK.BaseRelationshipsSection), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jCZb0.FastshiftTeamCard), {
                isCustomer: true,
                relationships: relationshipMapping
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Pftwr.SupportEngineersCard), {
                engineers: engineers
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dxIOQ.MigrationResourcesCard), {})
        ]
    });
};

});
parcelRegister("aQGUe", function(module, exports) {
$parcel$export(module.exports, "FastshiftTeamCard", function () { return (parcelRequire("jCZb0")).FastshiftTeamCard; });

var $jCZb0 = parcelRequire("jCZb0");

});
parcelRegister("jCZb0", function(module, exports) {
$parcel$export(module.exports, "FastshiftTeamCard", function () { return $59f858fcd2e7ffff$export$7817978309246061; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $2YtGy = parcelRequire("2YtGy");
parcelRequire("kBd4f");
var $gnnwI = parcelRequire("gnnwI");
parcelRequire("9rglY");
var $bVDGo = parcelRequire("bVDGo");

var $9UVqT = parcelRequire("9UVqT");
const $59f858fcd2e7ffff$export$7817978309246061 = ({ isCustomer: isCustomer = false, relationships: relationships = {} })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gnnwI.BaseCard), {
        message: isCustomer ? (0, $9UVqT.messages).fastshiftTeamCardTitleCustomer : (0, $9UVqT.messages).fastshiftTeamCardTitleInternal,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
            space: "space.100",
            children: [
                relationships.fastshiftChampion && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bVDGo.CardRelationship), {
                    name: relationships.fastshiftChampion.name,
                    imageUrl: relationships.fastshiftChampion.imageUrl,
                    titleMessage: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $9UVqT.messages).fastshiftTeamCardCustomerFastshiftChampionTitle))
                }),
                relationships.accountExecutive && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bVDGo.CardRelationship), {
                    name: relationships.accountExecutive.name,
                    imageUrl: relationships.accountExecutive.imageUrl,
                    titleMessage: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $9UVqT.messages).fastshiftTeamCardAccountExecutiveTitle))
                }),
                relationships.customerSuccessManager && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bVDGo.CardRelationship), {
                    name: relationships.customerSuccessManager.name,
                    imageUrl: relationships.customerSuccessManager.imageUrl,
                    titleMessage: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $9UVqT.messages).fastshiftTeamCardCustomerSuccessManagerTitle))
                })
            ]
        })
    });
};

});
parcelRegister("kBd4f", function(module, exports) {
$parcel$export(module.exports, "BaseCard", function () { return (parcelRequire("gnnwI")).BaseCard; });

var $gnnwI = parcelRequire("gnnwI");

});
parcelRegister("gnnwI", function(module, exports) {
$parcel$export(module.exports, "BaseCard", function () { return $b7f709383875bd41$export$ffd8d1a491a618f2; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $dTJrO = parcelRequire("dTJrO");

var $g3ExX = parcelRequire("g3ExX");
var $fmW7P = parcelRequire("fmW7P");
var $f6YGh = parcelRequire("f6YGh");
const $b7f709383875bd41$var$containerStyles = (0, $f6YGh.xcss)({
    borderRadius: "6px",
    borderColor: "color.border",
    borderWidth: "border.width",
    borderStyle: "solid",
    width: "100%",
    boxSizing: "border-box",
    height: "200px"
});
const $b7f709383875bd41$var$outerContentStyles = (0, $f6YGh.xcss)({
    height: "100%"
});
const $b7f709383875bd41$var$contentStyles = (0, $f6YGh.xcss)({
    flexGrow: 1
});
const $b7f709383875bd41$export$ffd8d1a491a618f2 = ({ children: children, message: message })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
        padding: "space.150",
        xcss: $b7f709383875bd41$var$containerStyles,
        as: "article",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $fmW7P.default), {
            xcss: $b7f709383875bd41$var$outerContentStyles,
            direction: "column",
            gap: "space.100",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                    size: "xsmall",
                    as: "h4",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, message))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                    xcss: $b7f709383875bd41$var$contentStyles,
                    children: children
                })
            ]
        })
    });
};

});
parcelRegister("g3ExX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bb0c60e02e0026ba$export$2e2bcd8739ae039; });

var $45ahP = parcelRequire("45ahP");

var $7NMHB = parcelRequire("7NMHB");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $b7FW2 = parcelRequire("b7FW2");

var $ahhSJ = parcelRequire("ahhSJ");

var $f6YGh = parcelRequire("f6YGh");
var $bb0c60e02e0026ba$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $bb0c60e02e0026ba$var$_excluded2 = [
    "className"
];
var $bb0c60e02e0026ba$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $7NMHB.default)(_ref, $bb0c60e02e0026ba$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $7NMHB.default)(htmlAttributes, $bb0c60e02e0026ba$var$_excluded2);
    var resolvedStyles = (0, $f6YGh.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $3dJ4i.jsx)(Component, (0, $45ahP.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $bb0c60e02e0026ba$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $ahhSJ.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $ahhSJ.isSurfaceColorToken)(backgroundColor) && (0, $ahhSJ.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $ahhSJ.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $ahhSJ.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $ahhSJ.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $ahhSJ.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $ahhSJ.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $ahhSJ.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $ahhSJ.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $3dJ4i.jsx)((0, $b7FW2.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $bb0c60e02e0026ba$export$2e2bcd8739ae039 = $bb0c60e02e0026ba$export$e71c4d32a2263218;
var $bb0c60e02e0026ba$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("45ahP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2f8f9bb9f4d6ca63$export$2e2bcd8739ae039; });
function $2f8f9bb9f4d6ca63$export$2e2bcd8739ae039() {
    return $2f8f9bb9f4d6ca63$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2f8f9bb9f4d6ca63$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("7NMHB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5ae2e3489b381b2d$export$2e2bcd8739ae039; });

var $38uky = parcelRequire("38uky");
function $5ae2e3489b381b2d$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $38uky.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("38uky", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2489a571b47d7bc0$export$2e2bcd8739ae039; });
function $2489a571b47d7bc0$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});





parcelRegister("9rglY", function(module, exports) {
$parcel$export(module.exports, "CardRelationship", function () { return (parcelRequire("bVDGo")).CardRelationship; });

var $bVDGo = parcelRequire("bVDGo");

});
parcelRegister("bVDGo", function(module, exports) {
$parcel$export(module.exports, "CardRelationship", function () { return $9b74410b30bd11bc$export$dea2bd7bbed2f4ec; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $4SA4u = parcelRequire("4SA4u");

var $dTJrO = parcelRequire("dTJrO");

var $fmW7P = parcelRequire("fmW7P");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");

var $hA6SQ = parcelRequire("hA6SQ");
const $9b74410b30bd11bc$export$dea2bd7bbed2f4ec = ({ name: name, imageUrl: imageUrl, titleMessage: titleMessage })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $fmW7P.default), {
        alignItems: "center",
        gap: "space.150",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4SA4u.default), {
                appearance: "circle",
                src: imageUrl,
                size: "large",
                name: name
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                        size: "xsmall",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $hA6SQ.messages).cardRelationshipNameMessage), {
                            values: {
                                name: name
                            }
                        }))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                        children: titleMessage
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("hA6SQ", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $48857f3d3221c4b8$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $48857f3d3221c4b8$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    cardRelationshipNameMessage: {
        id: "fastshift.card-relationship.relationship-name",
        defaultMessage: "{name}",
        description: "Name of the relationship"
    },
    cardRelationshipTitle: {
        id: "fastshift.card-relationship.relationship-title",
        defaultMessage: "{title}",
        description: "Title of the relationship"
    }
});

});



parcelRegister("9UVqT", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $a02ad04e0942d364$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $a02ad04e0942d364$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    fastshiftTeamCardTitleCustomer: {
        id: "fastshift.relationships-card.title.customer",
        defaultMessage: "Your FastShift Team",
        description: "Title for the FastShift team card"
    },
    fastshiftTeamCardTitleInternal: {
        id: "fastshift.relationships-card.title.internal",
        defaultMessage: "Customer FastShift Team",
        description: "Title for the FastShift team card"
    },
    fastshiftTeamCardCustomerFastshiftChampionTitle: {
        id: "fastshift.relationships-card.relationship-title.customer-fastshift-champion",
        defaultMessage: "Customer FastShift Champion",
        description: "Title of the Customer FastShift Champion"
    },
    fastshiftTeamCardAccountExecutiveTitle: {
        id: "fastshift.relationships-card.relationship-title.account-executive",
        defaultMessage: "Account Executive",
        description: "Title of the Account Executive"
    },
    fastshiftTeamCardCustomerSuccessManagerTitle: {
        id: "fastshift.relationships-card.relationship-title.customer-success-manager",
        defaultMessage: "Customer Success Manager",
        description: "Title of the Customer Success Manager"
    }
});

});



parcelRegister("hr1PU", function(module, exports) {
$parcel$export(module.exports, "MigrationResourcesCard", function () { return (parcelRequire("dxIOQ")).MigrationResourcesCard; });

var $dxIOQ = parcelRequire("dxIOQ");

});
parcelRegister("dxIOQ", function(module, exports) {
$parcel$export(module.exports, "MigrationResourcesCard", function () { return $9d648f0c37aa7e34$export$deaa4b29f6580987; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $j2t2h = parcelRequire("j2t2h");

var $1HVQz = parcelRequire("1HVQz");

var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");
parcelRequire("iTGju");
var $bh3Fv = parcelRequire("bh3Fv");
parcelRequire("kBd4f");
var $gnnwI = parcelRequire("gnnwI");

var $grpYP = parcelRequire("grpYP");
const $9d648f0c37aa7e34$var$contentStyles = (0, $f6YGh.xcss)({
    height: "100%"
});
const $9d648f0c37aa7e34$export$deaa4b29f6580987 = ()=>{
    const navigate = (0, $j2t2h.useNavigate)();
    const { paths: paths } = (0, $bh3Fv.useRoutes)();
    const navigateToDomainScopedResourcesPage = ()=>{
        const url = paths.domainScopedResources;
        if (url) navigate(url);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gnnwI.BaseCard), {
        message: (0, $grpYP.messages).migrationResourcesCardTitle,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
            xcss: $9d648f0c37aa7e34$var$contentStyles,
            space: "space.100",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $grpYP.messages).migrationResourcesCardDescription))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $79ZK0.default), {
                    alignBlock: "end",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), {
                        onClick: ()=>navigateToDomainScopedResourcesPage(),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $grpYP.messages).migrationResourcesCardButton))
                    })
                })
            ]
        })
    });
};

});
parcelRegister("1HVQz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $13e6adc6df75e5db$export$2e2bcd8739ae039; });

var $8Ad6U = parcelRequire("8Ad6U");

var $2rbPH = parcelRequire("2rbPH");

var $1oC0p = parcelRequire("1oC0p");

var $lCzCA = parcelRequire("lCzCA");

var $jBgJs = parcelRequire("jBgJs");

var $7kLyP = parcelRequire("7kLyP");
var $13e6adc6df75e5db$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $13e6adc6df75e5db$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $13e6adc6df75e5db$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, $2rbPH.default)(_ref, $13e6adc6df75e5db$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $2rbPH.default)(unsafeRest, $13e6adc6df75e5db$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lCzCA.default), (0, $8Ad6U.default)({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jBgJs.default), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7kLyP.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jBgJs.default), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jBgJs.default), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7kLyP.default), {
        icon: iconAfter
    }))));
}));
$13e6adc6df75e5db$var$Button.displayName = 'Button';
var $13e6adc6df75e5db$export$2e2bcd8739ae039 = $13e6adc6df75e5db$var$Button;

});

parcelRegister("iTGju", function(module, exports) {
$parcel$export(module.exports, "useRoutes", function () { return (parcelRequire("bh3Fv")).useRoutes; });
$parcel$export(module.exports, "useFetchSupportRequests", function () { return (parcelRequire("Riwsy")).useFetchSupportRequests; });

var $bh3Fv = parcelRequire("bh3Fv");

var $Riwsy = parcelRequire("Riwsy");

});
parcelRegister("Riwsy", function(module, exports) {
$parcel$export(module.exports, "useFetchSupportRequests", function () { return $08f6d72837707b28$export$280771f344ff11d9; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("jtpMK");
var $2hq4z = parcelRequire("2hq4z");
parcelRequire("hVHtn");
var $af3Tw = parcelRequire("af3Tw");
var $f7YG8 = parcelRequire("f7YG8");

var $8Bmsc = parcelRequire("8Bmsc");

var $PE2DD = parcelRequire("PE2DD");
const $08f6d72837707b28$export$280771f344ff11d9 = ()=>{
    const dispatch = (0, $f7YG8.useFastshiftDispatch)();
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const { data: customerDomainData } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomain);
    const selectedDomainOrg = (0, $f7YG8.useFastshiftSelector)((state)=>state.selectedDomainOrg);
    const { lastFetchParams: lastFetchParams } = (0, $f7YG8.useFastshiftSelector)((state)=>state.supportRequests);
    const supportTicketQueryParams = (0, $1oC0p.useMemo)(()=>{
        return selectedDomainOrg ? (0, $2hq4z.getOrgQueryParam)(selectedDomainOrg) : {};
    }, [
        selectedDomainOrg
    ]);
    (0, $1oC0p.useEffect)(()=>{
        let supportRequestsPromise = null;
        if (customerDomainData && selectedDomainOrg) {
            const needsFetch = !lastFetchParams || lastFetchParams.customerDomainId !== customerDomainData.customerDomainId || lastFetchParams.queryParams.orgId !== supportTicketQueryParams.orgId || lastFetchParams.queryParams.permissionLevel !== supportTicketQueryParams.permissionLevel;
            if (!needsFetch) return;
            // Clear migration tickets table controls when fetching new data (org changed)
            dispatch($8Bmsc.clearTableControls({
                tableId: (0, $af3Tw.TABLE_IDS).MIGRATION_TICKETS
            }));
            supportRequestsPromise = dispatch($8Bmsc.getFastshiftSupportRequests({
                stargateClient: stargateClient,
                customerDomainId: customerDomainData.customerDomainId,
                queryParams: supportTicketQueryParams
            }));
        }
        return ()=>{
            if (supportRequestsPromise) supportRequestsPromise.abort();
        };
    }, [
        dispatch,
        stargateClient,
        customerDomainData,
        selectedDomainOrg,
        supportTicketQueryParams,
        lastFetchParams
    ]);
};

});
parcelRegister("jtpMK", function(module, exports) {
$parcel$export(module.exports, "getCurrentTime", function () { return (parcelRequire("iS5nW")).getCurrentTime; });
$parcel$export(module.exports, "getOrgQueryParam", function () { return (parcelRequire("2hq4z")).getOrgQueryParam; });
$parcel$export(module.exports, "getStatusColor", function () { return (parcelRequire("lmgkB")).getStatusColor; });
$parcel$export(module.exports, "getStatusText", function () { return (parcelRequire("lmgkB")).getStatusText; });

var $iS5nW = parcelRequire("iS5nW");

var $2hq4z = parcelRequire("2hq4z");

var $lmgkB = parcelRequire("lmgkB");

});
parcelRegister("iS5nW", function(module, exports) {
$parcel$export(module.exports, "getCurrentTime", function () { return $5073739152930506$export$a86190deb5c4a8d0; });
const $5073739152930506$export$a86190deb5c4a8d0 = ()=>{
    return Date.now();
};

});

parcelRegister("2hq4z", function(module, exports) {
$parcel$export(module.exports, "getOrgQueryParam", function () { return $a1525010d158d7ef$export$a030e9c6d064b595; });

var $af3Tw = parcelRequire("af3Tw");

var $1uReC = parcelRequire("1uReC");
function $a1525010d158d7ef$export$a030e9c6d064b595(selectedDomainOrg) {
    switch(selectedDomainOrg.orgId){
        case (0, $af3Tw.RESERVED_ORG_IDS).NO_ORG:
            return {};
        case (0, $af3Tw.RESERVED_ORG_IDS).OTHER_ORGS:
            return {
                permissionLevel: (0, $1uReC.PERMISSION_LEVELS).NON_ADMIN
            };
        default:
            return {
                orgId: selectedDomainOrg.orgId,
                permissionLevel: (0, $1uReC.PERMISSION_LEVELS).ADMIN
            };
    }
}

});
parcelRegister("1uReC", function(module, exports) {
$parcel$export(module.exports, "USER_TYPE", function () { return $867812d36b46da61$export$30fccd4d2a57a124; });
$parcel$export(module.exports, "PRODUCT_NAME", function () { return $867812d36b46da61$export$a75e537c279a265a; });
$parcel$export(module.exports, "PERMISSION_LEVELS", function () { return $867812d36b46da61$export$62831deb0d015b43; });
const $867812d36b46da61$export$30fccd4d2a57a124 = {
    INTERNAL: "INTERNAL",
    PARTNER: "PARTNER",
    CUSTOMER: "CUSTOMER"
};
const $867812d36b46da61$export$a75e537c279a265a = {
    JIRA: "JIRA",
    CONFLUENCE: "CONFLUENCE"
};
const $867812d36b46da61$export$62831deb0d015b43 = {
    ADMIN: "ADMIN",
    NON_ADMIN: "NON_ADMIN"
};

});


parcelRegister("lmgkB", function(module, exports) {
$parcel$export(module.exports, "getStatusColor", function () { return $ce0cb7e975703713$export$9c3ee57c664156cd; });
$parcel$export(module.exports, "getStatusText", function () { return $ce0cb7e975703713$export$32e796a9286f339b; });

var $9tcM4 = parcelRequire("9tcM4");

var $9BSwZ = parcelRequire("9BSwZ");
const $ce0cb7e975703713$export$9c3ee57c664156cd = (status)=>{
    switch(status){
        case (0, $9tcM4.FASTSHIFT_ROLL_UP_STATUS).COMPLETE:
        case (0, $9tcM4.FASTSHIFT_ROLL_UP_STATUS).ON_TRACK:
            return "success";
        case (0, $9tcM4.FASTSHIFT_ROLL_UP_STATUS).AT_RISK_ATLASSIAN_OWNED:
            return "inprogress";
        case (0, $9tcM4.FASTSHIFT_ROLL_UP_STATUS).AT_RISK_PARTNER_OWNED:
            return "new";
        case (0, $9tcM4.FASTSHIFT_ROLL_UP_STATUS).NEEDS_CUSTOMER_ATTENTION:
            return "moved";
        case (0, $9tcM4.FASTSHIFT_ROLL_UP_STATUS).TO_DO:
        default:
            return "default";
    }
};
const $ce0cb7e975703713$export$32e796a9286f339b = (status)=>{
    switch(status){
        case (0, $9tcM4.FASTSHIFT_ROLL_UP_STATUS).COMPLETE:
            return (0, $9BSwZ.messages).migrationTicketsListStatusComplete;
        case (0, $9tcM4.FASTSHIFT_ROLL_UP_STATUS).ON_TRACK:
            return (0, $9BSwZ.messages).migrationTicketsListStatusOnTrack;
        case (0, $9tcM4.FASTSHIFT_ROLL_UP_STATUS).AT_RISK_ATLASSIAN_OWNED:
            return (0, $9BSwZ.messages).migrationTicketsListStatusAtRiskAtlassianOwned;
        case (0, $9tcM4.FASTSHIFT_ROLL_UP_STATUS).AT_RISK_PARTNER_OWNED:
            return (0, $9BSwZ.messages).migrationTicketsListStatusAtRiskPartnerOwned;
        case (0, $9tcM4.FASTSHIFT_ROLL_UP_STATUS).NEEDS_CUSTOMER_ATTENTION:
            return (0, $9BSwZ.messages).migrationTicketsListStatusNeedsCustomerAttention;
        case (0, $9tcM4.FASTSHIFT_ROLL_UP_STATUS).TO_DO:
            return (0, $9BSwZ.messages).migrationTicketsListStatusToDo;
        default:
            return (0, $9BSwZ.messages).migrationTicketsListStatusUnknown;
    }
};

});
parcelRegister("9BSwZ", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $fa9de29f9ded1012$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $fa9de29f9ded1012$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    migrationTicketsListStatusToDo: {
        id: "fastshift.dashboard.migration-tickets-list.status.to-do",
        defaultMessage: "TO DO",
        description: "Status label for TO_DO status"
    },
    migrationTicketsListStatusOnTrack: {
        id: "fastshift.dashboard.migration-tickets-list.status.on-track",
        defaultMessage: "ON TRACK",
        description: "Status label for ON_TRACK status"
    },
    migrationTicketsListStatusComplete: {
        id: "fastshift.dashboard.migration-tickets-list.status.complete",
        defaultMessage: "COMPLETED",
        description: "Status label for COMPLETE status"
    },
    migrationTicketsListStatusAtRiskAtlassianOwned: {
        id: "fastshift.dashboard.migration-tickets-list.status.at-risk-atlassian-owned",
        defaultMessage: "AT RISK - OWNED BY ATLASSIAN",
        description: "Status label for AT_RISK_ATLASSIAN_OWNED status"
    },
    migrationTicketsListStatusAtRiskPartnerOwned: {
        id: "fastshift.dashboard.migration-tickets-list.status.at-risk-partner-owned",
        defaultMessage: "AT RISK - OWNED BY PARTNER",
        description: "Status label for AT_RISK_PARTNER_OWNED status"
    },
    migrationTicketsListStatusNeedsCustomerAttention: {
        id: "fastshift.dashboard.migration-tickets-list.status.needs-customer-attention",
        defaultMessage: "NEEDS CUSTOMER ATTENTION",
        description: "Status label for NEEDS_CUSTOMER_ATTENTION status"
    },
    migrationTicketsListStatusUnknown: {
        id: "fastshift.dashboard.migration-tickets-list.status.unknown",
        defaultMessage: "UNKNOWN STATUS",
        description: "Fallback status label for unknown status values to prevent UI crashes"
    }
});

});





parcelRegister("grpYP", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $afa4c287f3919bcf$export$defe85febe8b728c; });

var $k0oFl = parcelRequire("k0oFl");
const $afa4c287f3919bcf$export$defe85febe8b728c = (0, $k0oFl.defineMessages)({
    migrationResourcesCardTitle: {
        id: "fastshift.relationships-card.title.migration-resources",
        defaultMessage: "Migration resources",
        description: "Title for the Migration Resources card"
    },
    migrationResourcesCardDescription: {
        id: "fastshift.relationships-card.description.migration-resources",
        defaultMessage: "Effortlessly find answers through our curated collection of help articles, providing practical tips and solutions for every phase of your cloud journey.",
        description: "Description for the Migration Resources card"
    },
    migrationResourcesCardButton: {
        id: "fastshift.relationships-card.button.migration-resources",
        defaultMessage: "View Articles",
        description: "Button text for the Migration Resources card"
    }
});

});



parcelRegister("8lWkh", function(module, exports) {
$parcel$export(module.exports, "SupportEngineersCard", function () { return (parcelRequire("Pftwr")).SupportEngineersCard; });

var $Pftwr = parcelRequire("Pftwr");

});
parcelRegister("Pftwr", function(module, exports) {
$parcel$export(module.exports, "SupportEngineersCard", function () { return $5a0324472dfef047$export$47c50ce9e6c40dd; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");

var $g07Wm = parcelRequire("g07Wm");

var $1HVQz = parcelRequire("1HVQz");

var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");
parcelRequire("iDqkL");
var $jCnLo = parcelRequire("jCnLo");
parcelRequire("kBd4f");
var $gnnwI = parcelRequire("gnnwI");
parcelRequire("9Kby0");
var $7bWX0 = parcelRequire("7bWX0");

var $c4oAd = parcelRequire("c4oAd");
const $5a0324472dfef047$var$contentStyles = (0, $f6YGh.xcss)({
    height: "100%"
});
const $5a0324472dfef047$export$47c50ce9e6c40dd = ({ engineers: engineers })=>{
    const [isModalOpen, setIsModalOpen] = (0, $1oC0p.useState)(false);
    const { sendRequestAssistanceButtonClickUIEvent: sendRequestAssistanceButtonClickUIEvent } = (0, $jCnLo.useRelationshipsAnalytics)();
    const handleRequestAssistanceClick = ()=>{
        sendRequestAssistanceButtonClickUIEvent();
        setIsModalOpen(true);
    };
    const shouldRenderAvatarGroup = engineers.some(({ imageUrl: imageUrl })=>imageUrl !== "");
    const avatarGroupData = shouldRenderAvatarGroup ? engineers.map(({ id: id, name: name, imageUrl: imageUrl })=>({
            key: id,
            name: name,
            href: "#",
            src: imageUrl
        })).sort((a, b)=>b.src.localeCompare(a.src)) : [];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gnnwI.BaseCard), {
        message: (0, $c4oAd.messages).supportEngineersCardTitle,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
            xcss: $5a0324472dfef047$var$contentStyles,
            space: "space.100",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $c4oAd.messages).supportEngineersCardSubtitle))
                }),
                shouldRenderAvatarGroup ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g07Wm.default), {
                    size: "large",
                    data: avatarGroupData
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $c4oAd.messages).supportEngineersCardMessageWhenNoAvaters))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7bWX0.RequestAssistanceModal), {
                            isModalOpen: isModalOpen,
                            setIsModalOpen: setIsModalOpen
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), {
                            onClick: handleRequestAssistanceClick,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $c4oAd.messages).supportEngineersCardButtonText))
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("iDqkL", function(module, exports) {
$parcel$export(module.exports, "useRelationshipsAnalytics", function () { return (parcelRequire("jCnLo")).useRelationshipsAnalytics; });
$parcel$export(module.exports, "useRelationshipsPageAnalytics", function () { return (parcelRequire("jbPzn")).useRelationshipsPageAnalytics; });

var $jCnLo = parcelRequire("jCnLo");

var $jbPzn = parcelRequire("jbPzn");

});
parcelRegister("jCnLo", function(module, exports) {
$parcel$export(module.exports, "useRelationshipsAnalytics", function () { return $fbf9093a1c0d3cbe$export$651d36257792949e; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
const $fbf9093a1c0d3cbe$export$651d36257792949e = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)(true);
    const { fireUIEvent: fireUIEvent, fireTrackEvent: fireTrackEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    const sendRequestAssistanceButtonClickUIEvent = (0, $1oC0p.useCallback)(()=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).REQUEST_ASSISTANCE_BUTTON,
            source: sourceKey
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendRequestAssistanceModalCommentSubmitButtonClickUIEvent = (0, $1oC0p.useCallback)((supportTicketId)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).REQUEST_FASTSHIFT_ASSISTANCE_MODAL_SUBMIT_BUTTON_CLICK,
            source: sourceKey,
            attributes: {
                supportTicketId: supportTicketId
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendRequestAssistanceModalDisplayedTrackEvent = (0, $1oC0p.useCallback)((isEmpty, supportTicketCount)=>{
        fireTrackEvent({
            action: (0, $3cXzX.ActionKey).DISPLAYED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).MODAL,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).REQUEST_FASTSHIFT_ASSISTANCE_MODAL,
            source: sourceKey,
            attributes: {
                isEmpty: isEmpty,
                supportTicketCount: supportTicketCount
            }
        });
    }, [
        fireTrackEvent,
        sourceKey
    ]);
    const sendPostCommentOutcomeFlagDisplayedTrackEvent = (0, $1oC0p.useCallback)((successFlag, supportTicketId)=>{
        fireTrackEvent({
            action: (0, $3cXzX.ActionKey).DISPLAYED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).FLAG,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).REQUEST_FASTSHIFT_ASSISTANCE_COMMENT_CONFIRMATION_FLAG,
            source: sourceKey,
            attributes: {
                successFlag: successFlag,
                supportTicketId: supportTicketId
            }
        });
    }, [
        fireTrackEvent,
        sourceKey
    ]);
    return {
        sendRequestAssistanceButtonClickUIEvent: // UI Events (button clicks)
        sendRequestAssistanceButtonClickUIEvent,
        sendRequestAssistanceModalCommentSubmitButtonClickUIEvent: sendRequestAssistanceModalCommentSubmitButtonClickUIEvent,
        sendRequestAssistanceModalDisplayedTrackEvent: // Track Events (manual triggers)
        sendRequestAssistanceModalDisplayedTrackEvent,
        sendPostCommentOutcomeFlagDisplayedTrackEvent: sendPostCommentOutcomeFlagDisplayedTrackEvent
    };
};

});
parcelRegister("hAwBv", function(module, exports) {
$parcel$export(module.exports, "useFastshiftAnalyticsData", function () { return (parcelRequire("3aU3i")).useFastshiftAnalyticsData; });
$parcel$export(module.exports, "useFireAnalyticsEvents", function () { return (parcelRequire("9ztLs")).useFireAnalyticsEvents; });

var $9ztLs = parcelRequire("9ztLs");
parcelRequire("67fUy");
parcelRequire("dLX0z");

});
parcelRegister("67fUy", function(module, exports) {
$parcel$export(module.exports, "useFastshiftAnalyticsData", function () { return (parcelRequire("3aU3i")).useFastshiftAnalyticsData; });

var $3aU3i = parcelRequire("3aU3i");

});
parcelRegister("3aU3i", function(module, exports) {
$parcel$export(module.exports, "useFastshiftAnalyticsData", function () { return $27f94822f7fa37f5$export$2b4091f90bc3079a; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $1oC0p = parcelRequire("1oC0p");

var $3riD8 = parcelRequire("3riD8");
parcelRequire("iTGju");
var $bh3Fv = parcelRequire("bh3Fv");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");

var $3cXzX = parcelRequire("3cXzX");

var $fijXj = parcelRequire("fijXj");

var $anlYB = parcelRequire("anlYB");

var $gi9YO = parcelRequire("gi9YO");
const $27f94822f7fa37f5$export$2b4091f90bc3079a = (allowFallback = false)=>{
    const baseIdentityAttrs = (0, $fijXj.useBaseIdentityAttrs)();
    const customerIdentityAttrs = (0, $anlYB.useCustomerIdentityAttrs)(allowFallback);
    const { domainId: domainId, fullPathname: fullPathname, paths: paths } = (0, $bh3Fv.useRoutes)();
    const { error: userDetailsError } = (0, $f7YG8.useFastshiftSelector)((state)=>state.userDetails);
    const loggedInUser = (0, $3riD8.useLoggedInUser)();
    var _loggedInUser_email_split_;
    const userDomain = loggedInUser.email ? (_loggedInUser_email_split_ = loggedInUser.email.split("@")[1]) !== null && _loggedInUser_email_split_ !== void 0 ? _loggedInUser_email_split_ : "" : "";
    const sourceKey = (0, $1oC0p.useMemo)(()=>{
        if (userDetailsError) return (0, $gi9YO.getSourceKeyFromError)(userDetailsError);
        const pathToScreenMap = {
            [paths.selection]: (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_SELECTION_SCREEN,
            [paths.partnerResources]: (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_PARTNER_RESOURCES_SCREEN
        };
        // Add domain-scoped paths if they exist
        if (paths.domainScopedOverview) pathToScreenMap[paths.domainScopedOverview] = (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_FOR_YOU_SCREEN;
        if (paths.domainScopedPlanning) pathToScreenMap[paths.domainScopedPlanning] = (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_MIGRATION_PLANNING_SCREEN;
        if (paths.domainScopedResources) pathToScreenMap[paths.domainScopedResources] = (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_CUSTOMER_RESOURCES_SCREEN;
        if (paths.domainScopedTickets) pathToScreenMap[paths.domainScopedTickets] = (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_MIGRATION_TICKETS_SCREEN;
        return pathToScreenMap[fullPathname] || (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_404_SCREEN;
    }, [
        userDetailsError,
        fullPathname,
        paths
    ]);
    const isDomainScoped = !!domainId;
    const identityAttrs = (0, $1oC0p.useMemo)(()=>{
        const attrs = isDomainScoped ? customerIdentityAttrs : baseIdentityAttrs;
        if (userDetailsError && userDomain) return (0, $dPABA._)((0, $6ogO3._)({}, attrs), {
            userDomain: userDomain
        });
        return attrs;
    }, [
        isDomainScoped,
        customerIdentityAttrs,
        baseIdentityAttrs,
        userDetailsError,
        userDomain
    ]);
    return {
        sourceKey: sourceKey,
        identityAttrs: identityAttrs
    };
};

});
parcelRegister("3cXzX", function(module, exports) {
$parcel$export(module.exports, "SourceKey", function () { return $77ec6f6b775a6f38$export$bfb20ca846513dde; });
$parcel$export(module.exports, "ActionKey", function () { return $77ec6f6b775a6f38$export$f4a12eb23846d703; });
$parcel$export(module.exports, "ActionSubjectKey", function () { return $77ec6f6b775a6f38$export$75d4c0092c8bfbec; });
$parcel$export(module.exports, "ActionSubjectIdKey", function () { return $77ec6f6b775a6f38$export$b272959d24ba2c3e; });
$parcel$export(module.exports, "SubjectAttributeKey", function () { return $77ec6f6b775a6f38$export$26783e579626c130; });
var $77ec6f6b775a6f38$export$bfb20ca846513dde = /*#__PURE__*/ function(SourceKey) {
    // EAP
    SourceKey["FASTSHIFT_PORTAL_DASHBOARD_SCREEN"] = "fastshiftPortalDashboardScreen";
    // M2
    SourceKey["FASTSHIFT_PORTAL_SELECTION_SCREEN"] = "fastshiftPortalSelectionScreen";
    SourceKey["FASTSHIFT_PORTAL_FOR_YOU_SCREEN"] = "fastshiftPortalForYouScreen";
    SourceKey["FASTSHIFT_PORTAL_MIGRATION_PLANNING_SCREEN"] = "fastshiftPortalMigrationPlanningScreen";
    SourceKey["FASTSHIFT_PORTAL_CUSTOMER_RESOURCES_SCREEN"] = "fastshiftPortalCustomerResourcesScreen";
    SourceKey["FASTSHIFT_PORTAL_PARTNER_RESOURCES_SCREEN"] = "fastshiftPortalPartnerResourcesScreen";
    SourceKey["FASTSHIFT_PORTAL_INELIGIBLE_NO_LICENSE_SCREEN"] = "fastshiftPortalIneligibleNoLicenseScreen";
    SourceKey["FASTSHIFT_PORTAL_INELIGIBLE_NO_ACCESS_SCREEN"] = "fastshiftPortalIneligibleNoAccessScreen";
    SourceKey["FASTSHIFT_PORTAL_GENERIC_ERROR_SCREEN"] = "fastshiftPortalGenericErrorScreen";
    SourceKey["FASTSHIFT_PORTAL_404_SCREEN"] = "fastshiftPortal404Screen";
    // M3
    SourceKey["FASTSHIFT_PORTAL_MIGRATION_TICKETS_SCREEN"] = "fastshiftPortalMigrationTicketsScreen";
    SourceKey["FASTSHIFT_PORTAL_LEGAL_CONSENT_SCREEN"] = "fastshiftPortalLegalConsentScreen";
    SourceKey["FASTSHIFT_PORTAL_CRITICAL_ERROR_SCREEN"] = "fastshiftPortalCriticalErrorScreen";
    return SourceKey;
}({});
var $77ec6f6b775a6f38$export$f4a12eb23846d703 = /*#__PURE__*/ function(ActionKey) {
    ActionKey["DISPLAYED"] = "displayed";
    ActionKey["CLICKED"] = "clicked";
    ActionKey["SUBMITTED"] = "submitted";
    ActionKey["REDIRECTED"] = "redirected";
    return ActionKey;
}({});
var $77ec6f6b775a6f38$export$75d4c0092c8bfbec = /*#__PURE__*/ function(ActionSubjectKey) {
    // General
    ActionSubjectKey["BUTTON"] = "button";
    ActionSubjectKey["DROPDOWN"] = "dropdown";
    ActionSubjectKey["FLAG"] = "flag";
    ActionSubjectKey["DROPDOWN_ITEM"] = "dropdownItem";
    ActionSubjectKey["MODAL"] = "modal";
    ActionSubjectKey["SECTION"] = "section";
    ActionSubjectKey["LINK"] = "link";
    ActionSubjectKey["SEARCH"] = "search";
    ActionSubjectKey["TABLE_COLUMN_SORT"] = "tableColumnSort";
    ActionSubjectKey["PAGE"] = "page";
    return ActionSubjectKey;
}({});
var $77ec6f6b775a6f38$export$b272959d24ba2c3e = /*#__PURE__*/ function(ActionSubjectIdKey) {
    // EAP - Dashboard Screen
    ActionSubjectIdKey["REQUEST_FASTSHIFT_ASSISTANCE_CARD"] = "requestFastshiftAssistanceCard";
    ActionSubjectIdKey["MIGRATION_PROGRESS_TABLE"] = "migrationProgressTable";
    ActionSubjectIdKey["FASTSHIFT_RESOURCES_CARD_LINK_CLICK"] = "fastshiftResourcesCardLinkClick";
    // Shared
    // EAP - Dashboard Screen & M2 - For You Screen
    ActionSubjectIdKey["ORG_SELECTOR_DROPDOWN"] = "orgSelectorDropdown";
    ActionSubjectIdKey["MIGRATION_SUMMARY_SECTION"] = "migrationSummarySection";
    // EAP - Dashboard Screen & M2 - Relationships Section: For You Screen & Migration Planning Screen
    ActionSubjectIdKey["REQUEST_FASTSHIFT_ASSISTANCE_MODAL"] = "requestFastshiftAssistanceModal";
    ActionSubjectIdKey["REQUEST_FASTSHIFT_ASSISTANCE_MODAL_SUBMIT_BUTTON_CLICK"] = "fastshiftAssistanceModalCommentSubmitButtonClick";
    ActionSubjectIdKey["REQUEST_FASTSHIFT_ASSISTANCE_COMMENT_CONFIRMATION_FLAG"] = "postCommentOutcomeConfirmationFlag";
    // M2 - Dashboard Template
    ActionSubjectIdKey["PAGE_LAYOUT"] = "pageLayout";
    // M2 - Selection Screen
    ActionSubjectIdKey["SELECTION_PAGE_DETAILS"] = "selectionPageDetails";
    ActionSubjectIdKey["SEE_DETAILS_BUTTON"] = "seeDetailsButton";
    ActionSubjectIdKey["DOMAIN_SELECTION_TABLE_SEARCH"] = "domainSelectionTableSearch";
    ActionSubjectIdKey["SELECTION_TABLE_PAGE_NAVIGATION_BUTTON"] = "selectionTablePageNavigationButton";
    ActionSubjectIdKey["SELECTION_TABLE_CHANGE_PAGE_SIZE_DROPDOWN_ITEM"] = "selectionTableChangePageSizeDropdownItem";
    ActionSubjectIdKey["SELECTION_TABLE_COLUMN_SORT"] = "selectionTableColumnSort";
    // M2 - For You Screen
    ActionSubjectIdKey["FOR_YOU_PAGE_DETAILS"] = "forYouPageDetails";
    ActionSubjectIdKey["MIGRATION_TICKETS_TOP_SECTION_DETAILS"] = "migrationTicketsTopSectionDetails";
    ActionSubjectIdKey["MIGRATION_TICKETS_TOP_SECTION_VIEW_ALL_LINK"] = "migrationTicketsTopSectionViewAllLink";
    ActionSubjectIdKey["MIGRATION_TICKETS_TOP_SECTION_OPEN_SUPPORT_TICKET_LINK"] = "migrationTicketsTopSectionOpenSupportTicketLink";
    // M2 - Migration Planning Screen
    ActionSubjectIdKey["MIGRATION_PLANNER_EMBED_SECTION"] = "migrationPlannerEmbedSection";
    ActionSubjectIdKey["EMBED_VIEW_TYPE_TOGGLE_BUTTON"] = "embedViewTypeToggleButton";
    ActionSubjectIdKey["SELECT_BOARD_DROPDOWN_ITEM"] = "selectBoardDropdownItem";
    ActionSubjectIdKey["JIRA_EMBED_LINK"] = "jiraEmbedLink";
    // M2 - Partner Resources Screen & Customer Resources Screen
    ActionSubjectIdKey["RESOURCE_FILTER"] = "resourceFilter";
    ActionSubjectIdKey["RESOURCE_LINK"] = "resourceLink";
    ActionSubjectIdKey["USEFUL_LINK"] = "usefulLink";
    // M2 - Relationships Section: For You Screen & Migration Planning Screen
    ActionSubjectIdKey["REQUEST_ASSISTANCE_BUTTON"] = "requestAssistanceButton";
    ActionSubjectIdKey["FASTSHIFT_RELATIONSHIPS_SECTION"] = "fastshiftRelationshipsSection";
    // M2 - Fastshift Ineligible Screen
    ActionSubjectIdKey["GO_BACK_BUTTON"] = "goBackButton";
    ActionSubjectIdKey["SIGN_IN_WITH_ANOTHER_ACCOUNT_BUTTON"] = "signInWithAnotherAccountButton";
    ActionSubjectIdKey["CONTACT_SUPPORT_LINK"] = "contactSupportLink";
    // M2 -404 Display
    ActionSubjectIdKey["GO_BACK_TO_HOME_LINK"] = "goBackToHomeLink";
    // M2 - Across All Screens
    ActionSubjectIdKey["SIDE_NAV_LINK"] = "sideNavLink";
    ActionSubjectIdKey["CUSTOMER_SELECTION_BACK_LINK"] = "customerSelectionBackLink";
    // M3 - Migration Tickets Screen
    ActionSubjectIdKey["MIGRATION_TICKETS_PAGE_DETAILS"] = "migrationTicketsPageDetails";
    ActionSubjectIdKey["MIGRATION_TICKETS_TABLE_SEARCH"] = "migrationTicketsTableSearch";
    ActionSubjectIdKey["MIGRATION_TICKETS_TABLE_PAGE_NAVIGATION_BUTTON"] = "migrationTicketsTablePageNavigationButton";
    ActionSubjectIdKey["MIGRATION_TICKETS_TABLE_CHANGE_PAGE_SIZE_DROPDOWN_ITEM"] = "migrationTicketsTableChangePageSizeDropdownItem";
    ActionSubjectIdKey["MIGRATION_TICKETS_TABLE_OPEN_SUPPORT_TICKET_LINK"] = "migrationTicketsTableOpenSupportTicketLink";
    ActionSubjectIdKey["STATUS_FILTER_DROPDOWN"] = "statusDropdown";
    ActionSubjectIdKey["MIGRATION_PHASE_DROPDOWN"] = "migrationPhaseDropdown";
    ActionSubjectIdKey["CLEAR_FILTERS_BUTTON"] = "clearFiltersButton";
    // Related Tickets Side Panel
    ActionSubjectIdKey["RELATED_TICKETS_SIDE_PANEL_LINK"] = "relatedTicketsSidePanelLink";
    ActionSubjectIdKey["RELATED_TICKETS_SIDE_PANEL_DISMISS_BUTTON"] = "relatedTicketsSidePanelDismissButton";
    ActionSubjectIdKey["RELATED_TICKETS_SIDE_PANEL_OPEN_SUPPORT_TICKET_LINK"] = "relatedTicketsSidePanelOpenSupportTicketLink";
    // Feedback Collector
    ActionSubjectIdKey["FEEDBACK_COLLECTOR_OPEN_BUTTON"] = "feedbackCollectorOpenButton";
    ActionSubjectIdKey["FEEDBACK_COLLECTOR_SUBMIT_BUTTON"] = "feedbackCollectorSubmitButton";
    // M3 - Legal Consent Page
    ActionSubjectIdKey["LEGAL_CONSENT_BUTTON"] = "submitCustomerLegalConsentButton";
    ActionSubjectIdKey["REFRESH_PORTAL_BUTTON"] = "criticalErrorRefreshPortalButton";
    return ActionSubjectIdKey;
}({});
var $77ec6f6b775a6f38$export$26783e579626c130 = /*#__PURE__*/ function(SubjectAttributeKey) {
    // EAP - Dashboard Screen
    SubjectAttributeKey["SEARCH_SUPPORT"] = "Search Support";
    SubjectAttributeKey["ATLASSIAN_COMMUNITY"] = "Atlassian Community";
    SubjectAttributeKey["ATLASSIAN_DOCUMENTATION"] = "Atlassian Documentation";
    // Shared: EAP - Dashboard Screen & M2 - For You Screen
    SubjectAttributeKey["VIEW_ASSESSMENTS"] = "View Assessments";
    SubjectAttributeKey["VIEW_MIGRATIONS"] = "View Migrations";
    return SubjectAttributeKey;
}({});

});

parcelRegister("fijXj", function(module, exports) {
$parcel$export(module.exports, "useBaseIdentityAttrs", function () { return $055b5f56573f26a3$export$627290518802a7d3; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");
const $055b5f56573f26a3$export$627290518802a7d3 = ()=>{
    const { data: userDetails } = (0, $f7YG8.useFastshiftSelector)((state)=>state.userDetails);
    return (0, $1oC0p.useMemo)(()=>{
        if (!userDetails) return null;
        return {
            role: userDetails.userType,
            userDomain: userDetails.userDomain.domain
        };
    }, [
        userDetails
    ]);
};

});

parcelRegister("anlYB", function(module, exports) {
$parcel$export(module.exports, "useCustomerIdentityAttrs", function () { return $4b55826e612e7268$export$57d44fbb0af76243; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");

var $fijXj = parcelRequire("fijXj");
const $4b55826e612e7268$export$57d44fbb0af76243 = (allowFallback = false)=>{
    const baseAttrs = (0, $fijXj.useBaseIdentityAttrs)();
    const { data: customerDomain } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomain);
    return (0, $1oC0p.useMemo)(()=>{
        if (!baseAttrs) return null;
        if (customerDomain) return (0, $dPABA._)((0, $6ogO3._)({}, baseAttrs), {
            selectedCustomerDomain: customerDomain.customerDomain,
            selectedCustomerDomainId: customerDomain.customerDomainId
        });
        // When customerDomain not ready: fallback to baseAttrs for UI events, null for critical events
        return allowFallback ? baseAttrs : null;
    }, [
        baseAttrs,
        customerDomain,
        allowFallback
    ]);
};

});

parcelRegister("gi9YO", function(module, exports) {
$parcel$export(module.exports, "getSourceKeyFromError", function () { return $90324d94c2f8519c$export$1d05dc8456901303; });

var $3cXzX = parcelRequire("3cXzX");

var $PE2DD = parcelRequire("PE2DD");
const $90324d94c2f8519c$export$1d05dc8456901303 = (userDetailsError)=>{
    switch(userDetailsError){
        case (0, $PE2DD.FastshiftUserDetailsExpectedError).NO_ELIGIBLE_LICENSE:
            return (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_INELIGIBLE_NO_LICENSE_SCREEN;
        case (0, $PE2DD.FastshiftUserDetailsExpectedError).NO_ACCESS:
            return (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_INELIGIBLE_NO_ACCESS_SCREEN;
        default:
            return (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_GENERIC_ERROR_SCREEN;
    }
};

});



parcelRegister("dLX0z", function(module, exports) {

});



parcelRegister("jbPzn", function(module, exports) {
$parcel$export(module.exports, "useRelationshipsPageAnalytics", function () { return $1613e7f37d5a0f16$export$5e811d905fce1292; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
const $1613e7f37d5a0f16$export$5e811d905fce1292 = (relationships)=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)();
    const { fireTrackEvent: fireTrackEvent } = (0, $9ztLs.useFireAnalyticsEvents)();
    // Track event for relationships section displayed
    (0, $1oC0p.useEffect)(()=>{
        if (!identityAttrs) return;
        const fastshiftRelationships = relationships.map((r)=>r.type);
        const hasCustomerFastshiftChampion = relationships.some((r)=>r.type === "FAST_SHIFT_CHAMPION");
        fireTrackEvent({
            action: (0, $3cXzX.ActionKey).DISPLAYED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).SECTION,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).FASTSHIFT_RELATIONSHIPS_SECTION,
            source: sourceKey,
            attributes: {
                hasCustomerFastshiftChampion: hasCustomerFastshiftChampion,
                fastshiftRelationships: fastshiftRelationships
            }
        });
    }, [
        fireTrackEvent,
        identityAttrs,
        sourceKey,
        relationships
    ]);
};

});


parcelRegister("9Kby0", function(module, exports) {
$parcel$export(module.exports, "RequestAssistanceModal", function () { return (parcelRequire("7bWX0")).RequestAssistanceModal; });

var $7bWX0 = parcelRequire("7bWX0");

});
parcelRegister("7bWX0", function(module, exports) {
$parcel$export(module.exports, "RequestAssistanceModal", function () { return $334976dfb17362e4$export$2e4cd6d66faa547e; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");

var $dTJrO = parcelRequire("dTJrO");

var $4kArV = parcelRequire("4kArV");
var $fWW7j = parcelRequire("fWW7j");
var $izxiU = parcelRequire("izxiU");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");

var $lwUVt = parcelRequire("lwUVt");
parcelRequire("iDqkL");
var $jCnLo = parcelRequire("jCnLo");

var $560h0 = parcelRequire("560h0");

var $95lLw = parcelRequire("95lLw");
parcelRequire("4b3M5");
var $8SPUx = parcelRequire("8SPUx");
parcelRequire("jyjIa");
var $4kY5W = parcelRequire("4kY5W");
parcelRequire("jECsZ");
var $jBzMQ = parcelRequire("jBzMQ");
const $334976dfb17362e4$export$2e4cd6d66faa547e = ({ isModalOpen: isModalOpen, setIsModalOpen: setIsModalOpen })=>{
    const { data: supportRequestsData, pending: isSupportRequestsLoading } = (0, $f7YG8.useFastshiftSelector)((state)=>state.supportRequests);
    const { sendRequestAssistanceModalDisplayedTrackEvent: sendRequestAssistanceModalDisplayedTrackEvent } = (0, $jCnLo.useRelationshipsAnalytics)();
    const handleCloseModal = ()=>{
        setIsModalOpen(false);
    };
    const openTicketCount = (supportRequestsData !== null && supportRequestsData !== void 0 ? supportRequestsData : []).filter((request)=>(0, $560h0.isSupportRequestOpen)(request.status)).length;
    // Track modal displayed event when modal opens
    (0, $1oC0p.useEffect)(()=>{
        if (isModalOpen && !isSupportRequestsLoading) {
            const isEmpty = openTicketCount === 0;
            sendRequestAssistanceModalDisplayedTrackEvent(isEmpty, openTicketCount);
        }
    }, [
        isModalOpen,
        isSupportRequestsLoading,
        openTicketCount,
        sendRequestAssistanceModalDisplayedTrackEvent
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izxiU.default), {
            children: isModalOpen && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $4kArV.default), {
                onClose: handleCloseModal,
                testId: "request-assistance-modal",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $fWW7j.default), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                                size: "medium",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $95lLw.messages).requestAssistanceModalTitle))
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lwUVt.CloseModalButton), {
                                onCloseClick: handleCloseModal
                            })
                        ]
                    }),
                    isSupportRequestsLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jBzMQ.RequestAssistanceModalLoader), {}) : openTicketCount > 0 ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4kY5W.FastshiftAssistanceModalForm), {
                        handleCloseModal: handleCloseModal,
                        supportRequests: supportRequestsData !== null && supportRequestsData !== void 0 ? supportRequestsData : [],
                        isSupportRequestsLoading: isSupportRequestsLoading
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8SPUx.RequestAssistanceModalEmpty), {
                        handleCloseModal: handleCloseModal
                    })
                ]
            })
        })
    });
};

});
parcelRegister("560h0", function(module, exports) {
$parcel$export(module.exports, "findChampion", function () { return $4dd41a1bc45d1af9$export$9ddc6abef4422108; });
$parcel$export(module.exports, "filterEngineers", function () { return $4dd41a1bc45d1af9$export$8b32d0c78f83fe94; });
$parcel$export(module.exports, "mapRelationships", function () { return $4dd41a1bc45d1af9$export$df049a3bbd6d9380; });
$parcel$export(module.exports, "isSupportRequestOpen", function () { return $4dd41a1bc45d1af9$export$cdaa26bc186b101c; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");
const $4dd41a1bc45d1af9$export$9ddc6abef4422108 = (relationships)=>{
    const rawCampionData = relationships === null || relationships === void 0 ? void 0 : relationships.find((rel)=>rel.type === "FAST_SHIFT_CHAMPION");
    return rawCampionData ? (0, $dPABA._)((0, $6ogO3._)({}, rawCampionData), {
        title: "Fastshift Champion"
    }) : undefined;
};
const $4dd41a1bc45d1af9$export$38d3b01fb880f962 = (relationships)=>{
    return relationships === null || relationships === void 0 ? void 0 : relationships.find((rel)=>rel.type === "ACCOUNT_EXECUTIVE");
};
const $4dd41a1bc45d1af9$export$8fa5216841a4aa79 = (relationships)=>{
    return relationships === null || relationships === void 0 ? void 0 : relationships.find((rel)=>rel.type === "CUSTOMER_SUCCESS_MANAGER");
};
const $4dd41a1bc45d1af9$export$8b32d0c78f83fe94 = (relationships)=>{
    return (relationships === null || relationships === void 0 ? void 0 : relationships.filter((rel)=>rel.type === "MIGRATION_SUPPORT_ENGINEER").map(({ name: name, imageUrl: imageUrl }, index)=>({
            id: `${name}-${index}`,
            name: name,
            title: "Migration Support Engineer",
            imageUrl: imageUrl
        }))) || [];
};
const $4dd41a1bc45d1af9$export$df049a3bbd6d9380 = (relationships)=>{
    const champion = $4dd41a1bc45d1af9$export$9ddc6abef4422108(relationships);
    return {
        fastshiftChampion: champion ? (0, $dPABA._)((0, $6ogO3._)({}, champion), {
            title: "Fastshift Champion"
        }) : undefined,
        accountExecutive: $4dd41a1bc45d1af9$export$38d3b01fb880f962(relationships),
        customerSuccessManager: $4dd41a1bc45d1af9$export$8fa5216841a4aa79(relationships)
    };
};
const $4dd41a1bc45d1af9$export$cdaa26bc186b101c = (status)=>{
    const upperStatus = status.toUpperCase();
    return upperStatus !== "CLOSED" && upperStatus !== "DONE" && upperStatus !== "COMPLETED";
};

});

parcelRegister("95lLw", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $d385c7390e82b077$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $d385c7390e82b077$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    requestAssistanceModalDescription: {
        id: "request.assistance.modal.description",
        defaultMessage: "Add a comment to a chosen ticket to receive the FastShift team\u2019s help.",
        description: "Description for the FastShift assistance modal"
    },
    requestAssistanceModalTitle: {
        id: "request.assistance.modal.title",
        defaultMessage: "Request FastShift assistance",
        description: "Title for the FastShift assistance modal"
    },
    requestAssistanceModalSubtitleNote: {
        id: "request.assistance.modal.subtitle-note",
        defaultMessage: "Required fields are marked with an asterisk",
        description: "Subtitle note for the FastShift assistance modal, describing that form fields with an asterisk are required"
    },
    requestAssistanceModalDropdownLabel: {
        id: "request.assistance.modal.dropdown-label",
        defaultMessage: "Select a MOVE ticket",
        description: "Label for the FastShift assistance modal dropdown where users can select a MOVE ticket"
    },
    requestAssistanceModalCommentLabel: {
        id: "request.assistance.modal.comment-label",
        defaultMessage: "Add a comment to the ticket",
        description: "Label for comment field in fastshift assistance modal"
    },
    requestAssistanceModalSendButton: {
        id: "request.assistance.modal.send-button",
        defaultMessage: "Send",
        description: "Button text for sending the comment to the selected move ticket, on the fastshift assistance modal"
    },
    requestAssistanceModalCancelButton: {
        id: "request.assistance.modal.cancel-button",
        defaultMessage: "Cancel",
        description: "Button text for closing the fastshift assistance modal"
    },
    requestAssistanceModalFailedRequestMessage: {
        id: "request.assistance.modal.failed-request-error-message",
        defaultMessage: "An error occurred. Please try again later",
        description: "Message shown if there is a server error when trying to create a comment after hitting send"
    },
    requestAssistanceModalFieldIsRequiredMessage: {
        id: "request.assistance.modal.form-field-required",
        defaultMessage: "This field is required",
        description: "Error message when user doesn't fill in a required field"
    },
    requestAssistanceModalSuccessFlagTitle: {
        id: "request.assistance.modal.success-flag-title",
        defaultMessage: "Comment created",
        description: "Title for flag shown when a comment is successfully created on a migration support ticket"
    },
    requestAssistanceModalSuccessFlagDescription: {
        id: "request.assistance.modal.success-flag-description",
        defaultMessage: "Comment has been successfully created.",
        description: "Description for flag shown when a comment is successfully created on a migration support ticket"
    },
    requestAssistanceModalSuccessFlagAction: {
        id: "request.assistance.modal.success-flag-action",
        defaultMessage: "View ticket",
        description: "Text for a link that will redirect customer to view their migration support ticket (to which they just posted a comment)"
    },
    requestAssistanceModalErrorFlagTitle: {
        id: "request.assistance.modal.error-flag-title",
        defaultMessage: "An error occurred",
        description: "Title for flag shown when there is an error creating a comment on a migration support ticket"
    },
    requestAssistanceModalErrorFlagDescription: {
        id: "request.assistance.modal.success-flag-description",
        defaultMessage: "Please try again later.",
        description: "Description for flag shown when there is an error creating a comment on a migration support ticket"
    },
    requestAssistanceModalEmptyDescription: {
        id: "request.assistance.modal.empty.description",
        defaultMessage: "You don\u2019t have any existing migration support tickets. To request assistance,\xa0please create one.",
        description: "Description for the FastShift assistance modal when the customer has no open support tickets"
    },
    requestAssistanceModalEmptyModalRaiseTicketButton: {
        id: "request.assistance.modal.empty.raise-ticket-button",
        defaultMessage: "Raise ticket",
        description: "Button to redirect to another website to raise a new support request"
    }
});

});

parcelRegister("4b3M5", function(module, exports) {
$parcel$export(module.exports, "RequestAssistanceModalEmpty", function () { return (parcelRequire("8SPUx")).RequestAssistanceModalEmpty; });

var $8SPUx = parcelRequire("8SPUx");

});
parcelRegister("8SPUx", function(module, exports) {
$parcel$export(module.exports, "RequestAssistanceModalEmpty", function () { return $a458c389e8ad9d41$export$c2e8b7e5d248223e; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $1HVQz = parcelRequire("1HVQz");
var $1p5OQ = parcelRequire("1p5OQ");

var $cfGSv = parcelRequire("cfGSv");
var $6NRHl = parcelRequire("6NRHl");

var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");

var $fq4go = parcelRequire("fq4go");

var $95lLw = parcelRequire("95lLw");
const $a458c389e8ad9d41$export$c2e8b7e5d248223e = ({ handleCloseModal: handleCloseModal })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cfGSv.default), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2YtGy.default), {
                    space: "space.200",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $95lLw.messages).requestAssistanceModalEmptyDescription))
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6NRHl.default), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), {
                        appearance: "subtle",
                        onClick: handleCloseModal,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $95lLw.messages).requestAssistanceModalCancelButton))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1p5OQ.default), {
                        appearance: "primary",
                        target: "_blank",
                        href: `${(0, $fq4go.SAC_URL)}/contact`,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $95lLw.messages).requestAssistanceModalEmptyModalRaiseTicketButton))
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("1p5OQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $105ca3cf120bafe1$export$2e2bcd8739ae039; });
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8Ad6U = parcelRequire("8Ad6U");

var $2rbPH = parcelRequire("2rbPH");

var $1oC0p = parcelRequire("1oC0p");


var $72iRh = parcelRequire("72iRh");

var $kPutE = parcelRequire("kPutE");

var $gyCsW = parcelRequire("gyCsW");

var $39c3M = parcelRequire("39c3M");

var $1ewIj = parcelRequire("1ewIj");

var $jBgJs = parcelRequire("jBgJs");

var $7kLyP = parcelRequire("7kLyP");
var $105ca3cf120bafe1$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "href",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId"
], $105ca3cf120bafe1$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $105ca3cf120bafe1$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhksyzs _syaz1lh4 _aetrglyw _irr3syzs _30l31lh4 _1di6syzs _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    fullWidth: "_1bsb1osq"
};
var $105ca3cf120bafe1$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _irr3yw9d _30l310s3 _1di6ip91 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
var $105ca3cf120bafe1$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $105ca3cf120bafe1$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $105ca3cf120bafe1$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $105ca3cf120bafe1$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $105ca3cf120bafe1$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1mjl _irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
var $105ca3cf120bafe1$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _irr3i1yw _30l31pke _1di619ru _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $105ca3cf120bafe1$var$LinkButtonBase = function LinkButtonBase(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, href = _ref.href, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, unsafeRest = (0, $2rbPH.default)(_ref, $105ca3cf120bafe1$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $2rbPH.default)(unsafeRest, $105ca3cf120bafe1$var$_excluded2);
    var hasIconAfter = Boolean(iconAfter);
    var hasIconBefore = Boolean(iconBefore);
    var localRef = (0, $1oC0p.useRef)(null);
    (0, $gyCsW.default)(localRef, autoFocus);
    var combinedRef = (0, $kPutE.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ $1oC0p.createElement((0, $1ewIj.default), (0, $8Ad6U.default)({
        analyticsContext: analyticsContext,
        ref: combinedRef,
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName
    }, saferRest, {
        xcss: (0, $72iRh.cx)($105ca3cf120bafe1$var$styles.base, appearance === 'default' && ((0, $39c3M.fg)('platform-component-visual-refresh') ? $105ca3cf120bafe1$var$defaultStyles.rootRefreshed : $105ca3cf120bafe1$var$defaultStyles.root), appearance === 'primary' && $105ca3cf120bafe1$var$primaryStyles.root, appearance === 'warning' && $105ca3cf120bafe1$var$warningStyles.root, appearance === 'danger' && $105ca3cf120bafe1$var$dangerStyles.root, appearance === 'discovery' && $105ca3cf120bafe1$var$discoveryStyles.root, appearance === 'subtle' && ((0, $39c3M.fg)('platform-component-visual-refresh') ? $105ca3cf120bafe1$var$subtleStyles.rootRefreshed : $105ca3cf120bafe1$var$subtleStyles.root), $105ca3cf120bafe1$var$styles.linkDecorationUnset, isSelected && ((0, $39c3M.fg)('platform-component-visual-refresh') ? $105ca3cf120bafe1$var$selectedStyles.rootRefreshed : $105ca3cf120bafe1$var$selectedStyles.root), // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $105ca3cf120bafe1$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $105ca3cf120bafe1$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $105ca3cf120bafe1$var$selectedStyles.discovery, isDisabled && $105ca3cf120bafe1$var$styles.disabled, spacing === 'compact' && $105ca3cf120bafe1$var$styles.spacingCompact, hasIconBefore && $105ca3cf120bafe1$var$styles.buttonIconBefore, hasIconAfter && $105ca3cf120bafe1$var$styles.buttonIconAfter, shouldFitContainer && $105ca3cf120bafe1$var$styles.fullWidth)
    }), iconBefore && /*#__PURE__*/ $1oC0p.createElement((0, $jBgJs.default), {
        type: "icon",
        position: "before",
        isLoading: false
    }, /*#__PURE__*/ $1oC0p.createElement((0, $7kLyP.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ $1oC0p.createElement((0, $jBgJs.default), {
        isLoading: false
    }, children), iconAfter && /*#__PURE__*/ $1oC0p.createElement((0, $jBgJs.default), {
        type: "icon",
        position: "after",
        isLoading: false
    }, /*#__PURE__*/ $1oC0p.createElement((0, $7kLyP.default), {
        icon: iconAfter
    })));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $105ca3cf120bafe1$var$LinkButton = /*#__PURE__*/ (0, $1oC0p.forwardRef)($105ca3cf120bafe1$var$LinkButtonBase);
$105ca3cf120bafe1$var$LinkButton.displayName = 'LinkButton';
var $105ca3cf120bafe1$export$2e2bcd8739ae039 = $105ca3cf120bafe1$var$LinkButton;

});

parcelRegister("cfGSv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8eb8257123687297$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $4cgdq = parcelRequire("4cgdq");

var $9GQ1i = parcelRequire("9GQ1i");

var $21Ly9 = parcelRequire("21Ly9");

var $3J1Qg = parcelRequire("3J1Qg");

var $agjuk = parcelRequire("agjuk");
var $8eb8257123687297$var$bodyStyles = (0, $3dJ4i.css)({
    /* This ensures the body fills the whole space between header and footer. */ flex: '1 1 auto'
});
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer using negative margins.
 */ var $8eb8257123687297$var$bodyScrollStyles = (0, $3dJ4i.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingBlock: (0, $3J1Qg.keylineHeight),
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ var $8eb8257123687297$var$viewportScrollStyles = (0, $3dJ4i.css)({
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $8eb8257123687297$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $9GQ1i.useModal)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $agjuk.default)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? (0, $3dJ4i.jsx)("div", {
        css: [
            $8eb8257123687297$var$bodyStyles,
            $8eb8257123687297$var$viewportScrollStyles
        ],
        "data-testid": testId
    }, children) : (0, $3dJ4i.jsx)((0, $4cgdq.TouchScrollable), null, (0, $3dJ4i.jsx)((0, $21Ly9.default), {
        testId: userDefinedTestId || modalTestId
    }, (0, $3dJ4i.jsx)("div", {
        css: [
            $8eb8257123687297$var$bodyStyles,
            $8eb8257123687297$var$bodyScrollStyles
        ],
        "data-testid": testId
    }, children)));
};
var $8eb8257123687297$export$2e2bcd8739ae039 = $8eb8257123687297$var$ModalBody;

});
parcelRegister("21Ly9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $17a08f2a4d765ed3$export$2e2bcd8739ae039; });

var $py6Rq = parcelRequire("py6Rq");

var $4Lw69 = parcelRequire("4Lw69");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $dH1HR = parcelRequire("dH1HR");

var $FcGYz = parcelRequire("FcGYz");

var $aUzEK = parcelRequire("aUzEK");

var $9qszB = parcelRequire("9qszB");

var $kXeye = parcelRequire("kXeye");

var $lL5vi = parcelRequire("lL5vi");

var $cAeoO = parcelRequire("cAeoO");

var $3J1Qg = parcelRequire("3J1Qg");
var $17a08f2a4d765ed3$var$baseStyles = (0, $3dJ4i.css)((0, $4Lw69.default)({
    display: 'inherit',
    margin: "var(--ds-space-0, 0px)",
    flex: 'inherit',
    flexDirection: 'inherit',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'auto'
}, (0, $cAeoO.media).above.xs, {
    height: 'unset',
    overflowY: 'auto'
}));
var $17a08f2a4d765ed3$var$topKeylineStyles = (0, $3dJ4i.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockStart: "".concat((0, $3J1Qg.keylineHeight), "px solid ").concat((0, $3J1Qg.keylineColor))
});
var $17a08f2a4d765ed3$var$bottomKeylineStyles = (0, $3dJ4i.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: "".concat((0, $3J1Qg.keylineHeight), "px solid ").concat((0, $3J1Qg.keylineColor))
});
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $17a08f2a4d765ed3$var$ScrollContainer = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $1oC0p.useRef)(null);
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $py6Rq.default)(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(false), _useState4 = (0, $py6Rq.default)(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(false), _useState6 = (0, $py6Rq.default)(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $1oC0p.useEffect)(function() {
        var schedule = (0, $FcGYz.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $kXeye.default)((0, $FcGYz.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > (0, $3J1Qg.keylineHeight));
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, $3J1Qg.keylineHeight));
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $1oC0p.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $dH1HR.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $dH1HR.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $9qszB.default);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return (0, $3dJ4i.jsx)((0, $lL5vi.default), {
        isInset: true
    }, (0, $3dJ4i.jsx)("div", {
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        "data-testid": testId && "".concat(testId, "--scrollable"),
        ref: (0, $aUzEK.default)([
            ref,
            scrollableRef
        ]),
        css: [
            $17a08f2a4d765ed3$var$baseStyles,
            showTopKeyline && $17a08f2a4d765ed3$var$topKeylineStyles,
            showBottomKeyline && $17a08f2a4d765ed3$var$bottomKeylineStyles
        ]
    }, children));
});
$17a08f2a4d765ed3$var$ScrollContainer.displayName = 'ScrollContainer';
var $17a08f2a4d765ed3$export$2e2bcd8739ae039 = $17a08f2a4d765ed3$var$ScrollContainer;

});

parcelRegister("agjuk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $778a83f9c442334e$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $9XJwS = parcelRequire("9XJwS");
function $778a83f9c442334e$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $1oC0p.useContext)((0, $9XJwS.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("6NRHl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4f40f8fed9fab61f$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3dJ4i = parcelRequire("3dJ4i");

var $9GQ1i = parcelRequire("9GQ1i");

var $3J1Qg = parcelRequire("3J1Qg");
var $4f40f8fed9fab61f$var$footerStyles = (0, $3dJ4i.css)({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginBlockStart: -(0, $3J1Qg.keylineHeight),
    paddingBlockEnd: "var(--ds-space-300, 24px)",
    paddingBlockStart: "var(--ds-space-200, 16px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $4f40f8fed9fab61f$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $9GQ1i.useModal)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return (0, $3dJ4i.jsx)("div", {
        css: $4f40f8fed9fab61f$var$footerStyles,
        "data-testid": testId
    }, children);
};
var $4f40f8fed9fab61f$export$2e2bcd8739ae039 = $4f40f8fed9fab61f$var$ModalFooter;

});



parcelRegister("jyjIa", function(module, exports) {
$parcel$export(module.exports, "FastshiftAssistanceModalForm", function () { return (parcelRequire("4kY5W")).FastshiftAssistanceModalForm; });

var $4kY5W = parcelRequire("4kY5W");

});
parcelRegister("4kY5W", function(module, exports) {
$parcel$export(module.exports, "FastshiftAssistanceModalForm", function () { return $ccccd5015e5174db$export$478b41a5c5725fea; });
/* request-assistance-modal-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $7Sqn0 = parcelRequire("7Sqn0");

var $1HVQz = parcelRequire("1HVQz");

var $lX14w = parcelRequire("lX14w");
var $ff3wF = parcelRequire("ff3wF");
var $igGC3 = parcelRequire("igGC3");
var $gZ0V2 = parcelRequire("gZ0V2");

var $cfGSv = parcelRequire("cfGSv");
var $6NRHl = parcelRequire("6NRHl");

var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");

var $lAVaU = parcelRequire("lAVaU");

var $P90vo = parcelRequire("P90vo");

var $fq4go = parcelRequire("fq4go");

var $kbaUT = parcelRequire("kbaUT");

var $PE2DD = parcelRequire("PE2DD");
parcelRequire("iDqkL");
var $jCnLo = parcelRequire("jCnLo");

var $560h0 = parcelRequire("560h0");

var $95lLw = parcelRequire("95lLw");

var $hJVgj = parcelRequire("hJVgj");
const $ccccd5015e5174db$var$StyledTextAreaWraper = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $aPnCa._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, (0, $dPABA._)((0, $6ogO3._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_12uszgxb",
            __cmplp.className
        ])
    }));
});
const $ccccd5015e5174db$export$478b41a5c5725fea = ({ handleCloseModal: handleCloseModal, supportRequests: supportRequests, isSupportRequestsLoading: isSupportRequestsLoading })=>{
    const intl = (0, $8e22h.default)();
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const { showFlag: showFlag } = (0, $1oC0p.useContext)((0, $kbaUT.default).Context);
    const { sendRequestAssistanceModalCommentSubmitButtonClickUIEvent: sendRequestAssistanceModalCommentSubmitButtonClickUIEvent, sendPostCommentOutcomeFlagDisplayedTrackEvent: sendPostCommentOutcomeFlagDisplayedTrackEvent } = (0, $jCnLo.useRelationshipsAnalytics)();
    const customerSupportRequestOptions = (0, $1oC0p.useMemo)(()=>supportRequests.filter((request)=>(0, $560h0.isSupportRequestOpen)(request.status)).map((request)=>{
            const productName = "";
            let siteDomainName = "";
            try {
                siteDomainName = request.destination.baseUrl ? new URL(request.destination.baseUrl).hostname : "";
            } catch (e) {
                siteDomainName = "";
            }
            return {
                label: `${request.supportTicketId} - ${request.title}`,
                site: siteDomainName,
                product: productName,
                value: request.supportTicketId
            };
        }), [
        supportRequests
    ]);
    const successFlag = (0, $1oC0p.useCallback)(({ ticketId: ticketId })=>{
        return {
            id: "success-flag",
            iconType: "success",
            styleOverride: true,
            autoDismiss: true,
            title: intl.formatMessage((0, $95lLw.messages).requestAssistanceModalSuccessFlagTitle),
            description: intl.formatMessage((0, $95lLw.messages).requestAssistanceModalSuccessFlagDescription),
            actions: [
                {
                    content: intl.formatMessage((0, $95lLw.messages).requestAssistanceModalSuccessFlagAction),
                    href: `${(0, $fq4go.SAC_URL)}/requests/${ticketId}`,
                    target: "_blank"
                }
            ]
        };
    }, [
        intl
    ]);
    const errorFlag = (0, $1oC0p.useMemo)(()=>{
        return {
            id: "error-flag",
            iconType: "error",
            styleOverride: true,
            autoDismiss: true,
            title: intl.formatMessage((0, $95lLw.messages).requestAssistanceModalErrorFlagTitle),
            description: intl.formatMessage((0, $95lLw.messages).requestAssistanceModalErrorFlagDescription)
        };
    }, [
        intl
    ]);
    const createMoveTicketCommentRequest = ({ stargateClient: stargateClient, issueId: issueId, comment: comment })=>{
        return new Promise((resolve, reject)=>(0, $hJVgj.createMoveTicketComment)({
                stargateClient: stargateClient,
                issueId: issueId,
                comment: comment
            }).then((response)=>{
                var _response_data_customerSupport, _response_data;
                if (!response || !(response === null || response === void 0 ? void 0 : (_response_data = response.data) === null || _response_data === void 0 ? void 0 : (_response_data_customerSupport = _response_data.customerSupport) === null || _response_data_customerSupport === void 0 ? void 0 : _response_data_customerSupport.addComment)) // if response payload is not valid, the comment was not created, regardless of the HTTP status code
                reject(new Error("Server failed to execute the request - comment was not created"));
                resolve(response);
            }).catch((error)=>{
                reject(error);
            }));
    };
    // Search for items by ticket id, summary, site domain name, or product name
    const searchDropdownOptions = (option, inputValue)=>{
        const lowerCaseInputValue = inputValue.toLowerCase();
        return option.label.toLowerCase().includes(lowerCaseInputValue) || option.site.toLowerCase().startsWith(lowerCaseInputValue) || option.product.toLowerCase().startsWith(lowerCaseInputValue);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
        onSubmit: (data)=>{
            // validate form fields
            if (!data.ticketId || !data.comment) {
                const errors = {
                    ticketId: !data.ticketId ? intl.formatMessage((0, $95lLw.messages).requestAssistanceModalFieldIsRequiredMessage) : undefined,
                    comment: !data.comment ? intl.formatMessage((0, $95lLw.messages).requestAssistanceModalFieldIsRequiredMessage) : undefined
                };
                return errors;
            }
            // Fire UI event for button click
            sendRequestAssistanceModalCommentSubmitButtonClickUIEvent(data.ticketId.value);
            return createMoveTicketCommentRequest({
                stargateClient: stargateClient,
                issueId: data.ticketId.value,
                comment: data.comment
            }).then(()=>{
                // Show success flag and track event
                showFlag(successFlag({
                    ticketId: data.ticketId.value
                }));
                sendPostCommentOutcomeFlagDisplayedTrackEvent(true, data.ticketId.value);
                handleCloseModal();
            }).catch((error)=>{
                console.error(error);
                // Show error flag and track event
                showFlag(errorFlag);
                sendPostCommentOutcomeFlagDisplayedTrackEvent(false, data.ticketId.value);
            });
        },
        children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", (0, $dPABA._)((0, $6ogO3._)({}, formProps), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cfGSv.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                            space: "space.200",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lPRxe.default), {
                                        color: "color.text.subtle",
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $95lLw.messages).requestAssistanceModalSubtitleNote)),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gZ0V2.default), {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                                    space: "space.100",
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                            color: "color.text.subtle",
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $95lLw.messages).requestAssistanceModalDescription))
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                            name: "ticketId",
                                            label: intl.formatMessage((0, $95lLw.messages).requestAssistanceModalDropdownLabel),
                                            "aria-required": true,
                                            isRequired: true,
                                            children: (_param)=>{
                                                var { fieldProps: { id: id }, error: error } = _param, rest = (0, $aPnCa._)(_param.fieldProps, [
                                                    "id"
                                                ]);
                                                return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lAVaU.default), (0, $dPABA._)((0, $6ogO3._)({
                                                            inputId: id
                                                        }, rest), {
                                                            options: customerSupportRequestOptions,
                                                            maxMenuHeight: 200,
                                                            isLoading: isSupportRequestsLoading,
                                                            filterOption: (option, inputValue)=>{
                                                                return searchDropdownOptions(option.data, inputValue);
                                                            }
                                                        })),
                                                        error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                            children: error
                                                        })
                                                    ]
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($ccccd5015e5174db$var$StyledTextAreaWraper, {
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                "aria-required": true,
                                                name: "comment",
                                                label: intl.formatMessage((0, $95lLw.messages).requestAssistanceModalCommentLabel),
                                                isRequired: true,
                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $P90vo.default), (0, $dPABA._)((0, $6ogO3._)({
                                                                autoComplete: "off"
                                                            }, fieldProps), {
                                                                isRequired: false,
                                                                resize: "auto",
                                                                maxHeight: "30vh",
                                                                minimumRows: 7
                                                            })),
                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                children: error
                                                            })
                                                        ]
                                                    })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6NRHl.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7Sqn0.default), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), {
                                    appearance: "subtle",
                                    onClick: handleCloseModal,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $95lLw.messages).requestAssistanceModalCancelButton))
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), {
                                    type: "submit",
                                    appearance: "primary",
                                    isLoading: submitting,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $95lLw.messages).requestAssistanceModalSendButton))
                                })
                            ]
                        })
                    })
                ]
            }))
    });
};

});
parcelRegister("kbaUT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $50814597c33f3e4d$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $dbITq = parcelRequire("dbITq");
var $lFTUI = parcelRequire("lFTUI");
var $7AbSd = parcelRequire("7AbSd");

var $dTJrO = parcelRequire("dTJrO");

var $5OpwE = parcelRequire("5OpwE");

var $8IO3K = parcelRequire("8IO3K");

var $lPRxe = parcelRequire("lPRxe");
const $50814597c33f3e4d$var$CustomFlag = (_param)=>{
    var { iconType: iconType, autoDismiss: autoDismiss, styleOverride: styleOverride } = _param, props = (0, $aPnCa._)(_param, [
        "iconType",
        "autoDismiss",
        "styleOverride"
    ]);
    const icon = iconType === "success" ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8IO3K))), {
        label: "success",
        color: "var(--ds-icon-success)"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5OpwE))), {
        label: "error",
        color: "var(--ds-icon-danger)"
    });
    // Wrapping text in ADS components resolves WAC and ADS Design System Conflicts for staging and production
    // note while props.actions do not display correctly in localhost, they do in stg and prod
    const styleOverrideProps = styleOverride ? {
        title: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
            size: "small",
            children: props.title
        }),
        description: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
            children: props.description
        })
    } : {};
    if (autoDismiss) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dbITq.default), (0, $6ogO3._)({
        icon: icon
    }, props, styleOverrideProps));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lFTUI.default), (0, $6ogO3._)({
        icon: icon
    }, props, styleOverrideProps));
};
const $50814597c33f3e4d$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    showFlag: ()=>{} // for instantiation only
});
const $50814597c33f3e4d$export$b0063bae72b769ca = ({ children: children })=>{
    const [flags, setFlags] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState([]);
    const showFlag = (config)=>{
        setFlags([
            config,
            ...flags
        ]);
    };
    const handleDismiss = ()=>{
        setFlags(flags.slice(1));
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)($50814597c33f3e4d$export$2eb95677cf2465e1.Provider, {
        value: {
            showFlag: showFlag
        },
        children: [
            children,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7AbSd.default), {
                onDismissed: handleDismiss,
                children: flags.map((props, index)=>{
                    return /*#__PURE__*/ (0, $7VQPk.jsx)($50814597c33f3e4d$var$CustomFlag, (0, $6ogO3._)({}, props), `flag-${index}`);
                })
            })
        ]
    });
};
var $50814597c33f3e4d$export$2e2bcd8739ae039 = {
    Provider: $50814597c33f3e4d$export$b0063bae72b769ca,
    Context: $50814597c33f3e4d$export$2eb95677cf2465e1
};

});
parcelRegister("dbITq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $999f2042949edc5c$export$2e2bcd8739ae039; });

var $8qa5V = parcelRequire("8qa5V");

var $1oC0p = parcelRequire("1oC0p");

var $aEDsG = parcelRequire("aEDsG");

var $7uNuF = parcelRequire("7uNuF");

var $lFTUI = parcelRequire("lFTUI");

var $7AbSd = parcelRequire("7AbSd");
var $999f2042949edc5c$var$packageName = "@atlaskit/flag";
var $999f2042949edc5c$var$packageVersion = "17.1.8";
var $999f2042949edc5c$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ var $999f2042949edc5c$var$AutoDismissFlag = function AutoDismissFlag(props) {
    var id = props.id, analyticsContext = props.analyticsContext, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $7uNuF.default) : _props$onDismissed;
    var autoDismissTimer = (0, $1oC0p.useRef)(null);
    var _useFlagGroup = (0, $7AbSd.useFlagGroup)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $1oC0p.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var onDismissedAnalytics = (0, $aEDsG.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $999f2042949edc5c$var$packageName,
        packageVersion: $999f2042949edc5c$var$packageVersion
    });
    var isAutoDismissAllowed = isDismissAllowed && onDismissed;
    var dismissFlag = (0, $1oC0p.useCallback)(function() {
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    var stopAutoDismissTimer = (0, $1oC0p.useCallback)(function() {
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    var startAutoDismissTimer = (0, $1oC0p.useCallback)(function() {
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, $999f2042949edc5c$export$66c3d409977b5615 * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed
    ]);
    (0, $1oC0p.useEffect)(function() {
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lFTUI.default), (0, $8qa5V.default)({}, props, {
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    }));
};
var $999f2042949edc5c$export$2e2bcd8739ae039 = $999f2042949edc5c$var$AutoDismissFlag;

});
parcelRegister("8qa5V", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $621895065f40a196$export$2e2bcd8739ae039; });
function $621895065f40a196$export$2e2bcd8739ae039() {
    return $621895065f40a196$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $621895065f40a196$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("aEDsG", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $7c1c400e4c9d54d0$export$a4687b0234b40e28; });

var $55aK4 = parcelRequire("55aK4");

var $1oC0p = parcelRequire("1oC0p");

var $gnz2P = parcelRequire("gnz2P");

var $7zWfl = parcelRequire("7zWfl");
function $7c1c400e4c9d54d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7c1c400e4c9d54d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7c1c400e4c9d54d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $55aK4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7c1c400e4c9d54d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7c1c400e4c9d54d0$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $gnz2P.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $7zWfl.useTrackedRef)(analyticsData);
    var fnRef = (0, $7zWfl.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $7c1c400e4c9d54d0$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("55aK4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3b35c087bf1c4675$export$2e2bcd8739ae039; });

var $5DP1s = parcelRequire("5DP1s");
function $3b35c087bf1c4675$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $5DP1s.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("5DP1s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $41b82c4b825f5234$export$2e2bcd8739ae039; });

var $7R6fn = parcelRequire("7R6fn");

var $dwbTR = parcelRequire("dwbTR");
function $41b82c4b825f5234$export$2e2bcd8739ae039(t) {
    var i = (0, $dwbTR.default)(t, "string");
    return "symbol" == (0, $7R6fn.default)(i) ? i : i + "";
}

});
parcelRegister("7R6fn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5b82542c478e7824$export$2e2bcd8739ae039; });
function $5b82542c478e7824$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $5b82542c478e7824$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5b82542c478e7824$export$2e2bcd8739ae039(o);
}

});

parcelRegister("dwbTR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9d777ea0b47caf1d$export$2e2bcd8739ae039; });

var $7R6fn = parcelRequire("7R6fn");
function $9d777ea0b47caf1d$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $7R6fn.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $7R6fn.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("gnz2P", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $bec9fa6f88869ac7$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $3uATv = parcelRequire("3uATv");

var $kj3fl = parcelRequire("kj3fl");
function $bec9fa6f88869ac7$export$5bf35293e545f20c() {
    var analyticsContext = (0, $kj3fl.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $3uATv.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("3uATv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $28b0cadb3d30db04$export$2e2bcd8739ae039; });

var $igZS8 = parcelRequire("igZS8");

var $iSNHz = parcelRequire("iSNHz");

var $5dqKq = parcelRequire("5dqKq");

var $6gbuF = parcelRequire("6gbuF");

var $dTP4E = parcelRequire("dTP4E");

var $1lgIL = parcelRequire("1lgIL");

var $lU9Ag = parcelRequire("lU9Ag");

var $55aK4 = parcelRequire("55aK4");

var $kl72S = parcelRequire("kl72S");
function $28b0cadb3d30db04$var$_callSuper(t, o, e) {
    return o = (0, $dTP4E.default)(o), (0, $6gbuF.default)(t, $28b0cadb3d30db04$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $dTP4E.default)(t).constructor) : o.apply(t, e));
}
function $28b0cadb3d30db04$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($28b0cadb3d30db04$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $28b0cadb3d30db04$var$_superPropGet(t, o, e, r) {
    var p = (0, $1lgIL.default)((0, $dTP4E.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $28b0cadb3d30db04$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $28b0cadb3d30db04$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $28b0cadb3d30db04$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $iSNHz.default)(this, UIAnalyticsEvent);
        _this = $28b0cadb3d30db04$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $55aK4.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $55aK4.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $igZS8.default)(_this.context);
            var handlers = (0, $igZS8.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $55aK4.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $lU9Ag.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $5dqKq.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $28b0cadb3d30db04$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $kl72S.default));

});
parcelRegister("igZS8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d4d9b727e67804d9$export$2e2bcd8739ae039; });

var $lp3xn = parcelRequire("lp3xn");

var $dlCls = parcelRequire("dlCls");

var $a5TUV = parcelRequire("a5TUV");

var $lOV0O = parcelRequire("lOV0O");
function $d4d9b727e67804d9$export$2e2bcd8739ae039(r) {
    return (0, $lp3xn.default)(r) || (0, $dlCls.default)(r) || (0, $a5TUV.default)(r) || (0, $lOV0O.default)();
}

});
parcelRegister("lp3xn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f94ead338bd5f079$export$2e2bcd8739ae039; });

var $1je0I = parcelRequire("1je0I");
function $f94ead338bd5f079$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $1je0I.default)(r);
}

});
parcelRegister("1je0I", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0f426efe57843cd0$export$2e2bcd8739ae039; });
function $0f426efe57843cd0$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("dlCls", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9b7afb104ee7a0c0$export$2e2bcd8739ae039; });
function $9b7afb104ee7a0c0$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("a5TUV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7595bef9dceeb668$export$2e2bcd8739ae039; });

var $1je0I = parcelRequire("1je0I");
function $7595bef9dceeb668$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $1je0I.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $1je0I.default)(r, a) : void 0;
    }
}

});

parcelRegister("lOV0O", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fe2a7de37ba847b5$export$2e2bcd8739ae039; });
function $fe2a7de37ba847b5$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("iSNHz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dbf3d2dce946adae$export$2e2bcd8739ae039; });
function $dbf3d2dce946adae$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("5dqKq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3cc2ea3458fdf7fc$export$2e2bcd8739ae039; });

var $5DP1s = parcelRequire("5DP1s");
function $3cc2ea3458fdf7fc$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $5DP1s.default)(o.key), o);
    }
}
function $3cc2ea3458fdf7fc$export$2e2bcd8739ae039(e, r, t) {
    return r && $3cc2ea3458fdf7fc$var$_defineProperties(e.prototype, r), t && $3cc2ea3458fdf7fc$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("6gbuF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $48ed2712b466ccf9$export$2e2bcd8739ae039; });

var $7R6fn = parcelRequire("7R6fn");

var $lV7ui = parcelRequire("lV7ui");
function $48ed2712b466ccf9$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $7R6fn.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $lV7ui.default)(t);
}

});
parcelRegister("lV7ui", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ff54babf63ce4e08$export$2e2bcd8739ae039; });
function $ff54babf63ce4e08$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("dTP4E", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a1e807a47d98d8cc$export$2e2bcd8739ae039; });
function $a1e807a47d98d8cc$export$2e2bcd8739ae039(t) {
    return $a1e807a47d98d8cc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $a1e807a47d98d8cc$export$2e2bcd8739ae039(t);
}

});

parcelRegister("1lgIL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0fa4b911b2fda028$export$2e2bcd8739ae039; });

var $lmi5E = parcelRequire("lmi5E");
function $0fa4b911b2fda028$export$2e2bcd8739ae039() {
    return $0fa4b911b2fda028$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $lmi5E.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $0fa4b911b2fda028$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("lmi5E", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f8c9af5cb562381a$export$2e2bcd8739ae039; });

var $dTP4E = parcelRequire("dTP4E");
function $f8c9af5cb562381a$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $dTP4E.default)(t)););
    return t;
}

});


parcelRegister("lU9Ag", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ff264319b9a2b106$export$2e2bcd8739ae039; });

var $c6nIM = parcelRequire("c6nIM");
function $ff264319b9a2b106$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $c6nIM.default)(t, e);
}

});
parcelRegister("c6nIM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8cf8722445a0dea6$export$2e2bcd8739ae039; });
function $8cf8722445a0dea6$export$2e2bcd8739ae039(t, e) {
    return $8cf8722445a0dea6$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $8cf8722445a0dea6$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("kl72S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eceb3be62099f3bd$export$2e2bcd8739ae039; });

var $7R6fn = parcelRequire("7R6fn");

var $iSNHz = parcelRequire("iSNHz");

var $5dqKq = parcelRequire("5dqKq");

var $55aK4 = parcelRequire("55aK4");
function $eceb3be62099f3bd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eceb3be62099f3bd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eceb3be62099f3bd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $55aK4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eceb3be62099f3bd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $eceb3be62099f3bd$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $eceb3be62099f3bd$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $eceb3be62099f3bd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $iSNHz.default)(this, AnalyticsEvent);
        (0, $55aK4.default)(this, "_isAnalyticsEvent", true);
        (0, $55aK4.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $eceb3be62099f3bd$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $5dqKq.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $7R6fn.default)(updater) === 'object') this.payload = $eceb3be62099f3bd$var$_objectSpread($eceb3be62099f3bd$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("kj3fl", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $ec8819ab74508c37$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $ec8819ab74508c37$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("7zWfl", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $5848fbd735c79143$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $5848fbd735c79143$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("lFTUI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fc78cc993f9d0d77$export$2e2bcd8739ae039; });
/* flag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8qa5V = parcelRequire("8qa5V");

var $55aK4 = parcelRequire("55aK4");

var $lE80C = parcelRequire("lE80C");

var $1oC0p = parcelRequire("1oC0p");

var $gcw6K = parcelRequire("gcw6K");
var $i0UnX = parcelRequire("i0UnX");

var $aEDsG = parcelRequire("aEDsG");

var $7uNuF = parcelRequire("7uNuF");

var $dWlEk = parcelRequire("dWlEk");

var $39c3M = parcelRequire("39c3M");

var $euC3u = parcelRequire("euC3u");
var $8sG9Y = parcelRequire("8sG9Y");
var $8GeHv = parcelRequire("8GeHv");

var $8BFJ8 = parcelRequire("8BFJ8");

var $1xcHY = parcelRequire("1xcHY");

var $lF69S = parcelRequire("lF69S");

var $7AbSd = parcelRequire("7AbSd");

var $fYjS4 = parcelRequire("fYjS4");
var $1G2RB = parcelRequire("1G2RB");

var $8j7J7 = parcelRequire("8j7J7");
function $fc78cc993f9d0d77$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fc78cc993f9d0d77$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fc78cc993f9d0d77$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $55aK4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fc78cc993f9d0d77$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fc78cc993f9d0d77$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkosqtm _1reo15vq _18m915vq _v564z97a _16qs8sq4 _1pbyni7l _1bsb1osq"
};
var $fc78cc993f9d0d77$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
var $fc78cc993f9d0d77$var$oldDescriptionStyles = null;
var $fc78cc993f9d0d77$var$descriptionStyles = null;
var $fc78cc993f9d0d77$var$oldIconWrapperStyles = null;
var $fc78cc993f9d0d77$var$iconWrapperStyles = null;
var $fc78cc993f9d0d77$var$flagWrapperStyles = null;
var $fc78cc993f9d0d77$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: "@atlaskit/flag",
    packageVersion: "17.1.8"
};
var $fc78cc993f9d0d77$var$transitionStyles = null;
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ var $fc78cc993f9d0d77$var$Flag = function Flag(props) {
    var _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $1xcHY.DEFAULT_APPEARANCE) : _props$appearance, icon = props.icon, title = props.title, description = props.description, linkComponent = props.linkComponent, onMouseOver = props.onMouseOver, _props$onFocus = props.onFocus, onFocus = _props$onFocus === void 0 ? (0, $7uNuF.default) : _props$onFocus, onMouseOut = props.onMouseOut, _props$onBlur = props.onBlur, onBlur = _props$onBlur === void 0 ? (0, $7uNuF.default) : _props$onBlur, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $7uNuF.default) : _props$onDismissed, testId = props.testId, id = props.id, analyticsContext = props.analyticsContext, delayAnnouncement = props.delayAnnouncement, _props$headingLevel = props.headingLevel, headingLevel = _props$headingLevel === void 0 ? 2 : _props$headingLevel;
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $lE80C.default)(_useState, 2), isDelayToAnnounce = _useState2[0], setIsDelayToAnnounce = _useState2[1];
    var _useFlagGroup = (0, $7AbSd.useFlagGroup)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $1oC0p.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var _useState3 = (0, $1oC0p.useState)(false), _useState4 = (0, $lE80C.default)(_useState3, 2), isExpanded = _useState4[0], setIsExpanded = _useState4[1];
    var onDismissedAnalytics = (0, $aEDsG.usePlatformLeafEventHandler)($fc78cc993f9d0d77$var$_objectSpread({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext
    }, $fc78cc993f9d0d77$var$analyticsAttributes));
    var isBold = appearance !== (0, $1xcHY.DEFAULT_APPEARANCE);
    var toggleExpand = (0, $1oC0p.useCallback)(function() {
        setIsExpanded(function(previous) {
            return !previous;
        });
    }, []);
    var buttonActionCallback = (0, $1oC0p.useCallback)(function() {
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $1oC0p.useEffect)(function() {
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!delayAnnouncement) return;
        setTimeout(function() {
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    var onFocusAnalytics = (0, $aEDsG.usePlatformLeafEventHandler)($fc78cc993f9d0d77$var$_objectSpread({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext
    }, $fc78cc993f9d0d77$var$analyticsAttributes));
    var onBlurAnalytics = (0, $aEDsG.usePlatformLeafEventHandler)($fc78cc993f9d0d77$var$_objectSpread({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext
    }, $fc78cc993f9d0d77$var$analyticsAttributes));
    var autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    var textColor = (0, $8j7J7.flagTextColor)[appearance];
    var iconColor = (0, $8j7J7.flagIconColor)[appearance];
    var iconGlyph = (0, $8j7J7.flagIconGlyph)[appearance];
    var isDismissable = isBold || isDismissAllowed;
    var shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    // when delayAnnouncement is available we will use a hidden content for announcement
    var delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ $1oC0p.createElement((0, $8BFJ8.default), null, title, description) : undefined;
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $8qa5V.default)({
        role: "alert",
        "data-testid": testId
    }, autoDismissProps, {
        className: (0, $gcw6K.default)([
            "_1bsb1osq"
        ])
    }), /*#__PURE__*/ $1oC0p.createElement((0, $euC3u.default), {
        padding: "space.200",
        backgroundColor: (0, $8j7J7.flagBackgroundColor)[appearance],
        xcss: $fc78cc993f9d0d77$var$styles.flag
    }, /*#__PURE__*/ $1oC0p.createElement((0, $8sG9Y.default), {
        alignBlock: (0, $39c3M.fg)('platform_ads_component_no_icon_spacing_support') ? 'start' : 'stretch',
        space: "space.200"
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        "data-testid": testId && "".concat(testId, "-icon-container"),
        className: (0, $gcw6K.default)([
            (0, $39c3M.fg)('platform_ads_component_no_icon_spacing_support') ? "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz16r9" : "_1e0c1txw _4cvrv2br _1o9zidpf _syaz16r9"
        ]),
        style: $fc78cc993f9d0d77$var$_objectSpread($fc78cc993f9d0d77$var$_objectSpread({}, (0, $55aK4.default)({}, $fc78cc993f9d0d77$var$CSS_VAR_ICON_COLOR, iconColor)), {}, {
            "--_11v68d2": (0, $i0UnX.default)("var(".concat($fc78cc993f9d0d77$var$CSS_VAR_ICON_COLOR, ")"))
        })
    }, icon || (iconGlyph && (0, $39c3M.fg)('platform_ads_component_no_icon_spacing_support') ? iconGlyph : null)), /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $gcw6K.default)([
            "_v5641hdc _16jlkb7n"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $8GeHv.default), {
        space: shouldRenderGap ? 'space.100' : 'space.0' // Gap exists even when not expanded due to Expander internals always being in the DOM
    }, isDelayToAnnounce && delayedAnnouncement, /*#__PURE__*/ $1oC0p.createElement((0, $8sG9Y.default), {
        alignBlock: "stretch",
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ $1oC0p.createElement((0, $euC3u.default), {
        paddingBlockStart: "space.050",
        paddingBlockEnd: "space.025",
        xcss: $fc78cc993f9d0d77$var$styles.overflowWrap
    }, /*#__PURE__*/ $1oC0p.createElement((0, $dWlEk.default), {
        as: "h".concat(headingLevel),
        size: "xsmall",
        color: textColor
    }, /*#__PURE__*/ $1oC0p.createElement("span", {
        /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce
    }, title))), isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ $1oC0p.createElement((0, $fYjS4.default), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), /*#__PURE__*/ $1oC0p.createElement((0, $1G2RB.default), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && /*#__PURE__*/ $1oC0p.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            color: (0, $8j7J7.flagTextColorToken)[appearance]
        },
        "data-testid": testId && "".concat(testId, "-description"),
        "aria-hidden": isDelayToAnnounce,
        className: (0, $gcw6K.default)([
            (0, $39c3M.fg)('platform_ads_explicit_font_styles') ? "_11c82smr _1reo1wug _18m91wug _c71l53f4 _1i4qfg65" : "_1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
        ])
    }, description), /*#__PURE__*/ $1oC0p.createElement((0, $lF69S.default), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId
    })))))));
};
var $fc78cc993f9d0d77$export$2e2bcd8739ae039 = $fc78cc993f9d0d77$var$Flag;

});
parcelRegister("lE80C", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fc238bd264ecbc9f$export$2e2bcd8739ae039; });

var $jFWhg = parcelRequire("jFWhg");

var $9d9Ms = parcelRequire("9d9Ms");

var $a5TUV = parcelRequire("a5TUV");

var $1skmG = parcelRequire("1skmG");
function $fc238bd264ecbc9f$export$2e2bcd8739ae039(r, e) {
    return (0, $jFWhg.default)(r) || (0, $9d9Ms.default)(r, e) || (0, $a5TUV.default)(r, e) || (0, $1skmG.default)();
}

});
parcelRegister("jFWhg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e52f0d5acf1bab1f$export$2e2bcd8739ae039; });
function $e52f0d5acf1bab1f$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("9d9Ms", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6b4cea299571ff0a$export$2e2bcd8739ae039; });
function $6b4cea299571ff0a$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("1skmG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $10f833fd11c93509$export$2e2bcd8739ae039; });
function $10f833fd11c93509$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("gcw6K", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bcb6ac48ab2d4ed5$export$2e2bcd8739ae039; });
const $bcb6ac48ab2d4ed5$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $bcb6ac48ab2d4ed5$var$ATOMIC_GROUP_LENGTH = 5;
function $bcb6ac48ab2d4ed5$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $bcb6ac48ab2d4ed5$var$UNDERSCORE_UNICODE ? $bcb6ac48ab2d4ed5$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("i0UnX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d1d3f70c3d0e219a$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $d1d3f70c3d0e219a$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("dWlEk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a2617c47cbdc023d$export$2e2bcd8739ae039; });
/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $lE80C = parcelRequire("lE80C");

var $1oC0p = parcelRequire("1oC0p");

var $gcw6K = parcelRequire("gcw6K");

var $6WZ4u = parcelRequire("6WZ4u");

var $2XkT3 = parcelRequire("2XkT3");

var $40jLo = parcelRequire("40jLo");

var $7t0tI = parcelRequire("7t0tI");
var $a2617c47cbdc023d$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
var $a2617c47cbdc023d$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
var $a2617c47cbdc023d$var$headingColorStylesMap = {
    'color.text': "_syaz1fxt",
    'color.text.inverse': "_syaz15cr",
    'color.text.warning.inverse': "_syazal3n"
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c47bed69b7a147a63fdb8c394e98514a>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $a2617c47cbdc023d$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */ var $a2617c47cbdc023d$var$useColor = function useColor(colorProp) {
    var surface = (0, $2XkT3.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $6WZ4u.inverseColorMap).hasOwnProperty(surface)) return (0, $6WZ4u.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $a2617c47cbdc023d$var$Heading = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $7t0tI;
    var _useHeading = (0, $40jLo.useHeading)($a2617c47cbdc023d$var$sizeTagMap[size]), _useHeading2 = (0, $lE80C.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $a2617c47cbdc023d$var$useColor(colorProp);
    return /*#__PURE__*/ $1oC0p.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $gcw6K.default)([
            $a2617c47cbdc023d$var$styles.reset,
            size && $a2617c47cbdc023d$var$headingSizeStylesMap[size],
            $a2617c47cbdc023d$var$headingColorStylesMap[color]
        ])
    }, children);
});
var $a2617c47cbdc023d$export$2e2bcd8739ae039 = $a2617c47cbdc023d$var$Heading;

});
parcelRegister("6WZ4u", function(module, exports) {
$parcel$export(module.exports, "inverseColorMap", function () { return $50f7885f5fc4c4a2$export$2185ce37f9bdd963; });

var $55aK4 = parcelRequire("55aK4");

var $3dJ4i = parcelRequire("3dJ4i");

var $8rBh7 = parcelRequire("8rBh7");
function $50f7885f5fc4c4a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $50f7885f5fc4c4a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $50f7885f5fc4c4a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $55aK4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $50f7885f5fc4c4a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $50f7885f5fc4c4a2$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $50f7885f5fc4c4a2$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $50f7885f5fc4c4a2$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $50f7885f5fc4c4a2$export$632685d741f3dbbf = $50f7885f5fc4c4a2$var$_objectSpread($50f7885f5fc4c4a2$var$_objectSpread({}, $50f7885f5fc4c4a2$export$958d0ae7f2977ae4), $50f7885f5fc4c4a2$export$d2dc61f58390201c);
var $50f7885f5fc4c4a2$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $50f7885f5fc4c4a2$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $50f7885f5fc4c4a2$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $50f7885f5fc4c4a2$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $50f7885f5fc4c4a2$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $50f7885f5fc4c4a2$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $50f7885f5fc4c4a2$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $50f7885f5fc4c4a2$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $50f7885f5fc4c4a2$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $50f7885f5fc4c4a2$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $50f7885f5fc4c4a2$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $50f7885f5fc4c4a2$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $50f7885f5fc4c4a2$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $50f7885f5fc4c4a2$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $50f7885f5fc4c4a2$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $50f7885f5fc4c4a2$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $50f7885f5fc4c4a2$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $50f7885f5fc4c4a2$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3dJ4i.css)((0, $55aK4.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $50f7885f5fc4c4a2$export$e615f061ca585a6c = $50f7885f5fc4c4a2$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $50f7885f5fc4c4a2$export$ca0f9c2de39ffed7(spacingProperty, $50f7885f5fc4c4a2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $50f7885f5fc4c4a2$export$bf46c3f9eeafc71f = $50f7885f5fc4c4a2$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $50f7885f5fc4c4a2$export$ca0f9c2de39ffed7(spacingProperty, $50f7885f5fc4c4a2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $50f7885f5fc4c4a2$export$e7af83bafe7f9e63 = $50f7885f5fc4c4a2$export$ca0f9c2de39ffed7('backgroundColor', $50f7885f5fc4c4a2$export$d1d79bf68ac056bd);
var $50f7885f5fc4c4a2$export$3a1bcba60b23d7f0 = $50f7885f5fc4c4a2$export$ca0f9c2de39ffed7('color', $50f7885f5fc4c4a2$export$8473307aa00d6ea1);
var $50f7885f5fc4c4a2$export$45f3f4fe16f9f7d5 = $50f7885f5fc4c4a2$export$ca0f9c2de39ffed7('fontWeight', $50f7885f5fc4c4a2$export$303e322c6b1ed114);
var $50f7885f5fc4c4a2$export$68cc305da27dbaa4 = $50f7885f5fc4c4a2$export$ca0f9c2de39ffed7('fontFamily', $50f7885f5fc4c4a2$export$3c7e9587132614b4);
var $50f7885f5fc4c4a2$export$128f10c238242f83 = $50f7885f5fc4c4a2$export$ca0f9c2de39ffed7('font', $50f7885f5fc4c4a2$export$6ffa317d5e70375);
var $50f7885f5fc4c4a2$export$219d364c0da35ae4 = $50f7885f5fc4c4a2$export$ca0f9c2de39ffed7('font', $50f7885f5fc4c4a2$export$236bfe3a33ef1292);
var $50f7885f5fc4c4a2$export$38845ca010b93505 = $50f7885f5fc4c4a2$export$ca0f9c2de39ffed7('fontWeight', $50f7885f5fc4c4a2$export$855cfd311192d666);
var $50f7885f5fc4c4a2$export$ff257d957d48c421 = $50f7885f5fc4c4a2$export$ca0f9c2de39ffed7((0, $8rBh7.CURRENT_SURFACE_CSS_VAR), $50f7885f5fc4c4a2$export$41a358c9c2356760);
var $50f7885f5fc4c4a2$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $50f7885f5fc4c4a2$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("8rBh7", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $625dc263cef39f4c$export$9d7b58831ae93caa; });
var $625dc263cef39f4c$export$4ef52930e33717cd = 'data-theme';
var $625dc263cef39f4c$export$a00eac3f8684bcd0 = 'data-color-mode';
var $625dc263cef39f4c$export$2112803007239c61 = 'data-contrast-mode';
var $625dc263cef39f4c$export$352e418ed5b6193a = 'data-custom-theme';
var $625dc263cef39f4c$export$6f0c6fb8c80fcc92 = 'ds';
var $625dc263cef39f4c$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $625dc263cef39f4c$export$dddac1532e822863 = "--".concat($625dc263cef39f4c$export$6f0c6fb8c80fcc92, "-token-not-found");
var $625dc263cef39f4c$export$9d7b58831ae93caa = "--".concat($625dc263cef39f4c$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("2XkT3", function(module, exports) {
$parcel$export(module.exports, "useSurface", function () { return $22714b2bca8f2b42$export$1aeb4f6b93c4540d; });

var $1oC0p = parcelRequire("1oC0p");
var $22714b2bca8f2b42$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $22714b2bca8f2b42$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($22714b2bca8f2b42$export$1ca2a26fecb070ae);
};
$22714b2bca8f2b42$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("40jLo", function(module, exports) {
$parcel$export(module.exports, "useHeading", function () { return $2ea67e172775c375$export$97a37b1befbbf9b1; });

var $1oC0p = parcelRequire("1oC0p");
// Allows support for heading levels 1-9 via aria-level
var $2ea67e172775c375$var$HeadingLevelContext = /*#__PURE__*/ (0, $1oC0p.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ var $2ea67e172775c375$var$useHeadingLevel = function useHeadingLevel() {
    return (0, $1oC0p.useContext)($2ea67e172775c375$var$HeadingLevelContext);
};
var $2ea67e172775c375$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $2ea67e172775c375$var$useHeadingLevel();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $2ea67e172775c375$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $2ea67e172775c375$var$useHeadingLevel();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($2ea67e172775c375$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $2ea67e172775c375$export$2e2bcd8739ae039 = $2ea67e172775c375$var$HeadingLevelContextProvider;

});


parcelRegister("euC3u", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a8d16308bd544716$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8qa5V = parcelRequire("8qa5V");

var $8msnN = parcelRequire("8msnN");

var $1oC0p = parcelRequire("1oC0p");

var $gcw6K = parcelRequire("gcw6K");

var $dacHF = parcelRequire("dacHF");
var $a8d16308bd544716$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $a8d16308bd544716$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $a8d16308bd544716$var$baseStyles = null;
var $a8d16308bd544716$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhk1fno",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1eds",
    'color.background.accent.lime.subtler.pressed': "_bfhk1hgz",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhkhgj8",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhk1b17",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhk1pbw",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkrw5d",
    'color.background.accent.red.subtler.pressed': "_bfhk69rw",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1tf4",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhkprmn",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtlest.hovered': "_bfhkg4tm",
    'color.background.accent.orange.subtlest.pressed': "_bfhk1ya0",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtler.hovered': "_bfhk1lml",
    'color.background.accent.orange.subtler.pressed': "_bfhkuxsx",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.subtle.hovered': "_bfhk1oew",
    'color.background.accent.orange.subtle.pressed': "_bfhk1phk",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.orange.bolder.hovered': "_bfhkhi52",
    'color.background.accent.orange.bolder.pressed': "_bfhkf767",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtlest.hovered': "_bfhk19g9",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk31d1",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtler.hovered': "_bfhklg04",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1d44",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.subtle.hovered': "_bfhk17e6",
    'color.background.accent.yellow.subtle.pressed': "_bfhko0y5",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk32kj",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkv5yf",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhkung8",
    'color.background.accent.green.subtler.pressed': "_bfhk1p19",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk8h4p",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1azz",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1j2h",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkg5py",
    'color.background.accent.teal.subtler.pressed': "_bfhkq7li",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk10ai",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhkse6l",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtlest.hovered': "_bfhkay3p",
    'color.background.accent.blue.subtlest.pressed': "_bfhk1xmr",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtler.hovered': "_bfhk16e6",
    'color.background.accent.blue.subtler.pressed': "_bfhk1uh7",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.subtle.hovered': "_bfhk1f4s",
    'color.background.accent.blue.subtle.pressed': "_bfhkqctv",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.blue.bolder.hovered': "_bfhk1cwi",
    'color.background.accent.blue.bolder.pressed': "_bfhkhcrq",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtlest.hovered': "_bfhkm0d5",
    'color.background.accent.purple.subtlest.pressed': "_bfhkgslw",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtler.hovered': "_bfhk1wyu",
    'color.background.accent.purple.subtler.pressed': "_bfhk5fkp",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.subtle.hovered': "_bfhk1wob",
    'color.background.accent.purple.subtle.pressed': "_bfhkwz05",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.purple.bolder.hovered': "_bfhkadgs",
    'color.background.accent.purple.bolder.pressed': "_bfhk1uro",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1een",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1r0p",
    'color.background.accent.magenta.subtler.pressed': "_bfhkxuzc",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk1ovh",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkwaw3",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtlest.hovered': "_bfhk12j4",
    'color.background.accent.gray.subtlest.pressed': "_bfhk1lb4",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtler.hovered': "_bfhk1f7l",
    'color.background.accent.gray.subtler.pressed': "_bfhkd8a2",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.subtle.hovered': "_bfhk1a2l",
    'color.background.accent.gray.subtle.pressed': "_bfhk1z0s",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.accent.gray.bolder.hovered': "_bfhke4nv",
    'color.background.accent.gray.bolder.pressed': "_bfhk82ra",
    'color.background.disabled': "_bfhksyzs",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhk1d5g",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.hovered': "_bfhk15ej",
    'color.background.neutral.pressed': "_bfhkip91",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk166n",
    'color.background.neutral.subtle.pressed': "_bfhk1dty",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.neutral.bold.hovered': "_bfhk1bsc",
    'color.background.neutral.bold.pressed': "_bfhk1b6k",
    'color.background.selected': "_bfhkfg4m",
    'color.background.selected.hovered': "_bfhki1yw",
    'color.background.selected.pressed': "_bfhk19ru",
    'color.background.selected.bold': "_bfhk1fvw",
    'color.background.selected.bold.hovered': "_bfhk18hz",
    'color.background.selected.bold.pressed': "_bfhkgr1v",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.subtlest.hovered': "_bfhkezq1",
    'color.background.brand.subtlest.pressed': "_bfhk2ggb",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.bold.hovered': "_bfhku1se",
    'color.background.brand.bold.pressed': "_bfhkqkzo",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.brand.boldest.hovered': "_bfhk1uwk",
    'color.background.brand.boldest.pressed': "_bfhk17jr",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1io2",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk9pqq",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.hovered': "_bfhk1rd4",
    'color.background.warning.pressed': "_bfhk11dh",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.warning.bold.hovered': "_bfhk1i4c",
    'color.background.warning.bold.pressed': "_bfhkrj9s",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.hovered': "_bfhk1jgi",
    'color.background.success.pressed': "_bfhky4f1",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.success.bold.hovered': "_bfhk1q4l",
    'color.background.success.bold.pressed': "_bfhkcrcn",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.hovered': "_bfhk1xp7",
    'color.background.discovery.pressed': "_bfhkdlkp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.discovery.bold.hovered': "_bfhk1w72",
    'color.background.discovery.bold.pressed': "_bfhkrb53",
    'color.background.information': "_bfhk33gi",
    'color.background.information.hovered': "_bfhk1vps",
    'color.background.information.pressed': "_bfhk1s0z",
    'color.background.information.bold': "_bfhk14wj",
    'color.background.information.bold.hovered': "_bfhk1amz",
    'color.background.information.bold.pressed': "_bfhk5bth",
    'color.blanket': "_bfhk10xm",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkn82g",
    'color.skeleton.subtle': "_bfhkh3tw",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk108i",
    'elevation.surface.pressed': "_bfhk1ji5",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk16qz",
    'elevation.surface.overlay.pressed': "_bfhkvq0a",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk1a0f",
    'elevation.surface.raised.pressed': "_bfhkf7u5",
    'elevation.surface.sunken': "_bfhkqbzx",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $a8d16308bd544716$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $a8d16308bd544716$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l108i",
    'elevation.surface.pressed': "_1q1l1ji5",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l16qz",
    'elevation.surface.overlay.pressed': "_1q1lvq0a",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l1a0f",
    'elevation.surface.raised.pressed': "_1q1lf7u5",
    'elevation.surface.sunken': "_1q1lqbzx"
};
var $a8d16308bd544716$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $a8d16308bd544716$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $a8d16308bd544716$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $a8d16308bd544716$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $a8d16308bd544716$var$Box = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $8msnN.default)(_ref, $a8d16308bd544716$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $8msnN.default)(htmlAttributes, $a8d16308bd544716$var$_excluded2);
    var node = /*#__PURE__*/ $1oC0p.createElement(Component, (0, $8qa5V.default)({
        style: style,
        ref: ref,
        className: (0, $gcw6K.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $a8d16308bd544716$var$backgroundColorMap[backgroundColor],
            backgroundColor && $a8d16308bd544716$var$isSurfaceToken(backgroundColor) && $a8d16308bd544716$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $a8d16308bd544716$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $a8d16308bd544716$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $a8d16308bd544716$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $a8d16308bd544716$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $1oC0p.createElement((0, $dacHF.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $a8d16308bd544716$export$2e2bcd8739ae039 = $a8d16308bd544716$var$Box;
function $a8d16308bd544716$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $a8d16308bd544716$var$setSurfaceTokenMap;
}

});
parcelRegister("8msnN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6166650520ba4e09$export$2e2bcd8739ae039; });

var $CQPft = parcelRequire("CQPft");
function $6166650520ba4e09$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $CQPft.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("CQPft", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $074c86c9479b8225$export$2e2bcd8739ae039; });
function $074c86c9479b8225$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("dacHF", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $9956102293a36fbb$export$1ca2a26fecb070ae; });

var $1oC0p = parcelRequire("1oC0p");
var $9956102293a36fbb$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $9956102293a36fbb$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($9956102293a36fbb$export$1ca2a26fecb070ae);
};
$9956102293a36fbb$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("8sG9Y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6291a44d4eb59e00$export$2e2bcd8739ae039; });
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $gcw6K = parcelRequire("gcw6K");

var $3lMbX = parcelRequire("3lMbX");

var $3Eead = parcelRequire("3Eead");
var $6291a44d4eb59e00$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $6291a44d4eb59e00$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $gcw6K.default)([
            $6291a44d4eb59e00$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $6291a44d4eb59e00$var$Inline = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $1oC0p.createElement($6291a44d4eb59e00$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $1oC0p.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $1oC0p.createElement((0, $3Eead.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $3lMbX.cx)(grow === 'hug' && $6291a44d4eb59e00$var$styles.hug, grow === 'fill' && $6291a44d4eb59e00$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$6291a44d4eb59e00$var$Inline.displayName = 'Inline';
var $6291a44d4eb59e00$export$2e2bcd8739ae039 = $6291a44d4eb59e00$var$Inline;

});
parcelRegister("3lMbX", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $2708b7277995ea90$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("1oC0p");


var $2Y5FP = parcelRequire("2Y5FP");
var $2708b7277995ea90$var$_createStrictAPI = (0, $2Y5FP.createStrictAPI)(), $2708b7277995ea90$var$XCSSProp = $2708b7277995ea90$var$_createStrictAPI.XCSSProp, $2708b7277995ea90$export$dbf350e5966cf602 = $2708b7277995ea90$var$_createStrictAPI.css, $2708b7277995ea90$export$eb1ecd84a24ee424 = $2708b7277995ea90$var$_createStrictAPI.cssMap, $2708b7277995ea90$export$a274e22fb40f762e = $2708b7277995ea90$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("2Y5FP", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", function () { return $22959609101a28c6$export$39716b4af53f4ad; });

var $9phrZ = parcelRequire("9phrZ");

var $cDEzj = parcelRequire("cDEzj");
function $22959609101a28c6$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $9phrZ.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $9phrZ.createStrictSetupError)();
        },
        cx: $cDEzj.cx,
        XCSSProp () {
            throw (0, $9phrZ.createStrictSetupError)();
        }
    };
}

});
parcelRegister("9phrZ", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", function () { return $6d93fc21813c7fa1$export$c4df1cb0c2b4d77c; });
const $6d93fc21813c7fa1$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $6d93fc21813c7fa1$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("cDEzj", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $933898a059bee6ce$export$a274e22fb40f762e; });

var $gcw6K = parcelRequire("gcw6K");
const $933898a059bee6ce$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $gcw6K.default)(actualStyles);
};

});



parcelRegister("3Eead", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2a801821213449ff$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $gcw6K = parcelRequire("gcw6K");
var $2a801821213449ff$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $2a801821213449ff$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $2a801821213449ff$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $2a801821213449ff$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $2a801821213449ff$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $2a801821213449ff$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $2a801821213449ff$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $2a801821213449ff$var$Flex = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    return /*#__PURE__*/ $1oC0p.createElement(Component, {
        role: role,
        className: (0, $gcw6K.default)([
            $2a801821213449ff$var$styles.root,
            gap && $2a801821213449ff$var$columnGapMap[gap],
            columnGap && $2a801821213449ff$var$columnGapMap[columnGap],
            gap && $2a801821213449ff$var$rowGapMap[gap],
            rowGap && $2a801821213449ff$var$rowGapMap[rowGap],
            alignItems && $2a801821213449ff$var$alignItemsMap[alignItems],
            direction && $2a801821213449ff$var$flexDirectionMap[direction],
            justifyContent && $2a801821213449ff$var$justifyContentMap[justifyContent],
            wrap && $2a801821213449ff$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$2a801821213449ff$var$Flex.displayName = 'Flex';
var $2a801821213449ff$export$2e2bcd8739ae039 = $2a801821213449ff$var$Flex;

});


parcelRegister("8GeHv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $651da63e6ad6b909$export$2e2bcd8739ae039; });
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");


var $3lMbX = parcelRequire("3lMbX");

var $3Eead = parcelRequire("3Eead");
var $651da63e6ad6b909$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $651da63e6ad6b909$var$Stack = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    return /*#__PURE__*/ $1oC0p.createElement((0, $3Eead.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $3lMbX.cx)(grow === 'hug' && $651da63e6ad6b909$var$styles.hug, grow === 'fill' && $651da63e6ad6b909$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$651da63e6ad6b909$var$Stack.displayName = 'Stack';
var $651da63e6ad6b909$export$2e2bcd8739ae039 = $651da63e6ad6b909$var$Stack;

});

parcelRegister("8BFJ8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $644225878028a315$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $1oC0p = parcelRequire("1oC0p");

var $hUeax = parcelRequire("hUeax");
var $644225878028a315$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $644225878028a315$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $hUeax.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $644225878028a315$export$2e2bcd8739ae039 = $644225878028a315$var$VisuallyHidden;

});
parcelRegister("hUeax", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d092a85031cbbb81$export$2e2bcd8739ae039; });
const $d092a85031cbbb81$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $d092a85031cbbb81$var$ATOMIC_GROUP_LENGTH = 5;
function $d092a85031cbbb81$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $d092a85031cbbb81$var$UNDERSCORE_UNICODE ? $d092a85031cbbb81$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});


parcelRegister("1xcHY", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_APPEARANCE", function () { return $11e2bb1a9759953f$export$d6830277b06edd6; });
var $11e2bb1a9759953f$export$d6830277b06edd6 = 'normal';

});

parcelRegister("lF69S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fc52343ec982c384$export$2e2bcd8739ae039; });
/* flag-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $55aK4 = parcelRequire("55aK4");

var $1oC0p = parcelRequire("1oC0p");

var $gcw6K = parcelRequire("gcw6K");
var $i0UnX = parcelRequire("i0UnX");

var $2JDLV = parcelRequire("2JDLV");

var $39c3M = parcelRequire("39c3M");

var $8sG9Y = parcelRequire("8sG9Y");

var $1xcHY = parcelRequire("1xcHY");

var $8j7J7 = parcelRequire("8j7J7");
function $fc52343ec982c384$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fc52343ec982c384$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fc52343ec982c384$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $55aK4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fc52343ec982c384$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fc52343ec982c384$var$buttonStyles = null;
var $fc52343ec982c384$var$fontStyles = null;
var $fc52343ec982c384$var$appearanceNormalButtonStyles = null;
var $fc52343ec982c384$var$appearanceNormalActionsContainerStyles = null;
var $fc52343ec982c384$var$FlagActions = function FlagActions(props) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $1xcHY.DEFAULT_APPEARANCE) : _props$appearance, _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, linkComponent = props.linkComponent, testId = props.testId;
    if (!actions.length) return null;
    var isBold = appearance !== (0, $1xcHY.DEFAULT_APPEARANCE);
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $gcw6K.default)([
            !isBold && "_1g4l107e _y8dn107e",
            (0, $39c3M.fg)('platform_ads_explicit_font_styles') && "_11c82smr"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $8sG9Y.default), {
        space: "space.100",
        shouldWrap: true,
        alignBlock: "center",
        separator: isBold ? undefined : "\xb7",
        testId: testId && "".concat(testId, "-actions")
    }, actions.map(function(action, index) {
        return /*#__PURE__*/ $1oC0p.createElement((0, $2JDLV.default), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? 'default' : 'link',
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            className: (0, $gcw6K.default)([
                "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk69tn6 _1wy69tn6 _b3g39tn6 _eqps9tn6 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                appearance === (0, $1xcHY.DEFAULT_APPEARANCE) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
            ]),
            style: $fc52343ec982c384$var$_objectSpread($fc52343ec982c384$var$_objectSpread({}, {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                '--color': (0, $8j7J7.actionTextColor)[appearance],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color': (0, $8j7J7.actionBackgroundColor)[appearance].default,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-hover': (0, $8j7J7.actionBackgroundColor)[appearance].pressed,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-active': (0, $8j7J7.actionBackgroundColor)[appearance].active
            }), {}, {
                "--_zkfc5e": (0, $i0UnX.default)("var(--ds-space-100, 8px)".concat(" !important"))
            })
        }, action.content);
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fc52343ec982c384$export$2e2bcd8739ae039 = $fc52343ec982c384$var$FlagActions;

});
parcelRegister("2JDLV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1fdea2a3753bf577$export$2e2bcd8739ae039; });

var $8qa5V = parcelRequire("8qa5V");

var $lE80C = parcelRequire("lE80C");

var $55aK4 = parcelRequire("55aK4");

var $8msnN = parcelRequire("8msnN");

var $1oC0p = parcelRequire("1oC0p");

var $hU1Rh = parcelRequire("hU1Rh");

var $4HhXY = parcelRequire("4HhXY");

var $joh3u = parcelRequire("joh3u");

var $jRB77 = parcelRequire("jRB77");

var $cbUsf = parcelRequire("cbUsf");
var $1fdea2a3753bf577$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $1fdea2a3753bf577$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1fdea2a3753bf577$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1fdea2a3753bf577$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $55aK4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1fdea2a3753bf577$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1fdea2a3753bf577$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
var $1fdea2a3753bf577$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $1fdea2a3753bf577$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $cbUsf.defaultThemeFn) : _ref2$theme, rest = (0, $8msnN.default)(_ref2, $1fdea2a3753bf577$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $1fdea2a3753bf577$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $1oC0p.useState)($1fdea2a3753bf577$var$initial), _useState2 = (0, $lE80C.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $1oC0p.useCallback)(function(event) {
        setState(function(current) {
            return $1fdea2a3753bf577$var$_objectSpread($1fdea2a3753bf577$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $1oC0p.useCallback)(function(event) {
        setState(function(current) {
            return $1fdea2a3753bf577$var$_objectSpread($1fdea2a3753bf577$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $1oC0p.useCallback)(function(event) {
        setState(function(current) {
            return $1fdea2a3753bf577$var$_objectSpread($1fdea2a3753bf577$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $1oC0p.useCallback)(function(event) {
        setState(function(current) {
            return $1fdea2a3753bf577$var$_objectSpread($1fdea2a3753bf577$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $1oC0p.useCallback)(function(event) {
        setState(function(current) {
            return $1fdea2a3753bf577$var$_objectSpread($1fdea2a3753bf577$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $1oC0p.useCallback)(function(event) {
        setState(function(current) {
            return $1fdea2a3753bf577$var$_objectSpread($1fdea2a3753bf577$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cbUsf.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $hU1Rh.default).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cbUsf.default).Consumer, (0, $8qa5V.default)({
            mode: mode,
            state: $1fdea2a3753bf577$var$getInteractionState($1fdea2a3753bf577$var$_objectSpread($1fdea2a3753bf577$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $joh3u.default)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4HhXY.default), (0, $8qa5V.default)({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jRB77.default), restProps) : null,
                "aria-disabled": isLoading || restProps['aria-disabled'],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $cbUsf.getSpecifiers)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$1fdea2a3753bf577$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $1fdea2a3753bf577$export$2e2bcd8739ae039 = $1fdea2a3753bf577$var$CustomThemeButton;

});
parcelRegister("hU1Rh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d0891babadb9e6bf$export$2e2bcd8739ae039; });

var $dwXUF = parcelRequire("dwXUF");
// Create default global light theme
var $d0891babadb9e6bf$var$_createTheme = (0, $dwXUF.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $d0891babadb9e6bf$var$Provider = $d0891babadb9e6bf$var$_createTheme.Provider, $d0891babadb9e6bf$var$Consumer = $d0891babadb9e6bf$var$_createTheme.Consumer, $d0891babadb9e6bf$export$7692396083754928 = $d0891babadb9e6bf$var$_createTheme.useTheme;
var $d0891babadb9e6bf$var$Theme = {
    Provider: $d0891babadb9e6bf$var$Provider,
    Consumer: $d0891babadb9e6bf$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d0891babadb9e6bf$export$2e2bcd8739ae039 = $d0891babadb9e6bf$var$Theme;

});
parcelRegister("dwXUF", function(module, exports) {
$parcel$export(module.exports, "createTheme", function () { return $9d9cbcffd328a7b0$export$25d302a5b900a763; });

var $8msnN = parcelRequire("8msnN");

var $1oC0p = parcelRequire("1oC0p");
var $9d9cbcffd328a7b0$var$_excluded = [
    "children"
];
function $9d9cbcffd328a7b0$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1oC0p.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $8msnN.default)(props, $9d9cbcffd328a7b0$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1oC0p.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1oC0p.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("4HhXY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $36b91d53c85ce91e$export$2e2bcd8739ae039; });

var $8qa5V = parcelRequire("8qa5V");

var $8msnN = parcelRequire("8msnN");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $auA6I = parcelRequire("auA6I");

var $7uNuF = parcelRequire("7uNuF");

var $gyCsW = parcelRequire("gyCsW");

var $cH8hr = parcelRequire("cH8hr");

var $etBkE = parcelRequire("etBkE");

var $lCRJc = parcelRequire("lCRJc");

var $6xNm4 = parcelRequire("6xNm4");

var $lF1vB = parcelRequire("lF1vB");

var $bB8MC = parcelRequire("bB8MC");
var $36b91d53c85ce91e$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $36b91d53c85ce91e$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $36b91d53c85ce91e$var$iconBeforeSpacingFixStyle = (0, $3dJ4i.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $36b91d53c85ce91e$var$iconAfterSpacingFixStyle = (0, $3dJ4i.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $36b91d53c85ce91e$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $bB8MC.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $36b91d53c85ce91e$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $bB8MC.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $3dJ4i.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $36b91d53c85ce91e$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $7uNuF.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $7uNuF.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, $8msnN.default)(props, $36b91d53c85ce91e$var$_excluded);
    var ourRef = (0, $1oC0p.useRef)();
    var setRef = (0, $1oC0p.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $gyCsW.default)(ourRef, autoFocus);
    var interactionContext = (0, $1oC0p.useContext)((0, $etBkE.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $auA6I.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "23.2.0",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $1oC0p.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $1oC0p.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $3dJ4i.css)((0, $lF1vB.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $lCRJc.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $lCRJc.N500), ")"), " !important")
        }
    };
    return (0, $3dJ4i.jsx)((0, $cH8hr.default), null, (0, $3dJ4i.jsx)(Component, (0, $8qa5V.default)({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $36b91d53c85ce91e$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $6xNm4.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $3dJ4i.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $lF1vB.getIconStyle)({
                spacing: spacing
            }),
            $36b91d53c85ce91e$var$getSpacingFix(children, $36b91d53c85ce91e$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $36b91d53c85ce91e$var$getChildren(children, [
        fadeStyles,
        (0, $lF1vB.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $3dJ4i.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $lF1vB.getIconStyle)({
                spacing: spacing
            }),
            $36b91d53c85ce91e$var$getSpacingFix(children, $36b91d53c85ce91e$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $3dJ4i.jsx)("span", {
        css: [
            (0, $lF1vB.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$36b91d53c85ce91e$export$2e2bcd8739ae039 = $36b91d53c85ce91e$var$ButtonBase;

});
parcelRegister("auA6I", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $7a38b6e307d7e72d$export$a4687b0234b40e28; });

var $55aK4 = parcelRequire("55aK4");

var $1oC0p = parcelRequire("1oC0p");

var $4BrqX = parcelRequire("4BrqX");

var $1ck9I = parcelRequire("1ck9I");
function $7a38b6e307d7e72d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7a38b6e307d7e72d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7a38b6e307d7e72d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $55aK4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7a38b6e307d7e72d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7a38b6e307d7e72d$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $4BrqX.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $1ck9I.useTrackedRef)(analyticsData);
    var fnRef = (0, $1ck9I.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $7a38b6e307d7e72d$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("4BrqX", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $359fe5e589bb4d84$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $c0Yua = parcelRequire("c0Yua");

var $452u1 = parcelRequire("452u1");
function $359fe5e589bb4d84$export$5bf35293e545f20c() {
    var analyticsContext = (0, $452u1.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $c0Yua.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("c0Yua", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8bf4674992f7eeb1$export$2e2bcd8739ae039; });

var $igZS8 = parcelRequire("igZS8");

var $iSNHz = parcelRequire("iSNHz");

var $5dqKq = parcelRequire("5dqKq");

var $6gbuF = parcelRequire("6gbuF");

var $dTP4E = parcelRequire("dTP4E");

var $1lgIL = parcelRequire("1lgIL");

var $lU9Ag = parcelRequire("lU9Ag");

var $55aK4 = parcelRequire("55aK4");

var $i7tOc = parcelRequire("i7tOc");
function $8bf4674992f7eeb1$var$_callSuper(t, o, e) {
    return o = (0, $dTP4E.default)(o), (0, $6gbuF.default)(t, $8bf4674992f7eeb1$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $dTP4E.default)(t).constructor) : o.apply(t, e));
}
function $8bf4674992f7eeb1$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8bf4674992f7eeb1$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $8bf4674992f7eeb1$var$_superPropGet(t, o, e, r) {
    var p = (0, $1lgIL.default)((0, $dTP4E.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $8bf4674992f7eeb1$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $8bf4674992f7eeb1$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $8bf4674992f7eeb1$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $iSNHz.default)(this, UIAnalyticsEvent);
        _this = $8bf4674992f7eeb1$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $55aK4.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $55aK4.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $igZS8.default)(_this.context);
            var handlers = (0, $igZS8.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $55aK4.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $lU9Ag.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $5dqKq.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $8bf4674992f7eeb1$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $i7tOc.default));

});
parcelRegister("i7tOc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d31000cdc989af33$export$2e2bcd8739ae039; });

var $7R6fn = parcelRequire("7R6fn");

var $iSNHz = parcelRequire("iSNHz");

var $5dqKq = parcelRequire("5dqKq");

var $55aK4 = parcelRequire("55aK4");
function $d31000cdc989af33$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d31000cdc989af33$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d31000cdc989af33$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $55aK4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d31000cdc989af33$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d31000cdc989af33$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $d31000cdc989af33$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $d31000cdc989af33$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $iSNHz.default)(this, AnalyticsEvent);
        (0, $55aK4.default)(this, "_isAnalyticsEvent", true);
        (0, $55aK4.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $d31000cdc989af33$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $5dqKq.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $7R6fn.default)(updater) === 'object') this.payload = $d31000cdc989af33$var$_objectSpread($d31000cdc989af33$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("452u1", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $2f898e2a3c01d0aa$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $2f898e2a3c01d0aa$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("1ck9I", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $0df68beda4e24b9f$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $0df68beda4e24b9f$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("lCRJc", function(module, exports) {
$parcel$export(module.exports, "R300", function () { return $fbe6d2d5e6a862c1$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $fbe6d2d5e6a862c1$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $fbe6d2d5e6a862c1$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y200", function () { return $fbe6d2d5e6a862c1$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $fbe6d2d5e6a862c1$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $fbe6d2d5e6a862c1$export$59619663aa6500fb; });
$parcel$export(module.exports, "B50", function () { return $fbe6d2d5e6a862c1$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $fbe6d2d5e6a862c1$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $fbe6d2d5e6a862c1$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $fbe6d2d5e6a862c1$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $fbe6d2d5e6a862c1$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $fbe6d2d5e6a862c1$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $fbe6d2d5e6a862c1$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N0", function () { return $fbe6d2d5e6a862c1$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $fbe6d2d5e6a862c1$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N70", function () { return $fbe6d2d5e6a862c1$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $fbe6d2d5e6a862c1$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $fbe6d2d5e6a862c1$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $fbe6d2d5e6a862c1$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $fbe6d2d5e6a862c1$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $fbe6d2d5e6a862c1$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $fbe6d2d5e6a862c1$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $fbe6d2d5e6a862c1$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $fbe6d2d5e6a862c1$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $fbe6d2d5e6a862c1$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $fbe6d2d5e6a862c1$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $fbe6d2d5e6a862c1$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $fbe6d2d5e6a862c1$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $fbe6d2d5e6a862c1$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $fbe6d2d5e6a862c1$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $fbe6d2d5e6a862c1$export$3d4f271a500072a; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $fbe6d2d5e6a862c1$export$4b84fd0e2c617bd = '#FFEBE6';
var $fbe6d2d5e6a862c1$export$b34b069eff244586 = '#FFBDAD';
var $fbe6d2d5e6a862c1$export$be802dd0d8b57f35 = '#FF8F73';
var $fbe6d2d5e6a862c1$export$60847d42f9da92a6 = '#FF7452';
var $fbe6d2d5e6a862c1$export$4a7404f376229999 = '#FF5630';
var $fbe6d2d5e6a862c1$export$2010d0fb4295b346 = '#DE350B';
var $fbe6d2d5e6a862c1$export$2837b5a1a71d5c02 = '#BF2600';
var $fbe6d2d5e6a862c1$export$8d9596b529bbb9cf = '#FFFAE6';
var $fbe6d2d5e6a862c1$export$41060a744ab0b7ae = '#FFF0B3';
var $fbe6d2d5e6a862c1$export$1cc05bbbf340e559 = '#FFE380';
var $fbe6d2d5e6a862c1$export$5aae31392d72caaa = '#FFC400';
var $fbe6d2d5e6a862c1$export$c6930421db9fa514 = '#FFAB00';
var $fbe6d2d5e6a862c1$export$59619663aa6500fb = '#FF991F';
var $fbe6d2d5e6a862c1$export$874739ea9e379ab6 = '#FF8B00';
var $fbe6d2d5e6a862c1$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $fbe6d2d5e6a862c1$export$69a3bf21b9686c2b = '#ABF5D1';
var $fbe6d2d5e6a862c1$export$afbce1382ec95f73 = '#79F2C0';
var $fbe6d2d5e6a862c1$export$747d86715d4175de = '#57D9A3';
var $fbe6d2d5e6a862c1$export$940e1f69e873f202 = '#36B37E';
var $fbe6d2d5e6a862c1$export$a49394138f7b8e85 = '#00875A';
var $fbe6d2d5e6a862c1$export$6fa04827ac68a4fb = '#006644';
var $fbe6d2d5e6a862c1$export$226de0355ed012f8 = '#DEEBFF';
var $fbe6d2d5e6a862c1$export$8c13c2ee36917869 = '#B3D4FF';
var $fbe6d2d5e6a862c1$export$ecfc1dff386a3e7a = '#4C9AFF';
var $fbe6d2d5e6a862c1$export$215b7063051591f1 = '#2684FF';
var $fbe6d2d5e6a862c1$export$e62e8919cca44969 = '#0065FF';
var $fbe6d2d5e6a862c1$export$b3de0ae08da2ce64 = '#0052CC';
var $fbe6d2d5e6a862c1$export$a6ee3d71bc067634 = '#0747A6';
var $fbe6d2d5e6a862c1$export$67f15409e87642a1 = '#669DF1';
var $fbe6d2d5e6a862c1$export$f0539dbc42dbb067 = '#8FB8F6';
var $fbe6d2d5e6a862c1$export$363e4475840015bb = '#EAE6FF';
var $fbe6d2d5e6a862c1$export$4b0a4417ed59760f = '#C0B6F2';
var $fbe6d2d5e6a862c1$export$6011520a64d9a187 = '#998DD9';
var $fbe6d2d5e6a862c1$export$a7175d4e9206bc80 = '#8777D9';
var $fbe6d2d5e6a862c1$export$b48405b95304b5a1 = '#6554C0';
var $fbe6d2d5e6a862c1$export$c71e4279dd54a18d = '#5243AA';
var $fbe6d2d5e6a862c1$export$147899de772240ec = '#403294';
var $fbe6d2d5e6a862c1$export$2cf711fe14c66f06 = '#E6FCFF';
var $fbe6d2d5e6a862c1$export$7a8f4d33f6f9772c = '#B3F5FF';
var $fbe6d2d5e6a862c1$export$776c9c497ef08533 = '#79E2F2';
var $fbe6d2d5e6a862c1$export$69cb3ca10c1e330e = '#00C7E6';
var $fbe6d2d5e6a862c1$export$9dc1ef0f3f48059b = '#00B8D9';
var $fbe6d2d5e6a862c1$export$7c835c78b6fcdef8 = '#00A3BF';
var $fbe6d2d5e6a862c1$export$6036577f95c3877e = '#008DA6';
var $fbe6d2d5e6a862c1$export$29a4f05edc054374 = '#FFFFFF';
var $fbe6d2d5e6a862c1$export$e655ef011c4aa1a2 = '#FAFBFC';
var $fbe6d2d5e6a862c1$export$9fdfb749e33cdf97 = '#F4F5F7';
var $fbe6d2d5e6a862c1$export$3e51e8f1440314ba = '#EBECF0';
var $fbe6d2d5e6a862c1$export$1ce2d1575d444ceb = '#DFE1E6';
var $fbe6d2d5e6a862c1$export$8754fc7e6d8b3000 = '#C1C7D0';
var $fbe6d2d5e6a862c1$export$c2e91cbeada39b8b = '#B3BAC5';
var $fbe6d2d5e6a862c1$export$5f71e19f3a7ad9de = '#A5ADBA';
var $fbe6d2d5e6a862c1$export$eaa8c8a70ac22806 = '#97A0AF';
var $fbe6d2d5e6a862c1$export$7c87d337fb91a97d = '#8993A4';
var $fbe6d2d5e6a862c1$export$d6447c357493214f = '#7A869A';
var $fbe6d2d5e6a862c1$export$f563ee71e9ee74cd = '#6B778C';
var $fbe6d2d5e6a862c1$export$e2ef2124cf4024b1 = '#5E6C84';
var $fbe6d2d5e6a862c1$export$eece5f492e429f08 = '#505F79';
var $fbe6d2d5e6a862c1$export$c39c0fe0f26207ae = '#42526E';
var $fbe6d2d5e6a862c1$export$7090862dc3038a9f = '#344563';
var $fbe6d2d5e6a862c1$export$ad0bacf983b7ddaa = '#253858';
var $fbe6d2d5e6a862c1$export$7d61b15e0da132af = '#172B4D';
var $fbe6d2d5e6a862c1$export$fbda843f0a27fe96 = '#091E42';
var $fbe6d2d5e6a862c1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $fbe6d2d5e6a862c1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $fbe6d2d5e6a862c1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $fbe6d2d5e6a862c1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $fbe6d2d5e6a862c1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $fbe6d2d5e6a862c1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $fbe6d2d5e6a862c1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $fbe6d2d5e6a862c1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $fbe6d2d5e6a862c1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $fbe6d2d5e6a862c1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $fbe6d2d5e6a862c1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $fbe6d2d5e6a862c1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $fbe6d2d5e6a862c1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $fbe6d2d5e6a862c1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $fbe6d2d5e6a862c1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $fbe6d2d5e6a862c1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $fbe6d2d5e6a862c1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $fbe6d2d5e6a862c1$export$2f6319cf7d736c2a = '#E6EDFA';
var $fbe6d2d5e6a862c1$export$95126bc8884d6634 = '#DCE5F5';
var $fbe6d2d5e6a862c1$export$8338d8c35d44ff1 = '#CED9EB';
var $fbe6d2d5e6a862c1$export$5368d76ae4fbbda7 = '#B8C7E0';
var $fbe6d2d5e6a862c1$export$9f0a771d16ec8d36 = '#ABBBD6';
var $fbe6d2d5e6a862c1$export$abcf8c38338b4aa5 = '#9FB0CC';
var $fbe6d2d5e6a862c1$export$97e81faa16a182c7 = '#8C9CB8';
var $fbe6d2d5e6a862c1$export$bfe21c59123ecf33 = '#7988A3';
var $fbe6d2d5e6a862c1$export$ee82aa2ea6a1558 = '#67758F';
var $fbe6d2d5e6a862c1$export$682927c6ed76be02 = '#56637A';
var $fbe6d2d5e6a862c1$export$91fd9994c5be9757 = '#455166';
var $fbe6d2d5e6a862c1$export$d281fbfe3cff2df6 = '#3B475C';
var $fbe6d2d5e6a862c1$export$3902c91d8b98a753 = '#313D52';
var $fbe6d2d5e6a862c1$export$8e8133c1ba5845b5 = '#283447';
var $fbe6d2d5e6a862c1$export$33ff357f6620b39 = '#202B3D';
var $fbe6d2d5e6a862c1$export$633847cf062b69e0 = '#1B2638';
var $fbe6d2d5e6a862c1$export$9776a6e503bdbf76 = '#121A29';
var $fbe6d2d5e6a862c1$export$6c813d5160dff5db = '#0E1624';
var $fbe6d2d5e6a862c1$export$3d4f271a500072a = '#0D1424';
var $fbe6d2d5e6a862c1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $fbe6d2d5e6a862c1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $fbe6d2d5e6a862c1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $fbe6d2d5e6a862c1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $fbe6d2d5e6a862c1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $fbe6d2d5e6a862c1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $fbe6d2d5e6a862c1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $fbe6d2d5e6a862c1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $fbe6d2d5e6a862c1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $fbe6d2d5e6a862c1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $fbe6d2d5e6a862c1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $fbe6d2d5e6a862c1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $fbe6d2d5e6a862c1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $fbe6d2d5e6a862c1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $fbe6d2d5e6a862c1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $fbe6d2d5e6a862c1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $fbe6d2d5e6a862c1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $fbe6d2d5e6a862c1$export$d2adc5dedf09fced = '#292A2E';
var $fbe6d2d5e6a862c1$export$f51762073d2bb381 = '#94C748';
var $fbe6d2d5e6a862c1$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("6xNm4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4c3c1c0716dfa528$export$2e2bcd8739ae039; });
function $4c3c1c0716dfa528$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $4c3c1c0716dfa528$var$tabKeyCode = 9;
function $4c3c1c0716dfa528$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $4c3c1c0716dfa528$var$tabKeyCode) return;
    $4c3c1c0716dfa528$var$abort(event);
}
var $4c3c1c0716dfa528$var$block = {
    onMouseDownCapture: $4c3c1c0716dfa528$var$abort,
    onMouseUpCapture: $4c3c1c0716dfa528$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $4c3c1c0716dfa528$var$onKey,
    onKeyUpCapture: $4c3c1c0716dfa528$var$onKey,
    onTouchStartCapture: $4c3c1c0716dfa528$var$abort,
    onTouchEndCapture: $4c3c1c0716dfa528$var$abort,
    onPointerDownCapture: $4c3c1c0716dfa528$var$abort,
    onPointerUpCapture: $4c3c1c0716dfa528$var$abort,
    onClickCapture: $4c3c1c0716dfa528$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $4c3c1c0716dfa528$var$abort
};
var $4c3c1c0716dfa528$var$doNotBlock = {};
function $4c3c1c0716dfa528$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $4c3c1c0716dfa528$var$doNotBlock : $4c3c1c0716dfa528$var$block;
}

});

parcelRegister("lF1vB", function(module, exports) {
$parcel$export(module.exports, "getCss", function () { return $fc4e98ed3be6420a$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $fc4e98ed3be6420a$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $fc4e98ed3be6420a$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $fc4e98ed3be6420a$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $fc4e98ed3be6420a$export$1a9fe1b84c876bb5; });

var $55aK4 = parcelRequire("55aK4");

var $3dJ4i = parcelRequire("3dJ4i");

var $39c3M = parcelRequire("39c3M");

var $gj5NR = parcelRequire("gj5NR");

var $9m4fw = parcelRequire("9m4fw");
function $fc4e98ed3be6420a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fc4e98ed3be6420a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fc4e98ed3be6420a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $55aK4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fc4e98ed3be6420a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fc4e98ed3be6420a$var$gridSize = (0, $gj5NR.gridSize)();
var $fc4e98ed3be6420a$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $fc4e98ed3be6420a$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $fc4e98ed3be6420a$var$lineHeights = {
    default: $fc4e98ed3be6420a$var$heights.default,
    compact: $fc4e98ed3be6420a$var$heights.compact,
    none: 'inherit'
};
var $fc4e98ed3be6420a$var$padding = {
    // 10px gutter
    default: "0 ".concat($fc4e98ed3be6420a$var$gridSize + $fc4e98ed3be6420a$var$gridSize / 4, "px"),
    compact: "0 ".concat($fc4e98ed3be6420a$var$gridSize + $fc4e98ed3be6420a$var$gridSize / 4, "px"),
    none: '0'
};
var $fc4e98ed3be6420a$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($fc4e98ed3be6420a$var$gridSize / 4, "px"),
    default: "0 ".concat($fc4e98ed3be6420a$var$gridSize / 4, "px"),
    none: '0'
};
var $fc4e98ed3be6420a$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $fc4e98ed3be6420a$var$innerMargin = {
    content: "0 ".concat($fc4e98ed3be6420a$var$gridSize / 4, "px"),
    icon: "0 ".concat($fc4e98ed3be6420a$var$gridSize / 4, "px")
};
var $fc4e98ed3be6420a$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $fc4e98ed3be6420a$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    '&:not([disabled])::after': $fc4e98ed3be6420a$var$_objectSpread($fc4e98ed3be6420a$var$_objectSpread({}, $fc4e98ed3be6420a$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $fc4e98ed3be6420a$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
var $fc4e98ed3be6420a$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #0C66E4)",
    '&:hover': {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: 'underline'
    }
};
var $fc4e98ed3be6420a$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $fc4e98ed3be6420a$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #172B4D)",
        textDecoration: 'underline'
    }
};
var $fc4e98ed3be6420a$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
var $fc4e98ed3be6420a$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $fc4e98ed3be6420a$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    '&:not([disabled])::after': $fc4e98ed3be6420a$var$_objectSpread($fc4e98ed3be6420a$var$_objectSpread({}, $fc4e98ed3be6420a$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $fc4e98ed3be6420a$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $fc4e98ed3be6420a$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $fc4e98ed3be6420a$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $fc4e98ed3be6420a$var$getColor({
            group: (0, $9m4fw.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($fc4e98ed3be6420a$var$getColor({
            group: (0, $9m4fw.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $fc4e98ed3be6420a$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $fc4e98ed3be6420a$var$getColors({
        appearance: appearance,
        key: isSelected ? 'selected' : 'default',
        mode: mode
    });
    return $fc4e98ed3be6420a$var$_objectSpread($fc4e98ed3be6420a$var$_objectSpread($fc4e98ed3be6420a$var$_objectSpread($fc4e98ed3be6420a$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap'
    }, !(0, $39c3M.fg)('platform-component-visual-refresh') && baseColors), {}, {
        cursor: 'pointer',
        height: $fc4e98ed3be6420a$var$heights[spacing],
        lineHeight: $fc4e98ed3be6420a$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $fc4e98ed3be6420a$var$singleIconPadding[spacing] : $fc4e98ed3be6420a$var$padding[spacing],
        verticalAlign: $fc4e98ed3be6420a$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, !(0, $39c3M.fg)('platform-component-visual-refresh') && $fc4e98ed3be6420a$var$_objectSpread($fc4e98ed3be6420a$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        '&:visited': $fc4e98ed3be6420a$var$_objectSpread({}, baseColors),
        '&:hover': $fc4e98ed3be6420a$var$_objectSpread($fc4e98ed3be6420a$var$_objectSpread({}, $fc4e98ed3be6420a$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'hover',
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'inherit',
            // background, box-shadow
            transitionDuration: '0s, 0.15s'
        }),
        // giving active styles preference by listing them after focus
        '&:active': $fc4e98ed3be6420a$var$_objectSpread($fc4e98ed3be6420a$var$_objectSpread({}, $fc4e98ed3be6420a$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $fc4e98ed3be6420a$var$_objectSpread($fc4e98ed3be6420a$var$_objectSpread({}, $fc4e98ed3be6420a$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        '&[disabled]': $fc4e98ed3be6420a$var$_objectSpread($fc4e98ed3be6420a$var$_objectSpread({}, $fc4e98ed3be6420a$var$getColors({
            appearance: appearance,
            key: 'disabled',
            mode: mode
        })), {}, {
            cursor: 'not-allowed',
            textDecoration: 'none'
        })
    }, $fc4e98ed3be6420a$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $fc4e98ed3be6420a$var$_objectSpread({}, $fc4e98ed3be6420a$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'default',
            mode: mode
        }))
    })), (0, $39c3M.fg)('platform-component-visual-refresh') && (isSelected ? $fc4e98ed3be6420a$var$selectedStyles : $fc4e98ed3be6420a$var$_objectSpread($fc4e98ed3be6420a$var$_objectSpread($fc4e98ed3be6420a$var$_objectSpread($fc4e98ed3be6420a$var$_objectSpread($fc4e98ed3be6420a$var$_objectSpread($fc4e98ed3be6420a$var$_objectSpread($fc4e98ed3be6420a$var$_objectSpread($fc4e98ed3be6420a$var$_objectSpread({}, appearance === 'default' && $fc4e98ed3be6420a$var$defaultStyles), appearance === 'primary' && $fc4e98ed3be6420a$var$primaryStyles), appearance === 'link' && $fc4e98ed3be6420a$var$linkStyles), appearance === 'subtle' && $fc4e98ed3be6420a$var$subtleStyles), appearance === 'subtle-link' && $fc4e98ed3be6420a$var$subtleLinkStyles), appearance === 'warning' && $fc4e98ed3be6420a$var$warningStyles), appearance === 'danger' && $fc4e98ed3be6420a$var$dangerStyles), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $fc4e98ed3be6420a$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $fc4e98ed3be6420a$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $fc4e98ed3be6420a$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
            }
        }
    }, $fc4e98ed3be6420a$var$hasOverlayStyles))), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $fc4e98ed3be6420a$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $3dJ4i.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $fc4e98ed3be6420a$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $fc4e98ed3be6420a$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $3dJ4i.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $fc4e98ed3be6420a$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $fc4e98ed3be6420a$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $3dJ4i.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
var $fc4e98ed3be6420a$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});
parcelRegister("gj5NR", function(module, exports) {
$parcel$export(module.exports, "gridSize", function () { return $bdf2ec17e58aef03$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "layers", function () { return $bdf2ec17e58aef03$export$7be255094ccdc533; });

var $2LAC5 = parcelRequire("2LAC5");

var $lCRJc = parcelRequire("lCRJc");
var $bdf2ec17e58aef03$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $bdf2ec17e58aef03$export$c93026a968943f95 = 'light';
var $bdf2ec17e58aef03$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $bdf2ec17e58aef03$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $bdf2ec17e58aef03$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $bdf2ec17e58aef03$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $lCRJc.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $bdf2ec17e58aef03$export$6d8204c2cb2e06b8() / 4;
    (0, $2LAC5.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $bdf2ec17e58aef03$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $bdf2ec17e58aef03$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $bdf2ec17e58aef03$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $2LAC5.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $bdf2ec17e58aef03$export$ba1d834b86d72a09 = $bdf2ec17e58aef03$export$a1b3edb637fb4f35;
var $bdf2ec17e58aef03$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $lCRJc.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $lCRJc.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $lCRJc.N30A), ")")
            }
        }
    };
};

});

parcelRegister("9m4fw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6cf976f2710e8af3$export$2e2bcd8739ae039; });

var $lCRJc = parcelRequire("lCRJc");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $6cf976f2710e8af3$var$fadedB75 = 'rgba(179, 212, 255, 0.6)';
var $6cf976f2710e8af3$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($lCRJc.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($lCRJc.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($lCRJc.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($lCRJc.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($6cf976f2710e8af3$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($lCRJc.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($lCRJc.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($lCRJc.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($lCRJc.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lCRJc.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($lCRJc.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lCRJc.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($lCRJc.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($lCRJc.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($lCRJc.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($lCRJc.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($lCRJc.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($lCRJc.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($lCRJc.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($lCRJc.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($lCRJc.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lCRJc.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($lCRJc.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lCRJc.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($lCRJc.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($lCRJc.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($lCRJc.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($lCRJc.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($lCRJc.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($lCRJc.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($lCRJc.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($lCRJc.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($lCRJc.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($lCRJc.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($lCRJc.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($lCRJc.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($lCRJc.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($lCRJc.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($lCRJc.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($lCRJc.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($lCRJc.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($lCRJc.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($lCRJc.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($lCRJc.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($lCRJc.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($lCRJc.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($lCRJc.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($lCRJc.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($lCRJc.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lCRJc.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($lCRJc.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lCRJc.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($lCRJc.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($lCRJc.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($6cf976f2710e8af3$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($lCRJc.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($lCRJc.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lCRJc.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($lCRJc.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lCRJc.DN0, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($lCRJc.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lCRJc.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($lCRJc.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lCRJc.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($lCRJc.N500, ")"),
                dark: "var(--ds-text, ".concat($lCRJc.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($lCRJc.B400, ")"),
                dark: "var(--ds-text, ".concat($lCRJc.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($lCRJc.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($lCRJc.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($lCRJc.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lCRJc.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($lCRJc.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lCRJc.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($lCRJc.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($lCRJc.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($lCRJc.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($lCRJc.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($lCRJc.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lCRJc.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($lCRJc.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lCRJc.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($lCRJc.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($lCRJc.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($lCRJc.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($lCRJc.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($lCRJc.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($lCRJc.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($lCRJc.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($lCRJc.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($lCRJc.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($lCRJc.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($lCRJc.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($lCRJc.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($lCRJc.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($lCRJc.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($lCRJc.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($lCRJc.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($lCRJc.B400, ")"),
                dark: "var(--ds-link, ".concat($lCRJc.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($lCRJc.B300, ")"),
                dark: "var(--ds-link, ".concat($lCRJc.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($lCRJc.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($lCRJc.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($lCRJc.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($lCRJc.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($lCRJc.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lCRJc.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($lCRJc.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lCRJc.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($lCRJc.N500, ")"),
                dark: "var(--ds-text, ".concat($lCRJc.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($lCRJc.B400, ")"),
                dark: "var(--ds-text, ".concat($lCRJc.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($lCRJc.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($lCRJc.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($lCRJc.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lCRJc.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($lCRJc.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lCRJc.DN400, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-text-subtle, ".concat($lCRJc.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($lCRJc.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($lCRJc.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($lCRJc.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($lCRJc.N400, ")"),
                dark: "var(--ds-text, ".concat($lCRJc.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($lCRJc.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($lCRJc.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($lCRJc.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lCRJc.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($lCRJc.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lCRJc.DN400, ")")
            }
        }
    }
};
var $6cf976f2710e8af3$export$2e2bcd8739ae039 = $6cf976f2710e8af3$var$values;

});


parcelRegister("bB8MC", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $8719f68ff833adf1$export$20bbd2efb0d734c4; });

var $1oC0p = parcelRequire("1oC0p");

var $8BFJ8 = parcelRequire("8BFJ8");
var $8719f68ff833adf1$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $1oC0p.isValidElement)(children) && children.type === (0, $8BFJ8.default);
};

});


parcelRegister("joh3u", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e1dd7d0b17f8ccab$export$2e2bcd8739ae039; });

var $bB8MC = parcelRequire("bB8MC");
function $e1dd7d0b17f8ccab$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $bB8MC.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("jRB77", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e75fc19809f30390$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $25phJ = parcelRequire("25phJ");
function $e75fc19809f30390$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $e75fc19809f30390$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing;
    var size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $25phJ.default), {
        size: size,
        label: ", Loading",
        appearance: $e75fc19809f30390$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("25phJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $184fa97e08dc4369$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $86hFf = parcelRequire("86hFf");

var $1oC0p = parcelRequire("1oC0p");

var $etBkE = parcelRequire("etBkE");

var $2E68Y = parcelRequire("2E68Y");

var $agQlq = parcelRequire("agQlq");
/**
 * Returns the appropriate circle stroke color.
 */ function $184fa97e08dc4369$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $2E68Y.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $2E68Y.N0), ")");
}
var $184fa97e08dc4369$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $184fa97e08dc4369$var$loadIn = null;
var $184fa97e08dc4369$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $184fa97e08dc4369$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $184fa97e08dc4369$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $agQlq.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $184fa97e08dc4369$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $etBkE.default));
    $184fa97e08dc4369$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $86hFf.default)([
            $184fa97e08dc4369$var$styles.wrapperStyles,
            $184fa97e08dc4369$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $86hFf.default)([
            $184fa97e08dc4369$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $86hFf.default)([
            $184fa97e08dc4369$var$styles.circleStyles
        ])
    })));
}));
var $184fa97e08dc4369$export$2e2bcd8739ae039 = $184fa97e08dc4369$var$Spinner;

});
parcelRegister("86hFf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5e5c960442322730$export$2e2bcd8739ae039; });
const $5e5c960442322730$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $5e5c960442322730$var$ATOMIC_GROUP_LENGTH = 5;
function $5e5c960442322730$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $5e5c960442322730$var$UNDERSCORE_UNICODE ? $5e5c960442322730$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("2E68Y", function(module, exports) {
$parcel$export(module.exports, "N0", function () { return $1ed4153aa5768a51$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $1ed4153aa5768a51$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $1ed4153aa5768a51$export$4b84fd0e2c617bd = '#FFEBE6';
var $1ed4153aa5768a51$export$b34b069eff244586 = '#FFBDAD';
var $1ed4153aa5768a51$export$be802dd0d8b57f35 = '#FF8F73';
var $1ed4153aa5768a51$export$60847d42f9da92a6 = '#FF7452';
var $1ed4153aa5768a51$export$4a7404f376229999 = '#FF5630';
var $1ed4153aa5768a51$export$2010d0fb4295b346 = '#DE350B';
var $1ed4153aa5768a51$export$2837b5a1a71d5c02 = '#BF2600';
var $1ed4153aa5768a51$export$8d9596b529bbb9cf = '#FFFAE6';
var $1ed4153aa5768a51$export$41060a744ab0b7ae = '#FFF0B3';
var $1ed4153aa5768a51$export$1cc05bbbf340e559 = '#FFE380';
var $1ed4153aa5768a51$export$5aae31392d72caaa = '#FFC400';
var $1ed4153aa5768a51$export$c6930421db9fa514 = '#FFAB00';
var $1ed4153aa5768a51$export$59619663aa6500fb = '#FF991F';
var $1ed4153aa5768a51$export$874739ea9e379ab6 = '#FF8B00';
var $1ed4153aa5768a51$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $1ed4153aa5768a51$export$69a3bf21b9686c2b = '#ABF5D1';
var $1ed4153aa5768a51$export$afbce1382ec95f73 = '#79F2C0';
var $1ed4153aa5768a51$export$747d86715d4175de = '#57D9A3';
var $1ed4153aa5768a51$export$940e1f69e873f202 = '#36B37E';
var $1ed4153aa5768a51$export$a49394138f7b8e85 = '#00875A';
var $1ed4153aa5768a51$export$6fa04827ac68a4fb = '#006644';
var $1ed4153aa5768a51$export$226de0355ed012f8 = '#DEEBFF';
var $1ed4153aa5768a51$export$8c13c2ee36917869 = '#B3D4FF';
var $1ed4153aa5768a51$export$ecfc1dff386a3e7a = '#4C9AFF';
var $1ed4153aa5768a51$export$215b7063051591f1 = '#2684FF';
var $1ed4153aa5768a51$export$e62e8919cca44969 = '#0065FF';
var $1ed4153aa5768a51$export$b3de0ae08da2ce64 = '#0052CC';
var $1ed4153aa5768a51$export$a6ee3d71bc067634 = '#0747A6';
var $1ed4153aa5768a51$export$67f15409e87642a1 = '#669DF1';
var $1ed4153aa5768a51$export$f0539dbc42dbb067 = '#8FB8F6';
var $1ed4153aa5768a51$export$363e4475840015bb = '#EAE6FF';
var $1ed4153aa5768a51$export$4b0a4417ed59760f = '#C0B6F2';
var $1ed4153aa5768a51$export$6011520a64d9a187 = '#998DD9';
var $1ed4153aa5768a51$export$a7175d4e9206bc80 = '#8777D9';
var $1ed4153aa5768a51$export$b48405b95304b5a1 = '#6554C0';
var $1ed4153aa5768a51$export$c71e4279dd54a18d = '#5243AA';
var $1ed4153aa5768a51$export$147899de772240ec = '#403294';
var $1ed4153aa5768a51$export$2cf711fe14c66f06 = '#E6FCFF';
var $1ed4153aa5768a51$export$7a8f4d33f6f9772c = '#B3F5FF';
var $1ed4153aa5768a51$export$776c9c497ef08533 = '#79E2F2';
var $1ed4153aa5768a51$export$69cb3ca10c1e330e = '#00C7E6';
var $1ed4153aa5768a51$export$9dc1ef0f3f48059b = '#00B8D9';
var $1ed4153aa5768a51$export$7c835c78b6fcdef8 = '#00A3BF';
var $1ed4153aa5768a51$export$6036577f95c3877e = '#008DA6';
var $1ed4153aa5768a51$export$29a4f05edc054374 = '#FFFFFF';
var $1ed4153aa5768a51$export$e655ef011c4aa1a2 = '#FAFBFC';
var $1ed4153aa5768a51$export$9fdfb749e33cdf97 = '#F4F5F7';
var $1ed4153aa5768a51$export$3e51e8f1440314ba = '#EBECF0';
var $1ed4153aa5768a51$export$1ce2d1575d444ceb = '#DFE1E6';
var $1ed4153aa5768a51$export$8754fc7e6d8b3000 = '#C1C7D0';
var $1ed4153aa5768a51$export$c2e91cbeada39b8b = '#B3BAC5';
var $1ed4153aa5768a51$export$5f71e19f3a7ad9de = '#A5ADBA';
var $1ed4153aa5768a51$export$eaa8c8a70ac22806 = '#97A0AF';
var $1ed4153aa5768a51$export$7c87d337fb91a97d = '#8993A4';
var $1ed4153aa5768a51$export$d6447c357493214f = '#7A869A';
var $1ed4153aa5768a51$export$f563ee71e9ee74cd = '#6B778C';
var $1ed4153aa5768a51$export$e2ef2124cf4024b1 = '#5E6C84';
var $1ed4153aa5768a51$export$eece5f492e429f08 = '#505F79';
var $1ed4153aa5768a51$export$c39c0fe0f26207ae = '#42526E';
var $1ed4153aa5768a51$export$7090862dc3038a9f = '#344563';
var $1ed4153aa5768a51$export$ad0bacf983b7ddaa = '#253858';
var $1ed4153aa5768a51$export$7d61b15e0da132af = '#172B4D';
var $1ed4153aa5768a51$export$fbda843f0a27fe96 = '#091E42';
var $1ed4153aa5768a51$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $1ed4153aa5768a51$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $1ed4153aa5768a51$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $1ed4153aa5768a51$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $1ed4153aa5768a51$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $1ed4153aa5768a51$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $1ed4153aa5768a51$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $1ed4153aa5768a51$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $1ed4153aa5768a51$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $1ed4153aa5768a51$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $1ed4153aa5768a51$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $1ed4153aa5768a51$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $1ed4153aa5768a51$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $1ed4153aa5768a51$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $1ed4153aa5768a51$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $1ed4153aa5768a51$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $1ed4153aa5768a51$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $1ed4153aa5768a51$export$2f6319cf7d736c2a = '#E6EDFA';
var $1ed4153aa5768a51$export$95126bc8884d6634 = '#DCE5F5';
var $1ed4153aa5768a51$export$8338d8c35d44ff1 = '#CED9EB';
var $1ed4153aa5768a51$export$5368d76ae4fbbda7 = '#B8C7E0';
var $1ed4153aa5768a51$export$9f0a771d16ec8d36 = '#ABBBD6';
var $1ed4153aa5768a51$export$abcf8c38338b4aa5 = '#9FB0CC';
var $1ed4153aa5768a51$export$97e81faa16a182c7 = '#8C9CB8';
var $1ed4153aa5768a51$export$bfe21c59123ecf33 = '#7988A3';
var $1ed4153aa5768a51$export$ee82aa2ea6a1558 = '#67758F';
var $1ed4153aa5768a51$export$682927c6ed76be02 = '#56637A';
var $1ed4153aa5768a51$export$91fd9994c5be9757 = '#455166';
var $1ed4153aa5768a51$export$d281fbfe3cff2df6 = '#3B475C';
var $1ed4153aa5768a51$export$3902c91d8b98a753 = '#313D52';
var $1ed4153aa5768a51$export$8e8133c1ba5845b5 = '#283447';
var $1ed4153aa5768a51$export$33ff357f6620b39 = '#202B3D';
var $1ed4153aa5768a51$export$633847cf062b69e0 = '#1B2638';
var $1ed4153aa5768a51$export$9776a6e503bdbf76 = '#121A29';
var $1ed4153aa5768a51$export$6c813d5160dff5db = '#0E1624';
var $1ed4153aa5768a51$export$3d4f271a500072a = '#0D1424';
var $1ed4153aa5768a51$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $1ed4153aa5768a51$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $1ed4153aa5768a51$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $1ed4153aa5768a51$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $1ed4153aa5768a51$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $1ed4153aa5768a51$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $1ed4153aa5768a51$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $1ed4153aa5768a51$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $1ed4153aa5768a51$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $1ed4153aa5768a51$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $1ed4153aa5768a51$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $1ed4153aa5768a51$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $1ed4153aa5768a51$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $1ed4153aa5768a51$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $1ed4153aa5768a51$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $1ed4153aa5768a51$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $1ed4153aa5768a51$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $1ed4153aa5768a51$export$d2adc5dedf09fced = '#292A2E';
var $1ed4153aa5768a51$export$f51762073d2bb381 = '#94C748';
var $1ed4153aa5768a51$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("agQlq", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $77a40089bf1d142f$export$4e9f1640bbe7a1a8; });
var $77a40089bf1d142f$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("cbUsf", function(module, exports) {
$parcel$export(module.exports, "getSpecifiers", function () { return $8e024dcf167a6bad$export$643db0b8d8778e; });
$parcel$export(module.exports, "defaultThemeFn", function () { return $8e024dcf167a6bad$export$437a7f77d13d7916; });
$parcel$export(module.exports, "default", function () { return $8e024dcf167a6bad$export$2e2bcd8739ae039; });

var $55aK4 = parcelRequire("55aK4");

var $dwXUF = parcelRequire("dwXUF");

var $lF1vB = parcelRequire("lF1vB");
function $8e024dcf167a6bad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e024dcf167a6bad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e024dcf167a6bad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $55aK4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e024dcf167a6bad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8e024dcf167a6bad$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $8e024dcf167a6bad$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? 'light' : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $lF1vB.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    var selector = $8e024dcf167a6bad$var$stateToSelectorMap[state];
    if (selector) result = $8e024dcf167a6bad$var$_objectSpread($8e024dcf167a6bad$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $8e024dcf167a6bad$var$_objectSpread($8e024dcf167a6bad$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}
function $8e024dcf167a6bad$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}
function $8e024dcf167a6bad$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $8e024dcf167a6bad$var$Theme = (0, $dwXUF.createTheme)(function(themeProps) {
    return {
        buttonStyles: $8e024dcf167a6bad$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8e024dcf167a6bad$export$2e2bcd8739ae039 = $8e024dcf167a6bad$var$Theme;

});


parcelRegister("8j7J7", function(module, exports) {
$parcel$export(module.exports, "flagBackgroundColor", function () { return $60c61774cd7ff320$export$59e42969c95d314; });
$parcel$export(module.exports, "flagIconColor", function () { return $60c61774cd7ff320$export$7f70afe2167f8235; });
$parcel$export(module.exports, "flagIconGlyph", function () { return $60c61774cd7ff320$export$73f08aee70487cd4; });
$parcel$export(module.exports, "flagTextColor", function () { return $60c61774cd7ff320$export$f50075b2584087f; });
$parcel$export(module.exports, "flagTextColorToken", function () { return $60c61774cd7ff320$export$13b42cd9d596bfe0; });
$parcel$export(module.exports, "actionBackgroundColor", function () { return $60c61774cd7ff320$export$81ba6b63eedb299f; });
$parcel$export(module.exports, "actionTextColor", function () { return $60c61774cd7ff320$export$7bcfe3cca4dd78b6; });

var $1oC0p = parcelRequire("1oC0p");

var $SqPdS = parcelRequire("SqPdS");

var $a6KiI = parcelRequire("a6KiI");

var $kYP94 = parcelRequire("kYP94");

var $fgc1B = parcelRequire("fgc1B");

var $lCRJc = parcelRequire("lCRJc");
var $60c61774cd7ff320$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};
var $60c61774cd7ff320$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #626F86)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #172B4D)"
};
var $60c61774cd7ff320$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($SqPdS))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $lCRJc.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-background-danger-bold, #C9372C)"
    }),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a6KiI))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $lCRJc.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-background-neutral-bold, #44546F)"
    }),
    normal: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a6KiI))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-subtle, ".concat((0, $lCRJc.N500), ")"),
        LEGACY_secondaryColor: "var(--ds-surface-overlay, #FFFFFF)"
    }),
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kYP94))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $lCRJc.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-background-success-bold, #1F845A)"
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgc1B))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-warning-inverse, ".concat((0, $lCRJc.N700), ")"),
        LEGACY_secondaryColor: "var(--ds-background-warning-bold, #F5CD47)"
    })
};
var $60c61774cd7ff320$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};
var $60c61774cd7ff320$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, ".concat((0, $lCRJc.N0), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $lCRJc.N0), ")"),
    normal: "var(--ds-text, ".concat((0, $lCRJc.N800), ")"),
    success: "var(--ds-text-inverse, ".concat((0, $lCRJc.N0), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $lCRJc.N700), ")")
};
var $60c61774cd7ff320$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $lCRJc.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $lCRJc.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $lCRJc.N30A), ")")
    },
    info: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $lCRJc.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $lCRJc.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $lCRJc.N30A), ")")
    },
    error: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $lCRJc.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $lCRJc.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $lCRJc.N30A), ")")
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $lCRJc.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $lCRJc.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $lCRJc.N30A), ")")
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};
var $60c61774cd7ff320$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, ".concat((0, $lCRJc.N0), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $lCRJc.N0), ")"),
    error: "var(--ds-text-inverse, ".concat((0, $lCRJc.N0), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $lCRJc.N700), ")"),
    normal: "var(--ds-link, ".concat((0, $lCRJc.B400), ")")
};

});
parcelRegister("SqPdS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::65cdc00c41545a5e974b615c0e363097>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0a39da2e5d2fcc97$var$_react = $0a39da2e5d2fcc97$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $0a39da2e5d2fcc97$var$_error = $0a39da2e5d2fcc97$var$_interopRequireDefault((parcelRequire("lzZD3")));

var $0a39da2e5d2fcc97$var$_error2 = $0a39da2e5d2fcc97$var$_interopRequireDefault((parcelRequire("e70JR")));
function $0a39da2e5d2fcc97$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0a39da2e5d2fcc97$var$ErrorIcon = (props)=>/*#__PURE__*/ $0a39da2e5d2fcc97$var$_react.default.createElement($0a39da2e5d2fcc97$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $0a39da2e5d2fcc97$var$_error2.default
    }, props));
$0a39da2e5d2fcc97$var$ErrorIcon.Name = 'ErrorIconMigration';
var $0a39da2e5d2fcc97$var$_default = module.exports.default = $0a39da2e5d2fcc97$var$ErrorIcon;

});
parcelRegister("lzZD3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2cd3105f02ad146f4ebeeb5e7e40633>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb5cac0f73ef143c$var$_react = $fb5cac0f73ef143c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $fb5cac0f73ef143c$var$_baseNew = $fb5cac0f73ef143c$var$_interopRequireDefault((parcelRequire("4Ny4d")));
function $fb5cac0f73ef143c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fb5cac0f73ef143c$var$ErrorIcon = (props)=>/*#__PURE__*/ $fb5cac0f73ef143c$var$_react.default.createElement($fb5cac0f73ef143c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$fb5cac0f73ef143c$var$ErrorIcon.displayName = 'ErrorIcon';
var $fb5cac0f73ef143c$var$_default = module.exports.default = $fb5cac0f73ef143c$var$ErrorIcon;

});
parcelRegister("4Ny4d", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return (parcelRequire("ji5Xc")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("ji5Xc")).Icon; });

var $ji5Xc = parcelRequire("ji5Xc");

});
parcelRegister("ji5Xc", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $e0b4511735da9c16$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $e0b4511735da9c16$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $gcw6K = parcelRequire("gcw6K");

var $39c3M = parcelRequire("39c3M");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $e0b4511735da9c16$var$svgStyles = null;
var $e0b4511735da9c16$var$iconStyles = null;
var $e0b4511735da9c16$var$utilityIconStyles = null;
var $e0b4511735da9c16$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $e0b4511735da9c16$var$baseHcmStyles = null;
var $e0b4511735da9c16$var$scaleSize = null;
var $e0b4511735da9c16$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $e0b4511735da9c16$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $e0b4511735da9c16$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $e0b4511735da9c16$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $e0b4511735da9c16$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $e0b4511735da9c16$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $39c3M.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $1oC0p.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'size' in props && props.size !== undefined && // This prevents invalid sizes being passed in, which is required
    // for handling unsupported legacy icon sizes which can
    // cause errors.
    (props.size === 'small' || props.size === 'medium') ? props.size : 'medium';
    var baseSize = $e0b4511735da9c16$var$baseSizeMap[type];
    var viewBoxPadding = $e0b4511735da9c16$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $gcw6K.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $gcw6K.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $e0b4511735da9c16$var$utilSizes[spacing] : size === 'small' ? $e0b4511735da9c16$var$coreSizeSmall[spacing] : $e0b4511735da9c16$var$coreSizeMedium[spacing]
        ])
    }));
});
var $e0b4511735da9c16$export$2e2bcd8739ae039 = $e0b4511735da9c16$export$f04a61298a47a40f;

});



parcelRegister("e70JR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4624ad49dd83c07$var$_react = $a4624ad49dd83c07$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $hyeEE = parcelRequire("hyeEE");

var $a4624ad49dd83c07$var$_error = $a4624ad49dd83c07$var$_interopRequireDefault((parcelRequire("lzZD3")));
function $a4624ad49dd83c07$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a4624ad49dd83c07$var$ErrorIcon = (props)=>/*#__PURE__*/ $a4624ad49dd83c07$var$_react.default.createElement($hyeEE.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $a4624ad49dd83c07$var$_error.default
    }));
$a4624ad49dd83c07$var$ErrorIcon.displayName = 'ErrorIcon';
var $a4624ad49dd83c07$var$_default = module.exports.default = $a4624ad49dd83c07$var$ErrorIcon;

});
parcelRegister("hyeEE", function(module, exports) {
$parcel$export(module.exports, "IconFacade", function () { return $cc70fabbaff03495$export$3cfb73f70dfca966; });

var $8qa5V = parcelRequire("8qa5V");

var $8msnN = parcelRequire("8msnN");

var $1oC0p = parcelRequire("1oC0p");

var $39c3M = parcelRequire("39c3M");

var $cPsuk = parcelRequire("cPsuk");
var $cc70fabbaff03495$var$_excluded = [
    "dangerouslySetGlyph",
    "size"
];
var $cc70fabbaff03495$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $cc70fabbaff03495$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $1oC0p.memo)(function IconFacade(_ref) {
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, size = _ref.size, props = (0, $8msnN.default)(_ref, $cc70fabbaff03495$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var iconSize = size !== null && size !== void 0 ? size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $39c3M.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (iconSize === 'small' || iconSize === 'medium')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, (0, $8qa5V.default)({}, props, {
                spacing: (0, $39c3M.fg)('platform-visual-refresh-icons-facade-button-fix') ? $cc70fabbaff03495$var$sizeSpacingMap['utility'][iconSize] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(_Icon, (0, $8qa5V.default)({}, props, {
                size: iconSize,
                spacing: $cc70fabbaff03495$var$sizeSpacingMap['core'][iconSize],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cPsuk.Icon), (0, $8qa5V.default)({
        dangerouslySetGlyph: dangerouslySetGlyph,
        size: size
    }, props));
});

});
parcelRegister("cPsuk", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $9570589ee66346e0$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8qa5V = parcelRequire("8qa5V");

var $55aK4 = parcelRequire("55aK4");

var $1oC0p = parcelRequire("1oC0p");

var $gcw6K = parcelRequire("gcw6K");
function $9570589ee66346e0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9570589ee66346e0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9570589ee66346e0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $55aK4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9570589ee66346e0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $9570589ee66346e0$var$iconStyles = null;
var $9570589ee66346e0$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $9570589ee66346e0$var$baseHcmStyles = null;
var $9570589ee66346e0$var$primaryEqualsSecondaryHcmStyles = null;
var $9570589ee66346e0$var$secondaryTransparentHcmStyles = null;
var $9570589ee66346e0$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $1oC0p.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $1oC0p.createElement("span", (0, $8qa5V.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $9570589ee66346e0$var$_objectSpread($9570589ee66346e0$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $gcw6K.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $9570589ee66346e0$var$sizeStyles[size]
        ])
    }));
});
var $9570589ee66346e0$export$2e2bcd8739ae039 = $9570589ee66346e0$export$f04a61298a47a40f;

});




parcelRegister("a6KiI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cba8aea4f01e137899fc410e6d59c613>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75be61545637bfcf$var$_react = $75be61545637bfcf$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $75be61545637bfcf$var$_information = $75be61545637bfcf$var$_interopRequireDefault((parcelRequire("f26qD")));

var $75be61545637bfcf$var$_info = $75be61545637bfcf$var$_interopRequireDefault((parcelRequire("7L71l")));
function $75be61545637bfcf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75be61545637bfcf$var$InformationIcon = (props)=>/*#__PURE__*/ $75be61545637bfcf$var$_react.default.createElement($75be61545637bfcf$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $75be61545637bfcf$var$_info.default
    }, props));
$75be61545637bfcf$var$InformationIcon.Name = 'InformationIconMigration';
var $75be61545637bfcf$var$_default = module.exports.default = $75be61545637bfcf$var$InformationIcon;

});
parcelRegister("f26qD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d43a7428702b82788297fb999fe29f0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02d308611cd836fd$var$_react = $02d308611cd836fd$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $02d308611cd836fd$var$_baseNew = $02d308611cd836fd$var$_interopRequireDefault((parcelRequire("4Ny4d")));
function $02d308611cd836fd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $02d308611cd836fd$var$InformationIcon = (props)=>/*#__PURE__*/ $02d308611cd836fd$var$_react.default.createElement($02d308611cd836fd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$02d308611cd836fd$var$InformationIcon.displayName = 'InformationIcon';
var $02d308611cd836fd$var$_default = module.exports.default = $02d308611cd836fd$var$InformationIcon;

});

parcelRegister("7L71l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a625e5bb6c20b8e$var$_react = $5a625e5bb6c20b8e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $hyeEE = parcelRequire("hyeEE");

var $5a625e5bb6c20b8e$var$_information = $5a625e5bb6c20b8e$var$_interopRequireDefault((parcelRequire("f26qD")));
function $5a625e5bb6c20b8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5a625e5bb6c20b8e$var$InfoIcon = (props)=>/*#__PURE__*/ $5a625e5bb6c20b8e$var$_react.default.createElement($hyeEE.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $5a625e5bb6c20b8e$var$_information.default
    }));
$5a625e5bb6c20b8e$var$InfoIcon.displayName = 'InfoIcon';
var $5a625e5bb6c20b8e$var$_default = module.exports.default = $5a625e5bb6c20b8e$var$InfoIcon;

});


parcelRegister("kYP94", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45c9288f6eb359396f296ae05aab18bb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f46115a6bd286555$var$_react = $f46115a6bd286555$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f46115a6bd286555$var$_success = $f46115a6bd286555$var$_interopRequireDefault((parcelRequire("c8pLj")));

var $f46115a6bd286555$var$_checkCircle = $f46115a6bd286555$var$_interopRequireDefault((parcelRequire("hWBoF")));
function $f46115a6bd286555$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f46115a6bd286555$var$SuccessIcon = (props)=>/*#__PURE__*/ $f46115a6bd286555$var$_react.default.createElement($f46115a6bd286555$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $f46115a6bd286555$var$_checkCircle.default
    }, props));
$f46115a6bd286555$var$SuccessIcon.Name = 'SuccessIconMigration';
var $f46115a6bd286555$var$_default = module.exports.default = $f46115a6bd286555$var$SuccessIcon;

});
parcelRegister("c8pLj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20972219c6507a2ba31d70f1a6537d02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d5a37396af21bb5$var$_react = $8d5a37396af21bb5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8d5a37396af21bb5$var$_baseNew = $8d5a37396af21bb5$var$_interopRequireDefault((parcelRequire("4Ny4d")));
function $8d5a37396af21bb5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d5a37396af21bb5$var$SuccessIcon = (props)=>/*#__PURE__*/ $8d5a37396af21bb5$var$_react.default.createElement($8d5a37396af21bb5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$8d5a37396af21bb5$var$SuccessIcon.displayName = 'SuccessIcon';
var $8d5a37396af21bb5$var$_default = module.exports.default = $8d5a37396af21bb5$var$SuccessIcon;

});

parcelRegister("hWBoF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d104dcb40cd62328$var$_react = $d104dcb40cd62328$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $hyeEE = parcelRequire("hyeEE");

var $d104dcb40cd62328$var$_success = $d104dcb40cd62328$var$_interopRequireDefault((parcelRequire("c8pLj")));
function $d104dcb40cd62328$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d104dcb40cd62328$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $d104dcb40cd62328$var$_react.default.createElement($hyeEE.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $d104dcb40cd62328$var$_success.default
    }));
$d104dcb40cd62328$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $d104dcb40cd62328$var$_default = module.exports.default = $d104dcb40cd62328$var$CheckCircleIcon;

});


parcelRegister("fgc1B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d5fac6bc179ab80298f715340f91ebf9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1c1ad8c0b8e95f9$var$_react = $b1c1ad8c0b8e95f9$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $b1c1ad8c0b8e95f9$var$_warning = $b1c1ad8c0b8e95f9$var$_interopRequireDefault((parcelRequire("bFtnb")));

var $b1c1ad8c0b8e95f9$var$_warning2 = $b1c1ad8c0b8e95f9$var$_interopRequireDefault((parcelRequire("i72ux")));
function $b1c1ad8c0b8e95f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1c1ad8c0b8e95f9$var$WarningIcon = (props)=>/*#__PURE__*/ $b1c1ad8c0b8e95f9$var$_react.default.createElement($b1c1ad8c0b8e95f9$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $b1c1ad8c0b8e95f9$var$_warning2.default
    }, props));
$b1c1ad8c0b8e95f9$var$WarningIcon.Name = 'WarningIconMigration';
var $b1c1ad8c0b8e95f9$var$_default = module.exports.default = $b1c1ad8c0b8e95f9$var$WarningIcon;

});
parcelRegister("bFtnb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c615014b011664b243a37531e093f861>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87ea4ee442d85214$var$_react = $87ea4ee442d85214$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $87ea4ee442d85214$var$_baseNew = $87ea4ee442d85214$var$_interopRequireDefault((parcelRequire("4Ny4d")));
function $87ea4ee442d85214$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87ea4ee442d85214$var$WarningIcon = (props)=>/*#__PURE__*/ $87ea4ee442d85214$var$_react.default.createElement($87ea4ee442d85214$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$87ea4ee442d85214$var$WarningIcon.displayName = 'WarningIcon';
var $87ea4ee442d85214$var$_default = module.exports.default = $87ea4ee442d85214$var$WarningIcon;

});

parcelRegister("i72ux", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $036724640b9d94fa$var$_react = $036724640b9d94fa$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $hyeEE = parcelRequire("hyeEE");

var $036724640b9d94fa$var$_warning = $036724640b9d94fa$var$_interopRequireDefault((parcelRequire("bFtnb")));
function $036724640b9d94fa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $036724640b9d94fa$var$WarningIcon = (props)=>/*#__PURE__*/ $036724640b9d94fa$var$_react.default.createElement($hyeEE.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $036724640b9d94fa$var$_warning.default
    }));
$036724640b9d94fa$var$WarningIcon.displayName = 'WarningIcon';
var $036724640b9d94fa$var$_default = module.exports.default = $036724640b9d94fa$var$WarningIcon;

});




parcelRegister("7AbSd", function(module, exports) {
$parcel$export(module.exports, "useFlagGroup", function () { return $58551b01bb82ff87$export$e91ea202abb66350; });
$parcel$export(module.exports, "default", function () { return $58551b01bb82ff87$export$2e2bcd8739ae039; });
/* flag-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7R6fn = parcelRequire("7R6fn");

var $1oC0p = parcelRequire("1oC0p");

var $gcw6K = parcelRequire("gcw6K");

var $7uNuF = parcelRequire("7uNuF");

var $01fYV = parcelRequire("01fYV");
var $gwrd5 = parcelRequire("gwrd5");

var $52Fo7 = parcelRequire("52Fo7");

var $gj5NR = parcelRequire("gj5NR");

var $8BFJ8 = parcelRequire("8BFJ8");
var $58551b01bb82ff87$export$1eee5ddc4f6d41c5 = 400;
var $58551b01bb82ff87$var$defaultFlagGroupContext = {
    onDismissed: (0, $7uNuF.default),
    isDismissAllowed: false
};
var $58551b01bb82ff87$export$c57ba665aaa722be = /*#__PURE__*/ (0, $1oC0p.createContext)($58551b01bb82ff87$var$defaultFlagGroupContext);
function $58551b01bb82ff87$export$e91ea202abb66350() {
    return (0, $1oC0p.useContext)($58551b01bb82ff87$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $58551b01bb82ff87$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
var $58551b01bb82ff87$var$dismissAllowedStyles = null;
var $58551b01bb82ff87$var$flagGroupContainerStyles = null;
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ var $58551b01bb82ff87$var$FlagGroup = function FlagGroup(props) {
    var id = props.id, _props$label = props.label, label = _props$label === void 0 ? 'Flag notifications' : _props$label, _props$labelTag = props.labelTag, LabelTag = _props$labelTag === void 0 ? 'h2' : _props$labelTag, _props$shouldRenderTo = props.shouldRenderToParent, shouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, children = props.children, _props$onDismissed = props.onDismissed, onDismissed = _props$onDismissed === void 0 ? (0, $7uNuF.default) : _props$onDismissed;
    var hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    var dismissFlagContext = (0, $1oC0p.useMemo)(function() {
        return {
            onDismissed: onDismissed,
            isDismissAllowed: true
        };
    }, [
        onDismissed
    ]);
    var renderChildren = function renderChildren() {
        return children && (0, $7R6fn.default)(children) === 'object' ? (0, $1oC0p.Children).map(children, function(flag, index) {
            var isDismissAllowed = index === 0;
            return /*#__PURE__*/ $1oC0p.createElement((0, $gwrd5.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in"
            }, function(_ref) {
                var className = _ref.className, ref = _ref.ref;
                return /*#__PURE__*/ $1oC0p.createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $gcw6K.default)([
                        $58551b01bb82ff87$var$groupStyles.root,
                        index === 0 && $58551b01bb82ff87$var$groupStyles.first,
                        index === 1 && $58551b01bb82ff87$var$groupStyles.second,
                        index >= 1 && $58551b01bb82ff87$var$groupStyles.nth,
                        index >= 2 && $58551b01bb82ff87$var$groupStyles.hidden,
                        isDismissAllowed && "_12a7luct",
                        className
                    ]),
                    ref: ref
                }, /*#__PURE__*/ $1oC0p.createElement($58551b01bb82ff87$export$c57ba665aaa722be.Provider, {
                    value: // Only the first flag should be able to be dismissed.
                    isDismissAllowed ? dismissFlagContext : $58551b01bb82ff87$var$defaultFlagGroupContext
                }, flag));
            });
        }) : false;
    };
    var flags = /*#__PURE__*/ $1oC0p.createElement("div", {
        id: id,
        className: (0, $gcw6K.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"
        ])
    }, hasFlags ? /*#__PURE__*/ $1oC0p.createElement((0, $8BFJ8.default), null, /*#__PURE__*/ $1oC0p.createElement(LabelTag, null, label)) : null, /*#__PURE__*/ $1oC0p.createElement((0, $01fYV.default), {
        appear: false
    }, renderChildren()));
    return shouldRenderToParent ? flags : /*#__PURE__*/ $1oC0p.createElement((0, $52Fo7.default), {
        zIndex: (0, $gj5NR.layers).flag()
    }, flags);
};
var $58551b01bb82ff87$export$2e2bcd8739ae039 = $58551b01bb82ff87$var$FlagGroup;

});

parcelRegister("fYjS4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ba0bdf9a0dac1137$export$2e2bcd8739ae039; });
/* dismiss-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");


var $6bEtr = parcelRequire("6bEtr");

var $bupbx = parcelRequire("bupbx");

var $5pbSw = parcelRequire("5pbSw");

var $l4cJM = parcelRequire("l4cJM");

var $8j7J7 = parcelRequire("8j7J7");
var $ba0bdf9a0dac1137$var$styles = {
    button: "_16jlidpf _1o9zidpf _i0dl1wug _1dqoglyw _1e0c1txw _1bsb1tcg _4t3i1tcg _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4cvr1h6o _1bah1h6o _80omtlke _o5721q9c"
};
var $ba0bdf9a0dac1137$var$DismissButtonComponent = function DismissButtonComponent(_ref) {
    var appearance = _ref.appearance, onClick = _ref.onClick, isBold = _ref.isBold, isExpanded = _ref.isExpanded, testId = _ref.testId;
    var ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($5pbSw)));
    var buttonLabel = 'Dismiss';
    var size = 'small';
    var buttonTestId = testId && "".concat(testId, "-dismiss");
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($bupbx))) : (0, (/*@__PURE__*/$parcel$interopDefault($6bEtr)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        size = 'medium';
        buttonTestId = testId && "".concat(testId, "-toggle");
    }
    return /*#__PURE__*/ $1oC0p.createElement((0, $l4cJM.default), {
        xcss: $ba0bdf9a0dac1137$var$styles.button,
        onClick: onClick,
        style: {
            background: 'none'
        },
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId,
        "aria-label": buttonLabel
    }, /*#__PURE__*/ $1oC0p.createElement(ButtonIcon, {
        label: "",
        LEGACY_size: size,
        LEGACY_primaryColor: (0, $8j7J7.flagTextColorToken)[appearance],
        color: (0, $8j7J7.flagTextColorToken)[appearance],
        size: "small"
    }));
};
var $ba0bdf9a0dac1137$var$DismissButton = /*#__PURE__*/ (0, $1oC0p.memo)($ba0bdf9a0dac1137$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ba0bdf9a0dac1137$export$2e2bcd8739ae039 = $ba0bdf9a0dac1137$var$DismissButton;

});
parcelRegister("6bEtr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e7cd534c00fe7f264597ee666bf617f5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $48132a6bcc465542$var$_react = $48132a6bcc465542$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $48132a6bcc465542$var$_chevronDown = $48132a6bcc465542$var$_interopRequireDefault((parcelRequire("bJd2V")));

var $48132a6bcc465542$var$_chevronDown2 = $48132a6bcc465542$var$_interopRequireDefault((parcelRequire("48XQF")));
function $48132a6bcc465542$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $48132a6bcc465542$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $48132a6bcc465542$var$_react.default.createElement($48132a6bcc465542$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $48132a6bcc465542$var$_chevronDown2.default
    }, props));
$48132a6bcc465542$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
var $48132a6bcc465542$var$_default = module.exports.default = $48132a6bcc465542$var$ChevronDownIcon;

});
parcelRegister("bJd2V", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $889e045b06240c48$var$_react = $889e045b06240c48$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $889e045b06240c48$var$_baseNew = $889e045b06240c48$var$_interopRequireDefault((parcelRequire("4Ny4d")));
function $889e045b06240c48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $889e045b06240c48$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $889e045b06240c48$var$_react.default.createElement($889e045b06240c48$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$889e045b06240c48$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $889e045b06240c48$var$_default = module.exports.default = $889e045b06240c48$var$ChevronDownIcon;

});

parcelRegister("48XQF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30465575dfce3ccf$var$_react = $30465575dfce3ccf$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $hyeEE = parcelRequire("hyeEE");

var $30465575dfce3ccf$var$_chevronDown = $30465575dfce3ccf$var$_interopRequireDefault((parcelRequire("bJd2V")));
function $30465575dfce3ccf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $30465575dfce3ccf$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $30465575dfce3ccf$var$_react.default.createElement($hyeEE.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props, {
        newIcon: $30465575dfce3ccf$var$_chevronDown.default
    }));
$30465575dfce3ccf$var$HipchatChevronDownIcon.displayName = 'HipchatChevronDownIcon';
var $30465575dfce3ccf$var$_default = module.exports.default = $30465575dfce3ccf$var$HipchatChevronDownIcon;

});


parcelRegister("bupbx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e591300488a0b21b4d41dc998cb671a7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85d6084d0e7d913c$var$_react = $85d6084d0e7d913c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $85d6084d0e7d913c$var$_chevronUp = $85d6084d0e7d913c$var$_interopRequireDefault((parcelRequire("4fhic")));

var $85d6084d0e7d913c$var$_chevronUp2 = $85d6084d0e7d913c$var$_interopRequireDefault((parcelRequire("dz8iy")));
function $85d6084d0e7d913c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronUpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85d6084d0e7d913c$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $85d6084d0e7d913c$var$_react.default.createElement($85d6084d0e7d913c$var$_chevronUp.default, Object.assign({
        LEGACY_fallbackIcon: $85d6084d0e7d913c$var$_chevronUp2.default
    }, props));
$85d6084d0e7d913c$var$ChevronUpIcon.Name = 'ChevronUpIconMigration';
var $85d6084d0e7d913c$var$_default = module.exports.default = $85d6084d0e7d913c$var$ChevronUpIcon;

});
parcelRegister("4fhic", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::186cfd732e4641b5fdb3f2d7a456f10c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3175fa0d1f04c7fa$var$_react = $3175fa0d1f04c7fa$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3175fa0d1f04c7fa$var$_baseNew = $3175fa0d1f04c7fa$var$_interopRequireDefault((parcelRequire("4Ny4d")));
function $3175fa0d1f04c7fa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3175fa0d1f04c7fa$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $3175fa0d1f04c7fa$var$_react.default.createElement($3175fa0d1f04c7fa$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$3175fa0d1f04c7fa$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $3175fa0d1f04c7fa$var$_default = module.exports.default = $3175fa0d1f04c7fa$var$ChevronUpIcon;

});

parcelRegister("dz8iy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e04fb1aeda59a6e$var$_react = $9e04fb1aeda59a6e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $hyeEE = parcelRequire("hyeEE");

var $9e04fb1aeda59a6e$var$_chevronUp = $9e04fb1aeda59a6e$var$_interopRequireDefault((parcelRequire("4fhic")));
function $9e04fb1aeda59a6e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9e04fb1aeda59a6e$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $9e04fb1aeda59a6e$var$_react.default.createElement($hyeEE.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props, {
        newIcon: $9e04fb1aeda59a6e$var$_chevronUp.default
    }));
$9e04fb1aeda59a6e$var$HipchatChevronUpIcon.displayName = 'HipchatChevronUpIcon';
var $9e04fb1aeda59a6e$var$_default = module.exports.default = $9e04fb1aeda59a6e$var$HipchatChevronUpIcon;

});


parcelRegister("5pbSw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35b8c6b585772b9406ca86ab3c3befd4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ef88054df38e79d$var$_react = $3ef88054df38e79d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3ef88054df38e79d$var$_close = $3ef88054df38e79d$var$_interopRequireDefault((parcelRequire("54xEj")));

var $3ef88054df38e79d$var$_cross = $3ef88054df38e79d$var$_interopRequireDefault((parcelRequire("3zoSi")));
function $3ef88054df38e79d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3ef88054df38e79d$var$CloseIcon = (props)=>/*#__PURE__*/ $3ef88054df38e79d$var$_react.default.createElement($3ef88054df38e79d$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $3ef88054df38e79d$var$_cross.default
    }, props));
$3ef88054df38e79d$var$CloseIcon.Name = 'CloseIconMigration';
var $3ef88054df38e79d$var$_default = module.exports.default = $3ef88054df38e79d$var$CloseIcon;

});
parcelRegister("54xEj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2832ce3758295ab6ed0286f39d79816>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b176d7efa148e4c$var$_react = $3b176d7efa148e4c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3b176d7efa148e4c$var$_baseNew = $3b176d7efa148e4c$var$_interopRequireDefault((parcelRequire("4Ny4d")));
function $3b176d7efa148e4c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Close".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3b176d7efa148e4c$var$CloseIcon = (props)=>/*#__PURE__*/ $3b176d7efa148e4c$var$_react.default.createElement($3b176d7efa148e4c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m9.06 8 4.97-4.97-1.06-1.06L8 6.94 3.03 1.97 1.97 3.03 6.94 8l-4.97 4.97 1.06 1.06L8 9.06l4.97 4.97 1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$3b176d7efa148e4c$var$CloseIcon.displayName = 'CloseIcon';
var $3b176d7efa148e4c$var$_default = module.exports.default = $3b176d7efa148e4c$var$CloseIcon;

});

parcelRegister("3zoSi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2997ef943a463b6f$var$_react = $2997ef943a463b6f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $hyeEE = parcelRequire("hyeEE");

var $2997ef943a463b6f$var$_close = $2997ef943a463b6f$var$_interopRequireDefault((parcelRequire("54xEj")));
function $2997ef943a463b6f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2997ef943a463b6f$var$CrossIcon = (props)=>/*#__PURE__*/ $2997ef943a463b6f$var$_react.default.createElement($hyeEE.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $2997ef943a463b6f$var$_close.default
    }));
$2997ef943a463b6f$var$CrossIcon.displayName = 'CrossIcon';
var $2997ef943a463b6f$var$_default = module.exports.default = $2997ef943a463b6f$var$CrossIcon;

});


parcelRegister("l4cJM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f563da11f065426c$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8qa5V = parcelRequire("8qa5V");

var $8msnN = parcelRequire("8msnN");

var $1oC0p = parcelRequire("1oC0p");


var $cDEzj = parcelRequire("cDEzj");

var $aEDsG = parcelRequire("aEDsG");

var $ef3YL = parcelRequire("ef3YL");

var $7uNuF = parcelRequire("7uNuF");

var $etBkE = parcelRequire("etBkE");

var $3RDim = parcelRequire("3RDim");
var $f563da11f065426c$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $f563da11f065426c$var$_excluded2 = [
    "className"
];
var $f563da11f065426c$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $f563da11f065426c$var$Pressable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $7uNuF.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $8msnN.default)(_ref, $f563da11f065426c$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $etBkE.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $aEDsG.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "14.8.4",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $8msnN.default)(htmlAttributes, $f563da11f065426c$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement((0, $3RDim.default), (0, $8qa5V.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $ef3YL.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $cDEzj.cx)($f563da11f065426c$var$styles.root, isDisabled && $f563da11f065426c$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $f563da11f065426c$export$2e2bcd8739ae039 = $f563da11f065426c$var$Pressable;

});
parcelRegister("3RDim", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2d04cd89dd86d564$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8qa5V = parcelRequire("8qa5V");

var $55aK4 = parcelRequire("55aK4");

var $8msnN = parcelRequire("8msnN");

var $1oC0p = parcelRequire("1oC0p");

var $gcw6K = parcelRequire("gcw6K");
var $i0UnX = parcelRequire("i0UnX");
var $2d04cd89dd86d564$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $2d04cd89dd86d564$var$_excluded2 = [
    "className"
];
function $2d04cd89dd86d564$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2d04cd89dd86d564$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2d04cd89dd86d564$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $55aK4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2d04cd89dd86d564$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2d04cd89dd86d564$var$focusRingStyles = null;
var $2d04cd89dd86d564$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $2d04cd89dd86d564$var$Focusable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $8msnN.default)(_ref, $2d04cd89dd86d564$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $8msnN.default)(htmlAttributes, $2d04cd89dd86d564$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $8qa5V.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $gcw6K.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $2d04cd89dd86d564$var$_objectSpread($2d04cd89dd86d564$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $i0UnX.default)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $2d04cd89dd86d564$export$2e2bcd8739ae039 = $2d04cd89dd86d564$var$Focusable;

});



parcelRegister("1G2RB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $138bef566b863465$export$2e2bcd8739ae039; });
/* expander.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8qa5V = parcelRequire("8qa5V");

var $1oC0p = parcelRequire("1oC0p");


var $01fYV = parcelRequire("01fYV");
var $b6Sy7 = parcelRequire("b6Sy7");

var $euC3u = parcelRequire("euC3u");
var $8GeHv = parcelRequire("8GeHv");
var $138bef566b863465$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
var $138bef566b863465$var$Expander = function Expander(_ref) {
    var children = _ref.children, isExpanded = _ref.isExpanded, testId = _ref.testId;
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ $1oC0p.createElement((0, $euC3u.default), {
        xcss: $138bef566b863465$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && "".concat(testId, "-expander")
    }, /*#__PURE__*/ $1oC0p.createElement((0, $01fYV.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ $1oC0p.createElement((0, $b6Sy7.default), null, function(props) {
        return /*#__PURE__*/ $1oC0p.createElement((0, $euC3u.default), (0, $8qa5V.default)({
            xcss: $138bef566b863465$var$styles.container
        }, props), /*#__PURE__*/ $1oC0p.createElement((0, $8GeHv.default), {
            space: "space.100"
        }, children));
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$138bef566b863465$export$2e2bcd8739ae039 = $138bef566b863465$var$Expander;

});



parcelRegister("8IO3K", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20972219c6507a2ba31d70f1a6537d02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65994388dde866fa$var$_react = $65994388dde866fa$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $65994388dde866fa$var$_baseNew = $65994388dde866fa$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $65994388dde866fa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $65994388dde866fa$var$SuccessIcon = (props)=>/*#__PURE__*/ $65994388dde866fa$var$_react.default.createElement($65994388dde866fa$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$65994388dde866fa$var$SuccessIcon.displayName = 'SuccessIcon';
var $65994388dde866fa$var$_default = module.exports.default = $65994388dde866fa$var$SuccessIcon;

});


parcelRegister("hJVgj", function(module, exports) {
$parcel$export(module.exports, "createMoveTicketComment", function () { return $8f8073faf4fa7681$export$ec4b78e935e4dfc6; });
const $8f8073faf4fa7681$export$ec4b78e935e4dfc6 = async ({ stargateClient: stargateClient, issueId: issueId, comment: comment })=>{
    const query = `
            mutation AddComment($IssueID: String!, $message: String!) {
                customerSupport {
                    addComment(input: {issueKey: $IssueID, message: $message}) {
                        message
                        author {
                            user {
                                accountId
                                name
                                picture
                                __typename
                            }
                            __typename
                        }
                        createdDate {
                            dateTime
                            friendly
                            __typename
                        }
                        __typename
                    }
                    __typename
                }
            }
        `;
    const response = await stargateClient.getCspGraphqlRequest({
        request: JSON.stringify({
            query: query,
            variables: {
                IssueID: issueId,
                message: comment
            }
        })
    });
    return response;
};

});



parcelRegister("jECsZ", function(module, exports) {
$parcel$export(module.exports, "RequestAssistanceModalLoader", function () { return (parcelRequire("jBzMQ")).RequestAssistanceModalLoader; });

var $jBzMQ = parcelRequire("jBzMQ");

});
parcelRegister("jBzMQ", function(module, exports) {
$parcel$export(module.exports, "RequestAssistanceModalLoader", function () { return $edc8909a2b341ef6$export$157f3ac7606c323f; });

var $7VQPk = parcelRequire("7VQPk");

var $cfGSv = parcelRequire("cfGSv");

var $g3ExX = parcelRequire("g3ExX");

var $7qFQI = parcelRequire("7qFQI");
const $edc8909a2b341ef6$export$157f3ac7606c323f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cfGSv.default), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
            padding: "space.200",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
                testId: "spinner",
                interactionName: "load",
                label: "Loading",
                size: "medium"
            })
        })
    });
};

});




parcelRegister("c4oAd", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $5d4bdb619ab07d92$export$defe85febe8b728c; });

var $k0oFl = parcelRequire("k0oFl");
const $5d4bdb619ab07d92$export$defe85febe8b728c = (0, $k0oFl.defineMessages)({
    supportEngineersCardTitle: {
        id: "fastshift.relationships-card.title.support-engineers",
        defaultMessage: "Migration Support Engineers",
        description: "Title for the Support Engineers card"
    },
    supportEngineersCardSubtitle: {
        id: "fastshift.relationships-card.subtitle.support-engineers",
        defaultMessage: "Team of Atlassian experts",
        description: "Subtitle for the Support Engineers card"
    },
    supportEngineersCardButtonText: {
        id: "fastshift.relationships-card.button-text.support-engineers",
        defaultMessage: "Request assistance",
        description: "Button text for the Support Engineers card"
    },
    supportEngineersCardMessageWhenNoAvaters: {
        id: "fastshift.relationships-card.message-when-no-avaters.support-engineers",
        defaultMessage: "Get guidance or support directly from your FastShift team.",
        description: "Message when no avaters are available"
    }
});

});



parcelRegister("4OJkD", function(module, exports) {
$parcel$export(module.exports, "BaseRelationshipsSection", function () { return (parcelRequire("4jbZK")).BaseRelationshipsSection; });

var $4jbZK = parcelRequire("4jbZK");

});
parcelRegister("4jbZK", function(module, exports) {
$parcel$export(module.exports, "BaseRelationshipsSection", function () { return $d338316ce9c683ee$export$a1d442548f64d041; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $dTJrO = parcelRequire("dTJrO");

var $fmW7P = parcelRequire("fmW7P");
var $2YtGy = parcelRequire("2YtGy");

var $9YKR6 = parcelRequire("9YKR6");
const $d338316ce9c683ee$export$a1d442548f64d041 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $9YKR6.messages).relationshipsSectionBaseTitle))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fmW7P.default), {
                gap: "space.200",
                justifyContent: "space-evenly",
                children: children
            })
        ]
    });
};

});
parcelRegister("9YKR6", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $d9f044bf472e22e3$export$defe85febe8b728c; });

var $k0oFl = parcelRequire("k0oFl");
const $d9f044bf472e22e3$export$defe85febe8b728c = (0, $k0oFl.defineMessages)({
    relationshipsSectionBaseTitle: {
        id: "fastshift.relationships-section.title",
        defaultMessage: "Help with migration",
        description: "Title for the relationships section"
    }
});

});





parcelRegister("1xCf5", function(module, exports) {
$parcel$export(module.exports, "PartnerRelationshipsSection", function () { return (parcelRequire("2FpC7")).PartnerRelationshipsSection; });

var $2FpC7 = parcelRequire("2FpC7");

});
parcelRegister("2FpC7", function(module, exports) {
$parcel$export(module.exports, "PartnerRelationshipsSection", function () { return $f7a015db0d06ea2f$export$d39d039c5fedc1cb; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("klVIP");
var $7vhjx = parcelRequire("7vhjx");
parcelRequire("aQGUe");
var $jCZb0 = parcelRequire("jCZb0");
parcelRequire("8lWkh");
var $Pftwr = parcelRequire("Pftwr");

var $560h0 = parcelRequire("560h0");
parcelRequire("4OJkD");
var $4jbZK = parcelRequire("4jbZK");
const $f7a015db0d06ea2f$export$d39d039c5fedc1cb = ({ relationships: relationships })=>{
    const champion = (0, $560h0.findChampion)(relationships);
    const relationshipMapping = (0, $560h0.mapRelationships)(relationships);
    const engineers = (0, $560h0.filterEngineers)(relationships);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $4jbZK.BaseRelationshipsSection), {
        children: [
            champion && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7vhjx.FastshiftChampionCard), {
                champion: champion
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jCZb0.FastshiftTeamCard), {
                relationships: relationshipMapping
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Pftwr.SupportEngineersCard), {
                engineers: engineers
            })
        ]
    });
};

});
parcelRegister("klVIP", function(module, exports) {
$parcel$export(module.exports, "FastshiftChampionCard", function () { return (parcelRequire("7vhjx")).FastshiftChampionCard; });

var $7vhjx = parcelRequire("7vhjx");

});
parcelRegister("7vhjx", function(module, exports) {
$parcel$export(module.exports, "FastshiftChampionCard", function () { return $2271e0f39b41188d$export$2843e45fafe457e7; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");
parcelRequire("kBd4f");
var $gnnwI = parcelRequire("gnnwI");
parcelRequire("9rglY");
var $bVDGo = parcelRequire("bVDGo");

var $jS9FY = parcelRequire("jS9FY");
const $2271e0f39b41188d$var$contentStyles = (0, $f6YGh.xcss)({
    height: "100%"
});
const $2271e0f39b41188d$export$2843e45fafe457e7 = ({ champion: champion })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gnnwI.BaseCard), {
        message: (0, $jS9FY.messages).fastshiftChampionCardTitle,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
            xcss: $2271e0f39b41188d$var$contentStyles,
            space: "space.400",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $jS9FY.messages).fastshiftChampionCardSubtitle))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bVDGo.CardRelationship), {
                    name: champion.name,
                    imageUrl: champion.imageUrl,
                    titleMessage: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $jS9FY.messages).fastshiftChampionTitle), {
                        values: {
                            title: champion.title
                        }
                    }))
                })
            ]
        })
    });
};

});
parcelRegister("jS9FY", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $a6d1ecead479505f$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $a6d1ecead479505f$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    fastshiftChampionCardTitle: {
        id: "fastshift.relationships-card.title.fastshift-champion",
        defaultMessage: "Your FastShift Champion",
        description: "Title for the FastShift champion card"
    },
    fastshiftChampionCardSubtitle: {
        id: "fastshift.relationships-card.subtitle.fastshift-champion",
        defaultMessage: "A dedicated expert for migration topics",
        description: "Subtitle for the FastShift champion card"
    },
    fastshiftChampionTitle: {
        id: "fastshift.relationships-card.relationship-name.fastshift-champion",
        defaultMessage: "{title}",
        description: "Name of the FastShift champion"
    }
});

});





parcelRegister("X2FaZ", function(module, exports) {
$parcel$export(module.exports, "NoRelationshipsSection", function () { return (parcelRequire("7XNgi")).NoRelationshipsSection; });

var $7XNgi = parcelRequire("7XNgi");

});
parcelRegister("7XNgi", function(module, exports) {
$parcel$export(module.exports, "NoRelationshipsSection", function () { return $80030ad208c6f077$export$37a75793f68c1ae9; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("hr1PU");
var $dxIOQ = parcelRequire("dxIOQ");
parcelRequire("50hUm");
var $bUpS8 = parcelRequire("bUpS8");
parcelRequire("4OJkD");
var $4jbZK = parcelRequire("4jbZK");
const $80030ad208c6f077$export$37a75793f68c1ae9 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $4jbZK.BaseRelationshipsSection), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bUpS8.RequestSupportCard), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dxIOQ.MigrationResourcesCard), {})
        ]
    });
};

});
parcelRegister("50hUm", function(module, exports) {
$parcel$export(module.exports, "RequestSupportCard", function () { return (parcelRequire("bUpS8")).RequestSupportCard; });

var $bUpS8 = parcelRequire("bUpS8");

});
parcelRegister("bUpS8", function(module, exports) {
$parcel$export(module.exports, "RequestSupportCard", function () { return $177999e5000191ef$export$104b222f73a621bd; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");

var $1HVQz = parcelRequire("1HVQz");

var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");
parcelRequire("iDqkL");
var $jCnLo = parcelRequire("jCnLo");
parcelRequire("kBd4f");
var $gnnwI = parcelRequire("gnnwI");
parcelRequire("9Kby0");
var $7bWX0 = parcelRequire("7bWX0");

var $6mMqN = parcelRequire("6mMqN");
const $177999e5000191ef$var$contentStyles = (0, $f6YGh.xcss)({
    height: "100%"
});
const $177999e5000191ef$export$104b222f73a621bd = ()=>{
    const [isModalOpen, setIsModalOpen] = (0, $1oC0p.useState)(false);
    const { sendRequestAssistanceButtonClickUIEvent: sendRequestAssistanceButtonClickUIEvent } = (0, $jCnLo.useRelationshipsAnalytics)();
    const handleRequestAssistanceClick = ()=>{
        sendRequestAssistanceButtonClickUIEvent();
        setIsModalOpen(true);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gnnwI.BaseCard), {
        message: (0, $6mMqN.messages).requestSupportCardTitle,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
            xcss: $177999e5000191ef$var$contentStyles,
            space: "space.100",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $6mMqN.messages).requestSupportCardDescription))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7bWX0.RequestAssistanceModal), {
                            isModalOpen: isModalOpen,
                            setIsModalOpen: setIsModalOpen
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), {
                            onClick: handleRequestAssistanceClick,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $6mMqN.messages).requestSupportCardButton))
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("6mMqN", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $100cd49746073358$export$defe85febe8b728c; });

var $k0oFl = parcelRequire("k0oFl");
const $100cd49746073358$export$defe85febe8b728c = (0, $k0oFl.defineMessages)({
    requestSupportCardTitle: {
        id: "fastshift.relationships-card.title.request-support",
        defaultMessage: "Reach out to your dedicated FastShift Team",
        description: "Title for the Request Support card"
    },
    requestSupportCardDescription: {
        id: "fastshift.relationships-card.description.request-support",
        defaultMessage: "Ask for guidance and assistance from a team of migration experts",
        description: "Description for the Request Support card"
    },
    requestSupportCardButton: {
        id: "fastshift.relationships-card.button.request-support",
        defaultMessage: "Request Assistance",
        description: "Button text for the Request Support card"
    }
});

});





parcelRegister("7E0l1", function(module, exports) {
$parcel$export(module.exports, "InternalRelationshipsSection", function () { return (parcelRequire("4VK5m")).InternalRelationshipsSection; });

var $4VK5m = parcelRequire("4VK5m");

});
parcelRegister("4VK5m", function(module, exports) {
$parcel$export(module.exports, "InternalRelationshipsSection", function () { return $b1db98a833b9be05$export$9a4ec837500c7c49; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("aQGUe");
var $jCZb0 = parcelRequire("jCZb0");
parcelRequire("8lWkh");
var $Pftwr = parcelRequire("Pftwr");

var $560h0 = parcelRequire("560h0");
parcelRequire("4OJkD");
var $4jbZK = parcelRequire("4jbZK");
const $b1db98a833b9be05$export$9a4ec837500c7c49 = ({ relationships: relationships })=>{
    const relationshipMapping = (0, $560h0.mapRelationships)(relationships);
    const engineers = (0, $560h0.filterEngineers)(relationships);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $4jbZK.BaseRelationshipsSection), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jCZb0.FastshiftTeamCard), {
                relationships: relationshipMapping
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Pftwr.SupportEngineersCard), {
                engineers: engineers
            })
        ]
    });
};

});



parcelRegister("jN2ro", function(module, exports) {
$parcel$export(module.exports, "RelationshipSection", function () { return $baea456447c203ff$export$3cd80b91cd232f4b; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $79ZK0 = parcelRequire("79ZK0");
var $f6YGh = parcelRequire("f6YGh");

var $7qFQI = parcelRequire("7qFQI");
parcelRequire("iTGju");
var $Riwsy = parcelRequire("Riwsy");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");

var $1uReC = parcelRequire("1uReC");
parcelRequire("bC7A8");
var $5PYTZ = parcelRequire("5PYTZ");
parcelRequire("7E0l1");
var $4VK5m = parcelRequire("4VK5m");
parcelRequire("X2FaZ");
var $7XNgi = parcelRequire("7XNgi");
parcelRequire("1xCf5");
var $2FpC7 = parcelRequire("2FpC7");
parcelRequire("iDqkL");
var $jbPzn = parcelRequire("jbPzn");
const $baea456447c203ff$var$loadingWrapperStyles = (0, $f6YGh.xcss)({
    padding: "space.500"
});
const $baea456447c203ff$var$renderSectionByUserType = ({ userType: userType, relationships: relationships })=>{
    switch(userType){
        case (0, $1uReC.USER_TYPE).CUSTOMER:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5PYTZ.CustomerRelationshipsSection), {
                relationships: relationships
            });
        case (0, $1uReC.USER_TYPE).PARTNER:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2FpC7.PartnerRelationshipsSection), {
                relationships: relationships
            });
        case (0, $1uReC.USER_TYPE).INTERNAL:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4VK5m.InternalRelationshipsSection), {
                relationships: relationships
            });
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7XNgi.NoRelationshipsSection), {});
    }
};
const $baea456447c203ff$export$3cd80b91cd232f4b = ()=>{
    const { pending: customerDomainPending, data: customerDomainData } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomain);
    const { pending: userDetailsPending, data: userDetailsData } = (0, $f7YG8.useFastshiftSelector)((state)=>state.userDetails);
    const relationships = (0, $1oC0p.useMemo)(()=>(customerDomainData === null || customerDomainData === void 0 ? void 0 : customerDomainData.relationships) || [], [
        customerDomainData === null || customerDomainData === void 0 ? void 0 : customerDomainData.relationships
    ]);
    // Fetch support requests data for RequestAssistanceModal
    (0, $Riwsy.useFetchSupportRequests)();
    // Use the page analytics hook (auto-fires section display event)
    (0, $jbPzn.useRelationshipsPageAnalytics)(relationships);
    if (customerDomainPending || userDetailsPending) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $79ZK0.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $baea456447c203ff$var$loadingWrapperStyles,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
            testId: "spinner",
            interactionName: "load",
            label: "Loading",
            size: "medium"
        })
    });
    // No staffs assigned to this customer domain
    if (relationships.length === 0) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7XNgi.NoRelationshipsSection), {});
    return $baea456447c203ff$var$renderSectionByUserType({
        userType: (userDetailsData === null || userDetailsData === void 0 ? void 0 : userDetailsData.userType) || "",
        relationships: relationships
    });
};

});


parcelRegister("LvLsc", function(module, exports) {
$parcel$export(module.exports, "PartnerWelcomeBanner", function () { return (parcelRequire("jeZYf")).PartnerWelcomeBanner; });
$parcel$export(module.exports, "CustomerWelcomeBanner", function () { return (parcelRequire("1e3AM")).CustomerWelcomeBanner; });
parcelRequire("9pdt8");
var $jeZYf = parcelRequire("jeZYf");
parcelRequire("jXSPk");
var $1e3AM = parcelRequire("1e3AM");

});
parcelRegister("9pdt8", function(module, exports) {
$parcel$export(module.exports, "PartnerWelcomeBanner", function () { return (parcelRequire("jeZYf")).PartnerWelcomeBanner; });

var $jeZYf = parcelRequire("jeZYf");

});
parcelRegister("jeZYf", function(module, exports) {
$parcel$export(module.exports, "PartnerWelcomeBanner", function () { return $bedae76b2bf046e6$export$67eb7e9c5afe3a4c; });

var $7wIVU = parcelRequire("7wIVU");

var $6M1ku = parcelRequire("6M1ku");

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("8r11b");
var $14kfB = parcelRequire("14kfB");

var $1zE7x = parcelRequire("1zE7x");
const $bedae76b2bf046e6$export$67eb7e9c5afe3a4c = (_param)=>{
    var props = (0, $7wIVU._)({}, (0, $6M1ku._)(_param));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $14kfB.BaseWelcomeBanner), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        subtitleMessage: (0, $1zE7x.messages).partnerWelcomeBannerSubtitle
    }));
};

});
parcelRegister("8r11b", function(module, exports) {
$parcel$export(module.exports, "BaseWelcomeBanner", function () { return (parcelRequire("14kfB")).BaseWelcomeBanner; });

var $14kfB = parcelRequire("14kfB");

});
parcelRegister("14kfB", function(module, exports) {
$parcel$export(module.exports, "BaseWelcomeBanner", function () { return $f75d0df470a285b9$export$cd351313b790cee4; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");

var $dTJrO = parcelRequire("dTJrO");

var $fmW7P = parcelRequire("fmW7P");
var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");

var $kpsDg = parcelRequire("kpsDg");

var $ib15X = parcelRequire("ib15X");
const $f75d0df470a285b9$var$headerContainerStyles = (0, $f6YGh.xcss)({
    borderRadius: "border.radius.200",
    backgroundColor: "color.background.selected"
});
const $f75d0df470a285b9$var$contentContainerStyles = (0, $f6YGh.xcss)({
    padding: "space.200",
    flex: 1
});
const $f75d0df470a285b9$var$cloudIconContainerStyles = (0, $f6YGh.xcss)({
    width: "350px"
});
const $f75d0df470a285b9$export$cd351313b790cee4 = ({ currentTime: currentTime, userName: userName, subtitleMessage: subtitleMessage })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $fmW7P.default), {
        xcss: $f75d0df470a285b9$var$headerContainerStyles,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                space: "space.250",
                xcss: $f75d0df470a285b9$var$contentContainerStyles,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fnHPc.FormattedDate), {
                                    weekday: "long",
                                    day: "numeric",
                                    month: "long",
                                    value: currentTime
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                                size: "medium",
                                children: userName ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $ib15X.messages).bannerTitleWithName), {
                                    values: {
                                        name: userName
                                    }
                                })) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $ib15X.messages).bannerTitleWithoutName))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $79ZK0.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, subtitleMessage))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fmW7P.default), {
                xcss: $f75d0df470a285b9$var$cloudIconContainerStyles,
                justifyContent: "end",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kpsDg.WelcomeBannerImage), {})
            })
        ]
    });
};

});
parcelRegister("kpsDg", function(module, exports) {
$parcel$export(module.exports, "WelcomeBannerImage", function () { return $f9e9a10b8b579727$export$678978e5abdb50f0; });

var $7VQPk = parcelRequire("7VQPk");
const $f9e9a10b8b579727$export$678978e5abdb50f0 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "340",
        height: "106",
        viewBox: "0 0 340 106",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M328.409 28.6662C327.932 28.6662 327.467 28.6721 326.996 28.6898C319.809 10.2571 304.704 2.54004 282.189 2.54004C249.919 2.54004 232.211 18.687 232.211 60.1296H361.817C358.164 39.5232 345.817 28.6662 328.404 28.6662H328.409Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M233.701 65.696H266.278C263.362 49.2368 253.501 40.5713 239.592 40.5713C226.638 40.5713 217.855 47.1514 212.653 65.696H233.701Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M239.592 40.5713C237.542 40.5713 235.604 40.7362 233.76 41.0897C232.741 46.7332 232.217 53.0541 232.217 60.1291H264.935C260.941 47.2928 251.839 40.5772 239.592 40.5772V40.5713Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M273.848 66.9864C274.231 66.9864 274.608 66.9923 274.985 67.0041C280.764 52.1943 292.899 45.9912 310.984 45.9912C336.916 45.9912 351.142 58.9689 351.142 92.2643H247.003C249.937 75.705 259.857 66.9864 273.854 66.9864H273.848Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M343.526 60.1235C336.822 50.2503 325.829 45.9912 310.99 45.9912C296.151 45.9912 285.117 50.2503 278.531 60.1235H343.526Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M151.237 58.562C151.982 58.7828 152.841 59.2341 153.562 59.4935C154.28 59.7904 155.149 60.2038 155.796 60.5183C155.796 60.5183 155.838 60.5633 155.9 60.6342C155.458 60.7412 154.933 60.8563 154.3 60.9473C154.264 60.9325 154.147 60.9257 154.132 60.8961C152.648 61.1483 151.121 60.9459 149.644 60.5577C148.16 60.1597 146.71 59.5904 145.203 59.0245C145.21 59.1325 145.083 59.167 145.01 59.0831L145.085 58.9806C142.999 58.3908 141.93 57.4337 139.974 56.9074C139.977 56.9072 140.242 56.8681 140.249 56.8677C137.183 55.3461 133.68 53.2607 130.053 51.1994C126.424 49.1552 122.634 47.1236 118.94 46.0516L118.971 46.0803L118.949 46.0917C119.274 46.2489 120.218 46.658 121.06 47.0594C121.479 47.2653 121.874 47.459 122.17 47.6044C122.459 47.7535 122.648 47.8508 122.648 47.8508C121.393 47.6123 120.167 47.1079 118.893 46.6165C117.626 46.128 116.292 45.657 114.938 45.5427L114.971 45.3851C116.15 45.4925 117.174 45.687 117.602 45.7129C116.587 45.4096 115.279 45.0895 113.772 45.0687C113.022 45.0378 112.224 45.1282 111.422 45.29C110.616 45.4587 109.819 45.7759 109.073 46.185C108.323 46.5943 107.663 47.1474 107.065 47.7239C106.498 48.3258 105.984 48.955 105.594 49.6041C105.255 50.1385 104.976 50.666 104.736 51.1778C103.232 50.1139 101.463 49.4853 99.6931 49.3275C98.6722 49.2378 97.6452 49.3178 96.6933 49.5763C95.7412 49.8315 94.871 50.2715 94.1486 50.8112C93.4127 51.3416 92.8786 52.0126 92.4376 52.6207C92.2473 52.9467 92.039 53.2398 91.9022 53.5424C91.7654 53.8449 91.6238 54.1207 91.53 54.3869C91.3457 54.9224 91.2041 55.3607 91.1564 55.6987C91.0957 56.0341 91.0734 56.2555 91.0951 56.349C91.1449 56.5358 91.3337 56.1862 91.7907 55.2487L91.831 55.4936C92.2171 54.5027 92.6952 53.6487 93.3195 52.9216C93.9441 52.2013 94.7282 51.6139 95.6978 51.2731C95.9506 51.1331 95.9898 51.141 95.9406 51.0186C96.0021 50.9676 96.1093 50.8733 96.0587 50.8356C95.9857 50.6909 96.1216 50.5916 96.3106 50.5162C96.4994 50.4375 96.7382 50.3864 96.8815 50.3577C96.8457 50.8948 98.3631 50.4409 100.126 50.6398C101.001 50.721 101.916 50.9286 102.647 51.1908C103.379 51.4497 103.928 51.7428 104.117 51.8842C104.095 52.004 104.166 52.1218 104.283 52.2436C104.16 52.5657 104.05 52.8701 103.957 53.1532C104.042 53.1245 104.158 52.6877 104.335 52.2948C104.389 52.3458 104.45 52.3965 104.518 52.4501C104.428 52.6788 104.345 52.9071 104.256 53.1358C104.082 53.6301 103.927 54.1233 103.768 54.5965C103.528 54.5122 103.8 53.9919 103.796 53.8668C103.747 53.9645 103.644 54.1838 103.522 54.516C103.464 54.6819 103.398 54.8754 103.324 55.0964C103.289 55.2068 103.25 55.3208 103.209 55.4417C103.168 55.5659 103.126 55.67 103.084 55.8891C102.984 56.264 103.007 56.7571 103.17 57.2217C103.336 57.6962 103.677 58.1132 104.109 58.3895C104.542 58.6657 105.074 58.8244 105.659 58.7531C105.804 58.738 105.952 58.6887 106.101 58.6462C106.246 58.5903 106.387 58.5111 106.527 58.4318C106.653 58.333 106.782 58.2273 106.901 58.1121C107.003 57.9876 107.105 57.8564 107.194 57.7192C107.266 57.5795 107.335 57.4367 107.397 57.2908C107.441 57.1563 107.475 57.0256 107.512 56.8914C107.6 56.6256 107.615 56.3369 107.643 56.0474C107.657 55.4709 107.57 54.8732 107.355 54.344C107.164 53.7963 106.862 53.3263 106.542 52.8742C106.368 52.6541 106.184 52.4413 105.992 52.2391C106.35 51.5411 106.757 50.8537 107.232 50.2065C107.696 49.6038 108.2 49.0294 108.784 48.5417C109.371 48.0639 110.021 47.6638 110.729 47.3721C112.149 46.7884 113.784 46.69 115.418 46.893C117.055 47.1025 118.699 47.5827 120.279 48.1883C121.863 48.7905 123.395 49.5141 124.856 50.2723C127.777 51.7956 130.422 53.4467 132.639 54.9567L132.595 54.8678C132.66 54.925 132.902 55.0328 132.926 55.1228C133.427 55.2969 134.295 55.6968 135.042 56.0496C135.785 56.4059 136.409 56.7049 136.409 56.7049C137.304 57.1134 138.201 57.5184 139.105 57.9061C139.105 57.9061 140.213 58.5527 141.601 59.217C142.985 59.8883 144.664 60.5356 145.683 60.6965C148.069 61.6177 150.577 62.3285 153.185 62.3733C153.185 62.3733 153.388 62.3616 153.708 62.3328C154.03 62.3141 154.464 62.2414 154.923 62.1606C155.509 62.0385 156.123 61.8369 156.597 61.6298C156.312 62.5268 155.127 64.0687 155.34 64.7877L154.66 65.7618C154.671 66.2826 154.528 66.8497 154.856 66.7866C155.184 66.7235 158.15 62.1423 158.262 60.5578L158.247 60.5723C158.247 60.5723 158.328 60.0901 158.375 60.128C157.542 59.506 156.4 58.5836 155.336 58.6861C155.072 58.4271 150.408 57.2422 151.244 58.565L151.237 58.562Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M193.108 39.0297C192.15 37.7183 190.267 36.3584 188.471 35.4958C185.049 30.734 196.317 38.4705 197.785 39.544C195.606 38.997 197.582 40.1529 198.518 40.3705C196.864 38.5777 203.003 42.1928 201.294 41.9887C201.484 42.1319 202.23 42.7362 201.904 42.1645C202.587 42.3202 210.215 46.2996 207.756 46.5295C203.507 44.7862 198.876 41.7879 193.109 39.0331L193.108 39.0297Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M193.065 51.8485C192.669 52.1496 192.056 52.1811 191.991 51.6128C190.421 52.3807 186.682 50.8245 183.661 50.6519C176.274 47.1145 182.525 47.5252 186.512 49.4196C185.157 49.7285 186.396 50.0442 187.014 49.8909C185.913 48.9054 189.858 49.8707 188.814 50.3127C189.026 50.4525 189.441 50.5281 189.199 50.2405C189.516 50.0184 194.54 51.0446 193.068 51.8474L193.065 51.8485Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M197.873 54.4197C197.787 54.0239 197.424 53.3936 196.735 53.4804C196.007 52.2502 197.679 51.4936 197.921 52.3934C197.899 52.0664 199.965 52.6325 198.997 52.9967C199.239 53.998 199.863 51.5095 200.357 53.3587C200.286 52.6269 202.313 53.0972 201.891 53.918C201.867 54.1176 201.268 54.8246 201.411 54.0105C201.193 55.0523 200.988 54.0161 200.925 54.0409C200.795 54.5314 200.812 54.0296 200.729 54.2303C200.714 54.9565 200.33 53.6304 200.316 54.334C199.472 55.2203 198.731 53.6901 197.874 54.423L197.873 54.4197Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M208.653 25.8541C212.145 27.3876 213.257 32.3331 214.38 33.4055C214.164 31.8618 216.056 34.8229 216.273 35.4419C215.896 35.0304 215.849 35.5119 216.172 35.8513C217.098 35.0541 221.641 43.0903 218.033 39.5892C216.489 37.1547 208.724 30.6924 208.654 25.8574L208.653 25.8541Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M202.947 32.1266C202.504 32.2179 202.082 32.1029 202.41 31.6293C201.664 32.3927 201.867 31.2054 201.771 31.1659C200.934 31.6406 201.222 30.3044 200.861 30.8343C199.48 30.814 198.897 28.6186 197.724 28.4461C194.055 21.614 201.113 27.8722 199.721 28.2274C199.531 29.3843 201.069 27.7854 201.467 29.6177C200.487 29.2118 204.606 31.5584 202.948 32.13L202.947 32.1266Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M205.434 36.5984C204.503 31.7577 208.36 35.9986 207.097 35.9388C206.713 36.5025 207.632 36.2601 207.517 35.9376C207.9 35.9715 208.479 36.4811 207.875 36.6976C210.288 36.7495 208.096 39.1603 208.385 37.8839C207.632 38.6348 208.062 37.691 207.999 37.682C207.625 38.0248 207.919 37.6222 207.743 37.7485C207.402 38.283 207.732 37.1171 207.37 37.6437C206.293 37.9729 206.311 36.2872 205.431 36.5995L205.434 36.5984Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M187.816 63.2548C187.518 63.6471 186.998 63.8434 186.803 63.3033C184.474 64.7374 179.838 64.2355 176.047 63.9705C172.557 61.7524 182.298 62.0966 180.825 62.9219C181.841 63.7631 181.907 61.6106 183.887 62.6074C183.159 62.7337 184.406 63.1972 183.983 62.7033C184.214 62.4045 188.943 62.1013 187.817 63.2581L187.816 63.2548Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M194.312 64.5159C189.41 62.8853 192.552 61.8075 195.92 62.5292C195.144 63.1561 195.914 63.1776 196.311 62.8574C195.67 62.218 197.217 62.2733 197.663 62.5417C197.51 62.5665 197.42 62.8709 197.797 62.8653C197.602 61.758 202.445 62.5553 199.811 63.5802C199.624 62.7447 199.938 64.4022 198.95 63.3863C198.935 63.8948 198.769 63.4054 198.716 63.6185C198.945 64.3086 197.851 63.1404 198.114 63.8192C197.18 64.8407 195.135 63.6477 194.316 64.5182L194.312 64.5159Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M180.442 76.9104C183.41 76.0073 186.216 75.2745 189.809 74.6702C187.158 76.2566 192.391 74.5643 190.139 74.6014C192.451 74.2813 200.727 70.7252 200.922 72.7492C202.508 72.5587 176.261 81.1714 180.442 76.9104Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M189.609 85.8882C190.699 85.1227 191.582 84.5803 193.102 84.0887C192.701 85.0189 193.408 84.6593 193.607 84.1869C192.727 83.932 194.151 83.2352 194.669 83.2544C193.978 84.0031 198.751 80.086 197.088 83.1315C196.535 82.4967 197.575 83.7957 196.223 83.3784C196.967 84.2613 188.607 89.0668 189.609 85.8882Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M201.249 79.5465C201.642 79.2951 201.669 78.8204 202.212 79.1237C204.168 77.0738 203.298 79.9942 203.991 78.5306C203.221 78.2578 204.718 77.3039 204.682 78.1011C204.765 76.642 207.935 76.9488 206.214 77.782C206.742 78.7066 205.868 78.0853 205.829 78.1507C206.062 78.6029 205.73 78.2252 205.797 78.4281C205.991 79.2163 201.133 82.2978 201.25 79.5499L201.249 79.5465Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M75.3463 24.3047H8.51752V41.3431H75.3463V24.3047Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M67.1936 37.0171H16.6672V45.0462H67.1936V37.0171Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M67.1936 41.3393V37.0137H16.6672V41.3393H67.1936Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M75.3564 89.2064H8.52765V72.168H75.3564V89.2064Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M67.1936 76.4934H16.6672V68.4644H67.1936V76.4934Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M67.2069 72.168V76.4936H16.6805V72.168H67.2069Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M75.3463 48.355H8.51752V65.3934H75.3463V48.355Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M52.2257 55.551C52.2826 55.5109 52.3495 55.4808 52.4231 55.454C52.4231 55.454 52.5034 55.4908 52.5971 55.531C52.6907 55.5678 52.7978 55.6046 52.9182 55.5778C53.052 55.715 53.1457 55.8822 53.1859 56.0528C53.1859 56.0528 53.2193 56.0997 53.2628 56.1532C53.3096 56.2101 53.3632 56.2803 53.4267 56.3171C53.507 56.3606 53.5973 56.3941 53.681 56.4041C53.7646 56.4142 53.8416 56.3907 53.8851 56.3138C53.9285 56.2402 53.9386 56.1097 53.8616 55.9424C53.8683 55.9358 53.875 55.919 53.8884 55.9123C53.7713 55.7451 53.7111 55.5811 53.6241 55.4038C53.5405 55.2332 53.4234 55.0559 53.2461 54.9522C53.2227 54.9957 53.1892 55.0191 53.1959 54.9923L53.2327 54.9422C53.0855 54.9221 53.0018 54.8585 52.9082 54.8117C52.8145 54.7648 52.7074 54.7381 52.5736 54.8184L52.6171 54.7448C52.219 54.6779 51.7105 54.728 51.299 55.0057C50.8875 55.2734 50.6132 55.7584 50.6199 56.1967H50.64C50.6734 56.1599 50.7303 56.0562 50.7872 55.9726C50.844 55.8889 50.8976 55.8187 50.8976 55.8187C50.9879 55.996 50.9511 56.0963 50.8976 56.2235C50.844 56.3439 50.7671 56.4878 50.7972 56.6249L50.7203 56.635C50.7035 56.5112 50.6667 56.4041 50.6366 56.3539C50.5697 56.5814 50.5998 56.9762 50.8005 57.2873C50.9879 57.6051 51.3157 57.8092 51.5432 57.8427C51.56 57.7891 51.3726 57.8326 51.4496 57.6486C51.5399 57.7022 51.6469 57.7222 51.7373 57.759C51.6938 57.8795 51.6503 57.8192 51.6336 57.8326C51.657 57.8795 51.9012 58.0334 52.2792 58.0534C52.6539 58.0835 53.1524 57.9196 53.4602 57.5918C53.7813 57.2706 53.8817 56.8357 53.8449 56.6082C53.8048 56.3673 53.7077 56.3372 53.5639 56.5145L53.5003 56.4911C53.4602 56.6617 53.3899 56.8123 53.2026 56.8959C53.2026 56.9193 53.1892 56.916 53.2461 56.9494C53.2528 56.9595 53.2628 56.9795 53.2862 56.9896C53.4267 57.0665 53.3397 57.0866 53.3297 57.1134C53.1256 56.9662 53.0587 57.0531 52.9918 57.1803C52.9282 57.3074 52.8346 57.4847 52.7911 57.4914C52.6807 57.284 52.6506 57.5416 52.5703 57.4579C52.5703 57.4479 52.5703 57.3944 52.5736 57.3843C52.5335 57.3141 52.4097 57.4278 52.2659 57.4747C52.122 57.5248 52.0016 57.5282 52.112 57.3977C51.9581 57.2505 51.8242 57.1334 51.7005 56.9929C51.58 56.8558 51.4663 56.6918 51.4261 56.4911C51.386 56.2904 51.4261 56.0662 51.5533 55.9123C51.6771 55.7551 51.8811 55.6882 52.0384 55.7518L52.025 55.725C52.025 55.725 52.0384 55.715 52.0517 55.7451C52.0618 55.6949 52.1019 55.638 52.1454 55.6046C52.1889 55.5644 52.2324 55.5477 52.2324 55.5477L52.2257 55.551ZM51.1217 56.5915C51.1217 56.5915 51.1351 56.5915 51.1384 56.5915C51.1117 56.5982 51.1518 56.6985 51.1485 56.7052L51.0715 56.7253C50.9779 56.6885 51.0581 56.5647 51.1384 56.5145C51.2254 56.4643 51.2923 56.4543 51.192 56.5747C51.212 56.5781 51.1485 56.5915 51.1217 56.5948V56.5915ZM51.6436 57.3676C51.6436 57.3676 51.6704 57.4011 51.6871 57.4178C51.5131 57.468 51.3726 57.3442 51.2923 57.2003C51.2087 57.0531 51.1786 56.8959 51.0782 56.7788C51.2622 56.7721 51.3224 56.8156 51.3525 56.8825C51.3827 56.9461 51.386 57.0398 51.4161 57.0899C51.5466 57.12 51.5733 57.2672 51.6403 57.371L51.6436 57.3676ZM53.1557 57.1836L53.1256 57.1568L53.1323 57.1502C53.1323 57.1502 53.1491 57.1669 53.1524 57.1702C53.1591 57.1769 53.1624 57.1836 53.1557 57.1836ZM52.0986 55.3771C52.0919 55.444 52.0216 55.4172 52.0417 55.2867C52.0584 55.3068 52.0819 55.2399 52.0986 55.3771ZM51.8744 57.575C51.9146 57.4546 52.0049 57.4446 51.9648 57.6219C51.9313 57.6152 51.9012 57.5951 51.8744 57.575ZM52.7744 55.3436C52.858 55.2299 52.7844 55.367 52.7509 55.4473C52.7543 55.4272 52.7376 55.4105 52.771 55.357V55.347L52.7744 55.3436ZM53.1925 55.5477C53.2461 55.5075 53.2996 55.4975 53.3096 55.5075C53.2929 55.5644 53.1557 55.5979 53.1925 55.5477ZM53.5405 56.2502C53.6174 56.2402 53.6475 56.2603 53.5706 56.2736C53.5137 56.2736 53.4669 56.2603 53.5539 56.2469C53.5505 56.2469 53.5438 56.2469 53.5405 56.2502ZM52.3461 57.9096C52.3227 58.1438 52.1989 57.9564 52.1354 58.0133C52.1655 57.7858 52.2592 57.9631 52.3093 57.9163C52.3261 57.9163 52.3361 57.9163 52.3461 57.9096ZM51.2421 55.3403C51.105 55.1931 51.3091 55.2232 51.3124 55.1696L51.3592 55.2332C51.3224 55.2867 51.3325 55.347 51.2421 55.3403ZM51.2455 57.6252C51.1752 57.672 51.192 57.5851 51.1752 57.5683C51.2522 57.4847 51.3392 57.5349 51.2455 57.6252ZM50.7169 56.7052C50.8373 56.6751 50.7872 56.7353 50.8039 56.7487C50.7771 56.7454 50.6968 56.742 50.6935 56.732C50.6935 56.7219 50.7069 56.7186 50.7136 56.7086L50.7169 56.7052ZM51.2622 55.4272C51.2355 55.4607 51.1987 55.4942 51.1685 55.5276L51.1083 55.4741L51.2087 55.3704L51.2622 55.4272ZM50.8909 55.7317L50.8206 55.6949C50.7872 55.5912 50.9678 55.6848 50.8909 55.7283V55.7317ZM51.7139 55.0291C51.7139 55.0291 51.6938 55.0291 51.6871 55.0291C51.5968 55.076 51.6202 54.7515 51.7139 55.0291ZM52.2123 54.8518C52.2123 54.8518 52.2357 54.815 52.2458 54.8184C52.3194 54.8318 52.2391 55.0191 52.2123 54.8518Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M59.1744 55.551C59.2313 55.5109 59.2982 55.4808 59.3718 55.454C59.3718 55.454 59.4521 55.4908 59.5457 55.531C59.6394 55.5678 59.7465 55.6046 59.8669 55.5778C60.0007 55.715 60.0944 55.8822 60.1345 56.0528C60.1345 56.0528 60.168 56.0997 60.2115 56.1532C60.2583 56.2101 60.3118 56.2803 60.3754 56.3171C60.4557 56.3606 60.546 56.3941 60.6297 56.4041C60.7133 56.4142 60.7902 56.3907 60.8337 56.3138C60.8772 56.2402 60.8873 56.1097 60.8103 55.9424C60.817 55.9358 60.8237 55.919 60.8371 55.9123C60.72 55.7451 60.6598 55.5811 60.5728 55.4038C60.4891 55.2332 60.3721 55.0559 60.1947 54.9522C60.1713 54.9957 60.1379 55.0191 60.1446 54.9923L60.1814 54.9422C60.0342 54.9221 59.9505 54.8585 59.8569 54.8117C59.7632 54.7648 59.6561 54.7381 59.5223 54.8184L59.5658 54.7448C59.1677 54.6779 58.6592 54.728 58.2477 55.0057C57.8362 55.2734 57.5619 55.7584 57.5686 56.1967H57.5886C57.6221 56.1599 57.679 56.0562 57.7358 55.9726C57.7927 55.8889 57.8462 55.8187 57.8462 55.8187C57.9366 55.996 57.8998 56.0963 57.8462 56.2235C57.7927 56.3439 57.7158 56.4878 57.7459 56.6249L57.6689 56.635C57.6522 56.5112 57.6154 56.4041 57.5853 56.3539C57.5184 56.5814 57.5485 56.9762 57.7492 57.2873C57.9366 57.6051 58.2644 57.8092 58.4919 57.8427C58.5086 57.7891 58.3213 57.8326 58.3982 57.6486C58.4886 57.7022 58.5956 57.7222 58.6859 57.759C58.6425 57.8795 58.599 57.8192 58.5822 57.8326C58.6057 57.8795 58.8499 58.0334 59.2279 58.0534C59.6026 58.0835 60.1011 57.9196 60.4089 57.5918C60.73 57.2706 60.8304 56.8357 60.7936 56.6082C60.7534 56.3673 60.6564 56.3372 60.5126 56.5145L60.449 56.4911C60.4089 56.6617 60.3386 56.8123 60.1513 56.8959C60.1513 56.9193 60.1379 56.916 60.1947 56.9494C60.2014 56.9595 60.2115 56.9795 60.2349 56.9896C60.3754 57.0665 60.2884 57.0866 60.2784 57.1134C60.0743 56.9662 60.0074 57.0531 59.9405 57.1803C59.8769 57.3074 59.7833 57.4847 59.7398 57.4914C59.6294 57.284 59.5993 57.5416 59.519 57.4579C59.519 57.4479 59.519 57.3944 59.5223 57.3843C59.4822 57.3141 59.3584 57.4278 59.2145 57.4747C59.0707 57.5248 58.9502 57.5282 59.0606 57.3977C58.9067 57.2505 58.7729 57.1334 58.6491 56.9929C58.5287 56.8558 58.415 56.6918 58.3748 56.4911C58.3347 56.2904 58.3748 56.0662 58.5019 55.9123C58.6257 55.7551 58.8298 55.6882 58.987 55.7518L58.9737 55.725C58.9737 55.725 58.987 55.715 59.0004 55.7451C59.0105 55.6949 59.0506 55.638 59.0941 55.6046C59.1376 55.5644 59.1811 55.5477 59.1811 55.5477L59.1744 55.551ZM58.0704 56.5915C58.0704 56.5915 58.0838 56.5915 58.0871 56.5915C58.0603 56.5982 58.1005 56.6985 58.0971 56.7052L58.0202 56.7253C57.9265 56.6885 58.0068 56.5647 58.0871 56.5145C58.1741 56.4643 58.241 56.4543 58.1406 56.5747C58.1607 56.5781 58.0971 56.5915 58.0704 56.5948V56.5915ZM58.5923 57.3676C58.5923 57.3676 58.619 57.4011 58.6358 57.4178C58.4618 57.468 58.3213 57.3442 58.241 57.2003C58.1574 57.0531 58.1273 56.8959 58.0269 56.7788C58.2109 56.7721 58.2711 56.8156 58.3012 56.8825C58.3313 56.9461 58.3347 57.0398 58.3648 57.0899C58.4953 57.12 58.522 57.2672 58.5889 57.371L58.5923 57.3676ZM60.1044 57.1836L60.0743 57.1568L60.081 57.1502C60.081 57.1502 60.0977 57.1669 60.1011 57.1702C60.1078 57.1769 60.1111 57.1836 60.1044 57.1836ZM59.0473 55.3771C59.0406 55.444 58.9703 55.4172 58.9904 55.2867C59.0071 55.3068 59.0305 55.2399 59.0473 55.3771ZM58.8231 57.575C58.8633 57.4546 58.9536 57.4446 58.9134 57.6219C58.88 57.6152 58.8499 57.5951 58.8231 57.575ZM59.723 55.3436C59.8067 55.2299 59.7331 55.367 59.6996 55.4473C59.703 55.4272 59.6862 55.4105 59.7197 55.357V55.347L59.723 55.3436ZM60.1412 55.5477C60.1947 55.5075 60.2483 55.4975 60.2583 55.5075C60.2416 55.5644 60.1044 55.5979 60.1412 55.5477ZM60.4891 56.2502C60.5661 56.2402 60.5962 56.2603 60.5193 56.2736C60.4624 56.2736 60.4156 56.2603 60.5025 56.2469C60.4992 56.2469 60.4925 56.2469 60.4891 56.2502ZM59.2948 57.9096C59.2714 58.1438 59.1476 57.9564 59.0841 58.0133C59.1142 57.7858 59.2078 57.9631 59.258 57.9163C59.2747 57.9163 59.2848 57.9163 59.2948 57.9096ZM58.1908 55.3403C58.0537 55.1931 58.2577 55.2232 58.2611 55.1696L58.3079 55.2332C58.2711 55.2867 58.2811 55.347 58.1908 55.3403ZM58.1942 57.6252C58.1239 57.672 58.1406 57.5851 58.1239 57.5683C58.2009 57.4847 58.2878 57.5349 58.1942 57.6252ZM57.6656 56.7052C57.786 56.6751 57.7358 56.7353 57.7526 56.7487C57.7258 56.7454 57.6455 56.742 57.6422 56.732C57.6422 56.7219 57.6555 56.7186 57.6622 56.7086L57.6656 56.7052ZM58.2109 55.4272C58.1841 55.4607 58.1473 55.4942 58.1172 55.5276L58.057 55.4741L58.1574 55.3704L58.2109 55.4272ZM57.8395 55.7317L57.7693 55.6949C57.7358 55.5912 57.9165 55.6848 57.8395 55.7283V55.7317ZM58.6625 55.0291C58.6625 55.0291 58.6425 55.0291 58.6358 55.0291C58.5454 55.076 58.5689 54.7515 58.6625 55.0291ZM59.161 54.8518C59.161 54.8518 59.1844 54.815 59.1945 54.8184C59.2681 54.8318 59.1878 55.0191 59.161 54.8518Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M66.1227 55.551C66.1796 55.5109 66.2465 55.4808 66.3201 55.454C66.3201 55.454 66.4004 55.4908 66.4941 55.531C66.5878 55.5678 66.6948 55.6046 66.8152 55.5778C66.9491 55.715 67.0427 55.8822 67.0829 56.0528C67.0829 56.0528 67.1163 56.0997 67.1598 56.1532C67.2067 56.2101 67.2602 56.2803 67.3238 56.3171C67.4041 56.3606 67.4944 56.3941 67.578 56.4041C67.6616 56.4142 67.7386 56.3907 67.7821 56.3138C67.8256 56.2402 67.8356 56.1097 67.7587 55.9424C67.7654 55.9358 67.772 55.919 67.7854 55.9123C67.6683 55.7451 67.6081 55.5811 67.5211 55.4038C67.4375 55.2332 67.3204 55.0559 67.1431 54.9522C67.1197 54.9957 67.0862 55.0191 67.0929 54.9923L67.1297 54.9422C66.9825 54.9221 66.8989 54.8585 66.8052 54.8117C66.7115 54.7648 66.6045 54.7381 66.4707 54.8184L66.5142 54.7448C66.1161 54.6779 65.6075 54.728 65.1961 55.0057C64.7846 55.2734 64.5102 55.7584 64.5169 56.1967H64.537C64.5704 56.1599 64.6273 56.0562 64.6842 55.9726C64.7444 55.8889 64.7946 55.8187 64.7946 55.8187C64.8849 55.996 64.8481 56.0963 64.7946 56.2235C64.7411 56.3439 64.6641 56.4878 64.6942 56.6249L64.6173 56.635C64.6006 56.5112 64.5638 56.4041 64.5336 56.3539C64.4667 56.5814 64.4968 56.9762 64.6976 57.2873C64.8849 57.6051 65.2128 57.8092 65.4403 57.8427C65.457 57.7891 65.2696 57.8326 65.3466 57.6486C65.4369 57.7022 65.544 57.7222 65.6343 57.759C65.5908 57.8795 65.5473 57.8192 65.5306 57.8326C65.554 57.8795 65.7982 58.0334 66.1763 58.0534C66.551 58.0835 67.0494 57.9196 67.3572 57.5918C67.6784 57.2706 67.7787 56.8357 67.7419 56.6082C67.7018 56.3673 67.6048 56.3372 67.4609 56.5145L67.3974 56.4911C67.3572 56.6617 67.287 56.8123 67.0996 56.8959C67.0996 56.9193 67.0862 56.916 67.1431 56.9494C67.1498 56.9595 67.1598 56.9795 67.1833 56.9896C67.3238 57.0665 67.2368 57.0866 67.2267 57.1134C67.0227 56.9662 66.9558 57.0531 66.8888 57.1803C66.8253 57.3074 66.7316 57.4847 66.6881 57.4914C66.5777 57.284 66.5476 57.5416 66.4673 57.4579C66.4673 57.4479 66.4673 57.3944 66.4707 57.3843C66.4305 57.3141 66.3067 57.4278 66.1629 57.4747C66.019 57.5248 65.8986 57.5282 66.009 57.3977C65.8551 57.2505 65.7213 57.1334 65.5975 56.9929C65.4771 56.8558 65.3633 56.6918 65.3232 56.4911C65.283 56.2904 65.3232 56.0662 65.4503 55.9123C65.5741 55.7551 65.7782 55.6882 65.9354 55.7518L65.922 55.725C65.922 55.725 65.9354 55.715 65.9488 55.7451C65.9588 55.6949 65.999 55.638 66.0424 55.6046C66.0859 55.5644 66.1294 55.5477 66.1294 55.5477L66.1227 55.551ZM65.0187 56.5915C65.0187 56.5915 65.0321 56.5915 65.0355 56.5915C65.0087 56.5982 65.0488 56.6985 65.0455 56.7052L64.9686 56.7253C64.8749 56.6885 64.9552 56.5647 65.0355 56.5145C65.1224 56.4643 65.1894 56.4543 65.089 56.5747C65.1091 56.5781 65.0455 56.5915 65.0187 56.5948V56.5915ZM65.5406 57.3676C65.5406 57.3676 65.5674 57.4011 65.5841 57.4178C65.4102 57.468 65.2696 57.3442 65.1894 57.2003C65.1057 57.0531 65.0756 56.8959 64.9752 56.7788C65.1592 56.7721 65.2195 56.8156 65.2496 56.8825C65.2797 56.9461 65.283 57.0398 65.3131 57.0899C65.4436 57.12 65.4704 57.2672 65.5373 57.371L65.5406 57.3676ZM67.0528 57.1836L67.0227 57.1568L67.0294 57.1502C67.0294 57.1502 67.0461 57.1669 67.0494 57.1702C67.0561 57.1769 67.0595 57.1836 67.0528 57.1836ZM65.9956 55.3771C65.9889 55.444 65.9187 55.4172 65.9387 55.2867C65.9555 55.3068 65.9789 55.2399 65.9956 55.3771ZM65.7715 57.575C65.8116 57.4546 65.9019 57.4446 65.8618 57.6219C65.8283 57.6152 65.7982 57.5951 65.7715 57.575ZM66.6714 55.3436C66.755 55.2299 66.6814 55.367 66.648 55.4473C66.6513 55.4272 66.6346 55.4105 66.668 55.357V55.347L66.6714 55.3436ZM67.0896 55.5477C67.1431 55.5075 67.1966 55.4975 67.2067 55.5075C67.1899 55.5644 67.0528 55.5979 67.0896 55.5477ZM67.4375 56.2502C67.5144 56.2402 67.5446 56.2603 67.4676 56.2736C67.4107 56.2736 67.3639 56.2603 67.4509 56.2469C67.4475 56.2469 67.4408 56.2469 67.4375 56.2502ZM66.2432 57.9096C66.2198 58.1438 66.096 57.9564 66.0324 58.0133C66.0625 57.7858 66.1562 57.9631 66.2064 57.9163C66.2231 57.9163 66.2331 57.9163 66.2432 57.9096ZM65.1392 55.3403C65.002 55.1931 65.2061 55.2232 65.2094 55.1696L65.2563 55.2332C65.2195 55.2867 65.2295 55.347 65.1392 55.3403ZM65.1425 57.6252C65.0723 57.672 65.089 57.5851 65.0723 57.5683C65.1492 57.4847 65.2362 57.5349 65.1425 57.6252ZM64.6173 56.7052C64.7377 56.6751 64.6875 56.7353 64.7043 56.7487C64.6775 56.7454 64.5972 56.742 64.5939 56.732C64.5939 56.7219 64.6072 56.7186 64.6139 56.7086L64.6173 56.7052ZM65.1593 55.4272C65.1325 55.4607 65.0957 55.4942 65.0656 55.5276L65.0054 55.4741L65.1057 55.3704L65.1593 55.4272ZM64.7879 55.7317L64.7176 55.6949C64.6842 55.5912 64.8649 55.6848 64.7879 55.7283V55.7317ZM65.6109 55.0291C65.6109 55.0291 65.5908 55.0291 65.5841 55.0291C65.4938 55.076 65.5172 54.7515 65.6109 55.0291ZM66.1094 54.8518C66.1094 54.8518 66.1328 54.815 66.1428 54.8184C66.2164 54.8318 66.1361 55.0191 66.1094 54.8518Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M66.2636 30.8318C66.3205 30.7916 66.3874 30.7615 66.461 30.7348C66.461 30.7348 66.5413 30.7716 66.6349 30.8117C66.7286 30.8485 66.8357 30.8853 66.9561 30.8586C67.0899 30.9957 67.1836 31.163 67.2237 31.3336C67.2237 31.3336 67.2572 31.3804 67.3007 31.434C67.3475 31.4908 67.4011 31.5611 67.4646 31.5979C67.5449 31.6414 67.6352 31.6748 67.7189 31.6849C67.8025 31.6949 67.8795 31.6715 67.9229 31.5946C67.9664 31.521 67.9765 31.3905 67.8995 31.2232C67.9062 31.2165 67.9129 31.1998 67.9263 31.1931C67.8092 31.0258 67.749 30.8619 67.662 30.6846C67.5784 30.514 67.4613 30.3367 67.284 30.233C67.2605 30.2764 67.2271 30.2999 67.2338 30.2731L67.2706 30.2229C67.1234 30.2028 67.0397 30.1393 66.9461 30.0924C66.8524 30.0456 66.7453 30.0188 66.6115 30.0991L66.655 30.0255C66.2569 29.9586 65.7484 30.0088 65.3369 30.2865C64.9254 30.5541 64.6511 31.0392 64.6578 31.4775H64.6678H64.6779C64.7113 31.4407 64.7682 31.337 64.8251 31.2533C64.8819 31.1697 64.9355 31.0994 64.9355 31.0994C65.0258 31.2767 64.989 31.3771 64.9355 31.5042C64.8819 31.6247 64.805 31.7685 64.8351 31.9057L64.7582 31.9157C64.7414 31.7919 64.7046 31.6849 64.6745 31.6347C64.6076 31.8622 64.6377 32.257 64.8384 32.5681C65.0258 32.8859 65.3536 33.09 65.5811 33.1234C65.5979 33.0699 65.4105 33.1134 65.4875 32.9294C65.5778 32.9829 65.6848 33.003 65.7752 33.0398C65.7317 33.1602 65.6882 33.1 65.6715 33.1134C65.6949 33.1602 65.9391 33.3141 66.3171 33.3342C66.6918 33.3643 67.1903 33.2004 67.4981 32.8725C67.8192 32.5514 67.9196 32.1164 67.8828 31.889C67.8427 31.6481 67.7456 31.618 67.6018 31.7953L67.5382 31.7719C67.4981 31.9425 67.4278 32.093 67.2405 32.1767C67.2405 32.2001 67.2271 32.1967 67.284 32.2302C67.2907 32.2402 67.3007 32.2603 67.3241 32.2703C67.4646 32.3473 67.3776 32.3674 67.3676 32.3941C67.1635 32.2469 67.0966 32.3339 67.0297 32.461C66.9661 32.5882 66.8725 32.7655 66.829 32.7722C66.7186 32.5647 66.6885 32.8223 66.6082 32.7387C66.6082 32.7287 66.6082 32.6751 66.6115 32.6651C66.5714 32.5948 66.4476 32.7086 66.3038 32.7554C66.1599 32.8056 66.0395 32.809 66.1499 32.6785C65.996 32.5313 65.8622 32.4142 65.7384 32.2737C65.6179 32.1365 65.5042 31.9726 65.464 31.7719C65.4239 31.5711 65.464 31.347 65.5912 31.1931C65.715 31.0359 65.919 30.969 66.0763 31.0325L66.0629 31.0058C66.0629 31.0058 66.0763 30.9957 66.0896 31.0258C66.0997 30.9756 66.1398 30.9188 66.1833 30.8853C66.2268 30.8452 66.2703 30.8284 66.2703 30.8284L66.2636 30.8318ZM65.163 31.8722C65.163 31.8722 65.1763 31.8722 65.1797 31.8722C65.1529 31.8789 65.1931 31.9793 65.1897 31.986L65.1128 32.006C65.0191 31.9692 65.0994 31.8455 65.1797 31.7953C65.2667 31.7451 65.3336 31.7351 65.2332 31.8555C65.2533 31.8588 65.1897 31.8722 65.163 31.8756V31.8722ZM65.6848 32.6484C65.6848 32.6484 65.7116 32.6818 65.7283 32.6986C65.5544 32.7487 65.4139 32.625 65.3336 32.4811C65.2499 32.3339 65.2198 32.1767 65.1195 32.0596C65.3035 32.0529 65.3637 32.0964 65.3938 32.1633C65.4239 32.2268 65.4272 32.3205 65.4574 32.3707C65.5878 32.4008 65.6146 32.548 65.6815 32.6517L65.6848 32.6484ZM67.1936 32.4644L67.1635 32.4376L67.1702 32.4309C67.1702 32.4309 67.1869 32.4476 67.1903 32.451C67.197 32.4577 67.2003 32.4644 67.1936 32.4644ZM66.1365 30.6578C66.1298 30.7247 66.0595 30.698 66.0796 30.5675C66.0963 30.5876 66.1198 30.5207 66.1365 30.6578ZM65.9123 32.8558C65.9525 32.7354 66.0428 32.7253 66.0027 32.9026C65.9692 32.8959 65.9391 32.8759 65.9123 32.8558ZM66.8123 30.6244C66.8959 30.5106 66.8223 30.6478 66.7888 30.7281C66.7922 30.708 66.7755 30.6913 66.8089 30.6378V30.6277L66.8123 30.6244ZM67.2338 30.8284C67.2873 30.7883 67.3408 30.7783 67.3509 30.7883C67.3342 30.8452 67.197 30.8786 67.2338 30.8284ZM67.5784 31.531C67.6553 31.521 67.6854 31.541 67.6085 31.5544C67.5516 31.5544 67.5048 31.541 67.5917 31.5276C67.5884 31.5276 67.5817 31.5276 67.5784 31.531ZM66.384 33.1903C66.3606 33.4245 66.2368 33.2372 66.1733 33.294C66.2034 33.0666 66.2971 33.2439 66.3472 33.197C66.364 33.197 66.374 33.197 66.384 33.1903ZM65.28 30.621C65.1429 30.4738 65.347 30.5039 65.3503 30.4504L65.3971 30.514C65.3603 30.5675 65.3704 30.6277 65.28 30.621ZM65.2834 32.906C65.2131 32.9528 65.2299 32.8658 65.2131 32.8491C65.2901 32.7655 65.3771 32.8156 65.2834 32.906ZM64.7582 31.986C64.8786 31.9559 64.8284 32.0161 64.8451 32.0295C64.8184 32.0261 64.7381 32.0228 64.7347 32.0127C64.7347 32.0027 64.7481 31.9994 64.7548 31.9893L64.7582 31.986ZM65.3035 30.708C65.2767 30.7415 65.2399 30.7749 65.2098 30.8084L65.1496 30.7548L65.2499 30.6511L65.3035 30.708ZM64.9288 31.0124L64.8585 30.9756C64.8251 30.8719 65.0057 30.9656 64.9288 31.0091V31.0124ZM65.7517 30.3099C65.7517 30.3099 65.7317 30.3099 65.725 30.3099C65.6347 30.3567 65.6581 30.0322 65.7517 30.3099ZM66.2502 30.1326C66.2502 30.1326 66.2736 30.0958 66.2837 30.0991C66.3573 30.1125 66.277 30.2999 66.2502 30.1326Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M66.1698 81.0369C66.2267 80.9967 66.2936 80.9666 66.3672 80.9398C66.3672 80.9398 66.4475 80.9767 66.5411 81.0168C66.6348 81.0536 66.7419 81.0904 66.8623 81.0636C66.9961 81.2008 67.0898 81.3681 67.1299 81.5387C67.1299 81.5387 67.1634 81.5855 67.2069 81.6391C67.2537 81.6959 67.3073 81.7662 67.3708 81.803C67.4511 81.8465 67.5414 81.8799 67.6251 81.89C67.7087 81.9 67.7857 81.8766 67.8291 81.7996C67.8726 81.726 67.8827 81.5956 67.8057 81.4283C67.8124 81.4216 67.8191 81.4049 67.8325 81.3982C67.7154 81.2309 67.6552 81.067 67.5682 80.8897C67.4846 80.7191 67.3675 80.5417 67.1902 80.438C67.1667 80.4815 67.1333 80.5049 67.14 80.4782L67.1768 80.428C67.0296 80.4079 66.9459 80.3444 66.8523 80.2975C66.7586 80.2507 66.6515 80.2239 66.5177 80.3042L66.5612 80.2306C66.1631 80.1637 65.6546 80.2139 65.2431 80.4916C64.8316 80.7592 64.5573 81.2443 64.564 81.6825H64.574H64.5841C64.6175 81.6457 64.6744 81.542 64.7313 81.4584C64.7881 81.3748 64.8417 81.3045 64.8417 81.3045C64.932 81.4818 64.8952 81.5822 64.8417 81.7093C64.7881 81.8297 64.7112 81.9736 64.7413 82.1108L64.6643 82.1208C64.6476 81.997 64.6108 81.89 64.5807 81.8398C64.5138 82.0673 64.5439 82.462 64.7446 82.7732C64.932 83.091 65.2598 83.295 65.4873 83.3285C65.5041 83.275 65.3167 83.3185 65.3937 83.1345C65.484 83.188 65.591 83.2081 65.6814 83.2449C65.6379 83.3653 65.5944 83.3051 65.5777 83.3185C65.6011 83.3653 65.8453 83.5192 66.2233 83.5393C66.598 83.5694 67.0965 83.4054 67.4043 83.0776C67.7254 82.7564 67.8258 82.3215 67.789 82.094C67.7489 81.8532 67.6518 81.823 67.508 82.0004L67.4444 81.9769C67.4043 82.1476 67.334 82.2981 67.1467 82.3817C67.1467 82.4052 67.1333 82.4018 67.1902 82.4353C67.1969 82.4453 67.2069 82.4654 67.2303 82.4754C67.3708 82.5524 67.2838 82.5724 67.2738 82.5992C67.0697 82.452 67.0028 82.539 66.9359 82.6661C66.8723 82.7932 66.7787 82.9705 66.7352 82.9772C66.6248 82.7698 66.5947 83.0274 66.5144 82.9438C66.5144 82.9337 66.5144 82.8802 66.5177 82.8702C66.4776 82.7999 66.3538 82.9137 66.2099 82.9605C66.0661 83.0107 65.9457 83.014 66.0561 82.8836C65.9022 82.7364 65.7683 82.6193 65.6446 82.4788C65.5241 82.3416 65.4104 82.1777 65.3702 81.9769C65.3301 81.7762 65.3702 81.5521 65.4974 81.3982C65.6211 81.2409 65.8252 81.174 65.9825 81.2376L65.9691 81.2108C65.9691 81.2108 65.9825 81.2008 65.9958 81.2309C66.0059 81.1807 66.046 81.1239 66.0895 81.0904C66.133 81.0503 66.1765 81.0335 66.1765 81.0335L66.1698 81.0369ZM65.0658 82.0773C65.0658 82.0773 65.0792 82.0773 65.0825 82.0773C65.0558 82.084 65.0959 82.1844 65.0926 82.1911L65.0156 82.2111C64.9219 82.1743 65.0022 82.0505 65.0825 82.0004C65.1695 81.9502 65.2364 81.9401 65.1361 82.0606C65.1561 82.0639 65.0926 82.0773 65.0658 82.0806V82.0773ZM65.5877 82.8534C65.5877 82.8534 65.6145 82.8869 65.6312 82.9036C65.4572 82.9538 65.3167 82.83 65.2364 82.6862C65.1528 82.539 65.1227 82.3817 65.0223 82.2647C65.2063 82.258 65.2665 82.3015 65.2966 82.3684C65.3267 82.4319 65.3301 82.5256 65.3602 82.5758C65.4907 82.6059 65.5174 82.7531 65.5843 82.8568L65.5877 82.8534ZM67.0998 82.6694L67.0697 82.6427L67.0764 82.636C67.0764 82.636 67.0931 82.6527 67.0965 82.6561C67.1032 82.6628 67.1065 82.6694 67.0998 82.6694ZM66.0393 80.8629C66.0326 80.9298 65.9624 80.903 65.9825 80.7726C65.9992 80.7926 66.0226 80.7257 66.0393 80.8629ZM65.8152 83.0609C65.8553 82.9404 65.9457 82.9304 65.9055 83.1077C65.8721 83.101 65.8419 83.0809 65.8152 83.0609ZM66.7151 80.8294C66.7987 80.7157 66.7251 80.8529 66.6917 80.9332C66.695 80.9131 66.6783 80.8964 66.7118 80.8428V80.8328L66.7151 80.8294ZM67.1366 81.0369C67.1902 80.9967 67.2437 80.9867 67.2537 80.9967C67.237 81.0536 67.0998 81.0871 67.1366 81.0369ZM67.4812 81.7394C67.5582 81.7294 67.5883 81.7495 67.5113 81.7628C67.4545 81.7628 67.4076 81.7495 67.4946 81.7361C67.4913 81.7361 67.4846 81.7361 67.4812 81.7394ZM66.2869 83.3954C66.2635 83.6296 66.1397 83.4423 66.0761 83.4991C66.1062 83.2716 66.1999 83.4489 66.2501 83.4021C66.2668 83.4021 66.2769 83.4021 66.2869 83.3954ZM65.1829 80.8261C65.0457 80.6789 65.2498 80.709 65.2531 80.6555L65.3 80.7191C65.2632 80.7726 65.2732 80.8328 65.1829 80.8261ZM65.1862 83.111C65.116 83.1579 65.1327 83.0709 65.116 83.0542C65.1929 82.9705 65.2799 83.0207 65.1862 83.111ZM64.661 82.1944C64.7814 82.1643 64.7313 82.2245 64.748 82.2379C64.7212 82.2345 64.6409 82.2312 64.6376 82.2212C64.6376 82.2111 64.651 82.2078 64.6577 82.1977L64.661 82.1944ZM65.2063 80.9131C65.1795 80.9465 65.1427 80.98 65.1126 81.0134L65.0524 80.9599L65.1528 80.8562L65.2063 80.9131ZM64.835 81.2175L64.7647 81.1807C64.7313 81.077 64.9119 81.1707 64.835 81.2142V81.2175ZM65.6546 80.515C65.6546 80.515 65.6345 80.515 65.6278 80.515C65.5375 80.5618 65.5609 80.2373 65.6546 80.515ZM66.1564 80.3377C66.1564 80.3377 66.1798 80.3009 66.1899 80.3042C66.2635 80.3176 66.1832 80.5049 66.1564 80.3377Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M79.0497 22.4373C79.1167 22.5009 79.1769 22.5645 79.2404 22.6314C79.2404 22.6314 79.2538 22.7451 79.2973 22.8689C79.3274 22.996 79.3876 23.1399 79.5081 23.2034C79.5415 23.4276 79.5415 23.6551 79.5449 23.8792C79.5449 23.8792 79.6151 24.1536 79.7423 24.2372C79.8225 24.2907 79.9129 24.3242 79.9965 24.3342C80.1638 24.3509 80.3009 24.2439 80.224 23.9395C80.234 23.9361 80.2441 23.9227 80.2575 23.9194C80.1939 23.7621 80.1839 23.6049 80.1939 23.441C80.2073 23.277 80.2207 23.1064 80.1604 22.9492C80.1136 22.9659 80.0735 22.9626 80.0969 22.9492L80.1571 22.9392C79.9865 22.7585 80.137 22.5611 79.8627 22.444L79.9463 22.4373C79.8761 22.2768 79.8125 22.1028 79.7188 21.9288C79.6352 21.7515 79.5449 21.5675 79.4311 21.3936C79.3308 21.2129 79.2036 21.0456 79.0732 20.8884C78.9494 20.7245 78.7988 20.594 78.655 20.4769V20.4869L78.6449 20.4903C78.6483 20.584 78.7955 20.8784 78.7955 20.8784C78.4074 20.9018 78.4743 20.4903 78.2602 20.333L78.3137 20.2762C78.394 20.3531 78.4944 20.3899 78.5479 20.3966C78.4342 20.226 78.2368 19.9784 77.9825 19.8045C77.7417 19.6104 77.4573 19.49 77.2633 19.4432C77.2432 19.5 77.4105 19.4465 77.3402 19.6305C77.2532 19.5837 77.1596 19.5536 77.0793 19.5168C77.1395 19.403 77.1663 19.4632 77.1863 19.4498C77.1663 19.403 76.9722 19.2625 76.6845 19.1153C76.5373 19.0517 76.37 18.9748 76.1894 18.9146C76.0054 18.8644 75.818 18.8075 75.6307 18.7774C75.4433 18.754 75.2627 18.7339 75.1055 18.7272C74.9449 18.7339 74.8077 18.7506 74.7073 18.7774C74.5033 18.8276 74.4564 18.9179 74.6404 19.0651L74.6204 19.1287C74.8077 19.1688 74.9683 19.1889 75.1423 19.3428C75.169 19.3361 75.1724 19.3495 75.1791 19.2826C75.1891 19.2725 75.2025 19.2558 75.2025 19.229C75.2192 19.0718 75.2727 19.1421 75.2995 19.1421C75.2493 19.3863 75.3898 19.4197 75.5604 19.3963C75.7277 19.3896 75.9318 19.3294 75.9719 19.3495C75.9217 19.5803 76.1325 19.3997 76.1492 19.5168C76.1425 19.5234 76.1057 19.5669 76.0991 19.5736C76.0991 19.6539 76.2998 19.6539 76.4737 19.664C76.6444 19.6773 76.7782 19.7141 76.6209 19.8011C76.9153 20.1925 77.4038 20.4669 77.8721 20.8482C78.3338 21.2196 78.7353 21.7214 78.7487 22.2098L78.7721 22.1898C78.7721 22.1898 78.7888 22.2132 78.762 22.2333C78.8858 22.2667 79.0531 22.4474 79.0531 22.4474L79.0497 22.4373ZM78.026 20.5639C78.026 20.5639 78.016 20.5706 78.016 20.5739C78.0327 20.5538 77.929 20.4836 77.929 20.4769L77.9825 20.4167C78.1833 20.3899 78.026 20.972 77.9825 20.6241C77.9625 20.6308 78.006 20.584 78.0227 20.5605L78.026 20.5639ZM77.1462 19.9182C77.1328 19.9015 77.1161 19.8814 77.096 19.8647C77.2767 19.8312 77.4272 19.9249 77.5476 20.052C77.6681 20.1825 77.7852 20.3163 77.9391 20.3765C77.638 20.5739 77.5543 20.2962 77.4573 20.1959C77.3068 20.1825 77.2198 20.032 77.1462 19.9216V19.9182ZM75.45 19.2491L75.4433 19.2893H75.4333C75.4333 19.2893 75.44 19.2625 75.44 19.2592C75.44 19.2525 75.4467 19.2458 75.45 19.2491ZM79.1568 22.2333C79.0899 22.2433 79.0899 22.1563 79.2237 22.1496C79.2103 22.1697 79.2806 22.1797 79.1568 22.2333ZM76.9087 19.684C76.8484 19.8011 76.7447 19.781 76.8217 19.6171C76.8551 19.6305 76.8819 19.6573 76.9087 19.684ZM79.5583 22.9024C79.6988 22.889 79.5482 22.9258 79.4679 22.9592C79.4847 22.9458 79.4847 22.9224 79.5482 22.909L79.5583 22.9024ZM79.7556 23.364C79.8225 23.3573 79.8694 23.3774 79.8761 23.3908C79.8292 23.4343 79.6988 23.3908 79.7556 23.364ZM79.8593 24.177C79.9363 24.177 79.9631 24.1937 79.8861 24.2037C79.8292 24.2037 79.7824 24.1803 79.8727 24.1736C79.8694 24.1736 79.8627 24.1736 79.8593 24.177ZM76.5607 19.2257C76.6711 19.025 76.7046 19.2257 76.7748 19.1989C76.6745 19.3997 76.6511 19.2123 76.5942 19.2357C76.5808 19.229 76.5708 19.229 76.5607 19.229V19.2257ZM79.1267 21.3233C79.294 21.2096 79.2204 21.3969 79.2772 21.4036L79.2103 21.4471C79.1635 21.4103 79.1033 21.4103 79.1267 21.3266V21.3233ZM77.5242 19.6305C77.5844 19.5736 77.5777 19.6573 77.5978 19.6673C77.5343 19.7643 77.4473 19.7309 77.5276 19.6305H77.5242ZM78.2736 20.226C78.1933 20.323 78.2 20.2461 78.1833 20.2461C78.2067 20.2327 78.2703 20.1858 78.2769 20.1959C78.2803 20.2026 78.2736 20.216 78.2736 20.226ZM79.0397 21.3333C79.0129 21.2999 78.9862 21.2631 78.9628 21.2263L79.0297 21.1794L79.11 21.2898L79.0431 21.3333H79.0397ZM78.8724 20.9085L78.9327 20.8583C79.0297 20.865 78.8758 20.9954 78.8724 20.9085ZM79.4144 21.7682C79.4144 21.7682 79.4144 21.7482 79.4144 21.7415C79.3642 21.6645 79.6787 21.6411 79.4144 21.7682ZM79.6954 22.1664C79.6954 22.1664 79.7356 22.173 79.7356 22.1831C79.7489 22.2466 79.5482 22.2567 79.6954 22.1664Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M83.5428 20.6575C83.6264 20.7612 83.7 20.8683 83.7803 20.9753C83.7803 20.9753 83.8138 21.1426 83.8807 21.3299C83.9309 21.524 84.0078 21.7414 84.1383 21.8518C84.1784 22.0191 84.1818 22.1897 84.1985 22.357C84.2086 22.5276 84.2353 22.6949 84.232 22.8621C84.232 22.8621 84.3089 23.277 84.436 23.4075C84.5163 23.4877 84.61 23.5413 84.6936 23.5513C84.8643 23.5781 84.9947 23.4208 84.9111 22.9759C84.9211 22.9692 84.9278 22.9525 84.9446 22.9491C84.881 22.7183 84.8576 22.4908 84.8576 22.2566V21.902C84.8408 21.7849 84.8174 21.6678 84.7806 21.5507C84.7338 21.5675 84.6936 21.5641 84.7137 21.5407L84.7739 21.5307C84.6736 21.3901 84.6602 21.2597 84.6334 21.1359C84.6033 21.0121 84.5531 20.8984 84.4026 20.798H84.4896C84.3926 20.5705 84.3022 20.3129 84.1684 20.062C84.1048 19.9349 84.0413 19.8044 83.9777 19.6706C83.9075 19.5401 83.8272 19.4163 83.7502 19.2859C83.6699 19.1587 83.5963 19.0283 83.5094 18.9045C83.4157 18.7874 83.3254 18.6669 83.235 18.5532C83.0611 18.3157 82.8436 18.1216 82.6429 17.941V17.951L82.6328 17.9544C82.6462 18.0112 82.7131 18.1417 82.78 18.2588C82.8436 18.3759 82.9072 18.4763 82.9072 18.4763C82.4422 18.4194 82.4288 17.9075 82.1243 17.6733L82.1812 17.6165C82.3016 17.7269 82.4355 17.7938 82.499 17.8139C82.412 17.6901 82.2849 17.5563 82.1444 17.4057C82.0708 17.3321 81.9972 17.2552 81.9169 17.1816C81.8299 17.1147 81.743 17.0477 81.656 16.9775C81.308 16.6965 80.8999 16.5125 80.6323 16.4188C80.6155 16.479 80.833 16.4523 80.7694 16.6463C80.6456 16.576 80.5118 16.5225 80.3914 16.469C80.4516 16.3552 80.5018 16.4288 80.5252 16.4121C80.4884 16.3586 80.1974 16.1679 79.7758 15.9638C79.5584 15.8768 79.3142 15.7698 79.0566 15.6828C78.7923 15.6125 78.5179 15.5323 78.247 15.4821C77.976 15.4453 77.715 15.4152 77.4842 15.3984C77.2534 15.4018 77.0526 15.4152 76.9054 15.4386C76.611 15.4854 76.5341 15.5757 76.8084 15.7229L76.7783 15.7865C77.0593 15.8333 77.2935 15.8501 77.5645 16.0173C77.6046 16.014 77.608 16.0274 77.618 15.9605C77.6314 15.9504 77.6515 15.9371 77.6481 15.9069C77.6649 15.7497 77.7485 15.8233 77.7886 15.8267C77.7318 16.0709 77.9459 16.1144 78.1968 16.1043C78.441 16.1177 78.7321 16.0776 78.7923 16.1043C78.7521 16.3385 79.0331 16.1746 79.0733 16.3017C79.0666 16.3084 79.0198 16.3485 79.0097 16.3552C79.0198 16.4389 79.3142 16.4723 79.5651 16.5091C79.8126 16.556 80.0033 16.6229 79.8026 16.6831C80.3011 17.1581 81.0571 17.5997 81.753 18.1952C82.4455 18.7773 83.0343 19.5435 83.1547 20.246L83.1748 20.2226C83.1748 20.2226 83.1982 20.2594 83.1748 20.2828C83.3187 20.3564 83.5428 20.6508 83.5428 20.6508V20.6575ZM81.8835 17.9042C81.8835 17.9042 81.8734 17.9109 81.8734 17.9142C81.8902 17.8941 81.743 17.7837 81.7396 17.7737L81.7931 17.7135C82.0374 17.7302 81.9905 18.406 81.8467 17.9677C81.8232 17.9744 81.8667 17.9243 81.8835 17.9008V17.9042ZM80.5654 16.9407C80.5419 16.9173 80.5152 16.8939 80.4851 16.8704C80.7259 16.8738 80.9501 17.0043 81.1408 17.1816C81.3281 17.3656 81.5188 17.5429 81.7296 17.6566C81.3917 17.8172 81.201 17.4659 81.0538 17.3254C80.8497 17.2685 80.6925 17.0845 80.5687 16.9407H80.5654ZM78.0195 15.9605L78.0128 16.0006H77.9994C77.9994 16.0006 78.0061 15.9739 78.0094 15.9705C78.0128 15.9638 78.0195 15.9571 78.0228 15.9605H78.0195ZM83.6131 20.3832C83.5395 20.3832 83.5227 20.2627 83.6699 20.2761C83.6599 20.3029 83.7402 20.3296 83.6131 20.3832ZM80.1873 16.6296C80.1271 16.7467 79.9766 16.7032 80.0535 16.5426C80.1037 16.5627 80.1438 16.5961 80.1873 16.6296ZM84.155 21.4136C84.2989 21.4136 84.145 21.447 84.068 21.4838C84.0848 21.4671 84.0814 21.4303 84.145 21.4203L84.155 21.4136ZM84.4093 22.1094C84.4762 22.1094 84.5264 22.1429 84.5331 22.1596C84.4896 22.2198 84.3524 22.1429 84.4093 22.1094ZM84.5531 23.3205C84.6301 23.3205 84.6568 23.3472 84.5832 23.3573C84.5264 23.3573 84.4795 23.3205 84.5699 23.3138C84.5665 23.3138 84.5598 23.3138 84.5565 23.3171L84.5531 23.3205ZM79.6219 16.0742C79.7457 15.8802 79.8227 16.0943 79.9163 16.0742C79.8126 16.2716 79.7457 16.0675 79.6721 16.0843C79.652 16.0776 79.6353 16.0709 79.6219 16.0709V16.0742ZM83.3956 19.1353C83.5629 19.0216 83.516 19.2524 83.583 19.2758L83.516 19.316C83.4558 19.2557 83.3856 19.2424 83.3956 19.1353ZM81.017 16.6965C81.0872 16.6463 81.0939 16.7366 81.1207 16.7533C81.0571 16.8504 80.9334 16.7968 81.017 16.6965ZM82.1177 17.5563C82.0407 17.6533 82.0307 17.5629 82.0072 17.5563C82.034 17.5462 82.1043 17.5061 82.1143 17.5161C82.121 17.5261 82.1143 17.5362 82.1143 17.5529L82.1177 17.5563ZM83.2986 19.1286C83.2584 19.0784 83.2183 19.0249 83.1815 18.968L83.2484 18.9245C83.2886 18.9781 83.3254 19.0316 83.3655 19.0851L83.2986 19.1286ZM83.0075 18.5398L83.0678 18.4896C83.1848 18.5197 83.031 18.6536 83.0075 18.5398ZM83.8104 19.791C83.8104 19.791 83.8104 19.7643 83.8038 19.7542C83.7335 19.6405 84.0781 19.6672 83.8104 19.791ZM84.1918 20.3899C84.2086 20.3965 84.2353 20.4066 84.2387 20.42C84.2621 20.5136 84.0513 20.4902 84.1918 20.3899Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M25.2883 57.0332L25.7031 56.9228C25.7031 56.9228 26.4224 57.0299 26.7101 56.8325L27.794 56.9061C27.794 56.9061 28.2457 56.8526 28.3828 56.7288C28.4665 56.6519 28.5233 56.5615 28.5334 56.4779C28.5568 56.3106 28.4029 56.1701 27.968 56.2303C27.9613 56.2203 27.9446 56.2103 27.9446 56.1969C27.4829 56.3207 27.0413 56.1099 26.5696 56.1367C26.5763 56.1868 26.5595 56.2236 26.5462 56.2002L26.5495 56.14C26.235 56.2638 26.041 56.0664 25.7566 56.2772C25.7566 56.2772 25.7901 56.1935 25.7901 56.1969C24.8099 56.237 23.4817 56.1567 22.4212 56.2604L22.4279 56.2705V56.2805C22.5249 56.3407 22.9933 56.4311 22.9933 56.4311C22.642 56.7288 22.2372 56.421 21.8625 56.4344V56.3541C22.0265 56.3541 22.1737 56.3207 22.2305 56.2872C21.6484 56.1801 20.4775 56.1634 19.9188 56.2872C19.9322 56.3474 20.1062 56.2136 20.1497 56.411C20.0058 56.411 19.8653 56.4444 19.7281 56.4411C19.7281 56.314 19.8051 56.3575 19.8218 56.334C19.5876 56.1935 14.8404 56.0631 15.9745 56.6017L15.9444 56.6686C16.2388 56.6953 16.4797 56.7188 16.7841 56.8459C16.8276 56.8359 16.831 56.8459 16.831 56.7823C16.841 56.7723 16.8611 56.7522 16.8577 56.7255C16.8544 56.5649 16.9481 56.6284 16.9915 56.6251C16.9414 57.1236 17.9383 56.6719 18.0721 56.692C18.0989 56.9295 18.3331 56.6987 18.4134 56.7991C18.4067 56.8091 18.3732 56.8593 18.3665 56.8693C18.4401 57.0199 19.6177 56.595 19.2798 56.8894C20.6749 57.3879 23.1974 56.7756 24.7028 57.2072L24.6928 57.1771C24.6928 57.1771 24.743 57.1737 24.7497 57.2072C24.8969 57.1102 25.2883 57.0399 25.2883 57.0399V57.0332ZM21.8391 56.7589C21.8391 56.7589 21.8391 56.7723 21.8391 56.7756C21.8391 56.7522 21.6451 56.7656 21.6384 56.7623V56.682C21.8358 56.5281 22.2874 57.0667 21.8592 56.8325C21.8458 56.8526 21.8458 56.7857 21.8425 56.7589H21.8391ZM20.1195 56.7556C20.0861 56.7489 20.0493 56.7422 20.0091 56.7355C20.4541 56.4846 21.0563 56.7924 21.5447 56.6753C21.3774 57.0299 20.9793 56.8425 20.7686 56.8225C20.5578 56.9028 20.3069 56.8057 20.1195 56.7556ZM17.2491 56.7054V56.7455H17.2324C17.2324 56.7355 17.2324 56.7221 17.2391 56.7154C17.2391 56.7054 17.2458 56.6987 17.2491 56.702V56.7054ZM25.0507 56.8459C25.0173 56.9095 24.8935 56.8727 24.9771 56.7489C24.9972 56.7689 25.0608 56.7087 25.0507 56.8459ZM19.6177 56.6619C19.6177 56.7924 19.4538 56.8191 19.4538 56.6385C19.5107 56.6385 19.5642 56.6485 19.6177 56.6619ZM26.2685 56.7087C26.312 56.5682 26.2986 56.7255 26.3153 56.8124C26.3053 56.7924 26.2651 56.7857 26.2718 56.7221V56.7087H26.2685ZM27.0346 56.6251C27.0446 56.5582 27.0881 56.5147 27.1082 56.5113C27.1617 56.5615 27.058 56.6853 27.0346 56.6251ZM28.2925 56.6084C28.2925 56.5314 28.3226 56.5047 28.3326 56.5816C28.3326 56.6385 28.2925 56.682 28.2891 56.595C28.2891 56.5983 28.2891 56.605 28.2925 56.6084ZM18.8617 56.3842C18.9051 56.1567 19.0557 56.3407 19.136 56.2805C19.1193 56.508 18.9754 56.3407 18.9118 56.3809C18.8918 56.3809 18.875 56.3809 18.8617 56.3876V56.3842ZM23.8163 56.4277C23.8163 56.227 23.9835 56.3876 24.0371 56.3407V56.421C23.9534 56.4411 23.9033 56.4946 23.8196 56.4277H23.8163ZM20.3838 56.314C20.4139 56.2337 20.4675 56.3106 20.5009 56.3073C20.5009 56.421 20.3638 56.4411 20.3838 56.3106V56.314ZM21.7755 56.3407C21.7822 56.4645 21.7153 56.4043 21.6953 56.4177C21.7086 56.3909 21.7354 56.314 21.7521 56.3173C21.7622 56.3173 21.7655 56.334 21.7789 56.3441L21.7755 56.3407ZM23.7561 56.5047C23.6925 56.5047 23.6222 56.5047 23.5553 56.5047V56.4244C23.6256 56.4244 23.6925 56.4244 23.7561 56.4244V56.5047ZM23.1037 56.3809V56.3006C23.1974 56.2236 23.2107 56.4277 23.1037 56.3809ZM24.5958 56.411C24.5958 56.411 24.569 56.4009 24.5623 56.4009C24.4285 56.411 24.6158 56.1199 24.5958 56.411ZM25.3017 56.3307C25.3017 56.3307 25.3318 56.2972 25.3485 56.2972C25.4422 56.3073 25.3385 56.498 25.3017 56.3307Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("ib15X", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $79ac9a6eda7c334f$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $79ac9a6eda7c334f$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    bannerTitleWithName: {
        id: "fastshift.dashboard.base-welcome-banner.title-with-name",
        defaultMessage: "Hello, {name}!",
        description: "Greeting message for the welcome banner"
    },
    bannerTitleWithoutName: {
        id: "fastshift.dashboard.base-welcome-banner.title-without-name",
        defaultMessage: "Hello!",
        description: "Greeting message for the welcome banner when the user's name is not available"
    }
});

});



parcelRegister("1zE7x", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $03bcc800a1849b05$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $03bcc800a1849b05$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    partnerWelcomeBannerSubtitle: {
        id: "fastshift.dashboard.partner-welcome-banner.subtitle",
        defaultMessage: "Welcome to the FastShift Portal. Select a customer to view more details about their migration progress.",
        description: "Subtitle for the partner welcome banner"
    }
});

});



parcelRegister("jXSPk", function(module, exports) {
$parcel$export(module.exports, "CustomerWelcomeBanner", function () { return (parcelRequire("1e3AM")).CustomerWelcomeBanner; });

var $1e3AM = parcelRequire("1e3AM");

});
parcelRegister("1e3AM", function(module, exports) {
$parcel$export(module.exports, "CustomerWelcomeBanner", function () { return $1d94a2ba48540d76$export$da496bb680f0711d; });

var $7wIVU = parcelRequire("7wIVU");

var $6M1ku = parcelRequire("6M1ku");

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("8r11b");
var $14kfB = parcelRequire("14kfB");

var $h07SN = parcelRequire("h07SN");
const $1d94a2ba48540d76$export$da496bb680f0711d = (_param)=>{
    var props = (0, $7wIVU._)({}, (0, $6M1ku._)(_param));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $14kfB.BaseWelcomeBanner), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        subtitleMessage: (0, $h07SN.messages).customerWelcomeBannerSubtitle
    }));
};

});
parcelRegister("h07SN", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $176f968b85e2ae4b$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $176f968b85e2ae4b$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    customerWelcomeBannerSubtitle: {
        id: "fastshift.dashboard.customer-welcome-banner.subtitle",
        defaultMessage: "Welcome to the FastShift Portal.",
        description: "Subtitle for the customer welcome banner"
    }
});

});




parcelRegister("6ezXX", function(module, exports) {
$parcel$export(module.exports, "useSummary", function () { return (parcelRequire("1c2IO")).useSummary; });
$parcel$export(module.exports, "useDashboardPageAnalytics", function () { return (parcelRequire("6aLna")).useDashboardPageAnalytics; });
$parcel$export(module.exports, "useDashboardUIAnalytics", function () { return (parcelRequire("kLOFc")).useDashboardUIAnalytics; });
parcelRequire("1c2IO");
parcelRequire("6aLna");
parcelRequire("kLOFc");

});
parcelRegister("1c2IO", function(module, exports) {
$parcel$export(module.exports, "useSummary", function () { return $c7b03e6331ba5e03$export$80b235df19ed566d; });

var $1oC0p = parcelRequire("1oC0p");

var $8Bmsc = parcelRequire("8Bmsc");

var $f7YG8 = parcelRequire("f7YG8");

var $PE2DD = parcelRequire("PE2DD");
const $c7b03e6331ba5e03$var$CONSOLIDATED_INSIGHTS_STATUS_HAS_ERRORS = "HAS_ERRORS";
const $c7b03e6331ba5e03$export$80b235df19ed566d = ()=>{
    const dispatch = (0, $f7YG8.useFastshiftDispatch)();
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const loadL1Assessments = (0, $1oC0p.useCallback)((orgId)=>{
        dispatch((0, $8Bmsc.getL1Assessments)({
            stargateClient: stargateClient,
            orgId: orgId
        }));
    }, [
        dispatch,
        stargateClient
    ]);
    const loadMigrationPlanTotals = (0, $1oC0p.useCallback)((orgId)=>{
        dispatch((0, $8Bmsc.getMigrationPlanTotals)({
            stargateClient: stargateClient,
            orgId: orgId
        }));
    }, [
        dispatch,
        stargateClient
    ]);
    const loadInstances = (0, $1oC0p.useCallback)((orgId)=>{
        dispatch((0, $8Bmsc.getInstances)({
            stargateClient: stargateClient,
            orgId: orgId
        }));
    }, [
        dispatch,
        stargateClient
    ]);
    const { l1Assessments: l1Assessments, migrationPlanTotals: migrationPlanTotals, instances: instances, selectedDomainOrg: selectedDomainOrg } = (0, $f7YG8.useFastshiftSelector)((state)=>({
            l1Assessments: state.l1Assessments,
            migrationPlanTotals: state.migrationPlanTotals,
            instances: state.instances,
            selectedDomainOrg: state.selectedDomainOrg
        }));
    const isL1AssessmentsLoading = l1Assessments.pending || !selectedDomainOrg;
    const isMigrationPlanTotalsLoading = migrationPlanTotals.pending || !selectedDomainOrg;
    const isInstancesLoading = instances.pending || !selectedDomainOrg;
    const summaryData = {
        dataCenter: {
            count: l1Assessments.data.length
        },
        areaImprovement: {
            count: l1Assessments.data.filter(({ consolidatedInsightsStatus: consolidatedInsightsStatus })=>consolidatedInsightsStatus === $c7b03e6331ba5e03$var$CONSOLIDATED_INSIGHTS_STATUS_HAS_ERRORS).length
        },
        deletedApps: {
            count: instances.data.totalCount
        },
        migrationCompleted: {
            count: migrationPlanTotals.data.totalPlansCompleted
        },
        migrationInProgress: {
            count: migrationPlanTotals.data.totalPlansRunning
        },
        unsuccessfulMigration: {
            count: migrationPlanTotals.data.totalPlansUnsuccessful
        }
    };
    // isEmpty means there is no data and no errors and not loading
    const isEmpty = l1Assessments.data.length === 0 && instances.data.totalCount === 0 && migrationPlanTotals.data.totalPlansCompleted === 0 && migrationPlanTotals.data.totalPlansUnsuccessful === 0 && migrationPlanTotals.data.totalPlansRunning === 0 && !isL1AssessmentsLoading && !isMigrationPlanTotalsLoading && !isInstancesLoading && !l1Assessments.error && !instances.error && !migrationPlanTotals.error;
    const errors = {
        l1Assessments: l1Assessments.error,
        migrationPlanTotals: migrationPlanTotals.error,
        instances: instances.error
    };
    return {
        summaryData: summaryData,
        isL1AssessmentsLoading: isL1AssessmentsLoading,
        isMigrationPlanTotalsLoading: isMigrationPlanTotalsLoading,
        isInstancesLoading: isInstancesLoading,
        isEmpty: isEmpty,
        errors: errors,
        loadL1Assessments: loadL1Assessments,
        loadMigrationPlanTotals: loadMigrationPlanTotals,
        loadInstances: loadInstances
    };
};

});

parcelRegister("6aLna", function(module, exports) {
$parcel$export(module.exports, "useDashboardPageAnalytics", function () { return $78832f2402d0974c$export$2bd0b0fa8a15d1c5; });

var $6ogO3 = parcelRequire("6ogO3");

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");

var $9cWyX = parcelRequire("9cWyX");
parcelRequire("6ezXX");
var $1c2IO = parcelRequire("1c2IO");
const $78832f2402d0974c$export$2bd0b0fa8a15d1c5 = ()=>{
    const { data: customerDomain } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomain);
    const { data: userDetails } = (0, $f7YG8.useFastshiftSelector)((state)=>state.userDetails);
    const { data: supportRequests, pending: supportRequestsPending } = (0, $f7YG8.useFastshiftSelector)((state)=>state.supportRequests);
    const domainOrg = (0, $f7YG8.useFastshiftSelector)((state)=>state.selectedDomainOrg);
    const { summaryData: summaryData, isL1AssessmentsLoading: isL1AssessmentsLoading, isMigrationPlanTotalsLoading: isMigrationPlanTotalsLoading, isInstancesLoading: isInstancesLoading, isEmpty: summaryEmpty } = (0, $1c2IO.useSummary)();
    const summaryLoading = isL1AssessmentsLoading || isMigrationPlanTotalsLoading || isInstancesLoading;
    const { identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)();
    const { fireScreenEvent: fireScreenEvent, fireTrackEvent: fireTrackEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    const lastFiredKeyRef = (0, $1oC0p.useRef)(null);
    // Screen event
    (0, $1oC0p.useEffect)(()=>{
        if (!identityAttrs) return;
        fireScreenEvent({
            name: (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_FOR_YOU_SCREEN
        });
    }, [
        fireScreenEvent,
        identityAttrs
    ]);
    // Track event - when a different org is selected and all migration data is loaded
    (0, $1oC0p.useEffect)(()=>{
        if (!customerDomain || !identityAttrs || !domainOrg || !supportRequests || summaryLoading || supportRequestsPending) return;
        const attrs = (0, $9cWyX.buildForYouPageDetailsAttributes)({
            customerDomain: customerDomain,
            domainOrg: domainOrg,
            summaryData: summaryData,
            summaryEmpty: summaryEmpty,
            supportRequests: supportRequests
        });
        if (!attrs) return;
        const key = JSON.stringify((0, $6ogO3._)({}, identityAttrs, attrs));
        if (lastFiredKeyRef.current === key) return;
        fireTrackEvent({
            action: (0, $3cXzX.ActionKey).DISPLAYED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).SECTION,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).FOR_YOU_PAGE_DETAILS,
            source: (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_FOR_YOU_SCREEN,
            attributes: attrs
        });
        lastFiredKeyRef.current = key;
    }, [
        customerDomain,
        userDetails,
        domainOrg,
        summaryLoading,
        summaryEmpty,
        summaryData,
        supportRequests,
        supportRequestsPending,
        identityAttrs,
        fireTrackEvent
    ]);
};

});
parcelRegister("9cWyX", function(module, exports) {
$parcel$export(module.exports, "buildForYouPageDetailsAttributes", function () { return $04b449ed096c5e16$export$6231480d55d5c5c9; });

var $1uReC = parcelRequire("1uReC");

var $560h0 = parcelRequire("560h0");
parcelRequire("hVHtn");
var $af3Tw = parcelRequire("af3Tw");
const $04b449ed096c5e16$export$8e3def920b6ced5f = (productName)=>{
    const normalizedName = (productName !== null && productName !== void 0 ? productName : "").toUpperCase();
    return normalizedName === (0, $1uReC.PRODUCT_NAME).JIRA || normalizedName === (0, $1uReC.PRODUCT_NAME).CONFLUENCE;
};
function $04b449ed096c5e16$export$6231480d55d5c5c9(args) {
    const { customerDomain: customerDomain, domainOrg: domainOrg, summaryData: summaryData, summaryEmpty: summaryEmpty, supportRequests: supportRequests } = args;
    var _domainOrg_orgId;
    // orgs & support counts
    const selectedOrgId = (_domainOrg_orgId = domainOrg.orgId) !== null && _domainOrg_orgId !== void 0 ? _domainOrg_orgId : (0, $af3Tw.RESERVED_ORG_IDS).NO_ORG;
    const orgCount = customerDomain.orgsWithAdminRole.length;
    const planTicketCount = supportRequests.length;
    const planTicketList = supportRequests.map((req)=>req.supportTicketId);
    // summary section
    const summaryCardsDisplayed = !summaryEmpty;
    const noAssessmentsBannerDisplayed = selectedOrgId !== (0, $af3Tw.RESERVED_ORG_IDS).NO_ORG && summaryEmpty;
    var _summaryData_dataCenter_count;
    const countAssessedInstances = (_summaryData_dataCenter_count = summaryData.dataCenter.count) !== null && _summaryData_dataCenter_count !== void 0 ? _summaryData_dataCenter_count : null;
    var _summaryData_areaImprovement_count;
    const countAreasToImprove = (_summaryData_areaImprovement_count = summaryData.areaImprovement.count) !== null && _summaryData_areaImprovement_count !== void 0 ? _summaryData_areaImprovement_count : null;
    var _summaryData_deletedApps_count;
    const countDetectedApps = (_summaryData_deletedApps_count = summaryData.deletedApps.count) !== null && _summaryData_deletedApps_count !== void 0 ? _summaryData_deletedApps_count : null;
    var _summaryData_migrationCompleted_count;
    const countMigrationsCompleted = (_summaryData_migrationCompleted_count = summaryData.migrationCompleted.count) !== null && _summaryData_migrationCompleted_count !== void 0 ? _summaryData_migrationCompleted_count : null;
    var _summaryData_migrationInProgress_count;
    const countMigrationsInProgress = (_summaryData_migrationInProgress_count = summaryData.migrationInProgress.count) !== null && _summaryData_migrationInProgress_count !== void 0 ? _summaryData_migrationInProgress_count : null;
    var _summaryData_unsuccessfulMigration_count;
    const countUnsuccessfulMigrations = (_summaryData_unsuccessfulMigration_count = summaryData.unsuccessfulMigration.count) !== null && _summaryData_unsuccessfulMigration_count !== void 0 ? _summaryData_unsuccessfulMigration_count : null;
    // request fastshift assistance section
    const hasRequestAssistancePathway = supportRequests.some((req)=>(0, $560h0.isSupportRequestOpen)(req.status));
    // data Quality of Progress Table
    const rowsMissingProductIcon = supportRequests.filter((r)=>{
        const sourceSupported = $04b449ed096c5e16$export$8e3def920b6ced5f(r.source.productName);
        const destinationSupported = $04b449ed096c5e16$export$8e3def920b6ced5f(r.destination.productName);
        return !(sourceSupported && destinationSupported);
    }).length;
    return {
        selectedOrgId: selectedOrgId,
        orgCount: orgCount,
        planTicketCount: planTicketCount,
        planTicketList: planTicketList,
        summaryCardsDisplayed: summaryCardsDisplayed,
        noAssessmentsBannerDisplayed: noAssessmentsBannerDisplayed,
        countAssessedInstances: countAssessedInstances,
        countAreasToImprove: countAreasToImprove,
        countDetectedApps: countDetectedApps,
        countMigrationsCompleted: countMigrationsCompleted,
        countMigrationsInProgress: countMigrationsInProgress,
        countUnsuccessfulMigrations: countUnsuccessfulMigrations,
        hasRequestAssistancePathway: hasRequestAssistancePathway,
        rowsMissingProductIcon: rowsMissingProductIcon
    };
}

});


parcelRegister("kLOFc", function(module, exports) {
$parcel$export(module.exports, "useDashboardUIAnalytics", function () { return $f03104b2565d981d$export$c2d1539a2ef03c27; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");

var $560h0 = parcelRequire("560h0");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");
const $f03104b2565d981d$export$c2d1539a2ef03c27 = ()=>{
    const { data: supportRequests } = (0, $f7YG8.useFastshiftSelector)((state)=>state.supportRequests);
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)(true);
    const { fireUIEvent: fireUIEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    const hasRequestAssistancePathway = (0, $1oC0p.useMemo)(()=>!!(supportRequests === null || supportRequests === void 0 ? void 0 : supportRequests.some((req)=>(0, $560h0.isSupportRequestOpen)(req.status))), [
        supportRequests
    ]);
    // UI event callbacks
    const sendOrgSelectorDropdownClickUIEvent = (0, $1oC0p.useCallback)(()=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).DROPDOWN,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).ORG_SELECTOR_DROPDOWN,
            source: sourceKey,
            attributes: {
                hasRequestAssistancePathway: hasRequestAssistancePathway
            }
        });
    }, [
        fireUIEvent,
        hasRequestAssistancePathway,
        sourceKey
    ]);
    const sendOrgSelectorDropdownItemClickUIEvent = (0, $1oC0p.useCallback)((selectedOrgId)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).DROPDOWN_ITEM,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).ORG_SELECTOR_DROPDOWN,
            source: sourceKey,
            attributes: {
                selectedOrgId: selectedOrgId
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendMigrationSummarySectionLinkClickUIEvent = (0, $1oC0p.useCallback)((subject, selectedOrgId)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).LINK,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).MIGRATION_SUMMARY_SECTION,
            source: sourceKey,
            attributes: {
                subject: subject,
                selectedOrgId: selectedOrgId
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendMigrationTicketsTopSectionOpenSupportTicketLinkClickUIEvent = (0, $1oC0p.useCallback)((ticketId)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).LINK,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).MIGRATION_TICKETS_TOP_SECTION_OPEN_SUPPORT_TICKET_LINK,
            source: sourceKey,
            attributes: {
                ticketId: ticketId
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendMigrationTicketsListViewAllButtonClickUIEvent = (0, $1oC0p.useCallback)(()=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).LINK,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).MIGRATION_TICKETS_TOP_SECTION_VIEW_ALL_LINK,
            source: sourceKey,
            attributes: {}
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    return {
        sendOrgSelectorDropdownClickUIEvent: sendOrgSelectorDropdownClickUIEvent,
        sendOrgSelectorDropdownItemClickUIEvent: sendOrgSelectorDropdownItemClickUIEvent,
        sendMigrationSummarySectionLinkClickUIEvent: sendMigrationSummarySectionLinkClickUIEvent,
        sendMigrationTicketsTopSectionOpenSupportTicketLinkClickUIEvent: sendMigrationTicketsTopSectionOpenSupportTicketLinkClickUIEvent,
        sendMigrationTicketsListViewAllButtonClickUIEvent: sendMigrationTicketsListViewAllButtonClickUIEvent
    };
};

});


parcelRegister("8LnDm", function(module, exports) {
$parcel$export(module.exports, "MigrationTicketsList", function () { return (parcelRequire("j9oYS")).MigrationTicketsList; });

var $j9oYS = parcelRequire("j9oYS");

});
parcelRegister("j9oYS", function(module, exports) {
$parcel$export(module.exports, "MigrationTicketsList", function () { return $98a100a01813dfee$export$aaea08760f52ff53; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $j2t2h = parcelRequire("j2t2h");

var $15dQb = parcelRequire("15dQb");

var $1HVQz = parcelRequire("1HVQz");

var $dTJrO = parcelRequire("dTJrO");

var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");

var $4jcRW = parcelRequire("4jcRW");

var $7qFQI = parcelRequire("7qFQI");

var $lP7A9 = parcelRequire("lP7A9");
parcelRequire("z8fwG");
var $1NoJu = parcelRequire("1NoJu");
parcelRequire("axBrj");
var $7DFvf = parcelRequire("7DFvf");
parcelRequire("hVHtn");
var $af3Tw = parcelRequire("af3Tw");
var $f7YG8 = parcelRequire("f7YG8");

var $9tcM4 = parcelRequire("9tcM4");
parcelRequire("26OJ7");
var $8P4me = parcelRequire("8P4me");

var $kLOFc = parcelRequire("kLOFc");

var $gGvtp = parcelRequire("gGvtp");

var $e2RMi = parcelRequire("e2RMi");

var $4EIUt = parcelRequire("4EIUt");
const $98a100a01813dfee$var$wrapperStyles = (0, $f6YGh.xcss)({
    border: `1px solid ${(0, $lP7A9.default)("color.border")}`,
    borderRadius: "4px"
});
const $98a100a01813dfee$var$viewAllStyles = (0, $f6YGh.xcss)({
    borderBlockStart: `1px solid ${(0, $lP7A9.default)("color.border")}`,
    padding: "space.100"
});
const $98a100a01813dfee$var$abnormalStateWrapperStyles = (0, $f6YGh.xcss)({
    borderRadius: "8px",
    border: `1px solid ${(0, $lP7A9.default)("color.border")}`,
    padding: "space.200"
});
const $98a100a01813dfee$var$iconContainerStyles = (0, $f6YGh.xcss)({
    width: "48px",
    height: "48px"
});
const $98a100a01813dfee$export$aaea08760f52ff53 = ({ migrationTicketsUrl: migrationTicketsUrl })=>{
    const intl = (0, $8e22h.default)();
    const navigate = (0, $j2t2h.useNavigate)();
    const selectedDomainOrg = (0, $f7YG8.useFastshiftSelector)((state)=>state.selectedDomainOrg);
    const { pending: customerDomainPending, data: customerDomainData } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomain);
    const { pending: topSupportRequestsPending, error: topSupportRequestsError, supportTickets: supportTickets, total: total, handleRefresh: handleRefresh } = (0, $e2RMi.useTopMigrationTickets)();
    const descriptionMessageMapping = (orgId)=>{
        switch(orgId){
            case (0, $af3Tw.RESERVED_ORG_IDS).NO_ORG:
                return (0, $4EIUt.messages).migrationTicketsTableDescriptionWithNoOrg;
            case (0, $af3Tw.RESERVED_ORG_IDS).OTHER_ORGS:
                return (0, $4EIUt.messages).migrationTicketsTableDescriptionAsNotAnAdmin;
            default:
                return (0, $4EIUt.messages).migrationTicketsTableDescriptionWithAnOrg;
        }
    };
    const numOfRemainingTickets = total - supportTickets.length;
    const isEmpty = supportTickets.length === 0;
    const isError = !!topSupportRequestsError;
    (0, $gGvtp.useMigrationTicketsListSectionAnalytics)();
    const { sendMigrationTicketsListViewAllButtonClickUIEvent: sendMigrationTicketsListViewAllButtonClickUIEvent, sendMigrationTicketsTopSectionOpenSupportTicketLinkClickUIEvent: sendMigrationTicketsTopSectionOpenSupportTicketLinkClickUIEvent } = (0, $kLOFc.useDashboardUIAnalytics)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4EIUt.messages).migrationTicketsTableHeading))
            }),
            customerDomainPending ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                height: "20px",
                width: "300px"
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, descriptionMessageMapping((selectedDomainOrg === null || selectedDomainOrg === void 0 ? void 0 : selectedDomainOrg.orgId) || "")))
            }),
            customerDomainPending || topSupportRequestsPending ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2YtGy.default), {
                xcss: $98a100a01813dfee$var$abnormalStateWrapperStyles,
                alignBlock: "center",
                alignInline: "center",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {})
            }) : isError ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2YtGy.default), {
                xcss: $98a100a01813dfee$var$abnormalStateWrapperStyles,
                alignBlock: "center",
                alignInline: "center",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NoJu.GenericErrorDisplay), {
                    iconSize: "small",
                    customMessage: intl.formatMessage((0, $4EIUt.messages).migrationTicketsListErrorMessage),
                    onRefresh: ()=>customerDomainData && handleRefresh(customerDomainData.customerDomainId)
                })
            }) : isEmpty ? /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                xcss: $98a100a01813dfee$var$abnormalStateWrapperStyles,
                alignBlock: "center",
                alignInline: "center",
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2YtGy.default), {
                        xcss: $98a100a01813dfee$var$iconContainerStyles,
                        alignBlock: "center",
                        alignInline: "center",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8P4me.MultiColorLine), {})
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4EIUt.messages).migrationTicketsListEmptyState))
                    })
                ]
            }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                xcss: $98a100a01813dfee$var$wrapperStyles,
                children: [
                    supportTickets.map((ticket, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7DFvf.MigrationTicketsCard), (0, $dPABA._)((0, $6ogO3._)({
                            issueType: (0, $9tcM4.FASTSHIFT_RELATED_TICKET_ISSUE_TYPE).PLAN
                        }, ticket), {
                            status: ticket.status,
                            showBottomBorder: index !== 0,
                            onClickAnalyticsEvent: sendMigrationTicketsTopSectionOpenSupportTicketLinkClickUIEvent
                        }), ticket.supportTicketId)),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $79ZK0.default), {
                        alignBlock: "center",
                        xcss: $98a100a01813dfee$var$viewAllStyles,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), {
                            appearance: "subtle",
                            onClick: ()=>{
                                sendMigrationTicketsListViewAllButtonClickUIEvent();
                                navigate(migrationTicketsUrl);
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                                alignBlock: "center",
                                space: "space.075",
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4EIUt.messages).migrationTicketsListViewAll))
                                    }),
                                    numOfRemainingTickets > 0 && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $15dQb.default), {
                                        children: [
                                            "+",
                                            numOfRemainingTickets
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("15dQb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0ca0fe88a1c58975$export$2e2bcd8739ae039; });
/* badge.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $39c3M = parcelRequire("39c3M");

var $8gp1u = parcelRequire("8gp1u");

var $kBxVG = parcelRequire("kBxVG");

var $1QDdc = parcelRequire("1QDdc");
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they will be updated in the labelling system work and we want to avoid frequent UI changes.\
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ var $0ca0fe88a1c58975$var$neutral300 = '#DDDEE1';
var $0ca0fe88a1c58975$var$red300 = '#FD9891';
var $0ca0fe88a1c58975$var$blue300 = '#8FB8F6';
var $0ca0fe88a1c58975$var$neutral1000 = '#292A2E';
var $0ca0fe88a1c58975$var$styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
var $0ca0fe88a1c58975$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    // Use this flag for allowing negative values(numbers) in badge component when custom number field is used
    if ((0, $39c3M.fg)('platform_ken_2029_negative_numbers_badge')) return typeof children === 'number' && typeof max === 'number' ? (0, $1QDdc.formatValueWithNegativeSupport)(children, max) : children;
    return typeof children === 'number' && max ? (0, $1QDdc.formatValue)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ var $0ca0fe88a1c58975$var$Badge = /*#__PURE__*/ (0, $1oC0p.memo)(function Badge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    if ((0, $39c3M.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        // Map old appearance names to new ones
        var newAppearance = (0, $kBxVG.appearanceMapping)[appearance];
        return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        $1oC0p.createElement((0, $kBxVG.default), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId
        }, children));
    }
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $2jatx.default)([
            $0ca0fe88a1c58975$var$styles.root,
            $0ca0fe88a1c58975$var$styles[appearance]
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $8gp1u.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $0ca0fe88a1c58975$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $0ca0fe88a1c58975$export$2e2bcd8739ae039 = $0ca0fe88a1c58975$var$Badge;

});
parcelRegister("8gp1u", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $60433a6392b8c83a$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lmxXn = parcelRequire("lmxXn");

var $lm01c = parcelRequire("lm01c");

var $iXXw7 = parcelRequire("iXXw7");
var $60433a6392b8c83a$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $60433a6392b8c83a$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $iXXw7.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($60433a6392b8c83a$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $60433a6392b8c83a$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $60433a6392b8c83a$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pmoej",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $60433a6392b8c83a$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
var $60433a6392b8c83a$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $60433a6392b8c83a$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $60433a6392b8c83a$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $60433a6392b8c83a$var$Text = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $lmxXn.default)($60433a6392b8c83a$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $lm01c.useHasTextAncestor)();
    var color = $60433a6392b8c83a$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $1oC0p.createElement(Component, {
        id: id,
        className: (0, $2jatx.default)([
            $60433a6392b8c83a$var$styles.root,
            size && $60433a6392b8c83a$var$fontSizeMap[size],
            color && $60433a6392b8c83a$var$textColorMap[color],
            maxLines && $60433a6392b8c83a$var$styles.truncation,
            maxLines === 1 && $60433a6392b8c83a$var$styles.breakAll,
            align && $60433a6392b8c83a$var$styles["textAlign.".concat(align)],
            weight && $60433a6392b8c83a$var$fontWeightMap[weight],
            Component === 'em' && $60433a6392b8c83a$var$styles['as.em'],
            Component === 'strong' && $60433a6392b8c83a$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $1oC0p.createElement((0, $lm01c.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $60433a6392b8c83a$export$2e2bcd8739ae039 = $60433a6392b8c83a$var$Text;

});
parcelRegister("lm01c", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", function () { return $f8bbaaaf20a92e1e$export$9322276ec105d055; });
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $f8bbaaaf20a92e1e$export$ae933c6cbe5643ad; });

var $1oC0p = parcelRequire("1oC0p");
var $f8bbaaaf20a92e1e$var$HasTextAncestorContext = /*#__PURE__*/ (0, $1oC0p.createContext)(false);
var $f8bbaaaf20a92e1e$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $1oC0p.useContext)($f8bbaaaf20a92e1e$var$HasTextAncestorContext);
};
var $f8bbaaaf20a92e1e$export$ae933c6cbe5643ad = $f8bbaaaf20a92e1e$var$HasTextAncestorContext.Provider;

});

parcelRegister("iXXw7", function(module, exports) {
$parcel$export(module.exports, "useSurface", function () { return $dcebe788383a5743$export$1aeb4f6b93c4540d; });

var $1oC0p = parcelRequire("1oC0p");
var $dcebe788383a5743$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $dcebe788383a5743$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($dcebe788383a5743$export$1ca2a26fecb070ae);
};
$dcebe788383a5743$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("kBxVG", function(module, exports) {
$parcel$export(module.exports, "appearanceMapping", function () { return $f0019501a0238a8a$export$d21bba0569254935; });
$parcel$export(module.exports, "default", function () { return $f0019501a0238a8a$export$2e2bcd8739ae039; });
/* badge-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8gp1u = parcelRequire("8gp1u");

var $1QDdc = parcelRequire("1QDdc");
var $f0019501a0238a8a$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger'
};
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var $f0019501a0238a8a$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk1s9h _1ut5iv2r _y8hm1hpu",
    danger: "_syaz1blx _bfhkrkii _1ut5zp7h _y8hm84f9",
    warning: "_bfhk1kmu _syazmgs1 _pers14ug _y8hmdo2b",
    information: "_syaz1qd9 _bfhk1dq8 _1ut5e5eq _y8hmxr8b",
    discovery: "_syaz1g72 _bfhkiizu _1ut51bbx _y8hm17oz",
    neutral: "_syazi7uo _bfhk7i23 _1ut5z5kg _y8hm1g0e",
    inverse: "_bfhkvuon _syazi7uo"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var $f0019501a0238a8a$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && max ? (0, $1QDdc.formatValue)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 */ var $f0019501a0238a8a$var$BadgeNew = /*#__PURE__*/ (0, $1oC0p.memo)(function BadgeNew(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $2jatx.default)([
            $f0019501a0238a8a$var$stylesNew.root,
            $f0019501a0238a8a$var$stylesNew[appearance]
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $8gp1u.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $f0019501a0238a8a$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $f0019501a0238a8a$export$2e2bcd8739ae039 = $f0019501a0238a8a$var$BadgeNew;

});
parcelRegister("1QDdc", function(module, exports) {
$parcel$export(module.exports, "formatValueWithNegativeSupport", function () { return $158910760079200c$export$4b844743568d5983; });
$parcel$export(module.exports, "formatValue", function () { return $158910760079200c$export$7c4d25c0c3217d8c; });
function $158910760079200c$var$getSafeValueWithNegativeSupport() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $158910760079200c$export$4b844743568d5983(value, max) {
    var safeValue = $158910760079200c$var$getSafeValueWithNegativeSupport(value);
    var safeMax = $158910760079200c$var$getSafeValueWithNegativeSupport(max);
    var hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}
function $158910760079200c$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $158910760079200c$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $158910760079200c$var$getSafeValue(value);
    var safeMax = $158910760079200c$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});



parcelRegister("z8fwG", function(module, exports) {
$parcel$export(module.exports, "FourOhFourDisplay", function () { return (parcelRequire("7WhrI")).FourOhFourDisplay; });
$parcel$export(module.exports, "GenericErrorDisplay", function () { return (parcelRequire("1NoJu")).GenericErrorDisplay; });
parcelRequire("eMwuR");
var $7WhrI = parcelRequire("7WhrI");
parcelRequire("iwIS2");
var $1NoJu = parcelRequire("1NoJu");

});
parcelRegister("eMwuR", function(module, exports) {
$parcel$export(module.exports, "FourOhFourDisplay", function () { return (parcelRequire("7WhrI")).FourOhFourDisplay; });

var $7WhrI = parcelRequire("7WhrI");

});
parcelRegister("7WhrI", function(module, exports) {
$parcel$export(module.exports, "FourOhFourDisplay", function () { return $496f7086a8f479de$export$9203c83241c79bee; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $1p5OQ = parcelRequire("1p5OQ");

var $dTJrO = parcelRequire("dTJrO");

var $g3ExX = parcelRequire("g3ExX");
var $fmW7P = parcelRequire("fmW7P");
var $2YtGy = parcelRequire("2YtGy");
var $f6YGh = parcelRequire("f6YGh");
parcelRequire("iTGju");
var $bh3Fv = parcelRequire("bh3Fv");
parcelRequire("64esq");
var $5d59U = parcelRequire("5d59U");
parcelRequire("ioBTZ");
var $bLCr3 = parcelRequire("bLCr3");

var $3Oz1A = parcelRequire("3Oz1A");
const $496f7086a8f479de$var$iconContainerStyles = (0, $f6YGh.xcss)({
    width: "180px",
    height: "180px"
});
const $496f7086a8f479de$export$9203c83241c79bee = ()=>{
    const { paths: paths } = (0, $bh3Fv.useRoutes)();
    const { sendGoBackToHomeLinkClickUIEvent: sendGoBackToHomeLinkClickUIEvent } = (0, $bLCr3.use404DisplayAnalytics)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
        padding: "space.400",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
            alignBlock: "center",
            space: "space.300",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fmW7P.default), {
                    xcss: $496f7086a8f479de$var$iconContainerStyles,
                    alignItems: "center",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5d59U.CautionVector), {})
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                    size: "small",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $3Oz1A.messages).fourOhFourHeading))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1p5OQ.default), {
                    appearance: "primary",
                    href: paths.home,
                    onClick: ()=>sendGoBackToHomeLinkClickUIEvent(),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $3Oz1A.messages).fourOhFourBackButtonText))
                })
            ]
        })
    });
};

});
parcelRegister("64esq", function(module, exports) {
$parcel$export(module.exports, "CautionVector", function () { return (parcelRequire("5d59U")).CautionVector; });
$parcel$export(module.exports, "ErrorVector", function () { return (parcelRequire("iahsB")).ErrorVector; });
$parcel$export(module.exports, "ErrorVectorNew", function () { return (parcelRequire("2SSvo")).ErrorVectorNew; });

var $5d59U = parcelRequire("5d59U");

var $iahsB = parcelRequire("iahsB");

var $2SSvo = parcelRequire("2SSvo");

});
parcelRegister("5d59U", function(module, exports) {
$parcel$export(module.exports, "CautionVector", function () { return $b2a50b649d0e7282$export$26b455e0e9f892ac; });

var $7VQPk = parcelRequire("7VQPk");
const $b2a50b649d0e7282$export$26b455e0e9f892ac = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "108",
        height: "100",
        viewBox: "0 0 108 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0.654541 99.1828L0.71345 99.3006H107.293L107.359 99.1828L54.0065 0.582031L0.654541 99.1828Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M51.7909 71.9011V35.8945H56.5887V71.9011H51.7909Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M53.3074 77.8498C53.6565 77.7872 53.9895 77.7686 54.2749 77.7686C54.5768 77.7686 54.876 77.7895 55.1764 77.8357L55.1874 77.8374L55.1985 77.8392C57.1012 78.1501 58.685 79.4742 59.0687 81.5901C59.1362 81.9485 59.1545 82.2927 59.1545 82.5762C59.1545 82.7961 59.1435 83.0437 59.1087 83.3059V83.3461L59.071 83.5564C58.6923 85.6662 57.1123 87.007 55.1985 87.3197L55.1874 87.3215L55.1764 87.3232C54.876 87.3694 54.5768 87.3904 54.2749 87.3904C53.9874 87.3904 53.6515 87.3715 53.2997 87.3077C51.4218 86.9824 49.8458 85.6702 49.4617 83.564C49.3951 83.211 49.3756 82.881 49.3756 82.5827C49.3756 82.2876 49.3946 81.9472 49.4631 81.5875C49.8516 79.5134 51.3948 78.1714 53.3074 77.8498ZM54.1735 82.5702C54.1734 82.5742 54.1734 82.5784 54.1734 82.5827C54.1734 82.5848 54.1734 82.5868 54.1734 82.5888C54.1756 82.589 54.178 82.5892 54.1806 82.5894C54.203 82.5911 54.2343 82.5925 54.2749 82.5925C54.3056 82.5925 54.3327 82.5917 54.3566 82.5904C54.3567 82.5858 54.3567 82.5811 54.3567 82.5762C54.3567 82.5736 54.3567 82.5711 54.3567 82.5686C54.3327 82.5672 54.3056 82.5664 54.2749 82.5664C54.2343 82.5664 54.203 82.5678 54.1806 82.5696C54.178 82.5698 54.1756 82.57 54.1735 82.5702Z",
                fill: "white"
            })
        ]
    });

});

parcelRegister("iahsB", function(module, exports) {
$parcel$export(module.exports, "ErrorVector", function () { return $a8d4ac7e9ff53832$export$355693f263ff741a; });

var $7VQPk = parcelRequire("7VQPk");
const $a8d4ac7e9ff53832$export$355693f263ff741a = ({ alt: alt, size: size = "large" })=>{
    const width = size === "small" ? "48" : "160";
    const height = size === "small" ? "48" : "160";
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 275 275",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M252.19 144H241.86L236.89 131.48H208.9C209.34 105.59 211.98 81.61 216.72 60H80.86C80.46 63.92 80.1 67.89 79.76 71.88H40.59L45.56 84.41H95.07L100.04 96.94H78.05C78.05 97.1 78.03 97.26 78.02 97.42L77.83 96.94H18L22.97 109.47H40.6L45.57 122H77.19C77.08 127.4 77.02 132.83 77.02 138.32C77.02 156.29 77.57 173.69 78.62 190.53H55.04L60.01 203.06H45.06L50.03 215.59H216.38C214.05 204.77 212.26 193.36 211 181.4H189.24L184.27 168.87H201.65L196.68 156.34L257.17 156.52L252.2 143.99L252.19 144Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M145.44 121.79C130.36 121.79 121.56 127.75 116.51 136.34C121.56 144.93 130.37 150.89 145.44 150.89V121.8V121.79Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M145.44 150.89C160.52 150.89 169.32 144.93 174.37 136.34C169.32 127.75 160.51 121.79 145.44 121.79V150.88V150.89Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M155.81 138.66C155.94 137.94 156.01 137.17 156.01 136.36C156.01 135.55 155.94 134.76 155.81 134.03C155.03 129.68 152 126.99 147.76 126.3C147.04 126.18 146.28 126.12 145.49 126.12C144.7 126.12 143.88 126.19 143.12 126.31C138.88 127.02 135.86 129.69 135.07 134.02C134.94 134.75 134.87 135.53 134.87 136.35C134.87 137.17 134.94 137.93 135.07 138.65C135.85 142.97 138.87 145.65 143.12 146.36C143.87 146.49 144.66 146.55 145.49 146.55C146.32 146.55 147.04 146.49 147.76 146.37C152.01 145.68 155.03 142.99 155.81 138.64V138.66Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M120.9 156.68L165.78 111.8L169.98 116L125.1 160.88L120.9 156.68Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M77.1799 122.001H106L101.03 109.471H77.1799V122.001Z",
                fill: "#B7B9BE"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M81.11 215.601H109.93L104.96 203.061H80.22L81.11 215.601Z",
                fill: "#B7B9BE"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M208.17 143.83H189.89L194.86 156.37H199.44H208.17V143.83Z",
                fill: "#B7B9BE"
            })
        ]
    });
};

});

parcelRegister("2SSvo", function(module, exports) {
$parcel$export(module.exports, "ErrorVectorNew", function () { return $5cba5bcb616a16b1$export$dfb127602993e44b; });
// Updated vector for GA release

var $7VQPk = parcelRequire("7VQPk");
const $5cba5bcb616a16b1$export$dfb127602993e44b = ({ alt: alt, size: size = "large" })=>{
    const width = size === "small" ? "48" : "160";
    const height = size === "small" ? "48" : "160";
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 157 102",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M153.288 54.9818H146.527L143.273 46.7869H124.953C125.241 29.8407 126.969 14.1447 130.071 0H41.1447C40.8829 2.56582 40.6473 5.16436 40.4247 7.776H14.7862L18.0393 15.9775H50.4458L53.6989 24.1789H39.3055C39.3055 24.2836 39.2924 24.3884 39.2858 24.4931L39.1615 24.1789H0L3.25309 32.3804H14.7927L18.0458 40.5818H38.7425C38.6705 44.1164 38.6313 47.6705 38.6313 51.264C38.6313 63.0262 38.9913 74.4153 39.6785 85.4378H24.2444L27.4975 93.6393H17.712L20.9651 101.841H129.849C128.324 94.7585 127.152 87.2902 126.327 79.4618H112.084L108.831 71.2604H120.207L116.954 63.0589L156.548 63.1767L153.295 54.9753L153.288 54.9818Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.7354 40.5821H57.5994L54.3463 32.3806H38.7354V40.5821Z",
                fill: "#B7B9BE"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.3081 101.847H60.1721L56.919 93.6394H40.7256L41.3081 101.847Z",
                fill: "#B7B9BE"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M124.475 54.8706H112.51L115.763 63.0786H118.761H124.475V54.8706Z",
                fill: "#B7B9BE"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M81.4775 58.2941V25.6584H85.3655V58.2941H81.4775Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M82.5393 64.2431C82.8883 64.1805 83.2213 64.1619 83.5067 64.1619C83.8086 64.1619 84.1078 64.1828 84.4082 64.229L84.4192 64.2307L84.4303 64.2325C86.333 64.5434 87.9168 65.8675 88.3005 67.9834C88.368 68.3419 88.3863 68.686 88.3863 68.9695C88.3863 69.1894 88.3753 69.437 88.3405 69.6992V69.7394L88.3028 69.9497C87.9241 72.0595 86.3442 73.4003 84.4303 73.713L84.4192 73.7148L84.4082 73.7165C84.1078 73.7627 83.8086 73.7837 83.5067 73.7837C83.2191 73.7837 82.8833 73.7648 82.5315 73.701C80.6535 73.3757 79.0775 72.0635 78.6935 69.9572C78.6265 69.6021 78.6074 69.2652 78.6074 68.976C78.6074 68.681 78.6264 68.3405 78.695 67.9808C79.0834 65.9067 80.6266 64.5647 82.5393 64.2431ZM83.4053 68.9635C83.4053 68.9675 83.4052 68.9717 83.4052 68.976C83.4052 68.9781 83.4052 68.9801 83.4053 68.9821C83.4075 68.9823 83.4098 68.9825 83.4124 68.9827C83.4348 68.9844 83.4662 68.9859 83.5067 68.9859C83.5374 68.9859 83.5645 68.985 83.5885 68.9837C83.5885 68.9791 83.5885 68.9744 83.5885 68.9695C83.5885 68.9669 83.5885 68.9644 83.5885 68.9619C83.5645 68.9605 83.5374 68.9597 83.5067 68.9597C83.4661 68.9597 83.4348 68.9611 83.4124 68.9629C83.4098 68.9631 83.4075 68.9633 83.4053 68.9635Z",
                fill: "white"
            })
        ]
    });
};

});


parcelRegister("ioBTZ", function(module, exports) {
$parcel$export(module.exports, "use404DisplayAnalytics", function () { return (parcelRequire("bLCr3")).use404DisplayAnalytics; });

var $bLCr3 = parcelRequire("bLCr3");

});
parcelRegister("bLCr3", function(module, exports) {
$parcel$export(module.exports, "use404DisplayAnalytics", function () { return $f6ac921f38859101$export$b04dd4b88dc7f99f; });

var $1oC0p = parcelRequire("1oC0p");

var $j2t2h = parcelRequire("j2t2h");
parcelRequire("hAwBv");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");
const $f6ac921f38859101$export$b04dd4b88dc7f99f = ()=>{
    const location = (0, $j2t2h.useLocation)();
    const { fireScreenEvent: fireScreenEvent, fireUIEvent: fireUIEvent } = (0, $9ztLs.useFireAnalyticsEvents)();
    const { data: userDetails } = (0, $f7YG8.useFastshiftSelector)((state)=>state.userDetails);
    // Screen event - when 404 page is displayed
    (0, $1oC0p.useEffect)(()=>{
        if (!userDetails) return;
        fireScreenEvent({
            name: (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_404_SCREEN,
            attributes: {
                userDomain: userDetails.userDomain.domain,
                pageRoute: location.pathname
            }
        });
    }, [
        fireScreenEvent,
        userDetails,
        location.pathname
    ]);
    // UI event callback for home link click
    const sendGoBackToHomeLinkClickUIEvent = (0, $1oC0p.useCallback)(()=>{
        if (!userDetails) return;
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).LINK,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).GO_BACK_TO_HOME_LINK,
            source: (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_404_SCREEN,
            attributes: {
                userDomain: userDetails.userDomain.domain,
                pageRoute: location.pathname
            }
        });
    }, [
        fireUIEvent,
        userDetails,
        location.pathname
    ]);
    return {
        sendGoBackToHomeLinkClickUIEvent: sendGoBackToHomeLinkClickUIEvent
    };
};

});


parcelRegister("3Oz1A", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $c5e234c607530720$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $c5e234c607530720$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    fourOhFourHeading: {
        id: "fastshift.common.displays.404-display.heading",
        defaultMessage: "We can\u2019t find the page you\u2019re looking for",
        description: "Heading for 404 display"
    },
    fourOhFourDescription: {
        id: "fastshift.common.displays.404-display.description",
        defaultMessage: "Go back to {404Link}",
        description: "Description for 404 display"
    },
    fourOhFourLinkText: {
        id: "fastshift.common.displays.404-display.link-text",
        defaultMessage: "atlassian.com/fastshift",
        description: "Link text for 404 display"
    },
    fourOhFourBackButtonText: {
        id: "fastshift.common.displays.404-display.back-button-text",
        defaultMessage: "Go to home",
        description: "Back button text for 404 display"
    }
});

});



parcelRegister("iwIS2", function(module, exports) {
$parcel$export(module.exports, "GenericErrorDisplay", function () { return (parcelRequire("1NoJu")).GenericErrorDisplay; });

var $1NoJu = parcelRequire("1NoJu");

});
parcelRegister("1NoJu", function(module, exports) {
$parcel$export(module.exports, "GenericErrorDisplay", function () { return $a44a4fd144f5f9a9$export$4fa328de5601b947; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $1HVQz = parcelRequire("1HVQz");

var $dTJrO = parcelRequire("dTJrO");

var $g3ExX = parcelRequire("g3ExX");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
parcelRequire("64esq");
var $iahsB = parcelRequire("iahsB");
var $2SSvo = parcelRequire("2SSvo");

var $cUajG = parcelRequire("cUajG");
const $a44a4fd144f5f9a9$export$4fa328de5601b947 = ({ iconSize: iconSize = "large", customMessage: customMessage, refreshButtonLabel: refreshButtonLabel, useNewErrorVector: useNewErrorVector = false, xcss: xcss, onRefresh: onRefresh })=>{
    const intl = (0, $8e22h.default)();
    const buttonLabel = refreshButtonLabel || intl.formatMessage((0, $cUajG.messages).defaultRefreshButtonLabel);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
        padding: "space.400",
        xcss: xcss,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
            alignBlock: "center",
            space: "space.200",
            alignInline: "center",
            children: [
                useNewErrorVector ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2SSvo.ErrorVectorNew), {
                    size: iconSize,
                    alt: intl.formatMessage((0, $cUajG.messages).genericErrorGraphicAltTextDecorative)
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iahsB.ErrorVector), {
                    size: iconSize,
                    alt: intl.formatMessage((0, $cUajG.messages).genericErrorGraphicAltText)
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                    size: "medium",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $cUajG.messages).genericErrorHeading))
                }),
                customMessage && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                    children: customMessage
                }),
                onRefresh && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), {
                    appearance: "primary",
                    onClick: onRefresh,
                    children: buttonLabel
                })
            ]
        })
    });
};

});
parcelRegister("cUajG", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $c5434338be773f1f$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $c5434338be773f1f$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    genericErrorHeading: {
        id: "fastshift.common.displays.generic-error.heading",
        defaultMessage: "Something went wrong",
        description: "Heading for error message displayed when an unknown error occurs, for example 500 internal server error, or server returns empty data"
    },
    genericErrorGraphicAltText: {
        id: "fastshift.common.displays.generic-error.graphic-alt-text",
        defaultMessage: "Error Graphic",
        description: "Alt Text for the generic error vector graphic displayed when an unknown error occurs"
    },
    genericErrorGraphicAltTextDecorative: {
        id: "fastshift.common.displays.generic-error.graphic-alt-text",
        defaultMessage: "Decorative image",
        description: "alt text for the decorative error vector graphic displayed when an unknown error occurs"
    },
    defaultRefreshButtonLabel: {
        id: "fastshift.common.displays.generic-error.refresh-button-label",
        defaultMessage: "Refresh",
        description: "Label for the refresh button that when clicked, refetches the data from the server."
    }
});

});




parcelRegister("axBrj", function(module, exports) {
$parcel$export(module.exports, "MigrationTicketsCard", function () { return (parcelRequire("7DFvf")).MigrationTicketsCard; });

var $7DFvf = parcelRequire("7DFvf");

});
parcelRegister("7DFvf", function(module, exports) {
$parcel$export(module.exports, "MigrationTicketsCard", function () { return $b4729c07917f2234$export$4870f38ff0f22853; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");

var $dC8cL = parcelRequire("dC8cL");

var $1Zr4f = parcelRequire("1Zr4f");

var $gcfBV = parcelRequire("gcfBV");

var $g3ExX = parcelRequire("g3ExX");
var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");

var $lP7A9 = parcelRequire("lP7A9");

var $hLJF4 = parcelRequire("hLJF4");

var $fq4go = parcelRequire("fq4go");
parcelRequire("jtpMK");
var $lmgkB = parcelRequire("lmgkB");

var $9tcM4 = parcelRequire("9tcM4");

var $38KZq = parcelRequire("38KZq");
const $b4729c07917f2234$var$listItemStyles = (0, $f6YGh.xcss)({
    paddingBlock: "space.150",
    paddingInline: "space.200"
});
const $b4729c07917f2234$var$notFirstItemStyles = (0, $f6YGh.xcss)({
    borderBlockStart: `1px solid ${(0, $lP7A9.default)("color.border")}`
});
const $b4729c07917f2234$var$iconWrapperStyles = (0, $f6YGh.xcss)({
    width: "32px",
    height: "32px",
    borderRadius: "4px",
    padding: "space.050",
    border: `1px solid ${(0, $lP7A9.default)("color.border")}`,
    marginInlineEnd: "space.200",
    flexShrink: 0
});
const $b4729c07917f2234$var$iconCompactWrapperStyles = (0, $f6YGh.xcss)({
    alignSelf: "flex-start"
});
const $b4729c07917f2234$var$linkIconStyles = (0, $f6YGh.xcss)({
    marginInlineStart: "space.500"
});
const $b4729c07917f2234$var$compactLinkIconStyles = (0, $f6YGh.xcss)({
    marginBlockStart: "space.200"
});
const $b4729c07917f2234$var$statusWrapperStyles = (0, $f6YGh.xcss)({
    marginBlockStart: "space.100"
});
const $b4729c07917f2234$var$strikeThroughTextStyles = (0, $f6YGh.xcss)({
    textDecoration: "line-through"
});
const $b4729c07917f2234$export$4870f38ff0f22853 = ({ issueType: issueType, supportTicketId: supportTicketId, title: title, status: status, showBottomBorder: showBottomBorder = false, compact: compact, onClickAnalyticsEvent: onClickAnalyticsEvent })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
        testId: `migration-ticket-list-item-${supportTicketId}`,
        xcss: [
            $b4729c07917f2234$var$listItemStyles,
            showBottomBorder && $b4729c07917f2234$var$notFirstItemStyles
        ],
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
            spread: "space-between",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2YtGy.default), {
                            xcss: [
                                $b4729c07917f2234$var$iconWrapperStyles,
                                compact && $b4729c07917f2234$var$iconCompactWrapperStyles
                            ],
                            alignBlock: "center",
                            alignInline: "center",
                            grow: "hug",
                            children: (0, $38KZq.getMigrationTicketIcon)(issueType)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hLJF4.default), {
                                    content: title,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                        size: "medium",
                                        maxLines: 2,
                                        children: title
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                    size: "small",
                                    color: "color.text.subtle",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                                        xcss: compact && status === (0, $9tcM4.FASTSHIFT_ROLL_UP_STATUS).COMPLETE && $b4729c07917f2234$var$strikeThroughTextStyles,
                                        as: "span",
                                        children: supportTicketId
                                    })
                                }),
                                compact && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $79ZK0.default), {
                                    xcss: $b4729c07917f2234$var$statusWrapperStyles,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gcfBV.default), {
                                        appearance: (0, $lmgkB.getStatusColor)(status),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $lmgkB.getStatusText)(status)))
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                    alignBlock: "center",
                    children: [
                        !compact && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gcfBV.default), {
                            appearance: (0, $lmgkB.getStatusColor)(status),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $lmgkB.getStatusText)(status)))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2YtGy.default), {
                            xcss: compact ? $b4729c07917f2234$var$compactLinkIconStyles : $b4729c07917f2234$var$linkIconStyles,
                            alignBlock: "center",
                            alignInline: "center",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dC8cL.default), {
                                href: `${(0, $fq4go.SAC_URL)}/requests/${supportTicketId}`,
                                target: "_blank",
                                appearance: "subtle",
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr4f))),
                                label: "link-external",
                                onClick: ()=>onClickAnalyticsEvent(supportTicketId)
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("gcfBV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bca9e0500886072e$export$2e2bcd8739ae039; });
/* lozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $1kibr = parcelRequire("1kibr");

var $39c3M = parcelRequire("39c3M");

var $lA9ds = parcelRequire("lA9ds");
var $bca9e0500886072e$var$stylesOld = {
    container: "_2rko12b0 _1reo15vq _18m915vq _18zr1b66 _1e0c116y _1kz6184x _kqswpfqs _vchhusvi",
    'text.bold.default': "_syaz15cr",
    'text.bold.inprogress': "_syaz15cr",
    'text.bold.moved': "_syazal3n",
    'text.bold.new': "_syaz15cr",
    'text.bold.removed': "_syaz15cr",
    'text.bold.success': "_syaz15cr",
    'text.subtle.default': "_syazjjyb",
    'text.subtle.inprogress': "_syaz1lpn",
    'text.subtle.moved': "_syaz1tm6",
    'text.subtle.new': "_syaz1mvf",
    'text.subtle.removed': "_syaz1ick",
    'text.subtle.success': "_syaz17fi"
};
// NOTE: This is isolated to avoid breaking the bounded `stylesOld` interface as they do not fall within the Design System.
var $bca9e0500886072e$var$stylesOldUnbounded = {
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi"
};
var $bca9e0500886072e$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var $bca9e0500886072e$var$stylesNew = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'border.subtle.default': "_19it14mp",
    'border.subtle.inprogress': "_19it1cy7",
    'border.subtle.moved': "_19itzi1n",
    'border.subtle.new': "_19it1apr",
    'border.subtle.removed': "_19itoa5t",
    'border.subtle.success': "_19it1am1",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syaz1fxt",
    'text.bold': "_syazwwip"
};
var $bca9e0500886072e$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $bca9e0500886072e$var$Lozenge = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? 'bold' : 'subtle';
    var appearanceType = (0, $1oC0p.useMemo)(function() {
        return $bca9e0500886072e$var$appearanceTypes.includes(appearance) ? appearance : 'default';
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $39c3M.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ $1oC0p.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $1kibr.default)([
            $bca9e0500886072e$var$stylesNew.container,
            $bca9e0500886072e$var$stylesNew["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === 'subtle' && !(0, $39c3M.fg)('visual-refresh_drop_5') && $bca9e0500886072e$var$stylesNew["border.subtle.".concat(appearanceType)],
            appearanceStyle === 'subtle' && (0, $39c3M.fg)('visual-refresh_drop_5') && $bca9e0500886072e$var$stylesNew["outline.subtle.".concat(appearanceType)],
            appearanceStyle === 'subtle' && (0, $39c3M.fg)('visual-refresh_drop_5') && $bca9e0500886072e$var$stylesNew.containerSubtle
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $1kibr.default)([
            $bca9e0500886072e$var$stylesNew.text,
            (0, $39c3M.fg)('platform-lozenge-custom-letterspacing') && $bca9e0500886072e$var$stylesNew.customLetterspacing,
            $bca9e0500886072e$var$stylesNew["text.".concat(appearanceStyle)]
        ])
    }, children));
    return /*#__PURE__*/ $1oC0p.createElement((0, $lA9ds.default), {
        as: "span",
        backgroundColor: $bca9e0500886072e$var$backgroundColorsOld[appearanceStyle][appearanceType],
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $bca9e0500886072e$var$stylesOld.container,
        testId: testId
    }, /*#__PURE__*/ $1oC0p.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $1kibr.default)([
            $bca9e0500886072e$var$stylesOldUnbounded.text,
            (0, $39c3M.fg)('platform-lozenge-custom-letterspacing') && $bca9e0500886072e$var$stylesOldUnbounded.customLetterspacing,
            $bca9e0500886072e$var$stylesOld["text.".concat(appearanceStyle, ".").concat(appearanceType)]
        ])
    }, children));
});
$bca9e0500886072e$var$Lozenge.displayName = 'Lozenge';
var $bca9e0500886072e$export$2e2bcd8739ae039 = $bca9e0500886072e$var$Lozenge;

});
parcelRegister("1kibr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0f75c392ab017c5e$export$2e2bcd8739ae039; });
const $0f75c392ab017c5e$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $0f75c392ab017c5e$var$ATOMIC_GROUP_LENGTH = 5;
function $0f75c392ab017c5e$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $0f75c392ab017c5e$var$UNDERSCORE_UNICODE ? $0f75c392ab017c5e$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("lA9ds", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fb641be27df99d98$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $38yuU = parcelRequire("38yuU");

var $iO8YU = parcelRequire("iO8YU");

var $1oC0p = parcelRequire("1oC0p");

var $1kibr = parcelRequire("1kibr");

var $b0Mn8 = parcelRequire("b0Mn8");
var $fb641be27df99d98$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $fb641be27df99d98$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $fb641be27df99d98$var$baseStyles = null;
var $fb641be27df99d98$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhk1fno",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1eds",
    'color.background.accent.lime.subtler.pressed': "_bfhk1hgz",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhkhgj8",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhk1b17",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhk1pbw",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkrw5d",
    'color.background.accent.red.subtler.pressed': "_bfhk69rw",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1tf4",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhkprmn",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtlest.hovered': "_bfhkg4tm",
    'color.background.accent.orange.subtlest.pressed': "_bfhk1ya0",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtler.hovered': "_bfhk1lml",
    'color.background.accent.orange.subtler.pressed': "_bfhkuxsx",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.subtle.hovered': "_bfhk1oew",
    'color.background.accent.orange.subtle.pressed': "_bfhk1phk",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.orange.bolder.hovered': "_bfhkhi52",
    'color.background.accent.orange.bolder.pressed': "_bfhkf767",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtlest.hovered': "_bfhk19g9",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk31d1",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtler.hovered': "_bfhklg04",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1d44",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.subtle.hovered': "_bfhk17e6",
    'color.background.accent.yellow.subtle.pressed': "_bfhko0y5",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk32kj",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkv5yf",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhkung8",
    'color.background.accent.green.subtler.pressed': "_bfhk1p19",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk8h4p",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1azz",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1j2h",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkg5py",
    'color.background.accent.teal.subtler.pressed': "_bfhkq7li",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk10ai",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhkse6l",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtlest.hovered': "_bfhkay3p",
    'color.background.accent.blue.subtlest.pressed': "_bfhk1xmr",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtler.hovered': "_bfhk16e6",
    'color.background.accent.blue.subtler.pressed': "_bfhk1uh7",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.subtle.hovered': "_bfhk1f4s",
    'color.background.accent.blue.subtle.pressed': "_bfhkqctv",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.blue.bolder.hovered': "_bfhk1cwi",
    'color.background.accent.blue.bolder.pressed': "_bfhkhcrq",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtlest.hovered': "_bfhkm0d5",
    'color.background.accent.purple.subtlest.pressed': "_bfhkgslw",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtler.hovered': "_bfhk1wyu",
    'color.background.accent.purple.subtler.pressed': "_bfhk5fkp",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.subtle.hovered': "_bfhk1wob",
    'color.background.accent.purple.subtle.pressed': "_bfhkwz05",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.purple.bolder.hovered': "_bfhkadgs",
    'color.background.accent.purple.bolder.pressed': "_bfhk1uro",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1een",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1r0p",
    'color.background.accent.magenta.subtler.pressed': "_bfhkxuzc",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk1ovh",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkwaw3",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtlest.hovered': "_bfhk12j4",
    'color.background.accent.gray.subtlest.pressed': "_bfhk1lb4",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtler.hovered': "_bfhk1f7l",
    'color.background.accent.gray.subtler.pressed': "_bfhkd8a2",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.subtle.hovered': "_bfhk1a2l",
    'color.background.accent.gray.subtle.pressed': "_bfhk1z0s",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.accent.gray.bolder.hovered': "_bfhke4nv",
    'color.background.accent.gray.bolder.pressed': "_bfhk82ra",
    'color.background.disabled': "_bfhksyzs",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhk1d5g",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.hovered': "_bfhk15ej",
    'color.background.neutral.pressed': "_bfhkip91",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk166n",
    'color.background.neutral.subtle.pressed': "_bfhk1dty",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.neutral.bold.hovered': "_bfhk1bsc",
    'color.background.neutral.bold.pressed': "_bfhk1b6k",
    'color.background.selected': "_bfhkfg4m",
    'color.background.selected.hovered': "_bfhki1yw",
    'color.background.selected.pressed': "_bfhk19ru",
    'color.background.selected.bold': "_bfhk1fvw",
    'color.background.selected.bold.hovered': "_bfhk18hz",
    'color.background.selected.bold.pressed': "_bfhkgr1v",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.subtlest.hovered': "_bfhkezq1",
    'color.background.brand.subtlest.pressed': "_bfhk2ggb",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.bold.hovered': "_bfhku1se",
    'color.background.brand.bold.pressed': "_bfhkqkzo",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.brand.boldest.hovered': "_bfhk1uwk",
    'color.background.brand.boldest.pressed': "_bfhk17jr",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1io2",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk9pqq",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.hovered': "_bfhk1rd4",
    'color.background.warning.pressed': "_bfhk11dh",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.warning.bold.hovered': "_bfhk1i4c",
    'color.background.warning.bold.pressed': "_bfhkrj9s",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.hovered': "_bfhk1jgi",
    'color.background.success.pressed': "_bfhky4f1",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.success.bold.hovered': "_bfhk1q4l",
    'color.background.success.bold.pressed': "_bfhkcrcn",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.hovered': "_bfhk1xp7",
    'color.background.discovery.pressed': "_bfhkdlkp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.discovery.bold.hovered': "_bfhk1w72",
    'color.background.discovery.bold.pressed': "_bfhkrb53",
    'color.background.information': "_bfhk33gi",
    'color.background.information.hovered': "_bfhk1vps",
    'color.background.information.pressed': "_bfhk1s0z",
    'color.background.information.bold': "_bfhk14wj",
    'color.background.information.bold.hovered': "_bfhk1amz",
    'color.background.information.bold.pressed': "_bfhk5bth",
    'color.blanket': "_bfhk10xm",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkn82g",
    'color.skeleton.subtle': "_bfhkh3tw",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk108i",
    'elevation.surface.pressed': "_bfhk1ji5",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk16qz",
    'elevation.surface.overlay.pressed': "_bfhkvq0a",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk1a0f",
    'elevation.surface.raised.pressed': "_bfhkf7u5",
    'elevation.surface.sunken': "_bfhkqbzx",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $fb641be27df99d98$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $fb641be27df99d98$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l108i",
    'elevation.surface.pressed': "_1q1l1ji5",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l16qz",
    'elevation.surface.overlay.pressed': "_1q1lvq0a",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l1a0f",
    'elevation.surface.raised.pressed': "_1q1lf7u5",
    'elevation.surface.sunken': "_1q1lqbzx"
};
var $fb641be27df99d98$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $fb641be27df99d98$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $fb641be27df99d98$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $fb641be27df99d98$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $fb641be27df99d98$var$Box = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $iO8YU.default)(_ref, $fb641be27df99d98$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $iO8YU.default)(htmlAttributes, $fb641be27df99d98$var$_excluded2);
    var node = /*#__PURE__*/ $1oC0p.createElement(Component, (0, $38yuU.default)({
        style: style,
        ref: ref,
        className: (0, $1kibr.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $fb641be27df99d98$var$backgroundColorMap[backgroundColor],
            backgroundColor && $fb641be27df99d98$var$isSurfaceToken(backgroundColor) && $fb641be27df99d98$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $fb641be27df99d98$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $fb641be27df99d98$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $fb641be27df99d98$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $fb641be27df99d98$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $1oC0p.createElement((0, $b0Mn8.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $fb641be27df99d98$export$2e2bcd8739ae039 = $fb641be27df99d98$var$Box;
function $fb641be27df99d98$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $fb641be27df99d98$var$setSurfaceTokenMap;
}

});
parcelRegister("38yuU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $248ce0f53026455f$export$2e2bcd8739ae039; });
function $248ce0f53026455f$export$2e2bcd8739ae039() {
    return $248ce0f53026455f$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $248ce0f53026455f$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("iO8YU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $db13dd0b614df578$export$2e2bcd8739ae039; });

var $iSHi1 = parcelRequire("iSHi1");
function $db13dd0b614df578$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $iSHi1.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("iSHi1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dbeed9937b9beb9e$export$2e2bcd8739ae039; });
function $dbeed9937b9beb9e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("b0Mn8", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $8045377e5d1bc209$export$1ca2a26fecb070ae; });

var $1oC0p = parcelRequire("1oC0p");
var $8045377e5d1bc209$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $8045377e5d1bc209$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($8045377e5d1bc209$export$1ca2a26fecb070ae);
};
$8045377e5d1bc209$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});



parcelRegister("38KZq", function(module, exports) {
$parcel$export(module.exports, "getMigrationTicketIcon", function () { return $43b6ca0204621264$export$e904f63c7a6ad1ac; });

var $7VQPk = parcelRequire("7VQPk");

var $9tcM4 = parcelRequire("9tcM4");

var $9joG0 = parcelRequire("9joG0");

var $j8V5h = parcelRequire("j8V5h");

var $kL2Jd = parcelRequire("kL2Jd");

var $5y1RD = parcelRequire("5y1RD");

var $euYaL = parcelRequire("euYaL");
const $43b6ca0204621264$export$e904f63c7a6ad1ac = (issueType)=>{
    switch(issueType){
        case (0, $9tcM4.FASTSHIFT_RELATED_TICKET_ISSUE_TYPE).CONSULT:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9joG0.ConsultIcon), {});
        case (0, $9tcM4.FASTSHIFT_RELATED_TICKET_ISSUE_TYPE).PLAN:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kL2Jd.PlanIcon), {});
        case (0, $9tcM4.FASTSHIFT_RELATED_TICKET_ISSUE_TYPE).SUPPORT_REQUEST:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $euYaL.SupportRequestIcon), {});
        case (0, $9tcM4.FASTSHIFT_RELATED_TICKET_ISSUE_TYPE).PROBLEM_REPORT:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5y1RD.ProblemIcon), {});
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j8V5h.IssueIcon), {});
    }
};

});
parcelRegister("9joG0", function(module, exports) {
$parcel$export(module.exports, "ConsultIcon", function () { return $f06abd8581ff83b4$export$5152f2c72a43e6c7; });

var $7VQPk = parcelRequire("7VQPk");
const $f06abd8581ff83b4$export$5152f2c72a43e6c7 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": "consult",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            clipRule: "evenodd",
            d: "m1 3c0-1.10457.89543-2 2-2h10c1.1046 0 2 .89543 2 2v10c0 1.1046-.8954 2-2 2h-10c-1.10457 0-2-.8954-2-2zm2-.5c-.27614 0-.5.22386-.5.5v10c0 .2761.22386.5.5.5h10c.2761 0 .5-.2239.5-.5v-10c0-.27614-.2239-.5-.5-.5h-3.48695l-1.16667 3h1.90362c.2476 0 .4792.12219.619.32655.1398.20435.1697.46453.08.69528l-1.75 4.49997-1.398-.5436 1.35262-3.4782h-1.90362c-.24759 0-.47923-.12219-.61902-.32655-.13979-.20435-.16972-.46453-.07998-.69528l1.35262-3.47817z",
            fill: "#f15b50",
            fillRule: "evenodd"
        })
    });

});

parcelRegister("j8V5h", function(module, exports) {
$parcel$export(module.exports, "IssueIcon", function () { return $88de2abd73f95908$export$cff2f7c4d3a0671f; });

var $7VQPk = parcelRequire("7VQPk");
const $88de2abd73f95908$export$cff2f7c4d3a0671f = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": "issue",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "m5 7.875 2 2.375 4-4.75m-9 7.75h12c.6904 0 1.25-.5596 1.25-1.25v-8c0-.69036-.5596-1.25-1.25-1.25h-12c-.69036 0-1.25.55964-1.25 1.25v8c0 .6904.55964 1.25 1.25 1.25z",
            stroke: "#4688ec",
            strokeLinejoin: "round",
            strokeWidth: "1.5"
        })
    });

});

parcelRegister("kL2Jd", function(module, exports) {
$parcel$export(module.exports, "PlanIcon", function () { return $a1f40c1f106add78$export$52fdd6ac94457e7e; });

var $7VQPk = parcelRequire("7VQPk");
const $a1f40c1f106add78$export$52fdd6ac94457e7e = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": "plan",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            clipRule: "evenodd",
            d: "m8 1.5c-1.38071 0-2.5 1.11929-2.5 2.5v3h5v-3c0-1.38071-1.11929-2.5-2.5-2.5zm4 5.5v-3c0-2.20914-1.7909-4-4-4-2.20914 0-4 1.79086-4 4v3c-1.10457 0-2 .89543-2 2v5c0 1.1046.89543 2 2 2h8c1.1046 0 2-.8954 2-2v-5c0-1.10457-.8954-2-2-2zm-8 1.5c-.27614 0-.5.22386-.5.5v5c0 .2761.22386.5.5.5h8c.2761 0 .5-.2239.5-.5v-5c0-.27614-.2239-.5-.5-.5z",
            fill: "#e06c00",
            fillRule: "evenodd"
        })
    });

});

parcelRegister("5y1RD", function(module, exports) {
$parcel$export(module.exports, "ProblemIcon", function () { return $cb88d0075708bc02$export$2ffd2f7dd3e3b851; });

var $7VQPk = parcelRequire("7VQPk");
const $cb88d0075708bc02$export$2ffd2f7dd3e3b851 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": "problem",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            clipRule: "evenodd",
            d: "m6.04021 1.52023-2.88889 3c-.15875.16486-.3841.24821-.61193.22634-.22782-.02188-.43319-.14659-.55767-.33865l-1.111114-1.71428 1.258734-.81585.59707.9212 2.23332-2.31922zm8.95979 1.97977h-8.00003v-1.5h8.00003zm-8.95979 3.27023-2.88889 3c-.15875.16486-.3841.24817-.61193.22634-.22782-.02188-.43319-.14659-.55767-.33865l-1.111114-1.71428 1.258724-.81585.59708.9212 2.23332-2.31922zm8.95979 1.97977h-8.00003v-1.5h8.00003zm-8.95979 3.2702-2.88889 3c-.15875.1649-.3841.2482-.61193.2264-.22782-.0219-.43319-.1466-.55767-.3387l-1.111115-1.7143 1.258725-.8158.59708.9212 2.23332-2.3192zm8.95979 1.9798h-8.00003v-1.5h8.00003z",
            fill: "#bf63f3",
            fillRule: "evenodd"
        })
    });

});

parcelRegister("euYaL", function(module, exports) {
$parcel$export(module.exports, "SupportRequestIcon", function () { return $32ec17a07e643757$export$83f266330efaf6ff; });

var $7VQPk = parcelRequire("7VQPk");
const $32ec17a07e643757$export$83f266330efaf6ff = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": "support-request",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            clipRule: "evenodd",
            d: "m1 3c0-1.10457.89543-2 2-2h10c1.1046 0 2 .89543 2 2v10c0 1.1046-.8954 2-2 2h-10c-1.10457 0-2-.8954-2-2zm2-.5c-.27614 0-.5.22386-.5.5v10c0 .2761.22386.5.5.5h10c.2761 0 .5-.2239.5-.5v-10c0-.27614-.2239-.5-.5-.5zm1 4.75h8v1.5h-8z",
            fill: "#6a9a23",
            fillRule: "evenodd"
        })
    });

});




parcelRegister("26OJ7", function(module, exports) {
$parcel$export(module.exports, "PaperPlaneVector", function () { return (parcelRequire("aimzj")).PaperPlaneVector; });
$parcel$export(module.exports, "MultiColorLine", function () { return (parcelRequire("8P4me")).MultiColorLine; });

var $aimzj = parcelRequire("aimzj");

var $8P4me = parcelRequire("8P4me");

});
parcelRegister("aimzj", function(module, exports) {
$parcel$export(module.exports, "PaperPlaneVector", function () { return $c9310761405dd0de$export$65ceaa350e9dc3d8; });

var $7VQPk = parcelRequire("7VQPk");
const $c9310761405dd0de$export$65ceaa350e9dc3d8 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "87",
        height: "67",
        viewBox: "0 0 87 67",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M86.8991 11.3607L5.23535 37.4356L34.3819 51.793L86.8991 11.3607Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M85.2155 12.3213L26.0303 50.7354L52.6541 66.3803L85.2155 12.3213Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M85.2202 12.3213L85.0183 12.8057L34.3822 51.7929L28.707 48.9997L85.2202 12.3213Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M85.2202 12.3213L85.0183 12.8057L34.3822 51.7929L28.707 48.9997L85.2202 12.3213Z",
                fill: "#164B35"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M33.6556 0.401855L0.109375 7.46549L11.1246 14.3596L33.6556 0.401855Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.9488 0.716797L7.84668 13.6009L16.1858 23.0581L32.9488 0.716797Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.9494 0.716797L32.8485 0.902469L11.1248 14.3597L8.98145 13.0196L32.9494 0.716797Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.9494 0.716797L32.8485 0.902469L11.1248 14.3597L8.98145 13.0196L32.9494 0.716797Z",
                fill: "#AE2A19"
            })
        ]
    });

});

parcelRegister("8P4me", function(module, exports) {
$parcel$export(module.exports, "MultiColorLine", function () { return $bd4bc8685d4eb070$export$57dd254d1e6160f5; });

var $7VQPk = parcelRequire("7VQPk");
const $bd4bc8685d4eb070$export$57dd254d1e6160f5 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M5.92996 22.61C5.92996 23 5.85496 23.385 5.70496 23.745C5.55496 24.105 5.33996 24.43 5.05996 24.71C4.78496 24.985 4.45496 25.205 4.09496 25.355C3.73496 25.505 3.34996 25.58 2.95996 25.58H25.58V19.655H2.96496C3.35496 19.655 3.73996 19.73 4.09996 19.88C4.45996 20.03 4.78496 20.245 5.05996 20.52C5.33496 20.795 5.55496 21.12 5.70496 21.48C5.85496 21.84 5.92996 22.225 5.92996 22.615V22.61Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M2.965 25.58V19.655C2.18 19.655 1.425 19.965 0.87 20.525C0.315 21.08 0 21.835 0 22.62C0 23.405 0.31 24.16 0.87 24.715C1.425 25.27 2.18 25.585 2.965 25.585V25.58Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M2.96484 25.58C3.74984 25.58 4.50484 25.27 5.05984 24.715C5.61484 24.16 5.92484 23.405 5.92484 22.62C5.92484 21.835 5.61484 21.08 5.05984 20.525C4.50484 19.97 3.74984 19.66 2.96484 19.66V25.58Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M2.96977 15.7449C4.60477 15.7449 5.92977 14.42 5.92977 12.785C5.92977 11.15 4.60477 9.82495 2.96977 9.82495C1.33477 9.82495 0.00976562 11.15 0.00976562 12.785C0.00976562 14.42 1.33477 15.7449 2.96977 15.7449Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M19.6647 12.785C19.6647 12 19.9747 11.245 20.5297 10.69C21.0847 10.135 21.8397 9.82495 22.6247 9.82495H7.30469V15.7449H22.6247C21.8397 15.7449 21.0847 15.43 20.5297 14.875C19.9747 14.32 19.6647 13.5649 19.6647 12.78V12.785Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.625 9.82495V15.7449C23.015 15.7449 23.4 15.6699 23.76 15.5199C24.12 15.3699 24.445 15.1549 24.72 14.88C24.995 14.6049 25.215 14.2799 25.36 13.9199C25.51 13.5599 25.585 13.175 25.585 12.785C25.585 12.395 25.51 12.01 25.36 11.65C25.21 11.29 24.995 10.965 24.72 10.69C24.445 10.415 24.12 10.195 23.76 10.05C23.4 9.89995 23.015 9.82495 22.625 9.82495Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.625 9.82495C21.84 9.82495 21.085 10.135 20.53 10.69C19.975 11.245 19.665 12 19.665 12.785C19.665 13.57 19.975 14.325 20.53 14.88C21.085 15.4349 21.84 15.7449 22.625 15.7449V9.82495Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18.2897 0H7.30469V5.92H18.2897V0Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M2.96977 5.92C4.60477 5.92 5.92977 4.595 5.92977 2.96C5.92977 1.325 4.60477 0 2.96977 0C1.33477 0 0.00976562 1.325 0.00976562 2.96C0.00976562 4.595 1.33477 5.92 2.96977 5.92Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.625 5.92C24.26 5.92 25.585 4.595 25.585 2.96C25.585 1.325 24.26 0 22.625 0C20.99 0 19.665 1.325 19.665 2.96C19.665 4.595 20.99 5.92 22.625 5.92Z",
                fill: "#1868DB"
            })
        ]
    });

});


parcelRegister("gGvtp", function(module, exports) {
$parcel$export(module.exports, "useMigrationTicketsListSectionAnalytics", function () { return $40207ca998c3a3bf$export$bc45576835705fb7; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");
const $40207ca998c3a3bf$export$bc45576835705fb7 = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)();
    const { fireTrackEvent: fireTrackEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    const selectedDomainOrg = (0, $f7YG8.useFastshiftSelector)((state)=>state.selectedDomainOrg);
    const { data: topSupportRequestsData } = (0, $f7YG8.useFastshiftSelector)((state)=>state.topSupportRequests);
    // Track event for migration tickets list displayed
    (0, $1oC0p.useEffect)(()=>{
        if (!identityAttrs || !selectedDomainOrg || !topSupportRequestsData) return;
        fireTrackEvent({
            action: (0, $3cXzX.ActionKey).DISPLAYED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).SECTION,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).MIGRATION_TICKETS_TOP_SECTION_DETAILS,
            source: sourceKey,
            attributes: {
                selectedOrgId: selectedDomainOrg.orgId,
                planTicketList: topSupportRequestsData.supportTickets.map(({ supportTicketId: supportTicketId })=>supportTicketId)
            }
        });
    }, [
        fireTrackEvent,
        sourceKey,
        selectedDomainOrg,
        topSupportRequestsData,
        identityAttrs
    ]);
};

});

parcelRegister("e2RMi", function(module, exports) {
$parcel$export(module.exports, "useTopMigrationTickets", function () { return $2ca7f6d33e3016eb$export$4887043d0c21c23; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("jtpMK");
var $2hq4z = parcelRequire("2hq4z");
parcelRequire("hVHtn");
var $8Bmsc = parcelRequire("8Bmsc");
var $f7YG8 = parcelRequire("f7YG8");

var $PE2DD = parcelRequire("PE2DD");
const $2ca7f6d33e3016eb$var$TOP_SUPPORT_REQUESTS_COUNT = 3;
const $2ca7f6d33e3016eb$export$4887043d0c21c23 = ()=>{
    const dispatch = (0, $f7YG8.useFastshiftDispatch)();
    const selectedDomainOrg = (0, $f7YG8.useFastshiftSelector)((state)=>state.selectedDomainOrg);
    const { data: customerDomainData } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomain);
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const { pending: pending, error: error, data: topSupportRequestsData, lastFetchParams: lastFetchParams } = (0, $f7YG8.useFastshiftSelector)((state)=>state.topSupportRequests);
    const supportTicketQueryParams = (0, $1oC0p.useMemo)(()=>{
        return selectedDomainOrg ? (0, $2hq4z.getOrgQueryParam)(selectedDomainOrg) : {};
    }, [
        selectedDomainOrg
    ]);
    const getTopSupportRequests = (0, $1oC0p.useCallback)((customerDomainId)=>{
        return dispatch((0, $8Bmsc.getFastshiftTopSupportRequests)({
            stargateClient: stargateClient,
            domainId: customerDomainId,
            count: $2ca7f6d33e3016eb$var$TOP_SUPPORT_REQUESTS_COUNT,
            queryParams: supportTicketQueryParams
        }));
    }, [
        dispatch,
        stargateClient,
        supportTicketQueryParams
    ]);
    (0, $1oC0p.useEffect)(()=>{
        let topSupportRequestsPromise = null;
        if (customerDomainData && selectedDomainOrg) {
            // Check if we need to fetch based on lastFetchParams
            const needsFetch = !lastFetchParams || lastFetchParams.customerDomainId !== customerDomainData.customerDomainId || lastFetchParams.queryParams.orgId !== supportTicketQueryParams.orgId || lastFetchParams.queryParams.permissionLevel !== supportTicketQueryParams.permissionLevel;
            // Skip fetch if data already cached for these params
            if (!needsFetch) return;
            topSupportRequestsPromise = getTopSupportRequests(customerDomainData.customerDomainId);
        }
        return ()=>{
            if (topSupportRequestsPromise) topSupportRequestsPromise.abort();
        };
    }, [
        dispatch,
        selectedDomainOrg,
        stargateClient,
        customerDomainData,
        supportTicketQueryParams,
        lastFetchParams,
        getTopSupportRequests
    ]);
    return (0, $dPABA._)((0, $6ogO3._)({
        pending: pending,
        error: error
    }, topSupportRequestsData ? topSupportRequestsData : {
        supportTickets: [],
        total: 0
    }), {
        handleRefresh: getTopSupportRequests
    });
};

});

parcelRegister("4EIUt", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $4f5a55a59a4d4cb7$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $4f5a55a59a4d4cb7$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    migrationTicketsTableHeading: {
        id: "fastshift.dashboard.migration-tickets-table.heading",
        defaultMessage: "Migration tickets",
        description: "Heading of the migration tickets table"
    },
    migrationTicketsTableDescriptionWithAnOrg: {
        id: "fastshift.dashboard.migration-tickets-table.description-with-an-org",
        defaultMessage: "Tickets associated with a selected cloud organization.",
        description: "Description of the migration tickets table with an org"
    },
    migrationTicketsTableDescriptionAsNotAnAdmin: {
        id: "fastshift.dashboard.migration-tickets-table.description-as-not-an-admin",
        defaultMessage: "Tickets associated with cloud organizations you\u2019re not an admin of.",
        description: "Description of the migration tickets table as not an admin"
    },
    migrationTicketsTableDescriptionWithNoOrg: {
        id: "fastshift.dashboard.migration-tickets-table.description-with-no-org",
        defaultMessage: "Tickets not associated with any cloud organization.",
        description: "Description of the migration tickets table with no org"
    },
    migrationTicketsListViewAll: {
        id: "fastshift.dashboard.migration-tickets-list.view-all",
        defaultMessage: "View all tickets",
        description: "Link text to view all migration tickets"
    },
    migrationTicketsListEmptyState: {
        id: "fastshift.dashboard.migration-tickets-list.empty-state",
        defaultMessage: "No migration tickets to show yet.",
        description: "Message displayed when no migration tickets are found"
    },
    migrationTicketsListErrorMessage: {
        id: "fastshift.dashboard.migration-tickets-list.error-message",
        defaultMessage: "We\u2019re unable to retrieve the data about your migration progress.",
        description: "Error message displayed when migration tickets fail to load"
    }
});

});



parcelRegister("dNM9R", function(module, exports) {
$parcel$export(module.exports, "SummarySection", function () { return (parcelRequire("aohNG")).SummarySection; });

var $aohNG = parcelRequire("aohNG");

});
parcelRegister("aohNG", function(module, exports) {
$parcel$export(module.exports, "SummarySection", function () { return $34f88ffa07e022c9$export$77fc3e7c6375c538; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $1p5OQ = parcelRequire("1p5OQ");

var $dTJrO = parcelRequire("dTJrO");

var $crY69 = parcelRequire("crY69");

var $g3ExX = parcelRequire("g3ExX");
var $fmW7P = parcelRequire("fmW7P");
var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $f6YGh = parcelRequire("f6YGh");

var $3cXzX = parcelRequire("3cXzX");
parcelRequire("dRWIs");
var $6f2qt = parcelRequire("6f2qt");
parcelRequire("2RRni");
var $bQWID = parcelRequire("bQWID");
parcelRequire("hVHtn");
var $af3Tw = parcelRequire("af3Tw");
var $8Bmsc = parcelRequire("8Bmsc");
var $f7YG8 = parcelRequire("f7YG8");
parcelRequire("6ezXX");
var $kLOFc = parcelRequire("kLOFc");
var $1c2IO = parcelRequire("1c2IO");

var $exB0Z = parcelRequire("exB0Z");
parcelRequire("k9OUw");
var $1m5bT = parcelRequire("1m5bT");
parcelRequire("jJQ0E");
var $7j6Ep = parcelRequire("7j6Ep");
parcelRequire("jY8rI");
var $78lTt = parcelRequire("78lTt");
const $34f88ffa07e022c9$var$topItemsStyles = (0, $f6YGh.xcss)({
    height: "32px" // This prevents layout shift when buttons are hidden
});
const $34f88ffa07e022c9$var$SummarySectionDetails = ()=>{
    const intl = (0, $8e22h.default)();
    const domainOrg = (0, $f7YG8.useFastshiftSelector)((state)=>state.selectedDomainOrg);
    const { summaryData: summaryData, errors: errors, isEmpty: isEmpty, isL1AssessmentsLoading: isL1AssessmentsLoading, isMigrationPlanTotalsLoading: isMigrationPlanTotalsLoading, isInstancesLoading: isInstancesLoading, loadL1Assessments: loadL1Assessments, loadMigrationPlanTotals: loadMigrationPlanTotals, loadInstances: loadInstances } = (0, $1c2IO.useSummary)();
    (0, $1oC0p.useEffect)(()=>{
        if (domainOrg && !Object.values((0, $af3Tw.RESERVED_ORG_IDS)).includes(domainOrg.orgId)) {
            loadL1Assessments(domainOrg.orgId);
            loadMigrationPlanTotals(domainOrg.orgId);
            loadInstances(domainOrg.orgId);
        }
    }, [
        domainOrg,
        loadL1Assessments,
        loadMigrationPlanTotals,
        loadInstances
    ]);
    const isNoOrgSelected = domainOrg && domainOrg.orgId === (0, $af3Tw.RESERVED_ORG_IDS).NO_ORG;
    const isOtherOrgsSelected = domainOrg && domainOrg.orgId === (0, $af3Tw.RESERVED_ORG_IDS).OTHER_ORGS;
    // Show empty state if "Other orgs" is selected
    if (isNoOrgSelected) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1m5bT.NoOrgDisplay), {});
    if (isOtherOrgsSelected) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7j6Ep.OtherOrgsDisplay), {});
    if (isEmpty) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6f2qt.EmptySummary), {
        orgId: (domainOrg === null || domainOrg === void 0 ? void 0 : domainOrg.orgId) || ""
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $78lTt.SummarySectionCard), {
                        title: intl.formatMessage((0, $exB0Z.messages).dataCenterCardHeading),
                        value: summaryData.dataCenter.count,
                        isLoading: isL1AssessmentsLoading,
                        error: errors.l1Assessments,
                        retry: ()=>loadL1Assessments((domainOrg === null || domainOrg === void 0 ? void 0 : domainOrg.orgId) || "")
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $78lTt.SummarySectionCard), {
                        title: intl.formatMessage((0, $exB0Z.messages).areaImprovementCardHeading),
                        value: summaryData.areaImprovement.count,
                        isLoading: isL1AssessmentsLoading,
                        error: errors.l1Assessments,
                        retry: ()=>loadL1Assessments((domainOrg === null || domainOrg === void 0 ? void 0 : domainOrg.orgId) || "")
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $78lTt.SummarySectionCard), {
                        title: intl.formatMessage((0, $exB0Z.messages).deletedAppsCardHeading),
                        value: summaryData.deletedApps.count,
                        isLoading: isInstancesLoading,
                        error: errors.instances,
                        retry: ()=>loadInstances((domainOrg === null || domainOrg === void 0 ? void 0 : domainOrg.orgId) || "")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $78lTt.SummarySectionCard), {
                        title: intl.formatMessage((0, $exB0Z.messages).migrationCompletedCardHeading),
                        value: summaryData.migrationCompleted.count,
                        isLoading: isMigrationPlanTotalsLoading,
                        error: errors.migrationPlanTotals,
                        retry: ()=>loadMigrationPlanTotals((domainOrg === null || domainOrg === void 0 ? void 0 : domainOrg.orgId) || "")
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $78lTt.SummarySectionCard), {
                        title: intl.formatMessage((0, $exB0Z.messages).migrationInProgressCardHeading),
                        value: summaryData.migrationInProgress.count,
                        isLoading: isMigrationPlanTotalsLoading,
                        error: errors.migrationPlanTotals,
                        retry: ()=>loadMigrationPlanTotals((domainOrg === null || domainOrg === void 0 ? void 0 : domainOrg.orgId) || "")
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $78lTt.SummarySectionCard), {
                        title: intl.formatMessage((0, $exB0Z.messages).unsuccessfulMigrationCardHeading),
                        value: summaryData.unsuccessfulMigration.count,
                        isLoading: isMigrationPlanTotalsLoading,
                        error: errors.migrationPlanTotals,
                        retry: ()=>loadMigrationPlanTotals((domainOrg === null || domainOrg === void 0 ? void 0 : domainOrg.orgId) || "")
                    })
                ]
            })
        ]
    });
};
const $34f88ffa07e022c9$export$77fc3e7c6375c538 = ()=>{
    const intl = (0, $8e22h.default)();
    const dispatch = (0, $f7YG8.useFastshiftDispatch)();
    const customerDomain = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomain);
    const domainOrg = (0, $f7YG8.useFastshiftSelector)((state)=>state.selectedDomainOrg);
    const setDomainOrg = (org)=>{
        if ((domainOrg === null || domainOrg === void 0 ? void 0 : domainOrg.orgId) === org.orgId) return;
        dispatch((0, $8Bmsc.setSelectedDomainOrg)(org));
    };
    const { sendMigrationSummarySectionLinkClickUIEvent: sendMigrationSummarySectionLinkClickUIEvent, sendOrgSelectorDropdownClickUIEvent: sendOrgSelectorDropdownClickUIEvent, sendOrgSelectorDropdownItemClickUIEvent: sendOrgSelectorDropdownItemClickUIEvent } = (0, $kLOFc.useDashboardUIAnalytics)();
    const baseUrl = "https://admin.atlassian.com";
    const migrationPlansUrl = `${baseUrl}/cloud-first-create-a-migration/${domainOrg === null || domainOrg === void 0 ? void 0 : domainOrg.orgId}`;
    const assessmentsUrl = `${baseUrl}/o/${domainOrg === null || domainOrg === void 0 ? void 0 : domainOrg.orgId}/product-insights/products`;
    // the selected org is not a special option (No org or Other orgs)
    const isValidCloudOrg = domainOrg && !Object.values((0, $af3Tw.RESERVED_ORG_IDS)).includes(domainOrg.orgId);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
        as: "section",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $fmW7P.default), {
                    alignItems: "center",
                    justifyContent: "space-between",
                    xcss: $34f88ffa07e022c9$var$topItemsStyles,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                            space: "space.200",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                                    size: "small",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $exB0Z.messages).summarySectionTitle))
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQWID.OrgSelectorDropdown), {
                                    customerDomain: customerDomain,
                                    selectedDomainOrg: domainOrg,
                                    onSetSelectedDomainOrg: setDomainOrg,
                                    sendOrgSelectorDropdownClickUIEvent: sendOrgSelectorDropdownClickUIEvent,
                                    sendOrgSelectorDropdownItemClickUIEvent: sendOrgSelectorDropdownItemClickUIEvent
                                })
                            ]
                        }),
                        isValidCloudOrg && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                            space: "space.100",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1p5OQ.default), {
                                    href: assessmentsUrl,
                                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($crY69))),
                                    target: "_blank",
                                    onClick: ()=>sendMigrationSummarySectionLinkClickUIEvent((0, $3cXzX.SubjectAttributeKey).VIEW_ASSESSMENTS, (domainOrg === null || domainOrg === void 0 ? void 0 : domainOrg.orgId) || (0, $af3Tw.RESERVED_ORG_IDS).NO_ORG),
                                    children: intl.formatMessage((0, $exB0Z.messages).viewAssessments)
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1p5OQ.default), {
                                    href: migrationPlansUrl,
                                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($crY69))),
                                    target: "_blank",
                                    onClick: ()=>sendMigrationSummarySectionLinkClickUIEvent((0, $3cXzX.SubjectAttributeKey).VIEW_MIGRATIONS, (domainOrg === null || domainOrg === void 0 ? void 0 : domainOrg.orgId) || (0, $af3Tw.RESERVED_ORG_IDS).NO_ORG),
                                    children: intl.formatMessage((0, $exB0Z.messages).viewMigrations)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)($34f88ffa07e022c9$var$SummarySectionDetails, {})
            ]
        })
    });
};

});
parcelRegister("dRWIs", function(module, exports) {
$parcel$export(module.exports, "EmptySummary", function () { return (parcelRequire("6f2qt")).EmptySummary; });

var $6f2qt = parcelRequire("6f2qt");

});
parcelRegister("6f2qt", function(module, exports) {
$parcel$export(module.exports, "EmptySummary", function () { return $908991f9f785d449$export$ea887ee58e627c40; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");

var $1p5OQ = parcelRequire("1p5OQ");

var $dTJrO = parcelRequire("dTJrO");

var $99VqK = parcelRequire("99VqK");
var $7OBrw = parcelRequire("7OBrw");
var $9HSUa = parcelRequire("9HSUa");
var $bHlSp = parcelRequire("bHlSp");
var $4HBPY = parcelRequire("4HBPY");

var $2I5jz = parcelRequire("2I5jz");

var $fNsiv = parcelRequire("fNsiv");
const $908991f9f785d449$var$containerStyles = (0, $4HBPY.xcss)({
    width: "100%",
    borderRadius: "border.radius.200",
    borderWidth: "border.width",
    borderStyle: "solid",
    borderColor: "color.border.disabled",
    backgroundColor: "elevation.surface.sunken",
    padding: "space.200"
});
const $908991f9f785d449$var$PaperAirplaneStyles = (0, $4HBPY.xcss)({
    display: "flex",
    width: "115px",
    height: "115px",
    justifyContent: "center",
    alignItems: "center"
});
const $908991f9f785d449$export$ea887ee58e627c40 = ({ orgId: orgId })=>{
    const assessmentsUrl = `https://admin.atlassian.com/o/${orgId}/product-insights/products`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7OBrw.default), {
        xcss: $908991f9f785d449$var$containerStyles,
        space: "space.400",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $99VqK.default), {
                xcss: $908991f9f785d449$var$PaperAirplaneStyles,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2I5jz.CloudsIcon), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9HSUa.default), {
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                        size: "small",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $fNsiv.messages).emptyAssessmentTitle))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bHlSp.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $fNsiv.messages).emptyAssessmentDescription))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7OBrw.default), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1p5OQ.default), {
                                href: assessmentsUrl,
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $fNsiv.messages).startAssessmentButton))
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1p5OQ.default), {
                                appearance: "subtle",
                                href: "https://support.atlassian.com/portfolio-insights/docs/what-is-portfolio-insights/",
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $fNsiv.messages).learnMoreLink))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("2I5jz", function(module, exports) {
$parcel$export(module.exports, "CloudsIcon", function () { return $32d320056cee5b16$export$3e275236e663d2b6; });

var $7VQPk = parcelRequire("7VQPk");
const $32d320056cee5b16$export$3e275236e663d2b6 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "103",
        height: "104",
        viewBox: "0 0 103 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.2387 42.2507C75.9353 42.2507 75.6394 42.2545 75.3398 42.2657C70.7703 30.5462 61.167 25.6396 46.8519 25.6396C26.3343 25.6396 15.0754 35.9059 15.0754 62.2552H97.4792C95.157 49.1536 87.3065 42.2507 76.235 42.2507H76.2387Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16.0231 65.7947H36.7355C34.8815 55.3299 28.6116 49.8203 19.7686 49.8203C11.5323 49.8203 5.94786 54.004 2.64062 65.7947H16.0231Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M19.7684 49.8203C18.465 49.8203 17.2327 49.9252 16.0604 50.1499C15.4124 53.7381 15.0791 57.7569 15.0791 62.2552H35.8814C33.3419 54.0939 27.5552 49.8241 19.7684 49.8241V49.8203Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.5483 66.6149C41.7917 66.6149 42.0314 66.6187 42.2711 66.6262C45.9454 57.2101 53.6611 53.2661 65.1596 53.2661C81.6471 53.2661 90.6924 61.5173 90.6924 82.6867H24.4802C26.3455 72.1582 32.6528 66.6149 41.552 66.6149H41.5483Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M85.8495 62.2515C81.5872 55.9741 74.5981 53.2661 65.1633 53.2661C55.7285 53.2661 48.7133 55.9741 44.5259 62.2515H85.8495Z",
                fill: "#09326C"
            })
        ]
    });

});

parcelRegister("fNsiv", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $1fbad467ea7eb0bd$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $1fbad467ea7eb0bd$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    emptyAssessmentTitle: {
        id: "fastshift.emptyAssessmentTitle",
        defaultMessage: "You have no assessment data for this organisation",
        description: "Title displayed when no assessments are available."
    },
    emptyAssessmentDescription: {
        id: "fastshift.emptyAssessmentDescription",
        defaultMessage: "First step on the journey to Cloud is to assess your Data Center instances and understand their Cloud readiness. Follow the link to start the process.",
        description: "Description displayed when no assessments are available, prompting the user to create one."
    },
    startAssessmentButton: {
        id: "fastshift.startAssessmentButton",
        defaultMessage: "Start assessment",
        description: "Button text to initiate a new assessment."
    },
    learnMoreLink: {
        id: "fastshift.learnMoreLink",
        defaultMessage: "Learn more about assessments",
        description: "Link text to provide more information about assessments."
    }
});

});



parcelRegister("2RRni", function(module, exports) {
$parcel$export(module.exports, "OrgSelectorDropdown", function () { return (parcelRequire("bQWID")).OrgSelectorDropdown; });

var $bQWID = parcelRequire("bQWID");

});
parcelRegister("bQWID", function(module, exports) {
$parcel$export(module.exports, "OrgSelectorDropdown", function () { return $5fe3ded8c5675ee0$export$dea5ca6f2210466; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $kMnBu = parcelRequire("kMnBu");
var $aKsx2 = parcelRequire("aKsx2");

var $cjwre = parcelRequire("cjwre");
parcelRequire("2DLpP");
var $cHXyg = parcelRequire("cHXyg");
parcelRequire("CkQbX");
var $f5jKK = parcelRequire("f5jKK");
const $5fe3ded8c5675ee0$export$dea5ca6f2210466 = ({ customerDomain: customerDomain, selectedDomainOrg: selectedDomainOrg, onSetSelectedDomainOrg: onSetSelectedDomainOrg, sendOrgSelectorDropdownClickUIEvent: sendOrgSelectorDropdownClickUIEvent, sendOrgSelectorDropdownItemClickUIEvent: sendOrgSelectorDropdownItemClickUIEvent, buttonSpacing: buttonSpacing = "compact" })=>{
    const { data: customerDomainData, pending: customerDomainPending } = customerDomain;
    const hasOrgs = !customerDomainPending && customerDomainData && customerDomainData.orgsWithAdminRole.length > 0 || false;
    (0, $1oC0p.useEffect)(()=>{
        if (!customerDomainPending && customerDomainData) {
            if (hasOrgs && !selectedDomainOrg) {
                const firstOrg = customerDomainData.orgsWithAdminRole[0];
                if (firstOrg) onSetSelectedDomainOrg(firstOrg);
            }
            if (!hasOrgs && !selectedDomainOrg) onSetSelectedDomainOrg((0, $cjwre.OTHER_ORG_FILTER));
        }
    }, [
        customerDomainData,
        customerDomainPending,
        hasOrgs,
        selectedDomainOrg,
        onSetSelectedDomainOrg
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kMnBu.default), {
        // This is atlaskit's recommended pattern for custom trigger components
        // eslint-disable-next-line react/no-unstable-nested-components
        trigger: (_param)=>{
            var { triggerRef: triggerRef } = _param, providedProps = (0, $aPnCa._)(_param, [
                "triggerRef"
            ]);
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cHXyg.OrgSelectorDropdownButton), (0, $dPABA._)((0, $6ogO3._)({
                triggerRef: triggerRef
            }, providedProps), {
                selectedDomainOrg: selectedDomainOrg,
                isLoading: customerDomainPending,
                isDisabled: customerDomainPending,
                sendOrgSelectorDropdownClickUIEvent: sendOrgSelectorDropdownClickUIEvent,
                spacing: buttonSpacing
            }));
        },
        spacing: "compact",
        shouldRenderToParent: true,
        isLoading: customerDomainPending,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aKsx2.default), {
            children: customerDomainData && [
                ...customerDomainData.orgsWithAdminRole,
                ...(0, $cjwre.DEFAULT_ORG_FILTERS_ORDER)
            ].map((org)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $f5jKK.OrgSelectorDropdownItem), {
                    org: org,
                    isSelected: org.orgId === (selectedDomainOrg === null || selectedDomainOrg === void 0 ? void 0 : selectedDomainOrg.orgId),
                    onSetSelectedDomainOrg: onSetSelectedDomainOrg,
                    sendOrgSelectorDropdownItemClickUIEvent: sendOrgSelectorDropdownItemClickUIEvent
                }, org.orgId))
        })
    });
};

});
parcelRegister("cjwre", function(module, exports) {
$parcel$export(module.exports, "OTHER_ORG_FILTER", function () { return $09e23db97a0c211c$export$5104ef36eb44df08; });
$parcel$export(module.exports, "DEFAULT_ORG_FILTERS_ORDER", function () { return $09e23db97a0c211c$export$4984c21048c8fcf6; });
parcelRequire("hVHtn");
var $af3Tw = parcelRequire("af3Tw");
const $09e23db97a0c211c$export$30872958cab48234 = {
    orgId: (0, $af3Tw.RESERVED_ORG_IDS).NO_ORG,
    orgName: "No Org" // do not display this name on UI
};
const $09e23db97a0c211c$export$5104ef36eb44df08 = {
    orgId: (0, $af3Tw.RESERVED_ORG_IDS).OTHER_ORGS,
    orgName: "Other Cloud Orgs" // do not display this name on UI
};
const $09e23db97a0c211c$export$4984c21048c8fcf6 = [
    $09e23db97a0c211c$export$5104ef36eb44df08,
    $09e23db97a0c211c$export$30872958cab48234
];

});

parcelRegister("2DLpP", function(module, exports) {
$parcel$export(module.exports, "OrgSelectorDropdownButton", function () { return (parcelRequire("cHXyg")).OrgSelectorDropdownButton; });

var $cHXyg = parcelRequire("cHXyg");

});
parcelRegister("cHXyg", function(module, exports) {
$parcel$export(module.exports, "OrgSelectorDropdownButton", function () { return $ab3422438e02a692$export$d5fe24fe84b0508f; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $1HVQz = parcelRequire("1HVQz");

var $5RBBI = parcelRequire("5RBBI");

var $3nGGx = parcelRequire("3nGGx");

var $79ZK0 = parcelRequire("79ZK0");

var $7g79J = parcelRequire("7g79J");
parcelRequire("5zgzR");
var $7ZBTI = parcelRequire("7ZBTI");
const $ab3422438e02a692$export$d5fe24fe84b0508f = (_param)=>{
    var { triggerRef: triggerRef, selectedDomainOrg: selectedDomainOrg, isLoading: isLoading, isDisabled: isDisabled, sendOrgSelectorDropdownClickUIEvent: sendOrgSelectorDropdownClickUIEvent, spacing: spacing = "compact" } = _param, providedProps = (0, $aPnCa._)(_param, [
        "triggerRef",
        "selectedDomainOrg",
        "isLoading",
        "isDisabled",
        "sendOrgSelectorDropdownClickUIEvent",
        "spacing"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), (0, $dPABA._)((0, $6ogO3._)({
        ref: triggerRef
    }, providedProps), {
        spacing: spacing,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: (e)=>{
            var _providedProps_onClick;
            sendOrgSelectorDropdownClickUIEvent();
            (_providedProps_onClick = providedProps.onClick) === null || _providedProps_onClick === void 0 ? void 0 : _providedProps_onClick.call(providedProps, e);
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
            space: "space.100",
            alignInline: "center",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3nGGx))), {
                    label: "Org icon"
                }),
                selectedDomainOrg ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7ZBTI.OrgSelectorItemMessage), {
                    org: selectedDomainOrg
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $7g79J.messages).orgSelectorDropdownNoOrgSelected)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))), {
                    label: "Chevron down icon",
                    size: "small"
                })
            ]
        })
    }));
};

});
parcelRegister("7g79J", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $68afe4500c8717e6$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $68afe4500c8717e6$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    orgSelectorDropdownNoOrgForOrgAdmin: {
        id: "fastshift.dashboard.welcome-banner.org-selector.selected-org-is-no-org",
        defaultMessage: "No cloud organization",
        description: "Message for MOVE tickets that do not contain a reference to a destination cloud org, in the org selector dropdown button on welcome banner"
    },
    orgSelectorDropdownOtherOrgsForOrgAdmin: {
        id: "fastshift.dashboard.welcome-banner.org-selector.selected-org-is-other-orgs",
        defaultMessage: "Other cloud organizations",
        description: "Message for MOVE tickets associated with cloud orgs that the customer is NOT org admin of, in the org selector dropdown button on welcome banner"
    },
    orgSelectorDropdownNoOrgSelected: {
        id: "fastshift.dashboard.welcome-banner.org-selector.org-not-selected-fallback",
        defaultMessage: "Select an organization...",
        description: "Fallback message displayed instead of the dropdown when the org has not been selected. Since orgs are selected automatically, this is only shown if there is a bug."
    }
});

});

parcelRegister("5zgzR", function(module, exports) {
$parcel$export(module.exports, "OrgSelectorItemMessage", function () { return (parcelRequire("7ZBTI")).OrgSelectorItemMessage; });

var $7ZBTI = parcelRequire("7ZBTI");

});
parcelRegister("7ZBTI", function(module, exports) {
$parcel$export(module.exports, "OrgSelectorItemMessage", function () { return $f1a73e8bfd58c9f1$export$e4d0ffcb60a134c7; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $lPRxe = parcelRequire("lPRxe");
parcelRequire("hVHtn");
var $af3Tw = parcelRequire("af3Tw");

var $7g79J = parcelRequire("7g79J");
const $f1a73e8bfd58c9f1$export$e4d0ffcb60a134c7 = ({ org: org })=>{
    switch(org.orgId){
        case (0, $af3Tw.RESERVED_ORG_IDS).NO_ORG:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $7g79J.messages).orgSelectorDropdownNoOrgForOrgAdmin))
            });
        case (0, $af3Tw.RESERVED_ORG_IDS).OTHER_ORGS:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $7g79J.messages).orgSelectorDropdownOtherOrgsForOrgAdmin))
            });
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                children: org.orgName
            });
    }
};

});




parcelRegister("CkQbX", function(module, exports) {
$parcel$export(module.exports, "OrgSelectorDropdownItem", function () { return (parcelRequire("f5jKK")).OrgSelectorDropdownItem; });

var $f5jKK = parcelRequire("f5jKK");

});
parcelRegister("f5jKK", function(module, exports) {
$parcel$export(module.exports, "OrgSelectorDropdownItem", function () { return $21a443490aa6cae7$export$1127d69ac57174e1; });

var $7VQPk = parcelRequire("7VQPk");

var $i99jD = parcelRequire("i99jD");

var $3nGGx = parcelRequire("3nGGx");

var $79ZK0 = parcelRequire("79ZK0");
parcelRequire("5zgzR");
var $7ZBTI = parcelRequire("7ZBTI");
const $21a443490aa6cae7$export$1127d69ac57174e1 = ({ org: org, isSelected: isSelected, onSetSelectedDomainOrg: onSetSelectedDomainOrg, sendOrgSelectorDropdownItemClickUIEvent: sendOrgSelectorDropdownItemClickUIEvent })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i99jD.default), {
        isSelected: isSelected,
        onClick: ()=>{
            sendOrgSelectorDropdownItemClickUIEvent(org.orgId);
            onSetSelectedDomainOrg(org);
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
            space: "space.100",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3nGGx))), {
                    label: "Org Icon"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7ZBTI.OrgSelectorItemMessage), {
                    org: org
                })
            ]
        })
    }, org.orgId);
};

});




parcelRegister("exB0Z", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $f70fb426b1efb330$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $f70fb426b1efb330$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    summarySectionTitle: {
        id: "fastshift.dashboard.summary-section.title",
        defaultMessage: "Summary",
        description: "Title for the summary section"
    },
    dataCenterCardHeading: {
        id: "fastshift.dashboard.data-center-card.heading",
        defaultMessage: "Data Center instances assessed",
        description: "Heading for the data center summary card"
    },
    areaImprovementCardHeading: {
        id: "fastshift.dashboard.area-improvement-card.heading",
        defaultMessage: "Areas to improve",
        description: "Heading for the area improvement summary card"
    },
    deletedAppsCardHeading: {
        id: "fastshift.dashboard.deleted-apps-card.heading",
        defaultMessage: "Deleted apps",
        description: "Heading for the deleted apps summary card"
    },
    migrationCompletedCardHeading: {
        id: "fastshift.dashboard.migration-completed-card.heading",
        defaultMessage: "Migrations completed",
        description: "Heading for the migration completed summary card"
    },
    migrationInProgressCardHeading: {
        id: "fastshift.dashboard.migration-running-card.heading",
        defaultMessage: "Migrations in progress",
        description: "Heading for the migration in progress summary card"
    },
    unsuccessfulMigrationCardHeading: {
        id: "fastshift.dashboard.unsuccessful-migration-card.heading",
        defaultMessage: "Unsuccessful migrations",
        description: "Heading for the unsuccessful migration summary card"
    },
    viewMigrations: {
        id: "fastshift.dashboard.organisation-summary.view-migrations",
        defaultMessage: "View migrations",
        description: "Button text to view migrations in the migration summary"
    },
    viewAssessments: {
        id: "fastshift.dashboard.organisation-summary.view-assessments",
        defaultMessage: "View assessments",
        description: "Button text to view assessments in the migration summary"
    }
});

});

parcelRegister("k9OUw", function(module, exports) {
$parcel$export(module.exports, "NoOrgDisplay", function () { return (parcelRequire("1m5bT")).NoOrgDisplay; });

var $1m5bT = parcelRequire("1m5bT");

});
parcelRegister("1m5bT", function(module, exports) {
$parcel$export(module.exports, "NoOrgDisplay", function () { return $b6086de0f8cf77d3$export$e538b736891fca54; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $dTJrO = parcelRequire("dTJrO");

var $g3ExX = parcelRequire("g3ExX");
var $fmW7P = parcelRequire("fmW7P");
var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");

var $lP7A9 = parcelRequire("lP7A9");
parcelRequire("26OJ7");
var $aimzj = parcelRequire("aimzj");

var $bVo8m = parcelRequire("bVo8m");
const $b6086de0f8cf77d3$var$boxStyles = (0, $f6YGh.xcss)({
    borderRadius: "border.radius.200",
    border: `1px solid ${(0, $lP7A9.default)("color.border.disabled")}`
});
const $b6086de0f8cf77d3$var$iconContainerStyles = (0, $f6YGh.xcss)({
    width: "111px",
    height: "111px"
});
const $b6086de0f8cf77d3$export$e538b736891fca54 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
        padding: "space.300",
        backgroundColor: "elevation.surface.sunken",
        xcss: $b6086de0f8cf77d3$var$boxStyles,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
            space: "space.400",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fmW7P.default), {
                    xcss: $b6086de0f8cf77d3$var$iconContainerStyles,
                    alignItems: "center",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aimzj.PaperPlaneVector), {})
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $bVo8m.messages).noOrgDisplayTitle))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $bVo8m.messages).noOrgDisplayDescription))
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("bVo8m", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $fb7cd4982b363abf$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $fb7cd4982b363abf$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    noOrgDisplayTitle: {
        id: "fastshift.dashboard.no-org-display.title",
        defaultMessage: "You\u2019re viewing tickets that aren\u2019t associated with any cloud organization",
        description: "Title for the no org display"
    },
    noOrgDisplayDescription: {
        id: "fastshift.dashboard.no-org-display.description",
        defaultMessage: "Tickets linked to an existing cloud organization appear under that organization\u2019s name. Once linked, you\u2019ll find the ticket in its respective view.",
        description: "Description for the no org display"
    }
});

});



parcelRegister("jJQ0E", function(module, exports) {
$parcel$export(module.exports, "OtherOrgsDisplay", function () { return (parcelRequire("7j6Ep")).OtherOrgsDisplay; });

var $7j6Ep = parcelRequire("7j6Ep");

});
parcelRegister("7j6Ep", function(module, exports) {
$parcel$export(module.exports, "OtherOrgsDisplay", function () { return $0589447ec1bf594a$export$dd105b474c1cc1e4; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $dTJrO = parcelRequire("dTJrO");

var $g3ExX = parcelRequire("g3ExX");
var $fmW7P = parcelRequire("fmW7P");
var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");

var $lP7A9 = parcelRequire("lP7A9");
parcelRequire("26OJ7");
var $aimzj = parcelRequire("aimzj");

var $ik0gk = parcelRequire("ik0gk");
const $0589447ec1bf594a$var$boxStyles = (0, $f6YGh.xcss)({
    borderRadius: "border.radius.200",
    border: `1px solid ${(0, $lP7A9.default)("color.border.disabled")}`
});
const $0589447ec1bf594a$var$iconContainerStyles = (0, $f6YGh.xcss)({
    width: "111px",
    height: "111px"
});
const $0589447ec1bf594a$export$dd105b474c1cc1e4 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
        padding: "space.300",
        backgroundColor: "elevation.surface.sunken",
        xcss: $0589447ec1bf594a$var$boxStyles,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
            space: "space.400",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fmW7P.default), {
                    xcss: $0589447ec1bf594a$var$iconContainerStyles,
                    alignItems: "center",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aimzj.PaperPlaneVector), {})
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $ik0gk.messages).otherOrgsDisplayTitle))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $ik0gk.messages).otherOrgsDisplayDescription))
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("ik0gk", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $d92bf3595b1bf4b7$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $d92bf3595b1bf4b7$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    otherOrgsDisplayTitle: {
        id: "fastshift.dashboard.other-orgs-display.title",
        defaultMessage: "You\u2019re viewing tickets associated with cloud organizations where you\u2019re not an org admin",
        description: "Title for the other orgs display"
    },
    otherOrgsDisplayDescription: {
        id: "fastshift.dashboard.other-orgs-display.description",
        defaultMessage: "If you have access to a ticket, but not sufficient permissions in cloud, you\u2019ll see it here without extra details about the organization.",
        description: "Description for the other orgs display"
    }
});

});



parcelRegister("jY8rI", function(module, exports) {
$parcel$export(module.exports, "SummarySectionCard", function () { return (parcelRequire("78lTt")).SummarySectionCard; });

var $78lTt = parcelRequire("78lTt");

});
parcelRegister("78lTt", function(module, exports) {
$parcel$export(module.exports, "SummarySectionCard", function () { return $4ca2899c489cb1fc$export$791caf28437942a5; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");

var $1HVQz = parcelRequire("1HVQz");

var $dTJrO = parcelRequire("dTJrO");

var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");

var $4jcRW = parcelRequire("4jcRW");

var $82exR = parcelRequire("82exR");
const $4ca2899c489cb1fc$var$containerStyle = (0, $f6YGh.xcss)({
    borderRadius: "border.radius.200",
    borderColor: "color.border",
    borderWidth: "border.width",
    borderStyle: "solid",
    padding: "space.200",
    minHeight: "80px"
});
const $4ca2899c489cb1fc$export$791caf28437942a5 = ({ title: title, value: value, isLoading: isLoading, error: error, retry: retry })=>{
    if (isLoading) return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
        xcss: $4ca2899c489cb1fc$var$containerStyle,
        grow: "fill",
        alignBlock: "center",
        space: "space.075",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                height: "12px",
                width: "100%"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                height: "20px",
                width: "100%"
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
        xcss: $4ca2899c489cb1fc$var$containerStyle,
        grow: "fill",
        alignBlock: "center",
        alignInline: "center",
        space: "space.025",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $82exR.messages).errorHeading))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), {
                appearance: "subtle",
                onClick: retry,
                spacing: "compact",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                    size: "small",
                    color: "color.link",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $82exR.messages).refresh))
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
        xcss: $4ca2899c489cb1fc$var$containerStyle,
        grow: "fill",
        alignBlock: "center",
        space: "space.075",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                size: "xxsmall",
                children: title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                size: "medium",
                children: value
            })
        ]
    });
};

});
parcelRegister("82exR", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $976e0e1d72c95250$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $976e0e1d72c95250$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    errorHeading: {
        id: "fastshift.dashboard.summary-section-card.error-heading",
        defaultMessage: "An Error Occurred",
        description: "Error heading for the summary section card"
    },
    refreshPage: {
        id: "fastshift.dashboard.summary-section-card.refresh-page-link",
        defaultMessage: "Refresh the page",
        description: "Refresh page link for the summary section card"
    },
    refresh: {
        id: "fastshift.dashboard.summary-section-card.refresh",
        defaultMessage: "Refresh",
        description: "Refresh data for the summary section card"
    }
});

});







parcelRegister("l4mrf", function(module, exports) {
$parcel$export(module.exports, "FastshiftCustomerSelectionPage", function () { return (parcelRequire("gXpxP")).FastshiftCustomerSelectionPage; });

var $gXpxP = parcelRequire("gXpxP");

});
parcelRegister("gXpxP", function(module, exports) {
$parcel$export(module.exports, "FastshiftCustomerSelectionPage", function () { return $c1aab659ec7339ce$export$2d7c9f9e8f1be7b; });
/* fastshift-customer-selection.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $gcfBV = parcelRequire("gcfBV");

var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
parcelRequire("z8fwG");
var $1NoJu = parcelRequire("1NoJu");
parcelRequire("kDIm2");
var $eh9Uj = parcelRequire("eh9Uj");
var $dyxra = parcelRequire("dyxra");
var $c9epK = parcelRequire("c9epK");

var $hv38C = parcelRequire("hv38C");
parcelRequire("jtpMK");
var $iS5nW = parcelRequire("iS5nW");
var $lmgkB = parcelRequire("lmgkB");
parcelRequire("LvLsc");
var $jeZYf = parcelRequire("jeZYf");
parcelRequire("hVHtn");
var $8Bmsc = parcelRequire("8Bmsc");
var $af3Tw = parcelRequire("af3Tw");
var $f7YG8 = parcelRequire("f7YG8");

var $PE2DD = parcelRequire("PE2DD");

var $at5jC = parcelRequire("at5jC");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $3riD8 = parcelRequire("3riD8");
parcelRequire("hjtkK");
var $hApyR = parcelRequire("hApyR");

var $45I4V = parcelRequire("45I4V");
parcelRequire("7kNfV");
var $2Ciyk = parcelRequire("2Ciyk");
const $c1aab659ec7339ce$var$PageContainer = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $aPnCa._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, (0, $dPABA._)((0, $6ogO3._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_1bsb1osq _p12f1yae",
            __cmplp.className
        ])
    }));
});
const $c1aab659ec7339ce$var$CustomizedStatusOptionContent = (option)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $gcfBV.default), {
        appearance: (0, $lmgkB.getStatusColor)(option.value),
        isBold: true,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $lmgkB.getStatusText)(option.value)))
    });
const $c1aab659ec7339ce$export$2d7c9f9e8f1be7b = ()=>{
    const userInfo = (0, $3riD8.useLoggedInUser)();
    const currentTime = (0, $iS5nW.getCurrentTime)();
    const dispatch = (0, $f7YG8.useFastshiftDispatch)();
    const stargateClient = (0, $at5jC.useBxpWebStargateClient)();
    const intl = (0, $8e22h.default)();
    const isRollUpStatusEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).sxpFastshiftPortalEnableRollUpStatus);
    const { data: customerDomains } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomains);
    const selectionTableControls = (0, $f7YG8.useFastshiftSelector)((state)=>state.pageStateCache[(0, $af3Tw.TABLE_IDS).SELECTION]);
    (0, $1oC0p.useEffect)(()=>{
        if (!customerDomains || customerDomains.data.length === 0) dispatch((0, $8Bmsc.getCustomerDomains)({
            stargateClient: stargateClient,
            controls: selectionTableControls
        }));
    // we only want this effect to run once on page load once stargate client is available
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        stargateClient
    ]);
    const onSetControlsPayload = (controls)=>{
        dispatch((0, $8Bmsc.setTableControls)({
            tableId: (0, $af3Tw.TABLE_IDS).SELECTION,
            controls: controls
        }));
        dispatch((0, $8Bmsc.getCustomerDomains)({
            stargateClient: stargateClient,
            controls: controls
        }));
    };
    (0, $hApyR.useCustomerSelectionPageAnalytics)();
    const { isTableLoading: isTableLoading, isTableError: isTableError, rows: rows, head: head, pagination: pagination } = (0, $2Ciyk.useDomainSelectionTable)();
    const ErrorComponent = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NoJu.GenericErrorDisplay), {
        customMessage: intl.formatMessage((0, $45I4V.messages).errorMessage),
        onRefresh: ()=>{
            dispatch((0, $8Bmsc.getCustomerDomains)({
                stargateClient: stargateClient,
                controls: (0, $eh9Uj.DEFAULT_CONTROLS_PAYLOAD)
            }));
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $79ZK0.default), {
        alignInline: "center",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($c1aab659ec7339ce$var$PageContainer, {
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                space: "space.400",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                        space: "space.300",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jeZYf.PartnerWelcomeBanner), {
                                currentTime: currentTime,
                                userName: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hv38C.LegalBanner), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dyxra.FastshiftTable), {
                        id: "customer-selection-table",
                        enableSearch: true,
                        toolbarContent: isRollUpStatusEnabled ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $c9epK.FastshiftTableFilterDropdown), {
                            label: intl.formatMessage((0, $45I4V.messages).statusFilterDropdownLabel),
                            options: Object.values((0, $PE2DD.FASTSHIFT_ROLL_UP_STATUS)).map((status)=>({
                                    label: status,
                                    value: status
                                })),
                            customOptionContent: $c1aab659ec7339ce$var$CustomizedStatusOptionContent,
                            onOptionClick: (option)=>{
                                onSetControlsPayload((0, $dPABA._)((0, $6ogO3._)({}, selectionTableControls), {
                                    filters: {
                                        status: option.value
                                    }
                                }));
                            }
                        }) : null,
                        summaryText: intl.formatMessage((0, $45I4V.messages).summaryText, {
                            viewSize: rows.length,
                            totalNumber: pagination.totalElements
                        }),
                        isTableLoading: isTableLoading,
                        isTableError: isTableError,
                        errorComponent: ErrorComponent,
                        head: head,
                        rows: rows,
                        controls: {
                            onSetControlsPayload: onSetControlsPayload,
                            controls: selectionTableControls,
                            pagination: pagination
                        }
                    })
                ]
            })
        })
    });
};

});
parcelRegister("kDIm2", function(module, exports) {
$parcel$export(module.exports, "FastshiftTable", function () { return (parcelRequire("dyxra")).FastshiftTable; });
$parcel$export(module.exports, "DEFAULT_CONTROLS_PAYLOAD", function () { return (parcelRequire("eh9Uj")).DEFAULT_CONTROLS_PAYLOAD; });
$parcel$export(module.exports, "FastshiftTableFilterDropdown", function () { return (parcelRequire("c9epK")).FastshiftTableFilterDropdown; });

var $dyxra = parcelRequire("dyxra");

var $eh9Uj = parcelRequire("eh9Uj");
parcelRequire("bF9Q8");
var $c9epK = parcelRequire("c9epK");

});
parcelRegister("dyxra", function(module, exports) {
$parcel$export(module.exports, "FastshiftTable", function () { return $9abce15fa73bb432$export$86fd6b3c9e851f41; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $1QfCI = parcelRequire("1QfCI");

var $g3ExX = parcelRequire("g3ExX");
var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");
parcelRequire("5En5H");
var $ky2Uk = parcelRequire("ky2Uk");

var $eh9Uj = parcelRequire("eh9Uj");
parcelRequire("iaJvq");
var $6vd2N = parcelRequire("6vd2N");
parcelRequire("2MBb4");
var $2N0OI = parcelRequire("2N0OI");
parcelRequire("fZEv5");
var $0xGy7 = parcelRequire("0xGy7");
parcelRequire("eQxC1");
var $dlnus = parcelRequire("dlnus");
var $cUZmH = parcelRequire("cUZmH");

var $gQY0i = parcelRequire("gQY0i");
const $9abce15fa73bb432$var$emptyTableContainerStyles = (0, $f6YGh.xcss)({
    height: "200px",
    width: "100%",
    padding: "space.400"
});
const $9abce15fa73bb432$var$emptyTableIconContainer = (0, $f6YGh.xcss)({
    paddingBlock: "space.100"
});
const $9abce15fa73bb432$export$86fd6b3c9e851f41 = ({ enableSearch: enableSearch = false, summaryText: summaryText, toolbarContent: toolbarContent, toolbarSpacing: toolbarSpacing = "space.200", isTableLoading: isTableLoading, isTableError: isTableError, errorComponent: errorComponent, head: head, rows: rows, controls: controls, id: id = "fastshift-table", testId: testId = "fastshift-table", showToolbarOnError: showToolbarOnError = false, enableRowClick: enableRowClick = false })=>{
    const intl = (0, $8e22h.default)();
    const { pagination: pagination, sorting: sorting, search: search } = (0, $cUZmH.useFastshiftTableControls)((0, $dPABA._)((0, $6ogO3._)({}, controls), {
        enableSearch: enableSearch
    }));
    const { sendSearchUIEvent: sendSearchUIEvent, sendNavigationUIEvent: sendNavigationUIEvent, sendPageSizeChangeUIEvent: sendPageSizeChangeUIEvent, sendSortUIEvent: sendSortUIEvent } = (0, $dlnus.useFastshiftTableAnalytics)();
    // Enhanced sort handler that triggers analytics
    const handleSort = (0, $1oC0p.useCallback)((key)=>{
        const nextOrder = sorting.sortBy === key && sorting.sortDirection === (0, $eh9Uj.SORT_DIRECTION).ASC ? (0, $eh9Uj.SORT_DIRECTION).DESC : (0, $eh9Uj.SORT_DIRECTION).ASC;
        sorting.onSort(key, nextOrder);
        sendSortUIEvent(key, nextOrder);
    }, [
        sorting,
        sendSortUIEvent
    ]);
    const handleSearchTermChange = (0, $1oC0p.useCallback)((searchTerm)=>{
        if (!enableSearch) return;
        search === null || search === void 0 ? void 0 : search.onSetSearchTerm(searchTerm);
        sendSearchUIEvent();
    }, [
        enableSearch,
        search,
        sendSearchUIEvent
    ]);
    const enhancedSearch = (0, $dPABA._)((0, $6ogO3._)({}, search), {
        onSetSearchTerm: handleSearchTermChange
    });
    const handleClickNext = (0, $1oC0p.useCallback)(()=>{
        pagination.onClickNext();
        sendNavigationUIEvent((0, $eh9Uj.PAGINATION_DIRECTION).NEXT, pagination.totalPages);
    }, [
        pagination,
        sendNavigationUIEvent
    ]);
    const handleClickPrevious = (0, $1oC0p.useCallback)(()=>{
        pagination.onClickPrevious();
        sendNavigationUIEvent((0, $eh9Uj.PAGINATION_DIRECTION).PREVIOUS, pagination.totalPages);
    }, [
        pagination,
        sendNavigationUIEvent
    ]);
    const handleSizeChange = (0, $1oC0p.useCallback)((size)=>{
        pagination.onSizeChange(size);
        sendPageSizeChangeUIEvent(size);
    }, [
        pagination,
        sendPageSizeChangeUIEvent
    ]);
    if (isTableError && !showToolbarOnError) return errorComponent;
    var _sorting_sortDirection;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
        space: toolbarSpacing,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                        space: "space.100",
                        testId: `${testId}-toolbar`,
                        shouldWrap: true,
                        children: [
                            enableSearch && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2N0OI.FastshiftTableSearch), {
                                id: `${id}-search`,
                                search: enhancedSearch,
                                testId: `${testId}-search`
                            }),
                            toolbarContent
                        ]
                    }),
                    summaryText && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                        size: "medium",
                        children: summaryText
                    })
                ]
            }),
            isTableError ? errorComponent : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $0xGy7.FastshiftTableWrapper), {
                id: `${id}-wrapper`,
                testId: `${testId}-wrapper`,
                enableRowClick: enableRowClick,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1QfCI.default), {
                        testId: `${testId}-table`,
                        head: head,
                        rows: rows,
                        isLoading: isTableLoading,
                        isFixedSize: true,
                        onSort: (data)=>handleSort(data.key),
                        sortOrder: (_sorting_sortDirection = sorting.sortDirection) !== null && _sorting_sortDirection !== void 0 ? _sorting_sortDirection : (0, $eh9Uj.SORT_DIRECTION).ASC,
                        sortKey: sorting.sortBy,
                        emptyView: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                            alignBlock: "center",
                            alignInline: "center",
                            xcss: $9abce15fa73bb432$var$emptyTableContainerStyles,
                            space: "space.300",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                                    xcss: $9abce15fa73bb432$var$emptyTableIconContainer,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ky2Uk.EmptySearchVector), {})
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                    children: intl.formatMessage((0, $gQY0i.messages).emptyTableMessage)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6vd2N.FastshiftTablePagination), {
                        pagination: (0, $dPABA._)((0, $6ogO3._)({}, pagination), {
                            onClickNext: handleClickNext,
                            onClickPrevious: handleClickPrevious,
                            onSizeChange: handleSizeChange
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("1QfCI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1576c44a126064bd$export$2e2bcd8739ae039; });

var $4RXD7 = parcelRequire("4RXD7");

var $hx25n = parcelRequire("hx25n");

var $iBgnv = parcelRequire("iBgnv");

var $1oC0p = parcelRequire("1oC0p");

var $9XbNz = parcelRequire("9XbNz");

var $kAw0E = parcelRequire("kAw0E");

var $1zZTY = parcelRequire("1zZTY");

var $d85Xv = parcelRequire("d85Xv");

var $fOTlv = parcelRequire("fOTlv");

var $eRQ3z = parcelRequire("eRQ3z");

var $iUSiK = parcelRequire("iUSiK");

var $juAvK = parcelRequire("juAvK");

var $k4Hjy = parcelRequire("k4Hjy");

var $ezV7G = parcelRequire("ezV7G");

var $10y3L = parcelRequire("10y3L");

var $8QO1H = parcelRequire("8QO1H");
var $1576c44a126064bd$var$_excluded = [
    "isRankable",
    "isRanking",
    "onRankStart",
    "onRankEnd",
    "isRankingDisabled"
];
function $1576c44a126064bd$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $1zZTY.DESC:
            return 0, $1zZTY.ASC;
        case 0, $1zZTY.ASC:
            return 0, $1zZTY.DESC;
        default:
            return currentSortOrder;
    }
}
var $1576c44a126064bd$var$DynamicTable = function DynamicTable(_ref) {
    var caption = _ref.caption, head = _ref.head, highlightedRowIndex = _ref.highlightedRowIndex, rows = _ref.rows, sortKey = _ref.sortKey, sortOrder = _ref.sortOrder, loadingLabel = _ref.loadingLabel, onPageRowsUpdate = _ref.onPageRowsUpdate, testId = _ref.testId, passedDownTotalRows = _ref.totalRows, label = _ref.label, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isFixedSize = _ref.isFixedSize, isFixedSize = _ref$isFixedSize === void 0 ? false : _ref$isFixedSize, _ref$rowsPerPage = _ref.rowsPerPage, rowsPerPage = _ref$rowsPerPage === void 0 ? Infinity : _ref$rowsPerPage, _ref$onSetPage = _ref.onSetPage, onSetPage = _ref$onSetPage === void 0 ? (0, $kAw0E.default) : _ref$onSetPage, _ref$onSort = _ref.onSort, providedOnSort = _ref$onSort === void 0 ? (0, $kAw0E.default) : _ref$onSort, _ref$page = _ref.page, page = _ref$page === void 0 ? 1 : _ref$page, emptyView = _ref.emptyView, _ref$isRankable = _ref.isRankable, isRankable = _ref$isRankable === void 0 ? false : _ref$isRankable, _ref$isRankingDisable = _ref.isRankingDisabled, isRankingDisabled = _ref$isRankingDisable === void 0 ? false : _ref$isRankingDisable, _ref$onRankStart = _ref.onRankStart, onRankStart = _ref$onRankStart === void 0 ? (0, $kAw0E.default) : _ref$onRankStart, _ref$onRankEnd = _ref.onRankEnd, providedOnRankEnd = _ref$onRankEnd === void 0 ? (0, $kAw0E.default) : _ref$onRankEnd, loadingSpinnerSize = _ref.loadingSpinnerSize, _ref$paginationi18n = _ref.paginationi18n, paginationi18n = _ref$paginationi18n === void 0 ? {
        prev: 'Previous Page',
        next: 'Next Page',
        label: 'Pagination',
        pageLabel: 'Page'
    } : _ref$paginationi18n;
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $iBgnv.default)(_useState, 2), isRanking = _useState2[0], setIsRanking = _useState2[1];
    var tableBodyRef = (0, $1oC0p.useRef)(null);
    var onSort = (0, $9XbNz.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "@atlaskit/dynamic-table",
        packageVersion: "18.2.7"
    });
    var onRankEnd = (0, $9XbNz.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "@atlaskit/dynamic-table",
        packageVersion: "18.2.7"
    });
    (0, $1oC0p.useEffect)(function() {
        (0, $d85Xv.validateSortKey)(sortKey, head);
        (0, $d85Xv.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    var onSortHandler = function onSortHandler(item) {
        return function() {
            var key = item.key;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $1zZTY.DESC)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            var sortOrderFormatted = key !== sortKey ? (0, $1zZTY.ASC) : $1576c44a126064bd$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    };
    var onSetPageHandler = function onSetPageHandler(page, event) {
        onSetPage(page, event);
    };
    var onRankStartHandler = function onRankStartHandler(params) {
        setIsRanking(true);
        onRankStart(params);
    };
    var onRankEndHandler = function onRankEndHandler(params) {
        setIsRanking(false);
        onRankEnd(params);
    };
    var getSpinnerSize = function getSpinnerSize() {
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $d85Xv.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $1zZTY.LARGE) : (0, $1zZTY.SMALL);
    };
    var renderEmptyBody = function renderEmptyBody() {
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eRQ3z.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eRQ3z.EmptyViewContainer), {
            testId: testId
        }, emptyView);
    };
    var rowsLength = rows && rows.length;
    var totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    var isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    var getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    var rowsExist = !!rowsLength;
    var spinnerSize = getSpinnerSize();
    var emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ezV7G.default), {
        isLoading: isLoading && rowsExist,
        spinnerSize: spinnerSize,
        targetRef: function targetRef() {
            return tableBodyRef.current;
        },
        testId: testId,
        loadingLabel: loadingLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fOTlv.Table), {
        isFixedSize: isFixedSize,
        "aria-label": label,
        hasDataRow: rowsExist,
        testId: testId,
        isLoading: isLoading
    }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fOTlv.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8QO1H.default), {
        head: head,
        onSort: onSortHandler,
        sortKey: sortKey,
        sortOrder: sortOrder,
        isRanking: isRanking,
        isRankable: isRankable,
        testId: testId
    }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($1576c44a126064bd$var$TableBody, {
        ref: tableBodyRef,
        highlightedRowIndex: highlightedRowIndex,
        rows: rows,
        head: head,
        sortKey: sortKey,
        sortOrder: sortOrder,
        rowsPerPage: rowsPerPage,
        page: getPageNumber,
        isFixedSize: isFixedSize || false,
        onPageRowsUpdate: onPageRowsUpdate,
        isTotalPagesControlledExternally: isTotalPagesControlledExternally,
        testId: testId,
        isRankable: isRankable,
        isRanking: isRanking,
        onRankStart: onRankStartHandler,
        onRankEnd: onRankEndHandler,
        isRankingDisabled: isRankingDisabled || isLoading || false
    }))), totalPages <= 1 ? null : /*#__PURE__*/ // only show pagination if there's MORE than 1 page
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fOTlv.PaginationWrapper), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $10y3L.default), {
        value: getPageNumber,
        onChange: onSetPageHandler,
        total: totalPages,
        i18n: paginationi18n,
        isDisabled: isLoading,
        testId: testId
    })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $k4Hjy.default), {
        isLoading: isLoading,
        spinnerSize: (0, $1zZTY.LARGE),
        testId: testId,
        loadingLabel: loadingLabel
    }, emptyBody));
};

var $1576c44a126064bd$var$RankableTableBody = /*#__PURE__*/ (0, $1oC0p.lazy)(function() {
    return (parcelRequire("44pei"));
});
var $1576c44a126064bd$var$TableBody = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TableBody(_ref2, ref) {
    var _ref2$isRankable = _ref2.isRankable, isRankable = _ref2$isRankable === void 0 ? false : _ref2$isRankable, isRanking = _ref2.isRanking, onRankStart = _ref2.onRankStart, onRankEnd = _ref2.onRankEnd, isRankingDisabled = _ref2.isRankingDisabled, bodyProps = (0, $hx25n.default)(_ref2, $1576c44a126064bd$var$_excluded);
    var canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ var _useState3 = (0, $1oC0p.useState)(false), _useState4 = (0, $iBgnv.default)(_useState3, 2), canRenderRankable = _useState4[0], setCanRenderRankable = _useState4[1];
    (0, $1oC0p.useEffect)(function() {
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    var nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iUSiK.default), (0, $4RXD7.default)({
        ref: ref
    }, bodyProps));
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $juAvK.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($1576c44a126064bd$var$RankableTableBody, (0, $4RXD7.default)({
        ref: ref
    }, bodyProps, {
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    })))) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1576c44a126064bd$export$2e2bcd8739ae039 = $1576c44a126064bd$var$DynamicTable;

});
parcelRegister("4RXD7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $38ba5ded7404e411$export$2e2bcd8739ae039; });
function $38ba5ded7404e411$export$2e2bcd8739ae039() {
    return $38ba5ded7404e411$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $38ba5ded7404e411$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("hx25n", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cc3722e4686f5cef$export$2e2bcd8739ae039; });

var $1380o = parcelRequire("1380o");
function $cc3722e4686f5cef$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $1380o.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("1380o", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0c3c47f7ae1e84f2$export$2e2bcd8739ae039; });
function $0c3c47f7ae1e84f2$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("iBgnv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d8a863082fecde8e$export$2e2bcd8739ae039; });

var $kpSeo = parcelRequire("kpSeo");

var $bO1Pt = parcelRequire("bO1Pt");

var $TMqGy = parcelRequire("TMqGy");

var $dl523 = parcelRequire("dl523");
function $d8a863082fecde8e$export$2e2bcd8739ae039(r, e) {
    return (0, $kpSeo.default)(r) || (0, $bO1Pt.default)(r, e) || (0, $TMqGy.default)(r, e) || (0, $dl523.default)();
}

});
parcelRegister("kpSeo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $edd035a45e19ff93$export$2e2bcd8739ae039; });
function $edd035a45e19ff93$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("bO1Pt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8985c87d46da0fd9$export$2e2bcd8739ae039; });
function $8985c87d46da0fd9$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("TMqGy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0a7ab43db317809a$export$2e2bcd8739ae039; });

var $8cgu6 = parcelRequire("8cgu6");
function $0a7ab43db317809a$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $8cgu6.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $8cgu6.default)(r, a) : void 0;
    }
}

});
parcelRegister("8cgu6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5f7c3b35e0224f6f$export$2e2bcd8739ae039; });
function $5f7c3b35e0224f6f$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("dl523", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9b6123ca9c33e2f1$export$2e2bcd8739ae039; });
function $9b6123ca9c33e2f1$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("9XbNz", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $73f2c6aa5be00e4d$export$a4687b0234b40e28; });

var $3ZAns = parcelRequire("3ZAns");

var $1oC0p = parcelRequire("1oC0p");

var $ewdeD = parcelRequire("ewdeD");

var $4SaI5 = parcelRequire("4SaI5");
function $73f2c6aa5be00e4d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $73f2c6aa5be00e4d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $73f2c6aa5be00e4d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3ZAns.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $73f2c6aa5be00e4d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $73f2c6aa5be00e4d$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $ewdeD.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $4SaI5.useTrackedRef)(analyticsData);
    var fnRef = (0, $4SaI5.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $73f2c6aa5be00e4d$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("3ZAns", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2e83495c759db391$export$2e2bcd8739ae039; });

var $9h9bU = parcelRequire("9h9bU");
function $2e83495c759db391$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $9h9bU.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("9h9bU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6c0cd4c0e54897be$export$2e2bcd8739ae039; });

var $4ww0t = parcelRequire("4ww0t");

var $k95Kc = parcelRequire("k95Kc");
function $6c0cd4c0e54897be$export$2e2bcd8739ae039(t) {
    var i = (0, $k95Kc.default)(t, "string");
    return "symbol" == (0, $4ww0t.default)(i) ? i : i + "";
}

});
parcelRegister("4ww0t", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $34b2fa73b1399e0c$export$2e2bcd8739ae039; });
function $34b2fa73b1399e0c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $34b2fa73b1399e0c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $34b2fa73b1399e0c$export$2e2bcd8739ae039(o);
}

});

parcelRegister("k95Kc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eaa91a93c2e88822$export$2e2bcd8739ae039; });

var $4ww0t = parcelRequire("4ww0t");
function $eaa91a93c2e88822$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $4ww0t.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $4ww0t.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("ewdeD", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $a91e520cc71a5f29$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $jLkAL = parcelRequire("jLkAL");

var $27hQ6 = parcelRequire("27hQ6");
function $a91e520cc71a5f29$export$5bf35293e545f20c() {
    var analyticsContext = (0, $27hQ6.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $jLkAL.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("jLkAL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e632613bbf652caf$export$2e2bcd8739ae039; });

var $9BlDl = parcelRequire("9BlDl");

var $rYoVd = parcelRequire("rYoVd");

var $7jPNY = parcelRequire("7jPNY");

var $8luqs = parcelRequire("8luqs");

var $aqate = parcelRequire("aqate");

var $g5v0W = parcelRequire("g5v0W");

var $52vxJ = parcelRequire("52vxJ");

var $3ZAns = parcelRequire("3ZAns");

var $6ba5H = parcelRequire("6ba5H");
function $e632613bbf652caf$var$_callSuper(t, o, e) {
    return o = (0, $aqate.default)(o), (0, $8luqs.default)(t, $e632613bbf652caf$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aqate.default)(t).constructor) : o.apply(t, e));
}
function $e632613bbf652caf$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e632613bbf652caf$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $e632613bbf652caf$var$_superPropGet(t, o, e, r) {
    var p = (0, $g5v0W.default)((0, $aqate.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $e632613bbf652caf$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $e632613bbf652caf$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $e632613bbf652caf$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $rYoVd.default)(this, UIAnalyticsEvent);
        _this = $e632613bbf652caf$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $3ZAns.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $3ZAns.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $9BlDl.default)(_this.context);
            var handlers = (0, $9BlDl.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $3ZAns.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $52vxJ.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $7jPNY.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $e632613bbf652caf$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $6ba5H.default));

});
parcelRegister("9BlDl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6fd859b9583138e9$export$2e2bcd8739ae039; });

var $509X3 = parcelRequire("509X3");

var $9vggF = parcelRequire("9vggF");

var $TMqGy = parcelRequire("TMqGy");

var $TBsqu = parcelRequire("TBsqu");
function $6fd859b9583138e9$export$2e2bcd8739ae039(r) {
    return (0, $509X3.default)(r) || (0, $9vggF.default)(r) || (0, $TMqGy.default)(r) || (0, $TBsqu.default)();
}

});
parcelRegister("509X3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3a44abfb714cfb2d$export$2e2bcd8739ae039; });

var $8cgu6 = parcelRequire("8cgu6");
function $3a44abfb714cfb2d$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $8cgu6.default)(r);
}

});

parcelRegister("9vggF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6eb3a0bb9a4926a6$export$2e2bcd8739ae039; });
function $6eb3a0bb9a4926a6$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("TBsqu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0a7231721e59fea6$export$2e2bcd8739ae039; });
function $0a7231721e59fea6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("rYoVd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0541601aad466691$export$2e2bcd8739ae039; });
function $0541601aad466691$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("7jPNY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $55427e26690a9503$export$2e2bcd8739ae039; });

var $9h9bU = parcelRequire("9h9bU");
function $55427e26690a9503$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $9h9bU.default)(o.key), o);
    }
}
function $55427e26690a9503$export$2e2bcd8739ae039(e, r, t) {
    return r && $55427e26690a9503$var$_defineProperties(e.prototype, r), t && $55427e26690a9503$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("8luqs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6137e2ca6f2ff231$export$2e2bcd8739ae039; });

var $4ww0t = parcelRequire("4ww0t");

var $7PZ5N = parcelRequire("7PZ5N");
function $6137e2ca6f2ff231$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $4ww0t.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $7PZ5N.default)(t);
}

});
parcelRegister("7PZ5N", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5b4caf84730e3d97$export$2e2bcd8739ae039; });
function $5b4caf84730e3d97$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("aqate", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7964744fe06d5d3f$export$2e2bcd8739ae039; });
function $7964744fe06d5d3f$export$2e2bcd8739ae039(t) {
    return $7964744fe06d5d3f$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $7964744fe06d5d3f$export$2e2bcd8739ae039(t);
}

});

parcelRegister("g5v0W", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bb652bc429185394$export$2e2bcd8739ae039; });

var $jV5Lr = parcelRequire("jV5Lr");
function $bb652bc429185394$export$2e2bcd8739ae039() {
    return $bb652bc429185394$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $jV5Lr.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $bb652bc429185394$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("jV5Lr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e807cfdd1f47f87d$export$2e2bcd8739ae039; });

var $aqate = parcelRequire("aqate");
function $e807cfdd1f47f87d$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $aqate.default)(t)););
    return t;
}

});


parcelRegister("52vxJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3ab59b7446f7542b$export$2e2bcd8739ae039; });

var $4rwVE = parcelRequire("4rwVE");
function $3ab59b7446f7542b$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $4rwVE.default)(t, e);
}

});
parcelRegister("4rwVE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $33c33a09e89252aa$export$2e2bcd8739ae039; });
function $33c33a09e89252aa$export$2e2bcd8739ae039(t, e) {
    return $33c33a09e89252aa$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $33c33a09e89252aa$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("6ba5H", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $47fb98fb208be422$export$2e2bcd8739ae039; });

var $4ww0t = parcelRequire("4ww0t");

var $rYoVd = parcelRequire("rYoVd");

var $7jPNY = parcelRequire("7jPNY");

var $3ZAns = parcelRequire("3ZAns");
function $47fb98fb208be422$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $47fb98fb208be422$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $47fb98fb208be422$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3ZAns.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $47fb98fb208be422$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $47fb98fb208be422$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $47fb98fb208be422$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $47fb98fb208be422$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $rYoVd.default)(this, AnalyticsEvent);
        (0, $3ZAns.default)(this, "_isAnalyticsEvent", true);
        (0, $3ZAns.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $47fb98fb208be422$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $7jPNY.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $4ww0t.default)(updater) === 'object') this.payload = $47fb98fb208be422$var$_objectSpread($47fb98fb208be422$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("27hQ6", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $18aa12b9a6972640$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $18aa12b9a6972640$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("4SaI5", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $38c4835897752c6d$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $38c4835897752c6d$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("kAw0E", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $efcfffdfdc49e085$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $efcfffdfdc49e085$export$2e2bcd8739ae039() {}

});

parcelRegister("1zZTY", function(module, exports) {
$parcel$export(module.exports, "ASC", function () { return $126913bae0ded861$export$1dee026a19752d6b; });
$parcel$export(module.exports, "DESC", function () { return $126913bae0ded861$export$b6abcf7fa1d94f65; });
$parcel$export(module.exports, "SMALL", function () { return $126913bae0ded861$export$71dd4c8ecd45e95f; });
$parcel$export(module.exports, "LARGE", function () { return $126913bae0ded861$export$7b93a10c0fefe3e3; });
$parcel$export(module.exports, "LOADING_CONTENTS_OPACITY", function () { return $126913bae0ded861$export$3843c586a90b9cbf; });
var $126913bae0ded861$export$1dee026a19752d6b = 'ASC';
var $126913bae0ded861$export$b6abcf7fa1d94f65 = 'DESC';
var $126913bae0ded861$export$71dd4c8ecd45e95f = 'small';
var $126913bae0ded861$export$7b93a10c0fefe3e3 = 'large';
var $126913bae0ded861$export$3843c586a90b9cbf = 0.22;

});

parcelRegister("d85Xv", function(module, exports) {
$parcel$export(module.exports, "getPageRows", function () { return $98f0a501c59c4fd6$export$3987dc24b734dcab; });
$parcel$export(module.exports, "assertIsSortable", function () { return $98f0a501c59c4fd6$export$5eb35a4771ec4090; });
$parcel$export(module.exports, "validateSortKey", function () { return $98f0a501c59c4fd6$export$9133f5a8bfe8a200; });
$parcel$export(module.exports, "inlineStylesIfRanking", function () { return $98f0a501c59c4fd6$export$a601f1775e10043f; });

var $iBgnv = parcelRequire("iBgnv");
var $98f0a501c59c4fd6$export$3987dc24b734dcab = function getPageRows(allRows, pageNumber, rowsPerPage) {
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
var $98f0a501c59c4fd6$export$5eb35a4771ec4090 = function assertIsSortable(head) {
    if (!head || !head.cells) return;
    head.cells.forEach(function(cell) {
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
var $98f0a501c59c4fd6$export$9133f5a8bfe8a200 = function validateSortKey(sortKey, head) {
    if (!sortKey) return;
    var headHasKey = head && head.cells.map(function(cell) {
        return cell.key;
    }).includes(sortKey);
    if (!headHasKey) try {
        throw Error("Cell with ".concat(sortKey, " key not found in head."));
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
var $98f0a501c59c4fd6$export$a601f1775e10043f = function inlineStylesIfRanking(isRanking, width, height) {
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
var $98f0a501c59c4fd6$export$92bcb1ed38b134a1 = function computeIndex(index, page, rowsPerPage) {
    var itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
var $98f0a501c59c4fd6$export$c476bbe5da59992d = function reorderRows(rankEnd, rows) {
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var rowsPerPage = arguments.length > 3 ? arguments[3] : undefined;
    var destination = rankEnd.destination, sourceIndex = rankEnd.sourceIndex;
    if (!destination) return rows;
    var fromIndex = $98f0a501c59c4fd6$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    var toIndex = $98f0a501c59c4fd6$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    var reordered = rows.slice();
    var _reordered$splice = reordered.splice(fromIndex, 1), _reordered$splice2 = (0, $iBgnv.default)(_reordered$splice, 1), removed = _reordered$splice2[0];
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("fOTlv", function(module, exports) {
$parcel$export(module.exports, "Table", function () { return $b846750befe9640f$export$54ec01a60f47d33d; });
$parcel$export(module.exports, "Caption", function () { return $b846750befe9640f$export$32fbfacc5d962e0c; });
$parcel$export(module.exports, "PaginationWrapper", function () { return $b846750befe9640f$export$3e5e12dc01f20a43; });
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4RXD7 = parcelRequire("4RXD7");

var $3ZAns = parcelRequire("3ZAns");

var $hx25n = parcelRequire("hx25n");

var $1oC0p = parcelRequire("1oC0p");

var $hBrR7 = parcelRequire("hBrR7");
var $dcXmn = parcelRequire("dcXmn");

var $hQ6Uh = parcelRequire("hQ6Uh");
var $b846750befe9640f$var$_excluded = [
    "isFixedSize",
    "hasDataRow",
    "children",
    "testId",
    "isLoading"
];
function $b846750befe9640f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b846750befe9640f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b846750befe9640f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3ZAns.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b846750befe9640f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b846750befe9640f$var$fixedSizeTableStyles = null;
var $b846750befe9640f$var$tableStyles = null;
var $b846750befe9640f$var$bodyBorder = null;
var $b846750befe9640f$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var isFixedSize = _ref.isFixedSize, hasDataRow = _ref.hasDataRow, children = _ref.children, testId = _ref.testId, isLoading = _ref.isLoading, rest = (0, $hx25n.default)(_ref, $b846750befe9640f$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement("table", (0, $4RXD7.default)({
        inert: isLoading ? '' : undefined,
        ref: ref
    }, rest, {
        "data-testid": testId && "".concat(testId, "--table"),
        className: (0, $hBrR7.default)([
            "_1bsb1osq _yq5hus1c _btyzidpf _ect41gqc",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179rralu"
        ]),
        style: $b846750befe9640f$var$_objectSpread($b846750befe9640f$var$_objectSpread({}, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, ".concat((0, $hQ6Uh.N10), ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, ".concat((0, $hQ6Uh.B50), ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, ".concat((0, $hQ6Uh.B75), ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, ".concat((0, $hQ6Uh.B100), ")")
        }), {}, {
            "--_k02y3n": (0, $dcXmn.default)("2px solid ".concat("var(--ds-border, ".concat((0, $hQ6Uh.N40), ")")))
        })
    }), children);
});
var $b846750befe9640f$var$captionStyles = null;
var $b846750befe9640f$export$32fbfacc5d962e0c = function Caption(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ $1oC0p.createElement("caption", {
        className: (0, $hBrR7.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ])
    }, children);
};
var $b846750befe9640f$var$paginationWrapperStyles = null;
var $b846750befe9640f$export$3e5e12dc01f20a43 = function PaginationWrapper(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        "data-testid": testId && "".concat(testId, "--pagination--container"),
        className: (0, $hBrR7.default)([
            "_1e0c1txw _1bah1h6o"
        ])
    }, children);
};

});
parcelRegister("hBrR7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cd0b7fed27365f19$export$2e2bcd8739ae039; });
const $cd0b7fed27365f19$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $cd0b7fed27365f19$var$ATOMIC_GROUP_LENGTH = 5;
function $cd0b7fed27365f19$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $cd0b7fed27365f19$var$UNDERSCORE_UNICODE ? $cd0b7fed27365f19$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("dcXmn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $99da71048e404b30$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $99da71048e404b30$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("hQ6Uh", function(module, exports) {
$parcel$export(module.exports, "R300", function () { return $cfcca686cd250136$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $cfcca686cd250136$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $cfcca686cd250136$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y200", function () { return $cfcca686cd250136$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $cfcca686cd250136$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $cfcca686cd250136$export$59619663aa6500fb; });
$parcel$export(module.exports, "B50", function () { return $cfcca686cd250136$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $cfcca686cd250136$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $cfcca686cd250136$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $cfcca686cd250136$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $cfcca686cd250136$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $cfcca686cd250136$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $cfcca686cd250136$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N0", function () { return $cfcca686cd250136$export$29a4f05edc054374; });
$parcel$export(module.exports, "N10", function () { return $cfcca686cd250136$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $cfcca686cd250136$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N40", function () { return $cfcca686cd250136$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N70", function () { return $cfcca686cd250136$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $cfcca686cd250136$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $cfcca686cd250136$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $cfcca686cd250136$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N400", function () { return $cfcca686cd250136$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $cfcca686cd250136$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $cfcca686cd250136$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $cfcca686cd250136$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $cfcca686cd250136$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $cfcca686cd250136$export$920c0d5c49070351; });
$parcel$export(module.exports, "N50A", function () { return $cfcca686cd250136$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $cfcca686cd250136$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "DN400", function () { return $cfcca686cd250136$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $cfcca686cd250136$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $cfcca686cd250136$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $cfcca686cd250136$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $cfcca686cd250136$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $cfcca686cd250136$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $cfcca686cd250136$export$3d4f271a500072a; });
// Reds
var $cfcca686cd250136$export$4b84fd0e2c617bd = '#FFEBE6';
var $cfcca686cd250136$export$b34b069eff244586 = '#FFBDAD';
var $cfcca686cd250136$export$be802dd0d8b57f35 = '#FF8F73';
var $cfcca686cd250136$export$60847d42f9da92a6 = '#FF7452';
var $cfcca686cd250136$export$4a7404f376229999 = '#FF5630';
var $cfcca686cd250136$export$2010d0fb4295b346 = '#DE350B';
var $cfcca686cd250136$export$2837b5a1a71d5c02 = '#BF2600';
var $cfcca686cd250136$export$8d9596b529bbb9cf = '#FFFAE6';
var $cfcca686cd250136$export$41060a744ab0b7ae = '#FFF0B3';
var $cfcca686cd250136$export$1cc05bbbf340e559 = '#FFE380';
var $cfcca686cd250136$export$5aae31392d72caaa = '#FFC400';
var $cfcca686cd250136$export$c6930421db9fa514 = '#FFAB00';
var $cfcca686cd250136$export$59619663aa6500fb = '#FF991F';
var $cfcca686cd250136$export$874739ea9e379ab6 = '#FF8B00';
var $cfcca686cd250136$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $cfcca686cd250136$export$69a3bf21b9686c2b = '#ABF5D1';
var $cfcca686cd250136$export$afbce1382ec95f73 = '#79F2C0';
var $cfcca686cd250136$export$747d86715d4175de = '#57D9A3';
var $cfcca686cd250136$export$940e1f69e873f202 = '#36B37E';
var $cfcca686cd250136$export$a49394138f7b8e85 = '#00875A';
var $cfcca686cd250136$export$6fa04827ac68a4fb = '#006644';
var $cfcca686cd250136$export$226de0355ed012f8 = '#DEEBFF';
var $cfcca686cd250136$export$8c13c2ee36917869 = '#B3D4FF';
var $cfcca686cd250136$export$ecfc1dff386a3e7a = '#4C9AFF';
var $cfcca686cd250136$export$215b7063051591f1 = '#2684FF';
var $cfcca686cd250136$export$e62e8919cca44969 = '#0065FF';
var $cfcca686cd250136$export$b3de0ae08da2ce64 = '#0052CC';
var $cfcca686cd250136$export$a6ee3d71bc067634 = '#0747A6';
var $cfcca686cd250136$export$67f15409e87642a1 = '#669DF1';
var $cfcca686cd250136$export$f0539dbc42dbb067 = '#8FB8F6';
var $cfcca686cd250136$export$363e4475840015bb = '#EAE6FF';
var $cfcca686cd250136$export$4b0a4417ed59760f = '#C0B6F2';
var $cfcca686cd250136$export$6011520a64d9a187 = '#998DD9';
var $cfcca686cd250136$export$a7175d4e9206bc80 = '#8777D9';
var $cfcca686cd250136$export$b48405b95304b5a1 = '#6554C0';
var $cfcca686cd250136$export$c71e4279dd54a18d = '#5243AA';
var $cfcca686cd250136$export$147899de772240ec = '#403294';
var $cfcca686cd250136$export$2cf711fe14c66f06 = '#E6FCFF';
var $cfcca686cd250136$export$7a8f4d33f6f9772c = '#B3F5FF';
var $cfcca686cd250136$export$776c9c497ef08533 = '#79E2F2';
var $cfcca686cd250136$export$69cb3ca10c1e330e = '#00C7E6';
var $cfcca686cd250136$export$9dc1ef0f3f48059b = '#00B8D9';
var $cfcca686cd250136$export$7c835c78b6fcdef8 = '#00A3BF';
var $cfcca686cd250136$export$6036577f95c3877e = '#008DA6';
var $cfcca686cd250136$export$29a4f05edc054374 = '#FFFFFF';
var $cfcca686cd250136$export$e655ef011c4aa1a2 = '#FAFBFC';
var $cfcca686cd250136$export$9fdfb749e33cdf97 = '#F4F5F7';
var $cfcca686cd250136$export$3e51e8f1440314ba = '#EBECF0';
var $cfcca686cd250136$export$1ce2d1575d444ceb = '#DFE1E6';
var $cfcca686cd250136$export$8754fc7e6d8b3000 = '#C1C7D0';
var $cfcca686cd250136$export$c2e91cbeada39b8b = '#B3BAC5';
var $cfcca686cd250136$export$5f71e19f3a7ad9de = '#A5ADBA';
var $cfcca686cd250136$export$eaa8c8a70ac22806 = '#97A0AF';
var $cfcca686cd250136$export$7c87d337fb91a97d = '#8993A4';
var $cfcca686cd250136$export$d6447c357493214f = '#7A869A';
var $cfcca686cd250136$export$f563ee71e9ee74cd = '#6B778C';
var $cfcca686cd250136$export$e2ef2124cf4024b1 = '#5E6C84';
var $cfcca686cd250136$export$eece5f492e429f08 = '#505F79';
var $cfcca686cd250136$export$c39c0fe0f26207ae = '#42526E';
var $cfcca686cd250136$export$7090862dc3038a9f = '#344563';
var $cfcca686cd250136$export$ad0bacf983b7ddaa = '#253858';
var $cfcca686cd250136$export$7d61b15e0da132af = '#172B4D';
var $cfcca686cd250136$export$fbda843f0a27fe96 = '#091E42';
var $cfcca686cd250136$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $cfcca686cd250136$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $cfcca686cd250136$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $cfcca686cd250136$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $cfcca686cd250136$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $cfcca686cd250136$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $cfcca686cd250136$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $cfcca686cd250136$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $cfcca686cd250136$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $cfcca686cd250136$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $cfcca686cd250136$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $cfcca686cd250136$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $cfcca686cd250136$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $cfcca686cd250136$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $cfcca686cd250136$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $cfcca686cd250136$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $cfcca686cd250136$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $cfcca686cd250136$export$2f6319cf7d736c2a = '#E6EDFA';
var $cfcca686cd250136$export$95126bc8884d6634 = '#DCE5F5';
var $cfcca686cd250136$export$8338d8c35d44ff1 = '#CED9EB';
var $cfcca686cd250136$export$5368d76ae4fbbda7 = '#B8C7E0';
var $cfcca686cd250136$export$9f0a771d16ec8d36 = '#ABBBD6';
var $cfcca686cd250136$export$abcf8c38338b4aa5 = '#9FB0CC';
var $cfcca686cd250136$export$97e81faa16a182c7 = '#8C9CB8';
var $cfcca686cd250136$export$bfe21c59123ecf33 = '#7988A3';
var $cfcca686cd250136$export$ee82aa2ea6a1558 = '#67758F';
var $cfcca686cd250136$export$682927c6ed76be02 = '#56637A';
var $cfcca686cd250136$export$91fd9994c5be9757 = '#455166';
var $cfcca686cd250136$export$d281fbfe3cff2df6 = '#3B475C';
var $cfcca686cd250136$export$3902c91d8b98a753 = '#313D52';
var $cfcca686cd250136$export$8e8133c1ba5845b5 = '#283447';
var $cfcca686cd250136$export$33ff357f6620b39 = '#202B3D';
var $cfcca686cd250136$export$633847cf062b69e0 = '#1B2638';
var $cfcca686cd250136$export$9776a6e503bdbf76 = '#121A29';
var $cfcca686cd250136$export$6c813d5160dff5db = '#0E1624';
var $cfcca686cd250136$export$3d4f271a500072a = '#0D1424';
var $cfcca686cd250136$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $cfcca686cd250136$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $cfcca686cd250136$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $cfcca686cd250136$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $cfcca686cd250136$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $cfcca686cd250136$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $cfcca686cd250136$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $cfcca686cd250136$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $cfcca686cd250136$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $cfcca686cd250136$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $cfcca686cd250136$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $cfcca686cd250136$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $cfcca686cd250136$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $cfcca686cd250136$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $cfcca686cd250136$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $cfcca686cd250136$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $cfcca686cd250136$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $cfcca686cd250136$export$d2adc5dedf09fced = '#292A2E';
var $cfcca686cd250136$export$f51762073d2bb381 = '#94C748';
var $cfcca686cd250136$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("eRQ3z", function(module, exports) {
$parcel$export(module.exports, "EmptyViewWithFixedHeight", function () { return $ad2e654624b4f9df$export$8f45b9407d4090d7; });
$parcel$export(module.exports, "EmptyViewContainer", function () { return $ad2e654624b4f9df$export$381ea436de119582; });
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");

var $hBrR7 = parcelRequire("hBrR7");
var $ad2e654624b4f9df$var$fixedHeightStyles = null;
var $ad2e654624b4f9df$export$8f45b9407d4090d7 = function EmptyViewWithFixedHeight(_ref) {
    var children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        "data-testid": testId && "".concat(testId, "--empty-view-with-fixed-height"),
        className: (0, $hBrR7.default)([
            "_4t3i1jdh"
        ])
    }, children);
};
var $ad2e654624b4f9df$var$emptyViewContainerStyles = null;
var $ad2e654624b4f9df$export$381ea436de119582 = function EmptyViewContainer(props) {
    var children = props.children, testId = props.testId;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        "data-testid": testId && "".concat(testId, "--empty-view-container"),
        className: (0, $hBrR7.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ])
    }, children);
};

});

parcelRegister("iUSiK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dc579417facef962$export$2e2bcd8739ae039; });

var $4RXD7 = parcelRequire("4RXD7");

var $rYoVd = parcelRequire("rYoVd");

var $7jPNY = parcelRequire("7jPNY");

var $8luqs = parcelRequire("8luqs");

var $aqate = parcelRequire("aqate");

var $52vxJ = parcelRequire("52vxJ");

var $1oC0p = parcelRequire("1oC0p");

var $dy1fT = parcelRequire("dy1fT");

var $iDDGx = parcelRequire("iDDGx");
function $dc579417facef962$var$_callSuper(t, o, e) {
    return o = (0, $aqate.default)(o), (0, $8luqs.default)(t, $dc579417facef962$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aqate.default)(t).constructor) : o.apply(t, e));
}
function $dc579417facef962$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dc579417facef962$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dc579417facef962$var$BodyComponent = /*#__PURE__*/ function(_React$Component) {
    function BodyComponent() {
        (0, $rYoVd.default)(this, BodyComponent);
        return $dc579417facef962$var$_callSuper(this, BodyComponent, arguments);
    }
    (0, $52vxJ.default)(BodyComponent, _React$Component);
    return (0, $7jPNY.default)(BodyComponent, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, pageRows = _this$props.pageRows, head = _this$props.head, isFixedSize = _this$props.isFixedSize, highlightedRowIndex = _this$props.highlightedRowIndex, testId = _this$props.testId, forwardedRef = _this$props.forwardedRef;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("tbody", {
                    "data-testid": testId && "".concat(testId, "--body"),
                    ref: forwardedRef
                }, pageRows.map(function(row, rowIndex) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iDDGx.default), {
                        head: head,
                        isFixedSize: isFixedSize,
                        key: row.key || rowIndex,
                        row: row,
                        isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                        testId: testId
                    });
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Component);
var $dc579417facef962$var$Body = (0, $dy1fT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($dc579417facef962$var$BodyComponent, (0, $4RXD7.default)({}, props, {
        forwardedRef: ref
    }));
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dc579417facef962$export$2e2bcd8739ae039 = $dc579417facef962$var$Body;

});
parcelRegister("dy1fT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9dcf6c9909251433$export$2e2bcd8739ae039; });

var $4RXD7 = parcelRequire("4RXD7");

var $hx25n = parcelRequire("hx25n");

var $rYoVd = parcelRequire("rYoVd");

var $7jPNY = parcelRequire("7jPNY");

var $8luqs = parcelRequire("8luqs");

var $aqate = parcelRequire("aqate");

var $52vxJ = parcelRequire("52vxJ");

var $3ZAns = parcelRequire("3ZAns");

var $4ww0t = parcelRequire("4ww0t");

var $1oC0p = parcelRequire("1oC0p");

var $1zZTY = parcelRequire("1zZTY");

var $d85Xv = parcelRequire("d85Xv");
var $9dcf6c9909251433$var$_excluded = [
    "rows",
    "head",
    "sortKey",
    "sortOrder",
    "rowsPerPage",
    "page",
    "forwardedRef"
];
function $9dcf6c9909251433$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9dcf6c9909251433$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9dcf6c9909251433$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3ZAns.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9dcf6c9909251433$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9dcf6c9909251433$var$_callSuper(t, o, e) {
    return o = (0, $aqate.default)(o), (0, $8luqs.default)(t, $9dcf6c9909251433$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aqate.default)(t).constructor) : o.apply(t, e));
}
function $9dcf6c9909251433$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9dcf6c9909251433$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $9dcf6c9909251433$var$getSortingCellValue = function getSortingCellValue(cells, head, sortKey) {
    for(var i = 0; i < cells.length; i++){
        var _head$cells$i;
        if (head.cells[i] && ((_head$cells$i = head.cells[i]) === null || _head$cells$i === void 0 ? void 0 : _head$cells$i.key) === sortKey) {
            var _cells$i;
            return (_cells$i = cells[i]) === null || _cells$i === void 0 ? void 0 : _cells$i.key;
        }
    }
    return undefined;
};
// sort all rows based on sort key and order
var $9dcf6c9909251433$var$getSortedRows = function getSortedRows(head, rows, sortKey, sortOrder) {
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    var modifier = sortOrder === (0, $1zZTY.ASC) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    var collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    var sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort(function(a, b) {
        var valA = $9dcf6c9909251433$var$getSortingCellValue(a.cells, head, sortKey);
        var valB = $9dcf6c9909251433$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if ((0, $4ww0t.default)(valA) !== (0, $4ww0t.default)(valB)) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $9dcf6c9909251433$export$2e2bcd8739ae039(WrappedComponent) {
    var WithSortedPageRows = /*#__PURE__*/ function(_React$Component) {
        function WithSortedPageRows() {
            var _this;
            (0, $rYoVd.default)(this, WithSortedPageRows);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = $9dcf6c9909251433$var$_callSuper(this, WithSortedPageRows, [].concat(args));
            (0, $3ZAns.default)(_this, "state", {
                pageRows: []
            });
            return _this;
        }
        (0, $52vxJ.default)(WithSortedPageRows, _React$Component);
        return (0, $7jPNY.default)(WithSortedPageRows, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(_prevProps, prevState) {
                    if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, rows = _this$props.rows, head = _this$props.head, sortKey = _this$props.sortKey, sortOrder = _this$props.sortOrder, rowsPerPage = _this$props.rowsPerPage, page = _this$props.page, forwardedRef = _this$props.forwardedRef, restProps = (0, $hx25n.default)(_this$props, $9dcf6c9909251433$var$_excluded);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(WrappedComponent, (0, $4RXD7.default)({
                        pageRows: this.state.pageRows,
                        head: head
                    }, restProps, {
                        ref: forwardedRef
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(props, state) {
                    var rows = props.rows, head = props.head, sortKey = props.sortKey, sortOrder = props.sortOrder, page = props.page, rowsPerPage = props.rowsPerPage, isTotalPagesControlledExternally = props.isTotalPagesControlledExternally;
                    (0, $d85Xv.validateSortKey)(sortKey, head);
                    var sortedRows;
                    var pageRows;
                    if (isTotalPagesControlledExternally) {
                        sortedRows = rows;
                        pageRows = rows;
                    } else {
                        sortedRows = $9dcf6c9909251433$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                        pageRows = (0, $d85Xv.getPageRows)(sortedRows, page, rowsPerPage);
                    }
                    return $9dcf6c9909251433$var$_objectSpread($9dcf6c9909251433$var$_objectSpread({}, state), {}, {
                        pageRows: pageRows
                    });
                }
            }
        ]);
    }((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Component);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(WithSortedPageRows, (0, $4RXD7.default)({}, props, {
            forwardedRef: ref
        }));
    });
}

});

parcelRegister("iDDGx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d91aa726ab2a0e5b$export$2e2bcd8739ae039; });

var $4RXD7 = parcelRequire("4RXD7");

var $hx25n = parcelRequire("hx25n");

var $1oC0p = parcelRequire("1oC0p");

var $3U5Wi = parcelRequire("3U5Wi");

var $iBu8Y = parcelRequire("iBu8Y");
var $d91aa726ab2a0e5b$var$_excluded = [
    "cells"
], $d91aa726ab2a0e5b$var$_excluded2 = [
    "content",
    "testId"
];
var $d91aa726ab2a0e5b$var$Row = function Row(_ref) {
    var row = _ref.row, head = _ref.head, testId = _ref.testId, isFixedSize = _ref.isFixedSize, isHighlighted = _ref.isHighlighted;
    var cells = row.cells, restRowProps = (0, $hx25n.default)(row, $d91aa726ab2a0e5b$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iBu8Y.TableBodyRow), (0, $4RXD7.default)({}, restRowProps, {
        isHighlighted: isHighlighted
    }, isHighlighted ? {
        'data-ts--dynamic-table--table-row--highlighted': true
    } : null, {
        testId: row.testId || testId && "".concat(testId, "--row-").concat(restRowProps.key)
    }), cells.map(function(cell, cellIndex) {
        var content = cell.content, cellTestId = cell.testId, restCellProps = (0, $hx25n.default)(cell, $d91aa726ab2a0e5b$var$_excluded2);
        var _ref2 = (head || {
            cells: []
        }).cells[cellIndex] || {}, shouldTruncate = _ref2.shouldTruncate, width = _ref2.width;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3U5Wi.TableBodyCell), (0, $4RXD7.default)({
            "data-testid": cellTestId || testId && "".concat(testId, "--cell-").concat(cellIndex)
        }, restCellProps, {
            isFixedSize: isFixedSize,
            key: cellIndex,
            shouldTruncate: shouldTruncate,
            width: width
        }), content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d91aa726ab2a0e5b$export$2e2bcd8739ae039 = $d91aa726ab2a0e5b$var$Row;

});
parcelRegister("3U5Wi", function(module, exports) {
$parcel$export(module.exports, "TableBodyCell", function () { return $2d7b357c661e502c$export$948e91fcef170792; });
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4RXD7 = parcelRequire("4RXD7");

var $hx25n = parcelRequire("hx25n");

var $1oC0p = parcelRequire("1oC0p");

var $hBrR7 = parcelRequire("hBrR7");

var $hVTSr = parcelRequire("hVTSr");
var $2d7b357c661e502c$var$_excluded = [
    "width",
    "isFixedSize",
    "shouldTruncate",
    "innerRef"
];
var $2d7b357c661e502c$var$fixedSizeTruncateStyles = null;
var $2d7b357c661e502c$var$overflowTruncateStyles = null;
var $2d7b357c661e502c$var$truncationWidthStyles = null;
var $2d7b357c661e502c$var$cellStyles = null;
var $2d7b357c661e502c$export$948e91fcef170792 = function TableBodyCell(_ref) {
    var width = _ref.width, isFixedSize = _ref.isFixedSize, shouldTruncate = _ref.shouldTruncate, innerRef = _ref.innerRef, props = (0, $hx25n.default)(_ref, $2d7b357c661e502c$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement("td", (0, $4RXD7.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $hVTSr.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        className: (0, $hBrR7.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ])
    }, props));
};

});
parcelRegister("hVTSr", function(module, exports) {
$parcel$export(module.exports, "getTruncationStyleVars", function () { return $d0e31a916be7d631$export$5e6497a652ae30b5; });

var $3ZAns = parcelRequire("3ZAns");
var $d0e31a916be7d631$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
var $d0e31a916be7d631$export$5e6497a652ae30b5 = function getTruncationStyleVars(_ref) {
    var width = _ref.width;
    return typeof width !== 'undefined' ? (0, $3ZAns.default)({}, $d0e31a916be7d631$var$CSS_VAR_WIDTH, "".concat(width, "%")) : undefined;
};

});


parcelRegister("iBu8Y", function(module, exports) {
$parcel$export(module.exports, "TableBodyRow", function () { return $d8b3109a49a5c6ab$export$45f39d9c38b886d5; });
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4RXD7 = parcelRequire("4RXD7");

var $3ZAns = parcelRequire("3ZAns");

var $hx25n = parcelRequire("hx25n");

var $1oC0p = parcelRequire("1oC0p");

var $hBrR7 = parcelRequire("hBrR7");
var $dcXmn = parcelRequire("dcXmn");
var $d8b3109a49a5c6ab$var$_excluded = [
    "isHighlighted",
    "children",
    "style",
    "testId",
    "className"
];
function $d8b3109a49a5c6ab$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d8b3109a49a5c6ab$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d8b3109a49a5c6ab$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3ZAns.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d8b3109a49a5c6ab$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d8b3109a49a5c6ab$var$rowStyles = null;
var $d8b3109a49a5c6ab$var$rowBackgroundStyles = null;
var $d8b3109a49a5c6ab$var$rowHighlightedBackgroundStyles = null;
var $d8b3109a49a5c6ab$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var isHighlighted = _ref.isHighlighted, children = _ref.children, style = _ref.style, testId = _ref.testId, className = _ref.className, rest = (0, $hx25n.default)(_ref, $d8b3109a49a5c6ab$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement("tr", (0, $4RXD7.default)({
        /**
     * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
     * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hBrR7.default)([
            "_bfhkqtfy _1ygb1852 _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ])
    }, rest, {
        ref: ref,
        "data-testid": testId,
        style: $d8b3109a49a5c6ab$var$_objectSpread($d8b3109a49a5c6ab$var$_objectSpread({}, style), {}, {
            "--_akp1ox": (0, $dcXmn.default)("2px solid ".concat("var(--ds-border-focused, var(--local-dynamic-table-hover-bg))"))
        })
    }), children);
});

});



parcelRegister("juAvK", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", function () { return $e30d23fb02afc343$export$e926676385687eaf; });

var $rYoVd = parcelRequire("rYoVd");

var $7jPNY = parcelRequire("7jPNY");

var $8luqs = parcelRequire("8luqs");

var $aqate = parcelRequire("aqate");

var $52vxJ = parcelRequire("52vxJ");

var $1oC0p = parcelRequire("1oC0p");
function $e30d23fb02afc343$var$_callSuper(t, o, e) {
    return o = (0, $aqate.default)(o), (0, $8luqs.default)(t, $e30d23fb02afc343$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aqate.default)(t).constructor) : o.apply(t, e));
}
function $e30d23fb02afc343$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e30d23fb02afc343$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $e30d23fb02afc343$export$e926676385687eaf = /*#__PURE__*/ function(_React$Component) {
    function ErrorBoundary(props) {
        var _this;
        (0, $rYoVd.default)(this, ErrorBoundary);
        _this = $e30d23fb02afc343$var$_callSuper(this, ErrorBoundary, [
            props
        ]);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    (0, $52vxJ.default)(ErrorBoundary, _React$Component);
    return (0, $7jPNY.default)(ErrorBoundary, [
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) // You can render any custom fallback UI
                return this.props.fallback;
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError() {
                // Update state so the next render will show the fallback UI.
                return {
                    hasError: true
                };
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Component);

});

parcelRegister("k4Hjy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $03c5833880d1a746$export$2e2bcd8739ae039; });

var $rYoVd = parcelRequire("rYoVd");

var $7jPNY = parcelRequire("7jPNY");

var $8luqs = parcelRequire("8luqs");

var $aqate = parcelRequire("aqate");

var $52vxJ = parcelRequire("52vxJ");

var $3ZAns = parcelRequire("3ZAns");

var $1oC0p = parcelRequire("1oC0p");

var $jLj7y = parcelRequire("jLj7y");

var $1zZTY = parcelRequire("1zZTY");

var $gkkE3 = parcelRequire("gkkE3");
function $03c5833880d1a746$var$_callSuper(t, o, e) {
    return o = (0, $aqate.default)(o), (0, $8luqs.default)(t, $03c5833880d1a746$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aqate.default)(t).constructor) : o.apply(t, e));
}
function $03c5833880d1a746$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($03c5833880d1a746$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $03c5833880d1a746$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function LoadingContainer() {
        (0, $rYoVd.default)(this, LoadingContainer);
        return $03c5833880d1a746$var$_callSuper(this, LoadingContainer, arguments);
    }
    (0, $52vxJ.default)(LoadingContainer, _React$Component);
    return (0, $7jPNY.default)(LoadingContainer, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, isLoading = _this$props.isLoading, spinnerSize = _this$props.spinnerSize, contentsOpacity = _this$props.contentsOpacity, testId = _this$props.testId, loadingLabel = _this$props.loadingLabel;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $gkkE3.Container), {
                    testId: testId
                }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $gkkE3.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId
                }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $gkkE3.SpinnerContainer), {
                    testId: testId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jLj7y.default), {
                    size: spinnerSize,
                    testId: testId && "".concat(testId, "--loadingSpinner"),
                    label: loadingLabel
                })));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Component);
(0, $3ZAns.default)($03c5833880d1a746$export$2e2bcd8739ae039, "defaultProps", {
    isLoading: true,
    spinnerSize: (0, $1zZTY.LARGE),
    contentsOpacity: (0, $1zZTY.LOADING_CONTENTS_OPACITY),
    loadingLabel: 'Loading table'
});

});
parcelRegister("jLj7y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e6313d1c6f0b133e$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hBrR7 = parcelRequire("hBrR7");

var $1oC0p = parcelRequire("1oC0p");

var $etBkE = parcelRequire("etBkE");

var $hQ6Uh = parcelRequire("hQ6Uh");

var $jWLKW = parcelRequire("jWLKW");
/**
 * Returns the appropriate circle stroke color.
 */ function $e6313d1c6f0b133e$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $hQ6Uh.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $hQ6Uh.N0), ")");
}
var $e6313d1c6f0b133e$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $e6313d1c6f0b133e$var$loadIn = null;
var $e6313d1c6f0b133e$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $e6313d1c6f0b133e$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $e6313d1c6f0b133e$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $jWLKW.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $e6313d1c6f0b133e$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $etBkE.default));
    $e6313d1c6f0b133e$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $hBrR7.default)([
            $e6313d1c6f0b133e$var$styles.wrapperStyles,
            $e6313d1c6f0b133e$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $hBrR7.default)([
            $e6313d1c6f0b133e$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $hBrR7.default)([
            $e6313d1c6f0b133e$var$styles.circleStyles
        ])
    })));
}));
var $e6313d1c6f0b133e$export$2e2bcd8739ae039 = $e6313d1c6f0b133e$var$Spinner;

});
parcelRegister("jWLKW", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $e8587a74ddb7699b$export$4e9f1640bbe7a1a8; });
var $e8587a74ddb7699b$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("gkkE3", function(module, exports) {
$parcel$export(module.exports, "Container", function () { return $be2e87430d15b599$export$42a852a2b6b56249; });
$parcel$export(module.exports, "ContentsContainer", function () { return $be2e87430d15b599$export$67c29eae8ae2137a; });
$parcel$export(module.exports, "SpinnerContainer", function () { return $be2e87430d15b599$export$a5e06607a5ac6158; });
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3ZAns = parcelRequire("3ZAns");

var $1oC0p = parcelRequire("1oC0p");

var $hBrR7 = parcelRequire("hBrR7");
var $dcXmn = parcelRequire("dcXmn");
function $be2e87430d15b599$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $be2e87430d15b599$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $be2e87430d15b599$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3ZAns.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $be2e87430d15b599$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $be2e87430d15b599$export$c335a80381ec61f5 = '--contents-opacity';
var $be2e87430d15b599$var$containerStyles = null;
var $be2e87430d15b599$export$42a852a2b6b56249 = function Container(_ref) {
    var children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        "data-testid": testId && "".concat(testId, "--container"),
        className: (0, $hBrR7.default)([
            "_kqswh2mm"
        ])
    }, children);
};
var $be2e87430d15b599$var$contentsContainerStyles = null;
var $be2e87430d15b599$export$67c29eae8ae2137a = function ContentsContainer(_ref2) {
    var children = _ref2.children, contentsOpacity = _ref2.contentsOpacity, testId = _ref2.testId;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        "data-testid": testId && "".concat(testId, "--contents--container"),
        className: (0, $hBrR7.default)([
            "_tzy47hfw _lcxvglyw"
        ]),
        style: $be2e87430d15b599$var$_objectSpread($be2e87430d15b599$var$_objectSpread({}, (0, $3ZAns.default)({}, $be2e87430d15b599$export$c335a80381ec61f5, contentsOpacity)), {}, {
            "--_cnddr8": (0, $dcXmn.default)("var(".concat($be2e87430d15b599$export$c335a80381ec61f5, ")"))
        })
    }, children);
};
var $be2e87430d15b599$var$spinnerContainerStyles = null;
var $be2e87430d15b599$export$a5e06607a5ac6158 = function SpinnerContainer(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        "data-testid": testId && "".concat(testId, "--spinner--container"),
        className: (0, $hBrR7.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ])
    }, children);
};

});


parcelRegister("ezV7G", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a9d0a4fa550c58ad$export$2e2bcd8739ae039; });

var $4ww0t = parcelRequire("4ww0t");

var $rYoVd = parcelRequire("rYoVd");

var $7jPNY = parcelRequire("7jPNY");

var $8luqs = parcelRequire("8luqs");

var $aqate = parcelRequire("aqate");

var $52vxJ = parcelRequire("52vxJ");

var $3ZAns = parcelRequire("3ZAns");

var $1oC0p = parcelRequire("1oC0p");

var $jLj7y = parcelRequire("jLj7y");

var $1zZTY = parcelRequire("1zZTY");

var $31zvf = parcelRequire("31zvf");
function $a9d0a4fa550c58ad$var$_callSuper(t, o, e) {
    return o = (0, $aqate.default)(o), (0, $8luqs.default)(t, $a9d0a4fa550c58ad$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aqate.default)(t).constructor) : o.apply(t, e));
}
function $a9d0a4fa550c58ad$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a9d0a4fa550c58ad$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $a9d0a4fa550c58ad$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function LoadingContainerAdvanced() {
        var _this;
        (0, $rYoVd.default)(this, LoadingContainerAdvanced);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $a9d0a4fa550c58ad$var$_callSuper(this, LoadingContainerAdvanced, [].concat(args));
        (0, $3ZAns.default)(_this, "spinnerRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createRef());
        (0, $3ZAns.default)(_this, "containerRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createRef());
        (0, $3ZAns.default)(_this, "componentDidMount", function() {
            if (_this.props.isLoading && _this.hasTargetNode()) {
                _this.attachListeners();
                _this.updateTargetAppearance();
                _this.updateSpinnerPosition();
            }
        });
        (0, $3ZAns.default)(_this, "UNSAFE_componentWillReceiveProps", function(nextProps) {
            if (!nextProps.isLoading || !_this.hasTargetNode(nextProps)) _this.detachListeners();
            else if (!_this.props.isLoading) _this.attachListeners();
        });
        (0, $3ZAns.default)(_this, "componentDidUpdate", function() {
            if (_this.hasTargetNode()) {
                _this.updateTargetAppearance();
                if (_this.props.isLoading) _this.updateSpinnerPosition();
            }
        });
        (0, $3ZAns.default)(_this, "componentWillUnmount", function() {
            _this.detachListeners();
        });
        (0, $3ZAns.default)(_this, "getTargetNode", function() {
            var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
            var targetRef = nextProps.targetRef;
            var target = targetRef === null || targetRef === void 0 ? void 0 : targetRef();
            return target || _this.containerRef.current;
        });
        (0, $3ZAns.default)(_this, "hasTargetNode", function(nextProps) {
            return !!_this.getTargetNode(nextProps);
        });
        (0, $3ZAns.default)(_this, "isVerticallyVisible", function(elementRect, viewportHeight) {
            var top = elementRect.top, bottom = elementRect.bottom;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        });
        (0, $3ZAns.default)(_this, "isFullyVerticallyVisible", function(elementRect, viewportHeight) {
            var top = elementRect.top, bottom = elementRect.bottom;
            return top >= 0 && bottom <= viewportHeight;
        });
        (0, $3ZAns.default)(_this, "handleResize", function() {
            _this.updateSpinnerPosition();
        });
        (0, $3ZAns.default)(_this, "handleScroll", function() {
            _this.updateSpinnerPosition();
        });
        (0, $3ZAns.default)(_this, "translateSpinner", function(spinnerNode, transformY, isFixed) {
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? "translate3d(0, ".concat(transformY, "px, 0)") : '';
        });
        (0, $3ZAns.default)(_this, "updateTargetAppearance", function() {
            var targetNode = _this.getTargetNode();
            var _this$props = _this.props, isLoading = _this$props.isLoading, contentsOpacity = _this$props.contentsOpacity;
            if (targetNode && targetNode.style && (0, $4ww0t.default)(targetNode.style) === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        });
        return _this;
    }
    (0, $52vxJ.default)(LoadingContainerAdvanced, _React$Component);
    return (0, $7jPNY.default)(LoadingContainerAdvanced, [
        {
            key: "attachListeners",
            value: function attachListeners() {
                window.addEventListener('scroll', this.handleScroll);
                window.addEventListener('resize', this.handleResize);
            }
        },
        {
            key: "detachListeners",
            value: function detachListeners() {
                window.removeEventListener('scroll', this.handleScroll);
                window.removeEventListener('resize', this.handleResize);
            }
        },
        {
            key: "updateSpinnerPosition",
            value: function updateSpinnerPosition() {
                var _this$spinnerRef, _this$containerRef;
                var viewportHeight = window.innerHeight;
                var targetNode = this.getTargetNode();
                var spinnerNode = (_this$spinnerRef = this.spinnerRef) === null || _this$spinnerRef === void 0 ? void 0 : _this$spinnerRef.current;
                if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
                var targetRect = targetNode.getBoundingClientRect();
                var spinnerRect = spinnerNode.getBoundingClientRect();
                var spinnerHeight = spinnerRect.height;
                var isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
                var top = targetRect.top, bottom = targetRect.bottom, height = targetRect.height;
                if (isInViewport) {
                    // The spinner may follow the element only if there is enough space:
                    // Let's say the element can fit at least three spinners (vertically)
                    var canFollow = height >= spinnerHeight * 3;
                    if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                        if (top >= 0) {
                            // Only the head of the element is visible
                            var viewportSpaceTakenByElement = viewportHeight - top;
                            var diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                            var y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                            this.translateSpinner(spinnerNode, y, true);
                        } else if (top < 0 && bottom > viewportHeight) {
                            // The element takes all viewport, nor its head nor tail are visible
                            var _y = viewportHeight / 2 - spinnerHeight / 2;
                            this.translateSpinner(spinnerNode, _y, true);
                        } else {
                            // Only the tail of the element is visible
                            var _diff = bottom / 2 - spinnerHeight / 2;
                            var _y2 = _diff < spinnerHeight ? _diff - (spinnerHeight - _diff) : _diff;
                            this.translateSpinner(spinnerNode, _y2, true);
                        }
                        return;
                    }
                } else {
                    // If both the element and the spinner are off screen - quit
                    if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
                }
                // Three options here:
                // 1) the element is fully visible
                // 2) the element is too small for the spinner to follow
                // 3) the spinner might still be visible while the element isn't
                var containerNode = (_this$containerRef = this.containerRef) === null || _this$containerRef === void 0 ? void 0 : _this$containerRef.current;
                if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
                    var thisTop = containerNode.getBoundingClientRect().top;
                    var _y3 = (top - thisTop) / 2;
                    this.translateSpinner(spinnerNode, _y3, false);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, children = _this$props2.children, isLoading = _this$props2.isLoading, spinnerSize = _this$props2.spinnerSize, testId = _this$props2.testId, loadingLabel = _this$props2.loadingLabel;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $31zvf.Container), {
                    testId: testId && "".concat(testId, "--loading--container--advanced"),
                    ref: this.containerRef
                }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $31zvf.SpinnerBackdrop), {
                    testId: testId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $31zvf.SpinnerContainer), {
                    ref: this.spinnerRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jLj7y.default), {
                    size: spinnerSize,
                    testId: testId && "".concat(testId, "--loadingSpinner"),
                    label: loadingLabel
                }))));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Component);
(0, $3ZAns.default)($a9d0a4fa550c58ad$export$2e2bcd8739ae039, "defaultProps", {
    isLoading: true,
    spinnerSize: (0, $1zZTY.LARGE),
    contentsOpacity: "var(--ds-opacity-loading, ".concat("".concat((0, $1zZTY.LOADING_CONTENTS_OPACITY)), ")"),
    loadingLabel: 'Loading table'
});

});
parcelRegister("31zvf", function(module, exports) {
$parcel$export(module.exports, "Container", function () { return $233d013c7c98737b$export$42a852a2b6b56249; });
$parcel$export(module.exports, "SpinnerBackdrop", function () { return $233d013c7c98737b$export$aa207050321b0c53; });
$parcel$export(module.exports, "SpinnerContainer", function () { return $233d013c7c98737b$export$a5e06607a5ac6158; });
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4RXD7 = parcelRequire("4RXD7");

var $hx25n = parcelRequire("hx25n");

var $1oC0p = parcelRequire("1oC0p");

var $hBrR7 = parcelRequire("hBrR7");
var $233d013c7c98737b$var$_excluded = [
    "children",
    "testId"
];
var $233d013c7c98737b$var$containerStyles = null;
var $233d013c7c98737b$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var children = props.children, testId = props.testId, rest = (0, $hx25n.default)(props, $233d013c7c98737b$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $4RXD7.default)({}, rest, {
        "data-testid": testId,
        ref: ref,
        className: (0, $hBrR7.default)([
            "_kqswh2mm _6rth1ejb"
        ])
    }), children);
});
var $233d013c7c98737b$var$spinnerBackdropStyles = null;
var $233d013c7c98737b$export$aa207050321b0c53 = function SpinnerBackdrop(_ref) {
    var children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        "data-testid": testId && "".concat(testId, "--spinner-backdrop"),
        className: (0, $hBrR7.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ])
    }, children);
};
var $233d013c7c98737b$var$spinnerContainerStyles = null;
var $233d013c7c98737b$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var children = _ref2.children;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        ref: ref,
        className: (0, $hBrR7.default)([
            "_kqswh2mm _152tidpf"
        ])
    }, children);
});

});


parcelRegister("10y3L", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0bc0361448d567ff$export$2e2bcd8739ae039; });

var $9BlDl = parcelRequire("9BlDl");

var $rYoVd = parcelRequire("rYoVd");

var $7jPNY = parcelRequire("7jPNY");

var $8luqs = parcelRequire("8luqs");

var $aqate = parcelRequire("aqate");

var $52vxJ = parcelRequire("52vxJ");

var $3ZAns = parcelRequire("3ZAns");

var $1oC0p = parcelRequire("1oC0p");

var $eKLsT = parcelRequire("eKLsT");
function $0bc0361448d567ff$var$_callSuper(t, o, e) {
    return o = (0, $aqate.default)(o), (0, $8luqs.default)(t, $0bc0361448d567ff$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aqate.default)(t).constructor) : o.apply(t, e));
}
function $0bc0361448d567ff$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0bc0361448d567ff$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $0bc0361448d567ff$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function ManagedPagination() {
        var _this;
        (0, $rYoVd.default)(this, ManagedPagination);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $0bc0361448d567ff$var$_callSuper(this, ManagedPagination, [].concat(args));
        (0, $3ZAns.default)(_this, "onChange", function(_event, newValue, analyticsEvent) {
            _this.props.onChange(newValue, analyticsEvent);
        });
        return _this;
    }
    (0, $52vxJ.default)(ManagedPagination, _React$Component);
    return (0, $7jPNY.default)(ManagedPagination, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, total = _this$props.total, _this$props$value = _this$props.value, value = _this$props$value === void 0 ? 1 : _this$props$value, i18n = _this$props.i18n, testId = _this$props.testId, isDisabled = _this$props.isDisabled;
                var pages = (0, $9BlDl.default)(Array(total)).map(function(_, index) {
                    return index + 1;
                });
                // Pagination accepts array now thus selectedIndex starts with 0
                // So, we are substracting value by one thus not breaking dynamic table
                var selectedIndex = value - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eKLsT.default), {
                    selectedIndex: selectedIndex,
                    isDisabled: isDisabled,
                    label: i18n === null || i18n === void 0 ? void 0 : i18n.label,
                    nextLabel: i18n === null || i18n === void 0 ? void 0 : i18n.next,
                    previousLabel: i18n === null || i18n === void 0 ? void 0 : i18n.prev,
                    pageLabel: i18n === null || i18n === void 0 ? void 0 : i18n.pageLabel,
                    onChange: this.onChange,
                    pages: pages,
                    testId: testId && "".concat(testId, "--pagination")
                });
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Component);

});
parcelRegister("eKLsT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $abda2e1b0eff432b$export$2e2bcd8739ae039; });
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3ZAns = parcelRequire("3ZAns");

var $iBgnv = parcelRequire("iBgnv");


var $1oC0p = parcelRequire("1oC0p");

var $9XbNz = parcelRequire("9XbNz");

var $kAw0E = parcelRequire("kAw0E");

var $lUQ4H = parcelRequire("lUQ4H");

var $9cUs6 = parcelRequire("9cUs6");

var $1TJXU = parcelRequire("1TJXU");

var $jR3dE = parcelRequire("jR3dE");
var $ktd1d = parcelRequire("ktd1d");

var $4W67J = parcelRequire("4W67J");

var $ez0gt = parcelRequire("ez0gt");

var $h2rcU = parcelRequire("h2rcU");

var $8YElH = parcelRequire("8YElH");

var $5ofmX = parcelRequire("5ofmX");
function $abda2e1b0eff432b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $abda2e1b0eff432b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $abda2e1b0eff432b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3ZAns.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $abda2e1b0eff432b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $abda2e1b0eff432b$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
var $abda2e1b0eff432b$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "@atlaskit/pagination",
    packageVersion: "16.1.8"
};
function $abda2e1b0eff432b$var$NavigatorIcon(_ref) {
    var chevronDirection = _ref.chevronDirection;
    var Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($9cUs6))) : (0, (/*@__PURE__*/$parcel$interopDefault($1TJXU)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jR3dE.default), {
        as: "span",
        xcss: $abda2e1b0eff432b$var$styles.navigatorIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Chevron, {
        label: "",
        LEGACY_margin: "0 ".concat("var(--ds-space-negative-075, -6px)"),
        color: "currentColor",
        size: "small"
    }));
}
function $abda2e1b0eff432b$var$InnerPagination(_ref2, ref) {
    var _ref2$components = _ref2.components, components = _ref2$components === void 0 ? (0, $8YElH.emptyObject) : _ref2$components, _ref2$defaultSelected = _ref2.defaultSelectedIndex, defaultSelectedIndex = _ref2$defaultSelected === void 0 ? 0 : _ref2$defaultSelected, selectedIndex = _ref2.selectedIndex, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'pagination' : _ref2$label, _ref2$pageLabel = _ref2.pageLabel, pageLabel = _ref2$pageLabel === void 0 ? 'page' : _ref2$pageLabel, _ref2$previousLabel = _ref2.previousLabel, previousLabel = _ref2$previousLabel === void 0 ? 'previous' : _ref2$previousLabel, _ref2$nextLabel = _ref2.nextLabel, nextLabel = _ref2$nextLabel === void 0 ? 'next' : _ref2$nextLabel, _ref2$style = _ref2.style, style = _ref2$style === void 0 ? (0, $8YElH.emptyObject) : _ref2$style, _ref2$max = _ref2.max, max = _ref2$max === void 0 ? 7 : _ref2$max, _ref2$onChange = _ref2.onChange, onChange = _ref2$onChange === void 0 ? (0, $kAw0E.default) : _ref2$onChange, pages = _ref2.pages, getPageLabel = _ref2.getPageLabel, _ref2$renderEllipsis = _ref2.renderEllipsis, renderEllipsis = _ref2$renderEllipsis === void 0 ? (0, $h2rcU.default) : _ref2$renderEllipsis, analyticsContext = _ref2.analyticsContext, testId = _ref2.testId, isDisabled = _ref2.isDisabled;
    var _useControlled = (0, $lUQ4H.default)(selectedIndex, function() {
        return defaultSelectedIndex || 0;
    }), _useControlled2 = (0, $iBgnv.default)(_useControlled, 2), selectedIndexValue = _useControlled2[0], setSelectedIndexValue = _useControlled2[1];
    var onChangeWithAnalytics = (0, $9XbNz.usePlatformLeafEventHandler)($abda2e1b0eff432b$var$_objectSpread({
        fn: function fn(value, analyticsEvent) {
            var event = value.event, selectedPageIndex = value.selectedPageIndex;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext
    }, $abda2e1b0eff432b$var$analyticsAttributes));
    var transform = function transform(page, currPageIndex, testId) {
        var selectedPage = pages[selectedIndexValue];
        var pageIndexLabel = "".concat(pageLabel, " ").concat(getPageLabel ? getPageLabel(page, currPageIndex) : page);
        var isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ktd1d.default), {
            as: "li",
            xcss: $abda2e1b0eff432b$var$styles.paginationMenuItem,
            key: "page-".concat(getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ez0gt.default), {
            component: components.Page,
            onClick: function onClick(event) {
                return onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                });
            },
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && "".concat(testId, "--").concat(isCurrentPage ? 'current-' : '', "page-").concat(currPageIndex)
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jR3dE.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ktd1d.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4W67J.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: function onClick(event) {
            return onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            });
        },
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($abda2e1b0eff432b$var$NavigatorIcon, {
            chevronDirection: "left"
        }),
        "aria-label": previousLabel,
        testId: testId && "".concat(testId, "--left-navigator")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ktd1d.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $abda2e1b0eff432b$var$styles.paginationMenu
    }, (0, $5ofmX.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4W67J.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: function onClick(event) {
            return onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            });
        },
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($abda2e1b0eff432b$var$NavigatorIcon, {
            chevronDirection: "right"
        }),
        "aria-label": nextLabel,
        testId: testId && "".concat(testId, "--right-navigator")
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ var $abda2e1b0eff432b$var$Pagination = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)($abda2e1b0eff432b$var$InnerPagination));
var $abda2e1b0eff432b$export$2e2bcd8739ae039 = $abda2e1b0eff432b$var$Pagination;

});
parcelRegister("lUQ4H", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ff4738e7c2928ace$export$2e2bcd8739ae039; });

var $iBgnv = parcelRequire("iBgnv");

var $1oC0p = parcelRequire("1oC0p");
function $ff4738e7c2928ace$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $1oC0p.useState)(getDefaultPropValue), _useState2 = (0, $iBgnv.default)(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $1oC0p.useRef)(isControlled);
    (0, $1oC0p.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $1oC0p.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("9cUs6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e34bc8237f35d48455854b605c0f874a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b41064b3042327c$var$_react = $6b41064b3042327c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6b41064b3042327c$var$_chevronLeft = $6b41064b3042327c$var$_interopRequireDefault((parcelRequire("7IesZ")));

var $6b41064b3042327c$var$_chevronLeftLarge = $6b41064b3042327c$var$_interopRequireDefault((parcelRequire("4qYpL")));
function $6b41064b3042327c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b41064b3042327c$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $6b41064b3042327c$var$_react.default.createElement($6b41064b3042327c$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $6b41064b3042327c$var$_chevronLeftLarge.default
    }, props));
$6b41064b3042327c$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $6b41064b3042327c$var$_default = module.exports.default = $6b41064b3042327c$var$ChevronLeftIcon;

});
parcelRegister("4qYpL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33a87439e8c81b54$var$_react = $33a87439e8c81b54$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $klGIk = parcelRequire("klGIk");

var $33a87439e8c81b54$var$_chevronLeft = $33a87439e8c81b54$var$_interopRequireDefault((parcelRequire("7IesZ")));
function $33a87439e8c81b54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $33a87439e8c81b54$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $33a87439e8c81b54$var$_react.default.createElement($klGIk.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $33a87439e8c81b54$var$_chevronLeft.default
    }));
$33a87439e8c81b54$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $33a87439e8c81b54$var$_default = module.exports.default = $33a87439e8c81b54$var$ChevronLeftLargeIcon;

});


parcelRegister("1TJXU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4724a1e5dc4e8ab6ea5bb133724929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $161e953e5de70295$var$_react = $161e953e5de70295$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $161e953e5de70295$var$_chevronRight = $161e953e5de70295$var$_interopRequireDefault((parcelRequire("9BG80")));

var $161e953e5de70295$var$_chevronRightLarge = $161e953e5de70295$var$_interopRequireDefault((parcelRequire("c0cnr")));
function $161e953e5de70295$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $161e953e5de70295$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $161e953e5de70295$var$_react.default.createElement($161e953e5de70295$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $161e953e5de70295$var$_chevronRightLarge.default
    }, props));
$161e953e5de70295$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $161e953e5de70295$var$_default = module.exports.default = $161e953e5de70295$var$ChevronRightIcon;

});
parcelRegister("c0cnr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bcf15f8d1de8609$var$_react = $8bcf15f8d1de8609$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $klGIk = parcelRequire("klGIk");

var $8bcf15f8d1de8609$var$_chevronRight = $8bcf15f8d1de8609$var$_interopRequireDefault((parcelRequire("9BG80")));
function $8bcf15f8d1de8609$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8bcf15f8d1de8609$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $8bcf15f8d1de8609$var$_react.default.createElement($klGIk.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $8bcf15f8d1de8609$var$_chevronRight.default
    }));
$8bcf15f8d1de8609$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $8bcf15f8d1de8609$var$_default = module.exports.default = $8bcf15f8d1de8609$var$ChevronRightLargeIcon;

});


parcelRegister("jR3dE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e74576d179e190e1$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4RXD7 = parcelRequire("4RXD7");

var $hx25n = parcelRequire("hx25n");

var $1oC0p = parcelRequire("1oC0p");

var $hBrR7 = parcelRequire("hBrR7");

var $cIMbg = parcelRequire("cIMbg");
var $e74576d179e190e1$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $e74576d179e190e1$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $e74576d179e190e1$var$baseStyles = null;
var $e74576d179e190e1$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhk1fno",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1eds",
    'color.background.accent.lime.subtler.pressed': "_bfhk1hgz",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhkhgj8",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhk1b17",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhk1pbw",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkrw5d",
    'color.background.accent.red.subtler.pressed': "_bfhk69rw",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1tf4",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhkprmn",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtlest.hovered': "_bfhkg4tm",
    'color.background.accent.orange.subtlest.pressed': "_bfhk1ya0",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtler.hovered': "_bfhk1lml",
    'color.background.accent.orange.subtler.pressed': "_bfhkuxsx",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.subtle.hovered': "_bfhk1oew",
    'color.background.accent.orange.subtle.pressed': "_bfhk1phk",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.orange.bolder.hovered': "_bfhkhi52",
    'color.background.accent.orange.bolder.pressed': "_bfhkf767",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtlest.hovered': "_bfhk19g9",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk31d1",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtler.hovered': "_bfhklg04",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1d44",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.subtle.hovered': "_bfhk17e6",
    'color.background.accent.yellow.subtle.pressed': "_bfhko0y5",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk32kj",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkv5yf",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhkung8",
    'color.background.accent.green.subtler.pressed': "_bfhk1p19",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk8h4p",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1azz",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1j2h",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkg5py",
    'color.background.accent.teal.subtler.pressed': "_bfhkq7li",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk10ai",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhkse6l",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtlest.hovered': "_bfhkay3p",
    'color.background.accent.blue.subtlest.pressed': "_bfhk1xmr",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtler.hovered': "_bfhk16e6",
    'color.background.accent.blue.subtler.pressed': "_bfhk1uh7",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.subtle.hovered': "_bfhk1f4s",
    'color.background.accent.blue.subtle.pressed': "_bfhkqctv",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.blue.bolder.hovered': "_bfhk1cwi",
    'color.background.accent.blue.bolder.pressed': "_bfhkhcrq",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtlest.hovered': "_bfhkm0d5",
    'color.background.accent.purple.subtlest.pressed': "_bfhkgslw",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtler.hovered': "_bfhk1wyu",
    'color.background.accent.purple.subtler.pressed': "_bfhk5fkp",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.subtle.hovered': "_bfhk1wob",
    'color.background.accent.purple.subtle.pressed': "_bfhkwz05",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.purple.bolder.hovered': "_bfhkadgs",
    'color.background.accent.purple.bolder.pressed': "_bfhk1uro",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1een",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1r0p",
    'color.background.accent.magenta.subtler.pressed': "_bfhkxuzc",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk1ovh",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkwaw3",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtlest.hovered': "_bfhk12j4",
    'color.background.accent.gray.subtlest.pressed': "_bfhk1lb4",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtler.hovered': "_bfhk1f7l",
    'color.background.accent.gray.subtler.pressed': "_bfhkd8a2",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.subtle.hovered': "_bfhk1a2l",
    'color.background.accent.gray.subtle.pressed': "_bfhk1z0s",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.accent.gray.bolder.hovered': "_bfhke4nv",
    'color.background.accent.gray.bolder.pressed': "_bfhk82ra",
    'color.background.disabled': "_bfhksyzs",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhk1d5g",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.hovered': "_bfhk15ej",
    'color.background.neutral.pressed': "_bfhkip91",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk166n",
    'color.background.neutral.subtle.pressed': "_bfhk1dty",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.neutral.bold.hovered': "_bfhk1bsc",
    'color.background.neutral.bold.pressed': "_bfhk1b6k",
    'color.background.selected': "_bfhkfg4m",
    'color.background.selected.hovered': "_bfhki1yw",
    'color.background.selected.pressed': "_bfhk19ru",
    'color.background.selected.bold': "_bfhk1fvw",
    'color.background.selected.bold.hovered': "_bfhk18hz",
    'color.background.selected.bold.pressed': "_bfhkgr1v",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.subtlest.hovered': "_bfhkezq1",
    'color.background.brand.subtlest.pressed': "_bfhk2ggb",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.bold.hovered': "_bfhku1se",
    'color.background.brand.bold.pressed': "_bfhkqkzo",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.brand.boldest.hovered': "_bfhk1uwk",
    'color.background.brand.boldest.pressed': "_bfhk17jr",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1io2",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk9pqq",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.hovered': "_bfhk1rd4",
    'color.background.warning.pressed': "_bfhk11dh",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.warning.bold.hovered': "_bfhk1i4c",
    'color.background.warning.bold.pressed': "_bfhkrj9s",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.hovered': "_bfhk1jgi",
    'color.background.success.pressed': "_bfhky4f1",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.success.bold.hovered': "_bfhk1q4l",
    'color.background.success.bold.pressed': "_bfhkcrcn",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.hovered': "_bfhk1xp7",
    'color.background.discovery.pressed': "_bfhkdlkp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.discovery.bold.hovered': "_bfhk1w72",
    'color.background.discovery.bold.pressed': "_bfhkrb53",
    'color.background.information': "_bfhk33gi",
    'color.background.information.hovered': "_bfhk1vps",
    'color.background.information.pressed': "_bfhk1s0z",
    'color.background.information.bold': "_bfhk14wj",
    'color.background.information.bold.hovered': "_bfhk1amz",
    'color.background.information.bold.pressed': "_bfhk5bth",
    'color.blanket': "_bfhk10xm",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkn82g",
    'color.skeleton.subtle': "_bfhkh3tw",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk108i",
    'elevation.surface.pressed': "_bfhk1ji5",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk16qz",
    'elevation.surface.overlay.pressed': "_bfhkvq0a",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk1a0f",
    'elevation.surface.raised.pressed': "_bfhkf7u5",
    'elevation.surface.sunken': "_bfhkqbzx",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $e74576d179e190e1$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $e74576d179e190e1$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l108i",
    'elevation.surface.pressed': "_1q1l1ji5",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l16qz",
    'elevation.surface.overlay.pressed': "_1q1lvq0a",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l1a0f",
    'elevation.surface.raised.pressed': "_1q1lf7u5",
    'elevation.surface.sunken': "_1q1lqbzx"
};
var $e74576d179e190e1$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $e74576d179e190e1$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $e74576d179e190e1$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $e74576d179e190e1$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $e74576d179e190e1$var$Box = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $hx25n.default)(_ref, $e74576d179e190e1$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $hx25n.default)(htmlAttributes, $e74576d179e190e1$var$_excluded2);
    var node = /*#__PURE__*/ $1oC0p.createElement(Component, (0, $4RXD7.default)({
        style: style,
        ref: ref,
        className: (0, $hBrR7.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $e74576d179e190e1$var$backgroundColorMap[backgroundColor],
            backgroundColor && $e74576d179e190e1$var$isSurfaceToken(backgroundColor) && $e74576d179e190e1$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $e74576d179e190e1$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $e74576d179e190e1$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $e74576d179e190e1$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $e74576d179e190e1$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $1oC0p.createElement((0, $cIMbg.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $e74576d179e190e1$export$2e2bcd8739ae039 = $e74576d179e190e1$var$Box;
function $e74576d179e190e1$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $e74576d179e190e1$var$setSurfaceTokenMap;
}

});
parcelRegister("cIMbg", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $942ef7c34d2af4b8$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $942ef7c34d2af4b8$export$1aeb4f6b93c4540d; });

var $1oC0p = parcelRequire("1oC0p");
var $942ef7c34d2af4b8$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $942ef7c34d2af4b8$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($942ef7c34d2af4b8$export$1ca2a26fecb070ae);
};
$942ef7c34d2af4b8$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("ktd1d", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ee709d4e1a84d230$export$2e2bcd8739ae039; });
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4RXD7 = parcelRequire("4RXD7");

var $hx25n = parcelRequire("hx25n");

var $1oC0p = parcelRequire("1oC0p");

var $hBrR7 = parcelRequire("hBrR7");

var $akAP0 = parcelRequire("akAP0");

var $991sQ = parcelRequire("991sQ");
var $ee709d4e1a84d230$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $ee709d4e1a84d230$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $ee709d4e1a84d230$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $hBrR7.default)([
            $ee709d4e1a84d230$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $ee709d4e1a84d230$var$Inline = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, $hx25n.default)(_ref2, $ee709d4e1a84d230$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $1oC0p.createElement($ee709d4e1a84d230$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $1oC0p.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $1oC0p.createElement((0, $991sQ.default), (0, $4RXD7.default)({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $akAP0.cx)(grow === 'hug' && $ee709d4e1a84d230$var$styles.hug, grow === 'fill' && $ee709d4e1a84d230$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$ee709d4e1a84d230$var$Inline.displayName = 'Inline';
var $ee709d4e1a84d230$export$2e2bcd8739ae039 = $ee709d4e1a84d230$var$Inline;

});
parcelRegister("akAP0", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $785855a7c4c77279$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("1oC0p");


var $1ZP5f = parcelRequire("1ZP5f");
var $785855a7c4c77279$var$_createStrictAPI = (0, $1ZP5f.createStrictAPI)(), $785855a7c4c77279$var$XCSSProp = $785855a7c4c77279$var$_createStrictAPI.XCSSProp, $785855a7c4c77279$export$dbf350e5966cf602 = $785855a7c4c77279$var$_createStrictAPI.css, $785855a7c4c77279$export$eb1ecd84a24ee424 = $785855a7c4c77279$var$_createStrictAPI.cssMap, $785855a7c4c77279$export$a274e22fb40f762e = $785855a7c4c77279$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("1ZP5f", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", function () { return $17431d1b32c8eabf$export$39716b4af53f4ad; });

var $gRoZU = parcelRequire("gRoZU");

var $114y6 = parcelRequire("114y6");
function $17431d1b32c8eabf$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $gRoZU.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $gRoZU.createStrictSetupError)();
        },
        cx: $114y6.cx,
        XCSSProp () {
            throw (0, $gRoZU.createStrictSetupError)();
        }
    };
}

});
parcelRegister("gRoZU", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", function () { return $c464fc8c6f33cfc4$export$c4df1cb0c2b4d77c; });
const $c464fc8c6f33cfc4$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $c464fc8c6f33cfc4$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("114y6", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $0bd969cb5f7a8050$export$a274e22fb40f762e; });

var $hBrR7 = parcelRequire("hBrR7");
const $0bd969cb5f7a8050$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $hBrR7.default)(actualStyles);
};

});



parcelRegister("991sQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6a86171afac5d24e$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4RXD7 = parcelRequire("4RXD7");

var $hx25n = parcelRequire("hx25n");

var $1oC0p = parcelRequire("1oC0p");

var $hBrR7 = parcelRequire("hBrR7");
var $6a86171afac5d24e$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $6a86171afac5d24e$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $6a86171afac5d24e$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $6a86171afac5d24e$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $6a86171afac5d24e$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $6a86171afac5d24e$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $6a86171afac5d24e$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $6a86171afac5d24e$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $6a86171afac5d24e$var$Flex = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, $hx25n.default)(_ref, $6a86171afac5d24e$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $4RXD7.default)({}, ariaAttributes, {
        role: role,
        className: (0, $hBrR7.default)([
            $6a86171afac5d24e$var$styles.root,
            gap && $6a86171afac5d24e$var$columnGapMap[gap],
            columnGap && $6a86171afac5d24e$var$columnGapMap[columnGap],
            gap && $6a86171afac5d24e$var$rowGapMap[gap],
            rowGap && $6a86171afac5d24e$var$rowGapMap[rowGap],
            alignItems && $6a86171afac5d24e$var$alignItemsMap[alignItems],
            direction && $6a86171afac5d24e$var$flexDirectionMap[direction],
            justifyContent && $6a86171afac5d24e$var$justifyContentMap[justifyContent],
            wrap && $6a86171afac5d24e$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$6a86171afac5d24e$var$Flex.displayName = 'Flex';
var $6a86171afac5d24e$export$2e2bcd8739ae039 = $6a86171afac5d24e$var$Flex;

});


parcelRegister("4W67J", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $39815443ca0558bc$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $42akA = parcelRequire("42akA");
function $39815443ca0558bc$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $42akA.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});
parcelRegister("42akA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2eff5cdf1d9bf613$export$2e2bcd8739ae039; });

var $4RXD7 = parcelRequire("4RXD7");

var $iBgnv = parcelRequire("iBgnv");

var $hx25n = parcelRequire("hx25n");

var $1oC0p = parcelRequire("1oC0p");

var $kAw0E = parcelRequire("kAw0E");

var $b8uqc = parcelRequire("b8uqc");

var $kc2vl = parcelRequire("kc2vl");

var $hXkvK = parcelRequire("hXkvK");

var $lkqdl = parcelRequire("lkqdl");
var $2eff5cdf1d9bf613$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $2eff5cdf1d9bf613$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $2eff5cdf1d9bf613$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $kAw0E.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $kAw0E.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, $hx25n.default)(_ref, $2eff5cdf1d9bf613$var$_excluded);
    var _useGlobalTheme = (0, $b8uqc.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $lkqdl.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $iBgnv.default)(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $1oC0p.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($2eff5cdf1d9bf613$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $1oC0p.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($2eff5cdf1d9bf613$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $1oC0p.useMemo)(function() {
        return (0, $hXkvK.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kc2vl.default), (0, $4RXD7.default)({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$2eff5cdf1d9bf613$var$Button.displayName = 'Button';
var $2eff5cdf1d9bf613$export$2e2bcd8739ae039 = $2eff5cdf1d9bf613$var$Button;

});
parcelRegister("b8uqc", function(module, exports) {
$parcel$export(module.exports, "useGlobalTheme", function () { return $81b80a2868cff176$export$7692396083754928; });

var $h74ZR = parcelRequire("h74ZR");
// Create default global light theme
var $81b80a2868cff176$var$_createTheme = (0, $h74ZR.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $81b80a2868cff176$var$Provider = $81b80a2868cff176$var$_createTheme.Provider, $81b80a2868cff176$var$Consumer = $81b80a2868cff176$var$_createTheme.Consumer, $81b80a2868cff176$export$7692396083754928 = $81b80a2868cff176$var$_createTheme.useTheme;
var $81b80a2868cff176$var$Theme = {
    Provider: $81b80a2868cff176$var$Provider,
    Consumer: $81b80a2868cff176$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$81b80a2868cff176$export$2e2bcd8739ae039 = $81b80a2868cff176$var$Theme;

});
parcelRegister("h74ZR", function(module, exports) {
$parcel$export(module.exports, "createTheme", function () { return $c756f760952c949e$export$25d302a5b900a763; });

var $hx25n = parcelRequire("hx25n");

var $1oC0p = parcelRequire("1oC0p");
var $c756f760952c949e$var$_excluded = [
    "children"
];
function $c756f760952c949e$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1oC0p.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $hx25n.default)(props, $c756f760952c949e$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1oC0p.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1oC0p.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("kc2vl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eb36defeb313beb7$export$2e2bcd8739ae039; });

var $4RXD7 = parcelRequire("4RXD7");

var $hx25n = parcelRequire("hx25n");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $9XbNz = parcelRequire("9XbNz");

var $kAw0E = parcelRequire("kAw0E");

var $36EVE = parcelRequire("36EVE");

var $cH8hr = parcelRequire("cH8hr");

var $etBkE = parcelRequire("etBkE");

var $hQ6Uh = parcelRequire("hQ6Uh");

var $7HXhe = parcelRequire("7HXhe");

var $hXkvK = parcelRequire("hXkvK");

var $j2uTH = parcelRequire("j2uTH");
var $eb36defeb313beb7$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $eb36defeb313beb7$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $eb36defeb313beb7$var$iconBeforeSpacingFixStyle = (0, $3dJ4i.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $eb36defeb313beb7$var$iconAfterSpacingFixStyle = (0, $3dJ4i.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $eb36defeb313beb7$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $j2uTH.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $eb36defeb313beb7$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $j2uTH.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $3dJ4i.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $eb36defeb313beb7$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $kAw0E.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $kAw0E.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, $hx25n.default)(props, $eb36defeb313beb7$var$_excluded);
    var ourRef = (0, $1oC0p.useRef)();
    var setRef = (0, $1oC0p.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $36EVE.default)(ourRef, autoFocus);
    var interactionContext = (0, $1oC0p.useContext)((0, $etBkE.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $9XbNz.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "23.3.2",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $1oC0p.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $1oC0p.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $3dJ4i.css)((0, $hXkvK.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $hQ6Uh.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $hQ6Uh.N500), ")"), " !important")
        }
    };
    return (0, $3dJ4i.jsx)((0, $cH8hr.default), null, (0, $3dJ4i.jsx)(Component, (0, $4RXD7.default)({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $eb36defeb313beb7$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $7HXhe.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $3dJ4i.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $hXkvK.getIconStyle)({
                spacing: spacing
            }),
            $eb36defeb313beb7$var$getSpacingFix(children, $eb36defeb313beb7$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $eb36defeb313beb7$var$getChildren(children, [
        fadeStyles,
        (0, $hXkvK.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $3dJ4i.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $hXkvK.getIconStyle)({
                spacing: spacing
            }),
            $eb36defeb313beb7$var$getSpacingFix(children, $eb36defeb313beb7$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $3dJ4i.jsx)("span", {
        css: [
            (0, $hXkvK.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$eb36defeb313beb7$export$2e2bcd8739ae039 = $eb36defeb313beb7$var$ButtonBase;

});
parcelRegister("36EVE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2431ae4178e60a75$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $2431ae4178e60a75$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("7HXhe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $59ca87bce69818a0$export$2e2bcd8739ae039; });
function $59ca87bce69818a0$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $59ca87bce69818a0$var$tabKeyCode = 9;
function $59ca87bce69818a0$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $59ca87bce69818a0$var$tabKeyCode) return;
    $59ca87bce69818a0$var$abort(event);
}
var $59ca87bce69818a0$var$block = {
    onMouseDownCapture: $59ca87bce69818a0$var$abort,
    onMouseUpCapture: $59ca87bce69818a0$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $59ca87bce69818a0$var$onKey,
    onKeyUpCapture: $59ca87bce69818a0$var$onKey,
    onTouchStartCapture: $59ca87bce69818a0$var$abort,
    onTouchEndCapture: $59ca87bce69818a0$var$abort,
    onPointerDownCapture: $59ca87bce69818a0$var$abort,
    onPointerUpCapture: $59ca87bce69818a0$var$abort,
    onClickCapture: $59ca87bce69818a0$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $59ca87bce69818a0$var$abort
};
var $59ca87bce69818a0$var$doNotBlock = {};
function $59ca87bce69818a0$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $59ca87bce69818a0$var$doNotBlock : $59ca87bce69818a0$var$block;
}

});

parcelRegister("hXkvK", function(module, exports) {
$parcel$export(module.exports, "getCss", function () { return $d127db6d1dfa3d48$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $d127db6d1dfa3d48$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $d127db6d1dfa3d48$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $d127db6d1dfa3d48$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $d127db6d1dfa3d48$export$1a9fe1b84c876bb5; });

var $3ZAns = parcelRequire("3ZAns");

var $3dJ4i = parcelRequire("3dJ4i");

var $39c3M = parcelRequire("39c3M");

var $aD9ip = parcelRequire("aD9ip");

var $8T7RC = parcelRequire("8T7RC");
function $d127db6d1dfa3d48$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d127db6d1dfa3d48$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d127db6d1dfa3d48$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3ZAns.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d127db6d1dfa3d48$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d127db6d1dfa3d48$var$gridSize = (0, $aD9ip.gridSize)();
var $d127db6d1dfa3d48$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $d127db6d1dfa3d48$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $d127db6d1dfa3d48$var$lineHeights = {
    default: $d127db6d1dfa3d48$var$heights.default,
    compact: $d127db6d1dfa3d48$var$heights.compact,
    none: 'inherit'
};
var $d127db6d1dfa3d48$var$padding = {
    // 10px gutter
    default: "0 ".concat($d127db6d1dfa3d48$var$gridSize + $d127db6d1dfa3d48$var$gridSize / 4, "px"),
    compact: "0 ".concat($d127db6d1dfa3d48$var$gridSize + $d127db6d1dfa3d48$var$gridSize / 4, "px"),
    none: '0'
};
var $d127db6d1dfa3d48$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($d127db6d1dfa3d48$var$gridSize / 4, "px"),
    default: "0 ".concat($d127db6d1dfa3d48$var$gridSize / 4, "px"),
    none: '0'
};
var $d127db6d1dfa3d48$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $d127db6d1dfa3d48$var$innerMargin = {
    content: "0 ".concat($d127db6d1dfa3d48$var$gridSize / 4, "px"),
    icon: "0 ".concat($d127db6d1dfa3d48$var$gridSize / 4, "px")
};
var $d127db6d1dfa3d48$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $d127db6d1dfa3d48$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    '&::after': $d127db6d1dfa3d48$var$_objectSpread($d127db6d1dfa3d48$var$_objectSpread({}, $d127db6d1dfa3d48$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $d127db6d1dfa3d48$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
var $d127db6d1dfa3d48$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #0C66E4)",
    '&:hover': {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: 'underline'
    }
};
var $d127db6d1dfa3d48$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $d127db6d1dfa3d48$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #172B4D)",
        textDecoration: 'underline'
    }
};
var $d127db6d1dfa3d48$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
var $d127db6d1dfa3d48$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $d127db6d1dfa3d48$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    '&:not([disabled])::after': $d127db6d1dfa3d48$var$_objectSpread($d127db6d1dfa3d48$var$_objectSpread({}, $d127db6d1dfa3d48$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $d127db6d1dfa3d48$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $d127db6d1dfa3d48$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $d127db6d1dfa3d48$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $d127db6d1dfa3d48$var$getColor({
            group: (0, $8T7RC.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($d127db6d1dfa3d48$var$getColor({
            group: (0, $8T7RC.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $d127db6d1dfa3d48$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $d127db6d1dfa3d48$var$getColors({
        appearance: appearance,
        key: isSelected ? 'selected' : 'default',
        mode: mode
    });
    return $d127db6d1dfa3d48$var$_objectSpread($d127db6d1dfa3d48$var$_objectSpread($d127db6d1dfa3d48$var$_objectSpread($d127db6d1dfa3d48$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap'
    }, !(0, $39c3M.fg)('platform-component-visual-refresh') && baseColors), {}, {
        cursor: 'pointer',
        height: $d127db6d1dfa3d48$var$heights[spacing],
        lineHeight: $d127db6d1dfa3d48$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $d127db6d1dfa3d48$var$singleIconPadding[spacing] : $d127db6d1dfa3d48$var$padding[spacing],
        verticalAlign: $d127db6d1dfa3d48$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, !(0, $39c3M.fg)('platform-component-visual-refresh') && $d127db6d1dfa3d48$var$_objectSpread($d127db6d1dfa3d48$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        '&:visited': $d127db6d1dfa3d48$var$_objectSpread({}, baseColors),
        '&:hover': $d127db6d1dfa3d48$var$_objectSpread($d127db6d1dfa3d48$var$_objectSpread({}, $d127db6d1dfa3d48$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'hover',
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'inherit',
            // background, box-shadow
            transitionDuration: '0s, 0.15s'
        }),
        // giving active styles preference by listing them after focus
        '&:active': $d127db6d1dfa3d48$var$_objectSpread($d127db6d1dfa3d48$var$_objectSpread({}, $d127db6d1dfa3d48$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $d127db6d1dfa3d48$var$_objectSpread($d127db6d1dfa3d48$var$_objectSpread({}, $d127db6d1dfa3d48$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        '&[disabled]': $d127db6d1dfa3d48$var$_objectSpread($d127db6d1dfa3d48$var$_objectSpread({}, $d127db6d1dfa3d48$var$getColors({
            appearance: appearance,
            key: 'disabled',
            mode: mode
        })), {}, {
            cursor: 'not-allowed',
            textDecoration: 'none'
        })
    }, $d127db6d1dfa3d48$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $d127db6d1dfa3d48$var$_objectSpread({}, $d127db6d1dfa3d48$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'default',
            mode: mode
        }))
    })), (0, $39c3M.fg)('platform-component-visual-refresh') && (isSelected ? $d127db6d1dfa3d48$var$selectedStyles : $d127db6d1dfa3d48$var$_objectSpread($d127db6d1dfa3d48$var$_objectSpread($d127db6d1dfa3d48$var$_objectSpread($d127db6d1dfa3d48$var$_objectSpread($d127db6d1dfa3d48$var$_objectSpread($d127db6d1dfa3d48$var$_objectSpread($d127db6d1dfa3d48$var$_objectSpread($d127db6d1dfa3d48$var$_objectSpread({}, appearance === 'default' && $d127db6d1dfa3d48$var$defaultStyles), appearance === 'primary' && $d127db6d1dfa3d48$var$primaryStyles), appearance === 'link' && $d127db6d1dfa3d48$var$linkStyles), appearance === 'subtle' && $d127db6d1dfa3d48$var$subtleStyles), appearance === 'subtle-link' && $d127db6d1dfa3d48$var$subtleLinkStyles), appearance === 'warning' && $d127db6d1dfa3d48$var$warningStyles), appearance === 'danger' && $d127db6d1dfa3d48$var$dangerStyles), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $d127db6d1dfa3d48$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $d127db6d1dfa3d48$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $d127db6d1dfa3d48$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
            }
        }
    }, $d127db6d1dfa3d48$var$hasOverlayStyles))), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $d127db6d1dfa3d48$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $3dJ4i.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $d127db6d1dfa3d48$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $d127db6d1dfa3d48$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $3dJ4i.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $d127db6d1dfa3d48$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $d127db6d1dfa3d48$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $3dJ4i.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
var $d127db6d1dfa3d48$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});
parcelRegister("aD9ip", function(module, exports) {
$parcel$export(module.exports, "gridSize", function () { return $7bd4c1dc034f135b$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "layers", function () { return $7bd4c1dc034f135b$export$7be255094ccdc533; });

var $6gSlv = parcelRequire("6gSlv");

var $hQ6Uh = parcelRequire("hQ6Uh");
var $7bd4c1dc034f135b$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $7bd4c1dc034f135b$export$c93026a968943f95 = 'light';
var $7bd4c1dc034f135b$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $7bd4c1dc034f135b$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $7bd4c1dc034f135b$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $7bd4c1dc034f135b$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $hQ6Uh.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7bd4c1dc034f135b$export$6d8204c2cb2e06b8() / 4;
    (0, $6gSlv.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $7bd4c1dc034f135b$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $7bd4c1dc034f135b$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $7bd4c1dc034f135b$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $6gSlv.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $7bd4c1dc034f135b$export$ba1d834b86d72a09 = $7bd4c1dc034f135b$export$a1b3edb637fb4f35;
var $7bd4c1dc034f135b$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $hQ6Uh.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $hQ6Uh.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $hQ6Uh.N30A), ")")
            }
        }
    };
};

});
parcelRegister("6gSlv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $490e64a492a422c9$export$2e2bcd8739ae039; });

var $E3UMx = parcelRequire("E3UMx");

var $7t0tI = parcelRequire("7t0tI");
function $490e64a492a422c9$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $E3UMx.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $490e64a492a422c9$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("E3UMx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0786c5f25057c4f7$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $0786c5f25057c4f7$var$printed = {};
function $0786c5f25057c4f7$export$2e2bcd8739ae039(message) {
    if ($0786c5f25057c4f7$var$printed[message]) return;
    $0786c5f25057c4f7$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});



parcelRegister("8T7RC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $67898f5db5a435fa$export$2e2bcd8739ae039; });

var $hQ6Uh = parcelRequire("hQ6Uh");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $67898f5db5a435fa$var$fadedB75 = 'rgba(179, 212, 255, 0.6)';
var $67898f5db5a435fa$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($hQ6Uh.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($hQ6Uh.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($hQ6Uh.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($hQ6Uh.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($67898f5db5a435fa$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($hQ6Uh.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($hQ6Uh.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($hQ6Uh.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($hQ6Uh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($hQ6Uh.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($hQ6Uh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($hQ6Uh.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($hQ6Uh.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($hQ6Uh.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($hQ6Uh.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($hQ6Uh.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($hQ6Uh.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($hQ6Uh.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($hQ6Uh.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($hQ6Uh.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($hQ6Uh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($hQ6Uh.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($hQ6Uh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($hQ6Uh.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($hQ6Uh.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($hQ6Uh.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($hQ6Uh.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($hQ6Uh.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($hQ6Uh.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($hQ6Uh.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($hQ6Uh.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($hQ6Uh.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($hQ6Uh.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($hQ6Uh.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($hQ6Uh.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($hQ6Uh.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($hQ6Uh.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($hQ6Uh.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($hQ6Uh.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($hQ6Uh.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($hQ6Uh.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($hQ6Uh.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($hQ6Uh.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($hQ6Uh.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($hQ6Uh.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($hQ6Uh.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($hQ6Uh.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($hQ6Uh.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($hQ6Uh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($hQ6Uh.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($hQ6Uh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($hQ6Uh.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($hQ6Uh.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($hQ6Uh.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($67898f5db5a435fa$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($hQ6Uh.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($hQ6Uh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($hQ6Uh.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($hQ6Uh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($hQ6Uh.DN0, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($hQ6Uh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($hQ6Uh.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($hQ6Uh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($hQ6Uh.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($hQ6Uh.N500, ")"),
                dark: "var(--ds-text, ".concat($hQ6Uh.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($hQ6Uh.B400, ")"),
                dark: "var(--ds-text, ".concat($hQ6Uh.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($hQ6Uh.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($hQ6Uh.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($hQ6Uh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($hQ6Uh.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($hQ6Uh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($hQ6Uh.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($hQ6Uh.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($hQ6Uh.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($hQ6Uh.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($hQ6Uh.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($hQ6Uh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($hQ6Uh.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($hQ6Uh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($hQ6Uh.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($hQ6Uh.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($hQ6Uh.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($hQ6Uh.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($hQ6Uh.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($hQ6Uh.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($hQ6Uh.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($hQ6Uh.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($hQ6Uh.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($hQ6Uh.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($hQ6Uh.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($hQ6Uh.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($hQ6Uh.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($hQ6Uh.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($hQ6Uh.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($hQ6Uh.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($hQ6Uh.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($hQ6Uh.B400, ")"),
                dark: "var(--ds-link, ".concat($hQ6Uh.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($hQ6Uh.B300, ")"),
                dark: "var(--ds-link, ".concat($hQ6Uh.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($hQ6Uh.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($hQ6Uh.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($hQ6Uh.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($hQ6Uh.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($hQ6Uh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($hQ6Uh.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($hQ6Uh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($hQ6Uh.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($hQ6Uh.N500, ")"),
                dark: "var(--ds-text, ".concat($hQ6Uh.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($hQ6Uh.B400, ")"),
                dark: "var(--ds-text, ".concat($hQ6Uh.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($hQ6Uh.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($hQ6Uh.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($hQ6Uh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($hQ6Uh.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($hQ6Uh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($hQ6Uh.DN400, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-text-subtle, ".concat($hQ6Uh.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($hQ6Uh.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($hQ6Uh.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($hQ6Uh.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($hQ6Uh.N400, ")"),
                dark: "var(--ds-text, ".concat($hQ6Uh.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($hQ6Uh.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($hQ6Uh.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($hQ6Uh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($hQ6Uh.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($hQ6Uh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($hQ6Uh.DN400, ")")
            }
        }
    }
};
var $67898f5db5a435fa$export$2e2bcd8739ae039 = $67898f5db5a435fa$var$values;

});


parcelRegister("j2uTH", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $ddc62bd20d1f69d0$export$20bbd2efb0d734c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bzlxh = parcelRequire("bzlxh");
var $ddc62bd20d1f69d0$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $1oC0p.isValidElement)(children) && children.type === (0, $bzlxh.default);
};

});
parcelRegister("bzlxh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $86c3ab277b25faad$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $1oC0p = parcelRequire("1oC0p");

var $c9dvM = parcelRequire("c9dvM");
var $86c3ab277b25faad$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $86c3ab277b25faad$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $c9dvM.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $86c3ab277b25faad$export$2e2bcd8739ae039 = $86c3ab277b25faad$var$VisuallyHidden;

});
parcelRegister("c9dvM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8d80ce7138ef3a2f$export$2e2bcd8739ae039; });
const $8d80ce7138ef3a2f$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $8d80ce7138ef3a2f$var$ATOMIC_GROUP_LENGTH = 5;
function $8d80ce7138ef3a2f$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $8d80ce7138ef3a2f$var$UNDERSCORE_UNICODE ? $8d80ce7138ef3a2f$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});




parcelRegister("lkqdl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f86fccd087edff0d$export$2e2bcd8739ae039; });

var $j2uTH = parcelRequire("j2uTH");
function $f86fccd087edff0d$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $j2uTH.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});



parcelRegister("ez0gt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a9a48a1d39c5a65a$export$2e2bcd8739ae039; });

var $4RXD7 = parcelRequire("4RXD7");

var $1oC0p = parcelRequire("1oC0p");

var $42akA = parcelRequire("42akA");
function $a9a48a1d39c5a65a$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $42akA.default), (0, $4RXD7.default)({}, props, {
        appearance: "subtle"
    }));
}

});

parcelRegister("h2rcU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c677ba5684cfd24b$export$2e2bcd8739ae039; });
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $1oC0p = parcelRequire("1oC0p");

var $jR3dE = parcelRequire("jR3dE");
var $l9uoa = parcelRequire("l9uoa");

var $bzlxh = parcelRequire("bzlxh");
var $c677ba5684cfd24b$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $c677ba5684cfd24b$export$2e2bcd8739ae039(_ref) {
    var key = _ref.key, testId = _ref.testId, from = _ref.from, to = _ref.to;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jR3dE.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $c677ba5684cfd24b$var$styles.container,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $l9uoa.default), {
        testId: testId && "".concat(testId, "-text")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bzlxh.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});
parcelRegister("l9uoa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f66202cc582b67d0$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $hBrR7 = parcelRequire("hBrR7");

var $lmxXn = parcelRequire("lmxXn");

var $fJXSU = parcelRequire("fJXSU");

var $cIMbg = parcelRequire("cIMbg");
var $f66202cc582b67d0$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $f66202cc582b67d0$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $cIMbg.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($f66202cc582b67d0$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $f66202cc582b67d0$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $f66202cc582b67d0$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pmoej",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $f66202cc582b67d0$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
var $f66202cc582b67d0$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $f66202cc582b67d0$var$textColorMap = {
    'color.text': "_syaz1fxt",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syaz1q28",
    'color.text.accent.orange.bolder': "_syaz1vps",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syazpnps",
    'color.text.accent.blue.bolder': "_syazsc1o",
    'color.text.accent.purple': "_syaz10m5",
    'color.text.accent.purple.bolder': "_syaz2ibx",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1dyx",
    'color.text.accent.gray.bolder': "_syaz1x9z",
    'color.text.disabled': "_syaz1lh4",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syazaqb7",
    'color.text.brand': "_syaz1e6v",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syazwx40",
    'color.text.warning.inverse': "_syazal3n",
    'color.text.success': "_syazy73q",
    'color.text.discovery': "_syazzjem",
    'color.text.information': "_syaze0os",
    'color.text.subtlest': "_syaz131l",
    'color.text.subtle': "_syaz1gjq",
    'color.link': "_syaz14q2",
    'color.link.pressed': "_syaz16c2",
    'color.link.visited': "_syazw7te",
    'color.link.visited.pressed': "_syazg3x0"
};
var $f66202cc582b67d0$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $f66202cc582b67d0$var$Text = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $lmxXn.default)($f66202cc582b67d0$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $fJXSU.useHasTextAncestor)();
    var color = $f66202cc582b67d0$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $1oC0p.createElement(Component, {
        id: id,
        className: (0, $hBrR7.default)([
            $f66202cc582b67d0$var$styles.root,
            size && $f66202cc582b67d0$var$fontSizeMap[size],
            color && $f66202cc582b67d0$var$textColorMap[color],
            maxLines && $f66202cc582b67d0$var$styles.truncation,
            maxLines === 1 && $f66202cc582b67d0$var$styles.breakAll,
            align && $f66202cc582b67d0$var$styles["textAlign.".concat(align)],
            weight && $f66202cc582b67d0$var$fontWeightMap[weight],
            Component === 'em' && $f66202cc582b67d0$var$styles['as.em'],
            Component === 'strong' && $f66202cc582b67d0$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $1oC0p.createElement((0, $fJXSU.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $f66202cc582b67d0$export$2e2bcd8739ae039 = $f66202cc582b67d0$var$Text;

});
parcelRegister("fJXSU", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", function () { return $b75982cde87fcc0f$export$9322276ec105d055; });
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $b75982cde87fcc0f$export$ae933c6cbe5643ad; });

var $1oC0p = parcelRequire("1oC0p");
var $b75982cde87fcc0f$var$HasTextAncestorContext = /*#__PURE__*/ (0, $1oC0p.createContext)(false);
var $b75982cde87fcc0f$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $1oC0p.useContext)($b75982cde87fcc0f$var$HasTextAncestorContext);
};
var $b75982cde87fcc0f$export$ae933c6cbe5643ad = $b75982cde87fcc0f$var$HasTextAncestorContext.Provider;

});



parcelRegister("8YElH", function(module, exports) {
$parcel$export(module.exports, "emptyObject", function () { return $689339c52505df32$export$3f860eba1218f8d3; });
var $689339c52505df32$export$3f860eba1218f8d3 = {};

});

parcelRegister("5ofmX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3ecb1da421128ec6$export$2e2bcd8739ae039; });

var $9BlDl = parcelRequire("9BlDl");

var $dWJ7u = parcelRequire("dWJ7u");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
var $3ecb1da421128ec6$var$collapseRange = function collapseRange(pages, current, _ref, testId) {
    var max = _ref.max, ellipsis = _ref.ellipsis, transform = _ref.transform;
    var total = pages.length;
    // only need ellipsis if we have more pages than we can display
    var needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    var hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    var hasEndEllipsis = needEllipsis && current < total - max + 3;
    var getPageComponents = (0, $dWJ7u.default)(function() {
        var startIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var lastIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : total;
        return pages.slice(startIndex, lastIndex).map(function(page, index) {
            return transform(page, startIndex + index, testId);
        });
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        var _pageCount = max - 2;
        return [].concat((0, $9BlDl.default)(getPageComponents(0, 1)), [
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && "".concat(testId, "-ellipsis"),
                from: 2,
                to: total - _pageCount
            })
        ], (0, $9BlDl.default)(getPageComponents(total - _pageCount)));
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        var _pageCount2 = max - 2;
        return [].concat((0, $9BlDl.default)(getPageComponents(0, _pageCount2)), [
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && "".concat(testId, "-ellipsis"),
                from: _pageCount2 + 1,
                to: total - 1
            })
        ], (0, $9BlDl.default)(getPageComponents(total - 1)));
    }
    // we have both start and end ellipsis
    var pageCount = max - 4;
    return [].concat((0, $9BlDl.default)(getPageComponents(0, 1)), [
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && "".concat(testId, "-ellipsis"),
            from: 2,
            to: current - Math.floor(pageCount / 2)
        })
    ], (0, $9BlDl.default)(getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1)), [
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && "".concat(testId, "-ellipsis"),
            from: current + 3,
            to: total - 1
        })
    ], (0, $9BlDl.default)(getPageComponents(total - 1)));
};
var $3ecb1da421128ec6$export$2e2bcd8739ae039 = $3ecb1da421128ec6$var$collapseRange;

});



parcelRegister("8QO1H", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6719fc45515e6da7$export$2e2bcd8739ae039; });

var $4RXD7 = parcelRequire("4RXD7");

var $hx25n = parcelRequire("hx25n");

var $rYoVd = parcelRequire("rYoVd");

var $7jPNY = parcelRequire("7jPNY");

var $8luqs = parcelRequire("8luqs");

var $aqate = parcelRequire("aqate");

var $52vxJ = parcelRequire("52vxJ");

var $1oC0p = parcelRequire("1oC0p");

var $39c3M = parcelRequire("39c3M");

var $d85Xv = parcelRequire("d85Xv");

var $akF5b = parcelRequire("akF5b");

var $hGEAE = parcelRequire("hGEAE");

var $7NY9E = parcelRequire("7NY9E");

var $f8Ivk = parcelRequire("f8Ivk");

var $lIAuX = parcelRequire("lIAuX");
var $6719fc45515e6da7$var$_excluded = [
    "cells"
], $6719fc45515e6da7$var$_excluded2 = [
    "ascendingSortTooltip",
    "buttonAriaRoleDescription",
    "colSpan",
    "content",
    "descendingSortTooltip",
    "isIconOnlyHeader",
    "isSortable",
    "key",
    "shouldTruncate",
    "testId",
    "width"
];
function $6719fc45515e6da7$var$_callSuper(t, o, e) {
    return o = (0, $aqate.default)(o), (0, $8luqs.default)(t, $6719fc45515e6da7$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aqate.default)(t).constructor) : o.apply(t, e));
}
function $6719fc45515e6da7$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6719fc45515e6da7$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $6719fc45515e6da7$var$TableHead = /*#__PURE__*/ function(_React$Component) {
    function TableHead(props) {
        var _this;
        (0, $rYoVd.default)(this, TableHead);
        _this = $6719fc45515e6da7$var$_callSuper(this, TableHead, [
            props
        ]);
        _this.state = {
            activeSortButtonId: null
        };
        return _this;
    }
    (0, $52vxJ.default)(TableHead, _React$Component);
    return (0, $7jPNY.default)(TableHead, [
        {
            key: "UNSAFE_componentWillMount",
            value: function UNSAFE_componentWillMount() {
                (0, $d85Xv.validateSortKey)(this.props.sortKey, this.props.head);
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $d85Xv.validateSortKey)(nextProps.sortKey, nextProps.head);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, head = _this$props.head, sortKey = _this$props.sortKey, sortOrder = _this$props.sortOrder, isFixedSize = _this$props.isFixedSize, onSort = _this$props.onSort, isRanking = _this$props.isRanking, isRankable = _this$props.isRankable, testId = _this$props.testId;
                var activeSortButtonId = this.state.activeSortButtonId;
                if (!head) return null;
                var HeadCellComponentOld = isRankable ? (0, $7NY9E.default) : (0, $lIAuX.default);
                var HeadCellComponent = isRankable ? (0, $hGEAE.default) : (0, $f8Ivk.default);
                // TODO: Remove `rest` props and use only what is explicitly in the API.
                // Some tests use this to pass in onClick and other stuff within the `head`
                // variable here, but considering it's not in the API, it should probably
                // be removed.
                var cells = head.cells, rest = (0, $hx25n.default)(head, $6719fc45515e6da7$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $akF5b.Head), (0, $4RXD7.default)({}, rest, {
                    isRanking: isRanking,
                    testId: testId && "".concat(testId, "--head")
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("tr", null, cells.map(function(cell, index) {
                    var ascendingSortTooltip = cell.ascendingSortTooltip, buttonAriaRoleDescription = cell.buttonAriaRoleDescription, colSpan = cell.colSpan, content = cell.content, descendingSortTooltip = cell.descendingSortTooltip, isIconOnlyHeader = cell.isIconOnlyHeader, isSortable = cell.isSortable, key = cell.key, shouldTruncate = cell.shouldTruncate, cellTestId = cell.testId, width = cell.width, restCellProps = (0, $hx25n.default)(cell, $6719fc45515e6da7$var$_excluded2);
                    var headCellId = "head-cell-".concat(index);
                    var handleClick = function handleClick() {
                        _this2.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return (0, $39c3M.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(HeadCellComponent, (0, $4RXD7.default)({
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        key: key || index,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription
                    }, restCellProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(HeadCellComponentOld, (0, $4RXD7.default)({
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        key: key || index,
                        onClick: isSortable ? onSort(cell) : undefined,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width
                    }, restCellProps));
                })));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Component); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $6719fc45515e6da7$export$2e2bcd8739ae039 = $6719fc45515e6da7$var$TableHead;

});
parcelRegister("akF5b", function(module, exports) {
$parcel$export(module.exports, "Head", function () { return $785ba3cc97155e67$export$e93312b7773dfcac; });
$parcel$export(module.exports, "HeadCell", function () { return $785ba3cc97155e67$export$4e8024263ace498b; });
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3ZAns = parcelRequire("3ZAns");

var $4RXD7 = parcelRequire("4RXD7");

var $hx25n = parcelRequire("hx25n");

var $1oC0p = parcelRequire("1oC0p");

var $hBrR7 = parcelRequire("hBrR7");
var $dcXmn = parcelRequire("dcXmn");

var $39c3M = parcelRequire("39c3M");

var $hQ6Uh = parcelRequire("hQ6Uh");

var $1zZTY = parcelRequire("1zZTY");

var $hVTSr = parcelRequire("hVTSr");
var $785ba3cc97155e67$var$_excluded = [
    "isRanking",
    "testId"
], $785ba3cc97155e67$var$_excluded2 = [
    "width",
    "children",
    "isSortable",
    "sortOrder",
    "isFixedSize",
    "shouldTruncate",
    "onClick",
    "style",
    "testId"
];
function $785ba3cc97155e67$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $785ba3cc97155e67$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $785ba3cc97155e67$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3ZAns.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $785ba3cc97155e67$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $785ba3cc97155e67$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
var $785ba3cc97155e67$var$rankingStyles = null;
var $785ba3cc97155e67$var$headStyles = null;
var $785ba3cc97155e67$var$overflowTruncateStyles = null;
var $785ba3cc97155e67$var$truncationWidthStyles = null;
var $785ba3cc97155e67$var$fixedSizeTruncateStyles = null;
var $785ba3cc97155e67$var$cellStyles = null;
var $785ba3cc97155e67$export$e93312b7773dfcac = function Head(_ref) {
    var isRanking = _ref.isRanking, testId = _ref.testId, props = (0, $hx25n.default)(_ref, $785ba3cc97155e67$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement("thead", (0, $4RXD7.default)({
        "data-testid": testId
    }, props, {
        className: (0, $hBrR7.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    }));
};
var $785ba3cc97155e67$var$headCellBaseStyles = null;
var $785ba3cc97155e67$var$headCellBaseStylesOld = null;
var $785ba3cc97155e67$var$onClickStyles = null;
var $785ba3cc97155e67$var$baseStyles = null;
var $785ba3cc97155e67$var$ascendingStyles = null;
var $785ba3cc97155e67$var$descendingStyles = null;
var $785ba3cc97155e67$export$4e8024263ace498b = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var width = _ref2.width, children = _ref2.children, isSortable = _ref2.isSortable, sortOrder = _ref2.sortOrder, isFixedSize = _ref2.isFixedSize, shouldTruncate = _ref2.shouldTruncate, onClick = _ref2.onClick, style = _ref2.style, testId = _ref2.testId, rest = (0, $hx25n.default)(_ref2, $785ba3cc97155e67$var$_excluded2);
    var mergedStyles = $785ba3cc97155e67$var$_objectSpread($785ba3cc97155e67$var$_objectSpread($785ba3cc97155e67$var$_objectSpread({}, style), width && (0, $hVTSr.getTruncationStyleVars)({
        width: width
    })), {}, (0, $3ZAns.default)({}, $785ba3cc97155e67$var$CSS_VAR_TEXT_COLOR, "var(--ds-text-subtlest, ".concat((0, $hQ6Uh.N300), ")")));
    var isASC = sortOrder === (0, $1zZTY.ASC);
    var isDESC = sortOrder === (0, $1zZTY.DESC);
    var getFormattedSortOrder = function getFormattedSortOrder() {
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    var Component = children ? 'th' : 'td';
    var isVisuallyRefreshed = (0, $39c3M.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $4RXD7.default)({
        "aria-sort": getFormattedSortOrder(),
        onClick: !isVisuallyRefreshed ? onClick : undefined,
        ref: ref,
        "data-testid": testId
    }, rest, {
        className: (0, $hBrR7.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            isVisuallyRefreshed ? "_11c8dcr7 _179rralu _mqm2glyw _kqswh2mm _syaz12fi _k48pmoej _y3gn1e5h _s7n4nkob _1ygbuwsq" : "_11c8dcr7 _179rralu _mqm2glyw _t51zglyw _191wglyw _vchhusvi _kqswh2mm _syaz12fi _k48pmoej _y3gn1e5h _s7n4jp4b _1ygbuwsq",
            !isVisuallyRefreshed && onClick && "_irr3bfnf _d0altlke",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            !isVisuallyRefreshed && isSortable && "_173zglyw _pw6dglyw _1xgk1j28 _1wfn1j28 _y9yonqa1 _997wnqa1 _sklb1l7b _1j091l7b _19w61ule _1w611ule _1hvvidpf _n56nidpf _wyc4idpf _1d4oidpf _no7mstnw _qh32stnw _4b5mb3bt _hn3bb3bt _14gsx0bf _cigmx0bf _c77k1f6e _qzvtu2gc _f4731f6e _1fpyidpf _a04fh2mm _xv14glyw _58ej1kw7 _1ay31kw7 _mdbq1kw7 _10pp1kw7 _1yw3ze3t _n2fdze3t _8607ze3t _szhwze3t _1g2wwc43 _ze9fwc43 _1lcgnqa1 _at5qnqa1 _o4d71l7b _npl51l7b _1rp11onz _1iornqa1 _oi051l7b _1ehx1onz _19t8nqa1 _1bog1l7b",
            !isVisuallyRefreshed && isASC && "_c77k2wk4 _142s94yt",
            !isVisuallyRefreshed && isDESC && "_f4732wk4 _17x894yt"
        ]),
        style: $785ba3cc97155e67$var$_objectSpread($785ba3cc97155e67$var$_objectSpread({}, mergedStyles), {}, {
            "--_k02y3n": (0, $dcXmn.default)("2px solid ".concat("var(--ds-border, ".concat((0, $hQ6Uh.N40), ")"))),
            "--_17ckjys": (0, $dcXmn.default)("var(--ds-text-subtle, ".concat("var(".concat($785ba3cc97155e67$var$CSS_VAR_TEXT_COLOR, ")"), ")")),
            "--_jz8ahf": (0, $dcXmn.default)("solid 2px ".concat("var(--ds-border-focused, ".concat((0, $hQ6Uh.B100), ")"))),
            "--_6j4ewu": (0, $dcXmn.default)("var(--ds-background-neutral-hovered, ".concat((0, $hQ6Uh.N30A), ")")),
            "--_1rdacuj": (0, $dcXmn.default)("3px solid ".concat("var(--ds-icon-disabled, ".concat((0, $hQ6Uh.N40), ")"))),
            "--_1qca9zt": (0, $dcXmn.default)("3px solid ".concat("var(--ds-icon-subtle, ".concat((0, $hQ6Uh.N300), ")")))
        })
    }), children);
});

});

parcelRegister("hGEAE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ce05d84ad501fa5d$export$2e2bcd8739ae039; });

var $4RXD7 = parcelRequire("4RXD7");

var $hx25n = parcelRequire("hx25n");

var $rYoVd = parcelRequire("rYoVd");

var $7jPNY = parcelRequire("7jPNY");

var $8luqs = parcelRequire("8luqs");

var $aqate = parcelRequire("aqate");

var $52vxJ = parcelRequire("52vxJ");

var $1oC0p = parcelRequire("1oC0p");

var $55FkX = parcelRequire("55FkX");

var $d85Xv = parcelRequire("d85Xv");

var $f8Ivk = parcelRequire("f8Ivk");
var $ce05d84ad501fa5d$var$_excluded = [
    "isRanking",
    "refHeight",
    "refWidth"
];
function $ce05d84ad501fa5d$var$_callSuper(t, o, e) {
    return o = (0, $aqate.default)(o), (0, $8luqs.default)(t, $ce05d84ad501fa5d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aqate.default)(t).constructor) : o.apply(t, e));
}
function $ce05d84ad501fa5d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ce05d84ad501fa5d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ce05d84ad501fa5d$var$RankableTableHeadCellComponent = /*#__PURE__*/ function(_React$Component) {
    function RankableTableHeadCellComponent() {
        (0, $rYoVd.default)(this, RankableTableHeadCellComponent);
        return $ce05d84ad501fa5d$var$_callSuper(this, RankableTableHeadCellComponent, arguments);
    }
    (0, $52vxJ.default)(RankableTableHeadCellComponent, _React$Component);
    return (0, $7jPNY.default)(RankableTableHeadCellComponent, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, isRanking = _this$props.isRanking, refHeight = _this$props.refHeight, refWidth = _this$props.refWidth, restProps = (0, $hx25n.default)(_this$props, $ce05d84ad501fa5d$var$_excluded);
                var inlineStyles = (0, $d85Xv.inlineStylesIfRanking)(isRanking, refWidth);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $f8Ivk.default), (0, $4RXD7.default)({
                    inlineStyles: inlineStyles
                }, restProps));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Component);
var $ce05d84ad501fa5d$var$RankableTableHeadCell = (0, $55FkX.default)($ce05d84ad501fa5d$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ce05d84ad501fa5d$export$2e2bcd8739ae039 = $ce05d84ad501fa5d$var$RankableTableHeadCell;

});
parcelRegister("55FkX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3b4d7c11666bc236$export$2e2bcd8739ae039; });

var $4RXD7 = parcelRequire("4RXD7");

var $rYoVd = parcelRequire("rYoVd");

var $7jPNY = parcelRequire("7jPNY");

var $8luqs = parcelRequire("8luqs");

var $aqate = parcelRequire("aqate");

var $52vxJ = parcelRequire("52vxJ");

var $3ZAns = parcelRequire("3ZAns");

var $1oC0p = parcelRequire("1oC0p");
function $3b4d7c11666bc236$var$_callSuper(t, o, e) {
    return o = (0, $aqate.default)(o), (0, $8luqs.default)(t, $3b4d7c11666bc236$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aqate.default)(t).constructor) : o.apply(t, e));
}
function $3b4d7c11666bc236$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3b4d7c11666bc236$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $3b4d7c11666bc236$export$2e2bcd8739ae039(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        function WithDimensions() {
            var _this;
            (0, $rYoVd.default)(this, WithDimensions);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = $3b4d7c11666bc236$var$_callSuper(this, WithDimensions, [].concat(args));
            (0, $3ZAns.default)(_this, "state", {
                refWidth: 0,
                refHeight: 0
            });
            (0, $3ZAns.default)(_this, "innerRef", function(ref) {
                if (ref && !_this.props.isRanking) _this.ref = ref;
            });
            (0, $3ZAns.default)(_this, "updateDimensions", function() {
                if (!_this.ref) return;
                var clientRect = _this.ref.getBoundingClientRect();
                var width = clientRect.width;
                var height = clientRect.height;
                if (width !== _this.state.refWidth || height !== _this.state.refHeight) _this.setState({
                    refWidth: width,
                    refHeight: height
                });
            });
            return _this;
        }
        (0, $52vxJ.default)(WithDimensions, _React$Component);
        return (0, $7jPNY.default)(WithDimensions, [
            {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps(nextProps) {
                    var wasRanking = this.props.isRanking;
                    var willRanking = nextProps.isRanking;
                    if (willRanking && !wasRanking) this.updateDimensions();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$state = this.state, refWidth = _this$state.refWidth, refHeight = _this$state.refHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(WrappedComponent, (0, $4RXD7.default)({
                        refWidth: refWidth,
                        refHeight: refHeight,
                        innerRef: this.innerRef
                    }, this.props));
                }
            }
        ]);
    }((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Component);
}

});

parcelRegister("f8Ivk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b05a1ff9afe24ae1$export$2e2bcd8739ae039; });
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4RXD7 = parcelRequire("4RXD7");

var $iBgnv = parcelRequire("iBgnv");

var $hx25n = parcelRequire("hx25n");

var $hBrR7 = parcelRequire("hBrR7");

var $1oC0p = parcelRequire("1oC0p");

var $9ait2 = parcelRequire("9ait2");

var $h4ACf = parcelRequire("h4ACf");

var $jR3dE = parcelRequire("jR3dE");
var $991sQ = parcelRequire("991sQ");
var $aCz9k = parcelRequire("aCz9k");

var $6vw1V = parcelRequire("6vw1V");

var $1zZTY = parcelRequire("1zZTY");

var $akF5b = parcelRequire("akF5b");
var $b05a1ff9afe24ae1$var$_excluded = [
    "content",
    "inlineStyles",
    "testId",
    "isRanking",
    "innerRef",
    "isSortable",
    "sortOrder",
    "onClick",
    "headCellId",
    "activeSortButtonId",
    "ascendingSortTooltip",
    "descendingSortTooltip",
    "buttonAriaRoleDescription",
    "isIconOnlyHeader"
];
var $b05a1ff9afe24ae1$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk1j28 _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
var $b05a1ff9afe24ae1$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c81o8v _syaz1gjq _k48pmoej"
};
var $b05a1ff9afe24ae1$var$TableHeadCell = function TableHeadCell(_ref) {
    var content = _ref.content, inlineStyles = _ref.inlineStyles, testId = _ref.testId, isRanking = _ref.isRanking, innerRef = _ref.innerRef, isSortable = _ref.isSortable, sortOrder = _ref.sortOrder, onClick = _ref.onClick, headCellId = _ref.headCellId, activeSortButtonId = _ref.activeSortButtonId, _ref$ascendingSortToo = _ref.ascendingSortTooltip, ascendingSortTooltip = _ref$ascendingSortToo === void 0 ? 'Sort ascending' : _ref$ascendingSortToo, _ref$descendingSortTo = _ref.descendingSortTooltip, descendingSortTooltip = _ref$descendingSortTo === void 0 ? 'Sort descending' : _ref$descendingSortTo, _ref$buttonAriaRoleDe = _ref.buttonAriaRoleDescription, buttonAriaRoleDescription = _ref$buttonAriaRoleDe === void 0 ? 'Sort button' : _ref$buttonAriaRoleDe, isIconOnlyHeader = _ref.isIconOnlyHeader, rest = (0, $hx25n.default)(_ref, $b05a1ff9afe24ae1$var$_excluded);
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $iBgnv.default)(_useState, 2), isHovered = _useState2[0], setIsHovered = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(false), _useState4 = (0, $iBgnv.default)(_useState3, 2), isFocused = _useState4[0], setIsFocused = _useState4[1];
    var isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    var isSortIconVisible = isHovered || isActive || isFocused;
    var isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    var shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    var handleFocus = (0, $1oC0p.useCallback)(function() {
        setIsFocused === null || setIsFocused === void 0 || setIsFocused(true);
    }, [
        setIsFocused
    ]);
    var handleBlur = (0, $1oC0p.useCallback)(function() {
        setIsFocused === null || setIsFocused === void 0 || setIsFocused(false);
    }, [
        setIsFocused
    ]);
    var handleMouseEnter = (0, $1oC0p.useCallback)(function() {
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    var handleMouseLeave = (0, $1oC0p.useCallback)(function() {
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    var visuallyRefreshedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jR3dE.default), {
        xcss: $b05a1ff9afe24ae1$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $6vw1V.default), {
        content: sortOrder === (0, $1zZTY.ASC) ? ascendingSortTooltip : descendingSortTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $aCz9k.default), {
        onClick: onClick,
        xcss: $b05a1ff9afe24ae1$var$styles.buttonWrapper,
        "aria-roledescription": buttonAriaRoleDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $991sQ.default), {
        xcss: isVisibleIconOnlyHeader ? $b05a1ff9afe24ae1$var$styles.hideIconHeaderWrapper : $b05a1ff9afe24ae1$var$styles.visibleHeaderWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        className: (0, $hBrR7.default)([
            $b05a1ff9afe24ae1$var$headCellStyles.text
        ])
    }, content)), shouldRenderSortIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $991sQ.default), {
        xcss: isSortIconVisible ? $b05a1ff9afe24ae1$var$styles.sortIconVisibleWrapper : $b05a1ff9afe24ae1$var$styles.sortIconHiddenWrapper
    }, sortOrder === (0, $1zZTY.ASC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h4ACf))), {
        label: "",
        color: "var(--ds-text-subtle, #44546F)",
        testId: testId && "".concat(testId, "--up--icon")
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ait2))), {
        label: "",
        color: "var(--ds-text-subtle, #44546F)",
        testId: testId && "".concat(testId, "--down--icon")
    })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $akF5b.HeadCell), (0, $4RXD7.default)({
        style: inlineStyles,
        testId: testId && "".concat(testId, "--head--cell"),
        ref: typeof innerRef !== 'string' ? innerRef : null // string refs must be discarded as LegacyRefs are not compatible with FC forwardRefs
    }, rest, {
        isSortable: isSortable,
        sortOrder: sortOrder
    }), isSortable ? visuallyRefreshedButton : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b05a1ff9afe24ae1$export$2e2bcd8739ae039 = $b05a1ff9afe24ae1$var$TableHeadCell;

});
parcelRegister("9ait2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ac35f76331c8ade$var$_react = $6ac35f76331c8ade$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6ac35f76331c8ade$var$_baseNew = $6ac35f76331c8ade$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $6ac35f76331c8ade$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6ac35f76331c8ade$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $6ac35f76331c8ade$var$_react.default.createElement($6ac35f76331c8ade$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$6ac35f76331c8ade$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $6ac35f76331c8ade$var$_default = module.exports.default = $6ac35f76331c8ade$var$ArrowDownIcon;

});

parcelRegister("aCz9k", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7bb8b7ec22852176$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4RXD7 = parcelRequire("4RXD7");

var $hx25n = parcelRequire("hx25n");

var $1oC0p = parcelRequire("1oC0p");


var $114y6 = parcelRequire("114y6");

var $9XbNz = parcelRequire("9XbNz");

var $4xhA5 = parcelRequire("4xhA5");

var $kAw0E = parcelRequire("kAw0E");

var $etBkE = parcelRequire("etBkE");

var $dBT8t = parcelRequire("dBT8t");
var $7bb8b7ec22852176$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $7bb8b7ec22852176$var$_excluded2 = [
    "className"
];
var $7bb8b7ec22852176$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $7bb8b7ec22852176$var$Pressable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $kAw0E.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $hx25n.default)(_ref, $7bb8b7ec22852176$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $etBkE.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $9XbNz.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "14.11.2",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $hx25n.default)(htmlAttributes, $7bb8b7ec22852176$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement((0, $dBT8t.default), (0, $4RXD7.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $4xhA5.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $114y6.cx)($7bb8b7ec22852176$var$styles.root, isDisabled && $7bb8b7ec22852176$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $7bb8b7ec22852176$export$2e2bcd8739ae039 = $7bb8b7ec22852176$var$Pressable;

});
parcelRegister("4xhA5", function(module, exports) {
$parcel$export(module.exports, "isSafari", function () { return $34d7e1b848de6edb$export$95df08bae54cb4df; });
function $34d7e1b848de6edb$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? //@ts-expect-error ignore userAgentData type issue
    re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $34d7e1b848de6edb$var$isIPhone() {
    return $34d7e1b848de6edb$var$testPlatform(/^iPhone/i);
}
function $34d7e1b848de6edb$var$isMac() {
    return $34d7e1b848de6edb$var$testPlatform(/^Mac/i);
}
function $34d7e1b848de6edb$var$isIPad() {
    return $34d7e1b848de6edb$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $34d7e1b848de6edb$var$isMac() && navigator.maxTouchPoints > 1;
}
function $34d7e1b848de6edb$var$isIOS() {
    return $34d7e1b848de6edb$var$isIPhone() || $34d7e1b848de6edb$var$isIPad();
}
function $34d7e1b848de6edb$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use2;
        var ua = (_window$navigator$use2 = window.navigator.userAgent) === null || _window$navigator$use2 === void 0 ? void 0 : _window$navigator$use2.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $34d7e1b848de6edb$export$e1865c3bedcd822b() {
    return $34d7e1b848de6edb$var$isMac() || $34d7e1b848de6edb$var$isIOS();
}

});

parcelRegister("dBT8t", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9e897fe1104b705d$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4RXD7 = parcelRequire("4RXD7");

var $3ZAns = parcelRequire("3ZAns");

var $hx25n = parcelRequire("hx25n");

var $1oC0p = parcelRequire("1oC0p");

var $hBrR7 = parcelRequire("hBrR7");
var $dcXmn = parcelRequire("dcXmn");
var $9e897fe1104b705d$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $9e897fe1104b705d$var$_excluded2 = [
    "className"
];
function $9e897fe1104b705d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9e897fe1104b705d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9e897fe1104b705d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3ZAns.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9e897fe1104b705d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9e897fe1104b705d$var$focusRingStyles = null;
var $9e897fe1104b705d$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $9e897fe1104b705d$var$Focusable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $hx25n.default)(_ref, $9e897fe1104b705d$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $hx25n.default)(htmlAttributes, $9e897fe1104b705d$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $4RXD7.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $hBrR7.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $9e897fe1104b705d$var$_objectSpread($9e897fe1104b705d$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $dcXmn.default)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $9e897fe1104b705d$export$2e2bcd8739ae039 = $9e897fe1104b705d$var$Focusable;

});


parcelRegister("6vw1V", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4bce7bd9a67e0875$export$2e2bcd8739ae039; });

var $4RXD7 = parcelRequire("4RXD7");

var $iBgnv = parcelRequire("iBgnv");

var $3ZAns = parcelRequire("3ZAns");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $1Fcoc = parcelRequire("1Fcoc");

var $kAw0E = parcelRequire("kAw0E");

var $Hg3St = parcelRequire("Hg3St");

var $6PlDK = parcelRequire("6PlDK");

var $6P6Jp = parcelRequire("6P6Jp");

var $01fYV = parcelRequire("01fYV");
var $b6Sy7 = parcelRequire("b6Sy7");

var $39c3M = parcelRequire("39c3M");

var $jer1f = parcelRequire("jer1f");

var $52Fo7 = parcelRequire("52Fo7");

var $aD9ip = parcelRequire("aD9ip");

var $4JUEg = parcelRequire("4JUEg");

var $ia9qH = parcelRequire("ia9qH");

var $kmGy7 = parcelRequire("kmGy7");

var $eNyaI = parcelRequire("eNyaI");

var $lEvro = parcelRequire("lEvro");
function $4bce7bd9a67e0875$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4bce7bd9a67e0875$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4bce7bd9a67e0875$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3ZAns.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4bce7bd9a67e0875$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4bce7bd9a67e0875$var$tooltipZIndex = (0, $aD9ip.layers).tooltip();
var $4bce7bd9a67e0875$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.4.0"
};
// Inverts motion direction
var $4bce7bd9a67e0875$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $4bce7bd9a67e0875$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $4bce7bd9a67e0875$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $eNyaI.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $kAw0E.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $kAw0E.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $1Fcoc.usePlatformLeafSyntheticEventHandler)($4bce7bd9a67e0875$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $4bce7bd9a67e0875$var$analyticsAttributes));
    var onHideHandler = (0, $1Fcoc.usePlatformLeafSyntheticEventHandler)($4bce7bd9a67e0875$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $4bce7bd9a67e0875$var$analyticsAttributes));
    var apiRef = (0, $1oC0p.useRef)(null);
    var _useState = (0, $1oC0p.useState)('hide'), _useState2 = (0, $iBgnv.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $1oC0p.useRef)(null);
    var containerRef = (0, $1oC0p.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $1oC0p.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $6PlDK.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $6PlDK.default)(onShowHandler);
    var onHideHandlerStable = (0, $6PlDK.default)(onHideHandler);
    var delayStable = (0, $6PlDK.default)(delay);
    var canAppearStable = (0, $6PlDK.default)(canAppear);
    var hasCalledShowHandler = (0, $1oC0p.useRef)(false);
    var start = (0, $1oC0p.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $1oC0p.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(function() {
        return (0, $4JUEg.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $1oC0p.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $ia9qH.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $Hg3St.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $1oC0p.useEffect)(function() {
        if (state === 'hide') return 0, $kAw0E.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $dH1HR.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $1oC0p.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $1oC0p.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $lEvro.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $lEvro.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $1oC0p.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $1oC0p.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible') && (0, $39c3M.fg)('platform-tooltip-focus-visible-new')) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $1oC0p.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $1oC0p.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $6P6Jp.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5;
        if (position === 'mouse' && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePosition) {
            var _apiRef$current6;
            return (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 ? void 0 : _apiRef$current6.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $kmGy7.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $1oC0p.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children($4bce7bd9a67e0875$var$_objectSpread($4bce7bd9a67e0875$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(CastTargetContainer, (0, $4RXD7.default)({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $52Fo7.default), {
        zIndex: $4bce7bd9a67e0875$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jer1f.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $4bce7bd9a67e0875$var$invertedDirection[$4bce7bd9a67e0875$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $01fYV.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $b6Sy7.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $4bce7bd9a67e0875$var$_objectSpread($4bce7bd9a67e0875$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $4bce7bd9a67e0875$export$2e2bcd8739ae039 = $4bce7bd9a67e0875$var$Tooltip;

});
parcelRegister("1Fcoc", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $13633b08043ac0ca$export$1a04351537078b55; });

var $3ZAns = parcelRequire("3ZAns");

var $1oC0p = parcelRequire("1oC0p");

var $ewdeD = parcelRequire("ewdeD");

var $4SaI5 = parcelRequire("4SaI5");
function $13633b08043ac0ca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $13633b08043ac0ca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $13633b08043ac0ca$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3ZAns.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $13633b08043ac0ca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $13633b08043ac0ca$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $ewdeD.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $4SaI5.useTrackedRef)(analyticsData);
    var fnRef = (0, $4SaI5.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $13633b08043ac0ca$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("Hg3St", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $082079c11eac9d23$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $39c3M = parcelRequire("39c3M");

var $kS5V7 = parcelRequire("kS5V7");
function $082079c11eac9d23$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $1oC0p.useRef)(false);
    var onKeyDown = (0, $1oC0p.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $kS5V7.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $1oC0p.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $1oC0p.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled && (0, $39c3M.fg)('platform_only_attach_escape_handler_on_view')) return;
        return (0, $dH1HR.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("kS5V7", function(module, exports) {
$parcel$export(module.exports, "ESCAPE", function () { return $f31d716c63a5f08c$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $f31d716c63a5f08c$export$390330c10ff2b9a1 = 'ArrowUp';
var $f31d716c63a5f08c$export$a80636c6f41931fe = 'ArrowDown';
var $f31d716c63a5f08c$export$4af703091671bc = 'Home';
var $f31d716c63a5f08c$export$e2bc30913faa5db7 = 'End';
var $f31d716c63a5f08c$export$10f6869ed0a7d75b = 'Tab';
var $f31d716c63a5f08c$export$8152f929a25a0ff4 = 'Enter';
var $f31d716c63a5f08c$export$e51a3576c045c8d5 = 'Space';
var $f31d716c63a5f08c$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("6PlDK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4f884ac355f43875$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $4f884ac355f43875$export$2e2bcd8739ae039(value) {
    var ref = (0, $1oC0p.useRef)(value);
    (0, $1oC0p.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("4JUEg", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $37374e9c52dc5122$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $dH1HR = parcelRequire("dH1HR");
var $37374e9c52dc5122$var$registrations = new Set();
var $37374e9c52dc5122$var$cleanupEndEventListeners = null;
function $37374e9c52dc5122$var$onDragStart() {
    if ($37374e9c52dc5122$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $37374e9c52dc5122$var$cleanupEndEventListeners = (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragend',
            listener: $37374e9c52dc5122$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $37374e9c52dc5122$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $37374e9c52dc5122$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($37374e9c52dc5122$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $37374e9c52dc5122$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $37374e9c52dc5122$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $37374e9c52dc5122$var$cleanupEndEventListeners = null;
    var clone = Array.from($37374e9c52dc5122$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $37374e9c52dc5122$var$bindStartEvents() {
    return (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $37374e9c52dc5122$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $37374e9c52dc5122$var$onDragStart
        }
    ]);
}
var $37374e9c52dc5122$var$cleanupStartEventListeners = null;
function $37374e9c52dc5122$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$37374e9c52dc5122$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $37374e9c52dc5122$var$cleanupStartEventListeners = $37374e9c52dc5122$var$bindStartEvents();
    $37374e9c52dc5122$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $37374e9c52dc5122$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $37374e9c52dc5122$var$registrations.delete(registration);
        if ($37374e9c52dc5122$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $37374e9c52dc5122$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $37374e9c52dc5122$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("ia9qH", function(module, exports) {
$parcel$export(module.exports, "show", function () { return $d39079b058fc81cb$export$57bf213be019eeb0; });

var $2e84g = parcelRequire("2e84g");
// This file is a singleton for managing tooltips
var $d39079b058fc81cb$var$active = null;
function $d39079b058fc81cb$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($d39079b058fc81cb$var$active && $d39079b058fc81cb$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $2e84g.clearScheduled)();
            $d39079b058fc81cb$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $2e84g.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $2e84g.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $2e84g.scheduleTimeout)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($d39079b058fc81cb$var$active && $d39079b058fc81cb$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($d39079b058fc81cb$var$active) {
            (0, $2e84g.clearScheduled)();
            $d39079b058fc81cb$var$active.entry.hide({
                isImmediate: true
            });
            $d39079b058fc81cb$var$active.entry.done();
            $d39079b058fc81cb$var$active = null;
        }
        // this tooltip is now the active tooltip
        $d39079b058fc81cb$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $2e84g.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("2e84g", function(module, exports) {
$parcel$export(module.exports, "clearScheduled", function () { return $19f325a78aa8742f$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $19f325a78aa8742f$export$5f4d6617421d489b; });
var $19f325a78aa8742f$var$delayId = null;
function $19f325a78aa8742f$export$eaf678f6f93f5250() {
    if ($19f325a78aa8742f$var$delayId != null) {
        window.clearTimeout($19f325a78aa8742f$var$delayId);
        $19f325a78aa8742f$var$delayId = null;
    }
}
function $19f325a78aa8742f$export$5f4d6617421d489b(fn, delay) {
    $19f325a78aa8742f$export$eaf678f6f93f5250();
    $19f325a78aa8742f$var$delayId = window.setTimeout(function() {
        $19f325a78aa8742f$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("kmGy7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ed36de1dcbcad849$export$2e2bcd8739ae039; });

var $3kocB = parcelRequire("3kocB");
function $ed36de1dcbcad849$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $3kocB.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("3kocB", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", function () { return $26c60369149ed61c$export$6ee17796e3d70de2; });

var $4ww0t = parcelRequire("4ww0t");

var $1oC0p = parcelRequire("1oC0p");

var $6JmtO = parcelRequire("6JmtO");

var $39c3M = parcelRequire("39c3M");
var $26c60369149ed61c$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $26c60369149ed61c$var$react18UseId = ($26c60369149ed61c$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId) !== null && $26c60369149ed61c$var$_React$useId !== void 0 ? $26c60369149ed61c$var$_React$useId : undefined;
function $26c60369149ed61c$export$f680877a34711e37() {
    if ($26c60369149ed61c$var$react18UseId && (0, $39c3M.fg)('platform-dst-react-18-use-id')) return $26c60369149ed61c$var$react18UseId();
    return "uid".concat((0, $6JmtO.useUID)());
}
var $26c60369149ed61c$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($26c60369149ed61c$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $4ww0t.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $4ww0t.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $26c60369149ed61c$export$6ee17796e3d70de2() {
    if ($26c60369149ed61c$var$react18UseId && (0, $39c3M.fg)('platform-dst-react-18-use-id')) {
        var uid = $26c60369149ed61c$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $6JmtO.useUIDSeed)();
}

});


parcelRegister("eNyaI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ac60261e853b3aac$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3ZAns = parcelRequire("3ZAns");

var $1oC0p = parcelRequire("1oC0p");

var $hBrR7 = parcelRequire("hBrR7");
var $dcXmn = parcelRequire("dcXmn");

var $hQ6Uh = parcelRequire("hQ6Uh");

var $jF2Fw = parcelRequire("jF2Fw");
function $ac60261e853b3aac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ac60261e853b3aac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ac60261e853b3aac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3ZAns.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ac60261e853b3aac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ac60261e853b3aac$var$baseStyles = null;
var $ac60261e853b3aac$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $ac60261e853b3aac$var$TooltipContainer = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $1oC0p.createElement((0, $jF2Fw.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hBrR7.default)([
            "_2rko1sit _11c8dcr7 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $ac60261e853b3aac$var$_objectSpread($ac60261e853b3aac$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $dcXmn.default)("var(--ds-background-neutral-bold, ".concat((0, $hQ6Uh.N800), ")")),
            "--_ywovvi": (0, $dcXmn.default)("var(--ds-text-inverse, ".concat((0, $hQ6Uh.N0), ")"))
        })
    }, children);
});
$ac60261e853b3aac$var$TooltipContainer.displayName = 'TooltipContainer';
var $ac60261e853b3aac$export$2e2bcd8739ae039 = $ac60261e853b3aac$var$TooltipContainer;

});
parcelRegister("jF2Fw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $03b19c8eee5fb1a9$export$2e2bcd8739ae039; });
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $hBrR7 = parcelRequire("hBrR7");
var $03b19c8eee5fb1a9$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $03b19c8eee5fb1a9$var$TooltipPrimitive = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        role: "tooltip",
        className: (0, $hBrR7.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$03b19c8eee5fb1a9$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $03b19c8eee5fb1a9$export$2e2bcd8739ae039 = $03b19c8eee5fb1a9$var$TooltipPrimitive;

});


parcelRegister("lEvro", function(module, exports) {
$parcel$export(module.exports, "getMousePosition", function () { return $fc35b8e527e84c30$export$642213d516a9b928; });
function $fc35b8e527e84c30$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});




parcelRegister("7NY9E", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5aebc573b89982d1$export$2e2bcd8739ae039; });

var $4RXD7 = parcelRequire("4RXD7");

var $hx25n = parcelRequire("hx25n");

var $rYoVd = parcelRequire("rYoVd");

var $7jPNY = parcelRequire("7jPNY");

var $8luqs = parcelRequire("8luqs");

var $aqate = parcelRequire("aqate");

var $52vxJ = parcelRequire("52vxJ");

var $1oC0p = parcelRequire("1oC0p");

var $55FkX = parcelRequire("55FkX");

var $d85Xv = parcelRequire("d85Xv");

var $lIAuX = parcelRequire("lIAuX");
var $5aebc573b89982d1$var$_excluded = [
    "isRanking",
    "refHeight",
    "refWidth"
];
function $5aebc573b89982d1$var$_callSuper(t, o, e) {
    return o = (0, $aqate.default)(o), (0, $8luqs.default)(t, $5aebc573b89982d1$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aqate.default)(t).constructor) : o.apply(t, e));
}
function $5aebc573b89982d1$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5aebc573b89982d1$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $5aebc573b89982d1$var$RankableTableHeadCellComponentOld = /*#__PURE__*/ function(_React$Component) {
    function RankableTableHeadCellComponentOld() {
        (0, $rYoVd.default)(this, RankableTableHeadCellComponentOld);
        return $5aebc573b89982d1$var$_callSuper(this, RankableTableHeadCellComponentOld, arguments);
    }
    (0, $52vxJ.default)(RankableTableHeadCellComponentOld, _React$Component);
    return (0, $7jPNY.default)(RankableTableHeadCellComponentOld, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, isRanking = _this$props.isRanking, refHeight = _this$props.refHeight, refWidth = _this$props.refWidth, restProps = (0, $hx25n.default)(_this$props, $5aebc573b89982d1$var$_excluded);
                var inlineStyles = (0, $d85Xv.inlineStylesIfRanking)(isRanking, refWidth);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lIAuX.default), (0, $4RXD7.default)({
                    inlineStyles: inlineStyles
                }, restProps));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Component);
var $5aebc573b89982d1$var$RankableTableHeadCellOld = (0, $55FkX.default)($5aebc573b89982d1$var$RankableTableHeadCellComponentOld);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5aebc573b89982d1$export$2e2bcd8739ae039 = $5aebc573b89982d1$var$RankableTableHeadCellOld;

});
parcelRegister("lIAuX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fcfa04d203f4e209$export$2e2bcd8739ae039; });

var $4RXD7 = parcelRequire("4RXD7");

var $hx25n = parcelRequire("hx25n");

var $1oC0p = parcelRequire("1oC0p");

var $akF5b = parcelRequire("akF5b");
var $fcfa04d203f4e209$var$_excluded = [
    "content",
    "inlineStyles",
    "testId",
    "isRanking",
    "innerRef",
    "isSortable",
    "onClick"
];
var $fcfa04d203f4e209$var$TableHeadCellOld = function TableHeadCellOld(_ref) {
    var content = _ref.content, inlineStyles = _ref.inlineStyles, testId = _ref.testId, isRanking = _ref.isRanking, innerRef = _ref.innerRef, isSortable = _ref.isSortable, onClick = _ref.onClick, rest = (0, $hx25n.default)(_ref, $fcfa04d203f4e209$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $akF5b.HeadCell), (0, $4RXD7.default)({
        style: inlineStyles,
        testId: testId && "".concat(testId, "--head--cell"),
        ref: typeof innerRef !== 'string' ? innerRef : null // string refs must be discarded as LegacyRefs are not compatible with FC forwardRefs
    }, rest, {
        onClick: onClick,
        isSortable: isSortable
    }), isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fcfa04d203f4e209$export$2e2bcd8739ae039 = $fcfa04d203f4e209$var$TableHeadCellOld;

});



parcelRegister("44pei", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("80DEJ")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("b52o4")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("9XWMM"))
]).then(()=>parcelRequire('3ohIy'));

});
parcelRegister("1athW", function(module, exports) {
"use strict";

var $1tHQt = parcelRequire("1tHQt");
module.exports = $1tHQt(function importModule(bundle) {
    return new Promise((resolve, reject)=>{
        // Add a global function to handle when the script loads.
        let globalName = `i${('' + Math.random()).slice(2)}`;
        $parcel$global[globalName] = (m)=>{
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        let cleanup = ()=>{
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        let script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = `import * as m from '${bundle}'; ${globalName}(m);`;
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("1tHQt", function(module, exports) {
"use strict";
let $113a82a87c54a561$var$cachedBundles = {};
let $113a82a87c54a561$var$cachedPreloads = {};
let $113a82a87c54a561$var$cachedPrefetches = {};
function $113a82a87c54a561$var$getCache(type) {
    switch(type){
        case 'preload':
            return $113a82a87c54a561$var$cachedPreloads;
        case 'prefetch':
            return $113a82a87c54a561$var$cachedPrefetches;
        default:
            return $113a82a87c54a561$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $113a82a87c54a561$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("hwrhg", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $cc1a958bd304f822$export$6503ec6e8aabbaf; }, function (v) { return $cc1a958bd304f822$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $cc1a958bd304f822$export$f7ad0328861e2f03; }, function (v) { return $cc1a958bd304f822$export$f7ad0328861e2f03 = v; });
var $cc1a958bd304f822$export$6503ec6e8aabbaf;
var $cc1a958bd304f822$export$f7ad0328861e2f03;
"use strict";
var $cc1a958bd304f822$var$mapping = new Map();
function $cc1a958bd304f822$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$cc1a958bd304f822$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $cc1a958bd304f822$var$resolve(id) {
    var resolved = $cc1a958bd304f822$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$cc1a958bd304f822$export$6503ec6e8aabbaf = $cc1a958bd304f822$var$register;
$cc1a958bd304f822$export$f7ad0328861e2f03 = $cc1a958bd304f822$var$resolve;

});



parcelRegister("5En5H", function(module, exports) {
$parcel$export(module.exports, "EmptySearchVector", function () { return (parcelRequire("ky2Uk")).EmptySearchVector; });

var $ky2Uk = parcelRequire("ky2Uk");

});
parcelRegister("ky2Uk", function(module, exports) {
$parcel$export(module.exports, "EmptySearchVector", function () { return $795a82120e8ba891$export$df81497daaac8d1d; });

var $7VQPk = parcelRequire("7VQPk");
const $795a82120e8ba891$export$df81497daaac8d1d = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "49",
        height: "54",
        viewBox: "0 0 49 54",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.1406 12.9633C37.5384 11.8084 36.7995 10.6593 35.9181 9.51897C35.025 8.36406 34.0824 7.34588 33.105 6.46151C27.2839 1.20188 20.1304 0.718969 13.4308 4.35242C12.2875 4.97206 11.1588 5.71097 10.0504 6.56624C8.89553 7.45933 7.85699 8.4077 6.93771 9.3997C1.75081 14.9968 0.42135 22.0281 4.01699 28.9517C4.62499 30.1212 5.37262 31.2877 6.26572 32.4455C7.14717 33.5859 8.07517 34.5895 9.04099 35.4622C14.8243 40.6841 21.9719 41.1699 28.7035 37.551C29.8963 36.911 31.0744 36.1459 32.2294 35.2528C33.3377 34.3975 34.3355 33.487 35.2228 32.5386C40.433 26.9619 41.7624 19.9044 38.1348 12.9633H38.1406Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M19.9996 41.8919C15.5778 41.8919 11.3479 40.2279 7.70867 36.9436C6.64686 35.9836 5.63158 34.881 4.69195 33.6679C3.74067 32.4374 2.9174 31.1603 2.25122 29.8745C-1.62951 22.4068 -0.454237 14.4505 5.4774 8.04758C6.48104 6.96539 7.60976 5.93558 8.83158 4.99012C10.0098 4.07958 11.2374 3.27376 12.4796 2.59885C20.1538 -1.56406 28.1596 -0.694242 34.4403 4.98139C35.5138 5.95303 36.5407 7.06721 37.4949 8.29776C38.4345 9.51085 39.2461 10.7705 39.9094 12.0388C43.8309 19.5414 42.6556 27.5094 36.6861 33.8978C35.7232 34.9305 34.6352 35.9167 33.4541 36.8272C32.2294 37.7727 30.9494 38.6076 29.6519 39.3058C26.4374 41.0338 23.1676 41.889 19.9996 41.889V41.8919ZM22.1087 3.98649C19.5923 3.98649 16.9858 4.68758 14.3792 6.1043C13.3261 6.67739 12.2789 7.36394 11.2665 8.14357C10.2163 8.95521 9.25049 9.83376 8.39813 10.7559C3.60976 15.9254 2.68176 22.0607 5.78576 28.0359C6.34431 29.1094 7.03667 30.1858 7.8454 31.2272C8.63958 32.2541 9.49194 33.1821 10.3821 33.985C15.3741 38.4941 21.5472 39.137 27.7669 35.7974C28.8723 35.2039 29.9661 34.4912 31.0163 33.6767C32.0287 32.8941 32.9538 32.0534 33.7741 31.1778C38.5887 26.0258 39.5109 19.8847 36.3778 13.8861C35.825 12.8272 35.1385 11.7654 34.3443 10.7385C33.5356 9.69412 32.6716 8.75158 31.7727 7.93994C28.8636 5.31303 25.5705 3.98649 22.1145 3.98649H22.1087Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M36.4418 35.9924C35.4119 34.5582 34.3065 34.5669 33.2272 35.4018C32.2148 36.1844 31.9443 37.2433 33.0236 38.6367L34.257 40.2309L37.6752 37.5865L36.4418 35.9924Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.5348 36.9226L33.4026 40.8906L43.0469 53.3644L48.1791 49.3963L38.5348 36.9226Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M37.7098 37.5597L34.2278 40.252L37.4983 44.482L40.9804 41.7898L37.7098 37.5597Z",
                fill: "#B7B9BE"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.8362 25.8099H19.9262V25.6254C19.8271 23.5554 21.0019 21.3142 22.6724 20.3969L22.7036 20.3804C22.7489 20.3569 22.7925 20.3295 22.8349 20.3014C23.7464 19.7136 24.2651 18.7018 24.2332 17.5871C24.2014 16.4827 23.6315 15.5115 22.7088 14.9899C22.1258 14.66 21.4759 14.4858 20.8286 14.4858C18.8581 14.4858 17.2549 16.1002 17.2549 18.0846H14.3442C14.3442 14.4848 17.2529 11.5557 20.8282 11.5557C21.9739 11.5557 23.1168 11.8598 24.1338 12.435C25.9556 13.4653 27.0802 15.3598 27.1416 17.5028C27.2036 19.6555 26.184 21.622 24.4151 22.7627C24.2963 22.8408 24.1748 22.9132 24.0547 22.9763C23.3611 23.366 22.7804 24.566 22.8339 25.5038L22.8362 25.8102V25.8099Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.0997 27.4903C21.2463 27.4658 21.4063 27.4512 21.5703 27.4512C21.7092 27.4512 21.8667 27.4593 22.0325 27.4874C22.9812 27.6431 23.7528 28.3085 23.9401 29.3445L23.9415 29.3524L23.9428 29.3602C23.9669 29.5047 23.9819 29.662 23.9819 29.8279C23.9819 29.9928 23.9671 30.1521 23.9417 30.2991L23.9412 30.3021C23.7578 31.3491 22.9743 32.012 22.0294 32.166C21.8661 32.193 21.7139 32.2017 21.5703 32.2017C21.4035 32.2017 21.248 32.1865 21.1057 32.1636L21.1051 32.1635C20.1555 32.0098 19.3803 31.3454 19.1919 30.3095L19.1904 30.3011L19.189 30.2927C19.1653 30.1504 19.1499 29.9958 19.1499 29.8279C19.1499 29.662 19.1649 29.5047 19.189 29.3602L19.1904 29.3518L19.1919 29.3434C19.3812 28.3027 20.1594 27.6479 21.0986 27.4905L21.0997 27.4903Z",
                fill: "#DDDEE1"
            })
        ]
    });

});


parcelRegister("iaJvq", function(module, exports) {
$parcel$export(module.exports, "FastshiftTablePagination", function () { return (parcelRequire("6vd2N")).FastshiftTablePagination; });

var $6vd2N = parcelRequire("6vd2N");

});
parcelRegister("6vd2N", function(module, exports) {
$parcel$export(module.exports, "FastshiftTablePagination", function () { return $b3f6de373a3582f0$export$371a8aee6982c805; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $1HVQz = parcelRequire("1HVQz");

var $kMnBu = parcelRequire("kMnBu");
var $i99jD = parcelRequire("i99jD");

var $5RBBI = parcelRequire("5RBBI");

var $g3ExX = parcelRequire("g3ExX");
var $fmW7P = parcelRequire("fmW7P");
var $79ZK0 = parcelRequire("79ZK0");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");

var $eh9Uj = parcelRequire("eh9Uj");

var $fBPEM = parcelRequire("fBPEM");
const $b3f6de373a3582f0$var$paginationSectionStyles = (0, $f6YGh.xcss)({
    borderColor: "color.border",
    borderWidth: "1px",
    borderRadius: "border.radius.100",
    borderStartStartRadius: "0",
    borderStartEndRadius: "0",
    borderBlockStart: "0",
    borderStyle: "solid",
    padding: "space.150"
});
const $b3f6de373a3582f0$export$371a8aee6982c805 = ({ pagination: pagination })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $fmW7P.default), {
        justifyContent: "space-between",
        alignItems: "center",
        xcss: $b3f6de373a3582f0$var$paginationSectionStyles,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                alignBlock: "center",
                alignInline: "center",
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                        color: "color.text.subtle",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $fBPEM.messages).resultsPerPageLabel))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                        style: {
                            width: "80px"
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kMnBu.default), {
                            // This is atlaskit's recommended pattern for custom trigger components
                            // eslint-disable-next-line react/no-unstable-nested-components
                            trigger: (_param)=>{
                                var { triggerRef: triggerRef } = _param, providedProps = (0, $aPnCa._)(_param, [
                                    "triggerRef"
                                ]);
                                return /*#__PURE__*/ (0, $7VQPk.jsx)($b3f6de373a3582f0$var$DropdownMenuTrigger, (0, $dPABA._)((0, $6ogO3._)({
                                    triggerRef: triggerRef
                                }, providedProps), {
                                    pagination: pagination
                                }));
                            },
                            shouldRenderToParent: true,
                            spacing: "compact",
                            children: (0, $eh9Uj.PAGE_SIZE_OPTIONS).map((option)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $i99jD.default), {
                                    onClick: ()=>{
                                        pagination.onSizeChange(option.value);
                                    },
                                    isSelected: option.value === pagination.size,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                        children: option.label
                                    })
                                }, option.value))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $79ZK0.default), {
                spread: "space-between",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                    alignBlock: "center",
                    alignInline: "center",
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                            color: "color.text.subtle",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $fBPEM.messages).resultsCountText), {
                                values: {
                                    startIndex: pagination.totalElements === 0 ? 0 : pagination.page * pagination.size + 1,
                                    endIndex: pagination.totalElements === 0 ? 0 : Math.min((pagination.page + 1) * pagination.size, pagination.totalElements),
                                    totalCount: pagination.totalElements
                                }
                            }))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), {
                            onClick: pagination.onClickPrevious,
                            spacing: "compact",
                            isDisabled: !pagination.hasPrevious,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $fBPEM.messages).previousButton))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), {
                            onClick: pagination.onClickNext,
                            spacing: "compact",
                            isDisabled: !pagination.hasNext,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $fBPEM.messages).nextButton))
                        })
                    ]
                })
            })
        ]
    });
};
const $b3f6de373a3582f0$var$DropdownMenuTrigger = (_param)=>{
    var { triggerRef: triggerRef, pagination: pagination } = _param, providedProps = (0, $aPnCa._)(_param, [
        "triggerRef",
        "pagination"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), (0, $dPABA._)((0, $6ogO3._)({
        ref: triggerRef
    }, providedProps), {
        spacing: "compact",
        onClick: (e)=>{
            var // sendClickDropdownEvent();
            _providedProps_onClick;
            (_providedProps_onClick = providedProps.onClick) === null || _providedProps_onClick === void 0 ? void 0 : _providedProps_onClick.call(providedProps, e);
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
            space: "space.100",
            alignInline: "center",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                    children: pagination.size
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))), {
                    label: "Chevron down icon",
                    size: "small"
                })
            ]
        })
    }));
};

});
parcelRegister("fBPEM", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $a354bf4010dcb980$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $a354bf4010dcb980$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    resultsPerPageLabel: {
        id: "fastshift.customer-selection.domain-selection-table.results-per-page-label",
        defaultMessage: "Results per page:",
        description: "Label for results per page dropdown"
    },
    resultsCountText: {
        id: "fastshift.customer-selection.domain-selection-table.results-count-text",
        defaultMessage: "{startIndex}-{endIndex} of {totalCount} results",
        description: "Text showing current page results count"
    },
    previousButton: {
        id: "fastshift.customer-selection.domain-selection-table.previous-button",
        defaultMessage: "Previous",
        description: "Previous page button text"
    },
    nextButton: {
        id: "fastshift.customer-selection.domain-selection-table.next-button",
        defaultMessage: "Next",
        description: "Next page button text"
    }
});

});



parcelRegister("2MBb4", function(module, exports) {
$parcel$export(module.exports, "FastshiftTableSearch", function () { return (parcelRequire("2N0OI")).FastshiftTableSearch; });

var $2N0OI = parcelRequire("2N0OI");

});
parcelRegister("2N0OI", function(module, exports) {
$parcel$export(module.exports, "FastshiftTableSearch", function () { return $d62777c1822d1a2d$export$337fb2e9ac52585b; });
/* fastshift-table-search.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $yagHz = parcelRequire("yagHz");

var $8e22h = parcelRequire("8e22h");

var $bZmYH = parcelRequire("bZmYH");

var $fmW7P = parcelRequire("fmW7P");
var $2YtGy = parcelRequire("2YtGy");
var $f6YGh = parcelRequire("f6YGh");

var $8KJ2x = parcelRequire("8KJ2x");

var $6yUs8 = parcelRequire("6yUs8");
const $d62777c1822d1a2d$var$searchIconContainerStyles = (0, $f6YGh.xcss)({
    paddingInlineStart: "space.100"
});
const $d62777c1822d1a2d$var$searchInputContainerStyles = null;
const $d62777c1822d1a2d$export$337fb2e9ac52585b = ({ search: search, id: id = "fastshift-table-search", testId: testId = "fastshift-table-search" })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { onSetSearchTerm: onSetSearchTerm, searchTerm: searchTerm } = search;
    const [inputValue, setInputValue] = (0, $1oC0p.useState)(searchTerm);
    (0, $1oC0p.useEffect)(()=>{
        setInputValue(searchTerm);
    }, [
        searchTerm
    ]);
    const debouncedSetSearchTerm = (0, $1oC0p.useMemo)(()=>(0, $yagHz.debounce)((value)=>onSetSearchTerm(value), 500), [
        onSetSearchTerm
    ]);
    (0, $1oC0p.useEffect)(()=>{
        return ()=>{
            debouncedSetSearchTerm.cancel();
        };
    }, [
        debouncedSetSearchTerm
    ]);
    const handleInputChange = (0, $1oC0p.useCallback)((event)=>{
        const value = event.target.value;
        setInputValue(value);
        debouncedSetSearchTerm(value);
    }, [
        debouncedSetSearchTerm
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2YtGy.default), {
        space: "space.200",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1bsbuuw1 _zt0yzgxb _rfga1ul9"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                appearance: "standard",
                id: `${id}-input`,
                testId: `${testId}-input`,
                placeholder: formatMessage((0, $6yUs8.messages).searchPlaceholder),
                onChange: handleInputChange,
                value: inputValue,
                elemBeforeInput: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fmW7P.default), {
                    xcss: $d62777c1822d1a2d$var$searchIconContainerStyles,
                    alignItems: "center",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bZmYH))), {
                        label: formatMessage((0, $6yUs8.messages).searchLabel),
                        size: "medium"
                    })
                })
            })
        })
    });
};

});
parcelRegister("6yUs8", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $5cf1c2f88051f23d$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $5cf1c2f88051f23d$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    searchPlaceholder: {
        id: "fastshift.customer-selection.domain-selection-table-search.search-placeholder",
        defaultMessage: "Search",
        description: "Placeholder for the search input"
    },
    searchLabel: {
        id: "fastshift.customer-selection.domain-selection-table-search.search-label",
        defaultMessage: "Search",
        description: "Label for the search input"
    }
});

});



parcelRegister("fZEv5", function(module, exports) {
$parcel$export(module.exports, "FastshiftTableWrapper", function () { return (parcelRequire("0xGy7")).FastshiftTableWrapper; });

var $0xGy7 = parcelRequire("0xGy7");

});
parcelRegister("0xGy7", function(module, exports) {
$parcel$export(module.exports, "FastshiftTableWrapper", function () { return $53f4686fa8872818$export$aca5068f6432850d; });
/* fastshift-table-wrapper.tsx generated by @compiled/babel-plugin v0.28.8 */ // Dynamic table is not composable currently, this is an override similar to AdminHub's TableWrapper
// We may make this generic for additional tables across Fastshift.
/* eslint-disable-next-line local/no-block-disable-of-nested-eslint */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $53f4686fa8872818$var$StyledFastshiftTableWrapper = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $aPnCa._)(_param, [
        "as",
        "style"
    ]);
    const { enableRowClick: enableRowClick } = __cmplp, __cmpldp = (0, $aPnCa._)(__cmplp, [
        "enableRowClick"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, (0, $dPABA._)((0, $6ogO3._)({}, __cmpldp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_7yjtidpf _ldgnidpf _un3pidpf _29hzidpf _r8iguia5 _v5rg1wug _r93f1y44 _tuer1y44 _1nnouia5 _1pkkuia5 _i4czuia5 _tg9f1wug _f8001osq _1eax15ls _1lmscfaq _kdhhuia5 _7fn31ylp _1esuu2gc _1ngwu2gc _1d28t94y _1vtcuia5 _6vjynkob _1y73azsu _vejeglyw _1450xh9o _1w801ylp _1a0zuia5 _1x7iglyw _2jlbuia5 _w7vcglyw _1uq6glyw _80tlu2gc _u0xiu2gc _g3wlu2gc _1whbu2gc",
            __cmplp.enableRowClick ? "_1ntttlke" : "_1ntt1wug",
            __cmplp.className
        ])
    }));
});
const $53f4686fa8872818$export$aca5068f6432850d = ({ children: children, id: id = "fastshift-table-wrapper", testId: testId = "fastshift-table-wrapper", enableRowClick: enableRowClick = false })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($53f4686fa8872818$var$StyledFastshiftTableWrapper, {
        "data-testid": testId,
        id: id,
        enableRowClick: enableRowClick,
        children: children
    });
};

});


parcelRegister("eQxC1", function(module, exports) {
$parcel$export(module.exports, "useFastshiftTableAnalytics", function () { return (parcelRequire("dlnus")).useFastshiftTableAnalytics; });
$parcel$export(module.exports, "useFastshiftTableControls", function () { return (parcelRequire("cUZmH")).useFastshiftTableControls; });

var $dlnus = parcelRequire("dlnus");
parcelRequire("ahQDs");
var $cUZmH = parcelRequire("cUZmH");

});
parcelRegister("dlnus", function(module, exports) {
$parcel$export(module.exports, "useFastshiftTableAnalytics", function () { return $d917cfc624499811$export$2addd2cd93f089b7; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
const $d917cfc624499811$var$TABLE_EVENT_TYPE = {
    SEARCH: "search",
    PAGE_SIZE: "pageSize",
    SORT: "sort",
    NAVIGATION: "navigation"
};
const $d917cfc624499811$var$getActionSubjectIdBySource = (source, eventType)=>{
    var _mapping_source;
    const mapping = {
        [(0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_SELECTION_SCREEN]: {
            [$d917cfc624499811$var$TABLE_EVENT_TYPE.SEARCH]: (0, $3cXzX.ActionSubjectIdKey).DOMAIN_SELECTION_TABLE_SEARCH,
            [$d917cfc624499811$var$TABLE_EVENT_TYPE.PAGE_SIZE]: (0, $3cXzX.ActionSubjectIdKey).SELECTION_TABLE_CHANGE_PAGE_SIZE_DROPDOWN_ITEM,
            [$d917cfc624499811$var$TABLE_EVENT_TYPE.SORT]: (0, $3cXzX.ActionSubjectIdKey).SELECTION_TABLE_COLUMN_SORT,
            [$d917cfc624499811$var$TABLE_EVENT_TYPE.NAVIGATION]: (0, $3cXzX.ActionSubjectIdKey).SELECTION_TABLE_PAGE_NAVIGATION_BUTTON
        },
        [(0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_MIGRATION_TICKETS_SCREEN]: {
            [$d917cfc624499811$var$TABLE_EVENT_TYPE.SEARCH]: (0, $3cXzX.ActionSubjectIdKey).MIGRATION_TICKETS_TABLE_SEARCH,
            [$d917cfc624499811$var$TABLE_EVENT_TYPE.PAGE_SIZE]: (0, $3cXzX.ActionSubjectIdKey).MIGRATION_TICKETS_TABLE_CHANGE_PAGE_SIZE_DROPDOWN_ITEM,
            [$d917cfc624499811$var$TABLE_EVENT_TYPE.NAVIGATION]: (0, $3cXzX.ActionSubjectIdKey).MIGRATION_TICKETS_TABLE_PAGE_NAVIGATION_BUTTON
        }
    };
    return (_mapping_source = mapping[source]) === null || _mapping_source === void 0 ? void 0 : _mapping_source[eventType];
};
const $d917cfc624499811$export$2addd2cd93f089b7 = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)(true);
    const { fireUIEvent: fireUIEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    const sendSearchUIEvent = (0, $1oC0p.useCallback)(()=>{
        const actionSubjectId = $d917cfc624499811$var$getActionSubjectIdBySource(sourceKey, $d917cfc624499811$var$TABLE_EVENT_TYPE.SEARCH);
        if (!actionSubjectId) return;
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).SUBMITTED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).SEARCH,
            actionSubjectId: actionSubjectId,
            source: sourceKey
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendNavigationUIEvent = (0, $1oC0p.useCallback)((buttonType, totalPages)=>{
        const actionSubjectId = $d917cfc624499811$var$getActionSubjectIdBySource(sourceKey, $d917cfc624499811$var$TABLE_EVENT_TYPE.NAVIGATION);
        if (!actionSubjectId) return;
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).BUTTON,
            actionSubjectId: actionSubjectId,
            source: sourceKey,
            attributes: {
                buttonType: buttonType,
                totalPages: totalPages
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendPageSizeChangeUIEvent = (0, $1oC0p.useCallback)((newPageSize)=>{
        const actionSubjectId = $d917cfc624499811$var$getActionSubjectIdBySource(sourceKey, $d917cfc624499811$var$TABLE_EVENT_TYPE.PAGE_SIZE);
        if (!actionSubjectId) return;
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).DROPDOWN_ITEM,
            actionSubjectId: actionSubjectId,
            source: sourceKey,
            attributes: {
                newPageSize: newPageSize
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendSortUIEvent = (0, $1oC0p.useCallback)((column, direction)=>{
        const actionSubjectId = $d917cfc624499811$var$getActionSubjectIdBySource(sourceKey, $d917cfc624499811$var$TABLE_EVENT_TYPE.SORT);
        if (!actionSubjectId) return;
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).TABLE_COLUMN_SORT,
            actionSubjectId: actionSubjectId,
            source: sourceKey,
            attributes: {
                columnTitle: column,
                sortType: direction
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    return {
        sendSearchUIEvent: sendSearchUIEvent,
        sendNavigationUIEvent: sendNavigationUIEvent,
        sendPageSizeChangeUIEvent: sendPageSizeChangeUIEvent,
        sendSortUIEvent: sendSortUIEvent
    };
};

});

parcelRegister("ahQDs", function(module, exports) {
$parcel$export(module.exports, "useFastshiftTableControls", function () { return (parcelRequire("cUZmH")).useFastshiftTableControls; });

var $cUZmH = parcelRequire("cUZmH");

});
parcelRegister("cUZmH", function(module, exports) {
$parcel$export(module.exports, "useFastshiftTableControls", function () { return $f76d2b69b20e88e3$export$5b9b8621863ff48f; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $1oC0p = parcelRequire("1oC0p");
const $f76d2b69b20e88e3$export$5b9b8621863ff48f = ({ pagination: pagination, controls: controls, onSetControlsPayload: onSetControlsPayload, enableSearch: enableSearch = false })=>{
    // Local state
    const searchTerm = (controls === null || controls === void 0 ? void 0 : controls.searchTerm) || "";
    const onClickNext = (0, $1oC0p.useCallback)(()=>{
        onSetControlsPayload((0, $dPABA._)((0, $6ogO3._)({}, controls), {
            page: pagination.page + 1
        }));
    }, [
        onSetControlsPayload,
        pagination.page,
        controls
    ]);
    const onClickPrevious = (0, $1oC0p.useCallback)(()=>{
        onSetControlsPayload((0, $dPABA._)((0, $6ogO3._)({}, controls), {
            page: pagination.page - 1
        }));
    }, [
        onSetControlsPayload,
        pagination.page,
        controls
    ]);
    const onSizeChange = (0, $1oC0p.useCallback)((size)=>{
        onSetControlsPayload((0, $dPABA._)((0, $6ogO3._)({}, controls), {
            page: 0,
            size: size
        }));
    }, [
        onSetControlsPayload,
        controls
    ]);
    const onSort = (0, $1oC0p.useCallback)((key, order)=>{
        if (!onSetControlsPayload) return;
        onSetControlsPayload((0, $dPABA._)((0, $6ogO3._)({}, controls), {
            page: 0,
            sortBy: key,
            sortDirection: order
        }));
    }, [
        onSetControlsPayload,
        controls
    ]);
    const onSetSearchTerm = (0, $1oC0p.useCallback)((searchTerm)=>{
        if (!enableSearch) return;
        onSetControlsPayload((0, $dPABA._)((0, $6ogO3._)({}, controls), {
            page: 0,
            searchTerm: searchTerm
        }));
    }, [
        enableSearch,
        onSetControlsPayload,
        controls
    ]);
    return {
        pagination: (0, $6ogO3._)({
            onClickNext: onClickNext,
            onClickPrevious: onClickPrevious,
            onSizeChange: onSizeChange
        }, pagination),
        sorting: {
            onSort: onSort,
            sortBy: controls === null || controls === void 0 ? void 0 : controls.sortBy,
            sortDirection: controls === null || controls === void 0 ? void 0 : controls.sortDirection
        },
        search: enableSearch ? {
            onSetSearchTerm: onSetSearchTerm,
            searchTerm: searchTerm
        } : null
    };
};

});



parcelRegister("gQY0i", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $c5a197b303dea06b$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $c5a197b303dea06b$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    emptyTableMessage: {
        id: "fastshift.table.empty-table-message",
        defaultMessage: "We couldn\u2019t find what you\u2019re looking for.",
        description: "Message for empty table"
    }
});

});


parcelRegister("bF9Q8", function(module, exports) {
$parcel$export(module.exports, "FastshiftTableFilterDropdown", function () { return (parcelRequire("c9epK")).FastshiftTableFilterDropdown; });

var $c9epK = parcelRequire("c9epK");

});
parcelRegister("c9epK", function(module, exports) {
$parcel$export(module.exports, "FastshiftTableFilterDropdown", function () { return $7ea0f6d0894d50dc$export$bbe6c26c1bb8a42e; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $1HVQz = parcelRequire("1HVQz");

var $kMnBu = parcelRequire("kMnBu");
var $aKsx2 = parcelRequire("aKsx2");

var $5RBBI = parcelRequire("5RBBI");

var $g3ExX = parcelRequire("g3ExX");
var $f6YGh = parcelRequire("f6YGh");

var $htKr5 = parcelRequire("htKr5");
const $7ea0f6d0894d50dc$var$labelStyle = (0, $f6YGh.xcss)({
    marginInlineEnd: "space.100",
    display: "inline-block"
});
const $7ea0f6d0894d50dc$var$DropdownTrigger = (_param)=>{
    var { label: label, onClick: onClick, isSelected: isSelected, triggerRef: triggerRef } = _param, rest = (0, $aPnCa._)(_param, [
        "label",
        "onClick",
        "isSelected",
        "triggerRef"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1HVQz.default), (0, $dPABA._)((0, $6ogO3._)({}, rest), {
        ref: triggerRef,
        onClick: onClick,
        isSelected: isSelected,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                xcss: $7ea0f6d0894d50dc$var$labelStyle,
                children: label
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))), {
                label: "Chevron down icon",
                size: "small"
            })
        ]
    }));
};
const $7ea0f6d0894d50dc$export$bbe6c26c1bb8a42e = ({ label: label, options: options, customOptionContent: customOptionContent, onOptionClick: onOptionClick })=>{
    const [selectedOption, setSelectedOption] = (0, $1oC0p.useState)(null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kMnBu.default), {
        trigger: (props)=>$7ea0f6d0894d50dc$var$DropdownTrigger((0, $dPABA._)((0, $6ogO3._)({}, props), {
                label: selectedOption ? customOptionContent ? customOptionContent(selectedOption) : selectedOption.label : label,
                isSelected: !!selectedOption
            })),
        spacing: "compact",
        shouldRenderToParent: true,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aKsx2.default), {
            children: options.map((option)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $htKr5.FastshiftTableFilterDropdownItem), {
                    option: option,
                    onClick: ()=>{
                        setSelectedOption(option);
                        onOptionClick === null || onOptionClick === void 0 ? void 0 : onOptionClick(option);
                    },
                    isSelected: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === option.value,
                    customContent: customOptionContent ? customOptionContent(option) : undefined
                }, option.value))
        })
    });
};

});
parcelRegister("htKr5", function(module, exports) {
$parcel$export(module.exports, "FastshiftTableFilterDropdownItem", function () { return $21e567f90e630270$export$73fcdc8d31c22d75; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $i99jD = parcelRequire("i99jD");

var $lPRxe = parcelRequire("lPRxe");
const $21e567f90e630270$export$73fcdc8d31c22d75 = ({ option: option, onClick: onClick, isSelected: isSelected, customContent: customContent })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i99jD.default), {
        onClick: onClick,
        isSelected: isSelected,
        children: customContent !== null && customContent !== void 0 ? customContent : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
            children: option.label
        })
    });
};

});




parcelRegister("hjtkK", function(module, exports) {
$parcel$export(module.exports, "useCustomerSelectionPageAnalytics", function () { return (parcelRequire("hApyR")).useCustomerSelectionPageAnalytics; });
$parcel$export(module.exports, "useCustomerSelectionUIAnalytics", function () { return (parcelRequire("ayOuq")).useCustomerSelectionUIAnalytics; });

var $hApyR = parcelRequire("hApyR");

var $ayOuq = parcelRequire("ayOuq");

});
parcelRegister("hApyR", function(module, exports) {
$parcel$export(module.exports, "useCustomerSelectionPageAnalytics", function () { return $c916118259a4bb36$export$659ed48541bfb328; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");
const $c916118259a4bb36$export$659ed48541bfb328 = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)();
    const { data: customerDomains, pending: customerDomainsPending } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomains);
    const { fireScreenEvent: fireScreenEvent, fireTrackEvent: fireTrackEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    // Screen event
    (0, $1oC0p.useEffect)(()=>{
        if (!identityAttrs) return;
        fireScreenEvent({
            name: (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_SELECTION_SCREEN
        });
    }, [
        fireScreenEvent,
        identityAttrs
    ]);
    // Track event
    (0, $1oC0p.useEffect)(()=>{
        if (!identityAttrs || !customerDomains || customerDomainsPending) return;
        fireTrackEvent({
            action: (0, $3cXzX.ActionKey).DISPLAYED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).SECTION,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).SELECTION_PAGE_DETAILS,
            source: sourceKey,
            attributes: {
                customerDomainCount: customerDomains.data.length
            }
        });
    }, [
        fireTrackEvent,
        identityAttrs,
        customerDomains,
        customerDomainsPending,
        sourceKey
    ]);
};

});

parcelRegister("ayOuq", function(module, exports) {
$parcel$export(module.exports, "useCustomerSelectionUIAnalytics", function () { return $095b8fc918c3d7f9$export$2e1db01705171632; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
const $095b8fc918c3d7f9$export$2e1db01705171632 = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)();
    const { fireUIEvent: fireUIEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    // UI event callbacks
    const sendSeeDetailsClickUIEvent = (0, $1oC0p.useCallback)((selectedCustomerDomain, selectedCustomerDomainId)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).LINK,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).SEE_DETAILS_BUTTON,
            source: sourceKey,
            attributes: {
                selectedCustomerDomain: selectedCustomerDomain,
                selectedCustomerDomainId: selectedCustomerDomainId
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    return {
        sendSeeDetailsClickUIEvent: sendSeeDetailsClickUIEvent
    };
};

});


parcelRegister("45I4V", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $48053c9e655297f9$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $48053c9e655297f9$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    customerColumnTitle: {
        id: "fastshift.customer-selection.domain-selection-table.customer-column-title",
        defaultMessage: "Customer",
        description: "Column title for customer name in domain selection table"
    },
    customerDomainColumnTitle: {
        id: "fastshift.customer-selection.domain-selection-table.customer-domain-column-title",
        defaultMessage: "Customer domain",
        description: "Column title for customer domain in domain selection table"
    },
    rollUpStatusColumnTitle: {
        id: "fastshift.customer-selection.domain-selection-table.roll-up-status-column-title",
        defaultMessage: "Status",
        description: "Column title for the roll up status in domain selection table"
    },
    actionsColumnTitle: {
        id: "fastshift.customer-selection.domain-selection-table.actions-column-title",
        defaultMessage: "Actions",
        description: "Column title for actions in domain selection table"
    },
    seeDetailsButton: {
        id: "fastshift.customer-selection.domain-selection-table.see-details-button",
        defaultMessage: "View details",
        description: "Button text for viewing customer details"
    },
    summaryText: {
        id: "fastshift.customer-selection.domain-selection-table.summary-text",
        defaultMessage: "Showing {viewSize} out of {totalNumber} customers",
        description: "Summary text for domain selection table"
    },
    errorMessage: {
        id: "fastshift.customer-selection.domain-selection-table.error-message",
        defaultMessage: "We\u2019re unable to retrieve the data about your customers.",
        description: "Error message for domain selection table"
    },
    statusFilterDropdownLabel: {
        id: "fastshift.customer-selection.domain-selection-table.status-filter-dropdown-label",
        defaultMessage: "Status",
        description: "Label for status filter dropdown"
    }
});

});

parcelRegister("7kNfV", function(module, exports) {
$parcel$export(module.exports, "useDomainSelectionTable", function () { return (parcelRequire("2Ciyk")).useDomainSelectionTable; });

var $2Ciyk = parcelRequire("2Ciyk");

});
parcelRegister("2Ciyk", function(module, exports) {
$parcel$export(module.exports, "useDomainSelectionTable", function () { return $80ae83baec97f406$export$6add7dfbb40ea047; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $j2t2h = parcelRequire("j2t2h");

var $1HVQz = parcelRequire("1HVQz");

var $dTJrO = parcelRequire("dTJrO");

var $a7XVW = parcelRequire("a7XVW");

var $gcfBV = parcelRequire("gcfBV");

var $g3ExX = parcelRequire("g3ExX");
var $79ZK0 = parcelRequire("79ZK0");
var $lPRxe = parcelRequire("lPRxe");

var $hLJF4 = parcelRequire("hLJF4");
parcelRequire("iTGju");
var $bh3Fv = parcelRequire("bh3Fv");

var $fq4go = parcelRequire("fq4go");
parcelRequire("jtpMK");
var $lmgkB = parcelRequire("lmgkB");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
parcelRequire("hjtkK");
var $ayOuq = parcelRequire("ayOuq");

var $45I4V = parcelRequire("45I4V");
const $80ae83baec97f406$export$6add7dfbb40ea047 = ()=>{
    const isRollUpStatusEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).sxpFastshiftPortalEnableRollUpStatus);
    const { getPathByDomainId: getPathByDomainId } = (0, $bh3Fv.useRoutes)();
    const { pending: customerDomainsPending, data: customerDomainsData, error: customerDomainsError } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomains);
    const navigate = (0, $j2t2h.useNavigate)();
    const { sendSeeDetailsClickUIEvent: sendSeeDetailsClickUIEvent } = (0, $ayOuq.useCustomerSelectionUIAnalytics)();
    const head = {
        cells: [
            {
                key: "customerName",
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                    size: "xxsmall",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $45I4V.messages).customerColumnTitle))
                }),
                width: 40,
                isSortable: true
            },
            {
                key: "customerDomain",
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                    size: "xxsmall",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $45I4V.messages).customerDomainColumnTitle))
                }),
                width: 40,
                isSortable: true
            },
            ...isRollUpStatusEnabled ? [
                {
                    key: "status",
                    content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                        size: "xxsmall",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $45I4V.messages).rollUpStatusColumnTitle))
                    }),
                    width: 20,
                    isSortable: true
                }
            ] : [],
            {
                key: "actions",
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $79ZK0.default), {
                    alignInline: "end",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                        size: "xxsmall",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $45I4V.messages).actionsColumnTitle))
                    })
                }),
                width: 20
            }
        ]
    };
    const rows = customerDomainsData.data.map((customer)=>{
        const domainScopedOverviewPath = getPathByDomainId((0, $fq4go.FASTSHIFT_PATHS)[(0, $fq4go.FASTSHIFT_PATH_KEYS).OVERVIEW], customer.customerDomainId || "");
        return {
            key: customer.customerDomainId,
            cells: [
                {
                    key: "customerName",
                    content: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a7XVW.default), {
                                src: customer.customerLogoUrl,
                                alt: `${customer.customerName} logo`,
                                style: {
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "3px"
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                size: "medium",
                                children: customer.customerName
                            })
                        ]
                    })
                },
                {
                    key: "customerDomain",
                    content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $79ZK0.default), {
                        space: "space.100",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                            children: customer.customerDomain
                        })
                    })
                },
                ...isRollUpStatusEnabled ? [
                    {
                        key: "status",
                        content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                            as: "span",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hLJF4.default), {
                                content: customer.overallStatus,
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gcfBV.default), {
                                    appearance: (0, $lmgkB.getStatusColor)(customer.overallStatus),
                                    isBold: true,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $lmgkB.getStatusText)(customer.overallStatus)))
                                })
                            })
                        })
                    }
                ] : [],
                {
                    key: "actions",
                    content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $79ZK0.default), {
                        alignInline: "end",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), {
                            appearance: "default",
                            spacing: "compact",
                            isDisabled: !domainScopedOverviewPath,
                            onClick: ()=>{
                                if (domainScopedOverviewPath) {
                                    sendSeeDetailsClickUIEvent(customer.customerDomain, customer.customerDomainId);
                                    navigate(domainScopedOverviewPath);
                                }
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $45I4V.messages).seeDetailsButton))
                        })
                    })
                }
            ]
        };
    });
    return {
        isTableLoading: customerDomainsPending,
        isTableError: !!customerDomainsError,
        rows: rows,
        head: head,
        pagination: customerDomainsData.pagination
    };
};

});
parcelRegister("a7XVW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $75f90c60affc9687$export$2e2bcd8739ae039; });

var $6AOly = parcelRequire("6AOly");

var $cAyDV = parcelRequire("cAyDV");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $agL8Z = parcelRequire("agL8Z");

var $kGkNR = parcelRequire("kGkNR");
var $75f90c60affc9687$var$_excluded = [
    "src",
    "srcDark",
    "alt",
    "testId"
];
var $75f90c60affc9687$var$baseImageStyles = (0, $3dJ4i.css)({
    maxWidth: '100%',
    height: 'auto'
});
var $75f90c60affc9687$var$themedImageStyles = (0, $3dJ4i.css)({
    content: "url(var(--img-source))",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'html[data-color-mode=dark] &': {
        content: "var(--img-source-dark)"
    }
});
function $75f90c60affc9687$export$2e2bcd8739ae039(_ref) {
    var src = _ref.src, srcDark = _ref.srcDark, alt = _ref.alt, testId = _ref.testId, props = (0, $cAyDV.default)(_ref, $75f90c60affc9687$var$_excluded);
    var imgRef = (0, $1oC0p.useRef)(null);
    var providedColorMode = (0, $agL8Z.UNSAFE_useColorModeForMigration)();
    var _useThemeObserver = (0, $kGkNR.default)(), observedColorMode = _useThemeObserver.colorMode;
    var colorMode = providedColorMode || observedColorMode;
    (0, $1oC0p.useEffect)(function() {
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return (0, $3dJ4i.jsx)("img", (0, $6AOly.default)({
        alt: alt,
        "data-testid": testId,
        src: src,
        style: {
            '--img-source': src,
            '--img-source-dark': srcDark || src
        },
        css: [
            $75f90c60affc9687$var$baseImageStyles,
            $75f90c60affc9687$var$themedImageStyles
        ],
        ref: imgRef
    }, props));
}

});
parcelRegister("6AOly", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4ccd28abf959361b$export$2e2bcd8739ae039; });
function $4ccd28abf959361b$export$2e2bcd8739ae039() {
    return $4ccd28abf959361b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4ccd28abf959361b$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("cAyDV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $92a3b830120bf687$export$2e2bcd8739ae039; });

var $lFh6o = parcelRequire("lFh6o");
function $92a3b830120bf687$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $lFh6o.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("lFh6o", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fc5ab16b339c1a7e$export$2e2bcd8739ae039; });
function $fc5ab16b339c1a7e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("agL8Z", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", function () { return $779ff7ce14d0154e$export$ce91654eb9fea460; });

var $6y3TW = parcelRequire("6y3TW");

var $48nxQ = parcelRequire("48nxQ");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $8McBf = parcelRequire("8McBf");
function $779ff7ce14d0154e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $779ff7ce14d0154e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $779ff7ce14d0154e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6y3TW.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $779ff7ce14d0154e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $779ff7ce14d0154e$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing'
};
var $779ff7ce14d0154e$var$ColorModeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
var $779ff7ce14d0154e$var$SetColorModeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
var $779ff7ce14d0154e$var$ThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
var $779ff7ce14d0154e$var$SetThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
function $779ff7ce14d0154e$export$ce91654eb9fea460() {
    var value = (0, $1oC0p.useContext)($779ff7ce14d0154e$var$ColorModeContext);
    return value;
}
function $779ff7ce14d0154e$export$20f3076712c8dfa() {
    var value = (0, $1oC0p.useContext)($779ff7ce14d0154e$var$ColorModeContext);
    if (!value) throw new Error('useColorMode must be used within AppProvider.');
    return value;
}
function $779ff7ce14d0154e$export$e2afe7397c3d11c7() {
    var value = (0, $1oC0p.useContext)($779ff7ce14d0154e$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
}
function $779ff7ce14d0154e$export$93d4e7f90805808f() {
    var value = (0, $1oC0p.useContext)($779ff7ce14d0154e$var$ThemeContext);
    if (!value) throw new Error('useTheme must be used within AppProvider.');
    return value;
}
function $779ff7ce14d0154e$export$501aa0dcd5527a48() {
    var value = (0, $1oC0p.useContext)($779ff7ce14d0154e$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
var $779ff7ce14d0154e$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $779ff7ce14d0154e$var$prefersDarkModeMql = $779ff7ce14d0154e$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $779ff7ce14d0154e$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $779ff7ce14d0154e$var$prefersDarkModeMql !== null && $779ff7ce14d0154e$var$prefersDarkModeMql !== void 0 && $779ff7ce14d0154e$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
function $779ff7ce14d0154e$export$d8964aec282183a3(_ref) {
    var children = _ref.children, defaultColorMode = _ref.defaultColorMode, _ref$defaultTheme = _ref.defaultTheme, _ref$defaultTheme2 = _ref$defaultTheme === void 0 ? $779ff7ce14d0154e$var$defaultThemeSettings : _ref$defaultTheme, _ref$defaultTheme2$da = _ref$defaultTheme2.dark, dark = _ref$defaultTheme2$da === void 0 ? 'dark' : _ref$defaultTheme2$da, _ref$defaultTheme2$li = _ref$defaultTheme2.light, light = _ref$defaultTheme2$li === void 0 ? 'light' : _ref$defaultTheme2$li, _ref$defaultTheme2$sp = _ref$defaultTheme2.spacing, spacing = _ref$defaultTheme2$sp === void 0 ? 'spacing' : _ref$defaultTheme2$sp, typography = _ref$defaultTheme2.typography, shape = _ref$defaultTheme2.shape;
    var _useState = (0, $1oC0p.useState)(defaultColorMode), _useState2 = (0, $48nxQ.default)(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)($779ff7ce14d0154e$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, $48nxQ.default)(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)({
        dark: dark,
        light: light,
        spacing: spacing,
        typography: typography,
        shape: shape
    }), _useState6 = (0, $48nxQ.default)(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $1oC0p.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($779ff7ce14d0154e$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $1oC0p.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $779ff7ce14d0154e$var$_objectSpread($779ff7ce14d0154e$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    (0, $1oC0p.useEffect)(function() {
        (0, $8McBf.default)($779ff7ce14d0154e$var$_objectSpread($779ff7ce14d0154e$var$_objectSpread({}, theme), {}, {
            colorMode: reconciledColorMode
        }));
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!$779ff7ce14d0154e$var$prefersDarkModeMql) return;
        var unbindListener = (0, $dH1HR.bind)($779ff7ce14d0154e$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($779ff7ce14d0154e$var$ColorModeContext.Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($779ff7ce14d0154e$var$SetColorModeContext.Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($779ff7ce14d0154e$var$ThemeContext.Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($779ff7ce14d0154e$var$SetThemeContext.Provider, {
        value: setPartialTheme
    }, children))));
}
var $779ff7ce14d0154e$export$2e2bcd8739ae039 = $779ff7ce14d0154e$export$d8964aec282183a3;

});
parcelRegister("6y3TW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4c48f1c5ed82b621$export$2e2bcd8739ae039; });

var $Q9C6b = parcelRequire("Q9C6b");
function $4c48f1c5ed82b621$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $Q9C6b.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("Q9C6b", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $09cc507bb824f661$export$2e2bcd8739ae039; });

var $jBiaT = parcelRequire("jBiaT");

var $dTZGl = parcelRequire("dTZGl");
function $09cc507bb824f661$export$2e2bcd8739ae039(t) {
    var i = (0, $dTZGl.default)(t, "string");
    return "symbol" == (0, $jBiaT.default)(i) ? i : i + "";
}

});
parcelRegister("jBiaT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e44f92299458092a$export$2e2bcd8739ae039; });
function $e44f92299458092a$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e44f92299458092a$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e44f92299458092a$export$2e2bcd8739ae039(o);
}

});

parcelRegister("dTZGl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a1f04228e49af81e$export$2e2bcd8739ae039; });

var $jBiaT = parcelRequire("jBiaT");
function $a1f04228e49af81e$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $jBiaT.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $jBiaT.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("48nxQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $302a2c47bea112ee$export$2e2bcd8739ae039; });

var $kE8IM = parcelRequire("kE8IM");

var $5Vz4G = parcelRequire("5Vz4G");

var $cyUvp = parcelRequire("cyUvp");

var $4xOt8 = parcelRequire("4xOt8");
function $302a2c47bea112ee$export$2e2bcd8739ae039(r, e) {
    return (0, $kE8IM.default)(r) || (0, $5Vz4G.default)(r, e) || (0, $cyUvp.default)(r, e) || (0, $4xOt8.default)();
}

});
parcelRegister("kE8IM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f07e4ee90c3b5025$export$2e2bcd8739ae039; });
function $f07e4ee90c3b5025$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("5Vz4G", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $450d7bae66df03c1$export$2e2bcd8739ae039; });
function $450d7bae66df03c1$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("cyUvp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $92547ddc36b31821$export$2e2bcd8739ae039; });

var $8U8N8 = parcelRequire("8U8N8");
function $92547ddc36b31821$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $8U8N8.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $8U8N8.default)(r, a) : void 0;
    }
}

});
parcelRegister("8U8N8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $67ba5f7f9b508fa3$export$2e2bcd8739ae039; });
function $67ba5f7f9b508fa3$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("4xOt8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $34f164904470581b$export$2e2bcd8739ae039; });
function $34f164904470581b$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("8McBf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $663c9475abd437c3$export$2e2bcd8739ae039; });

var $aqSjY = parcelRequire("aqSjY");

var $fypzx = parcelRequire("fypzx");

var $fDRK8 = parcelRequire("fDRK8");

var $kPEcb = parcelRequire("kPEcb");

var $hR11F = parcelRequire("hR11F");

var $e3xP1 = parcelRequire("e3xP1");

var $cKrdv = parcelRequire("cKrdv");

var $iAFIn = parcelRequire("iAFIn");

var $eJdPh = parcelRequire("eJdPh");
function $663c9475abd437c3$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $663c9475abd437c3$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $663c9475abd437c3$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $663c9475abd437c3$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $663c9475abd437c3$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $663c9475abd437c3$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $663c9475abd437c3$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, $aqSjY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fypzx))).mark(function _callee3() {
        var _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeLoader, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fypzx))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _ref2 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $kPEcb.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $kPEcb.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $kPEcb.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $kPEcb.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $kPEcb.themeStateDefaults)['shape'] : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $kPEcb.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $kPEcb.themeStateDefaults)['typography']() : _ref2$typography, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $kPEcb.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt;
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $fDRK8.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $iAFIn.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $eJdPh.loadAndAppendThemeCss); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, $aqSjY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fypzx))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($fypzx))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $hR11F.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $kPEcb.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $cKrdv.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, $aqSjY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fypzx))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($fypzx))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("ar6QM"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 10;
                    return Promise.all(loadingTasks);
                case 10:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $iAFIn.getThemeOverridePreferences)(themeState);
                    _iterator = $663c9475abd437c3$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 12;
                    _iterator.s();
                case 14:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 20;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 18;
                    return loadingStrategy(themeId);
                case 18:
                    _context3.next = 14;
                    break;
                case 20:
                    _context3.next = 25;
                    break;
                case 22:
                    _context3.prev = 22;
                    _context3.t0 = _context3["catch"](12);
                    _iterator.e(_context3.t0);
                case 25:
                    _context3.prev = 25;
                    _iterator.f();
                    return _context3.finish(25);
                case 28:
                    autoUnbind = (0, $e3xP1.default)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 30:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                12,
                22,
                25,
                28
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $663c9475abd437c3$export$2e2bcd8739ae039 = $663c9475abd437c3$var$setGlobalTheme;

});
parcelRegister("aqSjY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $79867827473be4ed$export$2e2bcd8739ae039; });
function $79867827473be4ed$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $79867827473be4ed$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $79867827473be4ed$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $79867827473be4ed$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("fypzx", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $b52dde1e6249f1a3$var$runtime = (parcelRequire("e2pXu"))();
module.exports = $b52dde1e6249f1a3$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $b52dde1e6249f1a3$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $b52dde1e6249f1a3$var$runtime;
    else Function("r", "regeneratorRuntime = r")($b52dde1e6249f1a3$var$runtime);
}

});
parcelRegister("e2pXu", function(module, exports) {

var $aAIiR = parcelRequire("aAIiR");

var $k90Xu = parcelRequire("k90Xu");

var $8uUyX = parcelRequire("8uUyX");

var $3iJ60 = parcelRequire("3iJ60");

var $87m4E = parcelRequire("87m4E");

var $fUlJ2 = parcelRequire("fUlJ2");

var $f2e3e = parcelRequire("f2e3e");
function $a385637021480a04$var$_regeneratorRuntime() {
    "use strict";
    var r = $k90Xu(), e = r.m($a385637021480a04$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $f2e3e(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $a385637021480a04$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $aAIiR(r, e);
            },
            AsyncIterator: $87m4E,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $3iJ60 : $8uUyX)(a(r), e, t, o, u);
            },
            keys: $fUlJ2,
            values: $f2e3e
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $a385637021480a04$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aAIiR", function(module, exports) {
function $7b5fa1d8730ec0c1$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $7b5fa1d8730ec0c1$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("k90Xu", function(module, exports) {

var $hbCx4 = parcelRequire("hbCx4");
function $eaa5643cfb44d4a8$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $hbCx4(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($hbCx4(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $hbCx4(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $hbCx4(u, "constructor", GeneratorFunctionPrototype), $hbCx4(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $hbCx4(GeneratorFunctionPrototype, o, "GeneratorFunction"), $hbCx4(u), $hbCx4(u, o, "Generator"), $hbCx4(u, n, function() {
        return this;
    }), $hbCx4(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $eaa5643cfb44d4a8$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $eaa5643cfb44d4a8$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hbCx4", function(module, exports) {
function $c8315a799cc0c679$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $c8315a799cc0c679$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $c8315a799cc0c679$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $c8315a799cc0c679$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $c8315a799cc0c679$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("8uUyX", function(module, exports) {

var $3iJ60 = parcelRequire("3iJ60");
function $0198b9cf7fb5fb53$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $3iJ60(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $0198b9cf7fb5fb53$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3iJ60", function(module, exports) {

var $k90Xu = parcelRequire("k90Xu");

var $87m4E = parcelRequire("87m4E");
function $267608a4f1a7f4bf$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $87m4E($k90Xu().w(r, e, t, o), n || Promise);
}
module.exports = $267608a4f1a7f4bf$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("87m4E", function(module, exports) {

var $aAIiR = parcelRequire("aAIiR");

var $hbCx4 = parcelRequire("hbCx4");
function $5e90199a509dbebc$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $aAIiR ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($hbCx4($5e90199a509dbebc$var$AsyncIterator.prototype), $hbCx4($5e90199a509dbebc$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $hbCx4(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $5e90199a509dbebc$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("fUlJ2", function(module, exports) {
function $b94cf030959b5a3a$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $b94cf030959b5a3a$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("f2e3e", function(module, exports) {

var $fwFaA = parcelRequire("fwFaA");
var $af21f12bd1016a08$var$_typeof = $fwFaA.default;
function $af21f12bd1016a08$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($af21f12bd1016a08$var$_typeof(e) + " is not iterable");
}
module.exports = $af21f12bd1016a08$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fwFaA", function(module, exports) {
function $b4d9c7a4145fad87$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $b4d9c7a4145fad87$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b4d9c7a4145fad87$var$_typeof(o);
}
module.exports = $b4d9c7a4145fad87$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("fDRK8", function(module, exports) {
$parcel$export(module.exports, "fg", function () { return $b6342fd065aae8aa$export$b40ec24ac8275656; });

var $4jakY = parcelRequire("4jakY");
function $b6342fd065aae8aa$export$ba05d765b8392e5e(flagResolver) {
    (0, $4jakY.setBooleanResolver)(flagResolver);
}
function $b6342fd065aae8aa$export$470e5c2be1411c89(name) {
    return (0, $4jakY.resolveBooleanFlag)(name);
}
function $b6342fd065aae8aa$export$b40ec24ac8275656(name) {
    return (0, $4jakY.resolveBooleanFlag)(name);
}

});
parcelRegister("4jakY", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $3230f48f40158712$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $3230f48f40158712$export$6333b6aff9fc6275; });

var $13zRV = parcelRequire("13zRV");

var $7t0tI = parcelRequire("7t0tI");
var $3230f48f40158712$var$pkgName = '@atlaskit/platform-feature-flags';
var $3230f48f40158712$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $3230f48f40158712$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $3230f48f40158712$var$ENV_ENABLE_PLATFORM_FF = $3230f48f40158712$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $3230f48f40158712$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $3230f48f40158712$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $3230f48f40158712$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $3230f48f40158712$var$ENV_ENABLE_PLATFORM_FF || $3230f48f40158712$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $3230f48f40158712$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $3230f48f40158712$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$3230f48f40158712$var$globalVar[$3230f48f40158712$export$7e41b1b2bdee3f98] = $3230f48f40158712$var$globalVar[$3230f48f40158712$export$7e41b1b2bdee3f98] || $3230f48f40158712$var$DEFAULT_PFF_GLOBAL;
function $3230f48f40158712$export$f2b591175b3e424c(resolver) {
    $3230f48f40158712$var$globalVar[$3230f48f40158712$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $3230f48f40158712$export$6333b6aff9fc6275(flagKey) {
    if ($3230f48f40158712$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $13zRV.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $3230f48f40158712$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $3230f48f40158712$var$globalVar[$3230f48f40158712$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("13zRV", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $0c51e50de5ff786a$export$1c9f709888824e05; });
var $0c51e50de5ff786a$var$_ref, $0c51e50de5ff786a$var$_process, $0c51e50de5ff786a$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $0c51e50de5ff786a$var$TESTS_MODE = ($0c51e50de5ff786a$var$_ref = (globalThis === null || globalThis === void 0 || ($0c51e50de5ff786a$var$_process = globalThis.process) === null || $0c51e50de5ff786a$var$_process === void 0 || ($0c51e50de5ff786a$var$_process = $0c51e50de5ff786a$var$_process.env) === null || $0c51e50de5ff786a$var$_process === void 0 ? void 0 : $0c51e50de5ff786a$var$_process.JEST_WORKER_ID) !== undefined, $0c51e50de5ff786a$var$_ref !== void 0) ? $0c51e50de5ff786a$var$_ref : false;
var $0c51e50de5ff786a$var$DEBUG_MODE = !$0c51e50de5ff786a$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($0c51e50de5ff786a$var$_process2 = globalThis.process) === null || $0c51e50de5ff786a$var$_process2 === void 0 || ($0c51e50de5ff786a$var$_process2 = $0c51e50de5ff786a$var$_process2.env) === null || $0c51e50de5ff786a$var$_process2 === void 0 ? void 0 : $0c51e50de5ff786a$var$_process2.NODE_ENV) !== 'production';
var $0c51e50de5ff786a$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$0c51e50de5ff786a$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("kPEcb", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", function () { return $f2a7c0145e4d36a4$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $f2a7c0145e4d36a4$export$7d43e72a58e3283f; });
$parcel$export(module.exports, "themeStateDefaults", function () { return $f2a7c0145e4d36a4$export$9aedcfa7336a207; });
$parcel$export(module.exports, "default", function () { return $f2a7c0145e4d36a4$export$2e2bcd8739ae039; });

var $fDRK8 = parcelRequire("fDRK8");
var $f2a7c0145e4d36a4$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
var $f2a7c0145e4d36a4$export$8ce7e340c74e86c5 = [
    'more',
    'no-preference',
    'auto'
];
var $f2a7c0145e4d36a4$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'light-brand-refresh',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'dark-brand-refresh',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography-adg3',
    'typography-modernized',
    'typography-refreshed'
];
var $f2a7c0145e4d36a4$export$ba8a43b83ecc69f8 = [];
var $f2a7c0145e4d36a4$export$92ba366331403db2 = [].concat($f2a7c0145e4d36a4$export$7d43e72a58e3283f, $f2a7c0145e4d36a4$export$ba8a43b83ecc69f8);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $f2a7c0145e4d36a4$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography-adg3': {
        id: 'typography-adg3',
        displayName: 'ADG3 Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Atlassian Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-typography-modernized': {
        id: 'typography-modernized',
        displayName: 'Atlassian Typography (Modernized)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-refreshed': {
        id: 'typography-refreshed',
        displayName: 'Atlassian Typography (Refreshed)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-light-brand-refresh': {
        id: 'light-brand-refresh',
        displayName: 'Light theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-dark-brand-refresh': {
        id: 'dark-brand-refresh',
        displayName: 'Dark theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    }
};
var $f2a7c0145e4d36a4$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: undefined,
    spacing: 'spacing',
    typography: function typography() {
        if ((0, $fDRK8.fg)('platform-default-typography-modernized')) return 'typography-modernized';
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $f2a7c0145e4d36a4$export$2e2bcd8739ae039 = $f2a7c0145e4d36a4$var$themeConfig;

});

parcelRegister("hR11F", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", function () { return $cff82ea5de364601$export$53031ac1ecb71f44; });
$parcel$export(module.exports, "rgbToHex", function () { return $cff82ea5de364601$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgbA", function () { return $cff82ea5de364601$export$b36dbdb4f463f05c; });
$parcel$export(module.exports, "hexToRgb", function () { return $cff82ea5de364601$export$5a544e13ad4e1fa5; });
$parcel$export(module.exports, "hexToHSL", function () { return $cff82ea5de364601$export$47ea145a83f50dc0; });
$parcel$export(module.exports, "HSLToRGB", function () { return $cff82ea5de364601$export$1ff93e992dd58bec; });
$parcel$export(module.exports, "relativeLuminanceW3C", function () { return $cff82ea5de364601$export$e770b01b744f3745; });
$parcel$export(module.exports, "getContrastRatio", function () { return $cff82ea5de364601$export$d061e26956a60b0a; });
$parcel$export(module.exports, "deltaE", function () { return $cff82ea5de364601$export$e8ddad763b4bebf9; });
// valid hex color with 6 digits
var $cff82ea5de364601$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $cff82ea5de364601$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $cff82ea5de364601$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $cff82ea5de364601$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $cff82ea5de364601$export$b36dbdb4f463f05c(hex) {
    if (!$cff82ea5de364601$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $cff82ea5de364601$export$1212645cf40ebf71(hex)
    ];
}
function $cff82ea5de364601$export$5a544e13ad4e1fa5(hex) {
    if (!$cff82ea5de364601$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $cff82ea5de364601$export$47ea145a83f50dc0(hex) {
    if (!$cff82ea5de364601$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $cff82ea5de364601$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $cff82ea5de364601$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $cff82ea5de364601$export$d061e26956a60b0a(foreground, background) {
    if (!$cff82ea5de364601$var$isValidHex(foreground) || !$cff82ea5de364601$var$isValidHex(background)) throw new Error('Invalid HEX');
    var foregroundRgb = $cff82ea5de364601$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $cff82ea5de364601$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $cff82ea5de364601$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $cff82ea5de364601$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $cff82ea5de364601$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $cff82ea5de364601$var$rgbToLab(rgbA);
    var labB = $cff82ea5de364601$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $cff82ea5de364601$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("e3xP1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a3bb94d10744af97$export$2e2bcd8739ae039; });

var $48nxQ = parcelRequire("48nxQ");

var $fDRK8 = parcelRequire("fDRK8");

var $jU0KV = parcelRequire("jU0KV");

var $jAHXM = parcelRequire("jAHXM");

var $dEvqL = parcelRequire("dEvqL");
function $a3bb94d10744af97$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $jAHXM.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $jAHXM.default).bind();
    } else (0, $jAHXM.default).unbind();
    if ((0, $fDRK8.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $dEvqL.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $dEvqL.default).bind();
        } else (0, $dEvqL.default).unbind();
    }
    var themeAttributes = (0, $jU0KV.default)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, $48nxQ.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $jAHXM.default).unbind();
        if ((0, $fDRK8.fg)('platform_increased-contrast-themes')) (0, $dEvqL.default).unbind();
    };
}

});
parcelRegister("jU0KV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e7d3d56123f76121$export$2e2bcd8739ae039; });

var $6y3TW = parcelRequire("6y3TW");

var $fDRK8 = parcelRequire("fDRK8");

var $9GwK5 = parcelRequire("9GwK5");

var $kPEcb = parcelRequire("kPEcb");

var $guzd7 = parcelRequire("guzd7");

var $hR11F = parcelRequire("hR11F");

var $amCGy = parcelRequire("amCGy");
function $e7d3d56123f76121$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e7d3d56123f76121$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e7d3d56123f76121$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6y3TW.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e7d3d56123f76121$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e7d3d56123f76121$var$defaultColorMode = 'light';
var $e7d3d56123f76121$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $e7d3d56123f76121$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _result;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $kPEcb.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $kPEcb.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $kPEcb.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $kPEcb.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $kPEcb.themeStateDefaults)['shape'] : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $kPEcb.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $kPEcb.themeStateDefaults)['typography']() : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $kPEcb.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $guzd7.themeObjectToString)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (_result = {}, (0, $6y3TW.default)(_result, (0, $9GwK5.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $6y3TW.default)(_result, (0, $9GwK5.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $e7d3d56123f76121$var$defaultColorMode : colorMode), _result);
    if ((0, $fDRK8.fg)('platform_increased-contrast-themes')) result = $e7d3d56123f76121$var$_objectSpread($e7d3d56123f76121$var$_objectSpread({}, result), {}, (0, $6y3TW.default)({}, (0, $9GwK5.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $e7d3d56123f76121$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $hR11F.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $amCGy.hash)(optionString);
        result[0, $9GwK5.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $e7d3d56123f76121$export$2e2bcd8739ae039 = $e7d3d56123f76121$var$getThemeHtmlAttrs;

});
parcelRegister("9GwK5", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $70d16f3b3e79765d$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $70d16f3b3e79765d$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $70d16f3b3e79765d$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $70d16f3b3e79765d$export$352e418ed5b6193a; });
var $70d16f3b3e79765d$export$4ef52930e33717cd = 'data-theme';
var $70d16f3b3e79765d$export$a00eac3f8684bcd0 = 'data-color-mode';
var $70d16f3b3e79765d$export$2112803007239c61 = 'data-contrast-mode';
var $70d16f3b3e79765d$export$352e418ed5b6193a = 'data-custom-theme';
var $70d16f3b3e79765d$export$2faeed762aac6741 = 'light';
var $70d16f3b3e79765d$export$6f0c6fb8c80fcc92 = 'ds';
var $70d16f3b3e79765d$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $70d16f3b3e79765d$export$dddac1532e822863 = "--".concat($70d16f3b3e79765d$export$6f0c6fb8c80fcc92, "-token-not-found");
var $70d16f3b3e79765d$export$9d7b58831ae93caa = "--".concat($70d16f3b3e79765d$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("guzd7", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", function () { return $c01ac2c4d3c727ac$export$f19b488f7c0547ee; });
$parcel$export(module.exports, "themeObjectToString", function () { return $c01ac2c4d3c727ac$export$62c37ab81302621a; });

var $jBiaT = parcelRequire("jBiaT");

var $48nxQ = parcelRequire("48nxQ");

var $kPEcb = parcelRequire("kPEcb");
var $c01ac2c4d3c727ac$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
var $c01ac2c4d3c727ac$var$customThemeOptions = 'UNSAFE_themeOptions';
var $c01ac2c4d3c727ac$var$isThemeKind = function isThemeKind(themeKind) {
    return $c01ac2c4d3c727ac$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $c01ac2c4d3c727ac$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $kPEcb.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $c01ac2c4d3c727ac$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $c01ac2c4d3c727ac$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([\s\S]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $48nxQ.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $c01ac2c4d3c727ac$var$isColorMode(id)) themeObject[kind] = id;
        if ($c01ac2c4d3c727ac$var$isThemeKind(kind) && $c01ac2c4d3c727ac$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $c01ac2c4d3c727ac$var$customThemeOptions) try {
            themeObject[$c01ac2c4d3c727ac$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $c01ac2c4d3c727ac$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, $48nxQ.default)(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $c01ac2c4d3c727ac$var$isColorMode(id) || // custom theme state
        kind === $c01ac2c4d3c727ac$var$customThemeOptions && (0, $jBiaT.default)(id) === 'object' || // other theme states
        $c01ac2c4d3c727ac$var$isThemeKind(kind) && typeof id === 'string' && $c01ac2c4d3c727ac$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, $jBiaT.default)(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});

parcelRegister("amCGy", function(module, exports) {
$parcel$export(module.exports, "hash", function () { return $78b9f795338e2e98$export$d6af199866bfb566; });
var $78b9f795338e2e98$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("jAHXM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e4337b458e21a3cc$export$2e2bcd8739ae039; });

var $kwUxy = parcelRequire("kwUxy");

var $dQ6jY = parcelRequire("dQ6jY");

var $6y3TW = parcelRequire("6y3TW");

var $dH1HR = parcelRequire("dH1HR");

var $9GwK5 = parcelRequire("9GwK5");

var $eJdPh = parcelRequire("eJdPh");
var $e4337b458e21a3cc$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $e4337b458e21a3cc$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $9GwK5.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $e4337b458e21a3cc$var$darkModeMql = $e4337b458e21a3cc$var$isMatchMediaAvailable && window.matchMedia((0, $eJdPh.darkModeMediaQuery));
var $e4337b458e21a3cc$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, $kwUxy.default)(this, ColorModeObserver);
        (0, $6y3TW.default)(this, "unbindThemeChangeListener", null);
    }
    (0, $dQ6jY.default)(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$e4337b458e21a3cc$var$darkModeMql) return 'light';
                return $e4337b458e21a3cc$var$darkModeMql !== null && $e4337b458e21a3cc$var$darkModeMql !== void 0 && $e4337b458e21a3cc$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($e4337b458e21a3cc$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $dH1HR.bind)($e4337b458e21a3cc$var$darkModeMql, {
                    type: 'change',
                    listener: $e4337b458e21a3cc$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
    return ColorModeObserver;
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $e4337b458e21a3cc$var$SingletonColorModeObserver = new $e4337b458e21a3cc$var$ColorModeObserver();
var $e4337b458e21a3cc$export$2e2bcd8739ae039 = $e4337b458e21a3cc$var$SingletonColorModeObserver;

});
parcelRegister("kwUxy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ef22a77ea37d2e19$export$2e2bcd8739ae039; });
function $ef22a77ea37d2e19$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("dQ6jY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a13508eadde68542$export$2e2bcd8739ae039; });

var $Q9C6b = parcelRequire("Q9C6b");
function $a13508eadde68542$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $Q9C6b.default)(o.key), o);
    }
}
function $a13508eadde68542$export$2e2bcd8739ae039(e, r, t) {
    return r && $a13508eadde68542$var$_defineProperties(e.prototype, r), t && $a13508eadde68542$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("eJdPh", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", function () { return $ab8ffe3f40c62d5c$export$26cd7ae85c7144e5; });
$parcel$export(module.exports, "darkModeMediaQuery", function () { return $ab8ffe3f40c62d5c$export$bb1e815119d30f8b; });
$parcel$export(module.exports, "moreContrastMediaQuery", function () { return $ab8ffe3f40c62d5c$export$8662df6937d86fcb; });

var $aqSjY = parcelRequire("aqSjY");

var $fypzx = parcelRequire("fypzx");

var $fDRK8 = parcelRequire("fDRK8");

var $b9lah = parcelRequire("b9lah");

var $9GwK5 = parcelRequire("9GwK5");
var $ab8ffe3f40c62d5c$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, $aqSjY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fypzx))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fypzx))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $9GwK5.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $9GwK5.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $ab8ffe3f40c62d5c$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $ab8ffe3f40c62d5c$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, $aqSjY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fypzx))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fypzx))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if ((themeId === 'light' || themeId === 'dark') && (0, $fDRK8.fg)('platform-component-visual-refresh')) themeId += '-brand-refresh';
                    _context2.next = 3;
                    return (0, $b9lah.default)[themeId]();
                case 3:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $ab8ffe3f40c62d5c$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $ab8ffe3f40c62d5c$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("b9lah", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $81e0f3d83dacd98d$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::8352f41e09dfe9d45ead708661744456>>
 * @codegenCommand yarn build tokens
 */ 














var $81e0f3d83dacd98d$var$themeImportsMap = {
    'light': function light() {
        return (parcelRequire("koszv"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("fR1sp"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("aPNKf"));
    },
    'dark': function dark() {
        return (parcelRequire("aUocr"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("3ctEi"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("8ZRqI"));
    },
    'legacy-light': function legacyLight() {
        return (parcelRequire("bSFKA"));
    },
    'legacy-dark': function legacyDark() {
        return (parcelRequire("6z09K"));
    },
    'spacing': function spacing() {
        return (parcelRequire("3wiFn"));
    },
    'typography-adg3': function typographyAdg3() {
        return (parcelRequire("6xjjH"));
    },
    'shape': function shape() {
        return (parcelRequire("kxbuz"));
    },
    'typography-modernized': function typographyModernized() {
        return (parcelRequire("eztJa"));
    },
    'typography-refreshed': function typographyRefreshed() {
        return (parcelRequire("7hOCb"));
    },
    'light-brand-refresh': function lightBrandRefresh() {
        return (parcelRequire("f4lI7"));
    },
    'dark-brand-refresh': function darkBrandRefresh() {
        return (parcelRequire("bCVby"));
    }
};
var $81e0f3d83dacd98d$export$2e2bcd8739ae039 = $81e0f3d83dacd98d$var$themeImportsMap;

});
parcelRegister("koszv", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("388jd")).then(()=>parcelRequire('i5wIo'));

});

parcelRegister("fR1sp", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("iKSwu")).then(()=>parcelRequire('icxng'));

});

parcelRegister("aPNKf", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("4N6tn")).then(()=>parcelRequire('gCuqo'));

});

parcelRegister("aUocr", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("gq4H5")).then(()=>parcelRequire('fbRqR'));

});

parcelRegister("3ctEi", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("3bIpC")).then(()=>parcelRequire('fUAUj'));

});

parcelRegister("8ZRqI", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("aKzO8")).then(()=>parcelRequire('6tpMz'));

});

parcelRegister("bSFKA", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("j4Gd6")).then(()=>parcelRequire('8haaF'));

});

parcelRegister("6z09K", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("jSYDT")).then(()=>parcelRequire('bfldO'));

});

parcelRegister("3wiFn", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("kLh1o")).then(()=>parcelRequire('cTbWf'));

});

parcelRegister("6xjjH", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("4Fs8X")).then(()=>parcelRequire('aSF6F'));

});

parcelRegister("kxbuz", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("apsqd")).then(()=>parcelRequire('4qtmK'));

});

parcelRegister("eztJa", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("auNKn")).then(()=>parcelRequire('5Y15z'));

});

parcelRegister("7hOCb", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("aHnAV")).then(()=>parcelRequire('fAHIy'));

});

parcelRegister("f4lI7", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("7SddD")).then(()=>parcelRequire('8A8bf'));

});

parcelRegister("bCVby", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("iMgFs")).then(()=>parcelRequire('CqFWl'));

});




parcelRegister("dEvqL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9f076441ae37864d$export$2e2bcd8739ae039; });

var $kwUxy = parcelRequire("kwUxy");

var $dQ6jY = parcelRequire("dQ6jY");

var $6y3TW = parcelRequire("6y3TW");

var $dH1HR = parcelRequire("dH1HR");

var $9GwK5 = parcelRequire("9GwK5");

var $eJdPh = parcelRequire("eJdPh");
var $9f076441ae37864d$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $9f076441ae37864d$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $9GwK5.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $9f076441ae37864d$var$contrastModeMql = $9f076441ae37864d$var$isMatchMediaAvailable && window.matchMedia((0, $eJdPh.moreContrastMediaQuery));
var $9f076441ae37864d$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, $kwUxy.default)(this, ContrastModeObserver);
        (0, $6y3TW.default)(this, "unbindContrastChangeListener", null);
    }
    (0, $dQ6jY.default)(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$9f076441ae37864d$var$contrastModeMql) return 'no-preference';
                return $9f076441ae37864d$var$contrastModeMql !== null && $9f076441ae37864d$var$contrastModeMql !== void 0 && $9f076441ae37864d$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($9f076441ae37864d$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $dH1HR.bind)($9f076441ae37864d$var$contrastModeMql, {
                    type: 'change',
                    listener: $9f076441ae37864d$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
    return ContrastModeObserver;
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $9f076441ae37864d$var$SingletonContrastModeObserver = new $9f076441ae37864d$var$ContrastModeObserver();
var $9f076441ae37864d$export$2e2bcd8739ae039 = $9f076441ae37864d$var$SingletonContrastModeObserver;

});


parcelRegister("cKrdv", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $947ee4981cb71337$export$bd1ac9300b0e885a; });
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", function () { return $947ee4981cb71337$export$e7ae172320e03461; });
$parcel$export(module.exports, "reduceTokenMap", function () { return $947ee4981cb71337$export$e673f367da2ff23e; });

var $48nxQ = parcelRequire("48nxQ");

var $k44XG = parcelRequire("k44XG");

var $hBXAc = parcelRequire("hBXAc");

var $9GwK5 = parcelRequire("9GwK5");

var $amCGy = parcelRequire("amCGy");
function $947ee4981cb71337$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $amCGy.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $9GwK5.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $9GwK5.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $947ee4981cb71337$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, $k44XG.default)(Array.from(document.head.querySelectorAll("style[".concat((0, $9GwK5.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $9GwK5.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $947ee4981cb71337$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, $48nxQ.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $hBXAc.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === 'string' ? value : themeRamp[value], ";") : acc;
    }, '');
}

});
parcelRegister("k44XG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e9b807a5a197b1ef$export$2e2bcd8739ae039; });

var $lgto8 = parcelRequire("lgto8");

var $cQnjz = parcelRequire("cQnjz");

var $cyUvp = parcelRequire("cyUvp");

var $4rNib = parcelRequire("4rNib");
function $e9b807a5a197b1ef$export$2e2bcd8739ae039(r) {
    return (0, $lgto8.default)(r) || (0, $cQnjz.default)(r) || (0, $cyUvp.default)(r) || (0, $4rNib.default)();
}

});
parcelRegister("lgto8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f7b1e381c35fbf8d$export$2e2bcd8739ae039; });

var $8U8N8 = parcelRequire("8U8N8");
function $f7b1e381c35fbf8d$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $8U8N8.default)(r);
}

});

parcelRegister("cQnjz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $959c6d2eca0ce635$export$2e2bcd8739ae039; });
function $959c6d2eca0ce635$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("4rNib", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $33cfeb7b804afcd2$export$2e2bcd8739ae039; });
function $33cfeb7b804afcd2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("hBXAc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cd241c49005a5cb5$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db26fca19e3969bcba2e77bc6fe6eb89>>
 * @codegenCommand yarn build tokens
 */ var $cd241c49005a5cb5$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.success': '--ds-text-success',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.information': '--ds-text-information',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'border.radius.050': '--ds-border-radius-050',
    'border.radius': '--ds-border-radius',
    'border.radius.100': '--ds-border-radius-100',
    'border.radius.200': '--ds-border-radius-200',
    'border.radius.300': '--ds-border-radius-300',
    'border.radius.400': '--ds-border-radius-400',
    'border.radius.circle': '--ds-border-radius-circle',
    'border.width': '--ds-border-width',
    'border.width.0': '--ds-border-width-0',
    'border.width.indicator': '--ds-border-width-indicator',
    'border.width.outline': '--ds-border-width-outline',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.letterSpacing.0': '--ds-font-letterSpacing-0',
    'font.letterSpacing.100': '--ds-font-letterSpacing-100',
    'font.letterSpacing.200': '--ds-font-letterSpacing-200',
    'font.letterSpacing.300': '--ds-font-letterSpacing-300',
    'font.letterSpacing.400': '--ds-font-letterSpacing-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.monospace': '--ds-font-family-monospace',
    'font.family.sans': '--ds-font-family-sans',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'font.size.050': '--ds-font-size-050',
    'font.size.075': '--ds-font-size-075',
    'font.size.100': '--ds-font-size-100',
    'font.size.200': '--ds-font-size-200',
    'font.size.300': '--ds-font-size-300',
    'font.size.400': '--ds-font-size-400',
    'font.size.500': '--ds-font-size-500',
    'font.size.600': '--ds-font-size-600',
    'font.lineHeight.1': '--ds-font-lineHeight-1',
    'font.lineHeight.100': '--ds-font-lineHeight-100',
    'font.lineHeight.200': '--ds-font-lineHeight-200',
    'font.lineHeight.300': '--ds-font-lineHeight-300',
    'font.lineHeight.400': '--ds-font-lineHeight-400',
    'font.lineHeight.500': '--ds-font-lineHeight-500',
    'font.lineHeight.600': '--ds-font-lineHeight-600'
};
var $cd241c49005a5cb5$export$2e2bcd8739ae039 = $cd241c49005a5cb5$var$tokens;

});


parcelRegister("iAFIn", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", function () { return $d88bf2728c90d7a8$export$dd6aeb7c823fc03d; });
$parcel$export(module.exports, "getThemeOverridePreferences", function () { return $d88bf2728c90d7a8$export$5d76d7014f4a5d08; });

var $k44XG = parcelRequire("k44XG");

var $fDRK8 = parcelRequire("fDRK8");

var $jhcfx = parcelRequire("jhcfx");
var $d88bf2728c90d7a8$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $fDRK8.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $jhcfx.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $fDRK8.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $jhcfx.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, $k44XG.default)(new Set(themePreferences));
};
var $d88bf2728c90d7a8$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, $k44XG.default)(new Set(themeOverridePreferences));
};

});
parcelRegister("jhcfx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e0891b6244123fec$export$2e2bcd8739ae039; });

var $48nxQ = parcelRequire("48nxQ");

var $kPEcb = parcelRequire("kPEcb");
function $e0891b6244123fec$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $kPEcb.default)).find(function(_ref) {
        var _ref2 = (0, $48nxQ.default)(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});


parcelRegister("ar6QM", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("2nk3e")).then(()=>parcelRequire('jaRsB'));

});



parcelRegister("kGkNR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f0e7ddfcf906dd51$export$2e2bcd8739ae039; });

var $48nxQ = parcelRequire("48nxQ");

var $1oC0p = parcelRequire("1oC0p");

var $hSUv5 = parcelRequire("hSUv5");

var $7vWhO = parcelRequire("7vWhO");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $f0e7ddfcf906dd51$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $1oC0p.useState)((0, $hSUv5.default)()), _useState2 = (0, $48nxQ.default)(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        var observer = new (0, $7vWhO.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $f0e7ddfcf906dd51$export$2e2bcd8739ae039 = $f0e7ddfcf906dd51$var$useThemeObserver;

});
parcelRegister("hSUv5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d0534e9cfd03bd74$export$2e2bcd8739ae039; });

var $6y3TW = parcelRequire("6y3TW");

var $9GwK5 = parcelRequire("9GwK5");

var $kPEcb = parcelRequire("kPEcb");

var $guzd7 = parcelRequire("guzd7");
function $d0534e9cfd03bd74$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d0534e9cfd03bd74$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d0534e9cfd03bd74$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6y3TW.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d0534e9cfd03bd74$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d0534e9cfd03bd74$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $kPEcb.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $d0534e9cfd03bd74$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $9GwK5.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $9GwK5.THEME_DATA_ATTRIBUTE)) || '';
    return $d0534e9cfd03bd74$var$_objectSpread($d0534e9cfd03bd74$var$_objectSpread({}, (0, $guzd7.themeStringToObject)(theme)), $d0534e9cfd03bd74$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $d0534e9cfd03bd74$export$2e2bcd8739ae039 = $d0534e9cfd03bd74$var$getGlobalTheme;

});

parcelRegister("7vWhO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5788a4146bc8204b$export$2e2bcd8739ae039; });

var $kwUxy = parcelRequire("kwUxy");

var $dQ6jY = parcelRequire("dQ6jY");

var $6y3TW = parcelRequire("6y3TW");

var $9GwK5 = parcelRequire("9GwK5");

var $hSUv5 = parcelRequire("hSUv5");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $5788a4146bc8204b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $kwUxy.default)(this, ThemeMutationObserver);
        (0, $6y3TW.default)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    (0, $dQ6jY.default)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $hSUv5.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $9GwK5.THEME_DATA_ATTRIBUTE),
                            (0, $9GwK5.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
    return ThemeMutationObserver;
}();
(0, $6y3TW.default)($5788a4146bc8204b$export$2e2bcd8739ae039, "observer", null);
(0, $6y3TW.default)($5788a4146bc8204b$export$2e2bcd8739ae039, "callbacks", new Set());

});







parcelRegister("6QUAv", function(module, exports) {
$parcel$export(module.exports, "FastshiftResourcesPage", function () { return (parcelRequire("5QUU6")).FastshiftResourcesPage; });

var $5QUU6 = parcelRequire("5QUU6");

});
parcelRegister("5QUU6", function(module, exports) {
$parcel$export(module.exports, "FastshiftResourcesPage", function () { return $f8604fd287622fb2$export$b08eba65734a7bc3; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");

var $dTJrO = parcelRequire("dTJrO");

var $iggFr = parcelRequire("iggFr");
var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");

var $3gCgH = parcelRequire("3gCgH");
parcelRequire("gXU9p");
var $7u9ZS = parcelRequire("7u9ZS");
parcelRequire("9Ua9k");
var $iEOeE = parcelRequire("iEOeE");

var $1m5EK = parcelRequire("1m5EK");
parcelRequire("gMMVS");
var $iutPV = parcelRequire("iutPV");
parcelRequire("5Ebnt");
var $dM6iN = parcelRequire("dM6iN");
const $f8604fd287622fb2$export$b08eba65734a7bc3 = ()=>{
    const [currentTab, setCurrentTab] = (0, $1oC0p.useState)((0, $3gCgH.TAB_KEYS).ALL);
    (0, $7u9ZS.useResourcesPageAnalytics)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
        space: "space.300",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                size: "large",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $1m5EK.messages).pageHeading))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dM6iN.TabSelector), {
                currentTab: currentTab,
                tabs: (0, $3gCgH.TABS),
                onTabSelect: setCurrentTab
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iggFr.default), {
                gap: "space.200",
                templateColumns: "1fr 1fr 1fr",
                children: (0, $3gCgH.RESOURCE_LINK_CARDS).filter((card)=>currentTab === (0, $3gCgH.TAB_KEYS).ALL || card.category === currentTab).map((card)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iutPV.ResourceLinkCard), (0, $6ogO3._)({}, card), card.id))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $79ZK0.default), {
                space: "space.200",
                grow: "fill",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iEOeE.LinkCardWrapper), {
                    heading: (0, $1m5EK.messages).usefulLinksHeading,
                    links: (0, $3gCgH.USEFUL_LINKS)
                })
            })
        ]
    });
};

});
parcelRegister("iggFr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d4b6a6658d6d36b6$export$2e2bcd8739ae039; });

var $4hcKa = parcelRequire("4hcKa");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $ahhSJ = parcelRequire("ahhSJ");

var $f6YGh = parcelRequire("f6YGh");
var $d4b6a6658d6d36b6$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
var $d4b6a6658d6d36b6$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
var $d4b6a6658d6d36b6$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
var $d4b6a6658d6d36b6$var$justifyContentMap = {
    start: (0, $3dJ4i.css)({
        justifyContent: 'start'
    }),
    center: (0, $3dJ4i.css)({
        justifyContent: 'center'
    }),
    end: (0, $3dJ4i.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3dJ4i.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3dJ4i.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3dJ4i.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3dJ4i.css)({
        justifyContent: 'stretch'
    })
};
var $d4b6a6658d6d36b6$var$justifyItemsMap = {
    start: (0, $3dJ4i.css)({
        justifyItems: 'start'
    }),
    center: (0, $3dJ4i.css)({
        justifyItems: 'center'
    }),
    end: (0, $3dJ4i.css)({
        justifyItems: 'end'
    }),
    stretch: (0, $3dJ4i.css)({
        justifyItems: 'stretch'
    })
};
var $d4b6a6658d6d36b6$var$alignContentMap = {
    start: (0, $3dJ4i.css)({
        alignContent: 'start'
    }),
    center: (0, $3dJ4i.css)({
        alignContent: 'center'
    }),
    end: (0, $3dJ4i.css)({
        alignContent: 'end'
    }),
    'space-between': (0, $3dJ4i.css)({
        alignContent: 'space-between'
    }),
    'space-around': (0, $3dJ4i.css)({
        alignContent: 'space-around'
    }),
    'space-evenly': (0, $3dJ4i.css)({
        alignContent: 'space-evenly'
    }),
    stretch: (0, $3dJ4i.css)({
        alignContent: 'stretch'
    })
};
var $d4b6a6658d6d36b6$var$alignItemsMap = {
    start: (0, $3dJ4i.css)({
        alignItems: 'start'
    }),
    center: (0, $3dJ4i.css)({
        alignItems: 'center'
    }),
    baseline: (0, $3dJ4i.css)({
        alignItems: 'baseline'
    }),
    end: (0, $3dJ4i.css)({
        alignItems: 'end'
    })
};
var $d4b6a6658d6d36b6$var$baseStyles = (0, $3dJ4i.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: "var(".concat($d4b6a6658d6d36b6$var$gridTemplateAreasVar, ")"),
    gridTemplateColumns: "var(".concat($d4b6a6658d6d36b6$var$gridTemplateColumnsVar, ")"),
    gridTemplateRows: "var(".concat($d4b6a6658d6d36b6$var$gridTemplateRowsVar, ")")
});
var $d4b6a6658d6d36b6$var$gridAutoFlowMap = {
    row: (0, $3dJ4i.css)({
        gridAutoFlow: 'row'
    }),
    column: (0, $3dJ4i.css)({
        gridAutoFlow: 'column'
    }),
    dense: (0, $3dJ4i.css)({
        gridAutoFlow: 'dense'
    }),
    'row dense': (0, $3dJ4i.css)({
        gridAutoFlow: 'row dense'
    }),
    'column dense': (0, $3dJ4i.css)({
        gridAutoFlow: 'column dense'
    })
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ var $d4b6a6658d6d36b6$var$Grid = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignItems, alignContent = _ref.alignContent, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, id = _ref.id, role = _ref.role, testId = _ref.testId, autoFlow = _ref.autoFlow, gridTemplateAreas = _ref.templateAreas, gridTemplateRows = _ref.templateRows, gridTemplateColumns = _ref.templateColumns, xcss = _ref.xcss;
    var Component = as || 'div';
    var resolvedStyles = (0, $f6YGh.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ var style = (0, $1oC0p.useMemo)(function() {
        return (0, $4hcKa.default)((0, $4hcKa.default)((0, $4hcKa.default)({}, $d4b6a6658d6d36b6$var$gridTemplateAreasVar, gridTemplateAreas ? gridTemplateAreas.map(function(str) {
            return "\"".concat(str, "\"");
        }).join('\n') || 'initial' : 'initial'), $d4b6a6658d6d36b6$var$gridTemplateColumnsVar, gridTemplateColumns || 'initial'), $d4b6a6658d6d36b6$var$gridTemplateRowsVar, gridTemplateRows || 'initial');
    }, [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return (0, $3dJ4i.jsx)(Component, {
        id: id,
        role: role,
        style: style,
        className: resolvedStyles.static,
        css: [
            $d4b6a6658d6d36b6$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $ahhSJ.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $ahhSJ.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $ahhSJ.spaceStylesMap).rowGap[rowGap],
            alignItems && $d4b6a6658d6d36b6$var$alignItemsMap[alignItems],
            alignContent && $d4b6a6658d6d36b6$var$alignContentMap[alignContent],
            justifyContent && $d4b6a6658d6d36b6$var$justifyContentMap[justifyContent],
            autoFlow && $d4b6a6658d6d36b6$var$gridAutoFlowMap[autoFlow],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$d4b6a6658d6d36b6$var$Grid.displayName = 'Grid';
var $d4b6a6658d6d36b6$export$2e2bcd8739ae039 = $d4b6a6658d6d36b6$var$Grid;

});

parcelRegister("3gCgH", function(module, exports) {
$parcel$export(module.exports, "TAB_KEYS", function () { return $280c6ac8c2066c91$export$c672a3478ed79724; });
$parcel$export(module.exports, "TABS", function () { return $280c6ac8c2066c91$export$73b877b58963a4f; });
$parcel$export(module.exports, "RESOURCE_LINK_CARDS", function () { return $280c6ac8c2066c91$export$115c227af3fc4874; });
$parcel$export(module.exports, "USEFUL_LINKS", function () { return $280c6ac8c2066c91$export$9b1e1aec2488ce2e; });

var $7VQPk = parcelRequire("7VQPk");

var $9lp51 = parcelRequire("9lp51");

var $cWei2 = parcelRequire("cWei2");

var $gc0nX = parcelRequire("gc0nX");

var $jB3hD = parcelRequire("jB3hD");

var $7v2eo = parcelRequire("7v2eo");

var $eBPGU = parcelRequire("eBPGU");

var $5XjEk = parcelRequire("5XjEk");

var $8BlKa = parcelRequire("8BlKa");

var $1m5EK = parcelRequire("1m5EK");
var $280c6ac8c2066c91$export$c672a3478ed79724 = /*#__PURE__*/ function(TAB_KEYS) {
    TAB_KEYS["ALL"] = "all";
    TAB_KEYS["ASSESSMENTS"] = "assessments";
    TAB_KEYS["PLANNING"] = "planning";
    TAB_KEYS["TEST_RUN"] = "testRun";
    TAB_KEYS["LAUNCH"] = "launch";
    return TAB_KEYS;
}({});
const $280c6ac8c2066c91$export$73b877b58963a4f = [
    {
        id: "all",
        icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5XjEk))), {
            label: ""
        }),
        tagIcon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5XjEk))), {
            label: "",
            size: "small"
        }),
        text: (0, $1m5EK.messages).tabPillAllText
    },
    {
        id: "assessments",
        icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cWei2))), {
            label: ""
        }),
        tagIcon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cWei2))), {
            label: "",
            size: "small"
        }),
        text: (0, $1m5EK.messages).tabPillAssessmentsText
    },
    {
        id: "planning",
        icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8BlKa))), {
            label: ""
        }),
        tagIcon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8BlKa))), {
            label: "",
            size: "small"
        }),
        text: (0, $1m5EK.messages).tabPillPlanningText
    },
    {
        id: "testRun",
        icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jB3hD))), {
            label: ""
        }),
        tagIcon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jB3hD))), {
            label: "",
            size: "small"
        }),
        text: (0, $1m5EK.messages).tabPillTestRunText
    },
    {
        id: "launch",
        icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7v2eo))), {
            label: ""
        }),
        tagIcon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7v2eo))), {
            label: "",
            size: "small"
        }),
        text: (0, $1m5EK.messages).tabPillLaunchText
    }
];
const $280c6ac8c2066c91$export$115c227af3fc4874 = [
    {
        id: "portfolio_insights",
        heading: (0, $1m5EK.messages).card1Heading,
        description: (0, $1m5EK.messages).card1Description,
        category: "assessments",
        link: {
            linkText: (0, $1m5EK.messages).linkText,
            href: "https://support.atlassian.com/portfolio-insights/docs/about-portfolio-insights/"
        }
    },
    {
        id: "detect_and_connect_to_your_portfolio",
        heading: (0, $1m5EK.messages).card2Heading,
        description: (0, $1m5EK.messages).card2Description,
        category: "assessments",
        link: {
            linkText: (0, $1m5EK.messages).linkText,
            href: "https://support.atlassian.com/portfolio-insights/docs/detect-and-connect-to-your-portfolio/"
        }
    },
    {
        id: "assess_jira_cloud_readiness",
        heading: (0, $1m5EK.messages).card3Heading,
        description: (0, $1m5EK.messages).card3Description,
        category: "assessments",
        link: {
            linkText: (0, $1m5EK.messages).linkText,
            href: "https://confluence.atlassian.com/support/assess-your-instance-scale-using-jira-cloud-migration-assistant-database-queries-and-usage-metrics-1267761445.html"
        }
    },
    {
        id: "assess_confluence_cloud_readiness",
        heading: (0, $1m5EK.messages).card4Heading,
        description: (0, $1m5EK.messages).card4Description,
        category: "assessments",
        link: {
            linkText: (0, $1m5EK.messages).linkText,
            href: "https://confluence.atlassian.com/support/assess-your-instance-scale-using-confluence-cloud-migration-assistant-database-queries-and-usage-metrics-1318881830.html"
        }
    },
    {
        id: "compare_cloud_migration_methods",
        heading: (0, $1m5EK.messages).card5Heading,
        description: (0, $1m5EK.messages).card5Description,
        category: "planning",
        link: {
            linkText: (0, $1m5EK.messages).linkText,
            href: "https://support.atlassian.com/migration/docs/compare-cloud-migration-methods/"
        }
    },
    {
        id: "milestone_tracker_template",
        heading: (0, $1m5EK.messages).card6Heading,
        description: (0, $1m5EK.messages).card6Description,
        category: "planning",
        link: {
            linkText: (0, $1m5EK.messages).linkText,
            href: "https://support.atlassian.com/migration/docs/milestone-tracker/"
        }
    },
    {
        id: "fastshift_stages_and_data_handling",
        heading: (0, $1m5EK.messages).card7Heading,
        description: (0, $1m5EK.messages).card7Description,
        category: "planning",
        link: {
            linkText: (0, $1m5EK.messages).linkText,
            href: "https://support.atlassian.com/migration/docs/fastshift-migration-stages-and-data-handling/"
        }
    },
    {
        id: "roles_and_responsibilities",
        heading: (0, $1m5EK.messages).card8Heading,
        description: (0, $1m5EK.messages).card8Description,
        category: "planning",
        link: {
            linkText: (0, $1m5EK.messages).linkText,
            href: "https://support.atlassian.com/migration/docs/roles-and-responsibilities-in-the-migration-process/"
        }
    },
    {
        id: "issue_tracker",
        heading: (0, $1m5EK.messages).card9Heading,
        description: (0, $1m5EK.messages).card9Description,
        category: "testRun",
        link: {
            linkText: (0, $1m5EK.messages).linkText,
            href: "https://support.atlassian.com/migration/docs/issue-tracker/"
        }
    },
    {
        id: "cloud_migration_runbook",
        heading: (0, $1m5EK.messages).card10Heading,
        description: (0, $1m5EK.messages).card10Description,
        category: "testRun",
        link: {
            linkText: (0, $1m5EK.messages).downloadText,
            href: "https://www.atlassian.com/dam/jcr:5451577b-91c9-4fc8-97f2-765ab8e89114/Cloud%20Migration%20Runbook%20Template.xlsx"
        }
    },
    {
        id: "link_fixing",
        heading: (0, $1m5EK.messages).card11Heading,
        description: (0, $1m5EK.messages).card11Description,
        category: "launch",
        link: {
            linkText: (0, $1m5EK.messages).linkText,
            href: "https://support.atlassian.com/migration/docs/what-are-product-links/"
        }
    },
    {
        id: "macro_repair",
        heading: (0, $1m5EK.messages).card12Heading,
        description: (0, $1m5EK.messages).card12Description,
        category: "launch",
        link: {
            linkText: (0, $1m5EK.messages).linkText,
            href: "https://confluence.atlassian.com/confkb/using-the-jira-macro-repair-1084362152.html"
        }
    }
];
const $280c6ac8c2066c91$export$9b1e1aec2488ce2e = [
    {
        id: "partner_portal",
        icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9lp51))), {
            label: "",
            spacing: "spacious"
        }),
        text: (0, $1m5EK.messages).partnerPortalLinkText,
        href: "https://partnercentral.atlassian.com/get-started"
    },
    {
        id: "billing_console",
        icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gc0nX))), {
            label: "",
            spacing: "spacious"
        }),
        text: (0, $1m5EK.messages).billingConsoleLinkText,
        href: "https://admin.atlassian.com/billing"
    },
    {
        id: "migration_support",
        icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eBPGU))), {
            label: "",
            spacing: "spacious"
        }),
        text: (0, $1m5EK.messages).migrationSupportLinkText,
        href: "https://support.atlassian.com/"
    }
];

});
parcelRegister("cWei2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::149b2cd6a95881a63bc7d331a2f52240>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $96b5fc7e0e62fbee$var$_react = $96b5fc7e0e62fbee$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $96b5fc7e0e62fbee$var$_baseNew = $96b5fc7e0e62fbee$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $96b5fc7e0e62fbee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Compass".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $96b5fc7e0e62fbee$var$CompassIcon = (props)=>/*#__PURE__*/ $96b5fc7e0e62fbee$var$_react.default.createElement($96b5fc7e0e62fbee$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m11.78-3.78a.75.75 0 0 1 .155.834l-2 4.5a.75.75 0 0 1-.38.381l-4.5 2a.75.75 0 0 1-.99-.99l2-4.5a.75.75 0 0 1 .38-.38l4.5-2a.75.75 0 0 1 .835.154M6.992 8.051l.955.956-1.72.764zm2.016-.105-.956-.955 1.72-.765z" clip-rule="evenodd"/>`
    }, props));
$96b5fc7e0e62fbee$var$CompassIcon.displayName = 'CompassIcon';
var $96b5fc7e0e62fbee$var$_default = module.exports.default = $96b5fc7e0e62fbee$var$CompassIcon;

});

parcelRegister("gc0nX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4932f6dfff92518aeab5d46f90dd8b8a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc9e10da20a3e5ed$var$_react = $bc9e10da20a3e5ed$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $bc9e10da20a3e5ed$var$_baseNew = $bc9e10da20a3e5ed$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $bc9e10da20a3e5ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CreditCard".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc9e10da20a3e5ed$var$CreditCardIcon = (props)=>/*#__PURE__*/ $bc9e10da20a3e5ed$var$_react.default.createElement($bc9e10da20a3e5ed$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1.5h13V4a.5.5 0 0 0-.5-.5zM14.5 7h-13v5a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM9 9.5h4V11H9z" clip-rule="evenodd"/>`
    }, props));
$bc9e10da20a3e5ed$var$CreditCardIcon.displayName = 'CreditCardIcon';
var $bc9e10da20a3e5ed$var$_default = module.exports.default = $bc9e10da20a3e5ed$var$CreditCardIcon;

});

parcelRegister("eBPGU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cf49c9cacb111227a84470c71b4079f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa2c9e26c0b76167$var$_react = $aa2c9e26c0b76167$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $aa2c9e26c0b76167$var$_baseNew = $aa2c9e26c0b76167$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $aa2c9e26c0b76167$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Support".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing help support.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aa2c9e26c0b76167$var$SupportIcon = (props)=>/*#__PURE__*/ $aa2c9e26c0b76167$var$_react.default.createElement($aa2c9e26c0b76167$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.964 2.904 5.752 4.69a4 4 0 0 1 4.497 0l1.787-1.787a6.5 6.5 0 0 0-8.072 0m9.132 1.06L11.31 5.752a4 4 0 0 1 0 4.497l1.787 1.787a6.5 6.5 0 0 0 0-8.072m-1.06 9.132-1.787-1.787a4 4 0 0 1-4.497 0l-1.788 1.787a6.5 6.5 0 0 0 8.072 0m-9.132-1.06 1.787-1.787a4 4 0 0 1 0-4.497L2.904 3.964a6.5 6.5 0 0 0 0 8.072m-.56-9.693a8 8 0 1 1 11.313 11.314A8 8 0 0 1 2.343 2.343m7.424 3.89a2.5 2.5 0 1 0-3.536 3.535 2.5 2.5 0 0 0 3.536-3.536" clip-rule="evenodd"/>`
    }, props));
$aa2c9e26c0b76167$var$SupportIcon.displayName = 'SupportIcon';
var $aa2c9e26c0b76167$var$_default = module.exports.default = $aa2c9e26c0b76167$var$SupportIcon;

});

parcelRegister("5XjEk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c07c4c04f9f99a3868a6c26b78654ed8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4561b46b8a64a14b$var$_react = $4561b46b8a64a14b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4561b46b8a64a14b$var$_baseNew = $4561b46b8a64a14b$var$_interopRequireDefault((parcelRequire("jcI35")));
function $4561b46b8a64a14b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4561b46b8a64a14b$var$BookOpenIcon = (props)=>/*#__PURE__*/ $4561b46b8a64a14b$var$_react.default.createElement($4561b46b8a64a14b$var$_baseNew.default, Object.assign({
        name: "BookOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$4561b46b8a64a14b$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $4561b46b8a64a14b$var$_default = module.exports.default = $4561b46b8a64a14b$var$BookOpenIcon;

});

parcelRegister("1m5EK", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $9dbd5245efe3c816$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $9dbd5245efe3c816$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    planningResourcesHeading: {
        id: "fastshift.resources-page.planning-resources-heading",
        defaultMessage: "Planning resources",
        description: "Heading for planning resources section"
    },
    card1Heading: {
        id: "fastshift.resources-page.card1.heading",
        defaultMessage: "Portfolio insights",
        description: "Heading for the assessments card 1"
    },
    card1Description: {
        id: "fastshift.resources-page.tooling-card.description",
        defaultMessage: "Understand how you\u2019ll assess your cloud readiness with Portfolio insights.",
        description: "Description for the assessments card 1"
    },
    card2Heading: {
        id: "fastshift.resources-page.card2.heading",
        defaultMessage: "Detect and connect to your portfolio",
        description: "Heading for the assessments card 2"
    },
    card2Description: {
        id: "fastshift.resources-page.card2.description",
        defaultMessage: "Use Portfolio insights to discover and connect to your instances.",
        description: "Description for the assessments card 2"
    },
    card3Heading: {
        id: "fastshift.resources-page.card3.heading",
        defaultMessage: "Assess Jira cloud readiness",
        description: "Heading for the assessments card 3"
    },
    card3Description: {
        id: "fastshift.resources-page.card3.description",
        defaultMessage: "How to assess cloud readiness by collecting data from your Jira instance.",
        description: "Description for the assessments card 3"
    },
    card4Heading: {
        id: "fastshift.resources-page.card4.heading",
        defaultMessage: "Assess Confluence cloud readiness",
        description: "Heading for the assessments card 4"
    },
    card4Description: {
        id: "fastshift.resources-page.card4.description",
        defaultMessage: "How to assess cloud readiness by collecting data from your Confluence instance.",
        description: "Description for the assessments card 4"
    },
    card5Heading: {
        id: "fastshift.resources-page.card5.heading",
        defaultMessage: "Compare cloud migration methods",
        description: "Heading for the Planning card 5"
    },
    card5Description: {
        id: "fastshift.resources-page.card5.description",
        defaultMessage: "Understand which migration method is best for your use case.",
        description: "Description for the Planning card 5"
    },
    card6Heading: {
        id: "fastshift.resources-page.card6.heading",
        defaultMessage: "Milestone tracker template",
        description: "Heading for the Planning card 6"
    },
    card6Description: {
        id: "fastshift.resources-page.card6.description",
        defaultMessage: "Use the document to track important milestones.",
        description: "Description for the Planning card 6"
    },
    card7Heading: {
        id: "fastshift.resources-page.card7.heading",
        defaultMessage: "FastShift stages and data handling",
        description: "Heading for the Planning card 7"
    },
    card7Description: {
        id: "fastshift.resources-page.card7.description",
        defaultMessage: "Understand migration stages and how we handle your data.",
        description: "Description for the Planning card 7"
    },
    card8Heading: {
        id: "fastshift.resources-page.card8.heading",
        defaultMessage: "Roles and responsibilities",
        description: "Heading for the Planning card 8"
    },
    card8Description: {
        id: "fastshift.resources-page.card8.description",
        defaultMessage: "Learn about roles and responsibilities in the FastShift migration process.",
        description: "Description for the Planning card 8"
    },
    card9Heading: {
        id: "fastshift.resources-page.card9.heading",
        defaultMessage: "Issue tracker",
        description: "Heading for the test run card 9"
    },
    card9Description: {
        id: "fastshift.resources-page.card9.description",
        defaultMessage: "Use this template to record and track issues that come up during test runs.",
        description: "Description for the test run card 9"
    },
    card10Heading: {
        id: "fastshift.resources-page.card10.heading",
        defaultMessage: "Cloud Migration Runbook",
        description: "Heading for the test run card 10"
    },
    card10Description: {
        id: "fastshift.resources-page.card10.description",
        defaultMessage: "View sample steps to help you prepare and execute a migration.",
        description: "Description for the test run card 10"
    },
    card11Heading: {
        id: "fastshift.resources-page.card11.heading",
        defaultMessage: "Link fixing",
        description: "Heading for the launch card 11"
    },
    card11Description: {
        id: "fastshift.resources-page.card11.description",
        defaultMessage: "Learn how to fix broken issue or page links after migration.",
        description: "Description for the launch card 11"
    },
    card12Heading: {
        id: "fastshift.resources-page.card12.heading",
        defaultMessage: "Macro repair",
        description: "Heading for the launch card 12"
    },
    card12Description: {
        id: "fastshift.resources-page.card12.description",
        defaultMessage: "Remap the Jira issue macro to correct app links after migration.",
        description: "Description for the launch card 12"
    },
    linkText: {
        id: "fastshift.resources-page.link-text",
        defaultMessage: "Read",
        description: "Text for the resource card link"
    },
    downloadText: {
        id: "fastshift.resources-page.download-text",
        defaultMessage: "Download",
        description: "Download text for the resource card link"
    },
    usefulLinksHeading: {
        id: "fastshift.resources-page.useful-links.heading",
        defaultMessage: "Useful links",
        description: "Heading for the useful links section"
    },
    partnerPortalLinkText: {
        id: "fastshift.resources-page.useful-links.partner-portal.link-text",
        defaultMessage: "Partner Portal",
        description: "Link text for the partner portal link button"
    },
    billingConsoleLinkText: {
        id: "fastshift.resources-page.useful-links.billing-console.link-text",
        defaultMessage: "Billing Console",
        description: "Link text for the billing console link button"
    },
    migrationSupportLinkText: {
        id: "fastshift.resources-page.useful-links.migration-support.link-text",
        defaultMessage: "Migration Support",
        description: "Link text for the migration support link button"
    },
    tabPillAllText: {
        id: "fastshift.resources-page.tabPill.all",
        defaultMessage: "All",
        description: "Text for the tab pill All"
    },
    tabPillAssessmentsText: {
        id: "fastshift.resources-page.tabPill.assess",
        defaultMessage: "Assess",
        description: "Text for the tab pill Assessments"
    },
    tabPillPlanningText: {
        id: "fastshift.resources-page.tabPill.plan",
        defaultMessage: "Plan",
        description: "Text for the tab pill Plan"
    },
    tabPillTestRunText: {
        id: "fastshift.resources-page.tabPill.test",
        defaultMessage: "Test",
        description: "Text for the tab pill Test"
    },
    tabPillProductionRunText: {
        id: "fastshift.resources-page.tabPill.production-run",
        defaultMessage: "Production-run",
        description: "Text for the tab pill Production-run"
    },
    tabPillLaunchText: {
        id: "fastshift.resources-page.tabPill.launch",
        defaultMessage: "Launch",
        description: "Text for the tab pill Launch"
    },
    pageHeading: {
        id: "fastshift.resources-page.page-heading",
        defaultMessage: "Resources",
        description: "Page heading for fastshift resources page"
    }
});

});


parcelRegister("gXU9p", function(module, exports) {
$parcel$export(module.exports, "useResourcesPageAnalytics", function () { return (parcelRequire("7u9ZS")).useResourcesPageAnalytics; });
$parcel$export(module.exports, "useResourcesPageUIAnalytics", function () { return (parcelRequire("1LM8l")).useResourcesPageUIAnalytics; });

var $7u9ZS = parcelRequire("7u9ZS");

var $1LM8l = parcelRequire("1LM8l");

});
parcelRegister("7u9ZS", function(module, exports) {
$parcel$export(module.exports, "useResourcesPageAnalytics", function () { return $ddc03cc7f3be2ac7$export$98f7cbe9106b954; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");
const $ddc03cc7f3be2ac7$export$98f7cbe9106b954 = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)();
    const { fireScreenEvent: fireScreenEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    (0, $1oC0p.useEffect)(()=>{
        if (!identityAttrs) return;
        fireScreenEvent({
            name: sourceKey,
            attributes: identityAttrs
        });
    }, [
        fireScreenEvent,
        identityAttrs,
        sourceKey
    ]);
};

});

parcelRegister("1LM8l", function(module, exports) {
$parcel$export(module.exports, "useResourcesPageUIAnalytics", function () { return $10c651867e9a23fc$export$d9f0d1eef9318778; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
const $10c651867e9a23fc$export$d9f0d1eef9318778 = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)(true);
    const { fireUIEvent: fireUIEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    const sendResourceFilterClickUIEvent = (0, $1oC0p.useCallback)((selectedFilter)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).RESOURCE_FILTER,
            source: sourceKey,
            attributes: {
                selectedFilter: selectedFilter
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendResourceLinkClickUIEvent = (0, $1oC0p.useCallback)((resourceSubject, resourceCategory)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).LINK,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).RESOURCE_LINK,
            source: sourceKey,
            attributes: {
                resourceSubject: resourceSubject,
                resourceType: resourceCategory
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendUsefulLinkClickUIEvent = (0, $1oC0p.useCallback)((linkSubject)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).LINK,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).USEFUL_LINK,
            source: sourceKey,
            attributes: {
                linkSubject: linkSubject
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    return {
        sendResourceFilterClickUIEvent: sendResourceFilterClickUIEvent,
        sendResourceLinkClickUIEvent: sendResourceLinkClickUIEvent,
        sendUsefulLinkClickUIEvent: sendUsefulLinkClickUIEvent
    };
};

});


parcelRegister("9Ua9k", function(module, exports) {
$parcel$export(module.exports, "LinkCardWrapper", function () { return (parcelRequire("iEOeE")).LinkCardWrapper; });

var $iEOeE = parcelRequire("iEOeE");

});
parcelRegister("iEOeE", function(module, exports) {
$parcel$export(module.exports, "LinkCardWrapper", function () { return $197eebfac001ded5$export$8463c987d12d7028; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");

var $dTJrO = parcelRequire("dTJrO");

var $7OBrw = parcelRequire("7OBrw");
var $9HSUa = parcelRequire("9HSUa");
var $4HBPY = parcelRequire("4HBPY");

var $9LRfx = parcelRequire("9LRfx");
const $197eebfac001ded5$var$linkCardWrapperStyle = (0, $4HBPY.xcss)({
    borderRadius: "border.radius.200",
    borderWidth: "border.width",
    borderStyle: "solid",
    borderColor: "color.border",
    backgroundColor: "elevation.surface.overlay",
    paddingBlockStart: "space.200",
    paddingBlockEnd: "space.150",
    paddingInline: "space.150"
});
const $197eebfac001ded5$export$8463c987d12d7028 = ({ heading: heading, links: links })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9HSUa.default), {
        space: "space.200",
        xcss: $197eebfac001ded5$var$linkCardWrapperStyle,
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                size: "xsmall",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, heading))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7OBrw.default), {
                space: "space.200",
                children: links.map((linkData, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $9LRfx.LinkCard), (0, $6ogO3._)({}, linkData), index))
            })
        ]
    });
};

});
parcelRegister("9LRfx", function(module, exports) {
$parcel$export(module.exports, "LinkCard", function () { return $302ebccc895ded29$export$2c381a86421d5abf; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");

var $crY69 = parcelRequire("crY69");

var $8tFck = parcelRequire("8tFck");
var $79ZK0 = parcelRequire("79ZK0");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");
parcelRequire("gXU9p");
var $1LM8l = parcelRequire("1LM8l");
const $302ebccc895ded29$var$anchorStyle = (0, $f6YGh.xcss)({
    "display": "flex",
    "flexGrow": 1,
    "alignItems": "center",
    "gap": "space.100",
    "color": "color.text",
    "backgroundColor": "elevation.surface",
    "textDecoration": "none",
    "borderRadius": "border.radius.200",
    "borderWidth": "border.width",
    "borderStyle": "solid",
    "borderColor": "color.border",
    ":hover": {
        color: "color.text",
        backgroundColor: "elevation.surface.hovered",
        textDecoration: "none",
        boxShadow: "elevation.shadow.raised"
    }
});
const $302ebccc895ded29$export$2c381a86421d5abf = ({ id: id, icon: icon, text: text, href: href })=>{
    const { sendUsefulLinkClickUIEvent: sendUsefulLinkClickUIEvent } = (0, $1LM8l.useResourcesPageUIAnalytics)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $8tFck.default), {
        href: href,
        target: "_blank",
        xcss: $302ebccc895ded29$var$anchorStyle,
        paddingBlock: "space.075",
        paddingInline: "space.150",
        onClick: ()=>sendUsefulLinkClickUIEvent(id),
        children: [
            icon,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $79ZK0.default), {
                grow: "fill",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, text))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($crY69))), {
                label: "",
                spacing: "spacious"
            })
        ]
    });
};

});
parcelRegister("8tFck", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $62c0fd32652f43f9$export$2e2bcd8739ae039; });

var $45ahP = parcelRequire("45ahP");

var $83oQa = parcelRequire("83oQa");

var $7NMHB = parcelRequire("7NMHB");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $lmxXn = parcelRequire("lmxXn");

var $2mFjt = parcelRequire("2mFjt");

var $joCBX = parcelRequire("joCBX");

var $7uNuF = parcelRequire("7uNuF");

var $4UF4U = parcelRequire("4UF4U");

var $etBkE = parcelRequire("etBkE");

var $ao69c = parcelRequire("ao69c");

var $ahhSJ = parcelRequire("ahhSJ");

var $f6YGh = parcelRequire("f6YGh");
var $62c0fd32652f43f9$var$_excluded = [
    "href",
    "children",
    "backgroundColor",
    "newWindowLabel",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss"
], $62c0fd32652f43f9$var$_excluded2 = [
    "className"
];
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $62c0fd32652f43f9$var$focusRingStyles = (0, $3dJ4i.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $ahhSJ.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $ahhSJ.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $ahhSJ.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $62c0fd32652f43f9$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    textDecoration: 'underline'
});
var $62c0fd32652f43f9$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $62c0fd32652f43f9$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
var $62c0fd32652f43f9$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $62c0fd32652f43f9$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, backgroundColor = _ref.backgroundColor, newWindowLabel = _ref.newWindowLabel, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $7uNuF.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $7NMHB.default)(_ref, $62c0fd32652f43f9$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $etBkE.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $4UF4U.useId)();
    var onClick = (0, $2mFjt.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "14.8.3",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $7NMHB.default)(htmlAttributes, $62c0fd32652f43f9$var$_excluded2);
    var resolvedStyles = (0, $f6YGh.parseXcss)(xcss);
    var RouterLink = (0, $joCBX.default)();
    var isExternal = typeof href === 'string' && $62c0fd32652f43f9$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $62c0fd32652f43f9$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, $83oQa.default)(href) === 'object';
    (0, $lmxXn.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return (0, $3dJ4i.jsx)(Component, (0, $45ahP.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel ? newWindowLabel : $62c0fd32652f43f9$var$OPENS_NEW_WINDOW_LABEL) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        css: [
            $62c0fd32652f43f9$var$baseStyles,
            $62c0fd32652f43f9$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $ahhSJ.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $ahhSJ.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $ahhSJ.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $ahhSJ.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $ahhSJ.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $ahhSJ.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $ahhSJ.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $ahhSJ.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && (0, $3dJ4i.jsx)((0, $ao69c.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel ? newWindowLabel : $62c0fd32652f43f9$var$OPENS_NEW_WINDOW_LABEL)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $62c0fd32652f43f9$var$Anchor = /*#__PURE__*/ (0, $1oC0p.forwardRef)($62c0fd32652f43f9$var$AnchorNoRef);
var $62c0fd32652f43f9$export$2e2bcd8739ae039 = $62c0fd32652f43f9$var$Anchor;

});
parcelRegister("2mFjt", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $1b8daebf78885bf8$export$a4687b0234b40e28; });

var $4hcKa = parcelRequire("4hcKa");

var $1oC0p = parcelRequire("1oC0p");

var $gO1Bt = parcelRequire("gO1Bt");

var $1HDkY = parcelRequire("1HDkY");
function $1b8daebf78885bf8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1b8daebf78885bf8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1b8daebf78885bf8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $4hcKa.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1b8daebf78885bf8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1b8daebf78885bf8$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $gO1Bt.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $1HDkY.useTrackedRef)(analyticsData);
    var fnRef = (0, $1HDkY.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $1b8daebf78885bf8$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("gO1Bt", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $c3c28f44effcd199$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $glTPb = parcelRequire("glTPb");

var $hRp2W = parcelRequire("hRp2W");
function $c3c28f44effcd199$export$5bf35293e545f20c() {
    var analyticsContext = (0, $hRp2W.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $glTPb.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("glTPb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $be79e91598e9daf2$export$2e2bcd8739ae039; });

var $3Hvqv = parcelRequire("3Hvqv");

var $lviej = parcelRequire("lviej");

var $d2ZTC = parcelRequire("d2ZTC");

var $6Rinj = parcelRequire("6Rinj");

var $lj9FC = parcelRequire("lj9FC");

var $hrw8D = parcelRequire("hrw8D");

var $6GJEv = parcelRequire("6GJEv");

var $4hcKa = parcelRequire("4hcKa");

var $9Ej5K = parcelRequire("9Ej5K");
function $be79e91598e9daf2$var$_callSuper(t, o, e) {
    return o = (0, $lj9FC.default)(o), (0, $6Rinj.default)(t, $be79e91598e9daf2$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $lj9FC.default)(t).constructor) : o.apply(t, e));
}
function $be79e91598e9daf2$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($be79e91598e9daf2$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $be79e91598e9daf2$var$_superPropGet(t, o, e, r) {
    var p = (0, $hrw8D.default)((0, $lj9FC.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $be79e91598e9daf2$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $be79e91598e9daf2$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $be79e91598e9daf2$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $lviej.default)(this, UIAnalyticsEvent);
        _this = $be79e91598e9daf2$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $4hcKa.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $4hcKa.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $3Hvqv.default)(_this.context);
            var handlers = (0, $3Hvqv.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $4hcKa.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $6GJEv.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $d2ZTC.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $be79e91598e9daf2$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $9Ej5K.default));

});
parcelRegister("lviej", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fa7aa2491305b33b$export$2e2bcd8739ae039; });
function $fa7aa2491305b33b$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("d2ZTC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $97fb7983c8c3b075$export$2e2bcd8739ae039; });

var $bOBg2 = parcelRequire("bOBg2");
function $97fb7983c8c3b075$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $bOBg2.default)(o.key), o);
    }
}
function $97fb7983c8c3b075$export$2e2bcd8739ae039(e, r, t) {
    return r && $97fb7983c8c3b075$var$_defineProperties(e.prototype, r), t && $97fb7983c8c3b075$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("6Rinj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4fe5f2388555a373$export$2e2bcd8739ae039; });

var $83oQa = parcelRequire("83oQa");

var $icC2E = parcelRequire("icC2E");
function $4fe5f2388555a373$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $83oQa.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $icC2E.default)(t);
}

});
parcelRegister("icC2E", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d406db4734f26747$export$2e2bcd8739ae039; });
function $d406db4734f26747$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("lj9FC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f832dfa3635763af$export$2e2bcd8739ae039; });
function $f832dfa3635763af$export$2e2bcd8739ae039(t) {
    return $f832dfa3635763af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $f832dfa3635763af$export$2e2bcd8739ae039(t);
}

});

parcelRegister("hrw8D", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cb2de3445a6faa86$export$2e2bcd8739ae039; });

var $kEJ9a = parcelRequire("kEJ9a");
function $cb2de3445a6faa86$export$2e2bcd8739ae039() {
    return $cb2de3445a6faa86$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $kEJ9a.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $cb2de3445a6faa86$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("kEJ9a", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f09a9048549a341e$export$2e2bcd8739ae039; });

var $lj9FC = parcelRequire("lj9FC");
function $f09a9048549a341e$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $lj9FC.default)(t)););
    return t;
}

});


parcelRegister("6GJEv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4dea13f0cac7c8fc$export$2e2bcd8739ae039; });

var $j4KcJ = parcelRequire("j4KcJ");
function $4dea13f0cac7c8fc$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $j4KcJ.default)(t, e);
}

});
parcelRegister("j4KcJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $de323b4919f0aa7b$export$2e2bcd8739ae039; });
function $de323b4919f0aa7b$export$2e2bcd8739ae039(t, e) {
    return $de323b4919f0aa7b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $de323b4919f0aa7b$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("9Ej5K", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7066a8ad8c410e4d$export$2e2bcd8739ae039; });

var $83oQa = parcelRequire("83oQa");

var $lviej = parcelRequire("lviej");

var $d2ZTC = parcelRequire("d2ZTC");

var $4hcKa = parcelRequire("4hcKa");
function $7066a8ad8c410e4d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7066a8ad8c410e4d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7066a8ad8c410e4d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $4hcKa.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7066a8ad8c410e4d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7066a8ad8c410e4d$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $7066a8ad8c410e4d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $7066a8ad8c410e4d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $lviej.default)(this, AnalyticsEvent);
        (0, $4hcKa.default)(this, "_isAnalyticsEvent", true);
        (0, $4hcKa.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $7066a8ad8c410e4d$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $d2ZTC.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $83oQa.default)(updater) === 'object') this.payload = $7066a8ad8c410e4d$var$_objectSpread($7066a8ad8c410e4d$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("hRp2W", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $d00ad0a12cf6ebb6$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $d00ad0a12cf6ebb6$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("1HDkY", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $13d8522820593bf2$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $13d8522820593bf2$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("joCBX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e1ee359dd198f242$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $33rJ2 = parcelRequire("33rJ2");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $e1ee359dd198f242$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $1oC0p.useContext)((0, $33rJ2.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $e1ee359dd198f242$export$2e2bcd8739ae039 = $e1ee359dd198f242$var$useRouterLink;

});
parcelRegister("33rJ2", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $23972893c603e83d$export$2931e0ee690eee88; });

var $1oC0p = parcelRequire("1oC0p");
var $23972893c603e83d$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $1oC0p.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $23972893c603e83d$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($23972893c603e83d$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $23972893c603e83d$export$2e2bcd8739ae039 = $23972893c603e83d$var$RouterLinkProvider;

});


parcelRegister("ao69c", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7900ea0590412dea$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $1oC0p = parcelRequire("1oC0p");

var $7CXnW = parcelRequire("7CXnW");
var $7900ea0590412dea$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $7900ea0590412dea$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $7CXnW.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $7900ea0590412dea$export$2e2bcd8739ae039 = $7900ea0590412dea$var$VisuallyHidden;

});
parcelRegister("7CXnW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $58da25af55982a1b$export$2e2bcd8739ae039; });
const $58da25af55982a1b$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $58da25af55982a1b$var$ATOMIC_GROUP_LENGTH = 5;
function $58da25af55982a1b$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $58da25af55982a1b$var$UNDERSCORE_UNICODE ? $58da25af55982a1b$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});






parcelRegister("gMMVS", function(module, exports) {
$parcel$export(module.exports, "ResourceLinkCard", function () { return (parcelRequire("iutPV")).ResourceLinkCard; });

var $iutPV = parcelRequire("iutPV");

});
parcelRegister("iutPV", function(module, exports) {
$parcel$export(module.exports, "ResourceLinkCard", function () { return $8da8de7b65d27da3$export$167499258be5d5a1; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $1p5OQ = parcelRequire("1p5OQ");

var $dTJrO = parcelRequire("dTJrO");

var $a1X32 = parcelRequire("a1X32");

var $fmW7P = parcelRequire("fmW7P");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");

var $4Xdza = parcelRequire("4Xdza");

var $3gCgH = parcelRequire("3gCgH");
parcelRequire("gXU9p");
var $1LM8l = parcelRequire("1LM8l");
const $8da8de7b65d27da3$var$linkResourceCardStyles = (0, $f6YGh.xcss)({
    minHeight: "156px",
    borderRadius: "border.radius.200",
    borderWidth: "border.width",
    borderStyle: "solid",
    borderColor: "color.border",
    backgroundColor: "elevation.surface.overlay",
    paddingBlockStart: "space.200",
    paddingBlockEnd: "space.150",
    paddingInline: "space.150"
});
const $8da8de7b65d27da3$export$167499258be5d5a1 = ({ id: id, heading: heading, description: description, link: link, category: category })=>{
    const { sendResourceLinkClickUIEvent: sendResourceLinkClickUIEvent } = (0, $1LM8l.useResourcesPageUIAnalytics)();
    const mappedCategory = (0, $3gCgH.TABS).find((tab)=>tab.id === category);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
        spread: "space-between",
        space: "space.200",
        grow: "fill",
        xcss: $8da8de7b65d27da3$var$linkResourceCardStyles,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                        size: "small",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, heading))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, description))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $fmW7P.default), {
                gap: "space.200",
                justifyContent: "space-between",
                children: [
                    mappedCategory && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Xdza.default), {
                        text: mappedCategory.text.defaultMessage,
                        elemBefore: mappedCategory.tagIcon
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1p5OQ.default), {
                        testId: "card-link",
                        appearance: "subtle",
                        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($a1X32))),
                        href: link.href,
                        target: "_blank",
                        onClick: ()=>sendResourceLinkClickUIEvent(id, category),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, link.linkText))
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("4Xdza", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $39b73211387e1aa7$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $4uDE2 = parcelRequire("4uDE2");

var $1CePs = parcelRequire("1CePs");

var $4hQ8r = parcelRequire("4hQ8r");
var $39b73211387e1aa7$var$SimpleTagComponent = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var appearance = _ref.appearance, _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, testId = _ref.testId, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, linkComponent = _ref.linkComponent;
    var content = (0, $3dJ4i.jsx)((0, $4hQ8r.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return (0, $3dJ4i.jsx)((0, $4uDE2.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: (0, $3dJ4i.jsx)((0, $1CePs.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ var $39b73211387e1aa7$var$SimpleTag = /*#__PURE__*/ (0, $1oC0p.memo)($39b73211387e1aa7$var$SimpleTagComponent);
var $39b73211387e1aa7$export$2e2bcd8739ae039 = $39b73211387e1aa7$var$SimpleTag;

});
parcelRegister("4uDE2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3458b75e5a5190ba$export$2e2bcd8739ae039; });

var $4ZcKk = parcelRequire("4ZcKk");

var $62Nah = parcelRequire("62Nah");

var $cvJHi = parcelRequire("cvJHi");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $1ZmVc = parcelRequire("1ZmVc");

var $e2mca = parcelRequire("e2mca");

var $jvk02 = parcelRequire("jvk02");
var $3458b75e5a5190ba$var$_excluded = [
    "before",
    "contentElement",
    "after",
    "testId",
    "appearance",
    "style",
    "color",
    "href",
    "className"
];
function $3458b75e5a5190ba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3458b75e5a5190ba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3458b75e5a5190ba$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $62Nah.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3458b75e5a5190ba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// To be removed with platform-component-visual-refresh (BLU-2992)
var $3458b75e5a5190ba$var$baseStylesOld = (0, $3dJ4i.css)({
    display: 'inline-flex',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $e2mca.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $e2mca.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: "var(".concat((0, $e2mca.cssVar).color.background.default, ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(".concat((0, $e2mca.cssVar).borderRadius, ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: "var(".concat((0, $e2mca.cssVar).color.text.default, ")"),
    cursor: 'default'
});
var $3458b75e5a5190ba$var$baseStyles = (0, $3dJ4i.css)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $e2mca.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $e2mca.defaultMargin),
    position: 'relative',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
    border: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderColor: "var(".concat((0, $e2mca.cssVar).color.borderColor, ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    borderWidth: "var(--ds-border-width, 1px)",
    color: "var(--ds-text, #172B4D)",
    cursor: 'default',
    paddingInline: "var(--ds-space-050, 4px)"
});
// To be removed with platform-component-visual-refresh (BLU-2992)
var $3458b75e5a5190ba$var$interactiveStylesOld = (0, $3dJ4i.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: "var(".concat((0, $e2mca.cssVar).color.background.hover, ")")
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: "var(".concat((0, $e2mca.cssVar).color.background.active, ")")
    }
});
var $3458b75e5a5190ba$var$interactiveStyles = (0, $3dJ4i.css)({
    '&:hover': {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    '&:active': {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    }
});
// To be removed with platform-component-visual-refresh (BLU-2992)
var $3458b75e5a5190ba$var$focusRingStylesOld = (0, $3dJ4i.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: "0 0 0 2px var(".concat((0, $e2mca.cssVar).color.focusRing, ")"),
        outline: 'none'
    }
});
var $3458b75e5a5190ba$var$focusRingStyles = (0, $3dJ4i.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        outline: "2px solid ".concat($jvk02.focusRingColors),
        outlineOffset: '2px '
    }
});
// To be removed with platform-component-visual-refresh (BLU-2992)
var $3458b75e5a5190ba$var$nonStandardLinkStyles = (0, $3dJ4i.css)({
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: "var(".concat((0, $e2mca.cssVar).color.text.active, ")")
    }
});
var $3458b75e5a5190ba$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function BaseTag(_ref, ref) {
    var _objectSpread2;
    var before = _ref.before, contentElement = _ref.contentElement, after = _ref.after, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, style = _ref.style, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, className = _ref.className, other = (0, $cvJHi.default)(_ref, $3458b75e5a5190ba$var$_excluded);
    var isLink = Boolean(href);
    var isRemovable = Boolean(after);
    var isInteractive = isLink || isRemovable;
    var isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    var textLinkColors = isStandardLink ? $jvk02.textColors['standardLink'] : $jvk02.textColors[color];
    var backgroundHoverColors = isRemovable && !isLink ? $jvk02.backgroundColors[color] : $jvk02.linkHoverBackgroundColors[color];
    var backgroundActiveColors = isRemovable && !isLink ? $jvk02.backgroundColors[color] : $jvk02.linkActiveBackgroundColors[color];
    return (0, $3dJ4i.jsx)("span", (0, $4ZcKk.default)({}, other, {
        ref: ref,
        css: [
            (0, $1ZmVc.fg)('platform-component-visual-refresh') ? $3458b75e5a5190ba$var$baseStyles : $3458b75e5a5190ba$var$baseStylesOld,
            isInteractive && ((0, $1ZmVc.fg)('platform-component-visual-refresh') ? $3458b75e5a5190ba$var$focusRingStyles : $3458b75e5a5190ba$var$focusRingStylesOld),
            (0, $1ZmVc.fg)('platform-component-visual-refresh') ? isLink && $3458b75e5a5190ba$var$interactiveStyles : undefined,
            !(0, $1ZmVc.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && $3458b75e5a5190ba$var$nonStandardLinkStyles,
            !(0, $1ZmVc.fg)('platform-component-visual-refresh') && isInteractive && $3458b75e5a5190ba$var$interactiveStylesOld
        ],
        style: $3458b75e5a5190ba$var$_objectSpread((_objectSpread2 = {}, (0, $62Nah.default)((0, $62Nah.default)((0, $62Nah.default)((0, $62Nah.default)((0, $62Nah.default)((0, $62Nah.default)((0, $62Nah.default)((0, $62Nah.default)((0, $62Nah.default)((0, $62Nah.default)(_objectSpread2, (0, $e2mca.cssVar).color.borderColor, $jvk02.borderColors[color]), (0, $e2mca.cssVar).color.text.default, $jvk02.textColors[color]), (0, $e2mca.cssVar).color.text.hover, $jvk02.textHoverColors[color]), (0, $e2mca.cssVar).color.text.active, $jvk02.textActiveColors[color]), (0, $e2mca.cssVar).color.text.link, textLinkColors), (0, $e2mca.cssVar).color.background.default, $jvk02.backgroundColors[color]), (0, $e2mca.cssVar).color.background.hover, backgroundHoverColors), (0, $e2mca.cssVar).color.background.active, backgroundActiveColors), (0, $e2mca.cssVar).color.focusRing, $jvk02.focusRingColors), (0, $e2mca.cssVar).color.removeButton.default, $jvk02.removeButtonColors[color]), (0, $62Nah.default)((0, $62Nah.default)(_objectSpread2, (0, $e2mca.cssVar).color.removeButton.hover, $jvk02.removeButtonHoverColors[color]), (0, $e2mca.cssVar).borderRadius, $jvk02.borderRadius[appearance])), style),
        className: className,
        "data-testid": testId
    }), before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3458b75e5a5190ba$export$2e2bcd8739ae039 = $3458b75e5a5190ba$var$BaseTag;

});
parcelRegister("4ZcKk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3a16bf0afdca7ea7$export$2e2bcd8739ae039; });
function $3a16bf0afdca7ea7$export$2e2bcd8739ae039() {
    return $3a16bf0afdca7ea7$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3a16bf0afdca7ea7$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("62Nah", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $46691110968fb60e$export$2e2bcd8739ae039; });

var $lsvVC = parcelRequire("lsvVC");
function $46691110968fb60e$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $lsvVC.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("lsvVC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f9f4fac7c354aa45$export$2e2bcd8739ae039; });

var $h6O0O = parcelRequire("h6O0O");

var $kk1A1 = parcelRequire("kk1A1");
function $f9f4fac7c354aa45$export$2e2bcd8739ae039(t) {
    var i = (0, $kk1A1.default)(t, "string");
    return "symbol" == (0, $h6O0O.default)(i) ? i : i + "";
}

});
parcelRegister("h6O0O", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c749ca96032b2f4b$export$2e2bcd8739ae039; });
function $c749ca96032b2f4b$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $c749ca96032b2f4b$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c749ca96032b2f4b$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kk1A1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ecb6e6a92955d8a5$export$2e2bcd8739ae039; });

var $h6O0O = parcelRequire("h6O0O");
function $ecb6e6a92955d8a5$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $h6O0O.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $h6O0O.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("cvJHi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $91bbd3d4730d22d2$export$2e2bcd8739ae039; });

var $8xQ7L = parcelRequire("8xQ7L");
function $91bbd3d4730d22d2$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $8xQ7L.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("8xQ7L", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6389d69832cf09ba$export$2e2bcd8739ae039; });
function $6389d69832cf09ba$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("1ZmVc", function(module, exports) {
$parcel$export(module.exports, "fg", function () { return $172d44b37ad1e5db$export$b40ec24ac8275656; });

var $euGx9 = parcelRequire("euGx9");
function $172d44b37ad1e5db$export$ba05d765b8392e5e(flagResolver) {
    (0, $euGx9.setBooleanResolver)(flagResolver);
}
function $172d44b37ad1e5db$export$470e5c2be1411c89(name) {
    return (0, $euGx9.resolveBooleanFlag)(name);
}
function $172d44b37ad1e5db$export$b40ec24ac8275656(name) {
    return (0, $euGx9.resolveBooleanFlag)(name);
}

});
parcelRegister("euGx9", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $a8d4dc517745f84f$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $a8d4dc517745f84f$export$6333b6aff9fc6275; });

var $3r1j8 = parcelRequire("3r1j8");

var $F9zqo = parcelRequire("F9zqo");

var $7t0tI = parcelRequire("7t0tI");
var $a8d4dc517745f84f$var$pkgName = '@atlaskit/platform-feature-flags';
var $a8d4dc517745f84f$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $a8d4dc517745f84f$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $a8d4dc517745f84f$var$ENV_ENABLE_PLATFORM_FF = $a8d4dc517745f84f$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $a8d4dc517745f84f$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $a8d4dc517745f84f$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $a8d4dc517745f84f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $a8d4dc517745f84f$var$ENV_ENABLE_PLATFORM_FF || $a8d4dc517745f84f$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $a8d4dc517745f84f$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $a8d4dc517745f84f$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$a8d4dc517745f84f$var$globalVar[$a8d4dc517745f84f$export$7e41b1b2bdee3f98] = $a8d4dc517745f84f$var$globalVar[$a8d4dc517745f84f$export$7e41b1b2bdee3f98] || $a8d4dc517745f84f$var$DEFAULT_PFF_GLOBAL;
function $a8d4dc517745f84f$export$f2b591175b3e424c(resolver) {
    $a8d4dc517745f84f$var$globalVar[$a8d4dc517745f84f$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $a8d4dc517745f84f$export$6333b6aff9fc6275(flagKey) {
    if ($a8d4dc517745f84f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $F9zqo.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $a8d4dc517745f84f$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $a8d4dc517745f84f$var$globalVar[$a8d4dc517745f84f$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $a8d4dc517745f84f$var$globalVar[$a8d4dc517745f84f$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $3r1j8.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $a8d4dc517745f84f$var$globalVar[$a8d4dc517745f84f$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("3r1j8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2804e863cdffbf25$export$2e2bcd8739ae039; });

var $liHeE = parcelRequire("liHeE");

var $dGhzs = parcelRequire("dGhzs");

var $62Nah = parcelRequire("62Nah");

var $7IQix = parcelRequire("7IQix");

var $c0Eus = parcelRequire("c0Eus");



var $2804e863cdffbf25$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $2804e863cdffbf25$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $liHeE.default)(this, FeatureGates);
    }
    return (0, $dGhzs.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$2804e863cdffbf25$var$_FeatureGates = $2804e863cdffbf25$var$FeatureGates;
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "client", new (0, $7IQix.Client)());
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$2804e863cdffbf25$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $2804e863cdffbf25$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $2804e863cdffbf25$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$2804e863cdffbf25$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $2804e863cdffbf25$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $2804e863cdffbf25$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "initializeCalled", $2804e863cdffbf25$var$_FeatureGates.client.initializeCalled.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "initializeCompleted", $2804e863cdffbf25$var$_FeatureGates.client.initializeCompleted.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "initialize", $2804e863cdffbf25$var$_FeatureGates.client.initialize.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "initializeWithProvider", $2804e863cdffbf25$var$_FeatureGates.client.initializeWithProvider.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "initializeFromValues", $2804e863cdffbf25$var$_FeatureGates.client.initializeFromValues.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "manuallyLogGateExposure", $2804e863cdffbf25$var$_FeatureGates.client.manuallyLogGateExposure.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "getExperiment", $2804e863cdffbf25$var$_FeatureGates.client.getExperiment.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "manuallyLogExperimentExposure", $2804e863cdffbf25$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "manuallyLogLayerExposure", $2804e863cdffbf25$var$_FeatureGates.client.manuallyLogLayerExposure.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "shutdownStatsig", $2804e863cdffbf25$var$_FeatureGates.client.shutdownStatsig.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "overrideGate", $2804e863cdffbf25$var$_FeatureGates.client.overrideGate.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "clearGateOverride", $2804e863cdffbf25$var$_FeatureGates.client.clearGateOverride.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "overrideConfig", $2804e863cdffbf25$var$_FeatureGates.client.overrideConfig.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "clearConfigOverride", $2804e863cdffbf25$var$_FeatureGates.client.clearConfigOverride.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "setOverrides", $2804e863cdffbf25$var$_FeatureGates.client.setOverrides.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "getOverrides", $2804e863cdffbf25$var$_FeatureGates.client.getOverrides.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "clearAllOverrides", $2804e863cdffbf25$var$_FeatureGates.client.clearAllOverrides.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "isCurrentUser", $2804e863cdffbf25$var$_FeatureGates.client.isCurrentUser.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "onGateUpdated", $2804e863cdffbf25$var$_FeatureGates.client.onGateUpdated.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "onExperimentValueUpdated", $2804e863cdffbf25$var$_FeatureGates.client.onExperimentValueUpdated.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "onAnyUpdated", $2804e863cdffbf25$var$_FeatureGates.client.onAnyUpdated.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "updateUser", $2804e863cdffbf25$var$_FeatureGates.client.updateUser.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "updateUserWithProvider", $2804e863cdffbf25$var$_FeatureGates.client.updateUserWithProvider.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "updateUserWithValues", $2804e863cdffbf25$var$_FeatureGates.client.updateUserWithValues.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "getPackageVersion", $2804e863cdffbf25$var$_FeatureGates.client.getPackageVersion.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "getLayer", $2804e863cdffbf25$var$_FeatureGates.client.getLayer.bind($2804e863cdffbf25$var$_FeatureGates.client));
(0, $62Nah.default)($2804e863cdffbf25$var$FeatureGates, "getLayerValue", $2804e863cdffbf25$var$_FeatureGates.client.getLayerValue.bind($2804e863cdffbf25$var$_FeatureGates.client));
var $2804e863cdffbf25$var$boundFGJS = $2804e863cdffbf25$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $2804e863cdffbf25$var$FeatureGates;
    else {
        var $2804e863cdffbf25$var$_boundFGJS, $2804e863cdffbf25$var$_boundFGJS$getPackage;
        $2804e863cdffbf25$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $2804e863cdffbf25$var$boundVersion = (($2804e863cdffbf25$var$_boundFGJS = $2804e863cdffbf25$var$boundFGJS) === null || $2804e863cdffbf25$var$_boundFGJS === void 0 || ($2804e863cdffbf25$var$_boundFGJS$getPackage = $2804e863cdffbf25$var$_boundFGJS.getPackageVersion) === null || $2804e863cdffbf25$var$_boundFGJS$getPackage === void 0 ? void 0 : $2804e863cdffbf25$var$_boundFGJS$getPackage.call($2804e863cdffbf25$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($2804e863cdffbf25$var$boundVersion !== (0, $c0Eus.CLIENT_VERSION)) {
            var $2804e863cdffbf25$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($2804e863cdffbf25$var$boundVersion, " when module version ").concat((0, $c0Eus.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($2804e863cdffbf25$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $2804e863cdffbf25$export$2e2bcd8739ae039 = $2804e863cdffbf25$var$boundFGJS;

});
parcelRegister("liHeE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f81cd10bda620841$export$2e2bcd8739ae039; });
function $f81cd10bda620841$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("dGhzs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9f5cd3d0c42dded5$export$2e2bcd8739ae039; });

var $lsvVC = parcelRequire("lsvVC");
function $9f5cd3d0c42dded5$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $lsvVC.default)(o.key), o);
    }
}
function $9f5cd3d0c42dded5$export$2e2bcd8739ae039(e, r, t) {
    return r && $9f5cd3d0c42dded5$var$_defineProperties(e.prototype, r), t && $9f5cd3d0c42dded5$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("7IQix", function(module, exports) {
$parcel$export(module.exports, "Client", function () { return $59f535bfe4272dd2$export$1f2bb630327ac4b6; });

var $cvJHi = parcelRequire("cvJHi");

var $ae3Oq = parcelRequire("ae3Oq");

var $aYhkb = parcelRequire("aYhkb");

var $liHeE = parcelRequire("liHeE");

var $dGhzs = parcelRequire("dGhzs");

var $62Nah = parcelRequire("62Nah");

var $hTFZN = parcelRequire("hTFZN");

var $ec1qE = parcelRequire("ec1qE");

var $5wbNV = parcelRequire("5wbNV");

var $gWlxn = parcelRequire("gWlxn");

var $afSIZ = parcelRequire("afSIZ");

var $6poP4 = parcelRequire("6poP4");

var $cUfLI = parcelRequire("cUfLI");

var $1oCE9 = parcelRequire("1oCE9");

var $19G90 = parcelRequire("19G90");

var $l43Am = parcelRequire("l43Am");

var $gJ0kC = parcelRequire("gJ0kC");

var $c0Eus = parcelRequire("c0Eus");
var $59f535bfe4272dd2$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $59f535bfe4272dd2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $59f535bfe4272dd2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $59f535bfe4272dd2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $62Nah.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $59f535bfe4272dd2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $59f535bfe4272dd2$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $59f535bfe4272dd2$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $59f535bfe4272dd2$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $19G90.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $liHeE.default)(this, Client);
        (0, $62Nah.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $62Nah.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $62Nah.default)(this, "initWithDefaults", false);
        (0, $62Nah.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $62Nah.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $62Nah.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $62Nah.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $62Nah.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $62Nah.default)(this, "subscriptions", new (0, $5wbNV.default)());
        (0, $62Nah.default)(this, "dataAdapter", new (0, $1oCE9.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $62Nah.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $19G90.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $dGhzs.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $gJ0kC.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $gJ0kC.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $gJ0kC.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $gJ0kC.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $c0Eus.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $59f535bfe4272dd2$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $c0Eus.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $l43Am.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $gJ0kC.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $gJ0kC.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $gJ0kC.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $cUfLI.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $gWlxn.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $gWlxn.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $6poP4.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $gJ0kC.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $gJ0kC.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $59f535bfe4272dd2$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $cUfLI.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $cUfLI.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, $ae3Oq.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $59f535bfe4272dd2$var$_objectSpread($59f535bfe4272dd2$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, $ae3Oq.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $gJ0kC.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $59f535bfe4272dd2$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $59f535bfe4272dd2$var$_objectSpread($59f535bfe4272dd2$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $59f535bfe4272dd2$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $l43Am.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $cvJHi.default)(newClientOptions, $59f535bfe4272dd2$var$_excluded);
                                this.user = (0, $gJ0kC.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $59f535bfe4272dd2$var$_objectSpread($59f535bfe4272dd2$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $ec1qE.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $ec1qE.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context9.prev = 12;
                                this.statsigClient = new (0, $ec1qE.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $ec1qE.StatsigClient)($59f535bfe4272dd2$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee1(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee1$(_context1) {
                        while(true)switch(_context1.prev = _context1.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context1.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context1.next = 5;
                                    break;
                                }
                                return _context1.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context1.prev = 6;
                                _context1.next = 9;
                                return this.initPromise;
                            case 9:
                                _context1.next = 13;
                                break;
                            case 11:
                                _context1.prev = 11;
                                _context1.t0 = _context1["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee0() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee0$(_context0) {
                                        while(true)switch(_context0.prev = _context0.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context0.next = 4;
                                                    break;
                                                }
                                                _context0.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context0.stop();
                                        }
                                    }, _callee0);
                                })));
                                return _context1.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context1.stop();
                        }
                    }, _callee1, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee10(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context10.prev = 1;
                                _context10.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context10.sent;
                                user = (0, $gJ0kC.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context10.next = 13;
                                break;
                            case 8:
                                _context10.prev = 8;
                                _context10.t0 = _context10["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context10.t0 instanceof Error ? _context10.t0.message : JSON.stringify(_context10.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context10.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context10.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context10.next = 21;
                                    break;
                                }
                                _context10.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context10.next = 27;
                                break;
                            case 23:
                                _context10.prev = 23;
                                _context10.t1 = _context10["catch"](15);
                                success = false;
                                errorMessage = String(_context10.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context10.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context10.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $c0Eus.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $afSIZ.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $afSIZ.Layer).fromLayer((0, $ec1qE._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("ae3Oq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $771e2b3bd74d8367$export$2e2bcd8739ae039; });

var $4d1N2 = parcelRequire("4d1N2");

var $aAqvB = parcelRequire("aAqvB");

var $bbchD = parcelRequire("bbchD");

var $hBQw0 = parcelRequire("hBQw0");
function $771e2b3bd74d8367$export$2e2bcd8739ae039(r, e) {
    return (0, $4d1N2.default)(r) || (0, $aAqvB.default)(r, e) || (0, $bbchD.default)(r, e) || (0, $hBQw0.default)();
}

});
parcelRegister("4d1N2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3109c3ca14eb0be3$export$2e2bcd8739ae039; });
function $3109c3ca14eb0be3$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("aAqvB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7b51d445755dd444$export$2e2bcd8739ae039; });
function $7b51d445755dd444$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("bbchD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $823a40005a542bd1$export$2e2bcd8739ae039; });

var $aBNCp = parcelRequire("aBNCp");
function $823a40005a542bd1$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $aBNCp.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $aBNCp.default)(r, a) : void 0;
    }
}

});
parcelRegister("aBNCp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7b93d94d1a6ecc86$export$2e2bcd8739ae039; });
function $7b93d94d1a6ecc86$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("hBQw0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cd1ea0cad9cf0349$export$2e2bcd8739ae039; });
function $cd1ea0cad9cf0349$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("aYhkb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7fccf23f709d8b19$export$2e2bcd8739ae039; });
function $7fccf23f709d8b19$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $7fccf23f709d8b19$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $7fccf23f709d8b19$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $7fccf23f709d8b19$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("hTFZN", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $d078262eb742ea9f$var$runtime = (parcelRequire("eciXf"))();
module.exports = $d078262eb742ea9f$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $d078262eb742ea9f$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $d078262eb742ea9f$var$runtime;
    else Function("r", "regeneratorRuntime = r")($d078262eb742ea9f$var$runtime);
}

});
parcelRegister("eciXf", function(module, exports) {

var $lD4am = parcelRequire("lD4am");

var $lmgM5 = parcelRequire("lmgM5");

var $2mcBm = parcelRequire("2mcBm");

var $dyfsC = parcelRequire("dyfsC");

var $6vrVz = parcelRequire("6vrVz");

var $eoa4k = parcelRequire("eoa4k");

var $2rDLR = parcelRequire("2rDLR");
function $a560e3a5be4a4f5e$var$_regeneratorRuntime() {
    "use strict";
    var r = $lmgM5(), e = r.m($a560e3a5be4a4f5e$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $2rDLR(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $a560e3a5be4a4f5e$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $lD4am(r, e);
            },
            AsyncIterator: $6vrVz,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $dyfsC : $2mcBm)(a(r), e, t, o, u);
            },
            keys: $eoa4k,
            values: $2rDLR
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $a560e3a5be4a4f5e$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lD4am", function(module, exports) {
function $fbf078ce750ecfd3$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $fbf078ce750ecfd3$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lmgM5", function(module, exports) {

var $dTWpo = parcelRequire("dTWpo");
function $f8c8aa1de746f194$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $dTWpo(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($dTWpo(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $dTWpo(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $dTWpo(u, "constructor", GeneratorFunctionPrototype), $dTWpo(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $dTWpo(GeneratorFunctionPrototype, o, "GeneratorFunction"), $dTWpo(u), $dTWpo(u, o, "Generator"), $dTWpo(u, n, function() {
        return this;
    }), $dTWpo(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $f8c8aa1de746f194$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $f8c8aa1de746f194$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dTWpo", function(module, exports) {
function $a1edb826abea28ab$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $a1edb826abea28ab$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $a1edb826abea28ab$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a1edb826abea28ab$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $a1edb826abea28ab$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2mcBm", function(module, exports) {

var $dyfsC = parcelRequire("dyfsC");
function $1b776947c40141e6$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $dyfsC(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $1b776947c40141e6$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dyfsC", function(module, exports) {

var $lmgM5 = parcelRequire("lmgM5");

var $6vrVz = parcelRequire("6vrVz");
function $9dda717a09026162$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $6vrVz($lmgM5().w(r, e, t, o), n || Promise);
}
module.exports = $9dda717a09026162$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6vrVz", function(module, exports) {

var $lD4am = parcelRequire("lD4am");

var $dTWpo = parcelRequire("dTWpo");
function $4bcb4d292d2703d2$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $lD4am ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($dTWpo($4bcb4d292d2703d2$var$AsyncIterator.prototype), $dTWpo($4bcb4d292d2703d2$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $dTWpo(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $4bcb4d292d2703d2$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("eoa4k", function(module, exports) {
function $a79b1e04da619892$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $a79b1e04da619892$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2rDLR", function(module, exports) {

var $N5NjJ = parcelRequire("N5NjJ");
var $1c7cf414ffd980cb$var$_typeof = $N5NjJ.default;
function $1c7cf414ffd980cb$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($1c7cf414ffd980cb$var$_typeof(e) + " is not iterable");
}
module.exports = $1c7cf414ffd980cb$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("N5NjJ", function(module, exports) {
function $0939125f91dd00d8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $0939125f91dd00d8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $0939125f91dd00d8$var$_typeof(o);
}
module.exports = $0939125f91dd00d8$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("5wbNV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $404918fa9c1c1c52$export$2e2bcd8739ae039; });

var $liHeE = parcelRequire("liHeE");

var $dGhzs = parcelRequire("dGhzs");

var $62Nah = parcelRequire("62Nah");

var $f72YL = parcelRequire("f72YL");
function $404918fa9c1c1c52$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $404918fa9c1c1c52$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $404918fa9c1c1c52$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $62Nah.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $404918fa9c1c1c52$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $404918fa9c1c1c52$export$a66cbd9b2289cd78 = '@all-features';
var $404918fa9c1c1c52$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $liHeE.default)(this, Subscriptions);
        (0, $62Nah.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($f72YL)))();
    }
    return (0, $dGhzs.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $404918fa9c1c1c52$var$_objectSpread($404918fa9c1c1c52$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $404918fa9c1c1c52$var$_objectSpread($404918fa9c1c1c52$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $404918fa9c1c1c52$var$_objectSpread($404918fa9c1c1c52$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $404918fa9c1c1c52$var$_objectSpread($404918fa9c1c1c52$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($404918fa9c1c1c52$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($404918fa9c1c1c52$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($404918fa9c1c1c52$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $404918fa9c1c1c52$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("gWlxn", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", function () { return $c552c4f943594e3d$export$6dc24881a3d96325; });

var $h6O0O = parcelRequire("h6O0O");

var $liHeE = parcelRequire("liHeE");

var $dGhzs = parcelRequire("dGhzs");

var $gJ0kC = parcelRequire("gJ0kC");
var $c552c4f943594e3d$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $liHeE.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $dGhzs.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $h6O0O.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $h6O0O.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $gJ0kC.migrateEvaluationDetails)(experiment.details), (0, $gJ0kC.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("gJ0kC", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $c2d11b2a0a6c4713$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $c2d11b2a0a6c4713$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $c2d11b2a0a6c4713$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $c2d11b2a0a6c4713$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $c2d11b2a0a6c4713$export$18ad168d3dbac899; });
$parcel$export(module.exports, "migrateSecondaryExposures", function () { return $c2d11b2a0a6c4713$export$55fd683752d01e67; });

var $cvJHi = parcelRequire("cvJHi");

var $ae3Oq = parcelRequire("ae3Oq");

var $62Nah = parcelRequire("62Nah");

var $7iPGz = parcelRequire("7iPGz");

var $6poP4 = parcelRequire("6poP4");

var $l43Am = parcelRequire("l43Am");
var $c2d11b2a0a6c4713$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $c2d11b2a0a6c4713$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c2d11b2a0a6c4713$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c2d11b2a0a6c4713$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $62Nah.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c2d11b2a0a6c4713$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c2d11b2a0a6c4713$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $c2d11b2a0a6c4713$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $7iPGz.isFedRamp)() ? (0, $l43Am.PerimeterType).FEDRAMP_MODERATE : (0, $l43Am.PerimeterType).COMMERCIAL
    }, options);
};
var $c2d11b2a0a6c4713$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $ae3Oq.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $ae3Oq.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $ae3Oq.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $ae3Oq.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $c2d11b2a0a6c4713$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $c2d11b2a0a6c4713$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $cvJHi.default)(options, $c2d11b2a0a6c4713$var$_excluded);
    return $c2d11b2a0a6c4713$var$_objectSpread($c2d11b2a0a6c4713$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $c2d11b2a0a6c4713$var$evaluationReasonMappings = Object.entries((0, $6poP4.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $ae3Oq.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $c2d11b2a0a6c4713$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $c2d11b2a0a6c4713$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $ae3Oq.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $6poP4.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $c2d11b2a0a6c4713$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("7iPGz", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", function () { return $55124e8435a9482e$export$64d6499adf9b2e51; });

var $dk9Y1 = parcelRequire("dk9Y1");
function $55124e8435a9482e$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $dk9Y1.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("dk9Y1", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $9b34dfe54394e58d$export$ce553301d55c2fd8; });
var $9b34dfe54394e58d$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $9b34dfe54394e58d$export$f005e2e9f707cb5f = 'commercial';
var $9b34dfe54394e58d$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $9b34dfe54394e58d$export$a739cd5aac835909 = 'stg';
var $9b34dfe54394e58d$export$42dd0cdd351a4a9 = 'prod';
var $9b34dfe54394e58d$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("6poP4", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", function () { return $4aa8552b663ee750$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $4aa8552b663ee750$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("l43Am", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $f55cc0b1f1ef7c41$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $f55cc0b1f1ef7c41$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $f55cc0b1f1ef7c41$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $f55cc0b1f1ef7c41$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $f55cc0b1f1ef7c41$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("afSIZ", function(module, exports) {
$parcel$export(module.exports, "Layer", function () { return $7775c14807eaf01e$export$936d0764594b6eb3; });

var $h6O0O = parcelRequire("h6O0O");

var $liHeE = parcelRequire("liHeE");

var $dGhzs = parcelRequire("dGhzs");

var $gJ0kC = parcelRequire("gJ0kC");
var $7775c14807eaf01e$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $liHeE.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $dGhzs.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $h6O0O.default)(val) === (0, $h6O0O.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $gJ0kC.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $gJ0kC.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $gJ0kC.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("cUfLI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9656f255234019ff$export$2e2bcd8739ae039; });

var $62Nah = parcelRequire("62Nah");

var $aYhkb = parcelRequire("aYhkb");

var $liHeE = parcelRequire("liHeE");

var $dGhzs = parcelRequire("dGhzs");

var $hTFZN = parcelRequire("hTFZN");

var $l43Am = parcelRequire("l43Am");

var $c0Eus = parcelRequire("c0Eus");

var $5NvGa = parcelRequire("5NvGa");
function $9656f255234019ff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9656f255234019ff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9656f255234019ff$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $62Nah.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9656f255234019ff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9656f255234019ff$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $9656f255234019ff$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $9656f255234019ff$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $9656f255234019ff$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $9656f255234019ff$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $9656f255234019ff$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $9656f255234019ff$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $9656f255234019ff$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $9656f255234019ff$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $9656f255234019ff$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $9656f255234019ff$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $liHeE.default)(this, Fetcher);
    }
    return (0, $dGhzs.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $5NvGa.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $5NvGa.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $9656f255234019ff$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $l43Am.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $l43Am.FeatureGateEnvironment).Production:
                        return $9656f255234019ff$export$18c93900db9358a4;
                    case (0, $l43Am.FeatureGateEnvironment).Staging:
                        return $9656f255234019ff$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $l43Am.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $l43Am.FeatureGateEnvironment).Development:
                        return $9656f255234019ff$export$f058dbf75c3bc647;
                    case (0, $l43Am.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $9656f255234019ff$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $9656f255234019ff$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $9656f255234019ff$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $9656f255234019ff$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $c0Eus.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $9656f255234019ff$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($9656f255234019ff$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($9656f255234019ff$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("c0Eus", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", function () { return $0241a09736ee5204$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $0241a09736ee5204$export$a59f8d67326bd1cb = "5.5.3";

});

parcelRegister("5NvGa", function(module, exports) {
$parcel$export(module.exports, "ResponseError", function () { return $438a1a2dd8ab9250$export$286baf652d0b1206; });

var $dGhzs = parcelRequire("dGhzs");

var $liHeE = parcelRequire("liHeE");

var $kRD2X = parcelRequire("kRD2X");

var $kqyYv = parcelRequire("kqyYv");

var $cp7Ld = parcelRequire("cp7Ld");

var $5ldQE = parcelRequire("5ldQE");
function $438a1a2dd8ab9250$var$_callSuper(t, o, e) {
    return o = (0, $kqyYv.default)(o), (0, $kRD2X.default)(t, $438a1a2dd8ab9250$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $kqyYv.default)(t).constructor) : o.apply(t, e));
}
function $438a1a2dd8ab9250$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($438a1a2dd8ab9250$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $438a1a2dd8ab9250$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $liHeE.default)(this, ResponseError);
        return $438a1a2dd8ab9250$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $cp7Ld.default)(ResponseError, _Error);
    return (0, $dGhzs.default)(ResponseError);
}(/*#__PURE__*/ (0, $5ldQE.default)(Error));

});
parcelRegister("kRD2X", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f3070bb912e77261$export$2e2bcd8739ae039; });

var $h6O0O = parcelRequire("h6O0O");

var $cJP91 = parcelRequire("cJP91");
function $f3070bb912e77261$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $h6O0O.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cJP91.default)(t);
}

});
parcelRegister("cJP91", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $94615c3f4dcee82c$export$2e2bcd8739ae039; });
function $94615c3f4dcee82c$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("kqyYv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $edf15da9fc491f5e$export$2e2bcd8739ae039; });
function $edf15da9fc491f5e$export$2e2bcd8739ae039(t) {
    return $edf15da9fc491f5e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $edf15da9fc491f5e$export$2e2bcd8739ae039(t);
}

});

parcelRegister("cp7Ld", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $907dd6ecfdf3fdd8$export$2e2bcd8739ae039; });

var $9aqlI = parcelRequire("9aqlI");
function $907dd6ecfdf3fdd8$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $9aqlI.default)(t, e);
}

});
parcelRegister("9aqlI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6ac97c9fabe2e059$export$2e2bcd8739ae039; });
function $6ac97c9fabe2e059$export$2e2bcd8739ae039(t, e) {
    return $6ac97c9fabe2e059$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $6ac97c9fabe2e059$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("5ldQE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3e39a7e0be527154$export$2e2bcd8739ae039; });

var $kqyYv = parcelRequire("kqyYv");

var $9aqlI = parcelRequire("9aqlI");

var $4bYUd = parcelRequire("4bYUd");

var $gXPwU = parcelRequire("gXPwU");
function $3e39a7e0be527154$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $3e39a7e0be527154$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $4bYUd.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $gXPwU.default)(t, arguments, (0, $kqyYv.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $9aqlI.default)(Wrapper, t);
    }, $3e39a7e0be527154$export$2e2bcd8739ae039(t);
}

});
parcelRegister("4bYUd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $30d76f18697def4d$export$2e2bcd8739ae039; });
function $30d76f18697def4d$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("gXPwU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c59a20c9252e8bb8$export$2e2bcd8739ae039; });

var $iFGvf = parcelRequire("iFGvf");

var $9aqlI = parcelRequire("9aqlI");
function $c59a20c9252e8bb8$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $iFGvf.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $9aqlI.default)(p, r.prototype), p;
}

});
parcelRegister("iFGvf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d97d0689f3a92e44$export$2e2bcd8739ae039; });
function $d97d0689f3a92e44$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d97d0689f3a92e44$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("1oCE9", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $104602c450391aee$export$55fffef3474104af; });

var $aYhkb = parcelRequire("aYhkb");

var $liHeE = parcelRequire("liHeE");

var $dGhzs = parcelRequire("dGhzs");

var $kRD2X = parcelRequire("kRD2X");

var $kqyYv = parcelRequire("kqyYv");

var $6N5iP = parcelRequire("6N5iP");

var $cp7Ld = parcelRequire("cp7Ld");

var $62Nah = parcelRequire("62Nah");

var $hTFZN = parcelRequire("hTFZN");

var $ec1qE = parcelRequire("ec1qE");
function $104602c450391aee$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $104602c450391aee$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $104602c450391aee$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $62Nah.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $104602c450391aee$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $104602c450391aee$var$_callSuper(t, o, e) {
    return o = (0, $kqyYv.default)(o), (0, $kRD2X.default)(t, $104602c450391aee$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $kqyYv.default)(t).constructor) : o.apply(t, e));
}
function $104602c450391aee$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($104602c450391aee$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $104602c450391aee$var$_superPropGet(t, o, e, r) {
    var p = (0, $6N5iP.default)((0, $kqyYv.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $104602c450391aee$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $liHeE.default)(this, NoFetchDataAdapter);
        _this = $104602c450391aee$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $62Nah.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $cp7Ld.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $dGhzs.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $ec1qE.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $104602c450391aee$var$_objectSpread($104602c450391aee$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $104602c450391aee$var$_objectSpread($104602c450391aee$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $aYhkb.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($hTFZN))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $ec1qE._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $ec1qE.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $104602c450391aee$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $104602c450391aee$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $ec1qE.DataAdapterCore));

});
parcelRegister("6N5iP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4f1b6ea9c8527bcc$export$2e2bcd8739ae039; });

var $a9WpK = parcelRequire("a9WpK");
function $4f1b6ea9c8527bcc$export$2e2bcd8739ae039() {
    return $4f1b6ea9c8527bcc$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $a9WpK.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $4f1b6ea9c8527bcc$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("a9WpK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $76580e85a7f45250$export$2e2bcd8739ae039; });

var $kqyYv = parcelRequire("kqyYv");
function $76580e85a7f45250$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $kqyYv.default)(t)););
    return t;
}

});



parcelRegister("19G90", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $0d7752b49edd3602$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $0d7752b49edd3602$export$bcb28fbac1def494; });

var $62Nah = parcelRequire("62Nah");

var $ae3Oq = parcelRequire("ae3Oq");

var $liHeE = parcelRequire("liHeE");

var $dGhzs = parcelRequire("dGhzs");

var $3wfvf = parcelRequire("3wfvf");
function $0d7752b49edd3602$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0d7752b49edd3602$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0d7752b49edd3602$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $62Nah.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0d7752b49edd3602$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0d7752b49edd3602$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $0d7752b49edd3602$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $0d7752b49edd3602$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0d7752b49edd3602$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0d7752b49edd3602$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0d7752b49edd3602$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $0d7752b49edd3602$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $0d7752b49edd3602$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $0d7752b49edd3602$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $0d7752b49edd3602$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $0d7752b49edd3602$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $0d7752b49edd3602$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $liHeE.default)(this, PersistentOverrideAdapter);
        this._overrides = $0d7752b49edd3602$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $dGhzs.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $0d7752b49edd3602$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $0d7752b49edd3602$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $0d7752b49edd3602$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $ae3Oq.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $ae3Oq.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $ae3Oq.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($0d7752b49edd3602$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($0d7752b49edd3602$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $0d7752b49edd3602$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $3wfvf._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $0d7752b49edd3602$var$_objectSpread($0d7752b49edd3602$var$_objectSpread({}, $0d7752b49edd3602$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $ae3Oq.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $ae3Oq.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($0d7752b49edd3602$var$djb2MapKey((0, $3wfvf._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($0d7752b49edd3602$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($0d7752b49edd3602$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($0d7752b49edd3602$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $0d7752b49edd3602$var$_objectSpread($0d7752b49edd3602$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $0d7752b49edd3602$var$_objectSpread($0d7752b49edd3602$var$_objectSpread({}, current.details), {}, {
                        reason: $0d7752b49edd3602$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($0d7752b49edd3602$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($0d7752b49edd3602$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($0d7752b49edd3602$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($0d7752b49edd3602$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($0d7752b49edd3602$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($0d7752b49edd3602$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $0d7752b49edd3602$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($0d7752b49edd3602$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $0d7752b49edd3602$var$_objectSpread($0d7752b49edd3602$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $0d7752b49edd3602$var$_objectSpread($0d7752b49edd3602$var$_objectSpread({}, current.details), {}, {
                        reason: $0d7752b49edd3602$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($0d7752b49edd3602$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $0d7752b49edd3602$var$_objectSpread($0d7752b49edd3602$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $0d7752b49edd3602$var$_objectSpread($0d7752b49edd3602$var$_objectSpread({}, current.details), {}, {
                        reason: $0d7752b49edd3602$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("F9zqo", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $07bb40eccd3dca2d$export$1c9f709888824e05; });
var $07bb40eccd3dca2d$var$_process, $07bb40eccd3dca2d$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $07bb40eccd3dca2d$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($07bb40eccd3dca2d$var$_process = globalThis.process) === null || $07bb40eccd3dca2d$var$_process === void 0 || ($07bb40eccd3dca2d$var$_process = $07bb40eccd3dca2d$var$_process.env) === null || $07bb40eccd3dca2d$var$_process === void 0 ? void 0 : $07bb40eccd3dca2d$var$_process.JEST_WORKER_ID) !== undefined;
var $07bb40eccd3dca2d$var$DEBUG_MODE = !$07bb40eccd3dca2d$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($07bb40eccd3dca2d$var$_process2 = globalThis.process) === null || $07bb40eccd3dca2d$var$_process2 === void 0 || ($07bb40eccd3dca2d$var$_process2 = $07bb40eccd3dca2d$var$_process2.env) === null || $07bb40eccd3dca2d$var$_process2 === void 0 ? void 0 : $07bb40eccd3dca2d$var$_process2.NODE_ENV) !== 'production';
var $07bb40eccd3dca2d$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$07bb40eccd3dca2d$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("e2mca", function(module, exports) {
$parcel$export(module.exports, "tagHeight", function () { return $a382781ecd1c3306$export$5b2b1030a679f37; });
$parcel$export(module.exports, "buttonWidthUnitless", function () { return $a382781ecd1c3306$export$c6f3ea2b4cffd0ca; });
$parcel$export(module.exports, "maxTextWidthUnitless", function () { return $a382781ecd1c3306$export$2e3bcb01bf928995; });
$parcel$export(module.exports, "maxTextWidth", function () { return $a382781ecd1c3306$export$982d4a1a6de11130; });
$parcel$export(module.exports, "defaultBorderRadius", function () { return $a382781ecd1c3306$export$35d5d1e251b985cf; });
$parcel$export(module.exports, "defaultRoundedBorderRadius", function () { return $a382781ecd1c3306$export$c49771100fee18c8; });
$parcel$export(module.exports, "defaultMargin", function () { return $a382781ecd1c3306$export$6728fea658cfb92e; });
$parcel$export(module.exports, "defaultTextPadding", function () { return $a382781ecd1c3306$export$c2d03c4c68282362; });
$parcel$export(module.exports, "textPaddingRight", function () { return $a382781ecd1c3306$export$b5686dedf408caa0; });
$parcel$export(module.exports, "textMarginLeft", function () { return $a382781ecd1c3306$export$b824cac86306f7a2; });
$parcel$export(module.exports, "cssVar", function () { return $a382781ecd1c3306$export$8b4981022bd80a4e; });
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $eozuQ = parcelRequire("eozuQ");
var $a382781ecd1c3306$var$gridSizeValue = (0, $eozuQ.gridSize)();
var $a382781ecd1c3306$var$borderRadiusValue = (0, $eozuQ.borderRadius)();
var $a382781ecd1c3306$var$tagHeightUnitless = 2.5 * $a382781ecd1c3306$var$gridSizeValue;
var $a382781ecd1c3306$export$5b2b1030a679f37 = "var(--ds-space-250, ".concat("".concat($a382781ecd1c3306$var$tagHeightUnitless, "px"), ")");
var $a382781ecd1c3306$export$c6f3ea2b4cffd0ca = $a382781ecd1c3306$var$tagHeightUnitless; // button should be square
var $a382781ecd1c3306$var$maxWidthUnitless = 25 * $a382781ecd1c3306$var$gridSizeValue;
var $a382781ecd1c3306$export$2e3bcb01bf928995 = $a382781ecd1c3306$var$maxWidthUnitless - $a382781ecd1c3306$var$tagHeightUnitless;
var $a382781ecd1c3306$export$982d4a1a6de11130 = "".concat($a382781ecd1c3306$export$2e3bcb01bf928995, "px");
var $a382781ecd1c3306$export$35d5d1e251b985cf = "".concat($a382781ecd1c3306$var$borderRadiusValue, "px");
var $a382781ecd1c3306$export$c49771100fee18c8 = "".concat($a382781ecd1c3306$export$c6f3ea2b4cffd0ca / 2, "px");
var $a382781ecd1c3306$export$6728fea658cfb92e = "var(--ds-space-050, ".concat("".concat($a382781ecd1c3306$var$gridSizeValue / 2, "px"), ")");
var $a382781ecd1c3306$export$c2d03c4c68282362 = "var(--ds-space-050, ".concat("".concat($a382781ecd1c3306$var$gridSizeValue / 2, "px"), ")");
var $a382781ecd1c3306$export$b5686dedf408caa0 = "var(--ds-space-200, ".concat("".concat(2 * $a382781ecd1c3306$var$gridSizeValue, "px"), ")");
var $a382781ecd1c3306$export$b824cac86306f7a2 = $a382781ecd1c3306$export$5b2b1030a679f37;
var $a382781ecd1c3306$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        borderColor: '--ds-bc',
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};

});
parcelRegister("eozuQ", function(module, exports) {
$parcel$export(module.exports, "borderRadius", function () { return $a7aed76f842f1e74$export$7a57f79000377ca2; });
$parcel$export(module.exports, "gridSize", function () { return $a7aed76f842f1e74$export$6d8204c2cb2e06b8; });

var $5WCtr = parcelRequire("5WCtr");

var $ijwRl = parcelRequire("ijwRl");
var $a7aed76f842f1e74$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $a7aed76f842f1e74$export$c93026a968943f95 = 'light';
var $a7aed76f842f1e74$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $a7aed76f842f1e74$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $a7aed76f842f1e74$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $a7aed76f842f1e74$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $a7aed76f842f1e74$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $a7aed76f842f1e74$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $a7aed76f842f1e74$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $a7aed76f842f1e74$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $ijwRl.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a7aed76f842f1e74$export$6d8204c2cb2e06b8() / 4;
    (0, $5WCtr.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $a7aed76f842f1e74$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $a7aed76f842f1e74$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $a7aed76f842f1e74$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5WCtr.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $a7aed76f842f1e74$export$ba1d834b86d72a09 = $a7aed76f842f1e74$export$a1b3edb637fb4f35;
var $a7aed76f842f1e74$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $ijwRl.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $ijwRl.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $ijwRl.N30A), ")")
            }
        }
    };
};

});
parcelRegister("5WCtr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $454036a07ac5bcd3$export$2e2bcd8739ae039; });

var $dW3tx = parcelRequire("dW3tx");

var $7t0tI = parcelRequire("7t0tI");
function $454036a07ac5bcd3$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $dW3tx.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $454036a07ac5bcd3$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("dW3tx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a2536344a72de733$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $a2536344a72de733$var$printed = {};
function $a2536344a72de733$export$2e2bcd8739ae039(message) {
    if ($a2536344a72de733$var$printed[message]) return;
    $a2536344a72de733$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});


parcelRegister("ijwRl", function(module, exports) {
$parcel$export(module.exports, "R50", function () { return $d5537d8843c9b56b$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R75", function () { return $d5537d8843c9b56b$export$b34b069eff244586; });
$parcel$export(module.exports, "R100", function () { return $d5537d8843c9b56b$export$be802dd0d8b57f35; });
$parcel$export(module.exports, "R500", function () { return $d5537d8843c9b56b$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y75", function () { return $d5537d8843c9b56b$export$41060a744ab0b7ae; });
$parcel$export(module.exports, "Y100", function () { return $d5537d8843c9b56b$export$1cc05bbbf340e559; });
$parcel$export(module.exports, "Y200", function () { return $d5537d8843c9b56b$export$5aae31392d72caaa; });
$parcel$export(module.exports, "G75", function () { return $d5537d8843c9b56b$export$69a3bf21b9686c2b; });
$parcel$export(module.exports, "G100", function () { return $d5537d8843c9b56b$export$afbce1382ec95f73; });
$parcel$export(module.exports, "G200", function () { return $d5537d8843c9b56b$export$747d86715d4175de; });
$parcel$export(module.exports, "G500", function () { return $d5537d8843c9b56b$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $d5537d8843c9b56b$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $d5537d8843c9b56b$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $d5537d8843c9b56b$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $d5537d8843c9b56b$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $d5537d8843c9b56b$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $d5537d8843c9b56b$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $d5537d8843c9b56b$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "P50", function () { return $d5537d8843c9b56b$export$363e4475840015bb; });
$parcel$export(module.exports, "P75", function () { return $d5537d8843c9b56b$export$4b0a4417ed59760f; });
$parcel$export(module.exports, "P100", function () { return $d5537d8843c9b56b$export$6011520a64d9a187; });
$parcel$export(module.exports, "P500", function () { return $d5537d8843c9b56b$export$147899de772240ec; });
$parcel$export(module.exports, "T75", function () { return $d5537d8843c9b56b$export$7a8f4d33f6f9772c; });
$parcel$export(module.exports, "T100", function () { return $d5537d8843c9b56b$export$776c9c497ef08533; });
$parcel$export(module.exports, "T200", function () { return $d5537d8843c9b56b$export$69cb3ca10c1e330e; });
$parcel$export(module.exports, "N0", function () { return $d5537d8843c9b56b$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $d5537d8843c9b56b$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $d5537d8843c9b56b$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $d5537d8843c9b56b$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N50", function () { return $d5537d8843c9b56b$export$8754fc7e6d8b3000; });
$parcel$export(module.exports, "N300", function () { return $d5537d8843c9b56b$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N400", function () { return $d5537d8843c9b56b$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $d5537d8843c9b56b$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $d5537d8843c9b56b$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $d5537d8843c9b56b$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $d5537d8843c9b56b$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $d5537d8843c9b56b$export$920c0d5c49070351; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $d5537d8843c9b56b$export$4b84fd0e2c617bd = '#FFEBE6';
var $d5537d8843c9b56b$export$b34b069eff244586 = '#FFBDAD';
var $d5537d8843c9b56b$export$be802dd0d8b57f35 = '#FF8F73';
var $d5537d8843c9b56b$export$60847d42f9da92a6 = '#FF7452';
var $d5537d8843c9b56b$export$4a7404f376229999 = '#FF5630';
var $d5537d8843c9b56b$export$2010d0fb4295b346 = '#DE350B';
var $d5537d8843c9b56b$export$2837b5a1a71d5c02 = '#BF2600';
var $d5537d8843c9b56b$export$8d9596b529bbb9cf = '#FFFAE6';
var $d5537d8843c9b56b$export$41060a744ab0b7ae = '#FFF0B3';
var $d5537d8843c9b56b$export$1cc05bbbf340e559 = '#FFE380';
var $d5537d8843c9b56b$export$5aae31392d72caaa = '#FFC400';
var $d5537d8843c9b56b$export$c6930421db9fa514 = '#FFAB00';
var $d5537d8843c9b56b$export$59619663aa6500fb = '#FF991F';
var $d5537d8843c9b56b$export$874739ea9e379ab6 = '#FF8B00';
var $d5537d8843c9b56b$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $d5537d8843c9b56b$export$69a3bf21b9686c2b = '#ABF5D1';
var $d5537d8843c9b56b$export$afbce1382ec95f73 = '#79F2C0';
var $d5537d8843c9b56b$export$747d86715d4175de = '#57D9A3';
var $d5537d8843c9b56b$export$940e1f69e873f202 = '#36B37E';
var $d5537d8843c9b56b$export$a49394138f7b8e85 = '#00875A';
var $d5537d8843c9b56b$export$6fa04827ac68a4fb = '#006644';
var $d5537d8843c9b56b$export$226de0355ed012f8 = '#DEEBFF';
var $d5537d8843c9b56b$export$8c13c2ee36917869 = '#B3D4FF';
var $d5537d8843c9b56b$export$ecfc1dff386a3e7a = '#4C9AFF';
var $d5537d8843c9b56b$export$215b7063051591f1 = '#2684FF';
var $d5537d8843c9b56b$export$e62e8919cca44969 = '#0065FF';
var $d5537d8843c9b56b$export$b3de0ae08da2ce64 = '#0052CC';
var $d5537d8843c9b56b$export$a6ee3d71bc067634 = '#0747A6';
var $d5537d8843c9b56b$export$67f15409e87642a1 = '#669DF1';
var $d5537d8843c9b56b$export$f0539dbc42dbb067 = '#8FB8F6';
var $d5537d8843c9b56b$export$363e4475840015bb = '#EAE6FF';
var $d5537d8843c9b56b$export$4b0a4417ed59760f = '#C0B6F2';
var $d5537d8843c9b56b$export$6011520a64d9a187 = '#998DD9';
var $d5537d8843c9b56b$export$a7175d4e9206bc80 = '#8777D9';
var $d5537d8843c9b56b$export$b48405b95304b5a1 = '#6554C0';
var $d5537d8843c9b56b$export$c71e4279dd54a18d = '#5243AA';
var $d5537d8843c9b56b$export$147899de772240ec = '#403294';
var $d5537d8843c9b56b$export$2cf711fe14c66f06 = '#E6FCFF';
var $d5537d8843c9b56b$export$7a8f4d33f6f9772c = '#B3F5FF';
var $d5537d8843c9b56b$export$776c9c497ef08533 = '#79E2F2';
var $d5537d8843c9b56b$export$69cb3ca10c1e330e = '#00C7E6';
var $d5537d8843c9b56b$export$9dc1ef0f3f48059b = '#00B8D9';
var $d5537d8843c9b56b$export$7c835c78b6fcdef8 = '#00A3BF';
var $d5537d8843c9b56b$export$6036577f95c3877e = '#008DA6';
var $d5537d8843c9b56b$export$29a4f05edc054374 = '#FFFFFF';
var $d5537d8843c9b56b$export$e655ef011c4aa1a2 = '#FAFBFC';
var $d5537d8843c9b56b$export$9fdfb749e33cdf97 = '#F4F5F7';
var $d5537d8843c9b56b$export$3e51e8f1440314ba = '#EBECF0';
var $d5537d8843c9b56b$export$1ce2d1575d444ceb = '#DFE1E6';
var $d5537d8843c9b56b$export$8754fc7e6d8b3000 = '#C1C7D0';
var $d5537d8843c9b56b$export$c2e91cbeada39b8b = '#B3BAC5';
var $d5537d8843c9b56b$export$5f71e19f3a7ad9de = '#A5ADBA';
var $d5537d8843c9b56b$export$eaa8c8a70ac22806 = '#97A0AF';
var $d5537d8843c9b56b$export$7c87d337fb91a97d = '#8993A4';
var $d5537d8843c9b56b$export$d6447c357493214f = '#7A869A';
var $d5537d8843c9b56b$export$f563ee71e9ee74cd = '#6B778C';
var $d5537d8843c9b56b$export$e2ef2124cf4024b1 = '#5E6C84';
var $d5537d8843c9b56b$export$eece5f492e429f08 = '#505F79';
var $d5537d8843c9b56b$export$c39c0fe0f26207ae = '#42526E';
var $d5537d8843c9b56b$export$7090862dc3038a9f = '#344563';
var $d5537d8843c9b56b$export$ad0bacf983b7ddaa = '#253858';
var $d5537d8843c9b56b$export$7d61b15e0da132af = '#172B4D';
var $d5537d8843c9b56b$export$fbda843f0a27fe96 = '#091E42';
var $d5537d8843c9b56b$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $d5537d8843c9b56b$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $d5537d8843c9b56b$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $d5537d8843c9b56b$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $d5537d8843c9b56b$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $d5537d8843c9b56b$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $d5537d8843c9b56b$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $d5537d8843c9b56b$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $d5537d8843c9b56b$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $d5537d8843c9b56b$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $d5537d8843c9b56b$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $d5537d8843c9b56b$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $d5537d8843c9b56b$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $d5537d8843c9b56b$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $d5537d8843c9b56b$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $d5537d8843c9b56b$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $d5537d8843c9b56b$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $d5537d8843c9b56b$export$2f6319cf7d736c2a = '#E6EDFA';
var $d5537d8843c9b56b$export$95126bc8884d6634 = '#DCE5F5';
var $d5537d8843c9b56b$export$8338d8c35d44ff1 = '#CED9EB';
var $d5537d8843c9b56b$export$5368d76ae4fbbda7 = '#B8C7E0';
var $d5537d8843c9b56b$export$9f0a771d16ec8d36 = '#ABBBD6';
var $d5537d8843c9b56b$export$abcf8c38338b4aa5 = '#9FB0CC';
var $d5537d8843c9b56b$export$97e81faa16a182c7 = '#8C9CB8';
var $d5537d8843c9b56b$export$bfe21c59123ecf33 = '#7988A3';
var $d5537d8843c9b56b$export$ee82aa2ea6a1558 = '#67758F';
var $d5537d8843c9b56b$export$682927c6ed76be02 = '#56637A';
var $d5537d8843c9b56b$export$91fd9994c5be9757 = '#455166';
var $d5537d8843c9b56b$export$d281fbfe3cff2df6 = '#3B475C';
var $d5537d8843c9b56b$export$3902c91d8b98a753 = '#313D52';
var $d5537d8843c9b56b$export$8e8133c1ba5845b5 = '#283447';
var $d5537d8843c9b56b$export$33ff357f6620b39 = '#202B3D';
var $d5537d8843c9b56b$export$633847cf062b69e0 = '#1B2638';
var $d5537d8843c9b56b$export$9776a6e503bdbf76 = '#121A29';
var $d5537d8843c9b56b$export$6c813d5160dff5db = '#0E1624';
var $d5537d8843c9b56b$export$3d4f271a500072a = '#0D1424';
var $d5537d8843c9b56b$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $d5537d8843c9b56b$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $d5537d8843c9b56b$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $d5537d8843c9b56b$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $d5537d8843c9b56b$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $d5537d8843c9b56b$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $d5537d8843c9b56b$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $d5537d8843c9b56b$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $d5537d8843c9b56b$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $d5537d8843c9b56b$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $d5537d8843c9b56b$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $d5537d8843c9b56b$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $d5537d8843c9b56b$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $d5537d8843c9b56b$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $d5537d8843c9b56b$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $d5537d8843c9b56b$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $d5537d8843c9b56b$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $d5537d8843c9b56b$export$d2adc5dedf09fced = '#292A2E';
var $d5537d8843c9b56b$export$f51762073d2bb381 = '#94C748';
var $d5537d8843c9b56b$export$95e26d54def96891 = '#B3DF72';

});



parcelRegister("jvk02", function(module, exports) {
$parcel$export(module.exports, "textColors", function () { return $e3306d1837a548cc$export$daa0ace263cb20d2; });
$parcel$export(module.exports, "borderColors", function () { return $e3306d1837a548cc$export$1c1b571cf296eca7; });
$parcel$export(module.exports, "textHoverColors", function () { return $e3306d1837a548cc$export$7c7104a5f052cab7; });
$parcel$export(module.exports, "textActiveColors", function () { return $e3306d1837a548cc$export$382469baad253eb7; });
$parcel$export(module.exports, "backgroundColors", function () { return $e3306d1837a548cc$export$b9d7c59a579c23c6; });
$parcel$export(module.exports, "linkHoverBackgroundColors", function () { return $e3306d1837a548cc$export$4410079763249c74; });
$parcel$export(module.exports, "linkActiveBackgroundColors", function () { return $e3306d1837a548cc$export$76be99c5e13e3566; });
$parcel$export(module.exports, "focusRingColors", function () { return $e3306d1837a548cc$export$2a31dbe82788f940; });
$parcel$export(module.exports, "borderRadius", function () { return $e3306d1837a548cc$export$7a57f79000377ca2; });
$parcel$export(module.exports, "removeButtonColors", function () { return $e3306d1837a548cc$export$f64c7641cbc22da7; });
$parcel$export(module.exports, "removeButtonHoverColors", function () { return $e3306d1837a548cc$export$b03fbc2a369c563e; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $ijwRl = parcelRequire("ijwRl");

var $e2mca = parcelRequire("e2mca");
var $e3306d1837a548cc$export$daa0ace263cb20d2 = {
    standard: "var(--ds-text, ".concat($ijwRl.N700, ")"),
    standardLink: "var(--ds-link, ".concat($ijwRl.B400, ")"),
    blue: "var(--ds-text-accent-blue-bolder, ".concat($ijwRl.N800, ")"),
    red: "var(--ds-text-accent-red-bolder, ".concat($ijwRl.N800, ")"),
    yellow: "var(--ds-text-accent-yellow-bolder, ".concat($ijwRl.N800, ")"),
    green: "var(--ds-text-accent-green-bolder, ".concat($ijwRl.N800, ")"),
    teal: "var(--ds-text-accent-teal-bolder, ".concat($ijwRl.N800, ")"),
    purple: "var(--ds-text-accent-purple-bolder, ".concat($ijwRl.N800, ")"),
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, ".concat($ijwRl.N0, ")"),
    blueLight: "var(--ds-text-accent-blue, ".concat($ijwRl.B500, ")"),
    redLight: "var(--ds-text-accent-red, ".concat($ijwRl.N500, ")"),
    yellowLight: "var(--ds-text-accent-yellow, ".concat($ijwRl.N500, ")"),
    greenLight: "var(--ds-text-accent-green, ".concat($ijwRl.G500, ")"),
    tealLight: "var(--ds-text-accent-teal, ".concat($ijwRl.N500, ")"),
    purpleLight: "var(--ds-text-accent-purple, ".concat($ijwRl.P500, ")"),
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, ".concat($ijwRl.N500, ")")
};
var $e3306d1837a548cc$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
var $e3306d1837a548cc$export$7c7104a5f052cab7 = {
    standard: "var(--ds-link, ".concat($ijwRl.B300, ")"),
    blue: "var(--ds-text-accent-blue-bolder, ".concat($ijwRl.N800, ")"),
    red: "var(--ds-text-accent-red-bolder, ".concat($ijwRl.N800, ")"),
    yellow: "var(--ds-text-accent-yellow-bolder, ".concat($ijwRl.N800, ")"),
    green: "var(--ds-text-accent-green-bolder, ".concat($ijwRl.N800, ")"),
    teal: "var(--ds-text-accent-teal-bolder, ".concat($ijwRl.N800, ")"),
    purple: "var(--ds-text-accent-purple-bolder, ".concat($ijwRl.N800, ")"),
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, ".concat($ijwRl.N0, ")"),
    blueLight: "var(--ds-text-accent-blue, ".concat($ijwRl.B500, ")"),
    redLight: "var(--ds-text-accent-red, ".concat($ijwRl.N500, ")"),
    yellowLight: "var(--ds-text-accent-yellow, ".concat($ijwRl.N500, ")"),
    greenLight: "var(--ds-text-accent-green, ".concat($ijwRl.G500, ")"),
    tealLight: "var(--ds-text-accent-teal, ".concat($ijwRl.N500, ")"),
    purpleLight: "var(--ds-text-accent-purple, ".concat($ijwRl.P500, ")"),
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, ".concat($ijwRl.N500, ")")
};
var $e3306d1837a548cc$export$382469baad253eb7 = {
    standard: "var(--ds-link-pressed, ".concat($ijwRl.B300, ")"),
    blue: "var(--ds-text-accent-blue, ".concat($ijwRl.N800, ")"),
    red: "var(--ds-text-accent-red, ".concat($ijwRl.N800, ")"),
    yellow: "var(--ds-text-accent-yellow, ".concat($ijwRl.N800, ")"),
    green: "var(--ds-text-accent-green, ".concat($ijwRl.N800, ")"),
    teal: "var(--ds-text-accent-teal, ".concat($ijwRl.N800, ")"),
    purple: "var(--ds-text-accent-purple, ".concat($ijwRl.N800, ")"),
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: "var(--ds-text-accent-gray, ".concat($ijwRl.N0, ")"),
    blueLight: "var(--ds-text-accent-blue-bolder, ".concat($ijwRl.B500, ")"),
    redLight: "var(--ds-text-accent-red-bolder, ".concat($ijwRl.N500, ")"),
    yellowLight: "var(--ds-text-accent-yellow-bolder, ".concat($ijwRl.N500, ")"),
    greenLight: "var(--ds-text-accent-green-bolder, ".concat($ijwRl.G500, ")"),
    tealLight: "var(--ds-text-accent-teal-bolder, ".concat($ijwRl.N500, ")"),
    purpleLight: "var(--ds-text-accent-purple-bolder, ".concat($ijwRl.P500, ")"),
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: "var(--ds-text-accent-gray-bolder, ".concat($ijwRl.N500, ")")
};
var $e3306d1837a548cc$export$b9d7c59a579c23c6 = {
    standard: "var(--ds-background-neutral, ".concat($ijwRl.N20, ")"),
    blue: "var(--ds-background-accent-blue-subtle, ".concat($ijwRl.B100, ")"),
    red: "var(--ds-background-accent-red-subtle, ".concat($ijwRl.R100, ")"),
    yellow: "var(--ds-background-accent-yellow-subtle, ".concat($ijwRl.Y200, ")"),
    green: "var(--ds-background-accent-green-subtle, ".concat($ijwRl.G200, ")"),
    teal: "var(--ds-background-accent-teal-subtle, ".concat($ijwRl.T200, ")"),
    purple: "var(--ds-background-accent-purple-subtle, ".concat($ijwRl.P100, ")"),
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: "var(--ds-background-accent-gray-subtle, ".concat($ijwRl.N500, ")"),
    blueLight: "var(--ds-background-accent-blue-subtler, ".concat($ijwRl.B75, ")"),
    redLight: "var(--ds-background-accent-red-subtler, ".concat($ijwRl.R75, ")"),
    yellowLight: "var(--ds-background-accent-yellow-subtler, ".concat($ijwRl.Y100, ")"),
    greenLight: "var(--ds-background-accent-green-subtler, ".concat($ijwRl.G100, ")"),
    tealLight: "var(--ds-background-accent-teal-subtler, ".concat($ijwRl.T100, ")"),
    purpleLight: "var(--ds-background-accent-purple-subtler, ".concat($ijwRl.P75, ")"),
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: "var(--ds-background-accent-gray-subtler, ".concat($ijwRl.N30, ")")
};
var $e3306d1837a548cc$export$4410079763249c74 = {
    standard: "var(--ds-background-neutral-hovered, ".concat($ijwRl.N30, ")"),
    blue: "var(--ds-background-accent-blue-subtle-hovered, ".concat($ijwRl.B75, ")"),
    red: "var(--ds-background-accent-red-subtle-hovered, ".concat($ijwRl.R75, ")"),
    yellow: "var(--ds-background-accent-yellow-subtle-hovered, ".concat($ijwRl.Y100, ")"),
    green: "var(--ds-background-accent-green-subtle-hovered, ".concat($ijwRl.G100, ")"),
    teal: "var(--ds-background-accent-teal-subtle-hovered, ".concat($ijwRl.T100, ")"),
    purple: "var(--ds-background-accent-purple-subtle-hovered, ".concat($ijwRl.P75, ")"),
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: "var(--ds-background-accent-gray-subtle-hovered, ".concat($ijwRl.N400, ")"),
    blueLight: "var(--ds-background-accent-blue-subtler-hovered, ".concat($ijwRl.B50, ")"),
    redLight: "var(--ds-background-accent-red-subtler-hovered, ".concat($ijwRl.R50, ")"),
    yellowLight: "var(--ds-background-accent-yellow-subtler-hovered, ".concat($ijwRl.Y75, ")"),
    greenLight: "var(--ds-background-accent-green-subtler-hovered, ".concat($ijwRl.G75, ")"),
    tealLight: "var(--ds-background-accent-teal-subtler-hovered, ".concat($ijwRl.T75, ")"),
    purpleLight: "var(--ds-background-accent-purple-subtler-hovered, ".concat($ijwRl.P50, ")"),
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: "var(--ds-background-accent-gray-subtler-hovered, ".concat($ijwRl.N40, ")")
};
var $e3306d1837a548cc$export$76be99c5e13e3566 = {
    standard: "var(--ds-background-neutral-pressed, ".concat($ijwRl.N30, ")"),
    blue: "var(--ds-background-accent-blue-subtle-pressed, ".concat($ijwRl.B50, ")"),
    red: "var(--ds-background-accent-red-subtle-pressed, ".concat($ijwRl.R50, ")"),
    yellow: "var(--ds-background-accent-yellow-subtle-pressed, ".concat($ijwRl.Y75, ")"),
    green: "var(--ds-background-accent-green-subtle-pressed, ".concat($ijwRl.G75, ")"),
    teal: "var(--ds-background-accent-teal-subtle-pressed, ".concat($ijwRl.T75, ")"),
    purple: "var(--ds-background-accent-purple-subtle-pressed, ".concat($ijwRl.P50, ")"),
    grey: "var(--ds-background-accent-gray-subtle-pressed, ".concat($ijwRl.N300, ")"),
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: "var(--ds-background-accent-blue-subtler-pressed, ".concat($ijwRl.B100, ")"),
    redLight: "var(--ds-background-accent-red-subtler-pressed, ".concat($ijwRl.R100, ")"),
    yellowLight: "var(--ds-background-accent-yellow-subtler-pressed, ".concat($ijwRl.Y200, ")"),
    greenLight: "var(--ds-background-accent-green-subtler-pressed, ".concat($ijwRl.G200, ")"),
    tealLight: "var(--ds-background-accent-teal-subtler-pressed, ".concat($ijwRl.T200, ")"),
    purpleLight: "var(--ds-background-accent-purple-subtler-pressed, ".concat($ijwRl.P100, ")"),
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: "var(--ds-background-accent-gray-subtler-pressed, ".concat($ijwRl.N50, ")")
};
var $e3306d1837a548cc$export$2a31dbe82788f940 = "var(--ds-border-focused, ".concat($ijwRl.B100, ")");
var $e3306d1837a548cc$export$7a57f79000377ca2 = {
    default: (0, $e2mca.defaultBorderRadius),
    rounded: (0, $e2mca.defaultRoundedBorderRadius)
};
var $e3306d1837a548cc$export$1202b7eb21da7b58 = "var(--ds-background-danger, ".concat($ijwRl.R50, ")");
var $e3306d1837a548cc$export$62ace793ebb16bda = "var(--ds-background-danger-hovered, ".concat($ijwRl.R50, ")");
var $e3306d1837a548cc$export$17d206ccea111bbb = "var(--ds-text-danger, ".concat($ijwRl.R500, ")");
var $e3306d1837a548cc$export$f64c7641cbc22da7 = {
    standard: "var(--ds-text, ".concat($ijwRl.N500, ")"),
    blue: "var(--ds-text-accent-blue-bolder, ".concat($ijwRl.N500, ")"),
    red: "var(--ds-text-accent-red-bolder, ".concat($ijwRl.N500, ")"),
    yellow: "var(--ds-text-accent-yellow-bolder, ".concat($ijwRl.N500, ")"),
    green: "var(--ds-text-accent-green-bolder, ".concat($ijwRl.N500, ")"),
    teal: "var(--ds-text-accent-teal-bolder, ".concat($ijwRl.N500, ")"),
    purple: "var(--ds-text-accent-purple-bolder, ".concat($ijwRl.N500, ")"),
    lime: "var(--ds-text-accent-lime-bolder, ".concat($ijwRl.N500, ")"),
    magenta: "var(--ds-text-accent-magenta-bolder, ".concat($ijwRl.N500, ")"),
    orange: "var(--ds-text-accent-orange-bolder, ".concat($ijwRl.N500, ")"),
    grey: "var(--ds-text-accent-gray-bolder, ".concat($ijwRl.N500, ")"),
    blueLight: "var(--ds-text-accent-blue, ".concat($ijwRl.N500, ")"),
    redLight: "var(--ds-text-accent-red, ".concat($ijwRl.N500, ")"),
    yellowLight: "var(--ds-text-accent-yellow, ".concat($ijwRl.N500, ")"),
    greenLight: "var(--ds-text-accent-green, ".concat($ijwRl.N500, ")"),
    tealLight: "var(--ds-text-accent-teal, ".concat($ijwRl.N500, ")"),
    purpleLight: "var(--ds-text-accent-purple, ".concat($ijwRl.N500, ")"),
    limeLight: "var(--ds-text-accent-lime, ".concat($ijwRl.N500, ")"),
    magentaLight: "var(--ds-text-accent-magenta, ".concat($ijwRl.N500, ")"),
    orangeLight: "var(--ds-text-accent-orange, ".concat($ijwRl.N500, ")"),
    greyLight: "var(--ds-text-accent-gray, ".concat($ijwRl.N500, ")")
};
var $e3306d1837a548cc$export$b03fbc2a369c563e = {
    standard: "var(--ds-text-danger, ".concat($ijwRl.N700, ")"),
    standardLink: "var(--ds-text-danger, ".concat($ijwRl.B400, ")"),
    blue: "var(--ds-text-danger, ".concat($ijwRl.N800, ")"),
    red: "var(--ds-text-danger, ".concat($ijwRl.N800, ")"),
    yellow: "var(--ds-text-danger, ".concat($ijwRl.N800, ")"),
    green: "var(--ds-text-danger, ".concat($ijwRl.N800, ")"),
    teal: "var(--ds-text-danger, ".concat($ijwRl.N800, ")"),
    purple: "var(--ds-text-danger, ".concat($ijwRl.N800, ")"),
    lime: "var(--ds-text-danger, ".concat($ijwRl.N800, ")"),
    magenta: "var(--ds-text-danger, ".concat($ijwRl.N800, ")"),
    orange: "var(--ds-text-danger, ".concat($ijwRl.N800, ")"),
    grey: "var(--ds-text-danger, ".concat($ijwRl.N0, ")"),
    blueLight: "var(--ds-text-danger, ".concat($ijwRl.B500, ")"),
    redLight: "var(--ds-text-danger, ".concat($ijwRl.N500, ")"),
    yellowLight: "var(--ds-text-danger, ".concat($ijwRl.N500, ")"),
    greenLight: "var(--ds-text-danger, ".concat($ijwRl.G500, ")"),
    tealLight: "var(--ds-text-danger, ".concat($ijwRl.N500, ")"),
    purpleLight: "var(--ds-text-danger, ".concat($ijwRl.P500, ")"),
    limeLight: "var(--ds-text-danger, ".concat($ijwRl.P500, ")"),
    magentaLight: "var(--ds-text-danger, ".concat($ijwRl.P500, ")"),
    orangeLight: "var(--ds-text-danger, ".concat($ijwRl.P500, ")"),
    greyLight: "var(--ds-text-danger, ".concat($ijwRl.N500, ")")
};

});


parcelRegister("1CePs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $12d4d7cbf74942df$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3dJ4i = parcelRequire("3dJ4i");

var $1ZmVc = parcelRequire("1ZmVc");

var $e2mca = parcelRequire("e2mca");
var $12d4d7cbf74942df$var$beforeElementStyles = (0, $3dJ4i.css)({
    display: 'flex',
    height: '16px',
    alignItems: 'center',
    justifyContent: 'center',
    insetBlockStart: "var(--ds-space-0, 0px)"
});
// To be removed with platform-component-visual-refresh (BLU-2992)
var $12d4d7cbf74942df$var$beforeElementStylesOld = (0, $3dJ4i.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(".concat((0, $e2mca.cssVar).borderRadius, ")"),
    insetBlockStart: "var(--ds-space-0, 0px)"
});
var $12d4d7cbf74942df$var$Before = function Before(_ref) {
    var elemBefore = _ref.elemBefore;
    return elemBefore ? (0, $3dJ4i.jsx)("span", {
        css: (0, $1ZmVc.fg)('platform-component-visual-refresh') ? $12d4d7cbf74942df$var$beforeElementStyles : $12d4d7cbf74942df$var$beforeElementStylesOld
    }, elemBefore) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$12d4d7cbf74942df$export$2e2bcd8739ae039 = $12d4d7cbf74942df$var$Before;

});

parcelRegister("4hQ8r", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $31f130e460423fee$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3dJ4i = parcelRequire("3dJ4i");

var $1ZmVc = parcelRequire("1ZmVc");

var $e2mca = parcelRequire("e2mca");
// To be removed with platform-component-visual-refresh (BLU-2992)
var $31f130e460423fee$var$baseStylesOld = (0, $3dJ4i.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $e2mca.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $e2mca.defaultTextPadding),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineStart: (0, $e2mca.defaultTextPadding),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $31f130e460423fee$var$baseStyles = (0, $3dJ4i.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $e2mca.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
// To be removed with platform-component-visual-refresh (BLU-2992)
var $31f130e460423fee$var$linkStylesOld = (0, $3dJ4i.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: "var(".concat((0, $e2mca.cssVar).color.text.link, ")"),
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: "var(".concat((0, $e2mca.cssVar).color.text.hover, ")"),
        textDecoration: 'underline'
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: "var(".concat((0, $e2mca.cssVar).color.text.active, ")"),
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
var $31f130e460423fee$var$linkStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text, #172B4D)",
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        color: "var(--ds-text, #172B4D)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-text, #172B4D)",
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
var $31f130e460423fee$var$hasAfterStylesOld = (0, $3dJ4i.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: "".concat((0, $e2mca.maxTextWidthUnitless) - (0, $e2mca.buttonWidthUnitless), "px"),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $e2mca.textPaddingRight)
});
var $31f130e460423fee$var$hasAfterStyles = (0, $3dJ4i.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: "".concat((0, $e2mca.maxTextWidthUnitless) - (0, $e2mca.buttonWidthUnitless), "px")
});
// To be removed with platform-component-visual-refresh (BLU-2992)
var $31f130e460423fee$var$hasBeforeStyles = (0, $3dJ4i.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: (0, $e2mca.textMarginLeft)
});
var $31f130e460423fee$var$Content = function Content(_ref) {
    var _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, linkComponent = _ref.linkComponent;
    var Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : 'a';
    if (href) return (0, $3dJ4i.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            (0, $1ZmVc.fg)('platform-component-visual-refresh') ? $31f130e460423fee$var$baseStyles : $31f130e460423fee$var$baseStylesOld,
            (0, $1ZmVc.fg)('platform-component-visual-refresh') ? $31f130e460423fee$var$linkStyles : $31f130e460423fee$var$linkStylesOld,
            !(0, $1ZmVc.fg)('platform-component-visual-refresh') && elemBefore && $31f130e460423fee$var$hasBeforeStyles,
            isRemovable && (0, $1ZmVc.fg)('platform-component-visual-refresh') ? $31f130e460423fee$var$hasAfterStyles : undefined,
            isRemovable && !(0, $1ZmVc.fg)('platform-component-visual-refresh') ? $31f130e460423fee$var$hasAfterStylesOld : undefined
        ]
    }, text);
    else return (0, $3dJ4i.jsx)("span", {
        css: [
            (0, $1ZmVc.fg)('platform-component-visual-refresh') ? $31f130e460423fee$var$baseStyles : $31f130e460423fee$var$baseStylesOld,
            !(0, $1ZmVc.fg)('platform-component-visual-refresh') && elemBefore && $31f130e460423fee$var$hasBeforeStyles,
            isRemovable && (0, $1ZmVc.fg)('platform-component-visual-refresh') ? $31f130e460423fee$var$hasAfterStyles : undefined,
            isRemovable && !(0, $1ZmVc.fg)('platform-component-visual-refresh') ? $31f130e460423fee$var$hasAfterStylesOld : undefined
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$31f130e460423fee$export$2e2bcd8739ae039 = $31f130e460423fee$var$Content;

});




parcelRegister("5Ebnt", function(module, exports) {
$parcel$export(module.exports, "TabSelector", function () { return (parcelRequire("dM6iN")).TabSelector; });

var $dM6iN = parcelRequire("dM6iN");

});
parcelRegister("dM6iN", function(module, exports) {
$parcel$export(module.exports, "TabSelector", function () { return $27362bc4bcd19398$export$a3a7254f7f149b03; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $79ZK0 = parcelRequire("79ZK0");
parcelRequire("gXU9p");
var $1LM8l = parcelRequire("1LM8l");

var $hNLAh = parcelRequire("hNLAh");
const $27362bc4bcd19398$export$a3a7254f7f149b03 = ({ currentTab: currentTab, tabs: tabs, onTabSelect: onTabSelect })=>{
    const { sendResourceFilterClickUIEvent: sendResourceFilterClickUIEvent } = (0, $1LM8l.useResourcesPageUIAnalytics)();
    const handleTabSelect = (tabId)=>{
        onTabSelect(tabId);
        sendResourceFilterClickUIEvent(tabId);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $79ZK0.default), {
        alignBlock: "center",
        space: "space.100",
        shouldWrap: true,
        children: tabs.map((tab)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $hNLAh.TabPill), {
                icon: tab.icon,
                text: tab.text,
                isSelected: tab.id === currentTab,
                onSelect: ()=>handleTabSelect(tab.id)
            }, tab.id))
    });
};

});
parcelRegister("hNLAh", function(module, exports) {
$parcel$export(module.exports, "TabPill", function () { return $9eef1d1ba939d1d1$export$78d1357ca0402517; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $79ZK0 = parcelRequire("79ZK0");
var $4DkqQ = parcelRequire("4DkqQ");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");

var $lP7A9 = parcelRequire("lP7A9");
const $9eef1d1ba939d1d1$var$tabPillCommonStyle = (0, $f6YGh.xcss)({
    "borderRadius": "90px",
    "padding": "unset",
    "border": `1px solid ${(0, $lP7A9.default)("color.background.neutral")}`,
    ":focus": {
        outlineColor: "color.border.focused",
        outlineWidth: "border.width.focused",
        outlineStyle: "solid"
    }
});
const $9eef1d1ba939d1d1$var$tabPillSelectedStyle = (0, $f6YGh.xcss)({
    "borderWidth": "border.width",
    "borderStyle": "solid",
    "borderColor": "color.border.selected",
    "color": "color.text.brand",
    "backgroundColor": "color.background.selected",
    ":hover": {
        backgroundColor: "color.background.selected.hovered"
    }
});
const $9eef1d1ba939d1d1$var$tabPillDefaultStyle = (0, $f6YGh.xcss)({
    "color": "color.text",
    "backgroundColor": "color.background.neutral",
    ":hover": {
        backgroundColor: "color.background.neutral.hovered"
    }
});
const $9eef1d1ba939d1d1$var$tabPillContentStyle = (0, $f6YGh.xcss)({
    height: "32px",
    paddingBlock: "space.075",
    paddingInline: "space.150"
});
const $9eef1d1ba939d1d1$export$78d1357ca0402517 = ({ icon: icon, text: text, isSelected: isSelected = false, onSelect: onSelect })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4DkqQ.default), {
        xcss: [
            $9eef1d1ba939d1d1$var$tabPillCommonStyle,
            isSelected ? $9eef1d1ba939d1d1$var$tabPillSelectedStyle : $9eef1d1ba939d1d1$var$tabPillDefaultStyle
        ],
        onClick: onSelect,
        role: "tab",
        "aria-selected": isSelected,
        "aria-controls": intl.formatMessage(text),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
            alignBlock: "center",
            xcss: $9eef1d1ba939d1d1$var$tabPillContentStyle,
            space: "space.050",
            children: [
                icon,
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                    color: isSelected ? "color.text.brand" : "color.text",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, text))
                })
            ]
        })
    });
};

});
parcelRegister("4DkqQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $35faa748cf73932f$export$2e2bcd8739ae039; });

var $45ahP = parcelRequire("45ahP");

var $7NMHB = parcelRequire("7NMHB");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $2mFjt = parcelRequire("2mFjt");

var $7uNuF = parcelRequire("7uNuF");

var $etBkE = parcelRequire("etBkE");

var $ahhSJ = parcelRequire("ahhSJ");

var $f6YGh = parcelRequire("f6YGh");
var $35faa748cf73932f$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $35faa748cf73932f$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $35faa748cf73932f$var$focusRingStyles = (0, $3dJ4i.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $ahhSJ.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $ahhSJ.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $ahhSJ.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $35faa748cf73932f$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $35faa748cf73932f$var$enabledStyles = (0, $3dJ4i.css)({
    cursor: 'pointer'
});
var $35faa748cf73932f$var$disabledStyles = (0, $3dJ4i.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $35faa748cf73932f$var$Pressable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $7uNuF.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $7NMHB.default)(_ref, $35faa748cf73932f$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $etBkE.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $2mFjt.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "14.8.3",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $7NMHB.default)(htmlAttributes, $35faa748cf73932f$var$_excluded2);
    var resolvedStyles = (0, $f6YGh.parseXcss)(xcss);
    return (0, $3dJ4i.jsx)("button", (0, $45ahP.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $35faa748cf73932f$var$baseStyles,
            $35faa748cf73932f$var$focusRingStyles,
            isDisabled ? $35faa748cf73932f$var$disabledStyles : $35faa748cf73932f$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $ahhSJ.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $ahhSJ.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $ahhSJ.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $ahhSJ.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $ahhSJ.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $ahhSJ.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $ahhSJ.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $ahhSJ.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
});
var $35faa748cf73932f$export$2e2bcd8739ae039 = $35faa748cf73932f$var$Pressable;

});






parcelRegister("3LMg6", function(module, exports) {
$parcel$export(module.exports, "FastshiftMigrationsManagementPage", function () { return (parcelRequire("drJeJ")).FastshiftMigrationsManagementPage; });
parcelRequire("538gg");
var $drJeJ = parcelRequire("drJeJ");

});
parcelRegister("538gg", function(module, exports) {
$parcel$export(module.exports, "FastshiftMigrationsManagementPage", function () { return (parcelRequire("drJeJ")).FastshiftMigrationsManagementPage; });

var $drJeJ = parcelRequire("drJeJ");

});
parcelRegister("drJeJ", function(module, exports) {
$parcel$export(module.exports, "FastshiftMigrationsManagementPage", function () { return $86cb780e26e9545c$export$47413fb85996cfab; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $jwXhl = parcelRequire("jwXhl");

var $dTJrO = parcelRequire("dTJrO");

var $dl4xv = parcelRequire("dl4xv");
var $6upp0 = parcelRequire("6upp0");

var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");

var $4jcRW = parcelRequire("4jcRW");
parcelRequire("z8fwG");
var $1NoJu = parcelRequire("1NoJu");

var $fq4go = parcelRequire("fq4go");

var $8Bmsc = parcelRequire("8Bmsc");

var $f7YG8 = parcelRequire("f7YG8");

var $PE2DD = parcelRequire("PE2DD");
parcelRequire("iVqTa");
var $c26x0 = parcelRequire("c26x0");
parcelRequire("7ruKO");
var $eqnO8 = parcelRequire("eqnO8");
var $8SFpL = parcelRequire("8SFpL");
var $aJQLC = parcelRequire("aJQLC");
parcelRequire("kx6Ht");
var $32pHP = parcelRequire("32pHP");
parcelRequire("gcyiK");
var $jLWW0 = parcelRequire("jLWW0");

var $j571n = parcelRequire("j571n");
const $86cb780e26e9545c$var$appEnvironment = "production";
const $86cb780e26e9545c$var$MigrationPlannerIntegration = ()=>{
    const intl = (0, $8e22h.default)();
    const cardClient = new (0, $dl4xv.default)($86cb780e26e9545c$var$appEnvironment, `${(0, $fq4go.BASE_URL)}/gateway/api`);
    const { data: engagementData, error: engagementError, pending: engagementPending } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomainEngagement);
    (0, $32pHP.useMigrationsManagementPageAnalytics)();
    const { domainId: domainId } = (0, $jwXhl.useParams)();
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const dispatch = (0, $f7YG8.useFastshiftDispatch)();
    const handleRefreshEngagementEndpoint = ()=>{
        dispatch($8Bmsc.getCustomerDomainEngagementDetails({
            stargateClient: stargateClient,
            customerDomainId: domainId || ""
        }));
    };
    if (engagementPending) return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                height: "650px",
                width: "100%",
                testId: "migration-planner-loading-skeleton",
                isShimmering: true
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                height: "90px",
                width: "100%",
                testId: "confluence-card-skeleton",
                isShimmering: true
            })
        ]
    });
    if (engagementError) switch(engagementError){
        case (0, $PE2DD.CustomerDomainEngagementExpectedError).NO_ENGAGEMENT:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8SFpL.NoEngagementErrorDisplay), {});
        case (0, $PE2DD.CustomerDomainEngagementExpectedError).USER_NOT_PROVISIONED:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aJQLC.UserNotProvisionedErrorDisplay), {});
        case (0, $PE2DD.CustomerDomainEngagementExpectedError).NO_ACCESS:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eqnO8.NoAccessErrorDisplay), {});
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NoJu.GenericErrorDisplay), {
                onRefresh: handleRefreshEngagementEndpoint,
                customMessage: intl.formatMessage((0, $j571n.messages).genericErrorDescription)
            });
    }
    if (!engagementData) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NoJu.GenericErrorDisplay), {
        onRefresh: handleRefreshEngagementEndpoint,
        customMessage: intl.formatMessage((0, $j571n.messages).genericErrorDescription)
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6upp0.SmartCardProvider), {
        client: cardClient,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jLWW0.JiraEmbeddedBoardSection), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $c26x0.ConfluenceCardLinkSection), {})
        ]
    });
};
const $86cb780e26e9545c$export$47413fb85996cfab = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
        space: "space.300",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                        size: "large",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $j571n.messages).pageHeading))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $j571n.messages).pageHeadingSubtext))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($86cb780e26e9545c$var$MigrationPlannerIntegration, {})
        ]
    });
};

});
parcelRegister("dl4xv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9b60c1f284cf0e4f$export$2e2bcd8739ae039; });

var $kQTxo = parcelRequire("kQTxo");

var $5fJwK = parcelRequire("5fJwK");

var $7vPd4 = parcelRequire("7vPd4");

var $aBFyY = parcelRequire("aBFyY");

var $aU64m = parcelRequire("aU64m");

var $fmKqJ = parcelRequire("fmKqJ");

var $35hqc = parcelRequire("35hqc");

var $8PYfA = parcelRequire("8PYfA");

var $2EIP6 = parcelRequire("2EIP6");

var $hMsf5 = parcelRequire("hMsf5");

var $8S7b4 = parcelRequire("8S7b4");

var $hxnsV = parcelRequire("hxnsV");

var $2v440 = parcelRequire("2v440");
var $9IyXd = parcelRequire("9IyXd");
var $9ORHy = parcelRequire("9ORHy");
var $dtL2d = parcelRequire("dtL2d");

var $lK1WF = parcelRequire("lK1WF");

var $kmuml = parcelRequire("kmuml");

var $5K7uW = parcelRequire("5K7uW");

var $39c3M = parcelRequire("39c3M");
var $9b60c1f284cf0e4f$var$_excluded = [
    "error"
];
function $9b60c1f284cf0e4f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9b60c1f284cf0e4f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9b60c1f284cf0e4f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $35hqc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9b60c1f284cf0e4f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9b60c1f284cf0e4f$var$MAX_BATCH_SIZE = 50;
var $9b60c1f284cf0e4f$var$MIN_TIME_BETWEEN_BATCHES = 250;
var $9b60c1f284cf0e4f$var$URL_RESPONSE_CACHE_SIZE = 100;
var $9b60c1f284cf0e4f$export$d6a66073b5d79eb3 = new (0, $kmuml.LRUMap)($9b60c1f284cf0e4f$var$URL_RESPONSE_CACHE_SIZE);
var $9b60c1f284cf0e4f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function CardClient(envKey, baseUrlOverride) {
        var _this = this;
        (0, $aU64m.default)(this, CardClient);
        (0, $35hqc.default)(this, "postBatchResolveNew", /*#__PURE__*/ function() {
            var _ref = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee(resources, resourceType, keyGetter) {
                var deDuplicatedResources, resolvedResources, headers, map, i, resource, data;
                return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            // De-duplicate requested URLs (see `this.createLoader` for more detail).
                            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
                            deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($5K7uW)))(resources, keyGetter);
                            resolvedResources = [];
                            headers = $9b60c1f284cf0e4f$var$_objectSpread($9b60c1f284cf0e4f$var$_objectSpread({
                                /**
                 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
                 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
                 */ 'origin-timezone': Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat().resolvedOptions().timeZone
                            }, _this.product ? {
                                'X-Product': _this.product
                            } : {}), (0, $hMsf5.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && _this.headers ? _this.headers : {});
                            _context.prev = 3;
                            if (!(resourceType === 'URL')) {
                                _context.next = 8;
                                break;
                            }
                            _context.next = 7;
                            return (0, $dtL2d.request)('post', "".concat(_this.resolverUrl, "/resolve/batch"), deDuplicatedResources, headers);
                        case 7:
                            resolvedResources = _context.sent;
                        case 8:
                            if (!(resourceType === 'ARI')) {
                                _context.next = 12;
                                break;
                            }
                            _context.next = 11;
                            return (0, $dtL2d.request)('post', "".concat(_this.resolverUrl, "/resolve/ari/batch"), deDuplicatedResources, headers);
                        case 11:
                            resolvedResources = _context.sent;
                        case 12:
                            _context.next = 17;
                            break;
                        case 14:
                            _context.prev = 14;
                            _context.t0 = _context["catch"](3);
                            // we make sure we return a valid dataloader response by creating an error
                            // response for each url/ari
                            resolvedResources = resources.map(function() {
                                // @ts-ignore
                                var status = (0, $lK1WF.isErrorResponse)(_context.t0) ? _context.t0.status : 500;
                                var errorResponse = {
                                    status: status,
                                    // @ts-ignore
                                    error: _context.t0
                                };
                                return errorResponse;
                            });
                        case 17:
                            // Reduce into a map to make accessing faster and easier.
                            map = {}; // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
                            for(i = 0; i < deDuplicatedResources.length; ++i){
                                resource = deDuplicatedResources[i];
                                data = resolvedResources[i];
                                map[keyGetter(resource)] = data;
                            }
                            // Reconvert list back into the original order in which it was given to us.
                            return _context.abrupt("return", resources.map(function(originalResource) {
                                return map[keyGetter(originalResource)];
                            }));
                        case 20:
                        case "end":
                            return _context.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        14
                    ]
                ]);
            }));
            return function(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            };
        }());
        (0, $35hqc.default)(this, "postBatchResolve", /*#__PURE__*/ function() {
            var _ref2 = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee2(resources) {
                var resourceType, deDuplicatedResources, resolvedResources, headers, map, i, resource, data, _args2 = arguments;
                return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            resourceType = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'URL';
                            // De-duplicate requested URLs (see `this.createLoader` for more detail).
                            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
                            deDuplicatedResources = (0, $7vPd4.default)(new Set(resources));
                            resolvedResources = [];
                            headers = $9b60c1f284cf0e4f$var$_objectSpread($9b60c1f284cf0e4f$var$_objectSpread({
                                /**
                 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
                 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
                 */ 'origin-timezone': Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat().resolvedOptions().timeZone
                            }, _this.product ? {
                                'X-Product': _this.product
                            } : {}), (0, $hMsf5.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && _this.headers ? _this.headers : {});
                            _context2.prev = 4;
                            if (!(resourceType === 'URL')) {
                                _context2.next = 9;
                                break;
                            }
                            _context2.next = 8;
                            return (0, $dtL2d.request)('post', "".concat(_this.resolverUrl, "/resolve/batch"), deDuplicatedResources.map(function(resourceUrl) {
                                return {
                                    resourceUrl: resourceUrl
                                };
                            }), headers);
                        case 8:
                            resolvedResources = _context2.sent;
                        case 9:
                            if (!(resourceType === 'ARI')) {
                                _context2.next = 13;
                                break;
                            }
                            _context2.next = 12;
                            return (0, $dtL2d.request)('post', "".concat(_this.resolverUrl, "/resolve/ari/batch"), deDuplicatedResources.map(function(ari) {
                                return {
                                    ari: ari
                                };
                            }), headers);
                        case 12:
                            resolvedResources = _context2.sent;
                        case 13:
                            _context2.next = 18;
                            break;
                        case 15:
                            _context2.prev = 15;
                            _context2.t0 = _context2["catch"](4);
                            // we make sure we return a valid dataloader response by creating an error
                            // response for each url/ari
                            resolvedResources = resources.map(function() {
                                // @ts-ignore
                                var status = (0, $lK1WF.isErrorResponse)(_context2.t0) ? _context2.t0.status : 500;
                                var errorResponse = {
                                    status: status,
                                    // @ts-ignore
                                    error: _context2.t0
                                };
                                return errorResponse;
                            });
                        case 18:
                            // Reduce into a map to make accessing faster and easier.
                            map = {}; // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
                            for(i = 0; i < deDuplicatedResources.length; ++i){
                                resource = deDuplicatedResources[i];
                                data = resolvedResources[i];
                                map[resource] = data;
                            }
                            // Reconvert list back into the original order in which it was given to us.
                            return _context2.abrupt("return", resources.map(function(originalResource) {
                                return map[originalResource];
                            }));
                        case 21:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2, null, [
                    [
                        4,
                        15
                    ]
                ]);
            }));
            return function(_x4) {
                return _ref2.apply(this, arguments);
            };
        }());
        (0, $35hqc.default)(this, "batchResolveUrl", /*#__PURE__*/ function() {
            var _ref3 = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee3(urls) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee3$(_context3) {
                    while(true)switch(_context3.prev = _context3.next){
                        case 0:
                            return _context3.abrupt("return", _this.postBatchResolveNew(urls, 'URL', function(resource) {
                                return resource.resourceUrl;
                            }));
                        case 1:
                        case "end":
                            return _context3.stop();
                    }
                }, _callee3);
            }));
            return function(_x5) {
                return _ref3.apply(this, arguments);
            };
        }());
        // Endpoint for batch resolve url
        (0, $35hqc.default)(this, "batchResolve", /*#__PURE__*/ function() {
            var _ref4 = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee4(urls) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee4$(_context4) {
                    while(true)switch(_context4.prev = _context4.next){
                        case 0:
                            return _context4.abrupt("return", _this.postBatchResolve(urls, 'URL'));
                        case 1:
                        case "end":
                            return _context4.stop();
                    }
                }, _callee4);
            }));
            return function(_x6) {
                return _ref4.apply(this, arguments);
            };
        }());
        // Endpoint for batch resolve ari
        (0, $35hqc.default)(this, "batchResolveAris", /*#__PURE__*/ function() {
            var _ref5 = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee5(aris) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee5$(_context5) {
                    while(true)switch(_context5.prev = _context5.next){
                        case 0:
                            return _context5.abrupt("return", _this.postBatchResolve(aris, 'ARI'));
                        case 1:
                        case "end":
                            return _context5.stop();
                    }
                }, _callee5);
            }));
            return function(_x7) {
                return _ref5.apply(this, arguments);
            };
        }());
        this.resolverUrl = (0, $9IyXd.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    return (0, $fmKqJ.default)(CardClient, [
        {
            key: "setProduct",
            value: function setProduct(product) {
                this.product = product;
            }
        },
        {
            key: "setHeaders",
            value: function setHeaders(headers) {
                this.headers = headers;
            }
        },
        {
            key: "createUrlLoader",
            value: function createUrlLoader() {
                var batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($hxnsV)))({
                    limit: 1,
                    interval: $9b60c1f284cf0e4f$var$MIN_TIME_BETWEEN_BATCHES
                });
                var throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
                return new (0, (/*@__PURE__*/$parcel$interopDefault($2EIP6)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
                // This is for two reasons:
                //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
                //  2: we want to avoid sending out heaps of requests from the client at once
                function(urls) {
                    return throttledBatchResolve(urls);
                }, {
                    maxBatchSize: $9b60c1f284cf0e4f$var$MAX_BATCH_SIZE,
                    // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
                    // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
                    // - the user clicks "request access", and then following the auth prompts and gets access
                    // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
                    //   because the smartlink's URL (which is the cache key) is exactly the same
                    //
                    // For this reason, we disable DataLoader's cache.
                    // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
                    // ourselves in `this.batchResolve`.
                    cache: false
                });
            }
        },
        {
            key: "createLoader",
            value: function createLoader() {
                var batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($hxnsV)))({
                    limit: 1,
                    interval: $9b60c1f284cf0e4f$var$MIN_TIME_BETWEEN_BATCHES
                });
                var throttledBatchResolve = batchResolveThrottler(this.batchResolve);
                return new (0, (/*@__PURE__*/$parcel$interopDefault($2EIP6)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
                // This is for two reasons:
                //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
                //  2: we want to avoid sending out heaps of requests from the client at once
                function(urls) {
                    return throttledBatchResolve(urls);
                }, {
                    maxBatchSize: $9b60c1f284cf0e4f$var$MAX_BATCH_SIZE,
                    // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
                    // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
                    // - the user clicks "request access", and then following the auth prompts and gets access
                    // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
                    //   because the smartlink's URL (which is the cache key) is exactly the same
                    //
                    // For this reason, we disable DataLoader's cache.
                    // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
                    // ourselves in `this.batchResolve`.
                    cache: false
                });
            }
        },
        {
            key: "getLoader",
            value: function getLoader(hostname) {
                if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
                return this.loadersByDomain[hostname];
            }
        },
        {
            key: "getUrlLoader",
            value: function getUrlLoader(hostname) {
                if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
                return this.urlLoadersByDomain[hostname];
            }
        },
        {
            key: "resolveUrl",
            value: function() {
                var _resolveUrl = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee6(url) {
                    var force, hostname, loader, responsePromise, urlLoader, response, isUnresolvedLink, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                force = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
                                hostname = new URL(url).hostname;
                                loader = this.getLoader(hostname);
                                responsePromise = $9b60c1f284cf0e4f$export$d6a66073b5d79eb3.get(url);
                                if (!responsePromise || force) {
                                    if ((0, $39c3M.fg)('platform_linking_force_no_cache_smart_card_client')) {
                                        urlLoader = this.getUrlLoader(hostname);
                                        responsePromise = urlLoader.load({
                                            resourceUrl: url,
                                            ignoreCachedValue: force || undefined
                                        });
                                    } else responsePromise = loader.load(url);
                                    $9b60c1f284cf0e4f$export$d6a66073b5d79eb3.set(url, responsePromise);
                                }
                                _context6.prev = 5;
                                _context6.next = 8;
                                return responsePromise;
                            case 8:
                                response = _context6.sent;
                                _context6.next = 15;
                                break;
                            case 11:
                                _context6.prev = 11;
                                _context6.t0 = _context6["catch"](5);
                                // Technically this never happens, since batchResolve handles errors and doesn't throw,
                                // But just in case.
                                $9b60c1f284cf0e4f$export$d6a66073b5d79eb3.delete(url);
                                throw _context6.t0;
                            case 15:
                                isUnresolvedLink = !(0, $lK1WF.isSuccessfulResponse)(response) || (0, $9ORHy.getStatus)(response.body) !== 'resolved';
                                if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
                                $9b60c1f284cf0e4f$export$d6a66073b5d79eb3.delete(url);
                                return _context6.abrupt("return", response);
                            case 18:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this, [
                        [
                            5,
                            11
                        ]
                    ]);
                }));
                function resolveUrl(_x8) {
                    return _resolveUrl.apply(this, arguments);
                }
                return resolveUrl;
            }()
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee8(url) {
                    var _this2 = this;
                    var response, retriedResponse;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                _context8.next = 2;
                                return this.resolveUrl(url, false);
                            case 2:
                                response = _context8.sent;
                                if (!(0, $lK1WF.isSuccessfulResponse)(response)) {
                                    _context8.next = 7;
                                    break;
                                }
                                return _context8.abrupt("return", response.body);
                            case 7:
                                _context8.prev = 7;
                                _context8.next = 10;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($8S7b4)))(/*#__PURE__*/ (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee7() {
                                    var _response;
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee7$(_context7) {
                                        while(true)switch(_context7.prev = _context7.next){
                                            case 0:
                                                if (_this2.resolvedCache[url]) {
                                                    _context7.next = 11;
                                                    break;
                                                }
                                                _context7.next = 3;
                                                return _this2.resolveUrl(url, false);
                                            case 3:
                                                _response = _context7.sent;
                                                if (!(0, $lK1WF.isSuccessfulResponse)(_response)) {
                                                    _context7.next = 8;
                                                    break;
                                                }
                                                return _context7.abrupt("return", _response);
                                            case 8:
                                                throw new Error('Retry for URL failed');
                                            case 9:
                                                _context7.next = 12;
                                                break;
                                            case 11:
                                                throw new Error('Retry unneeded - link has been resolved.');
                                            case 12:
                                            case "end":
                                                return _context7.stop();
                                        }
                                    }, _callee7);
                                })), this.retryConfig);
                            case 10:
                                retriedResponse = _context8.sent;
                                return _context8.abrupt("return", retriedResponse.body);
                            case 14:
                                _context8.prev = 14;
                                _context8.t0 = _context8["catch"](7);
                                return _context8.abrupt("return", undefined);
                            case 17:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            7,
                            14
                        ]
                    ]);
                }));
                function prefetchData(_x9) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "isRateLimitError",
            value: function isRateLimitError(response) {
                return (0, $lK1WF.isErrorResponse)(response) && response.error.status === 429;
            }
        },
        {
            key: "fetchData",
            value: function() {
                var _fetchData = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee0(url, force) {
                    var _this3 = this;
                    var response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                _context0.next = 2;
                                return this.resolveUrl(url, force);
                            case 2:
                                response = _context0.sent;
                                if (!this.isRateLimitError(response)) {
                                    _context0.next = 7;
                                    break;
                                }
                                _context0.next = 6;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($8S7b4)))(/*#__PURE__*/ (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee9() {
                                    var retryResponse;
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee9$(_context9) {
                                        while(true)switch(_context9.prev = _context9.next){
                                            case 0:
                                                _context9.next = 2;
                                                return _this3.resolveUrl(url, false);
                                            case 2:
                                                retryResponse = _context9.sent;
                                                if (!_this3.isRateLimitError(retryResponse)) {
                                                    _context9.next = 5;
                                                    break;
                                                }
                                                throw _this3.mapErrorResponse(retryResponse, new URL(url).hostname);
                                            case 5:
                                                return _context9.abrupt("return", retryResponse);
                                            case 6:
                                            case "end":
                                                return _context9.stop();
                                        }
                                    }, _callee9);
                                })), this.retryConfig);
                            case 6:
                                response = _context0.sent;
                            case 7:
                                if ((0, $lK1WF.isSuccessfulResponse)(response)) {
                                    _context0.next = 9;
                                    break;
                                }
                                throw this.mapErrorResponse(response, new URL(url).hostname);
                            case 9:
                                // Set a flag in the `resolvedCache` for this URL. The intent of this is
                                // to ensure that the exponential backoff method in `prefetchData` does
                                // not continue to retry fetching for this URL, especially if it was previously
                                // in a failed state. Note: this scenario only occurs on initial page load, if the
                                // user scrolls through the page very fast. Once the URL is visible, prefetching
                                // no longer takes place.
                                this.resolvedCache[url] = true;
                                // Return the JSON-LD response back up!
                                return _context0.abrupt("return", response.body);
                            case 11:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this);
                }));
                function fetchData(_x0, _x1) {
                    return _fetchData.apply(this, arguments);
                }
                return fetchData;
            }()
        },
        {
            key: "fetchDataAris",
            value: function() {
                var _fetchDataAris = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee1(aris) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee1$(_context1) {
                        while(true)switch(_context1.prev = _context1.next){
                            case 0:
                                _context1.next = 2;
                                return this.batchResolveAris(aris);
                            case 2:
                                return _context1.abrupt("return", _context1.sent);
                            case 3:
                            case "end":
                                return _context1.stop();
                        }
                    }, _callee1, this);
                }));
                function fetchDataAris(_x10) {
                    return _fetchDataAris.apply(this, arguments);
                }
                return fetchDataAris;
            }()
        },
        {
            key: "postData",
            value: function() {
                var _postData = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee10(data) {
                    var requestData;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                requestData = {
                                    key: data.key,
                                    action: data.action,
                                    context: data.context
                                };
                                _context10.next = 3;
                                return (0, $dtL2d.request)('post', "".concat(this.resolverUrl, "/invoke"), requestData);
                            case 3:
                                return _context10.abrupt("return", _context10.sent);
                            case 4:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this);
                }));
                function postData(_x11) {
                    return _postData.apply(this, arguments);
                }
                return postData;
            }()
        },
        {
            key: "search",
            value: function() {
                var _search = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee11(data) {
                    var key, action, query, context, requestData, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                key = data.key, action = data.action; // Note: context in action is different to context in data, see types.
                                query = action.query, context = action.context;
                                requestData = {
                                    key: key,
                                    search: {
                                        query: query,
                                        context: context
                                    }
                                };
                                _context11.next = 5;
                                return (0, $dtL2d.request)('post', "".concat(this.resolverUrl, "/invoke/search"), requestData);
                            case 5:
                                response = _context11.sent;
                                if (!(0, $lK1WF.isErrorResponse)(response)) {
                                    _context11.next = 8;
                                    break;
                                }
                                throw this.mapErrorResponse(response);
                            case 8:
                                return _context11.abrupt("return", response);
                            case 9:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this);
                }));
                function search(_x12) {
                    return _search.apply(this, arguments);
                }
                return search;
            }()
        },
        {
            key: "fetchAvailableSearchProviders",
            value: function() {
                var _fetchAvailableSearchProviders = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee12() {
                    var response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                _context12.next = 2;
                                return (0, $dtL2d.request)('post', "".concat(this.resolverUrl, "/providers"), {
                                    type: 'search'
                                });
                            case 2:
                                response = _context12.sent;
                                return _context12.abrupt("return", response.providers);
                            case 4:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this);
                }));
                function fetchAvailableSearchProviders() {
                    return _fetchAvailableSearchProviders.apply(this, arguments);
                }
                return fetchAvailableSearchProviders;
            }()
        },
        {
            key: "mapErrorResponse",
            value: function mapErrorResponse(response) {
                var hostname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                // Catch non-200 server responses to fallback or return useful information.
                if (response !== null && response !== void 0 && response.error) {
                    var errorType = response.error.type;
                    var errorMessage = response.error.message;
                    var extensionKey = response.error.extensionKey;
                    // this means there was a network error and we fallback to blue link
                    // without impacting SLO's
                    if (response.error instanceof (0, $dtL2d.NetworkError)) return new (0, $2v440.APIError)('fallback', hostname, errorMessage, errorType);
                    switch(errorType){
                        // BadRequestError - indicative of an API error, render
                        // a blue link to mitigate customer impact.
                        case 'ResolveBadRequestError':
                        case 'SearchBadRequestError':
                        case 'BadRequestError':
                            return new (0, $2v440.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                        // AuthError - if the user logs in, we may be able
                        // to recover. Render an unauthorized card.
                        case 'ResolveAuthError':
                        case 'SearchAuthError':
                        case 'AuthError':
                            return new (0, $2v440.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                        // UnsupportedError - we do not know how to render this URL.
                        // Bail out and ask the Editor to render as a blue link.
                        case 'ResolveUnsupportedError':
                        case 'SearchUnsupportedError':
                        case 'UnsupportedError':
                            // URL isn't supported
                            return new (0, $2v440.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                        case 'ResolveFailedError':
                        case 'SearchFailedError':
                        case 'ResolveTimeoutError':
                        case 'SearchTimeoutError':
                        case 'SearchRateLimitError':
                        case 'ResolveRateLimitError':
                        case 'InternalServerError':
                        case 'TimeoutError':
                        case 'RateLimitError':
                            return new (0, $2v440.APIError)('error', hostname, errorMessage, errorType, extensionKey);
                    }
                }
                // Catch all: we don't know this error, bail out.
                var _ref8 = response || {}, error = _ref8.error, rest = (0, $5fJwK.default)(_ref8, $9b60c1f284cf0e4f$var$_excluded);
                return new (0, $2v440.APIError)('fatal', hostname, // reason we stringify the error differently is because
                // JSON.stringify will return "{}" if it is an instance of Error
                // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
                // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
                // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
                // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
                // we assume 'rest'  to "serializable" meaning all its properties are enumerable
                response ? "".concat(this.stringifyError(error), " ").concat(JSON.stringify(rest)) : 'Response undefined', 'UnexpectedError');
            }
        },
        {
            key: "stringifyError",
            value: function stringifyError(err) {
                /**
       * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
       * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
       * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
       */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
                (0, $kQTxo.default)(err) === 'object' ? Object.getOwnPropertyNames(err) : undefined);
            }
        }
    ]);
}();

});
parcelRegister("kQTxo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f2e3be91a146b4da$export$2e2bcd8739ae039; });
function $f2e3be91a146b4da$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $f2e3be91a146b4da$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f2e3be91a146b4da$export$2e2bcd8739ae039(o);
}

});

parcelRegister("5fJwK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3d31ab3d5d070247$export$2e2bcd8739ae039; });

var $eIuqK = parcelRequire("eIuqK");
function $3d31ab3d5d070247$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $eIuqK.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("eIuqK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ab6cc7946009dd82$export$2e2bcd8739ae039; });
function $ab6cc7946009dd82$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("7vPd4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $578326d9714d0703$export$2e2bcd8739ae039; });

var $2EsZk = parcelRequire("2EsZk");

var $b3MyR = parcelRequire("b3MyR");

var $4nOoE = parcelRequire("4nOoE");

var $hKO3n = parcelRequire("hKO3n");
function $578326d9714d0703$export$2e2bcd8739ae039(r) {
    return (0, $2EsZk.default)(r) || (0, $b3MyR.default)(r) || (0, $4nOoE.default)(r) || (0, $hKO3n.default)();
}

});
parcelRegister("2EsZk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1ee5cda1dff112a4$export$2e2bcd8739ae039; });

var $3hzMV = parcelRequire("3hzMV");
function $1ee5cda1dff112a4$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $3hzMV.default)(r);
}

});
parcelRegister("3hzMV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $263eb862157b4d80$export$2e2bcd8739ae039; });
function $263eb862157b4d80$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("b3MyR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $80d5a4cb02d8c28b$export$2e2bcd8739ae039; });
function $80d5a4cb02d8c28b$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("4nOoE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3310671a8f1da47b$export$2e2bcd8739ae039; });

var $3hzMV = parcelRequire("3hzMV");
function $3310671a8f1da47b$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $3hzMV.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $3hzMV.default)(r, a) : void 0;
    }
}

});

parcelRegister("hKO3n", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cecd8f2458576f5b$export$2e2bcd8739ae039; });
function $cecd8f2458576f5b$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("aBFyY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7b8d99ac084f5323$export$2e2bcd8739ae039; });
function $7b8d99ac084f5323$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $7b8d99ac084f5323$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $7b8d99ac084f5323$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $7b8d99ac084f5323$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("aU64m", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7f03d79138a323df$export$2e2bcd8739ae039; });
function $7f03d79138a323df$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("fmKqJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b2fced243833c71a$export$2e2bcd8739ae039; });

var $iGZkz = parcelRequire("iGZkz");
function $b2fced243833c71a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $iGZkz.default)(o.key), o);
    }
}
function $b2fced243833c71a$export$2e2bcd8739ae039(e, r, t) {
    return r && $b2fced243833c71a$var$_defineProperties(e.prototype, r), t && $b2fced243833c71a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("iGZkz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d9bbb94195b3e11d$export$2e2bcd8739ae039; });

var $kQTxo = parcelRequire("kQTxo");

var $6eDzI = parcelRequire("6eDzI");
function $d9bbb94195b3e11d$export$2e2bcd8739ae039(t) {
    var i = (0, $6eDzI.default)(t, "string");
    return "symbol" == (0, $kQTxo.default)(i) ? i : i + "";
}

});
parcelRegister("6eDzI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $48a2bfab4af383a1$export$2e2bcd8739ae039; });

var $kQTxo = parcelRequire("kQTxo");
function $48a2bfab4af383a1$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $kQTxo.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $kQTxo.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("35hqc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $23ef5a4b9ec2ab6e$export$2e2bcd8739ae039; });

var $iGZkz = parcelRequire("iGZkz");
function $23ef5a4b9ec2ab6e$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $iGZkz.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("8PYfA", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $66f1d299512f8e9a$var$runtime = (parcelRequire("bMRjC"))();
module.exports = $66f1d299512f8e9a$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $66f1d299512f8e9a$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $66f1d299512f8e9a$var$runtime;
    else Function("r", "regeneratorRuntime = r")($66f1d299512f8e9a$var$runtime);
}

});
parcelRegister("bMRjC", function(module, exports) {

var $Nrqet = parcelRequire("Nrqet");

var $fOI5Y = parcelRequire("fOI5Y");

var $4FuMZ = parcelRequire("4FuMZ");

var $kFK1R = parcelRequire("kFK1R");

var $jht78 = parcelRequire("jht78");

var $kSyoE = parcelRequire("kSyoE");

var $gBH6D = parcelRequire("gBH6D");
function $894d88c2b4677c98$var$_regeneratorRuntime() {
    "use strict";
    var r = $fOI5Y(), e = r.m($894d88c2b4677c98$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $gBH6D(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $894d88c2b4677c98$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $Nrqet(r, e);
            },
            AsyncIterator: $jht78,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $kFK1R : $4FuMZ)(a(r), e, t, o, u);
            },
            keys: $kSyoE,
            values: $gBH6D
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $894d88c2b4677c98$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("Nrqet", function(module, exports) {
function $0949d92d294bdff3$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $0949d92d294bdff3$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fOI5Y", function(module, exports) {

var $7Tacp = parcelRequire("7Tacp");
function $b83dbaf0ce982976$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $7Tacp(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($7Tacp(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $7Tacp(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $7Tacp(u, "constructor", GeneratorFunctionPrototype), $7Tacp(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $7Tacp(GeneratorFunctionPrototype, o, "GeneratorFunction"), $7Tacp(u), $7Tacp(u, o, "Generator"), $7Tacp(u, n, function() {
        return this;
    }), $7Tacp(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $b83dbaf0ce982976$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $b83dbaf0ce982976$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7Tacp", function(module, exports) {
function $5be594ca0a770576$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $5be594ca0a770576$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $5be594ca0a770576$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $5be594ca0a770576$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $5be594ca0a770576$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4FuMZ", function(module, exports) {

var $kFK1R = parcelRequire("kFK1R");
function $3662dfd9239c7485$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $kFK1R(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $3662dfd9239c7485$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kFK1R", function(module, exports) {

var $fOI5Y = parcelRequire("fOI5Y");

var $jht78 = parcelRequire("jht78");
function $f0cb57671343d2b8$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $jht78($fOI5Y().w(r, e, t, o), n || Promise);
}
module.exports = $f0cb57671343d2b8$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jht78", function(module, exports) {

var $Nrqet = parcelRequire("Nrqet");

var $7Tacp = parcelRequire("7Tacp");
function $e096304eaf0f7263$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $Nrqet ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($7Tacp($e096304eaf0f7263$var$AsyncIterator.prototype), $7Tacp($e096304eaf0f7263$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $7Tacp(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $e096304eaf0f7263$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("kSyoE", function(module, exports) {
function $f333883fa1049c8b$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $f333883fa1049c8b$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gBH6D", function(module, exports) {

var $asmK4 = parcelRequire("asmK4");
var $c17189fbc46a9a37$var$_typeof = $asmK4.default;
function $c17189fbc46a9a37$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($c17189fbc46a9a37$var$_typeof(e) + " is not iterable");
}
module.exports = $c17189fbc46a9a37$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("asmK4", function(module, exports) {
function $79ce2903386d1d4e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $79ce2903386d1d4e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $79ce2903386d1d4e$var$_typeof(o);
}
module.exports = $79ce2903386d1d4e$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("hMsf5", function(module, exports) {
$parcel$export(module.exports, "expValEquals", function () { return $cf1cd3b154d20d8d$export$45abdb3f977b5b14; });

var $eaC33 = parcelRequire("eaC33");
function $cf1cd3b154d20d8d$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue) {
    var experimentDefaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return (0, $eaC33.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("eaC33", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", function () { return $a50f83747b6f1489$export$58e581060588c6bb; });

var $kdhYN = parcelRequire("kdhYN");

var $cozhm = parcelRequire("cozhm");
function $a50f83747b6f1489$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $cozhm._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $cozhm._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $kdhYN.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $kdhYN.default).getExperimentValue(experimentName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    return experimentValue === experimentExpectedValue;
}

});
parcelRegister("kdhYN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eb72f7f0f556238f$export$2e2bcd8739ae039; });

var $aU64m = parcelRequire("aU64m");

var $fmKqJ = parcelRequire("fmKqJ");

var $35hqc = parcelRequire("35hqc");

var $hrtTJ = parcelRequire("hrtTJ");

var $IpFGt = parcelRequire("IpFGt");



var $eb72f7f0f556238f$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $eb72f7f0f556238f$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $aU64m.default)(this, FeatureGates);
    }
    return (0, $fmKqJ.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$eb72f7f0f556238f$var$_FeatureGates = $eb72f7f0f556238f$var$FeatureGates;
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "client", new (0, $hrtTJ.Client)());
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$eb72f7f0f556238f$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $eb72f7f0f556238f$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $eb72f7f0f556238f$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$eb72f7f0f556238f$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $eb72f7f0f556238f$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $eb72f7f0f556238f$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "initializeCalled", $eb72f7f0f556238f$var$_FeatureGates.client.initializeCalled.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "initializeCompleted", $eb72f7f0f556238f$var$_FeatureGates.client.initializeCompleted.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "initialize", $eb72f7f0f556238f$var$_FeatureGates.client.initialize.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "initializeWithProvider", $eb72f7f0f556238f$var$_FeatureGates.client.initializeWithProvider.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "initializeFromValues", $eb72f7f0f556238f$var$_FeatureGates.client.initializeFromValues.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "manuallyLogGateExposure", $eb72f7f0f556238f$var$_FeatureGates.client.manuallyLogGateExposure.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "getExperiment", $eb72f7f0f556238f$var$_FeatureGates.client.getExperiment.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "manuallyLogExperimentExposure", $eb72f7f0f556238f$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "manuallyLogLayerExposure", $eb72f7f0f556238f$var$_FeatureGates.client.manuallyLogLayerExposure.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "shutdownStatsig", $eb72f7f0f556238f$var$_FeatureGates.client.shutdownStatsig.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "overrideGate", $eb72f7f0f556238f$var$_FeatureGates.client.overrideGate.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "clearGateOverride", $eb72f7f0f556238f$var$_FeatureGates.client.clearGateOverride.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "overrideConfig", $eb72f7f0f556238f$var$_FeatureGates.client.overrideConfig.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "clearConfigOverride", $eb72f7f0f556238f$var$_FeatureGates.client.clearConfigOverride.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "setOverrides", $eb72f7f0f556238f$var$_FeatureGates.client.setOverrides.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "getOverrides", $eb72f7f0f556238f$var$_FeatureGates.client.getOverrides.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "clearAllOverrides", $eb72f7f0f556238f$var$_FeatureGates.client.clearAllOverrides.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "isCurrentUser", $eb72f7f0f556238f$var$_FeatureGates.client.isCurrentUser.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "onGateUpdated", $eb72f7f0f556238f$var$_FeatureGates.client.onGateUpdated.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "onExperimentValueUpdated", $eb72f7f0f556238f$var$_FeatureGates.client.onExperimentValueUpdated.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "onAnyUpdated", $eb72f7f0f556238f$var$_FeatureGates.client.onAnyUpdated.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "updateUser", $eb72f7f0f556238f$var$_FeatureGates.client.updateUser.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "updateUserWithProvider", $eb72f7f0f556238f$var$_FeatureGates.client.updateUserWithProvider.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "updateUserWithValues", $eb72f7f0f556238f$var$_FeatureGates.client.updateUserWithValues.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "getPackageVersion", $eb72f7f0f556238f$var$_FeatureGates.client.getPackageVersion.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "getLayer", $eb72f7f0f556238f$var$_FeatureGates.client.getLayer.bind($eb72f7f0f556238f$var$_FeatureGates.client));
(0, $35hqc.default)($eb72f7f0f556238f$var$FeatureGates, "getLayerValue", $eb72f7f0f556238f$var$_FeatureGates.client.getLayerValue.bind($eb72f7f0f556238f$var$_FeatureGates.client));
var $eb72f7f0f556238f$var$boundFGJS = $eb72f7f0f556238f$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $eb72f7f0f556238f$var$FeatureGates;
    else {
        var $eb72f7f0f556238f$var$_boundFGJS, $eb72f7f0f556238f$var$_boundFGJS$getPackage;
        $eb72f7f0f556238f$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $eb72f7f0f556238f$var$boundVersion = (($eb72f7f0f556238f$var$_boundFGJS = $eb72f7f0f556238f$var$boundFGJS) === null || $eb72f7f0f556238f$var$_boundFGJS === void 0 || ($eb72f7f0f556238f$var$_boundFGJS$getPackage = $eb72f7f0f556238f$var$_boundFGJS.getPackageVersion) === null || $eb72f7f0f556238f$var$_boundFGJS$getPackage === void 0 ? void 0 : $eb72f7f0f556238f$var$_boundFGJS$getPackage.call($eb72f7f0f556238f$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($eb72f7f0f556238f$var$boundVersion !== (0, $IpFGt.CLIENT_VERSION)) {
            var $eb72f7f0f556238f$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($eb72f7f0f556238f$var$boundVersion, " when module version ").concat((0, $IpFGt.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($eb72f7f0f556238f$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $eb72f7f0f556238f$export$2e2bcd8739ae039 = $eb72f7f0f556238f$var$boundFGJS;

});
parcelRegister("hrtTJ", function(module, exports) {
$parcel$export(module.exports, "Client", function () { return $cb2c26677067ff43$export$1f2bb630327ac4b6; });

var $5fJwK = parcelRequire("5fJwK");

var $bo7JX = parcelRequire("bo7JX");

var $aBFyY = parcelRequire("aBFyY");

var $aU64m = parcelRequire("aU64m");

var $fmKqJ = parcelRequire("fmKqJ");

var $35hqc = parcelRequire("35hqc");

var $8PYfA = parcelRequire("8PYfA");

var $ec1qE = parcelRequire("ec1qE");

var $cJMLl = parcelRequire("cJMLl");

var $fP0J8 = parcelRequire("fP0J8");

var $hgn1g = parcelRequire("hgn1g");

var $a69eT = parcelRequire("a69eT");

var $1KGmI = parcelRequire("1KGmI");

var $dqeiA = parcelRequire("dqeiA");

var $8ZXUB = parcelRequire("8ZXUB");

var $fFxfN = parcelRequire("fFxfN");

var $fEsJP = parcelRequire("fEsJP");

var $IpFGt = parcelRequire("IpFGt");
var $cb2c26677067ff43$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $cb2c26677067ff43$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cb2c26677067ff43$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cb2c26677067ff43$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $35hqc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cb2c26677067ff43$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cb2c26677067ff43$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $cb2c26677067ff43$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $cb2c26677067ff43$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $8ZXUB.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $aU64m.default)(this, Client);
        (0, $35hqc.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $35hqc.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $35hqc.default)(this, "initWithDefaults", false);
        (0, $35hqc.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $35hqc.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $35hqc.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $35hqc.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $35hqc.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $35hqc.default)(this, "subscriptions", new (0, $cJMLl.default)());
        (0, $35hqc.default)(this, "dataAdapter", new (0, $dqeiA.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $35hqc.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $8ZXUB.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $fmKqJ.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $fEsJP.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $fEsJP.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $fEsJP.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $fEsJP.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $IpFGt.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $cb2c26677067ff43$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $IpFGt.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $fFxfN.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $fEsJP.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $fEsJP.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $fEsJP.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $1KGmI.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $fP0J8.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $fP0J8.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $a69eT.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $fEsJP.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $fEsJP.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $cb2c26677067ff43$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $1KGmI.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $1KGmI.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, $bo7JX.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $cb2c26677067ff43$var$_objectSpread($cb2c26677067ff43$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, $bo7JX.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $fEsJP.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $cb2c26677067ff43$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $cb2c26677067ff43$var$_objectSpread($cb2c26677067ff43$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $cb2c26677067ff43$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $fFxfN.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $5fJwK.default)(newClientOptions, $cb2c26677067ff43$var$_excluded);
                                this.user = (0, $fEsJP.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $cb2c26677067ff43$var$_objectSpread($cb2c26677067ff43$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $ec1qE.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $ec1qE.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context9.prev = 12;
                                this.statsigClient = new (0, $ec1qE.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $ec1qE.StatsigClient)($cb2c26677067ff43$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee1(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee1$(_context1) {
                        while(true)switch(_context1.prev = _context1.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context1.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context1.next = 5;
                                    break;
                                }
                                return _context1.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context1.prev = 6;
                                _context1.next = 9;
                                return this.initPromise;
                            case 9:
                                _context1.next = 13;
                                break;
                            case 11:
                                _context1.prev = 11;
                                _context1.t0 = _context1["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee0() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee0$(_context0) {
                                        while(true)switch(_context0.prev = _context0.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context0.next = 4;
                                                    break;
                                                }
                                                _context0.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context0.stop();
                                        }
                                    }, _callee0);
                                })));
                                return _context1.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context1.stop();
                        }
                    }, _callee1, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee10(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context10.prev = 1;
                                _context10.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context10.sent;
                                user = (0, $fEsJP.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context10.next = 13;
                                break;
                            case 8:
                                _context10.prev = 8;
                                _context10.t0 = _context10["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context10.t0 instanceof Error ? _context10.t0.message : JSON.stringify(_context10.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context10.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context10.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context10.next = 21;
                                    break;
                                }
                                _context10.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context10.next = 27;
                                break;
                            case 23:
                                _context10.prev = 23;
                                _context10.t1 = _context10["catch"](15);
                                success = false;
                                errorMessage = String(_context10.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context10.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context10.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $IpFGt.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $hgn1g.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $hgn1g.Layer).fromLayer((0, $ec1qE._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("bo7JX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $84a7f0ab8b385a66$export$2e2bcd8739ae039; });

var $alzDY = parcelRequire("alzDY");

var $3gQ0l = parcelRequire("3gQ0l");

var $4nOoE = parcelRequire("4nOoE");

var $gmPiu = parcelRequire("gmPiu");
function $84a7f0ab8b385a66$export$2e2bcd8739ae039(r, e) {
    return (0, $alzDY.default)(r) || (0, $3gQ0l.default)(r, e) || (0, $4nOoE.default)(r, e) || (0, $gmPiu.default)();
}

});
parcelRegister("alzDY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $788783a719a3eb70$export$2e2bcd8739ae039; });
function $788783a719a3eb70$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("3gQ0l", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $261b34bfc155ddfa$export$2e2bcd8739ae039; });
function $261b34bfc155ddfa$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("gmPiu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bea67df3f1689764$export$2e2bcd8739ae039; });
function $bea67df3f1689764$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("cJMLl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $945f833f6d3dbb25$export$2e2bcd8739ae039; });

var $aU64m = parcelRequire("aU64m");

var $fmKqJ = parcelRequire("fmKqJ");

var $35hqc = parcelRequire("35hqc");

var $f72YL = parcelRequire("f72YL");
function $945f833f6d3dbb25$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $945f833f6d3dbb25$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $945f833f6d3dbb25$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $35hqc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $945f833f6d3dbb25$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $945f833f6d3dbb25$export$a66cbd9b2289cd78 = '@all-features';
var $945f833f6d3dbb25$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $aU64m.default)(this, Subscriptions);
        (0, $35hqc.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($f72YL)))();
    }
    return (0, $fmKqJ.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $945f833f6d3dbb25$var$_objectSpread($945f833f6d3dbb25$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $945f833f6d3dbb25$var$_objectSpread($945f833f6d3dbb25$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $945f833f6d3dbb25$var$_objectSpread($945f833f6d3dbb25$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $945f833f6d3dbb25$var$_objectSpread($945f833f6d3dbb25$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($945f833f6d3dbb25$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($945f833f6d3dbb25$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($945f833f6d3dbb25$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $945f833f6d3dbb25$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("fP0J8", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", function () { return $b84c2ec83635b02d$export$6dc24881a3d96325; });

var $kQTxo = parcelRequire("kQTxo");

var $aU64m = parcelRequire("aU64m");

var $fmKqJ = parcelRequire("fmKqJ");

var $fEsJP = parcelRequire("fEsJP");
var $b84c2ec83635b02d$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $aU64m.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $fmKqJ.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $kQTxo.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $kQTxo.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $fEsJP.migrateEvaluationDetails)(experiment.details), (0, $fEsJP.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("fEsJP", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $b650e244a6f3a03d$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $b650e244a6f3a03d$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $b650e244a6f3a03d$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $b650e244a6f3a03d$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $b650e244a6f3a03d$export$18ad168d3dbac899; });
$parcel$export(module.exports, "migrateSecondaryExposures", function () { return $b650e244a6f3a03d$export$55fd683752d01e67; });

var $5fJwK = parcelRequire("5fJwK");

var $bo7JX = parcelRequire("bo7JX");

var $35hqc = parcelRequire("35hqc");

var $fXtQr = parcelRequire("fXtQr");

var $a69eT = parcelRequire("a69eT");

var $fFxfN = parcelRequire("fFxfN");
var $b650e244a6f3a03d$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $b650e244a6f3a03d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b650e244a6f3a03d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b650e244a6f3a03d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $35hqc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b650e244a6f3a03d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b650e244a6f3a03d$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $b650e244a6f3a03d$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $fXtQr.isFedRamp)() ? (0, $fFxfN.PerimeterType).FEDRAMP_MODERATE : (0, $fFxfN.PerimeterType).COMMERCIAL
    }, options);
};
var $b650e244a6f3a03d$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $bo7JX.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $bo7JX.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $bo7JX.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $bo7JX.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $b650e244a6f3a03d$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $b650e244a6f3a03d$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $5fJwK.default)(options, $b650e244a6f3a03d$var$_excluded);
    return $b650e244a6f3a03d$var$_objectSpread($b650e244a6f3a03d$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $b650e244a6f3a03d$var$evaluationReasonMappings = Object.entries((0, $a69eT.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $bo7JX.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $b650e244a6f3a03d$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $b650e244a6f3a03d$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $bo7JX.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $a69eT.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $b650e244a6f3a03d$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("fXtQr", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", function () { return $b9e38442d31cf454$export$64d6499adf9b2e51; });

var $gMzXs = parcelRequire("gMzXs");
function $b9e38442d31cf454$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $gMzXs.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("gMzXs", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $c37d058c48371dce$export$ce553301d55c2fd8; });
var $c37d058c48371dce$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $c37d058c48371dce$export$f005e2e9f707cb5f = 'commercial';
var $c37d058c48371dce$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $c37d058c48371dce$export$a739cd5aac835909 = 'stg';
var $c37d058c48371dce$export$42dd0cdd351a4a9 = 'prod';
var $c37d058c48371dce$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("a69eT", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", function () { return $75a1a1a44e8e9fb6$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $75a1a1a44e8e9fb6$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("fFxfN", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $02f19ee291507015$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $02f19ee291507015$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $02f19ee291507015$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $02f19ee291507015$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $02f19ee291507015$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("hgn1g", function(module, exports) {
$parcel$export(module.exports, "Layer", function () { return $c915c9742e5149a3$export$936d0764594b6eb3; });

var $kQTxo = parcelRequire("kQTxo");

var $aU64m = parcelRequire("aU64m");

var $fmKqJ = parcelRequire("fmKqJ");

var $fEsJP = parcelRequire("fEsJP");
var $c915c9742e5149a3$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $aU64m.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $fmKqJ.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $kQTxo.default)(val) === (0, $kQTxo.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $fEsJP.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $fEsJP.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $fEsJP.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("1KGmI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $146af32fe81affb2$export$2e2bcd8739ae039; });

var $35hqc = parcelRequire("35hqc");

var $aBFyY = parcelRequire("aBFyY");

var $aU64m = parcelRequire("aU64m");

var $fmKqJ = parcelRequire("fmKqJ");

var $8PYfA = parcelRequire("8PYfA");

var $fFxfN = parcelRequire("fFxfN");

var $IpFGt = parcelRequire("IpFGt");

var $9JtF7 = parcelRequire("9JtF7");
function $146af32fe81affb2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $146af32fe81affb2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $146af32fe81affb2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $35hqc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $146af32fe81affb2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $146af32fe81affb2$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $146af32fe81affb2$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $146af32fe81affb2$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $146af32fe81affb2$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $146af32fe81affb2$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $146af32fe81affb2$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $146af32fe81affb2$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $146af32fe81affb2$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $146af32fe81affb2$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $146af32fe81affb2$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $146af32fe81affb2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $aU64m.default)(this, Fetcher);
    }
    return (0, $fmKqJ.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $9JtF7.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $9JtF7.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $146af32fe81affb2$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $fFxfN.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $fFxfN.FeatureGateEnvironment).Production:
                        return $146af32fe81affb2$export$18c93900db9358a4;
                    case (0, $fFxfN.FeatureGateEnvironment).Staging:
                        return $146af32fe81affb2$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $fFxfN.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $fFxfN.FeatureGateEnvironment).Development:
                        return $146af32fe81affb2$export$f058dbf75c3bc647;
                    case (0, $fFxfN.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $146af32fe81affb2$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $146af32fe81affb2$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $146af32fe81affb2$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $146af32fe81affb2$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $IpFGt.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $146af32fe81affb2$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($146af32fe81affb2$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($146af32fe81affb2$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("IpFGt", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", function () { return $085805f723b1aef6$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $085805f723b1aef6$export$a59f8d67326bd1cb = "5.5.3";

});

parcelRegister("9JtF7", function(module, exports) {
$parcel$export(module.exports, "ResponseError", function () { return $715f53578f5daf95$export$286baf652d0b1206; });

var $fmKqJ = parcelRequire("fmKqJ");

var $aU64m = parcelRequire("aU64m");

var $f3sSy = parcelRequire("f3sSy");

var $8eIcZ = parcelRequire("8eIcZ");

var $2yISS = parcelRequire("2yISS");

var $78Q2K = parcelRequire("78Q2K");
function $715f53578f5daf95$var$_callSuper(t, o, e) {
    return o = (0, $8eIcZ.default)(o), (0, $f3sSy.default)(t, $715f53578f5daf95$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $8eIcZ.default)(t).constructor) : o.apply(t, e));
}
function $715f53578f5daf95$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($715f53578f5daf95$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $715f53578f5daf95$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $aU64m.default)(this, ResponseError);
        return $715f53578f5daf95$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $2yISS.default)(ResponseError, _Error);
    return (0, $fmKqJ.default)(ResponseError);
}(/*#__PURE__*/ (0, $78Q2K.default)(Error));

});
parcelRegister("f3sSy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $af5d8993d3702a4f$export$2e2bcd8739ae039; });

var $kQTxo = parcelRequire("kQTxo");

var $jWqqE = parcelRequire("jWqqE");
function $af5d8993d3702a4f$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $kQTxo.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $jWqqE.default)(t);
}

});
parcelRegister("jWqqE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e847ef4fff1d9096$export$2e2bcd8739ae039; });
function $e847ef4fff1d9096$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("8eIcZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5ff1ec6a905db240$export$2e2bcd8739ae039; });
function $5ff1ec6a905db240$export$2e2bcd8739ae039(t) {
    return $5ff1ec6a905db240$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $5ff1ec6a905db240$export$2e2bcd8739ae039(t);
}

});

parcelRegister("2yISS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1dd192c7e70a8928$export$2e2bcd8739ae039; });

var $dwKKZ = parcelRequire("dwKKZ");
function $1dd192c7e70a8928$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $dwKKZ.default)(t, e);
}

});
parcelRegister("dwKKZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9d9288769183bba8$export$2e2bcd8739ae039; });
function $9d9288769183bba8$export$2e2bcd8739ae039(t, e) {
    return $9d9288769183bba8$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $9d9288769183bba8$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("78Q2K", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5331a67f14af6dc6$export$2e2bcd8739ae039; });

var $8eIcZ = parcelRequire("8eIcZ");

var $dwKKZ = parcelRequire("dwKKZ");

var $6ZpMn = parcelRequire("6ZpMn");

var $9hZQU = parcelRequire("9hZQU");
function $5331a67f14af6dc6$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $5331a67f14af6dc6$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $6ZpMn.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $9hZQU.default)(t, arguments, (0, $8eIcZ.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $dwKKZ.default)(Wrapper, t);
    }, $5331a67f14af6dc6$export$2e2bcd8739ae039(t);
}

});
parcelRegister("6ZpMn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $516c6fc9953aaa33$export$2e2bcd8739ae039; });
function $516c6fc9953aaa33$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("9hZQU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6c35ae2befcb682d$export$2e2bcd8739ae039; });

var $cKFkL = parcelRequire("cKFkL");

var $dwKKZ = parcelRequire("dwKKZ");
function $6c35ae2befcb682d$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $cKFkL.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $dwKKZ.default)(p, r.prototype), p;
}

});
parcelRegister("cKFkL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9489d7f10afdb3d7$export$2e2bcd8739ae039; });
function $9489d7f10afdb3d7$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9489d7f10afdb3d7$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("dqeiA", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $9c58cb8488c61a6a$export$55fffef3474104af; });

var $aBFyY = parcelRequire("aBFyY");

var $aU64m = parcelRequire("aU64m");

var $fmKqJ = parcelRequire("fmKqJ");

var $f3sSy = parcelRequire("f3sSy");

var $8eIcZ = parcelRequire("8eIcZ");

var $gxwkq = parcelRequire("gxwkq");

var $2yISS = parcelRequire("2yISS");

var $35hqc = parcelRequire("35hqc");

var $8PYfA = parcelRequire("8PYfA");

var $ec1qE = parcelRequire("ec1qE");
function $9c58cb8488c61a6a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9c58cb8488c61a6a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9c58cb8488c61a6a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $35hqc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9c58cb8488c61a6a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9c58cb8488c61a6a$var$_callSuper(t, o, e) {
    return o = (0, $8eIcZ.default)(o), (0, $f3sSy.default)(t, $9c58cb8488c61a6a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $8eIcZ.default)(t).constructor) : o.apply(t, e));
}
function $9c58cb8488c61a6a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9c58cb8488c61a6a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $9c58cb8488c61a6a$var$_superPropGet(t, o, e, r) {
    var p = (0, $gxwkq.default)((0, $8eIcZ.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $9c58cb8488c61a6a$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $aU64m.default)(this, NoFetchDataAdapter);
        _this = $9c58cb8488c61a6a$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $35hqc.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $2yISS.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $fmKqJ.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $ec1qE.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $9c58cb8488c61a6a$var$_objectSpread($9c58cb8488c61a6a$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $9c58cb8488c61a6a$var$_objectSpread($9c58cb8488c61a6a$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $ec1qE._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $ec1qE._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $ec1qE.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $9c58cb8488c61a6a$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $9c58cb8488c61a6a$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $ec1qE.DataAdapterCore));

});
parcelRegister("gxwkq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c0a8ce2baba8081f$export$2e2bcd8739ae039; });

var $jqAAp = parcelRequire("jqAAp");
function $c0a8ce2baba8081f$export$2e2bcd8739ae039() {
    return $c0a8ce2baba8081f$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $jqAAp.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $c0a8ce2baba8081f$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("jqAAp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e24cd34e6fc1d087$export$2e2bcd8739ae039; });

var $8eIcZ = parcelRequire("8eIcZ");
function $e24cd34e6fc1d087$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $8eIcZ.default)(t)););
    return t;
}

});



parcelRegister("8ZXUB", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $68d27e79c262dea9$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $68d27e79c262dea9$export$bcb28fbac1def494; });

var $35hqc = parcelRequire("35hqc");

var $bo7JX = parcelRequire("bo7JX");

var $aU64m = parcelRequire("aU64m");

var $fmKqJ = parcelRequire("fmKqJ");

var $3wfvf = parcelRequire("3wfvf");
function $68d27e79c262dea9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68d27e79c262dea9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68d27e79c262dea9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $35hqc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68d27e79c262dea9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $68d27e79c262dea9$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $68d27e79c262dea9$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $68d27e79c262dea9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $68d27e79c262dea9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $68d27e79c262dea9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $68d27e79c262dea9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $68d27e79c262dea9$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $68d27e79c262dea9$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $68d27e79c262dea9$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $68d27e79c262dea9$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $68d27e79c262dea9$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $68d27e79c262dea9$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $aU64m.default)(this, PersistentOverrideAdapter);
        this._overrides = $68d27e79c262dea9$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $fmKqJ.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $68d27e79c262dea9$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $68d27e79c262dea9$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $68d27e79c262dea9$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $bo7JX.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $bo7JX.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $bo7JX.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($68d27e79c262dea9$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($68d27e79c262dea9$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $68d27e79c262dea9$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $3wfvf._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $68d27e79c262dea9$var$_objectSpread($68d27e79c262dea9$var$_objectSpread({}, $68d27e79c262dea9$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $bo7JX.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $bo7JX.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($68d27e79c262dea9$var$djb2MapKey((0, $3wfvf._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($68d27e79c262dea9$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($68d27e79c262dea9$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($68d27e79c262dea9$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $68d27e79c262dea9$var$_objectSpread($68d27e79c262dea9$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $68d27e79c262dea9$var$_objectSpread($68d27e79c262dea9$var$_objectSpread({}, current.details), {}, {
                        reason: $68d27e79c262dea9$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($68d27e79c262dea9$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($68d27e79c262dea9$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($68d27e79c262dea9$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($68d27e79c262dea9$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($68d27e79c262dea9$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($68d27e79c262dea9$var$djb2MapKey((0, $3wfvf._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $68d27e79c262dea9$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($68d27e79c262dea9$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $68d27e79c262dea9$var$_objectSpread($68d27e79c262dea9$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $68d27e79c262dea9$var$_objectSpread($68d27e79c262dea9$var$_objectSpread({}, current.details), {}, {
                        reason: $68d27e79c262dea9$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($68d27e79c262dea9$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $68d27e79c262dea9$var$_objectSpread($68d27e79c262dea9$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $3wfvf._makeTypedGet)(current.name, overridden),
                    details: $68d27e79c262dea9$var$_objectSpread($68d27e79c262dea9$var$_objectSpread({}, current.details), {}, {
                        reason: $68d27e79c262dea9$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("cozhm", function(module, exports) {
$parcel$export(module.exports, "_overrides", function () { return $9063179bd198593d$export$e5d73bf4f8e2ae96; });

var $35hqc = parcelRequire("35hqc");

var $bo7JX = parcelRequire("bo7JX");

var $5A3Aj = parcelRequire("5A3Aj");

var $2BBaO = parcelRequire("2BBaO");
function $9063179bd198593d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9063179bd198593d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9063179bd198593d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $35hqc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9063179bd198593d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9063179bd198593d$export$e5d73bf4f8e2ae96 = {};
var $9063179bd198593d$export$4e849416bb5c5b52 = {};
var $9063179bd198593d$export$cf7305fc65acbf0d;
function $9063179bd198593d$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce(function(acc, _ref) {
            var _ref2 = (0, $bo7JX.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
            var config = (0, $5A3Aj.editorExperimentsConfig)[key];
            if (config) acc = $9063179bd198593d$var$_objectSpread($9063179bd198593d$var$_objectSpread({}, acc), {}, (0, $35hqc.default)({}, key, config.typeGuard(value) ? value : config.defaultValue));
            return acc;
        }, {});
        $9063179bd198593d$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test') {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        var testOverrides = Object.fromEntries(Object.entries((0, $5A3Aj.editorExperimentsConfig)).map(function(_ref3) {
            var _ref5, _ref6, _groupOverrides, _groupOverrides2;
            var _ref4 = (0, $bo7JX.default)(_ref3, 2), key = _ref4[0], value = _ref4[1];
            var defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                (_ref5 = (_ref6 = (_groupOverrides = (_groupOverrides2 = groupOverrides) === null || _groupOverrides2 === void 0 ? void 0 : _groupOverrides2[key]) !== null && _groupOverrides !== void 0 ? _groupOverrides : (0, $2BBaO.testMultivariateOverrides)[key]) !== null && _ref6 !== void 0 ? _ref6 : (0, $2BBaO.testBooleanOverrides)[key]) !== null && _ref5 !== void 0 ? _ref5 : defaultValue
            ];
        }));
        $9063179bd198593d$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $9063179bd198593d$export$cf7305fc65acbf0d = product;
    $9063179bd198593d$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("5A3Aj", function(module, exports) {
$parcel$export(module.exports, "editorExperimentsConfig", function () { return $410318650ceb3c12$export$6cbb856f286b07ef; });
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $jVhgk = parcelRequire("jVhgk");
var $410318650ceb3c12$export$6cbb856f286b07ef = {
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_memoized_node_check: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_memoized_node_check'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_media_card_vc_wrapper_attribute: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_card_vc_wrapper_attribute'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_prevent_numbered_column_too_big_jira_1: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            jira: 'editor_prevent_numbered_column_too_big_jira_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_block_control_optimise_render: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_control_optimise_render'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $jVhgk.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-28
    platform_editor_controls_performance_fixes: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_performance_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $jVhgk.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $jVhgk.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-01
    platform_editor_controls_block_controls_state_fix: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_block_controls_state_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_smart_link_cmd_ctrl_click: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_smart_link_cmd_ctrl_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 28-02-2025
    platform_editor_insertion: (0, $jVhgk.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_insertion'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_vanilla_dom/setup
    platform_editor_vanilla_dom: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vanilla_dom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: (0, $jVhgk.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_proactive_ai_nudge_parameters'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-14
    editor_ai_inline_suggestion_date_v2: (0, $jVhgk.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_ai_inline_suggestion_date_v2'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    platform_editor_usesharedpluginstatewithselector: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstatewithselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_stop_width_reflows: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_stop_width_reflows'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-08
    platform_editor_core_static_emotion: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_emotion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-11
    platform_editor_core_static_emotion_non_central: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_emotion_non_central'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_cursor_on_edit_page_init'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-14
    platform_editor_jira_advanced_code_blocks: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_jira_advanced_code_blocks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-21
    platform_editor_nodevisibility: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nodevisibility'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quickstart_command'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-28
    platform_editor_toolbar_rerender_optimization_exp: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_rerender_optimization_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-02
    platform_editor_code_block_fold_gutter: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_fold_gutter'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-18
    platform_editor_ai_iw_adf_streaming: (0, $jVhgk.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf',
            'adf_personalisation'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-18
    platform_editor_ai_ct_sg_adf_streaming: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_ct_sg_adf_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-20
    platform_editor_ai_non_iw_adf_streaming: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_non_iw_adf_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-07
    platform_editor_ai_remove_trivial_prompts_cc: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_remove_trivial_prompts_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-07-25
    platform_editor_extension_styles: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_extension_styles'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-20
    confluence_whiteboards_quick_insert_aa: (0, $jVhgk.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-24
    platform_editor_find_and_replace_improvements: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_find_and_replace_improvements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    confluence_whiteboards_quick_insert: (0, $jVhgk.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // added out of order to avoid known conflict that will occur otherwise
    // Added 2025-07-11
    cc_editor_ufo_hold_table_till_resize_complete: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_ufo_hold_table_till_resize_complete'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-26
    platform_editor_feedback_mandatory_rating: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_feedback_mandatory_rating'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_drag_handle_aria_label: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_drag_handle_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-07
    platform_editor_toggle_expand_on_match_found: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toggle_expand_on_match_found'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_smart_card_otp: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_smart_card_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_responsiveness'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_preview_panel_linking_exp: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_linking_exp_conf',
            jira: 'platform_editor_preview_panel_linking_exp_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $jVhgk.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025--8-05
    platform_editor_block_menu: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    platform_editor_renderer_breakout_fix: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_breakout_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_enghealth_hyperlink_toolbar_aria_values: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enghealth_hyperlink_toolbar_aria_values'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-011
    cc_editor_interactions_trigger_traceufointeraction: (0, $jVhgk.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_interactions_trigger_traceufointeraction'
        },
        param: 'cohort',
        values: [
            'control',
            'all_events',
            'only_mousedown_event'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-07-14
    platform_editor_add_orange_highlight_color: (0, $jVhgk.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_orange_highlight_color'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc',
            confluence: 'platform_editor_toolbar_aifc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-08-13
    platform_editor_ai_aifc: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_ai_aifc_jira',
            confluence: 'platform_editor_ai_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-04
    platform_editor_floating_toolbar_button_aria_label: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_floating_toolbar_button_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    platform_editor_enghealth_table_plugin_lable_rule: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enghealth_table_plugin_lable_rule'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-28
    platform_editor_create_link_on_blur: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_create_link_on_blur'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-29
    cc_comments_include_path_for_renderer_emojis: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_comments_include_path_for_renderer_emojis'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_aifc_responsive: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_responsive',
            jira: 'platform_editor_toolbar_aifc_responsive'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_pasting_nested_table_fix: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_pasting_nested_table_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 20205-07-28
    platform_editor_fix_quick_insert_consistency_exp: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_quick_insert_consistency_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_fix_a11y_aria_posinset_0: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_a11y_aria_posinset_0'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-06
    cc_editor_limited_mode: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_limited_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_support: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_tables_scaling_css: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_scaling_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-10
    platform_synced_block: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_synced_block'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-06
    cc_improve_writing_on_paste: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_improve_writing_on_paste'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_find_replace_a11y_fixes: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_find_replace_a11y_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-19
    platform_editor_breakout_resizing_vc90_fix: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing_vc90_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_support_custom_components: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_support_custom_components'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-21
    platform_editor_paste_rich_text_bugfix: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_rich_text_bugfix',
            jira: 'platform_editor_paste_rich_text_bugfix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-25
    platform_editor_toolbar_aifc_template_editor: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_template_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-26
    platform_editor_toolbar_migrate_loom: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_migrate_loom',
            jira: 'platform_editor_toolbar_migrate_loom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-26
    platform_editor_toolbar_aifc_patch_1: (0, $jVhgk.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_patch_1',
            jira: 'platform_editor_toolbar_aifc_patch_1'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};

});
parcelRegister("jVhgk", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", function () { return $e810bb24b49cf2df$export$456f1587c9c92021; });
$parcel$export(module.exports, "createMultivariateExperiment", function () { return $e810bb24b49cf2df$export$fb89e8a786694d1; });

var $7vPd4 = parcelRequire("7vPd4");

var $35hqc = parcelRequire("35hqc");

var $4ljl2 = parcelRequire("4ljl2");
function $e810bb24b49cf2df$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e810bb24b49cf2df$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e810bb24b49cf2df$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $35hqc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e810bb24b49cf2df$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e810bb24b49cf2df$export$456f1587c9c92021(config) {
    return $e810bb24b49cf2df$var$_objectSpread($e810bb24b49cf2df$var$_objectSpread({}, config), {}, {
        typeGuard: (0, $4ljl2.isBoolean),
        defaultValue: config.defaultValue
    });
}
function $e810bb24b49cf2df$export$fb89e8a786694d1(config) {
    var values = config.values;
    return $e810bb24b49cf2df$var$_objectSpread($e810bb24b49cf2df$var$_objectSpread({}, config), {}, {
        values: (0, $7vPd4.default)(values),
        // Maintains the tuple
        typeGuard: (0, $4ljl2.oneOf)(config.values),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("4ljl2", function(module, exports) {
$parcel$export(module.exports, "isBoolean", function () { return $32981fcc6e864941$export$f9ce7b637dfbe238; });
$parcel$export(module.exports, "oneOf", function () { return $32981fcc6e864941$export$a9a18ae5ba42aeab; });
function $32981fcc6e864941$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $32981fcc6e864941$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($32981fcc6e864941$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
// @ts-ignore
var $32981fcc6e864941$var$IS_TESTING_ENV = false;

});



parcelRegister("2BBaO", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", function () { return $1e5bdf58be3751ab$export$7e849a84a00ffd1c; });
$parcel$export(module.exports, "testBooleanOverrides", function () { return $1e5bdf58be3751ab$export$54960937bb713f97; });
var $1e5bdf58be3751ab$export$7e849a84a00ffd1c = {
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_ai_proactive_ai_nudge_parameters: 'control',
    platform_editor_controls: 'control',
    confluence_whiteboards_quick_insert_aa: 'control',
    confluence_whiteboards_quick_insert: 'control',
    cc_editor_interactions_trigger_traceufointeraction: 'control',
    platform_editor_insertion: 'control',
    editor_ai_inline_suggestion_date_v2: 'control',
    platform_editor_add_orange_highlight_color: 'control',
    platform_editor_ai_iw_adf_streaming: 'control',
    platform_hover_card_preview_panel: 'control'
};
var $1e5bdf58be3751ab$export$54960937bb713f97 = {
    platform_editor_feedback_mandatory_rating: false,
    platform_editor_preview_panel_responsiveness: false,
    platform_editor_renderer_breakout_fix: false,
    platform_editor_toolbar_aifc: false,
    platform_editor_memoized_node_check: false,
    platform_editor_media_card_vc_wrapper_attribute: false,
    platform_editor_block_control_optimise_render: false,
    'test-new-experiments-package': false,
    support_table_in_comment: false,
    platform_editor_exp_lazy_node_views: false,
    platform_renderer_table_sticky_scrollbar: false,
    platform_editor_controls_performance_fixes: false,
    platform_editor_prevent_toolbar_layout_shifts: false,
    comment_on_bodied_extensions: false,
    advanced_layouts: false,
    single_column_layouts: false,
    support_table_in_comment_jira: false,
    'nested-tables-in-tables': false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_blockquote_in_text_formatting_menu: false,
    platform_editor_element_drag_and_drop_multiselect: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_smart_link_cmd_ctrl_click: false,
    platform_editor_vanilla_dom: false,
    platform_editor_offline_editing_web: false,
    platform_editor_tables_drag_and_drop: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_stop_width_reflows: false,
    platform_editor_core_static_emotion: false,
    platform_editor_core_static_emotion_non_central: false,
    platform_editor_no_cursor_on_edit_page_init: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_nodevisibility: false,
    platform_editor_breakout_resizing: false,
    platform_editor_ai_quickstart_command: false,
    platform_editor_toolbar_rerender_optimization_exp: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_ai_remove_trivial_prompts_cc: false,
    platform_editor_find_and_replace_improvements: false,
    cc_editor_ufo_hold_table_till_resize_complete: false,
    platform_editor_toggle_expand_on_match_found: false,
    platform_editor_reduce_noisy_steps_ncs: false,
    cc_improve_writing_on_paste: false,
    platform_editor_ai_aifc: false
};

});




parcelRegister("8S7b4", function(module, exports) {
// Packages

var $keRAj = parcelRequire("keRAj");
function $6758ef300f180b67$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $keRAj.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $6758ef300f180b67$var$retry;

});

parcelRegister("2v440", function(module, exports) {
$parcel$export(module.exports, "APIError", function () { return $1d21a0fef4441d0d$export$3e5b797e39668f84; });

var $fmKqJ = parcelRequire("fmKqJ");

var $aU64m = parcelRequire("aU64m");

var $f3sSy = parcelRequire("f3sSy");

var $8eIcZ = parcelRequire("8eIcZ");

var $2yISS = parcelRequire("2yISS");

var $78Q2K = parcelRequire("78Q2K");
function $1d21a0fef4441d0d$var$_callSuper(t, o, e) {
    return o = (0, $8eIcZ.default)(o), (0, $f3sSy.default)(t, $1d21a0fef4441d0d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $8eIcZ.default)(t).constructor) : o.apply(t, e));
}
function $1d21a0fef4441d0d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1d21a0fef4441d0d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $1d21a0fef4441d0d$export$3e5b797e39668f84 = /*#__PURE__*/ function(_Error) {
    function APIError(kind, hostname, message, type, extensionKey) {
        var _this;
        (0, $aU64m.default)(this, APIError);
        _this = $1d21a0fef4441d0d$var$_callSuper(this, APIError, [
            "".concat(kind, ": ").concat(message)
        ]);
        _this.kind = kind;
        _this.hostname = hostname;
        _this.message = message;
        _this.type = type;
        _this.extensionKey = extensionKey;
        _this.name = 'APIError';
        // The error type received from the server.
        _this.type = type;
        // The kind mapped to on the client.
        _this.kind = kind;
        // The message received from the server.
        _this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        _this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        _this.extensionKey = extensionKey;
        return _this;
    }
    (0, $2yISS.default)(APIError, _Error);
    return (0, $fmKqJ.default)(APIError);
}(/*#__PURE__*/ (0, $78Q2K.default)(Error));

});

parcelRegister("9IyXd", function(module, exports) {
$parcel$export(module.exports, "getResolverUrl", function () { return $713356405e4c0241$export$dc37652c1696f231; });
var $713356405e4c0241$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
var $713356405e4c0241$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
var $713356405e4c0241$var$prodBaseUrl = 'https://api-private.atlassian.com';
var $713356405e4c0241$export$e2b040f052407032 = {
    dev: $713356405e4c0241$var$devBaseUrl,
    development: $713356405e4c0241$var$devBaseUrl,
    stg: $713356405e4c0241$var$stgBaseUrl,
    staging: $713356405e4c0241$var$stgBaseUrl,
    prd: $713356405e4c0241$var$prodBaseUrl,
    prod: $713356405e4c0241$var$prodBaseUrl,
    production: $713356405e4c0241$var$prodBaseUrl
};
var $713356405e4c0241$export$f654b28f82155665 = function getBaseUrl(envKey, baseUrlOverride) {
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride !== null && baseUrlOverride !== void 0 ? baseUrlOverride : $713356405e4c0241$var$prodBaseUrl;
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $713356405e4c0241$export$e2b040f052407032 ? $713356405e4c0241$export$e2b040f052407032[envKey] : $713356405e4c0241$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
var $713356405e4c0241$export$dc37652c1696f231 = function getResolverUrl(envKey, baseUrlOverride) {
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride !== null && baseUrlOverride !== void 0 ? baseUrlOverride : '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        var baseUrl = baseUrlOverride || $713356405e4c0241$export$f654b28f82155665(envKey);
        return "".concat(baseUrl, "/object-resolver");
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $713356405e4c0241$export$2e2bcd8739ae039 = $713356405e4c0241$export$e2b040f052407032;

});

parcelRegister("9ORHy", function(module, exports) {
$parcel$export(module.exports, "getStatus", function () { return $72627091508e11cc$export$b70265791d2079d4; });
var $72627091508e11cc$var$getStatusForNotFoundVisibility = function getStatusForNotFoundVisibility(meta) {
    var _meta$requestAccess;
    var accessType = (_meta$requestAccess = meta.requestAccess) === null || _meta$requestAccess === void 0 ? void 0 : _meta$requestAccess.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
var $72627091508e11cc$export$b70265791d2079d4 = function getStatus(_ref) {
    var meta = _ref.meta;
    var access = meta.access, visibility = meta.visibility;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $72627091508e11cc$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});

parcelRegister("dtL2d", function(module, exports) {
$parcel$export(module.exports, "NetworkError", function () { return $9d0277ec35885b2d$export$bae979e68e4dc802; });
$parcel$export(module.exports, "request", function () { return $9d0277ec35885b2d$export$b5fe3f66a567bec0; });

var $35hqc = parcelRequire("35hqc");

var $aBFyY = parcelRequire("aBFyY");

var $fmKqJ = parcelRequire("fmKqJ");

var $aU64m = parcelRequire("aU64m");

var $f3sSy = parcelRequire("f3sSy");

var $8eIcZ = parcelRequire("8eIcZ");

var $2yISS = parcelRequire("2yISS");

var $78Q2K = parcelRequire("78Q2K");

var $8PYfA = parcelRequire("8PYfA");
function $9d0277ec35885b2d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9d0277ec35885b2d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9d0277ec35885b2d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $35hqc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9d0277ec35885b2d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9d0277ec35885b2d$var$_callSuper(t, o, e) {
    return o = (0, $8eIcZ.default)(o), (0, $f3sSy.default)(t, $9d0277ec35885b2d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $8eIcZ.default)(t).constructor) : o.apply(t, e));
}
function $9d0277ec35885b2d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9d0277ec35885b2d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $9d0277ec35885b2d$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
var $9d0277ec35885b2d$export$bae979e68e4dc802 = /*#__PURE__*/ function(_Error) {
    function NetworkError(error) {
        (0, $aU64m.default)(this, NetworkError);
        return $9d0277ec35885b2d$var$_callSuper(this, NetworkError, [
            error
        ]);
    }
    (0, $2yISS.default)(NetworkError, _Error);
    return (0, $fmKqJ.default)(NetworkError);
}(/*#__PURE__*/ (0, $78Q2K.default)(Error));
function $9d0277ec35885b2d$export$b5fe3f66a567bec0(_x, _x2, _x3, _x4) {
    return $9d0277ec35885b2d$var$_request.apply(this, arguments);
}
function $9d0277ec35885b2d$var$_request() {
    $9d0277ec35885b2d$var$_request = (0, $aBFyY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).mark(function _callee(method, url, data, headers) {
        var statuses, requestConfig, response, text, _args = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8PYfA))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    statuses = _args.length > 4 && _args[4] !== undefined ? _args[4] : $9d0277ec35885b2d$var$ALLOWED_RESPONSE_STATUS_CODES;
                    requestConfig = $9d0277ec35885b2d$var$_objectSpread({
                        method: method,
                        credentials: 'include',
                        headers: $9d0277ec35885b2d$var$_objectSpread({
                            Accept: 'application/json',
                            'Cache-Control': 'no-cache',
                            'Content-Type': 'application/json'
                        }, headers)
                    }, data ? {
                        body: JSON.stringify(data)
                    } : {});
                    _context.prev = 2;
                    _context.next = 5;
                    return fetch(url, requestConfig);
                case 5:
                    response = _context.sent;
                    if (!(response.ok || statuses !== null && statuses !== void 0 && statuses.includes(response.status))) {
                        _context.next = 17;
                        break;
                    }
                    if (!statuses.includes(204)) {
                        _context.next = 14;
                        break;
                    }
                    _context.next = 10;
                    return response.text();
                case 10:
                    text = _context.sent;
                    return _context.abrupt("return", text ? JSON.parse(text) : undefined);
                case 14:
                    _context.next = 16;
                    return response.json();
                case 16:
                    return _context.abrupt("return", _context.sent);
                case 17:
                    throw response;
                case 20:
                    _context.prev = 20;
                    _context.t0 = _context["catch"](2);
                    if (!(typeof _context.t0 === 'string' || _context.t0 instanceof TypeError)) {
                        _context.next = 24;
                        break;
                    }
                    throw new $9d0277ec35885b2d$export$bae979e68e4dc802(_context.t0);
                case 24:
                    throw _context.t0;
                case 25:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                2,
                20
            ]
        ]);
    }));
    return $9d0277ec35885b2d$var$_request.apply(this, arguments);
}

});

parcelRegister("lK1WF", function(module, exports) {
$parcel$export(module.exports, "isSuccessfulResponse", function () { return $fd3f671d9b03cac0$export$1b59fe731a28a49d; });
$parcel$export(module.exports, "isErrorResponse", function () { return $fd3f671d9b03cac0$export$bea7bee8a87e7c52; });
var $fd3f671d9b03cac0$export$1b59fe731a28a49d = function isSuccessfulResponse(response) {
    if (!response) return false;
    var hasSuccessfulStatus = response.status === 200;
    var hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
var $fd3f671d9b03cac0$export$bea7bee8a87e7c52 = function isErrorResponse(response) {
    if (!response) return false;
    var hasStatus = 'status' in response && response.status >= 200;
    var hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});


parcelRegister("6upp0", function(module, exports) {
$parcel$export(module.exports, "SmartCardProvider", function () { return $4b993fccad91272e$export$497ecb0280204df4; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("6uwqb");
var $lohLg = parcelRequire("lohLg");

var $eBAK3 = parcelRequire("eBAK3");

var $1irki = parcelRequire("1irki");

var $azA2w = parcelRequire("azA2w");

var $6VrlN = parcelRequire("6VrlN");

var $fzWTo = parcelRequire("fzWTo");

var $dl4xv = parcelRequire("dl4xv");
function $4b993fccad91272e$export$497ecb0280204df4(_ref) {
    var storeOptions = _ref.storeOptions, customClient = _ref.client, customAuthFlow = _ref.authFlow, children = _ref.children, renderers = _ref.renderers, isAdminHubAIEnabled = _ref.isAdminHubAIEnabled, product = _ref.product, shouldControlDataExport = _ref.shouldControlDataExport, isPreviewPanelAvailable = _ref.isPreviewPanelAvailable, openPreviewPanel = _ref.openPreviewPanel;
    var parentContext = (0, $1oC0p.useContext)((0, $fzWTo.SmartCardContext));
    var defaultInitialState = (0, $1oC0p.useMemo)(function() {
        return {};
    }, []);
    var _ref2 = storeOptions || {
        initialState: defaultInitialState
    }, initialState = _ref2.initialState;
    var store = (0, $1oC0p.useMemo)(function() {
        return (0, $lohLg.default)((0, $6VrlN.cardReducer), initialState);
    }, [
        initialState
    ]);
    var providerValue = (0, $1oC0p.useMemo)(function() {
        var client = customClient || new (0, $dl4xv.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        var authFlow = customAuthFlow || 'oauth2';
        var getPreview = function getPreview(url, platform) {
            var cardState = (0, $1irki.getUrl)(store, url);
            return cardState.details ? (0, $azA2w.extractSmartLinkEmbed)(cardState.details) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        };
    }, [
        customAuthFlow,
        customClient,
        isAdminHubAIEnabled,
        isPreviewPanelAvailable,
        openPreviewPanel,
        product,
        renderers,
        shouldControlDataExport,
        store
    ]);
    var value = (0, $1oC0p.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eBAK3)))({}, parentContext || providerValue, {
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        });
    }, [
        parentContext,
        providerValue,
        isPreviewPanelAvailable,
        openPreviewPanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fzWTo.SmartCardContext).Provider, {
        value: value
    }, children);
}
var $4b993fccad91272e$export$2e2bcd8739ae039 = $4b993fccad91272e$export$497ecb0280204df4;

});
parcelRegister("6uwqb", function(module, exports) {
$parcel$export(module.exports, "createStore", function () { return (parcelRequire("lohLg")).default; });

var $lohLg = parcelRequire("lohLg");

var $8MbiQ = parcelRequire("8MbiQ");

var $l6bqV = parcelRequire("l6bqV");

var $c02p7 = parcelRequire("c02p7");

var $2acKt = parcelRequire("2acKt");
parcelRequire("5J4lj");
/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/ function $4b9eb199e51bc67e$var$isCrushed() {}

});
parcelRegister("lohLg", function(module, exports) {
$parcel$export(module.exports, "ActionTypes", function () { return $f9299de2c71b1eb6$export$1385d81a6c6bbcd4; });
$parcel$export(module.exports, "default", function () { return $f9299de2c71b1eb6$export$2e2bcd8739ae039; });

var $kh05o = parcelRequire("kh05o");

var $9IkUh = parcelRequire("9IkUh");
var $f9299de2c71b1eb6$export$1385d81a6c6bbcd4 = {
    INIT: '@@redux/INIT'
};
function $f9299de2c71b1eb6$export$2e2bcd8739ae039(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error('Expected the enhancer to be a function.');
        return enhancer($f9299de2c71b1eb6$export$2e2bcd8739ae039)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error('Expected the reducer to be a function.');
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error('Expected listener to be a function.');
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!(0, $kh05o.default)(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === 'undefined') throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error('Reducers may not dispatch actions.');
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error('Expected the nextReducer to be a function.');
        currentReducer = nextReducer;
        dispatch({
            type: $f9299de2c71b1eb6$export$1385d81a6c6bbcd4.INIT
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object') throw new TypeError('Expected the observer to be an object.');
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[0, $9IkUh.default] = function() {
            return this;
        }, _ref;
    }
    // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $f9299de2c71b1eb6$export$1385d81a6c6bbcd4.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[0, $9IkUh.default] = observable, _ref2;
}

});
parcelRegister("kh05o", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ec257644c5d319ac$export$2e2bcd8739ae039; });

var $h1ib9 = parcelRequire("h1ib9");

var $gkyv4 = parcelRequire("gkyv4");

var $dnwPh = parcelRequire("dnwPh");
/** `Object#toString` result references. */ var $ec257644c5d319ac$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $ec257644c5d319ac$var$funcProto = Function.prototype, $ec257644c5d319ac$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ec257644c5d319ac$var$funcToString = $ec257644c5d319ac$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ec257644c5d319ac$var$hasOwnProperty = $ec257644c5d319ac$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $ec257644c5d319ac$var$objectCtorString = $ec257644c5d319ac$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $ec257644c5d319ac$var$isPlainObject(value) {
    if (!(0, $dnwPh.default)(value) || (0, $h1ib9.default)(value) != $ec257644c5d319ac$var$objectTag) return false;
    var proto = (0, $gkyv4.default)(value);
    if (proto === null) return true;
    var Ctor = $ec257644c5d319ac$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $ec257644c5d319ac$var$funcToString.call(Ctor) == $ec257644c5d319ac$var$objectCtorString;
}
var $ec257644c5d319ac$export$2e2bcd8739ae039 = $ec257644c5d319ac$var$isPlainObject;

});
parcelRegister("h1ib9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c640a19e9ea01620$export$2e2bcd8739ae039; });

var $jQpJx = parcelRequire("jQpJx");

var $h0KqD = parcelRequire("h0KqD");

var $iPx4I = parcelRequire("iPx4I");
/** `Object#toString` result references. */ var $c640a19e9ea01620$var$nullTag = '[object Null]', $c640a19e9ea01620$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $c640a19e9ea01620$var$symToStringTag = (0, $jQpJx.default) ? (0, $jQpJx.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $c640a19e9ea01620$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $c640a19e9ea01620$var$undefinedTag : $c640a19e9ea01620$var$nullTag;
    return $c640a19e9ea01620$var$symToStringTag && $c640a19e9ea01620$var$symToStringTag in Object(value) ? (0, $h0KqD.default)(value) : (0, $iPx4I.default)(value);
}
var $c640a19e9ea01620$export$2e2bcd8739ae039 = $c640a19e9ea01620$var$baseGetTag;

});
parcelRegister("jQpJx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e726d5c943c808b4$export$2e2bcd8739ae039; });

var $ftdUd = parcelRequire("ftdUd");
/** Built-in value references. */ var $e726d5c943c808b4$var$Symbol = (0, $ftdUd.default).Symbol;
var $e726d5c943c808b4$export$2e2bcd8739ae039 = $e726d5c943c808b4$var$Symbol;

});
parcelRegister("ftdUd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b43459d5c05996b8$export$2e2bcd8739ae039; });

var $604lN = parcelRequire("604lN");
/** Detect free variable `self`. */ var $b43459d5c05996b8$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $b43459d5c05996b8$var$root = (0, $604lN.default) || $b43459d5c05996b8$var$freeSelf || Function('return this')();
var $b43459d5c05996b8$export$2e2bcd8739ae039 = $b43459d5c05996b8$var$root;

});
parcelRegister("604lN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $01209d638617359c$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $01209d638617359c$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $01209d638617359c$export$2e2bcd8739ae039 = $01209d638617359c$var$freeGlobal;

});



parcelRegister("h0KqD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c626737ecacc4f71$export$2e2bcd8739ae039; });

var $jQpJx = parcelRequire("jQpJx");
/** Used for built-in method references. */ var $c626737ecacc4f71$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c626737ecacc4f71$var$hasOwnProperty = $c626737ecacc4f71$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c626737ecacc4f71$var$nativeObjectToString = $c626737ecacc4f71$var$objectProto.toString;
/** Built-in value references. */ var $c626737ecacc4f71$var$symToStringTag = (0, $jQpJx.default) ? (0, $jQpJx.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $c626737ecacc4f71$var$getRawTag(value) {
    var isOwn = $c626737ecacc4f71$var$hasOwnProperty.call(value, $c626737ecacc4f71$var$symToStringTag), tag = value[$c626737ecacc4f71$var$symToStringTag];
    try {
        value[$c626737ecacc4f71$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $c626737ecacc4f71$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$c626737ecacc4f71$var$symToStringTag] = tag;
        else delete value[$c626737ecacc4f71$var$symToStringTag];
    }
    return result;
}
var $c626737ecacc4f71$export$2e2bcd8739ae039 = $c626737ecacc4f71$var$getRawTag;

});

parcelRegister("iPx4I", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $db56a57532e88b14$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $db56a57532e88b14$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $db56a57532e88b14$var$nativeObjectToString = $db56a57532e88b14$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $db56a57532e88b14$var$objectToString(value) {
    return $db56a57532e88b14$var$nativeObjectToString.call(value);
}
var $db56a57532e88b14$export$2e2bcd8739ae039 = $db56a57532e88b14$var$objectToString;

});


parcelRegister("gkyv4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $be394698e8e9447d$export$2e2bcd8739ae039; });

var $f2Hk1 = parcelRequire("f2Hk1");
/** Built-in value references. */ var $be394698e8e9447d$var$getPrototype = (0, $f2Hk1.default)(Object.getPrototypeOf, Object);
var $be394698e8e9447d$export$2e2bcd8739ae039 = $be394698e8e9447d$var$getPrototype;

});
parcelRegister("f2Hk1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $af38a5bccb69a8dc$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $af38a5bccb69a8dc$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $af38a5bccb69a8dc$export$2e2bcd8739ae039 = $af38a5bccb69a8dc$var$overArg;

});


parcelRegister("dnwPh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9bd6e2f2c0236d51$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $9bd6e2f2c0236d51$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $9bd6e2f2c0236d51$export$2e2bcd8739ae039 = $9bd6e2f2c0236d51$var$isObjectLike;

});


parcelRegister("9IkUh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $712870c334d09718$export$2e2bcd8739ae039; });
/* global window */ 
var $8Py4t = parcelRequire("8Py4t");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $8Py4t.default)(root);
var $712870c334d09718$export$2e2bcd8739ae039 = result;

});
parcelRegister("8Py4t", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $66dd83fa3a3cfda9$export$2e2bcd8739ae039; });
function $66dd83fa3a3cfda9$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

});



parcelRegister("8MbiQ", function(module, exports) {

var $lohLg = parcelRequire("lohLg");

var $kh05o = parcelRequire("kh05o");
parcelRequire("5J4lj");
function $663b92f52719c26c$var$getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
    return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}
function $663b92f52719c26c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === (0, $lohLg.ActionTypes).INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!(0, $kh05o.default)(inputState)) return 'The ' + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (unexpectedKeys.length > 0) return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $663b92f52719c26c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: (0, $lohLg.ActionTypes).INIT
        });
        if (typeof initialState === 'undefined') throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
        var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
        if (typeof reducer(undefined, {
            type: type
        }) === 'undefined') throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + (0, $lohLg.ActionTypes).INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    });
}
function $663b92f52719c26c$export$2e2bcd8739ae039(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache = void 0;
    var shapeAssertionError = void 0;
    try {
        $663b92f52719c26c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var errorMessage = $663b92f52719c26c$var$getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}

});
parcelRegister("5J4lj", function(module, exports) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $42b48616410b78ec$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});


parcelRegister("l6bqV", function(module, exports) {
function $f5c306e8c31ee578$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(undefined, arguments));
    };
}
function $f5c306e8c31ee578$export$2e2bcd8739ae039(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $f5c306e8c31ee578$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var keys = Object.keys(actionCreators);
    var boundActionCreators = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $f5c306e8c31ee578$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}

});

parcelRegister("c02p7", function(module, exports) {

var $2acKt = parcelRequire("2acKt");
var $8bc7598aa83aebeb$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $8bc7598aa83aebeb$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function(reducer, preloadedState, enhancer) {
            var store = createStore(reducer, preloadedState, enhancer);
            var _dispatch = store.dispatch;
            var chain = [];
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch(action) {
                    return _dispatch(action);
                }
            };
            chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = (0, $2acKt.default).apply(undefined, chain)(store.dispatch);
            return $8bc7598aa83aebeb$var$_extends({}, store, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("2acKt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $19366788b5d1924b$export$2e2bcd8739ae039; });
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $19366788b5d1924b$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(undefined, arguments));
        };
    });
}

});



parcelRegister("1irki", function(module, exports) {
$parcel$export(module.exports, "getUrl", function () { return $0f1cab5630ebe6dd$export$94df0e59ebebf4a7; });
var $0f1cab5630ebe6dd$export$94df0e59ebebf4a7 = function getUrl(store, url) {
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("6VrlN", function(module, exports) {
$parcel$export(module.exports, "cardReducer", function () { return $50ad4830b5b6b2f2$export$3c7c3113a97b6492; });

var $35hqc = parcelRequire("35hqc");

var $916DP = parcelRequire("916DP");
var $9ORHy = parcelRequire("9ORHy");
function $50ad4830b5b6b2f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $50ad4830b5b6b2f2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $50ad4830b5b6b2f2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $35hqc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $50ad4830b5b6b2f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $50ad4830b5b6b2f2$var$isCardAction = function isCardAction(action) {
    return [
        (0, $916DP.ACTION_PENDING),
        (0, $916DP.ACTION_RESOLVING),
        (0, $916DP.ACTION_RESOLVED),
        (0, $916DP.ACTION_RELOADING),
        (0, $916DP.ACTION_ERROR),
        (0, $916DP.ACTION_ERROR_FALLBACK),
        (0, $916DP.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $50ad4830b5b6b2f2$var$persistPayloadToState(payload, state, type) {
    var nextDetails = payload;
    var nextState = $50ad4830b5b6b2f2$var$_objectSpread({}, state);
    if (nextDetails) {
        nextState.status = (0, $9ORHy.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $50ad4830b5b6b2f2$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $916DP.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $916DP.ACTION_RESOLVING:
            return $50ad4830b5b6b2f2$var$_objectSpread($50ad4830b5b6b2f2$var$_objectSpread({}, state), {}, {
                status: action.type
            });
        case 0, $916DP.ACTION_RESOLVED:
            return $50ad4830b5b6b2f2$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $916DP.ACTION_RELOADING:
            return $50ad4830b5b6b2f2$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $916DP.ACTION_ERROR:
            return $50ad4830b5b6b2f2$var$_objectSpread($50ad4830b5b6b2f2$var$_objectSpread({}, state), {}, {
                status: action.type,
                error: action.error
            });
        case 0, $916DP.ACTION_ERROR_FALLBACK:
            return $50ad4830b5b6b2f2$var$_objectSpread($50ad4830b5b6b2f2$var$_objectSpread({}, state), {}, {
                status: action.type,
                error: action.error,
                details: action.payload
            });
        case 0, $916DP.ACTION_UPDATE_METADATA_STATUS:
            return $50ad4830b5b6b2f2$var$_objectSpread($50ad4830b5b6b2f2$var$_objectSpread({}, state), {}, {
                metadataStatus: action.metadataStatus
            });
    }
}
var $50ad4830b5b6b2f2$export$3c7c3113a97b6492 = function cardReducer(state, action) {
    if (!$50ad4830b5b6b2f2$var$isCardAction(action)) return state;
    var cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    var hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        var nextState = $50ad4830b5b6b2f2$var$reduceToNextState(cardState, action);
        return $50ad4830b5b6b2f2$var$_objectSpread($50ad4830b5b6b2f2$var$_objectSpread({}, state), {}, (0, $35hqc.default)({}, action.url, nextState));
    }
};

});
parcelRegister("916DP", function(module, exports) {
$parcel$export(module.exports, "ACTION_PENDING", function () { return $69095beaf3b61ce3$export$6e470aad5ba8952e; });
$parcel$export(module.exports, "ACTION_RESOLVING", function () { return $69095beaf3b61ce3$export$9a6a932a0a39498e; });
$parcel$export(module.exports, "ACTION_RESOLVED", function () { return $69095beaf3b61ce3$export$63ec8bc7a8a75482; });
$parcel$export(module.exports, "ACTION_RELOADING", function () { return $69095beaf3b61ce3$export$b8cfaa842c9ab487; });
$parcel$export(module.exports, "ACTION_ERROR", function () { return $69095beaf3b61ce3$export$6d8ed3f9433dd372; });
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", function () { return $69095beaf3b61ce3$export$cfbbb7126bc8a0c6; });
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", function () { return $69095beaf3b61ce3$export$2c5edb971b673330; });
// TODO: eventually move this file to @atlaskit/link-actions
var $69095beaf3b61ce3$export$6e470aad5ba8952e = 'pending';
var $69095beaf3b61ce3$export$9a6a932a0a39498e = 'resolving';
var $69095beaf3b61ce3$export$63ec8bc7a8a75482 = 'resolved';
var $69095beaf3b61ce3$export$b8cfaa842c9ab487 = 'reloading';
var $69095beaf3b61ce3$export$6d8ed3f9433dd372 = 'errored';
var $69095beaf3b61ce3$export$cfbbb7126bc8a0c6 = 'fallback';
var $69095beaf3b61ce3$export$76b5c1aca20759c6 = 'preload';
var $69095beaf3b61ce3$export$2c5edb971b673330 = 'metadata';
var $69095beaf3b61ce3$export$a884a52152489cc3 = function cardAction(type, _ref, payload, error, metadataStatus, ignoreStatusCheck) {
    var url = _ref.url;
    return {
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    };
};

});



parcelRegister("iVqTa", function(module, exports) {
$parcel$export(module.exports, "ConfluenceCardLinkSection", function () { return (parcelRequire("c26x0")).ConfluenceCardLinkSection; });

var $c26x0 = parcelRequire("c26x0");

});
parcelRegister("c26x0", function(module, exports) {
$parcel$export(module.exports, "ConfluenceCardLinkSection", function () { return $8fccfb567e665205$export$2d0695a48fb0c352; });

var $7VQPk = parcelRequire("7VQPk");

var $2YtGy = parcelRequire("2YtGy");

var $7vcgf = parcelRequire("7vcgf");

var $f7YG8 = parcelRequire("f7YG8");
const $8fccfb567e665205$export$2d0695a48fb0c352 = ()=>{
    const { data: engagementData } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomainEngagement);
    if ((engagementData === null || engagementData === void 0 ? void 0 : engagementData.engagementSpaces.length) === 0) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2YtGy.default), {
        children: engagementData === null || engagementData === void 0 ? void 0 : engagementData.engagementSpaces.map((space)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7vcgf.Card), {
                url: space.spaceUrl,
                appearance: "block"
            }, space.spaceKey))
    });
};

});


parcelRegister("7ruKO", function(module, exports) {
$parcel$export(module.exports, "NoAccessErrorDisplay", function () { return (parcelRequire("eqnO8")).NoAccessErrorDisplay; });
$parcel$export(module.exports, "NoEngagementErrorDisplay", function () { return (parcelRequire("8SFpL")).NoEngagementErrorDisplay; });
$parcel$export(module.exports, "UserNotProvisionedErrorDisplay", function () { return (parcelRequire("aJQLC")).UserNotProvisionedErrorDisplay; });

var $eqnO8 = parcelRequire("eqnO8");

var $8SFpL = parcelRequire("8SFpL");

var $aJQLC = parcelRequire("aJQLC");

});
parcelRegister("eqnO8", function(module, exports) {
$parcel$export(module.exports, "NoAccessErrorDisplay", function () { return $f2afa77049c18faa$export$5797fd0edc12feb5; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $dTJrO = parcelRequire("dTJrO");

var $g3ExX = parcelRequire("g3ExX");
var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");

var $lP7A9 = parcelRequire("lP7A9");
parcelRequire("5vhho");
var $1kbsS = parcelRequire("1kbsS");

var $e7r5Z = parcelRequire("e7r5Z");
const $f2afa77049c18faa$var$boxStyles = (0, $f6YGh.xcss)({
    borderRadius: "border.radius.200",
    border: `1px solid ${(0, $lP7A9.default)("color.border.disabled")}`
});
const $f2afa77049c18faa$export$5797fd0edc12feb5 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
        padding: "space.300",
        backgroundColor: "elevation.surface.sunken",
        xcss: $f2afa77049c18faa$var$boxStyles,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
            space: "space.400",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1kbsS.PadlockVector), {
                    alt: intl.formatMessage((0, $e7r5Z.messages).noAccessGraphicAltText)
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $e7r5Z.messages).noAccessHeading))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $e7r5Z.messages).noAccessDescription))
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("5vhho", function(module, exports) {
$parcel$export(module.exports, "PadlockVector", function () { return (parcelRequire("1kbsS")).PadlockVector; });
$parcel$export(module.exports, "BlueprintVector", function () { return (parcelRequire("jTawP")).BlueprintVector; });

var $1kbsS = parcelRequire("1kbsS");

var $jTawP = parcelRequire("jTawP");

});
parcelRegister("1kbsS", function(module, exports) {
$parcel$export(module.exports, "PadlockVector", function () { return $4486b3b07193329a$export$627608150531cee2; });

var $7VQPk = parcelRequire("7VQPk");
const $4486b3b07193329a$export$627608150531cee2 = ({ alt: alt })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "103",
        height: "103",
        viewBox: "0 0 275 276",
        fill: "none",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M207.85 185.032C208.72 180.132 209.18 174.932 209.18 169.422C209.18 163.912 208.72 158.562 207.83 153.602C202.53 124.102 182.03 105.912 153.3 101.242C148.4 100.442 143.26 100.032 137.91 100.032C132.56 100.032 126.98 100.472 121.88 101.322C93.12 106.122 72.67 124.262 67.36 153.592C66.46 158.552 66 163.822 66 169.412C66 175.002 66.46 180.122 67.34 185.022C72.61 214.322 93.08 232.492 121.89 237.292C126.99 238.142 132.34 238.582 137.92 238.582C143.5 238.582 148.41 238.172 153.31 237.372C182.1 232.692 202.61 214.472 207.87 185.012L207.85 185.032Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M156.92 162.162C157.16 160.812 157.29 159.382 157.29 157.862C157.29 156.342 157.16 154.872 156.92 153.512C155.46 145.392 149.82 140.392 141.91 139.102C140.56 138.882 139.15 138.772 137.67 138.772C136.19 138.772 134.66 138.892 133.26 139.132C125.34 140.452 119.71 145.442 118.25 153.522C118 154.882 117.87 156.342 117.87 157.872C117.87 159.402 118 160.822 118.24 162.172C119.69 170.232 125.33 175.242 133.25 176.562C134.65 176.792 136.13 176.922 137.66 176.922C139.19 176.922 140.55 176.812 141.9 176.592C149.82 175.302 155.47 170.292 156.92 162.182V162.162Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M189.62 82.2422H85.5303V127.532H189.62V82.2422Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M150.11 167.092H125.04V200.312H150.11V167.092Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M137.74 126.482C134.47 126.482 131.24 126.222 128.16 125.702C109.13 122.532 96.3099 110.162 93.0099 91.7825C92.4699 88.7625 92.1899 85.5625 92.1899 82.2925C92.1899 79.0225 92.4699 75.7425 93.0199 72.6825C96.3499 54.3025 109.15 41.9425 128.16 38.7725C134.23 37.7625 140.9 37.7425 146.96 38.7225C166 41.8225 178.83 54.2025 182.15 72.7025C182.7 75.7625 182.98 78.9925 182.98 82.2925C182.98 85.5925 182.71 88.7525 182.17 91.7725C178.87 110.272 166.04 122.662 146.97 125.762C144.01 126.242 140.91 126.492 137.75 126.492L137.74 126.482ZM137.74 47.2725C135 47.2725 132.25 47.4825 129.69 47.9125C114.55 50.4425 104.77 59.8225 102.14 74.3325C101.68 76.8425 101.45 79.5225 101.45 82.2925C101.45 85.0625 101.68 87.6625 102.12 90.1425C104.73 104.652 114.52 114.042 129.68 116.572C134.75 117.422 140.44 117.432 145.47 116.612C160.64 114.142 170.43 104.742 173.04 90.1425C173.48 87.6525 173.71 85.0125 173.71 82.2925C173.71 79.5725 173.48 76.8525 173.03 74.3325C170.41 59.7325 160.62 50.3325 145.47 47.8625C143.01 47.4625 140.37 47.2625 137.73 47.2625L137.74 47.2725Z",
                fill: "#BF63F3"
            })
        ]
    });

});

parcelRegister("jTawP", function(module, exports) {
$parcel$export(module.exports, "BlueprintVector", function () { return $8b0da906fe731c63$export$3cb8cd060458893; });

var $7VQPk = parcelRequire("7VQPk");
const $8b0da906fe731c63$export$3cb8cd060458893 = ({ alt: alt })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "103",
        height: "103",
        viewBox: "0 0 187 174",
        fill: "none",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M11.0994 12.6406L0.649414 173.651H180.859L186.389 12.6406H11.0994Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M62.9297 79.8306H48.8096L98.5296 32.3906L149.87 79.8306H136.073C131.974 108.204 136.969 136.581 136.969 136.581H64.3993C59.1247 120.533 61.3153 93.5329 62.9297 79.8306Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M48.8691 17.092C48.9091 13.072 47.7891 13.032 47.5191 17.042C47.1391 22.732 46.8191 28.712 46.5091 36.402C46.2291 45.122 46.3691 47.302 46.1191 53.202C45.7391 63.182 44.7791 80.002 44.5391 84.062C44.5091 84.662 44.4791 85.262 44.4591 85.862C44.3391 90.162 43.7791 109.022 43.0691 125.252C42.6291 136.712 42.3591 143.812 42.2191 147.522C41.8891 156.272 41.7491 162.822 41.7191 169.252C41.6991 172.782 42.6691 172.822 42.9191 169.302C43.3791 162.892 43.7491 156.352 44.0891 147.602C44.2191 144.202 44.7591 137.122 45.1891 127.122C45.2591 125.492 45.2991 123.862 45.3291 122.242C45.5091 108.282 46.3091 90.172 46.3091 90.172C46.3091 90.172 47.3591 63.152 47.7991 51.742C48.1291 43.152 48.2891 39.022 48.3791 36.482C48.6691 28.792 48.8091 22.802 48.8691 17.102V17.092Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M100.119 17.092C100.159 13.072 99.0391 13.032 98.7691 17.042C98.3791 22.732 98.0691 28.712 97.7591 36.402C97.4791 45.122 97.619 47.302 97.369 53.202C96.989 63.182 96.0291 80.002 95.7891 84.062C95.7591 84.662 95.7291 85.262 95.7091 85.862C95.5891 90.162 95.0291 109.022 94.3191 125.252C93.8791 136.712 93.6091 143.812 93.4691 147.522C93.1391 156.272 92.9991 162.822 92.9691 169.252C92.9491 172.782 93.9191 172.822 94.1691 169.302C94.6291 162.892 94.999 156.352 95.339 147.602C95.469 144.202 96.009 137.122 96.439 127.122C96.509 125.492 96.5491 123.862 96.5791 122.242C96.7591 108.282 97.5591 90.172 97.5591 90.172C97.5591 90.172 98.609 63.152 99.049 51.742C99.379 43.152 99.5391 39.022 99.6291 36.482C99.9191 28.792 100.059 22.802 100.119 17.102V17.092Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M151.369 17.092C151.409 13.072 150.289 13.032 150.019 17.042C149.639 22.732 149.319 28.712 149.009 36.402C148.729 45.122 148.869 47.302 148.619 53.202C148.239 63.182 147.279 80.002 147.039 84.062C147.009 84.662 146.979 85.262 146.959 85.862C146.839 90.162 146.279 109.022 145.569 125.252C145.129 136.712 144.859 143.812 144.719 147.522C144.389 156.272 144.249 162.822 144.219 169.252C144.199 172.782 145.169 172.822 145.419 169.302C145.879 162.892 146.249 156.352 146.589 147.602C146.719 144.202 147.259 137.122 147.689 127.122C147.759 125.492 147.799 123.862 147.829 122.242C148.009 108.282 148.809 90.172 148.809 90.172C148.809 90.172 149.859 63.152 150.299 51.742C150.629 43.152 150.789 39.022 150.879 36.482C151.169 28.792 151.309 22.802 151.369 17.102V17.092Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M180.31 50.8316C184.3 50.7316 184.3 49.6116 180.31 49.4816C174.66 49.3016 168.72 49.1916 161.08 49.1616C152.43 49.1916 150.27 49.4116 144.41 49.3716C134.5 49.3416 117.79 48.9816 113.76 48.8916C113.16 48.8816 112.57 48.8716 111.97 48.8816C107.7 48.9116 88.9897 49.0216 72.8797 48.8916C61.4997 48.8616 54.4597 48.8416 50.7797 48.8316C42.0897 48.8116 35.5997 48.9116 29.2197 49.1016C25.7197 49.2116 25.7197 50.1816 29.2197 50.3016C35.5897 50.5316 42.0897 50.6716 50.7697 50.7016C54.1497 50.7116 61.1797 51.0016 71.1097 51.0816C72.7297 51.0916 74.3497 51.0816 75.9497 51.0416C89.7997 50.7216 107.78 50.8816 107.78 50.8816C107.78 50.8816 134.61 50.9716 145.93 51.0016C154.46 51.0216 158.56 51.0316 161.08 51.0416C168.71 51.0616 174.65 50.9916 180.31 50.8416V50.8316Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M180.32 93.3512C184.29 93.2512 184.29 92.1311 180.32 92.0011C174.69 91.8211 168.78 91.7111 161.18 91.6811C152.56 91.7111 150.42 91.9311 144.58 91.8911C134.72 91.8611 118.08 91.5011 114.07 91.4111C113.48 91.4111 112.88 91.3911 112.29 91.4111C108.04 91.4411 89.4097 91.5511 73.3697 91.4111C62.0397 91.3811 55.0297 91.3612 51.3597 91.3512C42.7097 91.3312 36.2397 91.4311 29.8997 91.6211C26.4097 91.7311 26.4097 92.7011 29.8997 92.8211C36.2397 93.0511 42.7097 93.1911 51.3597 93.2211C54.7197 93.2211 61.7197 93.5212 71.6097 93.6012C73.2197 93.6012 74.8297 93.6011 76.4297 93.5611C90.2197 93.2411 108.12 93.4011 108.12 93.4011C108.12 93.4011 134.83 93.4911 146.1 93.5211C154.59 93.5411 158.67 93.5511 161.18 93.5611C168.78 93.5811 174.7 93.5111 180.32 93.3611V93.3512Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M180.32 135.511C184.29 135.411 184.29 134.291 180.32 134.161C174.69 133.981 168.78 133.871 161.18 133.841C152.56 133.871 150.42 134.091 144.58 134.051C134.72 134.021 118.08 133.661 114.07 133.571C113.48 133.571 112.88 133.551 112.29 133.571C108.04 133.601 89.4097 133.711 73.3697 133.571C62.0397 133.541 55.0297 133.521 51.3597 133.511C42.7097 133.491 36.2397 133.591 29.8997 133.781C26.4097 133.891 26.4097 134.861 29.8997 134.981C36.2397 135.211 42.7097 135.351 51.3597 135.381C54.7197 135.381 61.7197 135.681 71.6097 135.761C73.2197 135.761 74.8297 135.761 76.4297 135.721C90.2197 135.401 108.12 135.561 108.12 135.561C108.12 135.561 134.83 135.651 146.1 135.681C154.59 135.701 158.67 135.711 161.18 135.721C168.78 135.741 174.7 135.671 180.32 135.521V135.511Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0.649998 173.641C0.649998 173.641 1.46 155.421 27.8 157.141V0.000976562C27.8 0.000976562 4.88 10.941 0 30.511C0 30.511 0.649998 170.771 0.649998 173.651V173.641Z",
                fill: "#09326C"
            })
        ]
    });

});


parcelRegister("e7r5Z", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $47f2565b7e7f9447$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $47f2565b7e7f9447$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    noEngagementHeading: {
        id: "fastshift.migrations-management-page.error-display.no-engagement.heading",
        defaultMessage: "A migration project hasn\u2019t started yet",
        description: "Heading for error banner displayed when there is no engagement project"
    },
    noEngagementDescription: {
        id: "fastshift.migrations-management-page.error-display.no-engagement.description",
        defaultMessage: "The FastShift team will engage with the customer to create a detailed migration project, defining tasks and timelines. Once that work has kicked off, it will be visible on this page.",
        description: "Description for error banner displayed when there is no engagement project"
    },
    noEngagementGraphicAltText: {
        id: "fastshift.migrations-management-page.error-display.no-engagement.graphic-alt-text",
        defaultMessage: "Blueprint Graphic",
        description: "Alt Text for the blueprint vector graphic displayed when a no-engagement-project error occurs"
    },
    noAccessHeading: {
        id: "fastshift.migrations-management-page.error-display.no-access.heading",
        defaultMessage: "You do not have permissions to view the migration project",
        description: "Heading for error banner displayed when customer does not have permissions to access the existing engagement project"
    },
    noAccessDescription: {
        id: "fastshift.migrations-management-page.error-display.no-access.description",
        defaultMessage: "If you believe you should be able to see the content of the migration project, contact your FastShift Champion.",
        description: "Description for error banner displayed when customer does not have permissions to access the existing  engagement project"
    },
    noAccessGraphicAltText: {
        id: "fastshift.migrations-management-page.error-display.no-access.graphic-alt-text",
        defaultMessage: "Padlock Graphic",
        description: "Alt Text for the generic error vector graphic displayed when a no-access error occurs"
    },
    userAccountNotProvisionedHeading: {
        id: "fastshift.migrations-management-page.error-display.userAccountNotProvisioned.heading",
        defaultMessage: "Get started with your project",
        description: "Heading for error banner displayed when the user's account has not been provisioned in as-a-team site yet"
    },
    userAccountNotProvisionedDescription: {
        id: "fastshift.migrations-management-page.error-display.userAccountNotProvisioned.description",
        defaultMessage: "To get access to a project with your migration plan, you need to first log in so we can set up your account.",
        description: "Description for error banner displayed when the user's account has not been provisioned in as-a-team site yet"
    },
    userAccountNotProvisionedButton: {
        id: "fastshift.migrations-management-page.error-display.userAccountNotProvisioned.button",
        defaultMessage: "Log In",
        description: "Log In Button Text on the error banner displayed when the user's account has not been provisioned in as-a-team site yet"
    }
});

});


parcelRegister("8SFpL", function(module, exports) {
$parcel$export(module.exports, "NoEngagementErrorDisplay", function () { return $28bed2ead1b60475$export$9f8c7430254f1f61; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $dTJrO = parcelRequire("dTJrO");

var $g3ExX = parcelRequire("g3ExX");
var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");

var $lP7A9 = parcelRequire("lP7A9");
parcelRequire("5vhho");
var $jTawP = parcelRequire("jTawP");

var $e7r5Z = parcelRequire("e7r5Z");
const $28bed2ead1b60475$var$boxStyles = (0, $f6YGh.xcss)({
    borderRadius: "border.radius.200",
    border: `1px solid ${(0, $lP7A9.default)("color.border.disabled")}`
});
const $28bed2ead1b60475$export$9f8c7430254f1f61 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
        padding: "space.300",
        backgroundColor: "elevation.surface.sunken",
        xcss: $28bed2ead1b60475$var$boxStyles,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
            space: "space.400",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jTawP.BlueprintVector), {
                    alt: intl.formatMessage((0, $e7r5Z.messages).noEngagementGraphicAltText)
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $e7r5Z.messages).noEngagementHeading))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $e7r5Z.messages).noEngagementDescription))
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("aJQLC", function(module, exports) {
$parcel$export(module.exports, "UserNotProvisionedErrorDisplay", function () { return $14a07c4d6a385c99$export$b36df73398da08ac; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $1p5OQ = parcelRequire("1p5OQ");

var $dTJrO = parcelRequire("dTJrO");

var $g3ExX = parcelRequire("g3ExX");
var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");

var $lP7A9 = parcelRequire("lP7A9");

var $fq4go = parcelRequire("fq4go");
parcelRequire("5vhho");
var $jTawP = parcelRequire("jTawP");

var $e7r5Z = parcelRequire("e7r5Z");
const $14a07c4d6a385c99$var$boxStyles = (0, $f6YGh.xcss)({
    borderRadius: "border.radius.200",
    border: `1px solid ${(0, $lP7A9.default)("color.border.disabled")}`
});
const $14a07c4d6a385c99$export$b36df73398da08ac = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
        padding: "space.300",
        backgroundColor: "elevation.surface.sunken",
        xcss: $14a07c4d6a385c99$var$boxStyles,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
            space: "space.400",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jTawP.BlueprintVector), {
                    alt: intl.formatMessage((0, $e7r5Z.messages).noEngagementGraphicAltText)
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $e7r5Z.messages).userAccountNotProvisionedHeading))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $e7r5Z.messages).userAccountNotProvisionedDescription))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1p5OQ.default), {
                                href: (0, $fq4go.AS_A_TEAM_URL),
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $e7r5Z.messages).userAccountNotProvisionedButton))
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});


parcelRegister("kx6Ht", function(module, exports) {
$parcel$export(module.exports, "useMigrationsManagementPageAnalytics", function () { return (parcelRequire("32pHP")).useMigrationsManagementPageAnalytics; });
$parcel$export(module.exports, "useMigrationsManagementUIAnalytics", function () { return (parcelRequire("5MNbT")).useMigrationsManagementUIAnalytics; });

var $32pHP = parcelRequire("32pHP");

var $5MNbT = parcelRequire("5MNbT");

});
parcelRegister("32pHP", function(module, exports) {
$parcel$export(module.exports, "useMigrationsManagementPageAnalytics", function () { return $807a33ac82aedf4f$export$80981aa7a88d8f7b; });

var $6ogO3 = parcelRequire("6ogO3");

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");

var $mI0Tn = parcelRequire("mI0Tn");
const $807a33ac82aedf4f$export$80981aa7a88d8f7b = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)();
    const { fireScreenEvent: fireScreenEvent, fireTrackEvent: fireTrackEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    const { data: engagementData, error: engagementError, pending: engagementPending } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomainEngagement);
    // Screen event
    (0, $1oC0p.useEffect)(()=>{
        if (!identityAttrs) return;
        fireScreenEvent({
            name: (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_MIGRATION_PLANNING_SCREEN
        });
    }, [
        fireScreenEvent,
        identityAttrs
    ]);
    // Track event
    (0, $1oC0p.useEffect)(()=>{
        if (!identityAttrs || engagementPending) return;
        const hasError = !!engagementError;
        const metrics = !hasError && engagementData ? (0, $mI0Tn.calculateEngagementMetrics)(engagementData) : {
            embedCount: null,
            boardCount: null,
            projectCount: null,
            spaceCount: null
        };
        fireTrackEvent({
            action: (0, $3cXzX.ActionKey).DISPLAYED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).SECTION,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).MIGRATION_PLANNER_EMBED_SECTION,
            source: sourceKey,
            attributes: (0, $6ogO3._)({
                hasError: hasError,
                errorType: engagementError
            }, metrics)
        });
    }, [
        fireTrackEvent,
        identityAttrs,
        engagementData,
        engagementError,
        engagementPending,
        sourceKey
    ]);
};

});
parcelRegister("mI0Tn", function(module, exports) {
$parcel$export(module.exports, "calculateEngagementMetrics", function () { return $5df822d3e0c2ad83$export$772abf2d17c1bdd; });
const $5df822d3e0c2ad83$export$772abf2d17c1bdd = (engagementData)=>{
    const embedCount = engagementData.engagementProjects.reduce((total, project)=>{
        return total + project.boards.reduce((boardTotal, board)=>{
            return boardTotal + board.embeds.length;
        }, 0);
    }, 0);
    const boardCount = engagementData.engagementProjects.reduce((total, project)=>{
        return total + project.boards.length;
    }, 0);
    const projectCount = engagementData.engagementProjects.length;
    const spaceCount = engagementData.engagementSpaces.length;
    return {
        embedCount: embedCount,
        boardCount: boardCount,
        projectCount: projectCount,
        spaceCount: spaceCount
    };
};

});


parcelRegister("5MNbT", function(module, exports) {
$parcel$export(module.exports, "useMigrationsManagementUIAnalytics", function () { return $ac3e5dd70dae6f2c$export$9c3d8ec90db18545; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
const $ac3e5dd70dae6f2c$export$9c3d8ec90db18545 = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)(true);
    const { fireUIEvent: fireUIEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    // UI event callbacks
    const sendEmbedViewToggleUIEvent = (0, $1oC0p.useCallback)((selectedEmbedType)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).EMBED_VIEW_TYPE_TOGGLE_BUTTON,
            source: sourceKey,
            attributes: {
                selectedEmbedType: selectedEmbedType
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendBoardSelectionUIEvent = (0, $1oC0p.useCallback)((selectedProjectKey, selectedBoardId)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).SELECT_BOARD_DROPDOWN_ITEM,
            source: sourceKey,
            attributes: {
                selectedProjectKey: selectedProjectKey,
                selectedBoardId: selectedBoardId
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendJiraEmbedLinkClickUIEvent = (0, $1oC0p.useCallback)((engagementUrl, selectedEmbedType)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).LINK,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).JIRA_EMBED_LINK,
            source: sourceKey,
            attributes: {
                engagementUrl: engagementUrl,
                selectedEmbedType: selectedEmbedType
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    return {
        sendEmbedViewToggleUIEvent: sendEmbedViewToggleUIEvent,
        sendBoardSelectionUIEvent: sendBoardSelectionUIEvent,
        sendJiraEmbedLinkClickUIEvent: sendJiraEmbedLinkClickUIEvent
    };
};

});


parcelRegister("gcyiK", function(module, exports) {
$parcel$export(module.exports, "JiraEmbeddedBoardSection", function () { return (parcelRequire("jLWW0")).JiraEmbeddedBoardSection; });

var $jLWW0 = parcelRequire("jLWW0");

});
parcelRegister("jLWW0", function(module, exports) {
$parcel$export(module.exports, "JiraEmbeddedBoardSection", function () { return $2b78365cec8037a8$export$7384e6c1e69f7f00; });
/* jira-embedded-board-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $dTJrO = parcelRequire("dTJrO");

var $7ZMp9 = parcelRequire("7ZMp9");

var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");

var $4jcRW = parcelRequire("4jcRW");

var $7vcgf = parcelRequire("7vcgf");

var $hnmMQ = parcelRequire("hnmMQ");
parcelRequire("kx6Ht");
var $5MNbT = parcelRequire("5MNbT");
parcelRequire("bNFQ7");
var $beIzk = parcelRequire("beIzk");

var $2Hp3D = parcelRequire("2Hp3D");

var $6G3FE = parcelRequire("6G3FE");
const $2b78365cec8037a8$var$EmbedContainer = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $aPnCa._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, (0, $dPABA._)((0, $6ogO3._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_1bsb1osq _ybkbstmo _5pue1osq _1gdjidpf _8s22idpf _14whidpf _zc4widpf",
            __cmplp.className
        ])
    }));
});
const $2b78365cec8037a8$var$SelectedBoardProjectTitle = ({ projectIcon: projectIcon, projectName: projectName, projectEmbedViewUrl: projectEmbedViewUrl, onLinkClick: onLinkClick })=>{
    const intl = (0, $8e22h.default)();
    // placeholder if no icon is available
    if (!projectIcon) return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                height: "20px",
                width: "20px",
                borderRadius: "border.radius"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7ZMp9.default), {
                    href: projectEmbedViewUrl || "",
                    target: "_blank",
                    onClick: onLinkClick,
                    children: projectName
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                image: {
                    src: projectIcon,
                    alt: intl.formatMessage((0, $2Hp3D.messages).logoAltText, {
                        name: projectName
                    })
                },
                style: {
                    width: "20px",
                    height: "20px",
                    borderRadius: "border.radius"
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7ZMp9.default), {
                    href: projectEmbedViewUrl || "",
                    target: "_blank",
                    onClick: onLinkClick,
                    children: projectName
                })
            })
        ]
    });
};
const $2b78365cec8037a8$var$SelectedBoardView = ({ selectedEmbedViewUrl: selectedEmbedViewUrl })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($2b78365cec8037a8$var$EmbedContainer, {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7vcgf.Card), {
                    appearance: "embed",
                    inheritDimensions: true,
                    frameStyle: "hide",
                    url: selectedEmbedViewUrl !== null && selectedEmbedViewUrl !== void 0 ? selectedEmbedViewUrl : ""
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $2Hp3D.messages).havingTroubleSubtext), {
                    values: {
                        Link: (msg)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7ZMp9.default), {
                                href: selectedEmbedViewUrl !== null && selectedEmbedViewUrl !== void 0 ? selectedEmbedViewUrl : "",
                                target: "_blank",
                                children: msg
                            })
                    }
                }))
            })
        ]
    });
};
const $2b78365cec8037a8$export$7384e6c1e69f7f00 = ()=>{
    const { boards: boards, selectedBoard: selectedBoard, setSelectedBoard: setSelectedBoard, selectedEmbedViewUrl: selectedEmbedViewUrl } = (0, $6G3FE.useJiraBoardEmbeds)();
    const { sendJiraEmbedLinkClickUIEvent: sendJiraEmbedLinkClickUIEvent } = (0, $5MNbT.useMigrationsManagementUIAnalytics)();
    if (boards.length === 0) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                space: "space.100",
                alignBlock: "center",
                grow: "fill",
                spread: "space-between",
                children: [
                    selectedBoard && /*#__PURE__*/ (0, $7VQPk.jsx)($2b78365cec8037a8$var$SelectedBoardProjectTitle, {
                        projectName: selectedBoard.projectName,
                        projectIcon: selectedBoard.projectIcon,
                        projectEmbedViewUrl: selectedEmbedViewUrl,
                        onLinkClick: ()=>{
                            if (selectedEmbedViewUrl) sendJiraEmbedLinkClickUIEvent(selectedEmbedViewUrl, selectedBoard.selectedView);
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $beIzk.BoardAndEmbedViewOptions), {
                        boards: boards,
                        selectedBoard: selectedBoard,
                        setSelectedBoard: setSelectedBoard
                    })
                ]
            }),
            selectedEmbedViewUrl && /*#__PURE__*/ (0, $7VQPk.jsx)($2b78365cec8037a8$var$SelectedBoardView, {
                selectedEmbedViewUrl: selectedEmbedViewUrl
            })
        ]
    });
};

});
parcelRegister("bNFQ7", function(module, exports) {
$parcel$export(module.exports, "BoardAndEmbedViewOptions", function () { return (parcelRequire("beIzk")).BoardAndEmbedViewOptions; });

var $beIzk = parcelRequire("beIzk");

});
parcelRegister("beIzk", function(module, exports) {
$parcel$export(module.exports, "BoardAndEmbedViewOptions", function () { return $dca52a9950d534f7$export$21d724bbb4c4a7e4; });
/* board-and-embed-view-options.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $1HVQz = parcelRequire("1HVQz");
var $4WS03 = parcelRequire("4WS03");
var $2G37a = parcelRequire("2G37a");

var $kMnBu = parcelRequire("kMnBu");
var $i99jD = parcelRequire("i99jD");
var $aKsx2 = parcelRequire("aKsx2");

var $26k9M = parcelRequire("26k9M");

var $5RBBI = parcelRequire("5RBBI");

var $79ZK0 = parcelRequire("79ZK0");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");
parcelRequire("kx6Ht");
var $5MNbT = parcelRequire("5MNbT");

var $2Hp3D = parcelRequire("2Hp3D");

var $7zThv = parcelRequire("7zThv");
const $dca52a9950d534f7$var$BorderlessButtonWrapper = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $aPnCa._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, (0, $dPABA._)((0, $6ogO3._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_419v1j28 _1w7j1j28 _ryt31j28 _179i1j28 _k0itmzrp _1ix6grf3",
            __cmplp.className
        ])
    }));
});
const $dca52a9950d534f7$var$toggleButtonGroupStyles = (0, $f6YGh.xcss)({
    // add border
    borderRadius: "border.radius.100",
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    padding: "space.050"
});
const $dca52a9950d534f7$export$21d724bbb4c4a7e4 = ({ boards: boards, selectedBoard: selectedBoard, setSelectedBoard: setSelectedBoard })=>{
    const intl = (0, $8e22h.default)();
    const { sendEmbedViewToggleUIEvent: sendEmbedViewToggleUIEvent, sendBoardSelectionUIEvent: sendBoardSelectionUIEvent } = (0, $5MNbT.useMigrationsManagementUIAnalytics)();
    const boardOptions = boards.map((boardState)=>({
            label: boardState.board.boardName,
            value: boardState.board.boardId,
            data: boardState
        }));
    const handleSelectedBoardChange = (option)=>{
        if (option) {
            setSelectedBoard(option.data);
            sendBoardSelectionUIEvent(option.data.projectKey, option.data.board.boardId);
        }
    };
    const setSelectedView = (embedType)=>{
        // if only one view is present, there is nothing to toggle
        if (!selectedBoard || !selectedBoard.calendarUrl || !selectedBoard.timelineUrl) return;
        // toggle the isSelected state of timeline and calendar
        const updatedBoard = (0, $dPABA._)((0, $6ogO3._)({}, selectedBoard), {
            selectedView: embedType
        });
        setSelectedBoard(updatedBoard);
        sendEmbedViewToggleUIEvent(embedType);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
        space: "space.100",
        alignInline: "end",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($dca52a9950d534f7$var$BorderlessButtonWrapper, {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                    xcss: $dca52a9950d534f7$var$toggleButtonGroupStyles,
                    space: "space.025",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), {
                            appearance: "subtle",
                            isDisabled: !(selectedBoard === null || selectedBoard === void 0 ? void 0 : selectedBoard.timelineUrl),
                            isSelected: (selectedBoard === null || selectedBoard === void 0 ? void 0 : selectedBoard.selectedView) === (0, $7zThv.CustomerDomainJiraBoardEmbedType).TIMELINE,
                            spacing: "compact",
                            onClick: ()=>// alter the isSelected state of timeline and calendar
                                setSelectedView((0, $7zThv.CustomerDomainJiraBoardEmbedType).TIMELINE),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $2Hp3D.messages).timelineViewToggleLabel))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), {
                            appearance: "subtle",
                            isDisabled: !(selectedBoard === null || selectedBoard === void 0 ? void 0 : selectedBoard.calendarUrl),
                            isSelected: (selectedBoard === null || selectedBoard === void 0 ? void 0 : selectedBoard.selectedView) === (0, $7zThv.CustomerDomainJiraBoardEmbedType).CALENDAR,
                            spacing: "compact",
                            onClick: ()=>setSelectedView((0, $7zThv.CustomerDomainJiraBoardEmbedType).CALENDAR),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $2Hp3D.messages).calendarViewToggleLabel))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2G37a.SplitButton), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), {
                        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($26k9M))),
                        children: selectedBoard === null || selectedBoard === void 0 ? void 0 : selectedBoard.board.boardName
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kMnBu.default), {
                        shouldRenderToParent: true,
                        // this is the recommended approach from atlaskit
                        // eslint-disable-next-line react/no-unstable-nested-components
                        trigger: (_param)=>{
                            var { triggerRef: triggerRef } = _param, triggerProps = (0, $aPnCa._)(_param, [
                                "triggerRef"
                            ]);
                            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4WS03.default), (0, $dPABA._)((0, $6ogO3._)({
                                ref: triggerRef
                            }, triggerProps), {
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))),
                                label: intl.formatMessage((0, $2Hp3D.messages).selectBoardSplitButtonDropdownLabel)
                            }));
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aKsx2.default), {
                            children: boardOptions.map((option)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $i99jD.default), {
                                    onClick: ()=>handleSelectedBoardChange(option),
                                    isSelected: (selectedBoard === null || selectedBoard === void 0 ? void 0 : selectedBoard.board.boardId) === option.value,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                        children: option.label
                                    })
                                }, option.value))
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("2G37a", function(module, exports) {
$parcel$export(module.exports, "SplitButton", function () { return $1f31eb87a15749f3$export$651ad66661acd392; });
/* split-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $axrVF = parcelRequire("axrVF");

var $39c3M = parcelRequire("39c3M");

var $9z2pQ = parcelRequire("9z2pQ");

var $cI8Gt = parcelRequire("cI8Gt");
var $1f31eb87a15749f3$var$dividerStyles = {
    baseDivider: "_1bsbe4h9 _kqswh2mm _1pbykb7n",
    dividerDisabled: "_bfhkojnm _80om13gf _tzy41uwv",
    dividerDisabledRefreshed: "_bfhk9xzm _80om13gf",
    dividerOffsetRefreshed: "_195g1n1a"
};
var $1f31eb87a15749f3$var$dividerAppearanceStyles = {
    default: "_bfhk1fxt _tzy41uwv",
    primary: "_bfhk15cr _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkdud1 _tzy419lr"
};
var $1f31eb87a15749f3$var$dividerRefreshedAppearanceStyles = {
    default: "_bfhkmuej",
    primary: "_bfhkveue _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkdud1 _tzy419lr"
};
var $1f31eb87a15749f3$var$dividerHeightStyles = {
    default: "_4t3iviql",
    compact: "_4t3i1k8s"
};
// The divider height is calculated by subtracting twice the border width from the button height.
// This ensures the divider does not intersect with the button's border, avoiding visual issues
// caused by overlapping alpha colors (color.border) at the intersection.
var $1f31eb87a15749f3$var$defaultDividerHeightStyles = {
    default: "_4t3im1ee",
    compact: "_4t3i1hvu"
};
var $1f31eb87a15749f3$export$2e0a83ec2e27ecbb = function Divider(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;
    var isDefaultDivider = appearance === 'default' && !isDisabled && (0, $39c3M.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $axrVF.default)([
            $1f31eb87a15749f3$var$dividerStyles.baseDivider,
            isDefaultDivider && $1f31eb87a15749f3$var$defaultDividerHeightStyles[spacing],
            !isDefaultDivider && $1f31eb87a15749f3$var$dividerHeightStyles[spacing],
            isDisabled && (0, $39c3M.fg)('platform-component-visual-refresh') && $1f31eb87a15749f3$var$dividerStyles.dividerDisabledRefreshed,
            isDisabled && !(0, $39c3M.fg)('platform-component-visual-refresh') && $1f31eb87a15749f3$var$dividerStyles.dividerDisabled,
            !isDisabled && (0, $39c3M.fg)('platform-component-visual-refresh') && $1f31eb87a15749f3$var$dividerRefreshedAppearanceStyles[appearance],
            !isDisabled && !(0, $39c3M.fg)('platform-component-visual-refresh') && $1f31eb87a15749f3$var$dividerAppearanceStyles[appearance],
            (0, $39c3M.fg)('platform-component-visual-refresh') && $1f31eb87a15749f3$var$dividerStyles.dividerOffsetRefreshed
        ])
    });
};
var $1f31eb87a15749f3$var$buttonStyles = {
    splitButton: "_1e0c116y _kqswh2mm _4cvr1h6o _o5721q9c",
    primaryButton: "_traeidpf _anlpidpf _p9ykidpf _bepvidpf",
    secondaryButton: "_1j4hidpf _1553idpf _1qgbidpf _y1n3idpf",
    defaultAppearanceContainer: "_2rko1sit _12jimuej _1cwg1n1a _1qu2nqa1 _12y3t94y"
};
var $1f31eb87a15749f3$export$994ba1b4c598f7 = function SplitButtonContainer(_ref2) {
    var appearance = _ref2.appearance, children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $axrVF.default)([
            appearance === 'default' && !isDisabled && (0, $39c3M.fg)('platform-component-visual-refresh') && $1f31eb87a15749f3$var$buttonStyles.defaultAppearanceContainer,
            $1f31eb87a15749f3$var$buttonStyles.splitButton
        ])
    }, children);
};
var $1f31eb87a15749f3$export$651ad66661acd392 = function SplitButton(_ref3) {
    var children = _ref3.children, _ref3$appearance = _ref3.appearance, appearance = _ref3$appearance === void 0 ? 'default' : _ref3$appearance, _ref3$spacing = _ref3.spacing, spacing = _ref3$spacing === void 0 ? 'default' : _ref3$spacing, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? false : _ref3$isDisabled;
    var _getActions = (0, $cI8Gt.getActions)(children), PrimaryAction = _getActions.PrimaryAction, SecondaryAction = _getActions.SecondaryAction;
    return /*#__PURE__*/ $1oC0p.createElement($1f31eb87a15749f3$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled
    }, /*#__PURE__*/ $1oC0p.createElement((0, $9z2pQ.SplitButtonContext).Provider, {
        value: {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        }
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $axrVF.default)([
            $1f31eb87a15749f3$var$buttonStyles.primaryButton
        ])
    }, PrimaryAction), /*#__PURE__*/ $1oC0p.createElement($1f31eb87a15749f3$export$2e0a83ec2e27ecbb, {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $axrVF.default)([
            $1f31eb87a15749f3$var$buttonStyles.secondaryButton
        ])
    }, SecondaryAction)));
};
var $1f31eb87a15749f3$export$e3ca81100b492e15 = function SplitButtonWithSlots(_ref4) {
    var primaryAction = _ref4.primaryAction, secondaryAction = _ref4.secondaryAction, _ref4$appearance = _ref4.appearance, appearance = _ref4$appearance === void 0 ? 'default' : _ref4$appearance, _ref4$spacing = _ref4.spacing, spacing = _ref4$spacing === void 0 ? 'default' : _ref4$spacing, _ref4$isDisabled = _ref4.isDisabled, isDisabled = _ref4$isDisabled === void 0 ? false : _ref4$isDisabled;
    return /*#__PURE__*/ $1oC0p.createElement($1f31eb87a15749f3$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled
    }, /*#__PURE__*/ $1oC0p.createElement((0, $9z2pQ.SplitButtonContext).Provider, {
        value: {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        }
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $axrVF.default)([
            $1f31eb87a15749f3$var$buttonStyles.primaryButton
        ])
    }, primaryAction), /*#__PURE__*/ $1oC0p.createElement($1f31eb87a15749f3$export$2e0a83ec2e27ecbb, {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $axrVF.default)([
            $1f31eb87a15749f3$var$buttonStyles.secondaryButton
        ])
    }, secondaryAction)));
};

});
parcelRegister("cI8Gt", function(module, exports) {
$parcel$export(module.exports, "getActions", function () { return $941054976967cea9$export$fe3955935f564b31; });

var $3bamO = parcelRequire("3bamO");

var $1oC0p = parcelRequire("1oC0p");

var $7t0tI = parcelRequire("7t0tI");
var $941054976967cea9$export$fe3955935f564b31 = function getActions(children) {
    var _Children$toArray = (0, $1oC0p.Children).toArray(children), _Children$toArray2 = (0, $3bamO.default)(_Children$toArray, 2), PrimaryAction = _Children$toArray2[0], SecondaryAction = _Children$toArray2[1];
    typeof $7t0tI;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});


parcelRegister("2Hp3D", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $8c6aa4e9052a57a9$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $8c6aa4e9052a57a9$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    timelineViewToggleLabel: {
        id: "fastshift.migrations-management-page.jira-embed-view-toggle.timeline",
        defaultMessage: "Timeline",
        description: "Label for toggling to the Jira Board Timeline View"
    },
    calendarViewToggleLabel: {
        id: "fastshift.migrations-management-page.jira-embed-view-toggle.calendar",
        defaultMessage: "Calendar",
        description: "Label for toggling to the Jira Board Calendar View"
    },
    selectBoardSplitButtonDropdownLabel: {
        id: "fastshift.migrations-management-page.jira-embed-view-dropdown.label",
        defaultMessage: "More Boards",
        description: "Label for opening a split button dropdown to select from more boards"
    },
    logoAltText: {
        id: "fastshift.migrations-management-page.jira-embed-view-title.logo-alt-text",
        defaultMessage: "Project Icon",
        description: "Alt Text for project icon for the selected board"
    },
    havingTroubleSubtext: {
        id: "fastshift.migrations-management-page.having-trouble-subtext",
        defaultMessage: "Having trouble viewing the plan? <Link>Log in to your project</Link> and refresh the page.",
        description: "Subtext for the migrations management page under the migration planner"
    }
});

});

parcelRegister("7zThv", function(module, exports) {
$parcel$export(module.exports, "CustomerDomainJiraBoardEmbedType", function () { return $8540b40d1f98ec5b$export$d373f8d380344366; });
var $8540b40d1f98ec5b$export$d373f8d380344366 = /*#__PURE__*/ function(CustomerDomainJiraBoardEmbedType) {
    CustomerDomainJiraBoardEmbedType["TIMELINE"] = "TIMELINE";
    CustomerDomainJiraBoardEmbedType["CALENDAR"] = "CALENDAR";
    return CustomerDomainJiraBoardEmbedType;
}({});

});



parcelRegister("6G3FE", function(module, exports) {
$parcel$export(module.exports, "useJiraBoardEmbeds", function () { return $06df403e7f093b5f$export$3252b8787313d9f9; });

var $1oC0p = parcelRequire("1oC0p");

var $f7YG8 = parcelRequire("f7YG8");

var $7zThv = parcelRequire("7zThv");
const $06df403e7f093b5f$var$getEmbedUrlByType = (board, type)=>{
    var _board_embeds_find;
    var _board_embeds_find_url;
    return (_board_embeds_find_url = board === null || board === void 0 ? void 0 : (_board_embeds_find = board.embeds.find((embed)=>embed.type === type)) === null || _board_embeds_find === void 0 ? void 0 : _board_embeds_find.url) !== null && _board_embeds_find_url !== void 0 ? _board_embeds_find_url : null;
};
const $06df403e7f093b5f$export$3252b8787313d9f9 = ()=>{
    const { data: engagementData } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomainEngagement);
    const [selectedBoard, setSelectedBoard] = (0, $1oC0p.useState)(null);
    const boards = (0, $1oC0p.useMemo)(()=>{
        return engagementData ? engagementData.engagementProjects.flatMap((project)=>project.boards.map((board)=>{
                const timelineUrl = $06df403e7f093b5f$var$getEmbedUrlByType(board, (0, $7zThv.CustomerDomainJiraBoardEmbedType).TIMELINE);
                const calendarUrl = $06df403e7f093b5f$var$getEmbedUrlByType(board, (0, $7zThv.CustomerDomainJiraBoardEmbedType).CALENDAR);
                if (!timelineUrl && !calendarUrl) return null;
                return {
                    timelineUrl: timelineUrl,
                    calendarUrl: calendarUrl,
                    selectedView: timelineUrl ? (0, $7zThv.CustomerDomainJiraBoardEmbedType).TIMELINE : (0, $7zThv.CustomerDomainJiraBoardEmbedType).CALENDAR,
                    board: board,
                    projectName: project.projectName,
                    projectIcon: project.projectIcon,
                    projectKey: project.projectKey
                };
            })).filter((boardState)=>boardState !== null) : [];
    }, [
        engagementData
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (boards.length > 0 && boards[0]) setSelectedBoard(boards[0]);
    }, [
        boards
    ]);
    const selectedEmbedViewUrl = (0, $1oC0p.useMemo)(()=>{
        if (!selectedBoard) return null;
        switch(selectedBoard.selectedView){
            case (0, $7zThv.CustomerDomainJiraBoardEmbedType).CALENDAR:
                return selectedBoard.calendarUrl;
            case (0, $7zThv.CustomerDomainJiraBoardEmbedType).TIMELINE:
                return selectedBoard.timelineUrl;
            default:
                return null;
        }
    }, [
        selectedBoard
    ]);
    return {
        boards: boards,
        selectedBoard: selectedBoard,
        setSelectedBoard: setSelectedBoard,
        selectedEmbedViewUrl: selectedEmbedViewUrl
    };
};

});



parcelRegister("j571n", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $954f6f43ed6ced56$export$defe85febe8b728c; });

var $blDbC = parcelRequire("blDbC");
const $954f6f43ed6ced56$export$defe85febe8b728c = (0, $blDbC.defineMessages)({
    pageHeading: {
        id: "fastshift.migrations-management-page.page-heading",
        defaultMessage: "Migration planning",
        description: "Heading for the migrations management page"
    },
    pageHeadingSubtext: {
        id: "fastshift.migrations-management-page.page-heading-subtext",
        defaultMessage: "Monitor your migration progress and review upcoming tasks to make sure everything stays on track.",
        description: "Subtext for the migrations management page under the heading"
    },
    genericErrorDescription: {
        id: "fastshift.migrations-management-page.error-display.generic-error.description",
        defaultMessage: "We couldn\u2019t retrieve the data.",
        description: "Description for error message displayed when an unknown error occurs, for example 500 internal server error, or server returns empty data"
    }
});

});
parcelRegister("blDbC", function(module, exports) {
$parcel$export(module.exports, "IntlError", function () { return (parcelRequire("iOyCd")).IntlError; });
$parcel$export(module.exports, "IntlErrorCode", function () { return (parcelRequire("iOyCd")).IntlErrorCode; });
$parcel$export(module.exports, "InvalidConfigError", function () { return (parcelRequire("iOyCd")).InvalidConfigError; });
$parcel$export(module.exports, "MessageFormatError", function () { return (parcelRequire("iOyCd")).MessageFormatError; });
$parcel$export(module.exports, "MissingDataError", function () { return (parcelRequire("iOyCd")).MissingDataError; });
$parcel$export(module.exports, "MissingTranslationError", function () { return (parcelRequire("iOyCd")).MissingTranslationError; });
$parcel$export(module.exports, "UnsupportedFormatterError", function () { return (parcelRequire("iOyCd")).UnsupportedFormatterError; });
$parcel$export(module.exports, "defineMessages", function () { return $84300d7f33a2ad27$export$1adfeb024f5185b; });


var $bceAk = parcelRequire("bceAk");
parcelRequire("iOyCd");

var $8xwAh = parcelRequire("8xwAh");







var $ejHIf = parcelRequire("ejHIf");
function $84300d7f33a2ad27$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $84300d7f33a2ad27$export$747d244ee58120dd(msg) {
    return msg;
}

});





parcelRegister("xxovY", function(module, exports) {
$parcel$export(module.exports, "FastshiftMigrationTicketsPage", function () { return (parcelRequire("8aiYh")).FastshiftMigrationTicketsPage; });

var $8aiYh = parcelRequire("8aiYh");

});
parcelRegister("8aiYh", function(module, exports) {
$parcel$export(module.exports, "FastshiftMigrationTicketsPage", function () { return $e43a400b5b793383$export$4debc89bddc8cf32; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $dTJrO = parcelRequire("dTJrO");

var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
parcelRequire("1GTvS");
var $g1m1l = parcelRequire("g1m1l");

var $4o8KE = parcelRequire("4o8KE");
parcelRequire("6labG");
var $bp6wt = parcelRequire("bp6wt");
const $e43a400b5b793383$export$4debc89bddc8cf32 = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    (0, $g1m1l.useMigrationTicketsPageAnalytics)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
        space: "space.300",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                        size: "large",
                        children: formatMessage((0, $4o8KE.messages).pageTitle)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                        color: "color.text.subtle",
                        children: formatMessage((0, $4o8KE.messages).pageDescription)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bp6wt.MigrationTicketsTable), {})
        ]
    });
};

});
parcelRegister("1GTvS", function(module, exports) {
$parcel$export(module.exports, "useMigrationTicketsTable", function () { return (parcelRequire("9xWji")).useMigrationTicketsTable; });
$parcel$export(module.exports, "useMigrationTicketsPageAnalytics", function () { return (parcelRequire("g1m1l")).useMigrationTicketsPageAnalytics; });
$parcel$export(module.exports, "useMigrationTicketsUIAnalytics", function () { return (parcelRequire("jMpIW")).useMigrationTicketsUIAnalytics; });

var $9xWji = parcelRequire("9xWji");

var $g1m1l = parcelRequire("g1m1l");

var $jMpIW = parcelRequire("jMpIW");

});
parcelRegister("9xWji", function(module, exports) {
$parcel$export(module.exports, "useMigrationTicketsTable", function () { return $5ca44869505036f7$export$2e46a030cc5cc443; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $15dQb = parcelRequire("15dQb");

var $dTJrO = parcelRequire("dTJrO");

var $7ZMp9 = parcelRequire("7ZMp9");

var $gcfBV = parcelRequire("gcfBV");

var $g3ExX = parcelRequire("g3ExX");
var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");

var $lP7A9 = parcelRequire("lP7A9");

var $hLJF4 = parcelRequire("hLJF4");
parcelRequire("biKC4");
var $edwqB = parcelRequire("edwqB");
parcelRequire("kDIm2");
var $eh9Uj = parcelRequire("eh9Uj");
parcelRequire("iTGju");
var $Riwsy = parcelRequire("Riwsy");

var $fq4go = parcelRequire("fq4go");
parcelRequire("jtpMK");
var $2hq4z = parcelRequire("2hq4z");
var $lmgkB = parcelRequire("lmgkB");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");

var $8Bmsc = parcelRequire("8Bmsc");

var $af3Tw = parcelRequire("af3Tw");

var $PE2DD = parcelRequire("PE2DD");

var $4o8KE = parcelRequire("4o8KE");
parcelRequire("cTxj3");
var $6nnJl = parcelRequire("6nnJl");
parcelRequire("3jjYa");
var $cixVJ = parcelRequire("cixVJ");

var $fH6Mg = parcelRequire("fH6Mg");

var $hDjaZ = parcelRequire("hDjaZ");

var $jMpIW = parcelRequire("jMpIW");
const $5ca44869505036f7$var$textEllipsisStyles = (0, $f6YGh.xcss)({
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
const $5ca44869505036f7$var$smallTextEllipsisStyles = (0, $f6YGh.xcss)({
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    font: (0, $lP7A9.default)("font.body.small"),
    color: "color.text.subtle"
});
const $5ca44869505036f7$var$stackInlineStyles = (0, $f6YGh.xcss)({
    minWidth: "0"
});
const $5ca44869505036f7$var$ticketBadgeStyles = (0, $f6YGh.xcss)({
    marginInlineStart: "space.050"
});
// Product name mapping with localization
const $5ca44869505036f7$var$productNameMapping = {
    JIRA: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4o8KE.messages).migrationTicketsTableJiraProductName)),
    CONFLUENCE: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4o8KE.messages).migrationTicketsTableConfluenceProductName))
};
const $5ca44869505036f7$export$2e46a030cc5cc443 = ()=>{
    const { openPanel: openPanel, closePanel: closePanel } = (0, $1oC0p.useContext)((0, $edwqB.PagePanelContext));
    const dispatch = (0, $f7YG8.useFastshiftDispatch)();
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const intl = (0, $8e22h.default)();
    const { sendMigrationTicketsTableOpenSupportTicketClickUIEvent: sendMigrationTicketsTableOpenSupportTicketClickUIEvent } = (0, $jMpIW.useMigrationTicketsUIAnalytics)();
    const { sendRelatedTicketsSidePanelLinkClickUIEvent: sendRelatedTicketsSidePanelLinkClickUIEvent } = (0, $jMpIW.useMigrationTicketsUIAnalytics)();
    const openPanelWithRelatedTickets = (0, $1oC0p.useCallback)((request)=>{
        const content = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6nnJl.MigrationTicketsPanel), {
            supportTicketId: request.supportTicketId,
            title: request.title,
            fastShiftStatusReason: request.fastShiftStatusReason,
            relatedTicketsCount: request.relatedTicketsCount,
            relatedTickets: request.relatedTickets,
            onClose: closePanel
        });
        openPanel(content);
    }, [
        openPanel,
        closePanel
    ]);
    const { data: supportRequestsData, pending: supportRequestsPending, error: supportRequestsError } = (0, $f7YG8.useFastshiftSelector)((state)=>state.supportRequests);
    const { pending: customerDomainPending, data: customerDomainData } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomain);
    const selectedDomainOrg = (0, $f7YG8.useFastshiftSelector)((state)=>state.selectedDomainOrg);
    const cachedTableControls = (0, $f7YG8.useFastshiftSelector)((state)=>state.pageStateCache[(0, $af3Tw.TABLE_IDS).MIGRATION_TICKETS]);
    const [pagination, setPagination] = (0, $1oC0p.useState)({
        page: cachedTableControls.page,
        size: cachedTableControls.size,
        totalElements: 0,
        totalPages: 0,
        hasNext: false,
        hasPrevious: false,
        sorted: false
    });
    const [filteredSupportRequests, setFilteredSupportRequests] = (0, $1oC0p.useState)([]);
    (0, $Riwsy.useFetchSupportRequests)();
    // Sync local pagination with cached controls and recalculate pagination metadata
    (0, $1oC0p.useEffect)(()=>{
        if (!supportRequestsData) {
            setPagination({
                page: (0, $eh9Uj.DEFAULT_CONTROLS_PAYLOAD).page,
                size: (0, $eh9Uj.DEFAULT_CONTROLS_PAYLOAD).size,
                totalElements: 0,
                totalPages: 0,
                hasNext: false,
                hasPrevious: false,
                sorted: false
            });
            return;
        }
        const page = cachedTableControls.page;
        const size = cachedTableControls.size;
        const totalElements = filteredSupportRequests.length;
        const totalPages = Math.ceil(totalElements / size);
        setPagination({
            page: page,
            size: size,
            totalElements: totalElements,
            totalPages: totalPages,
            hasNext: page < totalPages - 1,
            hasPrevious: page > 0,
            sorted: false
        });
    }, [
        cachedTableControls.page,
        cachedTableControls.size,
        supportRequestsData,
        filteredSupportRequests
    ]);
    // Recalculate filtered support requests with support requests data and cached table controls
    (0, $1oC0p.useEffect)(()=>{
        if (!supportRequestsData) {
            setFilteredSupportRequests([]);
            return;
        }
        const filtered = (0, $hDjaZ.applyFilters)(supportRequestsData, cachedTableControls === null || cachedTableControls === void 0 ? void 0 : cachedTableControls.filters);
        var _cachedTableControls_searchTerm;
        const searched = (0, $hDjaZ.applySearch)(filtered, (_cachedTableControls_searchTerm = cachedTableControls.searchTerm) !== null && _cachedTableControls_searchTerm !== void 0 ? _cachedTableControls_searchTerm : "");
        setFilteredSupportRequests(searched);
    }, [
        supportRequestsData,
        cachedTableControls.filters,
        cachedTableControls.searchTerm
    ]);
    const onSetControlsPayload = (controls)=>{
        if (!supportRequestsData) return;
        // If search term changed and we're not on page 0, reset to page 0
        const searchTermChanged = controls.searchTerm !== cachedTableControls.searchTerm;
        const updatedControls = searchTermChanged && controls.page !== 0 ? (0, $dPABA._)((0, $6ogO3._)({}, controls), {
            page: 0
        }) : controls;
        // Dispatch to Redux - useEffect will sync local state
        dispatch($8Bmsc.setTableControls({
            tableId: (0, $af3Tw.TABLE_IDS).MIGRATION_TICKETS,
            controls: updatedControls
        }));
    };
    const handleRefresh = ()=>{
        if (!customerDomainData || !selectedDomainOrg) return;
        const supportTicketQueryParams = (0, $2hq4z.getOrgQueryParam)(selectedDomainOrg);
        dispatch($8Bmsc.getFastshiftSupportRequests({
            stargateClient: stargateClient,
            customerDomainId: customerDomainData.customerDomainId,
            queryParams: supportTicketQueryParams
        }));
    };
    // Table head configuration
    const head = {
        cells: [
            {
                key: "ticket",
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                    size: "xxsmall",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4o8KE.messages).migrationTicketsTableTicketColumnTitle))
                })
            },
            {
                key: "status",
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                    size: "xxsmall",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4o8KE.messages).migrationTicketsTableStatusColumnTitle))
                }),
                width: 10
            },
            {
                key: "phase",
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                    size: "xxsmall",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4o8KE.messages).migrationTicketsTablePhaseColumnTitle))
                }),
                width: 11
            },
            {
                key: "source",
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                    size: "xxsmall",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4o8KE.messages).migrationTicketsTableSourceColumnTitle))
                }),
                width: 20
            },
            {
                key: "destination",
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                    size: "xxsmall",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4o8KE.messages).migrationTicketsTableDestinationColumnTitle))
                }),
                width: 20
            },
            {
                key: "planToMigrateDate",
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                    size: "xxsmall",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4o8KE.messages).migrationTicketsTablePlanToMigrateDateColumnTitle))
                }),
                width: 13
            }
        ]
    };
    const rows = (0, $1oC0p.useMemo)(()=>(filteredSupportRequests !== null && filteredSupportRequests !== void 0 ? filteredSupportRequests : []).slice(pagination.page * pagination.size, (pagination.page + 1) * pagination.size).map((request)=>{
            const statusMessage = (0, $lmgkB.getStatusText)(request.fastShiftStatusReason);
            const statusText = intl.formatMessage(statusMessage);
            return {
                key: request.supportTicketId,
                onClick: ()=>{
                    openPanelWithRelatedTickets(request);
                    sendRelatedTicketsSidePanelLinkClickUIEvent(request.supportTicketId);
                },
                cells: [
                    {
                        key: "ticket",
                        content: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hLJF4.default), {
                                    content: request.title,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                                        xcss: $5ca44869505036f7$var$textEllipsisStyles,
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                            children: request.title
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lPRxe.default), {
                                    color: "color.text.selected",
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7ZMp9.default), {
                                            href: `${(0, $fq4go.SAC_URL)}/requests/${request.supportTicketId}`,
                                            target: "_blank",
                                            onClick: (e)=>{
                                                e.stopPropagation();
                                                sendMigrationTicketsTableOpenSupportTicketClickUIEvent(request.supportTicketId);
                                            },
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                                color: "inherit",
                                                children: request.supportTicketId
                                            })
                                        }),
                                        request.relatedTicketsCount > 0 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                                            as: "span",
                                            xcss: $5ca44869505036f7$var$ticketBadgeStyles,
                                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $15dQb.default), {
                                                children: [
                                                    "+",
                                                    request.relatedTicketsCount
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    },
                    {
                        key: "status",
                        content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                            as: "span",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hLJF4.default), {
                                content: statusText,
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gcfBV.default), {
                                    appearance: (0, $lmgkB.getStatusColor)(request.fastShiftStatusReason),
                                    children: statusText
                                })
                            })
                        })
                    },
                    {
                        key: "phase",
                        content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $hDjaZ.getMigrationPhaseDisplayText)(request.migrationPhase)))
                        })
                    },
                    {
                        key: "source",
                        content: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                            space: "space.100",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cixVJ.ProductIcon), {
                                    productName: request.source.productName,
                                    variant: (0, $fH6Mg.PRODUCT_VARIANTS).SOURCE
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                                    xcss: $5ca44869505036f7$var$stackInlineStyles,
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                            children: request.source.productName ? $5ca44869505036f7$var$productNameMapping[request.source.productName] : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4o8KE.messages).migrationTicketsTableSourceDestinationColumnContentDefault))
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hLJF4.default), {
                                            content: request.source.baseUrl || intl.formatMessage((0, $4o8KE.messages).migrationTicketsTableSourceDestinationColumnContentNoBaseUrl),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                                                xcss: $5ca44869505036f7$var$smallTextEllipsisStyles,
                                                children: request.source.baseUrl || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4o8KE.messages).migrationTicketsTableSourceDestinationColumnContentNoBaseUrl))
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    },
                    {
                        key: "destination",
                        content: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                            space: "space.100",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cixVJ.ProductIcon), {
                                    productName: request.destination.productName,
                                    variant: (0, $fH6Mg.PRODUCT_VARIANTS).DESTINATION
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                                    xcss: $5ca44869505036f7$var$stackInlineStyles,
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                            children: request.destination.productName ? $5ca44869505036f7$var$productNameMapping[request.destination.productName] : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4o8KE.messages).migrationTicketsTableSourceDestinationColumnContentDefault))
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hLJF4.default), {
                                            content: request.destination.baseUrl || intl.formatMessage((0, $4o8KE.messages).migrationTicketsTableSourceDestinationColumnContentNoBaseUrl),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                                                xcss: $5ca44869505036f7$var$smallTextEllipsisStyles,
                                                children: request.destination.baseUrl || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4o8KE.messages).migrationTicketsTableSourceDestinationColumnContentNoBaseUrl))
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    },
                    {
                        key: "planToMigrateDate",
                        content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                            children: request.planToMigrateDate ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fnHPc.FormattedDate), {
                                value: new Date(request.planToMigrateDate),
                                day: "2-digit",
                                month: "short",
                                year: "numeric"
                            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4o8KE.messages).migrationTicketsTableNoDatePlanned))
                        })
                    }
                ]
            };
        }), [
        filteredSupportRequests,
        pagination.page,
        pagination.size,
        intl,
        openPanelWithRelatedTickets,
        sendRelatedTicketsSidePanelLinkClickUIEvent,
        sendMigrationTicketsTableOpenSupportTicketClickUIEvent
    ]);
    return {
        isTableLoading: customerDomainPending || supportRequestsPending,
        isTableError: !!supportRequestsError,
        head: head,
        rows: rows,
        handleRefresh: handleRefresh,
        pagination: pagination,
        onSetControlsPayload: onSetControlsPayload,
        controls: cachedTableControls,
        filters: cachedTableControls === null || cachedTableControls === void 0 ? void 0 : cachedTableControls.filters
    };
};

});
parcelRegister("biKC4", function(module, exports) {
$parcel$export(module.exports, "PagePanelContext", function () { return (parcelRequire("edwqB")).PagePanelContext; });
$parcel$export(module.exports, "PagePanelContextProvider", function () { return (parcelRequire("edwqB")).PagePanelContextProvider; });
parcelRequire("2AtL7");
var $edwqB = parcelRequire("edwqB");

});
parcelRegister("2AtL7", function(module, exports) {
$parcel$export(module.exports, "PagePanelContext", function () { return (parcelRequire("edwqB")).PagePanelContext; });
$parcel$export(module.exports, "PagePanelContextProvider", function () { return (parcelRequire("edwqB")).PagePanelContextProvider; });

var $edwqB = parcelRequire("edwqB");

});
parcelRegister("edwqB", function(module, exports) {
$parcel$export(module.exports, "PagePanelContext", function () { return $36132181164bd4f5$export$d19ae8cb831031b2; });
$parcel$export(module.exports, "PagePanelContextProvider", function () { return $36132181164bd4f5$export$a434f701d6eaa8e; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $yagHz = parcelRequire("yagHz");
parcelRequire("iTGju");
var $bh3Fv = parcelRequire("bh3Fv");
const $36132181164bd4f5$var$defaultContextValue = {
    isPanelOpen: false,
    openPanel: (0, $yagHz.noop),
    closePanel: (0, $yagHz.noop),
    panelContent: null
};
const $36132181164bd4f5$export$d19ae8cb831031b2 = /*#__PURE__*/ (0, $1oC0p.createContext)($36132181164bd4f5$var$defaultContextValue);
const $36132181164bd4f5$export$a434f701d6eaa8e = ({ children: children })=>{
    const { fullPathname: fullPathname } = (0, $bh3Fv.useRoutes)();
    const [isPanelOpen, setPanelOpen] = (0, $1oC0p.useState)(true);
    const [panelContent, setPanelContent] = (0, $1oC0p.useState)(null);
    (0, $1oC0p.useEffect)(()=>{
        setPanelOpen(false);
    }, [
        fullPathname
    ]);
    const openPanel = (content)=>{
        setPanelContent(content);
        setPanelOpen(true);
    };
    const closePanel = ()=>{
        setPanelOpen(false);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)($36132181164bd4f5$export$d19ae8cb831031b2.Provider, {
        value: {
            isPanelOpen: isPanelOpen,
            openPanel: openPanel,
            closePanel: closePanel,
            panelContent: panelContent
        },
        children: children
    });
};

});



parcelRegister("4o8KE", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $303a0d31a2ec3c0a$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $303a0d31a2ec3c0a$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    pageTitle: {
        id: "fastshift.migration-tickets-page.page-title",
        defaultMessage: "Migration tickets",
        description: "Page title for migration tickets page"
    },
    pageDescription: {
        id: "fastshift.migration-tickets-page.page-description",
        defaultMessage: "View all migration tickets that you have access to, filter by cloud organization, or view unassociated tickets. You can open a specific ticket to learn more about its status.",
        description: "Page description for migration tickets page"
    },
    migrationTicketsTableTicketColumnTitle: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.ticket-column-title",
        defaultMessage: "Ticket",
        description: "Column title for the ticket column in the migration tickets table"
    },
    migrationTicketsTableStatusColumnTitle: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.status-column-title",
        defaultMessage: "Status",
        description: "Column title for the status column in the migration tickets table"
    },
    migrationTicketsTablePhaseColumnTitle: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.phase-column-title",
        defaultMessage: "Phase",
        description: "Column title for the phase column in the migration tickets table"
    },
    migrationTicketsTableSourceColumnTitle: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.source-column-title",
        defaultMessage: "Source",
        description: "Column title for the source column in the migration tickets table"
    },
    migrationTicketsTableDestinationColumnTitle: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.destination-column-title",
        defaultMessage: "Destination",
        description: "Column title for the destination column in the migration tickets table"
    },
    migrationTicketsTablePlanToMigrateDateColumnTitle: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.plan-to-migrate-date-column-title",
        defaultMessage: "Plan to migrate",
        description: "Column title for the plan to migrate date column in the migration tickets table"
    },
    migrationTicketsTableMigrationPhaseExplore: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.migration-phase-explore",
        defaultMessage: "Explore",
        description: "Label for explore migration phase"
    },
    migrationTicketsTableMigrationPhaseAssess: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.migration-phase-assess",
        defaultMessage: "Assess",
        description: "Label for assess migration phase"
    },
    migrationTicketsTableMigrationPhasePlanAndTrack: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.migration-phase-plan-and-track",
        defaultMessage: "Plan & Track",
        description: "Label for plan and track migration phase"
    },
    migrationTicketsTableMigrationPhaseTestMigration: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.migration-phase-test-migration",
        defaultMessage: "Test Migration",
        description: "Label for test migration phase"
    },
    migrationTicketsTableMigrationPhaseProdMigration: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.migration-phase-prod-migration",
        defaultMessage: "Prod Migration",
        description: "Label for production migration phase"
    },
    migrationTicketsTableMigrationPhasePostMigration: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.migration-phase-post-migration",
        defaultMessage: "Post-Migration",
        description: "Label for post-migration phase"
    },
    migrationTicketsTableMigrationPhaseUnknown: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.migration-phase-unknown",
        defaultMessage: "Unknown Phase",
        description: "Fallback label for unknown migration phases to prevent UI crashes"
    },
    migrationTicketsTableEmptyStateTitle: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.empty-state-title",
        defaultMessage: "No migration tickets found",
        description: "Title for empty state when no migration tickets are available"
    },
    migrationTicketsTableEmptyStateDescription: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.empty-state-description",
        defaultMessage: "There are no migration tickets to display at this time.",
        description: "Description for empty state when no migration tickets are available"
    },
    migrationTicketsTableErrorMessage: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.error-message",
        defaultMessage: "We\u2019re unable to retrieve the data about your migration progress.",
        description: "Error message displayed when migration tickets fail to load"
    },
    migrationTicketsTableSourceDestinationColumnContentDefault: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.source-destination-column-content-default",
        defaultMessage: "Atlassian product",
        description: "Column content for the source column and destination column in the migration status table when the product is unknown"
    },
    migrationTicketsTableSourceColumnContentSenIdNotAvailable: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.source-column-content-sen-id-not-available",
        defaultMessage: "SEN ID not available",
        description: "Column content for the source column in the migration status table when the SEN ID is not available"
    },
    migrationTicketsTableSourceDestinationColumnContentNoBaseUrl: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.source-destination-column-content-no-base-url",
        defaultMessage: "URL not available",
        description: "Column content for the source column and destination column in the migration status table when the source base URL is not available"
    },
    migrationTicketsTableNoDatePlanned: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.no-date-planned",
        defaultMessage: "Pending",
        description: "Column content for the plan to migrate date column in the migration status table when the date is not available"
    },
    migrationTicketsTableJiraProductName: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.jira-product-name",
        defaultMessage: "Jira",
        description: "Column content for the Jira product name in the migration status table"
    },
    migrationTicketsTableConfluenceProductName: {
        id: "fastshift.migration-tickets-page.migration-tickets-table.confluence-product-name",
        defaultMessage: "Confluence",
        description: "Column content for the Confluence product name in the migration status table"
    },
    migrationTicketsPanelTitle: {
        id: "fastshift.migration-tickets-page.migration-tickets-panel.title",
        defaultMessage: "Details",
        description: "Title for migration tickets panel"
    },
    migrationTicketsPanelRelatedTicketsTitle: {
        id: "fastshift.migration-tickets-page.migration-tickets-panel.related-tickets-title",
        defaultMessage: "Related tickets",
        description: "Title for related tickets in migration tickets panel"
    }
});

});

parcelRegister("cTxj3", function(module, exports) {
$parcel$export(module.exports, "MigrationTicketsPanel", function () { return (parcelRequire("6nnJl")).MigrationTicketsPanel; });

var $6nnJl = parcelRequire("6nnJl");

});
parcelRegister("6nnJl", function(module, exports) {
$parcel$export(module.exports, "MigrationTicketsPanel", function () { return $629b15e8a612dfdb$export$fdd7ff648cf5a58d; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");

var $15dQb = parcelRequire("15dQb");

var $4WS03 = parcelRequire("4WS03");

var $dTJrO = parcelRequire("dTJrO");

var $h6Fsc = parcelRequire("h6Fsc");

var $g3ExX = parcelRequire("g3ExX");
var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $f6YGh = parcelRequire("f6YGh");

var $lP7A9 = parcelRequire("lP7A9");
parcelRequire("axBrj");
var $7DFvf = parcelRequire("7DFvf");

var $9tcM4 = parcelRequire("9tcM4");
parcelRequire("1GTvS");
var $jMpIW = parcelRequire("jMpIW");

var $4o8KE = parcelRequire("4o8KE");
const $629b15e8a612dfdb$var$cardWrapperStyles = (0, $f6YGh.xcss)({
    border: `1px solid ${(0, $lP7A9.default)("color.border")}`,
    borderRadius: "4px"
});
const $629b15e8a612dfdb$export$fdd7ff648cf5a58d = ({ supportTicketId: supportTicketId, title: title, fastShiftStatusReason: fastShiftStatusReason, relatedTicketsCount: relatedTicketsCount, relatedTickets: relatedTickets, onClose: onClose })=>{
    const { sendRelatedTicketsSidePanelDismissButtonClickUIEvent: sendRelatedTicketsSidePanelDismissButtonClickUIEvent, sendRelatedTicketsSidePanelOpenSupportTicketClickUIEvent: sendRelatedTicketsSidePanelOpenSupportTicketClickUIEvent } = (0, $jMpIW.useMigrationTicketsUIAnalytics)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
        space: "space.300",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                alignBlock: "center",
                spread: "space-between",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                        size: "medium",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4o8KE.messages).migrationTicketsPanelTitle))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4WS03.default), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($h6Fsc))),
                        label: "Close",
                        onClick: ()=>{
                            onClose();
                            sendRelatedTicketsSidePanelDismissButtonClickUIEvent(supportTicketId);
                        },
                        testId: "close-button"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                xcss: $629b15e8a612dfdb$var$cardWrapperStyles,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7DFvf.MigrationTicketsCard), {
                    compact: true,
                    issueType: (0, $9tcM4.FASTSHIFT_RELATED_TICKET_ISSUE_TYPE).PLAN,
                    supportTicketId: supportTicketId,
                    title: title,
                    status: fastShiftStatusReason,
                    onClickAnalyticsEvent: sendRelatedTicketsSidePanelOpenSupportTicketClickUIEvent
                })
            }),
            relatedTicketsCount > 0 && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                        alignBlock: "center",
                        space: "space.050",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                                size: "xsmall",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $4o8KE.messages).migrationTicketsPanelRelatedTicketsTitle))
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $15dQb.default), {
                                children: relatedTicketsCount
                            })
                        ]
                    }),
                    relatedTickets.map((ticket)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                            xcss: $629b15e8a612dfdb$var$cardWrapperStyles,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7DFvf.MigrationTicketsCard), {
                                compact: true,
                                issueType: ticket.issueType,
                                supportTicketId: ticket.supportTicketId,
                                title: ticket.title,
                                status: ticket.fastShiftStatusReason,
                                onClickAnalyticsEvent: sendRelatedTicketsSidePanelOpenSupportTicketClickUIEvent
                            })
                        }, ticket.supportTicketId))
                ]
            })
        ]
    });
};

});


parcelRegister("3jjYa", function(module, exports) {
$parcel$export(module.exports, "ProductIcon", function () { return (parcelRequire("cixVJ")).ProductIcon; });

var $cixVJ = parcelRequire("cixVJ");

});
parcelRegister("cixVJ", function(module, exports) {
$parcel$export(module.exports, "ProductIcon", function () { return $001174c8cd6e9581$export$1a199e029d5e93d6; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $dqSEE = parcelRequire("dqSEE");

var $63bv7 = parcelRequire("63bv7");

var $79ZK0 = parcelRequire("79ZK0");
var $f6YGh = parcelRequire("f6YGh");

var $fH6Mg = parcelRequire("fH6Mg");
const $001174c8cd6e9581$var$fallbackIconStyles = (0, $f6YGh.xcss)({
    width: "32px",
    height: "32px",
    borderRadius: "6px",
    backgroundColor: "color.background.accent.gray.subtler"
});
const $001174c8cd6e9581$var$PRODUCT_CONFIG = {
    [(0, $fH6Mg.PRODUCT_NAMES).JIRA]: {
        [(0, $fH6Mg.PRODUCT_VARIANTS).SOURCE]: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraDataCenterIcon), {
            appearance: "brand",
            size: "medium"
        }),
        [(0, $fH6Mg.PRODUCT_VARIANTS).DESTINATION]: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        })
    },
    [(0, $fH6Mg.PRODUCT_NAMES).CONFLUENCE]: {
        [(0, $fH6Mg.PRODUCT_VARIANTS).SOURCE]: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.ConfluenceDataCenterIcon), {
            appearance: "brand",
            size: "medium"
        }),
        [(0, $fH6Mg.PRODUCT_VARIANTS).DESTINATION]: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.ConfluenceIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        })
    }
};
const $001174c8cd6e9581$var$FALLBACK_ICON = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $79ZK0.default), {
    alignBlock: "center",
    alignInline: "center",
    xcss: $001174c8cd6e9581$var$fallbackIconStyles,
    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqSEE))), {
        label: "globe",
        size: "medium"
    })
});
const $001174c8cd6e9581$export$16b26cd5e98d9100 = (productType, variant)=>{
    if (!productType || !(productType in $001174c8cd6e9581$var$PRODUCT_CONFIG)) return $001174c8cd6e9581$var$FALLBACK_ICON;
    var _PRODUCT_CONFIG_productType_variant;
    return (_PRODUCT_CONFIG_productType_variant = $001174c8cd6e9581$var$PRODUCT_CONFIG[productType][variant]) !== null && _PRODUCT_CONFIG_productType_variant !== void 0 ? _PRODUCT_CONFIG_productType_variant : $001174c8cd6e9581$var$FALLBACK_ICON;
};
const $001174c8cd6e9581$export$1a199e029d5e93d6 = ({ productName: productType, variant: variant })=>{
    return $001174c8cd6e9581$export$16b26cd5e98d9100(productType, variant);
};

});
parcelRegister("fH6Mg", function(module, exports) {
$parcel$export(module.exports, "FILTER_KEYS", function () { return $80a4bc1143feb75f$export$53d040d638907d5e; });
$parcel$export(module.exports, "MIGRATION_PHASES", function () { return $80a4bc1143feb75f$export$1efa1f0409ff7265; });
$parcel$export(module.exports, "PRODUCT_NAMES", function () { return $80a4bc1143feb75f$export$a3c15905bd058cb9; });
$parcel$export(module.exports, "PRODUCT_VARIANTS", function () { return $80a4bc1143feb75f$export$3e4c388f5bb135c6; });
const $80a4bc1143feb75f$export$53d040d638907d5e = {
    STATUS: "status",
    MIGRATION_PHASE: "migrationPhase"
};
const $80a4bc1143feb75f$export$1efa1f0409ff7265 = {
    EXPLORE: "Explore",
    ASSESS: "Assess",
    PLAN_AND_TRACK: "Plan & Track",
    TEST_MIGRATION: "Test Migration",
    PROD_MIGRATION: "Prod Migration",
    POST_MIGRATION: "Post-Migration"
};
const $80a4bc1143feb75f$export$a3c15905bd058cb9 = {
    JIRA: "JIRA",
    CONFLUENCE: "CONFLUENCE"
};
const $80a4bc1143feb75f$export$3e4c388f5bb135c6 = {
    SOURCE: "source",
    DESTINATION: "destination"
};

});



parcelRegister("hDjaZ", function(module, exports) {
$parcel$export(module.exports, "getMigrationPhaseDisplayText", function () { return $55a43155d74f2bde$export$716f34c0ac7fd0bc; });
$parcel$export(module.exports, "applyFilters", function () { return $55a43155d74f2bde$export$47150c42ed89d097; });
$parcel$export(module.exports, "applySearch", function () { return $55a43155d74f2bde$export$7fd91c352a58fa31; });

var $4o8KE = parcelRequire("4o8KE");

var $fH6Mg = parcelRequire("fH6Mg");
const $55a43155d74f2bde$export$716f34c0ac7fd0bc = (phase)=>{
    switch(phase){
        case (0, $fH6Mg.MIGRATION_PHASES).EXPLORE:
            return (0, $4o8KE.messages).migrationTicketsTableMigrationPhaseExplore;
        case (0, $fH6Mg.MIGRATION_PHASES).ASSESS:
            return (0, $4o8KE.messages).migrationTicketsTableMigrationPhaseAssess;
        case (0, $fH6Mg.MIGRATION_PHASES).PLAN_AND_TRACK:
            return (0, $4o8KE.messages).migrationTicketsTableMigrationPhasePlanAndTrack;
        case (0, $fH6Mg.MIGRATION_PHASES).TEST_MIGRATION:
            return (0, $4o8KE.messages).migrationTicketsTableMigrationPhaseTestMigration;
        case (0, $fH6Mg.MIGRATION_PHASES).PROD_MIGRATION:
            return (0, $4o8KE.messages).migrationTicketsTableMigrationPhaseProdMigration;
        case (0, $fH6Mg.MIGRATION_PHASES).POST_MIGRATION:
            return (0, $4o8KE.messages).migrationTicketsTableMigrationPhasePostMigration;
        default:
            return (0, $4o8KE.messages).migrationTicketsTableMigrationPhaseUnknown;
    }
};
const $55a43155d74f2bde$export$47150c42ed89d097 = (data, filters)=>{
    if (!filters || Object.keys(filters).length === 0) return data;
    const migrationPhaseFilter = filters[(0, $fH6Mg.FILTER_KEYS).MIGRATION_PHASE];
    const statusFilter = filters[(0, $fH6Mg.FILTER_KEYS).STATUS];
    return data.filter((item)=>{
        const hasMigrationPhaseFilter = migrationPhaseFilter === null || migrationPhaseFilter === void 0 ? void 0 : migrationPhaseFilter.trim();
        const hasStatusFilter = statusFilter === null || statusFilter === void 0 ? void 0 : statusFilter.trim();
        if (hasMigrationPhaseFilter && item.migrationPhase !== migrationPhaseFilter) return false;
        if (hasStatusFilter && item.fastShiftStatusReason !== statusFilter) return false;
        return true;
    });
};
const $55a43155d74f2bde$export$7fd91c352a58fa31 = (data, searchTerm)=>{
    if (!(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.trim())) return data;
    const term = searchTerm.toLowerCase();
    return data.filter((req)=>req.supportTicketId.toLowerCase().includes(term) || req.title.toLowerCase().includes(term));
};

});

parcelRegister("jMpIW", function(module, exports) {
$parcel$export(module.exports, "useMigrationTicketsUIAnalytics", function () { return $48928b56f6b9f604$export$f00bdd73b172ac67; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
const $48928b56f6b9f604$export$f00bdd73b172ac67 = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)(true);
    const { fireUIEvent: fireUIEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    const sendOrgSelectorDropdownClickUIEvent = (0, $1oC0p.useCallback)(()=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).DROPDOWN,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).ORG_SELECTOR_DROPDOWN,
            source: sourceKey
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendOrgSelectorDropdownItemClickUIEvent = (0, $1oC0p.useCallback)((selectedOrgId)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).DROPDOWN_ITEM,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).ORG_SELECTOR_DROPDOWN,
            source: sourceKey,
            attributes: {
                selectedOrgId: selectedOrgId
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendStatusFilterDropdownClickUIEvent = (0, $1oC0p.useCallback)(()=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).DROPDOWN,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).STATUS_FILTER_DROPDOWN,
            source: sourceKey
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendStatusFilterDropdownItemClickUIEvent = (0, $1oC0p.useCallback)((selectedStatus)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).DROPDOWN_ITEM,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).STATUS_FILTER_DROPDOWN,
            source: sourceKey,
            attributes: {
                selectedStatus: selectedStatus
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendMigrationPhaseDropdownClickUIEvent = (0, $1oC0p.useCallback)(()=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).DROPDOWN,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).MIGRATION_PHASE_DROPDOWN,
            source: sourceKey
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendMigrationPhaseDropdownItemClickUIEvent = (0, $1oC0p.useCallback)((selectedMigrationPhase)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).DROPDOWN_ITEM,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).MIGRATION_PHASE_DROPDOWN,
            source: sourceKey,
            attributes: {
                selectedMigrationPhase: selectedMigrationPhase
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendClearFiltersButtonClickUIEvent = (0, $1oC0p.useCallback)(()=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).CLEAR_FILTERS_BUTTON,
            source: sourceKey
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendMigrationTicketsTableOpenSupportTicketClickUIEvent = (0, $1oC0p.useCallback)((ticketId)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).LINK,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).MIGRATION_TICKETS_TABLE_OPEN_SUPPORT_TICKET_LINK,
            source: sourceKey,
            attributes: {
                ticketId: ticketId
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendRelatedTicketsSidePanelLinkClickUIEvent = (0, $1oC0p.useCallback)((ticketId)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).LINK,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).RELATED_TICKETS_SIDE_PANEL_LINK,
            source: sourceKey,
            attributes: {
                ticketId: ticketId
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendRelatedTicketsSidePanelDismissButtonClickUIEvent = (0, $1oC0p.useCallback)((ticketId)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).RELATED_TICKETS_SIDE_PANEL_DISMISS_BUTTON,
            source: sourceKey,
            attributes: {
                ticketId: ticketId
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendRelatedTicketsSidePanelOpenSupportTicketClickUIEvent = (0, $1oC0p.useCallback)((ticketId)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).LINK,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).RELATED_TICKETS_SIDE_PANEL_OPEN_SUPPORT_TICKET_LINK,
            source: sourceKey,
            attributes: {
                ticketId: ticketId
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    return {
        sendOrgSelectorDropdownClickUIEvent: sendOrgSelectorDropdownClickUIEvent,
        sendOrgSelectorDropdownItemClickUIEvent: sendOrgSelectorDropdownItemClickUIEvent,
        sendStatusFilterDropdownClickUIEvent: sendStatusFilterDropdownClickUIEvent,
        sendStatusFilterDropdownItemClickUIEvent: sendStatusFilterDropdownItemClickUIEvent,
        sendMigrationPhaseDropdownClickUIEvent: sendMigrationPhaseDropdownClickUIEvent,
        sendMigrationPhaseDropdownItemClickUIEvent: sendMigrationPhaseDropdownItemClickUIEvent,
        sendClearFiltersButtonClickUIEvent: sendClearFiltersButtonClickUIEvent,
        sendMigrationTicketsTableOpenSupportTicketClickUIEvent: sendMigrationTicketsTableOpenSupportTicketClickUIEvent,
        sendRelatedTicketsSidePanelLinkClickUIEvent: sendRelatedTicketsSidePanelLinkClickUIEvent,
        sendRelatedTicketsSidePanelDismissButtonClickUIEvent: sendRelatedTicketsSidePanelDismissButtonClickUIEvent,
        sendRelatedTicketsSidePanelOpenSupportTicketClickUIEvent: sendRelatedTicketsSidePanelOpenSupportTicketClickUIEvent
    };
};

});


parcelRegister("g1m1l", function(module, exports) {
$parcel$export(module.exports, "useMigrationTicketsPageAnalytics", function () { return $399c4a4fa19e6459$export$b509495a40049d92; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");

var $af3Tw = parcelRequire("af3Tw");
const $399c4a4fa19e6459$export$b509495a40049d92 = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)();
    const { fireScreenEvent: fireScreenEvent, fireTrackEvent: fireTrackEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    const { selectedDomainOrg: selectedDomainOrg } = (0, $f7YG8.useFastshiftSelector)((state)=>({
            selectedDomainOrg: state.selectedDomainOrg
        }));
    const { data: supportRequestsData } = (0, $f7YG8.useFastshiftSelector)((state)=>state.supportRequests);
    const { data: customerDomainData } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomain);
    const cachedTableControls = (0, $f7YG8.useFastshiftSelector)((state)=>state.pageStateCache[(0, $af3Tw.TABLE_IDS).MIGRATION_TICKETS]);
    // Screen event on mount
    (0, $1oC0p.useEffect)(()=>{
        if (!identityAttrs) return;
        fireScreenEvent({
            name: sourceKey
        });
    }, [
        fireScreenEvent,
        sourceKey,
        identityAttrs
    ]);
    // Track event when page data loads or pagination changes
    (0, $1oC0p.useEffect)(()=>{
        if (!identityAttrs || !selectedDomainOrg || !supportRequestsData) return;
        const planTicketList = supportRequestsData.slice(cachedTableControls.page * cachedTableControls.size, (cachedTableControls.page + 1) * cachedTableControls.size).map((ticket)=>ticket.supportTicketId);
        const orgCount = customerDomainData === null || customerDomainData === void 0 ? void 0 : customerDomainData.orgsWithAdminRole.length;
        fireTrackEvent({
            action: (0, $3cXzX.ActionKey).DISPLAYED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).SECTION,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).MIGRATION_TICKETS_PAGE_DETAILS,
            source: sourceKey,
            attributes: {
                selectedOrgId: selectedDomainOrg.orgId,
                orgCount: orgCount,
                planTicketCount: planTicketList.length,
                planTicketList: planTicketList
            }
        });
    }, [
        identityAttrs,
        selectedDomainOrg,
        supportRequestsData,
        cachedTableControls.page,
        cachedTableControls.size,
        customerDomainData,
        fireTrackEvent,
        sourceKey
    ]);
};

});


parcelRegister("6labG", function(module, exports) {
$parcel$export(module.exports, "MigrationTicketsTable", function () { return (parcelRequire("bp6wt")).MigrationTicketsTable; });

var $bp6wt = parcelRequire("bp6wt");

});
parcelRegister("bp6wt", function(module, exports) {
$parcel$export(module.exports, "MigrationTicketsTable", function () { return $141afd47f3cf9772$export$c34f4106e7aa56d0; });
/* migration-tickets-table.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $f6YGh = parcelRequire("f6YGh");
parcelRequire("z8fwG");
var $1NoJu = parcelRequire("1NoJu");
parcelRequire("kDIm2");
var $dyxra = parcelRequire("dyxra");
parcelRequire("2RRni");
var $bQWID = parcelRequire("bQWID");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");

var $8Bmsc = parcelRequire("8Bmsc");
parcelRequire("1GTvS");
var $9xWji = parcelRequire("9xWji");
var $jMpIW = parcelRequire("jMpIW");

var $4o8KE = parcelRequire("4o8KE");

var $ibgnl = parcelRequire("ibgnl");
// Override the default height of the table rows to match the design
/* eslint-disable-next-line local/no-block-disable-of-nested-eslint */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ const $141afd47f3cf9772$var$StyledTableWrapper = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $aPnCa._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, (0, $dPABA._)((0, $6ogO3._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_14dhckbl",
            __cmplp.className
        ])
    }));
});
const $141afd47f3cf9772$var$errorDisplayStyles = (0, $f6YGh.xcss)({
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    borderRadius: "8px",
    padding: "space.200",
    alignContent: "center",
    height: "412px"
});
const $141afd47f3cf9772$export$c34f4106e7aa56d0 = ()=>{
    const { isTableLoading: isTableLoading, isTableError: isTableError, head: head, rows: rows, handleRefresh: handleRefresh, pagination: pagination, onSetControlsPayload: onSetControlsPayload, controls: cachedControls, filters: filters } = (0, $9xWji.useMigrationTicketsTable)();
    const intl = (0, $8e22h.default)();
    const customerDomain = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomain);
    const selectedDomainOrg = (0, $f7YG8.useFastshiftSelector)((state)=>state.selectedDomainOrg);
    const dispatch = (0, $f7YG8.useFastshiftDispatch)();
    const { sendOrgSelectorDropdownClickUIEvent: sendOrgSelectorDropdownClickUIEvent, sendOrgSelectorDropdownItemClickUIEvent: sendOrgSelectorDropdownItemClickUIEvent } = (0, $jMpIW.useMigrationTicketsUIAnalytics)();
    const handleSetSelectedDomainOrg = (org)=>{
        if ((selectedDomainOrg === null || selectedDomainOrg === void 0 ? void 0 : selectedDomainOrg.orgId) === org.orgId) return;
        dispatch($8Bmsc.setSelectedDomainOrg(org));
    };
    const errorComponent = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NoJu.GenericErrorDisplay), {
        xcss: $141afd47f3cf9772$var$errorDisplayStyles,
        customMessage: intl.formatMessage((0, $4o8KE.messages).migrationTicketsTableErrorMessage),
        onRefresh: handleRefresh
    });
    const controls = {
        pagination: pagination,
        onSetControlsPayload: onSetControlsPayload,
        controls: cachedControls
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)($141afd47f3cf9772$var$StyledTableWrapper, {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dyxra.FastshiftTable), {
            id: "migration-tickets-table",
            enableSearch: true,
            toolbarContent: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQWID.OrgSelectorDropdown), {
                        customerDomain: customerDomain,
                        selectedDomainOrg: selectedDomainOrg,
                        onSetSelectedDomainOrg: handleSetSelectedDomainOrg,
                        sendOrgSelectorDropdownClickUIEvent: sendOrgSelectorDropdownClickUIEvent,
                        sendOrgSelectorDropdownItemClickUIEvent: sendOrgSelectorDropdownItemClickUIEvent,
                        buttonSpacing: "default"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ibgnl.MigrationTicketsFilters), {
                        filters: filters,
                        onSetControlsPayload: onSetControlsPayload,
                        allControls: cachedControls
                    })
                ]
            }),
            toolbarSpacing: "space.400",
            head: head,
            rows: rows,
            isTableLoading: isTableLoading,
            isTableError: isTableError,
            errorComponent: errorComponent,
            controls: controls,
            showToolbarOnError: true,
            enableRowClick: true
        })
    });
};

});
parcelRegister("ibgnl", function(module, exports) {
$parcel$export(module.exports, "MigrationTicketsFilters", function () { return $70ef11c23eb40558$export$9ec7f279ecdd5195; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $1HVQz = parcelRequire("1HVQz");
parcelRequire("jtpMK");
var $lmgkB = parcelRequire("lmgkB");
parcelRequire("1GTvS");
var $jMpIW = parcelRequire("jMpIW");

var $fH6Mg = parcelRequire("fH6Mg");

var $hDjaZ = parcelRequire("hDjaZ");

var $fCc1P = parcelRequire("fCc1P");

var $cWumr = parcelRequire("cWumr");

var $6RF9z = parcelRequire("6RF9z");
const $70ef11c23eb40558$export$9ec7f279ecdd5195 = ({ filters: filters, onSetControlsPayload: onSetControlsPayload, allControls: allControls })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { sendStatusFilterDropdownClickUIEvent: sendStatusFilterDropdownClickUIEvent, sendStatusFilterDropdownItemClickUIEvent: sendStatusFilterDropdownItemClickUIEvent, sendMigrationPhaseDropdownClickUIEvent: sendMigrationPhaseDropdownClickUIEvent, sendMigrationPhaseDropdownItemClickUIEvent: sendMigrationPhaseDropdownItemClickUIEvent, sendClearFiltersButtonClickUIEvent: sendClearFiltersButtonClickUIEvent } = (0, $jMpIW.useMigrationTicketsUIAnalytics)();
    const handleFilterChange = (key, option)=>{
        const newFilters = (0, $6ogO3._)({}, filters);
        if (option === null) delete newFilters[key];
        else newFilters[key] = option.value;
        onSetControlsPayload((0, $dPABA._)((0, $6ogO3._)({}, allControls), {
            filters: Object.keys(newFilters).length > 0 ? newFilters : {}
        }));
    };
    const selectedStatus = (filters === null || filters === void 0 ? void 0 : filters[(0, $fH6Mg.FILTER_KEYS).STATUS]) ? {
        label: formatMessage((0, $lmgkB.getStatusText)(filters[(0, $fH6Mg.FILTER_KEYS).STATUS])),
        value: filters[(0, $fH6Mg.FILTER_KEYS).STATUS]
    } : null;
    const selectedPhase = (filters === null || filters === void 0 ? void 0 : filters[(0, $fH6Mg.FILTER_KEYS).MIGRATION_PHASE]) ? {
        label: formatMessage((0, $hDjaZ.getMigrationPhaseDisplayText)(filters[(0, $fH6Mg.FILTER_KEYS).MIGRATION_PHASE])),
        value: filters[(0, $fH6Mg.FILTER_KEYS).MIGRATION_PHASE]
    } : null;
    const hasActiveFilters = filters && Object.keys(filters).length > 0;
    const handleClearFilters = ()=>{
        onSetControlsPayload((0, $dPABA._)((0, $6ogO3._)({}, allControls), {
            filters: {}
        }));
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6RF9z.StatusFilterDropdown), {
                selectedStatus: selectedStatus,
                onStatusChange: (option)=>handleFilterChange((0, $fH6Mg.FILTER_KEYS).STATUS, option),
                sendStatusFilterDropdownClickUIEvent: sendStatusFilterDropdownClickUIEvent,
                sendStatusFilterDropdownItemClickUIEvent: sendStatusFilterDropdownItemClickUIEvent
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cWumr.MigrationPhaseFilterDropdown), {
                selectedPhase: selectedPhase,
                onPhaseChange: (option)=>handleFilterChange((0, $fH6Mg.FILTER_KEYS).MIGRATION_PHASE, option),
                sendMigrationPhaseDropdownClickUIEvent: sendMigrationPhaseDropdownClickUIEvent,
                sendMigrationPhaseDropdownItemClickUIEvent: sendMigrationPhaseDropdownItemClickUIEvent
            }),
            hasActiveFilters && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), {
                appearance: "subtle",
                onClick: ()=>{
                    handleClearFilters();
                    sendClearFiltersButtonClickUIEvent();
                },
                testId: "clear-filters-button",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $fCc1P.messages).migrationTicketsFiltersClearFilters))
            })
        ]
    });
};

});
parcelRegister("fCc1P", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $36d5673604b1e67d$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $36d5673604b1e67d$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    migrationTicketsFiltersStatusPlaceholder: {
        id: "fastshift.migration-tickets-page.migration-tickets-filters.status-placeholder",
        defaultMessage: "Status",
        description: "Placeholder text for status filter dropdown"
    },
    migrationTicketsFiltersPhasePlaceholder: {
        id: "fastshift.migration-tickets-page.migration-tickets-filters.phase-placeholder",
        defaultMessage: "Migration phase",
        description: "Placeholder text for migration phase filter dropdown"
    },
    migrationTicketsFiltersClearFilters: {
        id: "fastshift.migration-tickets-page.migration-tickets-filters.clear-filters",
        defaultMessage: "Clear filters",
        description: "Text for clear all filters button"
    }
});

});

parcelRegister("cWumr", function(module, exports) {
$parcel$export(module.exports, "MigrationPhaseFilterDropdown", function () { return $e659e709e8de4efa$export$317449c9ea31080a; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $1HVQz = parcelRequire("1HVQz");

var $kMnBu = parcelRequire("kMnBu");
var $aKsx2 = parcelRequire("aKsx2");

var $5RBBI = parcelRequire("5RBBI");

var $79ZK0 = parcelRequire("79ZK0");

var $fH6Mg = parcelRequire("fH6Mg");

var $hDjaZ = parcelRequire("hDjaZ");

var $fCc1P = parcelRequire("fCc1P");

var $7tQl8 = parcelRequire("7tQl8");
const $e659e709e8de4efa$export$317449c9ea31080a = ({ selectedPhase: selectedPhase, onPhaseChange: onPhaseChange, sendMigrationPhaseDropdownClickUIEvent: sendMigrationPhaseDropdownClickUIEvent, sendMigrationPhaseDropdownItemClickUIEvent: sendMigrationPhaseDropdownItemClickUIEvent })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const phaseOptions = Object.values((0, $fH6Mg.MIGRATION_PHASES)).map((phase)=>{
        const phaseMessage = (0, $hDjaZ.getMigrationPhaseDisplayText)(phase);
        const phaseText = formatMessage(phaseMessage);
        return {
            label: phaseText,
            value: phase
        };
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kMnBu.default), {
        // This is atlaskit's recommended pattern for custom trigger components
        // eslint-disable-next-line react/no-unstable-nested-components
        trigger: (_param)=>{
            var { triggerRef: triggerRef } = _param, triggerProps = (0, $aPnCa._)(_param, [
                "triggerRef"
            ]);
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), (0, $dPABA._)((0, $6ogO3._)({
                ref: triggerRef
            }, triggerProps), {
                testId: "phase-filter-button",
                onClick: (e)=>{
                    var _triggerProps_onClick;
                    sendMigrationPhaseDropdownClickUIEvent();
                    (_triggerProps_onClick = triggerProps.onClick) === null || _triggerProps_onClick === void 0 ? void 0 : _triggerProps_onClick.call(triggerProps, e);
                },
                isSelected: !!selectedPhase,
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                    space: "space.100",
                    alignInline: "center",
                    alignBlock: "center",
                    children: [
                        (selectedPhase === null || selectedPhase === void 0 ? void 0 : selectedPhase.label) || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $fCc1P.messages).migrationTicketsFiltersPhasePlaceholder)),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))), {
                            label: "Chevron down icon",
                            size: "small"
                        })
                    ]
                })
            }));
        },
        spacing: "compact",
        shouldRenderToParent: true,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aKsx2.default), {
            children: phaseOptions.map((option)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7tQl8.MigrationPhaseFilterDropdownItem), {
                    option: option,
                    isSelected: (selectedPhase === null || selectedPhase === void 0 ? void 0 : selectedPhase.value) === option.value,
                    onPhaseChange: onPhaseChange,
                    sendMigrationPhaseDropdownItemClickUIEvent: sendMigrationPhaseDropdownItemClickUIEvent
                }, option.value))
        })
    });
};

});
parcelRegister("7tQl8", function(module, exports) {
$parcel$export(module.exports, "MigrationPhaseFilterDropdownItem", function () { return $e67a4b09c425f5d6$export$a608103ff6f9a497; });

var $7VQPk = parcelRequire("7VQPk");

var $i99jD = parcelRequire("i99jD");

var $lPRxe = parcelRequire("lPRxe");
const $e67a4b09c425f5d6$export$a608103ff6f9a497 = ({ option: option, isSelected: isSelected, onPhaseChange: onPhaseChange, sendMigrationPhaseDropdownItemClickUIEvent: sendMigrationPhaseDropdownItemClickUIEvent })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i99jD.default), {
        onClick: ()=>{
            sendMigrationPhaseDropdownItemClickUIEvent(option.value);
            onPhaseChange(option);
        },
        isSelected: isSelected,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
            children: option.label
        })
    }, option.value);
};

});


parcelRegister("6RF9z", function(module, exports) {
$parcel$export(module.exports, "StatusFilterDropdown", function () { return $787e100c6b464b77$export$59387540279305d9; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $1HVQz = parcelRequire("1HVQz");

var $kMnBu = parcelRequire("kMnBu");
var $aKsx2 = parcelRequire("aKsx2");

var $5RBBI = parcelRequire("5RBBI");

var $gcfBV = parcelRequire("gcfBV");

var $79ZK0 = parcelRequire("79ZK0");
parcelRequire("jtpMK");
var $lmgkB = parcelRequire("lmgkB");

var $PE2DD = parcelRequire("PE2DD");

var $fCc1P = parcelRequire("fCc1P");

var $e2qMz = parcelRequire("e2qMz");
const $787e100c6b464b77$export$59387540279305d9 = ({ selectedStatus: selectedStatus, onStatusChange: onStatusChange, sendStatusFilterDropdownClickUIEvent: sendStatusFilterDropdownClickUIEvent, sendStatusFilterDropdownItemClickUIEvent: sendStatusFilterDropdownItemClickUIEvent })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const statusOptions = Object.values((0, $PE2DD.FASTSHIFT_ROLL_UP_STATUS)).map((status)=>{
        const statusMessage = (0, $lmgkB.getStatusText)(status);
        const statusText = formatMessage(statusMessage);
        return {
            label: statusText,
            value: status
        };
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kMnBu.default), {
        // This is atlaskit's recommended pattern for custom trigger components
        // eslint-disable-next-line react/no-unstable-nested-components
        trigger: (_param)=>{
            var { triggerRef: triggerRef } = _param, triggerProps = (0, $aPnCa._)(_param, [
                "triggerRef"
            ]);
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), (0, $dPABA._)((0, $6ogO3._)({
                ref: triggerRef
            }, triggerProps), {
                testId: "status-filter-button",
                onClick: (e)=>{
                    var _triggerProps_onClick;
                    sendStatusFilterDropdownClickUIEvent();
                    (_triggerProps_onClick = triggerProps.onClick) === null || _triggerProps_onClick === void 0 ? void 0 : _triggerProps_onClick.call(triggerProps, e);
                },
                isSelected: !!selectedStatus,
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                    space: "space.100",
                    alignInline: "center",
                    alignBlock: "center",
                    children: [
                        (selectedStatus === null || selectedStatus === void 0 ? void 0 : selectedStatus.label) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gcfBV.default), {
                            appearance: (0, $lmgkB.getStatusColor)(selectedStatus.value),
                            children: selectedStatus === null || selectedStatus === void 0 ? void 0 : selectedStatus.label
                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $fCc1P.messages).migrationTicketsFiltersStatusPlaceholder)),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))), {
                            label: "Chevron down icon",
                            size: "small"
                        })
                    ]
                })
            }));
        },
        spacing: "compact",
        shouldRenderToParent: true,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aKsx2.default), {
            children: statusOptions.map((option)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $e2qMz.StatusFilterDropdownItem), {
                    option: option,
                    isSelected: (selectedStatus === null || selectedStatus === void 0 ? void 0 : selectedStatus.value) === option.value,
                    onStatusChange: onStatusChange,
                    sendStatusFilterDropdownItemClickUIEvent: sendStatusFilterDropdownItemClickUIEvent
                }, option.value))
        })
    });
};

});
parcelRegister("e2qMz", function(module, exports) {
$parcel$export(module.exports, "StatusFilterDropdownItem", function () { return $a30519bf59794957$export$73dcf73d186382b2; });

var $7VQPk = parcelRequire("7VQPk");

var $i99jD = parcelRequire("i99jD");

var $gcfBV = parcelRequire("gcfBV");
parcelRequire("jtpMK");
var $lmgkB = parcelRequire("lmgkB");
const $a30519bf59794957$export$73dcf73d186382b2 = ({ option: option, isSelected: isSelected, onStatusChange: onStatusChange, sendStatusFilterDropdownItemClickUIEvent: sendStatusFilterDropdownItemClickUIEvent })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i99jD.default), {
        onClick: ()=>{
            sendStatusFilterDropdownItemClickUIEvent(option.value);
            onStatusChange(option);
        },
        isSelected: isSelected,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gcfBV.default), {
            appearance: (0, $lmgkB.getStatusColor)(option.value),
            children: option.label
        })
    }, option.value);
};

});







parcelRegister("8POFg", function(module, exports) {
$parcel$export(module.exports, "PageLayout", function () { return $4fb574b179d647c3$export$6d1402fb58384e4f; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $ipuAN = parcelRequire("ipuAN");

var $8e22h = parcelRequire("8e22h");

var $jwXhl = parcelRequire("jwXhl");

var $7LCKL = parcelRequire("7LCKL");

var $gcfBV = parcelRequire("gcfBV");

var $3HhJy = parcelRequire("3HhJy");
var $gvKqR = parcelRequire("gvKqR");

var $bWGpg = parcelRequire("bWGpg");
var $5JpTD = parcelRequire("5JpTD");
var $i13BD = parcelRequire("i13BD");
var $2lUOH = parcelRequire("2lUOH");

var $iF38V = parcelRequire("iF38V");
var $eoNne = parcelRequire("eoNne");
var $bQ6B4 = parcelRequire("bQ6B4");

var $1RpK2 = parcelRequire("1RpK2");

var $f3Vh4 = parcelRequire("f3Vh4");

var $5vd7q = parcelRequire("5vd7q");

var $g3ExX = parcelRequire("g3ExX");
var $79ZK0 = parcelRequire("79ZK0");
var $f6YGh = parcelRequire("f6YGh");
parcelRequire("UtNlw");
var $68u3n = parcelRequire("68u3n");
parcelRequire("biKC4");
var $edwqB = parcelRequire("edwqB");
parcelRequire("4oLek");
var $8K5F8 = parcelRequire("8K5F8");
parcelRequire("iTGju");
var $bh3Fv = parcelRequire("bh3Fv");
parcelRequire("b6eJV");
var $7ehC8 = parcelRequire("7ehC8");
parcelRequire("kpY1n");
var $i4499 = parcelRequire("i4499");
parcelRequire("z8fwG");
var $1NoJu = parcelRequire("1NoJu");

var $7J0yo = parcelRequire("7J0yo");
parcelRequire("g36T6");
var $4Li9Q = parcelRequire("4Li9Q");
parcelRequire("eVlKP");
var $ffpci = parcelRequire("ffpci");
parcelRequire("jGed2");
var $gulZg = parcelRequire("gulZg");
var $ct4Ak = parcelRequire("ct4Ak");
var $9GmHN = parcelRequire("9GmHN");

var $e0mZZ = parcelRequire("e0mZZ");

var $dKb1Y = parcelRequire("dKb1Y");
parcelRequire("11Cn2");
var $eUBIa = parcelRequire("eUBIa");
const $4fb574b179d647c3$var$mainStyles = (0, $f6YGh.xcss)({
    padding: "space.200"
});
// Adapter to convert BaseLogoProps to LogoProps for AppLogo
// resolves incompatible typing issues from package versioning
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4fb574b179d647c3$var$AtlassianAdminIconAdapter = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7LCKL.AtlassianAdminIcon), (0, $6ogO3._)({}, props));
const $4fb574b179d647c3$export$6d1402fb58384e4f = ()=>{
    const { domainId: domainId } = (0, $jwXhl.useParams)();
    const { paths: paths } = (0, $bh3Fv.useRoutes)();
    const accessControlState = (0, $e0mZZ.usePortalAuthenticationAndAccessControl)();
    const { userAccessState: userAccessState, shouldShowSideNav: shouldShowSideNav, isPartnerOrInternal: isPartnerOrInternal } = accessControlState;
    const shouldDisplayAIChatWidget = !accessControlState.isOnHomeRoute && accessControlState.userAccessState === (0, $e0mZZ.UserAccessValidationState).VALIDATION_SUCCESS;
    const isViewingConsentLandingPage = (0, $i4499.useShouldShowConsentLandingPage)();
    const shouldDisplayFeedbackCollector = (0, $1oC0p.useMemo)(()=>{
        return !isViewingConsentLandingPage && accessControlState.userAccessState === (0, $e0mZZ.UserAccessValidationState).VALIDATION_SUCCESS;
    }, [
        accessControlState,
        isViewingConsentLandingPage
    ]);
    (0, $gulZg.useLoadDomainScopedState)(domainId || "");
    const { pageKey: pageKey, links: pageMenuItems, isOnDomainScopedPage: isOnDomainScopedPage } = (0, $9GmHN.usePageNavLinks)();
    const { sendSideNavLinkClickEvent: sendSideNavLinkClickEvent } = (0, $ct4Ak.usePageLayoutAnalytics)();
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gvKqR.Root), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $edwqB.PagePanelContextProvider), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iF38V.TopNav), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)($ipuAN.ErrorBoundary, {
                        beforeCapture: (0, $7J0yo.beforeCaptureWithScope)("top-nav"),
                        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NoJu.GenericErrorDisplay), {}),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQ6B4.TopNavStart), {
                                children: [
                                    shouldShowSideNav && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2lUOH.SideNavToggleButton), {
                                        defaultCollapsed: true,
                                        collapseLabel: formatMessage((0, $dKb1Y.messages).collapseSidebarLabel),
                                        expandLabel: formatMessage((0, $dKb1Y.messages).expandSidebarLabel)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5vd7q.AppLogo), {
                                        icon: $4fb574b179d647c3$var$AtlassianAdminIconAdapter,
                                        name: formatMessage((0, $dKb1Y.messages).fastshiftAppName),
                                        label: formatMessage((0, $dKb1Y.messages).homePageLabel),
                                        href: paths.home
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gcfBV.default), {
                                        appearance: "removed",
                                        children: formatMessage((0, $dKb1Y.messages).betaLozenge)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $eoNne.TopNavEnd), {
                                children: [
                                    shouldDisplayFeedbackCollector && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8K5F8.FeedbackCollector), {}),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7ehC8.NavigationProfile), {})
                                ]
                            })
                        ]
                    })
                }),
                shouldShowSideNav && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bWGpg.SideNav), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)($ipuAN.ErrorBoundary, {
                        beforeCapture: (0, $7J0yo.beforeCaptureWithScope)("side-nav"),
                        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NoJu.GenericErrorDisplay), {}),
                        children: [
                            isPartnerOrInternal && isOnDomainScopedPage && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i13BD.SideNavHeader), {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ffpci.DomainScopedNavHeader), {
                                    isOnDomainScopedPage: isOnDomainScopedPage
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5JpTD.SideNavContent), {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f3Vh4.MenuList), {
                                    children: pageMenuItems.map((navItem)=>{
                                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1RpK2.LinkMenuItem), {
                                            href: navItem.link || "",
                                            elemBefore: navItem.icon,
                                            isSelected: navItem.key == pageKey,
                                            onClick: ()=>{
                                                sendSideNavLinkClickEvent(navItem.label, navItem.link || "", isOnDomainScopedPage);
                                            },
                                            children: navItem.label
                                        }, navItem.key);
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3HhJy.Main), {
                    testId: "main",
                    id: "main",
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                        alignInline: "center",
                        children: [
                            shouldDisplayAIChatWidget && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $68u3n.AIChatWidget), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Li9Q.AccessControlledPageContent), {
                                userAccessState: userAccessState,
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                                    xcss: $4fb574b179d647c3$var$mainStyles,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($ipuAN.ErrorBoundary, {
                                        beforeCapture: (0, $7J0yo.beforeCaptureWithScope)("page-content"),
                                        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NoJu.GenericErrorDisplay), {}),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jwXhl.Outlet), {})
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUBIa.PagePanel), {})
            ]
        })
    });
};

});
parcelRegister("3HhJy", function(module, exports) {
$parcel$export(module.exports, "Main", function () { return $2b1324c8c3c849e7$export$861edd1ccea2f746; });
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");

var $39c3M = parcelRequire("39c3M");

var $8Ook3 = parcelRequire("8Ook3");


var $9Kv5j = parcelRequire("9Kv5j");
var $2b1324c8c3c849e7$var$mainElementStyles = {
    root: "_nd5l1gzg _1reo1wug _18m91wug _19121cl4 _152timx3 _qwfh1wug _165teqxy _13wn1if8",
    containPaint: "_njlp1t7j"
};
function $2b1324c8c3c849e7$export$861edd1ccea2f746(_ref) {
    var children = _ref.children, xcss = _ref.xcss, _ref$skipLinkLabel = _ref.skipLinkLabel, skipLinkLabel = _ref$skipLinkLabel === void 0 ? 'Main Content' : _ref$skipLinkLabel, testId = _ref.testId, providedId = _ref.id;
    var id = (0, $9Kv5j.useLayoutId)({
        providedId: providedId
    });
    (0, $8Ook3.useSkipLink)(id, skipLinkLabel);
    return /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $iiT5o.default)([
            $2b1324c8c3c849e7$var$mainElementStyles.root,
            (0, $39c3M.fg)('platform_dst_nav4_layering_in_main_slot_fixes') && $2b1324c8c3c849e7$var$mainElementStyles.containPaint,
            xcss
        ]),
        role: "main",
        "data-testid": testId
    }, children));
}

});
parcelRegister("8Ook3", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContext", function () { return $66a5dc2dd828ad27$export$4c5cc3b14c7678a; });
$parcel$export(module.exports, "useSkipLinkInternal", function () { return $66a5dc2dd828ad27$export$707b94c26b8b75aa; });
$parcel$export(module.exports, "useSkipLink", function () { return $66a5dc2dd828ad27$export$89d9323301efc7d6; });

var $1oC0p = parcelRequire("1oC0p");

var $hshSj = parcelRequire("hshSj");
var $66a5dc2dd828ad27$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $1oC0p.createContext)({
    registerSkipLink: (0, $hshSj.default),
    unregisterSkipLink: (0, $hshSj.default)
});
var $66a5dc2dd828ad27$var$useSkipLinks = function useSkipLinks() {
    return (0, $1oC0p.useContext)($66a5dc2dd828ad27$export$4c5cc3b14c7678a);
};
var $66a5dc2dd828ad27$export$707b94c26b8b75aa = function useSkipLinkInternal(_ref) {
    var id = _ref.id, label = _ref.label, listIndex = _ref.listIndex, onBeforeNavigate = _ref.onBeforeNavigate, isHidden = _ref.isHidden;
    var _useSkipLinks = $66a5dc2dd828ad27$var$useSkipLinks(), registerSkipLink = _useSkipLinks.registerSkipLink, unregisterSkipLink = _useSkipLinks.unregisterSkipLink;
    (0, $1oC0p.useEffect)(function() {
        if (isHidden) /**
       * Skip links are hidden for slots with 0 height or width.
       * They should not be registered.
       */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            isHidden: isHidden
        });
        return function() {
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};
var $66a5dc2dd828ad27$export$89d9323301efc7d6 = function useSkipLink(id, label, listIndex) {
    $66a5dc2dd828ad27$export$707b94c26b8b75aa({
        id: id,
        label: label,
        listIndex: listIndex
    });
};

});

parcelRegister("9Kv5j", function(module, exports) {
$parcel$export(module.exports, "useLayoutId", function () { return $719085b208ec8342$export$110c3550c7c1c9aa; });

var $edmmv = parcelRequire("edmmv");
function $719085b208ec8342$export$fa3cfac0c8e29c5c() {
    var uniqueId = (0, $edmmv.useId)();
    return uniqueId;
}
function $719085b208ec8342$export$110c3550c7c1c9aa() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, providedId = _ref.providedId;
    var uniqueId = $719085b208ec8342$export$fa3cfac0c8e29c5c();
    var id = providedId ? providedId : uniqueId;
    return id;
}

});


parcelRegister("gvKqR", function(module, exports) {
$parcel$export(module.exports, "gridRootId", function () { return $c0538f17d0ced8b7$export$a6d827031bcb31d1; });
$parcel$export(module.exports, "Root", function () { return $c0538f17d0ced8b7$export$be92b6f5f03c0fe9; });
/* root.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iiT5o = parcelRequire("iiT5o");

var $1oC0p = parcelRequire("1oC0p");

var $3RhQr = parcelRequire("3RhQr");

var $39c3M = parcelRequire("39c3M");

var $lNidq = parcelRequire("lNidq");

var $HVr0Y = parcelRequire("HVr0Y");

var $gHZRl = parcelRequire("gHZRl");

var $5xY8f = parcelRequire("5xY8f");

var $knkrb = parcelRequire("knkrb");

var $9hlEa = parcelRequire("9hlEa");

var $ELP70 = parcelRequire("ELP70");
var $c0538f17d0ced8b7$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
var $c0538f17d0ced8b7$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
};
function $c0538f17d0ced8b7$export$be92b6f5f03c0fe9(_ref) {
    var children = _ref.children, xcss = _ref.xcss, _ref$UNSAFE_dangerous = _ref.UNSAFE_dangerouslyHoistSlotSizes, UNSAFE_dangerouslyHoistSlotSizes = _ref$UNSAFE_dangerous === void 0 ? false : _ref$UNSAFE_dangerous, _ref$skipLinksLabel = _ref.skipLinksLabel, skipLinksLabel = _ref$skipLinksLabel === void 0 ? 'Skip to:' : _ref$skipLinksLabel, testId = _ref.testId;
    var ref = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(function() {
        var IGNORED_ELEMENTS;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ELP70.SideNavVisibilityProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9hlEa.SideNavToggleButtonProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $knkrb.SideNavElementProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $gHZRl.TopNavStartProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3RhQr.OpenLayerObserver), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $5xY8f.DangerouslyHoistSlotSizes).Provider, {
        value: UNSAFE_dangerouslyHoistSlotSizes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $HVr0Y.SkipLinksProvider), {
        label: skipLinksLabel,
        testId: testId
    }, !(0, $39c3M.fg)('platform_dst_nav4_skip_links_hydration_fix') && /*#__PURE__*/ // SkipLinksContainer is rendered directly inside SkipLinksProvider when the FG is enabled.
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lNidq.SkipLinksContainer), {
        label: skipLinksLabel,
        testId: testId,
        links: // The links prop won't be used when the FG is disabled.
        []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        ref: ref,
        className: (0, $iiT5o.default)([
            $c0538f17d0ced8b7$var$styles.root,
            xcss
        ]),
        id: $c0538f17d0ced8b7$export$a6d827031bcb31d1,
        "data-testid": testId
    }, children))))))));
}

});
parcelRegister("3RhQr", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserver", function () { return $2cf429f816ae4bd4$export$97afddda23bcd287; });

var $3v8yH = parcelRequire("3v8yH");

var $1oC0p = parcelRequire("1oC0p");

var $lmxXn = parcelRequire("lmxXn");

var $9psBv = parcelRequire("9psBv");
/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ var $2cf429f816ae4bd4$var$noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function $2cf429f816ae4bd4$var$getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce(function(acc, listeners) {
        return acc + listeners.size;
    }, 0);
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function $2cf429f816ae4bd4$var$getListeners(_ref) {
    var registry = _ref.registry, namespace = _ref.namespace;
    // 1. If there are existing listeners for this namespace, return the existing set.
    var existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    var newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $2cf429f816ae4bd4$var$createInternalAPI() {
    /**
   * The layer count change listeners for each namespace.
   */ var namespaceToChangeListenerRegistry = new Map();
    /**
   * The `onClose` listeners for each namespace.
   * Each layer provides an `onClose` callback. **When the layer is open**, its `onClose`
   * callback is registered in this set.
   *
   * This data structure is also used determine the number of open layers.
   */ var namespaceToLayerCloseListenerRegistry = new Map();
    /**
   * Calls the appropriate layer count change listeners after the number of open layers has changed.
   */ function callChangeListeners(_ref2) {
        var namespace = _ref2.namespace, newCount = _ref2.newCount;
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            var listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace !== null && listenersForNamespace !== void 0 ? listenersForNamespace : []).forEach(function(listener) {
                return listener({
                    count: newCount
                });
            });
        }
        // 2. Call listeners registered without a specific namespace
        var noNamespaceListeners = namespaceToChangeListenerRegistry.get($2cf429f816ae4bd4$var$noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        var totalCount = $2cf429f816ae4bd4$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
        Array.from(noNamespaceListeners).forEach(function(listener) {
            return listener({
                count: totalCount
            });
        });
    }
    /**
   * Returns the current count of open layers.
   *
   * If a namespace is provided, the count for that namespace is returned.
   * Otherwise, the sum of all namespace counts is returned.
   */ function getCount() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, namespace = _ref3.namespace;
        if (namespace) {
            var _namespaceToLayerClos, _namespaceToLayerClos2;
            return (_namespaceToLayerClos = (_namespaceToLayerClos2 = namespaceToLayerCloseListenerRegistry.get(namespace)) === null || _namespaceToLayerClos2 === void 0 ? void 0 : _namespaceToLayerClos2.size) !== null && _namespaceToLayerClos !== void 0 ? _namespaceToLayerClos : 0;
        }
        // A specific namespace was not requested, so we return the sum across all namespaces.
        return $2cf429f816ae4bd4$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
    }
    /**
   * Adds a listener that will be called when the number of open layers changes.
   *
   * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
   */ function onChange(listener) {
        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, providedNamespace = _ref4.namespace;
        /**
     * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
     * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
     * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
     */ function wrapped() {
            listener.apply(void 0, arguments);
        }
        var namespace = providedNamespace !== null && providedNamespace !== void 0 ? providedNamespace : $2cf429f816ae4bd4$var$noNamespaceSymbol;
        var listenersForNamespace = $2cf429f816ae4bd4$var$getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
   * Adds a listener to the registry that tells the observer how to close the layer component.
   * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
   *
   * All close listeners will be called by the observer when `closeLayers` is called.
   *
   * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
   */ function onClose(listener, _ref5) {
        var providedNamespace = _ref5.namespace;
        /**
     * We are wrapping the passed listener in a function to ensure that each call to `onClose` creates a unique
     * function reference. This is to handle scenarios where the same function is provided to several different `onClose`
     * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
     */ function wrapped() {
            listener();
        }
        var namespace = providedNamespace !== null && providedNamespace !== void 0 ? providedNamespace : $2cf429f816ae4bd4$var$noNamespaceSymbol;
        var listenersForNamespace = $2cf429f816ae4bd4$var$getListeners({
            namespace: namespace,
            registry: namespaceToLayerCloseListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerCloseListenerRegistry.delete(namespace);
        };
    }
    /**
   * Closes all open layers registered across all namespaces.
   */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerCloseListenerRegistry.values()).forEach(function(listeners) {
            Array.from(listeners).forEach(function(listener) {
                return listener();
            });
        });
    }
    var internalAPI = {
        getCount: getCount,
        onChange: onChange,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
function $2cf429f816ae4bd4$export$97afddda23bcd287(_ref6) {
    var children = _ref6.children;
    // Using state to ensure a stable reference to a single instance.
    var _useState = (0, $1oC0p.useState)(function() {
        return $2cf429f816ae4bd4$var$createInternalAPI();
    }), _useState2 = (0, $3v8yH.default)(_useState, 1), internalAPI = _useState2[0];
    var parentContext = (0, $1oC0p.useContext)((0, $9psBv.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, $lmxXn.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9psBv.OpenLayerObserverContext).Provider, {
        value: internalAPI
    }, children);
}

});
parcelRegister("3v8yH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $28cae7f23e4273b8$export$2e2bcd8739ae039; });

var $iCpj6 = parcelRequire("iCpj6");

var $eIvrZ = parcelRequire("eIvrZ");

var $5dPE2 = parcelRequire("5dPE2");

var $dvWIv = parcelRequire("dvWIv");
function $28cae7f23e4273b8$export$2e2bcd8739ae039(r, e) {
    return (0, $iCpj6.default)(r) || (0, $eIvrZ.default)(r, e) || (0, $5dPE2.default)(r, e) || (0, $dvWIv.default)();
}

});
parcelRegister("iCpj6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d8df680fd3005ce2$export$2e2bcd8739ae039; });
function $d8df680fd3005ce2$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("eIvrZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ab6d922c4ffb041c$export$2e2bcd8739ae039; });
function $ab6d922c4ffb041c$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("dvWIv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9d6bb78e6bc08743$export$2e2bcd8739ae039; });
function $9d6bb78e6bc08743$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("lNidq", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContainer", function () { return $fddc4dcc9ec96ef6$export$fce25a0c32fbc1e1; });
/* skip-links-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");

var $kbX5S = parcelRequire("kbX5S");

var $kwO89 = parcelRequire("kwO89");

var $blZjw = parcelRequire("blZjw");
var $fddc4dcc9ec96ef6$var$styles = {
    root: "_zulp1b66 _2rkoglpi _1rjcutpp _18zrutpp _1e0c1txw _2lx21bp4 _kqsw1n9t _1e02v47k _152tv47k _bfhk1bhr _16qs1cd0 _1pby1mrw _tzy4idpf _lcxvglyw _1digjh3g _1mygkb7n _18eu1wug",
    skipLinkList: "_zulp1b66 _1e0c1txw _2lx21bp4 _1x8w11lx _2mzuglyw _1pfhze3t _bozgze3t"
};
/**
 * Keydown handler to hide the skip links when escape is pressed.
 *
 * TODO: consider removing this, it doesn't make a lot of sense.
 * The skip links look like a popup but in reality they aren't.
 * Even though we hide them when the user presses Escape, when
 * they press TAB it will reopen the list and move to the next one...
 *
 * One potential option is to use a tree walker to focus on the
 * next focusable element in the DOM (outside the skip links
 * container).
 */ var $fddc4dcc9ec96ef6$var$closeOnEscape = function closeOnEscape(event) {
    if (event.key !== 'Escape') return;
    var activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
var $fddc4dcc9ec96ef6$var$isOnlyWhitespaceRegex = /^\s*$/;
function $fddc4dcc9ec96ef6$export$fce25a0c32fbc1e1(_ref) {
    var label = _ref.label, testId = _ref.testId, links = _ref.links;
    var sortedLinks = (0, $kwO89.useSortedSkipLinks)(links);
    if (sortedLinks.length === 0) return null;
    var isEmptyLabel = $fddc4dcc9ec96ef6$var$isOnlyWhitespaceRegex.test(label);
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        onKeyDown: $fddc4dcc9ec96ef6$var$closeOnEscape,
        "data-testid": testId ? "".concat(testId, "--skip-links-container") : undefined,
        className: (0, $iiT5o.default)([
            $fddc4dcc9ec96ef6$var$styles.root
        ])
    }, !isEmptyLabel && /*#__PURE__*/ $1oC0p.createElement((0, $kbX5S.default), {
        weight: "bold",
        testId: testId ? "".concat(testId, "--skip-links-container--label") : undefined
    }, label), /*#__PURE__*/ $1oC0p.createElement("ol", {
        className: (0, $iiT5o.default)([
            $fddc4dcc9ec96ef6$var$styles.skipLinkList
        ])
    }, sortedLinks.map(function(_ref2) {
        var id = _ref2.id, label = _ref2.label, onBeforeNavigate = _ref2.onBeforeNavigate;
        return /*#__PURE__*/ $1oC0p.createElement((0, $blZjw.SkipLink), {
            key: id,
            id: id,
            onBeforeNavigate: onBeforeNavigate
        }, label);
    })));
}

});
parcelRegister("kbX5S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eb32ac8c59a06757$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");

var $lmxXn = parcelRequire("lmxXn");

var $7CqPI = parcelRequire("7CqPI");

var $1ftBY = parcelRequire("1ftBY");
var $eb32ac8c59a06757$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $eb32ac8c59a06757$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $1ftBY.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($eb32ac8c59a06757$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $eb32ac8c59a06757$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $eb32ac8c59a06757$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pmoej",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $eb32ac8c59a06757$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
var $eb32ac8c59a06757$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $eb32ac8c59a06757$var$textColorMap = {
    'color.text': "_syaz1fxt",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syaz1q28",
    'color.text.accent.orange.bolder': "_syaz1vps",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syazpnps",
    'color.text.accent.blue.bolder': "_syazsc1o",
    'color.text.accent.purple': "_syaz10m5",
    'color.text.accent.purple.bolder': "_syaz2ibx",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1dyx",
    'color.text.accent.gray.bolder': "_syaz1x9z",
    'color.text.disabled': "_syaz1lh4",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syazaqb7",
    'color.text.brand': "_syaz1e6v",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syazwx40",
    'color.text.warning.inverse': "_syazal3n",
    'color.text.success': "_syazy73q",
    'color.text.discovery': "_syazzjem",
    'color.text.information': "_syaze0os",
    'color.text.subtlest': "_syaz131l",
    'color.text.subtle': "_syaz1gjq",
    'color.link': "_syaz14q2",
    'color.link.pressed': "_syaz16c2",
    'color.link.visited': "_syazw7te",
    'color.link.visited.pressed': "_syazg3x0"
};
var $eb32ac8c59a06757$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $eb32ac8c59a06757$var$Text = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $lmxXn.default)($eb32ac8c59a06757$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $7CqPI.useHasTextAncestor)();
    var color = $eb32ac8c59a06757$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $1oC0p.createElement(Component, {
        id: id,
        className: (0, $iiT5o.default)([
            $eb32ac8c59a06757$var$styles.root,
            size && $eb32ac8c59a06757$var$fontSizeMap[size],
            color && $eb32ac8c59a06757$var$textColorMap[color],
            maxLines && $eb32ac8c59a06757$var$styles.truncation,
            maxLines === 1 && $eb32ac8c59a06757$var$styles.breakAll,
            align && $eb32ac8c59a06757$var$styles["textAlign.".concat(align)],
            weight && $eb32ac8c59a06757$var$fontWeightMap[weight],
            Component === 'em' && $eb32ac8c59a06757$var$styles['as.em'],
            Component === 'strong' && $eb32ac8c59a06757$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $1oC0p.createElement((0, $7CqPI.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $eb32ac8c59a06757$export$2e2bcd8739ae039 = $eb32ac8c59a06757$var$Text;

});
parcelRegister("7CqPI", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", function () { return $58c0e58504cc1698$export$9322276ec105d055; });
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $58c0e58504cc1698$export$ae933c6cbe5643ad; });

var $1oC0p = parcelRequire("1oC0p");
var $58c0e58504cc1698$var$HasTextAncestorContext = /*#__PURE__*/ (0, $1oC0p.createContext)(false);
var $58c0e58504cc1698$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $1oC0p.useContext)($58c0e58504cc1698$var$HasTextAncestorContext);
};
var $58c0e58504cc1698$export$ae933c6cbe5643ad = $58c0e58504cc1698$var$HasTextAncestorContext.Provider;

});

parcelRegister("1ftBY", function(module, exports) {
$parcel$export(module.exports, "useSurface", function () { return $0e8e295e56064f6d$export$1aeb4f6b93c4540d; });

var $1oC0p = parcelRequire("1oC0p");
var $0e8e295e56064f6d$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $0e8e295e56064f6d$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($0e8e295e56064f6d$export$1ca2a26fecb070ae);
};
$0e8e295e56064f6d$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("kwO89", function(module, exports) {
$parcel$export(module.exports, "SkipLinksDataContext", function () { return $ef1daea6b42f05f4$export$e9ab38ce6147d3d2; });
$parcel$export(module.exports, "useSortedSkipLinks", function () { return $ef1daea6b42f05f4$export$b0b0d4fc1b356759; });

var $88fXP = parcelRequire("88fXP");

var $363qk = parcelRequire("363qk");

var $1oC0p = parcelRequire("1oC0p");

var $39c3M = parcelRequire("39c3M");
function $ef1daea6b42f05f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef1daea6b42f05f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef1daea6b42f05f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $363qk.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef1daea6b42f05f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ef1daea6b42f05f4$export$e9ab38ce6147d3d2 = /*#__PURE__*/ (0, $1oC0p.createContext)([]);
var $ef1daea6b42f05f4$var$_assignIndex = function assignIndex(num, arr) {
    if (!arr.includes(num)) return num;
    return $ef1daea6b42f05f4$var$_assignIndex(num + 1, arr);
};
var $ef1daea6b42f05f4$export$fa48cafc8c96d283 = function sortSkipLinks(arr) {
    var customLinks = arr.filter(function(link) {
        return Number.isInteger(link.listIndex);
    });
    if (customLinks.length === 0) return arr;
    var usedIndexes = customLinks.map(function(a) {
        return a.listIndex;
    });
    var regularLinksWithIndex = arr.filter(function(link) {
        return link.listIndex === undefined;
    }).map(function(link, index) {
        var listIndex = $ef1daea6b42f05f4$var$_assignIndex(index, usedIndexes);
        usedIndexes.push(listIndex);
        return $ef1daea6b42f05f4$var$_objectSpread($ef1daea6b42f05f4$var$_objectSpread({}, link), {}, {
            listIndex: listIndex
        });
    });
    return [].concat((0, $88fXP.default)(customLinks), (0, $88fXP.default)(regularLinksWithIndex)).sort(function(a, b) {
        return a.listIndex - b.listIndex;
    });
};
function $ef1daea6b42f05f4$export$b0b0d4fc1b356759(providedLinks) {
    var skipLinksData = (0, $1oC0p.useContext)($ef1daea6b42f05f4$export$e9ab38ce6147d3d2);
    var links = (0, $39c3M.fg)('platform_dst_nav4_skip_links_hydration_fix') ? providedLinks : skipLinksData;
    return (0, $1oC0p.useMemo)(function() {
        return $ef1daea6b42f05f4$export$fa48cafc8c96d283(links);
    }, [
        links
    ]);
}

});

parcelRegister("blZjw", function(module, exports) {
$parcel$export(module.exports, "SkipLink", function () { return $84413783cf376677$export$ef95c37428582a65; });
/* skip-link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iiT5o = parcelRequire("iiT5o");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $cMmDg = parcelRequire("cMmDg");
var $84413783cf376677$var$styles = {
    skipLinkListItem: "_1pfhze3t"
};
/**
 * Used for moving focus to the corresponding slot or custom target after clicking on a skip link.
 */ function $84413783cf376677$var$focusElement(element) {
    /**
   * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
   * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
   *
   * Our slots are not interactive, so this is required.
   *
   * In the future we may want to check if there is an existing `tabindex` attribute,
   * as custom skip linked elements might already have one.
   */ element.setAttribute('tabindex', '-1');
    /**
   * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
   *
   * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
   *
   * - mess with click events
   * - potentially cause a focus ring to be always visible
   */ (0, $dH1HR.bind)(element, {
        type: 'blur',
        listener: function listener() {
            element.removeAttribute('tabindex');
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
   * Move focus to the slot or custom target.
   *
   * Calling `.focus()` will also scroll the element into view:
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
   */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        // @ts-expect-error - new and not in types yet
        focusVisible: true
    });
}
var $84413783cf376677$export$ef95c37428582a65 = function SkipLink(_ref) {
    var id = _ref.id, children = _ref.children, onBeforeNavigate = _ref.onBeforeNavigate;
    var href = "#".concat(id);
    var onClick = (0, $1oC0p.useCallback)(function(event) {
        event.preventDefault();
        // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
        var target = document.getElementById(id);
        if (!target) return;
        /**
     * Internal slots can attach an `onBeforeNavigate` callback.
     *
     * Side nav uses this to ensure it is expanded.
     */ onBeforeNavigate === null || onBeforeNavigate === void 0 || onBeforeNavigate();
        $84413783cf376677$var$focusElement(target);
        /**
     * We should look into removing this, or only calling it in specific cases.
     *
     * It means if the skip link element is in the window scroll container
     * then it might not get scrolled into view properly.
     *
     * This is not an issue for the default slots on desktop, but could break custom skip links or
     * even `Aside` on mobile.
     *
     * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
     * E.g. jumping to main / aside it makes sense to look at the start of the content.
     */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("li", {
        className: (0, $iiT5o.default)([
            $84413783cf376677$var$styles.skipLinkListItem
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cMmDg.default), {
        tabIndex: 0,
        href: href,
        onClick: onClick
    }, children));
};

});
parcelRegister("cMmDg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $94db860823d312b9$export$2e2bcd8739ae039; });

var $9jUeC = parcelRequire("9jUeC");

var $hD6XT = parcelRequire("hD6XT");

var $2q0os = parcelRequire("2q0os");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $lmxXn = parcelRequire("lmxXn");

var $B2fUL = parcelRequire("B2fUL");

var $90p8I = parcelRequire("90p8I");

var $hshSj = parcelRequire("hshSj");

var $edmmv = parcelRequire("edmmv");

var $etBkE = parcelRequire("etBkE");

var $39c3M = parcelRequire("39c3M");

var $8eZqB = parcelRequire("8eZqB");

var $iBQlw = parcelRequire("iBQlw");

var $cV0yz = parcelRequire("cV0yz");
var $94db860823d312b9$var$_excluded = [
    "href",
    "children",
    "backgroundColor",
    "newWindowLabel",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss"
], $94db860823d312b9$var$_excluded2 = [
    "className"
];
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $94db860823d312b9$var$focusRingStyles = (0, $3dJ4i.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $iBQlw.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $iBQlw.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $iBQlw.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $94db860823d312b9$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    textDecoration: 'underline'
});
var $94db860823d312b9$var$positionStyles = (0, $3dJ4i.css)({
    position: 'relative'
});
var $94db860823d312b9$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $94db860823d312b9$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
var $94db860823d312b9$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $94db860823d312b9$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, backgroundColor = _ref.backgroundColor, newWindowLabel = _ref.newWindowLabel, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $hshSj.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $2q0os.default)(_ref, $94db860823d312b9$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $etBkE.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $edmmv.useId)();
    var onClick = (0, $B2fUL.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "14.11.4",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $2q0os.default)(htmlAttributes, $94db860823d312b9$var$_excluded2);
    var resolvedStyles = (0, $cV0yz.parseXcss)(xcss);
    var RouterLink = (0, $90p8I.default)();
    var isExternal = typeof href === 'string' && $94db860823d312b9$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $94db860823d312b9$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, $hD6XT.default)(href) === 'object';
    (0, $lmxXn.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return (0, $3dJ4i.jsx)(Component, (0, $9jUeC.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel ? newWindowLabel : $94db860823d312b9$var$OPENS_NEW_WINDOW_LABEL) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        css: [
            $94db860823d312b9$var$baseStyles,
            (0, $39c3M.fg)('platform_design-system-team_anchor-positioning') ? $94db860823d312b9$var$positionStyles : undefined,
            $94db860823d312b9$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $iBQlw.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $iBQlw.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $iBQlw.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $iBQlw.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $iBQlw.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $iBQlw.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $iBQlw.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $iBQlw.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && (0, $3dJ4i.jsx)((0, $8eZqB.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel ? newWindowLabel : $94db860823d312b9$var$OPENS_NEW_WINDOW_LABEL)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $94db860823d312b9$var$Anchor = /*#__PURE__*/ (0, $1oC0p.forwardRef)($94db860823d312b9$var$AnchorNoRef);
var $94db860823d312b9$export$2e2bcd8739ae039 = $94db860823d312b9$var$Anchor;

});
parcelRegister("iBQlw", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", function () { return $d8c449895efd59d7$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $d8c449895efd59d7$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $d8c449895efd59d7$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $d8c449895efd59d7$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $d8c449895efd59d7$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $d8c449895efd59d7$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $d8c449895efd59d7$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $d8c449895efd59d7$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $d8c449895efd59d7$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $d8c449895efd59d7$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $d8c449895efd59d7$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $d8c449895efd59d7$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $d8c449895efd59d7$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $d8c449895efd59d7$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $d8c449895efd59d7$export$3c7e9587132614b4; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $d8c449895efd59d7$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $d8c449895efd59d7$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $d8c449895efd59d7$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "textColorStylesMap", function () { return $d8c449895efd59d7$export$3a1bcba60b23d7f0; });
$parcel$export(module.exports, "textSizeStylesMap", function () { return $d8c449895efd59d7$export$219d364c0da35ae4; });
$parcel$export(module.exports, "textWeightStylesMap", function () { return $d8c449895efd59d7$export$38845ca010b93505; });

var $363qk = parcelRequire("363qk");

var $3dJ4i = parcelRequire("3dJ4i");

var $rCt1n = parcelRequire("rCt1n");
function $d8c449895efd59d7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d8c449895efd59d7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d8c449895efd59d7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $363qk.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d8c449895efd59d7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d8c449895efd59d7$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $d8c449895efd59d7$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $d8c449895efd59d7$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $d8c449895efd59d7$export$632685d741f3dbbf = $d8c449895efd59d7$var$_objectSpread($d8c449895efd59d7$var$_objectSpread({}, $d8c449895efd59d7$export$958d0ae7f2977ae4), $d8c449895efd59d7$export$d2dc61f58390201c);
var $d8c449895efd59d7$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $d8c449895efd59d7$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $d8c449895efd59d7$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $d8c449895efd59d7$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $d8c449895efd59d7$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $d8c449895efd59d7$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $d8c449895efd59d7$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $d8c449895efd59d7$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $d8c449895efd59d7$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $d8c449895efd59d7$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    // @deprecated
    'border.width.0': "var(--ds-border-width-0, 0px)",
    // @deprecated
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    // @deprecated
    'border.width.outline': "var(--ds-border-width-outline, 2px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $d8c449895efd59d7$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    // @deprecated
    'border.radius': "var(--ds-border-radius, 3px)",
    // @deprecated
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    // @deprecated
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    // @deprecated
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    // @deprecated
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    // @deprecated
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    // @deprecated
    'border.radius.circle': "var(--ds-border-radius-circle, 9999px)"
};
var $d8c449895efd59d7$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $d8c449895efd59d7$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $d8c449895efd59d7$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $d8c449895efd59d7$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $d8c449895efd59d7$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $d8c449895efd59d7$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $d8c449895efd59d7$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $d8c449895efd59d7$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3dJ4i.css)((0, $363qk.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $d8c449895efd59d7$export$e615f061ca585a6c = $d8c449895efd59d7$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $d8c449895efd59d7$export$ca0f9c2de39ffed7(spacingProperty, $d8c449895efd59d7$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $d8c449895efd59d7$export$bf46c3f9eeafc71f = $d8c449895efd59d7$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $d8c449895efd59d7$export$ca0f9c2de39ffed7(spacingProperty, $d8c449895efd59d7$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $d8c449895efd59d7$export$e7af83bafe7f9e63 = $d8c449895efd59d7$export$ca0f9c2de39ffed7('backgroundColor', $d8c449895efd59d7$export$d1d79bf68ac056bd);
var $d8c449895efd59d7$export$3a1bcba60b23d7f0 = $d8c449895efd59d7$export$ca0f9c2de39ffed7('color', $d8c449895efd59d7$export$8473307aa00d6ea1);
var $d8c449895efd59d7$export$45f3f4fe16f9f7d5 = $d8c449895efd59d7$export$ca0f9c2de39ffed7('fontWeight', $d8c449895efd59d7$export$303e322c6b1ed114);
var $d8c449895efd59d7$export$68cc305da27dbaa4 = $d8c449895efd59d7$export$ca0f9c2de39ffed7('fontFamily', $d8c449895efd59d7$export$3c7e9587132614b4);
var $d8c449895efd59d7$export$128f10c238242f83 = $d8c449895efd59d7$export$ca0f9c2de39ffed7('font', $d8c449895efd59d7$export$6ffa317d5e70375);
var $d8c449895efd59d7$export$219d364c0da35ae4 = $d8c449895efd59d7$export$ca0f9c2de39ffed7('font', $d8c449895efd59d7$export$236bfe3a33ef1292);
var $d8c449895efd59d7$export$38845ca010b93505 = $d8c449895efd59d7$export$ca0f9c2de39ffed7('fontWeight', $d8c449895efd59d7$export$855cfd311192d666);
var $d8c449895efd59d7$export$ff257d957d48c421 = $d8c449895efd59d7$export$ca0f9c2de39ffed7((0, $rCt1n.CURRENT_SURFACE_CSS_VAR), $d8c449895efd59d7$export$41a358c9c2356760);
var $d8c449895efd59d7$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $d8c449895efd59d7$export$41a358c9c2356760[color] !== undefined;
};
var $d8c449895efd59d7$export$7001ce64d9ff7c7f = $d8c449895efd59d7$export$ca0f9c2de39ffed7('font', $d8c449895efd59d7$export$b805719bc8cb376);

});
parcelRegister("rCt1n", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $05305c7e09c121b4$export$9d7b58831ae93caa; });
var $05305c7e09c121b4$export$4ef52930e33717cd = 'data-theme';
var $05305c7e09c121b4$export$a00eac3f8684bcd0 = 'data-color-mode';
var $05305c7e09c121b4$export$2112803007239c61 = 'data-contrast-mode';
var $05305c7e09c121b4$export$352e418ed5b6193a = 'data-custom-theme';
var $05305c7e09c121b4$export$6f0c6fb8c80fcc92 = 'ds';
var $05305c7e09c121b4$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $05305c7e09c121b4$export$dddac1532e822863 = "--".concat($05305c7e09c121b4$export$6f0c6fb8c80fcc92, "-token-not-found");
var $05305c7e09c121b4$export$9d7b58831ae93caa = "--".concat($05305c7e09c121b4$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("cV0yz", function(module, exports) {
$parcel$export(module.exports, "parseXcss", function () { return $967b3d68a975a19c$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $967b3d68a975a19c$export$f6c783d06584602c; });

var $88fXP = parcelRequire("88fXP");

var $363qk = parcelRequire("363qk");

var $9DP70 = parcelRequire("9DP70");

var $hD6XT = parcelRequire("hD6XT");

var $3dJ4i = parcelRequire("3dJ4i");

var $iBQlw = parcelRequire("iBQlw");

var $7t0tI = parcelRequire("7t0tI");
function $967b3d68a975a19c$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $967b3d68a975a19c$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $967b3d68a975a19c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $967b3d68a975a19c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $967b3d68a975a19c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $967b3d68a975a19c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $967b3d68a975a19c$export$9a199fbafee0014e = {
    backgroundColor: (0, $iBQlw.backgroundColorMap),
    blockSize: (0, $iBQlw.dimensionMap),
    borderBlockColor: (0, $iBQlw.borderColorMap),
    borderBlockEndColor: (0, $iBQlw.borderColorMap),
    borderBlockEndWidth: (0, $iBQlw.borderWidthMap),
    borderBlockStartColor: (0, $iBQlw.borderColorMap),
    borderBlockStartWidth: (0, $iBQlw.borderWidthMap),
    borderBlockWidth: (0, $iBQlw.borderWidthMap),
    borderBottomColor: (0, $iBQlw.borderColorMap),
    borderBottomLeftRadius: (0, $iBQlw.borderRadiusMap),
    borderBottomRightRadius: (0, $iBQlw.borderRadiusMap),
    borderBottomWidth: (0, $iBQlw.borderWidthMap),
    borderColor: (0, $iBQlw.borderColorMap),
    borderEndEndRadius: (0, $iBQlw.borderRadiusMap),
    borderEndStartRadius: (0, $iBQlw.borderRadiusMap),
    borderInlineColor: (0, $iBQlw.borderColorMap),
    borderInlineEndColor: (0, $iBQlw.borderColorMap),
    borderInlineEndWidth: (0, $iBQlw.borderWidthMap),
    borderInlineStartColor: (0, $iBQlw.borderColorMap),
    borderInlineStartWidth: (0, $iBQlw.borderWidthMap),
    borderInlineWidth: (0, $iBQlw.borderWidthMap),
    borderLeftColor: (0, $iBQlw.borderColorMap),
    borderLeftWidth: (0, $iBQlw.borderWidthMap),
    borderRadius: (0, $iBQlw.borderRadiusMap),
    borderRightColor: (0, $iBQlw.borderColorMap),
    borderRightWidth: (0, $iBQlw.borderWidthMap),
    borderStartEndRadius: (0, $iBQlw.borderRadiusMap),
    borderStartStartRadius: (0, $iBQlw.borderRadiusMap),
    borderTopColor: (0, $iBQlw.borderColorMap),
    borderTopLeftRadius: (0, $iBQlw.borderRadiusMap),
    borderTopRightRadius: (0, $iBQlw.borderRadiusMap),
    borderTopWidth: (0, $iBQlw.borderWidthMap),
    borderWidth: (0, $iBQlw.borderWidthMap),
    bottom: (0, $iBQlw.allSpaceMap),
    boxShadow: (0, $iBQlw.shadowMap),
    color: (0, $iBQlw.textColorMap),
    columnGap: (0, $iBQlw.positiveSpaceMap),
    font: (0, $iBQlw.fontMap),
    fontFamily: (0, $iBQlw.fontFamilyMap),
    fontWeight: (0, $iBQlw.fontWeightMap),
    gap: (0, $iBQlw.positiveSpaceMap),
    height: (0, $iBQlw.dimensionMap),
    inlineSize: (0, $iBQlw.dimensionMap),
    inset: (0, $iBQlw.allSpaceMap),
    insetBlock: (0, $iBQlw.allSpaceMap),
    insetBlockEnd: (0, $iBQlw.allSpaceMap),
    insetBlockStart: (0, $iBQlw.allSpaceMap),
    insetInline: (0, $iBQlw.allSpaceMap),
    insetInlineEnd: (0, $iBQlw.allSpaceMap),
    insetInlineStart: (0, $iBQlw.allSpaceMap),
    left: (0, $iBQlw.allSpaceMap),
    margin: (0, $iBQlw.allSpaceMap),
    marginBlock: (0, $iBQlw.allSpaceMap),
    marginBlockEnd: (0, $iBQlw.allSpaceMap),
    marginBlockStart: (0, $iBQlw.allSpaceMap),
    marginBottom: (0, $iBQlw.allSpaceMap),
    marginInline: (0, $iBQlw.allSpaceMap),
    marginInlineEnd: (0, $iBQlw.allSpaceMap),
    marginInlineStart: (0, $iBQlw.allSpaceMap),
    marginLeft: (0, $iBQlw.allSpaceMap),
    marginRight: (0, $iBQlw.allSpaceMap),
    marginTop: (0, $iBQlw.allSpaceMap),
    maxBlockSize: (0, $iBQlw.dimensionMap),
    maxHeight: (0, $iBQlw.dimensionMap),
    maxInlineSize: (0, $iBQlw.dimensionMap),
    maxWidth: (0, $iBQlw.dimensionMap),
    minBlockSize: (0, $iBQlw.dimensionMap),
    minHeight: (0, $iBQlw.dimensionMap),
    minInlineSize: (0, $iBQlw.dimensionMap),
    minWidth: (0, $iBQlw.dimensionMap),
    opacity: (0, $iBQlw.opacityMap),
    outlineColor: (0, $iBQlw.borderColorMap),
    outlineOffset: (0, $iBQlw.allSpaceMap),
    outlineWidth: (0, $iBQlw.borderWidthMap),
    padding: (0, $iBQlw.positiveSpaceMap),
    paddingBlock: (0, $iBQlw.positiveSpaceMap),
    paddingBlockEnd: (0, $iBQlw.positiveSpaceMap),
    paddingBlockStart: (0, $iBQlw.positiveSpaceMap),
    paddingBottom: (0, $iBQlw.positiveSpaceMap),
    paddingInline: (0, $iBQlw.positiveSpaceMap),
    paddingInlineEnd: (0, $iBQlw.positiveSpaceMap),
    paddingInlineStart: (0, $iBQlw.positiveSpaceMap),
    paddingLeft: (0, $iBQlw.positiveSpaceMap),
    paddingRight: (0, $iBQlw.positiveSpaceMap),
    paddingTop: (0, $iBQlw.positiveSpaceMap),
    right: (0, $iBQlw.allSpaceMap),
    rowGap: (0, $iBQlw.positiveSpaceMap),
    top: (0, $iBQlw.allSpaceMap),
    width: (0, $iBQlw.dimensionMap),
    zIndex: (0, $iBQlw.layerMap)
};
var $967b3d68a975a19c$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $967b3d68a975a19c$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $7t0tI === "undefined" ? "undefined" : (0, $hD6XT.default)($7t0tI)) === 'object' && (0, $hD6XT.default)($7t0tI.env) === 'object' && false;
};
var $967b3d68a975a19c$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $967b3d68a975a19c$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $967b3d68a975a19c$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $hD6XT.default)(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($967b3d68a975a19c$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $9DP70.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $hD6XT.default)(value) === 'object' && $967b3d68a975a19c$var$safeSelectors.test(key)) {
            styleObj[key] = $967b3d68a975a19c$var$_transformStyles(value);
            return;
        }
        if ($967b3d68a975a19c$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($967b3d68a975a19c$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $967b3d68a975a19c$export$9a199fbafee0014e)) return;
        var tokenValue = $967b3d68a975a19c$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $967b3d68a975a19c$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $967b3d68a975a19c$var$_transformStyles(style);
    return (0, $363qk.default)({}, $967b3d68a975a19c$var$uniqueSymbol, (0, $3dJ4i.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $967b3d68a975a19c$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $967b3d68a975a19c$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $967b3d68a975a19c$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $88fXP.default)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$967b3d68a975a19c$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $967b3d68a975a19c$export$f6c783d06584602c(style) {
    return $967b3d68a975a19c$var$baseXcss(style);
}

});




parcelRegister("HVr0Y", function(module, exports) {
$parcel$export(module.exports, "SkipLinksProvider", function () { return $0840919b48aeb8a6$export$fe514f9f7b03d46f; });

var $88fXP = parcelRequire("88fXP");

var $9DP70 = parcelRequire("9DP70");

var $1oC0p = parcelRequire("1oC0p");

var $39c3M = parcelRequire("39c3M");

var $lNidq = parcelRequire("lNidq");

var $8Ook3 = parcelRequire("8Ook3");

var $kwO89 = parcelRequire("kwO89");
var $0840919b48aeb8a6$var$getByDomOrderSortFunction = function getByDomOrderSortFunction() {
    var layoutSlots = Array.from(document.querySelectorAll("[data-layout-slot]"));
    return function(a, b) {
        var _a$listIndex, _b$listIndex;
        var indexA = (_a$listIndex = a.listIndex) !== null && _a$listIndex !== void 0 ? _a$listIndex : layoutSlots.indexOf(document.getElementById(a.id));
        var indexB = (_b$listIndex = b.listIndex) !== null && _b$listIndex !== void 0 ? _b$listIndex : layoutSlots.indexOf(document.getElementById(b.id));
        /**
     * If they are tied it is because one (or both) is
     * a custom skiplink with a set index.
     *
     * Give the custom skiplink priority.
     */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
function $0840919b48aeb8a6$export$fe514f9f7b03d46f(_ref) {
    var children = _ref.children, label = _ref.label, testId = _ref.testId;
    var _useState = (0, $1oC0p.useState)([]), _useState2 = (0, $9DP70.default)(_useState, 2), links = _useState2[0], setLinks = _useState2[1];
    var registerSkipLink = (0, $1oC0p.useCallback)(function(skipLinkData) {
        // Don't add duplicate skip links
        setLinks(function(oldLinks) {
            if (oldLinks.some(function(_ref2) {
                var id = _ref2.id;
                return id === skipLinkData.id;
            })) return oldLinks;
            return [].concat((0, $88fXP.default)(oldLinks), [
                skipLinkData
            ]).sort($0840919b48aeb8a6$var$getByDomOrderSortFunction());
        });
    }, []);
    var unregisterSkipLink = (0, $1oC0p.useCallback)(function(id) {
        setLinks(function(links) {
            return links.filter(function(link) {
                return link.id !== id;
            });
        });
    }, []);
    var contextValue = (0, $1oC0p.useMemo)(function() {
        var data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8Ook3.SkipLinksContext).Provider, {
        value: contextValue
    }, (0, $39c3M.fg)('platform_dst_nav4_skip_links_hydration_fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lNidq.SkipLinksContainer), {
        label: label,
        testId: testId,
        links: links
    }), children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kwO89.SkipLinksDataContext).Provider, {
        value: links
    }, children));
}

});

parcelRegister("gHZRl", function(module, exports) {
$parcel$export(module.exports, "TopNavStartProvider", function () { return $c2a0a57a60c01fb9$export$bc9d0ad0bce43e75; });

var $9DP70 = parcelRequire("9DP70");

var $1oC0p = parcelRequire("1oC0p");

var $5lgNX = parcelRequire("5lgNX");
var $c2a0a57a60c01fb9$export$bc9d0ad0bce43e75 = function TopNavStartProvider(_ref) {
    var children = _ref.children;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $9DP70.default)(_useState, 2), element = _useState2[0], setElement = _useState2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $5lgNX.TopNavStartElement).Provider, {
        value: element
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $5lgNX.TopNavStartAttachRef).Provider, {
        value: setElement
    }, children));
};

});
parcelRegister("5lgNX", function(module, exports) {
$parcel$export(module.exports, "TopNavStartElement", function () { return $3e3bf2faa9867a11$export$e9e5087bd319cc8c; });
$parcel$export(module.exports, "TopNavStartAttachRef", function () { return $3e3bf2faa9867a11$export$55f0a642b785fb1f; });

var $1oC0p = parcelRequire("1oC0p");

var $hshSj = parcelRequire("hshSj");
var $3e3bf2faa9867a11$export$e9e5087bd319cc8c = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $3e3bf2faa9867a11$export$55f0a642b785fb1f = /*#__PURE__*/ (0, $1oC0p.createContext)((0, $hshSj.default));

});


parcelRegister("5xY8f", function(module, exports) {
$parcel$export(module.exports, "DangerouslyHoistSlotSizes", function () { return $409eadc3523f40cf$export$66e2c1a0115af861; });

var $1oC0p = parcelRequire("1oC0p");
var $409eadc3523f40cf$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $1oC0p.createContext)(false);

});

parcelRegister("knkrb", function(module, exports) {
$parcel$export(module.exports, "SideNavElementProvider", function () { return $ed55cf19b30baf28$export$85c1ff84bbf6e6dc; });
$parcel$export(module.exports, "useSideNavRef", function () { return $ed55cf19b30baf28$export$fa4d0cff03b1ea4f; });

var $1oC0p = parcelRequire("1oC0p");
var $ed55cf19b30baf28$var$SideNavRefContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    current: null
});
function $ed55cf19b30baf28$export$85c1ff84bbf6e6dc(_ref) {
    var children = _ref.children;
    var sideNavRef = (0, $1oC0p.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($ed55cf19b30baf28$var$SideNavRefContext.Provider, {
        value: sideNavRef
    }, children);
}
function $ed55cf19b30baf28$export$fa4d0cff03b1ea4f() {
    return (0, $1oC0p.useContext)($ed55cf19b30baf28$var$SideNavRefContext);
}

});

parcelRegister("9hlEa", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonProvider", function () { return $6c167e34fca79697$export$ceb8e60e9790fc0f; });

var $9DP70 = parcelRequire("9DP70");

var $1oC0p = parcelRequire("1oC0p");

var $3EiCz = parcelRequire("3EiCz");
var $6c167e34fca79697$export$ceb8e60e9790fc0f = function SideNavToggleButtonProvider(_ref) {
    var children = _ref.children;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $9DP70.default)(_useState, 2), element = _useState2[0], setElement = _useState2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3EiCz.SideNavToggleButtonElement).Provider, {
        value: element
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3EiCz.SideNavToggleButtonAttachRef).Provider, {
        value: setElement
    }, children));
};

});
parcelRegister("3EiCz", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonElement", function () { return $2a838d439c729943$export$9c1768094bef896; });
$parcel$export(module.exports, "SideNavToggleButtonAttachRef", function () { return $2a838d439c729943$export$fb8fa9a80240785e; });

var $1oC0p = parcelRequire("1oC0p");

var $hshSj = parcelRequire("hshSj");
var $2a838d439c729943$export$9c1768094bef896 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $2a838d439c729943$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $1oC0p.createContext)((0, $hshSj.default));

});


parcelRegister("ELP70", function(module, exports) {
$parcel$export(module.exports, "SideNavVisibilityProvider", function () { return $07a8d54521e92de8$export$aac8e996360f6ad9; });

var $9DP70 = parcelRequire("9DP70");

var $1oC0p = parcelRequire("1oC0p");

var $AKzjw = parcelRequire("AKzjw");
var $07a8d54521e92de8$export$aac8e996360f6ad9 = function SideNavVisibilityProvider(_ref) {
    var children = _ref.children;
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $9DP70.default)(_useState, 2), sideNavState = _useState2[0], setSideNavState = _useState2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $AKzjw.SideNavVisibilityState).Provider, {
        value: sideNavState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $AKzjw.SetSideNavVisibilityState).Provider, {
        value: setSideNavState
    }, children));
};

});
parcelRegister("AKzjw", function(module, exports) {
$parcel$export(module.exports, "SideNavVisibilityState", function () { return $06e77c751b27141d$export$eb04201bb6dd1e4e; });
$parcel$export(module.exports, "SetSideNavVisibilityState", function () { return $06e77c751b27141d$export$f6b496b07d1ea493; });

var $1oC0p = parcelRequire("1oC0p");

var $hshSj = parcelRequire("hshSj");
var $06e77c751b27141d$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $06e77c751b27141d$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $1oC0p.createContext)((0, $hshSj.default));

});



parcelRegister("bWGpg", function(module, exports) {
$parcel$export(module.exports, "SideNav", function () { return $8b26018a7d435a7c$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9jUeC = parcelRequire("9jUeC");

var $363qk = parcelRequire("363qk");

var $9DP70 = parcelRequire("9DP70");

var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");

var $dH1HR = parcelRequire("dH1HR");

var $gUjjH = parcelRequire("gUjjH");

var $64R6j = parcelRequire("64R6j");

var $1QnAr = parcelRequire("1QnAr");
var $6K714 = parcelRequire("6K714");

var $39c3M = parcelRequire("39c3M");

var $kzuyT = parcelRequire("kzuyT");

var $i4LXa = parcelRequire("i4LXa");

var $8Ook3 = parcelRequire("8Ook3");

var $5lgNX = parcelRequire("5lgNX");

var $h6B0m = parcelRequire("h6B0m");

var $5xY8f = parcelRequire("5xY8f");

var $9DxTV = parcelRequire("9DxTV");

var $9Kv5j = parcelRequire("9Kv5j");

var $hvwmI = parcelRequire("hvwmI");

var $3RCjk = parcelRequire("3RCjk");

var $knkrb = parcelRequire("knkrb");

var $9x4wR = parcelRequire("9x4wR");

var $3EiCz = parcelRequire("3EiCz");

var $3a2Xq = parcelRequire("3a2Xq");

var $a8q15 = parcelRequire("a8q15");

var $1hwXT = parcelRequire("1hwXT");

var $5808c = parcelRequire("5808c");

var $AKzjw = parcelRequire("AKzjw");
var $8b26018a7d435a7c$var$panelSplitterResizingVar = '--n_snvRsz';
var $8b26018a7d435a7c$var$widthResizeBounds = {
    min: '240px',
    max: '50vw'
};
function $8b26018a7d435a7c$var$getResizeBounds() {
    return $8b26018a7d435a7c$var$widthResizeBounds;
}
var $8b26018a7d435a7c$var$openLayerObserverSideNavNamespace = 'side-nav';
var $8b26018a7d435a7c$var$styles = {
    root: "_nd5l1b6c _bfhk1bhr _16qs1cd0 _vchhusvi _4t3ieqxy _152timx3 _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _qilnk0mc _4ap3vuon _scbpglyw",
    oldBorder: "_t51zzgxb",
    newBorder: "_191wglyw _t51zglyw _p5clzgxb",
    newBorderFlyoutOpen: "_p5clglyw",
    flyoutOpen: "_qiln1gzg _4ap31bhr _scbp1cd0 _139f8iot _1tpvfnf5 _sylc1a5r _oyeijq3t",
    flyoutAnimateClosed: "_1e0cglyw _qiln1gzg _139f8iot _1tpvfnf5 _sylc1a5r _1uwsjq3t",
    flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
    hiddenMobileAndDesktop: "_1e0cglyw",
    hiddenMobileOnly: "_1e0cglyw _dm2518uv",
    hiddenDesktopOnly: "_dm25glyw"
};
/**
 * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
 * context value.
 */ function $8b26018a7d435a7c$var$SideNavInternal(_ref) {
    var children = _ref.children, defaultCollapsed = _ref.defaultCollapsed, _ref$defaultWidth = _ref.defaultWidth, defaultWidth = _ref$defaultWidth === void 0 ? 320 : _ref$defaultWidth, testId = _ref.testId, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Sidebar' : _ref$label, _ref$skipLinkLabel = _ref.skipLinkLabel, skipLinkLabel = _ref$skipLinkLabel === void 0 ? label : _ref$skipLinkLabel, onExpand = _ref.onExpand, onCollapse = _ref.onCollapse, providedId = _ref.id;
    var id = (0, $9Kv5j.useLayoutId)({
        providedId: providedId
    });
    var expandSideNav = (0, $3a2Xq.useExpandSideNav)();
    /**
   * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
   *
   * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
   */ var synchronouslyExpandSideNav = (0, $1oC0p.useCallback)(function() {
        (0, $gUjjH.flushSync)(function() {
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandSideNav` makes.
       */ expandSideNav();
        });
    }, [
        expandSideNav
    ]);
    (0, $8Ook3.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        onBeforeNavigate: synchronouslyExpandSideNav
    });
    var sideNavState = (0, $1oC0p.useContext)((0, $AKzjw.SideNavVisibilityState));
    var setSideNavState = (0, $1oC0p.useContext)((0, $AKzjw.SetSideNavVisibilityState));
    var _useSideNavVisibility = (0, $a8q15.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    }), isExpandedOnDesktop = _useSideNavVisibility.isExpandedOnDesktop, isExpandedOnMobile = _useSideNavVisibility.isExpandedOnMobile;
    // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    var _useState = (0, $1oC0p.useState)(defaultCollapsed), _useState2 = (0, $9DP70.default)(_useState, 1), initialDefaultCollapsed = _useState2[0];
    var _useState3 = (0, $1oC0p.useState)(defaultWidth), _useState4 = (0, $9DP70.default)(_useState3, 2), width = _useState4[0], setWidth = _useState4[1];
    var clampedWidth = "clamp(".concat($8b26018a7d435a7c$var$widthResizeBounds.min, ", ").concat(width, "px, ").concat($8b26018a7d435a7c$var$widthResizeBounds.max, ")");
    var dangerouslyHoistSlotSizes = (0, $1oC0p.useContext)((0, $5xY8f.DangerouslyHoistSlotSizes));
    var navRef = (0, $1oC0p.useRef)(null);
    /**
   * Used to share the side nav element with the `Panel`,
   * which observes the side nav to determine its maximum width.
   */ var sharedRef = (0, $knkrb.useSideNavRef)();
    var mergedRef = (0, $64R6j.default)([
        navRef,
        sharedRef
    ]);
    var toggleButtonElement = (0, $1oC0p.useContext)((0, $3EiCz.SideNavToggleButtonElement));
    var topNavStartElement = (0, $1oC0p.useContext)((0, $5lgNX.TopNavStartElement));
    var devTimeOnlyAttributes = {};
    var openLayerObserver = (0, $6K714.useOpenLayerObserver)();
    var flyoutStateRef = (0, $1oC0p.useRef)({
        type: 'not-active'
    });
    var isFlyoutVisible = (sideNavState === null || sideNavState === void 0 ? void 0 : sideNavState.flyout) === 'open';
    var updateFlyoutState = (0, $1oC0p.useMemo)(function() {
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState(function(currentState) {
                if ((currentState === null || currentState === void 0 ? void 0 : currentState.desktop) === 'collapsed' && (currentState === null || currentState === void 0 ? void 0 : currentState.flyout) !== 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'open'
                };
                return currentState;
            });
        }
        function close() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState(function(currentState) {
                if ((currentState === null || currentState === void 0 ? void 0 : currentState.desktop) === 'collapsed' && (currentState === null || currentState === void 0 ? void 0 : currentState.flyout) === 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'triggered-animate-close'
                };
                return currentState;
            });
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            }
            // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                var timeout = setTimeout(function() {
                    updateFlyoutState('ready-to-close');
                }, (0, $9x4wR.sideNavFlyoutCloseDelayMs));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort: function abort() {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver.getCount({
                    namespace: $8b26018a7d435a7c$var$openLayerObserverSideNavNamespace
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        openLayerObserver,
        setSideNavState
    ]);
    var toggleVisibility = (0, $5808c.useToggleSideNav)();
    (0, $1oC0p.useEffect)(function() {
        // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        setSideNavState({
            desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
            mobile: 'collapsed',
            flyout: 'closed'
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState
    ]);
    var handleExpand = (0, $1oC0p.useCallback)(function(_ref2) {
        var screen = _ref2.screen;
        onExpand === null || onExpand === void 0 || onExpand({
            screen: screen
        });
        // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState
    ]);
    var handleCollapse = (0, $1oC0p.useCallback)(function(_ref3) {
        var screen = _ref3.screen;
        onCollapse === null || onCollapse === void 0 || onCollapse({
            screen: screen
        });
        // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState
    ]);
    (0, $1hwXT.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile
    });
    (0, $1oC0p.useEffect)(function() {
        var mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $dH1HR.bind)(mediaQueryList, {
            type: 'change',
            listener: function listener() {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibility();
                }
            }
        });
    }, [
        toggleVisibility,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]);
    /**
   * Close the mobile side nav if there is a click outside.
   *
   * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
   * If we listened to window size changes we'd need nested `bind()` calls.
   */ (0, $1oC0p.useEffect)(function() {
        if (!isExpandedOnMobile) return;
        /**
     * The expected URL fragment used by the side nav skip link.
     */ var skipLinkUrlFragment = "#".concat(id);
        return (0, $dH1HR.bind)(window, {
            type: 'click',
            listener: function listener(event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                var sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement !== null && toggleButtonElement !== void 0 && toggleButtonElement.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                if (event.target instanceof HTMLAnchorElement && /**
         * Intentionally using `.getAttribute()` for simplicity to match exactly what we expect
         * for skip links.
         *
         * Alternatives considered:
         *
         * - Using `.href` returns a full URL, which would then require extra parsing.
         * - Using `.hash` could incorrectly capture `<a href="/another-page#skip-link-id>` so we'd need extra checks.
         *
         * This approach has an edge case of `<a href="/same-page#skip-link-id>` not being captured,
         * but we are okay with that trade-off.
         */ event.target.getAttribute('href') === skipLinkUrlFragment) // This was a click on a link to the side nav, so we shouldn't try to collapse the SideNav.
                // It was most likely the skip link, although anyone can render a link with the ID.
                // In either case keeping the SideNav expanded makes sense.
                return;
                toggleVisibility();
            }
        });
    }, [
        id,
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibility
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!toggleButtonElement) return;
        return (0, $dH1HR.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener: function listener() {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                // Only flyout the side nav on desktop viewports
                var _window$matchMedia = window.matchMedia('(min-width: 64rem)'), matches = _window$matchMedia.matches;
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!toggleButtonElement) return;
        return (0, $dH1HR.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener: function listener() {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!navRef.current) return;
        return (0, $dH1HR.bind)(navRef.current, {
            type: 'mouseenter',
            listener: function listener() {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!navRef.current) return;
        return (0, $dH1HR.bind)(navRef.current, {
            type: 'mouseleave',
            listener: function listener() {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $1oC0p.useEffect)(function() {
        var nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
        // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $kzuyT.monitorForElements)({
            canMonitor: function canMonitor(_ref4) {
                var source = _ref4.source;
                return nav.contains(source.element);
            },
            onGenerateDragPreview: function onGenerateDragPreview() {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop: function onDrop(_ref5) {
                var location = _ref5.location;
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished');
                // If the user dropped outside of the flyout, we will close the flyout
                var underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!topNavStartElement || !toggleButtonElement) return;
        return (0, $dH1HR.bind)(topNavStartElement, {
            type: 'mouseover',
            listener: function listener(event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event.target === topNavStartElement) {
                    // The mouse is directly over the TopNavStart element, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                // The user has moused over a child element of the TopNavStart element that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!topNavStartElement) return;
        return (0, $dH1HR.bind)(topNavStartElement, {
            type: 'mouseleave',
            listener: function listener() {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                // The mouse has left the TopNavStart element, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $1oC0p.useEffect)(function() {
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, TopNavStart element)
        return openLayerObserver.onChange(function(_ref6) {
            var count = _ref6.count;
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: $8b26018a7d435a7c$var$openLayerObserverSideNavNamespace
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $1oC0p.useEffect)(function() {
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    var visible;
    (0, $3RCjk.useResizingWidthCssVarOnRootElement)({
        isEnabled: true,
        cssVar: $8b26018a7d435a7c$var$panelSplitterResizingVar,
        panelId: (0, $h6B0m.sideNavPanelSplitterId)
    });
    return /*#__PURE__*/ $1oC0p.createElement("nav", (0, $9jUeC.default)({
        id: id
    }, devTimeOnlyAttributes, {
        "data-layout-slot": true,
        "aria-label": label,
        style: (0, $363qk.default)({}, (0, $h6B0m.sideNavVar), clampedWidth),
        ref: mergedRef,
        "data-testid": testId,
        className: (0, $iiT5o.default)([
            $8b26018a7d435a7c$var$styles.root,
            (0, $39c3M.fg)('platform_design_system_nav4_sidenav_border') ? $8b26018a7d435a7c$var$styles.newBorder : $8b26018a7d435a7c$var$styles.oldBorder,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $8b26018a7d435a7c$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $8b26018a7d435a7c$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $8b26018a7d435a7c$var$styles.hiddenMobileAndDesktop,
            (sideNavState === null || sideNavState === void 0 ? void 0 : sideNavState.flyout) === 'open' && $8b26018a7d435a7c$var$styles.flyoutOpen,
            (sideNavState === null || sideNavState === void 0 ? void 0 : sideNavState.flyout) === 'open' && (0, $39c3M.fg)('platform_design_system_nav4_sidenav_border') && $8b26018a7d435a7c$var$styles.newBorderFlyoutOpen,
            (sideNavState === null || sideNavState === void 0 ? void 0 : sideNavState.flyout) === 'triggered-animate-close' && $8b26018a7d435a7c$var$styles.flyoutAnimateClosed
        ])
    }), /*#__PURE__*/ $1oC0p.createElement((0, $9DxTV.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $h6B0m.sideNavLiveWidthVar),
        value: "0px",
        mediaQuery: (0, $i4LXa.media).above.md,
        responsiveValue: isExpandedOnDesktop ? "var(".concat($8b26018a7d435a7c$var$panelSplitterResizingVar, ", ").concat(clampedWidth, ")") : 0
    }), dangerouslyHoistSlotSizes && /*#__PURE__*/ // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    $1oC0p.createElement((0, $9DxTV.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $h6B0m.UNSAFE_sideNavLayoutVar),
        value: "var(".concat((0, $h6B0m.sideNavLiveWidthVar), ")")
    }), /*#__PURE__*/ $1oC0p.createElement((0, $hvwmI.PanelSplitterProvider), {
        panelId: (0, $h6B0m.sideNavPanelSplitterId),
        panelRef: navRef,
        panelWidth: width,
        onCompleteResize: setWidth,
        getResizeBounds: $8b26018a7d435a7c$var$getResizeBounds,
        resizingCssVar: $8b26018a7d435a7c$var$panelSplitterResizingVar,
        isEnabled: isExpandedOnDesktop && !isFlyoutVisible
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $iiT5o.default)([
            $8b26018a7d435a7c$var$styles.flexContainer
        ])
    }, children)));
}
function $8b26018a7d435a7c$export$1a35787d6353cf6a(_ref8) {
    var children = _ref8.children, defaultCollapsed = _ref8.defaultCollapsed, _ref8$defaultWidth = _ref8.defaultWidth, defaultWidth = _ref8$defaultWidth === void 0 ? 320 : _ref8$defaultWidth, testId = _ref8.testId, label = _ref8.label, _ref8$skipLinkLabel = _ref8.skipLinkLabel, skipLinkLabel = _ref8$skipLinkLabel === void 0 ? label : _ref8$skipLinkLabel, onExpand = _ref8.onExpand, onCollapse = _ref8.onCollapse, id = _ref8.id;
    return /*#__PURE__*/ $1oC0p.createElement((0, $1QnAr.OpenLayerObserverNamespaceProvider), {
        namespace: $8b26018a7d435a7c$var$openLayerObserverSideNavNamespace
    }, /*#__PURE__*/ $1oC0p.createElement($8b26018a7d435a7c$var$SideNavInternal, {
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        testId: testId,
        label: label,
        skipLinkLabel: skipLinkLabel,
        onExpand: onExpand,
        onCollapse: onCollapse,
        id: id
    }, children));
}

});
parcelRegister("1QnAr", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceProvider", function () { return $157cf19fdd16faf3$export$327d0d2a7ae6f7cc; });

var $1oC0p = parcelRequire("1oC0p");

var $lmxXn = parcelRequire("lmxXn");

var $cirPy = parcelRequire("cirPy");

var $25QEh = parcelRequire("25QEh");
function $157cf19fdd16faf3$export$327d0d2a7ae6f7cc(_ref) {
    var children = _ref.children, namespace = _ref.namespace;
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    var parentContext = (0, $25QEh.useOpenLayerObserverNamespace)();
    (0, $1oC0p.useEffect)(function() {
        (0, $lmxXn.default)(parentContext === null, "An OpenLayerObserver namespace already exists in this component tree: ".concat(parentContext, ". Nesting OpenLayerObserverNamespaceProvider is not supported."));
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cirPy.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace
    }, children);
}

});

parcelRegister("6K714", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserver", function () { return $4e8c7b36c14095b5$export$750f5b0d6c51617e; });

var $1oC0p = parcelRequire("1oC0p");

var $lmxXn = parcelRequire("lmxXn");

var $9psBv = parcelRequire("9psBv");
function $4e8c7b36c14095b5$export$750f5b0d6c51617e() {
    var context = (0, $1oC0p.useContext)((0, $9psBv.OpenLayerObserverContext));
    (0, $lmxXn.default)(context, 'useOpenLayerObserver must be used within an OpenLayerObserver');
    var publicAPI = (0, $1oC0p.useMemo)(function() {
        return {
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        };
    }, [
        context.getCount,
        context.onChange,
        context.closeLayers
    ]);
    return publicAPI;
}

});

parcelRegister("i4LXa", function(module, exports) {
$parcel$export(module.exports, "media", function () { return $d28dcc443d2005bd$export$987d49ffe1b0900f; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $d28dcc443d2005bd$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
var $d28dcc443d2005bd$export$c881183ca713c214 = $d28dcc443d2005bd$export$987d49ffe1b0900f;

});

parcelRegister("h6B0m", function(module, exports) {
$parcel$export(module.exports, "sideNavVar", function () { return $c73fb3974eb87693$export$951bf5156e86d974; });
$parcel$export(module.exports, "panelVar", function () { return $c73fb3974eb87693$export$db0c2e1d744fb281; });
$parcel$export(module.exports, "topNavMountedVar", function () { return $c73fb3974eb87693$export$60ef3a7b1ed42328; });
$parcel$export(module.exports, "sideNavLiveWidthVar", function () { return $c73fb3974eb87693$export$1216dacffd1e9e65; });
$parcel$export(module.exports, "sideNavPanelSplitterId", function () { return $c73fb3974eb87693$export$5db28b16b6e686bc; });
$parcel$export(module.exports, "panelPanelSplitterId", function () { return $c73fb3974eb87693$export$3452dcb65711af44; });
$parcel$export(module.exports, "UNSAFE_topNavVar", function () { return $c73fb3974eb87693$export$855f5a09f5c99ac; });
$parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", function () { return $c73fb3974eb87693$export$6bfc931a04ec5741; });
$parcel$export(module.exports, "UNSAFE_panelLayoutVar", function () { return $c73fb3974eb87693$export$753bf7651b25db91; });
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
var $c73fb3974eb87693$export$951bf5156e86d974 = '--n_sNvw';
var $c73fb3974eb87693$export$594e6a30db7c057e = '--n_asDw';
var $c73fb3974eb87693$export$db0c2e1d744fb281 = '--n_pnlW';
var $c73fb3974eb87693$export$515a0b1baafe906c = '--n_bnrM';
var $c73fb3974eb87693$export$60ef3a7b1ed42328 = '--n_tNvM';
var $c73fb3974eb87693$export$1216dacffd1e9e65 = '--n_sNvlw';
var $c73fb3974eb87693$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
var $c73fb3974eb87693$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
var $c73fb3974eb87693$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
var $c73fb3974eb87693$export$2874e68531ce3163 = "calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))";
var $c73fb3974eb87693$export$bfabd8c2c572ad29 = "calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))";
var $c73fb3974eb87693$export$855f5a09f5c99ac = '--topNavigationHeight';
var $c73fb3974eb87693$export$26354f9814213292 = '--bannerHeight';
var $c73fb3974eb87693$export$6bfc931a04ec5741 = '--leftSidebarWidth';
var $c73fb3974eb87693$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
var $c73fb3974eb87693$export$753bf7651b25db91 = '--rightPanelWidth';
var $c73fb3974eb87693$export$6460bd6a2446260 = "calc(var(".concat($c73fb3974eb87693$export$26354f9814213292, ", 0px) + var(").concat($c73fb3974eb87693$export$855f5a09f5c99ac, ", 0px))");
var $c73fb3974eb87693$export$3055529fab2b4edf = "var(".concat($c73fb3974eb87693$export$6bfc931a04ec5741, ", 0px)");
var $c73fb3974eb87693$export$166d8fd766c3eb92 = "calc(var(".concat($c73fb3974eb87693$export$bbbace2ff0c7ae1b, ", 0px) + var(").concat($c73fb3974eb87693$export$753bf7651b25db91, ", 0px))");
var $c73fb3974eb87693$export$61156ceb1a99f6a0 = {
    topBar: 4,
    banner: 4,
    sideNav: 2,
    panelSmallViewports: 1
};

});

parcelRegister("9DxTV", function(module, exports) {
$parcel$export(module.exports, "HoistCssVarToLocalGrid", function () { return $70420d9ca0b140f4$export$cfa3cd08d675e56e; });
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", function () { return $70420d9ca0b140f4$export$9f45a1325e3cdfb8; });

var $1oC0p = parcelRequire("1oC0p");

var $gvKqR = parcelRequire("gvKqR");
var $70420d9ca0b140f4$export$cfa3cd08d675e56e = function HoistCssVarToLocalGrid(_ref) {
    var variableName = _ref.variableName, value = _ref.value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("style", null, "#".concat((0, $gvKqR.gridRootId), " { ").concat(variableName, ": ").concat(value, "px }"));
};
var $70420d9ca0b140f4$var$getCssStringValue = function getCssStringValue(value) {
    return typeof value === 'number' ? "".concat(value, "px") : value;
};
var $70420d9ca0b140f4$export$9f45a1325e3cdfb8 = function DangerouslyHoistCssVarToDocumentRoot(_ref2) {
    var variableName = _ref2.variableName, value = _ref2.value, mediaQuery = _ref2.mediaQuery, responsiveValue = _ref2.responsiveValue;
    /**
   * Note don't put multiple variables in multiple lines. eg
   * <style>
   *   {css1}
   *   {css2}
   * </style>
   *
   * React will insert an empty HTML comment in between the text in SSR.
   * This is not a valid tag and will break the page.
   * <style>foo<!-- -->bar</style>
   */ var style = ":root { ".concat(variableName, ": ").concat($70420d9ca0b140f4$var$getCssStringValue(value), " }");
    if (mediaQuery && responsiveValue) style += " ".concat(mediaQuery, " { :root { ").concat(variableName, ": ").concat($70420d9ca0b140f4$var$getCssStringValue(responsiveValue), " } }");
    return(/*#__PURE__*/ // Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("style", null, style));
};

});

parcelRegister("hvwmI", function(module, exports) {
$parcel$export(module.exports, "PanelSplitterProvider", function () { return $cbee6ffc53623f3a$export$f662bfb764348932; });

var $1oC0p = parcelRequire("1oC0p");

var $lWzs7 = parcelRequire("lWzs7");
var $cbee6ffc53623f3a$export$f662bfb764348932 = function PanelSplitterProvider(_ref) {
    var panelId = _ref.panelId, panelWidth = _ref.panelWidth, onCompleteResize = _ref.onCompleteResize, getResizeBounds = _ref.getResizeBounds, resizingCssVar = _ref.resizingCssVar, panelRef = _ref.panelRef, _ref$position = _ref.position, position = _ref$position === void 0 ? 'end' : _ref$position, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, children = _ref.children;
    var portalRef = (0, $1oC0p.useRef)(null);
    var context = (0, $1oC0p.useMemo)(function() {
        return {
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled,
            portalRef: portalRef
        };
    }, [
        panelId,
        panelWidth,
        onCompleteResize,
        getResizeBounds,
        resizingCssVar,
        position,
        portalRef,
        panelRef,
        isEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lWzs7.PanelSplitterContext).Provider, {
        value: context
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        ref: portalRef
    }));
};

});
parcelRegister("lWzs7", function(module, exports) {
$parcel$export(module.exports, "PanelSplitterContext", function () { return $ff9a83e9658afd35$export$7a4054f2c546f2cd; });

var $1oC0p = parcelRequire("1oC0p");
var $ff9a83e9658afd35$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});


parcelRegister("3RCjk", function(module, exports) {
$parcel$export(module.exports, "useResizingWidthCssVarOnRootElement", function () { return $2d040a0a70d3b0e4$export$d4931ecf0fbcc8fc; });

var $1oC0p = parcelRequire("1oC0p");

var $2OL6m = parcelRequire("2OL6m");

var $kzuyT = parcelRequire("kzuyT");

var $hVcGV = parcelRequire("hVcGV");
function $2d040a0a70d3b0e4$export$d4931ecf0fbcc8fc(_ref) {
    var _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, cssVar = _ref.cssVar, panelId = _ref.panelId;
    (0, $1oC0p.useEffect)(function() {
        if (!isEnabled) return;
        return (0, $2OL6m.combine)((0, $kzuyT.monitorForElements)({
            canMonitor: function canMonitor(_ref2) {
                var source = _ref2.source;
                return source.data.panelId === panelId;
            },
            onDrag: function onDrag(_ref3) {
                var source = _ref3.source;
                if (!(0, $hVcGV.isPanelSplitterDragData)(source.data)) return;
                /**
         * Copies the resizing width value to the `<html>` element.
         *
         * Required to reflect the live width of the side navigation.
         *
         * Used by:
         *   - Legacy `--leftSidebarWidth` variable
         *   - Panel slot max-width constraint
         *
         * When the legacy `--leftSidebarWidth` variable is no longer needed,
         * we could consider writing to the `Panel` element instead.
         */ document.documentElement.style.setProperty(cssVar, source.data.resizingWidth);
            },
            onDrop: function onDrop() {
                document.documentElement.style.removeProperty(cssVar);
            }
        }));
    }, [
        cssVar,
        isEnabled,
        panelId
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!isEnabled) return;
        /**
     * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
     * if the component unmounts during a drag.
     */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty(cssVar);
        };
    }, [
        cssVar,
        isEnabled
    ]);
}

});
parcelRegister("hVcGV", function(module, exports) {
$parcel$export(module.exports, "isPanelSplitterDragData", function () { return $d0c19ac471944442$export$e239b3966b677000; });
/* panel-splitter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9DP70 = parcelRequire("9DP70");

var $363qk = parcelRequire("363qk");

var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");

var $dH1HR = parcelRequire("dH1HR");

var $gUjjH = parcelRequire("gUjjH");

var $lmxXn = parcelRequire("lmxXn");

var $edmmv = parcelRequire("edmmv");

var $lGCES = parcelRequire("lGCES");

var $6K714 = parcelRequire("6K714");

var $2OL6m = parcelRequire("2OL6m");

var $kzuyT = parcelRequire("kzuyT");
parcelRequire("2yNd7");
var $3c2AU = parcelRequire("3c2AU");

var $2hDsc = parcelRequire("2hDsc");

var $lC6ee = parcelRequire("lC6ee");

var $8eZqB = parcelRequire("8eZqB");

var $lWzs7 = parcelRequire("lWzs7");

var $hIxLQ = parcelRequire("hIxLQ");

var $c3PH2 = parcelRequire("c3PH2");

var $4Ikok = parcelRequire("4Ikok");

var $cgimf = parcelRequire("cgimf");
function $d0c19ac471944442$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d0c19ac471944442$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d0c19ac471944442$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $363qk.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d0c19ac471944442$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d0c19ac471944442$var$containerStyles = {
    root: "_12ji1r31 _1qu2glyw _12y31o36 _1e0cglyw _kqswstnw _u7coidpf _152tidpf _1pbykb7n _181n1ule",
    positionEnd: "_rjxpftgi",
    positionStart: "_1e02zeo2"
};
var $d0c19ac471944442$var$grabAreaStyles = {
    root: "_1bsbl52n _4t3i1osq _kqswstnw _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz1j28 _bfhk1j28 _k8m01ylx _1oec1yx9 _1lww5cps _d0aluf7j _1gavfnf5 _vp7gaqb7 _30l3aqb7 _1dr21ylx _1s5z1ylx _1cg4fnf5 _le1bfnf5 _1gglglyw _9h8h16c2"
};
var $d0c19ac471944442$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsbjfq9 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
};
var $d0c19ac471944442$var$panelSplitterDragDataSymbol = Symbol('panel-splitter-drag-data');
function $d0c19ac471944442$var$signPanelSplitterDragData(data) {
    return $d0c19ac471944442$var$_objectSpread($d0c19ac471944442$var$_objectSpread({}, data), {}, (0, $363qk.default)({}, $d0c19ac471944442$var$panelSplitterDragDataSymbol, true));
}
function $d0c19ac471944442$export$e239b3966b677000(data) {
    return data[$d0c19ac471944442$var$panelSplitterDragDataSymbol] === true;
}
function $d0c19ac471944442$var$getTextDirection(element) {
    var _window$getComputedSt = window.getComputedStyle(element), direction = _window$getComputedSt.direction;
    return direction === 'rtl' ? 'rtl' : 'ltr';
}
var $d0c19ac471944442$var$PortaledPanelSplitter = function PortaledPanelSplitter(_ref) {
    var label = _ref.label, onResizeStart = _ref.onResizeStart, onResizeEnd = _ref.onResizeEnd, testId = _ref.testId, panelId = _ref.panelId, panelWidth = _ref.panelWidth, onCompleteResize = _ref.onCompleteResize, getResizeBounds = _ref.getResizeBounds, panel = _ref.panel, portal = _ref.portal, resizingCssVar = _ref.resizingCssVar, position = _ref.position;
    var splitterRef = (0, $1oC0p.useRef)(null);
    var labelId = (0, $edmmv.useId)();
    // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    var _useState = (0, $1oC0p.useState)(panelWidth), _useState2 = (0, $9DP70.default)(_useState, 2), rangeInputValue = _useState2[0], setRangeInputValue = _useState2[1];
    /**
   * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
   * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
   * when the user tries to resize using the keyboard.
   */ var _useState3 = (0, $1oC0p.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    }), _useState4 = (0, $9DP70.default)(_useState3, 2), rangeInputBounds = _useState4[0], setRangeInputBounds = _useState4[1];
    var openLayerObserver = (0, $6K714.useOpenLayerObserver)();
    (0, $1oC0p.useEffect)(function() {
        var splitter = splitterRef.current;
        (0, $lmxXn.default)(splitter, 'Splitter ref must be set');
        return (0, $2OL6m.combine)((0, $3c2AU.blockDraggingToIFrames)({
            element: splitter
        }), (0, $kzuyT.draggable)({
            element: splitter,
            onGenerateDragPreview: function onGenerateDragPreview(_ref2) {
                var nativeSetDragImage = _ref2.nativeSetDragImage;
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $2hDsc.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $lC6ee.preventUnhandled).start();
            },
            getInitialData: function getInitialData() {
                var initialWidth = (0, $4Ikok.getPixelWidth)(panel);
                /**
         * The drag calculations require the actual computed width of the element
         * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
         * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
         */ return $d0c19ac471944442$var$signPanelSplitterDragData({
                    panelId: panelId,
                    initialWidth: initialWidth,
                    resizingWidth: "".concat(initialWidth, "px"),
                    resizeBounds: getResizeBounds(),
                    // Only computing text direction when we need it, just as the drag is starting.
                    // Recomputing text direction on each new drag in case the text direction
                    // has changed. This is unlikely, but being safe.
                    direction: $d0c19ac471944442$var$getTextDirection(panel)
                });
            },
            onDragStart: function onDragStart(_ref3) {
                var source = _ref3.source;
                (0, $lmxXn.default)($d0c19ac471944442$export$e239b3966b677000(source.data));
                onResizeStart === null || onResizeStart === void 0 || onResizeStart({
                    initialWidth: source.data.initialWidth
                });
                // Close any open layers when the user starts resizing
                openLayerObserver === null || openLayerObserver === void 0 || openLayerObserver.closeLayers();
            },
            onDrag: function onDrag(_ref4) {
                var location = _ref4.location, source = _ref4.source;
                (0, $lmxXn.default)($d0c19ac471944442$export$e239b3966b677000(source.data));
                var _source$data = source.data, initialWidth = _source$data.initialWidth, resizeBounds = _source$data.resizeBounds, direction = _source$data.direction;
                /**
         * How wide the element would be if there were no width constraints,
         * based on the pointer's position.
         */ var targetWidth = (0, $4Ikok.getWidthFromDragLocation)({
                    initialWidth: initialWidth,
                    location: location,
                    direction: direction,
                    position: position
                });
                var resizingWidth = "clamp(".concat(resizeBounds.min, ", ").concat(targetWidth, "px, ").concat(resizeBounds.max, ")");
                panel.style.setProperty(resizingCssVar, resizingWidth);
                source.data.resizingWidth = resizingWidth;
            },
            onDrop: function onDrop(_ref5) {
                var source = _ref5.source;
                (0, $lmxXn.default)($d0c19ac471944442$export$e239b3966b677000(source.data));
                (0, $lC6ee.preventUnhandled).stop();
                (0, $lmxXn.default)($d0c19ac471944442$export$e239b3966b677000(source.data));
                var finalWidth = (0, $4Ikok.getPixelWidth)(panel);
                onCompleteResize(finalWidth);
                onResizeEnd === null || onResizeEnd === void 0 || onResizeEnd({
                    initialWidth: source.data.initialWidth,
                    finalWidth: finalWidth
                });
                panel.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStart,
        onResizeEnd,
        panel,
        resizingCssVar,
        panelWidth,
        position,
        openLayerObserver,
        panelId,
        getResizeBounds
    ]);
    var onResizeStartStableRef = (0, $lGCES.default)(onResizeStart);
    var onResizeEndStableRef = (0, $lGCES.default)(onResizeEnd);
    var _useState5 = (0, $1oC0p.useState)(function() {
        return (0, $cgimf.createKeyboardResizeManager)({
            onResizeStart: function onResizeStart() {
                var _onResizeStartStableR;
                // Close any open layers when the user starts resizing with keyboard
                openLayerObserver === null || openLayerObserver === void 0 || openLayerObserver.closeLayers();
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                (_onResizeStartStableR = onResizeStartStableRef.current) === null || _onResizeStartStableR === void 0 || _onResizeStartStableR.call.apply(_onResizeStartStableR, [
                    onResizeStartStableRef
                ].concat(args));
            },
            onResizeEnd: function onResizeEnd() {
                var _onResizeEndStableRef;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return (_onResizeEndStableRef = onResizeEndStableRef.current) === null || _onResizeEndStableRef === void 0 ? void 0 : _onResizeEndStableRef.call.apply(_onResizeEndStableRef, [
                    onResizeEndStableRef
                ].concat(args));
            }
        });
    }), _useState6 = (0, $9DP70.default)(_useState5, 1), keyboardResizeManager = _useState6[0];
    var handleSliderInputChange = (0, $1oC0p.useCallback)(function(event) {
        var value = parseInt(event.target.value);
        setRangeInputValue(value);
        /**
     * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
     * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
     */ onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        onCompleteResize,
        panelWidth,
        keyboardResizeManager
    ]);
    var resizeEventListenerCleanupFn = (0, $1oC0p.useRef)(null);
    var handleSliderFocus = (0, $1oC0p.useCallback)(function() {
        var _resizeEventListenerC;
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        (_resizeEventListenerC = resizeEventListenerCleanupFn.current) === null || _resizeEventListenerC === void 0 || _resizeEventListenerC.call(resizeEventListenerCleanupFn);
        // Update the range input value to match the current panel width.
        setRangeInputValue(panelWidth);
        var resizeBounds = getResizeBounds();
        // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $hIxLQ.convertResizeBoundToPixels)(resizeBounds.min),
            max: (0, $hIxLQ.convertResizeBoundToPixels)(resizeBounds.max)
        });
        /**
     * _While the slider element is focused_, add a window resize event listener to update the range input bounds
     * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
     * size - in case they are provided in vw units.
     *
     * This listener is cleaned up when the element is blurred.
     */ resizeEventListenerCleanupFn.current = (0, $dH1HR.bind)(window, {
            type: 'resize',
            listener: function updateState() {
                var resizeBounds = getResizeBounds();
                setRangeInputBounds({
                    min: (0, $hIxLQ.convertResizeBoundToPixels)(resizeBounds.min),
                    max: (0, $hIxLQ.convertResizeBoundToPixels)(resizeBounds.max)
                });
            }
        });
    }, [
        panelWidth,
        getResizeBounds
    ]);
    var handleSliderBlur = (0, $1oC0p.useCallback)(function() {
        var _resizeEventListenerC2;
        // Remove the resize event listener when the range input is blurred.
        (_resizeEventListenerC2 = resizeEventListenerCleanupFn.current) === null || _resizeEventListenerC2 === void 0 || _resizeEventListenerC2.call(resizeEventListenerCleanupFn);
    }, []);
    (0, $1oC0p.useEffect)(function() {
        return function cleanup() {
            var _resizeEventListenerC3;
            // Cleanup the resize event listener when the component is unmounted.
            (_resizeEventListenerC3 = resizeEventListenerCleanupFn.current) === null || _resizeEventListenerC3 === void 0 || _resizeEventListenerC3.call(resizeEventListenerCleanupFn);
        };
    }, []);
    var ariaValueText = (0, $1oC0p.useMemo)(function() {
        return "".concat((0, $c3PH2.getPercentageWithinPixelBounds)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        }), "% width");
    }, [
        rangeInputValue,
        rangeInputBounds
    ]);
    return /*#__PURE__*/ (0, $gUjjH.createPortal)(/*#__PURE__*/ $1oC0p.createElement("div", {
        "data-testid": testId ? "".concat(testId, "-container") : undefined,
        className: (0, $iiT5o.default)([
            $d0c19ac471944442$var$containerStyles.root,
            position === 'start' && $d0c19ac471944442$var$containerStyles.positionStart,
            position === 'end' && $d0c19ac471944442$var$containerStyles.positionEnd
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        ref: splitterRef,
        "data-testid": testId,
        className: (0, $iiT5o.default)([
            $d0c19ac471944442$var$grabAreaStyles.root
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $8eZqB.default), null, /*#__PURE__*/ $1oC0p.createElement("input", {
        type: "range",
        value: rangeInputValue,
        step: 20,
        min: rangeInputBounds.min,
        max: rangeInputBounds.max,
        "aria-valuetext": ariaValueText,
        "aria-labelledby": labelId,
        onChange: handleSliderInputChange,
        onFocus: handleSliderFocus,
        onBlur: handleSliderBlur
    }), /*#__PURE__*/ $1oC0p.createElement("span", {
        id: labelId
    }, label)), /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $iiT5o.default)([
            $d0c19ac471944442$var$lineStyles.root
        ])
    }))), portal);
};
var $d0c19ac471944442$export$db67e3f8d3d6da0f = function PanelSplitter(_ref6) {
    var label = _ref6.label, onResizeStart = _ref6.onResizeStart, onResizeEnd = _ref6.onResizeEnd, testId = _ref6.testId;
    var _useState7 = (0, $1oC0p.useState)(null), _useState8 = (0, $9DP70.default)(_useState7, 2), panel = _useState8[0], setPanel = _useState8[1];
    var _useState9 = (0, $1oC0p.useState)(null), _useState0 = (0, $9DP70.default)(_useState9, 2), portal = _useState0[0], setPortal = _useState0[1];
    var context = (0, $1oC0p.useContext)((0, $lWzs7.PanelSplitterContext));
    (0, $lmxXn.default)(context, 'Panel splitter context not set');
    var panelRef = context.panelRef, portalRef = context.portalRef, isEnabled = context.isEnabled, panelId = context.panelId, panelWidth = context.panelWidth, onCompleteResize = context.onCompleteResize, getResizeBounds = context.getResizeBounds, resizingCssVar = context.resizingCssVar, position = context.position;
    /**
   * **Explanation**
   *
   * _How React Suspense works_
   *
   * When a component is suspended:
   *
   * - it is _not_ "unmounted" and effects are _not_ cleaned up
   * - refs to react managed elements are cleared
   * - react adds `display:none !important` as an inline style to hide the element
   * - state is preserved
   *
   * When a suspended component is resumed:
   * - `display:none !important` inline style is removed
   * - it will re-render (without the refs set)
   * - refs will be set
   * - `useEffect` will _not_ re-run
   *
   * [More details](https://x.com/alexandereardon/status/1944617494569992440)
   *
   * _What does this mean for the panel splitter?_
   *
   * - The panel splitter renders into content into a react managed element (eg managed by Aside)
   * - When UI is suspended the portal ref is cleared
   * - After a suspense, we will get a render with cleared refs
   * - 🔥 This is problematic if we want to portal into that ref during the render
   *
   * _Approach: initial render_
   *
   * - We cannot portal the panel splitter until after the refs are initially set
   * - Effects run after refs being set. In an effect we set the ref values (which are populated),
   *   trigger a re-render and then portal into the refs.
   *
   * _Approach: suspense_
   *
   * - We put the refs into react `state` after every render
   * - The refs in `state` will not be cleared by suspending as effects are not run, or cleaned up,
   *   when components are suspended / resumed.
   * - After the post suspense render, we can use the `portalRef` (which was captured in an effect)
   *   to continue to portal into.
   *
   * _Why not store `portalRef` in `state` in `<PanelSplitterProvider>`?_
   *
   * - The `portalRef` is set high in the tree, so a re-render will cause a
   *   large amount of components to re-render (eg the whole sidebar)
   * - After a suspense, we would need to do _another_ large re-render to propagate the new refs
   * - With our current approach, any changes to `portalRef` will cause a re-render low in the tree
   *   (just in the `<PanelSplitter>`)
   */ // We want this effect to run after each render (see above)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $1oC0p.useEffect)(function() {
        // Don't need to do anything
        if (!isEnabled) return;
        // It is safe to access refs in useEffect, even with Suspense
        var panelEl = panelRef.current;
        var portalEl = portalRef.current;
        (0, $lmxXn.default)(panelEl, 'panelRef not set');
        (0, $lmxXn.default)(portalEl, 'portal element not set');
        // Doing our own check, as this results in fewer re-renders than react
        // (which also does it's own checks to see if a re-render should occur)
        if (panelEl === panel && portalEl === portal) return;
        // If refs don't change, react won't cause infinite loops
        setPanel(panelEl);
        setPortal(portalEl);
    });
    if (!isEnabled) return null;
    if (!portal || !panel) return null;
    return /*#__PURE__*/ $1oC0p.createElement($d0c19ac471944442$var$PortaledPanelSplitter, {
        label: label,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        testId: testId,
        panelId: panelId,
        panel: panel,
        portal: portal,
        panelWidth: panelWidth,
        onCompleteResize: onCompleteResize,
        getResizeBounds: getResizeBounds,
        resizingCssVar: resizingCssVar,
        position: position
    });
};

});
parcelRegister("2yNd7", function(module, exports) {
$parcel$export(module.exports, "blockDraggingToIFrames", function () { return (parcelRequire("3c2AU")).blockDraggingToIFrames; });

var $3c2AU = parcelRequire("3c2AU");

});
parcelRegister("3c2AU", function(module, exports) {
$parcel$export(module.exports, "blockDraggingToIFrames", function () { return $2534813c92bcd431$export$6ae1d8fab001518c; });

var $hs2By = parcelRequire("hs2By");

var $fxPVd = parcelRequire("fxPVd");

var $jrlIh = parcelRequire("jrlIh");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $2534813c92bcd431$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? '' : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
var $2534813c92bcd431$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $2534813c92bcd431$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($2534813c92bcd431$var$isActive) return;
    $2534813c92bcd431$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    var iframeCleanups = Array.from(document.querySelectorAll('iframe')).map(function(iframe) {
        return $2534813c92bcd431$var$setStyle(iframe, {
            property: 'pointer-events',
            rule: 'none',
            priority: 'important'
        });
    });
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    var cleanup = (0, $jrlIh.combine).apply(void 0, (0, $hs2By.default)(iframeCleanups).concat([
        // We only need this monitor for listening to the drop
        // as our monitor in `blockDraggingToIFrames()` will only
        // call this function when the drag has started
        (0, $fxPVd.monitorForElements)({
            onDrop: function onDrop() {
                cleanup();
            }
        }),
        function release() {
            $2534813c92bcd431$var$isActive = false;
        }
    ]));
}
function $2534813c92bcd431$export$6ae1d8fab001518c(_ref2) {
    var element = _ref2.element;
    return (0, $fxPVd.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview(_ref3) {
            var source = _ref3.source;
            // only starting if we are dragging the provided element
            if (source.element === element) $2534813c92bcd431$var$tryStart();
        }
    });
}

});


parcelRegister("hIxLQ", function(module, exports) {
$parcel$export(module.exports, "convertResizeBoundToPixels", function () { return $ce60bde53fd0b1d9$export$3d412b3011b66f82; });
/**
 * Resize bounds can either be provided in `vw` or `px` units. This function will convert the value into pixels.
 *
 * It accesses the `window` object to get the viewport width, so should only be used in the browser.
 */ function $ce60bde53fd0b1d9$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith('vw')) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        var maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}

});

parcelRegister("c3PH2", function(module, exports) {
$parcel$export(module.exports, "getPercentageWithinPixelBounds", function () { return $8c7ddd0443f7f788$export$b5423678cdf09f5; });
/**
 * Returns the percentage of the current width within the resize bounds.
 * It expects the resize bounds to already have been converted into numeric values, in pixel units.
 *
 * The return value is clamped between 0 and 100. This is to prevent the screen reader text (aria-valuetext)
 * from announcing an out-of-bounds percentage when the user is resizing the viewport.
 *
 * Examples:
 * - if the current width is 200px, and the resize bounds are 100px and 300px,
 * the percentage is 50%, and the function will return the number 50.
 * - if the current value is 400, and the resize bounds are 100 and 300, the
 * "percentage" is 100% and the function will return the number 100.
 */ function $8c7ddd0443f7f788$export$b5423678cdf09f5(_ref) {
    var currentWidth = _ref.currentWidth, resizeBounds = _ref.resizeBounds;
    var resizeRange = resizeBounds.max - resizeBounds.min;
    var widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("4Ikok", function(module, exports) {
$parcel$export(module.exports, "getWidthFromDragLocation", function () { return $36eb16cf2752a26a$export$e360234971cb95b8; });
$parcel$export(module.exports, "getPixelWidth", function () { return $36eb16cf2752a26a$export$d942790ad00c41f9; });
var $36eb16cf2752a26a$export$e360234971cb95b8 = function getWidthFromDragLocation(_ref) {
    var initialWidth = _ref.initialWidth, location = _ref.location, direction = _ref.direction, position = _ref.position;
    var diffX = location.current.input.clientX - location.initial.input.clientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};
var $36eb16cf2752a26a$export$d942790ad00c41f9 = function getPixelWidth(element) {
    var _window$getComputedSt = window.getComputedStyle(element), width = _window$getComputedSt.width;
    return parseInt(width);
};

});

parcelRegister("cgimf", function(module, exports) {
$parcel$export(module.exports, "createKeyboardResizeManager", function () { return $8ed538297961ec40$export$f7d3d5dae65f74aa; });
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ var $8ed538297961ec40$var$resizeCallbackDebounceTimeMs = 500;
function $8ed538297961ec40$export$f7d3d5dae65f74aa(_ref) {
    var onResizeStart = _ref.onResizeStart, onResizeEnd = _ref.onResizeEnd;
    var resizingState = {
        type: 'idle'
    };
    /**
   * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
   */ function startResizeEndTimer(_ref2) {
        var initialWidth = _ref2.initialWidth, finalWidth = _ref2.finalWidth;
        var markResizeAsEndedTimeout = setTimeout(function() {
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: 'idle'
            };
        }, $8ed538297961ec40$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: initialWidth,
            abort: function abort() {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize(_ref3) {
        var initialWidth = _ref3.initialWidth, finalWidth = _ref3.finalWidth;
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}

});



parcelRegister("9x4wR", function(module, exports) {
$parcel$export(module.exports, "sideNavFlyoutCloseDelayMs", function () { return $6f0ab57e58df57ad$export$a7801e29f563faad; });
// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ var $6f0ab57e58df57ad$export$a7801e29f563faad = 400;

});

parcelRegister("3a2Xq", function(module, exports) {
$parcel$export(module.exports, "useExpandSideNav", function () { return $24d4999334a12e09$export$e44b4744d8ff971a; });

var $1oC0p = parcelRequire("1oC0p");

var $lmxXn = parcelRequire("lmxXn");

var $AKzjw = parcelRequire("AKzjw");
function $24d4999334a12e09$export$e44b4744d8ff971a() {
    var setSideNavState = (0, $1oC0p.useContext)((0, $AKzjw.SetSideNavVisibilityState));
    var expandSideNav = (0, $1oC0p.useCallback)(function() {
        var _window$matchMedia = window.matchMedia('(min-width: 64rem)'), matches = _window$matchMedia.matches;
        if (matches) setSideNavState(function(currentState) {
            (0, $lmxXn.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                mobile: currentState.mobile,
                desktop: 'expanded',
                flyout: 'closed'
            };
        });
        else setSideNavState(function(currentState) {
            (0, $lmxXn.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.mobile === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                desktop: currentState.desktop,
                mobile: 'expanded',
                flyout: 'closed'
            };
        });
    }, [
        setSideNavState
    ]);
    return expandSideNav;
}

});

parcelRegister("a8q15", function(module, exports) {
$parcel$export(module.exports, "useSideNavVisibility", function () { return $760ed5143d36f0e6$export$4a602ad7e09bdb2c; });

var $1oC0p = parcelRequire("1oC0p");

var $AKzjw = parcelRequire("AKzjw");
var $760ed5143d36f0e6$export$4a602ad7e09bdb2c = function useSideNavVisibility() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$defaultCollapsed = _ref.defaultCollapsed, defaultCollapsed = _ref$defaultCollapsed === void 0 ? false : _ref$defaultCollapsed;
    var sideNavState = (0, $1oC0p.useContext)((0, $AKzjw.SideNavVisibilityState));
    // If the context value is `null`, it means we are still in SSR, and should use the default values.
    // For desktop, it comes from the `defaultCollapsed` prop, and for mobile, it is always `false`.
    if (sideNavState === null) return {
        isExpandedOnDesktop: !defaultCollapsed,
        isExpandedOnMobile: false
    };
    return {
        isExpandedOnDesktop: sideNavState.desktop === 'expanded',
        isExpandedOnMobile: sideNavState.mobile === 'expanded'
    };
};

});

parcelRegister("1hwXT", function(module, exports) {
$parcel$export(module.exports, "useSideNavVisibilityCallbacks", function () { return $0ef0f328c70b13eb$export$1904b8f2577aba9a; });

var $1oC0p = parcelRequire("1oC0p");

var $6BCZe = parcelRequire("6BCZe");
function $0ef0f328c70b13eb$export$1904b8f2577aba9a(_ref) {
    var onExpand = _ref.onExpand, onCollapse = _ref.onCollapse, isExpandedOnDesktop = _ref.isExpandedOnDesktop, isExpandedOnMobile = _ref.isExpandedOnMobile;
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    var onExpandRef = (0, $1oC0p.useRef)(onExpand);
    var onCollapseRef = (0, $1oC0p.useRef)(onCollapse);
    (0, $1oC0p.useEffect)(function() {
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    var previousIsExpandedOnDesktop = (0, $6BCZe.default)(isExpandedOnDesktop);
    (0, $1oC0p.useEffect)(function() {
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        if (isExpandedOnDesktop) {
            var _onExpandRef$current;
            (_onExpandRef$current = onExpandRef.current) === null || _onExpandRef$current === void 0 || _onExpandRef$current.call(onExpandRef, {
                screen: 'desktop'
            });
        } else {
            var _onCollapseRef$curren;
            (_onCollapseRef$curren = onCollapseRef.current) === null || _onCollapseRef$curren === void 0 || _onCollapseRef$curren.call(onCollapseRef, {
                screen: 'desktop'
            });
        }
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop
    ]);
    var previousIsExpandedOnMobile = (0, $6BCZe.default)(isExpandedOnMobile);
    (0, $1oC0p.useEffect)(function() {
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        if (isExpandedOnMobile) {
            var _onExpandRef$current2;
            (_onExpandRef$current2 = onExpandRef.current) === null || _onExpandRef$current2 === void 0 || _onExpandRef$current2.call(onExpandRef, {
                screen: 'mobile'
            });
        } else {
            var _onCollapseRef$curren2;
            (_onCollapseRef$curren2 = onCollapseRef.current) === null || _onCollapseRef$curren2 === void 0 || _onCollapseRef$curren2.call(onCollapseRef, {
                screen: 'mobile'
            });
        }
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile
    ]);
}

});
parcelRegister("6BCZe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4cf470b96f98debe$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $4cf470b96f98debe$export$2e2bcd8739ae039(value) {
    var ref = (0, $1oC0p.useRef)();
    (0, $1oC0p.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});


parcelRegister("5808c", function(module, exports) {
$parcel$export(module.exports, "useToggleSideNav", function () { return $3bbdcd317edeffc5$export$477ee35601a0a8ce; });

var $1oC0p = parcelRequire("1oC0p");

var $lmxXn = parcelRequire("lmxXn");

var $AKzjw = parcelRequire("AKzjw");
function $3bbdcd317edeffc5$export$477ee35601a0a8ce() {
    var setSideNavState = (0, $1oC0p.useContext)((0, $AKzjw.SetSideNavVisibilityState));
    var toggleSideNav = (0, $1oC0p.useCallback)(function() {
        var _window$matchMedia = window.matchMedia('(min-width: 64rem)'), matches = _window$matchMedia.matches;
        if (matches) setSideNavState(function(currentState) {
            (0, $lmxXn.default)(currentState, 'Side nav state should not be null');
            return {
                mobile: currentState.mobile,
                desktop: currentState.desktop === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed'
            };
        });
        else setSideNavState(function(currentState) {
            (0, $lmxXn.default)(currentState, 'Side nav state should not be null');
            return {
                desktop: currentState.desktop,
                mobile: currentState.mobile === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed'
            };
        });
    }, [
        setSideNavState
    ]);
    return toggleSideNav;
}

});


parcelRegister("5JpTD", function(module, exports) {
$parcel$export(module.exports, "SideNavContent", function () { return $42c53e2e2e846d39$export$babe3c784778f3ba; });
/* side-nav-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");
var $42c53e2e2e846d39$export$babe3c784778f3ba = /*#__PURE__*/ (0, $1oC0p.forwardRef)($42c53e2e2e846d39$var$_SideNavContent);
// Placing this const below the function breaks Compiled!
var $42c53e2e2e846d39$var$styles = {
    scrollContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug",
    paddingContainer: "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
function $42c53e2e2e846d39$var$_SideNavContent(_ref, ref) {
    var children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $iiT5o.default)([
            $42c53e2e2e846d39$var$styles.scrollContainer
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $iiT5o.default)([
            $42c53e2e2e846d39$var$styles.paddingContainer
        ])
    }, children));
}

});

parcelRegister("i13BD", function(module, exports) {
$parcel$export(module.exports, "SideNavHeader", function () { return $d1db1e128c9ea3f9$export$9d28ff3a0d89869c; });
/* side-nav-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");
var $d1db1e128c9ea3f9$var$styles = {
    root: "_18zrutpp _1q51utpp _85i51b66"
};
var $d1db1e128c9ea3f9$export$9d28ff3a0d89869c = function SideNavHeader(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $iiT5o.default)([
            $d1db1e128c9ea3f9$var$styles.root
        ])
    }, children);
};

});

parcelRegister("2lUOH", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButton", function () { return $1b699d8ac00616c0$export$8bd77667631fec25; });
/* toggle-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9DP70 = parcelRequire("9DP70");

var $iiT5o = parcelRequire("iiT5o");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $9Ex79 = parcelRequire("9Ex79");

var $iIWv0 = parcelRequire("iIWv0");

var $39c3M = parcelRequire("39c3M");

var $4x5Rz = parcelRequire("4x5Rz");

var $3EiCz = parcelRequire("3EiCz");

var $a8q15 = parcelRequire("a8q15");

var $5808c = parcelRequire("5808c");
var $1b699d8ac00616c0$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
// For duplicate "mouseenter" issue when changing icons (see below)
var $1b699d8ac00616c0$var$silentIconStyles = null;
var $1b699d8ac00616c0$export$8bd77667631fec25 = function SideNavToggleButton(_ref) {
    var _ref$defaultCollapsed = _ref.defaultCollapsed, defaultCollapsed = _ref$defaultCollapsed === void 0 ? false : _ref$defaultCollapsed, expandLabel = _ref.expandLabel, collapseLabel = _ref.collapseLabel, testId = _ref.testId, interactionName = _ref.interactionName, onClick = _ref.onClick;
    var _useSideNavVisibility = (0, $a8q15.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    }), isSideNavExpandedOnDesktop = _useSideNavVisibility.isExpandedOnDesktop, isSideNavExpandedOnMobile = _useSideNavVisibility.isExpandedOnMobile;
    var _useState = (0, $1oC0p.useState)(!defaultCollapsed), _useState2 = (0, $9DP70.default)(_useState, 2), isSideNavExpanded = _useState2[0], setIsSideNavExpanded = _useState2[1];
    var ref = (0, $1oC0p.useContext)((0, $3EiCz.SideNavToggleButtonAttachRef));
    var elementRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(function() {
        if ((0, $39c3M.fg)('platform_fix_component_state_update_for_suspense')) ref(elementRef.current);
    }, [
        elementRef,
        ref
    ]);
    (0, $1oC0p.useEffect)(function() {
        var _window$matchMedia = window.matchMedia('(min-width: 64rem)'), matches = _window$matchMedia.matches;
        setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    (0, $1oC0p.useEffect)(function() {
        // When screen size changes, ensure we use the correct visibility state
        var mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $dH1HR.bind)(mediaQueryList, {
            type: 'change',
            listener: function listener() {
                setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
            }
        });
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    var toggleVisibility = (0, $5808c.useToggleSideNav)();
    var handleClick = (0, $1oC0p.useCallback)(function(event, analyticsEvent) {
        onClick === null || onClick === void 0 || onClick(event, analyticsEvent, {
            isSideNavVisible: isSideNavExpanded
        });
        toggleVisibility();
    }, [
        onClick,
        toggleVisibility,
        isSideNavExpanded
    ]);
    /**
   * ## Behaviour
   * It is intentional that collapse icon will be used while the flyout is open.
   * The icon is tied to the expanded / collapse state, and not the flyout state.
   *
   * ## Why a function?
   * Unfortunately, changing the icon inside an <IconButton> when the user is over
   * the button will cause the svg element to be replaced, which can trigger a
   * "mouseenter" event. This is problematic when the user is already over the button,
   * as it can result in a "mouseenter" event after the user manually entered the button.
   *
   * `icon` accepts a function for the `icon` prop (ie a render prop), so we don't need to
   * memoize it, or pull it out into a new function
   */ var icon = function icon(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
            className: (0, $iiT5o.default)([
                "_1e0c1bgi _lcxvglyw"
            ])
        }, isSideNavExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Ex79))), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iIWv0))), props));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4x5Rz.IconButton), {
        appearance: "subtle",
        label: isSideNavExpanded ? collapseLabel : expandLabel,
        icon: icon,
        onClick: handleClick,
        testId: testId,
        isTooltipDisabled: false,
        interactionName: interactionName,
        ref: (0, $39c3M.fg)('platform_fix_component_state_update_for_suspense') ? elementRef : ref,
        tooltip: $1b699d8ac00616c0$var$toggleButtonTooltipOptions
    });
};

});
parcelRegister("9Ex79", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7c03d2728886be26240ae9af453c127>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7071894dbabd606d$var$_react = $7071894dbabd606d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7071894dbabd606d$var$_baseNew = $7071894dbabd606d$var$_interopRequireDefault((parcelRequire("hyw8n")));
function $7071894dbabd606d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7071894dbabd606d$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $7071894dbabd606d$var$_react.default.createElement($7071894dbabd606d$var$_baseNew.default, Object.assign({
        name: "SidebarCollapseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$7071894dbabd606d$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $7071894dbabd606d$var$_default = module.exports.default = $7071894dbabd606d$var$SidebarCollapseIcon;

});

parcelRegister("iIWv0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::87b126ba38d591666b6bb1a2ae894895>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $da19b6bdbad493a8$var$_react = $da19b6bdbad493a8$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $da19b6bdbad493a8$var$_baseNew = $da19b6bdbad493a8$var$_interopRequireDefault((parcelRequire("hyw8n")));
function $da19b6bdbad493a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $da19b6bdbad493a8$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $da19b6bdbad493a8$var$_react.default.createElement($da19b6bdbad493a8$var$_baseNew.default, Object.assign({
        name: "SidebarExpandIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-2v-11zm-3.5 0v11H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.03 7.47l-2.5-2.5-1.06 1.06L6.44 8 4.47 9.97l1.06 1.06 2.5-2.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$da19b6bdbad493a8$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $da19b6bdbad493a8$var$_default = module.exports.default = $da19b6bdbad493a8$var$SidebarExpandIcon;

});


parcelRegister("iF38V", function(module, exports) {
$parcel$export(module.exports, "TopNav", function () { return $d95e7e7672d96c2d$export$41d0d88a6b0e456f; });
/* top-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");

var $8Ook3 = parcelRequire("8Ook3");

var $emfz8 = parcelRequire("emfz8");

var $hyGUW = parcelRequire("hyGUW");

var $h6B0m = parcelRequire("h6B0m");

var $5xY8f = parcelRequire("5xY8f");

var $9DxTV = parcelRequire("9DxTV");

var $9Kv5j = parcelRequire("9Kv5j");
var $d95e7e7672d96c2d$var$styles = {
    root: "_nd5l8cbt _zulpu2gc _18zrutpp _179rzgxb _1e0c11p5 _yv0e1mfv _4cvr1h6o _bfhkvuon _vchhusvi _4t3i1dgc _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi _1j8b18ax"
};
function $d95e7e7672d96c2d$export$41d0d88a6b0e456f(_ref) {
    var children = _ref.children, xcss = _ref.xcss, _ref$height = _ref.height, height = _ref$height === void 0 ? 48 : _ref$height, _ref$skipLinkLabel = _ref.skipLinkLabel, skipLinkLabel = _ref$skipLinkLabel === void 0 ? 'Top Bar' : _ref$skipLinkLabel, testId = _ref.testId, providedId = _ref.id, UNSAFE_theme = _ref.UNSAFE_theme;
    var dangerouslyHoistSlotSizes = (0, $1oC0p.useContext)((0, $5xY8f.DangerouslyHoistSlotSizes));
    var id = (0, $9Kv5j.useLayoutId)({
        providedId: providedId
    });
    (0, $8Ook3.useSkipLink)(id, skipLinkLabel);
    var customTheme = (0, $hyGUW.useCustomTheme)(UNSAFE_theme);
    return /*#__PURE__*/ $1oC0p.createElement((0, $emfz8.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled
    }, /*#__PURE__*/ $1oC0p.createElement("header", {
        id: id,
        "data-layout-slot": true,
        className: (0, $iiT5o.default)([
            $d95e7e7672d96c2d$var$styles.root,
            xcss
        ]),
        "data-testid": testId,
        style: customTheme.isEnabled ? customTheme.style : undefined
    }, /*#__PURE__*/ $1oC0p.createElement((0, $9DxTV.HoistCssVarToLocalGrid), {
        variableName: (0, $h6B0m.topNavMountedVar),
        value: height
    }), dangerouslyHoistSlotSizes && /*#__PURE__*/ // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    $1oC0p.createElement((0, $9DxTV.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $h6B0m.UNSAFE_topNavVar),
        value: height
    }), children));
}

});
parcelRegister("hyGUW", function(module, exports) {
$parcel$export(module.exports, "useCustomTheme", function () { return $cc86e7293229284b$export$c0c5f5b297b77726; });

var $1oC0p = parcelRequire("1oC0p");

var $3axp2 = parcelRequire("3axp2");
function $cc86e7293229284b$export$c0c5f5b297b77726(theme) {
    var value = (0, $1oC0p.useMemo)(function() {
        if (!(theme !== null && theme !== void 0 && theme.backgroundColor) || !(theme !== null && theme !== void 0 && theme.highlightColor)) return {
            isEnabled: false
        };
        /**
     * Re-creating the `theme` object from it's pieces.
     *
     * _Technically_ we could just use `theme`, but that would involve an eslint opt out
     * as we would be leveraging a value (`theme`) not in the dependency array.
     *
     * The current approach is the most correct™️ and avoids foot guns.
     * We are only using values in the effect that are defined in the dependency array 🙌
     */ var value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        var style = (0, $3axp2.getCustomThemeStyles)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme === null || theme === void 0 ? void 0 : theme.backgroundColor,
        theme === null || theme === void 0 ? void 0 : theme.highlightColor
    ]);
    return value;
}

});
parcelRegister("3axp2", function(module, exports) {
$parcel$export(module.exports, "getCustomThemeStyles", function () { return $24ec376199a339d5$export$3986d75fe2da3239; });

var $363qk = parcelRequire("363qk");

var $3esCB = parcelRequire("3esCB");

var $1UlSm = parcelRequire("1UlSm");

var $cfLuB = parcelRequire("cfLuB");

var $3D640 = parcelRequire("3D640");

var $bwb56 = parcelRequire("bwb56");

var $1RDaR = parcelRequire("1RDaR");
function $24ec376199a339d5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $24ec376199a339d5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $24ec376199a339d5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $363qk.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $24ec376199a339d5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Expects colors to be passed as `RGB` objects.
 *
 * Allows `string` for hex strings only, for backwards compatibility.
 * This will likely be removed in the future.
 *
 * Allows `null` for ergonomic reasons, because our color parsing utilities can return
 * `null` if they cannot parse a color string.
 */ function $24ec376199a339d5$var$toRGBString(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
}
function $24ec376199a339d5$var$toRGBAString(_ref2) {
    var r = _ref2.r, g = _ref2.g, b = _ref2.b, a = _ref2.a;
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
var $24ec376199a339d5$var$buttonStyles = {
    light: (0, $363qk.default)((0, $363qk.default)((0, $363qk.default)((0, $363qk.default)((0, $363qk.default)((0, $363qk.default)((0, $363qk.default)((0, $363qk.default)((0, $363qk.default)({}, (0, $1UlSm.themedButtonBackground), 'transparent'), (0, $1UlSm.themedButtonBackgroundHovered), (0, $bwb56.palette).Neutral200A), (0, $1UlSm.themedButtonBackgroundPressed), (0, $bwb56.palette).Neutral300A), (0, $1UlSm.themedButtonBorder), (0, $bwb56.palette).Neutral300A), (0, $1UlSm.themedButtonSelectedBackground), (0, $bwb56.palette).Neutral300A), (0, $1UlSm.themedButtonSelectedBackgroundHovered), (0, $bwb56.palette).Neutral400A), (0, $1UlSm.themedButtonSelectedBackgroundPressed), (0, $bwb56.palette).Neutral500A), (0, $1UlSm.themedButtonDisabledText), (0, $bwb56.palette).Neutral400A), (0, $1UlSm.themedButtonDisabledBackground), (0, $bwb56.palette).Neutral100A),
    dark: (0, $363qk.default)((0, $363qk.default)((0, $363qk.default)((0, $363qk.default)((0, $363qk.default)((0, $363qk.default)((0, $363qk.default)((0, $363qk.default)((0, $363qk.default)({}, (0, $1UlSm.themedButtonBackground), 'transparent'), (0, $1UlSm.themedButtonBackgroundHovered), (0, $bwb56.palette).DarkNeutral200A), (0, $1UlSm.themedButtonBackgroundPressed), (0, $bwb56.palette).DarkNeutral300A), (0, $1UlSm.themedButtonBorder), (0, $bwb56.palette).DarkNeutral300A), (0, $1UlSm.themedButtonSelectedBackground), (0, $bwb56.palette).DarkNeutral300A), (0, $1UlSm.themedButtonSelectedBackgroundHovered), (0, $bwb56.palette).DarkNeutral400A), (0, $1UlSm.themedButtonSelectedBackgroundPressed), (0, $bwb56.palette).DarkNeutral500A), (0, $1UlSm.themedButtonDisabledText), (0, $bwb56.palette).DarkNeutral400A), (0, $1UlSm.themedButtonDisabledBackground), (0, $bwb56.palette).DarkNeutral100A)
};
var $24ec376199a339d5$var$logoStyles = {
    light: (0, $363qk.default)((0, $363qk.default)({}, (0, $3esCB.themedLogoIcon), (0, $bwb56.palette).DarkNeutral0), (0, $3esCB.themedLogoText), (0, $bwb56.palette).DarkNeutral0),
    dark: (0, $363qk.default)((0, $363qk.default)({}, (0, $3esCB.themedLogoIcon), (0, $bwb56.palette).Neutral0), (0, $3esCB.themedLogoText), (0, $bwb56.palette).Neutral0)
};
function $24ec376199a339d5$export$3986d75fe2da3239(_ref3) {
    var backgroundColor = _ref3.backgroundColor, highlightColor = _ref3.highlightColor;
    var backgroundRgb = typeof backgroundColor === 'string' ? (0, $3D640.parseHex)(backgroundColor) : backgroundColor;
    var highlightRgb = typeof highlightColor === 'string' ? (0, $3D640.parseHex)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    var textColor = (0, $cfLuB.getTextColor)(backgroundRgb);
    var colorMode = (0, $cfLuB.getColorMode)(backgroundRgb);
    var highlightTextColor = (0, $cfLuB.getTextColor)(highlightRgb);
    return $24ec376199a339d5$var$_objectSpread($24ec376199a339d5$var$_objectSpread($24ec376199a339d5$var$_objectSpread($24ec376199a339d5$var$_objectSpread({
        backgroundColor: $24ec376199a339d5$var$toRGBString(backgroundRgb),
        color: textColor.hex
    }, $24ec376199a339d5$var$buttonStyles[colorMode]), $24ec376199a339d5$var$logoStyles[colorMode]), $24ec376199a339d5$var$getSelectedStyles({
        backgroundColor: backgroundRgb,
        colorMode: colorMode
    })), {}, (0, $363qk.default)((0, $363qk.default)((0, $363qk.default)((0, $363qk.default)((0, $363qk.default)((0, $363qk.default)({}, (0, $1RDaR.themedSearchBorder), $24ec376199a339d5$var$toRGBAString($24ec376199a339d5$var$_objectSpread($24ec376199a339d5$var$_objectSpread({}, textColor.rgb), {}, {
        a: 0.5
    }))), (0, $1RDaR.themedSearchBorderFocused), $24ec376199a339d5$var$toRGBAString($24ec376199a339d5$var$_objectSpread($24ec376199a339d5$var$_objectSpread({}, highlightRgb), {}, {
        a: 0.8
    }))), (0, $1UlSm.themedButtonPrimaryBackground), $24ec376199a339d5$var$toRGBString(highlightRgb)), (0, $1UlSm.themedButtonPrimaryBackgroundHovered), $24ec376199a339d5$var$toRGBAString($24ec376199a339d5$var$_objectSpread($24ec376199a339d5$var$_objectSpread({}, highlightRgb), {}, {
        a: 0.8
    }))), (0, $1UlSm.themedButtonPrimaryBackgroundPressed), $24ec376199a339d5$var$toRGBAString($24ec376199a339d5$var$_objectSpread($24ec376199a339d5$var$_objectSpread({}, highlightRgb), {}, {
        a: 0.65
    }))), (0, $1UlSm.themedButtonPrimaryText), highlightTextColor.hex));
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ var $24ec376199a339d5$var$selectedBackgroundRGBA = {
    light: (0, $bwb56.paletteRgba).Neutral300A,
    dark: (0, $bwb56.paletteRgba).DarkNeutral300A
};
function $24ec376199a339d5$var$getSelectedStyles(_ref4) {
    var backgroundColor = _ref4.backgroundColor, colorMode = _ref4.colorMode;
    /**
   * The background color of the selected button in its default state.
   *
   * We are referring to this as a foreground color because it is semi-transparent,
   * so is not the actual color displayed when the button is on top of a background color.
   */ var foregroundColor = $24ec376199a339d5$var$selectedBackgroundRGBA[colorMode];
    /**
   * The blended color seen when the selected background is over the top bar.
   */ var blendedBackground = (0, $cfLuB.simpleAlphaComposite)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return (0, $363qk.default)((0, $363qk.default)({}, (0, $1UlSm.themedButtonSelectedText), (0, $cfLuB.getTextColor)(blendedBackground).hex), (0, $1UlSm.themedButtonSelectedBorder), (0, $cfLuB.isLight)(blendedBackground) ? (0, $bwb56.palette).Neutral1100 : (0, $bwb56.palette).DarkNeutral1100);
}

});
parcelRegister("3esCB", function(module, exports) {
$parcel$export(module.exports, "themedLogoIcon", function () { return $25a8e18e45e08c1e$export$24328117f1132113; });
$parcel$export(module.exports, "themedLogoText", function () { return $25a8e18e45e08c1e$export$91b0830f8f4ab279; });
$parcel$export(module.exports, "LogoRenderer", function () { return $25a8e18e45e08c1e$export$35e88bd9b061a3a4; });
/* logo-renderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $1oC0p = parcelRequire("1oC0p");

var $39c3M = parcelRequire("39c3M");

var $emfz8 = parcelRequire("emfz8");
var $25a8e18e45e08c1e$export$24328117f1132113 = '--ds-top-bar-logo-icon';
var $25a8e18e45e08c1e$export$91b0830f8f4ab279 = '--ds-top-bar-logo-text';
function $25a8e18e45e08c1e$export$35e88bd9b061a3a4(_ref) {
    var logoOrIcon = _ref.logoOrIcon, shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign;
    return (0, $39c3M.fg)('jiv-20710-fix-nav-rerender') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($25a8e18e45e08c1e$var$LogoRendererMemo, {
        logoOrIcon: logoOrIcon,
        shouldUseNewLogoDesign: shouldUseNewLogoDesign
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($25a8e18e45e08c1e$var$LogoRendererNoMemo, {
        logoOrIcon: logoOrIcon,
        shouldUseNewLogoDesign: shouldUseNewLogoDesign
    });
}
var $25a8e18e45e08c1e$var$LogoRendererMemo = /*#__PURE__*/ (0, $1oC0p.memo)($25a8e18e45e08c1e$var$LogoRendererNoMemo);
function $25a8e18e45e08c1e$var$LogoRendererNoMemo(_ref2) {
    var LogoOrIcon = _ref2.logoOrIcon, shouldUseNewLogoDesign = _ref2.shouldUseNewLogoDesign;
    var hasCustomTheme = (0, $emfz8.useHasCustomTheme)();
    if (hasCustomTheme) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(LogoOrIcon, {
        label: "",
        size: "small",
        shouldUseNewLogoDesign: shouldUseNewLogoDesign,
        iconColor: "var(".concat($25a8e18e45e08c1e$export$24328117f1132113, ")"),
        textColor: "var(".concat($25a8e18e45e08c1e$export$91b0830f8f4ab279, ")")
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(LogoOrIcon, {
        size: "small",
        shouldUseNewLogoDesign: shouldUseNewLogoDesign,
        label: "",
        appearance: "brand"
    });
}

});

parcelRegister("cfLuB", function(module, exports) {
$parcel$export(module.exports, "isLight", function () { return $8ebbb9cbe132986d$export$44af652f4cca9039; });
$parcel$export(module.exports, "getColorMode", function () { return $8ebbb9cbe132986d$export$5573a5bab3e074b5; });
$parcel$export(module.exports, "getTextColor", function () { return $8ebbb9cbe132986d$export$5357fe757c335c0d; });
$parcel$export(module.exports, "simpleAlphaComposite", function () { return $8ebbb9cbe132986d$export$e5e64c30bee1469b; });
/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $8ebbb9cbe132986d$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $8ebbb9cbe132986d$var$relativeLuminanceW3C(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    /**
   * Normalized sRGB - each channel is between 0 and 1
   */ var normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
   * linear RGB - the gamma correction of sRGB is removed and
   * the channels correspond directly to subpixel intensity
   */ var linear = {
        r: $8ebbb9cbe132986d$var$linearizeRGBChannel(normal.r),
        g: $8ebbb9cbe132986d$var$linearizeRGBChannel(normal.g),
        b: $8ebbb9cbe132986d$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    var L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ var $8ebbb9cbe132986d$var$flipLuminance = 0.179129;
function $8ebbb9cbe132986d$export$44af652f4cca9039(color) {
    return $8ebbb9cbe132986d$var$relativeLuminanceW3C(color) >= $8ebbb9cbe132986d$var$flipLuminance;
}
function $8ebbb9cbe132986d$export$5573a5bab3e074b5(backgroundColor) {
    if ($8ebbb9cbe132986d$var$relativeLuminanceW3C(backgroundColor) >= $8ebbb9cbe132986d$var$flipLuminance) return 'light';
    return 'dark';
}
var $8ebbb9cbe132986d$var$textColor = {
    light: {
        hex: '#000',
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: '#FFF',
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $8ebbb9cbe132986d$export$5357fe757c335c0d(backgroundColor) {
    var colorMode = $8ebbb9cbe132986d$export$5573a5bab3e074b5(backgroundColor);
    return $8ebbb9cbe132986d$var$textColor[colorMode];
}
function $8ebbb9cbe132986d$export$e5e64c30bee1469b(_ref2) {
    var background = _ref2.background, foreground = _ref2.foreground;
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}

});

parcelRegister("3D640", function(module, exports) {
$parcel$export(module.exports, "parseHex", function () { return $2a49b7bf2130b6c1$export$103711ef09c6edec; });
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
var $2a49b7bf2130b6c1$var$isValidHex = function isValidHex(hex) {
    return(// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex));
};
function $2a49b7bf2130b6c1$export$103711ef09c6edec(color) {
    if (!$2a49b7bf2130b6c1$var$isValidHex(color)) return null;
    var channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}

});

parcelRegister("bwb56", function(module, exports) {
$parcel$export(module.exports, "palette", function () { return $862b4763a2e54026$export$eaad8caa32d2521d; });
$parcel$export(module.exports, "paletteRgba", function () { return $862b4763a2e54026$export$c9b84419dae66a82; });
/**
 * Copied from the brand refresh palette.
 *
 * Ideally we'd codegen this but the brand refresh palette isn't exposed
 * through public API and we shouldn't use the private API of another package.
 */ var $862b4763a2e54026$export$eaad8caa32d2521d = {
    'DarkNeutral-100': '#111213',
    'DarkNeutral-100A': '#01040475',
    DarkNeutral0: '#18191A',
    DarkNeutral100: '#1F1F21',
    DarkNeutral100A: '#BDBDBD0A',
    DarkNeutral200: '#242528',
    DarkNeutral200A: '#CECED912',
    DarkNeutral250: '#2B2C2F',
    DarkNeutral250A: '#D9DAE71A',
    DarkNeutral300: '#303134',
    DarkNeutral300A: '#E3E4F21F',
    DarkNeutral350: '#3D3F43',
    DarkNeutral350A: '#E8EDFD2E',
    DarkNeutral400: '#4B4D51',
    DarkNeutral400A: '#E5E9F640',
    DarkNeutral500: '#63666B',
    DarkNeutral500A: '#E9F0FB5C',
    DarkNeutral600: '#7E8188',
    DarkNeutral700: '#96999E',
    DarkNeutral800: '#A9ABAF',
    DarkNeutral900: '#BFC1C4',
    DarkNeutral1000: '#CECFD2',
    DarkNeutral1100: '#E2E3E4',
    Neutral0: '#FFFFFF',
    Neutral100: '#F8F8F8',
    Neutral100A: '#17171708',
    Neutral200: '#F0F1F2',
    Neutral200A: '#0515240F',
    Neutral300: '#DDDEE1',
    Neutral300A: '#0B120E24',
    Neutral400: '#B7B9BE',
    Neutral400A: '#080F214A',
    Neutral500: '#8C8F97',
    Neutral500A: '#050C1F75',
    Neutral600: '#7D818A',
    Neutral700: '#6B6E76',
    Neutral800: '#505258',
    Neutral900: '#3B3D42',
    Neutral1000: '#292A2E',
    Neutral1100: '#1E1F21'
};
var $862b4763a2e54026$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};

});

parcelRegister("1RDaR", function(module, exports) {
$parcel$export(module.exports, "themedSearchBorder", function () { return $15b920dad10875c8$export$ae6fbf5ba3a7a784; });
$parcel$export(module.exports, "themedSearchBorderFocused", function () { return $15b920dad10875c8$export$ee42b8430f4c19bd; });

var $1UlSm = parcelRequire("1UlSm");

var $emfz8 = parcelRequire("emfz8");
var $15b920dad10875c8$export$ae6fbf5ba3a7a784 = '--ds-top-bar-search-border';
var $15b920dad10875c8$export$ee42b8430f4c19bd = '--ds-top-bar-search-border-focused';
/**
 * Theme object intended for use with Search Platform components while transitioning to nav4.
 *
 * This is for backwards compatibility with the legacy theming API that was designed for nav3.
 *
 * As nav4 matures we will ideally evolve the theming solution inside Search Platform,
 * at which point this legacy theme object will not be needed.
 */ var $15b920dad10875c8$var$legacySearchTheme = {
    default: {
        backgroundColor: 'transparent',
        color: 'currentColor',
        borderColor: "var(".concat($15b920dad10875c8$export$ae6fbf5ba3a7a784, ")")
    },
    focus: {
        /**
     * When expanded the input ignores the custom theme,
     * except for its border which is derived from the highlight color.
     */ color: "var(--ds-text, #172B4D)",
        backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
        borderColor: "var(".concat($15b920dad10875c8$export$ee42b8430f4c19bd, ")"),
        boxShadow: "inset 0px 0px 0px 1px var(".concat($15b920dad10875c8$export$ee42b8430f4c19bd, ")")
    },
    hover: {
        /**
     * This is not actually used for the search bar input (at least by the Search Platform components).
     *
     * Instead it's used as the hover background color for a close button when on mobile.
     */ backgroundColor: "var(".concat((0, $1UlSm.themedButtonBackgroundHovered), ")")
    }
};
function $15b920dad10875c8$export$18a29b1ed2212823() {
    var hasCustomTheme = (0, $emfz8.useHasCustomTheme)();
    if (hasCustomTheme) return $15b920dad10875c8$var$legacySearchTheme;
    return undefined;
}

});




parcelRegister("eoNne", function(module, exports) {
$parcel$export(module.exports, "TopNavEnd", function () { return $a7b99b25db175057$export$8b7a38b70a3c9839; });
/* top-nav-end.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9jUeC = parcelRequire("9jUeC");

var $9DP70 = parcelRequire("9DP70");

var $iiT5o = parcelRequire("iiT5o");

var $1oC0p = parcelRequire("1oC0p");

var $fYNKD = parcelRequire("fYNKD");

var $4GUnT = parcelRequire("4GUnT");

var $gC0QR = parcelRequire("gC0QR");

var $5U3pD = parcelRequire("5U3pD");

var $74uEr = parcelRequire("74uEr");

var $3m9lN = parcelRequire("3m9lN");

var $emfz8 = parcelRequire("emfz8");

var $4x5Rz = parcelRequire("4x5Rz");
var $a7b99b25db175057$var$containerStyles = {
    root: "_yyhy11wp _1e0c1txw _1bahh9n0 _1ul9zwfg _1d2y1ris _glte1ris _15ri1mjv _1gs5usvi _ndwch9n0"
};
var $a7b99b25db175057$var$listStyles = {
    root: "_zulp1b66 _4cvr1h6o _1e0c1txw",
    hideOnSmallViewport: "_1e0cglyw _181n1txw",
    popupContainer: "_1yt4u2gc"
};
function $a7b99b25db175057$export$8b7a38b70a3c9839(_ref) {
    var children = _ref.children, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Actions' : _ref$label, _ref$showMoreButtonLa = _ref.showMoreButtonLabel, showMoreButtonLabel = _ref$showMoreButtonLa === void 0 ? 'Show more' : _ref$showMoreButtonLa;
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $9DP70.default)(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    // Always setting to `false` for the initial render (will flip in an effect for mobile)
    var _useState3 = (0, $1oC0p.useState)(false), _useState4 = (0, $9DP70.default)(_useState3, 2), isMobile = _useState4[0], setIsMobile = _useState4[1];
    // Note: `query` is a stable value between renders
    var query = (0, $74uEr.UNSAFE_useMediaQuery)('below.sm', function onChange(event) {
        setIsMobile(event.matches);
        // Any time we shift between mobile and desktop
        // We always close the popup
        setIsOpen(false);
    });
    (0, $4GUnT.useLayoutEffect)(function() {
        var _query$matches;
        // The default is `false`, and desktop will remain as `false` (no re-render).
        // Mobile will flip from `false` to `true`.
        setIsMobile((_query$matches = query === null || query === void 0 ? void 0 : query.matches) !== null && _query$matches !== void 0 ? _query$matches : false);
    }, [
        query
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("nav", {
        "aria-label": label,
        className: (0, $iiT5o.default)([
            $a7b99b25db175057$var$containerStyles.root
        ])
    }, isMobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $5U3pD.default), {
        isOpen: isOpen,
        onClose: function onClose() {
            return setIsOpen(false);
        },
        placement: "bottom-start",
        shouldRenderToParent: true,
        content: function content() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $emfz8.HasCustomThemeContext).Provider, {
                value: false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3m9lN.List), {
                xcss: (0, $fYNKD.cx)($a7b99b25db175057$var$listStyles.root, $a7b99b25db175057$var$listStyles.popupContainer)
            }, children));
        },
        trigger: function trigger(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4x5Rz.IconButton), (0, $9jUeC.default)({}, triggerProps, {
                label: showMoreButtonLabel,
                isSelected: isOpen,
                onClick: function onClick() {
                    return setIsOpen(!isOpen);
                },
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC0QR))),
                isTooltipDisabled: false
            }));
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3m9lN.List), {
        xcss: (0, $fYNKD.cx)($a7b99b25db175057$var$listStyles.root, $a7b99b25db175057$var$listStyles.hideOnSmallViewport)
    }, children));
}

});
parcelRegister("4GUnT", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", function () { return $36a6d269a23e148e$export$e5c5a5f917a5871c; });

var $1oC0p = parcelRequire("1oC0p");
var $36a6d269a23e148e$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);

});

parcelRegister("gC0QR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a789640350a4d3b29556a43626f35de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c180db0d4a53f745$var$_react = $c180db0d4a53f745$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c180db0d4a53f745$var$_baseNew = $c180db0d4a53f745$var$_interopRequireDefault((parcelRequire("hyw8n")));
function $c180db0d4a53f745$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c180db0d4a53f745$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $c180db0d4a53f745$var$_react.default.createElement($c180db0d4a53f745$var$_baseNew.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$c180db0d4a53f745$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $c180db0d4a53f745$var$_default = module.exports.default = $c180db0d4a53f745$var$ShowMoreHorizontalIcon;

});

parcelRegister("5U3pD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $44c4d45a1549f12d$export$2e2bcd8739ae039; });

var $gSGsq = parcelRequire("gSGsq");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$44c4d45a1549f12d$export$2e2bcd8739ae039 = (0, $gSGsq.Popup);

});
parcelRegister("gSGsq", function(module, exports) {
$parcel$export(module.exports, "Popup", function () { return $c4a29fae098fb151$export$129a32eedafa97c5; });
/* popup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9DP70 = parcelRequire("9DP70");

var $1oC0p = parcelRequire("1oC0p");


var $edmmv = parcelRequire("edmmv");

var $bd2OO = parcelRequire("bd2OO");

var $6P6Jp = parcelRequire("6P6Jp");

var $39c3M = parcelRequire("39c3M");

var $8q4Jo = parcelRequire("8q4Jo");
var $kUCSO = parcelRequire("kUCSO");

var $52Fo7 = parcelRequire("52Fo7");

var $gIglk = parcelRequire("gIglk");

var $fEi4k = parcelRequire("fEi4k");

var $9aWzi = parcelRequire("9aWzi");

var $5CXSN = parcelRequire("5CXSN");

var $kUTMq = parcelRequire("kUTMq");
var $c4a29fae098fb151$var$defaultLayer = 400;
var $c4a29fae098fb151$var$wrapperStyles = {
    root: "_kqswh2mm"
};
var $c4a29fae098fb151$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? 'viewport' : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $c4a29fae098fb151$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $9DP70.default)(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $5CXSN.useGetMemoizedMergedTriggerRef)();
    var getMergedTriggerRefNew = (0, $kUTMq.useGetMemoizedMergedTriggerRefNew)();
    var generatedId = (0, $edmmv.useId)();
    var _usePopupAppearance = (0, $9aWzi.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    var handleOpenLayerObserverCloseSignal = (0, $1oC0p.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $6P6Jp.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    var renderPopperWrapper = /*#__PURE__*/ $1oC0p.createElement((0, $bd2OO.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $1oC0p.createElement((0, $fEi4k.default), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = /*#__PURE__*/ $1oC0p.createElement((0, $8q4Jo.Manager), null, /*#__PURE__*/ $1oC0p.createElement((0, $kUCSO.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $39c3M.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $39c3M.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $1oC0p.createElement((0, $52Fo7.default), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return /*#__PURE__*/ $1oC0p.createElement((0, $gIglk.default), {
        xcss: $c4a29fae098fb151$var$wrapperStyles.root
    }, popupContent);
    return popupContent;
});

});
parcelRegister("gIglk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c2ad6ece1043f5ce$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9jUeC = parcelRequire("9jUeC");

var $2q0os = parcelRequire("2q0os");

var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");

var $2c1i4 = parcelRequire("2c1i4");
var $c2ad6ece1043f5ce$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $c2ad6ece1043f5ce$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $c2ad6ece1043f5ce$var$baseStyles = null;
var $c2ad6ece1043f5ce$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhk1fno",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1eds",
    'color.background.accent.lime.subtler.pressed': "_bfhk1hgz",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhkhgj8",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhk1b17",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhk1pbw",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkrw5d",
    'color.background.accent.red.subtler.pressed': "_bfhk69rw",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1tf4",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhkprmn",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtlest.hovered': "_bfhkg4tm",
    'color.background.accent.orange.subtlest.pressed': "_bfhk1ya0",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtler.hovered': "_bfhk1lml",
    'color.background.accent.orange.subtler.pressed': "_bfhkuxsx",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.subtle.hovered': "_bfhk1oew",
    'color.background.accent.orange.subtle.pressed': "_bfhk1phk",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.orange.bolder.hovered': "_bfhkhi52",
    'color.background.accent.orange.bolder.pressed': "_bfhkf767",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtlest.hovered': "_bfhk19g9",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk31d1",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtler.hovered': "_bfhklg04",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1d44",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.subtle.hovered': "_bfhk17e6",
    'color.background.accent.yellow.subtle.pressed': "_bfhko0y5",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk32kj",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkv5yf",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhkung8",
    'color.background.accent.green.subtler.pressed': "_bfhk1p19",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk8h4p",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1azz",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1j2h",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkg5py",
    'color.background.accent.teal.subtler.pressed': "_bfhkq7li",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk10ai",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhkse6l",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtlest.hovered': "_bfhkay3p",
    'color.background.accent.blue.subtlest.pressed': "_bfhk1xmr",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtler.hovered': "_bfhk16e6",
    'color.background.accent.blue.subtler.pressed': "_bfhk1uh7",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.subtle.hovered': "_bfhk1f4s",
    'color.background.accent.blue.subtle.pressed': "_bfhkqctv",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.blue.bolder.hovered': "_bfhk1cwi",
    'color.background.accent.blue.bolder.pressed': "_bfhkhcrq",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtlest.hovered': "_bfhkm0d5",
    'color.background.accent.purple.subtlest.pressed': "_bfhkgslw",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtler.hovered': "_bfhk1wyu",
    'color.background.accent.purple.subtler.pressed': "_bfhk5fkp",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.subtle.hovered': "_bfhk1wob",
    'color.background.accent.purple.subtle.pressed': "_bfhkwz05",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.purple.bolder.hovered': "_bfhkadgs",
    'color.background.accent.purple.bolder.pressed': "_bfhk1uro",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1een",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1r0p",
    'color.background.accent.magenta.subtler.pressed': "_bfhkxuzc",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk1ovh",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkwaw3",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtlest.hovered': "_bfhk12j4",
    'color.background.accent.gray.subtlest.pressed': "_bfhk1lb4",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtler.hovered': "_bfhk1f7l",
    'color.background.accent.gray.subtler.pressed': "_bfhkd8a2",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.subtle.hovered': "_bfhk1a2l",
    'color.background.accent.gray.subtle.pressed': "_bfhk1z0s",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.accent.gray.bolder.hovered': "_bfhke4nv",
    'color.background.accent.gray.bolder.pressed': "_bfhk82ra",
    'color.background.disabled': "_bfhksyzs",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhk1d5g",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.hovered': "_bfhk15ej",
    'color.background.neutral.pressed': "_bfhkip91",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk166n",
    'color.background.neutral.subtle.pressed': "_bfhk1dty",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.neutral.bold.hovered': "_bfhk1bsc",
    'color.background.neutral.bold.pressed': "_bfhk1b6k",
    'color.background.selected': "_bfhkfg4m",
    'color.background.selected.hovered': "_bfhki1yw",
    'color.background.selected.pressed': "_bfhk19ru",
    'color.background.selected.bold': "_bfhk1fvw",
    'color.background.selected.bold.hovered': "_bfhk18hz",
    'color.background.selected.bold.pressed': "_bfhkgr1v",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.subtlest.hovered': "_bfhkezq1",
    'color.background.brand.subtlest.pressed': "_bfhk2ggb",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.bold.hovered': "_bfhku1se",
    'color.background.brand.bold.pressed': "_bfhkqkzo",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.brand.boldest.hovered': "_bfhk1uwk",
    'color.background.brand.boldest.pressed': "_bfhk17jr",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1io2",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk9pqq",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.hovered': "_bfhk1rd4",
    'color.background.warning.pressed': "_bfhk11dh",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.warning.bold.hovered': "_bfhk1i4c",
    'color.background.warning.bold.pressed': "_bfhkrj9s",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.hovered': "_bfhk1jgi",
    'color.background.success.pressed': "_bfhky4f1",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.success.bold.hovered': "_bfhk1q4l",
    'color.background.success.bold.pressed': "_bfhkcrcn",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.hovered': "_bfhk1xp7",
    'color.background.discovery.pressed': "_bfhkdlkp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.discovery.bold.hovered': "_bfhk1w72",
    'color.background.discovery.bold.pressed': "_bfhkrb53",
    'color.background.information': "_bfhk33gi",
    'color.background.information.hovered': "_bfhk1vps",
    'color.background.information.pressed': "_bfhk1s0z",
    'color.background.information.bold': "_bfhk14wj",
    'color.background.information.bold.hovered': "_bfhk1amz",
    'color.background.information.bold.pressed': "_bfhk5bth",
    'color.blanket': "_bfhk10xm",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkn82g",
    'color.skeleton.subtle': "_bfhkh3tw",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk108i",
    'elevation.surface.pressed': "_bfhk1ji5",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk16qz",
    'elevation.surface.overlay.pressed': "_bfhkvq0a",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk1a0f",
    'elevation.surface.raised.pressed': "_bfhkf7u5",
    'elevation.surface.sunken': "_bfhkqbzx",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $c2ad6ece1043f5ce$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $c2ad6ece1043f5ce$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l108i",
    'elevation.surface.pressed': "_1q1l1ji5",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l16qz",
    'elevation.surface.overlay.pressed': "_1q1lvq0a",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l1a0f",
    'elevation.surface.raised.pressed': "_1q1lf7u5",
    'elevation.surface.sunken': "_1q1lqbzx"
};
var $c2ad6ece1043f5ce$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $c2ad6ece1043f5ce$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $c2ad6ece1043f5ce$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $c2ad6ece1043f5ce$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $c2ad6ece1043f5ce$var$Box = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $2q0os.default)(_ref, $c2ad6ece1043f5ce$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $2q0os.default)(htmlAttributes, $c2ad6ece1043f5ce$var$_excluded2);
    var node = /*#__PURE__*/ $1oC0p.createElement(Component, (0, $9jUeC.default)({
        style: style,
        ref: ref,
        className: (0, $iiT5o.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $c2ad6ece1043f5ce$var$backgroundColorMap[backgroundColor],
            backgroundColor && $c2ad6ece1043f5ce$var$isSurfaceToken(backgroundColor) && $c2ad6ece1043f5ce$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $c2ad6ece1043f5ce$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $c2ad6ece1043f5ce$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $c2ad6ece1043f5ce$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $c2ad6ece1043f5ce$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $1oC0p.createElement((0, $2c1i4.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $c2ad6ece1043f5ce$export$2e2bcd8739ae039 = $c2ad6ece1043f5ce$var$Box;
function $c2ad6ece1043f5ce$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $c2ad6ece1043f5ce$var$setSurfaceTokenMap;
}

});
parcelRegister("2c1i4", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $198db4008abb91b0$export$1ca2a26fecb070ae; });

var $1oC0p = parcelRequire("1oC0p");
var $198db4008abb91b0$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $198db4008abb91b0$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($198db4008abb91b0$export$1ca2a26fecb070ae);
};
$198db4008abb91b0$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("fEi4k", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b6489b848bdf699c$export$2e2bcd8739ae039; });
/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $88fXP = parcelRequire("88fXP");

var $9DP70 = parcelRequire("9DP70");

var $9jUeC = parcelRequire("9jUeC");

var $2q0os = parcelRequire("2q0os");

var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");

var $5E2F4 = parcelRequire("5E2F4");

var $39c3M = parcelRequire("39c3M");

var $jer1f = parcelRequire("jer1f");

var $9YZFx = parcelRequire("9YZFx");

var $8iz1y = parcelRequire("8iz1y");

var $jESML = parcelRequire("jESML");
var $b6489b848bdf699c$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "className",
    "isReferenceHidden"
];
var $b6489b848bdf699c$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $b6489b848bdf699c$var$fullWidthStyles = null;
var $b6489b848bdf699c$var$wrapperStyles = {
    root: "_2rkoglpi _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs1cd0 _syaz1fxt _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36"
};
var $b6489b848bdf699c$var$scrollableStyles = null;
var $b6489b848bdf699c$var$blanketStyles = null;
var $b6489b848bdf699c$var$modalStyles = null;
var $b6489b848bdf699c$var$focusRingStyles = {
    root: "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y"
};
var $b6489b848bdf699c$var$DefaultPopupComponent = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, className = props.className, isReferenceHidden = props.isReferenceHidden, htmlAttributes = (0, $2q0os.default)(props, $b6489b848bdf699c$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $9jUeC.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $iiT5o.default)([
            $b6489b848bdf699c$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            !shouldRenderToParent && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ])
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $b6489b848bdf699c$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $b6489b848bdf699c$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $9DP70.default)(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(null), _useState4 = (0, $9DP70.default)(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $jESML.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $8iz1y.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $5E2F4.useLayering)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $1oC0p.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, $88fXP.default)(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ $1oC0p.createElement((0, $jer1f.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update, isReferenceHidden = _ref2.isReferenceHidden;
        var popupContainer = /*#__PURE__*/ $1oC0p.createElement(PopupContainer, {
            className: (0, $iiT5o.default)([
                xcss,
                // @ts-expect-error: `ax` is not typed correctly
                !initialFocusRef && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $39c3M.fg)('platform-design-system-apply-popup-wrapper-focus') && $b6489b848bdf699c$var$focusRingStyles.root
            ]),
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer,
            isReferenceHidden: isReferenceHidden
        }, /*#__PURE__*/ $1oC0p.createElement((0, $9YZFx.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, popupContainer, appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ $1oC0p.createElement("div", {
            className: (0, $iiT5o.default)([
                "_1r04idpf _kqsw1n9t _bfhk10xm"
            ])
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b6489b848bdf699c$export$2e2bcd8739ae039 = $b6489b848bdf699c$var$PopperWrapper;

});
parcelRegister("9YZFx", function(module, exports) {
$parcel$export(module.exports, "RepositionOnUpdate", function () { return $74498dda0fee5d97$export$51eddd7655ca235a; });

var $1oC0p = parcelRequire("1oC0p");
var $74498dda0fee5d97$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, children);
};

});

parcelRegister("8iz1y", function(module, exports) {
$parcel$export(module.exports, "useCloseManager", function () { return $60ab2c39dc6fe119$export$92dae2778ae88f9d; });
// eslint-disable-next-line no-duplicate-imports

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $hshSj = parcelRequire("hshSj");

var $5E2F4 = parcelRequire("5E2F4");

var $39c3M = parcelRequire("39c3M");

var $8JhZq = parcelRequire("8JhZq");

var $gL5cX = parcelRequire("gL5cX");
var $60ab2c39dc6fe119$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $5E2F4.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $gL5cX.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    (0, $1oC0p.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $hshSj.default;
        var inIframe = window && window.self !== window.top && (0, $39c3M.fg)('fix-dropdown-close-outside-iframe');
        var closePopup = function closePopup(event) {
            if (onClose) {
                var _currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest;
                    _currentLevel = (_event$target$closest = event.target.closest("[data-ds--level]")) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute('data-ds--level');
                }
                _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $39c3M.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if (target instanceof HTMLElement) {
                    var _target$closest;
                    var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                    if (layeredElement) {
                        var closeType = layeredElement.getAttribute('[data-ds--close--type]');
                        if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $8JhZq.isInteractiveElement)(document.activeElement) && (0, $39c3M.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $39c3M.fg)('platform_dst_popup-disable-focuslock')) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === 'Escape' || _key === 'Esc' || shouldCloseOnTab && _key === 'Tab') closePopup(event);
            }
        };
        var parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $dH1HR.bind)(window.parent.window, {
            type: 'click',
            listener: onClick,
            options: {
                capture: capture
            }
        });
        var unbind = (0, $hshSj.default);
        if ((0, $39c3M.fg)('popup-onclose-fix')) setTimeout(function() {
            unbind = (0, $dH1HR.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                }
            ]);
        }, 0);
        else unbind = (0, $dH1HR.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $hshSj.default);
        unbindBlur = (0, $dH1HR.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            var _parentUnbind;
            if ((0, $39c3M.fg)('popup-onclose-fix')) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            (_parentUnbind = parentUnbind) === null || _parentUnbind === void 0 || _parentUnbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("8JhZq", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", function () { return $65b07b11c33a02f7$export$3dee5e4542c672d9; });
var $65b07b11c33a02f7$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $65b07b11c33a02f7$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($65b07b11c33a02f7$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("gL5cX", function(module, exports) {
$parcel$export(module.exports, "useAnimationFrame", function () { return $c3351350eb803530$export$641fa9c94086b46e; });

var $1oC0p = parcelRequire("1oC0p");
var $c3351350eb803530$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $1oC0p.useRef)([]);
    var requestFrame = (0, $1oC0p.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $1oC0p.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $1oC0p.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("jESML", function(module, exports) {
$parcel$export(module.exports, "useFocusManager", function () { return $e4fc4001fd78e7eb$export$10c5169755ce7bd7; });

var $1oC0p = parcelRequire("1oC0p");

var $4b05t = parcelRequire("4b05t");

var $hshSj = parcelRequire("hshSj");

var $5E2F4 = parcelRequire("5E2F4");

var $39c3M = parcelRequire("39c3M");

var $gL5cX = parcelRequire("gL5cX");
var $e4fc4001fd78e7eb$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $gL5cX.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $5E2F4.useLayering)(), currentLevel = _useLayering.currentLevel;
    (0, $1oC0p.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $hshSj.default;
        if (shouldDisableFocusTrap && (0, $39c3M.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $hshSj.default;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($4b05t)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("9aWzi", function(module, exports) {
$parcel$export(module.exports, "usePopupAppearance", function () { return $6ae27aaac44d6caf$export$4065aef1d79a5730; });

var $9DP70 = parcelRequire("9DP70");

var $1oC0p = parcelRequire("1oC0p");

var $kfvXY = parcelRequire("kfvXY");
function $6ae27aaac44d6caf$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $kfvXY.UNSAFE_useMediaQuery)('below.sm', function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $1oC0p.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, $9DP70.default)(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("kfvXY", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", function () { return $ebde012e9c977029$export$49e55ae2c03d6045; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $5VjKv = parcelRequire("5VjKv");
var $ebde012e9c977029$var$_window, $ebde012e9c977029$var$_window$matchMedia, $ebde012e9c977029$var$_window2, $ebde012e9c977029$var$_window2$matchMedia, $ebde012e9c977029$var$_window3, $ebde012e9c977029$var$_window3$matchMedia, $ebde012e9c977029$var$_window4, $ebde012e9c977029$var$_window4$matchMedia, $ebde012e9c977029$var$_window5, $ebde012e9c977029$var$_window5$matchMedia, $ebde012e9c977029$var$_window6, $ebde012e9c977029$var$_window6$matchMedia, $ebde012e9c977029$var$_window7, $ebde012e9c977029$var$_window7$matchMedia, $ebde012e9c977029$var$_window8, $ebde012e9c977029$var$_window8$matchMedia, $ebde012e9c977029$var$_window9, $ebde012e9c977029$var$_window9$matchMedia, $ebde012e9c977029$var$_window0, $ebde012e9c977029$var$_window0$matchMedia, $ebde012e9c977029$var$_window1, $ebde012e9c977029$var$_window1$matchMedia;
var $ebde012e9c977029$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($ebde012e9c977029$var$_window = window) === null || $ebde012e9c977029$var$_window === void 0 || ($ebde012e9c977029$var$_window$matchMedia = $ebde012e9c977029$var$_window.matchMedia) === null || $ebde012e9c977029$var$_window$matchMedia === void 0 ? void 0 : $ebde012e9c977029$var$_window$matchMedia.call($ebde012e9c977029$var$_window, (0, $5VjKv.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($ebde012e9c977029$var$_window2 = window) === null || $ebde012e9c977029$var$_window2 === void 0 || ($ebde012e9c977029$var$_window2$matchMedia = $ebde012e9c977029$var$_window2.matchMedia) === null || $ebde012e9c977029$var$_window2$matchMedia === void 0 ? void 0 : $ebde012e9c977029$var$_window2$matchMedia.call($ebde012e9c977029$var$_window2, (0, $5VjKv.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($ebde012e9c977029$var$_window3 = window) === null || $ebde012e9c977029$var$_window3 === void 0 || ($ebde012e9c977029$var$_window3$matchMedia = $ebde012e9c977029$var$_window3.matchMedia) === null || $ebde012e9c977029$var$_window3$matchMedia === void 0 ? void 0 : $ebde012e9c977029$var$_window3$matchMedia.call($ebde012e9c977029$var$_window3, (0, $5VjKv.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($ebde012e9c977029$var$_window4 = window) === null || $ebde012e9c977029$var$_window4 === void 0 || ($ebde012e9c977029$var$_window4$matchMedia = $ebde012e9c977029$var$_window4.matchMedia) === null || $ebde012e9c977029$var$_window4$matchMedia === void 0 ? void 0 : $ebde012e9c977029$var$_window4$matchMedia.call($ebde012e9c977029$var$_window4, (0, $5VjKv.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($ebde012e9c977029$var$_window5 = window) === null || $ebde012e9c977029$var$_window5 === void 0 || ($ebde012e9c977029$var$_window5$matchMedia = $ebde012e9c977029$var$_window5.matchMedia) === null || $ebde012e9c977029$var$_window5$matchMedia === void 0 ? void 0 : $ebde012e9c977029$var$_window5$matchMedia.call($ebde012e9c977029$var$_window5, (0, $5VjKv.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($ebde012e9c977029$var$_window6 = window) === null || $ebde012e9c977029$var$_window6 === void 0 || ($ebde012e9c977029$var$_window6$matchMedia = $ebde012e9c977029$var$_window6.matchMedia) === null || $ebde012e9c977029$var$_window6$matchMedia === void 0 ? void 0 : $ebde012e9c977029$var$_window6$matchMedia.call($ebde012e9c977029$var$_window6, (0, $5VjKv.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($ebde012e9c977029$var$_window7 = window) === null || $ebde012e9c977029$var$_window7 === void 0 || ($ebde012e9c977029$var$_window7$matchMedia = $ebde012e9c977029$var$_window7.matchMedia) === null || $ebde012e9c977029$var$_window7$matchMedia === void 0 ? void 0 : $ebde012e9c977029$var$_window7$matchMedia.call($ebde012e9c977029$var$_window7, (0, $5VjKv.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($ebde012e9c977029$var$_window8 = window) === null || $ebde012e9c977029$var$_window8 === void 0 || ($ebde012e9c977029$var$_window8$matchMedia = $ebde012e9c977029$var$_window8.matchMedia) === null || $ebde012e9c977029$var$_window8$matchMedia === void 0 ? void 0 : $ebde012e9c977029$var$_window8$matchMedia.call($ebde012e9c977029$var$_window8, (0, $5VjKv.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($ebde012e9c977029$var$_window9 = window) === null || $ebde012e9c977029$var$_window9 === void 0 || ($ebde012e9c977029$var$_window9$matchMedia = $ebde012e9c977029$var$_window9.matchMedia) === null || $ebde012e9c977029$var$_window9$matchMedia === void 0 ? void 0 : $ebde012e9c977029$var$_window9$matchMedia.call($ebde012e9c977029$var$_window9, (0, $5VjKv.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($ebde012e9c977029$var$_window0 = window) === null || $ebde012e9c977029$var$_window0 === void 0 || ($ebde012e9c977029$var$_window0$matchMedia = $ebde012e9c977029$var$_window0.matchMedia) === null || $ebde012e9c977029$var$_window0$matchMedia === void 0 ? void 0 : $ebde012e9c977029$var$_window0$matchMedia.call($ebde012e9c977029$var$_window0, (0, $5VjKv.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($ebde012e9c977029$var$_window1 = window) === null || $ebde012e9c977029$var$_window1 === void 0 || ($ebde012e9c977029$var$_window1$matchMedia = $ebde012e9c977029$var$_window1.matchMedia) === null || $ebde012e9c977029$var$_window1$matchMedia === void 0 ? void 0 : $ebde012e9c977029$var$_window1$matchMedia.call($ebde012e9c977029$var$_window1, (0, $5VjKv.media).below.xl.replace('@media ', '').trim())
};
var $ebde012e9c977029$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $1oC0p.useRef)(listener);
    (0, $1oC0p.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $ebde012e9c977029$var$queries[queryString];
    (0, $1oC0p.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $dH1HR.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("5VjKv", function(module, exports) {
$parcel$export(module.exports, "media", function () { return $4501985d8cb7f44d$export$987d49ffe1b0900f; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $4501985d8cb7f44d$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("5CXSN", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", function () { return $418ef3d4041ce1ef$export$7cc5c058dd769dff; });

var $9DP70 = parcelRequire("9DP70");

var $1oC0p = parcelRequire("1oC0p");

var $dWJ7u = parcelRequire("dWJ7u");
var $418ef3d4041ce1ef$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $1oC0p.useState)(function() {
        return (0, $dWJ7u.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $9DP70.default)(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("kUTMq", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", function () { return $f3a44e60c55c1b12$export$5d3a2de79e07b376; });

var $9DP70 = parcelRequire("9DP70");

var $1oC0p = parcelRequire("1oC0p");

var $dWJ7u = parcelRequire("dWJ7u");
var $f3a44e60c55c1b12$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $1oC0p.useState)(function() {
        return (0, $dWJ7u.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $9DP70.default)(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("74uEr", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", function () { return $5260aed7bf6f78cb$export$49e55ae2c03d6045; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $4hBnR = parcelRequire("4hBnR");
var $5260aed7bf6f78cb$var$_window, $5260aed7bf6f78cb$var$_window$matchMedia, $5260aed7bf6f78cb$var$_window2, $5260aed7bf6f78cb$var$_window2$matchMedia, $5260aed7bf6f78cb$var$_window3, $5260aed7bf6f78cb$var$_window3$matchMedia, $5260aed7bf6f78cb$var$_window4, $5260aed7bf6f78cb$var$_window4$matchMedia, $5260aed7bf6f78cb$var$_window5, $5260aed7bf6f78cb$var$_window5$matchMedia, $5260aed7bf6f78cb$var$_window6, $5260aed7bf6f78cb$var$_window6$matchMedia, $5260aed7bf6f78cb$var$_window7, $5260aed7bf6f78cb$var$_window7$matchMedia, $5260aed7bf6f78cb$var$_window8, $5260aed7bf6f78cb$var$_window8$matchMedia, $5260aed7bf6f78cb$var$_window9, $5260aed7bf6f78cb$var$_window9$matchMedia, $5260aed7bf6f78cb$var$_window0, $5260aed7bf6f78cb$var$_window0$matchMedia, $5260aed7bf6f78cb$var$_window1, $5260aed7bf6f78cb$var$_window1$matchMedia;
var $5260aed7bf6f78cb$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($5260aed7bf6f78cb$var$_window = window) === null || $5260aed7bf6f78cb$var$_window === void 0 || ($5260aed7bf6f78cb$var$_window$matchMedia = $5260aed7bf6f78cb$var$_window.matchMedia) === null || $5260aed7bf6f78cb$var$_window$matchMedia === void 0 ? void 0 : $5260aed7bf6f78cb$var$_window$matchMedia.call($5260aed7bf6f78cb$var$_window, (0, $4hBnR.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($5260aed7bf6f78cb$var$_window2 = window) === null || $5260aed7bf6f78cb$var$_window2 === void 0 || ($5260aed7bf6f78cb$var$_window2$matchMedia = $5260aed7bf6f78cb$var$_window2.matchMedia) === null || $5260aed7bf6f78cb$var$_window2$matchMedia === void 0 ? void 0 : $5260aed7bf6f78cb$var$_window2$matchMedia.call($5260aed7bf6f78cb$var$_window2, (0, $4hBnR.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($5260aed7bf6f78cb$var$_window3 = window) === null || $5260aed7bf6f78cb$var$_window3 === void 0 || ($5260aed7bf6f78cb$var$_window3$matchMedia = $5260aed7bf6f78cb$var$_window3.matchMedia) === null || $5260aed7bf6f78cb$var$_window3$matchMedia === void 0 ? void 0 : $5260aed7bf6f78cb$var$_window3$matchMedia.call($5260aed7bf6f78cb$var$_window3, (0, $4hBnR.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($5260aed7bf6f78cb$var$_window4 = window) === null || $5260aed7bf6f78cb$var$_window4 === void 0 || ($5260aed7bf6f78cb$var$_window4$matchMedia = $5260aed7bf6f78cb$var$_window4.matchMedia) === null || $5260aed7bf6f78cb$var$_window4$matchMedia === void 0 ? void 0 : $5260aed7bf6f78cb$var$_window4$matchMedia.call($5260aed7bf6f78cb$var$_window4, (0, $4hBnR.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($5260aed7bf6f78cb$var$_window5 = window) === null || $5260aed7bf6f78cb$var$_window5 === void 0 || ($5260aed7bf6f78cb$var$_window5$matchMedia = $5260aed7bf6f78cb$var$_window5.matchMedia) === null || $5260aed7bf6f78cb$var$_window5$matchMedia === void 0 ? void 0 : $5260aed7bf6f78cb$var$_window5$matchMedia.call($5260aed7bf6f78cb$var$_window5, (0, $4hBnR.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($5260aed7bf6f78cb$var$_window6 = window) === null || $5260aed7bf6f78cb$var$_window6 === void 0 || ($5260aed7bf6f78cb$var$_window6$matchMedia = $5260aed7bf6f78cb$var$_window6.matchMedia) === null || $5260aed7bf6f78cb$var$_window6$matchMedia === void 0 ? void 0 : $5260aed7bf6f78cb$var$_window6$matchMedia.call($5260aed7bf6f78cb$var$_window6, (0, $4hBnR.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($5260aed7bf6f78cb$var$_window7 = window) === null || $5260aed7bf6f78cb$var$_window7 === void 0 || ($5260aed7bf6f78cb$var$_window7$matchMedia = $5260aed7bf6f78cb$var$_window7.matchMedia) === null || $5260aed7bf6f78cb$var$_window7$matchMedia === void 0 ? void 0 : $5260aed7bf6f78cb$var$_window7$matchMedia.call($5260aed7bf6f78cb$var$_window7, (0, $4hBnR.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($5260aed7bf6f78cb$var$_window8 = window) === null || $5260aed7bf6f78cb$var$_window8 === void 0 || ($5260aed7bf6f78cb$var$_window8$matchMedia = $5260aed7bf6f78cb$var$_window8.matchMedia) === null || $5260aed7bf6f78cb$var$_window8$matchMedia === void 0 ? void 0 : $5260aed7bf6f78cb$var$_window8$matchMedia.call($5260aed7bf6f78cb$var$_window8, (0, $4hBnR.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($5260aed7bf6f78cb$var$_window9 = window) === null || $5260aed7bf6f78cb$var$_window9 === void 0 || ($5260aed7bf6f78cb$var$_window9$matchMedia = $5260aed7bf6f78cb$var$_window9.matchMedia) === null || $5260aed7bf6f78cb$var$_window9$matchMedia === void 0 ? void 0 : $5260aed7bf6f78cb$var$_window9$matchMedia.call($5260aed7bf6f78cb$var$_window9, (0, $4hBnR.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($5260aed7bf6f78cb$var$_window0 = window) === null || $5260aed7bf6f78cb$var$_window0 === void 0 || ($5260aed7bf6f78cb$var$_window0$matchMedia = $5260aed7bf6f78cb$var$_window0.matchMedia) === null || $5260aed7bf6f78cb$var$_window0$matchMedia === void 0 ? void 0 : $5260aed7bf6f78cb$var$_window0$matchMedia.call($5260aed7bf6f78cb$var$_window0, (0, $4hBnR.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($5260aed7bf6f78cb$var$_window1 = window) === null || $5260aed7bf6f78cb$var$_window1 === void 0 || ($5260aed7bf6f78cb$var$_window1$matchMedia = $5260aed7bf6f78cb$var$_window1.matchMedia) === null || $5260aed7bf6f78cb$var$_window1$matchMedia === void 0 ? void 0 : $5260aed7bf6f78cb$var$_window1$matchMedia.call($5260aed7bf6f78cb$var$_window1, (0, $4hBnR.media).below.xl.replace('@media ', '').trim())
};
var $5260aed7bf6f78cb$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $1oC0p.useRef)(listener);
    (0, $1oC0p.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $5260aed7bf6f78cb$var$queries[queryString];
    (0, $1oC0p.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $dH1HR.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("4hBnR", function(module, exports) {
$parcel$export(module.exports, "media", function () { return $31e5bf98bfc5195e$export$987d49ffe1b0900f; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $31e5bf98bfc5195e$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});


parcelRegister("3m9lN", function(module, exports) {
$parcel$export(module.exports, "List", function () { return $271aadf8ddaaa14b$export$54c2e3dc7acea9f5; });
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

function $271aadf8ddaaa14b$var$_List(_ref, forwardedRef) {
    var children = _ref.children, testId = _ref.testId, xcss = _ref.xcss;
    return(/*#__PURE__*/ /**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ $1oC0p.createElement("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId
    }, children));
}
var $271aadf8ddaaa14b$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $1oC0p.forwardRef)($271aadf8ddaaa14b$var$_List);

});


parcelRegister("bQ6B4", function(module, exports) {
$parcel$export(module.exports, "TopNavStart", function () { return $89e9ab0780a5b68a$export$4c15269b98c5129; });
/* top-nav-start.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iiT5o = parcelRequire("iiT5o");

var $1oC0p = parcelRequire("1oC0p");

var $39c3M = parcelRequire("39c3M");

var $5lgNX = parcelRequire("5lgNX");
var $89e9ab0780a5b68a$var$styles = {
    root: "_zulp1b66 _yyhykb7n _4t3i1osq _4cvr1h6o _1e0c1txw _glte1ris _15ri1mjv _1gs5usvi"
};
function $89e9ab0780a5b68a$export$4c15269b98c5129(_ref) {
    var children = _ref.children, testId = _ref.testId;
    var ref = (0, $1oC0p.useContext)((0, $5lgNX.TopNavStartAttachRef));
    var elementRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(function() {
        if ((0, $39c3M.fg)('platform_fix_component_state_update_for_suspense')) ref(elementRef.current);
    }, [
        elementRef,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        ref: (0, $39c3M.fg)('platform_fix_component_state_update_for_suspense') ? elementRef : ref,
        "data-testid": testId,
        className: (0, $iiT5o.default)([
            $89e9ab0780a5b68a$var$styles.root
        ])
    }, children);
}

});

parcelRegister("1RpK2", function(module, exports) {
$parcel$export(module.exports, "LinkMenuItem", function () { return $15aeb56fe1cbd11a$export$d2cad7a1cce7b35f; });
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");


var $64R6j = parcelRequire("64R6j");

var $aExgB = parcelRequire("aExgB");

var $3kvXS = parcelRequire("3kvXS");

var $8Zydg = parcelRequire("8Zydg");

var $VABui = parcelRequire("VABui");
var $15aeb56fe1cbd11a$var$listItemStyles = {
    root: "_10m98stt"
};
var $15aeb56fe1cbd11a$var$LinkMenuItemNoRef = function LinkMenuItemNoRef(_ref, forwardedRef) {
    var testId = _ref.testId, actions = _ref.actions, children = _ref.children, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, target = _ref.target, actionsOnHover = _ref.actionsOnHover, isSelected = _ref.isSelected, onClick = _ref.onClick, interactionName = _ref.interactionName, isContentTooltipDisabled = _ref.isContentTooltipDisabled, visualContentRef = _ref.visualContentRef, listItemRef = _ref.listItemRef, isDragging = _ref.isDragging, hasDragIndicator = _ref.hasDragIndicator, dropIndicator = _ref.dropIndicator;
    var itemRef = (0, $1oC0p.useRef)(null);
    (0, $VABui.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected !== null && isSelected !== void 0 ? isSelected : false
    });
    var ref = (0, $1oC0p.useMemo)(function() {
        return (0, $64R6j.default)([
            itemRef,
            listItemRef !== null && listItemRef !== void 0 ? listItemRef : null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ $1oC0p.createElement((0, $3kvXS.ListItem), {
        ref: ref,
        xcss: $15aeb56fe1cbd11a$var$listItemStyles.root
    }, /*#__PURE__*/ $1oC0p.createElement((0, $8Zydg.MenuItemBase), {
        testId: testId,
        description: description,
        actions: actions,
        elemAfter: elemAfter,
        elemBefore: elemBefore,
        href: href,
        target: target,
        actionsOnHover: actionsOnHover,
        isSelected: isSelected,
        onClick: onClick,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
};
var $15aeb56fe1cbd11a$export$d2cad7a1cce7b35f = (0, $aExgB.forwardRefWithGeneric)($15aeb56fe1cbd11a$var$LinkMenuItemNoRef);

});
parcelRegister("8Zydg", function(module, exports) {
$parcel$export(module.exports, "MenuItemBase", function () { return $68be8f349b492789$export$859b390bf71e044e; });
/* menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $363qk = parcelRequire("363qk");

var $9jUeC = parcelRequire("9jUeC");

var $2q0os = parcelRequire("2q0os");

var $iiT5o = parcelRequire("iiT5o");

var $1oC0p = parcelRequire("1oC0p");

var $fYNKD = parcelRequire("fYNKD");

var $6lzqg = parcelRequire("6lzqg");

var $64R6j = parcelRequire("64R6j");

var $39c3M = parcelRequire("39c3M");

var $lvqQZ = parcelRequire("lvqQZ");
var $3XkIQ = parcelRequire("3XkIQ");
var $kbX5S = parcelRequire("kbX5S");

var $gMSrZ = parcelRequire("gMSrZ");
var $9cBfA = parcelRequire("9cBfA");

var $aExgB = parcelRequire("aExgB");

var $aXOg7 = parcelRequire("aXOg7");

var $96tNG = parcelRequire("96tNG");

var $gxqxE = parcelRequire("gxqxE");

var $frJ6H = parcelRequire("frJ6H");
var $68be8f349b492789$var$_excluded = [
    "children",
    "className"
];
function $68be8f349b492789$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68be8f349b492789$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68be8f349b492789$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $363qk.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68be8f349b492789$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

// Using `lazy` so that only consumers who want drag and drop
// need to include code for the drag handle.
var $68be8f349b492789$var$LazyDragHandle = /*#__PURE__*/ (0, $1oC0p.lazy)(function() {
    return (parcelRequire("hR5B6"));
});
var $68be8f349b492789$var$tooltipStyles = {
    root: "_2rkoglpi _11c8dcr7 _1e0c1txw _2lx21bp4 _1bah1h6o _1tkezwfg _p12f1pna _vchhusvi _1q51v77o _y4ti12x7 _85i5v77o _bozg12x7 _bfhkcdhy _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _slp31hna"
};
var $68be8f349b492789$var$MenuItemTooltip = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function MenuItemTooltip(_ref, ref) {
    var children = _ref.children, className = _ref.className, rest = (0, $2q0os.default)(_ref, $68be8f349b492789$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9cBfA.default), (0, $9jUeC.default)({}, rest, {
        // Manually passing on `className` so it gets merged correctly in the build output.
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $iiT5o.default)([
            $68be8f349b492789$var$tooltipStyles.root,
            className
        ]),
        ref: ref
    }), children);
});
function $68be8f349b492789$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
var $68be8f349b492789$var$defaultAvatarValues = {
    size: 'small'
};
var $68be8f349b492789$var$elemAfterDisplayVar = '--elem-after-display';
// Note: actionsOnHoverDisplayVar wll be cleaned up with fg('platform_dst_nav4_actionsonhover_focus_fix')
var $68be8f349b492789$var$actionsOnHoverDisplayVar = '--actions-on-hover-display';
var $68be8f349b492789$var$actionsOnHoverOpacityVar = '--actions-on-hover-opacity';
var $68be8f349b492789$var$actionsOnHoverWidthVar = '--actions-on-hover-width';
var $68be8f349b492789$var$actionsOnHoverPaddingInlineEndVar = '--actions-on-hover-padding';
var $68be8f349b492789$var$notchColorVar = '--notch-color';
// Note: this is also used in `drag-handle.tsx`
var $68be8f349b492789$var$dragHandleDisplayVar = '--drag-handle-display';
var $68be8f349b492789$var$dragCursorAnimation = null;
/**
 * ## 🤹 `position:relative`
 *
 * We need `position:relative` on an element that takes
 * up the full size of the interactive element so we
 * can correctly use `position:absolute` to place:
 * 1. the notch for links
 * 2. drop indicators for drag and drop
 * 3. a child of button / anchor to stretch it out to
 *    increase it's pressable area.
 *
 * ⛔️ We cannot add `position:relative` _only_ on the
 * button / anchor as that will cause sibling elements
 * to be rendered under the button / anchor when setting
 * a background color on the button / anchor.
 *
 * 📖 Note: `position:relative` elements are painted after
 * elements with `position:static` (the default)
 * https://drafts.csswg.org/css-position-4/#painting-order
 *
 * ⛔️ We cannot add `position:relative` to the container
 * element, as then the `:focus` ring styles on the
 * button / anchor can be cut off by the next sibling if it has
 * has a background color set (eg when selected)
 *
 * ✅ Add `position:relative` to all first level descendants
 * of the container element so that we don't impact DOM ordered
 * paint ordering within the item and the button / anchor focus
 * ring can still bleed over siblings
 *
 * 📖 We could use `> * { position: relative; }` on the container,
 * but that would violate our styling standard.
 */ var $68be8f349b492789$var$topLevelSiblingStyles = {
    root: "_kqswh2mm"
};
/**
 * All slots on the menu item (eg `elemBefore`) are rendered as siblings
 * of our main button / anchor element and they are visually placed on
 * top of the main button / anchor.
 *
 * 📖 This is done so that we don't nest interactive elements in our markup.
 *
 * ✅ This is great when element in the slot is an interactive element
 * as we don't want the main menu item button / anchor to be triggered
 * when interacting with the element in the slot.
 *
 * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
 * prevent the main button / anchor (that is visually behind the element in
 * the slot) from being clicked. The element in the slot is a sibling of our
 * main button / anchor (not a child of it) so clicking on the element in the
 * slot will not bubble up to the button / anchor.
 *
 * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
 * element so that static content in a slot does not prevent clicking on the main
 * button / anchor.
 */ var $68be8f349b492789$var$onTopOfButtonOrAnchorStyles = {
    root: "_18ukglyw"
};
var $68be8f349b492789$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup="true"])';
var $68be8f349b492789$var$containerStyles = {
    root: "_2rkoglpi _vchhusvi _1e0c11p5 _yv0e7dup _2z05hkll _1lmcu4vt _1ul9t9kd _4t3iviql _4cvr1h6o _uiztglyw _syaz1gjq _1yyu1j28 _91ju1txw _1swv108i _irr3108i",
    actionsOnHoverFocusFixEnabled: "_uomdidpf _pmxpidpf _db80idpf _qxq9kb7n _1rbv1wug _kwq51b66 _t7p8kb7n _g4kikb7n _91nl1wug _ynyi1wug _iy5o1b66 _v4o21b66",
    actionsOnHoverFocusFixDisabled: "_ek6gglyw _1ojv1txw _1brr1txw _109x1txw",
    removeElemAfter: "_91juglyw",
    showHoverActionsWithFocusFixEnabled: "_uomdkb7n _pmxp1wug _db801b66",
    showHoverActionsWithFocusFixDisabled: "_ek6g1txw",
    removeElemAfterOnHoverOrOpenNestedPopup: "_1djyglyw _1mfcglyw _1sjuglyw",
    selected: "_bfhkfg4m _syazaqb7 _1yyu1fvw _1swvi1yw _30l3aqb7 _irr3i1yw",
    disabled: "_syaz1lh4 _irr3n7od",
    hasDescription: "_4t3i1wto",
    dragging: "_tzy41ou4"
};
var $68be8f349b492789$var$buttonOrAnchorStyles = {
    root: "_2rkoglpi _yyhyjvu9 _1ii7kb7n _1e0c11p5 _yv0enbh3 _2z05nbh3 _y4ti1b66 _bozg1b66 _1q511b66 _85i51b66 _bfhk1j28 _syaz1gjq _4cvr1h6o _y3gnv2br _14iu1ji5",
    selected: "_syazaqb7 _14iu19ru",
    hasDragIndicator: "_1ifmglyw _1cykglyw _x0kw1txw _11om6b4r _7psyru3m _1uy01amc _bir2q7pw"
};
var $68be8f349b492789$var$extendButtonOrAnchorStyles = {
    root: "_1r04ze3t _kqswstnw"
};
var $68be8f349b492789$var$notchStyles = {
    root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
var $68be8f349b492789$var$actionStyles = {
    root: "_zulp1b66 _nd5lbc26 _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
var $68be8f349b492789$var$actionsOnHoverStyles = {
    root: "_nd5l16dh _zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1guo18uv _12s918uv",
    focusFixEnabled: "_1e0c1txw _tzy4pnc3 _1bsbty16 _y4tidria",
    focusFixDisabled: "_1e0c1c3z _y4ti1b66"
};
var $68be8f349b492789$var$textStyles = {
    root: "_zulpv77o _1reo15vq _18m915vq _y4ti1b66 _bozg1b66 _1e0c1txw _2lx21bp4 _1ul91c9m _1guo18uv _12s918uv",
    noElemBeforeIndent: "_bozg12x7"
};
var $68be8f349b492789$var$elemBeforeStyles = {
    root: "_nd5l17zh _1reo15vq _18m915vq _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66 _vchh1ntv _1guo18uv _12s918uv"
};
var $68be8f349b492789$var$elemAfterStyles = {
    root: "_nd5l16dh _1reo15vq _18m915vq _1e0c13yo _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
/**
 * We are using a wrapping element for our interactive content
 * even though only the `Text` element is the only thing not using `position:absolute`
 *
 * Rationale:
 * - Super clear that everything inside the interactive content should be in a specific slot in the grid
 * - To work around a browser bug in Safari where it does not work well with `position:absolute`
 *   on a subgrid child.
 *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
 */ var $68be8f349b492789$var$interactiveContentStyles = {
    root: "_nd5l19l3 _1e0c1txw _2lx21bp4 _ae4v1h6o"
};
function $68be8f349b492789$var$getTextColor(_ref2) {
    var isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected;
    if (isDisabled) return 'color.text.disabled';
    if (isSelected) return 'color.text.selected';
    return 'color.text.subtle';
}
/**
 * Includes all props that are used by any menu item, as MenuItembase is the base component for all menu item components.
 *
 * We also include additional `aria` props to support the menu item being a trigger for the FlyoutMenuItem popup and for the
 * expanded content for ExpandableMenuItem.
 */ /**
 * This is the internal version of the component, to be passed into `forwardRef`.
 *
 * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
 * This can be inferred from the type of the `onClick` prop.
 */ var $68be8f349b492789$var$MenuItemBaseNoRef = function MenuItemBaseNoRef(_ref3, forwardedRef) {
    var id = _ref3.id, testId = _ref3.testId, actions = _ref3.actions, actionsOnHover = _ref3.actionsOnHover, children = _ref3.children, description = _ref3.description, elemAfter = _ref3.elemAfter, elemBefore = _ref3.elemBefore, href = _ref3.href, target = _ref3.target, isDisabled = _ref3.isDisabled, isSelected = _ref3.isSelected, onClick = _ref3.onClick, ariaControls = _ref3.ariaControls, ariaExpanded = _ref3.ariaExpanded, ariaHasPopup = _ref3.ariaHasPopup, interactionName = _ref3.interactionName, isContentTooltipDisabled = _ref3.isContentTooltipDisabled, visualContentRef = _ref3.visualContentRef, isDragging = _ref3.isDragging, hasDragIndicator = _ref3.hasDragIndicator, dropIndicator = _ref3.dropIndicator;
    var level = (0, $96tNG.useLevel)();
    var setFlyoutMenuOpen = (0, $gxqxE.useSetFlyoutMenuOpen)();
    var isFlyoutMenuOpen = (0, $gxqxE.useFlyoutMenuOpen)();
    var isLink = typeof href !== 'undefined';
    var labelRef = (0, $1oC0p.useRef)(null);
    var descriptionRef = (0, $1oC0p.useRef)(null);
    var tooltipOnClick = (0, $1oC0p.useRef)(null);
    var handleClick = (0, $1oC0p.useCallback)(function(event, analyticsEvent) {
        var _tooltipOnClick$curre;
        onClick === null || onClick === void 0 || onClick(event, analyticsEvent);
        // Toggle flyout menu open state when inside a flyout context provider
        setFlyoutMenuOpen(!isFlyoutMenuOpen);
        (_tooltipOnClick$curre = tooltipOnClick.current) === null || _tooltipOnClick$curre === void 0 || _tooltipOnClick$curre.call(tooltipOnClick, event);
    }, [
        onClick,
        setFlyoutMenuOpen,
        isFlyoutMenuOpen
    ]);
    /**
   * Show the tooltip if _either_ label or description is truncated
   */ var canTooltipAppear = (0, $1oC0p.useCallback)(function() {
        if (isContentTooltipDisabled) return false;
        // Show tooltip if _either_ label or description are clamped
        var label = labelRef.current;
        var description = descriptionRef.current;
        if (label && $68be8f349b492789$var$isTextClamped(label)) return true;
        return Boolean(description && $68be8f349b492789$var$isTextClamped(description));
    }, [
        isContentTooltipDisabled
    ]);
    // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    var showElemBefore = elemBefore !== (0, $frJ6H.COLLAPSE_ELEM_BEFORE);
    var interactiveElemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        className: (0, $iiT5o.default)([
            $68be8f349b492789$var$interactiveContentStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        // This extends the clickable area of nested menu items to the width
        // of the root level menu items, while being visually indented.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            insetInlineStart: "calc(-1 * ".concat(level, " * ").concat((0, $aXOg7.expandableMenuItemIndentation), ")")
        },
        "aria-hidden": "true",
        className: (0, $iiT5o.default)([
            $68be8f349b492789$var$extendButtonOrAnchorStyles.root
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        className: (0, $iiT5o.default)([
            $68be8f349b492789$var$textStyles.root,
            !showElemBefore && $68be8f349b492789$var$textStyles.noElemBeforeIndent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kbX5S.default), {
        weight: "medium",
        maxLines: 1,
        color: $68be8f349b492789$var$getTextColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        ref: labelRef
    }, children), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kbX5S.default), {
        color: isDisabled ? 'color.text.disabled' : 'color.text.subtle',
        size: "small",
        maxLines: 1,
        ref: descriptionRef
    }, description)), hasDragIndicator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($68be8f349b492789$var$LazyDragHandle, null)) : null, dropIndicator);
    /**
   *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
   *
   * Note: we also remove the `elemAfter` when showing `actionsOnHover`
   */ var showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $6lzqg.AvatarContext).Provider, {
        value: $68be8f349b492789$var$defaultAvatarValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        ref: visualContentRef,
        "data-testid": testId ? "".concat(testId, "-container") : undefined,
        "data-selected": isSelected,
        className: (0, $iiT5o.default)([
            $68be8f349b492789$var$containerStyles.root,
            (0, $39c3M.fg)('platform_dst_nav4_actionsonhover_focus_fix') ? $68be8f349b492789$var$containerStyles.actionsOnHoverFocusFixEnabled : $68be8f349b492789$var$containerStyles.actionsOnHoverFocusFixDisabled,
            isSelected && $68be8f349b492789$var$containerStyles.selected,
            isDragging && $68be8f349b492789$var$containerStyles.dragging,
            description && $68be8f349b492789$var$containerStyles.hasDescription,
            showHoverActionsWhenNotHovered && !(0, $39c3M.fg)('platform_dst_nav4_actionsonhover_focus_fix') && $68be8f349b492789$var$containerStyles.showHoverActionsWithFocusFixDisabled,
            showHoverActionsWhenNotHovered && (0, $39c3M.fg)('platform_dst_nav4_actionsonhover_focus_fix') && $68be8f349b492789$var$containerStyles.showHoverActionsWithFocusFixEnabled,
            showHoverActionsWhenNotHovered && elemAfter && $68be8f349b492789$var$containerStyles.removeElemAfter,
            actionsOnHover && elemAfter && $68be8f349b492789$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
            isDisabled && $68be8f349b492789$var$containerStyles.disabled
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $gMSrZ.default), {
        content: function content() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", null, children), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", null, description) : null);
        },
        position: "right",
        component: $68be8f349b492789$var$MenuItemTooltip,
        ignoreTooltipPointerEvents: true,
        hideTooltipOnMouseDown: true,
        isScreenReaderAnnouncementDisabled: true,
        canAppear: canTooltipAppear
    }, function(tooltipProps) {
        // Putting the tooltip onClick into a ref.
        // This way we don't need to create a new `onClick` function on each
        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
        tooltipOnClick.current = tooltipProps.onClick;
        var sharedProps = $68be8f349b492789$var$_objectSpread($68be8f349b492789$var$_objectSpread({}, tooltipProps), {}, {
            'aria-controls': ariaControls,
            'aria-haspopup': ariaHasPopup,
            ref: (0, $64R6j.default)([
                forwardedRef,
                tooltipProps.ref
            ]),
            id: id,
            testId: testId,
            interactionName: interactionName
        });
        return isLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lvqQZ.default), (0, $9jUeC.default)({}, sharedProps, {
            onClick: handleClick,
            xcss: (0, $fYNKD.cx)($68be8f349b492789$var$buttonOrAnchorStyles.root, $68be8f349b492789$var$topLevelSiblingStyles.root, isSelected && $68be8f349b492789$var$buttonOrAnchorStyles.selected, hasDragIndicator && $68be8f349b492789$var$buttonOrAnchorStyles.hasDragIndicator),
            style: {
                textDecoration: 'none'
            },
            "aria-current": isSelected ? 'page' : undefined,
            href: href,
            target: target,
            draggable: hasDragIndicator ? undefined : false
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
            "aria-hidden": "true",
            className: (0, $iiT5o.default)([
                $68be8f349b492789$var$notchStyles.root
            ])
        }), interactiveElemContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3XkIQ.default), (0, $9jUeC.default)({}, sharedProps, {
            onClick: handleClick,
            xcss: (0, $fYNKD.cx)($68be8f349b492789$var$buttonOrAnchorStyles.root, $68be8f349b492789$var$topLevelSiblingStyles.root, isSelected && $68be8f349b492789$var$buttonOrAnchorStyles.selected, hasDragIndicator && $68be8f349b492789$var$buttonOrAnchorStyles.hasDragIndicator),
            "aria-expanded": ariaExpanded,
            isDisabled: isDisabled
        }), interactiveElemContent);
    }), showElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        className: (0, $iiT5o.default)([
            $68be8f349b492789$var$elemBeforeStyles.root,
            $68be8f349b492789$var$topLevelSiblingStyles.root,
            $68be8f349b492789$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemBefore), actionsOnHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        className: (0, $iiT5o.default)([
            $68be8f349b492789$var$actionsOnHoverStyles.root,
            (0, $39c3M.fg)('platform_dst_nav4_actionsonhover_focus_fix') ? $68be8f349b492789$var$actionsOnHoverStyles.focusFixEnabled : $68be8f349b492789$var$actionsOnHoverStyles.focusFixDisabled
        ])
    }, actionsOnHover), elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        className: (0, $iiT5o.default)([
            $68be8f349b492789$var$elemAfterStyles.root,
            $68be8f349b492789$var$topLevelSiblingStyles.root,
            $68be8f349b492789$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemAfter), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        className: (0, $iiT5o.default)([
            $68be8f349b492789$var$actionStyles.root,
            $68be8f349b492789$var$topLevelSiblingStyles.root,
            $68be8f349b492789$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, actions)));
};
var $68be8f349b492789$export$859b390bf71e044e = (0, $aExgB.forwardRefWithGeneric)($68be8f349b492789$var$MenuItemBaseNoRef);

});
parcelRegister("6lzqg", function(module, exports) {
$parcel$export(module.exports, "AvatarContext", function () { return $49f02e71b8a0b38d$export$a20dad690e1279e2; });
$parcel$export(module.exports, "useAvatarContext", function () { return $49f02e71b8a0b38d$export$b50b87a1c4086b23; });
$parcel$export(module.exports, "AvatarContentContext", function () { return $49f02e71b8a0b38d$export$b983474ddd0b6d28; });
$parcel$export(module.exports, "useAvatarContent", function () { return $49f02e71b8a0b38d$export$79d078b69b7e4842; });
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", function () { return $49f02e71b8a0b38d$export$6b4cbd90d24955ad; });
$parcel$export(module.exports, "useEnsureIsInsideAvatar", function () { return $49f02e71b8a0b38d$export$7db5c57474082dd9; });

var $1oC0p = parcelRequire("1oC0p");
var $49f02e71b8a0b38d$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
var $49f02e71b8a0b38d$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $1oC0p.useContext)($49f02e71b8a0b38d$export$a20dad690e1279e2);
};
var $49f02e71b8a0b38d$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
var $49f02e71b8a0b38d$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $1oC0p.createContext)($49f02e71b8a0b38d$var$defaultAvatarContentProps);
var $49f02e71b8a0b38d$export$79d078b69b7e4842 = function useAvatarContent() {
    return (0, $1oC0p.useContext)($49f02e71b8a0b38d$export$b983474ddd0b6d28);
};
var $49f02e71b8a0b38d$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $1oC0p.createContext)(false);
var $49f02e71b8a0b38d$export$7db5c57474082dd9 = function useEnsureIsInsideAvatar() {
    var context = (0, $1oC0p.useContext)($49f02e71b8a0b38d$export$6b4cbd90d24955ad);
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});

parcelRegister("aXOg7", function(module, exports) {
$parcel$export(module.exports, "expandableMenuItemIndentation", function () { return $7fb666726e2b56c7$export$d492445a79a49b48; });
/**
 * _Internally_ shared value for the menu item indentation. Used in:
 * - Expandable menu item content, to add padding for each expandable level
 * - The base menu item, to set the negative inset to extend the clickable area of nested menu items
 * to the root level menu items.
 *
 * Internal to the package only. Should not be exported from the package.
 *
 * Note: We're unable to use a token() call here, as Compiled complains about function calls in imported
 * values - it requires statically defined values only.
 *
 * @private
 * @internal
 */ var $7fb666726e2b56c7$export$d492445a79a49b48 = '12px';

});

parcelRegister("96tNG", function(module, exports) {
$parcel$export(module.exports, "useLevel", function () { return $6a0bca57e3c2e391$export$fdfe9e5e8183d4f2; });
$parcel$export(module.exports, "useAreAllAncestorsExpanded", function () { return $6a0bca57e3c2e391$export$57108b5f08ae5194; });

var $1oC0p = parcelRequire("1oC0p");

var $lmxXn = parcelRequire("lmxXn");

var $cHafX = parcelRequire("cHafX");
var $6a0bca57e3c2e391$export$9c01e0e6a504d553 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $6a0bca57e3c2e391$export$c856e5885cc34d81 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $6a0bca57e3c2e391$export$48cb11cb8691f597 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $6a0bca57e3c2e391$export$572ce188c913ceba = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $6a0bca57e3c2e391$export$650d12d3c2ddb8fc = (0, $cHafX.ExpandableMenuItemLevelContext);
var $6a0bca57e3c2e391$export$37e565a09598825e = function useIsExpanded() {
    var context = (0, $1oC0p.useContext)($6a0bca57e3c2e391$export$c856e5885cc34d81);
    (0, $lmxXn.default)(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
var $6a0bca57e3c2e391$export$c9a171ea8de5861b = function useSetIsExpanded() {
    var context = (0, $1oC0p.useContext)($6a0bca57e3c2e391$export$48cb11cb8691f597);
    (0, $lmxXn.default)(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
var $6a0bca57e3c2e391$export$56c8438498b72c7a = function useOnExpansionToggle() {
    return (0, $1oC0p.useContext)($6a0bca57e3c2e391$export$572ce188c913ceba);
};
var $6a0bca57e3c2e391$export$fdfe9e5e8183d4f2 = function useLevel() {
    return (0, $1oC0p.useContext)($6a0bca57e3c2e391$export$650d12d3c2ddb8fc);
};
var $6a0bca57e3c2e391$export$57108b5f08ae5194 = function useAreAllAncestorsExpanded() {
    var _useContext;
    return (_useContext = (0, $1oC0p.useContext)($6a0bca57e3c2e391$export$9c01e0e6a504d553)) !== null && _useContext !== void 0 ? _useContext : true;
};

});
parcelRegister("cHafX", function(module, exports) {
$parcel$export(module.exports, "ExpandableMenuItemLevelContext", function () { return $93e174dfa8574be2$export$f8d6463f9b5ca897; });

var $1oC0p = parcelRequire("1oC0p");
var $93e174dfa8574be2$export$f8d6463f9b5ca897 = /*#__PURE__*/ (0, $1oC0p.createContext)(0);

});


parcelRegister("gxqxE", function(module, exports) {
$parcel$export(module.exports, "useFlyoutMenuOpen", function () { return $c0a4510c050b4242$export$6927118f874a49aa; });
$parcel$export(module.exports, "useSetFlyoutMenuOpen", function () { return $c0a4510c050b4242$export$538ac1aa421adb94; });

var $1oC0p = parcelRequire("1oC0p");

var $hshSj = parcelRequire("hshSj");
var $c0a4510c050b4242$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $1oC0p.createContext)(false);
var $c0a4510c050b4242$export$4c55b1c61a116b42 = /*#__PURE__*/ (0, $1oC0p.createContext)((0, $hshSj.default));
var $c0a4510c050b4242$export$6927118f874a49aa = function useFlyoutMenuOpen() {
    return (0, $1oC0p.useContext)($c0a4510c050b4242$export$efa4d9670e96ac31);
};
var $c0a4510c050b4242$export$538ac1aa421adb94 = function useSetFlyoutMenuOpen() {
    return (0, $1oC0p.useContext)($c0a4510c050b4242$export$4c55b1c61a116b42);
};

});

parcelRegister("frJ6H", function(module, exports) {
$parcel$export(module.exports, "COLLAPSE_ELEM_BEFORE", function () { return $b3ec5df7fa2bcb8b$export$f4b8e24fae579c6f; });
/**
 * A symbol to collapse the `elemBefore` slot.
 * This should be placed in the `elemBefore` prop of supported menu items.
 */ var $b3ec5df7fa2bcb8b$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');

});

parcelRegister("hR5B6", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("53ccg")).then(()=>parcelRequire('2p3GC'));

});


parcelRegister("VABui", function(module, exports) {
$parcel$export(module.exports, "useScrollMenuItemIntoView", function () { return $0ad1b7b4b384412a$export$2c52ec851fcc6058; });

var $1oC0p = parcelRequire("1oC0p");

var $lmxXn = parcelRequire("lmxXn");

var $96tNG = parcelRequire("96tNG");
function $0ad1b7b4b384412a$var$scrollMenuItemIntoView(element) {
    var _element$scrollIntoVi;
    /**
   * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
   * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
   * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
   *
   * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
   */ if (typeof element.scrollIntoViewIfNeeded === 'function') {
        element.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    (_element$scrollIntoVi = element.scrollIntoView) === null || _element$scrollIntoVi === void 0 || _element$scrollIntoVi.call(element, {
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function $0ad1b7b4b384412a$export$2c52ec851fcc6058(_ref) {
    var elementRef = _ref.elementRef, isSelected = _ref.isSelected;
    var areAllAncestorsExpanded = (0, $96tNG.useAreAllAncestorsExpanded)();
    var waitingStateRef = (0, $1oC0p.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $1oC0p.useEffect)(function() {
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            var shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            var element = elementRef.current;
            (0, $lmxXn.default)(element, 'Element ref must be set');
            $0ad1b7b4b384412a$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}

});


parcelRegister("f3Vh4", function(module, exports) {
$parcel$export(module.exports, "MenuList", function () { return $af73904d1ea45df7$export$d4c4e98c5044dc8; });

var $3m9lN = parcelRequire("3m9lN");
var $af73904d1ea45df7$export$d4c4e98c5044dc8 = (0, $3m9lN.List);

});

parcelRegister("5vd7q", function(module, exports) {
$parcel$export(module.exports, "AppLogo", function () { return $401a061b63502a78$export$113a612889e1565d; });
/* app-logo.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iiT5o = parcelRequire("iiT5o");

var $1oC0p = parcelRequire("1oC0p");

var $fYNKD = parcelRequire("fYNKD");

var $cMmDg = parcelRequire("cMmDg");
var $26wrD = parcelRequire("26wrD");
var $fOPmN = parcelRequire("fOPmN");

var $gMSrZ = parcelRequire("gMSrZ");

var $emfz8 = parcelRequire("emfz8");

var $3esCB = parcelRequire("3esCB");
var $401a061b63502a78$var$anchorStyles = {
    root: "_2rko19bv _1e0c1txw _4cvr1h6o _4t3izwfg _1o9zidpf _ahbq1b66 _1toh1r31 _5jyqglyw _mrqmnqa1 _1w901kw7",
    interactionStates: "_irr3166n _1di61wwy",
    interactionStatesCustomTheming: "_irr31rps _1di6yhlj"
};
var $401a061b63502a78$var$logoWrapperStyles = {
    root: "_18zr1b66"
};
var $401a061b63502a78$var$iconContainerStyles = {
    root: "_1reo15vq _18m915vq _1e0c1txw _p12f1tcg"
};
var $401a061b63502a78$var$logoTextStyles = {
    root: "_1bsb1ris _p12fnklw _uiztglyw _y4tiv77o _1e0cglyw _10y418uv"
};
function $401a061b63502a78$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
var $401a061b63502a78$export$113a612889e1565d = function AppLogo(_ref) {
    var name = _ref.name, label = _ref.label, href = _ref.href, icon = _ref.icon, onClick = _ref.onClick;
    var ref = (0, $1oC0p.useRef)(null);
    var nameRef = (0, $1oC0p.useRef)(null);
    var hasCustomTheme = (0, $emfz8.useHasCustomTheme)();
    /**
   * Show the tooltip if the name is truncated
   */ var canTooltipAppear = (0, $1oC0p.useCallback)(function() {
        var text = nameRef.current;
        return Boolean(text && $401a061b63502a78$var$isTextClamped(text));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cMmDg.default), {
        ref: ref,
        "aria-label": label,
        href: href,
        xcss: (0, $fYNKD.cx)($401a061b63502a78$var$anchorStyles.root, hasCustomTheme ? $401a061b63502a78$var$anchorStyles.interactionStatesCustomTheming : $401a061b63502a78$var$anchorStyles.interactionStates),
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $26wrD.default), {
        space: "space.075",
        alignBlock: "center",
        xcss: $401a061b63502a78$var$logoWrapperStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        className: (0, $iiT5o.default)([
            $401a061b63502a78$var$iconContainerStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3esCB.LogoRenderer), {
        shouldUseNewLogoDesign: true,
        logoOrIcon: icon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        className: (0, $iiT5o.default)([
            $401a061b63502a78$var$logoTextStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $gMSrZ.default), {
        content: name,
        position: "bottom",
        ignoreTooltipPointerEvents: true,
        hideTooltipOnMouseDown: true,
        isScreenReaderAnnouncementDisabled: true,
        canAppear: canTooltipAppear
    }, function(tooltipProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fOPmN.default), {
            "aria-hidden": true,
            color: "inherit",
            weight: "semibold",
            maxLines: 1,
            ref: nameRef
        }, name));
    }))));
};

});
parcelRegister("26wrD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $18854f2356f1e610$export$2e2bcd8739ae039; });

var $88fXP = parcelRequire("88fXP");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $cV0yz = parcelRequire("cV0yz");

var $1tRz6 = parcelRequire("1tRz6");
var $18854f2356f1e610$var$flexGrowMap = {
    hug: (0, $cV0yz.xcss)({
        flexGrow: 0
    }),
    fill: (0, $cV0yz.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $18854f2356f1e610$var$separatorStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $18854f2356f1e610$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $3dJ4i.jsx)("span", {
        css: $18854f2356f1e610$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $18854f2356f1e610$var$Inline = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, id = _ref2.id, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $3dJ4i.jsx)($18854f2356f1e610$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $1oC0p.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $18854f2356f1e610$var$flexGrowMap[grow]
    ].concat((0, $88fXP.default)(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $3dJ4i.jsx)((0, $1tRz6.default), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$18854f2356f1e610$var$Inline.displayName = 'Inline';
var $18854f2356f1e610$export$2e2bcd8739ae039 = $18854f2356f1e610$var$Inline;

});
parcelRegister("1tRz6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $11420cc82d77bdf4$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $iBQlw = parcelRequire("iBQlw");

var $cV0yz = parcelRequire("cV0yz");
var $11420cc82d77bdf4$var$justifyContentMap = {
    start: (0, $3dJ4i.css)({
        justifyContent: 'start'
    }),
    center: (0, $3dJ4i.css)({
        justifyContent: 'center'
    }),
    end: (0, $3dJ4i.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3dJ4i.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3dJ4i.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3dJ4i.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3dJ4i.css)({
        justifyContent: 'stretch'
    })
};
var $11420cc82d77bdf4$var$flexDirectionMap = {
    column: (0, $3dJ4i.css)({
        flexDirection: 'column'
    }),
    row: (0, $3dJ4i.css)({
        flexDirection: 'row'
    })
};
var $11420cc82d77bdf4$var$flexWrapMap = {
    wrap: (0, $3dJ4i.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $3dJ4i.css)({
        flexWrap: 'nowrap'
    })
};
var $11420cc82d77bdf4$var$alignItemsMap = {
    start: (0, $3dJ4i.css)({
        alignItems: 'start'
    }),
    center: (0, $3dJ4i.css)({
        alignItems: 'center'
    }),
    baseline: (0, $3dJ4i.css)({
        alignItems: 'baseline'
    }),
    end: (0, $3dJ4i.css)({
        alignItems: 'end'
    }),
    stretch: (0, $3dJ4i.css)({
        alignItems: 'stretch'
    })
};
var $11420cc82d77bdf4$var$baseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $11420cc82d77bdf4$var$Flex = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $cV0yz.parseXcss)(xcss);
    return (0, $3dJ4i.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $11420cc82d77bdf4$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $iBQlw.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $iBQlw.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $iBQlw.spaceStylesMap).rowGap[rowGap],
            alignItems && $11420cc82d77bdf4$var$alignItemsMap[alignItems],
            direction && $11420cc82d77bdf4$var$flexDirectionMap[direction],
            justifyContent && $11420cc82d77bdf4$var$justifyContentMap[justifyContent],
            wrap && $11420cc82d77bdf4$var$flexWrapMap[wrap],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$11420cc82d77bdf4$var$Flex.displayName = 'Flex';
var $11420cc82d77bdf4$export$2e2bcd8739ae039 = $11420cc82d77bdf4$var$Flex;

});


parcelRegister("fOPmN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b8435ee3f2385829$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $lmxXn = parcelRequire("lmxXn");

var $7CqPI = parcelRequire("7CqPI");

var $1ftBY = parcelRequire("1ftBY");

var $iBQlw = parcelRequire("iBQlw");
var $b8435ee3f2385829$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $b8435ee3f2385829$var$resetStyles = (0, $3dJ4i.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
var $b8435ee3f2385829$var$strongStyles = (0, $3dJ4i.css)({
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
var $b8435ee3f2385829$var$emStyles = (0, $3dJ4i.css)({
    fontStyle: 'italic'
});
var $b8435ee3f2385829$var$textAlignMap = {
    center: (0, $3dJ4i.css)({
        textAlign: 'center'
    }),
    end: (0, $3dJ4i.css)({
        textAlign: 'end'
    }),
    start: (0, $3dJ4i.css)({
        textAlign: 'start'
    })
};
var $b8435ee3f2385829$var$truncationStyles = (0, $3dJ4i.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $b8435ee3f2385829$var$wordBreakMap = {
    breakAll: (0, $3dJ4i.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $b8435ee3f2385829$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $1ftBY.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $iBQlw.inverseColorMap).hasOwnProperty(surface)) return (0, $iBQlw.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $b8435ee3f2385829$var$Text = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $lmxXn.default)($b8435ee3f2385829$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $7CqPI.useHasTextAncestor)();
    var color = $b8435ee3f2385829$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = (0, $3dJ4i.jsx)(Component, {
        ref: ref,
        css: [
            $b8435ee3f2385829$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $iBQlw.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $iBQlw.textColorStylesMap)[color],
            maxLines && $b8435ee3f2385829$var$truncationStyles,
            maxLines === 1 && $b8435ee3f2385829$var$wordBreakMap.breakAll,
            align && $b8435ee3f2385829$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $iBQlw.textWeightStylesMap)[weight],
            Component === 'em' && $b8435ee3f2385829$var$emStyles,
            Component === 'strong' && $b8435ee3f2385829$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $3dJ4i.jsx)((0, $7CqPI.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $b8435ee3f2385829$export$2e2bcd8739ae039 = $b8435ee3f2385829$var$Text;

});


parcelRegister("UtNlw", function(module, exports) {
$parcel$export(module.exports, "AIChatWidget", function () { return (parcelRequire("68u3n")).AIChatWidget; });

var $68u3n = parcelRequire("68u3n");

});
parcelRegister("68u3n", function(module, exports) {
$parcel$export(module.exports, "AIChatWidget", function () { return $0e4b82b5fc4efa44$export$10ed193107df4e03; });

var $1oC0p = parcelRequire("1oC0p");
const $0e4b82b5fc4efa44$var$WIDGET_CONTAINER_SELECTOR = "#atlassian-conversation-assistant-widget";
const $0e4b82b5fc4efa44$var$CHAT_WIDGET_LOADER_SCRIPT_URL = "https://jcs-chat-widget.atlassian.com/assets/loader.js";
const $0e4b82b5fc4efa44$var$CHAT_WIDGET_SCRIPT_ID = "ai-chat-widget-loader";
const $0e4b82b5fc4efa44$export$10ed193107df4e03 = ()=>{
    (0, $1oC0p.useEffect)(()=>{
        // Add SSR guards
        if (typeof window === "undefined" || typeof document === "undefined") return;
        const loadScript = (url)=>{
            const script = document.createElement("script");
            script.src = url;
            script.defer = true;
            script.id = $0e4b82b5fc4efa44$var$CHAT_WIDGET_SCRIPT_ID;
            document.body.append(script);
        };
        const checkAndLoadWidget = ()=>{
            try {
                const widget = document.querySelector($0e4b82b5fc4efa44$var$WIDGET_CONTAINER_SELECTOR);
                const existingScript = document.querySelector(`script[src="${$0e4b82b5fc4efa44$var$CHAT_WIDGET_LOADER_SCRIPT_URL}"], script#${$0e4b82b5fc4efa44$var$CHAT_WIDGET_SCRIPT_ID}`);
                if (!widget && !existingScript) loadScript($0e4b82b5fc4efa44$var$CHAT_WIDGET_LOADER_SCRIPT_URL);
            } catch (error) {
                console.error("Error checking and loading widget", error);
            }
        };
        checkAndLoadWidget();
    }, []);
    return null;
};

});


parcelRegister("4oLek", function(module, exports) {
$parcel$export(module.exports, "FeedbackCollector", function () { return (parcelRequire("8K5F8")).FeedbackCollector; });

var $8K5F8 = parcelRequire("8K5F8");

});
parcelRegister("8K5F8", function(module, exports) {
$parcel$export(module.exports, "FeedbackCollector", function () { return $a1cc16411f635fe8$export$fa63c8dd87ea8148; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $4WS03 = parcelRequire("4WS03");

var $aZNQ9 = parcelRequire("aZNQ9");

var $g3ExX = parcelRequire("g3ExX");

var $kbaUT = parcelRequire("kbaUT");

var $9QCHt = parcelRequire("9QCHt");
parcelRequire("gfZG5");
var $5m9HZ = parcelRequire("5m9HZ");
parcelRequire("hIyw9");
var $j8NTL = parcelRequire("j8NTL");
const $a1cc16411f635fe8$export$fa63c8dd87ea8148 = ()=>{
    const ref = (0, $1oC0p.useRef)(null);
    const [isOpen, setIsOpen] = (0, $1oC0p.useState)(false);
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { showFlag: showFlag } = (0, $1oC0p.useContext)((0, $kbaUT.default).Context);
    const handleClose = ()=>setIsOpen(false);
    const { sendFeedbackCollectorOpenButtonClickUIEvent: sendFeedbackCollectorOpenButtonClickUIEvent, sendFeedbackCollectorSubmitButtonClickUIEvent: sendFeedbackCollectorSubmitButtonClickUIEvent } = (0, $j8NTL.useFeedbackCollectorAnalytics)();
    const handleOpen = ()=>{
        setIsOpen(true);
        sendFeedbackCollectorOpenButtonClickUIEvent();
    };
    const handleSubmit = (formFields)=>{
        setIsOpen(false);
        showFlag({
            autoDismiss: true,
            iconType: "success",
            title: formatMessage((0, $9QCHt.messages).feedbackSubmittedTitle),
            description: formatMessage((0, $9QCHt.messages).feedbackSubmittedDescription),
            id: "feedback-submitted-flag"
        });
        sendFeedbackCollectorSubmitButtonClickUIEvent(formFields.type);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $g3ExX.default), {
        id: "fastshift-feedback-collector",
        testId: "fastshift-feedback-collector",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4WS03.default), {
                appearance: "subtle",
                label: formatMessage((0, $9QCHt.messages).iconButtonLabel),
                onClick: handleOpen,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($aZNQ9))),
                ref: ref
            }),
            isOpen && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5m9HZ.FeedbackCollectorModal), {
                onClose: handleClose,
                onSubmit: handleSubmit,
                shouldReturnFocusRef: ref
            })
        ]
    });
};

});
parcelRegister("9QCHt", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $b1e7a1d3eb15b266$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $b1e7a1d3eb15b266$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    feedbackSubmittedTitle: {
        id: "fastshift.feedback-collector.feedback-submitted-title",
        defaultMessage: "Thanks!",
        description: "Title for the feedback submitted flag"
    },
    feedbackSubmittedDescription: {
        id: "fastshift.feedback-collector.feedback-submitted-description",
        defaultMessage: "Your valuable feedback helps us continually improve our products.",
        description: "Description for the feedback submitted flag"
    },
    iconButtonLabel: {
        id: "fastshift.feedback-collector.icon-button-label",
        defaultMessage: "open customer feedback collector",
        description: "Label for the icon button"
    }
});

});

parcelRegister("gfZG5", function(module, exports) {
$parcel$export(module.exports, "FeedbackCollectorModal", function () { return (parcelRequire("5m9HZ")).FeedbackCollectorModal; });

var $5m9HZ = parcelRequire("5m9HZ");

});
parcelRegister("5m9HZ", function(module, exports) {
$parcel$export(module.exports, "FeedbackCollectorModal", function () { return $7a1d44746816b4aa$export$21ca6c649ed55a5a; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $9owK2 = parcelRequire("9owK2");

var $PE2DD = parcelRequire("PE2DD");

var $3riD8 = parcelRequire("3riD8");

var $8MgQg = parcelRequire("8MgQg");
const $7a1d44746816b4aa$var$ENTRYPOINT_ID = "b06cac34-19fe-4a8a-bbf7-085cd5fd3d0c";
const $7a1d44746816b4aa$export$21ca6c649ed55a5a = ({ onClose: onClose, onSubmit: onSubmit, shouldReturnFocusRef: shouldReturnFocusRef })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const userInfo = (0, $3riD8.useLoggedInUser)();
    const stargateBaseUrl = (0, $PE2DD.getStargateBaseUrl)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9owK2.default), {
        locale: "en",
        customGatewayUrl: stargateBaseUrl,
        customFeedbackUrl: `${stargateBaseUrl}/feedback-collector-api`,
        atlassianAccountId: userInfo.accountId,
        email: userInfo.email,
        name: userInfo.name,
        shouldGetEntitlementDetails: false,
        entrypointId: $7a1d44746816b4aa$var$ENTRYPOINT_ID,
        onClose: onClose,
        onSubmit: (formFields)=>onSubmit(formFields),
        shouldReturnFocusRef: shouldReturnFocusRef,
        feedbackTitle: formatMessage((0, $8MgQg.messages).feedbackTitle),
        feedbackTitleDetails: formatMessage((0, $8MgQg.messages).feedbackTitleDetails)
    });
};

});
parcelRegister("9owK2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6d6fc0c095d8364f$export$2e2bcd8739ae039; });


var $1lgHm = parcelRequire("1lgHm");


var $6d6fc0c095d8364f$export$2e2bcd8739ae039 = (0, $1lgHm.default);

});
parcelRegister("1lgHm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0fa4b48c7803651b$export$2e2bcd8739ae039; });

var $efs8s = parcelRequire("efs8s");

var $342Py = parcelRequire("342Py");

var $8ut70 = parcelRequire("8ut70");

var $3AhEU = parcelRequire("3AhEU");

var $gWIyR = parcelRequire("gWIyR");

var $ciMo5 = parcelRequire("ciMo5");

var $g9Nc1 = parcelRequire("g9Nc1");

var $c3W0a = parcelRequire("c3W0a");

var $9Sn3s = parcelRequire("9Sn3s");

var $9pTPz = parcelRequire("9pTPz");

var $567QU = parcelRequire("567QU");

var $1oC0p = parcelRequire("1oC0p");

var $39c3M = parcelRequire("39c3M");

var $jknRH = parcelRequire("jknRH");

var $5OB8l = parcelRequire("5OB8l");

var $9VIDp = parcelRequire("9VIDp");
function $0fa4b48c7803651b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0fa4b48c7803651b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0fa4b48c7803651b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0fa4b48c7803651b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0fa4b48c7803651b$var$_callSuper(t, o, e) {
    return o = (0, $g9Nc1.default)(o), (0, $ciMo5.default)(t, $0fa4b48c7803651b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $g9Nc1.default)(t).constructor) : o.apply(t, e));
}
function $0fa4b48c7803651b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0fa4b48c7803651b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $0fa4b48c7803651b$var$MAX_SUMMARY_LENGTH_CHARS = 100;
var $0fa4b48c7803651b$var$singleLineTruncatedText = function singleLineTruncatedText(text) {
    var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0fa4b48c7803651b$var$MAX_SUMMARY_LENGTH_CHARS;
    var singleLineText = text.replace(/\n/g, ' ');
    return (0, $5OB8l.default)(singleLineText, length);
};
var $0fa4b48c7803651b$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    function FeedbackCollector() {
        var _this;
        (0, $3AhEU.default)(this, FeedbackCollector);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $0fa4b48c7803651b$var$_callSuper(this, FeedbackCollector, [].concat(args));
        (0, $9Sn3s.default)(_this, "state", {
            anonymousFeedback: true
        });
        (0, $9Sn3s.default)(_this, "postFeedback", /*#__PURE__*/ function() {
            var _ref = (0, $8ut70.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9pTPz))).mark(function _callee(formValues) {
                var entrypointId, fetchUrl, formData, body, postData;
                return (0, (/*@__PURE__*/$parcel$interopDefault($9pTPz))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            entrypointId = _this.props.entrypointId;
                            fetchUrl = _this.getFeedbackUrl(); // Don't dispatch unless we have suitable props (allows tests to pass through empty strings and avoid redundant network calls)
                            if (!entrypointId) {
                                _context.next = 10;
                                break;
                            }
                            _context.next = 5;
                            return _this.mapFormToJSD(formValues);
                        case 5:
                            formData = _context.sent;
                            body = {
                                feedback: $0fa4b48c7803651b$var$_objectSpread({
                                    entrypointId: _this.props.entrypointId,
                                    entrypointUiVersion: _this.getPackageVersion()
                                }, formData)
                            };
                            if ((0, $jknRH.isApiGatewayUrl)(fetchUrl)) fetchUrl += '/feedback-collector-api';
                            else if (!_this.props.customFeedbackUrl) fetchUrl = 'https://feedback-collector-api.services.atlassian.com';
                            postData = (0, $567QU.Buffer).from(JSON.stringify(body)).toString('base64');
                            fetch("".concat(fetchUrl, "/v2/feedback"), {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    data: postData
                                }),
                                credentials: 'include'
                            });
                        case 10:
                            _this.props.onClose();
                            // slightly delay confirming submit since we don't wait for the REST call to succeed
                            //
                            // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
                            // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
                            // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
                            //
                            setTimeout(function() {
                                return _this.props.onSubmit(formValues);
                            }, _this.props.timeoutOnSubmit);
                        case 12:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x) {
                return _ref.apply(this, arguments);
            };
        }());
        return _this;
    }
    (0, $c3W0a.default)(FeedbackCollector, _Component);
    return (0, $gWIyR.default)(FeedbackCollector, [
        {
            key: "componentDidMount",
            value: function() {
                var _componentDidMount = (0, $8ut70.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9pTPz))).mark(function _callee2() {
                    var anonymousFeedback;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($9pTPz))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.shouldShowOptInCheckboxesNew();
                            case 2:
                                anonymousFeedback = !_context2.sent;
                                this.setState({
                                    anonymousFeedback: anonymousFeedback
                                });
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function componentDidMount() {
                    return _componentDidMount.apply(this, arguments);
                }
                return componentDidMount;
            }()
        },
        {
            key: "getGatewayUrl",
            value: function getGatewayUrl() {
                var _this$props = this.props, customGatewayUrl = _this$props.customGatewayUrl, url = _this$props.url;
                if (customGatewayUrl) return customGatewayUrl;
                if (url) return url;
                return FeedbackCollector.defaultProps.url;
            }
        },
        {
            key: "getFeedbackUrl",
            value: function getFeedbackUrl() {
                var _this$props2 = this.props, customFeedbackUrl = _this$props2.customFeedbackUrl, url = _this$props2.url;
                if (customFeedbackUrl) return customFeedbackUrl;
                if (url) return url;
                return FeedbackCollector.defaultProps.url;
            }
        },
        {
            key: "getPackageVersion",
            value: function getPackageVersion() {
                return "0.0.0-development";
            }
        },
        {
            key: "getEntitlementInformation",
            value: function() {
                var _getEntitlementInformation = (0, $8ut70.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9pTPz))).mark(function _callee3() {
                    var _entitlementDetails, _entitlementDetails2, _productName, _entitlement;
                    var url, productName, productEntitlement, entitlementDetails, productKey, _document$querySelect, hasPremium, entitlement, entitlementInformation, cloudSiteId, _entitlementDetails3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($9pTPz))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                url = this.getGatewayUrl(); // jira / confluence / bitbucket / trello
                                if (!window.location.host.includes('bitbucket.org')) {
                                    _context3.next = 9;
                                    break;
                                }
                                productName = 'Bitbucket';
                                productKey = 'bitbucket';
                                entitlementDetails = JSON.parse(JSON.stringify((_document$querySelect = document.querySelector('meta[id="bb-bootstrap"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute('data-current-user')));
                                hasPremium = entitlementDetails['hasPremium'];
                                productEntitlement = hasPremium ? 'PREMIUM' : 'STANDARD';
                                _context3.next = 24;
                                break;
                            case 9:
                                if (![
                                    'trellis.coffee',
                                    'trello.com'
                                ].includes(window.location.host)) {
                                    _context3.next = 14;
                                    break;
                                }
                                productName = 'Trello';
                                productKey = 'trello';
                                _context3.next = 24;
                                break;
                            case 14:
                                if (document.querySelector('meta[id="confluence-context-path"]')) {
                                    productName = 'Confluence';
                                    productKey = 'pricingplan.confluence.ondemand';
                                } else {
                                    productName = 'Jira';
                                    productKey = 'jira-software.ondemand';
                                }
                                _context3.prev = 15;
                                _context3.next = 18;
                                return fetch("".concat(url, "/customer-context/entitlements/").concat(window.location.host), $0fa4b48c7803651b$var$_objectSpread({
                                    method: 'GET',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    }
                                }, (0, $jknRH.isApiGatewayUrl)(url) ? {
                                    credentials: 'include'
                                } : {}));
                            case 18:
                                entitlementDetails = _context3.sent;
                                _context3.next = 24;
                                break;
                            case 21:
                                _context3.prev = 21;
                                _context3.t0 = _context3["catch"](15);
                                entitlementDetails = undefined;
                            case 24:
                                entitlementInformation = [];
                                cloudSiteId = ((_entitlementDetails = entitlementDetails) === null || _entitlementDetails === void 0 ? void 0 : _entitlementDetails.cloudSiteId) || '';
                                if ((_entitlementDetails2 = entitlementDetails) !== null && _entitlementDetails2 !== void 0 && _entitlementDetails2.children) entitlement = (_entitlementDetails3 = entitlementDetails) === null || _entitlementDetails3 === void 0 ? void 0 : _entitlementDetails3.children.find(function(entitlement) {
                                    return entitlement.key === productKey;
                                });
                                entitlementInformation.push({
                                    id: 'product',
                                    value: productName ? (_productName = productName) === null || _productName === void 0 ? void 0 : _productName.toLowerCase() : ''
                                }, {
                                    id: 'hostingType',
                                    value: (_entitlement = entitlement) !== null && _entitlement !== void 0 && _entitlement.product ? entitlement.product.hostingType : 'CLOUD'
                                }, {
                                    id: 'entitlementEdition',
                                    value: productEntitlement !== null && productEntitlement !== void 0 ? productEntitlement : ''
                                }, {
                                    id: 'cloudId',
                                    value: cloudSiteId
                                });
                                return _context3.abrupt("return", entitlementInformation);
                            case 29:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this, [
                        [
                            15,
                            21
                        ]
                    ]);
                }));
                function getEntitlementInformation() {
                    return _getEntitlementInformation.apply(this, arguments);
                }
                return getEntitlementInformation;
            }()
        },
        {
            key: "getTypeFieldValue",
            value: function getTypeFieldValue(dtype) {
                switch(dtype){
                    case 'bug':
                        return this.props.typeBugDefaultValue;
                    case 'comment':
                        return this.props.typeCommentDefaultValue;
                    case 'suggestion':
                        return this.props.typeSuggestionDefaultValue;
                    case 'question':
                        return this.props.typeQuestionDefaultValue;
                    case 'empty':
                    default:
                        return this.props.typeEmptyDefaultValue;
                }
            }
        },
        {
            key: "getAtlassianID",
            value: function() {
                var _getAtlassianID = (0, $8ut70.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9pTPz))).mark(function _callee4() {
                    var _this$props3, atlassianAccountId, shouldGetEntitlementDetails, url, result, json;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($9pTPz))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _this$props3 = this.props, atlassianAccountId = _this$props3.atlassianAccountId, shouldGetEntitlementDetails = _this$props3.shouldGetEntitlementDetails;
                                _context4.prev = 1;
                                if (!(atlassianAccountId || !shouldGetEntitlementDetails)) {
                                    _context4.next = 4;
                                    break;
                                }
                                return _context4.abrupt("return", atlassianAccountId);
                            case 4:
                                url = this.getGatewayUrl();
                                _context4.next = 7;
                                return fetch("".concat(url, "/me"), $0fa4b48c7803651b$var$_objectSpread({
                                    method: 'GET',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    }
                                }, (0, $jknRH.isApiGatewayUrl)(url) ? {
                                    credentials: 'include'
                                } : {}));
                            case 7:
                                result = _context4.sent;
                                _context4.next = 10;
                                return result.json();
                            case 10:
                                json = _context4.sent;
                                return _context4.abrupt("return", json.account_id);
                            case 14:
                                _context4.prev = 14;
                                _context4.t0 = _context4["catch"](1);
                                return _context4.abrupt("return", undefined);
                            case 17:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this, [
                        [
                            1,
                            14
                        ]
                    ]);
                }));
                function getAtlassianID() {
                    return _getAtlassianID.apply(this, arguments);
                }
                return getAtlassianID;
            }()
        },
        {
            key: "shouldShowOptInCheckboxes",
            value: function shouldShowOptInCheckboxes() {
                if (this.props.anonymousFeedback) return !this.props.anonymousFeedback;
                if (this.props.atlassianAccountId) return true;
                var response;
                this.getAtlassianID().then(function(result) {
                    response = result !== undefined;
                }).catch(function() {
                    response = false;
                });
                // @ts-ignore
                return response;
            }
        },
        {
            key: "shouldShowOptInCheckboxesNew",
            value: function shouldShowOptInCheckboxesNew() {
                var _this2 = this;
                return new Promise(function(resolve) {
                    if (_this2.props.anonymousFeedback) resolve(!_this2.props.anonymousFeedback);
                    if (_this2.props.atlassianAccountId) resolve(true);
                    _this2.getAtlassianID().then(function(result) {
                        resolve(result !== undefined);
                    }).catch(function() {
                        resolve(false);
                    });
                });
            }
        },
        {
            key: "getDescription",
            value: function getDescription(formValues) {
                return formValues.description || this.props.descriptionDefaultValue;
            }
        },
        {
            key: "getSummary",
            value: function getSummary(formValues) {
                return $0fa4b48c7803651b$var$singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
            }
        },
        {
            key: "getCustomerName",
            value: function getCustomerName() {
                var _this$props$name;
                return (_this$props$name = this.props.name) !== null && _this$props$name !== void 0 ? _this$props$name : this.props.customerNameDefaultValue;
            }
        },
        {
            key: "addEmailToContext",
            value: function addEmailToContext() {
                var contextField = this.props.additionalFields.find(function(field) {
                    return field.id === 'customfield_10047';
                });
                if (contextField) contextField.value = "".concat(contextField.value, "\n        email: ").concat(this.props.email);
                else this.props.additionalFields.push({
                    id: 'customfield_10047',
                    value: "email: ".concat(this.props.email)
                });
            }
        },
        {
            key: "addAccountIdToContext",
            value: function addAccountIdToContext(atlassianID) {
                if (atlassianID) {
                    var contextField = this.props.additionalFields.find(function(field) {
                        return field.id === 'customfield_10047';
                    });
                    if (contextField) contextField.value = "".concat(contextField.value, "\n\t\t\tatlassian-account-id: ").concat(atlassianID);
                }
            }
        },
        {
            key: "mapFormToJSD",
            value: function() {
                var _mapFormToJSD = (0, $8ut70.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9pTPz))).mark(function _callee5(formValues) {
                    var _this$props4, _this$props5;
                    var entitlementInformation, atlassianID;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($9pTPz))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                entitlementInformation = null;
                                if (!((_this$props4 = this.props) !== null && _this$props4 !== void 0 && _this$props4.shouldGetEntitlementDetails)) {
                                    _context5.next = 5;
                                    break;
                                }
                                _context5.next = 4;
                                return this.getEntitlementInformation();
                            case 4:
                                entitlementInformation = _context5.sent;
                            case 5:
                                if ((_this$props5 = this.props) !== null && _this$props5 !== void 0 && _this$props5.email) this.addEmailToContext();
                                _context5.next = 8;
                                return this.getAtlassianID();
                            case 8:
                                atlassianID = _context5.sent;
                                this.addAccountIdToContext(atlassianID);
                                return _context5.abrupt("return", {
                                    fields: [].concat((0, $342Py.default)(entitlementInformation !== null && entitlementInformation || []), [
                                        this.props.showTypeField ? {
                                            id: this.props.typeFieldId,
                                            value: this.getTypeFieldValue(formValues.type)
                                        } : undefined,
                                        {
                                            id: this.props.summaryFieldId,
                                            value: this.getSummary(formValues)
                                        },
                                        {
                                            id: this.props.descriptionFieldId,
                                            value: this.getDescription(formValues)
                                        },
                                        {
                                            id: 'aaidOrHash',
                                            value: formValues.canBeContacted ? atlassianID : undefined
                                        },
                                        {
                                            id: this.props.customerNameFieldId,
                                            value: this.getCustomerName()
                                        },
                                        formValues.canBeContacted ? {
                                            id: this.props.canBeContactedFieldId,
                                            value: this.props.canBeContactedAgreeValue
                                        } : {
                                            id: this.props.canBeContactedFieldId,
                                            value: this.props.canBeContactedDeclineValue
                                        },
                                        formValues.enrollInResearchGroup ? {
                                            id: this.props.enrollInResearchFieldId,
                                            value: this.props.enrollInResearchAgreeValue
                                        } : {
                                            id: this.props.enrollInResearchFieldId,
                                            value: this.props.enrollInResearchDeclineValue
                                        }
                                    ], (0, $342Py.default)(this.props.additionalFields)).filter(Boolean)
                                });
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function mapFormToJSD(_x2) {
                    return _mapFormToJSD.apply(this, arguments);
                }
                return mapFormToJSD;
            }()
        },
        {
            key: "render",
            value: function render() {
                var anonymousFeedback = !this.shouldShowOptInCheckboxes();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9VIDp.default), (0, $efs8s.default)({
                    customContent: this.props.customContent,
                    feedbackTitle: this.props.feedbackTitle,
                    feedbackTitleDetails: this.props.feedbackTitleDetails,
                    showTypeField: this.props.showTypeField,
                    showDefaultTextFields: this.props.showDefaultTextFields,
                    hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
                    canBeContactedLabel: this.props.canBeContactedLabel,
                    enrolInResearchLabel: this.props.enrolInResearchLabel,
                    summaryPlaceholder: this.props.summaryPlaceholder,
                    submitButtonLabel: this.props.submitButtonLabel,
                    cancelButtonLabel: this.props.cancelButtonLabel,
                    feedbackGroupLabels: this.props.feedbackGroupLabels,
                    onSubmit: this.postFeedback,
                    onClose: this.props.onClose,
                    locale: this.props.locale,
                    anonymousFeedback: (0, $39c3M.fg)('platform.proforma-form-builder-feedback_hupaz') ? this.state.anonymousFeedback : anonymousFeedback,
                    selectLabel: this.props.selectLabel,
                    customTextAreaLabel: this.props.customTextAreaLabel,
                    customFeedbackOptions: this.props.customFeedbackOptions,
                    shouldReturnFocusRef: this.props.shouldReturnFocusRef,
                    disableSubmitButton: this.props.disableSubmitButton
                }, (0, $39c3M.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                    enrolInResearchLink: this.props.enrolInResearchLink,
                    canBeContactedLink: this.props.canBeContactedLink
                }));
            }
        }
    ]);
}((0, $1oC0p.Component));
(0, $9Sn3s.default)($0fa4b48c7803651b$export$2e2bcd8739ae039, "defaultProps", {
    locale: 'en',
    url: '/gateway/api',
    shouldGetEntitlementDetails: true,
    canBeContactedFieldId: 'customfield_10043',
    canBeContactedAgreeValue: [
        {
            id: '10109'
        }
    ],
    canBeContactedDeclineValue: [
        {
            id: '10111'
        }
    ],
    additionalFields: [],
    customerNameFieldId: 'customfield_10045',
    customerNameDefaultValue: 'unknown',
    descriptionFieldId: 'description',
    descriptionDefaultValue: '',
    enrollInResearchFieldId: 'customfield_10044',
    enrollInResearchAgreeValue: [
        {
            id: '10110'
        }
    ],
    enrollInResearchDeclineValue: [
        {
            id: '10112'
        }
    ],
    summaryFieldId: 'summary',
    summaryDefaultValue: '',
    summaryTruncateLength: 100,
    timeoutOnSubmit: 700,
    typeFieldId: 'customfield_10042',
    typeBugDefaultValue: {
        id: '10105'
    },
    typeCommentDefaultValue: {
        id: '10106'
    },
    typeSuggestionDefaultValue: {
        id: '10107'
    },
    typeQuestionDefaultValue: {
        id: '10108'
    },
    typeEmptyDefaultValue: {
        id: 'empty'
    },
    showTypeField: true,
    showDefaultTextFields: true,
    anonymousFeedback: false,
    onClose: function onClose() {},
    onSubmit: function onSubmit() {}
});

});
parcelRegister("efs8s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a5f84a7cc084efcd$export$2e2bcd8739ae039; });
function $a5f84a7cc084efcd$export$2e2bcd8739ae039() {
    return $a5f84a7cc084efcd$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a5f84a7cc084efcd$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("342Py", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $23b3f0e964fae848$export$2e2bcd8739ae039; });

var $anY3d = parcelRequire("anY3d");

var $6P7RN = parcelRequire("6P7RN");

var $giz0B = parcelRequire("giz0B");

var $b2ja3 = parcelRequire("b2ja3");
function $23b3f0e964fae848$export$2e2bcd8739ae039(r) {
    return (0, $anY3d.default)(r) || (0, $6P7RN.default)(r) || (0, $giz0B.default)(r) || (0, $b2ja3.default)();
}

});
parcelRegister("anY3d", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $78faa2331ea84a27$export$2e2bcd8739ae039; });

var $hisrF = parcelRequire("hisrF");
function $78faa2331ea84a27$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $hisrF.default)(r);
}

});
parcelRegister("hisrF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c97a2ebdc5ccc4b0$export$2e2bcd8739ae039; });
function $c97a2ebdc5ccc4b0$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("6P7RN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4f7d9bab1cb5850c$export$2e2bcd8739ae039; });
function $4f7d9bab1cb5850c$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("giz0B", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bdd97bc2c23ab9ee$export$2e2bcd8739ae039; });

var $hisrF = parcelRequire("hisrF");
function $bdd97bc2c23ab9ee$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $hisrF.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $hisrF.default)(r, a) : void 0;
    }
}

});

parcelRegister("b2ja3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $808ebea31bbe4526$export$2e2bcd8739ae039; });
function $808ebea31bbe4526$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("8ut70", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $62e7b51c0dd70a97$export$2e2bcd8739ae039; });
function $62e7b51c0dd70a97$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $62e7b51c0dd70a97$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $62e7b51c0dd70a97$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $62e7b51c0dd70a97$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("3AhEU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $29c26e8fe035ab6b$export$2e2bcd8739ae039; });
function $29c26e8fe035ab6b$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("gWIyR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c564a10eeca629ca$export$2e2bcd8739ae039; });

var $gN1XO = parcelRequire("gN1XO");
function $c564a10eeca629ca$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $gN1XO.default)(o.key), o);
    }
}
function $c564a10eeca629ca$export$2e2bcd8739ae039(e, r, t) {
    return r && $c564a10eeca629ca$var$_defineProperties(e.prototype, r), t && $c564a10eeca629ca$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("gN1XO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c392bee2cc2d1ef0$export$2e2bcd8739ae039; });

var $6DX60 = parcelRequire("6DX60");

var $5oEjL = parcelRequire("5oEjL");
function $c392bee2cc2d1ef0$export$2e2bcd8739ae039(t) {
    var i = (0, $5oEjL.default)(t, "string");
    return "symbol" == (0, $6DX60.default)(i) ? i : i + "";
}

});
parcelRegister("6DX60", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4d6439cac1401b0c$export$2e2bcd8739ae039; });
function $4d6439cac1401b0c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $4d6439cac1401b0c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4d6439cac1401b0c$export$2e2bcd8739ae039(o);
}

});

parcelRegister("5oEjL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3ede77e92be8f353$export$2e2bcd8739ae039; });

var $6DX60 = parcelRequire("6DX60");
function $3ede77e92be8f353$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $6DX60.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $6DX60.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("ciMo5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8f4cb33429f8b984$export$2e2bcd8739ae039; });

var $6DX60 = parcelRequire("6DX60");

var $hn60H = parcelRequire("hn60H");
function $8f4cb33429f8b984$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $6DX60.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hn60H.default)(t);
}

});
parcelRegister("hn60H", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ca593f283b119692$export$2e2bcd8739ae039; });
function $ca593f283b119692$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("g9Nc1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bc33a54bc09226f0$export$2e2bcd8739ae039; });
function $bc33a54bc09226f0$export$2e2bcd8739ae039(t) {
    return $bc33a54bc09226f0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $bc33a54bc09226f0$export$2e2bcd8739ae039(t);
}

});

parcelRegister("c3W0a", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8c82c1c26bd3278e$export$2e2bcd8739ae039; });

var $kDKNu = parcelRequire("kDKNu");
function $8c82c1c26bd3278e$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $kDKNu.default)(t, e);
}

});
parcelRegister("kDKNu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f06bc019887c8216$export$2e2bcd8739ae039; });
function $f06bc019887c8216$export$2e2bcd8739ae039(t, e) {
    return $f06bc019887c8216$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $f06bc019887c8216$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("9Sn3s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $730b0a67c274890a$export$2e2bcd8739ae039; });

var $gN1XO = parcelRequire("gN1XO");
function $730b0a67c274890a$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $gN1XO.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("9pTPz", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $6db1c1ad837af60a$var$runtime = (parcelRequire("2K9Ab"))();
module.exports = $6db1c1ad837af60a$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $6db1c1ad837af60a$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $6db1c1ad837af60a$var$runtime;
    else Function("r", "regeneratorRuntime = r")($6db1c1ad837af60a$var$runtime);
}

});
parcelRegister("2K9Ab", function(module, exports) {

var $5Mmee = parcelRequire("5Mmee");

var $ewDFl = parcelRequire("ewDFl");

var $9Tjb7 = parcelRequire("9Tjb7");

var $1uJyu = parcelRequire("1uJyu");

var $gfsVp = parcelRequire("gfsVp");

var $8RBJ6 = parcelRequire("8RBJ6");

var $b96zq = parcelRequire("b96zq");
function $1ff74f88ee2dd49b$var$_regeneratorRuntime() {
    "use strict";
    var r = $ewDFl(), e = r.m($1ff74f88ee2dd49b$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $b96zq(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $1ff74f88ee2dd49b$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $5Mmee(r, e);
            },
            AsyncIterator: $gfsVp,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $1uJyu : $9Tjb7)(a(r), e, t, o, u);
            },
            keys: $8RBJ6,
            values: $b96zq
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $1ff74f88ee2dd49b$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5Mmee", function(module, exports) {
function $4352ad92f201c00f$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $4352ad92f201c00f$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ewDFl", function(module, exports) {

var $1gTub = parcelRequire("1gTub");
function $02baa04d16f32f0c$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $1gTub(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($1gTub(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $1gTub(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $1gTub(u, "constructor", GeneratorFunctionPrototype), $1gTub(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $1gTub(GeneratorFunctionPrototype, o, "GeneratorFunction"), $1gTub(u), $1gTub(u, o, "Generator"), $1gTub(u, n, function() {
        return this;
    }), $1gTub(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $02baa04d16f32f0c$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $02baa04d16f32f0c$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1gTub", function(module, exports) {
function $0ed25361504c282f$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $0ed25361504c282f$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $0ed25361504c282f$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $0ed25361504c282f$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $0ed25361504c282f$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9Tjb7", function(module, exports) {

var $1uJyu = parcelRequire("1uJyu");
function $7338208449f825b7$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $1uJyu(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $7338208449f825b7$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1uJyu", function(module, exports) {

var $ewDFl = parcelRequire("ewDFl");

var $gfsVp = parcelRequire("gfsVp");
function $116bee1cf54f1785$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $gfsVp($ewDFl().w(r, e, t, o), n || Promise);
}
module.exports = $116bee1cf54f1785$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gfsVp", function(module, exports) {

var $5Mmee = parcelRequire("5Mmee");

var $1gTub = parcelRequire("1gTub");
function $bd447bf800b6ab93$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $5Mmee ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($1gTub($bd447bf800b6ab93$var$AsyncIterator.prototype), $1gTub($bd447bf800b6ab93$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $1gTub(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $bd447bf800b6ab93$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("8RBJ6", function(module, exports) {
function $674089a561b73583$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $674089a561b73583$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("b96zq", function(module, exports) {

var $d6fMN = parcelRequire("d6fMN");
var $81d5a1bc001994f2$var$_typeof = $d6fMN.default;
function $81d5a1bc001994f2$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($81d5a1bc001994f2$var$_typeof(e) + " is not iterable");
}
module.exports = $81d5a1bc001994f2$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("d6fMN", function(module, exports) {
function $989814abb999fc42$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $989814abb999fc42$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $989814abb999fc42$var$_typeof(o);
}
module.exports = $989814abb999fc42$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("jknRH", function(module, exports) {
$parcel$export(module.exports, "isApiGatewayUrl", function () { return $e12265ac5d09e006$export$f0f6fc934288a17c; });
var $e12265ac5d09e006$export$f0f6fc934288a17c = function isApiGatewayUrl(url) {
    return [
        '/gateway/api'
    ].includes(url);
};

});

parcelRegister("5OB8l", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $43be6d31f93faba0$export$2e2bcd8739ae039; });
function $43be6d31f93faba0$export$2e2bcd8739ae039(text, maxLength) {
    if (!text || !maxLength) return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}

});

parcelRegister("9VIDp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $73ac0f70f079843c$export$2e2bcd8739ae039; });

var $efs8s = parcelRequire("efs8s");

var $9Sn3s = parcelRequire("9Sn3s");

var $8ySUD = parcelRequire("8ySUD");

var $8ut70 = parcelRequire("8ut70");

var $2gb89 = parcelRequire("2gb89");

var $9pTPz = parcelRequire("9pTPz");

var $1oC0p = parcelRequire("1oC0p");

var $fzVi0 = parcelRequire("fzVi0");
var $beJjp = parcelRequire("beJjp");

var $cI4BR = parcelRequire("cI4BR");

var $btuK0 = parcelRequire("btuK0");

var $kY7Pn = parcelRequire("kY7Pn");
var $i7Tb1 = parcelRequire("i7Tb1");
var $fF4td = parcelRequire("fF4td");
var $3LBzK = parcelRequire("3LBzK");
var $kmI4g = parcelRequire("kmI4g");

var $d6n4m = parcelRequire("d6n4m");

var $ewvWf = parcelRequire("ewvWf");
var $iFeCY = parcelRequire("iFeCY");
var $lnA0w = parcelRequire("lnA0w");
var $bhwjR = parcelRequire("bhwjR");
var $iPrCd = parcelRequire("iPrCd");

var $39c3M = parcelRequire("39c3M");

var $kGOC1 = parcelRequire("kGOC1");

var $j673i = parcelRequire("j673i");

var $iLLng = parcelRequire("iLLng");

var $iqCss = parcelRequire("iqCss");

var $b30sm = parcelRequire("b30sm");

var $37gbk = parcelRequire("37gbk");
var $73ac0f70f079843c$var$_excluded = [
    "id"
], $73ac0f70f079843c$var$_excluded2 = [
    "locale"
];
function $73ac0f70f079843c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $73ac0f70f079843c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $73ac0f70f079843c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $73ac0f70f079843c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $73ac0f70f079843c$var$LinkWrapper = function LinkWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingInlineStart: "var(--ds-space-300, 24px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginInlineStart: "var(--ds-space-050, 4px)"
        }
    }, children);
};
var $73ac0f70f079843c$var$FeedbackForm = function FeedbackForm(_ref2) {
    var _ref2$showTypeField = _ref2.showTypeField, showTypeField = _ref2$showTypeField === void 0 ? true : _ref2$showTypeField, _ref2$showDefaultText = _ref2.showDefaultTextFields, showDefaultTextFields = _ref2$showDefaultText === void 0 ? true : _ref2$showDefaultText, customContent = _ref2.customContent, onClose = _ref2.onClose, onSubmit = _ref2.onSubmit, feedbackTitle = _ref2.feedbackTitle, feedbackTitleDetails = _ref2.feedbackTitleDetails, feedbackGroupLabels = _ref2.feedbackGroupLabels, summaryPlaceholder = _ref2.summaryPlaceholder, canBeContactedLabel = _ref2.canBeContactedLabel, canBeContactedLink = _ref2.canBeContactedLink, enrolInResearchLabel = _ref2.enrolInResearchLabel, enrolInResearchLink = _ref2.enrolInResearchLink, submitButtonLabel = _ref2.submitButtonLabel, cancelButtonLabel = _ref2.cancelButtonLabel, anonymousFeedback = _ref2.anonymousFeedback, hasDescriptionDefaultValue = _ref2.hasDescriptionDefaultValue, selectLabel = _ref2.selectLabel, customTextAreaLabel = _ref2.customTextAreaLabel, _ref2$customFeedbackO = _ref2.customFeedbackOptions, customFeedbackOptions = _ref2$customFeedbackO === void 0 ? [] : _ref2$customFeedbackO, shouldReturnFocusRef = _ref2.shouldReturnFocusRef, disableSubmitButton = _ref2.disableSubmitButton;
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2gb89.default)(_useState, 2), canBeContacted = _useState2[0], setCanBeContacted = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(''), _useState4 = (0, $2gb89.default)(_useState3, 2), description = _useState4[0], setDescription = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(false), _useState6 = (0, $2gb89.default)(_useState5, 2), enrollInResearchGroup = _useState6[0], setEnrollInResearchGroup = _useState6[1];
    var _useState7 = (0, $1oC0p.useState)('empty'), _useState8 = (0, $2gb89.default)(_useState7, 2), type = _useState8[0], setType = _useState8[1];
    var _useState9 = (0, $1oC0p.useState)(false), _useState0 = (0, $2gb89.default)(_useState9, 2), isSubmitting = _useState0[0], setIsSubmitting = _useState0[1];
    var _useState1 = (0, $1oC0p.useState)({}), _useState10 = (0, $2gb89.default)(_useState1, 2), validationErrors = _useState10[0], setValidationErrors = _useState10[1];
    var _useIntl = (0, $beJjp.default)(), formatMessage = _useIntl.formatMessage;
    var isTypeSelected = function isTypeSelected() {
        return type !== 'empty';
    };
    var canShowTextField = isTypeSelected() || !showTypeField;
    var hasDescription = description || hasDescriptionDefaultValue;
    // Feature flag determines validation behavior
    var useNewValidation = (0, $39c3M.fg)('feedback-collector-custom-validation');
    var isDisabled = useNewValidation ? isSubmitting || disableSubmitButton // New: only disable when submitting or explicitly disabled
     : disableSubmitButton || (showTypeField ? !isTypeSelected() || !hasDescription : !hasDescription); // Old: disable based on form validation
    var getValidationErrors = function getValidationErrors() {
        var errors = {};
        // Validate type selection if showTypeField is true
        if (showTypeField && !isTypeSelected()) errors.type = formatMessage((0, $b30sm.messages).validationErrorTypeRequired);
        // Validate description if showDefaultTextFields is true
        if (showDefaultTextFields && !hasDescription) errors.description = formatMessage((0, $b30sm.messages).validationErrorDescriptionRequired);
        return errors;
    };
    var getFieldLabels = function getFieldLabels(record) {
        var _record$bug, _record$comment, _record$suggestion, _record$question, _record$empty, _record$not_relevant, _record$not_accurate, _record$too_slow, _record$unhelpful_lin, _record$other;
        return {
            bug: (record === null || record === void 0 || (_record$bug = record.bug) === null || _record$bug === void 0 ? void 0 : _record$bug.fieldLabel) || formatMessage((0, $b30sm.messages).formBugLabel),
            comment: (record === null || record === void 0 || (_record$comment = record.comment) === null || _record$comment === void 0 ? void 0 : _record$comment.fieldLabel) || formatMessage((0, $b30sm.messages).formCommentLabel),
            suggestion: (record === null || record === void 0 || (_record$suggestion = record.suggestion) === null || _record$suggestion === void 0 ? void 0 : _record$suggestion.fieldLabel) || formatMessage((0, $b30sm.messages).formSuggestionLabel),
            question: (record === null || record === void 0 || (_record$question = record.question) === null || _record$question === void 0 ? void 0 : _record$question.fieldLabel) || formatMessage((0, $b30sm.messages).formQuestionLabel),
            empty: (record === null || record === void 0 || (_record$empty = record.empty) === null || _record$empty === void 0 ? void 0 : _record$empty.fieldLabel) || formatMessage((0, $b30sm.messages).formEmptyLabel),
            not_relevant: (record === null || record === void 0 || (_record$not_relevant = record.not_relevant) === null || _record$not_relevant === void 0 ? void 0 : _record$not_relevant.fieldLabel) || formatMessage((0, $b30sm.messages).formNotRelevantLabel),
            not_accurate: (record === null || record === void 0 || (_record$not_accurate = record.not_accurate) === null || _record$not_accurate === void 0 ? void 0 : _record$not_accurate.fieldLabel) || formatMessage((0, $b30sm.messages).formNotAccurateLabel),
            too_slow: (record === null || record === void 0 || (_record$too_slow = record.too_slow) === null || _record$too_slow === void 0 ? void 0 : _record$too_slow.fieldLabel) || formatMessage((0, $b30sm.messages).formTooSlowLabel),
            unhelpful_links: (record === null || record === void 0 || (_record$unhelpful_lin = record.unhelpful_links) === null || _record$unhelpful_lin === void 0 ? void 0 : _record$unhelpful_lin.fieldLabel) || formatMessage((0, $b30sm.messages).formUnhelpfulLinksLabel),
            other: (record === null || record === void 0 || (_record$other = record.other) === null || _record$other === void 0 ? void 0 : _record$other.fieldLabel) || formatMessage((0, $b30sm.messages).formOtherLabel)
        };
    };
    var getSelectOptions = function getSelectOptions(record) {
        var _record$question2, _record$comment2, _record$bug2, _record$suggestion2;
        return [
            {
                label: (record === null || record === void 0 || (_record$question2 = record.question) === null || _record$question2 === void 0 ? void 0 : _record$question2.selectOptionLabel) || formatMessage((0, $b30sm.messages).selectionOptionQuestionLabel),
                value: 'question'
            },
            {
                label: (record === null || record === void 0 || (_record$comment2 = record.comment) === null || _record$comment2 === void 0 ? void 0 : _record$comment2.selectOptionLabel) || formatMessage((0, $b30sm.messages).selectionOptionCommentLabel),
                value: 'comment'
            },
            {
                label: (record === null || record === void 0 || (_record$bug2 = record.bug) === null || _record$bug2 === void 0 ? void 0 : _record$bug2.selectOptionLabel) || formatMessage((0, $b30sm.messages).selectionOptionBugLabel),
                value: 'bug'
            },
            {
                label: (record === null || record === void 0 || (_record$suggestion2 = record.suggestion) === null || _record$suggestion2 === void 0 ? void 0 : _record$suggestion2.selectOptionLabel) || formatMessage((0, $b30sm.messages).selectionOptionSuggestionLabel),
                value: 'suggestion'
            }
        ];
    };
    var getDefaultPlaceholder = function getDefaultPlaceholder(record) {
        var _record$empty2;
        return (record === null || record === void 0 || (_record$empty2 = record.empty) === null || _record$empty2 === void 0 ? void 0 : _record$empty2.selectOptionLabel) || formatMessage((0, $b30sm.messages).selectionOptionDefaultPlaceholder);
    };
    var focusRef = (0, $1oC0p.useRef)();
    var selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
    var renderContactLabelAppify = function renderContactLabelAppify() {
        if ((0, $39c3M.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $b30sm.messages).canBeContactedLabelAppifyWithoutLink;
        return (0, $b30sm.messages).canBeContactedLabelAppify;
    };
    var renderContactLabel = function renderContactLabel() {
        if ((0, $39c3M.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $b30sm.messages).canBeContactedLabelWithoutLink;
        return (0, $b30sm.messages).canBeContactedLabel;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ewvWf.default), {
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        testId: "feedbackCollectorModalDialog",
        shouldReturnFocus: shouldReturnFocusRef,
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kY7Pn.default), {
        onSubmit: /*#__PURE__*/ (0, $8ut70.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9pTPz))).mark(function _callee() {
            var errors;
            return (0, (/*@__PURE__*/$parcel$interopDefault($9pTPz))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        if (!useNewValidation) {
                            _context.next = 5;
                            break;
                        }
                        // New validation: validate on submit and show errors
                        errors = getValidationErrors(); // If there are validation errors, show them and don't submit
                        if (!(Object.keys(errors).length > 0)) {
                            _context.next = 5;
                            break;
                        }
                        setValidationErrors(errors);
                        return _context.abrupt("return");
                    case 5:
                        // Submit the form (both old and new validation paths reach here)
                        setIsSubmitting(true);
                        _context.prev = 6;
                        _context.next = 9;
                        return onSubmit({
                            canBeContacted: canBeContacted,
                            description: description,
                            enrollInResearchGroup: enrollInResearchGroup,
                            type: type
                        });
                    case 9:
                        _context.prev = 9;
                        setIsSubmitting(false);
                        return _context.finish(9);
                    case 12:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    6,
                    ,
                    9,
                    12
                ]
            ]);
        }))
    }, function(_ref4) {
        var formProps = _ref4.formProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bhwjR.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iPrCd.default), null, feedbackTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fzVi0.default), (0, $b30sm.messages).feedbackTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iFeCY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("p", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                color: "var(--ds-text-subtle, ".concat((0, $iqCss.N300), ")"),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                marginBottom: "var(--ds-space-300, 24px)"
            }
        }, formatMessage((0, $b30sm.messages).requiredFieldsSummary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kmI4g.default), null)), feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fF4td.default), {
            name: "topic",
            label: selectLabel || formatMessage((0, $b30sm.messages).selectionOptionDefaultLabel),
            isRequired: true,
            "aria-required": true // JCA11Y-1619
        }, function(_ref5) {
            var _ref5$fieldProps = _ref5.fieldProps, id = _ref5$fieldProps.id, restProps = (0, $8ySUD.default)(_ref5$fieldProps, $73ac0f70f079843c$var$_excluded);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $j673i.default), (0, $efs8s.default)({}, restProps, {
                onChange: function onChange(option) {
                    if (!option || option instanceof Array) return;
                    setType(option.value);
                    // Clear validation error when user selects a type (only for new validation)
                    if (useNewValidation && validationErrors.type) setValidationErrors(function(prev) {
                        return $73ac0f70f079843c$var$_objectSpread($73ac0f70f079843c$var$_objectSpread({}, prev), {}, {
                            type: undefined
                        });
                    });
                },
                menuPortalTarget: document.body,
                styles: {
                    menuPortal: function menuPortal(base) {
                        return $73ac0f70f079843c$var$_objectSpread($73ac0f70f079843c$var$_objectSpread({}, base), {}, {
                            zIndex: 9999
                        });
                    }
                },
                options: selectOptions,
                ref: focusRef,
                placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                inputId: id
            })), useNewValidation && validationErrors.type && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $i7Tb1.ErrorMessage), null, validationErrors.type));
        }) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fF4td.default), {
            label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $b30sm.messages).defaultCustomTextAreaLabel),
            isRequired: true,
            name: "description"
        }, function(_ref6) {
            var fieldProps = _ref6.fieldProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iLLng.default), (0, $efs8s.default)({}, fieldProps, {
                name: "foo",
                minimumRows: 6,
                placeholder: summaryPlaceholder || undefined,
                onChange: function onChange(e) {
                    setDescription(e.target.value);
                    // Clear validation error when user types
                    if (useNewValidation && validationErrors.description) setValidationErrors(function(prev) {
                        return $73ac0f70f079843c$var$_objectSpread($73ac0f70f079843c$var$_objectSpread({}, prev), {}, {
                            description: undefined
                        });
                    });
                },
                value: description
            })), useNewValidation && validationErrors.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $i7Tb1.ErrorMessage), null, validationErrors.description));
        }), !anonymousFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3LBzK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("legend", {
            "aria-hidden": false,
            hidden: true
        }, "Atlassian opt-in options"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fF4td.default), {
            name: "can-be-contacted"
        }, function(_ref7) {
            var fieldProps = _ref7.fieldProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $btuK0.default), (0, $efs8s.default)({}, fieldProps, {
                "aria-describedby": undefined // JCA11Y-1988
                ,
                label: canBeContactedLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fzVi0.default), (0, $efs8s.default)({}, (0, $39c3M.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(), !(0, $39c3M.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                    values: {
                        a: function a(chunks) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $d6n4m.default), {
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                target: "_blank"
                            }, chunks);
                        }
                    }
                })),
                onChange: function onChange(event) {
                    return setCanBeContacted(event.target.checked);
                }
            })), canBeContactedLabel && canBeContactedLink && (0, $39c3M.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($73ac0f70f079843c$var$LinkWrapper, null, canBeContactedLink), !canBeContactedLabel && (0, $39c3M.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($73ac0f70f079843c$var$LinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $d6n4m.default), {
                href: "https://www.atlassian.com/legal/privacy-policy",
                target: "_blank"
            }, formatMessage((0, $b30sm.messages).privacyPolicy))));
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fF4td.default), {
            name: "enroll-in-research-group"
        }, function(_ref8) {
            var fieldProps = _ref8.fieldProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $btuK0.default), (0, $efs8s.default)({}, fieldProps, {
                "aria-describedby": undefined // JCA11Y-1988
                ,
                label: enrolInResearchLabel || formatMessage((0, $b30sm.messages).enrolInResearchLabel),
                onChange: function onChange(event) {
                    return setEnrollInResearchGroup(event.target.checked);
                }
            })), enrolInResearchLabel && enrolInResearchLink && (0, $39c3M.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($73ac0f70f079843c$var$LinkWrapper, null, enrolInResearchLink));
        })) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fF4td.default), {
            name: 'anonymousFeedback'
        }, function() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kGOC1.default), {
                title: formatMessage((0, $b30sm.messages).feedbackIsAnonymousTitle),
                appearance: 'information'
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("p", null, formatMessage((0, $b30sm.messages).feedbackIsAnonymous)));
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lnA0w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cI4BR.default), {
            appearance: "subtle",
            onClick: onClose
        }, cancelButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fzVi0.default), (0, $b30sm.messages).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cI4BR.default), {
            appearance: "primary",
            type: "submit",
            isDisabled: isSubmitting || isDisabled,
            testId: "feedbackCollectorSubmitBtn"
        }, submitButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fzVi0.default), (0, $b30sm.messages).submitButtonLabel))));
    }));
};
var $73ac0f70f079843c$var$FeedbackFormWithIntl = function FeedbackFormWithIntl(_ref9) {
    var locale = _ref9.locale, props = (0, $8ySUD.default)(_ref9, $73ac0f70f079843c$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $37gbk.IntlProviderWithResolvedMessages), {
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($73ac0f70f079843c$var$FeedbackForm, props));
};
var $73ac0f70f079843c$export$2e2bcd8739ae039 = $73ac0f70f079843c$var$FeedbackFormWithIntl;

});
parcelRegister("8ySUD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $63bc182ee93f3e98$export$2e2bcd8739ae039; });

var $b9R1R = parcelRequire("b9R1R");
function $63bc182ee93f3e98$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $b9R1R.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("b9R1R", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $81f9ab6e5434a213$export$2e2bcd8739ae039; });
function $81f9ab6e5434a213$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("2gb89", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1a55b5b1fbb31764$export$2e2bcd8739ae039; });

var $4Csca = parcelRequire("4Csca");

var $fHxKM = parcelRequire("fHxKM");

var $giz0B = parcelRequire("giz0B");

var $bjKUF = parcelRequire("bjKUF");
function $1a55b5b1fbb31764$export$2e2bcd8739ae039(r, e) {
    return (0, $4Csca.default)(r) || (0, $fHxKM.default)(r, e) || (0, $giz0B.default)(r, e) || (0, $bjKUF.default)();
}

});
parcelRegister("4Csca", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $35d09509f0870ba8$export$2e2bcd8739ae039; });
function $35d09509f0870ba8$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("fHxKM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b6e50de66b8d998c$export$2e2bcd8739ae039; });
function $b6e50de66b8d998c$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("bjKUF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $83d5dbfe0091deda$export$2e2bcd8739ae039; });
function $83d5dbfe0091deda$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("cI4BR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $940d2b74a124c27d$export$2e2bcd8739ae039; });

var $efs8s = parcelRequire("efs8s");

var $2gb89 = parcelRequire("2gb89");

var $8ySUD = parcelRequire("8ySUD");

var $1oC0p = parcelRequire("1oC0p");

var $lRnUi = parcelRequire("lRnUi");

var $dXIpj = parcelRequire("dXIpj");

var $bHeQo = parcelRequire("bHeQo");

var $eAo9o = parcelRequire("eAo9o");

var $fqjcg = parcelRequire("fqjcg");
var $940d2b74a124c27d$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $940d2b74a124c27d$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $940d2b74a124c27d$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $lRnUi.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $lRnUi.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, $8ySUD.default)(_ref, $940d2b74a124c27d$var$_excluded);
    var _useGlobalTheme = (0, $dXIpj.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $fqjcg.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2gb89.default)(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $1oC0p.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($940d2b74a124c27d$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $1oC0p.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($940d2b74a124c27d$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $1oC0p.useMemo)(function() {
        return (0, $eAo9o.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bHeQo.default), (0, $efs8s.default)({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$940d2b74a124c27d$var$Button.displayName = 'Button';
var $940d2b74a124c27d$export$2e2bcd8739ae039 = $940d2b74a124c27d$var$Button;

});
parcelRegister("lRnUi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fea117a19c887973$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $fea117a19c887973$export$2e2bcd8739ae039() {}

});

parcelRegister("dXIpj", function(module, exports) {
$parcel$export(module.exports, "useGlobalTheme", function () { return $a2a33b6632037cfb$export$7692396083754928; });

var $kISmd = parcelRequire("kISmd");
// Create default global light theme
var $a2a33b6632037cfb$var$_createTheme = (0, $kISmd.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $a2a33b6632037cfb$var$Provider = $a2a33b6632037cfb$var$_createTheme.Provider, $a2a33b6632037cfb$var$Consumer = $a2a33b6632037cfb$var$_createTheme.Consumer, $a2a33b6632037cfb$export$7692396083754928 = $a2a33b6632037cfb$var$_createTheme.useTheme;
var $a2a33b6632037cfb$var$Theme = {
    Provider: $a2a33b6632037cfb$var$Provider,
    Consumer: $a2a33b6632037cfb$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a2a33b6632037cfb$export$2e2bcd8739ae039 = $a2a33b6632037cfb$var$Theme;

});
parcelRegister("kISmd", function(module, exports) {
$parcel$export(module.exports, "createTheme", function () { return $f16214f383d71fec$export$25d302a5b900a763; });

var $8ySUD = parcelRequire("8ySUD");

var $1oC0p = parcelRequire("1oC0p");
var $f16214f383d71fec$var$_excluded = [
    "children"
];
function $f16214f383d71fec$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1oC0p.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $8ySUD.default)(props, $f16214f383d71fec$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1oC0p.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1oC0p.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("bHeQo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $883f399223d193ba$export$2e2bcd8739ae039; });

var $efs8s = parcelRequire("efs8s");

var $8ySUD = parcelRequire("8ySUD");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $iiIHF = parcelRequire("iiIHF");

var $lRnUi = parcelRequire("lRnUi");

var $gSqBs = parcelRequire("gSqBs");

var $cH8hr = parcelRequire("cH8hr");

var $01IpD = parcelRequire("01IpD");

var $iqCss = parcelRequire("iqCss");

var $h9HfW = parcelRequire("h9HfW");

var $eAo9o = parcelRequire("eAo9o");

var $aEC1p = parcelRequire("aEC1p");
var $883f399223d193ba$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $883f399223d193ba$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $883f399223d193ba$var$iconBeforeSpacingFixStyle = (0, $3dJ4i.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $883f399223d193ba$var$iconAfterSpacingFixStyle = (0, $3dJ4i.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $883f399223d193ba$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $aEC1p.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $883f399223d193ba$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $aEC1p.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $3dJ4i.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $883f399223d193ba$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $lRnUi.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $lRnUi.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, $8ySUD.default)(props, $883f399223d193ba$var$_excluded);
    var ourRef = (0, $1oC0p.useRef)();
    var setRef = (0, $1oC0p.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $gSqBs.default)(ourRef, autoFocus);
    var interactionContext = (0, $1oC0p.useContext)((0, $01IpD.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $iiIHF.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $1oC0p.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $1oC0p.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $3dJ4i.css)((0, $eAo9o.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $iqCss.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $iqCss.N500), ")"), " !important")
        }
    };
    return (0, $3dJ4i.jsx)((0, $cH8hr.default), null, (0, $3dJ4i.jsx)(Component, (0, $efs8s.default)({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $883f399223d193ba$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $h9HfW.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $3dJ4i.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $eAo9o.getIconStyle)({
                spacing: spacing
            }),
            $883f399223d193ba$var$getSpacingFix(children, $883f399223d193ba$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $883f399223d193ba$var$getChildren(children, [
        fadeStyles,
        (0, $eAo9o.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $3dJ4i.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $eAo9o.getIconStyle)({
                spacing: spacing
            }),
            $883f399223d193ba$var$getSpacingFix(children, $883f399223d193ba$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $3dJ4i.jsx)("span", {
        css: [
            (0, $eAo9o.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$883f399223d193ba$export$2e2bcd8739ae039 = $883f399223d193ba$var$ButtonBase;

});
parcelRegister("iiIHF", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $d52c9599e9cb6087$export$a4687b0234b40e28; });

var $9Sn3s = parcelRequire("9Sn3s");

var $1oC0p = parcelRequire("1oC0p");

var $d70M0 = parcelRequire("d70M0");

var $6f3AQ = parcelRequire("6f3AQ");
function $d52c9599e9cb6087$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d52c9599e9cb6087$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d52c9599e9cb6087$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d52c9599e9cb6087$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d52c9599e9cb6087$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $d70M0.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $6f3AQ.useTrackedRef)(analyticsData);
    var fnRef = (0, $6f3AQ.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $d52c9599e9cb6087$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("d70M0", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $98bc87635b72870e$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $7tXbC = parcelRequire("7tXbC");

var $2tS1v = parcelRequire("2tS1v");
function $98bc87635b72870e$export$5bf35293e545f20c() {
    var analyticsContext = (0, $2tS1v.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $7tXbC.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("7tXbC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5729270389bc38d7$export$2e2bcd8739ae039; });

var $342Py = parcelRequire("342Py");

var $3AhEU = parcelRequire("3AhEU");

var $gWIyR = parcelRequire("gWIyR");

var $ciMo5 = parcelRequire("ciMo5");

var $g9Nc1 = parcelRequire("g9Nc1");

var $9kUlu = parcelRequire("9kUlu");

var $c3W0a = parcelRequire("c3W0a");

var $9Sn3s = parcelRequire("9Sn3s");

var $2m4Pv = parcelRequire("2m4Pv");
function $5729270389bc38d7$var$_callSuper(t, o, e) {
    return o = (0, $g9Nc1.default)(o), (0, $ciMo5.default)(t, $5729270389bc38d7$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $g9Nc1.default)(t).constructor) : o.apply(t, e));
}
function $5729270389bc38d7$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5729270389bc38d7$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $5729270389bc38d7$var$_superPropGet(t, o, e, r) {
    var p = (0, $9kUlu.default)((0, $g9Nc1.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $5729270389bc38d7$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $5729270389bc38d7$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $5729270389bc38d7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $3AhEU.default)(this, UIAnalyticsEvent);
        _this = $5729270389bc38d7$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $9Sn3s.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $9Sn3s.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $342Py.default)(_this.context);
            var handlers = (0, $342Py.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $9Sn3s.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $c3W0a.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $gWIyR.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $5729270389bc38d7$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $2m4Pv.default));

});
parcelRegister("9kUlu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6cc1b066ac95be42$export$2e2bcd8739ae039; });

var $a22q5 = parcelRequire("a22q5");
function $6cc1b066ac95be42$export$2e2bcd8739ae039() {
    return $6cc1b066ac95be42$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $a22q5.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $6cc1b066ac95be42$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("a22q5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $74dbf7d2e50db164$export$2e2bcd8739ae039; });

var $g9Nc1 = parcelRequire("g9Nc1");
function $74dbf7d2e50db164$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $g9Nc1.default)(t)););
    return t;
}

});


parcelRegister("2m4Pv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1b7161f33b2e1ea2$export$2e2bcd8739ae039; });

var $6DX60 = parcelRequire("6DX60");

var $3AhEU = parcelRequire("3AhEU");

var $gWIyR = parcelRequire("gWIyR");

var $9Sn3s = parcelRequire("9Sn3s");
function $1b7161f33b2e1ea2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1b7161f33b2e1ea2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1b7161f33b2e1ea2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1b7161f33b2e1ea2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1b7161f33b2e1ea2$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $1b7161f33b2e1ea2$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $1b7161f33b2e1ea2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $3AhEU.default)(this, AnalyticsEvent);
        (0, $9Sn3s.default)(this, "_isAnalyticsEvent", true);
        (0, $9Sn3s.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $1b7161f33b2e1ea2$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $gWIyR.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $6DX60.default)(updater) === 'object') this.payload = $1b7161f33b2e1ea2$var$_objectSpread($1b7161f33b2e1ea2$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("2tS1v", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $1ce8321a1a5b5965$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $1ce8321a1a5b5965$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("6f3AQ", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $48b6ee51273a9dfa$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $48b6ee51273a9dfa$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("gSqBs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c496534de59953d5$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $c496534de59953d5$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("01IpD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $00528b8121afcd07$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $00528b8121afcd07$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("iqCss", function(module, exports) {
$parcel$export(module.exports, "R50", function () { return $d6a87ca65a886e3b$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R300", function () { return $d6a87ca65a886e3b$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $d6a87ca65a886e3b$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $d6a87ca65a886e3b$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $d6a87ca65a886e3b$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y200", function () { return $d6a87ca65a886e3b$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $d6a87ca65a886e3b$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $d6a87ca65a886e3b$export$59619663aa6500fb; });
$parcel$export(module.exports, "Y500", function () { return $d6a87ca65a886e3b$export$874739ea9e379ab6; });
$parcel$export(module.exports, "G50", function () { return $d6a87ca65a886e3b$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G500", function () { return $d6a87ca65a886e3b$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $d6a87ca65a886e3b$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $d6a87ca65a886e3b$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $d6a87ca65a886e3b$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $d6a87ca65a886e3b$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $d6a87ca65a886e3b$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $d6a87ca65a886e3b$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $d6a87ca65a886e3b$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "P50", function () { return $d6a87ca65a886e3b$export$363e4475840015bb; });
$parcel$export(module.exports, "P500", function () { return $d6a87ca65a886e3b$export$147899de772240ec; });
$parcel$export(module.exports, "N0", function () { return $d6a87ca65a886e3b$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $d6a87ca65a886e3b$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N70", function () { return $d6a87ca65a886e3b$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $d6a87ca65a886e3b$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $d6a87ca65a886e3b$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $d6a87ca65a886e3b$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N400", function () { return $d6a87ca65a886e3b$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $d6a87ca65a886e3b$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $d6a87ca65a886e3b$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $d6a87ca65a886e3b$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $d6a87ca65a886e3b$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $d6a87ca65a886e3b$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $d6a87ca65a886e3b$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $d6a87ca65a886e3b$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $d6a87ca65a886e3b$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $d6a87ca65a886e3b$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $d6a87ca65a886e3b$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $d6a87ca65a886e3b$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $d6a87ca65a886e3b$export$3d4f271a500072a; });
// Reds
var $d6a87ca65a886e3b$export$4b84fd0e2c617bd = '#FFEBE6';
var $d6a87ca65a886e3b$export$b34b069eff244586 = '#FFBDAD';
var $d6a87ca65a886e3b$export$be802dd0d8b57f35 = '#FF8F73';
var $d6a87ca65a886e3b$export$60847d42f9da92a6 = '#FF7452';
var $d6a87ca65a886e3b$export$4a7404f376229999 = '#FF5630';
var $d6a87ca65a886e3b$export$2010d0fb4295b346 = '#DE350B';
var $d6a87ca65a886e3b$export$2837b5a1a71d5c02 = '#BF2600';
var $d6a87ca65a886e3b$export$8d9596b529bbb9cf = '#FFFAE6';
var $d6a87ca65a886e3b$export$41060a744ab0b7ae = '#FFF0B3';
var $d6a87ca65a886e3b$export$1cc05bbbf340e559 = '#FFE380';
var $d6a87ca65a886e3b$export$5aae31392d72caaa = '#FFC400';
var $d6a87ca65a886e3b$export$c6930421db9fa514 = '#FFAB00';
var $d6a87ca65a886e3b$export$59619663aa6500fb = '#FF991F';
var $d6a87ca65a886e3b$export$874739ea9e379ab6 = '#FF8B00';
var $d6a87ca65a886e3b$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $d6a87ca65a886e3b$export$69a3bf21b9686c2b = '#ABF5D1';
var $d6a87ca65a886e3b$export$afbce1382ec95f73 = '#79F2C0';
var $d6a87ca65a886e3b$export$747d86715d4175de = '#57D9A3';
var $d6a87ca65a886e3b$export$940e1f69e873f202 = '#36B37E';
var $d6a87ca65a886e3b$export$a49394138f7b8e85 = '#00875A';
var $d6a87ca65a886e3b$export$6fa04827ac68a4fb = '#006644';
var $d6a87ca65a886e3b$export$226de0355ed012f8 = '#DEEBFF';
var $d6a87ca65a886e3b$export$8c13c2ee36917869 = '#B3D4FF';
var $d6a87ca65a886e3b$export$ecfc1dff386a3e7a = '#4C9AFF';
var $d6a87ca65a886e3b$export$215b7063051591f1 = '#2684FF';
var $d6a87ca65a886e3b$export$e62e8919cca44969 = '#0065FF';
var $d6a87ca65a886e3b$export$b3de0ae08da2ce64 = '#0052CC';
var $d6a87ca65a886e3b$export$a6ee3d71bc067634 = '#0747A6';
var $d6a87ca65a886e3b$export$67f15409e87642a1 = '#669DF1';
var $d6a87ca65a886e3b$export$f0539dbc42dbb067 = '#8FB8F6';
var $d6a87ca65a886e3b$export$363e4475840015bb = '#EAE6FF';
var $d6a87ca65a886e3b$export$4b0a4417ed59760f = '#C0B6F2';
var $d6a87ca65a886e3b$export$6011520a64d9a187 = '#998DD9';
var $d6a87ca65a886e3b$export$a7175d4e9206bc80 = '#8777D9';
var $d6a87ca65a886e3b$export$b48405b95304b5a1 = '#6554C0';
var $d6a87ca65a886e3b$export$c71e4279dd54a18d = '#5243AA';
var $d6a87ca65a886e3b$export$147899de772240ec = '#403294';
var $d6a87ca65a886e3b$export$2cf711fe14c66f06 = '#E6FCFF';
var $d6a87ca65a886e3b$export$7a8f4d33f6f9772c = '#B3F5FF';
var $d6a87ca65a886e3b$export$776c9c497ef08533 = '#79E2F2';
var $d6a87ca65a886e3b$export$69cb3ca10c1e330e = '#00C7E6';
var $d6a87ca65a886e3b$export$9dc1ef0f3f48059b = '#00B8D9';
var $d6a87ca65a886e3b$export$7c835c78b6fcdef8 = '#00A3BF';
var $d6a87ca65a886e3b$export$6036577f95c3877e = '#008DA6';
var $d6a87ca65a886e3b$export$29a4f05edc054374 = '#FFFFFF';
var $d6a87ca65a886e3b$export$e655ef011c4aa1a2 = '#FAFBFC';
var $d6a87ca65a886e3b$export$9fdfb749e33cdf97 = '#F4F5F7';
var $d6a87ca65a886e3b$export$3e51e8f1440314ba = '#EBECF0';
var $d6a87ca65a886e3b$export$1ce2d1575d444ceb = '#DFE1E6';
var $d6a87ca65a886e3b$export$8754fc7e6d8b3000 = '#C1C7D0';
var $d6a87ca65a886e3b$export$c2e91cbeada39b8b = '#B3BAC5';
var $d6a87ca65a886e3b$export$5f71e19f3a7ad9de = '#A5ADBA';
var $d6a87ca65a886e3b$export$eaa8c8a70ac22806 = '#97A0AF';
var $d6a87ca65a886e3b$export$7c87d337fb91a97d = '#8993A4';
var $d6a87ca65a886e3b$export$d6447c357493214f = '#7A869A';
var $d6a87ca65a886e3b$export$f563ee71e9ee74cd = '#6B778C';
var $d6a87ca65a886e3b$export$e2ef2124cf4024b1 = '#5E6C84';
var $d6a87ca65a886e3b$export$eece5f492e429f08 = '#505F79';
var $d6a87ca65a886e3b$export$c39c0fe0f26207ae = '#42526E';
var $d6a87ca65a886e3b$export$7090862dc3038a9f = '#344563';
var $d6a87ca65a886e3b$export$ad0bacf983b7ddaa = '#253858';
var $d6a87ca65a886e3b$export$7d61b15e0da132af = '#172B4D';
var $d6a87ca65a886e3b$export$fbda843f0a27fe96 = '#091E42';
var $d6a87ca65a886e3b$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $d6a87ca65a886e3b$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $d6a87ca65a886e3b$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $d6a87ca65a886e3b$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $d6a87ca65a886e3b$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $d6a87ca65a886e3b$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $d6a87ca65a886e3b$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $d6a87ca65a886e3b$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $d6a87ca65a886e3b$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $d6a87ca65a886e3b$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $d6a87ca65a886e3b$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $d6a87ca65a886e3b$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $d6a87ca65a886e3b$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $d6a87ca65a886e3b$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $d6a87ca65a886e3b$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $d6a87ca65a886e3b$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $d6a87ca65a886e3b$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $d6a87ca65a886e3b$export$2f6319cf7d736c2a = '#E6EDFA';
var $d6a87ca65a886e3b$export$95126bc8884d6634 = '#DCE5F5';
var $d6a87ca65a886e3b$export$8338d8c35d44ff1 = '#CED9EB';
var $d6a87ca65a886e3b$export$5368d76ae4fbbda7 = '#B8C7E0';
var $d6a87ca65a886e3b$export$9f0a771d16ec8d36 = '#ABBBD6';
var $d6a87ca65a886e3b$export$abcf8c38338b4aa5 = '#9FB0CC';
var $d6a87ca65a886e3b$export$97e81faa16a182c7 = '#8C9CB8';
var $d6a87ca65a886e3b$export$bfe21c59123ecf33 = '#7988A3';
var $d6a87ca65a886e3b$export$ee82aa2ea6a1558 = '#67758F';
var $d6a87ca65a886e3b$export$682927c6ed76be02 = '#56637A';
var $d6a87ca65a886e3b$export$91fd9994c5be9757 = '#455166';
var $d6a87ca65a886e3b$export$d281fbfe3cff2df6 = '#3B475C';
var $d6a87ca65a886e3b$export$3902c91d8b98a753 = '#313D52';
var $d6a87ca65a886e3b$export$8e8133c1ba5845b5 = '#283447';
var $d6a87ca65a886e3b$export$33ff357f6620b39 = '#202B3D';
var $d6a87ca65a886e3b$export$633847cf062b69e0 = '#1B2638';
var $d6a87ca65a886e3b$export$9776a6e503bdbf76 = '#121A29';
var $d6a87ca65a886e3b$export$6c813d5160dff5db = '#0E1624';
var $d6a87ca65a886e3b$export$3d4f271a500072a = '#0D1424';
var $d6a87ca65a886e3b$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $d6a87ca65a886e3b$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $d6a87ca65a886e3b$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $d6a87ca65a886e3b$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $d6a87ca65a886e3b$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $d6a87ca65a886e3b$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $d6a87ca65a886e3b$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $d6a87ca65a886e3b$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $d6a87ca65a886e3b$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $d6a87ca65a886e3b$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $d6a87ca65a886e3b$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $d6a87ca65a886e3b$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $d6a87ca65a886e3b$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $d6a87ca65a886e3b$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $d6a87ca65a886e3b$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $d6a87ca65a886e3b$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $d6a87ca65a886e3b$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $d6a87ca65a886e3b$export$d2adc5dedf09fced = '#292A2E';
var $d6a87ca65a886e3b$export$f51762073d2bb381 = '#94C748';
var $d6a87ca65a886e3b$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("h9HfW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c7d4d4ac2723516c$export$2e2bcd8739ae039; });
function $c7d4d4ac2723516c$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $c7d4d4ac2723516c$var$tabKeyCode = 9;
function $c7d4d4ac2723516c$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $c7d4d4ac2723516c$var$tabKeyCode) return;
    $c7d4d4ac2723516c$var$abort(event);
}
var $c7d4d4ac2723516c$var$block = {
    onMouseDownCapture: $c7d4d4ac2723516c$var$abort,
    onMouseUpCapture: $c7d4d4ac2723516c$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $c7d4d4ac2723516c$var$onKey,
    onKeyUpCapture: $c7d4d4ac2723516c$var$onKey,
    onTouchStartCapture: $c7d4d4ac2723516c$var$abort,
    onTouchEndCapture: $c7d4d4ac2723516c$var$abort,
    onPointerDownCapture: $c7d4d4ac2723516c$var$abort,
    onPointerUpCapture: $c7d4d4ac2723516c$var$abort,
    onClickCapture: $c7d4d4ac2723516c$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $c7d4d4ac2723516c$var$abort
};
var $c7d4d4ac2723516c$var$doNotBlock = {};
function $c7d4d4ac2723516c$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $c7d4d4ac2723516c$var$doNotBlock : $c7d4d4ac2723516c$var$block;
}

});

parcelRegister("eAo9o", function(module, exports) {
$parcel$export(module.exports, "getCss", function () { return $a9e72944af39280a$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $a9e72944af39280a$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $a9e72944af39280a$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $a9e72944af39280a$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $a9e72944af39280a$export$1a9fe1b84c876bb5; });

var $9Sn3s = parcelRequire("9Sn3s");

var $3dJ4i = parcelRequire("3dJ4i");

var $39c3M = parcelRequire("39c3M");

var $5oNzw = parcelRequire("5oNzw");
function $a9e72944af39280a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a9e72944af39280a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a9e72944af39280a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a9e72944af39280a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a9e72944af39280a$var$gridSize = 8;
var $a9e72944af39280a$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $a9e72944af39280a$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $a9e72944af39280a$var$lineHeights = {
    default: $a9e72944af39280a$var$heights.default,
    compact: $a9e72944af39280a$var$heights.compact,
    none: 'inherit'
};
var $a9e72944af39280a$var$padding = {
    // 10px gutter
    default: "0 ".concat($a9e72944af39280a$var$gridSize + $a9e72944af39280a$var$gridSize / 4, "px"),
    compact: "0 ".concat($a9e72944af39280a$var$gridSize + $a9e72944af39280a$var$gridSize / 4, "px"),
    none: '0'
};
var $a9e72944af39280a$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($a9e72944af39280a$var$gridSize / 4, "px"),
    default: "0 ".concat($a9e72944af39280a$var$gridSize / 4, "px"),
    none: '0'
};
var $a9e72944af39280a$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $a9e72944af39280a$var$innerMargin = {
    content: "0 ".concat($a9e72944af39280a$var$gridSize / 4, "px"),
    icon: "0 ".concat($a9e72944af39280a$var$gridSize / 4, "px")
};
var $a9e72944af39280a$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $a9e72944af39280a$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    '&::after': $a9e72944af39280a$var$_objectSpread($a9e72944af39280a$var$_objectSpread({}, $a9e72944af39280a$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $a9e72944af39280a$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
var $a9e72944af39280a$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #0C66E4)",
    '&:hover': {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: 'underline'
    }
};
var $a9e72944af39280a$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $a9e72944af39280a$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #172B4D)",
        textDecoration: 'underline'
    }
};
var $a9e72944af39280a$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
var $a9e72944af39280a$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $a9e72944af39280a$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    '&:not([disabled])::after': $a9e72944af39280a$var$_objectSpread($a9e72944af39280a$var$_objectSpread({}, $a9e72944af39280a$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $a9e72944af39280a$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $a9e72944af39280a$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $a9e72944af39280a$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $a9e72944af39280a$var$getColor({
            group: (0, $5oNzw.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($a9e72944af39280a$var$getColor({
            group: (0, $5oNzw.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $a9e72944af39280a$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $a9e72944af39280a$var$getColors({
        appearance: appearance,
        key: isSelected ? 'selected' : 'default',
        mode: mode
    });
    return $a9e72944af39280a$var$_objectSpread($a9e72944af39280a$var$_objectSpread($a9e72944af39280a$var$_objectSpread($a9e72944af39280a$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap'
    }, !(0, $39c3M.fg)('platform-component-visual-refresh') && baseColors), {}, {
        cursor: 'pointer',
        height: $a9e72944af39280a$var$heights[spacing],
        lineHeight: $a9e72944af39280a$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $a9e72944af39280a$var$singleIconPadding[spacing] : $a9e72944af39280a$var$padding[spacing],
        verticalAlign: $a9e72944af39280a$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, !(0, $39c3M.fg)('platform-component-visual-refresh') && $a9e72944af39280a$var$_objectSpread($a9e72944af39280a$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        '&:visited': $a9e72944af39280a$var$_objectSpread({}, baseColors),
        '&:hover': $a9e72944af39280a$var$_objectSpread($a9e72944af39280a$var$_objectSpread({}, $a9e72944af39280a$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'hover',
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'inherit',
            // background, box-shadow
            transitionDuration: '0s, 0.15s'
        }),
        // giving active styles preference by listing them after focus
        '&:active': $a9e72944af39280a$var$_objectSpread($a9e72944af39280a$var$_objectSpread({}, $a9e72944af39280a$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $a9e72944af39280a$var$_objectSpread($a9e72944af39280a$var$_objectSpread({}, $a9e72944af39280a$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        '&[disabled]': $a9e72944af39280a$var$_objectSpread($a9e72944af39280a$var$_objectSpread({}, $a9e72944af39280a$var$getColors({
            appearance: appearance,
            key: 'disabled',
            mode: mode
        })), {}, {
            cursor: 'not-allowed',
            textDecoration: 'none'
        })
    }, $a9e72944af39280a$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $a9e72944af39280a$var$_objectSpread({}, $a9e72944af39280a$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'default',
            mode: mode
        }))
    })), (0, $39c3M.fg)('platform-component-visual-refresh') && (isSelected ? $a9e72944af39280a$var$selectedStyles : $a9e72944af39280a$var$_objectSpread($a9e72944af39280a$var$_objectSpread($a9e72944af39280a$var$_objectSpread($a9e72944af39280a$var$_objectSpread($a9e72944af39280a$var$_objectSpread($a9e72944af39280a$var$_objectSpread($a9e72944af39280a$var$_objectSpread($a9e72944af39280a$var$_objectSpread({}, appearance === 'default' && $a9e72944af39280a$var$defaultStyles), appearance === 'primary' && $a9e72944af39280a$var$primaryStyles), appearance === 'link' && $a9e72944af39280a$var$linkStyles), appearance === 'subtle' && $a9e72944af39280a$var$subtleStyles), appearance === 'subtle-link' && $a9e72944af39280a$var$subtleLinkStyles), appearance === 'warning' && $a9e72944af39280a$var$warningStyles), appearance === 'danger' && $a9e72944af39280a$var$dangerStyles), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $a9e72944af39280a$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $a9e72944af39280a$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $a9e72944af39280a$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
            }
        }
    }, $a9e72944af39280a$var$hasOverlayStyles))), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $a9e72944af39280a$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $3dJ4i.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $a9e72944af39280a$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $a9e72944af39280a$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $3dJ4i.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $a9e72944af39280a$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $a9e72944af39280a$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $3dJ4i.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
var $a9e72944af39280a$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});
parcelRegister("5oNzw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3ee5a5932eda4edd$export$2e2bcd8739ae039; });

var $iqCss = parcelRequire("iqCss");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $3ee5a5932eda4edd$var$fadedB75 = 'rgba(179, 212, 255, 0.6)';
var $3ee5a5932eda4edd$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($iqCss.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($iqCss.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($iqCss.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($iqCss.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($3ee5a5932eda4edd$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($iqCss.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($iqCss.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($iqCss.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($iqCss.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($iqCss.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($iqCss.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($iqCss.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($iqCss.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($iqCss.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($iqCss.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($iqCss.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($iqCss.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($iqCss.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($iqCss.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($iqCss.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($iqCss.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($iqCss.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($iqCss.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($iqCss.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($iqCss.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($iqCss.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($iqCss.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($iqCss.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($iqCss.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($iqCss.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($iqCss.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($iqCss.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($iqCss.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($iqCss.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($iqCss.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($iqCss.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($iqCss.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($iqCss.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($iqCss.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($iqCss.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($iqCss.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($iqCss.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($iqCss.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($iqCss.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($iqCss.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($iqCss.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($iqCss.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($iqCss.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($iqCss.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($iqCss.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($iqCss.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($iqCss.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($iqCss.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($iqCss.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($3ee5a5932eda4edd$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($iqCss.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($iqCss.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($iqCss.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($iqCss.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($iqCss.DN0, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($iqCss.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($iqCss.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($iqCss.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($iqCss.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($iqCss.N500, ")"),
                dark: "var(--ds-text, ".concat($iqCss.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($iqCss.B400, ")"),
                dark: "var(--ds-text, ".concat($iqCss.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($iqCss.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($iqCss.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($iqCss.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($iqCss.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($iqCss.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($iqCss.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($iqCss.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($iqCss.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($iqCss.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($iqCss.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($iqCss.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($iqCss.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($iqCss.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($iqCss.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($iqCss.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($iqCss.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($iqCss.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($iqCss.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($iqCss.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($iqCss.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($iqCss.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($iqCss.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($iqCss.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($iqCss.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($iqCss.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($iqCss.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($iqCss.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($iqCss.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($iqCss.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($iqCss.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($iqCss.B400, ")"),
                dark: "var(--ds-link, ".concat($iqCss.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($iqCss.B300, ")"),
                dark: "var(--ds-link, ".concat($iqCss.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($iqCss.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($iqCss.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($iqCss.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($iqCss.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($iqCss.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($iqCss.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($iqCss.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($iqCss.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($iqCss.N500, ")"),
                dark: "var(--ds-text, ".concat($iqCss.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($iqCss.B400, ")"),
                dark: "var(--ds-text, ".concat($iqCss.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($iqCss.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($iqCss.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($iqCss.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($iqCss.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($iqCss.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($iqCss.DN400, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-text-subtle, ".concat($iqCss.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($iqCss.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($iqCss.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($iqCss.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($iqCss.N400, ")"),
                dark: "var(--ds-text, ".concat($iqCss.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($iqCss.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($iqCss.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($iqCss.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($iqCss.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($iqCss.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($iqCss.DN400, ")")
            }
        }
    }
};
var $3ee5a5932eda4edd$export$2e2bcd8739ae039 = $3ee5a5932eda4edd$var$values;

});


parcelRegister("aEC1p", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $7c1b2221323ad5ac$export$20bbd2efb0d734c4; });

var $1oC0p = parcelRequire("1oC0p");

var $8vIkL = parcelRequire("8vIkL");
var $7c1b2221323ad5ac$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $1oC0p.isValidElement)(children) && children.type === (0, $8vIkL.default);
};

});
parcelRegister("8vIkL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $63239bcaaa40f724$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $1oC0p = parcelRequire("1oC0p");

var $72zBO = parcelRequire("72zBO");
var $63239bcaaa40f724$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $63239bcaaa40f724$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $72zBO.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $63239bcaaa40f724$export$2e2bcd8739ae039 = $63239bcaaa40f724$var$VisuallyHidden;

});
parcelRegister("72zBO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $52045780c9ca0e8b$export$2e2bcd8739ae039; });
const $52045780c9ca0e8b$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $52045780c9ca0e8b$var$ATOMIC_GROUP_LENGTH = 5;
function $52045780c9ca0e8b$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $52045780c9ca0e8b$var$UNDERSCORE_UNICODE ? $52045780c9ca0e8b$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});




parcelRegister("fqjcg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b3a82cd45cd21eea$export$2e2bcd8739ae039; });

var $aEC1p = parcelRequire("aEC1p");
function $b3a82cd45cd21eea$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $aEC1p.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("btuK0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $85aa3fa656e979e9$export$2e2bcd8739ae039; });
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $efs8s = parcelRequire("efs8s");

var $2gb89 = parcelRequire("2gb89");

var $8ySUD = parcelRequire("8ySUD");

var $1oC0p = parcelRequire("1oC0p");

var $f0JWV = parcelRequire("f0JWV");

var $iiIHF = parcelRequire("iiIHF");

var $aQ5sv = parcelRequire("aQ5sv");

var $dIjlA = parcelRequire("dIjlA");
var $3frgl = parcelRequire("3frgl");
var $blvp4 = parcelRequire("blvp4");
var $gNxu7 = parcelRequire("gNxu7");
var $85aa3fa656e979e9$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId",
    "xcss",
    "className"
];
/**
 * Using `cssMap` to avoid a Compiled bug with the transformed styles.
 * It was using a CSS variable for the outline template string,
 * which broke because of the use of a sibling selector.
 *
 * Related to: https://github.com/atlassian-labs/compiled/pull/1795
 *
 * Using `cssMap` seems to be a workaround for this.
 */ var $85aa3fa656e979e9$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
};
/**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ var $85aa3fa656e979e9$var$Checkbox = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function Checkbox(_ref, ref) {
    var isCheckedProp = _ref.isChecked, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$defaultChecked = _ref.defaultChecked, defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked, _ref$isIndeterminate = _ref.isIndeterminate, isIndeterminate = _ref$isIndeterminate === void 0 ? false : _ref$isIndeterminate, onChangeProps = _ref.onChange, analyticsContext = _ref.analyticsContext, label = _ref.label, name = _ref.name, value = _ref.value, isRequired = _ref.isRequired, testId = _ref.testId, xcss = _ref.xcss, className = _ref.className, rest = (0, $8ySUD.default)(_ref, $85aa3fa656e979e9$var$_excluded);
    var _useState = (0, $1oC0p.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, $2gb89.default)(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $iiIHF.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "@atlaskit/checkbox",
        packageVersion: "17.1.8"
    });
    var internalRef = (0, $1oC0p.useRef)(null);
    var mergedRefs = (0, $aQ5sv.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $1oC0p.useEffect)(function() {
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $1oC0p.createElement((0, $3frgl.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label"),
        xcss: xcss
    }, /*#__PURE__*/ $1oC0p.createElement("input", (0, $efs8s.default)({
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0
    }, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $f0JWV.default)([
            $85aa3fa656e979e9$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? 'true' : undefined
    })), /*#__PURE__*/ $1oC0p.createElement((0, $dIjlA.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $1oC0p.createElement((0, $blvp4.default), null, label, isRequired && /*#__PURE__*/ $1oC0p.createElement((0, $gNxu7.default), null)));
}));
$85aa3fa656e979e9$var$Checkbox.displayName = 'Checkbox';
var $85aa3fa656e979e9$export$2e2bcd8739ae039 = $85aa3fa656e979e9$var$Checkbox;

});
parcelRegister("f0JWV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aeda7fb26ab646b8$export$2e2bcd8739ae039; });
const $aeda7fb26ab646b8$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $aeda7fb26ab646b8$var$ATOMIC_GROUP_LENGTH = 5;
function $aeda7fb26ab646b8$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $aeda7fb26ab646b8$var$UNDERSCORE_UNICODE ? $aeda7fb26ab646b8$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("aQ5sv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7e42feb65a5cd1d5$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $7e42feb65a5cd1d5$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("dIjlA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9fbe6461f834359a$export$2e2bcd8739ae039; });
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");


var $befez = parcelRequire("befez");

var $39c3M = parcelRequire("39c3M");
function $9fbe6461f834359a$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $39c3M.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ $1oC0p.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ $1oC0p.createElement("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $39c3M.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ $1oC0p.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ $1oC0p.createElement("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $9fbe6461f834359a$var$CheckboxIcon = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $1oC0p.useMemo)(function() {
        return $9fbe6461f834359a$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $1oC0p.createElement((0, $befez.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ $1oC0p.createElement("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $39c3M.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ $1oC0p.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5"
    }) : /*#__PURE__*/ $1oC0p.createElement("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $9fbe6461f834359a$export$2e2bcd8739ae039 = $9fbe6461f834359a$var$CheckboxIcon;

});
parcelRegister("befez", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $82ccd1a5e6889ca9$export$2e2bcd8739ae039; });
/* svg.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f0JWV = parcelRequire("f0JWV");
var $82ccd1a5e6889ca9$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
var $82ccd1a5e6889ca9$var$svgStyles = null;
/**
 * __SVG__
 *
 * @deprecated Custom SVG is deprecated and will be removed from `atlaskit/icon` in an upcoming major release. Please use either an existing icon from @atlaskit/icon or @atlaskit/icon-lab, or contributing to @atlaskit/icon-lab directly. For third party logos, use an SVG element along with a label.
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ var $82ccd1a5e6889ca9$var$SVG = /*#__PURE__*/ (0, $1oC0p.memo)(function SVG(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, label = _ref.label, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, testId = _ref.testId, children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor
        },
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $f0JWV.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw _vc881r31",
            $82ccd1a5e6889ca9$var$sizeStyles[size]
        ])
    }, children);
});
var $82ccd1a5e6889ca9$export$2e2bcd8739ae039 = $82ccd1a5e6889ca9$var$SVG;

});


parcelRegister("3frgl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $25d7eb9dfadf317d$export$2e2bcd8739ae039; });
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f0JWV = parcelRequire("f0JWV");
var $iOWnd = parcelRequire("iOWnd");

var $jczco = parcelRequire("jczco");
var $25d7eb9dfadf317d$var$baseStyles = null;
var $25d7eb9dfadf317d$var$textLabelLayoutStyles = null;
var $25d7eb9dfadf317d$var$disabledStyles = null;
var $25d7eb9dfadf317d$var$labelStyles = null;
function $25d7eb9dfadf317d$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, testId = _ref.testId, label = _ref.label, id = _ref.id, xcss = _ref.xcss;
    return /*#__PURE__*/ $1oC0p.createElement("label", {
        className: (0, $f0JWV.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazovqm _80om73ad",
            label && "_zulp1te3 _yv0ey09t",
            isDisabled && "_syaz7wap _80om13gf",
            "_h5e31kd8 _1nzs1kc0 _1esz1j4g _yp0j1ehr _ay2w1ouc _d51u12ci _phftddza _1g1fe69j _l6wk1j4g _1dik1ehr _1sfg1380 _fpdj1ouc _1yjc3zdg _oaj1ddza _1j3h1380 _eawbxz7c _1rdaeh7q _18q0snw8 _13hr1j28",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        style: {
            "--_5xk3r4": (0, $iOWnd.default)("var(--ds-text, ".concat((0, $jczco.N900), ")")),
            "--_1l71759": (0, $iOWnd.default)("var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-050, 4px)")),
            "--_1ynhf1h": (0, $iOWnd.default)("var(--ds-text-disabled, ".concat((0, $jczco.N80), ")")),
            "--_4mkb4g": (0, $iOWnd.default)("var(--ds-background-input, ".concat((0, $jczco.N10), ")")),
            "--_1cd0fcx": (0, $iOWnd.default)("var(--ds-background-input-pressed, ".concat((0, $jczco.B50), ")")),
            "--_1gcp7nr": (0, $iOWnd.default)("var(--ds-background-selected-bold, ".concat((0, $jczco.B400), ")")),
            "--_14y1fod": (0, $iOWnd.default)("var(--ds-background-selected-bold-hovered, ".concat((0, $jczco.B300), ")")),
            "--_r5pknd": (0, $iOWnd.default)("var(--ds-background-disabled, ".concat((0, $jczco.N20), ")")),
            "--_1z08gfx": (0, $iOWnd.default)("var(--ds-background-input-hovered, ".concat((0, $jczco.N30), ")")),
            "--_vnm8xo": (0, $iOWnd.default)("var(--ds-border-input, ".concat((0, $jczco.N100), ")")),
            "--_rczcge": (0, $iOWnd.default)("var(--ds-border, ".concat((0, $jczco.B50), ")")),
            "--_1i4xulb": (0, $iOWnd.default)("var(--ds-border-danger, ".concat((0, $jczco.R300), ")")),
            "--_xjqa3d": (0, $iOWnd.default)("var(--ds-border-focused, ".concat((0, $jczco.B200), ")")),
            "--_uq1ko9": (0, $iOWnd.default)("var(--ds-icon-inverse, ".concat((0, $jczco.B400), ")")),
            "--_jf353p": (0, $iOWnd.default)("var(--ds-icon-inverse, ".concat((0, $jczco.N10), ")")),
            "--_1xmcmw9": (0, $iOWnd.default)("var(--ds-icon-disabled, ".concat((0, $jczco.N70), ")"))
        }
    }, children);
}

});
parcelRegister("iOWnd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $db3a2d3cee81e76a$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $db3a2d3cee81e76a$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("jczco", function(module, exports) {
$parcel$export(module.exports, "R300", function () { return $dfaa711936ac34a7$export$4a7404f376229999; });
$parcel$export(module.exports, "R500", function () { return $dfaa711936ac34a7$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "B50", function () { return $dfaa711936ac34a7$export$226de0355ed012f8; });
$parcel$export(module.exports, "B200", function () { return $dfaa711936ac34a7$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $dfaa711936ac34a7$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $dfaa711936ac34a7$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N10", function () { return $dfaa711936ac34a7$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $dfaa711936ac34a7$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $dfaa711936ac34a7$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N70", function () { return $dfaa711936ac34a7$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N80", function () { return $dfaa711936ac34a7$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "N100", function () { return $dfaa711936ac34a7$export$d6447c357493214f; });
$parcel$export(module.exports, "N900", function () { return $dfaa711936ac34a7$export$fbda843f0a27fe96; });
// Reds
var $dfaa711936ac34a7$export$4b84fd0e2c617bd = '#FFEBE6';
var $dfaa711936ac34a7$export$b34b069eff244586 = '#FFBDAD';
var $dfaa711936ac34a7$export$be802dd0d8b57f35 = '#FF8F73';
var $dfaa711936ac34a7$export$60847d42f9da92a6 = '#FF7452';
var $dfaa711936ac34a7$export$4a7404f376229999 = '#FF5630';
var $dfaa711936ac34a7$export$2010d0fb4295b346 = '#DE350B';
var $dfaa711936ac34a7$export$2837b5a1a71d5c02 = '#BF2600';
var $dfaa711936ac34a7$export$8d9596b529bbb9cf = '#FFFAE6';
var $dfaa711936ac34a7$export$41060a744ab0b7ae = '#FFF0B3';
var $dfaa711936ac34a7$export$1cc05bbbf340e559 = '#FFE380';
var $dfaa711936ac34a7$export$5aae31392d72caaa = '#FFC400';
var $dfaa711936ac34a7$export$c6930421db9fa514 = '#FFAB00';
var $dfaa711936ac34a7$export$59619663aa6500fb = '#FF991F';
var $dfaa711936ac34a7$export$874739ea9e379ab6 = '#FF8B00';
var $dfaa711936ac34a7$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $dfaa711936ac34a7$export$69a3bf21b9686c2b = '#ABF5D1';
var $dfaa711936ac34a7$export$afbce1382ec95f73 = '#79F2C0';
var $dfaa711936ac34a7$export$747d86715d4175de = '#57D9A3';
var $dfaa711936ac34a7$export$940e1f69e873f202 = '#36B37E';
var $dfaa711936ac34a7$export$a49394138f7b8e85 = '#00875A';
var $dfaa711936ac34a7$export$6fa04827ac68a4fb = '#006644';
var $dfaa711936ac34a7$export$226de0355ed012f8 = '#DEEBFF';
var $dfaa711936ac34a7$export$8c13c2ee36917869 = '#B3D4FF';
var $dfaa711936ac34a7$export$ecfc1dff386a3e7a = '#4C9AFF';
var $dfaa711936ac34a7$export$215b7063051591f1 = '#2684FF';
var $dfaa711936ac34a7$export$e62e8919cca44969 = '#0065FF';
var $dfaa711936ac34a7$export$b3de0ae08da2ce64 = '#0052CC';
var $dfaa711936ac34a7$export$a6ee3d71bc067634 = '#0747A6';
var $dfaa711936ac34a7$export$67f15409e87642a1 = '#669DF1';
var $dfaa711936ac34a7$export$f0539dbc42dbb067 = '#8FB8F6';
var $dfaa711936ac34a7$export$363e4475840015bb = '#EAE6FF';
var $dfaa711936ac34a7$export$4b0a4417ed59760f = '#C0B6F2';
var $dfaa711936ac34a7$export$6011520a64d9a187 = '#998DD9';
var $dfaa711936ac34a7$export$a7175d4e9206bc80 = '#8777D9';
var $dfaa711936ac34a7$export$b48405b95304b5a1 = '#6554C0';
var $dfaa711936ac34a7$export$c71e4279dd54a18d = '#5243AA';
var $dfaa711936ac34a7$export$147899de772240ec = '#403294';
var $dfaa711936ac34a7$export$2cf711fe14c66f06 = '#E6FCFF';
var $dfaa711936ac34a7$export$7a8f4d33f6f9772c = '#B3F5FF';
var $dfaa711936ac34a7$export$776c9c497ef08533 = '#79E2F2';
var $dfaa711936ac34a7$export$69cb3ca10c1e330e = '#00C7E6';
var $dfaa711936ac34a7$export$9dc1ef0f3f48059b = '#00B8D9';
var $dfaa711936ac34a7$export$7c835c78b6fcdef8 = '#00A3BF';
var $dfaa711936ac34a7$export$6036577f95c3877e = '#008DA6';
var $dfaa711936ac34a7$export$29a4f05edc054374 = '#FFFFFF';
var $dfaa711936ac34a7$export$e655ef011c4aa1a2 = '#FAFBFC';
var $dfaa711936ac34a7$export$9fdfb749e33cdf97 = '#F4F5F7';
var $dfaa711936ac34a7$export$3e51e8f1440314ba = '#EBECF0';
var $dfaa711936ac34a7$export$1ce2d1575d444ceb = '#DFE1E6';
var $dfaa711936ac34a7$export$8754fc7e6d8b3000 = '#C1C7D0';
var $dfaa711936ac34a7$export$c2e91cbeada39b8b = '#B3BAC5';
var $dfaa711936ac34a7$export$5f71e19f3a7ad9de = '#A5ADBA';
var $dfaa711936ac34a7$export$eaa8c8a70ac22806 = '#97A0AF';
var $dfaa711936ac34a7$export$7c87d337fb91a97d = '#8993A4';
var $dfaa711936ac34a7$export$d6447c357493214f = '#7A869A';
var $dfaa711936ac34a7$export$f563ee71e9ee74cd = '#6B778C';
var $dfaa711936ac34a7$export$e2ef2124cf4024b1 = '#5E6C84';
var $dfaa711936ac34a7$export$eece5f492e429f08 = '#505F79';
var $dfaa711936ac34a7$export$c39c0fe0f26207ae = '#42526E';
var $dfaa711936ac34a7$export$7090862dc3038a9f = '#344563';
var $dfaa711936ac34a7$export$ad0bacf983b7ddaa = '#253858';
var $dfaa711936ac34a7$export$7d61b15e0da132af = '#172B4D';
var $dfaa711936ac34a7$export$fbda843f0a27fe96 = '#091E42';
var $dfaa711936ac34a7$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $dfaa711936ac34a7$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $dfaa711936ac34a7$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $dfaa711936ac34a7$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $dfaa711936ac34a7$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $dfaa711936ac34a7$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $dfaa711936ac34a7$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $dfaa711936ac34a7$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $dfaa711936ac34a7$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $dfaa711936ac34a7$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $dfaa711936ac34a7$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $dfaa711936ac34a7$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $dfaa711936ac34a7$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $dfaa711936ac34a7$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $dfaa711936ac34a7$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $dfaa711936ac34a7$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $dfaa711936ac34a7$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $dfaa711936ac34a7$export$2f6319cf7d736c2a = '#E6EDFA';
var $dfaa711936ac34a7$export$95126bc8884d6634 = '#DCE5F5';
var $dfaa711936ac34a7$export$8338d8c35d44ff1 = '#CED9EB';
var $dfaa711936ac34a7$export$5368d76ae4fbbda7 = '#B8C7E0';
var $dfaa711936ac34a7$export$9f0a771d16ec8d36 = '#ABBBD6';
var $dfaa711936ac34a7$export$abcf8c38338b4aa5 = '#9FB0CC';
var $dfaa711936ac34a7$export$97e81faa16a182c7 = '#8C9CB8';
var $dfaa711936ac34a7$export$bfe21c59123ecf33 = '#7988A3';
var $dfaa711936ac34a7$export$ee82aa2ea6a1558 = '#67758F';
var $dfaa711936ac34a7$export$682927c6ed76be02 = '#56637A';
var $dfaa711936ac34a7$export$91fd9994c5be9757 = '#455166';
var $dfaa711936ac34a7$export$d281fbfe3cff2df6 = '#3B475C';
var $dfaa711936ac34a7$export$3902c91d8b98a753 = '#313D52';
var $dfaa711936ac34a7$export$8e8133c1ba5845b5 = '#283447';
var $dfaa711936ac34a7$export$33ff357f6620b39 = '#202B3D';
var $dfaa711936ac34a7$export$633847cf062b69e0 = '#1B2638';
var $dfaa711936ac34a7$export$9776a6e503bdbf76 = '#121A29';
var $dfaa711936ac34a7$export$6c813d5160dff5db = '#0E1624';
var $dfaa711936ac34a7$export$3d4f271a500072a = '#0D1424';
var $dfaa711936ac34a7$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $dfaa711936ac34a7$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $dfaa711936ac34a7$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $dfaa711936ac34a7$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $dfaa711936ac34a7$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $dfaa711936ac34a7$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $dfaa711936ac34a7$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $dfaa711936ac34a7$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $dfaa711936ac34a7$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $dfaa711936ac34a7$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $dfaa711936ac34a7$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $dfaa711936ac34a7$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $dfaa711936ac34a7$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $dfaa711936ac34a7$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $dfaa711936ac34a7$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $dfaa711936ac34a7$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $dfaa711936ac34a7$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $dfaa711936ac34a7$export$d2adc5dedf09fced = '#292A2E';
var $dfaa711936ac34a7$export$f51762073d2bb381 = '#94C748';
var $dfaa711936ac34a7$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("blvp4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $842a03ee90622efb$export$2e2bcd8739ae039; });
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f0JWV = parcelRequire("f0JWV");
var $842a03ee90622efb$var$labelTextStyles = null;
function $842a03ee90622efb$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $f0JWV.default)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
}

});

parcelRegister("gNxu7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c3ab3258864008f0$export$2e2bcd8739ae039; });
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $f0JWV = parcelRequire("f0JWV");
var $iOWnd = parcelRequire("iOWnd");

var $jczco = parcelRequire("jczco");
var $c3ab3258864008f0$var$requiredIndicatorStyles = null;
function $c3ab3258864008f0$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "aria-hidden": true,
        className: (0, $f0JWV.default)([
            "_syaz1ml5 _bozgv77o"
        ]),
        style: {
            "--_1xw92dq": (0, $iOWnd.default)("var(--ds-text-danger, ".concat((0, $jczco.R500), ")"))
        }
    }, "*");
}

});


parcelRegister("kY7Pn", function(module, exports) {
$parcel$export(module.exports, "FormContext", function () { return $f43f7ba524719864$export$c24727297075ec6a; });
$parcel$export(module.exports, "IsDisabledContext", function () { return $f43f7ba524719864$export$c17cf6b332a82dbc; });
$parcel$export(module.exports, "default", function () { return $f43f7ba524719864$export$2e2bcd8739ae039; });

var $efs8s = parcelRequire("efs8s");

var $9Sn3s = parcelRequire("9Sn3s");

var $2gb89 = parcelRequire("2gb89");

var $1oC0p = parcelRequire("1oC0p");

var $kQfSQ = parcelRequire("kQfSQ");

var $5WvoT = parcelRequire("5WvoT");

var $8WfyD = parcelRequire("8WfyD");

var $lzJOX = parcelRequire("lzJOX");

var $a9WMg = parcelRequire("a9WMg");

var $39c3M = parcelRequire("39c3M");

var $3pIGm = parcelRequire("3pIGm");
function $f43f7ba524719864$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f43f7ba524719864$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f43f7ba524719864$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f43f7ba524719864$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f43f7ba524719864$export$c24727297075ec6a = /*#__PURE__*/ (0, $1oC0p.createContext)({
    registerField: function registerField() {
        return function() {};
    },
    getCurrentValue: function getCurrentValue() {
        return undefined;
    },
    subscribe: function subscribe() {
        return function() {};
    }
});
var $f43f7ba524719864$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $1oC0p.createContext)(false);
var $f43f7ba524719864$var$FormBase = function FormBase(props, ref) {
    var autocomplete = props.autocomplete, userProvidedFormProps = props.formProps, id = props.id, label = props.label, labelId = props.labelId, name = props.name, noValidate = props.noValidate, onSubmit = props.onSubmit, testId = props.testId, xcss = props.xcss;
    var formRef = (0, $1oC0p.useRef)(null);
    var onSubmitRef = (0, $1oC0p.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    var _useState = (0, $1oC0p.useState)(function() {
        // Types here would break the existing API
        var finalForm = (0, $kQfSQ.createForm)({
            onSubmit: function onSubmit() {
                return onSubmitRef.current.apply(onSubmitRef, arguments);
            },
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: function setDefaultValue(_ref, state) {
                    var _ref2 = (0, $2gb89.default)(_ref, 2), name = _ref2[0], defaultValue = _ref2[1];
                    if (state.formState.initialValues) {
                        var initialValues = state.formState.initialValues;
                        var values = state.formState.values;
                        var _value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($8WfyD)))(initialValues, name, _value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($8WfyD)))(values, name, _value);
                    }
                }
            }
        });
        (0, $5WvoT.default)(function() {
            return formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [];
        }, (0, $39c3M.fg)('platform-form-field-error-focus') ? (0, $3pIGm.getFirstErrorField) : undefined)(finalForm);
        return finalForm;
    }), _useState2 = (0, $2gb89.default)(_useState, 1), form = _useState2[0];
    var _useState3 = (0, $1oC0p.useState)({
        dirty: false,
        submitting: false
    }), _useState4 = (0, $2gb89.default)(_useState3, 2), state = _useState4[0], setState = _useState4[1];
    (0, $1oC0p.useEffect)(function() {
        var unsubscribe = form.subscribe(function(_ref3) {
            var dirty = _ref3.dirty, submitting = _ref3.submitting;
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    var registerField = (0, $1oC0p.useCallback)(function(name, defaultValue, subscriber, subscription, config) {
        form.pauseValidation();
        var unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    var handleSubmit = function handleSubmit(e) {
        if (e) e.preventDefault();
        form.submit();
    };
    var handleReset = function handleReset(initialValues) {
        form.reset(initialValues);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            var submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    var _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, children = props.children;
    var dirty = state.dirty, submitting = state.submitting;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ var getCurrentValue = (0, $1oC0p.useCallback)(function(name) {
        var formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    var FormContextValue = (0, $1oC0p.useMemo)(function() {
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    var conditionalFormProps = {
        autocomplete: autocomplete,
        className: xcss,
        id: id,
        'aria-label': label,
        'aria-labelledby': labelId,
        name: name,
        noValidate: noValidate,
        'data-testid': testId
    };
    // Abstracting so we can use the same for both rendering patterns
    var formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, $a9WMg.default)([
            ref,
            formRef
        ]) : formRef
    };
    // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach(function(attr) {
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    var childrenContent = function() {
        if (typeof children === 'function') {
            var result = children.length > 0 ? children($f43f7ba524719864$var$_objectSpread({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: function getState() {
                    return form.getState();
                },
                getValues: function getValues() {
                    return form.getState().values;
                },
                setFieldValue: form.change
            }, (0, $39c3M.fg)('platform-form-reset-field-state') && {
                resetFieldState: form.resetFieldState
            })) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("form", (0, $efs8s.default)({}, formProps, userProvidedFormProps), children);
    }();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($f43f7ba524719864$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($f43f7ba524719864$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, childrenContent));
};
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ var $f43f7ba524719864$var$Form = (0, $lzJOX.default)($f43f7ba524719864$var$FormBase);
var $f43f7ba524719864$export$2e2bcd8739ae039 = $f43f7ba524719864$var$Form;

});
parcelRegister("lzJOX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fb5068eb6d343079$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $fb5068eb6d343079$export$2e2bcd8739ae039 = (0, $1oC0p.forwardRef);

});

parcelRegister("a9WMg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7658569d1d565d10$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $7658569d1d565d10$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("3pIGm", function(module, exports) {
$parcel$export(module.exports, "getFirstErrorField", function () { return $27c65ddc0cc332cf$export$fc06342dc8588d3b; });

var $kQfSQ = parcelRequire("kQfSQ");
var $27c65ddc0cc332cf$export$fc06342dc8588d3b = function getFirstErrorField(inputs, errors) {
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    var htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $kQfSQ.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $kQfSQ.getIn)(errors, input.name);
    });
};

});


parcelRegister("i7Tb1", function(module, exports) {
$parcel$export(module.exports, "HelperMessage", function () { return $d323ae6408db5c20$export$8fbe3c7d0ed2c683; });
$parcel$export(module.exports, "ErrorMessage", function () { return $d323ae6408db5c20$export$915e9e7bd4f0f96d; });
$parcel$export(module.exports, "ValidMessage", function () { return $d323ae6408db5c20$export$5505afb209a532c8; });
$parcel$export(module.exports, "MessageWrapper", function () { return $d323ae6408db5c20$export$ec445f12f63100a5; });
/* messages.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $2gb89 = parcelRequire("2gb89");

var $1oC0p = parcelRequire("1oC0p");

var $dotQ5 = parcelRequire("dotQ5");

var $kOMgb = parcelRequire("kOMgb");

var $eZVCa = parcelRequire("eZVCa");

var $39c3M = parcelRequire("39c3M");

var $dCSzs = parcelRequire("dCSzs");
/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $d323ae6408db5c20$var$messageStyles = null;
var $d323ae6408db5c20$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
var $d323ae6408db5c20$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
var $d323ae6408db5c20$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $dotQ5.default)([
            $d323ae6408db5c20$var$iconWrapperStyles.root
        ])
    }, children);
};
var $d323ae6408db5c20$var$messageIcons = {
    error: /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kOMgb))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eZVCa))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success",
        size: "small"
    })
};
var $d323ae6408db5c20$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var icon = $d323ae6408db5c20$var$messageIcons[appearance];
    var _useContext = (0, $1oC0p.useContext)($d323ae6408db5c20$var$MessageWrapperContext), isWrapper = _useContext.isWrapper;
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2gb89.default)(_useState, 2), shouldRenderAfterDelay = _useState2[0], setShouldRenderAfterDelay = _useState2[1];
    // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
    var isDelayRenderEnabled = (0, $39c3M.fg)('platform_dst_form_screenreader_message_fix') && !isWrapper;
    (0, $1oC0p.useEffect)(function() {
        if (isDelayRenderEnabled) {
            // Only delay rendering if there is no wrapper and feature flag is enabled
            var timer = setTimeout(function() {
                setShouldRenderAfterDelay(true);
            }, 10);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        isDelayRenderEnabled
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === 'string' ? children : /*#__PURE__*/ $1oC0p.createElement("span", null, children);
    var childrenToRender = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, icon && /*#__PURE__*/ $1oC0p.createElement($d323ae6408db5c20$var$IconWrapper, null, icon), content);
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        "data-testid": testId,
        id: fieldId,
        "aria-live": !isWrapper ? 'polite' : undefined,
        className: (0, $dotQ5.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $d323ae6408db5c20$var$messageAppearanceStyles[appearance]
        ])
    }, isDelayRenderEnabled ? shouldRenderAfterDelay && childrenToRender : childrenToRender);
};
var $d323ae6408db5c20$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return /*#__PURE__*/ $1oC0p.createElement((0, $dCSzs.FieldId).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $1oC0p.createElement($d323ae6408db5c20$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $d323ae6408db5c20$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return /*#__PURE__*/ $1oC0p.createElement((0, $dCSzs.FieldId).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $1oC0p.createElement($d323ae6408db5c20$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $d323ae6408db5c20$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return /*#__PURE__*/ $1oC0p.createElement((0, $dCSzs.FieldId).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $1oC0p.createElement($d323ae6408db5c20$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ var $d323ae6408db5c20$var$MessageWrapperContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    isWrapper: false
});
var $d323ae6408db5c20$export$ec445f12f63100a5 = function MessageWrapper(_ref6) {
    var children = _ref6.children;
    var contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ $1oC0p.createElement($d323ae6408db5c20$var$MessageWrapperContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("dotQ5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9c04a9a8ac7a3df1$export$2e2bcd8739ae039; });
const $9c04a9a8ac7a3df1$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $9c04a9a8ac7a3df1$var$ATOMIC_GROUP_LENGTH = 5;
function $9c04a9a8ac7a3df1$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $9c04a9a8ac7a3df1$var$UNDERSCORE_UNICODE ? $9c04a9a8ac7a3df1$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("kOMgb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f27de99900bdd944$var$_react = $f27de99900bdd944$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f27de99900bdd944$var$_statusError = $f27de99900bdd944$var$_interopRequireDefault((parcelRequire("99gqA")));

var $f27de99900bdd944$var$_error = $f27de99900bdd944$var$_interopRequireDefault((parcelRequire("lOxKv")));
function $f27de99900bdd944$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f27de99900bdd944$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $f27de99900bdd944$var$_react.default.createElement($f27de99900bdd944$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $f27de99900bdd944$var$_error.default
    }, props));
$f27de99900bdd944$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $f27de99900bdd944$var$_default = module.exports.default = $f27de99900bdd944$var$StatusErrorIcon;

});
parcelRegister("99gqA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a91b2892382b332$var$_react = $6a91b2892382b332$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6a91b2892382b332$var$_baseNew = $6a91b2892382b332$var$_interopRequireDefault((parcelRequire("hfnTt")));
function $6a91b2892382b332$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a91b2892382b332$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $6a91b2892382b332$var$_react.default.createElement($6a91b2892382b332$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$6a91b2892382b332$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $6a91b2892382b332$var$_default = module.exports.default = $6a91b2892382b332$var$StatusErrorIcon;

});
parcelRegister("hfnTt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return (parcelRequire("2et7k")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("2et7k")).Icon; });

var $2et7k = parcelRequire("2et7k");

});
parcelRegister("2et7k", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $1a0379a5361c03f4$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $1a0379a5361c03f4$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $dotQ5 = parcelRequire("dotQ5");

var $39c3M = parcelRequire("39c3M");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $1a0379a5361c03f4$var$svgStyles = null;
var $1a0379a5361c03f4$var$iconStyles = null;
var $1a0379a5361c03f4$var$utilityIconStyles = null;
var $1a0379a5361c03f4$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $1a0379a5361c03f4$var$baseHcmStyles = null;
var $1a0379a5361c03f4$var$scaleSize = null;
var $1a0379a5361c03f4$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $1a0379a5361c03f4$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $1a0379a5361c03f4$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $1a0379a5361c03f4$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $1a0379a5361c03f4$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $1a0379a5361c03f4$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $39c3M.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $1oC0p.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $1a0379a5361c03f4$var$baseSizeMap[type];
    var viewBoxPadding = $1a0379a5361c03f4$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $dotQ5.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $dotQ5.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $1a0379a5361c03f4$var$utilSizes[spacing] : size === 'small' ? $1a0379a5361c03f4$var$coreSizeSmall[spacing] : $1a0379a5361c03f4$var$coreSizeMedium[spacing]
        ])
    }));
});
var $1a0379a5361c03f4$export$2e2bcd8739ae039 = $1a0379a5361c03f4$export$f04a61298a47a40f;

});



parcelRegister("lOxKv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe18725c0e4d76bc$var$_react = $fe18725c0e4d76bc$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1hrck = parcelRequire("1hrck");
function $fe18725c0e4d76bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fe18725c0e4d76bc$var$ErrorIcon = (props)=>/*#__PURE__*/ $fe18725c0e4d76bc$var$_react.default.createElement($1hrck.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$fe18725c0e4d76bc$var$ErrorIcon.displayName = 'ErrorIcon';
var $fe18725c0e4d76bc$var$_default = module.exports.default = $fe18725c0e4d76bc$var$ErrorIcon;

});
parcelRegister("1hrck", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $0eec79e5e6550c1b$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $efs8s = parcelRequire("efs8s");

var $9Sn3s = parcelRequire("9Sn3s");

var $1oC0p = parcelRequire("1oC0p");

var $dotQ5 = parcelRequire("dotQ5");
function $0eec79e5e6550c1b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0eec79e5e6550c1b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0eec79e5e6550c1b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0eec79e5e6550c1b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $0eec79e5e6550c1b$var$iconStyles = null;
var $0eec79e5e6550c1b$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $0eec79e5e6550c1b$var$baseHcmStyles = null;
var $0eec79e5e6550c1b$var$primaryEqualsSecondaryHcmStyles = null;
var $0eec79e5e6550c1b$var$secondaryTransparentHcmStyles = null;
var $0eec79e5e6550c1b$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $1oC0p.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $1oC0p.createElement("span", (0, $efs8s.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $0eec79e5e6550c1b$var$_objectSpread($0eec79e5e6550c1b$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $dotQ5.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $0eec79e5e6550c1b$var$sizeStyles[size]
        ])
    }));
});
var $0eec79e5e6550c1b$export$2e2bcd8739ae039 = $0eec79e5e6550c1b$export$f04a61298a47a40f;

});



parcelRegister("eZVCa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::849e146248de3896aa5effb6cb325c8d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aeb37444329dcca2$var$_react = $aeb37444329dcca2$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $aeb37444329dcca2$var$_statusSuccess = $aeb37444329dcca2$var$_interopRequireDefault((parcelRequire("3yNnV")));

var $aeb37444329dcca2$var$_success = $aeb37444329dcca2$var$_interopRequireDefault((parcelRequire("1Q20M")));
function $aeb37444329dcca2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aeb37444329dcca2$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $aeb37444329dcca2$var$_react.default.createElement($aeb37444329dcca2$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $aeb37444329dcca2$var$_success.default
    }, props));
$aeb37444329dcca2$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $aeb37444329dcca2$var$_default = module.exports.default = $aeb37444329dcca2$var$StatusSuccessIcon;

});
parcelRegister("3yNnV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $297adae29990ded8$var$_react = $297adae29990ded8$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $297adae29990ded8$var$_baseNew = $297adae29990ded8$var$_interopRequireDefault((parcelRequire("hfnTt")));
function $297adae29990ded8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $297adae29990ded8$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $297adae29990ded8$var$_react.default.createElement($297adae29990ded8$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$297adae29990ded8$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $297adae29990ded8$var$_default = module.exports.default = $297adae29990ded8$var$StatusSuccessIcon;

});

parcelRegister("1Q20M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $156c354148a7536e$var$_react = $156c354148a7536e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1hrck = parcelRequire("1hrck");
function $156c354148a7536e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $156c354148a7536e$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $156c354148a7536e$var$_react.default.createElement($1hrck.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props));
$156c354148a7536e$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $156c354148a7536e$var$_default = module.exports.default = $156c354148a7536e$var$EditorSuccessIcon;

});


parcelRegister("dCSzs", function(module, exports) {
$parcel$export(module.exports, "FieldId", function () { return $9eb9279c290decfe$export$3c4232819458a302; });

var $1oC0p = parcelRequire("1oC0p");
var $9eb9279c290decfe$export$3c4232819458a302 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);

});


parcelRegister("fF4td", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b66e2711672a6b95$export$2e2bcd8739ae039; });
/* field.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $9Sn3s = parcelRequire("9Sn3s");

var $2gb89 = parcelRequire("2gb89");

var $6DX60 = parcelRequire("6DX60");

var $dotQ5 = parcelRequire("dotQ5");

var $1oC0p = parcelRequire("1oC0p");

var $lHqL5 = parcelRequire("lHqL5");

var $dCSzs = parcelRequire("dCSzs");

var $kY7Pn = parcelRequire("kY7Pn");

var $a7aOt = parcelRequire("a7aOt");

var $i7Tb1 = parcelRequire("i7Tb1");

var $kmI4g = parcelRequire("kmI4g");
function $b66e2711672a6b95$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b66e2711672a6b95$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b66e2711672a6b95$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b66e2711672a6b95$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b66e2711672a6b95$var$fieldWrapperStyles = null;
function $b66e2711672a6b95$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $b66e2711672a6b95$var$isFunction(x) {
    return typeof x === 'function';
}
// Must be exported to satisfy error TS4023 from Jira builds
// src/packages/servicedesk/virtual-agent/common/src/ui/base-text-field/index.tsx(10,14):
// error TS4023: Exported variable `BaseTextField` has or is using name
// `FieldComponentProps` from external module
// `/opt/atlassian/pipelines/agent/build/jira/tsDist/@atlaskit__form/app/src/field`
// but cannot be named.
function $b66e2711672a6b95$var$usePreviousRef(current) {
    var ref = (0, $1oC0p.useRef)(current);
    // will be updated on the next render
    (0, $1oC0p.useEffect)(function() {
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $b66e2711672a6b95$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if ((0, $6DX60.default)(previousValue) === 'object' && (0, $6DX60.default)(currentValue) === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $b66e2711672a6b95$export$2e2bcd8739ae039(props) {
    var _getCurrentValue;
    var _props$children = props.children, children = _props$children === void 0 ? function() {
        return null;
    } : _props$children, component = props.component;
    var _useContext = (0, $1oC0p.useContext)((0, $kY7Pn.FormContext)), registerField = _useContext.registerField, getCurrentValue = _useContext.getCurrentValue;
    var isDisabled = (0, $1oC0p.useContext)((0, $kY7Pn.IsDisabledContext)) || props.isDisabled || false;
    var defaultValue = $b66e2711672a6b95$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    var latestPropsRef = $b66e2711672a6b95$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ var isDefaultValueChanged = !$b66e2711672a6b95$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    var _useState = (0, $1oC0p.useState)({
        fieldProps: {
            onChange: function onChange() {},
            onBlur: function onBlur() {},
            onFocus: function onFocus() {},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
         * effectively made it an optional prop to external consumers of Field. However the
         * prop types defined defaultValue as required, so inside the component it was not
         * valid for defaultValue to be undefined. We need to suppress the error
         * after changing defaultValue to explicitly be an optional prop.
         * If default value has changed we are using new default value.
         * Otherwise we need to check if we already have value for this field
         * (because we are using changing key prop to re-run field level validation, and that
         * cause the component re-mounting) to not override the actual value with the default value.
         */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : (_getCurrentValue = getCurrentValue(props.name)) !== null && _getCurrentValue !== void 0 ? _getCurrentValue : defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    }), _useState2 = (0, $2gb89.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var latestStateRef = $b66e2711672a6b95$var$usePreviousRef(state);
    (0, $1oC0p.useEffect)(function() {
        function fieldStateToMeta() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        var unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $b66e2711672a6b95$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, function(fieldState) {
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ var modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ var modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ var modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            var modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ var modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($b66e2711672a6b95$var$isEvent(eventOrValue)) {
                    var currentTarget = eventOrValue.currentTarget;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: function onChange(e) {
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: function getValidator() {
                return function validate(value, formState, fieldState) {
                    var supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                };
            }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    var uid = (0, $lHqL5.useId)();
    var fieldId = (0, $1oC0p.useMemo)(function() {
        return props.id ? props.id : "".concat(props.name, "-").concat(uid);
    }, [
        props.id,
        props.name,
        uid
    ]);
    var getDescribedBy = function getDescribedBy() {
        var value = '';
        if (state.error) value += "".concat(fieldId, "-error ");
        if (state.valid) value += "".concat(fieldId, "-valid ");
        return "".concat(value).concat(fieldId, "-helper");
    };
    var extendedFieldProps = $b66e2711672a6b95$var$_objectSpread($b66e2711672a6b95$var$_objectSpread({}, state.fieldProps), {}, {
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': "".concat(fieldId, "-label"),
        id: fieldId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        "data-testid": props.testId,
        className: (0, $dotQ5.default)([
            "_1pfhu2gc"
        ])
    }, props.label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $a7aOt.Label), {
        htmlFor: fieldId,
        id: "".concat(fieldId, "-label"),
        testId: props.testId && "".concat(props.testId, "--label")
    }, props.label, props.isRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kmI4g.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dCSzs.FieldId).Provider, {
        value: fieldId
    }, component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, component({
        fieldProps: extendedFieldProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $i7Tb1.MessageWrapper), null, props.helperMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $i7Tb1.HelperMessage), null, props.helperMessage), state.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $i7Tb1.ErrorMessage), null, props.errorMessage || state.error), state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $i7Tb1.ValidMessage), null, props.validMessage))) : children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("lHqL5", function(module, exports) {
$parcel$export(module.exports, "useId", function () { return $fcc25ec70e3cbcfa$export$f680877a34711e37; });

var $6DX60 = parcelRequire("6DX60");

var $1oC0p = parcelRequire("1oC0p");

var $6JmtO = parcelRequire("6JmtO");

var $39c3M = parcelRequire("39c3M");
var $fcc25ec70e3cbcfa$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $fcc25ec70e3cbcfa$var$react18UseId = ($fcc25ec70e3cbcfa$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId) !== null && $fcc25ec70e3cbcfa$var$_React$useId !== void 0 ? $fcc25ec70e3cbcfa$var$_React$useId : undefined;
function $fcc25ec70e3cbcfa$export$f680877a34711e37() {
    if ($fcc25ec70e3cbcfa$var$react18UseId && (0, $39c3M.fg)('platform-dst-react-18-use-id')) {
        if ((0, $39c3M.fg)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $fcc25ec70e3cbcfa$var$react18UseId().replace(/[:«»]/g, '_');
        return $fcc25ec70e3cbcfa$var$react18UseId();
    }
    return "uid".concat((0, $6JmtO.useUID)());
}
var $fcc25ec70e3cbcfa$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($fcc25ec70e3cbcfa$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $6DX60.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $6DX60.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $fcc25ec70e3cbcfa$export$6ee17796e3d70de2() {
    if ($fcc25ec70e3cbcfa$var$react18UseId && (0, $39c3M.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        var uid = $fcc25ec70e3cbcfa$export$f680877a34711e37();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $6JmtO.useUIDSeed)();
}

});

parcelRegister("a7aOt", function(module, exports) {
$parcel$export(module.exports, "Label", function () { return $75d2f212d03ca023$export$b04be29aa201d4f5; });
$parcel$export(module.exports, "Legend", function () { return $75d2f212d03ca023$export$ed247974535929c7; });
/* label.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $dotQ5 = parcelRequire("dotQ5");
var $75d2f212d03ca023$var$fieldsetLabelStyles = null;
var $75d2f212d03ca023$export$b04be29aa201d4f5 = function Label(_ref) {
    var children = _ref.children, htmlFor = _ref.htmlFor, id = _ref.id, testId = _ref.testId;
    return /*#__PURE__*/ $1oC0p.createElement("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $dotQ5.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};
var $75d2f212d03ca023$export$ed247974535929c7 = function Legend(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ $1oC0p.createElement("legend", {
        className: (0, $dotQ5.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};

});

parcelRegister("kmI4g", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ed380badb7789f14$export$2e2bcd8739ae039; });
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $dotQ5 = parcelRequire("dotQ5");
var $ed380badb7789f14$var$requiredIndicatorStyles = null;
function $ed380badb7789f14$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $dotQ5.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ])
    }, "*");
}

});


parcelRegister("3LBzK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2be2e89b4395fbf7$export$2e2bcd8739ae039; });
/* fieldset.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $dotQ5 = parcelRequire("dotQ5");

var $a7aOt = parcelRequire("a7aOt");
var $2be2e89b4395fbf7$var$fieldSetStyles = null;
/**
 * __Fieldset__
 *
 * A fieldset groups a number of fields together. For example, when multiple CheckboxFields share the same name,
 * a fieldset can be used to group them together. This makes the form more accessible.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 */ var $2be2e89b4395fbf7$var$Fieldset = function Fieldset(_ref) {
    var children = _ref.children, legend = _ref.legend;
    return /*#__PURE__*/ $1oC0p.createElement("fieldset", {
        className: (0, $dotQ5.default)([
            "_1pfhu2gc"
        ])
    }, legend && /*#__PURE__*/ $1oC0p.createElement((0, $a7aOt.Legend), null, legend), children);
};
var $2be2e89b4395fbf7$export$2e2bcd8739ae039 = $2be2e89b4395fbf7$var$Fieldset;

});

parcelRegister("d6n4m", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $989dbafc3e944083$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $efs8s = parcelRequire("efs8s");

var $8ySUD = parcelRequire("8ySUD");

var $1oC0p = parcelRequire("1oC0p");

var $bhUiq = parcelRequire("bhUiq");

var $6AuBq = parcelRequire("6AuBq");

var $39c3M = parcelRequire("39c3M");

var $iqCm6 = parcelRequire("iqCm6");
var $aeQY4 = parcelRequire("aeQY4");
var $989dbafc3e944083$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $989dbafc3e944083$var$styles = {
    visitedLink: "_ect41gqc _1053w7te _1ienw7te _n0fxw7te _1vhvg3x0",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz14q2 _ect41gqc _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj14q2 _9oik1r31 _1bnxglyw _jf4cnqa1 _30l314q2 _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h16c2",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41gqc _syaz1gjq _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1gjq _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31gjq _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8h1fxt",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n4jp4b _kqswh2mm _152ttb3r"
};
var $989dbafc3e944083$var$iconStyles = null;
var $989dbafc3e944083$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, preventedClassName = _ref.className, preventedStyle = _ref.style, htmlAttributes = (0, $8ySUD.default)(_ref, $989dbafc3e944083$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement((0, $iqCm6.default), (0, $efs8s.default)({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $6AuBq.cx)(appearance === 'default' && $989dbafc3e944083$var$styles.defaultAppearance, appearance === 'subtle' && $989dbafc3e944083$var$styles.subtleAppearance, appearance === 'inverse' && $989dbafc3e944083$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $989dbafc3e944083$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $1oC0p.createElement((0, $aeQY4.default), {
        as: "span",
        xcss: $989dbafc3e944083$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", (0, $39c3M.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ $1oC0p.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $bhUiq.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    })) : /*#__PURE__*/ $1oC0p.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        className: (0, $bhUiq.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("path", {
        d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
    }), /*#__PURE__*/ $1oC0p.createElement("path", {
        d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $989dbafc3e944083$var$Link = /*#__PURE__*/ (0, $1oC0p.forwardRef)($989dbafc3e944083$var$LinkWithoutRef);
var $989dbafc3e944083$export$2e2bcd8739ae039 = $989dbafc3e944083$var$Link;

});
parcelRegister("bhUiq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $837cf37bf7ca1015$export$2e2bcd8739ae039; });
const $837cf37bf7ca1015$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $837cf37bf7ca1015$var$ATOMIC_GROUP_LENGTH = 5;
function $837cf37bf7ca1015$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $837cf37bf7ca1015$var$UNDERSCORE_UNICODE ? $837cf37bf7ca1015$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("6AuBq", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $4cbdd7e94fd1ddc7$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("1oC0p");


var $f9fVU = parcelRequire("f9fVU");
var $4cbdd7e94fd1ddc7$var$_createStrictAPI = (0, $f9fVU.createStrictAPI)(), $4cbdd7e94fd1ddc7$var$XCSSProp = $4cbdd7e94fd1ddc7$var$_createStrictAPI.XCSSProp, $4cbdd7e94fd1ddc7$export$dbf350e5966cf602 = $4cbdd7e94fd1ddc7$var$_createStrictAPI.css, $4cbdd7e94fd1ddc7$export$eb1ecd84a24ee424 = $4cbdd7e94fd1ddc7$var$_createStrictAPI.cssMap, $4cbdd7e94fd1ddc7$export$a274e22fb40f762e = $4cbdd7e94fd1ddc7$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("f9fVU", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", function () { return $b0740e43bc68bc35$export$39716b4af53f4ad; });

var $3AyoZ = parcelRequire("3AyoZ");

var $ixaBS = parcelRequire("ixaBS");
function $b0740e43bc68bc35$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $3AyoZ.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $3AyoZ.createStrictSetupError)();
        },
        cx: $ixaBS.cx,
        XCSSProp () {
            throw (0, $3AyoZ.createStrictSetupError)();
        }
    };
}

});
parcelRegister("3AyoZ", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", function () { return $29cf6b665149b201$export$c4df1cb0c2b4d77c; });
const $29cf6b665149b201$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $29cf6b665149b201$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("ixaBS", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $d7e389f70921775c$export$a274e22fb40f762e; });

var $cEwxv = parcelRequire("cEwxv");
const $d7e389f70921775c$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $cEwxv.default)(actualStyles);
};

});
parcelRegister("cEwxv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9362761693ef3df7$export$2e2bcd8739ae039; });
const $9362761693ef3df7$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $9362761693ef3df7$var$ATOMIC_GROUP_LENGTH = 5;
function $9362761693ef3df7$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $9362761693ef3df7$var$UNDERSCORE_UNICODE ? $9362761693ef3df7$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});




parcelRegister("iqCm6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d6a8684fe4d0753e$export$2e2bcd8739ae039; });
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $efs8s = parcelRequire("efs8s");

var $6DX60 = parcelRequire("6DX60");

var $8ySUD = parcelRequire("8ySUD");

var $1oC0p = parcelRequire("1oC0p");


var $5b8Wf = parcelRequire("5b8Wf");

var $lmxXn = parcelRequire("lmxXn");

var $52iP8 = parcelRequire("52iP8");

var $doRDb = parcelRequire("doRDb");

var $d80kv = parcelRequire("d80kv");

var $cUrZi = parcelRequire("cUrZi");

var $lHuwh = parcelRequire("lHuwh");

var $8vIkL = parcelRequire("8vIkL");

var $45qak = parcelRequire("45qak");
var $d6a8684fe4d0753e$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $d6a8684fe4d0753e$var$_excluded2 = [
    "className"
];
var $d6a8684fe4d0753e$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi"
};
var $d6a8684fe4d0753e$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $d6a8684fe4d0753e$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $d6a8684fe4d0753e$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $d80kv.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, $8ySUD.default)(_ref, $d6a8684fe4d0753e$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $lHuwh.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $cUrZi.useId)();
    var onClick = (0, $52iP8.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "14.8.0",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $8ySUD.default)(htmlAttributes, $d6a8684fe4d0753e$var$_excluded2);
    var RouterLink = (0, $doRDb.default)();
    var isExternal = typeof href === 'string' && $d6a8684fe4d0753e$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $d6a8684fe4d0753e$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, $6DX60.default)(href) === 'object';
    (0, $lmxXn.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $1oC0p.createElement((0, $45qak.default), (0, $efs8s.default)({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $5b8Wf.cx)($d6a8684fe4d0753e$var$styles.root, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $1oC0p.createElement((0, $8vIkL.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $d6a8684fe4d0753e$var$Anchor = /*#__PURE__*/ (0, $1oC0p.forwardRef)($d6a8684fe4d0753e$var$AnchorNoRef);
var $d6a8684fe4d0753e$export$2e2bcd8739ae039 = $d6a8684fe4d0753e$var$Anchor;

});
parcelRegister("5b8Wf", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $3c54e9d2d07916f5$export$a274e22fb40f762e; });

var $bhUiq = parcelRequire("bhUiq");
const $3c54e9d2d07916f5$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $bhUiq.default)(actualStyles);
};

});

parcelRegister("52iP8", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $3aabbda479a5142d$export$a4687b0234b40e28; });

var $9Sn3s = parcelRequire("9Sn3s");

var $1oC0p = parcelRequire("1oC0p");

var $gtUpn = parcelRequire("gtUpn");

var $61Jg9 = parcelRequire("61Jg9");
function $3aabbda479a5142d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3aabbda479a5142d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3aabbda479a5142d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3aabbda479a5142d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3aabbda479a5142d$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $gtUpn.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $61Jg9.useTrackedRef)(analyticsData);
    var fnRef = (0, $61Jg9.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $3aabbda479a5142d$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("gtUpn", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $0318b20148e73a9d$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $jNgnE = parcelRequire("jNgnE");

var $emTJr = parcelRequire("emTJr");
function $0318b20148e73a9d$export$5bf35293e545f20c() {
    var analyticsContext = (0, $emTJr.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $jNgnE.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("jNgnE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e68f4cb812cbbd94$export$2e2bcd8739ae039; });

var $342Py = parcelRequire("342Py");

var $3AhEU = parcelRequire("3AhEU");

var $gWIyR = parcelRequire("gWIyR");

var $ciMo5 = parcelRequire("ciMo5");

var $g9Nc1 = parcelRequire("g9Nc1");

var $9kUlu = parcelRequire("9kUlu");

var $c3W0a = parcelRequire("c3W0a");

var $9Sn3s = parcelRequire("9Sn3s");

var $8vZ6J = parcelRequire("8vZ6J");
function $e68f4cb812cbbd94$var$_callSuper(t, o, e) {
    return o = (0, $g9Nc1.default)(o), (0, $ciMo5.default)(t, $e68f4cb812cbbd94$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $g9Nc1.default)(t).constructor) : o.apply(t, e));
}
function $e68f4cb812cbbd94$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e68f4cb812cbbd94$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $e68f4cb812cbbd94$var$_superPropGet(t, o, e, r) {
    var p = (0, $9kUlu.default)((0, $g9Nc1.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $e68f4cb812cbbd94$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $e68f4cb812cbbd94$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $e68f4cb812cbbd94$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $3AhEU.default)(this, UIAnalyticsEvent);
        _this = $e68f4cb812cbbd94$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $9Sn3s.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $9Sn3s.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $342Py.default)(_this.context);
            var handlers = (0, $342Py.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $9Sn3s.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $c3W0a.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $gWIyR.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $e68f4cb812cbbd94$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $8vZ6J.default));

});
parcelRegister("8vZ6J", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $63309eab304ee9b5$export$2e2bcd8739ae039; });

var $6DX60 = parcelRequire("6DX60");

var $3AhEU = parcelRequire("3AhEU");

var $gWIyR = parcelRequire("gWIyR");

var $9Sn3s = parcelRequire("9Sn3s");
function $63309eab304ee9b5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $63309eab304ee9b5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $63309eab304ee9b5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $63309eab304ee9b5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $63309eab304ee9b5$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $63309eab304ee9b5$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $63309eab304ee9b5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $3AhEU.default)(this, AnalyticsEvent);
        (0, $9Sn3s.default)(this, "_isAnalyticsEvent", true);
        (0, $9Sn3s.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $63309eab304ee9b5$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $gWIyR.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $6DX60.default)(updater) === 'object') this.payload = $63309eab304ee9b5$var$_objectSpread($63309eab304ee9b5$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("emTJr", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $a75e59fc6632f31e$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $a75e59fc6632f31e$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("61Jg9", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $4635f1a7d5dea3fd$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $4635f1a7d5dea3fd$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("doRDb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9c171e4531257c9d$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $gk2nu = parcelRequire("gk2nu");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $9c171e4531257c9d$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $1oC0p.useContext)((0, $gk2nu.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $9c171e4531257c9d$export$2e2bcd8739ae039 = $9c171e4531257c9d$var$useRouterLink;

});
parcelRegister("gk2nu", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $be205bca9b24ae9c$export$2931e0ee690eee88; });

var $1oC0p = parcelRequire("1oC0p");
var $be205bca9b24ae9c$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $1oC0p.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $be205bca9b24ae9c$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($be205bca9b24ae9c$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $be205bca9b24ae9c$export$2e2bcd8739ae039 = $be205bca9b24ae9c$var$RouterLinkProvider;

});


parcelRegister("d80kv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $98ec4732a87051ea$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $98ec4732a87051ea$export$2e2bcd8739ae039() {}

});

parcelRegister("cUrZi", function(module, exports) {
$parcel$export(module.exports, "useId", function () { return $96606cc742472909$export$f680877a34711e37; });

var $6DX60 = parcelRequire("6DX60");

var $1oC0p = parcelRequire("1oC0p");

var $6JmtO = parcelRequire("6JmtO");

var $39c3M = parcelRequire("39c3M");
var $96606cc742472909$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $96606cc742472909$var$react18UseId = ($96606cc742472909$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId) !== null && $96606cc742472909$var$_React$useId !== void 0 ? $96606cc742472909$var$_React$useId : undefined;
function $96606cc742472909$export$f680877a34711e37() {
    if ($96606cc742472909$var$react18UseId && (0, $39c3M.fg)('platform-dst-react-18-use-id')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $96606cc742472909$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $6JmtO.useUID)());
}
var $96606cc742472909$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($96606cc742472909$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $6DX60.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $6DX60.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $96606cc742472909$export$6ee17796e3d70de2() {
    if ($96606cc742472909$var$react18UseId && (0, $39c3M.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $96606cc742472909$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $6JmtO.useUIDSeed)();
}

});

parcelRegister("lHuwh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fcc549b4ddf6e9d8$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $fcc549b4ddf6e9d8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("45qak", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2f9bed02152063a2$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $efs8s = parcelRequire("efs8s");

var $9Sn3s = parcelRequire("9Sn3s");

var $8ySUD = parcelRequire("8ySUD");

var $1oC0p = parcelRequire("1oC0p");

var $bhUiq = parcelRequire("bhUiq");
var $ajm6x = parcelRequire("ajm6x");
var $2f9bed02152063a2$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $2f9bed02152063a2$var$_excluded2 = [
    "className"
];
function $2f9bed02152063a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2f9bed02152063a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2f9bed02152063a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2f9bed02152063a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2f9bed02152063a2$var$focusRingStyles = null;
var $2f9bed02152063a2$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $2f9bed02152063a2$var$Focusable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $8ySUD.default)(_ref, $2f9bed02152063a2$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $8ySUD.default)(htmlAttributes, $2f9bed02152063a2$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $efs8s.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $bhUiq.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $2f9bed02152063a2$var$_objectSpread($2f9bed02152063a2$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $ajm6x.default)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $2f9bed02152063a2$export$2e2bcd8739ae039 = $2f9bed02152063a2$var$Focusable;

});
parcelRegister("ajm6x", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $781cd33697fb4478$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $781cd33697fb4478$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});



parcelRegister("aeQY4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $77444c7b9825ba4b$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $efs8s = parcelRequire("efs8s");

var $8ySUD = parcelRequire("8ySUD");

var $1oC0p = parcelRequire("1oC0p");

var $bhUiq = parcelRequire("bhUiq");

var $arFqY = parcelRequire("arFqY");
var $77444c7b9825ba4b$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $77444c7b9825ba4b$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $77444c7b9825ba4b$var$baseStyles = null;
var $77444c7b9825ba4b$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhk1fno",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1eds",
    'color.background.accent.lime.subtler.pressed': "_bfhk1hgz",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhkhgj8",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhk1b17",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhk1pbw",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkrw5d",
    'color.background.accent.red.subtler.pressed': "_bfhk69rw",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1tf4",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhkprmn",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtlest.hovered': "_bfhkg4tm",
    'color.background.accent.orange.subtlest.pressed': "_bfhk1ya0",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtler.hovered': "_bfhk1lml",
    'color.background.accent.orange.subtler.pressed': "_bfhkuxsx",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.subtle.hovered': "_bfhk1oew",
    'color.background.accent.orange.subtle.pressed': "_bfhk1phk",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.orange.bolder.hovered': "_bfhkhi52",
    'color.background.accent.orange.bolder.pressed': "_bfhkf767",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtlest.hovered': "_bfhk19g9",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk31d1",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtler.hovered': "_bfhklg04",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1d44",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.subtle.hovered': "_bfhk17e6",
    'color.background.accent.yellow.subtle.pressed': "_bfhko0y5",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk32kj",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkv5yf",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhkung8",
    'color.background.accent.green.subtler.pressed': "_bfhk1p19",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk8h4p",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1azz",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1j2h",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkg5py",
    'color.background.accent.teal.subtler.pressed': "_bfhkq7li",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk10ai",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhkse6l",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtlest.hovered': "_bfhkay3p",
    'color.background.accent.blue.subtlest.pressed': "_bfhk1xmr",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtler.hovered': "_bfhk16e6",
    'color.background.accent.blue.subtler.pressed': "_bfhk1uh7",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.subtle.hovered': "_bfhk1f4s",
    'color.background.accent.blue.subtle.pressed': "_bfhkqctv",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.blue.bolder.hovered': "_bfhk1cwi",
    'color.background.accent.blue.bolder.pressed': "_bfhkhcrq",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtlest.hovered': "_bfhkm0d5",
    'color.background.accent.purple.subtlest.pressed': "_bfhkgslw",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtler.hovered': "_bfhk1wyu",
    'color.background.accent.purple.subtler.pressed': "_bfhk5fkp",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.subtle.hovered': "_bfhk1wob",
    'color.background.accent.purple.subtle.pressed': "_bfhkwz05",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.purple.bolder.hovered': "_bfhkadgs",
    'color.background.accent.purple.bolder.pressed': "_bfhk1uro",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1een",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1r0p",
    'color.background.accent.magenta.subtler.pressed': "_bfhkxuzc",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk1ovh",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkwaw3",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtlest.hovered': "_bfhk12j4",
    'color.background.accent.gray.subtlest.pressed': "_bfhk1lb4",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtler.hovered': "_bfhk1f7l",
    'color.background.accent.gray.subtler.pressed': "_bfhkd8a2",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.subtle.hovered': "_bfhk1a2l",
    'color.background.accent.gray.subtle.pressed': "_bfhk1z0s",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.accent.gray.bolder.hovered': "_bfhke4nv",
    'color.background.accent.gray.bolder.pressed': "_bfhk82ra",
    'color.background.disabled': "_bfhksyzs",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhk1d5g",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.hovered': "_bfhk15ej",
    'color.background.neutral.pressed': "_bfhkip91",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk166n",
    'color.background.neutral.subtle.pressed': "_bfhk1dty",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.neutral.bold.hovered': "_bfhk1bsc",
    'color.background.neutral.bold.pressed': "_bfhk1b6k",
    'color.background.selected': "_bfhkfg4m",
    'color.background.selected.hovered': "_bfhki1yw",
    'color.background.selected.pressed': "_bfhk19ru",
    'color.background.selected.bold': "_bfhk1fvw",
    'color.background.selected.bold.hovered': "_bfhk18hz",
    'color.background.selected.bold.pressed': "_bfhkgr1v",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.subtlest.hovered': "_bfhkezq1",
    'color.background.brand.subtlest.pressed': "_bfhk2ggb",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.bold.hovered': "_bfhku1se",
    'color.background.brand.bold.pressed': "_bfhkqkzo",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.brand.boldest.hovered': "_bfhk1uwk",
    'color.background.brand.boldest.pressed': "_bfhk17jr",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1io2",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk9pqq",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.hovered': "_bfhk1rd4",
    'color.background.warning.pressed': "_bfhk11dh",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.warning.bold.hovered': "_bfhk1i4c",
    'color.background.warning.bold.pressed': "_bfhkrj9s",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.hovered': "_bfhk1jgi",
    'color.background.success.pressed': "_bfhky4f1",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.success.bold.hovered': "_bfhk1q4l",
    'color.background.success.bold.pressed': "_bfhkcrcn",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.hovered': "_bfhk1xp7",
    'color.background.discovery.pressed': "_bfhkdlkp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.discovery.bold.hovered': "_bfhk1w72",
    'color.background.discovery.bold.pressed': "_bfhkrb53",
    'color.background.information': "_bfhk33gi",
    'color.background.information.hovered': "_bfhk1vps",
    'color.background.information.pressed': "_bfhk1s0z",
    'color.background.information.bold': "_bfhk14wj",
    'color.background.information.bold.hovered': "_bfhk1amz",
    'color.background.information.bold.pressed': "_bfhk5bth",
    'color.blanket': "_bfhk10xm",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkn82g",
    'color.skeleton.subtle': "_bfhkh3tw",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk108i",
    'elevation.surface.pressed': "_bfhk1ji5",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk16qz",
    'elevation.surface.overlay.pressed': "_bfhkvq0a",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk1a0f",
    'elevation.surface.raised.pressed': "_bfhkf7u5",
    'elevation.surface.sunken': "_bfhkqbzx",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $77444c7b9825ba4b$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $77444c7b9825ba4b$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l108i",
    'elevation.surface.pressed': "_1q1l1ji5",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l16qz",
    'elevation.surface.overlay.pressed': "_1q1lvq0a",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l1a0f",
    'elevation.surface.raised.pressed': "_1q1lf7u5",
    'elevation.surface.sunken': "_1q1lqbzx"
};
var $77444c7b9825ba4b$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $77444c7b9825ba4b$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $77444c7b9825ba4b$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $77444c7b9825ba4b$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $77444c7b9825ba4b$var$Box = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $8ySUD.default)(_ref, $77444c7b9825ba4b$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $8ySUD.default)(htmlAttributes, $77444c7b9825ba4b$var$_excluded2);
    var node = /*#__PURE__*/ $1oC0p.createElement(Component, (0, $efs8s.default)({
        style: style,
        ref: ref,
        className: (0, $bhUiq.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $77444c7b9825ba4b$var$backgroundColorMap[backgroundColor],
            backgroundColor && $77444c7b9825ba4b$var$isSurfaceToken(backgroundColor) && $77444c7b9825ba4b$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $77444c7b9825ba4b$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $77444c7b9825ba4b$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $77444c7b9825ba4b$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $77444c7b9825ba4b$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $1oC0p.createElement((0, $arFqY.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $77444c7b9825ba4b$export$2e2bcd8739ae039 = $77444c7b9825ba4b$var$Box;
function $77444c7b9825ba4b$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $77444c7b9825ba4b$var$setSurfaceTokenMap;
}

});
parcelRegister("arFqY", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $79ac90f64b2cb532$export$1ca2a26fecb070ae; });

var $1oC0p = parcelRequire("1oC0p");
var $79ac90f64b2cb532$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $79ac90f64b2cb532$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($79ac90f64b2cb532$export$1ca2a26fecb070ae);
};
$79ac90f64b2cb532$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});



parcelRegister("ewvWf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a92cd428f17d8dee$export$2e2bcd8739ae039; });

var $efs8s = parcelRequire("efs8s");

var $1oC0p = parcelRequire("1oC0p");

var $kAu3P = parcelRequire("kAu3P");
function $a92cd428f17d8dee$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kAu3P.default), (0, $efs8s.default)({}, props, {
        isFullScreen: false
    }));
}

});
parcelRegister("kAu3P", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $efce7ce0939bdcd9$export$2e2bcd8739ae039; });
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $efs8s = parcelRequire("efs8s");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $fBQ8H = parcelRequire("fBQ8H");

var $4cgdq = parcelRequire("4cgdq");

var $iiIHF = parcelRequire("iiIHF");

var $b3BH6 = parcelRequire("b3BH6");

var $a3pKW = parcelRequire("a3pKW");

var $6pKdI = parcelRequire("6pKdI");

var $eyff6 = parcelRequire("eyff6");

var $3inBk = parcelRequire("3inBk");

var $39c3M = parcelRequire("39c3M");

var $52Fo7 = parcelRequire("52Fo7");

var $3a38i = parcelRequire("3a38i");

var $gdEa0 = parcelRequire("gdEa0");

var $8gf4P = parcelRequire("8gf4P");

var $6yznd = parcelRequire("6yznd");
var $efce7ce0939bdcd9$var$fillScreenStyles = null;
var $efce7ce0939bdcd9$var$allowlistElements = function allowlistElements(element, callback) {
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (!!document.querySelector('.aui-blanket:not([hidden])')) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $efce7ce0939bdcd9$var$InternalModalWrapper = function InternalModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, providedOnClose = props.onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $a3pKW.default) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId, isFullScreen = props.isFullScreen;
    var calculatedStackIndex = (0, $gdEa0.default)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    var onCloseHandler = (0, $iiIHF.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $a3pKW.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "0.0.0-development"
    });
    var onBlanketClicked = (0, $1oC0p.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $1oC0p.useCallback)(function(element) {
        return $efce7ce0939bdcd9$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $8gf4P.default)();
    (0, $eyff6.useNotifyOpenLayerObserver)({
        type: 'modal',
        // Modal dialog is conditionally rendered when visible, so when this runs it is always open.
        isOpen: (0, $39c3M.fg)('platform-dst-open-layer-observer-layer-type'),
        // Passing a no-op for now, as there isn't a real use case for closing the modal dialog programmatically
        // by the OpenLayerObserver. The only current use case is closing layers when resizing the nav layout,
        // which cannot happen while a modal dialog is open.
        onClose: (0, $a3pKW.default)
    });
    var modalDialogWithBlanket = /*#__PURE__*/ $1oC0p.createElement((0, $b3BH6.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, /*#__PURE__*/ $1oC0p.createElement((0, $6yznd.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        hasProvidedOnClose: Boolean(providedOnClose),
        isFullScreen: isFullScreen
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return /*#__PURE__*/ $1oC0p.createElement((0, $6pKdI.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $1oC0p.createElement((0, $52Fo7.default), {
        zIndex: (0, $3a38i.layers).modal()
    }, /*#__PURE__*/ $1oC0p.createElement((0, $3inBk.default), null, function(fadeInProps) {
        return /*#__PURE__*/ $1oC0p.createElement("div", (0, $efs8s.default)({}, fadeInProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $2jatx.default)([
                "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                fadeInProps.className
            ]),
            "aria-hidden": !isForeground
        }), /*#__PURE__*/ $1oC0p.createElement((0, $fBQ8H.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4cgdq))), null), shouldScrollInViewport ? /*#__PURE__*/ $1oC0p.createElement((0, $4cgdq.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $efce7ce0939bdcd9$export$2e2bcd8739ae039 = $efce7ce0939bdcd9$var$InternalModalWrapper;

});
parcelRegister("fBQ8H", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b5d2c17f9f45f2ca$export$2e2bcd8739ae039; });

var $jPpjS = parcelRequire("jPpjS");

var $b5d2c17f9f45f2ca$export$2e2bcd8739ae039 = (0, $jPpjS.default);

});
parcelRegister("jPpjS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e6f66bb3df4ce942$export$2e2bcd8739ae039; });

var $b9R1R = parcelRequire("b9R1R");

var $efs8s = parcelRequire("efs8s");

var $1oC0p = parcelRequire("1oC0p");

var $54Du1 = parcelRequire("54Du1");

var $kxHha = parcelRequire("kxHha");
/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/ var $e6f66bb3df4ce942$var$FocusLockCombination = /*#__PURE__*/ $1oC0p.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $1oC0p.createElement((0, $54Du1.default), (0, $efs8s.default)({
        sideCar: (0, $kxHha.default),
        ref: ref
    }, props));
});
var $e6f66bb3df4ce942$var$_ref = (0, $54Du1.default).propTypes || {}, $e6f66bb3df4ce942$var$sideCar = $e6f66bb3df4ce942$var$_ref.sideCar, $e6f66bb3df4ce942$var$propTypes = (0, $b9R1R.default)($e6f66bb3df4ce942$var$_ref, [
    "sideCar"
]);
$e6f66bb3df4ce942$var$FocusLockCombination.propTypes = {};
var $e6f66bb3df4ce942$export$2e2bcd8739ae039 = $e6f66bb3df4ce942$var$FocusLockCombination;

});
parcelRegister("54Du1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3b1bf4062d7a65f0$export$2e2bcd8739ae039; });

var $efs8s = parcelRequire("efs8s");

var $1oC0p = parcelRequire("1oC0p");


var $9d7xu = parcelRequire("9d7xu");

var $fHPxa = parcelRequire("fHPxa");

var $5kiDX = parcelRequire("5kiDX");

var $6xrPx = parcelRequire("6xrPx");
var $3b1bf4062d7a65f0$var$emptyArray = [];
var $3b1bf4062d7a65f0$var$FocusLock = /*#__PURE__*/ $1oC0p.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $1oC0p.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $1oC0p.useRef();
    var isActive = $1oC0p.useRef(false);
    var originalFocusedElement = $1oC0p.useRef(null);
    var children = props.children, disabled = props.disabled, noFocusGuards = props.noFocusGuards, persistentFocus = props.persistentFocus, crossFrame = props.crossFrame, autoFocus = props.autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $3b1bf4062d7a65f0$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, shouldReturnFocus = props.returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState2 = $1oC0p.useState({}), id = _React$useState2[0]; // SIDE EFFECT CALLBACKS
    var onActivation = $1oC0p.useCallback(function() {
        originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $1oC0p.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
    }, [
        onDeactivationCallback
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (!disabled) // cleanup return focus on trap deactivation
        // sideEffect/returnFocus should happen by this time
        originalFocusedElement.current = null;
    }, []);
    var returnFocus = $1oC0p.useCallback(function(allowDefer) {
        var returnFocusTo = originalFocusedElement.current;
        if (returnFocusTo && returnFocusTo.focus) {
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) // React might return focus after update
                // it's safer to defer the action
                Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]); // MEDIUM CALLBACKS
    var onFocus = $1oC0p.useCallback(function(event) {
        if (isActive.current) (0, $6xrPx.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $6xrPx.mediumBlur).useMedium; // REF PROPAGATION
    // not using real refs due to race conditions
    var setObserveNode = $1oC0p.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $efs8s.default)((_extends2 = {}, _extends2[$9d7xu.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$9d7xu.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $fHPxa.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    return /*#__PURE__*/ $1oC0p.createElement($1oC0p.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ // nearest focus guard
        $1oC0p.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $5kiDX.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $1oC0p.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $5kiDX.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $1oC0p.createElement(SideCar, {
        id: id,
        sideCar: (0, $6xrPx.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $1oC0p.createElement(Container, (0, $efs8s.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), children), hasTailingGuards && /*#__PURE__*/ $1oC0p.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $5kiDX.hiddenGuard)
    }));
});
$3b1bf4062d7a65f0$var$FocusLock.propTypes = {};
$3b1bf4062d7a65f0$var$FocusLock.defaultProps = {
    children: undefined,
    disabled: false,
    returnFocus: false,
    focusOptions: undefined,
    noFocusGuards: false,
    autoFocus: true,
    persistentFocus: false,
    crossFrame: true,
    hasPositiveIndices: undefined,
    allowTextSelection: undefined,
    group: undefined,
    className: undefined,
    whiteList: undefined,
    shards: undefined,
    as: 'div',
    lockProps: {},
    onActivation: undefined,
    onDeactivation: undefined
};
var $3b1bf4062d7a65f0$export$2e2bcd8739ae039 = $3b1bf4062d7a65f0$var$FocusLock;

});
parcelRegister("fHPxa", function(module, exports) {
$parcel$export(module.exports, "useMergeRefs", function () { return $b6f2d8bbce9fd6a8$export$74665b213cb5c4cf; });

var $aRfeJ = parcelRequire("aRfeJ");

var $7KGQZ = parcelRequire("7KGQZ");
function $b6f2d8bbce9fd6a8$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $7KGQZ.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $aRfeJ.assignRef)(ref, newValue);
        });
    });
}

});
parcelRegister("aRfeJ", function(module, exports) {
$parcel$export(module.exports, "assignRef", function () { return $7e7aac4f79b49428$export$d734136a7b018efe; });
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $7e7aac4f79b49428$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("7KGQZ", function(module, exports) {
$parcel$export(module.exports, "useCallbackRef", function () { return $5a4e1223ccd1249a$export$25bec8c6f54ee79a; });

var $1oC0p = parcelRequire("1oC0p");
function $5a4e1223ccd1249a$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $1oC0p.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("5kiDX", function(module, exports) {
$parcel$export(module.exports, "hiddenGuard", function () { return $3e0d48375dd1d4ee$export$b8c7b07253306600; });

var $1oC0p = parcelRequire("1oC0p");

var $3e0d48375dd1d4ee$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $3e0d48375dd1d4ee$var$InFocusGuard = function InFocusGuard(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement($1oC0p.Fragment, null, /*#__PURE__*/ $1oC0p.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $3e0d48375dd1d4ee$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $1oC0p.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $3e0d48375dd1d4ee$export$b8c7b07253306600
    }));
};
$3e0d48375dd1d4ee$var$InFocusGuard.propTypes = {};
$3e0d48375dd1d4ee$var$InFocusGuard.defaultProps = {
    children: null
};
var $3e0d48375dd1d4ee$export$2e2bcd8739ae039 = $3e0d48375dd1d4ee$var$InFocusGuard;

});

parcelRegister("6xrPx", function(module, exports) {
$parcel$export(module.exports, "mediumFocus", function () { return $4c2b69a91652ed54$export$5733e022b1d538cb; });
$parcel$export(module.exports, "mediumBlur", function () { return $4c2b69a91652ed54$export$b3e9a9312f73723c; });
$parcel$export(module.exports, "mediumEffect", function () { return $4c2b69a91652ed54$export$3a1d52767cbc07b8; });
$parcel$export(module.exports, "mediumSidecar", function () { return $4c2b69a91652ed54$export$892cbf28e5518020; });

var $f1gJI = parcelRequire("f1gJI");
var $4c2b69a91652ed54$export$5733e022b1d538cb = (0, $f1gJI.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $4c2b69a91652ed54$export$b3e9a9312f73723c = (0, $f1gJI.createMedium)();
var $4c2b69a91652ed54$export$3a1d52767cbc07b8 = (0, $f1gJI.createMedium)();
var $4c2b69a91652ed54$export$892cbf28e5518020 = (0, $f1gJI.createSidecarMedium)({
    async: true // focus-lock sidecar is not required on the server
});

});


parcelRegister("kxHha", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ef487562ae46d71d$export$2e2bcd8739ae039; });
/* eslint-disable no-mixed-operators */ 
var $1oC0p = parcelRequire("1oC0p");


var $6P2F1 = parcelRequire("6P2F1");

var $7IutG = parcelRequire("7IutG");
var $azUCw = parcelRequire("azUCw");
var $9gZ1p = parcelRequire("9gZ1p");
var $5uZTH = parcelRequire("5uZTH");

var $9LqcA = parcelRequire("9LqcA");

var $6xrPx = parcelRequire("6xrPx");
var $ef487562ae46d71d$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $ef487562ae46d71d$var$isFreeFocus = function isFreeFocus() {
    return $ef487562ae46d71d$var$focusOnBody() || (0, $9gZ1p.focusIsHidden)();
};
var $ef487562ae46d71d$var$lastActiveTrap = null;
var $ef487562ae46d71d$var$lastActiveFocus = null;
var $ef487562ae46d71d$var$lastPortaledElement = null;
var $ef487562ae46d71d$var$focusWasOutsideWindow = false;
var $ef487562ae46d71d$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $ef487562ae46d71d$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($ef487562ae46d71d$var$lastActiveTrap.whiteList || $ef487562ae46d71d$var$defaultWhitelist)(activeElement);
};
var $ef487562ae46d71d$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $ef487562ae46d71d$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $ef487562ae46d71d$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $ef487562ae46d71d$var$lastPortaledElement && $ef487562ae46d71d$var$lastPortaledElement.portaledElement === element;
};
function $ef487562ae46d71d$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) // we will tab to the next element
            return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $ef487562ae46d71d$var$extractRef = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $ef487562ae46d71d$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) // with cross frame return true for any value
    return Boolean($ef487562ae46d71d$var$focusWasOutsideWindow);
     // in other case return only of focus went a while aho
    return $ef487562ae46d71d$var$focusWasOutsideWindow === 'meanwhile';
};
var $ef487562ae46d71d$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement) // dive up
    ) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $ef487562ae46d71d$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $ef487562ae46d71d$var$checkInHost(activeElement, area, area);
    });
};
var $ef487562ae46d71d$var$activateTrap = function activateTrap() {
    var result = false;
    if ($ef487562ae46d71d$var$lastActiveTrap) {
        var _lastActiveTrap = $ef487562ae46d71d$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $ef487562ae46d71d$var$lastPortaledElement && $ef487562ae46d71d$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map($ef487562ae46d71d$var$extractRef).filter(Boolean));
            if (!activeElement || $ef487562ae46d71d$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $ef487562ae46d71d$var$focusWasOutside(crossFrame) || !$ef487562ae46d71d$var$isFreeFocus() || !$ef487562ae46d71d$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $azUCw.focusInside)(workingArea) || // check for shadow-dom contained elements
                    activeElement && $ef487562ae46d71d$var$withinHost(activeElement, workingArea) || $ef487562ae46d71d$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$ef487562ae46d71d$var$lastActiveFocus && activeElement && !autoFocus) {
                            // Check if blur() exists, which is missing on certain elements on IE
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $5uZTH.moveFocusInside)(workingArea, $ef487562ae46d71d$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $ef487562ae46d71d$var$lastPortaledElement = {};
                        }
                    }
                    $ef487562ae46d71d$var$focusWasOutsideWindow = false;
                    $ef487562ae46d71d$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $7IutG.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    // remove old focus
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $ef487562ae46d71d$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $ef487562ae46d71d$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $ef487562ae46d71d$var$onTrap = function onTrap(event) {
    if ($ef487562ae46d71d$var$activateTrap() && event) {
        // prevent scroll jump
        event.stopPropagation();
        event.preventDefault();
    }
};
var $ef487562ae46d71d$var$onBlur = function onBlur() {
    return (0, $9LqcA.deferAction)($ef487562ae46d71d$var$activateTrap);
};
var $ef487562ae46d71d$var$onFocus = function onFocus(event) {
    // detect portal
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $ef487562ae46d71d$var$recordPortal(currentNode, source);
};
var $ef487562ae46d71d$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $ef487562ae46d71d$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        onBlur: $ef487562ae46d71d$var$onBlur,
        onFocus: $ef487562ae46d71d$var$onFocus
    }, children);
};
$ef487562ae46d71d$var$FocusTrap.propTypes = {};
var $ef487562ae46d71d$var$onWindowBlur = function onWindowBlur() {
    $ef487562ae46d71d$var$focusWasOutsideWindow = 'just'; // using setTimeout to set  this variable after React/sidecar reaction
    (0, $9LqcA.deferAction)(function() {
        $ef487562ae46d71d$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $ef487562ae46d71d$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $ef487562ae46d71d$var$onTrap);
    document.addEventListener('focusout', $ef487562ae46d71d$var$onBlur);
    window.addEventListener('blur', $ef487562ae46d71d$var$onWindowBlur);
};
var $ef487562ae46d71d$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $ef487562ae46d71d$var$onTrap);
    document.removeEventListener('focusout', $ef487562ae46d71d$var$onBlur);
    window.removeEventListener('blur', $ef487562ae46d71d$var$onWindowBlur);
};
function $ef487562ae46d71d$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
function $ef487562ae46d71d$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$ef487562ae46d71d$var$lastActiveTrap) $ef487562ae46d71d$var$attachHandler();
    var lastTrap = $ef487562ae46d71d$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $ef487562ae46d71d$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation(); // return focus only of last trap was removed
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) // allow defer is no other trap is awaiting restore
        lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $ef487562ae46d71d$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation();
        $ef487562ae46d71d$var$activateTrap(true);
        (0, $9LqcA.deferAction)($ef487562ae46d71d$var$activateTrap);
    } else {
        $ef487562ae46d71d$var$detachHandler();
        $ef487562ae46d71d$var$lastActiveFocus = null;
    }
} // bind medium
(0, $6xrPx.mediumFocus).assignSyncMedium($ef487562ae46d71d$var$onFocus);
(0, $6xrPx.mediumBlur).assignMedium($ef487562ae46d71d$var$onBlur);
(0, $6xrPx.mediumEffect).assignMedium(function(cb) {
    return cb({
        moveFocusInside: (0, $5uZTH.moveFocusInside),
        focusInside: (0, $azUCw.focusInside)
    });
});
var $ef487562ae46d71d$export$2e2bcd8739ae039 = (0, $6P2F1.default)($ef487562ae46d71d$var$reducePropsToState, $ef487562ae46d71d$var$handleStateChangeOnClient)($ef487562ae46d71d$var$FocusWatcher);

});
parcelRegister("9LqcA", function(module, exports) {
$parcel$export(module.exports, "deferAction", function () { return $71bcd3fff648a7cd$export$6523025722806278; });
function $71bcd3fff648a7cd$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $71bcd3fff648a7cd$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};

});




parcelRegister("a3pKW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $751e29cd0e31711a$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $751e29cd0e31711a$export$2e2bcd8739ae039() {}

});

parcelRegister("6pKdI", function(module, exports) {
$parcel$export(module.exports, "LevelContext", function () { return $4ab8ee45c77b27be$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "LevelNodeContext", function () { return $4ab8ee45c77b27be$export$18f4d8b5b3a77f59; });
$parcel$export(module.exports, "RootNodeContext", function () { return $4ab8ee45c77b27be$export$fa973f110e8f6ca8; });
$parcel$export(module.exports, "Layering", function () { return $4ab8ee45c77b27be$export$7c885f891c940977; });

var $1oC0p = parcelRequire("1oC0p");

var $1x0tl = parcelRequire("1x0tl");
var $4ab8ee45c77b27be$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $1oC0p.createContext)(0);
var $4ab8ee45c77b27be$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    current: null
});
var $4ab8ee45c77b27be$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    current: null
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $4ab8ee45c77b27be$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $1oC0p.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($4ab8ee45c77b27be$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($4ab8ee45c77b27be$export$18f4d8b5b3a77f59.Provider, {
        value: levelNode
    }, children));
};
var $4ab8ee45c77b27be$export$7c885f891c940977 = function Layering(_ref2) {
    var children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? true : _ref2$isDisabled;
    var currentLevel = (0, $1oC0p.useContext)($4ab8ee45c77b27be$export$650d12d3c2ddb8fc);
    var parentNode = (0, $1oC0p.useContext)($4ab8ee45c77b27be$export$18f4d8b5b3a77f59);
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $1oC0p.useRef)(new (0, $1x0tl.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($4ab8ee45c77b27be$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($4ab8ee45c77b27be$export$fa973f110e8f6ca8.Provider, {
        value: newNode
    }, content);
};

});
parcelRegister("1x0tl", function(module, exports) {
$parcel$export(module.exports, "LayerNode", function () { return $11d93d46f1c0690d$export$da4f61fd78d35243; });

var $342Py = parcelRequire("342Py");

var $3AhEU = parcelRequire("3AhEU");

var $gWIyR = parcelRequire("gWIyR");
var $11d93d46f1c0690d$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, $3AhEU.default)(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, $gWIyR.default)(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, $342Py.default)(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();

});


parcelRegister("eyff6", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", function () { return $a980108a95d6a50b$export$469bb693f11edc7f; });

var $1oC0p = parcelRequire("1oC0p");

var $gZAgU = parcelRequire("gZAgU");

var $jx15I = parcelRequire("jx15I");
function $a980108a95d6a50b$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $1oC0p.useContext)((0, $gZAgU.OpenLayerObserverContext));
    var namespace = (0, $jx15I.useOpenLayerObserverNamespace)();
    (0, $1oC0p.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("gZAgU", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", function () { return $c5ee7aa8fd45eccf$export$5fbf4d7fae6cdc00; });

var $1oC0p = parcelRequire("1oC0p");
var $c5ee7aa8fd45eccf$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("jx15I", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", function () { return $e381f215c7c36d83$export$1d57e79091cc3046; });

var $1oC0p = parcelRequire("1oC0p");

var $hyQLr = parcelRequire("hyQLr");
function $e381f215c7c36d83$export$1d57e79091cc3046() {
    var namespace = (0, $1oC0p.useContext)((0, $hyQLr.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("hyQLr", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", function () { return $cc8e8a86fe5a6d25$export$644a49f3b8c50fcd; });

var $1oC0p = parcelRequire("1oC0p");
var $cc8e8a86fe5a6d25$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});



parcelRegister("3inBk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26655c3e074b8fc7$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $92NKm = parcelRequire("92NKm");
var $26655c3e074b8fc7$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $26655c3e074b8fc7$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $26655c3e074b8fc7$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $92NKm.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $26655c3e074b8fc7$export$2e2bcd8739ae039 = $26655c3e074b8fc7$var$FadeIn;

});
parcelRegister("92NKm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $695ae3a308f3ec5d$export$2e2bcd8739ae039; });
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2gb89 = parcelRequire("2gb89");

var $1oC0p = parcelRequire("1oC0p");

var $3F0aB = parcelRequire("3F0aB");

var $efX04 = parcelRequire("efX04");

var $iqcXV = parcelRequire("iqcXV");

var $bVUTw = parcelRequire("bVUTw");

var $fQ1Y9 = parcelRequire("fQ1Y9");

var $6cz9s = parcelRequire("6cz9s");
var $695ae3a308f3ec5d$var$zoomIn = null;
var $695ae3a308f3ec5d$var$zoomOut = null;
var $695ae3a308f3ec5d$var$fadeIn = null;
var $695ae3a308f3ec5d$var$fadeOut = null;
var $695ae3a308f3ec5d$var$fadeInFromTop = null;
var $695ae3a308f3ec5d$var$fadeOutFromTop = null;
var $695ae3a308f3ec5d$var$fadeInFromLeft = null;
var $695ae3a308f3ec5d$var$fadeOutFromLeft = null;
var $695ae3a308f3ec5d$var$fadeInFromBottom = null;
var $695ae3a308f3ec5d$var$fadeOutFromBottom = null;
var $695ae3a308f3ec5d$var$fadeInFromRight = null;
var $695ae3a308f3ec5d$var$fadeOutFromRight = null;
var $695ae3a308f3ec5d$var$fadeInFromTopConstant = null;
var $695ae3a308f3ec5d$var$fadeOutFromTopConstant = null;
var $695ae3a308f3ec5d$var$fadeInFromLeftConstant = null;
var $695ae3a308f3ec5d$var$fadeOutFromLeftConstant = null;
var $695ae3a308f3ec5d$var$fadeInFromBottomConstant = null;
var $695ae3a308f3ec5d$var$fadeOutFromBottomConstant = null;
var $695ae3a308f3ec5d$var$fadeInFromRightConstant = null;
var $695ae3a308f3ec5d$var$fadeOutFromRightConstant = null;
var $695ae3a308f3ec5d$var$slideInFromTop = null;
var $695ae3a308f3ec5d$var$slideOutFromTop = null;
var $695ae3a308f3ec5d$var$slideInFromRight = null;
var $695ae3a308f3ec5d$var$slideOutFromRight = null;
var $695ae3a308f3ec5d$var$slideInFromBottom = null;
var $695ae3a308f3ec5d$var$slideOutFromBottom = null;
var $695ae3a308f3ec5d$var$slideInFromLeft = null;
var $695ae3a308f3ec5d$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $695ae3a308f3ec5d$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $6cz9s.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $fQ1Y9.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $bVUTw.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $1oC0p.useState)(appear), _useState2 = (0, $2gb89.default)(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $efX04.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $iqcXV.exitingDurations)[duration] : (0, $iqcXV.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $3F0aB.default)([
            (0, $3F0aB.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $3F0aB.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $3F0aB.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $3F0aB.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $3F0aB.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $3F0aB.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $3F0aB.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $3F0aB.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $3F0aB.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $3F0aB.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $3F0aB.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $3F0aB.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $3F0aB.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $3F0aB.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $3F0aB.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $3F0aB.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $3F0aB.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $3F0aB.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $3F0aB.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $3F0aB.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $3F0aB.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $3F0aB.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $3F0aB.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $3F0aB.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $3F0aB.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $3F0aB.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $3F0aB.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $3F0aB.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $3F0aB.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $3F0aB.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $3F0aB.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $3F0aB.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $3F0aB.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $3F0aB.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $3F0aB.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $3F0aB.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $3F0aB.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $3F0aB.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $3F0aB.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $3F0aB.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $3F0aB.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $3F0aB.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $3F0aB.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $3F0aB.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $3F0aB.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $3F0aB.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $3F0aB.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $3F0aB.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $3F0aB.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $3F0aB.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $3F0aB.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $695ae3a308f3ec5d$export$2e2bcd8739ae039 = $695ae3a308f3ec5d$var$EnteringMotion;

});
parcelRegister("3F0aB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2aa5552afda8edf7$export$2e2bcd8739ae039; });
const $2aa5552afda8edf7$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $2aa5552afda8edf7$var$ATOMIC_GROUP_LENGTH = 5;
function $2aa5552afda8edf7$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $2aa5552afda8edf7$var$UNDERSCORE_UNICODE ? $2aa5552afda8edf7$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("efX04", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", function () { return $a6103b9b74a52615$export$b7baf7667a68d87c; });

var $2gb89 = parcelRequire("2gb89");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");
var $a6103b9b74a52615$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $a6103b9b74a52615$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$a6103b9b74a52615$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $a6103b9b74a52615$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $1oC0p.useState)($a6103b9b74a52615$export$b7baf7667a68d87c), _useState2 = (0, $2gb89.default)(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        if (!$a6103b9b74a52615$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $dH1HR.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $a6103b9b74a52615$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $a6103b9b74a52615$export$ff7706047246b98b = function prefersReducedMotion() {
    return $a6103b9b74a52615$export$f0f789643ba5a83c;
};

});

parcelRegister("iqcXV", function(module, exports) {
$parcel$export(module.exports, "durations", function () { return $d694b65ed8e61a4d$export$38b928a7167ce124; });
$parcel$export(module.exports, "exitingDurations", function () { return $d694b65ed8e61a4d$export$30fa1a2e62ae150c; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $d694b65ed8e61a4d$export$368bacef0dacbe05 = 25;
var $d694b65ed8e61a4d$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $d694b65ed8e61a4d$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $d694b65ed8e61a4d$export$30fa1a2e62ae150c = {
    none: $d694b65ed8e61a4d$export$38b928a7167ce124.none,
    small: $d694b65ed8e61a4d$export$38b928a7167ce124.small * $d694b65ed8e61a4d$var$EXITING_MOTION_MULTIPLIER,
    medium: $d694b65ed8e61a4d$export$38b928a7167ce124.medium * $d694b65ed8e61a4d$var$EXITING_MOTION_MULTIPLIER,
    large: $d694b65ed8e61a4d$export$38b928a7167ce124.large * $d694b65ed8e61a4d$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("bVUTw", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", function () { return $8b01269f24230cb5$export$4f34107a2b00f39c; });

var $1oC0p = parcelRequire("1oC0p");
var $8b01269f24230cb5$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $8b01269f24230cb5$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $1oC0p.useRef)([]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $8b01269f24230cb5$var$getHookDeps(opts));
    return (0, $1oC0p.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $8b01269f24230cb5$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $1oC0p.useRef)([]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $8b01269f24230cb5$var$getHookDeps(opts));
    return (0, $1oC0p.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("fQ1Y9", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", function () { return $b87d3d65dd3e3041$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $b87d3d65dd3e3041$export$2e2bcd8739ae039; });

var $2gb89 = parcelRequire("2gb89");

var $1oC0p = parcelRequire("1oC0p");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $b87d3d65dd3e3041$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $b87d3d65dd3e3041$var$ExitingContext = /*#__PURE__*/ (0, $1oC0p.createContext)($b87d3d65dd3e3041$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $b87d3d65dd3e3041$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b87d3d65dd3e3041$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($b87d3d65dd3e3041$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $b87d3d65dd3e3041$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $1oC0p.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $b87d3d65dd3e3041$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $b87d3d65dd3e3041$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $b87d3d65dd3e3041$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $b87d3d65dd3e3041$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $b87d3d65dd3e3041$var$ExitingPersistence = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $1oC0p.useState)([
        null,
        children
    ]), _useState2 = (0, $2gb89.default)(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)([]), _useState4 = (0, $2gb89.default)(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, $2gb89.default)(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $1oC0p.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, $2gb89.default)(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $b87d3d65dd3e3041$var$childrenToArray(previousChildren);
    var current = $b87d3d65dd3e3041$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $b87d3d65dd3e3041$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $b87d3d65dd3e3041$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $b87d3d65dd3e3041$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $b87d3d65dd3e3041$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $b87d3d65dd3e3041$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $1oC0p.useContext)($b87d3d65dd3e3041$var$ExitingContext);
};
$b87d3d65dd3e3041$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $b87d3d65dd3e3041$export$2e2bcd8739ae039 = $b87d3d65dd3e3041$var$ExitingPersistence;

});

parcelRegister("6cz9s", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", function () { return $483f2169928d89d9$export$25c7213fc07ec080; });

var $2gb89 = parcelRequire("2gb89");

var $1oC0p = parcelRequire("1oC0p");

var $5hN1N = parcelRequire("5hN1N");

var $bQ3RE = parcelRequire("bQ3RE");

var $w09ek = parcelRequire("w09ek");
var $483f2169928d89d9$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $1oC0p.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $5hN1N.default)
    };
});
var $483f2169928d89d9$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $w09ek.useUniqueId)();
    var context = (0, $1oC0p.useContext)($483f2169928d89d9$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $483f2169928d89d9$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $1oC0p.useRef)([]);
    var indexes = [];
    var _useState = (0, $1oC0p.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, $2gb89.default)(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $bQ3RE.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($483f2169928d89d9$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $483f2169928d89d9$export$2e2bcd8739ae039 = $483f2169928d89d9$var$StaggeredEntrance;

});
parcelRegister("5hN1N", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3d94923625a09f73$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $3d94923625a09f73$export$2e2bcd8739ae039() {}

});

parcelRegister("bQ3RE", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", function () { return $89e78c6924e7507a$export$e5c5a5f917a5871c; });

var $1oC0p = parcelRequire("1oC0p");
var $89e78c6924e7507a$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);

});

parcelRegister("w09ek", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", function () { return $06031aa365c7d1cc$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $1oC0p = parcelRequire("1oC0p");
function $06031aa365c7d1cc$export$c485849f2e393253() {
    var identifier = (0, $1oC0p.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("3a38i", function(module, exports) {
$parcel$export(module.exports, "layers", function () { return $24d4bc5dad871e10$export$7be255094ccdc533; });

var $4NHB0 = parcelRequire("4NHB0");

var $iqCss = parcelRequire("iqCss");
var $24d4bc5dad871e10$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $24d4bc5dad871e10$export$c93026a968943f95 = 'light';
var $24d4bc5dad871e10$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $24d4bc5dad871e10$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $iqCss.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $4NHB0.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $24d4bc5dad871e10$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $24d4bc5dad871e10$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $24d4bc5dad871e10$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $4NHB0.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $24d4bc5dad871e10$export$ba1d834b86d72a09 = $24d4bc5dad871e10$export$a1b3edb637fb4f35;
var $24d4bc5dad871e10$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $iqCss.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $iqCss.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $iqCss.N30A), ")")
            }
        }
    };
};

});
parcelRegister("4NHB0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $37ed8e45bcf94e60$export$2e2bcd8739ae039; });

var $3PYjr = parcelRequire("3PYjr");

var $7t0tI = parcelRequire("7t0tI");
function $37ed8e45bcf94e60$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $3PYjr.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $37ed8e45bcf94e60$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("3PYjr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2cb4eb5beeb9e8c3$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $2cb4eb5beeb9e8c3$var$printed = {};
function $2cb4eb5beeb9e8c3$export$2e2bcd8739ae039(message) {
    if ($2cb4eb5beeb9e8c3$var$printed[message]) return;
    $2cb4eb5beeb9e8c3$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});



parcelRegister("gdEa0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bced033cc78dfc0c$export$2e2bcd8739ae039; });

var $2gb89 = parcelRequire("2gb89");

var $1oC0p = parcelRequire("1oC0p");

var $82NpA = parcelRequire("82NpA");

var $52ofd = parcelRequire("52ofd");

var $lv6uQ = parcelRequire("lv6uQ");

var $fQ1Y9 = parcelRequire("fQ1Y9");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $bced033cc78dfc0c$var$modalStackRegister = [];
function $bced033cc78dfc0c$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $fQ1Y9.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $lv6uQ.default)(0), _useStateRef2 = (0, $2gb89.default)(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $52ofd.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $82NpA.default)(function() {
        var newStackIndex = $bced033cc78dfc0c$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $1oC0p.useEffect)(function() {
        var currentStackIndex = $bced033cc78dfc0c$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $bced033cc78dfc0c$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $bced033cc78dfc0c$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $bced033cc78dfc0c$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $bced033cc78dfc0c$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $bced033cc78dfc0c$var$modalStackRegister.splice(currentStackIndex, 1);
                $bced033cc78dfc0c$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $1oC0p.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("82NpA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5db4d6c48d826c3b$export$2e2bcd8739ae039; });

var $hV4sw = parcelRequire("hV4sw");
function $5db4d6c48d826c3b$export$2e2bcd8739ae039(callback) {
    var ref = (0, $hV4sw.default)(function() {
        return callback;
    });
    return ref.current;
}

});
parcelRegister("hV4sw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d0bb38092ba14823$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $d0bb38092ba14823$var$uniqueReferencedValue = {};
function $d0bb38092ba14823$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $1oC0p.useRef)($d0bb38092ba14823$var$uniqueReferencedValue);
    if (ref.current === $d0bb38092ba14823$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("52ofd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3aaff21b6807c893$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $3aaff21b6807c893$export$2e2bcd8739ae039(value) {
    var ref = (0, $1oC0p.useRef)();
    (0, $1oC0p.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("lv6uQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fa71884f76f6bacb$export$2e2bcd8739ae039; });

var $2gb89 = parcelRequire("2gb89");

var $1oC0p = parcelRequire("1oC0p");
function $fa71884f76f6bacb$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $1oC0p.useState)(initialState), _useState2 = (0, $2gb89.default)(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $1oC0p.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("8gf4P", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $603b834cfcbdedc8$export$2e2bcd8739ae039; });

var $2gb89 = parcelRequire("2gb89");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $603b834cfcbdedc8$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $603b834cfcbdedc8$export$2e2bcd8739ae039() {
    var _useState = (0, $1oC0p.useState)(0), _useState2 = (0, $2gb89.default)(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $1oC0p.useLayoutEffect)(function() {
        setScrollTopOffset($603b834cfcbdedc8$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $1oC0p.useCallback)(function() {
        if ($603b834cfcbdedc8$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $1oC0p.useEffect)(function() {
        return (0, $dH1HR.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("6yznd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4c615b7a56ee77da$export$2e2bcd8739ae039; });
/* modal-dialog.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $efs8s = parcelRequire("efs8s");

var $2gb89 = parcelRequire("2gb89");

var $6DX60 = parcelRequire("6DX60");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $kc3Cl = parcelRequire("kc3Cl");

var $5yU9U = parcelRequire("5yU9U");

var $apH1Q = parcelRequire("apH1Q");

var $6VUo8 = parcelRequire("6VUo8");

var $3inBk = parcelRequire("3inBk");

var $2OL6m = parcelRequire("2OL6m");

var $5qkEW = parcelRequire("5qkEW");

var $8r9C2 = parcelRequire("8r9C2");

var $6cCbl = parcelRequire("6cCbl");

var $5sVjK = parcelRequire("5sVjK");

var $lGgGl = parcelRequire("lGgGl");

var $4LGGP = parcelRequire("4LGGP");

var $jE8f1 = parcelRequire("jE8f1");
var $4c615b7a56ee77da$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $4c615b7a56ee77da$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syaz1fxt _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1p6i _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p1cd0 _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkxfajl"
};
var $4c615b7a56ee77da$var$viewportScrollStyles = null;
var $4c615b7a56ee77da$var$bodyScrollStyles = null;
var $4c615b7a56ee77da$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? 'medium' : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, hasProvidedOnClose = props.hasProvidedOnClose, children = props.children, label = props.label, testId = props.testId, _props$isFullScreen = props.isFullScreen, isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen;
    var id = (0, $apH1Q.useId)();
    var titleId = "modal-dialog-title-".concat(id);
    var defaultTestId = testId || 'modal-dialog';
    (0, $1oC0p.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $2OL6m.combine)((0, $6cCbl.disableDraggingToCrossOriginIFramesForElement)(), (0, $lGgGl.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $5sVjK.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $5yU9U.default)((0, $6DX60.default)(autoFocus) === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, $6DX60.default)(autoFocus) === 'object');
    var _useOnMotionFinish = (0, $8r9C2.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, $2gb89.default)(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $1oC0p.useMemo)(function() {
        return {
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        };
    }, [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $6VUo8.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $6VUo8.useLayering)(), currentLevel = _useLayering.currentLevel;
    return /*#__PURE__*/ $1oC0p.createElement((0, $jE8f1.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen
    }, /*#__PURE__*/ $1oC0p.createElement((0, $5qkEW.ModalContext).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ $1oC0p.createElement((0, $5qkEW.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, /*#__PURE__*/ $1oC0p.createElement((0, $3inBk.default), {
        entranceDirection: isFullScreen ? undefined : 'bottom',
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return /*#__PURE__*/ $1oC0p.createElement("section", (0, $efs8s.default)({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $kc3Cl.default)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, $4LGGP.dialogWidth)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, $4LGGP.dialogHeight)(height)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $2jatx.default)([
                $4c615b7a56ee77da$var$dialogStyles.root,
                !isFullScreen && $4c615b7a56ee77da$var$dialogStyles.borderRadius,
                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                bottomFadeInProps.className
            ]),
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": defaultTestId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children);
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4c615b7a56ee77da$export$2e2bcd8739ae039 = $4c615b7a56ee77da$var$ModalDialog;

});
parcelRegister("kc3Cl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eb37bc00664dedf0$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $eb37bc00664dedf0$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("5yU9U", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $40cbb0b98322b6c4$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $40cbb0b98322b6c4$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("apH1Q", function(module, exports) {
$parcel$export(module.exports, "useId", function () { return $794d9dcaced899db$export$f680877a34711e37; });

var $6DX60 = parcelRequire("6DX60");

var $1oC0p = parcelRequire("1oC0p");

var $6JmtO = parcelRequire("6JmtO");

var $39c3M = parcelRequire("39c3M");
var $794d9dcaced899db$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $794d9dcaced899db$var$react18UseId = ($794d9dcaced899db$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId) !== null && $794d9dcaced899db$var$_React$useId !== void 0 ? $794d9dcaced899db$var$_React$useId : undefined;
function $794d9dcaced899db$export$f680877a34711e37() {
    if ($794d9dcaced899db$var$react18UseId && (0, $39c3M.fg)('platform-dst-react-18-use-id')) {
        if ((0, $39c3M.fg)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $794d9dcaced899db$var$react18UseId().replace(/[:«»]/g, '_');
        return $794d9dcaced899db$var$react18UseId();
    }
    return "uid".concat((0, $6JmtO.useUID)());
}
var $794d9dcaced899db$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($794d9dcaced899db$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $6DX60.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $6DX60.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $794d9dcaced899db$export$6ee17796e3d70de2() {
    if ($794d9dcaced899db$var$react18UseId && (0, $39c3M.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        var uid = $794d9dcaced899db$export$f680877a34711e37();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $6JmtO.useUIDSeed)();
}

});

parcelRegister("6VUo8", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", function () { return $50c3ce7ce5aea137$export$4a4bf067ea9e7886; });
$parcel$export(module.exports, "useLayering", function () { return $50c3ce7ce5aea137$export$c8b4d54e03dee6ed; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $6pKdI = parcelRequire("6pKdI");
var $50c3ce7ce5aea137$var$ESCAPE = 'Escape';
function $50c3ce7ce5aea137$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $1oC0p.useRef)(false);
    var _useLayering = $50c3ce7ce5aea137$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $1oC0p.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $50c3ce7ce5aea137$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $1oC0p.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $1oC0p.useEffect)(function() {
        return (0, $dH1HR.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $50c3ce7ce5aea137$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $1oC0p.useContext)((0, $6pKdI.LevelContext));
    var layerNode = (0, $1oC0p.useContext)((0, $6pKdI.LevelNodeContext));
    var rootNode = (0, $1oC0p.useContext)((0, $6pKdI.RootNodeContext));
    var isLayerDisabled = (0, $1oC0p.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $1oC0p.useCallback)(function() {
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});

parcelRegister("5qkEW", function(module, exports) {
$parcel$export(module.exports, "ModalContext", function () { return $3f2f67f4e07e7cc3$export$ab57792b9b6974a6; });
$parcel$export(module.exports, "ScrollContext", function () { return $3f2f67f4e07e7cc3$export$dece24112a937f92; });

var $1oC0p = parcelRequire("1oC0p");
var $3f2f67f4e07e7cc3$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $3f2f67f4e07e7cc3$export$dece24112a937f92 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("8r9C2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $62484d2c02106418$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $62484d2c02106418$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $1oC0p.useRef)(null);
    var onMotionFinish = (0, $1oC0p.useCallback)(function(state) {
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("6cCbl", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", function () { return $48417b3b5179d706$export$ec28e97c7d8b1b35; });

var $dH1HR = parcelRequire("dH1HR");

var $2OL6m = parcelRequire("2OL6m");

var $kzuyT = parcelRequire("kzuyT");

var $4hf1S = parcelRequire("4hf1S");
function $48417b3b5179d706$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $dH1HR.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $kzuyT.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $2OL6m.combine)(unbindEvents, unbindMonitor);
}
function $48417b3b5179d706$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $dH1HR.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $48417b3b5179d706$var$api = (0, $4hf1S.makeFixForAdapter)({
    watchForInteractionStart: $48417b3b5179d706$var$watchForInteractionStart,
    watchForInteractionEnd: $48417b3b5179d706$var$watchForInteractionEnd
});
function $48417b3b5179d706$export$ec28e97c7d8b1b35() {
    return $48417b3b5179d706$var$api.registerUsage();
}

});
parcelRegister("4hf1S", function(module, exports) {
$parcel$export(module.exports, "makeFixForAdapter", function () { return $31d4687a4c1437b7$export$a74bff2507e6126b; });

var $342Py = parcelRequire("342Py");

var $2OL6m = parcelRequire("2OL6m");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $31d4687a4c1437b7$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? '' : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $31d4687a4c1437b7$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $31d4687a4c1437b7$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$31d4687a4c1437b7$var$hasSameOrigin(window.location.href, iframe.src);
}
var $31d4687a4c1437b7$var$registry = new Map();
function $31d4687a4c1437b7$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll('iframe')).filter($31d4687a4c1437b7$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $31d4687a4c1437b7$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $31d4687a4c1437b7$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $31d4687a4c1437b7$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $31d4687a4c1437b7$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $2OL6m.combine).apply(void 0, (0, $342Py.default)(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $31d4687a4c1437b7$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $31d4687a4c1437b7$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("5sVjK", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", function () { return $3fac07540fa7f845$export$27d79116d3a4e7d5; });

var $eDaGe = parcelRequire("eDaGe");

var $4hf1S = parcelRequire("4hf1S");
function $3fac07540fa7f845$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $eDaGe.monitorForExternal)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $3fac07540fa7f845$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $eDaGe.monitorForExternal)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $3fac07540fa7f845$var$api = (0, $4hf1S.makeFixForAdapter)({
    watchForInteractionStart: $3fac07540fa7f845$var$watchForInteractionStart,
    watchForInteractionEnd: $3fac07540fa7f845$var$watchForInteractionEnd
});
function $3fac07540fa7f845$export$27d79116d3a4e7d5() {
    return $3fac07540fa7f845$var$api.registerUsage();
}

});

parcelRegister("lGgGl", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", function () { return $fc8a75e6616877ec$export$9c0606fcefb5d1e2; });

var $dH1HR = parcelRequire("dH1HR");

var $2OL6m = parcelRequire("2OL6m");

var $d58at = parcelRequire("d58at");

var $4hf1S = parcelRequire("4hf1S");
function $fc8a75e6616877ec$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $dH1HR.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $d58at.monitorForTextSelection)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $2OL6m.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $fc8a75e6616877ec$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $dH1HR.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $fc8a75e6616877ec$var$api = (0, $4hf1S.makeFixForAdapter)({
    watchForInteractionStart: $fc8a75e6616877ec$var$watchForInteractionStart,
    watchForInteractionEnd: $fc8a75e6616877ec$var$watchForInteractionEnd
});
function $fc8a75e6616877ec$export$9c0606fcefb5d1e2() {
    return $fc8a75e6616877ec$var$api.registerUsage();
}

});

parcelRegister("4LGGP", function(module, exports) {
$parcel$export(module.exports, "dialogWidth", function () { return $378caa839ed99a3f$export$a3da89b899389ed8; });
$parcel$export(module.exports, "dialogHeight", function () { return $378caa839ed99a3f$export$ceba93bf0bdd16f2; });
var $378caa839ed99a3f$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
var $378caa839ed99a3f$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return 'auto';
    var isWidthName = $378caa839ed99a3f$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat($378caa839ed99a3f$export$7e3df82ee760448c.widths[widthName], "px");
    return typeof input === 'number' ? "".concat(input, "px") : input;
};
var $378caa839ed99a3f$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return 'auto';
    return typeof input === 'number' ? "".concat(input, "px") : input;
};

});

parcelRegister("jE8f1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e4d82546ed82b315$export$2e2bcd8739ae039; });
/* positioner.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $G1AXG = parcelRequire("G1AXG");

var $iqcXV = parcelRequire("iqcXV");

// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $e4d82546ed82b315$var$positionerStyles = null;
var $e4d82546ed82b315$var$stackStyles = {
    stackTransition: "_k8m01e03 _1bumglyw _sedtglyw",
    stackTransform: "_t9ec1b95",
    stackIdle: "_t9ecglyw"
};
// Hardcoded pixels are based off a 60px base gutter
var $e4d82546ed82b315$var$scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1f6n1wqb _1eot1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41nf8 _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
function $e4d82546ed82b315$var$getScrollBehavior(_ref) {
    var isFullScreen = _ref.isFullScreen, shouldScrollInViewport = _ref.shouldScrollInViewport;
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
var $e4d82546ed82b315$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId, isFullScreen = props.isFullScreen;
    var scrollBehavior = $e4d82546ed82b315$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        style: {
            '--modal-dialog-translate-y': "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: "".concat((0, $iqcXV.durations).medium, "ms"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $G1AXG.easeInOut)
        },
        "data-testid": testId && "".concat(testId, "--positioner"),
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            $e4d82546ed82b315$var$stackStyles.stackTransition,
            stackIndex > 0 ? $e4d82546ed82b315$var$stackStyles.stackTransform : $e4d82546ed82b315$var$stackStyles.stackIdle,
            $e4d82546ed82b315$var$scrollStyles[scrollBehavior]
        ])
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e4d82546ed82b315$export$2e2bcd8739ae039 = $e4d82546ed82b315$var$Positioner;

});
parcelRegister("G1AXG", function(module, exports) {
$parcel$export(module.exports, "easeInOut", function () { return $07e5291f7d2130ed$export$c07234257a03d5e9; });
var $07e5291f7d2130ed$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $07e5291f7d2130ed$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $07e5291f7d2130ed$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
var $07e5291f7d2130ed$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
var $07e5291f7d2130ed$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
var $07e5291f7d2130ed$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
var $07e5291f7d2130ed$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

});





parcelRegister("iFeCY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d967670fdd759b1c$export$2e2bcd8739ae039; });
/* modal-body.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $4cgdq = parcelRequire("4cgdq");

var $39c3M = parcelRequire("39c3M");

var $7mfYl = parcelRequire("7mfYl");

var $cvOqE = parcelRequire("cvOqE");

var $aTyoQ = parcelRequire("aTyoQ");
var $d967670fdd759b1c$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug",
    font: "_11c82smr",
    paddingBlock: "_1rjcv77o",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $d967670fdd759b1c$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasInlinePaddi = props.hasInlinePadding, hasInlinePadding = _props$hasInlinePaddi === void 0 ? true : _props$hasInlinePaddi;
    var _useModal = (0, $7mfYl.useModal)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $aTyoQ.default)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        "data-testid": testId,
        className: (0, $2jatx.default)([
            $d967670fdd759b1c$var$styles.root,
            hasInlinePadding && $d967670fdd759b1c$var$styles.paddingInline,
            (0, $39c3M.fg)('platform_ads_explicit_font_styles') && $d967670fdd759b1c$var$styles.font
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $4cgdq.TouchScrollable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cvOqE.default), {
        testId: userDefinedTestId || modalTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        "data-testid": testId,
        className: (0, $2jatx.default)([
            $d967670fdd759b1c$var$styles.root,
            /**
     * Adding block padding for scroll keylines, which are only shown when the scrolling
     * is on the container.
     */ $d967670fdd759b1c$var$styles.paddingBlock,
            hasInlinePadding && $d967670fdd759b1c$var$styles.paddingInline,
            (0, $39c3M.fg)('platform_ads_explicit_font_styles') && $d967670fdd759b1c$var$styles.font
        ])
    }, children)));
};
var $d967670fdd759b1c$export$2e2bcd8739ae039 = $d967670fdd759b1c$var$ModalBody;

});
parcelRegister("7mfYl", function(module, exports) {
$parcel$export(module.exports, "useModal", function () { return $55b6fa40be3cac82$export$33ffd74ebf07f060; });

var $1oC0p = parcelRequire("1oC0p");

var $5qkEW = parcelRequire("5qkEW");
var $55b6fa40be3cac82$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $1oC0p.useContext)((0, $5qkEW.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});

parcelRegister("cvOqE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $91bf7f6bb8a46331$export$2e2bcd8739ae039; });
/* scroll-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $2gb89 = parcelRequire("2gb89");


var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $FcGYz = parcelRequire("FcGYz");

var $p2bNn = parcelRequire("p2bNn");

var $kc3Cl = parcelRequire("kc3Cl");

var $a3pKW = parcelRequire("a3pKW");

var $82NpA = parcelRequire("82NpA");

var $8SsjG = parcelRequire("8SsjG");
var $91bf7f6bb8a46331$var$keylineColor = "var(--ds-border, #091E4224)";
var $91bf7f6bb8a46331$var$styles = {
    base: "_kkes1kw7 _1e0c1kw7 _2lx21kw7 _16jlkb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm2187z",
    bottomKeyline: "_179r187z"
};
var $91bf7f6bb8a46331$var$keylineHeight = 2;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $91bf7f6bb8a46331$var$ScrollContainer = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $1oC0p.useRef)(null);
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2gb89.default)(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(false), _useState4 = (0, $2gb89.default)(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)(false), _useState6 = (0, $2gb89.default)(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $1oC0p.useEffect)(function() {
        var schedule = (0, $FcGYz.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $82NpA.default)((0, $FcGYz.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $91bf7f6bb8a46331$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $91bf7f6bb8a46331$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $1oC0p.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $dH1HR.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $dH1HR.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $a3pKW.default);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8SsjG.default), {
        as: "div",
        isInset: true,
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && "".concat(testId, "--scrollable"),
        ref: (0, $kc3Cl.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $p2bNn.cx)($91bf7f6bb8a46331$var$styles.base, showTopKeyline && $91bf7f6bb8a46331$var$styles.topKeyline, showBottomKeyline && $91bf7f6bb8a46331$var$styles.bottomKeyline)
    }, children);
});
$91bf7f6bb8a46331$var$ScrollContainer.displayName = 'ScrollContainer';
var $91bf7f6bb8a46331$export$2e2bcd8739ae039 = $91bf7f6bb8a46331$var$ScrollContainer;

});
parcelRegister("p2bNn", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $04b408a7244384ff$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("1oC0p");


var $adHov = parcelRequire("adHov");
var $04b408a7244384ff$var$strictApi = (0, $adHov.createStrictAPI)();
var $04b408a7244384ff$export$dbf350e5966cf602 = $04b408a7244384ff$var$strictApi.css;
var $04b408a7244384ff$export$eb1ecd84a24ee424 = $04b408a7244384ff$var$strictApi.cssMap;
$04b408a7244384ff$var$strictApi.cssMap;
var $04b408a7244384ff$export$a274e22fb40f762e = $04b408a7244384ff$var$strictApi.cx;
var $04b408a7244384ff$var$XCSSProp = $04b408a7244384ff$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});

parcelRegister("8SsjG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $676954f2ec060d66$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $efs8s = parcelRequire("efs8s");

var $8ySUD = parcelRequire("8ySUD");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $676954f2ec060d66$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $676954f2ec060d66$var$_excluded2 = [
    "className"
];
var $676954f2ec060d66$var$focusRingStyles = null;
var $676954f2ec060d66$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $676954f2ec060d66$var$Focusable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $8ySUD.default)(_ref, $676954f2ec060d66$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $8ySUD.default)(htmlAttributes, $676954f2ec060d66$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $efs8s.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $2jatx.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $676954f2ec060d66$export$2e2bcd8739ae039 = $676954f2ec060d66$var$Focusable;

});


parcelRegister("aTyoQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7ee9b98631133fdb$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $5qkEW = parcelRequire("5qkEW");
function $7ee9b98631133fdb$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $1oC0p.useContext)((0, $5qkEW.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("lnA0w", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f907ad4c286fb183$export$2e2bcd8739ae039; });
/* modal-footer.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $7mfYl = parcelRequire("7mfYl");
var $f907ad4c286fb183$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $f907ad4c286fb183$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $7mfYl.useModal)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        "data-testid": testId,
        className: (0, $2jatx.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1i6y _85i51ejb _1q51pxbi"
        ])
    }, children);
};
var $f907ad4c286fb183$export$2e2bcd8739ae039 = $f907ad4c286fb183$var$ModalFooter;

});

parcelRegister("bhwjR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $836a5a2cbb0f8086$export$2e2bcd8739ae039; });
/* modal-header.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $3miCA = parcelRequire("3miCA");
var $je75P = parcelRequire("je75P");

var $2t6En = parcelRequire("2t6En");

var $7mfYl = parcelRequire("7mfYl");
var $836a5a2cbb0f8086$var$headerStyles = null;
var $836a5a2cbb0f8086$var$flexStyles = (0, $je75P.xcss)({
    flexDirection: 'row-reverse',
    width: '100%'
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $836a5a2cbb0f8086$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasCloseButton = props.hasCloseButton, hasCloseButton = _props$hasCloseButton === void 0 ? false : _props$hasCloseButton;
    var _useModal = (0, $7mfYl.useModal)(), hasProvidedOnClose = _useModal.hasProvidedOnClose, onClose = _useModal.onClose, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    // Only show if an onClose was provided for the modal dialog
    var shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        "data-testid": testId,
        className: (0, $2jatx.default)([
            "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1i6y _85i5pxbi _1q511ejb"
        ])
    }, shouldShowCloseButton ? /*#__PURE__*/ // The reason we are putting the close button first in the DOM and then
    // reordering them is to ensure that users of assistive technology get
    // all the context of a modal when initial focus is placed on the close
    // button, since it's the first interactive element.
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3miCA.default), {
        gap: "space.200",
        justifyContent: "space-between",
        xcss: $836a5a2cbb0f8086$var$flexStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3miCA.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2t6En.CloseButton), {
        onClick: onClose,
        testId: modalTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3miCA.default), {
        justifyContent: "start",
        alignItems: "center"
    }, children)) : children);
};
var $836a5a2cbb0f8086$export$2e2bcd8739ae039 = $836a5a2cbb0f8086$var$ModalHeader;

});
parcelRegister("3miCA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2721df025d1e7223$export$2e2bcd8739ae039; });

var $342Py = parcelRequire("342Py");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $6uMP1 = parcelRequire("6uMP1");

var $je75P = parcelRequire("je75P");
var $2721df025d1e7223$var$justifyContentMap = {
    start: (0, $3dJ4i.css)({
        justifyContent: 'start'
    }),
    center: (0, $3dJ4i.css)({
        justifyContent: 'center'
    }),
    end: (0, $3dJ4i.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3dJ4i.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3dJ4i.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3dJ4i.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3dJ4i.css)({
        justifyContent: 'stretch'
    })
};
var $2721df025d1e7223$var$flexDirectionMap = {
    column: (0, $3dJ4i.css)({
        flexDirection: 'column'
    }),
    row: (0, $3dJ4i.css)({
        flexDirection: 'row'
    })
};
var $2721df025d1e7223$var$flexWrapMap = {
    wrap: (0, $3dJ4i.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $3dJ4i.css)({
        flexWrap: 'nowrap'
    })
};
var $2721df025d1e7223$var$alignItemsMap = {
    start: (0, $3dJ4i.css)({
        alignItems: 'start'
    }),
    center: (0, $3dJ4i.css)({
        alignItems: 'center'
    }),
    baseline: (0, $3dJ4i.css)({
        alignItems: 'baseline'
    }),
    end: (0, $3dJ4i.css)({
        alignItems: 'end'
    }),
    stretch: (0, $3dJ4i.css)({
        alignItems: 'stretch'
    })
};
var $2721df025d1e7223$var$baseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $2721df025d1e7223$var$Flex = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $je75P.parseXcss)(xcss);
    return (0, $3dJ4i.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $2721df025d1e7223$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $6uMP1.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $6uMP1.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $6uMP1.spaceStylesMap).rowGap[rowGap],
            alignItems && $2721df025d1e7223$var$alignItemsMap[alignItems],
            direction && $2721df025d1e7223$var$flexDirectionMap[direction],
            justifyContent && $2721df025d1e7223$var$justifyContentMap[justifyContent],
            wrap && $2721df025d1e7223$var$flexWrapMap[wrap]
        ].concat((0, $342Py.default)(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$2721df025d1e7223$var$Flex.displayName = 'Flex';
var $2721df025d1e7223$export$2e2bcd8739ae039 = $2721df025d1e7223$var$Flex;

});
parcelRegister("6uMP1", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", function () { return $4bab6a73d4bbae80$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $4bab6a73d4bbae80$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $4bab6a73d4bbae80$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $4bab6a73d4bbae80$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $4bab6a73d4bbae80$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $4bab6a73d4bbae80$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $4bab6a73d4bbae80$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $4bab6a73d4bbae80$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $4bab6a73d4bbae80$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $4bab6a73d4bbae80$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $4bab6a73d4bbae80$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $4bab6a73d4bbae80$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $4bab6a73d4bbae80$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $4bab6a73d4bbae80$export$3c7e9587132614b4; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $4bab6a73d4bbae80$export$bf46c3f9eeafc71f; });

var $9Sn3s = parcelRequire("9Sn3s");

var $3dJ4i = parcelRequire("3dJ4i");

var $kInhq = parcelRequire("kInhq");
function $4bab6a73d4bbae80$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4bab6a73d4bbae80$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4bab6a73d4bbae80$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4bab6a73d4bbae80$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4bab6a73d4bbae80$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $4bab6a73d4bbae80$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $4bab6a73d4bbae80$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $4bab6a73d4bbae80$export$632685d741f3dbbf = $4bab6a73d4bbae80$var$_objectSpread($4bab6a73d4bbae80$var$_objectSpread({}, $4bab6a73d4bbae80$export$958d0ae7f2977ae4), $4bab6a73d4bbae80$export$d2dc61f58390201c);
var $4bab6a73d4bbae80$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $4bab6a73d4bbae80$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $4bab6a73d4bbae80$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $4bab6a73d4bbae80$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $4bab6a73d4bbae80$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $4bab6a73d4bbae80$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $4bab6a73d4bbae80$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $4bab6a73d4bbae80$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $4bab6a73d4bbae80$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $4bab6a73d4bbae80$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $4bab6a73d4bbae80$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $4bab6a73d4bbae80$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $4bab6a73d4bbae80$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $4bab6a73d4bbae80$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $4bab6a73d4bbae80$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $4bab6a73d4bbae80$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $4bab6a73d4bbae80$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $4bab6a73d4bbae80$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $4bab6a73d4bbae80$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3dJ4i.css)((0, $9Sn3s.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $4bab6a73d4bbae80$export$e615f061ca585a6c = $4bab6a73d4bbae80$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $4bab6a73d4bbae80$export$ca0f9c2de39ffed7(spacingProperty, $4bab6a73d4bbae80$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $4bab6a73d4bbae80$export$bf46c3f9eeafc71f = $4bab6a73d4bbae80$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $4bab6a73d4bbae80$export$ca0f9c2de39ffed7(spacingProperty, $4bab6a73d4bbae80$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $4bab6a73d4bbae80$export$e7af83bafe7f9e63 = $4bab6a73d4bbae80$export$ca0f9c2de39ffed7('backgroundColor', $4bab6a73d4bbae80$export$d1d79bf68ac056bd);
var $4bab6a73d4bbae80$export$3a1bcba60b23d7f0 = $4bab6a73d4bbae80$export$ca0f9c2de39ffed7('color', $4bab6a73d4bbae80$export$8473307aa00d6ea1);
var $4bab6a73d4bbae80$export$45f3f4fe16f9f7d5 = $4bab6a73d4bbae80$export$ca0f9c2de39ffed7('fontWeight', $4bab6a73d4bbae80$export$303e322c6b1ed114);
var $4bab6a73d4bbae80$export$68cc305da27dbaa4 = $4bab6a73d4bbae80$export$ca0f9c2de39ffed7('fontFamily', $4bab6a73d4bbae80$export$3c7e9587132614b4);
var $4bab6a73d4bbae80$export$128f10c238242f83 = $4bab6a73d4bbae80$export$ca0f9c2de39ffed7('font', $4bab6a73d4bbae80$export$6ffa317d5e70375);
var $4bab6a73d4bbae80$export$219d364c0da35ae4 = $4bab6a73d4bbae80$export$ca0f9c2de39ffed7('font', $4bab6a73d4bbae80$export$236bfe3a33ef1292);
var $4bab6a73d4bbae80$export$38845ca010b93505 = $4bab6a73d4bbae80$export$ca0f9c2de39ffed7('fontWeight', $4bab6a73d4bbae80$export$855cfd311192d666);
var $4bab6a73d4bbae80$export$ff257d957d48c421 = $4bab6a73d4bbae80$export$ca0f9c2de39ffed7((0, $kInhq.CURRENT_SURFACE_CSS_VAR), $4bab6a73d4bbae80$export$41a358c9c2356760);
var $4bab6a73d4bbae80$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $4bab6a73d4bbae80$export$41a358c9c2356760[color] !== undefined;
};
var $4bab6a73d4bbae80$export$7001ce64d9ff7c7f = $4bab6a73d4bbae80$export$ca0f9c2de39ffed7('font', $4bab6a73d4bbae80$export$b805719bc8cb376);

});
parcelRegister("kInhq", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $f149f9aabe8a1167$export$9d7b58831ae93caa; });
var $f149f9aabe8a1167$export$4ef52930e33717cd = 'data-theme';
var $f149f9aabe8a1167$export$a00eac3f8684bcd0 = 'data-color-mode';
var $f149f9aabe8a1167$export$2112803007239c61 = 'data-contrast-mode';
var $f149f9aabe8a1167$export$352e418ed5b6193a = 'data-custom-theme';
var $f149f9aabe8a1167$export$6f0c6fb8c80fcc92 = 'ds';
var $f149f9aabe8a1167$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $f149f9aabe8a1167$export$dddac1532e822863 = "--".concat($f149f9aabe8a1167$export$6f0c6fb8c80fcc92, "-token-not-found");
var $f149f9aabe8a1167$export$9d7b58831ae93caa = "--".concat($f149f9aabe8a1167$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("je75P", function(module, exports) {
$parcel$export(module.exports, "parseXcss", function () { return $dff4d3a0eebae5f4$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $dff4d3a0eebae5f4$export$f6c783d06584602c; });

var $342Py = parcelRequire("342Py");

var $9Sn3s = parcelRequire("9Sn3s");

var $2gb89 = parcelRequire("2gb89");

var $6DX60 = parcelRequire("6DX60");

var $3dJ4i = parcelRequire("3dJ4i");

var $6uMP1 = parcelRequire("6uMP1");

var $7t0tI = parcelRequire("7t0tI");
function $dff4d3a0eebae5f4$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $dff4d3a0eebae5f4$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $dff4d3a0eebae5f4$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $dff4d3a0eebae5f4$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $dff4d3a0eebae5f4$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $dff4d3a0eebae5f4$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $dff4d3a0eebae5f4$export$9a199fbafee0014e = {
    backgroundColor: (0, $6uMP1.backgroundColorMap),
    blockSize: (0, $6uMP1.dimensionMap),
    borderBlockColor: (0, $6uMP1.borderColorMap),
    borderBlockEndColor: (0, $6uMP1.borderColorMap),
    borderBlockEndWidth: (0, $6uMP1.borderWidthMap),
    borderBlockStartColor: (0, $6uMP1.borderColorMap),
    borderBlockStartWidth: (0, $6uMP1.borderWidthMap),
    borderBlockWidth: (0, $6uMP1.borderWidthMap),
    borderBottomColor: (0, $6uMP1.borderColorMap),
    borderBottomLeftRadius: (0, $6uMP1.borderRadiusMap),
    borderBottomRightRadius: (0, $6uMP1.borderRadiusMap),
    borderBottomWidth: (0, $6uMP1.borderWidthMap),
    borderColor: (0, $6uMP1.borderColorMap),
    borderEndEndRadius: (0, $6uMP1.borderRadiusMap),
    borderEndStartRadius: (0, $6uMP1.borderRadiusMap),
    borderInlineColor: (0, $6uMP1.borderColorMap),
    borderInlineEndColor: (0, $6uMP1.borderColorMap),
    borderInlineEndWidth: (0, $6uMP1.borderWidthMap),
    borderInlineStartColor: (0, $6uMP1.borderColorMap),
    borderInlineStartWidth: (0, $6uMP1.borderWidthMap),
    borderInlineWidth: (0, $6uMP1.borderWidthMap),
    borderLeftColor: (0, $6uMP1.borderColorMap),
    borderLeftWidth: (0, $6uMP1.borderWidthMap),
    borderRadius: (0, $6uMP1.borderRadiusMap),
    borderRightColor: (0, $6uMP1.borderColorMap),
    borderRightWidth: (0, $6uMP1.borderWidthMap),
    borderStartEndRadius: (0, $6uMP1.borderRadiusMap),
    borderStartStartRadius: (0, $6uMP1.borderRadiusMap),
    borderTopColor: (0, $6uMP1.borderColorMap),
    borderTopLeftRadius: (0, $6uMP1.borderRadiusMap),
    borderTopRightRadius: (0, $6uMP1.borderRadiusMap),
    borderTopWidth: (0, $6uMP1.borderWidthMap),
    borderWidth: (0, $6uMP1.borderWidthMap),
    bottom: (0, $6uMP1.allSpaceMap),
    boxShadow: (0, $6uMP1.shadowMap),
    color: (0, $6uMP1.textColorMap),
    columnGap: (0, $6uMP1.positiveSpaceMap),
    font: (0, $6uMP1.fontMap),
    fontFamily: (0, $6uMP1.fontFamilyMap),
    fontWeight: (0, $6uMP1.fontWeightMap),
    gap: (0, $6uMP1.positiveSpaceMap),
    height: (0, $6uMP1.dimensionMap),
    inlineSize: (0, $6uMP1.dimensionMap),
    inset: (0, $6uMP1.allSpaceMap),
    insetBlock: (0, $6uMP1.allSpaceMap),
    insetBlockEnd: (0, $6uMP1.allSpaceMap),
    insetBlockStart: (0, $6uMP1.allSpaceMap),
    insetInline: (0, $6uMP1.allSpaceMap),
    insetInlineEnd: (0, $6uMP1.allSpaceMap),
    insetInlineStart: (0, $6uMP1.allSpaceMap),
    left: (0, $6uMP1.allSpaceMap),
    margin: (0, $6uMP1.allSpaceMap),
    marginBlock: (0, $6uMP1.allSpaceMap),
    marginBlockEnd: (0, $6uMP1.allSpaceMap),
    marginBlockStart: (0, $6uMP1.allSpaceMap),
    marginBottom: (0, $6uMP1.allSpaceMap),
    marginInline: (0, $6uMP1.allSpaceMap),
    marginInlineEnd: (0, $6uMP1.allSpaceMap),
    marginInlineStart: (0, $6uMP1.allSpaceMap),
    marginLeft: (0, $6uMP1.allSpaceMap),
    marginRight: (0, $6uMP1.allSpaceMap),
    marginTop: (0, $6uMP1.allSpaceMap),
    maxBlockSize: (0, $6uMP1.dimensionMap),
    maxHeight: (0, $6uMP1.dimensionMap),
    maxInlineSize: (0, $6uMP1.dimensionMap),
    maxWidth: (0, $6uMP1.dimensionMap),
    minBlockSize: (0, $6uMP1.dimensionMap),
    minHeight: (0, $6uMP1.dimensionMap),
    minInlineSize: (0, $6uMP1.dimensionMap),
    minWidth: (0, $6uMP1.dimensionMap),
    opacity: (0, $6uMP1.opacityMap),
    outlineColor: (0, $6uMP1.borderColorMap),
    outlineOffset: (0, $6uMP1.allSpaceMap),
    outlineWidth: (0, $6uMP1.borderWidthMap),
    padding: (0, $6uMP1.positiveSpaceMap),
    paddingBlock: (0, $6uMP1.positiveSpaceMap),
    paddingBlockEnd: (0, $6uMP1.positiveSpaceMap),
    paddingBlockStart: (0, $6uMP1.positiveSpaceMap),
    paddingBottom: (0, $6uMP1.positiveSpaceMap),
    paddingInline: (0, $6uMP1.positiveSpaceMap),
    paddingInlineEnd: (0, $6uMP1.positiveSpaceMap),
    paddingInlineStart: (0, $6uMP1.positiveSpaceMap),
    paddingLeft: (0, $6uMP1.positiveSpaceMap),
    paddingRight: (0, $6uMP1.positiveSpaceMap),
    paddingTop: (0, $6uMP1.positiveSpaceMap),
    right: (0, $6uMP1.allSpaceMap),
    rowGap: (0, $6uMP1.positiveSpaceMap),
    top: (0, $6uMP1.allSpaceMap),
    width: (0, $6uMP1.dimensionMap),
    zIndex: (0, $6uMP1.layerMap)
};
var $dff4d3a0eebae5f4$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $dff4d3a0eebae5f4$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $7t0tI === "undefined" ? "undefined" : (0, $6DX60.default)($7t0tI)) === 'object' && (0, $6DX60.default)($7t0tI.env) === 'object' && false;
};
var $dff4d3a0eebae5f4$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $dff4d3a0eebae5f4$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $dff4d3a0eebae5f4$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $6DX60.default)(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($dff4d3a0eebae5f4$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $2gb89.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $6DX60.default)(value) === 'object' && $dff4d3a0eebae5f4$var$safeSelectors.test(key)) {
            styleObj[key] = $dff4d3a0eebae5f4$var$_transformStyles(value);
            return;
        }
        if ($dff4d3a0eebae5f4$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($dff4d3a0eebae5f4$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $dff4d3a0eebae5f4$export$9a199fbafee0014e)) return;
        var tokenValue = $dff4d3a0eebae5f4$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $dff4d3a0eebae5f4$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $dff4d3a0eebae5f4$var$_transformStyles(style);
    return (0, $9Sn3s.default)({}, $dff4d3a0eebae5f4$var$uniqueSymbol, (0, $3dJ4i.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $dff4d3a0eebae5f4$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $dff4d3a0eebae5f4$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $dff4d3a0eebae5f4$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $342Py.default)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$dff4d3a0eebae5f4$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $dff4d3a0eebae5f4$export$f6c783d06584602c(style) {
    return $dff4d3a0eebae5f4$var$baseXcss(style);
}

});


parcelRegister("2t6En", function(module, exports) {
$parcel$export(module.exports, "CloseButton", function () { return $1cc372ccdc8592d9$export$de65de8213222d10; });

var $1oC0p = parcelRequire("1oC0p");

var $bvLOe = parcelRequire("bvLOe");

var $1zkOL = parcelRequire("1zkOL");
var $1cc372ccdc8592d9$export$de65de8213222d10 = function CloseButton(_ref) {
    var label = _ref.label, onBlur = _ref.onBlur, onClick = _ref.onClick, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bvLOe.default), {
        testId: testId && "".concat(testId, "--close-button"),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1zkOL))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });
};

});
parcelRegister("bvLOe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8617acd8a68bec90$export$2e2bcd8739ae039; });

var $efs8s = parcelRequire("efs8s");

var $8ySUD = parcelRequire("8ySUD");

var $1oC0p = parcelRequire("1oC0p");

var $9g7Q1 = parcelRequire("9g7Q1");

var $l0ud4 = parcelRequire("l0ud4");

var $8vIkL = parcelRequire("8vIkL");

var $2QFG1 = parcelRequire("2QFG1");

var $c99Cq = parcelRequire("c99Cq");

var $9RfjD = parcelRequire("9RfjD");
var $8617acd8a68bec90$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $8617acd8a68bec90$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $8617acd8a68bec90$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, $8ySUD.default)(_ref, $8617acd8a68bec90$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $8ySUD.default)(unsafeRest, $8617acd8a68bec90$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2QFG1.default), (0, $efs8s.default)({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $c99Cq.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9RfjD.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8vIkL.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $l0ud4.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2QFG1.default), (0, $efs8s.default)({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $9g7Q1.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $c99Cq.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9RfjD.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8vIkL.default), null, label)));
    });
}));
$8617acd8a68bec90$var$IconButton.displayName = 'IconButton';
var $8617acd8a68bec90$export$2e2bcd8739ae039 = $8617acd8a68bec90$var$IconButton;

});
parcelRegister("9g7Q1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6bdbb027687e020c$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $6bdbb027687e020c$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("l0ud4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f4b10818d9224f4c$export$2e2bcd8739ae039; });

var $efs8s = parcelRequire("efs8s");

var $2gb89 = parcelRequire("2gb89");

var $9Sn3s = parcelRequire("9Sn3s");

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $fIOLe = parcelRequire("fIOLe");

var $abA24 = parcelRequire("abA24");

var $7j2J8 = parcelRequire("7j2J8");

var $kqRvy = parcelRequire("kqRvy");

var $6P6Jp = parcelRequire("6P6Jp");

var $fQ1Y9 = parcelRequire("fQ1Y9");
var $3inBk = parcelRequire("3inBk");

var $39c3M = parcelRequire("39c3M");

var $jer1f = parcelRequire("jer1f");

var $52Fo7 = parcelRequire("52Fo7");

var $3a38i = parcelRequire("3a38i");

var $bZXCc = parcelRequire("bZXCc");

var $kRV3w = parcelRequire("kRV3w");

var $7CUK1 = parcelRequire("7CUK1");

var $2Tncz = parcelRequire("2Tncz");

var $8B9DE = parcelRequire("8B9DE");
function $f4b10818d9224f4c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f4b10818d9224f4c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f4b10818d9224f4c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f4b10818d9224f4c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f4b10818d9224f4c$var$tooltipZIndex = (0, $3a38i.layers).tooltip();
var $f4b10818d9224f4c$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "0.0.0-development"
};
// Inverts motion direction
var $f4b10818d9224f4c$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $f4b10818d9224f4c$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $f4b10818d9224f4c$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $2Tncz.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $abA24.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $abA24.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $fIOLe.usePlatformLeafSyntheticEventHandler)($f4b10818d9224f4c$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $f4b10818d9224f4c$var$analyticsAttributes));
    var onHideHandler = (0, $fIOLe.usePlatformLeafSyntheticEventHandler)($f4b10818d9224f4c$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $f4b10818d9224f4c$var$analyticsAttributes));
    var apiRef = (0, $1oC0p.useRef)(null);
    var _useState = (0, $1oC0p.useState)('hide'), _useState2 = (0, $2gb89.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $1oC0p.useRef)(null);
    var containerRef = (0, $1oC0p.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $1oC0p.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $kqRvy.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $kqRvy.default)(onShowHandler);
    var onHideHandlerStable = (0, $kqRvy.default)(onHideHandler);
    var delayStable = (0, $kqRvy.default)(delay);
    var canAppearStable = (0, $kqRvy.default)(canAppear);
    var hasCalledShowHandler = (0, $1oC0p.useRef)(false);
    var start = (0, $1oC0p.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $1oC0p.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $1oC0p.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(function() {
        return (0, $bZXCc.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $1oC0p.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $kRV3w.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $7j2J8.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $1oC0p.useEffect)(function() {
        if (state === 'hide') return 0, $abA24.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $dH1HR.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $1oC0p.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $1oC0p.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $8B9DE.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $1oC0p.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $8B9DE.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $1oC0p.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $1oC0p.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible') && (0, $39c3M.fg)('platform-tooltip-focus-visible-new')) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $1oC0p.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $1oC0p.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $1oC0p.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $6P6Jp.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5;
        if (position === 'mouse' && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePosition) {
            var _apiRef$current6;
            return (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 ? void 0 : _apiRef$current6.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $7CUK1.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $1oC0p.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children($f4b10818d9224f4c$var$_objectSpread($f4b10818d9224f4c$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(CastTargetContainer, (0, $efs8s.default)({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $52Fo7.default), {
        zIndex: $f4b10818d9224f4c$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jer1f.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $f4b10818d9224f4c$var$invertedDirection[$f4b10818d9224f4c$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fQ1Y9.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3inBk.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $f4b10818d9224f4c$var$_objectSpread($f4b10818d9224f4c$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $f4b10818d9224f4c$export$2e2bcd8739ae039 = $f4b10818d9224f4c$var$Tooltip;

});
parcelRegister("fIOLe", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $b722571969bbeaba$export$1a04351537078b55; });

var $9Sn3s = parcelRequire("9Sn3s");

var $1oC0p = parcelRequire("1oC0p");

var $d70M0 = parcelRequire("d70M0");

var $6f3AQ = parcelRequire("6f3AQ");
function $b722571969bbeaba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b722571969bbeaba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b722571969bbeaba$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b722571969bbeaba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b722571969bbeaba$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $d70M0.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $6f3AQ.useTrackedRef)(analyticsData);
    var fnRef = (0, $6f3AQ.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $b722571969bbeaba$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("abA24", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $76a6e1ba9a07428b$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $76a6e1ba9a07428b$export$2e2bcd8739ae039() {}

});

parcelRegister("7j2J8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $551c6c43f4c591bf$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $39c3M = parcelRequire("39c3M");

var $isoOM = parcelRequire("isoOM");
function $551c6c43f4c591bf$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $1oC0p.useRef)(false);
    var onKeyDown = (0, $1oC0p.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $isoOM.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $1oC0p.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $1oC0p.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled && (0, $39c3M.fg)('platform_only_attach_escape_handler_on_view')) return;
        return (0, $dH1HR.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("isoOM", function(module, exports) {
$parcel$export(module.exports, "ESCAPE", function () { return $d6fe17e09ab67aad$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $d6fe17e09ab67aad$export$390330c10ff2b9a1 = 'ArrowUp';
var $d6fe17e09ab67aad$export$a80636c6f41931fe = 'ArrowDown';
var $d6fe17e09ab67aad$export$4af703091671bc = 'Home';
var $d6fe17e09ab67aad$export$e2bc30913faa5db7 = 'End';
var $d6fe17e09ab67aad$export$10f6869ed0a7d75b = 'Tab';
var $d6fe17e09ab67aad$export$8152f929a25a0ff4 = 'Enter';
var $d6fe17e09ab67aad$export$e51a3576c045c8d5 = 'Space';
var $d6fe17e09ab67aad$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("kqRvy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $edffbde5dae67367$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $edffbde5dae67367$export$2e2bcd8739ae039(value) {
    var ref = (0, $1oC0p.useRef)(value);
    (0, $1oC0p.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("bZXCc", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $8bc3a288bfdfc867$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $dH1HR = parcelRequire("dH1HR");
var $8bc3a288bfdfc867$var$registrations = new Set();
var $8bc3a288bfdfc867$var$cleanupEndEventListeners = null;
function $8bc3a288bfdfc867$var$onDragStart() {
    if ($8bc3a288bfdfc867$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $8bc3a288bfdfc867$var$cleanupEndEventListeners = (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragend',
            listener: $8bc3a288bfdfc867$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $8bc3a288bfdfc867$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $8bc3a288bfdfc867$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($8bc3a288bfdfc867$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $8bc3a288bfdfc867$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $8bc3a288bfdfc867$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $8bc3a288bfdfc867$var$cleanupEndEventListeners = null;
    var clone = Array.from($8bc3a288bfdfc867$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $8bc3a288bfdfc867$var$bindStartEvents() {
    return (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $8bc3a288bfdfc867$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $8bc3a288bfdfc867$var$onDragStart
        }
    ]);
}
var $8bc3a288bfdfc867$var$cleanupStartEventListeners = null;
function $8bc3a288bfdfc867$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$8bc3a288bfdfc867$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $8bc3a288bfdfc867$var$cleanupStartEventListeners = $8bc3a288bfdfc867$var$bindStartEvents();
    $8bc3a288bfdfc867$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $8bc3a288bfdfc867$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $8bc3a288bfdfc867$var$registrations.delete(registration);
        if ($8bc3a288bfdfc867$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $8bc3a288bfdfc867$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $8bc3a288bfdfc867$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("kRV3w", function(module, exports) {
$parcel$export(module.exports, "show", function () { return $f31503fbccf4fe3a$export$57bf213be019eeb0; });

var $8Se3P = parcelRequire("8Se3P");
// This file is a singleton for managing tooltips
var $f31503fbccf4fe3a$var$active = null;
function $f31503fbccf4fe3a$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($f31503fbccf4fe3a$var$active && $f31503fbccf4fe3a$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $8Se3P.clearScheduled)();
            $f31503fbccf4fe3a$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $8Se3P.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $8Se3P.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $8Se3P.scheduleTimeout)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($f31503fbccf4fe3a$var$active && $f31503fbccf4fe3a$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($f31503fbccf4fe3a$var$active) {
            (0, $8Se3P.clearScheduled)();
            $f31503fbccf4fe3a$var$active.entry.hide({
                isImmediate: true
            });
            $f31503fbccf4fe3a$var$active.entry.done();
            $f31503fbccf4fe3a$var$active = null;
        }
        // this tooltip is now the active tooltip
        $f31503fbccf4fe3a$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $8Se3P.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("8Se3P", function(module, exports) {
$parcel$export(module.exports, "clearScheduled", function () { return $675e460e8ff456c0$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $675e460e8ff456c0$export$5f4d6617421d489b; });
var $675e460e8ff456c0$var$delayId = null;
function $675e460e8ff456c0$export$eaf678f6f93f5250() {
    if ($675e460e8ff456c0$var$delayId != null) {
        window.clearTimeout($675e460e8ff456c0$var$delayId);
        $675e460e8ff456c0$var$delayId = null;
    }
}
function $675e460e8ff456c0$export$5f4d6617421d489b(fn, delay) {
    $675e460e8ff456c0$export$eaf678f6f93f5250();
    $675e460e8ff456c0$var$delayId = window.setTimeout(function() {
        $675e460e8ff456c0$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("7CUK1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $58d818a0ce2c00f8$export$2e2bcd8739ae039; });

var $e63ql = parcelRequire("e63ql");
function $58d818a0ce2c00f8$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $e63ql.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("e63ql", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", function () { return $a434482b309dc220$export$6ee17796e3d70de2; });

var $6DX60 = parcelRequire("6DX60");

var $1oC0p = parcelRequire("1oC0p");

var $6JmtO = parcelRequire("6JmtO");

var $39c3M = parcelRequire("39c3M");
var $a434482b309dc220$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $a434482b309dc220$var$react18UseId = ($a434482b309dc220$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId) !== null && $a434482b309dc220$var$_React$useId !== void 0 ? $a434482b309dc220$var$_React$useId : undefined;
function $a434482b309dc220$export$f680877a34711e37() {
    if ($a434482b309dc220$var$react18UseId && (0, $39c3M.fg)('platform-dst-react-18-use-id')) {
        if ((0, $39c3M.fg)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $a434482b309dc220$var$react18UseId().replace(/[:«»]/g, '_');
        return $a434482b309dc220$var$react18UseId();
    }
    return "uid".concat((0, $6JmtO.useUID)());
}
var $a434482b309dc220$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($a434482b309dc220$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $6DX60.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $6DX60.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $a434482b309dc220$export$6ee17796e3d70de2() {
    if ($a434482b309dc220$var$react18UseId && (0, $39c3M.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        var uid = $a434482b309dc220$export$f680877a34711e37();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $6JmtO.useUIDSeed)();
}

});


parcelRegister("2Tncz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $21b2b734a0ba3935$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $9SSta = parcelRequire("9SSta");

var $39c3M = parcelRequire("39c3M");

var $2nCMM = parcelRequire("2nCMM");
var $21b2b734a0ba3935$var$styles = {
    base: "_2rkofajl _11c8dcr7 _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
    baseRefreshedPadding: "_1q511b66 _85i51b66",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $21b2b734a0ba3935$var$TooltipContainer = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $1oC0p.createElement((0, $2nCMM.default), {
        ref: ref,
        style: style,
        className: (0, $9SSta.default)([
            $21b2b734a0ba3935$var$styles.base,
            (0, $39c3M.fg)('platform-dst-tooltip-shortcuts') && $21b2b734a0ba3935$var$styles.baseRefreshedPadding,
            truncate && $21b2b734a0ba3935$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$21b2b734a0ba3935$var$TooltipContainer.displayName = 'TooltipContainer';
var $21b2b734a0ba3935$export$2e2bcd8739ae039 = $21b2b734a0ba3935$var$TooltipContainer;

});
parcelRegister("9SSta", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $732368ac69b9d658$export$2e2bcd8739ae039; });
const $732368ac69b9d658$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $732368ac69b9d658$var$ATOMIC_GROUP_LENGTH = 5;
function $732368ac69b9d658$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $732368ac69b9d658$var$UNDERSCORE_UNICODE ? $732368ac69b9d658$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("2nCMM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1bbbd0cbc1cdd61c$export$2e2bcd8739ae039; });
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $9SSta = parcelRequire("9SSta");

var $39c3M = parcelRequire("39c3M");

var $5VoJv = parcelRequire("5VoJv");
var $1bbbd0cbc1cdd61c$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $1bbbd0cbc1cdd61c$var$TooltipPrimitive = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        role: "tooltip",
        className: (0, $9SSta.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && (0, $39c3M.fg)('platform-dst-tooltip-shortcuts') && /*#__PURE__*/ $1oC0p.createElement((0, $5VoJv.TooltipShortcut), {
        shortcut: shortcut
    })));
});
$1bbbd0cbc1cdd61c$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $1bbbd0cbc1cdd61c$export$2e2bcd8739ae039 = $1bbbd0cbc1cdd61c$var$TooltipPrimitive;

});
parcelRegister("5VoJv", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", function () { return $450576126dde7de6$export$5bcbc43c84236222; });
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $9SSta = parcelRequire("9SSta");
var $450576126dde7de6$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c81u0j _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d7jlr _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7"
};
var $450576126dde7de6$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $9SSta.default)([
            $450576126dde7de6$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $1oC0p.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $9SSta.default)([
                $450576126dde7de6$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};

});



parcelRegister("8B9DE", function(module, exports) {
$parcel$export(module.exports, "getMousePosition", function () { return $6429416b6ffc4055$export$642213d516a9b928; });
function $6429416b6ffc4055$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("2QFG1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2130c43bf9de4df7$export$2e2bcd8739ae039; });
/* button-base.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $efs8s = parcelRequire("efs8s");

var $8ySUD = parcelRequire("8ySUD");

var $lL9sL = parcelRequire("lL9sL");

var $1oC0p = parcelRequire("1oC0p");

var $dZUAU = parcelRequire("dZUAU");

var $9g7Q1 = parcelRequire("9g7Q1");

var $gSqBs = parcelRequire("gSqBs");

var $2wbOh = parcelRequire("2wbOh");

var $39c3M = parcelRequire("39c3M");

var $iNdX6 = parcelRequire("iNdX6");

var $8vIkL = parcelRequire("8vIkL");

var $jX5B8 = parcelRequire("jX5B8");

var $f8S33 = parcelRequire("f8S33");

var $7J7hh = parcelRequire("7J7hh");
var $2130c43bf9de4df7$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $2130c43bf9de4df7$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $2130c43bf9de4df7$var$LOADING_LABEL = ', Loading';
var $2130c43bf9de4df7$var$styles = {
    base: "_2rkofajl _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1lh4 _30l31lh4 _9h8h1lh4",
    sharedDisabled: "_bfhk1fvb _irr31fvb _1di61fvb",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $2130c43bf9de4df7$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq",
    disabledRefreshed: "_bfhk1j28 _8l3m13gt _irr31j28 _1di61j28"
};
var $2130c43bf9de4df7$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $2130c43bf9de4df7$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $2130c43bf9de4df7$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $2130c43bf9de4df7$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $2130c43bf9de4df7$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq",
    disabledRefreshed: "_bfhk1j28 _8l3m13gt _irr31j28 _1di61j28"
};
var $2130c43bf9de4df7$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $2130c43bf9de4df7$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, $8ySUD.default)(_ref, $2130c43bf9de4df7$var$_excluded);
    var localRef = (0, $1oC0p.useRef)(null);
    var splitButtonContext = (0, $jX5B8.useSplitButtonContext)();
    var loadingLabelId = (0, $2wbOh.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton && (0, $39c3M.fg)('platform-component-visual-refresh') ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $gSqBs.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $8ySUD.default)(unsafeRest, $2130c43bf9de4df7$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $iNdX6.default), (0, $efs8s.default)({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $9g7Q1.default)([
            localRef,
            ref
        ]),
        xcss: (0, $dZUAU.cx)($2130c43bf9de4df7$var$styles.base, appearance === 'default' && ((0, $39c3M.fg)('platform-component-visual-refresh') ? $2130c43bf9de4df7$var$defaultStyles.rootRefreshed : $2130c43bf9de4df7$var$defaultStyles.root), appearance === 'default' && isInteractive && ((0, $39c3M.fg)('platform-component-visual-refresh') ? $2130c43bf9de4df7$var$defaultStyles.interactiveRefreshed : $2130c43bf9de4df7$var$defaultStyles.interactive), appearance === 'primary' && $2130c43bf9de4df7$var$primaryStyles.root, appearance === 'primary' && isInteractive && $2130c43bf9de4df7$var$primaryStyles.interactive, appearance === 'warning' && $2130c43bf9de4df7$var$warningStyles.root, appearance === 'warning' && isInteractive && $2130c43bf9de4df7$var$warningStyles.interactive, appearance === 'danger' && $2130c43bf9de4df7$var$dangerStyles.root, appearance === 'danger' && isInteractive && $2130c43bf9de4df7$var$dangerStyles.interactive, appearance === 'discovery' && $2130c43bf9de4df7$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $2130c43bf9de4df7$var$discoveryStyles.interactive, appearance === 'subtle' && ((0, $39c3M.fg)('platform-component-visual-refresh') ? $2130c43bf9de4df7$var$subtleStyles.rootRefreshed : $2130c43bf9de4df7$var$subtleStyles.root), appearance === 'subtle' && isInteractive && ((0, $39c3M.fg)('platform-component-visual-refresh') ? $2130c43bf9de4df7$var$subtleStyles.interactiveRefreshed : $2130c43bf9de4df7$var$subtleStyles.interactive), $2130c43bf9de4df7$var$styles.linkDecorationUnset, isSelected && ((0, $39c3M.fg)('platform-component-visual-refresh') ? $2130c43bf9de4df7$var$selectedStyles.rootRefreshed : $2130c43bf9de4df7$var$selectedStyles.root), isSelected && isSplitButton && $2130c43bf9de4df7$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $2130c43bf9de4df7$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $2130c43bf9de4df7$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $2130c43bf9de4df7$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $2130c43bf9de4df7$var$selectedStyles.discovery, isDisabled && $2130c43bf9de4df7$var$styles.disabled, isDisabled && (!(0, $39c3M.fg)('platform-component-visual-refresh') || appearance !== 'default' && appearance !== 'subtle') && $2130c43bf9de4df7$var$styles.sharedDisabled, isDisabled && appearance === 'default' && ((0, $39c3M.fg)('platform-component-visual-refresh') ? $2130c43bf9de4df7$var$defaultStyles.disabledRefreshed : $2130c43bf9de4df7$var$defaultStyles.disabled), isCircle && !isSplitButton && $2130c43bf9de4df7$var$styles.circle, spacing === 'compact' && $2130c43bf9de4df7$var$styles.spacingCompact, hasIconBefore && $2130c43bf9de4df7$var$styles.buttonIconBefore, shouldFitContainer && $2130c43bf9de4df7$var$styles.fullWidth, hasIconAfter && $2130c43bf9de4df7$var$styles.buttonIconAfter, isIconButton && $2130c43bf9de4df7$var$styles.iconButton, isIconButton && spacing === 'compact' && $2130c43bf9de4df7$var$styles.iconButtonCompact, isLoading && $2130c43bf9de4df7$var$styles.loading, isSplitButton && $2130c43bf9de4df7$var$styles.splitButton, isNavigationSplitButton && $2130c43bf9de4df7$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($2130c43bf9de4df7$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $f8S33.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jX5B8.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        className: (0, $lL9sL.default)([
            $2130c43bf9de4df7$var$styles.loadingOverlay
        ])
    }, (0, $7J7hh.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8vIkL.default), {
        id: loadingLabelId
    }, $2130c43bf9de4df7$var$LOADING_LABEL)));
});
var $2130c43bf9de4df7$export$2e2bcd8739ae039 = $2130c43bf9de4df7$var$ButtonBase;

});
parcelRegister("lL9sL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fd7553e77afd4668$export$2e2bcd8739ae039; });
const $fd7553e77afd4668$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $fd7553e77afd4668$var$ATOMIC_GROUP_LENGTH = 5;
function $fd7553e77afd4668$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $fd7553e77afd4668$var$UNDERSCORE_UNICODE ? $fd7553e77afd4668$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("dZUAU", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $a30cdf50f823084b$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("1oC0p");


var $lUKgi = parcelRequire("lUKgi");
var $a30cdf50f823084b$var$_createStrictAPI = (0, $lUKgi.createStrictAPI)(), $a30cdf50f823084b$var$XCSSProp = $a30cdf50f823084b$var$_createStrictAPI.XCSSProp, $a30cdf50f823084b$export$dbf350e5966cf602 = $a30cdf50f823084b$var$_createStrictAPI.css, $a30cdf50f823084b$export$eb1ecd84a24ee424 = $a30cdf50f823084b$var$_createStrictAPI.cssMap, $a30cdf50f823084b$export$a274e22fb40f762e = $a30cdf50f823084b$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("lUKgi", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", function () { return $ff42b6926ac13fb0$export$39716b4af53f4ad; });

var $99Gc3 = parcelRequire("99Gc3");

var $enecN = parcelRequire("enecN");
function $ff42b6926ac13fb0$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $99Gc3.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $99Gc3.createStrictSetupError)();
        },
        cx: $enecN.cx,
        XCSSProp () {
            throw (0, $99Gc3.createStrictSetupError)();
        }
    };
}

});
parcelRegister("99Gc3", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", function () { return $6aa5af0a089caa09$export$c4df1cb0c2b4d77c; });
const $6aa5af0a089caa09$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $6aa5af0a089caa09$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("enecN", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $a76e3b8c6c3e8fb8$export$a274e22fb40f762e; });

var $lL9sL = parcelRequire("lL9sL");
const $a76e3b8c6c3e8fb8$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $lL9sL.default)(actualStyles);
};

});



parcelRegister("2wbOh", function(module, exports) {
$parcel$export(module.exports, "useId", function () { return $1d57bb2766149f29$export$f680877a34711e37; });

var $6DX60 = parcelRequire("6DX60");

var $1oC0p = parcelRequire("1oC0p");

var $6JmtO = parcelRequire("6JmtO");

var $39c3M = parcelRequire("39c3M");
var $1d57bb2766149f29$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $1d57bb2766149f29$var$react18UseId = ($1d57bb2766149f29$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId) !== null && $1d57bb2766149f29$var$_React$useId !== void 0 ? $1d57bb2766149f29$var$_React$useId : undefined;
function $1d57bb2766149f29$export$f680877a34711e37() {
    if ($1d57bb2766149f29$var$react18UseId && (0, $39c3M.fg)('platform-dst-react-18-use-id')) {
        if ((0, $39c3M.fg)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $1d57bb2766149f29$var$react18UseId().replace(/[:«»]/g, '_');
        return $1d57bb2766149f29$var$react18UseId();
    }
    return "uid".concat((0, $6JmtO.useUID)());
}
var $1d57bb2766149f29$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($1d57bb2766149f29$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $6DX60.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $6DX60.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $1d57bb2766149f29$export$6ee17796e3d70de2() {
    if ($1d57bb2766149f29$var$react18UseId && (0, $39c3M.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        var uid = $1d57bb2766149f29$export$f680877a34711e37();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $6JmtO.useUIDSeed)();
}

});

parcelRegister("iNdX6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dae7a03d0f6db2e1$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $efs8s = parcelRequire("efs8s");

var $8ySUD = parcelRequire("8ySUD");

var $1oC0p = parcelRequire("1oC0p");


var $j1Rld = parcelRequire("j1Rld");

var $iiIHF = parcelRequire("iiIHF");

var $1yyv6 = parcelRequire("1yyv6");

var $8yRFv = parcelRequire("8yRFv");

var $bu7Lb = parcelRequire("bu7Lb");

var $Rxu3i = parcelRequire("Rxu3i");
var $dae7a03d0f6db2e1$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $dae7a03d0f6db2e1$var$_excluded2 = [
    "className"
];
var $dae7a03d0f6db2e1$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $dae7a03d0f6db2e1$var$Pressable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $8yRFv.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $8ySUD.default)(_ref, $dae7a03d0f6db2e1$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $bu7Lb.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $iiIHF.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "14.15.4",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $8ySUD.default)(htmlAttributes, $dae7a03d0f6db2e1$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement((0, $Rxu3i.default), (0, $efs8s.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $1yyv6.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $j1Rld.cx)($dae7a03d0f6db2e1$var$styles.root, isDisabled && $dae7a03d0f6db2e1$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $dae7a03d0f6db2e1$export$2e2bcd8739ae039 = $dae7a03d0f6db2e1$var$Pressable;

});
parcelRegister("j1Rld", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $dda77cc547dbe2cd$export$a274e22fb40f762e; });

var $9Tm05 = parcelRequire("9Tm05");
const $dda77cc547dbe2cd$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $9Tm05.default)(actualStyles);
};

});
parcelRegister("9Tm05", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $733a50ebd383f08d$export$2e2bcd8739ae039; });
const $733a50ebd383f08d$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $733a50ebd383f08d$var$ATOMIC_GROUP_LENGTH = 5;
function $733a50ebd383f08d$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $733a50ebd383f08d$var$UNDERSCORE_UNICODE ? $733a50ebd383f08d$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});


parcelRegister("1yyv6", function(module, exports) {
$parcel$export(module.exports, "isSafari", function () { return $1223ba82d2b0dc32$export$95df08bae54cb4df; });
function $1223ba82d2b0dc32$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $1223ba82d2b0dc32$var$isIPhone() {
    return $1223ba82d2b0dc32$var$testPlatform(/^iPhone/i);
}
function $1223ba82d2b0dc32$var$isMac() {
    return $1223ba82d2b0dc32$var$testPlatform(/^Mac/i);
}
function $1223ba82d2b0dc32$var$isIPad() {
    return $1223ba82d2b0dc32$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $1223ba82d2b0dc32$var$isMac() && navigator.maxTouchPoints > 1;
}
function $1223ba82d2b0dc32$var$isIOS() {
    return $1223ba82d2b0dc32$var$isIPhone() || $1223ba82d2b0dc32$var$isIPad();
}
function $1223ba82d2b0dc32$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $1223ba82d2b0dc32$export$e1865c3bedcd822b() {
    return $1223ba82d2b0dc32$var$isMac() || $1223ba82d2b0dc32$var$isIOS();
}

});

parcelRegister("8yRFv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $63bb211e2524324d$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $63bb211e2524324d$export$2e2bcd8739ae039() {}

});

parcelRegister("bu7Lb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $85c88407c8e4b203$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $85c88407c8e4b203$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("Rxu3i", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0a0eec8518a35279$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $efs8s = parcelRequire("efs8s");

var $8ySUD = parcelRequire("8ySUD");

var $1oC0p = parcelRequire("1oC0p");

var $9Tm05 = parcelRequire("9Tm05");

var $39c3M = parcelRequire("39c3M");
var $0a0eec8518a35279$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $0a0eec8518a35279$var$_excluded2 = [
    "className"
];
var $0a0eec8518a35279$var$focusRingStyles = null;
var $0a0eec8518a35279$var$insetFocusRingStyles = null;
// This is added to override and reset global styles that apps might be applying - for example,
// at the time of writing, Jira has global styles that targets all button and anchor elements,
// adding an outline on :focus.
var $0a0eec8518a35279$var$outlineResetStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $0a0eec8518a35279$var$Focusable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $8ySUD.default)(_ref, $0a0eec8518a35279$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $8ySUD.default)(htmlAttributes, $0a0eec8518a35279$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $efs8s.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $9Tm05.default)([
            "_mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            (0, $39c3M.fg)('platform_dst_compiled_primitives_outline_reset') && "_ymio1r31 _ypr0glyw _zcxs1o36",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $0a0eec8518a35279$export$2e2bcd8739ae039 = $0a0eec8518a35279$var$Focusable;

});


parcelRegister("jX5B8", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", function () { return $e867dea087f34e04$export$4b86304b2c0d7e71; });
$parcel$export(module.exports, "useSplitButtonContext", function () { return $e867dea087f34e04$export$47e2c6fdb142d947; });

var $1oC0p = parcelRequire("1oC0p");
var $e867dea087f34e04$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
var $e867dea087f34e04$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $1oC0p.useContext)($e867dea087f34e04$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("f8S33", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b061873c873bcfc2$export$2e2bcd8739ae039; });
function $b061873c873bcfc2$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $b061873c873bcfc2$var$tabKeyCode = 9;
function $b061873c873bcfc2$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $b061873c873bcfc2$var$tabKeyCode) return;
    $b061873c873bcfc2$var$abort(event);
}
function $b061873c873bcfc2$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $b061873c873bcfc2$var$abort,
        onMouseUpCapture: $b061873c873bcfc2$var$abort,
        onKeyDownCapture: $b061873c873bcfc2$var$onKey,
        onKeyUpCapture: $b061873c873bcfc2$var$onKey,
        onTouchStartCapture: $b061873c873bcfc2$var$abort,
        onTouchEndCapture: $b061873c873bcfc2$var$abort,
        onPointerDownCapture: $b061873c873bcfc2$var$abort,
        onPointerUpCapture: $b061873c873bcfc2$var$abort,
        onClickCapture: $b061873c873bcfc2$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $b061873c873bcfc2$var$abort
    } : events;
}

});

parcelRegister("7J7hh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5a02619843c4ce03$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $i0wEP = parcelRequire("i0wEP");
function $5a02619843c4ce03$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $5a02619843c4ce03$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $5a02619843c4ce03$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $i0wEP.default), {
        size: $5a02619843c4ce03$var$getIconSpacing(spacing),
        appearance: $5a02619843c4ce03$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("i0wEP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d1c18f2b32a8cf7e$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4igoi = parcelRequire("4igoi");

var $1oC0p = parcelRequire("1oC0p");

var $lHuwh = parcelRequire("lHuwh");

var $iTObT = parcelRequire("iTObT");

var $2wfCj = parcelRequire("2wfCj");
/**
 * Returns the appropriate circle stroke color.
 */ function $d1c18f2b32a8cf7e$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $iTObT.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $iTObT.N0), ")");
}
var $d1c18f2b32a8cf7e$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $d1c18f2b32a8cf7e$var$loadIn = null;
var $d1c18f2b32a8cf7e$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $d1c18f2b32a8cf7e$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $d1c18f2b32a8cf7e$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $2wfCj.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $d1c18f2b32a8cf7e$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $lHuwh.default));
    $d1c18f2b32a8cf7e$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $4igoi.default)([
            $d1c18f2b32a8cf7e$var$styles.wrapperStyles,
            $d1c18f2b32a8cf7e$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $4igoi.default)([
            $d1c18f2b32a8cf7e$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $4igoi.default)([
            $d1c18f2b32a8cf7e$var$styles.circleStyles
        ])
    })));
}));
var $d1c18f2b32a8cf7e$export$2e2bcd8739ae039 = $d1c18f2b32a8cf7e$var$Spinner;

});
parcelRegister("4igoi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $32058ebe96edf7f7$export$2e2bcd8739ae039; });
const $32058ebe96edf7f7$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $32058ebe96edf7f7$var$ATOMIC_GROUP_LENGTH = 5;
function $32058ebe96edf7f7$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $32058ebe96edf7f7$var$UNDERSCORE_UNICODE ? $32058ebe96edf7f7$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("iTObT", function(module, exports) {
$parcel$export(module.exports, "N0", function () { return $dc244be6a95c3ee5$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $dc244be6a95c3ee5$export$c39c0fe0f26207ae; });
// Reds
var $dc244be6a95c3ee5$export$4b84fd0e2c617bd = '#FFEBE6';
var $dc244be6a95c3ee5$export$b34b069eff244586 = '#FFBDAD';
var $dc244be6a95c3ee5$export$be802dd0d8b57f35 = '#FF8F73';
var $dc244be6a95c3ee5$export$60847d42f9da92a6 = '#FF7452';
var $dc244be6a95c3ee5$export$4a7404f376229999 = '#FF5630';
var $dc244be6a95c3ee5$export$2010d0fb4295b346 = '#DE350B';
var $dc244be6a95c3ee5$export$2837b5a1a71d5c02 = '#BF2600';
var $dc244be6a95c3ee5$export$8d9596b529bbb9cf = '#FFFAE6';
var $dc244be6a95c3ee5$export$41060a744ab0b7ae = '#FFF0B3';
var $dc244be6a95c3ee5$export$1cc05bbbf340e559 = '#FFE380';
var $dc244be6a95c3ee5$export$5aae31392d72caaa = '#FFC400';
var $dc244be6a95c3ee5$export$c6930421db9fa514 = '#FFAB00';
var $dc244be6a95c3ee5$export$59619663aa6500fb = '#FF991F';
var $dc244be6a95c3ee5$export$874739ea9e379ab6 = '#FF8B00';
var $dc244be6a95c3ee5$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $dc244be6a95c3ee5$export$69a3bf21b9686c2b = '#ABF5D1';
var $dc244be6a95c3ee5$export$afbce1382ec95f73 = '#79F2C0';
var $dc244be6a95c3ee5$export$747d86715d4175de = '#57D9A3';
var $dc244be6a95c3ee5$export$940e1f69e873f202 = '#36B37E';
var $dc244be6a95c3ee5$export$a49394138f7b8e85 = '#00875A';
var $dc244be6a95c3ee5$export$6fa04827ac68a4fb = '#006644';
var $dc244be6a95c3ee5$export$226de0355ed012f8 = '#DEEBFF';
var $dc244be6a95c3ee5$export$8c13c2ee36917869 = '#B3D4FF';
var $dc244be6a95c3ee5$export$ecfc1dff386a3e7a = '#4C9AFF';
var $dc244be6a95c3ee5$export$215b7063051591f1 = '#2684FF';
var $dc244be6a95c3ee5$export$e62e8919cca44969 = '#0065FF';
var $dc244be6a95c3ee5$export$b3de0ae08da2ce64 = '#0052CC';
var $dc244be6a95c3ee5$export$a6ee3d71bc067634 = '#0747A6';
var $dc244be6a95c3ee5$export$67f15409e87642a1 = '#669DF1';
var $dc244be6a95c3ee5$export$f0539dbc42dbb067 = '#8FB8F6';
var $dc244be6a95c3ee5$export$363e4475840015bb = '#EAE6FF';
var $dc244be6a95c3ee5$export$4b0a4417ed59760f = '#C0B6F2';
var $dc244be6a95c3ee5$export$6011520a64d9a187 = '#998DD9';
var $dc244be6a95c3ee5$export$a7175d4e9206bc80 = '#8777D9';
var $dc244be6a95c3ee5$export$b48405b95304b5a1 = '#6554C0';
var $dc244be6a95c3ee5$export$c71e4279dd54a18d = '#5243AA';
var $dc244be6a95c3ee5$export$147899de772240ec = '#403294';
var $dc244be6a95c3ee5$export$2cf711fe14c66f06 = '#E6FCFF';
var $dc244be6a95c3ee5$export$7a8f4d33f6f9772c = '#B3F5FF';
var $dc244be6a95c3ee5$export$776c9c497ef08533 = '#79E2F2';
var $dc244be6a95c3ee5$export$69cb3ca10c1e330e = '#00C7E6';
var $dc244be6a95c3ee5$export$9dc1ef0f3f48059b = '#00B8D9';
var $dc244be6a95c3ee5$export$7c835c78b6fcdef8 = '#00A3BF';
var $dc244be6a95c3ee5$export$6036577f95c3877e = '#008DA6';
var $dc244be6a95c3ee5$export$29a4f05edc054374 = '#FFFFFF';
var $dc244be6a95c3ee5$export$e655ef011c4aa1a2 = '#FAFBFC';
var $dc244be6a95c3ee5$export$9fdfb749e33cdf97 = '#F4F5F7';
var $dc244be6a95c3ee5$export$3e51e8f1440314ba = '#EBECF0';
var $dc244be6a95c3ee5$export$1ce2d1575d444ceb = '#DFE1E6';
var $dc244be6a95c3ee5$export$8754fc7e6d8b3000 = '#C1C7D0';
var $dc244be6a95c3ee5$export$c2e91cbeada39b8b = '#B3BAC5';
var $dc244be6a95c3ee5$export$5f71e19f3a7ad9de = '#A5ADBA';
var $dc244be6a95c3ee5$export$eaa8c8a70ac22806 = '#97A0AF';
var $dc244be6a95c3ee5$export$7c87d337fb91a97d = '#8993A4';
var $dc244be6a95c3ee5$export$d6447c357493214f = '#7A869A';
var $dc244be6a95c3ee5$export$f563ee71e9ee74cd = '#6B778C';
var $dc244be6a95c3ee5$export$e2ef2124cf4024b1 = '#5E6C84';
var $dc244be6a95c3ee5$export$eece5f492e429f08 = '#505F79';
var $dc244be6a95c3ee5$export$c39c0fe0f26207ae = '#42526E';
var $dc244be6a95c3ee5$export$7090862dc3038a9f = '#344563';
var $dc244be6a95c3ee5$export$ad0bacf983b7ddaa = '#253858';
var $dc244be6a95c3ee5$export$7d61b15e0da132af = '#172B4D';
var $dc244be6a95c3ee5$export$fbda843f0a27fe96 = '#091E42';
var $dc244be6a95c3ee5$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $dc244be6a95c3ee5$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $dc244be6a95c3ee5$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $dc244be6a95c3ee5$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $dc244be6a95c3ee5$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $dc244be6a95c3ee5$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $dc244be6a95c3ee5$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $dc244be6a95c3ee5$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $dc244be6a95c3ee5$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $dc244be6a95c3ee5$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $dc244be6a95c3ee5$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $dc244be6a95c3ee5$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $dc244be6a95c3ee5$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $dc244be6a95c3ee5$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $dc244be6a95c3ee5$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $dc244be6a95c3ee5$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $dc244be6a95c3ee5$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $dc244be6a95c3ee5$export$2f6319cf7d736c2a = '#E6EDFA';
var $dc244be6a95c3ee5$export$95126bc8884d6634 = '#DCE5F5';
var $dc244be6a95c3ee5$export$8338d8c35d44ff1 = '#CED9EB';
var $dc244be6a95c3ee5$export$5368d76ae4fbbda7 = '#B8C7E0';
var $dc244be6a95c3ee5$export$9f0a771d16ec8d36 = '#ABBBD6';
var $dc244be6a95c3ee5$export$abcf8c38338b4aa5 = '#9FB0CC';
var $dc244be6a95c3ee5$export$97e81faa16a182c7 = '#8C9CB8';
var $dc244be6a95c3ee5$export$bfe21c59123ecf33 = '#7988A3';
var $dc244be6a95c3ee5$export$ee82aa2ea6a1558 = '#67758F';
var $dc244be6a95c3ee5$export$682927c6ed76be02 = '#56637A';
var $dc244be6a95c3ee5$export$91fd9994c5be9757 = '#455166';
var $dc244be6a95c3ee5$export$d281fbfe3cff2df6 = '#3B475C';
var $dc244be6a95c3ee5$export$3902c91d8b98a753 = '#313D52';
var $dc244be6a95c3ee5$export$8e8133c1ba5845b5 = '#283447';
var $dc244be6a95c3ee5$export$33ff357f6620b39 = '#202B3D';
var $dc244be6a95c3ee5$export$633847cf062b69e0 = '#1B2638';
var $dc244be6a95c3ee5$export$9776a6e503bdbf76 = '#121A29';
var $dc244be6a95c3ee5$export$6c813d5160dff5db = '#0E1624';
var $dc244be6a95c3ee5$export$3d4f271a500072a = '#0D1424';
var $dc244be6a95c3ee5$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $dc244be6a95c3ee5$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $dc244be6a95c3ee5$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $dc244be6a95c3ee5$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $dc244be6a95c3ee5$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $dc244be6a95c3ee5$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $dc244be6a95c3ee5$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $dc244be6a95c3ee5$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $dc244be6a95c3ee5$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $dc244be6a95c3ee5$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $dc244be6a95c3ee5$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $dc244be6a95c3ee5$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $dc244be6a95c3ee5$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $dc244be6a95c3ee5$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $dc244be6a95c3ee5$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $dc244be6a95c3ee5$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $dc244be6a95c3ee5$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $dc244be6a95c3ee5$export$d2adc5dedf09fced = '#292A2E';
var $dc244be6a95c3ee5$export$f51762073d2bb381 = '#94C748';
var $dc244be6a95c3ee5$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("2wfCj", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $1d5aaf1cf10afabf$export$4e9f1640bbe7a1a8; });
var $1d5aaf1cf10afabf$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("c99Cq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8d7dc960d3edf680$export$2e2bcd8739ae039; });
/* content.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $lL9sL = parcelRequire("lL9sL");

var $1oC0p = parcelRequire("1oC0p");
var $8d7dc960d3edf680$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $8d7dc960d3edf680$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        className: (0, $lL9sL.default)([
            $8d7dc960d3edf680$var$styles.common,
            type === 'text' && $8d7dc960d3edf680$var$styles.text,
            type === 'icon' && $8d7dc960d3edf680$var$styles.icon,
            isLoading && $8d7dc960d3edf680$var$styles.fade,
            position === 'before' && $8d7dc960d3edf680$var$styles.beforeIcon,
            position === 'after' && $8d7dc960d3edf680$var$styles.afterIcon
        ])
    }, children);
};
var $8d7dc960d3edf680$export$2e2bcd8739ae039 = $8d7dc960d3edf680$var$Content;

});

parcelRegister("9RfjD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $72d4f1aad6816936$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $39c3M = parcelRequire("39c3M");
function $72d4f1aad6816936$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $72d4f1aad6816936$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    var isRenderProp = $72d4f1aad6816936$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $39c3M.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, iconProps));
};
var $72d4f1aad6816936$export$2e2bcd8739ae039 = $72d4f1aad6816936$var$IconRenderer;

});


parcelRegister("1zkOL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2c17176afeb2169f76dc501092efdf0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1249354db8e5f19f$var$_react = $1249354db8e5f19f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1249354db8e5f19f$var$_cross = $1249354db8e5f19f$var$_interopRequireDefault((parcelRequire("f7lPm")));

var $1249354db8e5f19f$var$_cross2 = $1249354db8e5f19f$var$_interopRequireDefault((parcelRequire("9qwds")));
function $1249354db8e5f19f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1249354db8e5f19f$var$CrossIcon = (props)=>/*#__PURE__*/ $1249354db8e5f19f$var$_react.default.createElement($1249354db8e5f19f$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $1249354db8e5f19f$var$_cross2.default
    }, props));
$1249354db8e5f19f$var$CrossIcon.displayName = 'CrossIconMigration';
var $1249354db8e5f19f$var$_default = module.exports.default = $1249354db8e5f19f$var$CrossIcon;

});
parcelRegister("f7lPm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b01870f0a18c2fc5$var$_react = $b01870f0a18c2fc5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $b01870f0a18c2fc5$var$_baseNew = $b01870f0a18c2fc5$var$_interopRequireDefault((parcelRequire("iCITr")));
function $b01870f0a18c2fc5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b01870f0a18c2fc5$var$CrossIcon = (props)=>/*#__PURE__*/ $b01870f0a18c2fc5$var$_react.default.createElement($b01870f0a18c2fc5$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$b01870f0a18c2fc5$var$CrossIcon.displayName = 'CrossIcon';
var $b01870f0a18c2fc5$var$_default = module.exports.default = $b01870f0a18c2fc5$var$CrossIcon;

});
parcelRegister("iCITr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return (parcelRequire("7Q0EW")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("7Q0EW")).Icon; });

var $7Q0EW = parcelRequire("7Q0EW");

});
parcelRegister("7Q0EW", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $5b4de6a923c01ad0$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $5b4de6a923c01ad0$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $6Wo2f = parcelRequire("6Wo2f");

var $39c3M = parcelRequire("39c3M");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $5b4de6a923c01ad0$var$svgStyles = null;
var $5b4de6a923c01ad0$var$iconStyles = null;
var $5b4de6a923c01ad0$var$utilityIconStyles = null;
var $5b4de6a923c01ad0$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $5b4de6a923c01ad0$var$baseHcmStyles = null;
var $5b4de6a923c01ad0$var$scaleSize = null;
var $5b4de6a923c01ad0$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $5b4de6a923c01ad0$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $5b4de6a923c01ad0$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $5b4de6a923c01ad0$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $5b4de6a923c01ad0$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $5b4de6a923c01ad0$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $39c3M.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $1oC0p.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $5b4de6a923c01ad0$var$baseSizeMap[type];
    var viewBoxPadding = $5b4de6a923c01ad0$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $6Wo2f.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $6Wo2f.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $5b4de6a923c01ad0$var$utilSizes[spacing] : size === 'small' ? $5b4de6a923c01ad0$var$coreSizeSmall[spacing] : $5b4de6a923c01ad0$var$coreSizeMedium[spacing]
        ])
    }));
});
var $5b4de6a923c01ad0$export$2e2bcd8739ae039 = $5b4de6a923c01ad0$export$f04a61298a47a40f;

});
parcelRegister("6Wo2f", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $50dacdbf8a97dd60$export$2e2bcd8739ae039; });
const $50dacdbf8a97dd60$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $50dacdbf8a97dd60$var$ATOMIC_GROUP_LENGTH = 5;
function $50dacdbf8a97dd60$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $50dacdbf8a97dd60$var$UNDERSCORE_UNICODE ? $50dacdbf8a97dd60$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});




parcelRegister("9qwds", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6dcf8835ba606cab$var$_react = $6dcf8835ba606cab$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $wh7nS = parcelRequire("wh7nS");
function $6dcf8835ba606cab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6dcf8835ba606cab$var$CrossIcon = (props)=>/*#__PURE__*/ $6dcf8835ba606cab$var$_react.default.createElement($wh7nS.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props));
$6dcf8835ba606cab$var$CrossIcon.displayName = 'CrossIcon';
var $6dcf8835ba606cab$var$_default = module.exports.default = $6dcf8835ba606cab$var$CrossIcon;

});
parcelRegister("wh7nS", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $061044925ae58701$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $efs8s = parcelRequire("efs8s");

var $9Sn3s = parcelRequire("9Sn3s");

var $1oC0p = parcelRequire("1oC0p");

var $6Wo2f = parcelRequire("6Wo2f");
function $061044925ae58701$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $061044925ae58701$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $061044925ae58701$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $061044925ae58701$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $061044925ae58701$var$iconStyles = null;
var $061044925ae58701$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $061044925ae58701$var$baseHcmStyles = null;
var $061044925ae58701$var$primaryEqualsSecondaryHcmStyles = null;
var $061044925ae58701$var$secondaryTransparentHcmStyles = null;
var $061044925ae58701$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $1oC0p.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $1oC0p.createElement("span", (0, $efs8s.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $061044925ae58701$var$_objectSpread($061044925ae58701$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $6Wo2f.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $061044925ae58701$var$sizeStyles[size]
        ])
    }));
});
var $061044925ae58701$export$2e2bcd8739ae039 = $061044925ae58701$export$f04a61298a47a40f;

});





parcelRegister("iPrCd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $db5269401cee4a11$export$2e2bcd8739ae039; });
/* modal-title.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $3XT1i = parcelRequire("3XT1i");

var $gOCmi = parcelRequire("gOCmi");

var $7mfYl = parcelRequire("7mfYl");
var $db5269401cee4a11$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E56910)"
};
var $db5269401cee4a11$var$iconStyles = null;
var $db5269401cee4a11$var$titleStyles = null;
var $db5269401cee4a11$var$textStyles = null;
var $db5269401cee4a11$var$truncatedTextStyles = null;
var $db5269401cee4a11$var$TitleIcon = function TitleIcon(_ref) {
    var appearance = _ref.appearance;
    var Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($3XT1i))) : (0, (/*@__PURE__*/$parcel$interopDefault($gOCmi)));
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $2jatx.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement(Icon, {
        label: appearance,
        color: $db5269401cee4a11$var$iconColor[appearance],
        spacing: "spacious"
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $db5269401cee4a11$var$ModalTitle = function ModalTitle(props) {
    var appearance = props.appearance, children = props.children, _props$isMultiline = props.isMultiline, isMultiline = _props$isMultiline === void 0 ? true : _props$isMultiline, userDefinedTestId = props.testId;
    var _useModal = (0, $7mfYl.useModal)(), titleId = _useModal.titleId, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--title");
    return /*#__PURE__*/ $1oC0p.createElement("h1", {
        "data-testid": testId,
        className: (0, $2jatx.default)([
            "_zulpu2gc _11c8lodh _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ])
    }, appearance && /*#__PURE__*/ $1oC0p.createElement($db5269401cee4a11$var$TitleIcon, {
        appearance: appearance
    }), /*#__PURE__*/ $1oC0p.createElement("span", {
        id: titleId,
        "data-testid": testId && "".concat(testId, "-text"),
        className: (0, $2jatx.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _slp31hna",
            !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    }, children));
};
var $db5269401cee4a11$export$2e2bcd8739ae039 = $db5269401cee4a11$var$ModalTitle;

});
parcelRegister("3XT1i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e318f9bb054a46c$var$_react = $2e318f9bb054a46c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2e318f9bb054a46c$var$_statusError = $2e318f9bb054a46c$var$_interopRequireDefault((parcelRequire("jrsGT")));

var $2e318f9bb054a46c$var$_error = $2e318f9bb054a46c$var$_interopRequireDefault((parcelRequire("98o6h")));
function $2e318f9bb054a46c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e318f9bb054a46c$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $2e318f9bb054a46c$var$_react.default.createElement($2e318f9bb054a46c$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $2e318f9bb054a46c$var$_error.default
    }, props));
$2e318f9bb054a46c$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $2e318f9bb054a46c$var$_default = module.exports.default = $2e318f9bb054a46c$var$StatusErrorIcon;

});
parcelRegister("jrsGT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e276cb573dba6e64$var$_react = $e276cb573dba6e64$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $e276cb573dba6e64$var$_baseNew = $e276cb573dba6e64$var$_interopRequireDefault((parcelRequire("iCITr")));
function $e276cb573dba6e64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e276cb573dba6e64$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $e276cb573dba6e64$var$_react.default.createElement($e276cb573dba6e64$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$e276cb573dba6e64$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $e276cb573dba6e64$var$_default = module.exports.default = $e276cb573dba6e64$var$StatusErrorIcon;

});

parcelRegister("98o6h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a678e355b567fbe$var$_react = $6a678e355b567fbe$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $wh7nS = parcelRequire("wh7nS");
function $6a678e355b567fbe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6a678e355b567fbe$var$ErrorIcon = (props)=>/*#__PURE__*/ $6a678e355b567fbe$var$_react.default.createElement($wh7nS.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$6a678e355b567fbe$var$ErrorIcon.displayName = 'ErrorIcon';
var $6a678e355b567fbe$var$_default = module.exports.default = $6a678e355b567fbe$var$ErrorIcon;

});


parcelRegister("gOCmi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::715767a087f47b16ede12b841c1dd7f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3df1217675cc533$var$_react = $c3df1217675cc533$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c3df1217675cc533$var$_statusWarning = $c3df1217675cc533$var$_interopRequireDefault((parcelRequire("e8PJm")));

var $c3df1217675cc533$var$_warning = $c3df1217675cc533$var$_interopRequireDefault((parcelRequire("jJlwe")));
function $c3df1217675cc533$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3df1217675cc533$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $c3df1217675cc533$var$_react.default.createElement($c3df1217675cc533$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $c3df1217675cc533$var$_warning.default
    }, props));
$c3df1217675cc533$var$StatusWarningIcon.displayName = 'StatusWarningIconMigration';
var $c3df1217675cc533$var$_default = module.exports.default = $c3df1217675cc533$var$StatusWarningIcon;

});
parcelRegister("e8PJm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4b9f0aa49158c22$var$_react = $a4b9f0aa49158c22$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a4b9f0aa49158c22$var$_baseNew = $a4b9f0aa49158c22$var$_interopRequireDefault((parcelRequire("iCITr")));
function $a4b9f0aa49158c22$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a4b9f0aa49158c22$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $a4b9f0aa49158c22$var$_react.default.createElement($a4b9f0aa49158c22$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$a4b9f0aa49158c22$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $a4b9f0aa49158c22$var$_default = module.exports.default = $a4b9f0aa49158c22$var$StatusWarningIcon;

});

parcelRegister("jJlwe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5d2e97b14674f6f$var$_react = $e5d2e97b14674f6f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $wh7nS = parcelRequire("wh7nS");
function $e5d2e97b14674f6f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e5d2e97b14674f6f$var$WarningIcon = (props)=>/*#__PURE__*/ $e5d2e97b14674f6f$var$_react.default.createElement($wh7nS.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$e5d2e97b14674f6f$var$WarningIcon.displayName = 'WarningIcon';
var $e5d2e97b14674f6f$var$_default = module.exports.default = $e5d2e97b14674f6f$var$WarningIcon;

});



parcelRegister("kGOC1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f0fefd6ab68eac7e$export$2e2bcd8739ae039; });
/* section-message.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $2gb89 = parcelRequire("2gb89");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $bvLOe = parcelRequire("bvLOe");

var $dvf7h = parcelRequire("dvf7h");

var $1zkOL = parcelRequire("1zkOL");

var $gQDpn = parcelRequire("gQDpn");
var $hcDwO = parcelRequire("hcDwO");

var $8Yi91 = parcelRequire("8Yi91");
var $f0fefd6ab68eac7e$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr",
    dismissButtonContainer: "_1pfh1i6y"
};
var $f0fefd6ab68eac7e$var$appearanceStyles = {
    information: "_bfhk33gi",
    warning: "_bfhk1tzq",
    error: "_bfhk1gly",
    success: "_bfhkmv6i",
    discovery: "_bfhk1nvp"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $f0fefd6ab68eac7e$var$SectionMessage = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'information' : _ref$appearance, actions = _ref.actions, title = _ref.title, icon = _ref.icon, isDismissible = _ref.isDismissible, onDismiss = _ref.onDismiss, testId = _ref.testId;
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $2gb89.default)(_useState, 2), dismissed = _useState2[0], setDismissed = _useState2[1];
    var handleDismiss = (0, $1oC0p.useCallback)(function() {
        onDismiss === null || onDismiss === void 0 || onDismiss();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    var _getAppearanceIconSty = (0, $8Yi91.getAppearanceIconStyles)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, $1oC0p.Fragment) ? actions.props.children : actions;
    var actionsArray = (0, $1oC0p.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ $1oC0p.createElement("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $2jatx.default)([
            $f0fefd6ab68eac7e$var$sectionMessageStyles.container,
            $f0fefd6ab68eac7e$var$appearanceStyles[appearance]
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $gQDpn.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $2jatx.default)([
            $f0fefd6ab68eac7e$var$sectionMessageStyles.iconContainer
        ])
    }, /*#__PURE__*/ $1oC0p.createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        LEGACY_size: "medium",
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ $1oC0p.createElement((0, $hcDwO.default), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content"),
        xcss: $f0fefd6ab68eac7e$var$sectionMessageStyles.contentContainer
    }, !!title && /*#__PURE__*/ $1oC0p.createElement((0, $dvf7h.default), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $2jatx.default)([
            $f0fefd6ab68eac7e$var$sectionMessageStyles.content
        ])
    }, children), actionsArray.length > 0 && /*#__PURE__*/ $1oC0p.createElement((0, $gQDpn.default), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xB7",
        space: "space.100",
        rowSpace: "space.0",
        role: actionsArray.length > 1 ? 'list' : undefined,
        xcss: $f0fefd6ab68eac7e$var$sectionMessageStyles.actionsContainer
    }, actionsArray.map(function(action, id) {
        return(/*#__PURE__*/ // Only use a listitem role if more than one action is present
        $1oC0p.createElement((0, $gQDpn.default), {
            role: actionsArray.length > 1 ? 'listitem' : undefined,
            key: id
        }, action));
    }))), isDismissible && /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $2jatx.default)([
            $f0fefd6ab68eac7e$var$sectionMessageStyles.dismissButtonContainer
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $bvLOe.default), {
        testId: testId && "".concat(testId, "--dismiss-button"),
        label: "Dismiss",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1zkOL))),
        appearance: "subtle",
        onClick: handleDismiss,
        spacing: "compact"
    }))));
});
$f0fefd6ab68eac7e$var$SectionMessage.displayName = 'SectionMessage';
var $f0fefd6ab68eac7e$export$2e2bcd8739ae039 = $f0fefd6ab68eac7e$var$SectionMessage;

});
parcelRegister("dvf7h", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9d49e5699bd4bf39$export$2e2bcd8739ae039; });
/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2gb89 = parcelRequire("2gb89");

var $1oC0p = parcelRequire("1oC0p");

var $22haY = parcelRequire("22haY");

var $6DsXE = parcelRequire("6DsXE");

var $fKjnY = parcelRequire("fKjnY");

var $fdRM4 = parcelRequire("fdRM4");

var $7t0tI = parcelRequire("7t0tI");
var $9d49e5699bd4bf39$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
var $9d49e5699bd4bf39$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
var $9d49e5699bd4bf39$var$headingColorStylesMap = {
    'color.text': "_syaz1fxt",
    'color.text.inverse': "_syaz15cr",
    'color.text.warning.inverse': "_syazal3n"
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c47bed69b7a147a63fdb8c394e98514a>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $9d49e5699bd4bf39$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */ var $9d49e5699bd4bf39$var$useColor = function useColor(colorProp) {
    var surface = (0, $fKjnY.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $6DsXE.inverseColorMap).hasOwnProperty(surface)) return (0, $6DsXE.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $9d49e5699bd4bf39$var$Heading = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $7t0tI;
    var _useHeading = (0, $fdRM4.useHeading)($9d49e5699bd4bf39$var$sizeTagMap[size]), _useHeading2 = (0, $2gb89.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $9d49e5699bd4bf39$var$useColor(colorProp);
    return /*#__PURE__*/ $1oC0p.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $22haY.default)([
            $9d49e5699bd4bf39$var$styles.reset,
            size && $9d49e5699bd4bf39$var$headingSizeStylesMap[size],
            $9d49e5699bd4bf39$var$headingColorStylesMap[color]
        ])
    }, children);
});
var $9d49e5699bd4bf39$export$2e2bcd8739ae039 = $9d49e5699bd4bf39$var$Heading;

});
parcelRegister("22haY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $17b91778f0a982c1$export$2e2bcd8739ae039; });
const $17b91778f0a982c1$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $17b91778f0a982c1$var$ATOMIC_GROUP_LENGTH = 5;
function $17b91778f0a982c1$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $17b91778f0a982c1$var$UNDERSCORE_UNICODE ? $17b91778f0a982c1$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("6DsXE", function(module, exports) {
$parcel$export(module.exports, "inverseColorMap", function () { return $4d4cd9adf92ab4d7$export$2185ce37f9bdd963; });

var $9Sn3s = parcelRequire("9Sn3s");

var $3dJ4i = parcelRequire("3dJ4i");

var $4802K = parcelRequire("4802K");
function $4d4cd9adf92ab4d7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4d4cd9adf92ab4d7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4d4cd9adf92ab4d7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4d4cd9adf92ab4d7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4d4cd9adf92ab4d7$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $4d4cd9adf92ab4d7$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $4d4cd9adf92ab4d7$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $4d4cd9adf92ab4d7$export$632685d741f3dbbf = $4d4cd9adf92ab4d7$var$_objectSpread($4d4cd9adf92ab4d7$var$_objectSpread({}, $4d4cd9adf92ab4d7$export$958d0ae7f2977ae4), $4d4cd9adf92ab4d7$export$d2dc61f58390201c);
var $4d4cd9adf92ab4d7$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $4d4cd9adf92ab4d7$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $4d4cd9adf92ab4d7$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $4d4cd9adf92ab4d7$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $4d4cd9adf92ab4d7$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $4d4cd9adf92ab4d7$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $4d4cd9adf92ab4d7$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $4d4cd9adf92ab4d7$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $4d4cd9adf92ab4d7$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $4d4cd9adf92ab4d7$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $4d4cd9adf92ab4d7$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $4d4cd9adf92ab4d7$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $4d4cd9adf92ab4d7$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $4d4cd9adf92ab4d7$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $4d4cd9adf92ab4d7$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $4d4cd9adf92ab4d7$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $4d4cd9adf92ab4d7$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $4d4cd9adf92ab4d7$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3dJ4i.css)((0, $9Sn3s.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $4d4cd9adf92ab4d7$export$e615f061ca585a6c = $4d4cd9adf92ab4d7$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $4d4cd9adf92ab4d7$export$ca0f9c2de39ffed7(spacingProperty, $4d4cd9adf92ab4d7$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $4d4cd9adf92ab4d7$export$bf46c3f9eeafc71f = $4d4cd9adf92ab4d7$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $4d4cd9adf92ab4d7$export$ca0f9c2de39ffed7(spacingProperty, $4d4cd9adf92ab4d7$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $4d4cd9adf92ab4d7$export$e7af83bafe7f9e63 = $4d4cd9adf92ab4d7$export$ca0f9c2de39ffed7('backgroundColor', $4d4cd9adf92ab4d7$export$d1d79bf68ac056bd);
var $4d4cd9adf92ab4d7$export$3a1bcba60b23d7f0 = $4d4cd9adf92ab4d7$export$ca0f9c2de39ffed7('color', $4d4cd9adf92ab4d7$export$8473307aa00d6ea1);
var $4d4cd9adf92ab4d7$export$45f3f4fe16f9f7d5 = $4d4cd9adf92ab4d7$export$ca0f9c2de39ffed7('fontWeight', $4d4cd9adf92ab4d7$export$303e322c6b1ed114);
var $4d4cd9adf92ab4d7$export$68cc305da27dbaa4 = $4d4cd9adf92ab4d7$export$ca0f9c2de39ffed7('fontFamily', $4d4cd9adf92ab4d7$export$3c7e9587132614b4);
var $4d4cd9adf92ab4d7$export$128f10c238242f83 = $4d4cd9adf92ab4d7$export$ca0f9c2de39ffed7('font', $4d4cd9adf92ab4d7$export$6ffa317d5e70375);
var $4d4cd9adf92ab4d7$export$219d364c0da35ae4 = $4d4cd9adf92ab4d7$export$ca0f9c2de39ffed7('font', $4d4cd9adf92ab4d7$export$236bfe3a33ef1292);
var $4d4cd9adf92ab4d7$export$38845ca010b93505 = $4d4cd9adf92ab4d7$export$ca0f9c2de39ffed7('fontWeight', $4d4cd9adf92ab4d7$export$855cfd311192d666);
var $4d4cd9adf92ab4d7$export$ff257d957d48c421 = $4d4cd9adf92ab4d7$export$ca0f9c2de39ffed7((0, $4802K.CURRENT_SURFACE_CSS_VAR), $4d4cd9adf92ab4d7$export$41a358c9c2356760);
var $4d4cd9adf92ab4d7$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $4d4cd9adf92ab4d7$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("4802K", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $3017f1682b5c0ab5$export$9d7b58831ae93caa; });
var $3017f1682b5c0ab5$export$4ef52930e33717cd = 'data-theme';
var $3017f1682b5c0ab5$export$a00eac3f8684bcd0 = 'data-color-mode';
var $3017f1682b5c0ab5$export$2112803007239c61 = 'data-contrast-mode';
var $3017f1682b5c0ab5$export$352e418ed5b6193a = 'data-custom-theme';
var $3017f1682b5c0ab5$export$6f0c6fb8c80fcc92 = 'ds';
var $3017f1682b5c0ab5$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $3017f1682b5c0ab5$export$dddac1532e822863 = "--".concat($3017f1682b5c0ab5$export$6f0c6fb8c80fcc92, "-token-not-found");
var $3017f1682b5c0ab5$export$9d7b58831ae93caa = "--".concat($3017f1682b5c0ab5$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("fKjnY", function(module, exports) {
$parcel$export(module.exports, "useSurface", function () { return $b76a30820a0fd99c$export$1aeb4f6b93c4540d; });

var $1oC0p = parcelRequire("1oC0p");
var $b76a30820a0fd99c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $b76a30820a0fd99c$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($b76a30820a0fd99c$export$1ca2a26fecb070ae);
};
$b76a30820a0fd99c$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("fdRM4", function(module, exports) {
$parcel$export(module.exports, "useHeading", function () { return $b151c85e978bdd0c$export$97a37b1befbbf9b1; });

var $1oC0p = parcelRequire("1oC0p");
// Allows support for heading levels 1-9 via aria-level
var $b151c85e978bdd0c$var$HeadingLevelContext = /*#__PURE__*/ (0, $1oC0p.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ var $b151c85e978bdd0c$var$useHeadingLevel = function useHeadingLevel() {
    return (0, $1oC0p.useContext)($b151c85e978bdd0c$var$HeadingLevelContext);
};
var $b151c85e978bdd0c$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $b151c85e978bdd0c$var$useHeadingLevel();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $b151c85e978bdd0c$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $b151c85e978bdd0c$var$useHeadingLevel();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($b151c85e978bdd0c$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $b151c85e978bdd0c$export$2e2bcd8739ae039 = $b151c85e978bdd0c$var$HeadingLevelContextProvider;

});


parcelRegister("gQDpn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c440125aeb28225f$export$2e2bcd8739ae039; });
/* inline.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $efs8s = parcelRequire("efs8s");

var $8ySUD = parcelRequire("8ySUD");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2etn6 = parcelRequire("2etn6");

var $g5T7Q = parcelRequire("g5T7Q");
var $c440125aeb28225f$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $c440125aeb28225f$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $c440125aeb28225f$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $2jatx.default)([
            $c440125aeb28225f$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $c440125aeb28225f$var$Inline = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, $8ySUD.default)(_ref2, $c440125aeb28225f$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $1oC0p.createElement($c440125aeb28225f$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $1oC0p.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $1oC0p.createElement((0, $g5T7Q.default), (0, $efs8s.default)({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $2etn6.cx)(grow === 'hug' && $c440125aeb28225f$var$styles.hug, grow === 'fill' && $c440125aeb28225f$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$c440125aeb28225f$var$Inline.displayName = 'Inline';
var $c440125aeb28225f$export$2e2bcd8739ae039 = $c440125aeb28225f$var$Inline;

});
parcelRegister("2etn6", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $1a03ac25ef653412$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("1oC0p");


var $adHov = parcelRequire("adHov");
var $1a03ac25ef653412$var$strictApi = (0, $adHov.createStrictAPI)();
var $1a03ac25ef653412$export$dbf350e5966cf602 = $1a03ac25ef653412$var$strictApi.css;
var $1a03ac25ef653412$export$eb1ecd84a24ee424 = $1a03ac25ef653412$var$strictApi.cssMap;
$1a03ac25ef653412$var$strictApi.cssMap;
var $1a03ac25ef653412$export$a274e22fb40f762e = $1a03ac25ef653412$var$strictApi.cx;
var $1a03ac25ef653412$var$XCSSProp = $1a03ac25ef653412$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});

parcelRegister("g5T7Q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bb77dfc1b8e9716b$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $efs8s = parcelRequire("efs8s");

var $8ySUD = parcelRequire("8ySUD");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $bb77dfc1b8e9716b$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $bb77dfc1b8e9716b$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $bb77dfc1b8e9716b$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $bb77dfc1b8e9716b$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $bb77dfc1b8e9716b$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $bb77dfc1b8e9716b$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $bb77dfc1b8e9716b$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $bb77dfc1b8e9716b$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $bb77dfc1b8e9716b$var$Flex = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, $8ySUD.default)(_ref, $bb77dfc1b8e9716b$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement(Component, (0, $efs8s.default)({}, ariaAttributes, {
        role: role,
        className: (0, $2jatx.default)([
            $bb77dfc1b8e9716b$var$styles.root,
            gap && $bb77dfc1b8e9716b$var$columnGapMap[gap],
            columnGap && $bb77dfc1b8e9716b$var$columnGapMap[columnGap],
            gap && $bb77dfc1b8e9716b$var$rowGapMap[gap],
            rowGap && $bb77dfc1b8e9716b$var$rowGapMap[rowGap],
            alignItems && $bb77dfc1b8e9716b$var$alignItemsMap[alignItems],
            direction && $bb77dfc1b8e9716b$var$flexDirectionMap[direction],
            justifyContent && $bb77dfc1b8e9716b$var$justifyContentMap[justifyContent],
            wrap && $bb77dfc1b8e9716b$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$bb77dfc1b8e9716b$var$Flex.displayName = 'Flex';
var $bb77dfc1b8e9716b$export$2e2bcd8739ae039 = $bb77dfc1b8e9716b$var$Flex;

});


parcelRegister("hcDwO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c86238209d114491$export$2e2bcd8739ae039; });
/* stack.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $efs8s = parcelRequire("efs8s");

var $8ySUD = parcelRequire("8ySUD");

var $1oC0p = parcelRequire("1oC0p");


var $2etn6 = parcelRequire("2etn6");

var $g5T7Q = parcelRequire("g5T7Q");
var $c86238209d114491$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "spread",
    "grow",
    "space",
    "children",
    "testId",
    "xcss",
    "role"
];
var $c86238209d114491$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $c86238209d114491$var$Stack = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, ariaAttributes = (0, $8ySUD.default)(_ref, $c86238209d114491$var$_excluded);
    return /*#__PURE__*/ $1oC0p.createElement((0, $g5T7Q.default), (0, $efs8s.default)({}, ariaAttributes, {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $2etn6.cx)(grow === 'hug' && $c86238209d114491$var$styles.hug, grow === 'fill' && $c86238209d114491$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$c86238209d114491$var$Stack.displayName = 'Stack';
var $c86238209d114491$export$2e2bcd8739ae039 = $c86238209d114491$var$Stack;

});

parcelRegister("8Yi91", function(module, exports) {
$parcel$export(module.exports, "getAppearanceIconStyles", function () { return $68820077ab405a54$export$e9b82d2e21ac0c1f; });

var $9Sn3s = parcelRequire("9Sn3s");

var $1oC0p = parcelRequire("1oC0p");

var $g317t = parcelRequire("g317t");

var $3XT1i = parcelRequire("3XT1i");

var $eRD3y = parcelRequire("eRD3y");

var $i4nWV = parcelRequire("i4nWV");

var $gOCmi = parcelRequire("gOCmi");

var $iqCss = parcelRequire("iqCss");
function $68820077ab405a54$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68820077ab405a54$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68820077ab405a54$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68820077ab405a54$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68820077ab405a54$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, ".concat((0, $iqCss.B50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eRD3y))),
        primaryIconColor: "var(--ds-icon-information, ".concat((0, $iqCss.B500), ")")
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, ".concat((0, $iqCss.Y50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gOCmi))),
        primaryIconColor: "var(--ds-icon-warning, ".concat((0, $iqCss.Y500), ")")
    },
    error: {
        backgroundColor: "var(--ds-background-danger, ".concat((0, $iqCss.R50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3XT1i))),
        primaryIconColor: "var(--ds-icon-danger, ".concat((0, $iqCss.R500), ")")
    },
    success: {
        backgroundColor: "var(--ds-background-success, ".concat((0, $iqCss.G50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($i4nWV))),
        primaryIconColor: "var(--ds-icon-success, ".concat((0, $iqCss.G500), ")")
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $iqCss.P50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($g317t))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $iqCss.P500), ")")
    }
};
function $68820077ab405a54$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $68820077ab405a54$var$appearanceIconSchema[appearance] || $68820077ab405a54$var$appearanceIconSchema.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var size = _ref.size, primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $68820077ab405a54$var$_objectSpread($68820077ab405a54$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}

});
parcelRegister("g317t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5501f2ec2c7fc2907a8ddc6771935d76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $baedcb77e3d2f092$var$_react = $baedcb77e3d2f092$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $baedcb77e3d2f092$var$_discovery = $baedcb77e3d2f092$var$_interopRequireDefault((parcelRequire("aLUKd")));

var $baedcb77e3d2f092$var$_note = $baedcb77e3d2f092$var$_interopRequireDefault((parcelRequire("7QLW0")));
function $baedcb77e3d2f092$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DiscoveryIcon.
 * This component is DiscoveryIcon, with `UNSAFE_fallbackIcon` set to "EditorNoteIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $baedcb77e3d2f092$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $baedcb77e3d2f092$var$_react.default.createElement($baedcb77e3d2f092$var$_discovery.default, Object.assign({
        name: "DiscoveryIcon",
        LEGACY_fallbackIcon: $baedcb77e3d2f092$var$_note.default
    }, props));
$baedcb77e3d2f092$var$DiscoveryIcon.displayName = 'DiscoveryIconMigration';
var $baedcb77e3d2f092$var$_default = module.exports.default = $baedcb77e3d2f092$var$DiscoveryIcon;

});
parcelRegister("aLUKd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84ac540d37aa7b8e7ab349dbbb474c30>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d7a4f6d5c4e528e$var$_react = $7d7a4f6d5c4e528e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7d7a4f6d5c4e528e$var$_baseNew = $7d7a4f6d5c4e528e$var$_interopRequireDefault((parcelRequire("iCITr")));
function $7d7a4f6d5c4e528e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Discovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d7a4f6d5c4e528e$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $7d7a4f6d5c4e528e$var$_react.default.createElement($7d7a4f6d5c4e528e$var$_baseNew.default, Object.assign({
        name: "DiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6v-4.75C9 9.56 9.56 9 10.25 9H15V3a2 2 0 0 0-2-2M4 5.5h7V4H4zM4 9h3V7.5H4z" clip-rule="evenodd"/><path fill="currentcolor" d="M11.25 10.5a.75.75 0 0 0-.75.75v3.81l4.56-4.56z"/>`
    }, props));
$7d7a4f6d5c4e528e$var$DiscoveryIcon.displayName = 'DiscoveryIcon';
var $7d7a4f6d5c4e528e$var$_default = module.exports.default = $7d7a4f6d5c4e528e$var$DiscoveryIcon;

});

parcelRegister("7QLW0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5b72928b209bcc83$var$_react = $5b72928b209bcc83$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $wh7nS = parcelRequire("wh7nS");
function $5b72928b209bcc83$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5b72928b209bcc83$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $5b72928b209bcc83$var$_react.default.createElement($wh7nS.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props));
$5b72928b209bcc83$var$EditorNoteIcon.displayName = 'EditorNoteIcon';
var $5b72928b209bcc83$var$_default = module.exports.default = $5b72928b209bcc83$var$EditorNoteIcon;

});


parcelRegister("eRD3y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::750ecc162e36259ef90344888c589176>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ad244fadd783d955$var$_react = $ad244fadd783d955$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ad244fadd783d955$var$_statusInformation = $ad244fadd783d955$var$_interopRequireDefault((parcelRequire("H3c6V")));

var $ad244fadd783d955$var$_info = $ad244fadd783d955$var$_interopRequireDefault((parcelRequire("ioyF6")));
function $ad244fadd783d955$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ad244fadd783d955$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $ad244fadd783d955$var$_react.default.createElement($ad244fadd783d955$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $ad244fadd783d955$var$_info.default
    }, props));
$ad244fadd783d955$var$StatusInformationIcon.displayName = 'StatusInformationIconMigration';
var $ad244fadd783d955$var$_default = module.exports.default = $ad244fadd783d955$var$StatusInformationIcon;

});
parcelRegister("H3c6V", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08167e984e6fbf14$var$_react = $08167e984e6fbf14$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $08167e984e6fbf14$var$_baseNew = $08167e984e6fbf14$var$_interopRequireDefault((parcelRequire("iCITr")));
function $08167e984e6fbf14$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $08167e984e6fbf14$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $08167e984e6fbf14$var$_react.default.createElement($08167e984e6fbf14$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$08167e984e6fbf14$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $08167e984e6fbf14$var$_default = module.exports.default = $08167e984e6fbf14$var$StatusInformationIcon;

});

parcelRegister("ioyF6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d6455b00c14346ef$var$_react = $d6455b00c14346ef$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $wh7nS = parcelRequire("wh7nS");
function $d6455b00c14346ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d6455b00c14346ef$var$InfoIcon = (props)=>/*#__PURE__*/ $d6455b00c14346ef$var$_react.default.createElement($wh7nS.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props));
$d6455b00c14346ef$var$InfoIcon.displayName = 'InfoIcon';
var $d6455b00c14346ef$var$_default = module.exports.default = $d6455b00c14346ef$var$InfoIcon;

});


parcelRegister("i4nWV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f966e8890debb57eaf4e6f167681f98b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d27b2d8c2ebe2d05$var$_react = $d27b2d8c2ebe2d05$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $d27b2d8c2ebe2d05$var$_statusSuccess = $d27b2d8c2ebe2d05$var$_interopRequireDefault((parcelRequire("gBBGO")));

var $d27b2d8c2ebe2d05$var$_checkCircle = $d27b2d8c2ebe2d05$var$_interopRequireDefault((parcelRequire("gWTWK")));
function $d27b2d8c2ebe2d05$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d27b2d8c2ebe2d05$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $d27b2d8c2ebe2d05$var$_react.default.createElement($d27b2d8c2ebe2d05$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $d27b2d8c2ebe2d05$var$_checkCircle.default
    }, props));
$d27b2d8c2ebe2d05$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $d27b2d8c2ebe2d05$var$_default = module.exports.default = $d27b2d8c2ebe2d05$var$StatusSuccessIcon;

});
parcelRegister("gBBGO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c16d565fd05f9587$var$_react = $c16d565fd05f9587$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c16d565fd05f9587$var$_baseNew = $c16d565fd05f9587$var$_interopRequireDefault((parcelRequire("iCITr")));
function $c16d565fd05f9587$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c16d565fd05f9587$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $c16d565fd05f9587$var$_react.default.createElement($c16d565fd05f9587$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$c16d565fd05f9587$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $c16d565fd05f9587$var$_default = module.exports.default = $c16d565fd05f9587$var$StatusSuccessIcon;

});

parcelRegister("gWTWK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c56d75f441c44dad$var$_react = $c56d75f441c44dad$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $wh7nS = parcelRequire("wh7nS");
function $c56d75f441c44dad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c56d75f441c44dad$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $c56d75f441c44dad$var$_react.default.createElement($wh7nS.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$c56d75f441c44dad$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $c56d75f441c44dad$var$_default = module.exports.default = $c56d75f441c44dad$var$CheckCircleIcon;

});




parcelRegister("j673i", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $de740c41a5a8b5fe$export$2e2bcd8739ae039; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $fiGIU = parcelRequire("fiGIU");
var $cIn1R = parcelRequire("cIn1R");
var $9nVp4 = parcelRequire("9nVp4");

var $hOJ7X = parcelRequire("hOJ7X");

var $4EjnY = parcelRequire("4EjnY");
var $de740c41a5a8b5fe$var$packageName = "@atlaskit/select";
var $de740c41a5a8b5fe$var$packageVersion = "0.0.0-development";
var $de740c41a5a8b5fe$export$d1de3b251ccaa8a3 = (0, $4EjnY.default)((0, $hOJ7X.default));
var $de740c41a5a8b5fe$var$createAndFireEventOnAtlaskit = (0, $fiGIU.default)('atlaskit');
var $de740c41a5a8b5fe$var$Select = (0, $cIn1R.default)({
    componentName: 'select',
    packageName: $de740c41a5a8b5fe$var$packageName,
    packageVersion: $de740c41a5a8b5fe$var$packageVersion
})((0, $9nVp4.default)({
    onChange: $de740c41a5a8b5fe$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $de740c41a5a8b5fe$var$packageName,
            packageVersion: $de740c41a5a8b5fe$var$packageVersion
        }
    })
})($de740c41a5a8b5fe$export$d1de3b251ccaa8a3));
var $de740c41a5a8b5fe$export$2e2bcd8739ae039 = $de740c41a5a8b5fe$var$Select;

});
parcelRegister("fiGIU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b239ad6c2812d65c$export$2e2bcd8739ae039; });
var $b239ad6c2812d65c$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

});

parcelRegister("cIn1R", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $941b75282abe72e0$export$2e2bcd8739ae039; });

var $efs8s = parcelRequire("efs8s");

var $9Sn3s = parcelRequire("9Sn3s");

var $8ySUD = parcelRequire("8ySUD");

var $1oC0p = parcelRequire("1oC0p");

var $1Ow6B = parcelRequire("1Ow6B");
var $941b75282abe72e0$var$_excluded = [
    "analyticsContext"
];
function $941b75282abe72e0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $941b75282abe72e0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $941b75282abe72e0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $941b75282abe72e0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $941b75282abe72e0$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, $8ySUD.default)(_ref, $941b75282abe72e0$var$_excluded);
            var analyticsData = (0, $1oC0p.useMemo)(function() {
                return $941b75282abe72e0$var$_objectSpread($941b75282abe72e0$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1Ow6B.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(WrappedComponent, (0, $efs8s.default)({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $941b75282abe72e0$export$2e2bcd8739ae039 = $941b75282abe72e0$var$withAnalyticsContext;

});
parcelRegister("1Ow6B", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $15235d758bd29737$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $39c3M = parcelRequire("39c3M");

var $6ZNvk = parcelRequire("6ZNvk");

var $hbshU = parcelRequire("hbshU");

var $ciwpK = parcelRequire("ciwpK");
var $15235d758bd29737$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var isModernContext = (0, $6ZNvk.default) || (0, $39c3M.fg)('analytics-next-use-modern-context_jira');
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ciwpK.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $hbshU.default), props);
};
var $15235d758bd29737$export$2e2bcd8739ae039 = $15235d758bd29737$var$ExportedAnalyticsContext;

});
parcelRegister("6ZNvk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $517ed721282c057a$export$2e2bcd8739ae039; });

var $7t0tI = parcelRequire("7t0tI");
var $517ed721282c057a$var$_process$env;
var /// <reference types="node" />
$517ed721282c057a$export$2e2bcd8739ae039 = typeof $7t0tI !== 'undefined' && $7t0tI !== null && (($517ed721282c057a$var$_process$env = {}, $517ed721282c057a$var$_process$env === void 0) ? void 0 : $517ed721282c057a$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);

});

parcelRegister("hbshU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c8296821d010b373$export$2e2bcd8739ae039; });

var $342Py = parcelRequire("342Py");

var $3AhEU = parcelRequire("3AhEU");

var $gWIyR = parcelRequire("gWIyR");

var $ciMo5 = parcelRequire("ciMo5");

var $g9Nc1 = parcelRequire("g9Nc1");

var $c3W0a = parcelRequire("c3W0a");

var $9Sn3s = parcelRequire("9Sn3s");

var $1oC0p = parcelRequire("1oC0p");

var $4OgEb = parcelRequire("4OgEb");

var $bEiDG = parcelRequire("bEiDG");
function $c8296821d010b373$var$_callSuper(t, o, e) {
    return o = (0, $g9Nc1.default)(o), (0, $ciMo5.default)(t, $c8296821d010b373$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $g9Nc1.default)(t).constructor) : o.apply(t, e));
}
function $c8296821d010b373$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c8296821d010b373$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c8296821d010b373$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).func
};
var $c8296821d010b373$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $c8296821d010b373$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, $3AhEU.default)(this, AnalyticsContext);
        _this = $c8296821d010b373$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, $9Sn3s.default)(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, $9Sn3s.default)(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $c8296821d010b373$var$noop : _this$context$getAtla;
            return [].concat((0, $342Py.default)(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, $9Sn3s.default)(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $c8296821d010b373$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, $c3W0a.default)(AnalyticsContext, _Component);
    return (0, $gWIyR.default)(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bEiDG.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $1oC0p.Component));
(0, $9Sn3s.default)($c8296821d010b373$var$AnalyticsContext, "contextTypes", $c8296821d010b373$var$ContextTypes);
(0, $9Sn3s.default)($c8296821d010b373$var$AnalyticsContext, "childContextTypes", $c8296821d010b373$var$ContextTypes);
var $c8296821d010b373$export$2e2bcd8739ae039 = $c8296821d010b373$var$AnalyticsContext;

});

parcelRegister("ciwpK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8f404f418bb029ea$export$2e2bcd8739ae039; });

var $342Py = parcelRequire("342Py");

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");

var $2tS1v = parcelRequire("2tS1v");

var $6f3AQ = parcelRequire("6f3AQ");
var $8f404f418bb029ea$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $6f3AQ.useTrackedRef)(data);
    var _useAnalyticsContext = (0, $2tS1v.useAnalyticsContext)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $1oC0p.useCallback)(function() {
        return [].concat((0, $342Py.default)(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $1oC0p.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bEiDG.default).Provider, {
        value: value
    }, children);
};
var $8f404f418bb029ea$export$2e2bcd8739ae039 = $8f404f418bb029ea$var$AnalyticsContext;

});



parcelRegister("9nVp4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6d52ca2678f4144f$export$2e2bcd8739ae039; });

var $efs8s = parcelRequire("efs8s");

var $1oC0p = parcelRequire("1oC0p");

var $d70M0 = parcelRequire("d70M0");

var $1I35e = parcelRequire("1I35e");
var $6d52ca2678f4144f$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $1I35e.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $d70M0.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(WrappedComponent, (0, $efs8s.default)({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $6d52ca2678f4144f$export$2e2bcd8739ae039 = $6d52ca2678f4144f$var$withAnalyticsEvents;

});
parcelRegister("1I35e", function(module, exports) {
$parcel$export(module.exports, "usePatchedProps", function () { return $13ec4acf121baeaf$export$9ebb5a84d17e5d18; });

var $9Sn3s = parcelRequire("9Sn3s");

var $6DX60 = parcelRequire("6DX60");

var $1oC0p = parcelRequire("1oC0p");

var $d70M0 = parcelRequire("d70M0");
function $13ec4acf121baeaf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $13ec4acf121baeaf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $13ec4acf121baeaf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $13ec4acf121baeaf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $13ec4acf121baeaf$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $d70M0.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $1oC0p.useRef)({});
    var patchedProps = (0, $1oC0p.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes((0, $6DX60.default)(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $13ec4acf121baeaf$var$_objectSpread($13ec4acf121baeaf$var$_objectSpread({}, p), {}, (0, $9Sn3s.default)({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $13ec4acf121baeaf$var$_objectSpread($13ec4acf121baeaf$var$_objectSpread({}, p), {}, (0, $9Sn3s.default)({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("4EjnY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3629ef70f93e2a46$export$2e2bcd8739ae039; });

var $efs8s = parcelRequire("efs8s");

var $8ySUD = parcelRequire("8ySUD");

var $1oC0p = parcelRequire("1oC0p");
var $3629ef70f93e2a46$var$_excluded = [
    "ariaLiveMessages",
    "isInvalid",
    "onClickPreventDefault",
    "tabSelectsValue",
    "validationState"
];
function $3629ef70f93e2a46$export$2e2bcd8739ae039(WrappedComponent) {
    var AtlaskitSelect = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        var ariaLiveMessages = props.ariaLiveMessages, isInvalid = props.isInvalid, _props$onClickPrevent = props.onClickPreventDefault, onClickPreventDefault = _props$onClickPrevent === void 0 ? true : _props$onClickPrevent, _props$tabSelectsValu = props.tabSelectsValue, tabSelectsValue = _props$tabSelectsValu === void 0 ? false : _props$tabSelectsValu, _props$validationStat = props.validationState, validationState = _props$validationStat === void 0 ? 'default' : _props$validationStat, restProps = (0, $8ySUD.default)(props, $3629ef70f93e2a46$var$_excluded);
        var internalSelectRef = (0, $1oC0p.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $1oC0p.useImperativeHandle)(forwardedRef, function() {
            return {
                select: internalSelectRef.current,
                focus: function focus() {
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: function blur() {
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            };
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(WrappedComponent, (0, $efs8s.default)({
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error'
        }, restProps, {
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        }));
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});


parcelRegister("iLLng", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $daa15d4c83057201$export$2e2bcd8739ae039; });
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $efs8s = parcelRequire("efs8s");

var $6DX60 = parcelRequire("6DX60");

var $9Sn3s = parcelRequire("9Sn3s");

var $8ySUD = parcelRequire("8ySUD");

var $jf44d = parcelRequire("jf44d");
var $7watR = parcelRequire("7watR");

var $1oC0p = parcelRequire("1oC0p");

var $3XlEJ = parcelRequire("3XlEJ");

var $39c3M = parcelRequire("39c3M");

var $kQXTD = parcelRequire("kQXTD");
var $daa15d4c83057201$var$_excluded = [
    "resize",
    "appearance",
    "isCompact",
    "isRequired",
    "isReadOnly",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "minimumRows",
    "testId",
    "maxHeight",
    "onBlur",
    "onFocus",
    "onChange",
    "value",
    "style"
];
function $daa15d4c83057201$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $daa15d4c83057201$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $daa15d4c83057201$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $daa15d4c83057201$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $daa15d4c83057201$var$packageName = "@atlaskit/textarea";
var $daa15d4c83057201$var$packageVersion = "8.0.0";
var $daa15d4c83057201$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $daa15d4c83057201$var$packageName,
    packageVersion: $daa15d4c83057201$var$packageVersion
};
var $daa15d4c83057201$var$lineHeightBase = 20;
var $daa15d4c83057201$var$lineHeightCompact = 16;
var $daa15d4c83057201$var$compactVerticalPadding = 2;
var $daa15d4c83057201$var$verticalPadding = 6;
var $daa15d4c83057201$var$transitionDuration = '0.2s';
var $daa15d4c83057201$var$borderWidth = 2;
var $daa15d4c83057201$var$baseStyles = null;
var $daa15d4c83057201$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u1j28 _jomr1j28 _7ehi3sij"
};
var $daa15d4c83057201$var$fontStyles = {
    default: "_ect41sbm",
    monospace: "_ect41odn _1tn21oud _14mdudxr",
    large: "_11c81doa _1tn21oud"
};
var $daa15d4c83057201$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
var $daa15d4c83057201$var$setSmartHeight = function setSmartHeight(el) {
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    var borderHeight = $daa15d4c83057201$var$borderWidth;
    var paddingBoxHeight = el.scrollHeight;
    var borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = "".concat(borderBoxHeight, "px");
};
var $daa15d4c83057201$var$InnerTextArea = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var ourRef = (0, $1oC0p.useRef)(null);
    var _props$resize = props.resize, resize = _props$resize === void 0 ? 'smart' : _props$resize, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'standard' : _props$appearance, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$minimumRows = props.minimumRows, minimumRows = _props$minimumRows === void 0 ? 2 : _props$minimumRows, testId = props.testId, _props$maxHeight = props.maxHeight, maxHeight = _props$maxHeight === void 0 ? '50vh' : _props$maxHeight, onBlur = props.onBlur, onFocus = props.onFocus, onChange = props.onChange, value = props.value, style = props.style, rest = (0, $8ySUD.default)(props, $daa15d4c83057201$var$_excluded);
    var borderHeight = (0, $1oC0p.useMemo)(function() {
        return appearance === 'none' ? 2 : 1;
    }, [
        appearance
    ]);
    (0, $1oC0p.useEffect)(function() {
        var el = ourRef.current;
        if (resize === 'smart' && el) $daa15d4c83057201$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    var onBlurWithAnalytics = (0, $3XlEJ.usePlatformLeafEventHandler)($daa15d4c83057201$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: 'blurred'
    }, $daa15d4c83057201$var$analyticsParams));
    var onFocusWithAnalytics = (0, $3XlEJ.usePlatformLeafEventHandler)($daa15d4c83057201$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: 'focused'
    }, $daa15d4c83057201$var$analyticsParams));
    var getTextAreaRef = function getTextAreaRef(elementRef) {
        ourRef.current = elementRef;
        if (ref && (0, $6DX60.default)(ref) === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    var handleOnChange = (0, $1oC0p.useCallback)(function(e) {
        var el = ourRef.current;
        if (resize === 'smart' && el) $daa15d4c83057201$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    var controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    var compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("textarea", (0, $efs8s.default)({}, controlProps, {
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows
    }, rest, {
        className: (0, $jf44d.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c81oud _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v5641gs0 _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazovqm _slp31hna _153gksl0 _usy41kd8 _1a2sh9qi _vbqbhxcb _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fraksl0 _ibjd12ci _6zpvh9qi _19k01ouc _1idrpsu8 _1lephxcb _nmhq1fiz _1n388sxn _1luh3zdg _ndzbkwt5 _1vj0119y",
            $daa15d4c83057201$var$appearanceStyles[appearance],
            (0, $39c3M.fg)('platform_design_system_team_safari_input_fix') && $daa15d4c83057201$var$fontStyles['large'],
            $daa15d4c83057201$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $daa15d4c83057201$var$resizeStyles[resize],
            "_uzq71d1b _16lw1cn1"
        ]),
        style: $daa15d4c83057201$var$_objectSpread($daa15d4c83057201$var$_objectSpread({}, style), {}, {
            maxHeight: maxHeight,
            "--_5xk3r4": (0, $7watR.default)("var(--ds-text, ".concat((0, $kQXTD.N900), ")")),
            "--_19uzta9": (0, $7watR.default)("background-color ".concat($daa15d4c83057201$var$transitionDuration, " ease-in-out,\n               border-color ").concat($daa15d4c83057201$var$transitionDuration, " ease-in-out")),
            "--_dnrmjm": (0, $7watR.default)("var(--ds-text-disabled, ".concat((0, $kQXTD.N70), ")")),
            "--_t0vtv2": (0, $7watR.default)("var(--ds-background-input-pressed, ".concat((0, $kQXTD.N0), ")")),
            "--_xjqa3d": (0, $7watR.default)("var(--ds-border-focused, ".concat((0, $kQXTD.B200), ")")),
            "--_1n75f5r": (0, $7watR.default)("inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-focused, ".concat((0, $kQXTD.B200), ")"))),
            "--_4mkb4g": (0, $7watR.default)("var(--ds-background-input, ".concat((0, $kQXTD.N10), ")")),
            "--_1u9fbts": (0, $7watR.default)("var(--ds-border-danger, ".concat((0, $kQXTD.R400), ")")),
            "--_1l1juom": (0, $7watR.default)("inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-danger, ".concat((0, $kQXTD.R400), ")"))),
            "--_r5pknd": (0, $7watR.default)("var(--ds-background-disabled, ".concat((0, $kQXTD.N20), ")")),
            "--_1z08gfx": (0, $7watR.default)("var(--ds-background-input-hovered, ".concat((0, $kQXTD.N30), ")")),
            "--_vrm7dk": (0, $7watR.default)("var(--ds-text-subtlest, ".concat((0, $kQXTD.N200), ")")),
            "--_dqsusn": (0, $7watR.default)("".concat($daa15d4c83057201$var$lineHeightCompact * minimumRows + $daa15d4c83057201$var$compactVerticalPadding * 2 + borderHeight * 2, "px")),
            "--_n9nqvh": (0, $7watR.default)("".concat($daa15d4c83057201$var$lineHeightBase * minimumRows + $daa15d4c83057201$var$verticalPadding * 2 + borderHeight * 2, "px"))
        })
    }));
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ var $daa15d4c83057201$var$TextArea = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($daa15d4c83057201$var$InnerTextArea, (0, $efs8s.default)({
        ref: ref
    }, props));
}));
$daa15d4c83057201$var$TextArea.displayName = 'TextArea';
var $daa15d4c83057201$export$2e2bcd8739ae039 = $daa15d4c83057201$var$TextArea;

});
parcelRegister("jf44d", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e02292a371fa8824$export$2e2bcd8739ae039; });
const $e02292a371fa8824$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $e02292a371fa8824$var$ATOMIC_GROUP_LENGTH = 5;
function $e02292a371fa8824$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $e02292a371fa8824$var$UNDERSCORE_UNICODE ? $e02292a371fa8824$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("7watR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5793a6c72492fafb$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $5793a6c72492fafb$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("3XlEJ", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $2e17ae3598e6b517$export$a4687b0234b40e28; });

var $9Sn3s = parcelRequire("9Sn3s");

var $1oC0p = parcelRequire("1oC0p");

var $9jjdy = parcelRequire("9jjdy");

var $j2lYd = parcelRequire("j2lYd");
function $2e17ae3598e6b517$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2e17ae3598e6b517$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2e17ae3598e6b517$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e17ae3598e6b517$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2e17ae3598e6b517$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $9jjdy.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $j2lYd.useTrackedRef)(analyticsData);
    var fnRef = (0, $j2lYd.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $2e17ae3598e6b517$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("9jjdy", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $6c74cb9b90ec0a4e$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $4NCrl = parcelRequire("4NCrl");

var $adflW = parcelRequire("adflW");
function $6c74cb9b90ec0a4e$export$5bf35293e545f20c() {
    var analyticsContext = (0, $adflW.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $4NCrl.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("4NCrl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $37e98e6fe81b6dde$export$2e2bcd8739ae039; });

var $342Py = parcelRequire("342Py");

var $3AhEU = parcelRequire("3AhEU");

var $gWIyR = parcelRequire("gWIyR");

var $ciMo5 = parcelRequire("ciMo5");

var $g9Nc1 = parcelRequire("g9Nc1");

var $9kUlu = parcelRequire("9kUlu");

var $c3W0a = parcelRequire("c3W0a");

var $9Sn3s = parcelRequire("9Sn3s");

var $fm3nt = parcelRequire("fm3nt");
function $37e98e6fe81b6dde$var$_callSuper(t, o, e) {
    return o = (0, $g9Nc1.default)(o), (0, $ciMo5.default)(t, $37e98e6fe81b6dde$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $g9Nc1.default)(t).constructor) : o.apply(t, e));
}
function $37e98e6fe81b6dde$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($37e98e6fe81b6dde$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $37e98e6fe81b6dde$var$_superPropGet(t, o, e, r) {
    var p = (0, $9kUlu.default)((0, $g9Nc1.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $37e98e6fe81b6dde$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $37e98e6fe81b6dde$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $37e98e6fe81b6dde$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $3AhEU.default)(this, UIAnalyticsEvent);
        _this = $37e98e6fe81b6dde$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $9Sn3s.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $9Sn3s.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $342Py.default)(_this.context);
            var handlers = (0, $342Py.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $9Sn3s.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $c3W0a.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $gWIyR.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $37e98e6fe81b6dde$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $fm3nt.default));

});
parcelRegister("fm3nt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b2db87cc5ac8a8ac$export$2e2bcd8739ae039; });

var $6DX60 = parcelRequire("6DX60");

var $3AhEU = parcelRequire("3AhEU");

var $gWIyR = parcelRequire("gWIyR");

var $9Sn3s = parcelRequire("9Sn3s");
function $b2db87cc5ac8a8ac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b2db87cc5ac8a8ac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b2db87cc5ac8a8ac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Sn3s.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b2db87cc5ac8a8ac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b2db87cc5ac8a8ac$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $b2db87cc5ac8a8ac$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $b2db87cc5ac8a8ac$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $3AhEU.default)(this, AnalyticsEvent);
        (0, $9Sn3s.default)(this, "_isAnalyticsEvent", true);
        (0, $9Sn3s.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $b2db87cc5ac8a8ac$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $gWIyR.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $6DX60.default)(updater) === 'object') this.payload = $b2db87cc5ac8a8ac$var$_objectSpread($b2db87cc5ac8a8ac$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("adflW", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $76f70707a033deda$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $76f70707a033deda$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("j2lYd", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $ddbf3f0cf80fd0e9$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $ddbf3f0cf80fd0e9$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("kQXTD", function(module, exports) {
$parcel$export(module.exports, "R400", function () { return $f2e7202209702c38$export$2010d0fb4295b346; });
$parcel$export(module.exports, "B200", function () { return $f2e7202209702c38$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $f2e7202209702c38$export$29a4f05edc054374; });
$parcel$export(module.exports, "N10", function () { return $f2e7202209702c38$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $f2e7202209702c38$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $f2e7202209702c38$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N70", function () { return $f2e7202209702c38$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N200", function () { return $f2e7202209702c38$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N900", function () { return $f2e7202209702c38$export$fbda843f0a27fe96; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $f2e7202209702c38$export$4b84fd0e2c617bd = '#FFEBE6';
var $f2e7202209702c38$export$b34b069eff244586 = '#FFBDAD';
var $f2e7202209702c38$export$be802dd0d8b57f35 = '#FF8F73';
var $f2e7202209702c38$export$60847d42f9da92a6 = '#FF7452';
var $f2e7202209702c38$export$4a7404f376229999 = '#FF5630';
var $f2e7202209702c38$export$2010d0fb4295b346 = '#DE350B';
var $f2e7202209702c38$export$2837b5a1a71d5c02 = '#BF2600';
var $f2e7202209702c38$export$8d9596b529bbb9cf = '#FFFAE6';
var $f2e7202209702c38$export$41060a744ab0b7ae = '#FFF0B3';
var $f2e7202209702c38$export$1cc05bbbf340e559 = '#FFE380';
var $f2e7202209702c38$export$5aae31392d72caaa = '#FFC400';
var $f2e7202209702c38$export$c6930421db9fa514 = '#FFAB00';
var $f2e7202209702c38$export$59619663aa6500fb = '#FF991F';
var $f2e7202209702c38$export$874739ea9e379ab6 = '#FF8B00';
var $f2e7202209702c38$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $f2e7202209702c38$export$69a3bf21b9686c2b = '#ABF5D1';
var $f2e7202209702c38$export$afbce1382ec95f73 = '#79F2C0';
var $f2e7202209702c38$export$747d86715d4175de = '#57D9A3';
var $f2e7202209702c38$export$940e1f69e873f202 = '#36B37E';
var $f2e7202209702c38$export$a49394138f7b8e85 = '#00875A';
var $f2e7202209702c38$export$6fa04827ac68a4fb = '#006644';
var $f2e7202209702c38$export$226de0355ed012f8 = '#DEEBFF';
var $f2e7202209702c38$export$8c13c2ee36917869 = '#B3D4FF';
var $f2e7202209702c38$export$ecfc1dff386a3e7a = '#4C9AFF';
var $f2e7202209702c38$export$215b7063051591f1 = '#2684FF';
var $f2e7202209702c38$export$e62e8919cca44969 = '#0065FF';
var $f2e7202209702c38$export$b3de0ae08da2ce64 = '#0052CC';
var $f2e7202209702c38$export$a6ee3d71bc067634 = '#0747A6';
var $f2e7202209702c38$export$67f15409e87642a1 = '#669DF1';
var $f2e7202209702c38$export$f0539dbc42dbb067 = '#8FB8F6';
var $f2e7202209702c38$export$363e4475840015bb = '#EAE6FF';
var $f2e7202209702c38$export$4b0a4417ed59760f = '#C0B6F2';
var $f2e7202209702c38$export$6011520a64d9a187 = '#998DD9';
var $f2e7202209702c38$export$a7175d4e9206bc80 = '#8777D9';
var $f2e7202209702c38$export$b48405b95304b5a1 = '#6554C0';
var $f2e7202209702c38$export$c71e4279dd54a18d = '#5243AA';
var $f2e7202209702c38$export$147899de772240ec = '#403294';
var $f2e7202209702c38$export$2cf711fe14c66f06 = '#E6FCFF';
var $f2e7202209702c38$export$7a8f4d33f6f9772c = '#B3F5FF';
var $f2e7202209702c38$export$776c9c497ef08533 = '#79E2F2';
var $f2e7202209702c38$export$69cb3ca10c1e330e = '#00C7E6';
var $f2e7202209702c38$export$9dc1ef0f3f48059b = '#00B8D9';
var $f2e7202209702c38$export$7c835c78b6fcdef8 = '#00A3BF';
var $f2e7202209702c38$export$6036577f95c3877e = '#008DA6';
var $f2e7202209702c38$export$29a4f05edc054374 = '#FFFFFF';
var $f2e7202209702c38$export$e655ef011c4aa1a2 = '#FAFBFC';
var $f2e7202209702c38$export$9fdfb749e33cdf97 = '#F4F5F7';
var $f2e7202209702c38$export$3e51e8f1440314ba = '#EBECF0';
var $f2e7202209702c38$export$1ce2d1575d444ceb = '#DFE1E6';
var $f2e7202209702c38$export$8754fc7e6d8b3000 = '#C1C7D0';
var $f2e7202209702c38$export$c2e91cbeada39b8b = '#B3BAC5';
var $f2e7202209702c38$export$5f71e19f3a7ad9de = '#A5ADBA';
var $f2e7202209702c38$export$eaa8c8a70ac22806 = '#97A0AF';
var $f2e7202209702c38$export$7c87d337fb91a97d = '#8993A4';
var $f2e7202209702c38$export$d6447c357493214f = '#7A869A';
var $f2e7202209702c38$export$f563ee71e9ee74cd = '#6B778C';
var $f2e7202209702c38$export$e2ef2124cf4024b1 = '#5E6C84';
var $f2e7202209702c38$export$eece5f492e429f08 = '#505F79';
var $f2e7202209702c38$export$c39c0fe0f26207ae = '#42526E';
var $f2e7202209702c38$export$7090862dc3038a9f = '#344563';
var $f2e7202209702c38$export$ad0bacf983b7ddaa = '#253858';
var $f2e7202209702c38$export$7d61b15e0da132af = '#172B4D';
var $f2e7202209702c38$export$fbda843f0a27fe96 = '#091E42';
var $f2e7202209702c38$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $f2e7202209702c38$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $f2e7202209702c38$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $f2e7202209702c38$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $f2e7202209702c38$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $f2e7202209702c38$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $f2e7202209702c38$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $f2e7202209702c38$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $f2e7202209702c38$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $f2e7202209702c38$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $f2e7202209702c38$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $f2e7202209702c38$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $f2e7202209702c38$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $f2e7202209702c38$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $f2e7202209702c38$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $f2e7202209702c38$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $f2e7202209702c38$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $f2e7202209702c38$export$2f6319cf7d736c2a = '#E6EDFA';
var $f2e7202209702c38$export$95126bc8884d6634 = '#DCE5F5';
var $f2e7202209702c38$export$8338d8c35d44ff1 = '#CED9EB';
var $f2e7202209702c38$export$5368d76ae4fbbda7 = '#B8C7E0';
var $f2e7202209702c38$export$9f0a771d16ec8d36 = '#ABBBD6';
var $f2e7202209702c38$export$abcf8c38338b4aa5 = '#9FB0CC';
var $f2e7202209702c38$export$97e81faa16a182c7 = '#8C9CB8';
var $f2e7202209702c38$export$bfe21c59123ecf33 = '#7988A3';
var $f2e7202209702c38$export$ee82aa2ea6a1558 = '#67758F';
var $f2e7202209702c38$export$682927c6ed76be02 = '#56637A';
var $f2e7202209702c38$export$91fd9994c5be9757 = '#455166';
var $f2e7202209702c38$export$d281fbfe3cff2df6 = '#3B475C';
var $f2e7202209702c38$export$3902c91d8b98a753 = '#313D52';
var $f2e7202209702c38$export$8e8133c1ba5845b5 = '#283447';
var $f2e7202209702c38$export$33ff357f6620b39 = '#202B3D';
var $f2e7202209702c38$export$633847cf062b69e0 = '#1B2638';
var $f2e7202209702c38$export$9776a6e503bdbf76 = '#121A29';
var $f2e7202209702c38$export$6c813d5160dff5db = '#0E1624';
var $f2e7202209702c38$export$3d4f271a500072a = '#0D1424';
var $f2e7202209702c38$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $f2e7202209702c38$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $f2e7202209702c38$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $f2e7202209702c38$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $f2e7202209702c38$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $f2e7202209702c38$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $f2e7202209702c38$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $f2e7202209702c38$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $f2e7202209702c38$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $f2e7202209702c38$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $f2e7202209702c38$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $f2e7202209702c38$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $f2e7202209702c38$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $f2e7202209702c38$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $f2e7202209702c38$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $f2e7202209702c38$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $f2e7202209702c38$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $f2e7202209702c38$export$d2adc5dedf09fced = '#292A2E';
var $f2e7202209702c38$export$f51762073d2bb381 = '#94C748';
var $f2e7202209702c38$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("b30sm", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $80b05423ee50f59e$export$defe85febe8b728c; });

var $k0oFl = parcelRequire("k0oFl");
var $80b05423ee50f59e$export$defe85febe8b728c = (0, $k0oFl.defineMessages)({
    feedbackTitle: {
        id: 'feedback-collector.feedback-title',
        defaultMessage: 'Share your thoughts',
        description: 'The title shown at the top of the feedback form encouraging users to leave feedback'
    },
    enrolInResearchLabel: {
        id: 'feedback-collector.enrol-in-research.label',
        defaultMessage: "I'd like to participate in product research",
        description: 'The checkbox label letting users enrol themselves in future product research interviews'
    },
    canBeContactedLabel: {
        id: 'feedback-collector.can-be-contacted.label',
        defaultMessage: 'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <a>Atlassian Privacy Policy</a>.',
        description: 'The checkbox label to give consent to be contacted about their feedback'
    },
    canBeContactedLabelWithoutLink: {
        id: 'feedback-collector.can-be-contacted.label-without-link',
        defaultMessage: 'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy.',
        description: 'The checkbox label to give consent to be contacted about their feedback'
    },
    privacyPolicy: {
        id: 'feedback-collector.privacy-policy',
        defaultMessage: 'Atlassian Privacy Policy',
        description: 'The text content for the Privacy Policy link'
    },
    summaryPlaceholder: {
        id: 'feedback-collector.summary-placeholder',
        defaultMessage: "Let us know what's on your mind",
        description: 'The textarea label listing feedback categories (bug, suggestions, questions, comments)'
    },
    formCommentLabel: {
        id: 'feedback-collector.form.comment.label',
        defaultMessage: "Let us know what's on your mind",
        description: 'The textarea label where users can write their comment'
    },
    submitButtonLabel: {
        id: 'feedback-collector.submit-button.label',
        defaultMessage: 'Send feedback',
        description: 'The button to submit the feedback form'
    },
    cancelButtonLabel: {
        id: 'feedback-collector.cancel-button.label',
        defaultMessage: 'Cancel',
        description: 'The button to cancel feedback submission'
    },
    giveFeedback: {
        id: 'proforma-form-builder.give-feedback',
        defaultMessage: 'Give feedback',
        description: 'The button that allows users to give feedback'
    },
    formBugLabel: {
        id: 'feedback-collector.form.bug.label',
        defaultMessage: 'Describe the bug or issue',
        description: 'The textarea label where users can describe the bug or issue they have'
    },
    formSuggestionLabel: {
        id: 'feedback-collector.form.suggestion.label',
        defaultMessage: "Let us know what you'd like to improve",
        description: 'The textarea label where users can write their suggestion'
    },
    formQuestionLabel: {
        id: 'feedback-collector.form.question.label',
        defaultMessage: 'What would you like to know?',
        description: 'The textarea label where users can write their question'
    },
    formEmptyLabel: {
        id: 'feedback-collector.form.empty.label',
        defaultMessage: 'Select an option',
        description: 'The default dropdown list option'
    },
    formNotRelevantLabel: {
        id: 'feedback-collector.form.not-relevant.label',
        defaultMessage: "Wasn't relevant",
        description: 'The textarea label where users can write their not relevant feedback'
    },
    formNotAccurateLabel: {
        id: 'feedback-collector.form.not-accurate.label',
        defaultMessage: "Wasn't accurate",
        description: 'The textarea label where users can write their not accurate feedback'
    },
    formTooSlowLabel: {
        id: 'feedback-collector.form.too-slow.label',
        defaultMessage: 'Too slow',
        description: 'The textarea label where users can write their too slow feedback'
    },
    formUnhelpfulLinksLabel: {
        id: 'feedback-collector.form.unhelpful-links.label',
        defaultMessage: 'Unhelpful links',
        description: 'The textarea label where users can write their unhelpful links feedback'
    },
    formOtherLabel: {
        id: 'feedback-collector.form.other.label',
        defaultMessage: 'Other',
        description: 'The textarea label where users can write their other feedback'
    },
    selectionOptionQuestionLabel: {
        id: 'feedback-collector.option.question.label',
        defaultMessage: 'Ask a question',
        description: 'The feedback dropdown list option to ask a question'
    },
    selectionOptionCommentLabel: {
        id: 'feedback-collector.option.comment.label',
        defaultMessage: 'Leave a comment',
        description: 'The feedback dropdown list option to leave a comment'
    },
    selectionOptionBugLabel: {
        id: 'feedback-collector.option.bug.label',
        defaultMessage: 'Report a bug',
        description: 'The feedback dropdown list option to report a bug'
    },
    selectionOptionSuggestionLabel: {
        id: 'feedback-collector.option.suggestion.label',
        defaultMessage: 'Suggest an improvement',
        description: 'The feedback dropdown list option to suggest an improvement'
    },
    selectionOptionDefaultLabel: {
        id: 'feedback-collector.option.default.label',
        defaultMessage: 'Select feedback',
        description: 'The feedback dropdown list label'
    },
    selectionOptionDefaultPlaceholder: {
        id: 'feedback-collector.option.default.placeholder',
        defaultMessage: 'Choose one',
        description: 'The feedback dropdown list placeholder'
    },
    feedbackIconLabel: {
        id: 'proforma-form-builder.feedback-icon-label',
        defaultMessage: 'Feedback',
        description: 'Accessibility text used for the feedback icon'
    },
    feedbackSuccessFlagDescription: {
        id: 'feedback-collector.success-flag.description',
        defaultMessage: 'Your valuable feedback helps us continually improve our products.',
        description: 'Description shown when feedback is successfully submitted'
    },
    feedbackSuccessFlagTitle: {
        id: 'feedback-collector.success-flag.title',
        defaultMessage: 'Thanks!',
        description: 'Button to dismiss successflag flag after submitting feedback'
    },
    feedbackIsAnonymousTitle: {
        id: 'feedback-collector.anonymous.title',
        defaultMessage: 'Anonymous feedback',
        description: 'Section message title for anonymous feedback'
    },
    feedbackIsAnonymous: {
        id: 'feedback-collector.anonymous',
        defaultMessage: 'This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback',
        description: 'Notice that feedback is anonymous'
    },
    requiredFieldsSummary: {
        id: 'feedback-collector.required.fields.summary',
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Summary info of required fields asterisk.'
    },
    defaultCustomTextAreaLabel: {
        id: 'feedback-collector.default.custom.textarea.label',
        defaultMessage: "What's on your mind?",
        description: 'The textarea label where users can write their suggestion for custom feedback collector'
    },
    canBeContactedLabelAppify: {
        id: 'feedback-collector.can-be-contacted.label-appify',
        defaultMessage: 'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the <a>Atlassian Privacy Policy</a>.',
        description: 'The checkbox label to give consent to be contacted about their feedback'
    },
    canBeContactedLabelAppifyWithoutLink: {
        id: 'feedback-collector.can-be-contacted.label-appify-without-link',
        defaultMessage: 'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the Atlassian Privacy Policy.',
        description: 'The checkbox label to give consent to be contacted about their feedback'
    },
    feedbackSuccessFlagDescriptionAppify: {
        id: 'feedback-collector.success-flag.description-appify',
        defaultMessage: 'Your valuable feedback helps us continually improve our apps.',
        description: 'Description shown when feedback is successfully submitted'
    },
    validationErrorTypeRequired: {
        id: 'feedback-collector.validation.type.required',
        defaultMessage: 'Please select a feedback type',
        description: 'Error message when feedback type is not selected'
    },
    validationErrorDescriptionRequired: {
        id: 'feedback-collector.validation.description.required',
        defaultMessage: 'Please provide a description',
        description: 'Error message when description is not provided'
    }
});

});

parcelRegister("37gbk", function(module, exports) {
$parcel$export(module.exports, "IntlProviderWithResolvedMessages", function () { return $244e93e2707f90a4$export$f793de1293176fe6; });

var $8ut70 = parcelRequire("8ut70");

var $2gb89 = parcelRequire("2gb89");

var $9pTPz = parcelRequire("9pTPz");

var $1oC0p = parcelRequire("1oC0p");

var $12z4Z = parcelRequire("12z4Z");

var $1aPRr = parcelRequire("1aPRr");
var $244e93e2707f90a4$export$f793de1293176fe6 = function IntlProviderWithResolvedMessages(_ref) {
    var children = _ref.children, locale = _ref.locale;
    var _useState = (0, $1oC0p.useState)(), _useState2 = (0, $2gb89.default)(_useState, 2), resolvedMessagesForLocale = _useState2[0], setResolvedMessagesForLocale = _useState2[1];
    (0, $1oC0p.useEffect)(function() {
        var fetchMessageLocale = /*#__PURE__*/ function() {
            var _ref2 = (0, $8ut70.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9pTPz))).mark(function _callee() {
                var messages;
                return (0, (/*@__PURE__*/$parcel$interopDefault($9pTPz))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!locale) {
                                _context.next = 5;
                                break;
                            }
                            _context.next = 3;
                            return (0, $1aPRr.getMessagesForLocale)(locale);
                        case 3:
                            messages = _context.sent;
                            setResolvedMessagesForLocale(messages);
                        case 5:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function fetchMessageLocale() {
                return _ref2.apply(this, arguments);
            };
        }();
        fetchMessageLocale();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $12z4Z.default), {
        locale: locale || 'en',
        defaultLocale: "en",
        messages: resolvedMessagesForLocale
    }, children);
};

});
parcelRegister("1aPRr", function(module, exports) {
$parcel$export(module.exports, "getMessagesForLocale", function () { return $0daef425a9bbb736$export$d0a3169680473b6c; });

var $8ut70 = parcelRequire("8ut70");

var $9pTPz = parcelRequire("9pTPz");
var $0daef425a9bbb736$export$d0a3169680473b6c = /*#__PURE__*/ function() {
    var _ref = (0, $8ut70.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9pTPz))).mark(function _callee(locale) {
        var messages, parentLocale, _messages;
        return (0, (/*@__PURE__*/$parcel$interopDefault($9pTPz))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    locale = locale.replace('-', '_');
                    _context.prev = 1;
                    _context.next = 4;
                    return import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ "../i18n/".concat(locale));
                case 4:
                    messages = _context.sent;
                    return _context.abrupt("return", messages.default);
                case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](1);
                case 10:
                    _context.prev = 10;
                    parentLocale = locale.split(/[-_]/)[0];
                    _context.next = 14;
                    return import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ "../i18n/".concat(parentLocale));
                case 14:
                    _messages = _context.sent;
                    return _context.abrupt("return", _messages.default);
                case 18:
                    _context.prev = 18;
                    _context.t1 = _context["catch"](10);
                case 20:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ],
            [
                10,
                18
            ]
        ]);
    }));
    return function getMessagesForLocale(_x) {
        return _ref.apply(this, arguments);
    };
}();

});





parcelRegister("8MgQg", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $d42517faa4565188$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $d42517faa4565188$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    feedbackTitle: {
        id: "fastshift.feedback-collector.feedback-title",
        defaultMessage: "Help us improve FastShift Portal",
        description: "Title for the feedback collector"
    },
    feedbackTitleDetails: {
        id: "fastshift.feedback-collector.feedback-title-details",
        defaultMessage: "We\u2019d love to hear about your experience using FastShift Portal. ",
        description: "Details for the feedback collector title"
    }
});

});



parcelRegister("hIyw9", function(module, exports) {
$parcel$export(module.exports, "useFeedbackCollectorAnalytics", function () { return (parcelRequire("j8NTL")).useFeedbackCollectorAnalytics; });
parcelRequire("hXt7P");
var $j8NTL = parcelRequire("j8NTL");

});
parcelRegister("hXt7P", function(module, exports) {
$parcel$export(module.exports, "useFeedbackCollectorAnalytics", function () { return (parcelRequire("j8NTL")).useFeedbackCollectorAnalytics; });

var $j8NTL = parcelRequire("j8NTL");

});
parcelRegister("j8NTL", function(module, exports) {
$parcel$export(module.exports, "useFeedbackCollectorAnalytics", function () { return $fff16c0d2f1e11e5$export$c94f8da1b55a1fea; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
const $fff16c0d2f1e11e5$export$c94f8da1b55a1fea = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)(true);
    const { fireUIEvent: fireUIEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    const sendFeedbackCollectorOpenButtonClickUIEvent = (0, $1oC0p.useCallback)(()=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).FEEDBACK_COLLECTOR_OPEN_BUTTON,
            source: sourceKey
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendFeedbackCollectorSubmitButtonClickUIEvent = (0, $1oC0p.useCallback)((feedbackType)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).FEEDBACK_COLLECTOR_SUBMIT_BUTTON,
            source: sourceKey,
            attributes: {
                feedbackType: feedbackType
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    return {
        sendFeedbackCollectorOpenButtonClickUIEvent: sendFeedbackCollectorOpenButtonClickUIEvent,
        sendFeedbackCollectorSubmitButtonClickUIEvent: sendFeedbackCollectorSubmitButtonClickUIEvent
    };
};

});





parcelRegister("b6eJV", function(module, exports) {
$parcel$export(module.exports, "NavigationProfile", function () { return (parcelRequire("7ehC8")).NavigationProfile; });

var $7ehC8 = parcelRequire("7ehC8");

});
parcelRegister("7ehC8", function(module, exports) {
$parcel$export(module.exports, "NavigationProfile", function () { return $25a10c92c330bda1$export$a516508354e55db1; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $4SA4u = parcelRequire("4SA4u");

var $dTJrO = parcelRequire("dTJrO");

var $ig0gX = parcelRequire("ig0gX");
var $adr5D = parcelRequire("adr5D");
var $55VkZ = parcelRequire("55VkZ");

var $flLGf = parcelRequire("flLGf");

var $4Z5S3 = parcelRequire("4Z5S3");

var $g3ExX = parcelRequire("g3ExX");
var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");

var $fq4go = parcelRequire("fq4go");

var $3riD8 = parcelRequire("3riD8");

var $7GdwZ = parcelRequire("7GdwZ");
const $25a10c92c330bda1$var$baseStyles = (0, $f6YGh.xcss)({
    marginInline: "auto",
    width: "320px"
});
const $25a10c92c330bda1$var$avatarStyles = (0, $f6YGh.xcss)({
    paddingInlineStart: "space.200"
});
const $25a10c92c330bda1$var$LOGOUT_URL = `${(0, $fq4go.IDENTITY_BASE_URL)}/logout?continue=${encodeURIComponent(`${(0, $fq4go.BASE_URL)}/fastshift`)}`;
const $25a10c92c330bda1$var$onLogOutClick = ()=>{
    window.location.assign($25a10c92c330bda1$var$LOGOUT_URL);
};
const $25a10c92c330bda1$export$a516508354e55db1 = ()=>{
    const [isOpen, setIsOpen] = (0, $1oC0p.useState)(false);
    const intl = (0, $8e22h.default)();
    const userInfo = (0, $3riD8.useLoggedInUser)();
    const onClose = ()=>{
        setIsOpen(false);
    };
    const renderTrigger = (triggerProps)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $flLGf.Profile), (0, $dPABA._)((0, $6ogO3._)({}, triggerProps), {
            src: userInfo.picture,
            label: "Your profile and settings",
            onClick: ()=>setIsOpen((prev)=>!prev),
            testId: "profile-avatar-trigger"
        }));
    const menu = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
            xcss: $25a10c92c330bda1$var$baseStyles,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $adr5D.default), {
                testId: "profile-content",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $55VkZ.default), {
                        title: intl.formatMessage((0, $7GdwZ.messages).accountSectionTitle),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                            xcss: $25a10c92c330bda1$var$avatarStyles,
                            space: "space.200",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4SA4u.default), {
                                    size: "medium",
                                    src: userInfo.picture,
                                    name: userInfo.name
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                                            size: "small",
                                            children: userInfo.name
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                            children: userInfo.email
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $55VkZ.default), {
                        hasSeparator: true,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ig0gX.default), {
                            onClick: $25a10c92c330bda1$var$onLogOutClick,
                            testId: "logout-button",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $7GdwZ.messages).profileLogout))
                        })
                    })
                ]
            })
        });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Z5S3.Popup), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-end",
        zIndex: 1000,
        content: menu,
        trigger: renderTrigger
    });
};

});
parcelRegister("ig0gX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d4a9eec0738b95f1$export$2e2bcd8739ae039; });

var $5OBHa = parcelRequire("5OBHa");

var $6bGSd = parcelRequire("6bGSd");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $8PfSM = parcelRequire("8PfSM");

var $4i1Fo = parcelRequire("4i1Fo");

var $jmlTB = parcelRequire("jmlTB");

var $39c3M = parcelRequire("39c3M");

var $evajR = parcelRequire("evajR");
var $d4a9eec0738b95f1$var$_excluded = [
    "children",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $d4a9eec0738b95f1$var$ButtonItem = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $4i1Fo.default) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, $6bGSd.default)(props, $d4a9eec0738b95f1$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $1oC0p.useContext)((0, $jmlTB.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    (0, $8PfSM.propDeprecationWarning)("@atlaskit/menu", 'cssFn', cssFn !== (0, $4i1Fo.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $3dJ4i.jsx)((0, $evajR.default), (0, $5OBHa.default)({
        className: UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $3dJ4i.jsx)("button", (0, $5OBHa.default)({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: (0, $39c3M.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $d4a9eec0738b95f1$export$2e2bcd8739ae039 = $d4a9eec0738b95f1$var$ButtonItem;

});
parcelRegister("5OBHa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $43bedcc0df839c44$export$2e2bcd8739ae039; });
function $43bedcc0df839c44$export$2e2bcd8739ae039() {
    return $43bedcc0df839c44$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $43bedcc0df839c44$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("6bGSd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $481506f06ab48ab6$export$2e2bcd8739ae039; });

var $aZX3G = parcelRequire("aZX3G");
function $481506f06ab48ab6$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $aZX3G.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("aZX3G", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $801d69aa784903b1$export$2e2bcd8739ae039; });
function $801d69aa784903b1$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("8PfSM", function(module, exports) {
$parcel$export(module.exports, "propDeprecationWarning", function () { return $66cf6811687b70ed$export$eb1decd851a5ae56; });

var $gml15 = parcelRequire("gml15");

var $7t0tI = parcelRequire("7t0tI");
function $66cf6811687b70ed$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $gml15.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $66cf6811687b70ed$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("gml15", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $be8f00db2794d560$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $be8f00db2794d560$var$printed = {};
function $be8f00db2794d560$export$2e2bcd8739ae039(message) {
    if ($be8f00db2794d560$var$printed[message]) return;
    $be8f00db2794d560$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});


parcelRegister("4i1Fo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $31fa22d344b1dd58$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $31fa22d344b1dd58$export$2e2bcd8739ae039() {}

});

parcelRegister("jmlTB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e1810e6c3b1680a9$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $e1810e6c3b1680a9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("evajR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a8ebf7295f176145$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $8PfSM = parcelRequire("8PfSM");

var $ezcrP = parcelRequire("ezcrP");

var $lQZRh = parcelRequire("lQZRh");
var $WXxGK = parcelRequire("WXxGK");
var $hYcxk = parcelRequire("hYcxk");

var $16qju = parcelRequire("16qju");

var $rX2Mz = parcelRequire("rX2Mz");
var $a8ebf7295f176145$var$defaultRender = function defaultRender(Component, props) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $3dJ4i.jsx)(Component, props));
};
var $a8ebf7295f176145$var$beforeAfterElementStyles = (0, $3dJ4i.css)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
});
var $a8ebf7295f176145$var$contentStyles = (0, $hYcxk.xcss)({
    outline: 'none',
    overflow: 'hidden',
    textAlign: 'left'
});
var $a8ebf7295f176145$var$truncateStyles = (0, $3dJ4i.css)({
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $a8ebf7295f176145$var$titleStyles = (0, $3dJ4i.css)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
var $a8ebf7295f176145$var$wordBreakStyles = (0, $3dJ4i.css)({
    wordBreak: 'break-word'
});
var $a8ebf7295f176145$var$descriptionStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtlest, ".concat((0, $16qju.N200), ")"),
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
var $a8ebf7295f176145$var$disabledDescriptionStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-disabled, ".concat((0, $16qju.N200), ")")
});
var $a8ebf7295f176145$var$positionRelativeStyles = (0, $3dJ4i.css)({
    position: 'relative'
});
var $a8ebf7295f176145$var$primitiveStyles = (0, $3dJ4i.css)({
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%',
    minHeight: 40,
    margin: "var(--ds-space-0, 0px)",
    alignItems: 'center',
    border: 0,
    outline: 0,
    textDecoration: 'none',
    userSelect: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:hover': {
        textDecoration: 'none'
    }
});
var $a8ebf7295f176145$var$spacingMapStyles = {
    cozy: (0, $3dJ4i.css)({
        // 8 * 2 (16) + icon (24) === 40
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-200, 16px)"
    }),
    compact: (0, $3dJ4i.css)({
        minHeight: 32,
        // 4 * 2 (8) + icon (24) === 32
        paddingBlock: "var(--ds-space-050, 4px)",
        paddingInline: "var(--ds-space-150, 12px)"
    })
};
var $a8ebf7295f176145$var$interactiveStyles = (0, $3dJ4i.css)({
    cursor: 'pointer'
});
var $a8ebf7295f176145$var$unselectedStyles = (0, $3dJ4i.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: 'currentColor',
    '&:visited': {
        color: 'currentColor'
    },
    '&:hover': {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat((0, $16qju.N20), ")"),
        color: 'currentColor'
    },
    '&:active': {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, ".concat((0, $16qju.N30), ")"),
        boxShadow: 'none',
        color: 'currentColor'
    }
});
var $a8ebf7295f176145$var$disabledStyles = (0, $3dJ4i.css)({
    cursor: 'not-allowed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&, :hover, :active': {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: "var(--ds-text-disabled, ".concat((0, $16qju.N200), ")")
    }
});
var $a8ebf7295f176145$var$selectedBorderStyles = (0, $3dJ4i.css)({
    '&::before': {
        width: 2,
        position: 'absolute',
        background: "var(--ds-border-selected, transparent)",
        content: '""',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: 0
    }
});
var $a8ebf7295f176145$var$selectedNotchStyles = (0, $3dJ4i.css)({
    '&::before': {
        width: 4,
        position: 'absolute',
        background: "var(--ds-border-selected, transparent)",
        borderRadius: "0 ".concat("var(--ds-border-radius, 4px)", " ", "var(--ds-border-radius, 4px)", " 0"),
        content: '""',
        insetBlockEnd: "var(--ds-space-150, 12px)",
        insetBlockStart: "var(--ds-space-150, 12px)",
        insetInlineStart: 0
    }
});
var $a8ebf7295f176145$var$selectedStyles = (0, $3dJ4i.css)({
    backgroundColor: "var(--ds-background-selected, ".concat((0, $16qju.N20), ")"),
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    '&:visited': {
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:hover': {
        backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $16qju.N20), ")"),
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:active': {
        backgroundColor: "var(--ds-background-selected-pressed, ".concat((0, $16qju.N30), ")"),
        color: "var(--ds-text-selected, currentColor)"
    }
});
var $a8ebf7295f176145$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $a8ebf7295f176145$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, testId = _ref.testId;
    (0, $8PfSM.propDeprecationWarning)("@atlaskit/menu", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var spacing = (0, $1oC0p.useContext)((0, $rX2Mz.SpacingContext));
    var selectionStyle = (0, $1oC0p.useContext)((0, $rX2Mz.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    var renderTitle = overrides && overrides.Title && overrides.Title.render || $a8ebf7295f176145$var$defaultRender;
    var UNSAFE_className = UNSAFE_externalClassName;
    return (0, $3dJ4i.jsx)((0, $3dJ4i.ClassNames), null, function(_ref2) {
        var cn = _ref2.css, cx = _ref2.cx;
        return (0, $3dJ4i.jsx)((0, $ezcrP.default), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $a8ebf7295f176145$var$positionRelativeStyles,
                    $a8ebf7295f176145$var$primitiveStyles,
                    $a8ebf7295f176145$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $a8ebf7295f176145$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $a8ebf7295f176145$var$selectedStyles,
                        [
                            selectionStyle === 'border' && $a8ebf7295f176145$var$selectedBorderStyles,
                            selectionStyle === 'notch' && $a8ebf7295f176145$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $a8ebf7295f176145$var$disabledStyles : $a8ebf7295f176145$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: (0, $3dJ4i.jsx)((0, $lQZRh.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $a8ebf7295f176145$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && (0, $3dJ4i.jsx)("span", {
                "data-item-elem-before": true,
                css: $a8ebf7295f176145$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-before")
            }, iconBefore), title && (0, $3dJ4i.jsx)((0, $WXxGK.default), {
                alignBlock: "center",
                grow: "fill",
                xcss: $a8ebf7295f176145$var$contentStyles
            }, renderTitle('span', {
                children: title,
                className: cn($a8ebf7295f176145$var$titleStyles, shouldTitleWrap ? $a8ebf7295f176145$var$wordBreakStyles : $a8ebf7295f176145$var$truncateStyles),
                'data-item-title': true
            }), description && (0, $3dJ4i.jsx)("span", {
                "data-item-description": true,
                css: [
                    $a8ebf7295f176145$var$descriptionStyles,
                    isDisabled && $a8ebf7295f176145$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $a8ebf7295f176145$var$wordBreakStyles : $a8ebf7295f176145$var$truncateStyles
                ]
            }, description)), iconAfter && (0, $3dJ4i.jsx)("span", {
                "data-item-elem-after": true,
                css: $a8ebf7295f176145$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-after")
            }, iconAfter))
        }));
    });
};
var $a8ebf7295f176145$export$2e2bcd8739ae039 = $a8ebf7295f176145$var$MenuItemPrimitive;

});
parcelRegister("ezcrP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a9adfd78bf23e555$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");
var $a9adfd78bf23e555$var$BORDER_WIDTH = 2;
var $a9adfd78bf23e555$var$baseFocusOutsideStyles = (0, $3dJ4i.css)({
    outline: "".concat($a9adfd78bf23e555$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $a9adfd78bf23e555$var$BORDER_WIDTH
});
var $a9adfd78bf23e555$var$baseInsetStyles = (0, $3dJ4i.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$a9adfd78bf23e555$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $a9adfd78bf23e555$var$focusRingStyles = (0, $3dJ4i.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $a9adfd78bf23e555$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $a9adfd78bf23e555$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $a9adfd78bf23e555$var$insetFocusRingStyles = (0, $3dJ4i.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $a9adfd78bf23e555$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $a9adfd78bf23e555$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $a9adfd78bf23e555$var$FocusRing = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $a9adfd78bf23e555$var$baseInsetStyles : $a9adfd78bf23e555$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $a9adfd78bf23e555$var$insetFocusRingStyles : $a9adfd78bf23e555$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $3dJ4i.jsx)((0, $3dJ4i.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $1oC0p.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $1oC0p.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$a9adfd78bf23e555$var$FocusRing.displayName = 'FocusRing';
var $a9adfd78bf23e555$export$2e2bcd8739ae039 = $a9adfd78bf23e555$var$FocusRing;

});

parcelRegister("lQZRh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fe8e701b37b321fb$export$2e2bcd8739ae039; });

var $1JoDH = parcelRequire("1JoDH");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $hYcxk = parcelRequire("hYcxk");

var $fO71G = parcelRequire("fO71G");
var $fe8e701b37b321fb$var$flexGrowMap = {
    hug: (0, $hYcxk.xcss)({
        flexGrow: 0
    }),
    fill: (0, $hYcxk.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $fe8e701b37b321fb$var$separatorStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $fe8e701b37b321fb$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $3dJ4i.jsx)("span", {
        css: $fe8e701b37b321fb$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $fe8e701b37b321fb$var$Inline = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $3dJ4i.jsx)($fe8e701b37b321fb$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $1oC0p.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $fe8e701b37b321fb$var$flexGrowMap[grow]
    ].concat((0, $1JoDH.default)(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $3dJ4i.jsx)((0, $fO71G.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$fe8e701b37b321fb$var$Inline.displayName = 'Inline';
var $fe8e701b37b321fb$export$2e2bcd8739ae039 = $fe8e701b37b321fb$var$Inline;

});
parcelRegister("1JoDH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $142d1b4526aa70ea$export$2e2bcd8739ae039; });

var $7DFP1 = parcelRequire("7DFP1");

var $6FC2w = parcelRequire("6FC2w");

var $fZsvW = parcelRequire("fZsvW");

var $ethkR = parcelRequire("ethkR");
function $142d1b4526aa70ea$export$2e2bcd8739ae039(r) {
    return (0, $7DFP1.default)(r) || (0, $6FC2w.default)(r) || (0, $fZsvW.default)(r) || (0, $ethkR.default)();
}

});
parcelRegister("7DFP1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $58fc9de6b6e7f6a6$export$2e2bcd8739ae039; });

var $dfQUv = parcelRequire("dfQUv");
function $58fc9de6b6e7f6a6$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $dfQUv.default)(r);
}

});
parcelRegister("dfQUv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9a65b8001d00db29$export$2e2bcd8739ae039; });
function $9a65b8001d00db29$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("6FC2w", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4db4144a18057b98$export$2e2bcd8739ae039; });
function $4db4144a18057b98$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("fZsvW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ba42abd7a5fdfc31$export$2e2bcd8739ae039; });

var $dfQUv = parcelRequire("dfQUv");
function $ba42abd7a5fdfc31$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $dfQUv.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $dfQUv.default)(r, a) : void 0;
    }
}

});

parcelRegister("ethkR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a89138997d435123$export$2e2bcd8739ae039; });
function $a89138997d435123$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("hYcxk", function(module, exports) {
$parcel$export(module.exports, "parseXcss", function () { return $d151c3c9361e915d$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $d151c3c9361e915d$export$f6c783d06584602c; });

var $1JoDH = parcelRequire("1JoDH");

var $8jLCr = parcelRequire("8jLCr");

var $9O9Xs = parcelRequire("9O9Xs");

var $faKxe = parcelRequire("faKxe");

var $3dJ4i = parcelRequire("3dJ4i");

var $bAJuw = parcelRequire("bAJuw");

var $7t0tI = parcelRequire("7t0tI");
function $d151c3c9361e915d$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $d151c3c9361e915d$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $d151c3c9361e915d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d151c3c9361e915d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d151c3c9361e915d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d151c3c9361e915d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $d151c3c9361e915d$export$9a199fbafee0014e = {
    backgroundColor: (0, $bAJuw.backgroundColorMap),
    blockSize: (0, $bAJuw.dimensionMap),
    borderBlockColor: (0, $bAJuw.borderColorMap),
    borderBlockEndColor: (0, $bAJuw.borderColorMap),
    borderBlockEndWidth: (0, $bAJuw.borderWidthMap),
    borderBlockStartColor: (0, $bAJuw.borderColorMap),
    borderBlockStartWidth: (0, $bAJuw.borderWidthMap),
    borderBlockWidth: (0, $bAJuw.borderWidthMap),
    borderBottomColor: (0, $bAJuw.borderColorMap),
    borderBottomLeftRadius: (0, $bAJuw.borderRadiusMap),
    borderBottomRightRadius: (0, $bAJuw.borderRadiusMap),
    borderBottomWidth: (0, $bAJuw.borderWidthMap),
    borderColor: (0, $bAJuw.borderColorMap),
    borderEndEndRadius: (0, $bAJuw.borderRadiusMap),
    borderEndStartRadius: (0, $bAJuw.borderRadiusMap),
    borderInlineColor: (0, $bAJuw.borderColorMap),
    borderInlineEndColor: (0, $bAJuw.borderColorMap),
    borderInlineEndWidth: (0, $bAJuw.borderWidthMap),
    borderInlineStartColor: (0, $bAJuw.borderColorMap),
    borderInlineStartWidth: (0, $bAJuw.borderWidthMap),
    borderInlineWidth: (0, $bAJuw.borderWidthMap),
    borderLeftColor: (0, $bAJuw.borderColorMap),
    borderLeftWidth: (0, $bAJuw.borderWidthMap),
    borderRadius: (0, $bAJuw.borderRadiusMap),
    borderRightColor: (0, $bAJuw.borderColorMap),
    borderRightWidth: (0, $bAJuw.borderWidthMap),
    borderStartEndRadius: (0, $bAJuw.borderRadiusMap),
    borderStartStartRadius: (0, $bAJuw.borderRadiusMap),
    borderTopColor: (0, $bAJuw.borderColorMap),
    borderTopLeftRadius: (0, $bAJuw.borderRadiusMap),
    borderTopRightRadius: (0, $bAJuw.borderRadiusMap),
    borderTopWidth: (0, $bAJuw.borderWidthMap),
    borderWidth: (0, $bAJuw.borderWidthMap),
    bottom: (0, $bAJuw.allSpaceMap),
    boxShadow: (0, $bAJuw.shadowMap),
    color: (0, $bAJuw.textColorMap),
    columnGap: (0, $bAJuw.positiveSpaceMap),
    font: (0, $bAJuw.fontMap),
    fontFamily: (0, $bAJuw.fontFamilyMap),
    fontWeight: (0, $bAJuw.fontWeightMap),
    gap: (0, $bAJuw.positiveSpaceMap),
    height: (0, $bAJuw.dimensionMap),
    inlineSize: (0, $bAJuw.dimensionMap),
    inset: (0, $bAJuw.allSpaceMap),
    insetBlock: (0, $bAJuw.allSpaceMap),
    insetBlockEnd: (0, $bAJuw.allSpaceMap),
    insetBlockStart: (0, $bAJuw.allSpaceMap),
    insetInline: (0, $bAJuw.allSpaceMap),
    insetInlineEnd: (0, $bAJuw.allSpaceMap),
    insetInlineStart: (0, $bAJuw.allSpaceMap),
    left: (0, $bAJuw.allSpaceMap),
    margin: (0, $bAJuw.allSpaceMap),
    marginBlock: (0, $bAJuw.allSpaceMap),
    marginBlockEnd: (0, $bAJuw.allSpaceMap),
    marginBlockStart: (0, $bAJuw.allSpaceMap),
    marginBottom: (0, $bAJuw.allSpaceMap),
    marginInline: (0, $bAJuw.allSpaceMap),
    marginInlineEnd: (0, $bAJuw.allSpaceMap),
    marginInlineStart: (0, $bAJuw.allSpaceMap),
    marginLeft: (0, $bAJuw.allSpaceMap),
    marginRight: (0, $bAJuw.allSpaceMap),
    marginTop: (0, $bAJuw.allSpaceMap),
    maxBlockSize: (0, $bAJuw.dimensionMap),
    maxHeight: (0, $bAJuw.dimensionMap),
    maxInlineSize: (0, $bAJuw.dimensionMap),
    maxWidth: (0, $bAJuw.dimensionMap),
    minBlockSize: (0, $bAJuw.dimensionMap),
    minHeight: (0, $bAJuw.dimensionMap),
    minInlineSize: (0, $bAJuw.dimensionMap),
    minWidth: (0, $bAJuw.dimensionMap),
    opacity: (0, $bAJuw.opacityMap),
    outlineColor: (0, $bAJuw.borderColorMap),
    outlineOffset: (0, $bAJuw.positiveSpaceMap),
    outlineWidth: (0, $bAJuw.borderWidthMap),
    padding: (0, $bAJuw.positiveSpaceMap),
    paddingBlock: (0, $bAJuw.positiveSpaceMap),
    paddingBlockEnd: (0, $bAJuw.positiveSpaceMap),
    paddingBlockStart: (0, $bAJuw.positiveSpaceMap),
    paddingBottom: (0, $bAJuw.positiveSpaceMap),
    paddingInline: (0, $bAJuw.positiveSpaceMap),
    paddingInlineEnd: (0, $bAJuw.positiveSpaceMap),
    paddingInlineStart: (0, $bAJuw.positiveSpaceMap),
    paddingLeft: (0, $bAJuw.positiveSpaceMap),
    paddingRight: (0, $bAJuw.positiveSpaceMap),
    paddingTop: (0, $bAJuw.positiveSpaceMap),
    right: (0, $bAJuw.allSpaceMap),
    rowGap: (0, $bAJuw.positiveSpaceMap),
    top: (0, $bAJuw.allSpaceMap),
    width: (0, $bAJuw.dimensionMap),
    zIndex: (0, $bAJuw.layerMap)
};
var $d151c3c9361e915d$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $d151c3c9361e915d$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $7t0tI === "undefined" ? "undefined" : (0, $faKxe.default)($7t0tI)) === 'object' && (0, $faKxe.default)($7t0tI.env) === 'object' && false;
};
var $d151c3c9361e915d$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $d151c3c9361e915d$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $d151c3c9361e915d$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $faKxe.default)(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($d151c3c9361e915d$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $9O9Xs.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $faKxe.default)(value) === 'object' && $d151c3c9361e915d$var$safeSelectors.test(key)) {
            styleObj[key] = $d151c3c9361e915d$var$_transformStyles(value);
            return;
        }
        if ($d151c3c9361e915d$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($d151c3c9361e915d$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $d151c3c9361e915d$export$9a199fbafee0014e)) return;
        var tokenValue = $d151c3c9361e915d$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $d151c3c9361e915d$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $d151c3c9361e915d$var$_transformStyles(style);
    return (0, $8jLCr.default)({}, $d151c3c9361e915d$var$uniqueSymbol, (0, $3dJ4i.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $d151c3c9361e915d$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $d151c3c9361e915d$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $d151c3c9361e915d$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $1JoDH.default)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$d151c3c9361e915d$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $d151c3c9361e915d$export$f6c783d06584602c(style) {
    return $d151c3c9361e915d$var$baseXcss(style);
}

});
parcelRegister("8jLCr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $60e5093f2cbce6a7$export$2e2bcd8739ae039; });

var $jZZiw = parcelRequire("jZZiw");
function $60e5093f2cbce6a7$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $jZZiw.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("jZZiw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e8f3434d0541f99f$export$2e2bcd8739ae039; });

var $faKxe = parcelRequire("faKxe");

var $5bJWB = parcelRequire("5bJWB");
function $e8f3434d0541f99f$export$2e2bcd8739ae039(t) {
    var i = (0, $5bJWB.default)(t, "string");
    return "symbol" == (0, $faKxe.default)(i) ? i : i + "";
}

});
parcelRegister("faKxe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b0bbe30d0718e616$export$2e2bcd8739ae039; });
function $b0bbe30d0718e616$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b0bbe30d0718e616$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b0bbe30d0718e616$export$2e2bcd8739ae039(o);
}

});

parcelRegister("5bJWB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3c719e6522fdc3da$export$2e2bcd8739ae039; });

var $faKxe = parcelRequire("faKxe");
function $3c719e6522fdc3da$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $faKxe.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $faKxe.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("9O9Xs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7240820330b906d6$export$2e2bcd8739ae039; });

var $8qaFy = parcelRequire("8qaFy");

var $4dPCZ = parcelRequire("4dPCZ");

var $fZsvW = parcelRequire("fZsvW");

var $64qaF = parcelRequire("64qaF");
function $7240820330b906d6$export$2e2bcd8739ae039(r, e) {
    return (0, $8qaFy.default)(r) || (0, $4dPCZ.default)(r, e) || (0, $fZsvW.default)(r, e) || (0, $64qaF.default)();
}

});
parcelRegister("8qaFy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6219071e54e3c34a$export$2e2bcd8739ae039; });
function $6219071e54e3c34a$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("4dPCZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $31306c860b01e929$export$2e2bcd8739ae039; });
function $31306c860b01e929$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("64qaF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0123fd9812eaff1e$export$2e2bcd8739ae039; });
function $0123fd9812eaff1e$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bAJuw", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", function () { return $87065822f440998a$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $87065822f440998a$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $87065822f440998a$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $87065822f440998a$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $87065822f440998a$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $87065822f440998a$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $87065822f440998a$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $87065822f440998a$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $87065822f440998a$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $87065822f440998a$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $87065822f440998a$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $87065822f440998a$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $87065822f440998a$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $87065822f440998a$export$3c7e9587132614b4; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $87065822f440998a$export$bf46c3f9eeafc71f; });

var $8jLCr = parcelRequire("8jLCr");

var $3dJ4i = parcelRequire("3dJ4i");

var $c2pR8 = parcelRequire("c2pR8");
function $87065822f440998a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $87065822f440998a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $87065822f440998a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $8jLCr.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $87065822f440998a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $87065822f440998a$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $87065822f440998a$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $87065822f440998a$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $87065822f440998a$export$632685d741f3dbbf = $87065822f440998a$var$_objectSpread($87065822f440998a$var$_objectSpread({}, $87065822f440998a$export$958d0ae7f2977ae4), $87065822f440998a$export$d2dc61f58390201c);
var $87065822f440998a$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $87065822f440998a$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $87065822f440998a$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $87065822f440998a$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $87065822f440998a$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $87065822f440998a$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $87065822f440998a$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $87065822f440998a$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $87065822f440998a$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $87065822f440998a$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $87065822f440998a$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $87065822f440998a$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $87065822f440998a$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $87065822f440998a$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $87065822f440998a$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $87065822f440998a$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $87065822f440998a$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $87065822f440998a$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $3dJ4i.css)((0, $8jLCr.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $87065822f440998a$export$e615f061ca585a6c = $87065822f440998a$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $87065822f440998a$export$ca0f9c2de39ffed7(spacingProperty, $87065822f440998a$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $87065822f440998a$export$bf46c3f9eeafc71f = $87065822f440998a$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $87065822f440998a$export$ca0f9c2de39ffed7(spacingProperty, $87065822f440998a$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $87065822f440998a$export$e7af83bafe7f9e63 = $87065822f440998a$export$ca0f9c2de39ffed7('backgroundColor', $87065822f440998a$export$d1d79bf68ac056bd);
var $87065822f440998a$export$3a1bcba60b23d7f0 = $87065822f440998a$export$ca0f9c2de39ffed7('color', $87065822f440998a$export$8473307aa00d6ea1);
var $87065822f440998a$export$45f3f4fe16f9f7d5 = $87065822f440998a$export$ca0f9c2de39ffed7('fontWeight', $87065822f440998a$export$303e322c6b1ed114);
var $87065822f440998a$export$68cc305da27dbaa4 = $87065822f440998a$export$ca0f9c2de39ffed7('fontFamily', $87065822f440998a$export$3c7e9587132614b4);
var $87065822f440998a$export$128f10c238242f83 = $87065822f440998a$export$ca0f9c2de39ffed7('font', $87065822f440998a$export$6ffa317d5e70375);
var $87065822f440998a$export$219d364c0da35ae4 = $87065822f440998a$export$ca0f9c2de39ffed7('font', $87065822f440998a$export$236bfe3a33ef1292);
var $87065822f440998a$export$38845ca010b93505 = $87065822f440998a$export$ca0f9c2de39ffed7('fontWeight', $87065822f440998a$export$855cfd311192d666);
var $87065822f440998a$export$ff257d957d48c421 = $87065822f440998a$export$ca0f9c2de39ffed7((0, $c2pR8.CURRENT_SURFACE_CSS_VAR), $87065822f440998a$export$41a358c9c2356760);
var $87065822f440998a$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $87065822f440998a$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("c2pR8", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $8c39ba654e3e590a$export$9d7b58831ae93caa; });
var $8c39ba654e3e590a$export$4ef52930e33717cd = 'data-theme';
var $8c39ba654e3e590a$export$a00eac3f8684bcd0 = 'data-color-mode';
var $8c39ba654e3e590a$export$2112803007239c61 = 'data-contrast-mode';
var $8c39ba654e3e590a$export$352e418ed5b6193a = 'data-custom-theme';
var $8c39ba654e3e590a$export$2faeed762aac6741 = 'light';
var $8c39ba654e3e590a$export$6f0c6fb8c80fcc92 = 'ds';
var $8c39ba654e3e590a$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $8c39ba654e3e590a$export$dddac1532e822863 = "--".concat($8c39ba654e3e590a$export$6f0c6fb8c80fcc92, "-token-not-found");
var $8c39ba654e3e590a$export$9d7b58831ae93caa = "--".concat($8c39ba654e3e590a$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});



parcelRegister("fO71G", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b820f9c1f610d225$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $bAJuw = parcelRequire("bAJuw");

var $hYcxk = parcelRequire("hYcxk");
var $b820f9c1f610d225$var$justifyContentMap = {
    start: (0, $3dJ4i.css)({
        justifyContent: 'start'
    }),
    center: (0, $3dJ4i.css)({
        justifyContent: 'center'
    }),
    end: (0, $3dJ4i.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3dJ4i.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3dJ4i.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3dJ4i.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3dJ4i.css)({
        justifyContent: 'stretch'
    })
};
var $b820f9c1f610d225$var$flexDirectionMap = {
    column: (0, $3dJ4i.css)({
        flexDirection: 'column'
    }),
    row: (0, $3dJ4i.css)({
        flexDirection: 'row'
    })
};
var $b820f9c1f610d225$var$flexWrapMap = {
    wrap: (0, $3dJ4i.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $3dJ4i.css)({
        flexWrap: 'nowrap'
    })
};
var $b820f9c1f610d225$var$alignItemsMap = {
    start: (0, $3dJ4i.css)({
        alignItems: 'start'
    }),
    center: (0, $3dJ4i.css)({
        alignItems: 'center'
    }),
    baseline: (0, $3dJ4i.css)({
        alignItems: 'baseline'
    }),
    end: (0, $3dJ4i.css)({
        alignItems: 'end'
    }),
    stretch: (0, $3dJ4i.css)({
        alignItems: 'stretch'
    })
};
var $b820f9c1f610d225$var$baseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $b820f9c1f610d225$var$Flex = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $hYcxk.parseXcss)(xcss);
    return (0, $3dJ4i.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $b820f9c1f610d225$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $bAJuw.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $bAJuw.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $bAJuw.spaceStylesMap).rowGap[rowGap],
            alignItems && $b820f9c1f610d225$var$alignItemsMap[alignItems],
            direction && $b820f9c1f610d225$var$flexDirectionMap[direction],
            justifyContent && $b820f9c1f610d225$var$justifyContentMap[justifyContent],
            wrap && $b820f9c1f610d225$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$b820f9c1f610d225$var$Flex.displayName = 'Flex';
var $b820f9c1f610d225$export$2e2bcd8739ae039 = $b820f9c1f610d225$var$Flex;

});


parcelRegister("WXxGK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0b139ac47cf1ba19$export$2e2bcd8739ae039; });

var $1JoDH = parcelRequire("1JoDH");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $hYcxk = parcelRequire("hYcxk");

var $fO71G = parcelRequire("fO71G");
var $0b139ac47cf1ba19$var$flexGrowMap = {
    hug: (0, $hYcxk.xcss)({
        flexGrow: 0
    }),
    fill: (0, $hYcxk.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $0b139ac47cf1ba19$var$Stack = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $0b139ac47cf1ba19$var$flexGrowMap[grow]
    ].concat((0, $1JoDH.default)(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $3dJ4i.jsx)((0, $fO71G.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$0b139ac47cf1ba19$var$Stack.displayName = 'Stack';
var $0b139ac47cf1ba19$export$2e2bcd8739ae039 = $0b139ac47cf1ba19$var$Stack;

});

parcelRegister("16qju", function(module, exports) {
$parcel$export(module.exports, "N20", function () { return $0cdac3414c6c0cac$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $0cdac3414c6c0cac$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N200", function () { return $0cdac3414c6c0cac$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $0cdac3414c6c0cac$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N30A", function () { return $0cdac3414c6c0cac$export$920c0d5c49070351; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $0cdac3414c6c0cac$export$4b84fd0e2c617bd = '#FFEBE6';
var $0cdac3414c6c0cac$export$b34b069eff244586 = '#FFBDAD';
var $0cdac3414c6c0cac$export$be802dd0d8b57f35 = '#FF8F73';
var $0cdac3414c6c0cac$export$60847d42f9da92a6 = '#FF7452';
var $0cdac3414c6c0cac$export$4a7404f376229999 = '#FF5630';
var $0cdac3414c6c0cac$export$2010d0fb4295b346 = '#DE350B';
var $0cdac3414c6c0cac$export$2837b5a1a71d5c02 = '#BF2600';
var $0cdac3414c6c0cac$export$8d9596b529bbb9cf = '#FFFAE6';
var $0cdac3414c6c0cac$export$41060a744ab0b7ae = '#FFF0B3';
var $0cdac3414c6c0cac$export$1cc05bbbf340e559 = '#FFE380';
var $0cdac3414c6c0cac$export$5aae31392d72caaa = '#FFC400';
var $0cdac3414c6c0cac$export$c6930421db9fa514 = '#FFAB00';
var $0cdac3414c6c0cac$export$59619663aa6500fb = '#FF991F';
var $0cdac3414c6c0cac$export$874739ea9e379ab6 = '#FF8B00';
var $0cdac3414c6c0cac$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $0cdac3414c6c0cac$export$69a3bf21b9686c2b = '#ABF5D1';
var $0cdac3414c6c0cac$export$afbce1382ec95f73 = '#79F2C0';
var $0cdac3414c6c0cac$export$747d86715d4175de = '#57D9A3';
var $0cdac3414c6c0cac$export$940e1f69e873f202 = '#36B37E';
var $0cdac3414c6c0cac$export$a49394138f7b8e85 = '#00875A';
var $0cdac3414c6c0cac$export$6fa04827ac68a4fb = '#006644';
var $0cdac3414c6c0cac$export$226de0355ed012f8 = '#DEEBFF';
var $0cdac3414c6c0cac$export$8c13c2ee36917869 = '#B3D4FF';
var $0cdac3414c6c0cac$export$ecfc1dff386a3e7a = '#4C9AFF';
var $0cdac3414c6c0cac$export$215b7063051591f1 = '#2684FF';
var $0cdac3414c6c0cac$export$e62e8919cca44969 = '#0065FF';
var $0cdac3414c6c0cac$export$b3de0ae08da2ce64 = '#0052CC';
var $0cdac3414c6c0cac$export$a6ee3d71bc067634 = '#0747A6';
var $0cdac3414c6c0cac$export$67f15409e87642a1 = '#669DF1';
var $0cdac3414c6c0cac$export$f0539dbc42dbb067 = '#8FB8F6';
var $0cdac3414c6c0cac$export$363e4475840015bb = '#EAE6FF';
var $0cdac3414c6c0cac$export$4b0a4417ed59760f = '#C0B6F2';
var $0cdac3414c6c0cac$export$6011520a64d9a187 = '#998DD9';
var $0cdac3414c6c0cac$export$a7175d4e9206bc80 = '#8777D9';
var $0cdac3414c6c0cac$export$b48405b95304b5a1 = '#6554C0';
var $0cdac3414c6c0cac$export$c71e4279dd54a18d = '#5243AA';
var $0cdac3414c6c0cac$export$147899de772240ec = '#403294';
var $0cdac3414c6c0cac$export$2cf711fe14c66f06 = '#E6FCFF';
var $0cdac3414c6c0cac$export$7a8f4d33f6f9772c = '#B3F5FF';
var $0cdac3414c6c0cac$export$776c9c497ef08533 = '#79E2F2';
var $0cdac3414c6c0cac$export$69cb3ca10c1e330e = '#00C7E6';
var $0cdac3414c6c0cac$export$9dc1ef0f3f48059b = '#00B8D9';
var $0cdac3414c6c0cac$export$7c835c78b6fcdef8 = '#00A3BF';
var $0cdac3414c6c0cac$export$6036577f95c3877e = '#008DA6';
var $0cdac3414c6c0cac$export$29a4f05edc054374 = '#FFFFFF';
var $0cdac3414c6c0cac$export$e655ef011c4aa1a2 = '#FAFBFC';
var $0cdac3414c6c0cac$export$9fdfb749e33cdf97 = '#F4F5F7';
var $0cdac3414c6c0cac$export$3e51e8f1440314ba = '#EBECF0';
var $0cdac3414c6c0cac$export$1ce2d1575d444ceb = '#DFE1E6';
var $0cdac3414c6c0cac$export$8754fc7e6d8b3000 = '#C1C7D0';
var $0cdac3414c6c0cac$export$c2e91cbeada39b8b = '#B3BAC5';
var $0cdac3414c6c0cac$export$5f71e19f3a7ad9de = '#A5ADBA';
var $0cdac3414c6c0cac$export$eaa8c8a70ac22806 = '#97A0AF';
var $0cdac3414c6c0cac$export$7c87d337fb91a97d = '#8993A4';
var $0cdac3414c6c0cac$export$d6447c357493214f = '#7A869A';
var $0cdac3414c6c0cac$export$f563ee71e9ee74cd = '#6B778C';
var $0cdac3414c6c0cac$export$e2ef2124cf4024b1 = '#5E6C84';
var $0cdac3414c6c0cac$export$eece5f492e429f08 = '#505F79';
var $0cdac3414c6c0cac$export$c39c0fe0f26207ae = '#42526E';
var $0cdac3414c6c0cac$export$7090862dc3038a9f = '#344563';
var $0cdac3414c6c0cac$export$ad0bacf983b7ddaa = '#253858';
var $0cdac3414c6c0cac$export$7d61b15e0da132af = '#172B4D';
var $0cdac3414c6c0cac$export$fbda843f0a27fe96 = '#091E42';
var $0cdac3414c6c0cac$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $0cdac3414c6c0cac$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $0cdac3414c6c0cac$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $0cdac3414c6c0cac$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $0cdac3414c6c0cac$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $0cdac3414c6c0cac$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $0cdac3414c6c0cac$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $0cdac3414c6c0cac$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $0cdac3414c6c0cac$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $0cdac3414c6c0cac$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $0cdac3414c6c0cac$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $0cdac3414c6c0cac$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $0cdac3414c6c0cac$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $0cdac3414c6c0cac$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $0cdac3414c6c0cac$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $0cdac3414c6c0cac$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $0cdac3414c6c0cac$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $0cdac3414c6c0cac$export$2f6319cf7d736c2a = '#E6EDFA';
var $0cdac3414c6c0cac$export$95126bc8884d6634 = '#DCE5F5';
var $0cdac3414c6c0cac$export$8338d8c35d44ff1 = '#CED9EB';
var $0cdac3414c6c0cac$export$5368d76ae4fbbda7 = '#B8C7E0';
var $0cdac3414c6c0cac$export$9f0a771d16ec8d36 = '#ABBBD6';
var $0cdac3414c6c0cac$export$abcf8c38338b4aa5 = '#9FB0CC';
var $0cdac3414c6c0cac$export$97e81faa16a182c7 = '#8C9CB8';
var $0cdac3414c6c0cac$export$bfe21c59123ecf33 = '#7988A3';
var $0cdac3414c6c0cac$export$ee82aa2ea6a1558 = '#67758F';
var $0cdac3414c6c0cac$export$682927c6ed76be02 = '#56637A';
var $0cdac3414c6c0cac$export$91fd9994c5be9757 = '#455166';
var $0cdac3414c6c0cac$export$d281fbfe3cff2df6 = '#3B475C';
var $0cdac3414c6c0cac$export$3902c91d8b98a753 = '#313D52';
var $0cdac3414c6c0cac$export$8e8133c1ba5845b5 = '#283447';
var $0cdac3414c6c0cac$export$33ff357f6620b39 = '#202B3D';
var $0cdac3414c6c0cac$export$633847cf062b69e0 = '#1B2638';
var $0cdac3414c6c0cac$export$9776a6e503bdbf76 = '#121A29';
var $0cdac3414c6c0cac$export$6c813d5160dff5db = '#0E1624';
var $0cdac3414c6c0cac$export$3d4f271a500072a = '#0D1424';
var $0cdac3414c6c0cac$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $0cdac3414c6c0cac$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $0cdac3414c6c0cac$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $0cdac3414c6c0cac$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $0cdac3414c6c0cac$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $0cdac3414c6c0cac$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $0cdac3414c6c0cac$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $0cdac3414c6c0cac$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $0cdac3414c6c0cac$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $0cdac3414c6c0cac$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $0cdac3414c6c0cac$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $0cdac3414c6c0cac$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $0cdac3414c6c0cac$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $0cdac3414c6c0cac$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $0cdac3414c6c0cac$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $0cdac3414c6c0cac$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $0cdac3414c6c0cac$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $0cdac3414c6c0cac$export$d2adc5dedf09fced = '#292A2E';
var $0cdac3414c6c0cac$export$f51762073d2bb381 = '#94C748';
var $0cdac3414c6c0cac$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("rX2Mz", function(module, exports) {
$parcel$export(module.exports, "SpacingContext", function () { return $0540529d99a947d9$export$443076ec7ebce042; });
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", function () { return $0540529d99a947d9$export$9ca534b70725964d; });

var $1oC0p = parcelRequire("1oC0p");
var $0540529d99a947d9$export$443076ec7ebce042 = /*#__PURE__*/ (0, $1oC0p.createContext)('cozy');
var $0540529d99a947d9$export$9ca534b70725964d = /*#__PURE__*/ (0, $1oC0p.createContext)('border');

});



parcelRegister("adr5D", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $770021c68c23976a$export$2e2bcd8739ae039; });

var $5OBHa = parcelRequire("5OBHa");

var $6bGSd = parcelRequire("6bGSd");

var $3dJ4i = parcelRequire("3dJ4i");

var $rX2Mz = parcelRequire("rX2Mz");
var $770021c68c23976a$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "className"
];
var $770021c68c23976a$var$baseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    position: 'static',
    flexDirection: 'column',
    overflow: 'auto'
});
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $770021c68c23976a$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'cozy' : _ref$spacing, UNSAFE_className = _ref.className, rest = (0, $6bGSd.default)(_ref, $770021c68c23976a$var$_excluded);
    return (0, $3dJ4i.jsx)((0, $rX2Mz.SpacingContext).Provider, {
        value: spacing
    }, (0, $3dJ4i.jsx)((0, $rX2Mz.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, (0, $3dJ4i.jsx)("div", (0, $5OBHa.default)({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        css: $770021c68c23976a$var$baseStyles,
        "data-testid": testId,
        role: role,
        className: UNSAFE_className
    }, rest))));
};
var $770021c68c23976a$export$2e2bcd8739ae039 = $770021c68c23976a$var$MenuGroup;

});

parcelRegister("55VkZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3b59e5672782da13$export$2e2bcd8739ae039; });

var $5OBHa = parcelRequire("5OBHa");

var $6bGSd = parcelRequire("6bGSd");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $8PfSM = parcelRequire("8PfSM");

var $16qju = parcelRequire("16qju");

var $i0M8O = parcelRequire("i0M8O");
var $3b59e5672782da13$var$_excluded = [
    "children",
    "overrides",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "className"
];
var $3b59e5672782da13$var$gridSize = 8;
var $3b59e5672782da13$var$itemHeadingTopMargin = $3b59e5672782da13$var$gridSize * 2.5;
var $3b59e5672782da13$var$itemHeadingBottomMargin = $3b59e5672782da13$var$gridSize * 0.75;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $3b59e5672782da13$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $3b59e5672782da13$var$skeletonHeadingHeight = $3b59e5672782da13$var$gridSize;
var $3b59e5672782da13$var$skeletonHeadingMarginOffset = 3;
var $3b59e5672782da13$var$skeletonHeadingTopMargin = $3b59e5672782da13$var$itemHeadingTopMargin + ($3b59e5672782da13$var$itemHeadingContentHeight - $3b59e5672782da13$var$skeletonHeadingHeight) - $3b59e5672782da13$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
var $3b59e5672782da13$var$skeletonHeadingBottomMargin = $3b59e5672782da13$var$itemHeadingBottomMargin + $3b59e5672782da13$var$skeletonHeadingMarginOffset;
var $3b59e5672782da13$var$sectionPaddingTopBottom = $3b59e5672782da13$var$gridSize * 0.75;
var $3b59e5672782da13$var$VAR_SEPARATOR_COLOR = '--ds-menu-seperator-color';
var $3b59e5672782da13$var$sectionStyles = (0, $3dJ4i.css)({
    '&::before, &::after': {
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $3b59e5672782da13$var$sectionPaddingTopBottom,
        content: '""'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-ds--menu--heading-item]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $3b59e5672782da13$var$itemHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $3b59e5672782da13$var$itemHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $3b59e5672782da13$var$itemHeadingTopMargin - $3b59e5672782da13$var$sectionPaddingTopBottom
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-ds--menu--skeleton-heading-item]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $3b59e5672782da13$var$skeletonHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $3b59e5672782da13$var$skeletonHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $3b59e5672782da13$var$skeletonHeadingTopMargin - $3b59e5672782da13$var$sectionPaddingTopBottom
        }
    },
    '&:focus': {
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        // This makes the outline go inside by 1px so it can actually be displayed
        // else it gets cut off from the overflow: scroll from the parent menu group.
        outlineOffset: -1
    }
});
var $3b59e5672782da13$var$scrollableStyles = (0, $3dJ4i.css)({
    flexShrink: 1,
    overflow: 'auto'
});
var $3b59e5672782da13$var$unscrollableStyles = (0, $3dJ4i.css)({
    flexShrink: 0
});
var $3b59e5672782da13$var$thinSeparatorStyles = (0, $3dJ4i.css)({
    borderBlockStart: "1px solid var(".concat($3b59e5672782da13$var$VAR_SEPARATOR_COLOR, ", ", "var(--ds-border, ".concat((0, $16qju.N30A), ")"), ")")
});
var $3b59e5672782da13$var$noSeparatorStyles = (0, $3dJ4i.css)({
    // this is to ensure that adjacent sections without separators don't get additional margins.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '[data-section] + &': {
        marginBlockStart: -6
    }
});
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $3b59e5672782da13$var$Section = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, overrides = _ref.overrides, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, UNSAFE_className = _ref.className, rest = (0, $6bGSd.default)(_ref, $3b59e5672782da13$var$_excluded);
    (0, $8PfSM.propDeprecationWarning)("@atlaskit/menu", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var UNSAFE_headingOverrides = overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
    var content = isList ? (0, $3dJ4i.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $1oC0p.Children).map((0, $1oC0p.Children).toArray(children), function(child, index) {
        return (0, $3dJ4i.jsx)("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, (0, $3dJ4i.jsx)((0, $i0M8O.default), {
        cssFn: UNSAFE_headingOverrides,
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true
    }, title), content) : (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, content);
    return (0, $3dJ4i.jsx)("div", (0, $5OBHa.default)({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        id: id,
        css: [
            $3b59e5672782da13$var$sectionStyles,
            isScrollable ? $3b59e5672782da13$var$scrollableStyles : $3b59e5672782da13$var$unscrollableStyles,
            hasSeparator ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            $3b59e5672782da13$var$thinSeparatorStyles : $3b59e5672782da13$var$noSeparatorStyles
        ],
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $3b59e5672782da13$export$2e2bcd8739ae039 = $3b59e5672782da13$var$Section;

});
parcelRegister("i0M8O", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0362488c02d6d30d$export$2e2bcd8739ae039; });

var $5OBHa = parcelRequire("5OBHa");

var $6bGSd = parcelRequire("6bGSd");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $8PfSM = parcelRequire("8PfSM");

var $4i1Fo = parcelRequire("4i1Fo");

var $16qju = parcelRequire("16qju");
var $0362488c02d6d30d$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "cssFn",
    "className"
];
var $0362488c02d6d30d$var$headingStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtle, ".concat((0, $16qju.N300), ")"),
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)"
});
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $0362488c02d6d30d$var$HeadingItem = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $4i1Fo.default) : _ref$cssFn, UNSAFE_className = _ref.className, rest = (0, $6bGSd.default)(_ref, $0362488c02d6d30d$var$_excluded);
    (0, $8PfSM.propDeprecationWarning)("@atlaskit/menu", 'cssFn', cssFn !== (0, $4i1Fo.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var UNSAFE_overrides = (0, $3dJ4i.css)(cssFn(undefined));
    return (0, $3dJ4i.jsx)("div", (0, $5OBHa.default)({
        css: [
            $0362488c02d6d30d$var$headingStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            UNSAFE_overrides
        ],
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: UNSAFE_className
    }, rest), children);
});
var $0362488c02d6d30d$export$2e2bcd8739ae039 = $0362488c02d6d30d$var$HeadingItem;

});


parcelRegister("flLGf", function(module, exports) {
$parcel$export(module.exports, "Profile", function () { return $b2cdcd816d80e229$export$5120f2d0b8d4cab8; });

var $9jUeC = parcelRequire("9jUeC");

var $2q0os = parcelRequire("2q0os");

var $1oC0p = parcelRequire("1oC0p");

var $3n9k5 = parcelRequire("3n9k5");

var $2hqpf = parcelRequire("2hqpf");
var $b2cdcd816d80e229$var$_excluded = [
    "src"
];
var $b2cdcd816d80e229$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var src = _ref.src, props = (0, $2q0os.default)(_ref, $b2cdcd816d80e229$var$_excluded);
    var ProfileAvatar = (0, $1oC0p.useCallback)(function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3n9k5.default), {
            appearance: "circle",
            src: src,
            size: "small"
        });
    }, [
        src
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2hqpf.EndItem), (0, $9jUeC.default)({}, props, {
        ref: ref,
        icon: ProfileAvatar
    }));
});

});
parcelRegister("3n9k5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $274ac06c4c62ea3a$export$2e2bcd8739ae039; });
/* avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $363qk = parcelRequire("363qk");

var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");

var $1VbqL = parcelRequire("1VbqL");

var $edmmv = parcelRequire("edmmv");

var $jzYRu = parcelRequire("jzYRu");

var $6lzqg = parcelRequire("6lzqg");

var $iVPpk = parcelRequire("iVPpk");

var $7GOES = parcelRequire("7GOES");

var $fRpYa = parcelRequire("fRpYa");

var $9Olgq = parcelRequire("9Olgq");
function $274ac06c4c62ea3a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $274ac06c4c62ea3a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $274ac06c4c62ea3a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $363qk.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $274ac06c4c62ea3a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $274ac06c4c62ea3a$var$packageName = "@atlaskit/avatar";
var $274ac06c4c62ea3a$var$packageVersion = "25.1.8";
var $274ac06c4c62ea3a$var$containerStyles = null;
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $274ac06c4c62ea3a$var$Avatar = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'circle' : _ref$appearance, label = _ref.label, borderColor = _ref.borderColor, children = _ref.children, href = _ref.href, isDisabled = _ref.isDisabled, name = _ref.name, onClick = _ref.onClick, presence = _ref.presence, sizeProp = _ref.size, src = _ref.src, stackIndex = _ref.stackIndex, status = _ref.status, target = _ref.target, testId = _ref.testId, _ref$as = _ref.as, AvatarContainer = _ref$as === void 0 ? 'div' : _ref$as, _ref$isDecorative = _ref.isDecorative, isDecorative = _ref$isDecorative === void 0 ? false : _ref$isDecorative, imgLoading = _ref.imgLoading;
    var _useAnalyticsEvents = (0, $1VbqL.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $6lzqg.useAvatarContext)();
    var size = sizeProp || (context === null || context === void 0 ? void 0 : context.size) || 'medium';
    var customPresenceNode = /*#__PURE__*/ (0, $1oC0p.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $1oC0p.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    var lastAnalytics = (0, $1oC0p.useRef)(analyticsContext);
    var labelId = (0, $edmmv.useId)();
    (0, $1oC0p.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $1oC0p.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== 'function') return;
        var analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $274ac06c4c62ea3a$var$packageName,
                packageVersion: $274ac06c4c62ea3a$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $274ac06c4c62ea3a$var$_objectSpread({
            componentName: 'avatar',
            packageName: $274ac06c4c62ea3a$var$packageName,
            packageVersion: $274ac06c4c62ea3a$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(' ');
    var isInteractive = onClick || href || isDisabled;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ $1oC0p.createElement((0, $6lzqg.EnsureIsInsideAvatarContext).Provider, {
        value: true
    }, /*#__PURE__*/ $1oC0p.createElement(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage && !isDecorative ? labelId : undefined,
        style: {
            zIndex: stackIndex
        },
        className: (0, $iiT5o.default)([
            "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement((0, $6lzqg.AvatarContentContext).Provider, {
        value: {
            as: (0, $9Olgq.getCustomElement)(isDisabled, href, onClick),
            appearance: appearance,
            borderColor: borderColor,
            href: href,
            isDisabled: isDisabled,
            label: label || defaultLabel,
            onClick: isInteractive ? onClickHandler : undefined,
            ref: ref,
            size: size,
            stackIndex: stackIndex,
            target: target,
            testId: testId ? "".concat(testId, "--inner") : undefined,
            avatarImage: /*#__PURE__*/ $1oC0p.createElement((0, $iVPpk.default), {
                alt: !containerShouldBeImage && src ? name : undefined,
                src: src,
                appearance: appearance,
                size: size,
                testId: testId,
                imgLoading: imgLoading
            })
        }
    }, children || /*#__PURE__*/ $1oC0p.createElement((0, $jzYRu.AvatarContent), null)), isPresence && /*#__PURE__*/ $1oC0p.createElement((0, $7GOES.PresenceWrapper), {
        appearance: appearance,
        size: size,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ $1oC0p.createElement((0, $fRpYa.StatusWrapper), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined));
});
$274ac06c4c62ea3a$var$Avatar.displayName = 'Avatar';
var $274ac06c4c62ea3a$export$2e2bcd8739ae039 = $274ac06c4c62ea3a$var$Avatar;

});
parcelRegister("jzYRu", function(module, exports) {
$parcel$export(module.exports, "AvatarContent", function () { return $e4107f109a57b225$export$47fbc0b44cae5559; });
/* avatar-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9jUeC = parcelRequire("9jUeC");

var $363qk = parcelRequire("363qk");

var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");

var $39c3M = parcelRequire("39c3M");

var $6lzqg = parcelRequire("6lzqg");
var $e4107f109a57b225$var$boxShadowCssVar = '--avatar-box-shadow';
var $e4107f109a57b225$var$bgColorCssVar = '--avatar-bg-color';
var $e4107f109a57b225$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu194a _1ah3v77o _ra3xnqa1 _128m1bk5 _4dave4h9",
    circle: "_2rko1q5u _14mj1q5u",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
var $e4107f109a57b225$var$unboundStyles = {
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpu1g4v _ez1ykb7n _gcm1182g _eeh8kb7n _jlxit94y"
};
var $e4107f109a57b225$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
var $e4107f109a57b225$var$borderRadiusMap = {
    xsmall: "_2rkogqwt _14mjgqwt",
    small: "_2rkogqwt _14mjgqwt",
    medium: "_2rkosqtm _14mjsqtm",
    large: "_2rkosqtm _14mjsqtm",
    xlarge: "_2rkoi2wt _14mji2wt",
    xxlarge: "_2rkob7nn _14mjb7nn"
};
var $e4107f109a57b225$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children;
    (0, $6lzqg.useEnsureIsInsideAvatar)();
    var _useAvatarContent = (0, $6lzqg.useAvatarContent)(), Container = _useAvatarContent.as, appearance = _useAvatarContent.appearance, avatarImage = _useAvatarContent.avatarImage, _useAvatarContent$bor = _useAvatarContent.borderColor, borderColor = _useAvatarContent$bor === void 0 ? (0, $39c3M.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : "var(--ds-surface-overlay, #FFFFFF)" : _useAvatarContent$bor, href = _useAvatarContent.href, isDisabled = _useAvatarContent.isDisabled, label = _useAvatarContent.label, onClick = _useAvatarContent.onClick, contextRef = _useAvatarContent.ref, tabIndex = _useAvatarContent.tabIndex, target = _useAvatarContent.target, testId = _useAvatarContent.testId, size = _useAvatarContent.size, stackIndex = _useAvatarContent.stackIndex;
    var isInteractive = Boolean(onClick || href || isDisabled);
    return /*#__PURE__*/ $1oC0p.createElement(Container, (0, $9jUeC.default)({
        style: (0, $363qk.default)((0, $363qk.default)({}, $e4107f109a57b225$var$bgColorCssVar, borderColor), $e4107f109a57b225$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined
    }, href && {
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined
    }, {
        className: (0, $iiT5o.default)([
            $e4107f109a57b225$var$unboundStyles.root,
            $e4107f109a57b225$var$styles.root,
            $e4107f109a57b225$var$borderRadiusMap[size],
            appearance === 'circle' && $e4107f109a57b225$var$styles.circle,
            $e4107f109a57b225$var$widthHeightMap[size],
            stackIndex !== undefined && $e4107f109a57b225$var$styles.positionRelative,
            isInteractive && !isDisabled && $e4107f109a57b225$var$unboundStyles.interactive,
            isDisabled && $e4107f109a57b225$var$styles.disabled
        ])
    }), children || avatarImage);
});

});

parcelRegister("iVPpk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dc856d5056391366$export$2e2bcd8739ae039; });
/* avatar-image.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9DP70 = parcelRequire("9DP70");

var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");

var $8ZBlj = parcelRequire("8ZBlj");

var $7xJsd = parcelRequire("7xJsd");

var $39c3M = parcelRequire("39c3M");
var $dc856d5056391366$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq",
    iconBg: "_bfhkr4aa",
    iconBGVisualRefresh: "_bfhk1v33",
    circle: "_2rko14q2"
};
var $dc856d5056391366$var$borderRadiusMap = {
    xsmall: "_2rkogqwt",
    small: "_2rkogqwt",
    medium: "_2rkosqtm",
    large: "_2rkosqtm",
    xlarge: "_2rkoi2wt",
    xxlarge: "_2rkob7nn"
};
var $dc856d5056391366$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $dc856d5056391366$var$AvatarImage = function AvatarImage(_ref) {
    var _ref$alt = _ref.alt, alt = _ref$alt === void 0 ? '' : _ref$alt, src = _ref.src, appearance = _ref.appearance, size = _ref.size, testId = _ref.testId, imgLoading = _ref.imgLoading;
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $9DP70.default)(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    // If src changes, reset state
    (0, $1oC0p.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ $1oC0p.createElement("span", {
        className: (0, $iiT5o.default)([
            $dc856d5056391366$var$styles.icon,
            (0, $39c3M.fg)('platform-component-visual-refresh') ? $dc856d5056391366$var$styles.iconBGVisualRefresh : $dc856d5056391366$var$styles.iconBg,
            $dc856d5056391366$var$nestedSvgStylesMap[size]
        ])
    }, appearance === 'circle' ? /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZBlj))), {
        label: alt,
        color: (0, $39c3M.fg)('platform-component-visual-refresh') ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-inverse, #FFFFFF)",
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious",
        LEGACY_secondaryColor: "var(--ds-icon-subtle, #626F86)"
    }) : /*#__PURE__*/ $1oC0p.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7xJsd))), {
        label: alt,
        color: (0, $39c3M.fg)('platform-component-visual-refresh') ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-inverse, #FFFFFF)",
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious",
        LEGACY_secondaryColor: "var(--ds-icon-subtle, #626F86)"
    }));
    return /*#__PURE__*/ $1oC0p.createElement("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? "".concat(testId, "--image") : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $iiT5o.default)([
            $dc856d5056391366$var$styles.image,
            $dc856d5056391366$var$borderRadiusMap[size],
            appearance === 'circle' && $dc856d5056391366$var$styles.circle
        ])
    });
};
var $dc856d5056391366$export$2e2bcd8739ae039 = $dc856d5056391366$var$AvatarImage;

});
parcelRegister("8ZBlj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::325d0bc066f2b42d61e7c5ff0e093014>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68c0fcbf46e65ee3$var$_react = $68c0fcbf46e65ee3$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $68c0fcbf46e65ee3$var$_person = $68c0fcbf46e65ee3$var$_interopRequireDefault((parcelRequire("eH1WB")));

var $68c0fcbf46e65ee3$var$_person2 = $68c0fcbf46e65ee3$var$_interopRequireDefault((parcelRequire("lV1V6")));
function $68c0fcbf46e65ee3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $68c0fcbf46e65ee3$var$PersonIcon = (props)=>/*#__PURE__*/ $68c0fcbf46e65ee3$var$_react.default.createElement($68c0fcbf46e65ee3$var$_person.default, Object.assign({
        LEGACY_fallbackIcon: $68c0fcbf46e65ee3$var$_person2.default
    }, props));
$68c0fcbf46e65ee3$var$PersonIcon.Name = 'PersonIconMigration';
var $68c0fcbf46e65ee3$var$_default = module.exports.default = $68c0fcbf46e65ee3$var$PersonIcon;

});
parcelRegister("eH1WB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f4e6f87c1306b0b7d1107d65930cc1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab2696e8a46e3ae1$var$_react = $ab2696e8a46e3ae1$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ab2696e8a46e3ae1$var$_baseNew = $ab2696e8a46e3ae1$var$_interopRequireDefault((parcelRequire("2nrc5")));
function $ab2696e8a46e3ae1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab2696e8a46e3ae1$var$PersonIcon = (props)=>/*#__PURE__*/ $ab2696e8a46e3ae1$var$_react.default.createElement($ab2696e8a46e3ae1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$ab2696e8a46e3ae1$var$PersonIcon.displayName = 'PersonIcon';
var $ab2696e8a46e3ae1$var$_default = module.exports.default = $ab2696e8a46e3ae1$var$PersonIcon;

});
parcelRegister("2nrc5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return (parcelRequire("7dqOe")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("7dqOe")).Icon; });

var $7dqOe = parcelRequire("7dqOe");

});
parcelRegister("7dqOe", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $540e8b089d2163d4$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $540e8b089d2163d4$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");

var $39c3M = parcelRequire("39c3M");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $540e8b089d2163d4$var$svgStyles = null;
var $540e8b089d2163d4$var$iconStyles = null;
var $540e8b089d2163d4$var$utilityIconStyles = null;
var $540e8b089d2163d4$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $540e8b089d2163d4$var$baseHcmStyles = null;
var $540e8b089d2163d4$var$scaleSize = null;
var $540e8b089d2163d4$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $540e8b089d2163d4$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $540e8b089d2163d4$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $540e8b089d2163d4$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $540e8b089d2163d4$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $540e8b089d2163d4$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $39c3M.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $1oC0p.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'size' in props && props.size !== undefined && // This prevents invalid sizes being passed in, which is required
    // for handling unsupported legacy icon sizes which can
    // cause errors.
    (props.size === 'small' || props.size === 'medium') ? props.size : 'medium';
    var baseSize = $540e8b089d2163d4$var$baseSizeMap[type];
    var viewBoxPadding = $540e8b089d2163d4$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $iiT5o.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1oC0p.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $iiT5o.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $540e8b089d2163d4$var$utilSizes[spacing] : size === 'small' ? $540e8b089d2163d4$var$coreSizeSmall[spacing] : $540e8b089d2163d4$var$coreSizeMedium[spacing]
        ])
    }));
});
var $540e8b089d2163d4$export$2e2bcd8739ae039 = $540e8b089d2163d4$export$f04a61298a47a40f;

});



parcelRegister("lV1V6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff5069185b2a7923$var$_react = $ff5069185b2a7923$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $i2UYu = parcelRequire("i2UYu");

var $ff5069185b2a7923$var$_person = $ff5069185b2a7923$var$_interopRequireDefault((parcelRequire("eH1WB")));
function $ff5069185b2a7923$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ff5069185b2a7923$var$PersonIcon = (props)=>/*#__PURE__*/ $ff5069185b2a7923$var$_react.default.createElement($i2UYu.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $ff5069185b2a7923$var$_person.default
    }));
$ff5069185b2a7923$var$PersonIcon.displayName = 'PersonIcon';
var $ff5069185b2a7923$var$_default = module.exports.default = $ff5069185b2a7923$var$PersonIcon;

});
parcelRegister("i2UYu", function(module, exports) {
$parcel$export(module.exports, "IconFacade", function () { return $d2349bdd0124dbc5$export$3cfb73f70dfca966; });

var $9jUeC = parcelRequire("9jUeC");

var $2q0os = parcelRequire("2q0os");

var $1oC0p = parcelRequire("1oC0p");

var $39c3M = parcelRequire("39c3M");

var $6hEqS = parcelRequire("6hEqS");
var $d2349bdd0124dbc5$var$_excluded = [
    "dangerouslySetGlyph",
    "size"
];
var $d2349bdd0124dbc5$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $d2349bdd0124dbc5$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $1oC0p.memo)(function IconFacade(_ref) {
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, size = _ref.size, props = (0, $2q0os.default)(_ref, $d2349bdd0124dbc5$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var iconSize = size !== null && size !== void 0 ? size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $39c3M.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (iconSize === 'small' || iconSize === 'medium') && !(0, $39c3M.fg)('platform-visual-refresh-icons-facade-removal')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Icon, (0, $9jUeC.default)({}, props, {
                spacing: (0, $39c3M.fg)('platform-visual-refresh-icons-facade-button-fix') ? $d2349bdd0124dbc5$var$sizeSpacingMap['utility'][iconSize] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(_Icon, (0, $9jUeC.default)({}, props, {
                size: iconSize,
                spacing: $d2349bdd0124dbc5$var$sizeSpacingMap['core'][iconSize],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $6hEqS.Icon), (0, $9jUeC.default)({
        dangerouslySetGlyph: dangerouslySetGlyph,
        size: size
    }, props));
});

});
parcelRegister("6hEqS", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $4933b1a3e105e1c9$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9jUeC = parcelRequire("9jUeC");

var $363qk = parcelRequire("363qk");

var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");
function $4933b1a3e105e1c9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4933b1a3e105e1c9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4933b1a3e105e1c9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $363qk.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4933b1a3e105e1c9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $4933b1a3e105e1c9$var$iconStyles = null;
var $4933b1a3e105e1c9$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $4933b1a3e105e1c9$var$baseHcmStyles = null;
var $4933b1a3e105e1c9$var$primaryEqualsSecondaryHcmStyles = null;
var $4933b1a3e105e1c9$var$secondaryTransparentHcmStyles = null;
var $4933b1a3e105e1c9$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $1oC0p.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $1oC0p.createElement("span", (0, $9jUeC.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $4933b1a3e105e1c9$var$_objectSpread($4933b1a3e105e1c9$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $iiT5o.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $4933b1a3e105e1c9$var$sizeStyles[size]
        ])
    }));
});
var $4933b1a3e105e1c9$export$2e2bcd8739ae039 = $4933b1a3e105e1c9$export$f04a61298a47a40f;

});




parcelRegister("7xJsd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df09611fb9f343ce3ed015b37269b5a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57dedfb3ce789145$var$_react = $57dedfb3ce789145$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $57dedfb3ce789145$var$_release = $57dedfb3ce789145$var$_interopRequireDefault((parcelRequire("dvvrV")));

var $57dedfb3ce789145$var$_ship = $57dedfb3ce789145$var$_interopRequireDefault((parcelRequire("k6L2g")));
function $57dedfb3ce789145$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $57dedfb3ce789145$var$ReleaseIcon = (props)=>/*#__PURE__*/ $57dedfb3ce789145$var$_react.default.createElement($57dedfb3ce789145$var$_release.default, Object.assign({
        LEGACY_fallbackIcon: $57dedfb3ce789145$var$_ship.default
    }, props));
$57dedfb3ce789145$var$ReleaseIcon.Name = 'ReleaseIconMigration';
var $57dedfb3ce789145$var$_default = module.exports.default = $57dedfb3ce789145$var$ReleaseIcon;

});
parcelRegister("dvvrV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1a26e96d639121c034f7ae4d8530108>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d5690cc22e1c05a$var$_react = $9d5690cc22e1c05a$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9d5690cc22e1c05a$var$_baseNew = $9d5690cc22e1c05a$var$_interopRequireDefault((parcelRequire("2nrc5")));
function $9d5690cc22e1c05a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9d5690cc22e1c05a$var$ReleaseIcon = (props)=>/*#__PURE__*/ $9d5690cc22e1c05a$var$_react.default.createElement($9d5690cc22e1c05a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$9d5690cc22e1c05a$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $9d5690cc22e1c05a$var$_default = module.exports.default = $9d5690cc22e1c05a$var$ReleaseIcon;

});

parcelRegister("k6L2g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ea38da7b0193cd17$var$_react = $ea38da7b0193cd17$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $i2UYu = parcelRequire("i2UYu");

var $ea38da7b0193cd17$var$_release = $ea38da7b0193cd17$var$_interopRequireDefault((parcelRequire("dvvrV")));
function $ea38da7b0193cd17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ea38da7b0193cd17$var$ShipIcon = (props)=>/*#__PURE__*/ $ea38da7b0193cd17$var$_react.default.createElement($i2UYu.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props, {
        newIcon: $ea38da7b0193cd17$var$_release.default
    }));
$ea38da7b0193cd17$var$ShipIcon.displayName = 'ShipIcon';
var $ea38da7b0193cd17$var$_default = module.exports.default = $ea38da7b0193cd17$var$ShipIcon;

});



parcelRegister("7GOES", function(module, exports) {
$parcel$export(module.exports, "PresenceWrapper", function () { return $5993c051315e4212$export$972c5e90200fa0ef; });
/* presence.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");

var $krTU6 = parcelRequire("krTU6");

var $gdHRt = parcelRequire("gdHRt");
var $5993c051315e4212$var$BusyIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $krTU6.R300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $krTU6.N0), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $5993c051315e4212$var$FocusIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $krTU6.P300), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $5993c051315e4212$var$OfflineIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $krTU6.N200), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $krTU6.N40), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $5993c051315e4212$var$OnlineIndicator = /*#__PURE__*/ $1oC0p.createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $krTU6.G300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $5993c051315e4212$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $5993c051315e4212$var$BusyIndicator;
        case 'focus':
            return $5993c051315e4212$var$FocusIndicator;
        case 'offline':
            return $5993c051315e4212$var$OfflineIndicator;
        case 'online':
            return $5993c051315e4212$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $5993c051315e4212$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ $1oC0p.createElement((0, $gdHRt.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ $1oC0p.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $5993c051315e4212$var$getPresence(presence)) : children);
};
var $5993c051315e4212$export$2e2bcd8739ae039 = $5993c051315e4212$var$AvatarPresence;
var $5993c051315e4212$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
var $5993c051315e4212$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $5993c051315e4212$var$iconOffsetMap = {
    square: "_94n5myb0 _1xi2myb0",
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
var $5993c051315e4212$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        className: (0, $iiT5o.default)([
            $5993c051315e4212$var$styles.root,
            $5993c051315e4212$var$iconSizeMap[size],
            $5993c051315e4212$var$iconOffsetMap[size],
            appearance === 'square' && $5993c051315e4212$var$iconOffsetMap['square']
        ])
    }, /*#__PURE__*/ $1oC0p.createElement($5993c051315e4212$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};

});
parcelRegister("gdHRt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bcefe23bb95fb57b$export$2e2bcd8739ae039; });
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");
var $bcefe23bb95fb57b$var$styles = {
    root: "_2rko1q5u _1reo15vq _18m915vq _189e1bk5 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
var $bcefe23bb95fb57b$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $bcefe23bb95fb57b$var$IconWrapper = function IconWrapper(_ref) {
    var bgColor = _ref.bgColor, children = _ref.children;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $iiT5o.default)([
            $bcefe23bb95fb57b$var$styles.root,
            $bcefe23bb95fb57b$var$unboundStyles.root
        ])
    }, children);
};
var $bcefe23bb95fb57b$export$2e2bcd8739ae039 = $bcefe23bb95fb57b$var$IconWrapper;

});


parcelRegister("fRpYa", function(module, exports) {
$parcel$export(module.exports, "StatusWrapper", function () { return $b8bff33af3c3d4a8$export$8045894f255f9726; });
/* status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");

var $krTU6 = parcelRequire("krTU6");

var $gdHRt = parcelRequire("gdHRt");
var $b8bff33af3c3d4a8$var$styles = {
    root: "_kqswstnw"
};
var $b8bff33af3c3d4a8$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $b8bff33af3c3d4a8$var$iconOffsetMap = {
    square: "_1xi2idpf _154iidpf",
    small: "_1xi2idpf _154iidpf",
    medium: "_1xi2idpf _154iidpf",
    large: "_1xi2t94y _154it94y",
    xlarge: "_1xi21v6z _154i1v6z"
};
var $b8bff33af3c3d4a8$var$ApprovedIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $krTU6.G400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $krTU6.N0), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $b8bff33af3c3d4a8$var$DeclinedIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $krTU6.R400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $krTU6.N0), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $b8bff33af3c3d4a8$var$LockedIndicator = /*#__PURE__*/ $1oC0p.createElement((0, $1oC0p.Fragment), null, /*#__PURE__*/ $1oC0p.createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $krTU6.N40), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $1oC0p.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $krTU6.N500), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $b8bff33af3c3d4a8$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $b8bff33af3c3d4a8$var$ApprovedIndicator;
        case 'declined':
            return $b8bff33af3c3d4a8$var$DeclinedIndicator;
        case 'locked':
            return $b8bff33af3c3d4a8$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $b8bff33af3c3d4a8$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ $1oC0p.createElement((0, $gdHRt.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ $1oC0p.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $b8bff33af3c3d4a8$var$getStatus(status)) : children);
};
var $b8bff33af3c3d4a8$export$2e2bcd8739ae039 = $b8bff33af3c3d4a8$var$AvatarStatus;
var $b8bff33af3c3d4a8$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    return /*#__PURE__*/ $1oC0p.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        className: (0, $iiT5o.default)([
            $b8bff33af3c3d4a8$var$styles.root,
            $b8bff33af3c3d4a8$var$iconSizeMap[size],
            $b8bff33af3c3d4a8$var$iconOffsetMap[size],
            appearance === 'square' && $b8bff33af3c3d4a8$var$iconOffsetMap['square']
        ])
    }, /*#__PURE__*/ $1oC0p.createElement($b8bff33af3c3d4a8$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};

});

parcelRegister("9Olgq", function(module, exports) {
$parcel$export(module.exports, "getCustomElement", function () { return $72494720dc289404$export$83ee468102cdf04c; });
var $72494720dc289404$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled) return 'button';
    return 'span';
};

});



parcelRegister("7GdwZ", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $62532a9657821928$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $62532a9657821928$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    profileLogout: {
        id: "fastshift.navigation.profile.logout",
        defaultMessage: "Logout",
        description: "Label for the logout link in the profile section"
    },
    accountSectionTitle: {
        id: "fastshift.navigation.profile.account-section-title",
        defaultMessage: "ACCOUNT",
        description: "Title for the account section in the profile navigation"
    }
});

});



parcelRegister("kpY1n", function(module, exports) {
$parcel$export(module.exports, "useFastshiftUIAnalytics", function () { return (parcelRequire("5oHNi")).useFastshiftUIAnalytics; });
$parcel$export(module.exports, "useFastshiftPageAnalytics", function () { return (parcelRequire("bDYcw")).useFastshiftPageAnalytics; });
$parcel$export(module.exports, "useShouldShowConsentLandingPage", function () { return (parcelRequire("i4499")).useShouldShowConsentLandingPage; });

var $5oHNi = parcelRequire("5oHNi");

var $bDYcw = parcelRequire("bDYcw");

var $i4499 = parcelRequire("i4499");

});
parcelRegister("5oHNi", function(module, exports) {
$parcel$export(module.exports, "useFastshiftUIAnalytics", function () { return $234dd7d09610caf2$export$1c68f76135b864ca; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
const $234dd7d09610caf2$export$1c68f76135b864ca = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)(true);
    const { fireUIEvent: fireUIEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    const sendGoBackButtonClickUIEvent = (0, $1oC0p.useCallback)(()=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).GO_BACK_BUTTON,
            source: sourceKey,
            attributes: {}
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendSignInWithAnotherAccountButtonClickUIEvent = (0, $1oC0p.useCallback)(()=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).SIGN_IN_WITH_ANOTHER_ACCOUNT_BUTTON,
            source: sourceKey,
            attributes: {}
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendContactSupportLinkClickUIEvent = (0, $1oC0p.useCallback)(()=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).LINK,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).CONTACT_SUPPORT_LINK,
            source: sourceKey,
            attributes: {}
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    return {
        sendGoBackButtonClickUIEvent: sendGoBackButtonClickUIEvent,
        sendSignInWithAnotherAccountButtonClickUIEvent: sendSignInWithAnotherAccountButtonClickUIEvent,
        sendContactSupportLinkClickUIEvent: sendContactSupportLinkClickUIEvent
    };
};

});

parcelRegister("bDYcw", function(module, exports) {
$parcel$export(module.exports, "useFastshiftPageAnalytics", function () { return $94bdf109921119b1$export$e9a72f1288f66b0c; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");
const $94bdf109921119b1$export$e9a72f1288f66b0c = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)();
    const { fireScreenEvent: fireScreenEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    (0, $1oC0p.useEffect)(()=>{
        if (!identityAttrs) return;
        fireScreenEvent({
            name: sourceKey
        });
    }, [
        fireScreenEvent,
        sourceKey,
        identityAttrs
    ]);
};

});

parcelRegister("i4499", function(module, exports) {
$parcel$export(module.exports, "useShouldShowConsentLandingPage", function () { return $aa9e713da01b1a77$export$cc3cbdc2d95741b8; });
// Hook returns true if consent landing page should be shown
// Logic extracted here so we can reuse in page-layout component to hide feedback form icon
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");
const $aa9e713da01b1a77$export$cc3cbdc2d95741b8 = ()=>{
    const { data: userDetails, error: userDetailsError } = (0, $f7YG8.useFastshiftSelector)((state)=>state.userDetails);
    const isPartnerOrInternal = (userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) === "PARTNER" || (userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) === "INTERNAL";
    const { data: userHasConsented, error: userConsentError } = (0, $f7YG8.useFastshiftSelector)((state)=>state.portalUserConsent);
    const portalHasCriticalError = userDetailsError || userConsentError;
    const shouldShowConsentLandingPage = !isPartnerOrInternal && userHasConsented === false && // we don't want this to evaluate true when null
    !portalHasCriticalError;
    return shouldShowConsentLandingPage;
};

});


parcelRegister("g36T6", function(module, exports) {
$parcel$export(module.exports, "AccessControlledPageContent", function () { return (parcelRequire("4Li9Q")).AccessControlledPageContent; });

var $4Li9Q = parcelRequire("4Li9Q");

});
parcelRegister("4Li9Q", function(module, exports) {
$parcel$export(module.exports, "AccessControlledPageContent", function () { return $52a23624d6591acf$export$3da7e6823a50f04c; });
/* access-controlled-page-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $j2t2h = parcelRequire("j2t2h");

var $79ZK0 = parcelRequire("79ZK0");
var $f6YGh = parcelRequire("f6YGh");

var $7qFQI = parcelRequire("7qFQI");
parcelRequire("z8fwG");
var $7WhrI = parcelRequire("7WhrI");
parcelRequire("iTGju");
var $bh3Fv = parcelRequire("bh3Fv");

var $e0mZZ = parcelRequire("e0mZZ");
const $52a23624d6591acf$var$PageContentContainer = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $aPnCa._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, (0, $dPABA._)((0, $6ogO3._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_1bsb1osq _p12f1yae",
            __cmplp.className
        ])
    }));
});
const $52a23624d6591acf$var$LoadingContainerStyles = (0, $f6YGh.xcss)({
    height: "80vh",
    width: "100%"
});
const $52a23624d6591acf$var$LoadingPageView = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($52a23624d6591acf$var$PageContentContainer, {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $79ZK0.default), {
            alignInline: "center",
            alignBlock: "center",
            xcss: $52a23624d6591acf$var$LoadingContainerStyles,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
                size: "xlarge",
                label: "Loading",
                testId: "loading-spinner"
            })
        })
    });
};
const $52a23624d6591acf$export$3da7e6823a50f04c = ({ userAccessState: userAccessState, children: children })=>{
    const pathname = (0, $j2t2h.useLocation)().pathname;
    const { paths: paths } = (0, $bh3Fv.useRoutes)();
    // always allow home path to render children
    if (pathname === paths.home) switch(userAccessState){
        case (0, $e0mZZ.UserAccessValidationState).LOADING_PORTAL_ELIGIBILITY:
        case (0, $e0mZZ.UserAccessValidationState).LOADING_USER_PERMISSIONS:
            return /*#__PURE__*/ (0, $7VQPk.jsx)($52a23624d6591acf$var$LoadingPageView, {});
        case (0, $e0mZZ.UserAccessValidationState).VALIDATION_SUCCESS:
        case (0, $e0mZZ.UserAccessValidationState).VALIDATION_FAIL_NO_ACCESS_TO_SELECTED_ROUTE:
        case (0, $e0mZZ.UserAccessValidationState).VALIDATION_FAIL_INELIGIBLE_FOR_PORTAL:
        case (0, $e0mZZ.UserAccessValidationState).VALIDATION_FAIL_CUSTOMER_NOT_CONSENTED:
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)($52a23624d6591acf$var$PageContentContainer, {
                children: children
            });
    }
    switch(userAccessState){
        case (0, $e0mZZ.UserAccessValidationState).LOADING_PORTAL_ELIGIBILITY:
        case (0, $e0mZZ.UserAccessValidationState).LOADING_USER_PERMISSIONS:
            return /*#__PURE__*/ (0, $7VQPk.jsx)($52a23624d6591acf$var$LoadingPageView, {});
        case (0, $e0mZZ.UserAccessValidationState).VALIDATION_SUCCESS:
            return /*#__PURE__*/ (0, $7VQPk.jsx)($52a23624d6591acf$var$PageContentContainer, {
                children: children
            });
        case (0, $e0mZZ.UserAccessValidationState).VALIDATION_FAIL_NO_ACCESS_TO_SELECTED_ROUTE:
        case (0, $e0mZZ.UserAccessValidationState).VALIDATION_FAIL_INELIGIBLE_FOR_PORTAL:
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WhrI.FourOhFourDisplay), {});
    }
};

});
parcelRegister("e0mZZ", function(module, exports) {
$parcel$export(module.exports, "UserAccessValidationState", function () { return $af9b68b1f2b166ba$export$65223d64021ba6a8; });
$parcel$export(module.exports, "usePortalAuthenticationAndAccessControl", function () { return $af9b68b1f2b166ba$export$6fd889175fcd8d17; });

var $1oC0p = parcelRequire("1oC0p");

var $j2t2h = parcelRequire("j2t2h");

var $fq4go = parcelRequire("fq4go");

var $cl5fF = parcelRequire("cl5fF");
parcelRequire("kPtON");
var $34zoS = parcelRequire("34zoS");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");

var $8Bmsc = parcelRequire("8Bmsc");

var $PE2DD = parcelRequire("PE2DD");
parcelRequire("iTGju");
var $bh3Fv = parcelRequire("bh3Fv");
var $af9b68b1f2b166ba$export$65223d64021ba6a8 = /*#__PURE__*/ function(UserAccessValidationState) {
    UserAccessValidationState["LOADING_PORTAL_ELIGIBILITY"] = "LOADING_PORTAL_ELIGIBILITY";
    UserAccessValidationState["LOADING_USER_PERMISSIONS"] = "LOADING_USER_PERMISSIONS";
    UserAccessValidationState["VALIDATION_FAIL_NO_ACCESS_TO_SELECTED_ROUTE"] = "VALIDATION_FAIL_NO_ACCESS_TO_SELECTED_ROUTE";
    UserAccessValidationState["VALIDATION_FAIL_INELIGIBLE_FOR_PORTAL"] = "VALIDATION_FAIL_INELIGIBLE_FOR_PORTAL";
    UserAccessValidationState["VALIDATION_FAIL_CUSTOMER_NOT_CONSENTED"] = "VALIDATION_FAIL_CUSTOMER_NOT_CONSENTED";
    UserAccessValidationState["VALIDATION_SUCCESS"] = "VALIDATION_SUCCESS";
    return UserAccessValidationState;
}({});
const $af9b68b1f2b166ba$export$6fd889175fcd8d17 = ()=>{
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const { isValidFastshiftRoute: isValidFastshiftRoute, domainId: domainId, paths: paths, isValidFastshiftPartnerRoute: isValidFastshiftPartnerRoute } = (0, $bh3Fv.useRoutes)();
    const { pathname: pathname } = (0, $j2t2h.useLocation)();
    const navigate = (0, $j2t2h.useNavigate)();
    const dispatch = (0, $f7YG8.useFastshiftDispatch)();
    const { data: userDetails, error: userDetailsError, pending: userDetailsIsPending } = (0, $f7YG8.useFastshiftSelector)((state)=>state.userDetails);
    const { data: customerDomainData, error: customerDomainError } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomain);
    const { data: domainsForPartnerAccess } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomains);
    const { data: userHasConsented, pending: userHasConsentedIsPending } = (0, $f7YG8.useFastshiftSelector)((state)=>state.portalUserConsent);
    const [userAccessState, setUserAccessState] = (0, $1oC0p.useState)("LOADING_PORTAL_ELIGIBILITY");
    const strippedPathname = (0, $1oC0p.useMemo)(()=>(0, $cl5fF.removeTrailingSlash)(pathname), [
        pathname
    ]);
    const isPartnerOrInternal = (userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) === "PARTNER" || (userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) === "INTERNAL";
    const pageDomainIsPresentInPartnerSelectionTable = (0, $1oC0p.useMemo)(()=>{
        var _domainsForPartnerAccess_data;
        return domainsForPartnerAccess === null || domainsForPartnerAccess === void 0 ? void 0 : (_domainsForPartnerAccess_data = domainsForPartnerAccess.data) === null || _domainsForPartnerAccess_data === void 0 ? void 0 : _domainsForPartnerAccess_data.some((accessibleDomain)=>accessibleDomain.customerDomainId === domainId);
    }, [
        domainsForPartnerAccess,
        domainId
    ]);
    const shouldShowSideNav = (0, $1oC0p.useMemo)(()=>{
        return [
            "VALIDATION_SUCCESS",
            "LOADING_USER_PERMISSIONS"
        ].includes(userAccessState) && isValidFastshiftRoute(pathname) && strippedPathname !== paths.home;
    }, [
        userAccessState,
        isValidFastshiftRoute,
        pathname,
        strippedPathname,
        paths.home
    ]);
    const isOnHomeRoute = (0, $1oC0p.useMemo)(()=>strippedPathname === paths.home, [
        strippedPathname,
        paths.home
    ]);
    const customerConsentCheckStillPending = (userDetailsIsPending || (userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) === "CUSTOMER") && userHasConsentedIsPending;
    const resolvesIfUserIsAuthenticated = (0, $1oC0p.useCallback)(async ()=>{
        return stargateClient.me({});
    }, [
        stargateClient
    ]);
    const redirectToHomeRoute = ()=>{
        if (strippedPathname !== paths.home) navigate(paths.home);
    };
    const redirectIneligibleUserToHome = ()=>{
        setUserAccessState("VALIDATION_FAIL_INELIGIBLE_FOR_PORTAL");
        redirectToHomeRoute();
    };
    const redirectUserToConsentLandingPage = ()=>{
        setUserAccessState("VALIDATION_FAIL_CUSTOMER_NOT_CONSENTED");
        redirectToHomeRoute();
    };
    // Trigger appropriate checks on page route change
    (0, $1oC0p.useEffect)(()=>{
        // if present, user has already passed portal eligibility checks
        if (userDetails) {
            // Avoid flickering/loading state when navigating between routes after success
            if (userAccessState !== "VALIDATION_SUCCESS") setUserAccessState("LOADING_USER_PERMISSIONS");
            return;
        }
        // if previously shown to be ineligible for portal
        if (userDetailsError) {
            redirectIneligibleUserToHome();
            return;
        }
        setUserAccessState("LOADING_PORTAL_ELIGIBILITY");
    // should only run when user changes page
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pathname
    ]);
    // Portal Eligibility: Check User is Authenticated
    (0, $1oC0p.useEffect)(()=>{
        if (userAccessState !== "LOADING_PORTAL_ELIGIBILITY") return;
        // if user details is not present, ensure user is authenticated and fetch details
        resolvesIfUserIsAuthenticated().then(()=>{
            // Retrieve /user details
            dispatch($8Bmsc.getUserDetails(stargateClient));
            // Retrieve consent details
            dispatch($8Bmsc.getPortalUserConsent({
                stargateClient: stargateClient,
                displayedText: (0, $34zoS.CONSENT_PAGE_LEGAL_DISPLAY_TEXT_VERSION)
            }));
        }).catch(()=>{
            // Redirect to Identity to login user
            const currentDomain = window.location.hostname;
            // If fastshift domain - use new fastshift login auth redirect url
            if ((0, $fq4go.FASTSHIFT_DOMAINS).includes(currentDomain)) {
                const fastshiftLoginAuthContinueUrl = encodeURIComponent(`${(0, $fq4go.FASTSHIFT_BASE_URL)}${(0, $fq4go.FASTSHIFT_AUTH_REDIRECT_URL)}`);
                const loginUrl = `${"https://id.atlassian.com"}/login?continue=${fastshiftLoginAuthContinueUrl}`;
                window.location.href = loginUrl;
            } else {
                const loginUrl = `${"https://id.atlassian.com"}/login?continue=${encodeURIComponent(`${(0, $fq4go.BASE_URL)}${strippedPathname}`)}`;
                window.location.href = loginUrl;
            }
        });
    // should only run Portal Eligibility check is initiated
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userAccessState
    ]);
    // Portal Eligibility: Check User is Eligible
    (0, $1oC0p.useEffect)(()=>{
        if (userAccessState !== "LOADING_PORTAL_ELIGIBILITY") return;
        // still resolving details
        if (!userDetails && !userDetailsError) return;
        // if ineligible for portal
        if (userDetailsError) {
            redirectIneligibleUserToHome();
            return;
        }
        // wait for check if customer has consented
        if (customerConsentCheckStillPending) return;
        // if customer hasn't consented, redirect to home
        if (!userHasConsented && (userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) === "CUSTOMER") {
            redirectUserToConsentLandingPage();
            return;
        }
        // at this point, permissions on specific page may be checked
        setUserAccessState("LOADING_USER_PERMISSIONS");
        // if on EAP home route, redirect to Milestone 2 home route
        if (strippedPathname === paths.eapHome) {
            redirectToHomeRoute();
            return;
        }
    // should only run when /user endpoint resolves during eligibility check
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userDetails,
        userDetailsError,
        customerConsentCheckStillPending
    ]);
    // User Permissions: Page Check
    // eslint-disable-next-line complexity
    (0, $1oC0p.useEffect)(()=>{
        // Wait until portal eligibility (user details) is resolved
        if (!userDetails && !userDetailsError) return;
        // If user is ineligible for portal, do not perform route-level checks
        if (userDetailsError) return;
        // wait for check if customer has consented
        if (customerConsentCheckStillPending) return;
        // any authenticated user may access home /fastshift route
        if (strippedPathname === paths.home) {
            setUserAccessState("VALIDATION_SUCCESS");
            return;
        }
        // if not on a valid fastshift route, immediate 404
        if (!isValidFastshiftRoute(strippedPathname)) {
            setUserAccessState("VALIDATION_FAIL_NO_ACCESS_TO_SELECTED_ROUTE");
            return;
        }
        // check partner-specific routes (no domainId)
        if (!domainId) {
            if (isPartnerOrInternal && isValidFastshiftPartnerRoute(strippedPathname)) setUserAccessState("VALIDATION_SUCCESS");
            else setUserAccessState("VALIDATION_FAIL_NO_ACCESS_TO_SELECTED_ROUTE");
            return;
        }
        // domain-scoped routes:
        // customer may access their own page without waiting for domain API
        if ((userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) === "CUSTOMER" && domainId === userDetails.userDomain.domainId) {
            setUserAccessState("VALIDATION_SUCCESS");
            return;
        }
        // partners/internal may access domains from selection table
        if (isPartnerOrInternal) {
            if (pageDomainIsPresentInPartnerSelectionTable === true) {
                setUserAccessState("VALIDATION_SUCCESS");
                return;
            }
        }
        // still pending domain info -> keep current state (likely LOADING_USER_PERMISSIONS)
        if (!customerDomainData && !customerDomainError) return;
        // if /domain returns error, then user may not access page
        if (customerDomainError) {
            setUserAccessState("VALIDATION_FAIL_NO_ACCESS_TO_SELECTED_ROUTE");
            return;
        }
        // any user may access a page where /domain returns valid response
        if (customerDomainData && customerDomainData.customerDomainId === domainId) {
            setUserAccessState("VALIDATION_SUCCESS");
            return;
        }
        // default: no access
        setUserAccessState("VALIDATION_FAIL_NO_ACCESS_TO_SELECTED_ROUTE");
    }, [
        strippedPathname,
        domainId,
        userDetails,
        customerDomainData,
        customerDomainError,
        userDetailsError,
        isPartnerOrInternal,
        isValidFastshiftRoute,
        isValidFastshiftPartnerRoute,
        paths,
        pageDomainIsPresentInPartnerSelectionTable,
        customerConsentCheckStillPending
    ]);
    return {
        userAccessState: userAccessState,
        shouldShowSideNav: shouldShowSideNav,
        isPartnerOrInternal: isPartnerOrInternal,
        isOnHomeRoute: isOnHomeRoute
    };
};

});
parcelRegister("cl5fF", function(module, exports) {
$parcel$export(module.exports, "getDomainScopedPathKeys", function () { return $1cba51e16cd6bc21$export$f1b565c028d844bf; });
$parcel$export(module.exports, "removeTrailingSlash", function () { return $1cba51e16cd6bc21$export$b6d465111d914331; });

var $fq4go = parcelRequire("fq4go");
const $1cba51e16cd6bc21$export$f1b565c028d844bf = ()=>Object.keys((0, $fq4go.FASTSHIFT_PATHS)).filter((pathKey)=>(0, $fq4go.FASTSHIFT_PATHS)[pathKey].includes(":domainId"));
const $1cba51e16cd6bc21$export$b6d465111d914331 = (url)=>url.replace(/\/+$/, "");
const $1cba51e16cd6bc21$export$51ace7bd145e4ac6 = (env)=>{
    switch(env){
        case "production":
            return 0, $fq4go.FASTSHIFT_BASE_URL_PROD;
        case "staging":
            return 0, $fq4go.FASTSHIFT_BASE_URL_STAGING;
        case "development":
            // development environment is not fully set up so expect errors if you use this environment
            return 0, $fq4go.FASTSHIFT_BASE_URL_DEV;
        default:
            return null;
    }
};

});

parcelRegister("kPtON", function(module, exports) {
$parcel$export(module.exports, "LegalConsentPage", function () { return (parcelRequire("fepi2")).LegalConsentPage; });
$parcel$export(module.exports, "CONSENT_PAGE_LEGAL_DISPLAY_TEXT_VERSION", function () { return (parcelRequire("34zoS")).CONSENT_PAGE_LEGAL_DISPLAY_TEXT_VERSION; });

var $fepi2 = parcelRequire("fepi2");

var $34zoS = parcelRequire("34zoS");

});
parcelRegister("fepi2", function(module, exports) {
$parcel$export(module.exports, "LegalConsentPage", function () { return $a6426de1a5816394$export$a2c179b32c53e8e9; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $1HVQz = parcelRequire("1HVQz");

var $lWOKW = parcelRequire("lWOKW");

var $dTJrO = parcelRequire("dTJrO");

var $cB1fn = parcelRequire("cB1fn");

var $dTWad = parcelRequire("dTWad");

var $04laP = parcelRequire("04laP");

var $7ZMp9 = parcelRequire("7ZMp9");

var $g3ExX = parcelRequire("g3ExX");
var $iggFr = parcelRequire("iggFr");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");

var $imIsw = parcelRequire("imIsw");

var $10JVy = parcelRequire("10JVy");
parcelRequire("2oyXL");
var $7XUV9 = parcelRequire("7XUV9");
var $1hJn7 = parcelRequire("1hJn7");

var $1Gdf7 = parcelRequire("1Gdf7");
const $a6426de1a5816394$var$baseStyles = (0, $f6YGh.xcss)({
    width: "800px",
    marginInline: "auto"
});
const $a6426de1a5816394$var$EXTERNAL_LINK = {
    CUSTOMER_AGREEMENT: "https://www.atlassian.com/legal/atlassian-customer-agreement#intro",
    PRIVACY_POLICY: "https://www.atlassian.com/legal/privacy-policy"
};
// defining in-render components above to fix "react/no-unstable-nested-components" warning
const $a6426de1a5816394$var$CustomerAgreementExternalLink = (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7ZMp9.default), {
        href: $a6426de1a5816394$var$EXTERNAL_LINK.CUSTOMER_AGREEMENT,
        target: "_blank",
        children: chunks
    });
const $a6426de1a5816394$var$CustomerAgreementPrivacyProlicy = (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7ZMp9.default), {
        href: $a6426de1a5816394$var$EXTERNAL_LINK.PRIVACY_POLICY,
        target: "_blank",
        children: chunks
    });
const $a6426de1a5816394$export$a2c179b32c53e8e9 = ()=>{
    const { submitUserConsentWithFlags: submitUserConsentWithFlags, submitIsLoading: isSubmitConsentRequestPending } = (0, $1hJn7.useSubmitUserConsentWithFlags)();
    const intl = (0, $8e22h.default)();
    const [isChecked, setIsChecked] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState(false);
    const { sendCustomerConsentButtonClickUIEvent: sendCustomerConsentButtonClickUIEvent } = (0, $7XUV9.useLegalConsentPageAnalytics)();
    const handleCheckboxAction = ()=>{
        setIsChecked((current)=>!current);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
        xcss: $a6426de1a5816394$var$baseStyles,
        paddingBlockStart: "space.400",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
            alignBlock: "center",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7i5qx6qe6npbltnew2788ii8d46x8siv/t/re_w_1500,re_h_380,re_rm_stretch/AT12DQGV.auto",
                        alt: intl.formatMessage((0, $1Gdf7.messages).legalConsentBannerAltText)
                    },
                    style: {
                        width: "800px",
                        height: "203px"
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                    paddingBlockStart: "space.400",
                    paddingBlockEnd: "space.200",
                    paddingInline: "space.500",
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                        alignBlock: "center",
                        space: "space.200",
                        alignInline: "center",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                                size: "large",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $1Gdf7.messages).legalConsentHeading))
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                align: "center",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $1Gdf7.messages).legalConsentDescription), {
                                    values: {
                                        a: (chunks)=>$a6426de1a5816394$var$CustomerAgreementExternalLink(chunks),
                                        b: (chunks)=>$a6426de1a5816394$var$CustomerAgreementPrivacyProlicy(chunks)
                                    }
                                }))
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                align: "center",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $1Gdf7.messages).legalConsentFeatureHeadlineText))
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $iggFr.default), {
                                gap: "space.200",
                                autoFlow: "column",
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $10JVy.FeatureBox), {
                                        heading: (0, $1Gdf7.messages).legalConsentPortalFeature_TrackTickets_Heading,
                                        description: (0, $1Gdf7.messages).legalConsentPortalFeature_TrackTickets_Description,
                                        icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($04laP))), {
                                            label: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $10JVy.FeatureBox), {
                                        heading: (0, $1Gdf7.messages).legalConsentPortalFeature_PlanMigration_Heading,
                                        description: (0, $1Gdf7.messages).legalConsentPortalFeature_PlanMigration_Description,
                                        icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dTWad))), {
                                            label: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $10JVy.FeatureBox), {
                                        heading: (0, $1Gdf7.messages).legalConsentPortalFeature_ViewResources_Heading,
                                        description: (0, $1Gdf7.messages).legalConsentPortalFeature_ViewResources_Description,
                                        icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cB1fn))), {
                                            label: ""
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lWOKW.default), {
                                isChecked: isChecked,
                                label: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $1Gdf7.messages).legalConsentPortalFeature_LegalAgreementCheckboxText))
                                }),
                                onChange: handleCheckboxAction,
                                name: "legal-agreement-checkbox",
                                testId: "legal-agreement-checkbox"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                    paddingBlock: "space.250",
                    paddingInline: "space.500",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2YtGy.default), {
                        alignBlock: "center",
                        alignInline: "center",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1HVQz.default), {
                            appearance: "primary",
                            isLoading: isSubmitConsentRequestPending,
                            onClick: ()=>{
                                sendCustomerConsentButtonClickUIEvent();
                                submitUserConsentWithFlags();
                            },
                            isDisabled: !isChecked,
                            children: intl.formatMessage((0, $1Gdf7.messages).legalConsentPortalFeature_ProceedToPortalButton)
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                    align: "center",
                    size: "small",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $1Gdf7.messages).legalConsentPortalFeature_LegalAgreementFooter))
                })
            ]
        })
    });
};

});
parcelRegister("10JVy", function(module, exports) {
$parcel$export(module.exports, "FeatureBox", function () { return $83f19aeff66cdcbd$export$d73954f5113b3279; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $dTJrO = parcelRequire("dTJrO");

var $g3ExX = parcelRequire("g3ExX");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");
const $83f19aeff66cdcbd$var$iconBorderStyles = (0, $f6YGh.xcss)({
    height: "32px",
    width: "32px",
    padding: "space.050",
    // border
    border: "1.5px",
    borderRadius: "6px",
    borderStyle: "solid",
    borderColor: "color.border.disabled"
});
const $83f19aeff66cdcbd$export$d73954f5113b3279 = ({ heading: heading, description: description, icon: icon })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
        padding: "space.200",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
            space: "space.200",
            alignInline: "start",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2YtGy.default), {
                    xcss: $83f19aeff66cdcbd$var$iconBorderStyles,
                    alignBlock: "center",
                    alignInline: "center",
                    grow: "fill",
                    children: icon
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                    space: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, heading))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, description))
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("2oyXL", function(module, exports) {
$parcel$export(module.exports, "useLegalConsentPageAnalytics", function () { return (parcelRequire("7XUV9")).useLegalConsentPageAnalytics; });
$parcel$export(module.exports, "useSubmitUserConsentWithFlags", function () { return (parcelRequire("1hJn7")).useSubmitUserConsentWithFlags; });

var $7XUV9 = parcelRequire("7XUV9");

var $1hJn7 = parcelRequire("1hJn7");

});
parcelRegister("7XUV9", function(module, exports) {
$parcel$export(module.exports, "useLegalConsentPageAnalytics", function () { return $3293d7d22368f48f$export$17dfadfa2958cbe6; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
const $3293d7d22368f48f$export$17dfadfa2958cbe6 = ()=>{
    const { identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)();
    const { fireScreenEvent: fireScreenEvent, fireUIEvent: fireUIEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    // Screen Event
    (0, $1oC0p.useEffect)(()=>{
        fireScreenEvent({
            name: (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_LEGAL_CONSENT_SCREEN
        });
    }, [
        fireScreenEvent
    ]);
    // UI event
    const sendCustomerConsentButtonClickUIEvent = (0, $1oC0p.useCallback)(()=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).LEGAL_CONSENT_BUTTON,
            source: (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_LEGAL_CONSENT_SCREEN
        });
    }, [
        fireUIEvent
    ]);
    return {
        sendCustomerConsentButtonClickUIEvent: sendCustomerConsentButtonClickUIEvent
    };
};

});

parcelRegister("1hJn7", function(module, exports) {
$parcel$export(module.exports, "useSubmitUserConsentWithFlags", function () { return $38a094dcd858dc82$export$acec1891eaf67a5a; });

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $kbaUT = parcelRequire("kbaUT");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");

var $8Bmsc = parcelRequire("8Bmsc");

var $9n7Lo = parcelRequire("9n7Lo");

var $PE2DD = parcelRequire("PE2DD");

var $34zoS = parcelRequire("34zoS");

var $1Gdf7 = parcelRequire("1Gdf7");
const $38a094dcd858dc82$var$UNKNOWN_REGION = "UNKNOWN";
const $38a094dcd858dc82$export$acec1891eaf67a5a = ()=>{
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const intl = (0, $8e22h.default)();
    const dispatch = (0, $f7YG8.useFastshiftDispatch)();
    const [submitIsLoading, setSubmitIsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState(false);
    const { data: userDetails } = (0, $f7YG8.useFastshiftSelector)((state)=>state.userDetails);
    const { showFlag: showFlag } = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useContext((0, $kbaUT.default).Context);
    const successFlag = {
        id: "success-flag",
        iconType: "success",
        styleOverride: true,
        autoDismiss: true,
        title: intl.formatMessage((0, $1Gdf7.messages).legalConsentPortalFeature_SuccessFlag_Title),
        description: intl.formatMessage((0, $1Gdf7.messages).legalConsentPortalFeature_SuccessFlag_Description)
    };
    const errorFlag = {
        id: "error-flag",
        iconType: "error",
        styleOverride: true,
        autoDismiss: true,
        title: intl.formatMessage((0, $1Gdf7.messages).legalConsentPortalFeature_ErrorFlag_Title),
        description: intl.formatMessage((0, $1Gdf7.messages).legalConsentPortalFeature_ErrorFlag_Description)
    };
    const displayAndReportError = (message)=>{
        var _userDetails_userDomain;
        setSubmitIsLoading(false);
        showFlag(errorFlag);
        (0, $9n7Lo.captureErrorWithContext)({
            error: "Error on fetching user consent state",
            message: message,
            userDomain: userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_userDomain = userDetails.userDomain) === null || _userDetails_userDomain === void 0 ? void 0 : _userDetails_userDomain.domain
        });
    };
    const submitUserConsentWithFlags = ()=>{
        setSubmitIsLoading(true);
        stargateClient.sendFastshiftPortalConsent({
            requestBody: {
                displayedText: (0, $34zoS.CONSENT_PAGE_LEGAL_DISPLAY_TEXT_VERSION),
                locale: $38a094dcd858dc82$var$UNKNOWN_REGION
            }
        }).then((response)=>{
            if (response.data.consent && response.success) {
                dispatch($8Bmsc.setPortalUserConsent(true));
                setSubmitIsLoading(false);
                showFlag(successFlag);
            } else displayAndReportError(`Backend request succeeded, but response data was unexpected: ${JSON.stringify(response)}`);
        }).catch((message)=>{
            displayAndReportError(message);
        });
    };
    return {
        submitUserConsentWithFlags: submitUserConsentWithFlags,
        submitIsLoading: submitIsLoading
    };
};

});
parcelRegister("34zoS", function(module, exports) {
$parcel$export(module.exports, "CONSENT_PAGE_LEGAL_DISPLAY_TEXT_VERSION", function () { return $69cd3783b3257b4d$export$1040852d0b63c109; });

var $1Gdf7 = parcelRequire("1Gdf7");
const $69cd3783b3257b4d$export$1040852d0b63c109 = (0, $1Gdf7.messages).legalConsentPortalFeature_LegalAgreementCheckboxText.defaultMessage;

});
parcelRegister("1Gdf7", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $0fda6eb53e2594f8$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $0fda6eb53e2594f8$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    legalConsentHeading: {
        id: "fastshift.legal-consent-page.heading",
        defaultMessage: "Start using FastShift Portal",
        description: "Heading for landing page shown to customers when they use Fastshift Portal for the first time."
    },
    legalConsentBannerAltText: {
        id: "fastshift.legal-consent-page.header.alt-text",
        defaultMessage: "Decorative image",
        description: "Alt Text for the banner image for this page."
    },
    legalConsentDescription: {
        id: "fastshift.legal-consent-page.description",
        defaultMessage: "The FastShift Portal enables visibility and collaboration across teams working on your migration, including Atlassian, your partners, and your own teams. Use of the FastShift Portal is governed by the <a>Atlassian Customer Agreement</a> and <b>Atlassian Privacy Policy</b>.*",
        description: "Usage agreement details for the consent landing page shown to customers when they use Fastshift Portal for the first time."
    },
    legalConsentFeatureHeadlineText: {
        id: "fastshift.legal-consent-page.description-headline",
        defaultMessage: "FastShift Portal allows you and your migration team to:",
        description: "This text is shown directly above a table describing some features of fastshift portal."
    },
    legalConsentPortalFeature_TrackTickets_Heading: {
        id: "fastshift.legal-consent-page.feature.track-tickets.heading",
        defaultMessage: "Track tickets",
        description: "Heading for Fastshift Portal Feature Tile - feature: lets you track migration support tickets."
    },
    legalConsentPortalFeature_TrackTickets_Description: {
        id: "fastshift.legal-consent-page.feature.track-tickets.description",
        defaultMessage: "View all migration tickets in one place.",
        description: "Description for Fastshift Portal Feature Tile - feature: lets you track migration support tickets."
    },
    legalConsentPortalFeature_PlanMigration_Heading: {
        id: "fastshift.legal-consent-page.feature.plan-migration.heading",
        defaultMessage: "Plan migration",
        description: "Heading for Fastshift Portal Feature Tile - feature: helps you plan your migration."
    },
    legalConsentPortalFeature_PlanMigration_Description: {
        id: "fastshift.legal-consent-page.feature.plan-migration.description",
        defaultMessage: "Have an overview of nexts steps of your migration.",
        description: "Description for Fastshift Portal Feature Tile - feature: helps you plan your migration."
    },
    legalConsentPortalFeature_ViewResources_Heading: {
        id: "fastshift.legal-consent-page.feature.view-resources.heading",
        defaultMessage: "View resources",
        description: "Heading for Fastshift Portal Feature Tile - feature: helps you share and review documents."
    },
    legalConsentPortalFeature_ViewResources_Description: {
        id: "fastshift.legal-consent-page.feature.view-resources.description",
        defaultMessage: "Get dedicated resources focused on each phase of your migration.",
        description: "Description for Fastshift Portal Feature Tile - feature: helps you share and review documents."
    },
    legalConsentPortalFeature_LegalAgreementCheckboxText: {
        id: "fastshift.legal-consent-page.legal-agreement-checkbox-text",
        defaultMessage: "I understand that the FastShift Portal is a \u201CFree or Beta Product\u201D under Section 17 of the Atlassian Customer Agreement and I authorize its use by the teams supporting my migration.",
        description: "Description for Fastshift Portal legal agreement. This text is shown next to a checkbox, and the user ticks the checkbox if they agree with this statement. This is important to translate accurately."
    },
    legalConsentPortalFeature_LegalAgreementFooter: {
        id: "fastshift.legal-consent-page.legal-agreement-footer",
        defaultMessage: "*If you have any questions, please contact your delivery manager.",
        description: "Footer underneath the main text to describe how the customer can seek assistance in further understanding the context of the legal consent page."
    },
    legalConsentPortalFeature_ProceedToPortalButton: {
        id: "fastshift.legal-consent-page.button.proceed-to-portal",
        defaultMessage: "Proceed to FastShift Portal",
        description: "Clicking this button lets you access the rest of Fastshift Portal. (This button is only enabled if the user has ticked the user agreement checkbox to indicate their consent.)"
    },
    legalConsentPortalFeature_SuccessFlag_Title: {
        id: "fastshift.legal-consent-page.success-flag.title",
        defaultMessage: "We\u2019ve saved your consent",
        description: "Title of success flag shown when the user consents successfully."
    },
    legalConsentPortalFeature_SuccessFlag_Description: {
        id: "fastshift.legal-consent-page.success-flag.description",
        defaultMessage: "Your consent has been successfully recorded.",
        description: "Description of success flag shown when the user consents successfully."
    },
    legalConsentPortalFeature_ErrorFlag_Title: {
        id: "fastshift.legal-consent-page.error-flag.title",
        defaultMessage: "We\u2019re unable to save your consent right now",
        description: "Title of error flag shown when the user submits consent but there is some backend error causing it to fail."
    },
    legalConsentPortalFeature_ErrorFlag_Description: {
        id: "fastshift.legal-consent-page.error-flag.description",
        defaultMessage: "Refresh the page or try again later.",
        description: "Description of error flag shown when the user submits consent but there is some backend error causing it to fail."
    }
});

});









parcelRegister("eVlKP", function(module, exports) {
$parcel$export(module.exports, "DomainScopedNavHeader", function () { return (parcelRequire("ffpci")).DomainScopedNavHeader; });

var $ffpci = parcelRequire("ffpci");

});
parcelRegister("ffpci", function(module, exports) {
$parcel$export(module.exports, "DomainScopedNavHeader", function () { return $b5c65783793a6efb$export$75394d8c360864dd; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $4hbqm = parcelRequire("4hbqm");

var $1RpK2 = parcelRequire("1RpK2");

var $f3Vh4 = parcelRequire("f3Vh4");

var $fmW7P = parcelRequire("fmW7P");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");

var $4jcRW = parcelRequire("4jcRW");

var $f7YG8 = parcelRequire("f7YG8");

var $imIsw = parcelRequire("imIsw");
parcelRequire("iTGju");
var $bh3Fv = parcelRequire("bh3Fv");
parcelRequire("jGed2");
var $ct4Ak = parcelRequire("ct4Ak");

var $dKb1Y = parcelRequire("dKb1Y");
const $b5c65783793a6efb$var$selectedCustomerStyles = (0, $f6YGh.xcss)({
    paddingInlineStart: "space.100",
    paddingBlockEnd: "space.150",
    alignItems: "center",
    gap: "space.100"
});
const $b5c65783793a6efb$var$selectedCustomerTextStyles = (0, $f6YGh.xcss)({
    flex: 1
});
const $b5c65783793a6efb$var$CustomerDomainDisplay = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    // use the customer domain id to get the customer name
    const { data: customerDomain, pending: isLoadingCustomerDomain } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomain);
    // return skeleton if pending refresh or there is no data available
    if (!customerDomain || isLoadingCustomerDomain) return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $fmW7P.default), {
        xcss: $b5c65783793a6efb$var$selectedCustomerStyles,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                height: "36px",
                width: "36px",
                borderRadius: "border.radius",
                testId: "customer-domain-logo-skeleton",
                isShimmering: true
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                xcss: $b5c65783793a6efb$var$selectedCustomerTextStyles,
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                        height: "16px",
                        width: "100%",
                        testId: "customer-name-skeleton",
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                        height: "16px",
                        width: "100%",
                        testId: "customer-domain-skeleton",
                        isShimmering: true
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $fmW7P.default), {
        xcss: $b5c65783793a6efb$var$selectedCustomerStyles,
        children: [
            customerDomain.customerLogoUrl ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: customerDomain.customerLogoUrl,
                    alt: formatMessage((0, $dKb1Y.messages).logoAltText, {
                        name: customerDomain.customerName
                    })
                },
                style: {
                    width: "32px",
                    height: "32px",
                    borderRadius: "4px"
                }
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
                height: "36px",
                width: "36px",
                borderRadius: "4px",
                testId: "customer-domain-logo-skeleton"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                xcss: $b5c65783793a6efb$var$selectedCustomerTextStyles,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                        size: "large",
                        children: customerDomain.customerName
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                        color: "color.text.subtlest",
                        children: customerDomain.customerDomain
                    })
                ]
            })
        ]
    });
};
const $b5c65783793a6efb$export$75394d8c360864dd = ({ isOnDomainScopedPage: isOnDomainScopedPage })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { paths: paths } = (0, $bh3Fv.useRoutes)();
    const { sendCustomerSelectionBackButtonClickEvent: sendCustomerSelectionBackButtonClickEvent } = (0, $ct4Ak.usePageLayoutAnalytics)();
    if (!isOnDomainScopedPage) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f3Vh4.MenuList), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1RpK2.LinkMenuItem), {
                    href: paths.selection,
                    elemBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4hbqm))), {
                        label: "",
                        color: "currentColor",
                        spacing: "spacious"
                    }),
                    onClick: ()=>{
                        sendCustomerSelectionBackButtonClickEvent(paths.selection);
                    },
                    children: formatMessage((0, $dKb1Y.messages).customersBackLabel)
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($b5c65783793a6efb$var$CustomerDomainDisplay, {})
        ]
    });
};

});
parcelRegister("jGed2", function(module, exports) {
$parcel$export(module.exports, "usePageNavLinks", function () { return (parcelRequire("9GmHN")).usePageNavLinks; });
$parcel$export(module.exports, "useLoadDomainScopedState", function () { return (parcelRequire("gulZg")).useLoadDomainScopedState; });
$parcel$export(module.exports, "usePageLayoutAnalytics", function () { return (parcelRequire("ct4Ak")).usePageLayoutAnalytics; });

var $9GmHN = parcelRequire("9GmHN");

var $gulZg = parcelRequire("gulZg");

var $ct4Ak = parcelRequire("ct4Ak");

});
parcelRegister("9GmHN", function(module, exports) {
$parcel$export(module.exports, "usePageNavLinks", function () { return $7c5aed3b8ac90c78$export$bf0e9f036a169a36; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $jwXhl = parcelRequire("jwXhl");

var $9lp51 = parcelRequire("9lp51");

var $cWei2 = parcelRequire("cWei2");

var $7l1vc = parcelRequire("7l1vc");

var $ehGJT = parcelRequire("ehGJT");
parcelRequire("iTGju");
var $bh3Fv = parcelRequire("bh3Fv");

var $fq4go = parcelRequire("fq4go");

var $cl5fF = parcelRequire("cl5fF");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $dKb1Y = parcelRequire("dKb1Y");
const $7c5aed3b8ac90c78$export$bf0e9f036a169a36 = ()=>{
    var _navLinks_find, _domainsTableList_data_find, _domainsTableList_data;
    const { fullPathname: fullPathname, paths: paths } = (0, $bh3Fv.useRoutes)();
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { domainId: domainId } = (0, $jwXhl.useParams)();
    const { data: selectedDomainData } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomain);
    const { data: domainsTableList } = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomains);
    const isUnder1kExperienceEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).sxpFastshiftPortalUnder1kCustomerExperience);
    // note that the order of this navLinks array determines
    // the order of links displayed inside the sidenav component
    const navLinks = [
        // (Ordered) Partner Scoped Links
        {
            key: (0, $fq4go.FASTSHIFT_PATH_KEYS).SELECTION,
            label: formatMessage((0, $dKb1Y.messages).customersNavLabel),
            link: paths.selection,
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7l1vc))), {
                label: ""
            })
        },
        {
            key: (0, $fq4go.FASTSHIFT_PATH_KEYS).RESOURCES_PARTNER_SCOPED,
            label: formatMessage((0, $dKb1Y.messages).resourcesNavLabel),
            link: paths.partnerResources,
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9lp51))), {
                label: ""
            })
        },
        // (Ordered) Domain Scoped Links
        {
            key: (0, $fq4go.FASTSHIFT_PATH_KEYS).OVERVIEW,
            label: formatMessage((0, $dKb1Y.messages).forYouNavLabel),
            link: paths.domainScopedOverview,
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7l1vc))), {
                label: ""
            })
        },
        {
            key: (0, $fq4go.FASTSHIFT_PATH_KEYS).TICKETS,
            label: formatMessage((0, $dKb1Y.messages).migrationTicketsNavLabel),
            link: paths.domainScopedTickets,
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ehGJT))), {
                label: ""
            })
        },
        {
            key: (0, $fq4go.FASTSHIFT_PATH_KEYS).PLANNING,
            label: formatMessage((0, $dKb1Y.messages).migrationPlanningNavLabel),
            link: paths.domainScopedPlanning,
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cWei2))), {
                label: ""
            })
        },
        {
            key: (0, $fq4go.FASTSHIFT_PATH_KEYS).RESOURCES_DOMAIN_SCOPED,
            label: formatMessage((0, $dKb1Y.messages).resourcesNavLabel),
            link: paths.domainScopedResources,
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9lp51))), {
                label: ""
            })
        }
    ];
    // find the key of the navlinks object with a link that matches the pathname
    const currentPageKey = (_navLinks_find = navLinks.find((navLink)=>navLink.link === fullPathname)) === null || _navLinks_find === void 0 ? void 0 : _navLinks_find.key;
    // filter and return domain scoped sidenav
    // if customer is small (under 1k), do not show "Migration Planning" navlink
    const domainScopedPathKeys = (0, $cl5fF.getDomainScopedPathKeys)();
    const userSelectedAnOver1kCustomerFromSelectionPage = domainsTableList === null || domainsTableList === void 0 ? void 0 : (_domainsTableList_data = domainsTableList.data) === null || _domainsTableList_data === void 0 ? void 0 : (_domainsTableList_data_find = _domainsTableList_data.find((domain)=>domain.customerDomainId === domainId)) === null || _domainsTableList_data_find === void 0 ? void 0 : _domainsTableList_data_find.hasOver1KPaidSeatsInAtLeastOneProduct;
    const shouldShowMigrationPlanningLink = (selectedDomainData === null || selectedDomainData === void 0 ? void 0 : selectedDomainData.hasOver1KPaidSeatsInAtLeastOneProduct) || userSelectedAnOver1kCustomerFromSelectionPage;
    const domainScopedLinks = navLinks.filter((navLink)=>domainScopedPathKeys.includes(navLink.key) && (navLink.key !== (0, $fq4go.FASTSHIFT_PATH_KEYS).PLANNING || shouldShowMigrationPlanningLink));
    if (domainScopedPathKeys.includes(currentPageKey || "")) return {
        pageKey: currentPageKey,
        links: isUnder1kExperienceEnabled ? domainScopedLinks : [
            ...navLinks.filter((navLink)=>domainScopedPathKeys.includes(navLink.key))
        ],
        isOnDomainScopedPage: true
    };
    // return partner scoped sidenav
    return {
        pageKey: currentPageKey,
        links: [
            ...navLinks.filter((navLink)=>!domainScopedPathKeys.includes(navLink.key))
        ],
        isOnDomainScopedPage: false
    };
};

});
parcelRegister("dKb1Y", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $ce294b8a075896e0$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $ce294b8a075896e0$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    customersNavLabel: {
        id: "fastshift-portal.page-layout.nav.customers-label",
        defaultMessage: "Customers",
        description: "Navigation label for customers page"
    },
    resourcesNavLabel: {
        id: "fastshift-portal.page-layout.nav.resources-label",
        defaultMessage: "Resources",
        description: "Navigation label for resources page"
    },
    forYouNavLabel: {
        id: "fastshift-portal.page-layout.nav.for-you-label",
        defaultMessage: "For You",
        description: "Navigation label for for you page"
    },
    migrationPlanningNavLabel: {
        id: "fastshift-portal.page-layout.nav.migration-planning-label",
        defaultMessage: "Migration Planning",
        description: "Navigation label for migration planning page"
    },
    migrationTicketsNavLabel: {
        id: "fastshift-portal.page-layout.nav.migration-tickets-label",
        defaultMessage: "Migration Tickets",
        description: "Navigation label for migration tickets page"
    },
    collapseSidebarLabel: {
        id: "fastshift-portal.page-layout.sidebar.collapse-label",
        defaultMessage: "Collapse sidebar",
        description: "Label for collapse sidebar button"
    },
    expandSidebarLabel: {
        id: "fastshift-portal.page-layout.sidebar.expand-label",
        defaultMessage: "Expand sidebar",
        description: "Label for expand sidebar button"
    },
    fastshiftAppName: {
        id: "fastshift-portal.page-layout.app.name",
        defaultMessage: "Fastshift",
        description: "Application name for Fastshift"
    },
    homePageLabel: {
        id: "fastshift-portal.page-layout.app.home-page-label",
        defaultMessage: "Home page",
        description: "Label for home page link"
    },
    customersBackLabel: {
        id: "fastshift-portal.page-layout.nav.customers-back-label",
        defaultMessage: "Customers",
        description: "Label for back to customers link in sidebar header"
    },
    logoAltText: {
        id: "fastshift-portal.page-layout.logo.alt-text",
        defaultMessage: "{name} logo",
        description: "Alt text for the company logo of the selected customer"
    },
    betaLozenge: {
        id: "fastshift-portal.page-layout.app.beta-lozenge",
        defaultMessage: "Beta",
        description: "Beta lozenge"
    }
});

});


parcelRegister("gulZg", function(module, exports) {
$parcel$export(module.exports, "useLoadDomainScopedState", function () { return $3d7a3dd07421c562$export$c25f886b0fc98cd3; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");

var $8Bmsc = parcelRequire("8Bmsc");

var $PE2DD = parcelRequire("PE2DD");
const $3d7a3dd07421c562$export$c25f886b0fc98cd3 = (customerDomainId)=>{
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const dispatch = (0, $f7YG8.useFastshiftDispatch)();
    const customerDomain = (0, $f7YG8.useFastshiftSelector)((state)=>state.customerDomain);
    (0, $1oC0p.useEffect)(()=>{
        var _customerDomain_data;
        // Fetch is not relevant to non-domain scoped pages
        if (!customerDomainId) return;
        // Don't refetch if domain-scoped state is already available
        if ((customerDomain === null || customerDomain === void 0 ? void 0 : (_customerDomain_data = customerDomain.data) === null || _customerDomain_data === void 0 ? void 0 : _customerDomain_data.customerDomainId) === customerDomainId) return;
        // Clear any outdated domain-scoped data
        // For example - a partner selected a different customer domain
        if (customerDomain === null || customerDomain === void 0 ? void 0 : customerDomain.data) dispatch($8Bmsc.clearAllCustomerDomainScopedState());
        dispatch($8Bmsc.getCustomerDomain({
            stargateClient: stargateClient,
            customerDomainId: customerDomainId
        }));
        dispatch($8Bmsc.getCustomerDomainEngagementDetails({
            stargateClient: stargateClient,
            customerDomainId: customerDomainId
        }));
    // Add once available: retrieve domain-scoped move tickets
    // Only run effect when URL Parameter is updated
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        customerDomainId
    ]);
};

});

parcelRegister("ct4Ak", function(module, exports) {
$parcel$export(module.exports, "usePageLayoutAnalytics", function () { return $f0da2f8ddbbe7b18$export$e91aa6667fd40dd5; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
const $f0da2f8ddbbe7b18$export$e91aa6667fd40dd5 = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)(true);
    const { fireUIEvent: fireUIEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    const sendSideNavLinkClickEvent = (0, $1oC0p.useCallback)((navLinkTitle, destinationRoute, isDomainScopedView)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).LINK,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).SIDE_NAV_LINK,
            source: sourceKey,
            attributes: {
                navLinkTitle: navLinkTitle,
                destinationRoute: destinationRoute,
                isDomainScopedView: isDomainScopedView
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendCustomerSelectionBackButtonClickEvent = (0, $1oC0p.useCallback)((destinationRoute)=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).LINK,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).CUSTOMER_SELECTION_BACK_LINK,
            source: sourceKey,
            attributes: {
                destinationRoute: destinationRoute
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    return {
        sendSideNavLinkClickEvent: sendSideNavLinkClickEvent,
        sendCustomerSelectionBackButtonClickEvent: sendCustomerSelectionBackButtonClickEvent
    };
};

});




parcelRegister("11Cn2", function(module, exports) {
$parcel$export(module.exports, "PagePanel", function () { return (parcelRequire("eUBIa")).PagePanel; });

var $eUBIa = parcelRequire("eUBIa");

});
parcelRegister("eUBIa", function(module, exports) {
$parcel$export(module.exports, "PagePanel", function () { return $c2664486ccb41b7c$export$9519e9bd8dc013e5; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $bkuZ6 = parcelRequire("bkuZ6");

var $79ZK0 = parcelRequire("79ZK0");
var $f6YGh = parcelRequire("f6YGh");
parcelRequire("biKC4");
var $edwqB = parcelRequire("edwqB");
const $c2664486ccb41b7c$var$panelWrapperStyle = (0, $f6YGh.xcss)({
    paddingBlock: "space.400",
    paddingInline: "space.400"
});
const $c2664486ccb41b7c$export$9519e9bd8dc013e5 = ()=>{
    const { isPanelOpen: isPanelOpen, panelContent: panelContent } = (0, $1oC0p.useContext)((0, $edwqB.PagePanelContext));
    return isPanelOpen && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bkuZ6.Panel), {
        defaultWidth: 400,
        hasBorder: true,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $79ZK0.default), {
            xcss: $c2664486ccb41b7c$var$panelWrapperStyle,
            grow: "fill",
            children: panelContent
        })
    });
};

});
parcelRegister("bkuZ6", function(module, exports) {
$parcel$export(module.exports, "Panel", function () { return $83f998d705a55733$export$2ddb90ad54e5f587; });
/* panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $363qk = parcelRequire("363qk");

var $9DP70 = parcelRequire("9DP70");

var $1oC0p = parcelRequire("1oC0p");

var $iiT5o = parcelRequire("iiT5o");

var $39c3M = parcelRequire("39c3M");

var $i4LXa = parcelRequire("i4LXa");

var $8Ook3 = parcelRequire("8Ook3");

var $h6B0m = parcelRequire("h6B0m");

var $5xY8f = parcelRequire("5xY8f");

var $9DxTV = parcelRequire("9DxTV");

var $9Kv5j = parcelRequire("9Kv5j");

var $hvwmI = parcelRequire("hvwmI");

var $knkrb = parcelRequire("knkrb");

var $3RCjk = parcelRequire("3RCjk");
var $83f998d705a55733$var$panelSplitterResizingVar = '--n_pnlRsz';
/**
 * We typically use the `defaultWidth` as the minimum resizing width,
 * but for large default widths we fallback to a standard value.
 *
 * This standard value of `400px` is to align with the Global Preview Panels.
 */ var $83f998d705a55733$var$fallbackResizeMinWidth = 400;
var $83f998d705a55733$var$styles = {
    root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3ieqxy _kqsw1if8 _152timx3 _bfhk1bhr _14b54rrg _4ap3vuon _1dhy1c6w _9sns1wug",
    border: "_191wglyw _16qs1cd0 _1w6ezgxb _scbpglyw",
    scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
    hidden: "_1e0cglyw",
    oldMobileWidth: "_1bsb1adv",
    newMobileWidth: "_1bsb1dxx"
};
function $83f998d705a55733$export$2ddb90ad54e5f587(_ref) {
    var children = _ref.children, _ref$defaultWidth = _ref.defaultWidth, defaultWidth = _ref$defaultWidth === void 0 ? 365 : _ref$defaultWidth, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Panel' : _ref$label, _ref$skipLinkLabel = _ref.skipLinkLabel, skipLinkLabel = _ref$skipLinkLabel === void 0 ? label : _ref$skipLinkLabel, testId = _ref.testId, providedId = _ref.id, xcss = _ref.xcss, _ref$hasBorder = _ref.hasBorder, hasBorder = _ref$hasBorder === void 0 ? (0, $39c3M.fg)('platform_design_system_nav4_panel_default_border') : _ref$hasBorder;
    var dangerouslyHoistSlotSizes = (0, $1oC0p.useContext)((0, $5xY8f.DangerouslyHoistSlotSizes));
    var id = (0, $9Kv5j.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $8Ook3.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0
    });
    var ref = (0, $1oC0p.useRef)(null);
    var _useState = (0, $1oC0p.useState)(defaultWidth), _useState2 = (0, $9DP70.default)(_useState, 2), width = _useState2[0], setWidth = _useState2[1];
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    var defaultWidthRef = (0, $1oC0p.useRef)(defaultWidth);
    /**
   * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
   * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $1oC0p.useEffect)(function() {
        if (defaultWidthRef.current === defaultWidth) return;
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    var sideNavRef = (0, $knkrb.useSideNavRef)();
    /**
   * The minimum width that the panel can be resized to by the user.
   *
   * We only use the `defaultWidth` up to a point to avoid huge panels.
   */ var minWidth = Math.min(defaultWidth, $83f998d705a55733$var$fallbackResizeMinWidth);
    /**
   * Returns the bounds for resizing, evaluated lazily when needed.
   *
   * Defined separately to the slot bounds because the resizing bounds need to be resolvable to a pixel value,
   * and the panel's slot bounds use a complex CSS expression.
   */ var getResizeBounds = (0, $1oC0p.useCallback)(function() {
        var _sideNavRef$current$o, _sideNavRef$current;
        var sideNavWidth = (_sideNavRef$current$o = (_sideNavRef$current = sideNavRef.current) === null || _sideNavRef$current === void 0 ? void 0 : _sideNavRef$current.offsetWidth) !== null && _sideNavRef$current$o !== void 0 ? _sideNavRef$current$o : 0;
        /**
     * The panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
     *
     * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
     */ var maxWidth = Math.round((window.innerWidth - sideNavWidth) / 2);
        return {
            min: "".concat(minWidth, "px"),
            max: "".concat(maxWidth, "px")
        };
    }, [
        minWidth,
        sideNavRef
    ]);
    var panelWidthSlotBounds = {
        min: "".concat(minWidth, "px"),
        // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
        max: "round(nearest, calc((100vw - var(".concat((0, $h6B0m.sideNavLiveWidthVar), ", 0px)) / 2), 1px)")
    };
    var panelVariableWidth = "clamp(".concat(panelWidthSlotBounds.min, ", ").concat(width, "px, ").concat(panelWidthSlotBounds.max, ")");
    (0, $3RCjk.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes,
        cssVar: $83f998d705a55733$var$panelSplitterResizingVar,
        panelId: (0, $h6B0m.panelPanelSplitterId)
    });
    return /*#__PURE__*/ $1oC0p.createElement("section", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $iiT5o.default)([
            $83f998d705a55733$var$styles.root,
            defaultWidth === 0 && $83f998d705a55733$var$styles.hidden,
            hasBorder && $83f998d705a55733$var$styles.border,
            (0, $39c3M.fg)('platform_design_system_nav4_panel_mobile_width_fix') ? $83f998d705a55733$var$styles.newMobileWidth : $83f998d705a55733$var$styles.oldMobileWidth,
            xcss
        ]),
        style: (0, $363qk.default)((0, $363qk.default)({}, (0, $h6B0m.panelVar), panelVariableWidth), '--minWidth', (0, $39c3M.fg)('platform_design_system_nav4_panel_mobile_width_fix') ? "".concat(minWidth, "px") : undefined),
        "data-testid": testId,
        ref: ref
    }, dangerouslyHoistSlotSizes && /*#__PURE__*/ // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    $1oC0p.createElement((0, $9DxTV.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $h6B0m.UNSAFE_panelLayoutVar),
        value: "0px",
        mediaQuery: (0, $i4LXa.media).above.lg,
        responsiveValue: "var(".concat($83f998d705a55733$var$panelSplitterResizingVar, ", ").concat(panelVariableWidth, ")")
    }), /*#__PURE__*/ $1oC0p.createElement((0, $hvwmI.PanelSplitterProvider), {
        panelId: (0, $h6B0m.panelPanelSplitterId),
        panelRef: ref,
        panelWidth: width,
        onCompleteResize: setWidth,
        getResizeBounds: getResizeBounds,
        resizingCssVar: $83f998d705a55733$var$panelSplitterResizingVar,
        position: "start"
    }, /*#__PURE__*/ $1oC0p.createElement("div", {
        className: (0, $iiT5o.default)([
            $83f998d705a55733$var$styles.scrollContainer
        ])
    }, children)));
}

});




parcelRegister("ifxD0", function(module, exports) {
$parcel$export(module.exports, "FastshiftPage", function () { return (parcelRequire("iPVQq")).FastshiftPage; });

var $iPVQq = parcelRequire("iPVQq");

});
parcelRegister("iPVQq", function(module, exports) {
$parcel$export(module.exports, "FastshiftPage", function () { return $c34eeef8a82a003a$export$99add00aff814de5; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $j2t2h = parcelRequire("j2t2h");
parcelRequire("iTGju");
var $bh3Fv = parcelRequire("bh3Fv");

var $fq4go = parcelRequire("fq4go");
parcelRequire("hVHtn");
var $f7YG8 = parcelRequire("f7YG8");
parcelRequire("hOMFg");
var $PE2DD = parcelRequire("PE2DD");
parcelRequire("kPtON");
var $fepi2 = parcelRequire("fepi2");

var $3yaMk = parcelRequire("3yaMk");
parcelRequire("kpY1n");
var $i4499 = parcelRequire("i4499");
parcelRequire("40PWP");
var $6YTDI = parcelRequire("6YTDI");
const $c34eeef8a82a003a$export$99add00aff814de5 = ()=>{
    const { paths: paths, getPathByDomainId: getPathByDomainId } = (0, $bh3Fv.useRoutes)();
    const { data: userDetails, error: userDetailsError } = (0, $f7YG8.useFastshiftSelector)((state)=>state.userDetails);
    const navigate = (0, $j2t2h.useNavigate)();
    const isPartnerOrInternal = (userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) === "PARTNER" || (userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) === "INTERNAL";
    const { data: userHasConsented } = (0, $f7YG8.useFastshiftSelector)((state)=>state.portalUserConsent);
    const shouldShowConsentLandingPage = (0, $i4499.useShouldShowConsentLandingPage)();
    (0, $1oC0p.useEffect)(()=>{
        if (userDetails) {
            if (userDetails.userType === "CUSTOMER") {
                var _userDetails_userDomain;
                // if customer has not consented yet, remain on Home page
                if (!userHasConsented) return;
                var _userDetails_userDomain_domainId;
                // customer has consented, so redirect to For You Page
                const url = getPathByDomainId((0, $fq4go.FASTSHIFT_PATHS)[(0, $fq4go.FASTSHIFT_PATH_KEYS).OVERVIEW], (_userDetails_userDomain_domainId = (_userDetails_userDomain = userDetails.userDomain) === null || _userDetails_userDomain === void 0 ? void 0 : _userDetails_userDomain.domainId) !== null && _userDetails_userDomain_domainId !== void 0 ? _userDetails_userDomain_domainId : "");
                if (url) navigate(url);
            } else if (isPartnerOrInternal) {
                const url = paths.selection;
                if (url) navigate(url);
            }
        }
    }, [
        userDetails,
        isPartnerOrInternal,
        navigate,
        getPathByDomainId,
        paths.selection,
        userHasConsented
    ]);
    if (userDetailsError === (0, $PE2DD.FastshiftUserDetailsExpectedError).NO_ELIGIBLE_LICENSE) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6YTDI.NotEligibleDisplay), {
            ineligibilityReason: "no-license"
        })
    });
    if (userDetailsError === (0, $PE2DD.FastshiftUserDetailsExpectedError).NO_ACCESS) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6YTDI.NotEligibleDisplay), {
            ineligibilityReason: "not-linked"
        })
    });
    if (shouldShowConsentLandingPage) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fepi2.LegalConsentPage), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3yaMk.CriticalErrorDisplay), {});
};

});
parcelRegister("3yaMk", function(module, exports) {
$parcel$export(module.exports, "CriticalErrorDisplay", function () { return $3a386e7568f7b670$export$17c1c445997e000a; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");
parcelRequire("z8fwG");
var $1NoJu = parcelRequire("1NoJu");
parcelRequire("d79PU");
var $bt3Kd = parcelRequire("bt3Kd");

var $7m4oB = parcelRequire("7m4oB");
const $3a386e7568f7b670$export$17c1c445997e000a = ()=>{
    const intl = (0, $8e22h.default)();
    const { refreshPortalButtonClickUIEvent: refreshPortalButtonClickUIEvent } = (0, $bt3Kd.useCriticalErrorDisplayAnalytics)();
    const onRefresh = ()=>{
        refreshPortalButtonClickUIEvent();
        window.location.reload();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NoJu.GenericErrorDisplay), {
        customMessage: intl.formatMessage((0, $7m4oB.messages).criticalErrorCustomText),
        onRefresh: onRefresh
    });
};

});
parcelRegister("d79PU", function(module, exports) {
$parcel$export(module.exports, "useCriticalErrorDisplayAnalytics", function () { return (parcelRequire("bt3Kd")).useCriticalErrorDisplayAnalytics; });

var $bt3Kd = parcelRequire("bt3Kd");

});
parcelRegister("bt3Kd", function(module, exports) {
$parcel$export(module.exports, "useCriticalErrorDisplayAnalytics", function () { return $fbb2ad197757a41a$export$5c0e668d8ce69e5f; });

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("hAwBv");
var $3aU3i = parcelRequire("3aU3i");
var $9ztLs = parcelRequire("9ztLs");

var $3cXzX = parcelRequire("3cXzX");
const $fbb2ad197757a41a$export$5c0e668d8ce69e5f = ()=>{
    const { identityAttrs: identityAttrs } = (0, $3aU3i.useFastshiftAnalyticsData)();
    const { fireScreenEvent: fireScreenEvent, fireUIEvent: fireUIEvent } = (0, $9ztLs.useFireAnalyticsEvents)(identityAttrs);
    // Screen Event
    (0, $1oC0p.useEffect)(()=>{
        fireScreenEvent({
            name: (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_CRITICAL_ERROR_SCREEN
        });
    }, [
        fireScreenEvent
    ]);
    // UI event
    const refreshPortalButtonClickUIEvent = (0, $1oC0p.useCallback)(()=>{
        fireUIEvent({
            action: (0, $3cXzX.ActionKey).CLICKED,
            actionSubject: (0, $3cXzX.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $3cXzX.ActionSubjectIdKey).REFRESH_PORTAL_BUTTON,
            source: (0, $3cXzX.SourceKey).FASTSHIFT_PORTAL_CRITICAL_ERROR_SCREEN
        });
    }, [
        fireUIEvent
    ]);
    return {
        refreshPortalButtonClickUIEvent: refreshPortalButtonClickUIEvent
    };
};

});


parcelRegister("7m4oB", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $6e16ceb3e4a25581$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $6e16ceb3e4a25581$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    criticalErrorCustomText: {
        id: "fastshift.home-page.critical-error-display.custom-text",
        defaultMessage: "We\u2019re unable to load this page right now.",
        description: "Alt Text for the generic error vector graphic displayed when an unknown error occurs"
    }
});

});


parcelRegister("40PWP", function(module, exports) {
$parcel$export(module.exports, "NotEligibleDisplay", function () { return (parcelRequire("6YTDI")).NotEligibleDisplay; });

var $6YTDI = parcelRequire("6YTDI");

});
parcelRegister("6YTDI", function(module, exports) {
$parcel$export(module.exports, "NotEligibleDisplay", function () { return $9d058e5ec8b2e7f5$export$53f49d5ce0b525cc; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $1p5OQ = parcelRequire("1p5OQ");

var $dTJrO = parcelRequire("dTJrO");

var $8tFck = parcelRequire("8tFck");
var $g3ExX = parcelRequire("g3ExX");
var $fmW7P = parcelRequire("fmW7P");
var $79ZK0 = parcelRequire("79ZK0");
var $2YtGy = parcelRequire("2YtGy");
var $lPRxe = parcelRequire("lPRxe");
var $f6YGh = parcelRequire("f6YGh");

var $fq4go = parcelRequire("fq4go");

var $lEDbn = parcelRequire("lEDbn");
parcelRequire("kpY1n");
var $bDYcw = parcelRequire("bDYcw");
var $5oHNi = parcelRequire("5oHNi");

var $33FAp = parcelRequire("33FAp");
const $9d058e5ec8b2e7f5$var$padlockStyles = (0, $f6YGh.xcss)({
    marginBlockEnd: "space.150",
    paddingBlock: "space.300"
});
const $9d058e5ec8b2e7f5$var$textStyles = (0, $f6YGh.xcss)({
    maxWidth: "580px",
    marginBlockEnd: "space.200"
});
const $9d058e5ec8b2e7f5$var$SWITCH_ACCOUNT_IDENTITY_URL = `${(0, $fq4go.IDENTITY_BASE_URL)}/login?continue=${encodeURIComponent(`${(0, $fq4go.BASE_URL)}/fastshift`)}&prompt=select_account`;
const $9d058e5ec8b2e7f5$export$53f49d5ce0b525cc = ({ ineligibilityReason: ineligibilityReason })=>{
    (0, $bDYcw.useFastshiftPageAnalytics)();
    const { sendGoBackButtonClickUIEvent: sendGoBackButtonClickUIEvent, sendSignInWithAnotherAccountButtonClickUIEvent: sendSignInWithAnotherAccountButtonClickUIEvent } = (0, $5oHNi.useFastshiftUIAnalytics)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
        padding: "space.300",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $fmW7P.default), {
            justifyContent: "center",
            alignItems: "center",
            direction: "column",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ExX.default), {
                    xcss: $9d058e5ec8b2e7f5$var$padlockStyles,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lEDbn.PadlockIcon), {})
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2YtGy.default), {
                    space: "space.200",
                    alignInline: "center",
                    xcss: $9d058e5ec8b2e7f5$var$textStyles,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $33FAp.messages).notEligibleTitle))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lPRxe.default), {
                            align: "center",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($9d058e5ec8b2e7f5$var$DescriptionMessage, {
                                ineligibilityReason: ineligibilityReason
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $79ZK0.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1p5OQ.default), {
                            href: (0, $fq4go.FASTSHIFT_PORTAL_MARKETING_URL),
                            onClick: ()=>sendGoBackButtonClickUIEvent(),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $33FAp.messages).goBackButton))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1p5OQ.default), {
                            href: $9d058e5ec8b2e7f5$var$SWITCH_ACCOUNT_IDENTITY_URL,
                            appearance: "primary",
                            onClick: ()=>sendSignInWithAnotherAccountButtonClickUIEvent(),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $33FAp.messages).signInWithAnotherAccountButton))
                        })
                    ]
                })
            ]
        })
    });
};
const $9d058e5ec8b2e7f5$var$DescriptionMessage = ({ ineligibilityReason: ineligibilityReason })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { sendContactSupportLinkClickUIEvent: sendContactSupportLinkClickUIEvent } = (0, $5oHNi.useFastshiftUIAnalytics)();
    switch(ineligibilityReason){
        case "no-license":
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $33FAp.messages).noLicenseDescription), {
                values: {
                    contactSupportLink: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8tFck.default), {
                        href: `${(0, $fq4go.SAC_URL)}/contact`,
                        target: "_blank",
                        onClick: ()=>sendContactSupportLinkClickUIEvent(),
                        children: formatMessage((0, $33FAp.messages).contactSupportAnchorText)
                    })
                }
            }));
        case "not-linked":
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $33FAp.messages).notLinkedDescription), {
                values: {
                    contactSupportLink: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8tFck.default), {
                        href: `${(0, $fq4go.SAC_URL)}/contact`,
                        target: "_blank",
                        onClick: ()=>sendContactSupportLinkClickUIEvent(),
                        children: formatMessage((0, $33FAp.messages).contactSupportAnchorText)
                    })
                }
            }));
        default:
            return null;
    }
};

});
parcelRegister("lEDbn", function(module, exports) {
$parcel$export(module.exports, "PadlockIcon", function () { return $1cf79cf0d1358ace$export$814f7e023436df33; });

var $7VQPk = parcelRequire("7VQPk");
const $1cf79cf0d1358ace$export$814f7e023436df33 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "162",
        height: "132",
        viewBox: "0 0 162 132",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M36.4193 46.0518C34.724 46.0518 33.055 45.9143 31.4579 45.6525C21.5939 44.0096 14.9568 37.6016 13.2419 28.078C12.9604 26.5136 12.8164 24.8576 12.8164 23.1623C12.8164 21.4671 12.9604 19.7653 13.2484 18.1878C14.9699 8.66416 21.607 2.25616 31.4579 0.619799C34.5997 0.0961628 38.0622 0.0830714 41.1975 0.593617C51.0615 2.19725 57.7117 8.61835 59.4331 18.2009C59.7146 19.7849 59.8651 21.4605 59.8651 23.1689C59.8651 24.8773 59.7211 26.5136 59.4462 28.078C57.7379 37.6605 51.0877 44.0816 41.204 45.6853C39.6724 45.934 38.0622 46.0649 36.4259 46.0649L36.4193 46.0518ZM36.4062 7.36162C35.1691 7.36162 33.932 7.4598 32.78 7.64962C25.9531 8.78852 21.548 13.0169 20.3633 19.5623C20.1604 20.6947 20.0557 21.8991 20.0557 23.1493C20.0557 24.3994 20.1604 25.5645 20.3568 26.6903C21.535 33.2293 25.9466 37.4642 32.78 38.6031C35.0644 38.9827 37.6302 38.9893 39.8949 38.6227C46.735 37.51 51.1466 33.2751 52.3248 26.6903C52.5277 25.5711 52.6259 24.3798 52.6259 23.1493C52.6259 21.9187 52.5211 20.7013 52.3182 19.5623C51.1335 12.9776 46.7219 8.74271 39.8949 7.62998C38.7888 7.45325 37.5975 7.36162 36.4062 7.36162Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M72.5238 24.3926H0.818359V96.098H72.5238V24.3926Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M46.9175 60.9825C47.0419 60.2822 47.1074 59.5425 47.1074 58.7571C47.1074 57.9716 47.0419 57.2058 46.911 56.4989C46.1583 52.2902 43.2325 49.6982 39.135 49.0305C38.4346 48.9193 37.7015 48.8604 36.9423 48.8604C36.183 48.8604 35.3845 48.9258 34.6579 49.0436C30.5539 49.7309 27.6412 52.3163 26.8819 56.4989C26.751 57.2058 26.6855 57.9585 26.6855 58.7571C26.6855 59.5556 26.751 60.2822 26.8754 60.9825C27.6281 65.1585 30.5474 67.7505 34.6579 68.4378C35.3845 68.5622 36.1503 68.6211 36.9423 68.6211C37.7343 68.6211 38.4412 68.5622 39.135 68.4509C43.239 67.7833 46.1648 65.1847 46.9175 60.9825Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.5051 63.5352H32.4004V80.7497H41.5051V63.5352Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M121.654 59.4704C121.628 59.0646 121.615 58.6523 121.615 58.2333C121.615 56.9897 121.72 55.7788 121.923 54.6464C123.107 48.101 127.519 43.8726 134.339 42.7337C135.491 42.5439 136.728 42.4457 137.966 42.4457C139.203 42.4457 140.348 42.5373 141.454 42.7141C148.281 43.8268 152.693 48.0617 153.878 54.6464C154.08 55.7788 154.185 56.9897 154.185 58.2333C154.185 58.6523 154.172 59.0646 154.146 59.4704H161.392C161.411 59.0581 161.418 58.6457 161.418 58.2333C161.418 56.5184 161.274 54.8493 160.986 53.2653C159.264 43.6828 152.621 37.2683 142.75 35.6581C139.615 35.1475 136.152 35.1606 133.011 35.6843C123.166 37.3272 116.529 43.7286 114.801 53.2523C114.513 54.8363 114.369 56.5119 114.369 58.2268C114.369 58.6392 114.376 59.0515 114.395 59.4639H121.641L121.654 59.4704Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M134.496 59.4707H62.791V131.176H134.496V59.4707Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M72.5241 59.4707H62.791V96.0991H72.5241V59.4707Z",
                fill: "#B7B9BE"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M109.983 96.0597C110.107 95.3593 110.173 94.6197 110.173 93.8342C110.173 93.0488 110.107 92.283 109.976 91.576C109.224 87.3673 106.298 84.7753 102.2 84.1077C101.5 83.9964 100.767 83.9375 100.008 83.9375C99.2484 83.9375 98.4499 84.003 97.7233 84.1208C93.6193 84.808 90.7066 87.3935 89.9473 91.576C89.8164 92.283 89.751 93.0357 89.751 93.8342C89.751 94.6328 89.8164 95.3593 89.9408 96.0597C90.6935 100.236 93.6128 102.828 97.7233 103.515C98.4499 103.639 99.2157 103.698 100.008 103.698C100.8 103.698 101.507 103.639 102.2 103.528C106.304 102.86 109.23 100.262 109.983 96.0597Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M104.571 98.6123H95.4658V115.827H104.571V98.6123Z",
                fill: "#1868DB"
            })
        ]
    });
};

});

parcelRegister("33FAp", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $41068fea93b1c711$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $41068fea93b1c711$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    notEligibleTitle: {
        id: "fastshift.not-eligible.title",
        defaultMessage: "You can\u2019t access FastShift Portal",
        description: "Title for the not eligible display"
    },
    noLicenseDescription: {
        id: "fastshift.no-license.description",
        defaultMessage: "Your Atlassian account is not linked to a cloud license eligible to access FastShift Portal. Check your account status or {contactSupportLink} for further assistance.",
        description: "Description for the no license display"
    },
    notLinkedDescription: {
        id: "fastshift.not-linked.description",
        defaultMessage: "Your Atlassian account is not linked to any ongoing migration. If you believe you should have Portal access, {contactSupportLink}.",
        description: "Description for the not linked display"
    },
    contactSupportAnchorText: {
        id: "fastshift.not-eligible.contact-support-anchor-text",
        defaultMessage: "contact support",
        description: "Link text for contacting support"
    },
    goBackButton: {
        id: "fastshift.not-eligible.go-back-button",
        defaultMessage: "Go back",
        description: "Button text for going back to the previous display"
    },
    signInWithAnotherAccountButton: {
        id: "fastshift.not-eligible.sign-in-with-another-account",
        defaultMessage: "Sign in with another account",
        description: "Button text for signing in with another account"
    }
});

});






parcelRegister("2uw17", function(module, exports) {
$parcel$export(module.exports, "RedirectToSelectionPage", function () { return $33f4c5f7dbec8665$export$485895d4d5e7861a; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $j2t2h = parcelRequire("j2t2h");

var $7qFQI = parcelRequire("7qFQI");
parcelRequire("iTGju");
var $bh3Fv = parcelRequire("bh3Fv");
const $33f4c5f7dbec8665$export$485895d4d5e7861a = ()=>{
    const navigate = (0, $j2t2h.useNavigate)();
    const { paths: paths } = (0, $bh3Fv.useRoutes)();
    (0, $1oC0p.useEffect)(()=>{
        const selectionPageUrl = paths.selection;
        navigate(selectionPageUrl);
    }, [
        navigate
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
        interactionName: "load",
        label: "Loading"
    });
};

});






//# sourceMappingURL=fastshift-dashboard-page.5e7ac5c5.js.map
